/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1785);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(854);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(855)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Typography_A__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Typography_A__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icons_AddressIcon__ = __webpack_require__(1104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Icons_AddressIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert_Alert__ = __webpack_require__(1105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Alert_Alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_AlertIcon__ = __webpack_require__(1107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Icons_AlertIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_ArrowDownIcon__ = __webpack_require__(412);
/* unused harmony reexport ArrowDownIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_ArrowLeftIcon__ = __webpack_require__(1108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Icons_ArrowLeftIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_ArrowLeftThinIcon__ = __webpack_require__(1109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__Icons_ArrowLeftThinIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_ArrowRightIcon__ = __webpack_require__(1110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__Icons_ArrowRightIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icons_ArrowRightThinIcon__ = __webpack_require__(413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__Icons_ArrowRightThinIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BackButton_BackButton__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__BackButton_BackButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Button_Button__ = __webpack_require__(252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__Button_Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonGroup_ButtonGroup__ = __webpack_require__(415);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ButtonIcon_ButtonIcon__ = __webpack_require__(589);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_12__ButtonIcon_ButtonIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Typography_Caption__ = __webpack_require__(1328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_13__Typography_Caption__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Card_Card__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_14__Card_Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CheckBoxGroup_CheckBoxGroup__ = __webpack_require__(1329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_15__CheckBoxGroup_CheckBoxGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icons_CheckIcon__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_16__Icons_CheckIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icons_ChevronIcon__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_17__Icons_ChevronIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icons_ColorIcon_ColorIcon__ = __webpack_require__(1331);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_18__Icons_ColorIcon_ColorIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ColumnGroup_ColumnGroup__ = __webpack_require__(478);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_19__ColumnGroup_ColumnGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Container_Container__ = __webpack_require__(477);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_20__Container_Container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Content_Content__ = __webpack_require__(588);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_21__Content_Content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icons_CrossIcon__ = __webpack_require__(591);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_22__Icons_CrossIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icons_ExternalLinkIcon__ = __webpack_require__(1334);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_23__Icons_ExternalLinkIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icons_FacebookIcon__ = __webpack_require__(1335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_24__Icons_FacebookIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__FormGroup_FormGroup__ = __webpack_require__(1336);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_25__FormGroup_FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Typography_H1__ = __webpack_require__(1338);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_26__Typography_H1__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Typography_H2__ = __webpack_require__(1339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_27__Typography_H2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Typography_H3__ = __webpack_require__(1340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_28__Typography_H3__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Typography_H4__ = __webpack_require__(1341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_29__Typography_H4__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Typography_H5__ = __webpack_require__(1342);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_30__Typography_H5__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Typography_H6__ = __webpack_require__(1343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_31__Typography_H6__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icons_HideIcon__ = __webpack_require__(1344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_32__Icons_HideIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icons_HoursIcon__ = __webpack_require__(1345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_33__Icons_HoursIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icons_Icon180Icon__ = __webpack_require__(1346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_34__Icons_Icon180Icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icons_Icon360Icon__ = __webpack_require__(1347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_35__Icons_Icon360Icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__IdWrapper_IdWrapper__ = __webpack_require__(528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_36__IdWrapper_IdWrapper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icons_InfoIcon__ = __webpack_require__(1348);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_37__Icons_InfoIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Input_Input__ = __webpack_require__(1349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_38__Input_Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__InputCaptcha_InputCaptcha__ = __webpack_require__(1351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_39__InputCaptcha_InputCaptcha__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__InputCheckBox_InputCheckBox__ = __webpack_require__(1406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_40__InputCheckBox_InputCheckBox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__InputEmail_InputEmail__ = __webpack_require__(1407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_41__InputEmail_InputEmail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__InputPassword_InputPassword__ = __webpack_require__(1409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_42__InputPassword_InputPassword__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__InputRadio_InputRadio__ = __webpack_require__(1411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_43__InputRadio_InputRadio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__InputRange_InputRange__ = __webpack_require__(1413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_44__InputRange_InputRange__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__InputSelect_InputSelect__ = __webpack_require__(1431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_45__InputSelect_InputSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__InputText_InputText__ = __webpack_require__(1433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_46__InputText_InputText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icons_InstagramIcon__ = __webpack_require__(1435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_47__Icons_InstagramIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Typography_Interactive__ = __webpack_require__(1436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_48__Typography_Interactive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Icons_LinkIcon__ = __webpack_require__(1437);
/* unused harmony reexport LinkIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Icons_LoadingIcon_LoadingIcon__ = __webpack_require__(1438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_50__Icons_LoadingIcon_LoadingIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__LoadingSection_LoadingSection__ = __webpack_require__(1440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_51__LoadingSection_LoadingSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Icons_MailIcon__ = __webpack_require__(1442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_52__Icons_MailIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Icons_MaintenanceIcon__ = __webpack_require__(1443);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_53__Icons_MaintenanceIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Modal_Modal__ = __webpack_require__(1444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_54__Modal_Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Icons_MuteIcon__ = __webpack_require__(1451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_55__Icons_MuteIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Typography_P__ = __webpack_require__(1452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_56__Typography_P__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__PersonalisationBlockItem_PersonalisationBlockItem__ = __webpack_require__(571);
/* unused harmony reexport PersonalisationBlockItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Icons_PhoneIcon__ = __webpack_require__(1453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_58__Icons_PhoneIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Icons_PlusCircleIcon__ = __webpack_require__(1454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_59__Icons_PlusCircleIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Icons_PlusIcon__ = __webpack_require__(1455);
/* unused harmony reexport PlusIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Icons_RemoveCircleIcon__ = __webpack_require__(1456);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_61__Icons_RemoveCircleIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Icons_RestartIcon__ = __webpack_require__(1457);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_62__Icons_RestartIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Icons_SaveIcon__ = __webpack_require__(1458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_63__Icons_SaveIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Icons_SearchIcon__ = __webpack_require__(1459);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_64__Icons_SearchIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Section_Section__ = __webpack_require__(476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_65__Section_Section__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Icons_ShareIcon__ = __webpack_require__(1460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_66__Icons_ShareIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Icons_ShowIcon__ = __webpack_require__(1461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_67__Icons_ShowIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Icons_ServiceIcon__ = __webpack_require__(1462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_68__Icons_ServiceIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Icons_SlugIcon_SlugIcon__ = __webpack_require__(1463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_69__Icons_SlugIcon_SlugIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__SocialIcons_SocialIcons__ = __webpack_require__(578);
/* unused harmony reexport SocialIcons */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Typography_Space__ = __webpack_require__(1465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_71__Typography_Space__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Spotlight_Spotlight__ = __webpack_require__(579);
/* unused harmony reexport Spotlight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Icons_StarIcon__ = __webpack_require__(1466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_73__Icons_StarIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__StickySection_StickySection__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_74__StickySection_StickySection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Tag_Tag__ = __webpack_require__(1467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_75__Tag_Tag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Testimonial_Testimonial__ = __webpack_require__(581);
/* unused harmony reexport Testimonial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Icons_TickModalIcon__ = __webpack_require__(1469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_77__Icons_TickModalIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__ToastPopup_ToastPopup__ = __webpack_require__(1470);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_78__ToastPopup_ToastPopup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Icons_TorchIcon__ = __webpack_require__(1473);
/* unused harmony reexport TorchIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__Icons_TwitterIcon__ = __webpack_require__(1474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_80__Icons_TwitterIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Icons_UnMuteIcon__ = __webpack_require__(1475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_81__Icons_UnMuteIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Visible_Visible__ = __webpack_require__(615);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_82__Visible_Visible__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Icons_WebsiteIcon__ = __webpack_require__(1476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_83__Icons_WebsiteIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Icons_YoutubeIcon__ = __webpack_require__(1477);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_84__Icons_YoutubeIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__YoutubePlayer_YoutubePlayer__ = __webpack_require__(1478);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_85__YoutubePlayer_YoutubePlayer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__Icons_ZoomZoomIcon__ = __webpack_require__(1480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_86__Icons_ZoomZoomIcon__["a"]; });


























































































/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export combineHOCs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return withRadium; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configured_radium__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_location__ = __webpack_require__(375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_location__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detect_thresholds__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__detect_thresholds__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detect_compact__ = __webpack_require__(962);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__detect_compact__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__search_params__ = __webpack_require__(963);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__search_params__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__detect_window_scroll__ = __webpack_require__(964);
/* unused harmony reexport DetectWindowScroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__price__ = __webpack_require__(965);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__price__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__specs__ = __webpack_require__(966);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__specs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gtm_event__ = __webpack_require__(967);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__gtm_event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__local_vehicle__ = __webpack_require__(968);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__local_vehicle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__with_hash__ = __webpack_require__(973);
/* unused harmony reexport withHash */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__with_search__ = __webpack_require__(974);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__with_search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__with_dynamic_components__ = __webpack_require__(975);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_13__with_dynamic_components__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__with_data_components__ = __webpack_require__(976);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__with_data_components__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__configured_radium__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__configured_radium__["b"]; });

































var combineHOCs = __WEBPACK_IMPORTED_MODULE_0__utils__["J" /* pipe */];

var withRadium = function withRadium() {
  for (var _len = arguments.length, hocs = Array(_len), _key = 0; _key < _len; _key++) {
    hocs[_key] = arguments[_key];
  }

  return combineHOCs.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__configured_radium__["a" /* default */]].concat(hocs));
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animation_player__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bubble__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents_Button_Button__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__close_button__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__color_selector__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_error__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__countdown_timer__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_message_section__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__expandable_area__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flash_message__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__full_width_image_section__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__global_nav_dropdown__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_nav_item_grid__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_nav_link__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__global_nav_link_accordion__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__global_nav_link_secondary__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__global_nav_overlay__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__gyroscope__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__heading__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__hyperlink__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__interior_selector__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__interior_swatch__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__loading__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__location_text__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__map_marker__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__map_with_markers__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__missing_component__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__nameplate_link__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pagination_selector__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__slideshow__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__static_dealer_map_with_toggle__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__step_counter__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__stepped_flow__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__summary__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__summary_with_price__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__tabs__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__text_video_frame__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__time_component__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__video_background__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__video_slideshow__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__video_with_timed_frames__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__wysiwyg_content__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__icons_account_icon__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__icons_add_circle_icon__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__icons_animated_hamburger_icon__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__icons_calculator_icon__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__icons_calendar_icon__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__icons_cancel_icon__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__icons_check_icon__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__icons_confirm_copy_link_icon__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__icons_contact_icon__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__icons_cross_icon__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__icons_document_icon__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__icons_down_arrow_icon__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__icons_download_icon__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__icons_edit_icon__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__icons_error_icon__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__icons_external_link__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__icons_eye_icon__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__icons_hex_icon__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__icons_link_icon__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__icons_loader_icon__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__icons_mail_icon__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__icons_notifications_icon__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__icons_plus_icon__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__icons_print_icon__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__icons_radio_icon__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__icons_remove_circle_icon__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__icons_save_icon__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__icons_chevron_icon__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__icons_search_icon__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__icons_servicing_icon__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__icons_share_icon__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__tabs_responsive__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__icons_tick_modal_icon__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__icons_mute_icon__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__icons_unmute_icon__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__icons_vehicle_icon__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__icons_info_circle_icon__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__form_elements_address_suggest__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__form_elements_checkbox__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__form_elements_dealer_search_box__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__form_elements_dealers_field__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__form_elements_input_label__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__form_elements_input_radio__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__form_elements_input_text__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__form_elements_input_textarea__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__form_elements_input_time__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__form_elements_postcode_suggest__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__form_elements_search_input__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__form_elements_select__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__form_elements_select_base__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__form_elements_dealer_search_box_nz__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__mymazda_dealer_summary__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__mymazda_editable_details_section__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__mymazda_notifications_list__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__mymazda_vehicle_resource_list__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__mymazda_service_carousel__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__mymazda_service_export__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__mymazda_service_history__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__mymazda_service_summary__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__mymazda_vehicle_specs__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__mymazda_vehicle_list__ = __webpack_require__(1670);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__animation_player__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__bubble__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__close_button__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__color_selector__["a"]; });
/* unused harmony reexport ComponentError */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__countdown_timer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_7__error_message_section__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_8__expandable_area__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_9__flash_message__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_10__full_width_image_section__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_11__global_nav_dropdown__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_12__global_nav_item_grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_13__global_nav_link__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_14__global_nav_link_accordion__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_15__global_nav_link_secondary__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_16__global_nav_overlay__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_17__gyroscope__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_18__heading__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_19__hyperlink__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_20__interior_selector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_21__interior_swatch__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_22__loading__["a"]; });
/* unused harmony reexport LocationText */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_24__map_marker__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_25__map_with_markers__["a"]; });
/* unused harmony reexport MissingComponent */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_27__nameplate_link__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_28__pagination_selector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_89__form_elements_search_input__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_29__slideshow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_30__static_dealer_map_with_toggle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_31__step_counter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_32__stepped_flow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_33__summary__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_34__summary_with_price__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_35__tabs__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_73__tabs_responsive__["a"]; });
/* unused harmony reexport TextVideoFrame */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_37__time_component__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_38__video_background__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_39__video_slideshow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_40__video_with_timed_frames__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_41__wysiwyg_content__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_42__icons_account_icon__["a"]; });
/* unused harmony reexport AddCircleIcon */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_44__icons_animated_hamburger_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_45__icons_calculator_icon__["a"]; });
/* unused harmony reexport CalendarIcon */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_47__icons_cancel_icon__["a"]; });
/* unused harmony reexport CheckIcon */
/* unused harmony reexport ConfirmCopyLinkIcon */
/* unused harmony reexport ContactIcon */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_51__icons_cross_icon__["a"]; });
/* unused harmony reexport DocumentIcon */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_53__icons_down_arrow_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_54__icons_download_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_55__icons_edit_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_56__icons_error_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_57__icons_external_link__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_58__icons_eye_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_59__icons_hex_icon__["a"]; });
/* unused harmony reexport LinkIcon */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_61__icons_loader_icon__["a"]; });
/* unused harmony reexport MailIcon */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_63__icons_notifications_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_64__icons_plus_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_65__icons_print_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_66__icons_radio_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_67__icons_remove_circle_icon__["a"]; });
/* unused harmony reexport SaveIcon */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_69__icons_chevron_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_70__icons_search_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_71__icons_servicing_icon__["a"]; });
/* unused harmony reexport ShareIcon */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_75__icons_mute_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_76__icons_unmute_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_74__icons_tick_modal_icon__["a"]; });
/* unused harmony reexport VehicleIcon */
/* unused harmony reexport InfoCircleIcon */
/* unused harmony reexport AddressSuggest */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2_AtomicComponents_Button_Button__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_80__form_elements_checkbox__["a"]; });
/* unused harmony reexport DealerSearchBox */
/* unused harmony reexport DealersField */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_83__form_elements_input_label__["a"]; });
/* unused harmony reexport InputRadio */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_85__form_elements_input_text__["a"]; });
/* unused harmony reexport InputTextArea */
/* unused harmony reexport InputTime */
/* unused harmony reexport PostcodeSuggest */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_90__form_elements_select__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_91__form_elements_select_base__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_92__form_elements_dealer_search_box_nz__["a"]; });
/* unused harmony reexport DealerSummary */
/* unused harmony reexport MyMazdaEditableDetailsSection */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_95__mymazda_notifications_list__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_96__mymazda_vehicle_resource_list__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_97__mymazda_service_carousel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_98__mymazda_service_export__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_99__mymazda_service_history__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_100__mymazda_service_summary__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_101__mymazda_vehicle_specs__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_102__mymazda_vehicle_list__["a"]; });
// Components











































// Icons






































// Form Elements















// MyMazda











// Components


// Icons


// Form Elements


// MyMazda


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(54);
var hide = __webpack_require__(44);
var redefine = __webpack_require__(45);
var ctx = __webpack_require__(55);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessories__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animated_arrow__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animated_check_icon__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animated_plus_minus__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__arrow_icon__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__article_page__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__background_image__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__background_image_selector__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__body__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colored_label__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__column__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__column_group__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__compare_tool__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__compare_vehicle_selector__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__conditional_layout__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__build__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__configured_vehicle__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__expandable_info__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__feature_youtube__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__fifty_fifty_block__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__fine_print__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__fixed_bar__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__gallery__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__gallery_full_width__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__gallery_grid__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__gallery_item__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__configured_vehicle_selector_get_image_src_based_on_options__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__global_nav__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__heading_block__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__hero_video_with_timed_frames__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__icon_link__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__icon_tout_block__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__image_block__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__image_disclaimer__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__image_selector__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__image_tout_block__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__inline_disclaimer_block__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__layered_background_image__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__layered_background_image_autoplay__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__location_tile__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__map_location__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__mobile_share__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__mymazda_login__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__mymazda_specifications_block__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__mymazda_summary__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__offers__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__outlet_store__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__outlet_store_detail__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__outlet_store_specifications_block__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__overlay__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__postcode_popup__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__postcode_selector__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__read_more_text__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__recalls_block__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__configured_vehicle_selector_render_config_vehicle__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__configured_vehicle_selector_render_config_vehicle_compact__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__ribbon__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__round_icon_button__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__scraped_page__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__scrollable_anchor__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__search_select_box__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__service_calculator_filter__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__service_calculator_owner__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__service_calculator_prospect__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__service_details__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__service_details_full__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__service_list_inspect__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__service_list_select__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__service_main_panel__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__service_model_details__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__site_search__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__sixty_fourty_block__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__slider__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__specification_list__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__specification_list_item__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__specifications_block__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__stat_list__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__sticky__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__interactive_slideshow_block__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__text_toggle__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__toast_popup__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__triggered_overlay__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__video_overlay__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__youtube_player__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__mymazda__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__mymazda_login__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__mymazda_wrapper__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__mymazda_manage_vehicle_flows_remove_vehicle__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__mymazda_manage_vehicle_flows_add_vehicle__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__mymazda_manage_account_deactivate_account_flow__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__mymazda_manage_account_account_details__ = __webpack_require__(1762);
/* unused harmony reexport Accessories */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__animated_arrow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__animated_check_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__animated_plus_minus__["a"]; });
/* unused harmony reexport App */
/* unused harmony reexport ArrowIcon */
/* unused harmony reexport ArticlePageContainer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__background_image__["a"]; });
/* unused harmony reexport BackgroundImageSelector */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9__body__["a"]; });
/* unused harmony reexport ColoredLabel */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__column__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__column_group__["a"]; });
/* unused harmony reexport CompareTool */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_14__compare_vehicle_selector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_15__conditional_layout__["a"]; });
/* unused harmony reexport Configurator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_17__configured_vehicle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_18__expandable_info__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_19__feature_youtube__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_20__fifty_fifty_block__["a"]; });
/* unused harmony reexport FinePrint */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_22__fixed_bar__["a"]; });
/* unused harmony reexport Gallery */
/* unused harmony reexport GalleryFullWidth */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_25__gallery_grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_26__gallery_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_27__configured_vehicle_selector_get_image_src_based_on_options__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_28__global_nav__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_29__heading_block__["a"]; });
/* unused harmony reexport HeroVideoWithTimedFrames */
/* unused harmony reexport IconLink */
/* unused harmony reexport IconToutBlock */
/* unused harmony reexport ImageBlock */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_34__image_disclaimer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_35__image_selector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_36__image_tout_block__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_37__inline_disclaimer_block__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_38__layered_background_image__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_39__layered_background_image_autoplay__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_40__location_tile__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_41__map_location__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_42__mobile_share__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_85__mymazda__["a"]; });
/* unused harmony reexport MyMazdaLogin */
/* unused harmony reexport MyMazdaLoginContainer */
/* unused harmony reexport MyMazdaSpecificationBlock */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_45__mymazda_summary__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_87__mymazda_wrapper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_88__mymazda_manage_vehicle_flows_remove_vehicle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_89__mymazda_manage_vehicle_flows_add_vehicle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_90__mymazda_manage_account_deactivate_account_flow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_91__mymazda_manage_account_account_details__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_46__offers__["a"]; });
/* unused harmony reexport OutletStoreContainer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_48__outlet_store_detail__["a"]; });
/* unused harmony reexport OutletStoreSpecificationsBlock */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_50__overlay__["a"]; });
/* unused harmony reexport PostcodePopup */
/* unused harmony reexport PostcodeSelector */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_53__read_more_text__["a"]; });
/* unused harmony reexport RecallsBlock */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_55__configured_vehicle_selector_render_config_vehicle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_56__configured_vehicle_selector_render_config_vehicle_compact__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_57__ribbon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_58__round_icon_button__["a"]; });
/* unused harmony reexport ScrapedPage */
/* unused harmony reexport ScrollableAnchor */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_61__search_select_box__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_62__service_calculator_filter__["a"]; });
/* unused harmony reexport ServiceCalculatorOwner */
/* unused harmony reexport ServiceCalculatorProspect */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_65__service_details__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_66__service_details_full__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_67__service_list_inspect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_68__service_list_select__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_69__service_main_panel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_70__service_model_details__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_71__site_search__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_72__sixty_fourty_block__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_73__slider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_74__specification_list__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_75__specification_list_item__["a"]; });
/* unused harmony reexport SpecificationsBlock */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_77__stat_list__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_78__sticky__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_79__interactive_slideshow_block__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_80__text_toggle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_81__toast_popup__["a"]; });
/* unused harmony reexport TriggeredOverlay */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_83__video_overlay__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_84__youtube_player__["a"]; });
// Containers/index.js
// Load App first since it imports global page css, and we want that on top
// of the generated css file


// Rest in alpha order.





















































































// MyMazda










/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccessoryDetails_AccessoryDetails__ = __webpack_require__(417);
/* unused harmony reexport AccessoryDetails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccessoryItem_AccessoryItem__ = __webpack_require__(1113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AccessoryItem_AccessoryItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccessoryList_AccessoryList__ = __webpack_require__(418);
/* unused harmony reexport AccessoryList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccordionText_AccordionText__ = __webpack_require__(253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__AccordionText_AccordionText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccordionTextList_AccordionTextList__ = __webpack_require__(419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__AccordionTextList_AccordionTextList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AlertList_AlertList__ = __webpack_require__(1116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__AlertList_AlertList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ArticlePage_ArticlePage__ = __webpack_require__(254);
/* unused harmony reexport ArticlePage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ArticlePreview_ArticlePreview__ = __webpack_require__(420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__ArticlePreview_ArticlePreview__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ArticleSelector_ArticleSelector__ = __webpack_require__(421);
/* unused harmony reexport ArticleSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BookServiceForm_BookServiceForm__ = __webpack_require__(422);
/* unused harmony reexport BookServiceForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BookTestDrive_BookTestDrive__ = __webpack_require__(425);
/* unused harmony reexport BookTestDrive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BrowserHeightSection_BrowserHeightSection__ = __webpack_require__(1125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__BrowserHeightSection_BrowserHeightSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BrowserWarning_BrowserWarning__ = __webpack_require__(426);
/* unused harmony reexport BrowserWarning */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardYoutubePlayer_CardYoutubePlayer__ = __webpack_require__(255);
/* unused harmony reexport CardYoutubePlayer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardYoutubePlayerList_CardYoutubePlayerList__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_14__CardYoutubePlayerList_CardYoutubePlayerList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ColorPicker_ColorPicker__ = __webpack_require__(428);
/* unused harmony reexport ColorPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CompetitionForm_CompetitionForm__ = __webpack_require__(429);
/* unused harmony reexport CompetitionForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ContentCard_ContentCard__ = __webpack_require__(430);
/* unused harmony reexport ContentCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ContentCardList_ContentCardList__ = __webpack_require__(431);
/* unused harmony reexport ContentCardList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CorporateSelect_CorporateSelect__ = __webpack_require__(432);
/* unused harmony reexport CorporateSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DealerSearch_DealerSearch__ = __webpack_require__(1138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_20__DealerSearch_DealerSearch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Disclaimer_Disclaimer__ = __webpack_require__(434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_21__Disclaimer_Disclaimer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FeaturedCategoriesTab_FeaturedCategoriesTab__ = __webpack_require__(435);
/* unused harmony reexport FeaturedCategoriesTab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__FeatureFocusBlock_FeatureFocusBlock__ = __webpack_require__(436);
/* unused harmony reexport FeatureFocusBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__FiftyFiftyBlock_FiftyFiftyBlock__ = __webpack_require__(437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_24__FiftyFiftyBlock_FiftyFiftyBlock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Footer_Footer__ = __webpack_require__(438);
/* unused harmony reexport Footer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__FullWidthImageSection_FullWidthImageSection__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_26__FullWidthImageSection_FullWidthImageSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__GetInTouch_GetInTouch__ = __webpack_require__(440);
/* unused harmony reexport GetInTouch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__GradePicker_GradePicker__ = __webpack_require__(441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_28__GradePicker_GradePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Heading_Heading__ = __webpack_require__(442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_29__Heading_Heading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Hero_Hero__ = __webpack_require__(443);
/* unused harmony reexport Hero */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__HeroContent_HeroContent__ = __webpack_require__(257);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_31__HeroContent_HeroContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Image_Image__ = __webpack_require__(444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_32__Image_Image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Image360_Image360__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_33__Image360_Image360__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Gallery_Gallery__ = __webpack_require__(446);
/* unused harmony reexport ImagesGallery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ImagesRotator_ImagesRotator__ = __webpack_require__(447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_35__ImagesRotator_ImagesRotator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__InputDate_InputDate__ = __webpack_require__(1158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_36__InputDate_InputDate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__InputSearchable_InputSearchable__ = __webpack_require__(105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_37__InputSearchable_InputSearchable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__InteriorPicker_InteriorPicker__ = __webpack_require__(448);
/* unused harmony reexport InteriorPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__MyMazdaChangeEmail_MyMazdaChangeEmail__ = __webpack_require__(1170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_39__MyMazdaChangeEmail_MyMazdaChangeEmail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__MyMazdaDashboard_MyMazdaDashboard__ = __webpack_require__(449);
/* unused harmony reexport MyMazdaDashboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__MyMazdaDashboard_MyMazdaDashboardItem__ = __webpack_require__(451);
/* unused harmony reexport MyMazdaDashboardItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__MyMazdaDetails_MyMazdaDetails__ = __webpack_require__(1172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_42__MyMazdaDetails_MyMazdaDetails__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__MyMazdaLogin_MyMazdaLogin__ = __webpack_require__(452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_43__MyMazdaLogin_MyMazdaLogin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__MyMazdaLoginContainer_MyMazdaLoginContainer__ = __webpack_require__(453);
/* unused harmony reexport MyMazdaLoginContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__MyMazdaPassword_MyMazdaPassword__ = __webpack_require__(1176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_45__MyMazdaPassword_MyMazdaPassword__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__MyMazdaPersonalDetails_MyMazdaPersonalDetails__ = __webpack_require__(1179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_46__MyMazdaPersonalDetails_MyMazdaPersonalDetails__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__MyMazdaRegister_MyMazdaRegister__ = __webpack_require__(1181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_47__MyMazdaRegister_MyMazdaRegister__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__MyMazdaResetPassword_MyMazdaResetPassword__ = __webpack_require__(1183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_48__MyMazdaResetPassword_MyMazdaResetPassword__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__MyMazdaServiceHistory_MyMazdaServiceHistory__ = __webpack_require__(454);
/* unused harmony reexport MyMazdaServiceHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__MyMazdaServiceRequest_MyMazdaServiceRequest__ = __webpack_require__(1186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_50__MyMazdaServiceRequest_MyMazdaServiceRequest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__MyMazdaVehicleSummary_MyMazdaVehicleSummary__ = __webpack_require__(455);
/* unused harmony reexport MyMazdaVehicleSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__MyNewMazda_MyNewMazda__ = __webpack_require__(456);
/* unused harmony reexport MyNewMazda */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Offers_Offers__ = __webpack_require__(457);
/* unused harmony reexport Offers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__OffersFilters_OffersFilters__ = __webpack_require__(1192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_54__OffersFilters_OffersFilters__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__OfferTile_OfferTile__ = __webpack_require__(458);
/* unused harmony reexport OfferTile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__OutletStoreEnquiryForm_OutletStoreEnquiryForm__ = __webpack_require__(459);
/* unused harmony reexport OutletStoreEnquiryForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__PDFTemplate_PDFTemplate__ = __webpack_require__(460);
/* unused harmony reexport PDFTemplate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__PersonalisationBlockContainer_PersonalisationBlockContainer__ = __webpack_require__(461);
/* unused harmony reexport PersonalisationBlockContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Price_Price__ = __webpack_require__(462);
/* unused harmony reexport Price */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Recall_Recall__ = __webpack_require__(463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_60__Recall_Recall__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__RecallDetail_RecallDetail__ = __webpack_require__(464);
/* unused harmony reexport RecallDetail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__RecallDocument_RecallDocument__ = __webpack_require__(260);
/* unused harmony reexport RecallDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__RegisterInterestForm_RegisterInterestForm__ = __webpack_require__(466);
/* unused harmony reexport RegisterInterestForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__SaveForm_SaveForm__ = __webpack_require__(467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_64__SaveForm_SaveForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__SaveShareCopy_SaveShareCopy__ = __webpack_require__(468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_65__SaveShareCopy_SaveShareCopy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ShareForm_ShareForm__ = __webpack_require__(469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_66__ShareForm_ShareForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__SixtyFourtyBlock_SixtyFourtyBlock__ = __webpack_require__(470);
/* unused harmony reexport SixtyFourtyBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Slideshow_Slideshow__ = __webpack_require__(1208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_68__Slideshow_Slideshow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__SpecificationsBlock_SpecificationsBlock__ = __webpack_require__(471);
/* unused harmony reexport SpecificationsBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__StickyNav_StickyNav__ = __webpack_require__(472);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_70__StickyNav_StickyNav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Tabs_Tabs__ = __webpack_require__(1212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_71__Tabs_Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Tooltip_Tooltip__ = __webpack_require__(1214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_72__Tooltip_Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__VehicleNotFoundPage_VehicleNotFoundPage__ = __webpack_require__(473);
/* unused harmony reexport VehicleNotFoundPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__VideoPlayer_VideoPlayer__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_74__VideoPlayer_VideoPlayer__["a"]; });














































































/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animations__ = __webpack_require__(853);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__animations__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(342);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__array__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__array__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__array__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__array__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_2__array__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__async__ = __webpack_require__(912);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component__ = __webpack_require__(913);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__component__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__component__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_4__component__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_4__component__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom__ = __webpack_require__(914);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__environment__ = __webpack_require__(915);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_6__environment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__function__ = __webpack_require__(35);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__function__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__function__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__function__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_7__function__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__function__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_7__function__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_7__function__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hash__ = __webpack_require__(916);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_8__hash__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_8__hash__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_8__hash__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__history__ = __webpack_require__(103);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_9__history__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__koala__ = __webpack_require__(920);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_10__koala__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__number__ = __webpack_require__(921);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_11__number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__object__ = __webpack_require__(134);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_12__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_12__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_12__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_12__object__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_12__object__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_12__object__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_12__object__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__page__ = __webpack_require__(922);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_13__page__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__query__ = __webpack_require__(923);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__query__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_14__query__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_14__query__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_14__query__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__scroll__ = __webpack_require__(927);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_15__scroll__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__scroll__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_15__scroll__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_15__scroll__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_15__scroll__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_15__scroll__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__string__ = __webpack_require__(228);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_16__string__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__formatters__ = __webpack_require__(929);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_17__formatters__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_17__formatters__["b"]; });
/* unused harmony reexport validation */






















/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_radium__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vh_px_plugin_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keyframes__ = __webpack_require__(906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__keyframes__["a"]; });
/* unused harmony reexport Style */




/* harmony default export */ __webpack_exports__["a"] = (function (component) {
  return __WEBPACK_IMPORTED_MODULE_0_radium___default()({
    plugins: [__WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.mergeStyleArray, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.checkProps, __WEBPACK_IMPORTED_MODULE_1__vh_px_plugin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.resolveMediaQueries, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.resolveInteractionStyles, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.keyframes, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.visited, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.removeNestedStyles, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.checkProps]
  })(component);
});



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicUtils_cookieHandler__ = __webpack_require__(15);



var gtmHandler = function gtmHandler(_ref) {
  var _ref$pageCategory = _ref.pageCategory,
      pageCategory = _ref$pageCategory === undefined ? "" : _ref$pageCategory,
      _ref$pageAction = _ref.pageAction,
      pageAction = _ref$pageAction === undefined ? "" : _ref$pageAction;

  if (__WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__["i" /* WINDOW */]) {
    if (!__WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__["i" /* WINDOW */].dataLayer) __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__["i" /* WINDOW */].dataLayer = [];

    var newData = {
      event: "reactjs.event",
      pageCategory: pageCategory,
      pageAction: pageAction
    };

    var cookieHandlerObject = new __WEBPACK_IMPORTED_MODULE_1_AtomicUtils_cookieHandler__["a" /* default */]();
    if (cookieHandlerObject.getCookie("userId")) {
      newData.userId = cookieHandlerObject.getCookie("userId");
    }

    if (process && process.env && "production" === "development") {
      console.table({
        GTM_CALL: {
          Category: newData.pageCategory,
          Action: newData.pageAction,
          UserId: newData.userId || 'guest'
        }
      });
    }

    __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__["i" /* WINDOW */].dataLayer.push(newData);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (gtmHandler);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_BROWSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_DEV; });
/* unused harmony export IS_TEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return WINDOW; });
/* unused harmony export NAVIGATOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOCUMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IS_IFRAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HAS_TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IS_IOS; });
/* unused harmony export IS_ANDROID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MIN_BROWSERS; });
var IS_BROWSER = typeof window !== "undefined";
var IS_DEV = "production" !== "production";
var IS_TEST = "production" === "test";
var WINDOW = IS_BROWSER && window;
var NAVIGATOR = WINDOW && WINDOW.navigator;
var DOCUMENT = WINDOW && WINDOW.document;
var IS_IFRAME = WINDOW && WINDOW.self !== WINDOW.top;
var HAS_TOUCH = DOCUMENT && "ontouchstart" in DOCUMENT.documentElement;
var IS_IOS = NAVIGATOR && /iPhone|iPad|iPod/i.test(NAVIGATOR.userAgent || "");
var IS_ANDROID = NAVIGATOR && /Android/i.test(NAVIGATOR.userAgent || "");
var IS_MOBILE = NAVIGATOR && /iPhone|iPod|Android/i.test(NAVIGATOR.userAgent);
var MIN_BROWSERS = {
  safari: 9.1,
  chrome: 57,
  firefox: 53,
  msie: 11,
  msedge: 14
};

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  BLUE: "#13618F",
  ORANGE: "#F06735",
  BLACK: "#101010",
  GRAY_DARKER: "#2E2E2E",
  GRAY_DARK: "#999999",
  GRAY: "#D5D5D5",
  GRAY_LIGHT: "#E7E7E7",
  GRAY_LIGHTER: "#F5F5F5",
  GRAY1: "#303030",
  GRAY2: "#3D3D3D",
  GRAY3: "#414141",
  WHITE: "#FFFFFF",
  GREEN: "#7dbe38",
  RED: "#910A2D",
  RED_DARK: "#770000"
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__moduleImporter__ = __webpack_require__(416);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicUtils\\componentParser.js";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var componentParser = function componentParser() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var extraProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parentsName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var randomGeneration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!data || !data.length || data.length === 0) {
    return null;
  }

  var clonedExtraProps = _extends({}, extraProps);

  return data.map(function (_ref, index) {
    var _ref$name = _ref.name,
        name = _ref$name === undefined ? '' : _ref$name,
        props = _ref.props;

    // This dynamically imports the component
    if (name && name != '') {
      var Component = Object(__WEBPACK_IMPORTED_MODULE_1__moduleImporter__["a" /* default */])(name);
      if (!Component) {
        console.error(name + " tried to render but was not found");
        return null;
      }
      // if there is a scenario we want to move something to children
      // like ColumnGroup to Column/Section
      if (clonedExtraProps.children) delete clonedExtraProps.children;
      if (clonedExtraProps.children) delete clonedExtraProps.components;

      // Legacy issue, we don't want to pass fullWidth to Button from Section
      if (parentsName === "Section" && name === "Button") {
        if (clonedExtraProps.fullWidth) delete clonedExtraProps.fullWidth;
      }

      var key = name + "-" + index;
      if (randomGeneration) {
        key = key + "-" + Math.floor(Math.random() * 100000);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({
        key: key
      }, clonedExtraProps, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43
        }
      }));
    }
    return null;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (componentParser);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils__ = __webpack_require__(9);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var cookieHandler = function () {
  function cookieHandler() {
    _classCallCheck(this, cookieHandler);

    if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */]) return;
    this.cookie = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document.cookie || "";
    this.parsedCookie = this._parseCookie();
  }

  cookieHandler.prototype._parseCookie = function _parseCookie() {
    var parsedCookie = {};
    var decodedCookie = this.cookie;
    var decodedCookieArray = decodedCookie.split(";");
    decodedCookieArray.forEach(function (item) {
      var splitedItem = item.split("=");
      parsedCookie[splitedItem[0].trim()] = splitedItem[1];
    });
    this.parsedCookie = parsedCookie;
    return parsedCookie;
  };

  cookieHandler.prototype.getCookie = function getCookie(name) {
    var nameFormatted = name;
    if (this.parsedCookie && this.parsedCookie[nameFormatted]) {
      return this.parsedCookie[nameFormatted];
    }
    return null;
  };

  cookieHandler.prototype.setCookie = function setCookie(name, value) {
    var newCookie = name + "=" + value + ";";

    var date = new Date();
    var days = 30;
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    newCookie = newCookie + ";path=/;expires=" + date.toGMTString();

    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document.cookie = newCookie;
    this.cookie = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document.cookie;
    this.parsedCookie = this._parseCookie();
    return newCookie;
  };

  return cookieHandler;
}();

/* harmony default export */ __webpack_exports__["a"] = (cookieHandler);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_BROWSER; });
/* unused harmony export IS_DEV */
/* unused harmony export IS_TEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return WINDOW; });
/* unused harmony export NAVIGATOR */
/* unused harmony export DOCUMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IS_IFRAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HAS_TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IS_IOS; });
/* unused harmony export IS_ANDROID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_IE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_EDGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MIN_BROWSERS; });
var IS_BROWSER = typeof window !== "undefined";
var IS_DEV = "production" !== "production";
var IS_TEST = "production" === "test";
var WINDOW = IS_BROWSER && window;
var NAVIGATOR = WINDOW && WINDOW.navigator;
var DOCUMENT = WINDOW && WINDOW.document;
var IS_IFRAME = WINDOW && WINDOW.self !== WINDOW.top;
var HAS_TOUCH = DOCUMENT && "ontouchstart" in DOCUMENT.documentElement;
var IS_IOS = NAVIGATOR && /iPhone|iPad|iPod/i.test(NAVIGATOR.userAgent || "");
var IS_ANDROID = NAVIGATOR && /Android/i.test(NAVIGATOR.userAgent || "");
var IS_MOBILE = NAVIGATOR && /iPhone|iPod|Android/i.test(NAVIGATOR.userAgent);
var IS_IE = NAVIGATOR && /Trident/i.test(NAVIGATOR.userAgent || "");
var IS_EDGE = NAVIGATOR && /Edge/i.test(NAVIGATOR.userAgent || "");
var MIN_BROWSERS = {
  safari: 9.1,
  chrome: 57,
  firefox: 53,
  msie: 11,
  msedge: 14
};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicConstants_MESSAGES__ = __webpack_require__(30);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var fetchAPI = function fetchAPI(_ref) {
  var url = _ref.url,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? "GET" : _ref$method,
      _ref$body = _ref.body,
      body = _ref$body === undefined ? null : _ref$body;

  var verificationTokenHeaderName = 'X-XSRF-TOKEN';
  var tokenElements = document.getElementsByName(verificationTokenHeaderName);
  var options = {
    method: method,
    credentials: "include",
    headers: {
      "content-type": "application/json"
    }
  };

  if (tokenElements.length === 1) {
    options.headers[verificationTokenHeaderName] = tokenElements[0].value;
  }

  if (body) options.body = JSON.stringify(body);

  return new Promise(function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch(url, options).then(function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (response.status === 200) {
                            resolve(response);
                          }
                          reject({
                            status: response.status,
                            message: response.status === 429 ? __WEBPACK_IMPORTED_MODULE_1_AtomicConstants_MESSAGES__["a" /* default */].SERVICE_MAX_TRIES : __WEBPACK_IMPORTED_MODULE_1_AtomicConstants_MESSAGES__["a" /* default */].UNEXPECTED_ERROR
                          });

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
};

/* harmony default export */ __webpack_exports__["a"] = (fetchAPI);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gtm_events_book_testdrive_duck__ = __webpack_require__(480);
/* unused harmony reexport bookTestDriveFormActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gtm_events_compare_tool_duck__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__gtm_events_compare_tool_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gtm_events_compare_vehicle_selector_duck__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__gtm_events_compare_vehicle_selector_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gtm_events_global_nav_duck__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__gtm_events_global_nav_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gtm_events_global_footer_duck__ = __webpack_require__(484);
/* unused harmony reexport gtmGlobalFooterActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gtm_events_contact_us_duck__ = __webpack_require__(485);
/* unused harmony reexport getInTouchFormActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gtm_events_accessory_list_duck__ = __webpack_require__(486);
/* unused harmony reexport gtmAccessoryListActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gtm_events_accordion_duck__ = __webpack_require__(487);
/* unused harmony reexport gtmAccordionActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gtm_events_background_image_selector_duck__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__gtm_events_background_image_selector_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gtm_events_build_duck__ = __webpack_require__(489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__gtm_events_build_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gtm_events_button_duck__ = __webpack_require__(490);
/* unused harmony reexport gtmButtonActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__gtm_events_feature_youtube_duck__ = __webpack_require__(491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__gtm_events_feature_youtube_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__gtm_events_map_search_duck__ = __webpack_require__(492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_12__gtm_events_map_search_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__gtm_events_icon_tout_block_duck__ = __webpack_require__(493);
/* unused harmony reexport gtmIconToutBlockActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__gtm_events_in_page_navigation_duck__ = __webpack_require__(494);
/* unused harmony reexport gtmInPageNavigationActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__gtm_events_map_select_state_duck__ = __webpack_require__(495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_15__gtm_events_map_select_state_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__gtm_events_mini_configurator_duck__ = __webpack_require__(496);
/* unused harmony reexport gtmMiniConfiguratorActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__gtm_events_mymazda_login_duck__ = __webpack_require__(497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_17__gtm_events_mymazda_login_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__gtm_events_mymazda2_duck__ = __webpack_require__(498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_18__gtm_events_mymazda2_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__gtm_events_mymazda_register_duck__ = __webpack_require__(1222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_19__gtm_events_mymazda_register_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__gtm_events_mymazda_summary_duck__ = __webpack_require__(499);
/* unused harmony reexport gtmMyMazdaSummaryActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__gtm_events_offers_duck__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_21__gtm_events_offers_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__gtm_events_outlet_store_duck__ = __webpack_require__(501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_22__gtm_events_outlet_store_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__gtm_events_outlet_store_enquiry_form_duck__ = __webpack_require__(502);
/* unused harmony reexport gtmOutletStoreEnquiryFormActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__gtm_events_recalls_block_duck__ = __webpack_require__(503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_24__gtm_events_recalls_block_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__gtm_events_register_interest_duck__ = __webpack_require__(504);
/* unused harmony reexport gtmRegisterInterestActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__gtm_events_search_duck__ = __webpack_require__(505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_26__gtm_events_search_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__gtm_events_image_tout_block_duck__ = __webpack_require__(506);
/* unused harmony reexport imageToutBlockActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__gtm_events_postcode_popup_duck__ = __webpack_require__(507);
/* unused harmony reexport postcodeActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__gtm_events_book_service_duck__ = __webpack_require__(508);
/* unused harmony reexport requestServiceFormActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__gtm_events_wysiwyg_content_duck__ = __webpack_require__(509);
/* unused harmony reexport wysiwygActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__gtm_events_competition_form_duck__ = __webpack_require__(510);
/* unused harmony reexport competitionFormActionTypes */

































/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(144)('wks');
var uid = __webpack_require__(94);
var Symbol = __webpack_require__(18).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(57);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fromLinkInputs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formLinkSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formSetDefaultValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formSetValidations; });
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var fromLinkInputs = function fromLinkInputs(state, name) {
  var _onChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  return {
    onChange: function onChange(value) {
      var _extends2;

      var _CheckValidation = CheckValidation({
        validations: state.state.form[name].validations,
        value: value
      }, state),
          isValid = _CheckValidation.isValid,
          message = _CheckValidation.message;

      state.setState({
        form: _extends({}, state.state.form, (_extends2 = {}, _extends2[name] = _extends({}, state.state.form[name], {
          value: value,
          isValid: isValid,
          dirty: true,
          message: message
        }), _extends2))
      }, function () {
        var disabled = [];
        var form = _extends({}, state.state.form);
        Object.keys(form).forEach(function (inputName) {
          if (inputName !== "submitButton") {
            form[inputName] = CheckValidation(form[inputName], state);
            if (!form[inputName].isValid) {
              disabled.push(form[inputName]);
            }
          }
        });
        state.setState({
          form: _extends({}, state.state.form, {
            submitButton: _extends({}, state.state.form.submitButton, {
              disabled: disabled.length > 0
            })
          })
        }, function () {
          return _onChange(value);
        });
      });
    },
    getThisInput: function getThisInput(inputThis) {
      if (!state.form) state.form = [];
      state.form[name] = inputThis;
    },
    defaultValue: state.state.form["" + name].defaultValue,
    required: state.state.form[name].validations && state.state.form[name].validations.required,
    message: state.state.form["" + name].message,
    isValid: !state.state.form["" + name].dirty || state.state.form["" + name].isValid
  };
};

var formLinkSubmit = function formLinkSubmit(state) {
  var onSubmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return {
    onClick: function onClick() {
      var disabled = [];
      var form = _extends({}, state.state.form);
      Object.keys(form).forEach(function (inputName) {
        if (inputName !== "submitButton") {
          form[inputName] = _extends({}, CheckValidation(form[inputName], state));
          form[inputName].dirty = true;
          if (!form[inputName].isValid) {
            disabled.push(form[inputName]);
          }
        }
      });

      state.setState({
        form: _extends({}, form, {
          submitButton: _extends({}, form.submitButton, {
            disabled: disabled.length > 0
          })
        })
      }, function () {
        if (!form.submitButton.disabled) onSubmit();
      });
    },
    disabled: state.state.form.submitButton.disabled
  };
};

var formSetDefaultValues = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(state) {
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Object.keys(values).forEach(function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(inputName, item) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!(state.form && state.form[inputName] && (values[inputName] || values[inputName] === false))) {
                          _context.next = 3;
                          break;
                        }

                        _context.next = 3;
                        return setTimeout(function () {
                          state.form[inputName]._onChange(values[inputName], true);
                        }, 10);

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x6, _x7) {
                return _ref2.apply(this, arguments);
              };
            }());

          case 2:
            callback();

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function formSetDefaultValues(_x3) {
    return _ref.apply(this, arguments);
  };
}();

var formSetValidations = function formSetValidations(state, name) {
  var newValidations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var form = _extends({}, state.state.form);
  Object.keys(form).forEach(function (inputName) {
    if (inputName !== "submitButton") {
      form[inputName].isValid = true;
      if (inputName === name) {
        form[inputName].validations = newValidations;
      }
    }
  });

  state.setState({
    form: form
  }, function () {
    var disabled = [];
    var form = _extends({}, state.state.form);
    Object.keys(form).forEach(function (inputName) {
      if (inputName !== "submitButton") {
        form[inputName] = CheckValidation(form[inputName], state);
        if (!form[inputName].isValid) {
          disabled.push(form[inputName]);
        }
      }
    });
    state.setState({
      form: _extends({}, state.state.form, {
        submitButton: _extends({}, state.state.form.submitButton, {
          disabled: disabled.length > 0
        })
      })
    });
  });
};

var CheckValidation = function CheckValidation(newInput, state) {
  var isValid = true;
  var message = "";
  if (newInput.validations) {
    // validations
    // --> required
    // --> phone


    if (isValid && newInput.validations.phone) {
      if (newInput.value) {
        if (newInput.value.length < 9) {
          isValid = false;
        } else if (!String(newInput.value).match(/^0(2|3|4|7|8|9)\d+$/)) {
          isValid = false;
        }
        message = isValid ? "" : newInput.validations.phone;
      }
    }

    if (isValid && newInput.validations.mobilePhone) {
      if (newInput.value) {
        if (newInput.value.length < 9) {
          isValid = false;
        } else if (!String(newInput.value).match(/^04\d+$/)) {
          isValid = false;
        }
        message = isValid ? "" : newInput.validations.mobilePhone;
      }
    }

    if (isValid && newInput.validations.extension) {
      if (newInput.value) {
        if (newInput.value.length > 6) {
          isValid = false;
        } else if (!String(newInput.value).match(/\[?([0-9])\]?/g)) {
          isValid = false;
        }
        message = isValid ? "" : newInput.validations.extension;
      }
    }

    if (isValid && newInput.validations.email) {
      if (newInput.value) {
        if (newInput.value.length > 60) {
          isValid = false;
        } else if (!String(newInput.value).match(/^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/)) {
          isValid = false;
        }
        message = isValid ? "" : newInput.validations.email;
      }
    }

    if (isValid && newInput.validations.address) {
      if (newInput.value) {
        if (!newInput.value.streetNumber) {
          isValid = false;
        }
        message = isValid ? "" : newInput.validations.address;
      }
    }

    if (isValid && newInput.validations.postcode) {
      // if (newInput.value) {
      //   if (newInput.value.length < 4) {
      //     isValid = false
      //   } else if (!String(newInput.value).match(/^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/)) {
      //     isValid = false
      //   }
      //   message = isValid ? "" : newInput.validations.postcode
      // }
    }

    if (isValid && newInput.validations.odometer) {
      if (newInput.value) {
        if (!String(newInput.value).match(/^[0-9]*$/)) {
          isValid = false;
        } else if (newInput.value.indexOf(".") > -1) {
          isValid = false;
        }
        message = isValid ? "" : newInput.validations.odometer;
      }
    }

    if (isValid && newInput.validations.postcodeSearchable) {
      if (newInput.value) {
        if (!newInput.value.postcode) {
          isValid = false;
        } else if (newInput.value.postcode.length < 4) {
          isValid = false;
        } else if (!String(newInput.value.postcode).match(/^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/)) {
          isValid = false;
        }
        message = isValid ? "" : newInput.validations.postcodeSearchable;
      }
    }

    if (isValid && newInput.validations.businessName) {
      if (newInput.value) {
        if (newInput.value.length > 200) {
          isValid = false;
        } else if (!String(newInput.value).match(/^[A-Za-z0-9!#$%&'()*,-.\/:;=?@\\_{|}]+(?: [A-Za-z0-9!#$%&'()*,-.\/:;=?@\\_{|}]+)*$/)) {
          isValid = false;
        }
        message = isValid ? "" : newInput.validations.postcode;
      }
    }

    if (isValid && newInput.validations.confirmPassword) {
      if (newInput.value) {
        if (newInput.value != state.state.form.password.value) {
          isValid = false;
        }
        message = isValid ? "" : newInput.validations.confirmPassword;
      }
    }

    if (isValid && newInput.validations.required) {
      isValid = !!(newInput.value && newInput.value !== "");
      message = isValid ? "" : newInput.validations.required;
    }
  }

  var result = _extends({}, newInput);
  result.isValid = isValid;
  result.message = message;

  return result;
};

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(941);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SameHeadingStyle":"Typography__SameHeadingStyle___3_8V4","WithDetails":"Typography__WithDetails___2nKC7","white":"Typography__white___27E2a","Glow":"Typography__Glow___xO_4I","glow":"Typography__glow___3jksb","H1":"Typography__H1___nrXAk","H2":"Typography__H2___1qw1V","H3":"Typography__H3___2KR6I","H4":"Typography__H4___2DH39","H5":"Typography__H5___3XGe2","H6":"Typography__H6___1z9An","Interactive":"Typography__Interactive___2tIRr","P":"Typography__P___h8aGa","disclaimer":"Typography__disclaimer___1pOIv","withoutMargin":"Typography__withoutMargin___2bReC","Caption":"Typography__Caption___3i28p","grey":"Typography__grey___14I9C","black":"Typography__black___2Q5HS","A":"Typography__A___YFiux","active":"Typography__active___1r54u","blackColor":"Typography__blackColor___2RC7B","redColor":"Typography__redColor___Hmhwr","whiteColor":"Typography__whiteColor___3T7-_","greyColor":"Typography__greyColor___-Rroe","withoutStyle":"Typography__withoutStyle___11W7o","Space":"Typography__Space___2G0RH"};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(19)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var IE8_DOM_DEFINE = __webpack_require__(306);
var toPrimitive = __webpack_require__(63);
var dP = Object.defineProperty;

exports.f = __webpack_require__(28) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _MESSAGES;

var MESSAGES = (_MESSAGES = {
  ADDRESS_INVALID: "Please select a valid street address.",
  ADDRESS_LOCATION_INVALID: "Please select a valid address from the list.",
  ADDRESS_REQUIRED: "Please enter your address.",
  ADDRESS1_REQUIRED: "Please enter an address.",
  ADDRESS2_REQUIRED: "Please enter a suburb.",
  ADDRESS3_REQUIRED: "Please enter a postcode.",
  BODYSTYLE_REQUIRED: "Please select a body style.",
  BUSINESS_INVALID: "Please enter a valid business name.",
  BUSINESS_REQUIRED: "Please enter a business name.",
  DATE_REQUIRED: "Please select a date",
  DEALERS_NO_POSTCODE: "Please enter your postcode, suburb or dealer name.",
  DEALERS_REQUIRED: "Please select a dealer.",
  EMAIL_INVALID: "Please enter a valid email address.",
  EMAIL_MAXLENGTH: "Email is too long.",
  EMAIL_REQUIRED: "Please enter an email address.",
  FINANCE_REQUIRED: "Please select one of the options.",
  FIRSTNAME_MAXLENGTH: "First name must be shorter than 30 characters",
  FIRSTNAME_NUMBERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  FIRSTNAME_REQUIRED: "Please enter a first name.",
  FIRSTNAME_SPECIAL_CHARACTERS_POSITION: "Please use only letters (a-z) for the first and last character of your name.",
  FIRSTNAME_SPECIAL_CHARACTERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LASTNAME_MAXLENGTH: "Last name must be shorter than 50 characters",
  LASTNAME_NUMBERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LASTNAME_REQUIRED: "Please enter a last name.",
  LASTNAME_SPECIAL_CHARACTERS_POSITION: "Please use only letters (a-z) for the first and last character of your name.",
  LASTNAME_SPECIAL_CHARACTERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LOCATION_INVALID: "Please select a valid postcode or suburb from the list.",
  LOCATION_REQUIRED: "Please enter your postcode or tell us which suburb you live in.",
  MOBILE_NUMBER_INVALID: "Please enter a valid mobile number",
  MOBILE_NUMBER_REQUIRED: "Please enter your mobile number.",
  MODEL_FREETEXT_REQUIRED: "Please enter a model.",
  MODEL_REQUIRED: "Please select a model from the drop-down list."
}, _MESSAGES["MODEL_REQUIRED"] = "Please select a model.", _MESSAGES.MULTIPLERESULTS = "Sorry, no result can be displayed because more than one result exists in Mazda’s database. Please enter your VIN and try again or contact your local Mazda dealer.", _MESSAGES.NOTFOUND = "Unfortunately we were unable to identify your vehicle from the details entered, or no service data exists. Please verify the vehicle details entered and try again, or contact your local Mazda dealer.", _MESSAGES.NOTSUPPORTED = "Unfortunately the VIN/Rego number you entered is not supported. Please verify the vehicle details entered and try again, or contact your local Mazda dealer.", _MESSAGES.ODOMETER_INVALID = "Please enter odometer value as a whole number.", _MESSAGES.ODOMETER_REQUIRED = "Please enter odometer value.", _MESSAGES.OPTIN_REQUIRED = "This is a mandatory field", _MESSAGES.PASSWORD_CASE = "Password must contain atleast one uppercase and one lowercase letter.", _MESSAGES.PASSWORD_MAXLENGTH = "Password is too long.", _MESSAGES.PASSWORD_MINLENGTH = "Password is too short.", _MESSAGES.PASSWORD_NUMBER_SYMBOL = "Password must contain atleast one number or symbol.", _MESSAGES.PASSWORD_REQUIRED = "Please enter a password.", _MESSAGES.PHONE_EXTENSION_INVALID = "The extension number you have entered is not valid. Please ensure it does not exceed 6 digits.", _MESSAGES.PHONE_NUMBER_AREACODE_INVALID = "Please enter a valid landline or mobile number using the correct area code.", _MESSAGES.PHONE_NUMBER_INVALID = "Please remove spaces or characters and ensure number at least 9 digits.", _MESSAGES.PHONE_NUMBER_REQUIRED = "Please enter your phone number.", _MESSAGES.POSTCODE_INVALID = "Please enter a valid postcode.", _MESSAGES.PRIVACY_POLICY_REQUIRED = "This is a mandatory field", _MESSAGES.PROFANITY_FILTER = "Your input has triggered the profanity filter, please try again", _MESSAGES.RECAPTCHA_REQUIRED = "This is a mandatory field", _MESSAGES.REGISTRATION_INVALID = "Please enter valid registration number.", _MESSAGES.REGO_OR_VIN_REQUIRED = "Please enter a valid registration or VIN.", _MESSAGES.SELECT_REQUIRED = "Please select one from the drop-down list.", _MESSAGES.SERVICE_MAX_TRIES = "Sorry, you've exceeded the number of tries for this service. Please try again later.", _MESSAGES.STATE_REQUIRED = "Please select your state.", _MESSAGES.TIME_INVALID = "Please enter time in the format HH/MM.", _MESSAGES.TIME_REQUIRED = "Please select a time", _MESSAGES.TITLE_REQUIRED = "Please select a title from the drop-down list.", _MESSAGES.TOPIC_REQUIRED = "Please select an enquiry topic from the drop-down list.", _MESSAGES.UNEXPECTED_ERROR = "Sorry, we've encountered an unexpected error. Please try again later.", _MESSAGES.VIN_INVALID = "Please enter a valid VIN number.", _MESSAGES);

/* harmony default export */ __webpack_exports__["a"] = (MESSAGES);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(64);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(932);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicUtils_scroll__ = __webpack_require__(180);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// Functions that can be used in urlHandler
// new urlHandler(URL);
// setParam(key, value, changeURLOfThePage)
// removeParam(key, changeURLOfThePage)
// newTab()

var urlHandler = function urlHandler(fullUrl) {
  var _this = this;

  _classCallCheck(this, urlHandler);

  this.parseUrl = function () {
    _this.setHrefWithoutSearchParams();
    _this.setSeachParams();
    _this.setDetails();
    _this.setSearchParamsQuery();
  };

  this.getHref = function () {
    return _this.href;
  };

  this.setHrefWithoutSearchParams = function () {
    _this.hrefWithoutSearchParams = _this.href.split("?")[0];
  };

  this.setDetails = function () {
    var parsed = _this.href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    if (parsed) {
      _this.details = {
        protocol: parsed[1],
        host: parsed[2],
        hostname: parsed[3],
        port: parsed[4],
        pathname: parsed[5],
        search: parsed[6],
        hash: parsed[7]
      };
    }
  };

  this.getPathname = function () {
    return _this.details.pathname;
  };

  this.getHrefWithoutSearchParams = function () {
    return _this.hrefWithoutSearchParams;
  };

  this.setSeachParams = function () {
    _this.searchParams = _this.href.split("?")[1];
  };

  this.getSeachParams = function () {
    return _this.searchParams;
  };

  this.setSearchParamsQuery = function () {
    var query = {};
    if (_this.searchParams) {
      var pairs = (_this.searchParams[0] === "?" ? _this.searchParams.substr(1) : _this.searchParams).split("&");
      for (var i = 0; i < pairs.length; i += 1) {
        var pair = pairs[i].split("=");
        var key = decodeURIComponent(pair[0]);
        if (query[key]) {
          if (!Array.isArray(query[key])) {
            query[key] = [query[key]];
          }
          query[key].push(decodeURIComponent(pair[1] || ""));
        } else {
          query[key] = decodeURIComponent(pair[1] || "");
        }
      }
    }
    _this.query = query;
  };

  this.getSearchParamsQuery = function () {
    return _this.query;
  };

  this.getParam = function (key) {
    return _this.query[key];
  };

  this.buildNewUrl = function (queries) {
    var newSearchParams = "";
    Object.keys(queries).forEach(function (key) {
      if (key && key !== null && queries[key] !== null) {
        if (newSearchParams !== "") {
          newSearchParams += "&" + key + "=" + queries[key];
        } else {
          newSearchParams = "?" + key + "=" + queries[key];
        }
      }
    });
    _this.href = "" + _this.hrefWithoutSearchParams + (newSearchParams !== "" ? newSearchParams : "");
    _this.parseUrl();
    return _this.href;
  };

  this.setParam = function (key, value, changeURLOfThePage) {
    var newKey = encodeURIComponent(key);
    var newValue = encodeURIComponent(value);
    var queries = _this.query;

    queries[newKey] = newValue;
    _this.href = _this.buildNewUrl(queries);

    if (changeURLOfThePage) __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].history.pushState(null, null, _this.href);

    return _this.href;
  };

  this.removeParam = function (key, changeURLOfThePage) {
    var newKey = encodeURIComponent(key);
    var queries = _this.query;

    if (queries[newKey]) {
      delete queries[newKey];
    }

    _this.href = _this.buildNewUrl(queries);

    if (changeURLOfThePage) __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].history.pushState(null, null, _this.href);

    return _this.href;
  };

  this.newTab = function () {
    var addOrigin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var newHref = _this.href;
    if (addOrigin) {
      newHref = __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].location.origin + newHref;
    }
    __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].open(newHref);
  };

  this.redirect = function () {
    var addOrigin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var newHref = _this.href;
    if (addOrigin) {
      newHref = __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].location.origin + newHref;
    } else if (newHref.replace(__WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].location.pathname, '').slice(0, 1) === "#") {
      Object(__WEBPACK_IMPORTED_MODULE_1_AtomicUtils_scroll__["a" /* scrollToElementId */])(newHref.split("#")[1]);
    } else if (newHref.replace(__WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].location.pathname, '').slice(0, 2) === "/#") {
      Object(__WEBPACK_IMPORTED_MODULE_1_AtomicUtils_scroll__["a" /* scrollToElementId */])(newHref.split("#")[1]);
      _this.setHash(newHref.split("#")[1]);
      return;
    }
    __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].location = newHref;
  };

  this.getHash = function () {
    return __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].location.hash.slice(1);
  };

  this.setHash = function (hash) {
    return __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].location.hash = hash;
  };

  this.href = fullUrl;
  this.hrefWithoutSearchParams = "";
  this.searchParams = "";
  this.details = {};
  this.query = {};

  this.parseUrl();
};

/* harmony default export */ __webpack_exports__["a"] = (urlHandler);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PLACEHOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return identity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return pipe; });
/* unused harmony export compose */
/* unused harmony export nAry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return unary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return curry; });
/* unused harmony export partial */
/* unused harmony export defer */
/* unused harmony export tap */
/* unused harmony export until */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return invokeFuncs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return onKeyPress; });
var _this2 = this;

var PLACEHOLDER = Symbol("PLACEHOLDER");

var basePartial = function basePartial(fn, args) {
  return fn.bind.apply(fn, [null].concat(args));
};

var nextPlaceholderIdx = function nextPlaceholderIdx(args) {
  return args.indexOf(PLACEHOLDER);
};

var noop = function noop() {};

var identity = function identity(x) {
  return x;
};

var constant = function constant(x) {
  return function () {
    return x;
  };
};

var isFunction = function isFunction(t) {
  return t ? typeof t === "function" : false;
};

var pipe = function pipe(first) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return function () {
    return rest.reduce(function (result, fn) {
      return fn(result);
    }, first.apply(undefined, arguments));
  };
};

var compose = function compose() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return pipe.apply(undefined, fns.reverse());
};

var nAry = function nAry(arity, fn) {
  if (fn === undefined) return function (cFn) {
    return nAry(arity, cFn);
  };
  return function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return fn.apply(undefined, args.slice(0, arity));
  };
};

var unary = nAry(1);

var curry = function curry(fn) {
  return function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    if (nextPlaceholderIdx(args) === -1) {
      return args.length >= fn.length ? fn.apply(undefined, args) : curry(basePartial(fn, args));
    }

    return function () {
      for (var _len5 = arguments.length, nextArgs = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        nextArgs[_key5] = arguments[_key5];
      }

      var newArgs = args.map(function (v) {
        return v === PLACEHOLDER && nextArgs.length ? nextArgs.shift() : v;
      });
      newArgs = newArgs.concat(nextArgs);

      return newArgs.length >= fn.length && nextPlaceholderIdx(newArgs) === -1 ? fn.apply(undefined, newArgs) : curry(fn).apply(undefined, newArgs);
    };
  };
};

var partial = curry(basePartial);

var defer = function defer(fn) {
  return setTimeout(fn, 0);
};

var tap = curry(function (fn, x) {
  fn(x);
  return x;
});

function shallowRecursively(wrapper, selector) {
  // Do not try to shallow render empty nodes and host elements
  // (a.k.a primitives). Simply return the wrapper in that case.
  if (wrapper.isEmptyRender() || typeof wrapper.getElement().type === "string") return wrapper;

  var nextWrapper = wrapper.dive();

  return selector && wrapper.is(selector) ? nextWrapper : shallowRecursively(nextWrapper, selector);
}

function until(selector) {
  var _this = this;

  return this.single("until", function () {
    return shallowRecursively(_this, selector);
  });
}

// Invoke an array of functions object that has the blueprint of {func: func, args: []}
var invokeFuncs = function invokeFuncs(functions) {
  if (Array.isArray(functions)) {
    functions.map(function (funcObj, i) {
      if (!funcObj || !funcObj.args) return;
      if (Array.isArray(funcObj.args)) {
        funcObj.func.apply(_this2, funcObj.args);
      } else if (funcObj.args.gtmID) {
        funcObj.func.call(_this2, funcObj.args);
      }
    });
  } else {
    console.warn("You did not pass an array to invokeFuncs");
  }
};

var onKeyPress = function onKeyPress(keys) {
  return function (func) {
    return function (event) {
      if (keys.some(function (key) {
        return event.key === key;
      })) {
        func(event);
      }
    };
  };
};

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return routerActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return flashActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return serviceActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return notificationsActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return uiStateActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shorthash__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shorthash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shorthash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






// Action Types

var routerActionTypes = {
  MYMAZDA_FETCH_START: "MYMAZDA_FETCH_START",
  MYMAZDA_FETCH_ERROR: "MYMAZDA_FETCH_ERROR",
  MYMAZDA_FETCH_SUCCESS: "MYMAZDA_FETCH_SUCCESS",
  MYMAZDA_UPDATE_ROUTE_COMPONENTS: "MYMAZDA_UPDATE_ROUTE_COMPONENTS",
  MYMAZDA_REGISTER_ROUTES: "MYMAZDA_REGISTER_ROUTES",
  MYMAZDA_HYDRATE_ROUTE_COMPONENTS: "MYMAZDA_HYDRATE_ROUTE_COMPONENTS",
  MYMAZDA_REFRESH_CURRENT_ROUTE: "MYMAZDA_REFRESH_CURRENT_ROUTE"
};

var flashActionTypes = {
  MYMAZDA_FLASH_ADD_MESSAGE: "MYMAZDA_FLASH_ADD_MESSAGE",
  MYMAZDA_FLASH_REMOVE_MESSAGE: "MYMAZDA_FLASH_REMOVE_MESSAGE"
};

var serviceActionTypes = {
  MYMAZDA_UPDATE_SERVICE_DETAILS: "MYMAZDA_UPDATE_SERVICE_DETAILS"
};

var notificationsActionTypes = {
  MYMAZDA_SAVE_NOTIFICATIONS: "MYMAZDA_SAVE_NOTIFICATIONS"
};

var uiStateActionTypes = {
  MYMAZDA_TOGGLE_NAV: "MYMAZDA_TOGGLE_NAV",
  MYMAZDA_TOGGLE_USER: "MYMAZDA_TOGGLE_USER",
  MYMAZDA_TOGGLE_NOTIFICATIONS: "MYMAZDA_TOGGLE_NOTIFICATIONS",
  MYMAZDA_EXPAND_NAV_ITEM: "MYMAZDA_EXPAND_NAV_ITEM",
  MYMAZDA_TOGGLE_NAV_ITEM: "MYMAZDA_TOGGLE_NAV_ITEM",
  MYMAZDA_CLOSE_ALL: "MYMAZDA_CLOSE_ALL"
};

var actionTypes = _extends({}, routerActionTypes, flashActionTypes, serviceActionTypes, notificationsActionTypes, uiStateActionTypes);

var toggleNav = function toggleNav() {
  return {
    type: uiStateActionTypes.MYMAZDA_TOGGLE_NAV,
    payload: {}
  };
};

var toggleUser = function toggleUser() {
  return {
    type: uiStateActionTypes.MYMAZDA_TOGGLE_USER,
    payload: {}
  };
};

var toggleNotifications = function toggleNotifications() {
  return {
    type: uiStateActionTypes.MYMAZDA_TOGGLE_NOTIFICATIONS,
    payload: {}
  };
};

var closeAllNav = function closeAllNav() {
  return {
    type: uiStateActionTypes.MYMAZDA_CLOSE_ALL,
    payload: {}
  };
};

var expandNavItem = function expandNavItem(index) {
  return {
    type: uiStateActionTypes.MYMAZDA_EXPAND_NAV_ITEM,
    payload: {
      index: index
    }
  };
};

var toggleNavItem = function toggleNavItem(index) {
  return {
    type: uiStateActionTypes.MYMAZDA_TOGGLE_NAV_ITEM,
    payload: {
      index: index
    }
  };
};

var addFlashMessage = function addFlashMessage(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "MESSAGE";
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
  return {
    type: flashActionTypes.MYMAZDA_FLASH_ADD_MESSAGE,
    payload: {
      id: __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()(),
      timeout: timeout,
      message: message,
      type: type
    }
  };
};

var removeFlashMessage = function removeFlashMessage(id) {
  return {
    type: flashActionTypes.MYMAZDA_FLASH_REMOVE_MESSAGE,
    payload: {
      id: id
    }
  };
};

var hydrateRouteComponents = function hydrateRouteComponents(route, components) {
  return {
    type: routerActionTypes.MYMAZDA_HYDRATE_ROUTE_COMPONENTS,
    payload: {
      components: components,
      route: route,
      key: Object(__WEBPACK_IMPORTED_MODULE_1_shorthash__["unique"])(route || "")
    }
  };
};

var registerRoutes = function registerRoutes(routes) {
  return {
    type: routerActionTypes.MYMAZDA_REGISTER_ROUTES,
    payload: {
      routes: routes
    }
  };
};

var refreshCurrentRoute = function refreshCurrentRoute() {
  return {
    type: routerActionTypes.MYMAZDA_REFRESH_CURRENT_ROUTE
  };
};

// Action Creators
var updateRouteComponents = function updateRouteComponents(route, search) {
  return {
    type: routerActionTypes.MYMAZDA_UPDATE_ROUTE_COMPONENTS,
    payload: {
      route: route,
      search: search,
      key: Object(__WEBPACK_IMPORTED_MODULE_1_shorthash__["unique"])("" + route + search)
    }
  };
};

var updateServiceDetails = function updateServiceDetails(service, vin) {
  return {
    type: serviceActionTypes.MYMAZDA_UPDATE_SERVICE_DETAILS,
    payload: {
      service: service,
      vin: vin
    }
  };
};

var saveNotifications = function saveNotifications(notifications) {
  return {
    type: notificationsActionTypes.MYMAZDA_SAVE_NOTIFICATIONS,
    payload: {
      notifications: notifications
    }
  };
};

var actionCreators = {
  hydrateRouteComponents: hydrateRouteComponents,
  updateRouteComponents: updateRouteComponents,
  registerRoutes: registerRoutes,
  addFlashMessage: addFlashMessage,
  removeFlashMessage: removeFlashMessage,
  updateServiceDetails: updateServiceDetails,
  saveNotifications: saveNotifications,
  refreshCurrentRoute: refreshCurrentRoute,
  toggleNav: toggleNav,
  closeAllNav: closeAllNav,
  expandNavItem: expandNavItem,
  toggleNavItem: toggleNavItem,
  toggleUser: toggleUser,
  toggleNotifications: toggleNotifications

  // Selectors

};var getMymazda = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])("mymazda");

var getMymazdaPage = function getMymazdaPage(vehicleId, route) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["J" /* pipe */])(getMymazda, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])(vehicleId + "." + route));
};

var getRoutes = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["J" /* pipe */])(getMymazda, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])("routes"));

var getUiState = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["J" /* pipe */])(getMymazda, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])("uiState"));

var getRoute = function getRoute(route) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["J" /* pipe */])(getRoutes, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])(route));
};
var getRouteComponents = function getRouteComponents(route, search) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["J" /* pipe */])(getMymazda, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])("cache"), Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])(Object(__WEBPACK_IMPORTED_MODULE_1_shorthash__["unique"])("" + route + search)));
};

var getServices = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["J" /* pipe */])(getMymazda, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])("service"));
var getService = function getService(vin) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["J" /* pipe */])(getServices, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])(vin));
};

var getNotifications = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["J" /* pipe */])(getMymazda, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])("notifications"));

// @todo weird hacky functional programming fix this
var ifDef = function ifDef(suc, fail) {
  return function (state) {
    return !state ? fail() : suc(state);
  };
};
var getBreadcrumb = function getBreadcrumb(route) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["J" /* pipe */])(getRoute(route), ifDef(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])("breadcrumb"), function () {
    return [];
  }));
};

var getFlashMessages = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["J" /* pipe */])(getMymazda, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* get */])("flashMessages"));

var selectors = {
  getRouteComponents: getRouteComponents,
  getMymazda: getMymazda,
  getMymazdaPage: getMymazdaPage,
  getRoutes: getRoutes,
  getBreadcrumb: getBreadcrumb,
  getRoute: getRoute,
  getFlashMessages: getFlashMessages,
  getServices: getServices,
  getService: getService,
  getNotifications: getNotifications,
  getUiState: getUiState
};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GENERAL_STYLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GENERAL_STYLE_HEADING; });
/* unused harmony export GENERAL_STYLE_COPY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BASE_HEADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_COPY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_palette__ = __webpack_require__(13);


var GENERAL_STYLE = {
  OPACITY_HOVER: "0.6"
};

var GENERAL_STYLE_HEADING = {
  COLOR: __WEBPACK_IMPORTED_MODULE_0__color_palette__["a" /* default */].BLACK,
  LETTER_SPACING: "0.2em",
  FONT_WEIGHT: 600,
  LINE_HEIGHT: 1.2
};

var GENERAL_STYLE_COPY = {
  COLOR: __WEBPACK_IMPORTED_MODULE_0__color_palette__["a" /* default */].BLACK,
  FONT_WEIGHT: 200,
  LINE_HEIGHT: 1.4
};

var BASE_HEADING = {
  color: GENERAL_STYLE_HEADING.COLOR,
  letterSpacing: GENERAL_STYLE_HEADING.LETTER_SPACING,
  fontWeight: GENERAL_STYLE_HEADING.FONT_WEIGHT,
  lineHeight: GENERAL_STYLE_HEADING.LINE_HEIGHT,
  textTransform: "uppercase"
};

var BASE_COPY = {
  color: GENERAL_STYLE_COPY.COLOR,
  fontWeight: GENERAL_STYLE_COPY.FONT_WEIGHT,
  lineHeight: GENERAL_STYLE_COPY.LINE_HEIGHT
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(977);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(981);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(982);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(984);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(985);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(987);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(380);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(238);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(989);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(991);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(993);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(994);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(995);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRICE_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SERVICE_SCHEDULE_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GEO_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FORM_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEALER_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SEARCH_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MYMAZDA_ERRORS; });
var ERRORS = {
  POSTCODE_INVALID: "Invalid postcode. Please try again."
};

var PRICE_ERRORS = {
  LOADING: "Your price is on its way.",
  /**
   * @todo  NO_LOCATION not used, text 'postcode' needs to be link
   */
  NO_LOCATION: "Enter your postcode to see accurate pricing in your area.",
  LAST_RESORT: "Price unavailable. Please contact your local Dealer."
};

var SERVICE_SCHEDULE_ERRORS = {
  NOTFOUND: "Unfortunately we were unable to identify your vehicle from the details entered, or no service data exists. Please verify the vehicle details entered and try again, or contact your local Mazda dealer.",
  MULTIPLERESULTS: "Sorry, no result can be displayed because more than one result exists in Mazda’s database. Please enter your VIN and try again or contact your local Mazda dealer."
};

var GEO_ERRORS = {
  // Internal
  // comment out to remove errors from client side

  // // Could not load geocoding functionality
  // NO_GEOCODER: 'Could not access your location',
  // // Could not load geolocation functionality
  // NO_GEOLOCATION: 'Could not access your location',
  // // Could not find post code or location
  POSTCODE_NOT_FOUND: "Invalid postcode. Please try again.",
  LOCATION_NOT_FOUND: "Invalid postcode. Please try again."
  //
  // // Geocoder status via Google Maps Geocoder API
  // // https://developers.google.com/maps/documentation/geocoding/intro#StatusCodes
  //
  // GEOCODER_ZERO_RESULTS: 'Could not find your location',
  // GEOCODER_OVER_QUERY_LIMIT: 'Could not access your location',
  // GEOCODER_REQUEST_DENIED: 'Could not access your location',
  // GEOCODER_INVALID_REQUEST: 'Could not access your location',
  // GEOCODER_UNKNOWN_ERROR: 'Could not access your location',
  //
  // // Geolocation error codes via browser geolocationAPI
  // // https://developer.mozilla.org/en-US/docs/Web/API/PositionError
  //
  // // User denied access to location
  // GEOLOCATION_1: 'Location access denied',
  // // There was error attempting to find user location
  // GEOLOCATION_2: 'Could not access your location',
  // // Attempts to find user location timed out
  // GEOLOCATION_3: 'Could not access your location',
  //
  // // For all else
  // default: 'Could not access your location'


  // Register Interest
  // Book-service
};var FORM_ERRORS = {
  // PERSONAL INFORMATION
  TITLE_REQUIRED: "Please select a title from the drop-down list.",
  SELECT_REQUIRED: "Please select one from the drop-down list.",
  PROFANITY_FILTER: "Your input has triggered the profanity filter, please try again",
  FIRSTNAME_MAXLENGTH: "First name must be shorter than 30 characters",
  FIRSTNAME_SPECIAL_CHARACTERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  FIRSTNAME_SPECIAL_CHARACTERS_POSITION: "Please use only letters (a-z) for the first and last character of your name.",
  FIRSTNAME_NUMBERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  FIRSTNAME_REQUIRED: "Please enter a first name.",
  LASTNAME_MAXLENGTH: "Last name must be shorter than 50 characters",
  LASTNAME_SPECIAL_CHARACTERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LASTNAME_SPECIAL_CHARACTERS_POSITION: "Please use only letters (a-z) for the first and last character of your name.",
  LASTNAME_NUMBERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LASTNAME_REQUIRED: "Please enter a last name.",
  PHONE_NUMBER_AREACODE_INVALID: "Please enter a valid landline or mobile number using the correct area code.",
  PHONE_NUMBER_INVALID: "Please enter a valid landline or mobile number using the correct area code.",
  MOBILE_NUMBER_INVALID: "Please enter a valid mobile number",
  PHONE_NUMBER_REQUIRED: "Please enter your phone number.",
  PHONE_EXTENSION_INVALID: "The extension number you have entered is not valid. Please ensure it does not exceed 6 digits.",
  MOBILE_NUMBER_REQUIRED: "Please enter your mobile number.",
  EMAIL_MAXLENGTH: "Email is too long.",
  EMAIL_INVALID: "Please enter a valid email address.",
  EMAIL_REQUIRED: "Please enter an email address.",
  PASSWORD_REQUIRED: "Please enter a password.",
  PASSWORD_MAXLENGTH: "Password is too long.",
  PASSWORD_MINLENGTH: "Password is too short.",
  PASSWORD_CASE: "Password must contain atleast one uppercase and one lowercase letter.",
  PASSWORD_NUMBER_SYMBOL: "Password must contain atleast one number or symbol.",
  VIN_INVALID: "Please enter valid VIN number.",
  REGISTRATION_INVALID: "Please enter valid registration number.",
  MODEL_REQUIRED: "Please select a model from the drop-down list.",
  PRIVACY_POLICY_REQUIRED: "This is a mandatory field",
  OPTIN_REQUIRED: "This is a mandatory field",
  MODEL_FREETEXT_REQUIRED: "Please enter a model.",
  ODOMETER_REQUIRED: "Please enter odometer value.",
  ODOMETER_INVALID: "Please enter odometer value as a whole number.",
  REGO_OR_VIN_REQUIRED: "Please enter a valid registration or VIN.",
  TOPIC_REQUIRED: "Please select an enquiry topic from the drop-down list.",
  TIME_INVALID: "Please enter time in the format HH/MM.",
  LOCATION_REQUIRED: "Please enter your postcode or tell us which suburb you live in.",
  ADDRESS_REQUIRED: "Please enter your address.",
  LOCATION_INVALID: "Please enter a valid postcode or suburb.",
  ADDRESS_LOCATION_INVALID: "Please enter a full address.",
  STATE_REQUIRED: "Please select your state.",
  ADDRESS_INVALID: "Please enter a valid address.",
  ADDRESS1_REQUIRED: "Please enter an address",
  ADDRESS2_REQUIRED: "Please enter a suburb",
  ADDRESS3_REQUIRED: "Please enter a postcode",
  DEALERS_NO_POSTCODE: "Enter your postcode above and we’ll give you a list of your local Mazda Dealerships."
};

var DEALER_ERRORS = {
  FIRST_VISIT: "",
  NO_DEALERS_FOUND: "Sorry, we can't seem to find the Dealership you're looking for. Please try again."
};

var SEARCH_ERRORS = {
  API_ERROR: "Sorry, there was an error with your search. Please try again later."
};

var MYMAZDA_ERRORS = {
  ACCOUNT_RESEND_CHANGE_EMAIL: "Verification email re-sent. Check your inbox.",
  ACCOUNT_RESEND_CHANGE_EMAIL_FAILED: "Sorry, verification email could not be re-sent. Please try again later.",
  ACCOUNT_CHANGE_EMAIL_REQUESTED: "Verification email sent. Check your inbox.",
  ACCOUNT_PERSONAL_DETAILS_UPDATED: "Personal details updated.",
  ACCOUNT_PASSWORD_UPDATED: "Password changed.",
  VEHICLE_DEACTIVATE_SUCCESS: "Your account was successfully deactivated.",
  VEHICLE_DEACTIVATE_FAILED: "Sorry, your account could not be deactivated at this time. Please try again later.",
  VEHICLE_ADD_TRANSFER_REQUESTED: function VEHICLE_ADD_TRANSFER_REQUESTED(_ref) {
    var nameplate = _ref.nameplate,
        rego = _ref.rego;
    return nameplate + " [" + (rego || "Registration number not available") + "] vehicle transfer requested.";
  },
  VEHICLE_ADD_SUCCESS: function VEHICLE_ADD_SUCCESS(_ref2) {
    var nameplate = _ref2.nameplate,
        rego = _ref2.rego;
    return nameplate + " [" + (rego || "Registration number not available") + "] added to your vehicles.";
  },
  VEHICLE_ADD_FAILED: function VEHICLE_ADD_FAILED(_ref3) {
    var nameplate = _ref3.nameplate,
        rego = _ref3.rego,
        error = _ref3.error;
    return nameplate + " [" + (rego || "Registration number not available") + "] could not be added. " + error;
  },
  VEHICLE_REMOVE_SUCCESS: function VEHICLE_REMOVE_SUCCESS(_ref4) {
    var nameplate = _ref4.nameplate,
        registrationNumber = _ref4.registrationNumber;
    return "Your " + nameplate + " [" + registrationNumber + "] has been removed.";
  },
  VEHICLE_REMOVE_FAILED: function VEHICLE_REMOVE_FAILED(_ref5) {
    var nameplate = _ref5.nameplate,
        registrationNumber = _ref5.registrationNumber,
        error = _ref5.error;
    return "Your " + nameplate + " [" + registrationNumber + "] could not be removed. " + error + ".";
  }
};

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return childParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicUtils_moduleImporter__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(9);
/* unused harmony reexport rafThrottle */
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\utilities\\index.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/**
 * @param {Object} props - True sets columns to full width.
 * @param {Function} additionalProps - Return props as a function of index.
 * @returns {Array} Array of React Component
 */
var childParser = function childParser(_ref) {
  var children = _ref.children,
      components = _ref.components;
  var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return false;
  };

  if (children) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
      if (!child) return null;
      if (additionalProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, additionalProps(index));
      }
      return child;
    });
  }

  if (components) {
    return components.map(function (_ref2, index) {
      var name = _ref2.name,
          props = _ref2.props;
      return renderComponent({
        name: name,
        props: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_utils__["D" /* nullCheckProps */])(props), additionalProps(index), {
          key: index
        })
      });
    });
  }
  return null;
};

// For rendering flexible component given name and props
var renderComponent = function renderComponent(component) {
  var Component = Object(__WEBPACK_IMPORTED_MODULE_1_AtomicUtils_moduleImporter__["a" /* default */])(component.name);
  if (!Component) {
    console.error(component.name + " tried to render but was not found. Please make sure " + component.name + " is imported in /blocks");
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, component.props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46
    }
  }));
};
renderComponent.displayName = "renderComponent";
renderComponent.displayName = "renderComponent";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(29);
var createDesc = __webpack_require__(93);
module.exports = __webpack_require__(28) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var hide = __webpack_require__(44);
var has = __webpack_require__(48);
var SRC = __webpack_require__(94)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(54).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
var fails = __webpack_require__(19);
var defined = __webpack_require__(64);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Read if you do not know what debounce is doing
// https://davidwalsh.name/javascript-debounce-function
// Event Listner has to be called with debounce

var debounce = function debounce(func) {
	var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
	var immediate = arguments[2];

	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

/* harmony default export */ __webpack_exports__["a"] = (debounce);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(129);
var defined = __webpack_require__(64);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(130);
var createDesc = __webpack_require__(93);
var toIObject = __webpack_require__(49);
var toPrimitive = __webpack_require__(63);
var has = __webpack_require__(48);
var IE8_DOM_DEFINE = __webpack_require__(306);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(28) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(48);
var toObject = __webpack_require__(31);
var IE_PROTO = __webpack_require__(202)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(38);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(19);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedValue;
function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
  if (keepUnprefixed) {
    return [prefixedValue, value];
  }
  return prefixedValue;
}
module.exports = exports["default"];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(280)('wks');
var uid = __webpack_require__(191);
var Symbol = __webpack_require__(72).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(6);
var core = __webpack_require__(54);
var fails = __webpack_require__(19);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(55);
var IObject = __webpack_require__(129);
var toObject = __webpack_require__(31);
var toLength = __webpack_require__(24);
var asc = __webpack_require__(218);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(862)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)(o|0)s/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(924);
var objectAssign = __webpack_require__(53);
var decodeComponent = __webpack_require__(925);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setLocal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeLocal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLocalStorageSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return persist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return load; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_universal_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_environment__ = __webpack_require__(12);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var cookies = __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_1__constants_environment__["a" /* DOCUMENT */] && new __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default.a();

var getLocal = function getLocal(key) {
  return __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */].localStorage.getItem(key) || undefined;
};
var setLocal = function setLocal(key, value) {
  return __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */].localStorage.setItem(key, value);
};
var removeLocal = function removeLocal(key) {
  return __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */].localStorage.removeItem(key);
};
var getCookie = function getCookie(key) {
  return cookies && cookies.get(key);
};
var setCookie = function setCookie(key, value) {
  return cookies && cookies.set(key, value, { path: "/" });
};

var isLocalStorageSupported = function isLocalStorageSupported() {
  if (__WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */].localStorage) {
    var test = "__localstoragetest__";
    try {
      __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */].localStorage.setItem(test, test);
      __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */].localStorage.removeItem(test);
    } catch (ex) {
      console.log("localStorage not supported!");
      return false;
    }
    return true;
  }
  return false;
};

var persist = function persist(props) {
  return Object.keys(props).forEach(function (key) {
    var value = void 0;
    if (_typeof(props[key]) === "object") {
      value = JSON.stringify(props[key]);
    } else {
      value = String(props[key]);
    }
    setCookie(key, value);
    // localStorage doesn't work in iOS Safari private mode, hence the checking
    if (isLocalStorageSupported()) {
      setLocal(key, value);
    }
  });
};

var load = function load(key) {
  var _persist;

  var fromCookie = getCookie(key);
  var fromLocal = getLocal(key);
  if (fromCookie) return fromCookie;

  if (fromLocal) persist((_persist = {}, _persist[key] = fromLocal, _persist));
  if (typeof fromLocal === "string") {
    try {
      return JSON.parse(fromLocal);
    } catch (error) {
      return fromLocal;
    }
  }
};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 72 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(28)) {
  var LIBRARY = __webpack_require__(83);
  var global = __webpack_require__(18);
  var fails = __webpack_require__(19);
  var $export = __webpack_require__(6);
  var $typed = __webpack_require__(155);
  var $buffer = __webpack_require__(226);
  var ctx = __webpack_require__(55);
  var anInstance = __webpack_require__(100);
  var propertyDesc = __webpack_require__(93);
  var hide = __webpack_require__(44);
  var redefineAll = __webpack_require__(102);
  var toInteger = __webpack_require__(57);
  var toLength = __webpack_require__(24);
  var toIndex = __webpack_require__(334);
  var toAbsoluteIndex = __webpack_require__(96);
  var toPrimitive = __webpack_require__(63);
  var has = __webpack_require__(48);
  var classof = __webpack_require__(108);
  var isObject = __webpack_require__(20);
  var toObject = __webpack_require__(31);
  var isArrayIter = __webpack_require__(215);
  var create = __webpack_require__(97);
  var getPrototypeOf = __webpack_require__(51);
  var gOPN = __webpack_require__(98).f;
  var getIterFn = __webpack_require__(217);
  var uid = __webpack_require__(94);
  var wks = __webpack_require__(23);
  var createArrayMethod = __webpack_require__(66);
  var createArrayIncludes = __webpack_require__(145);
  var speciesConstructor = __webpack_require__(132);
  var ArrayIterators = __webpack_require__(220);
  var Iterators = __webpack_require__(110);
  var $iterDetect = __webpack_require__(150);
  var setSpecies = __webpack_require__(99);
  var arrayFill = __webpack_require__(219);
  var arrayCopyWithin = __webpack_require__(323);
  var $DP = __webpack_require__(29);
  var $GOPD = __webpack_require__(50);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(329);
var $export = __webpack_require__(6);
var shared = __webpack_require__(144)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(332))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enhancer = __webpack_require__(343);

var _enhancer2 = _interopRequireDefault(_enhancer);

var _plugins = __webpack_require__(355);

var _plugins2 = _interopRequireDefault(_plugins);

var _style = __webpack_require__(902);

var _style2 = _interopRequireDefault(_style);

var _styleRoot = __webpack_require__(903);

var _styleRoot2 = _interopRequireDefault(_styleRoot);

var _getState = __webpack_require__(352);

var _getState2 = _interopRequireDefault(_getState);

var _keyframes = __webpack_require__(905);

var _keyframes2 = _interopRequireDefault(_keyframes);

var _resolveStyles = __webpack_require__(344);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Radium(ComposedComponent) {
  return (0, _enhancer2.default)(ComposedComponent);
}

Radium.Plugins = _plugins2.default;
Radium.Style = _style2.default;
Radium.StyleRoot = _styleRoot2.default;
Radium.getState = _getState2.default;
Radium.keyframes = _keyframes2.default;

if (false) {
  Radium.TestMode = {
    clearState: _resolveStyles.__clearStateForTests,
    disable: _resolveStyles.__setTestMode.bind(null, false),
    enable: _resolveStyles.__setTestMode.bind(null, true)
  };
}

exports.default = Radium;
module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THRESHOLD_NORMAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_THRESHOLD_WIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_IFRAME_HEIGHT; });
var DEFAULT_THRESHOLD_NORMAL = 768;
var DEFAULT_THRESHOLD_WIDE = 1200;
var DEFAULT_IFRAME_HEIGHT = 800;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(392);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(72);
var core = __webpack_require__(61);
var ctx = __webpack_require__(123);
var hide = __webpack_require__(91);
var has = __webpack_require__(106);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(92);
var IE8_DOM_DEFINE = __webpack_require__(594);
var toPrimitive = __webpack_require__(273);
var dP = Object.defineProperty;

exports.f = __webpack_require__(81) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(124)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(94)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(48);
var setDesc = __webpack_require__(29).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(19)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(23)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(44)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(9);



// Action Types

var actionTypes = {
  UPDATE_FOOTER_HEIGHT: "UPDATE_FOOTER_HEIGHT",
  UPDATE_GLOBAL_HEADER_HEIGHT: "UPDATE_GLOBAL_HEADER_HEIGHT",
  UPDATE_IN_PAGE_NAV_HEIGHT: "UPDATE_IN_PAGE_NAV_HEIGHT",
  UPDATE_WINDOW_SIZE: "UPDATE_WINDOW_SIZE",
  UPDATE_WINDOW_SCROLL: "UPDATE_WINDOW_SCROLL"

  // Action Creators

};var updateGlobalHeaderHeight = function updateGlobalHeaderHeight(height) {
  return {
    type: actionTypes.UPDATE_GLOBAL_HEADER_HEIGHT,
    payload: { height: height }
  };
};

var updateInPageNavHeight = function updateInPageNavHeight(height) {
  return {
    type: actionTypes.UPDATE_IN_PAGE_NAV_HEIGHT,
    payload: { height: height }
  };
};

var updateFooterHeight = function updateFooterHeight(height) {
  return {
    type: actionTypes.UPDATE_FOOTER_HEIGHT,
    payload: { height: height }
  };
};

var updateWindowSize = function updateWindowSize(win) {
  return {
    type: actionTypes.UPDATE_WINDOW_SIZE,
    payload: win
  };
};

var updateWindowScroll = function updateWindowScroll(win) {
  return {
    type: actionTypes.UPDATE_WINDOW_SCROLL,
    payload: win
  };
};

var actionCreators = {
  updateGlobalHeaderHeight: updateGlobalHeaderHeight,
  updateInPageNavHeight: updateInPageNavHeight,
  updateWindowSize: updateWindowSize,
  updateWindowScroll: updateWindowScroll,
  updateFooterHeight: updateFooterHeight

  // Selectors

};var pickDimensions = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["I" /* pick */])(["innerWidth", "innerHeight"]);
var pickScroll = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["I" /* pick */])(["scrollY"]);

var getEnvironment = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* get */])("environment");
var getGlobalHeaderHeight = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["J" /* pipe */])(getEnvironment, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* get */])("globalHeaderHeight"));
var getInPageNavHeight = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["J" /* pipe */])(getEnvironment, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* get */])("inPageNavHeight"));
var getFooterHeight = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["J" /* pipe */])(getEnvironment, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* get */])("footerHeight"));
var getWindow = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["J" /* pipe */])(getEnvironment, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* get */])("window"));
var getWindowSize = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["J" /* pipe */])(getWindow, pickDimensions);
var getWindowScroll = function getWindowScroll() {
  return {
    scrollY: __WEBPACK_IMPORTED_MODULE_0__constants_environment__["c" /* IS_BROWSER */] ? window.scrollY || window.pageYOffset || document.documentElement.scrollTop : 0
  };
};
var getIsOldBrowser = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["J" /* pipe */])(getEnvironment, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* get */])("isOldBrowser"));

var selectors = {
  getGlobalHeaderHeight: getGlobalHeaderHeight,
  getInPageNavHeight: getInPageNavHeight,
  getFooterHeight: getFooterHeight,
  getWindowSize: getWindowSize,
  getWindowScroll: getWindowScroll,
  getIsOldBrowser: getIsOldBrowser,
  pickDimensions: pickDimensions,
  pickScroll: pickScroll
};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchKoalaData; });
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var fetchKoalaData = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, params) {
    var additionalOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$throwOnUnsucces = _ref2.throwOnUnsuccessful,
        throwOnUnsuccessful = _ref2$throwOnUnsucces === undefined ? true : _ref2$throwOnUnsucces;

    var verificationTokenHeaderName, tokenElements, options, response, json, success, data, errorMsg, errorMessage, errorCode, words, error;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            verificationTokenHeaderName = 'X-XSRF-TOKEN';
            tokenElements = document.getElementsByName(verificationTokenHeaderName);
            options = _extends({
              method: 'POST',
              headers: { 'content-type': 'application/json' }
            }, additionalOptions, {
              credentials: 'include',
              body: JSON.stringify(params)
            });


            if (tokenElements.length === 1) {
              options.headers[verificationTokenHeaderName] = tokenElements[0].value;
            }

            _context.prev = 4;
            _context.next = 7;
            return fetch(url, options);

          case 7:
            response = _context.sent;

            if (!(response.status !== 200)) {
              _context.next = 10;
              break;
            }

            throw new Error('Failed with status ' + response.status);

          case 10:
            _context.next = 12;
            return response.json();

          case 12:
            json = _context.sent;
            success = json.success, data = json.data, errorMsg = json.errorMsg, errorMessage = json.errorMessage, errorCode = json.errorCode, words = json.words;

            if (success) {
              _context.next = 23;
              break;
            }

            if (!throwOnUnsuccessful) {
              _context.next = 22;
              break;
            }

            error = new Error(errorMsg || errorMessage || errorCode);


            if (data) error.data = data;
            if (words) error.words = words;

            throw error;

          case 22:
            return _context.abrupt('return', json);

          case 23:

            if (!data) console.warn('No data returned.', json);

            return _context.abrupt('return', data || undefined);

          case 27:
            _context.prev = 27;
            _context.t0 = _context['catch'](4);

            console.warn('Koala fetch failed');
            console.warn('1. Error:', _context.t0);
            console.warn('2. URL:', url);
            console.warn('3. params:', params);
            throw _context.t0;

          case 34:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[4, 27]]);
  }));

  return function fetchKoalaData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["j"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["g"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* harmony export (immutable) */ __webpack_exports__["h"] = race;
/* harmony export (immutable) */ __webpack_exports__["d"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["f"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["e"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["i"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(52);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button___2WEh2","ButtonRed":"Button__ButtonRed___8nOAr","ButtonWhite":"Button__ButtonWhite___2vUYW","ButtonBlack":"Button__ButtonBlack___27Cf1","ButtonBlackOutlined":"Button__ButtonBlackOutlined___l74zB","ButtonWhiteOutlined":"Button__ButtonWhiteOutlined___31Pqy","ButtonWhiteOutlinedWithOpacity":"Button__ButtonWhiteOutlinedWithOpacity___1ytcD","ButtonDisabled":"Button__ButtonDisabled___2KUju","ButtonFullWidth":"Button__ButtonFullWidth___SjHzW","LoadingSection":"Button__LoadingSection___WwjhU"};

/***/ }),
/* 89 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortalCompat__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PortalWithState__ = __webpack_require__(1254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PortalCompat__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__PortalWithState__["a"]; });





/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(79);
var createDesc = __webpack_require__(188);
module.exports = __webpack_require__(81) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(308);
var enumBugKeys = __webpack_require__(203);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(57);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(16);
var dPs = __webpack_require__(309);
var enumBugKeys = __webpack_require__(203);
var IE_PROTO = __webpack_require__(202)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(200)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(204).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(308);
var hiddenKeys = __webpack_require__(203).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var dP = __webpack_require__(29);
var DESCRIPTORS = __webpack_require__(28);
var SPECIES = __webpack_require__(23)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(55);
var call = __webpack_require__(321);
var isArrayIter = __webpack_require__(215);
var anObject = __webpack_require__(16);
var toLength = __webpack_require__(24);
var getIterFn = __webpack_require__(217);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(45);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return history; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createMemoryHistory__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(12);





var history = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["c" /* IS_BROWSER */] ? __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()() : __WEBPACK_IMPORTED_MODULE_1_history_createMemoryHistory___default()();

var getLocation = function getLocation() {
  return history.location;
};

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getGoogleMapsApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGeocoder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAutocompleteService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_map_react_lib_loaders_google_map_loader__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_map_react_lib_loaders_google_map_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_google_map_react_lib_loaders_google_map_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_config__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Use exisiting loader util from google-map-react so we avoid conflicts in maps api load




var defaultMapsConfig = { key: __WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* GOOGLE_MAPS_API_KEY */], libraries: ["places"] };
var defaultKeys = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["I" /* pick */])(Object.keys(defaultMapsConfig));

var cachedGeocoder = null;
var cachedAutocompleteService = null;

var getGoogleMapsApi = function getGoogleMapsApi() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultMapsConfig$co = _extends({}, defaultMapsConfig, config),
      key = _defaultMapsConfig$co.key,
      libraries = _defaultMapsConfig$co.libraries;

  return __WEBPACK_IMPORTED_MODULE_0_google_map_react_lib_loaders_google_map_loader___default()({ key: key, libraries: libraries.join(",") });
};

var getGeocoder = function getGeocoder() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (cachedGeocoder) return Promise.resolve(_extends({}, cachedGeocoder));
  return getGoogleMapsApi(defaultKeys(config)).then(function (_ref) {
    var Geocoder = _ref.Geocoder,
        GeocoderLocationTypes = _ref.GeocoderLocationTypes,
        GeocoderStatus = _ref.GeocoderStatus;

    cachedGeocoder = {
      geocoder: new Geocoder(),
      locationTypes: GeocoderLocationTypes,
      statusCodes: GeocoderStatus
    };
    return _extends({}, cachedGeocoder);
  });
};

var getAutocompleteService = function getAutocompleteService() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (cachedAutocompleteService) return Promise.resolve(_extends({}, cachedAutocompleteService));
  return getGoogleMapsApi(defaultKeys(config)).then(function (_ref2) {
    var places = _ref2.places;

    cachedAutocompleteService = {
      autocompleteService: new places.AutocompleteService(),
      statusCodes: places.PlacesServiceStatus
    };

    return _extends({}, cachedAutocompleteService);
  });
};

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_googleAutoComplete__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputSearchable_less__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputSearchable_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InputSearchable_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_fetchAPI__ = __webpack_require__(21);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\InputSearchable\\InputSearchable.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var InputSearchable = function (_React$Component) {
  _inherits(InputSearchable, _React$Component);

  function InputSearchable(props) {
    var _this2 = this;

    _classCallCheck(this, InputSearchable);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._onBlurHandler = function () {
      _this.setState({
        places: [],
        showOptions: false
      }, function () {
        var _this$props$onBlur = _this.props.onBlur,
            onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur;

        onBlur();
      });
    };

    _this._onFocusHandler = function () {
      _this.setState({
        showOptions: true
      }, function () {
        var _this$props$onFocus = _this.props.onFocus,
            onFocus = _this$props$onFocus === undefined ? function () {} : _this$props$onFocus;

        onFocus();
      });
    };

    _this.searchDealers = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var forceChange = arguments[1];
        var service;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                service = '/api/dealer-search';
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_fetchAPI__["a" /* default */])({
                  method: "POST",
                  url: service,
                  body: {
                    searchText: input
                  }
                }).then(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                    var json, success, data;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return response.json();

                          case 2:
                            json = _context.sent;
                            success = json.success, data = json.data;

                            if (success) {
                              _this.setState({
                                showOptions: true,
                                hoverIndex: 0,
                                selected: {},
                                dealers: data
                              }, function () {
                                if (forceChange && _this.state.dealers && _this.state.dealers.length > 0) {
                                  _this._onSelect(_this.state.dealers[0]);
                                }
                              });
                            }

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }();

    _this._onChangeHandler = function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var forceChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          _this$props$type = _this$props.type,
          type = _this$props$type === undefined ? "postcode" : _this$props$type,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

      onChange();
      if (!value || value === "") {
        _this.setState({
          showOptions: false,
          hoverIndex: 0,
          selected: {}
        });
        return;
      }

      if (type === "dealer") {
        console.log("searching by dealer");
        _this.searchDealers(value, forceChange);
      }

      if (type === "postcode" || type === "dealer") {
        console.log("searching by postcode or dealer");
        _this.google.searchPostcode(value, function (response) {
          if (response && response.length > 0) {
            _this.setState({
              showOptions: true,
              hoverIndex: 0,
              selected: {},
              places: response.filter(function (item) {
                return !item.types.includes("administrative_area_level_1");
              })
            }, function () {
              if (forceChange && _this.state.places && _this.state.places.length > 0) {
                _this._onSelect(_this.state.places[0]);
              }
            });
          }
        });
      }
      if (type === "address") {
        console.log("searching by address");
        _this.google.searchAddress(value, function (response) {
          if (response && response.length > 0) {
            _this.setState({
              showOptions: true,
              selected: {},
              hoverIndex: 0,
              places: response.filter(function (item) {
                return !item.types.includes("administrative_area_level_1");
              })
            }, function () {
              if (forceChange && _this.state.places && _this.state.places.length > 0) {
                _this._onSelect(_this.state.places[0]);
              }
            });
          }
        });
      }
    };

    _this._getThisInput = function (inputThis) {
      var _this$props$getThisIn = _this.props.getThisInput,
          getThisInput = _this$props$getThisIn === undefined ? function () {} : _this$props$getThisIn;

      _this.postcode = inputThis;
      getThisInput(inputThis);
    };

    _this._onSelect = function (item) {
      var _this$props2 = _this.props,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === undefined ? function () {} : _this$props2$onChange,
          _this$props2$onBlur = _this$props2.onBlur,
          onBlur = _this$props2$onBlur === undefined ? function () {} : _this$props2$onBlur,
          _this$props2$type = _this$props2.type,
          type = _this$props2$type === undefined ? "postcode" : _this$props2$type;


      _this.setState({
        places: [],
        dealers: [],
        showOptions: false,
        selected: item
      }, function () {

        if (item.display) {
          var selected = _extends({}, _this.state.selected);
          _this.setState({
            selected: selected
          }, function () {
            onChange(_this.state.selected);
            onBlur(_this.state.selected);
          });
          _this.postcode._onChangeOnlyValue(item.display);
        } else {
          _this.google.getPostcode(item.description, function (response) {
            console.log('searching for a post code');
            if (response && response[0] && response[0].address_components) {
              var _selected = _extends({}, _this.state.selected);
              response[0].address_components.forEach(function (address) {
                if (address.types.includes("subpremise")) {
                  _selected.subpremise = address.short_name;
                }
                if (address.types.includes("street_number")) {
                  _selected.streetNumber = address.short_name;
                }
                if (address.types.includes("route")) {
                  _selected.route = address.short_name;
                }
                if (address.types.includes("postal_code")) {
                  _selected.postcode = address.short_name;
                } else if (item.description.match(/\d{4}/)) {
                  _selected.postcode = item.description.match(/\d{4}/)[0];
                }
                if (address.types.includes("locality")) {
                  _selected.suburb = address.short_name;
                }
                if (address.types.includes("administrative_area_level_1")) {
                  _selected.state = address.short_name;
                }
              });
              _this.setState({
                selected: _selected
              }, function () {
                onChange(_this.state.selected);
                onBlur(_this.state.selected);
              });
            }
          });
          _this.postcode._onChangeOnlyValue(item.description);
        }
      });
    };

    _this._onClickDownKey = function () {
      var _this$state = _this.state,
          places = _this$state.places,
          dealers = _this$state.dealers,
          hoverIndex = _this$state.hoverIndex;

      if (dealers.length > 0) {
        if (dealers.length > hoverIndex) {
          _this.setState({
            hoverIndex: hoverIndex + 1
          });
        }
      } else if (places.length > 0) {
        if (places.length > hoverIndex) {
          _this.setState({
            hoverIndex: hoverIndex + 1
          });
        }
      }
    };

    _this._onClickUpKey = function () {
      var _this$state2 = _this.state,
          places = _this$state2.places,
          dealers = _this$state2.dealers,
          hoverIndex = _this$state2.hoverIndex;


      if (dealers.length > 0) {
        if (hoverIndex > 0) {
          _this.setState({
            hoverIndex: hoverIndex - 1
          });
        }
      } else if (places.length > 0) {
        if (hoverIndex > 0) {
          _this.setState({
            hoverIndex: hoverIndex - 1
          });
        }
      }
    };

    _this._onClickEnterKey = function () {
      var _this$state3 = _this.state,
          places = _this$state3.places,
          dealers = _this$state3.dealers,
          hoverIndex = _this$state3.hoverIndex;


      if (dealers && dealers.length > 0 && dealers[hoverIndex]) {
        _this._onSelect(dealers[hoverIndex]);
      } else if (places && places.length > 0 && places[hoverIndex]) {
        _this._onSelect(places[hoverIndex]);
      }
    };

    _this._onHover = function (index) {
      _this.setState({
        hoverIndex: index
      });
    };

    _this.postcode = null;
    _this.google = new __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_googleAutoComplete__["a" /* default */]();
    _this.state = {
      places: [],
      dealers: [],
      showOptions: false,
      selected: {},
      hoverIndex: 0
    };
    return _this;
  }

  InputSearchable.prototype.render = function render() {
    var _classnames,
        _classnames2,
        _classnames3,
        _classnames4,
        _this3 = this;

    var _props = this.props,
        label = _props.label,
        name = _props.name,
        required = _props.required,
        isValid = _props.isValid,
        message = _props.message,
        defaultValue = _props.defaultValue;
    var _state = this.state,
        places = _state.places,
        dealers = _state.dealers,
        showOptions = _state.showOptions,
        hoverIndex = _state.hoverIndex;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_4__InputSearchable_less___default.a.InputSearchable] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 253
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["K" /* Input */], {
        label: label,
        getThisInput: this._getThisInput,
        name: name,
        disableEnter: true,
        type: "text",
        required: required,
        defaultValue: defaultValue,
        autoComplete: "new-password",
        isValid: isValid,
        message: message,
        onChange: this._onChangeHandler,
        onBlur: this._onBlurHandler,
        onFocus: this._onFocusHandler,
        callOnChangeAfterBlur: false,
        onClickDownKey: this._onClickDownKey,
        onClickUpKey: this._onClickUpKey,
        onClickEnterKey: this._onClickEnterKey,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 256
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_4__InputSearchable_less___default.a.InputSearchableIcon] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_4__InputSearchable_less___default.a.InputSearchableIconInnerInvalid] = !isValid && message, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 275
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_7" /* SearchIcon */], { style: {
            width: "16px",
            height: "16px"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 279
          }
        })
      ),
      showOptions && places && places.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_4__InputSearchable_less___default.a.selectOptions] = true, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 285
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_4__InputSearchable_less___default.a.selectOptionsUL] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 288
            }
          },
          dealers.length ? dealers.map(function (item, index) {
            var _classnames5;

            if (item && item.display) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              {
                key: "SelectOptions-" + item.value,
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_4__InputSearchable_less___default.a.selectOptionsLI] = true, _classnames5[__WEBPACK_IMPORTED_MODULE_4__InputSearchable_less___default.a.selectOptionsLIHover] = hoverIndex === index, _classnames5)),
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 294
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
                {
                  withoutStyle: true,
                  onClick: function onClick() {
                    _this3._onSelect(item);
                  },
                  onMouseOver: function onMouseOver() {
                    _this3._onHover(index);
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 301
                  }
                },
                item.display
              )
            );
          }) : null,
          !dealers.length && places.map(function (item, index) {
            var _classnames6;

            if (item && item.structured_formatting && item.description) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              {
                key: "SelectOptions-" + item.place_id,
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_4__InputSearchable_less___default.a.selectOptionsLI] = true, _classnames6[__WEBPACK_IMPORTED_MODULE_4__InputSearchable_less___default.a.selectOptionsLIHover] = hoverIndex === index, _classnames6)),
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 314
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
                {
                  withoutStyle: true,
                  onClick: function onClick() {
                    _this3._onSelect(item);
                  },
                  onMouseOver: function onMouseOver() {
                    _this3._onHover(index);
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 321
                  }
                },
                item.description
              )
            );
          })
        )
      )
    );
  };

  return InputSearchable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InputSearchable.displayName = "InputSearchable";


/* harmony default export */ __webpack_exports__["a"] = (InputSearchable);

/***/ }),
/* 106 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(29).f;
var has = __webpack_require__(48);
var TAG = __webpack_require__(23)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(56);
var TAG = __webpack_require__(23)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
var defined = __webpack_require__(64);
var fails = __webpack_require__(19);
var spaces = __webpack_require__(206);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);


// Action Types

var actionTypes = {
  UPDATE_POSTCODE_REQUEST: "UPDATE_POSTCODE_REQUEST",
  UPDATE_POSTCODE_SUCCESS: "UPDATE_POSTCODE_SUCCESS",
  LOCATION_FETCH_REQUEST: "LOCATION_FETCH_REQUEST",
  POSTCODE_INPUT_REQUEST: "POSTCODE_INPUT_REQUEST",
  POSTCODE_INPUT_CANCEL: "POSTCODE_INPUT_CANCEL",
  POSTCODE_POPUP_SHOW: "POSTCODE_POPUP_SHOW",
  POSTCODE_POPUP_HIDE: "POSTCODE_POPUP_HIDE",
  LOCATION_FETCH_START: "LOCATION_FETCH_START",
  LOCATION_FETCH_SUCCESS: "LOCATION_FETCH_SUCCESS",
  LOCATION_FETCH_ERROR: "LOCATION_FETCH_ERROR",
  LOCATION_CONFIRMED: "LOCATION_CONFIRMED"

  // Action Creators

};var updatePostcode = function updatePostcode(postcode) {
  return {
    type: actionTypes.UPDATE_POSTCODE_REQUEST,
    payload: { postcode: postcode }
  };
};

var fetchLocation = function fetchLocation() {
  return {
    type: actionTypes.LOCATION_FETCH_REQUEST
  };
};

var requestPostcodeInput = function requestPostcodeInput() {
  return {
    type: actionTypes.POSTCODE_INPUT_REQUEST
  };
};

var cancelPostcodeInput = function cancelPostcodeInput() {
  return {
    type: actionTypes.POSTCODE_INPUT_CANCEL
  };
};

var actionCreators = {
  updatePostcode: updatePostcode,
  fetchLocation: fetchLocation,
  requestPostcodeInput: requestPostcodeInput,
  cancelPostcodeInput: cancelPostcodeInput

  // Selectors

};var getLocation = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("location");

var selectors = {
  getLocation: getLocation
};

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(978);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(979);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(980);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(135);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(384);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["d"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* unused harmony reexport cancel */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["i"]; });
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__ = __webpack_require__(1004);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["b"]; });
/* unused harmony reexport throttle */




/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1031),
    getValue = __webpack_require__(1036);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGeoDataFromPostcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGeoDataFromPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchGeoDataFromAddress; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__google_maps__ = __webpack_require__(104);
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var firstOfType = function firstOfType(type, arr) {
  return arr.find(function (_ref) {
    var types = _ref.types;
    return types.indexOf(type) !== -1;
  });
};

var parseGeocoderResults = function parseGeocoderResults() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _results$0$address_co = results[0].address_components,
      addressComponents = _results$0$address_co === undefined ? [] : _results$0$address_co;

  var locality = firstOfType('locality', addressComponents);
  var state = firstOfType('administrative_area_level_1', addressComponents);
  var postcode = firstOfType('postal_code', addressComponents);
  return _extends({}, state ? {
    state: state.short_name
  } : {}, locality ? {
    locality: locality.short_name
  } : {}, postcode ? {
    postcode: postcode.short_name
  } : {});
};

var geolocation = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])('navigator.geolocation', __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */] || {});

var getErrorMessage = function getErrorMessage(error) {
  return __WEBPACK_IMPORTED_MODULE_2__constants_errors__["d" /* GEO_ERRORS */][error.message || error] || __WEBPACK_IMPORTED_MODULE_2__constants_errors__["d" /* GEO_ERRORS */].default;
};

var geocode = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var geocoder, statusCodes, googleGeocode;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            geocoder = void 0;
            statusCodes = void 0;
            _context.prev = 2;
            _context.next = 5;
            return Object(__WEBPACK_IMPORTED_MODULE_3__google_maps__["b" /* getGeocoder */])();

          case 5:
            googleGeocode = _context.sent;

            geocoder = googleGeocode.geocoder;
            statusCodes = googleGeocode.statusCodes;
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](2);
            throw new Error('NO_GEOCODER');

          case 13:
            return _context.abrupt('return', new Promise(function (resolve, reject) {
              var _geocoder;

              (_geocoder = geocoder).geocode.apply(_geocoder, args.concat([function (results, status) {
                if (status !== statusCodes.OK) reject('GEOCODER_' + status);
                resolve(results);
              }]));
            }));

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[2, 10]]);
  }));

  return function geocode() {
    return _ref2.apply(this, arguments);
  };
}();

var getCurrentPosition = function getCurrentPosition(options) {
  if (!geolocation) throw new Error('NO_GEOLOCATION');

  return new Promise(function (resolve, reject) {
    geolocation.getCurrentPosition(resolve, function (_ref3) {
      var code = _ref3.code;
      return reject('GEOLOCATION_' + code);
    }, options);
  });
};

var fetchGeoDataFromPostcode = function fetchGeoDataFromPostcode(newPostcode) {
  return geocode({
    address: 'Postcode ' + newPostcode,
    componentRestrictions: {
      country: 'NZ'
    }
  }).then(function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(results) {
      var _parseGeocoderResults, state, locality, _parseGeocoderResults2, postcode;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _parseGeocoderResults = parseGeocoderResults(results), state = _parseGeocoderResults.state, locality = _parseGeocoderResults.locality, _parseGeocoderResults2 = _parseGeocoderResults.postcode, postcode = _parseGeocoderResults2 === undefined ? newPostcode : _parseGeocoderResults2;

              if (state) {
                _context2.next = 3;
                break;
              }

              throw new Error('POSTCODE_NOT_FOUND');

            case 3:
              return _context2.abrupt('return', { state: state, locality: locality, postcode: postcode });

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }()).catch(function () {
    throw new Error('POSTCODE_NOT_FOUND');
  });
};

var fetchGeoDataFromPosition = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref6) {
    var latitude = _ref6.latitude,
        longitude = _ref6.longitude;

    var results, _parseGeocoderResults3, state, locality, postcode;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return geocode({
              location: {
                lat: Number(latitude),
                lng: Number(longitude)
              }
            });

          case 3:
            results = _context3.sent;
            _parseGeocoderResults3 = parseGeocoderResults(results), state = _parseGeocoderResults3.state, locality = _parseGeocoderResults3.locality, postcode = _parseGeocoderResults3.postcode;

            if (!(!state || !postcode)) {
              _context3.next = 7;
              break;
            }

            throw new Error('LOCATION_NOT_FOUND');

          case 7:
            return _context3.abrupt('return', {
              state: state,
              locality: locality,
              postcode: postcode
            });

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3['catch'](0);
            throw _context3.t0;

          case 13:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[0, 10]]);
  }));

  return function fetchGeoDataFromPosition(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchGeoDataFromAddress = function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(address) {
    var getAddressComponent, _ref10, place;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            getAddressComponent = function getAddressComponent(components, componentType) {
              for (var _iterator = components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref8;

                if (_isArray) {
                  if (_i >= _iterator.length) break;
                  _ref8 = _iterator[_i++];
                } else {
                  _i = _iterator.next();
                  if (_i.done) break;
                  _ref8 = _i.value;
                }

                var component = _ref8;

                for (var _iterator2 = component.types, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                  var _ref9;

                  if (_isArray2) {
                    if (_i2 >= _iterator2.length) break;
                    _ref9 = _iterator2[_i2++];
                  } else {
                    _i2 = _iterator2.next();
                    if (_i2.done) break;
                    _ref9 = _i2.value;
                  }

                  var type = _ref9;

                  if (type === componentType) return component.short_name;
                }
              }
            };

            _context4.prev = 1;
            _context4.next = 4;
            return geocode(address);

          case 4:
            _ref10 = _context4.sent;
            place = _ref10[0];
            return _context4.abrupt('return', {
              addressDetails: {
                subpremise: getAddressComponent(place.address_components, 'subpremise'),
                number: getAddressComponent(place.address_components, 'street_number'),
                street: getAddressComponent(place.address_components, 'route'),
                state: getAddressComponent(place.address_components, 'administrative_area_level_1'),
                postcode: getAddressComponent(place.address_components, 'postal_code'),
                suburb: getAddressComponent(place.address_components, 'locality'),
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
              },
              placeId: place.place_id
            });

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4['catch'](1);
            throw _context4.t0;

          case 12:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[1, 9]]);
  }));

  return function fetchGeoDataFromAddress(_x4) {
    return _ref7.apply(this, arguments);
  };
}();

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchMyMazdaComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeMyMazdaVehicle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return queryMyMazdaVinRego; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return linkMyMazdaVinRego; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deactivateAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return verifyMymazdaEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resendMyMazdaVerificationEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apis_koala__ = __webpack_require__(86);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var fetchMyMazdaComponents = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
    var response, _ref2, data, errorMsg, errorCode, success;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url, {
              method: 'POST',
              credentials: 'include'
            });

          case 2:
            response = _context.sent;

            if (!(response.status !== 200)) {
              _context.next = 5;
              break;
            }

            throw new Error('Failed with status ' + response.status);

          case 5:
            _context.next = 7;
            return response.json();

          case 7:
            _ref2 = _context.sent;
            data = _ref2.data;
            errorMsg = _ref2.errorMsg;
            errorCode = _ref2.errorCode;
            success = _ref2.success;

            if (success) {
              _context.next = 14;
              break;
            }

            return _context.abrupt('return', {
              errorMsg: errorMsg,
              errorCode: errorCode
            });

          case 14:
            return _context.abrupt('return', {
              data: data
            });

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchMyMazdaComponents(_x) {
    return _ref.apply(this, arguments);
  };
}();

var removeMyMazdaVehicle = function removeMyMazdaVehicle(endpoint, data) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_apis_koala__["a" /* fetchKoalaData */])(endpoint, data, {
    method: 'DELETE',
    credentials: 'include'
  });
};

var queryMyMazdaVinRego = function queryMyMazdaVinRego(endpoint, vinRego) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_apis_koala__["a" /* fetchKoalaData */])(endpoint + '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({
    vinRego: vinRego
  }));
};

var linkMyMazdaVinRego = function linkMyMazdaVinRego(endpoint, vin) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_apis_koala__["a" /* fetchKoalaData */])(endpoint + '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({
    vin: vin
  }), {}, {
    credentials: 'include'
  });
};

var deactivateAccount = function deactivateAccount(endpoint, password) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_apis_koala__["a" /* fetchKoalaData */])(endpoint, {
    password: password
  }, {
    credentials: 'include',
    method: 'DELETE'
  });
};

var verifyMymazdaEmail = function verifyMymazdaEmail(endpoint, payload) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_apis_koala__["a" /* fetchKoalaData */])(endpoint + '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(payload), {}, {
    credentials: 'include'
  });
};

var resendMyMazdaVerificationEmail = function resendMyMazdaVerificationEmail(endpoint) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_apis_koala__["a" /* fetchKoalaData */])(endpoint, {}, {
    credentials: 'include'
  });
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.isDate = isDate;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */
function isDate(value) {
  return value instanceof Date && !isNaN(value.valueOf());
}

/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {[type]} d
 * @param {[type]} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameMonth(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDate: isDate,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(12);


// TODO: WE NEED TO GET RID OF THIS API!

// set global namespace
var namespace = "__KOALA";

// expose function to window
var exposeGlobal = function exposeGlobal(slug, value) {
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */]) return;
  // http://webreflection.blogspot.com.au/2011/08/please-stop-reassigning-for-no-reason.html
  namespace in __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */] || (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */][namespace] = {});
  slug in __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */][namespace] && console.warn(slug + " exists in " + namespace + " and will be over-written.");

  __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */][namespace][slug] = value;
};

/* harmony default export */ __webpack_exports__["a"] = (exposeGlobal);

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(1308);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(593);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(274);
var defined = __webpack_require__(276);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sidebarWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dropdownWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return tabletWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return desktopWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return breakpointTablet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return breakpointDesktop; });
var sidebarWidth = 320;
var dropdownWidth = 375;

var tabletWidth = 620;
var desktopWidth = 1280;

var breakpointTablet = "@media (min-width: " + tabletWidth + "px)";
var breakpointDesktop = "@media (min-width: " + desktopWidth + "px)";

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(299);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab__ = __webpack_require__(1622);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["b"]; });
/* unused harmony reexport lch */
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix__ = __webpack_require__(1623);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix__["a"]; });





/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(639);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(56);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(16);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(16);
var aFunction = __webpack_require__(38);
var SPECIES = __webpack_require__(23)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasLowerUpperCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lengthCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasSymbol; });
/* unused harmony export optional */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return required; });
/* unused harmony export validateName */
/* unused harmony export validateDealersField */
/* unused harmony export validateVinRego */
/* unused harmony export validateFirstName */
/* unused harmony export validateCaptcha */
/* unused harmony export validateTime */
/* unused harmony export validateOdometer */
/* unused harmony export validatePostcodeSuggest */
/* unused harmony export validateAddressSuggest */
/* unused harmony export validateLastName */
/* unused harmony export validatePhoneNumber */
/* unused harmony export validateMobileNumber */
/* unused harmony export validatePhoneExtension */
/* unused harmony export validateVin */
/* unused harmony export validateRego */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return validateEmail; });
/* unused harmony export postcodeValidation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return validatePassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_errors__ = __webpack_require__(41);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var isValidEmail = function isValidEmail(email) {
  // Thanks to:
  // http://fightingforalostcause.net/misc/2006/compare-email-regex.php
  // http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
  // http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
  // https://github.com/Sembiance/email-validator
  var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  if (!email) {
    return false;
  }

  if (email.length > 254) {
    return false;
  }

  var valid = tester.test(email);
  if (!valid) {
    return false;
  }
  // Further checking of some things regex can't handle
  var parts = email.split("@");
  if (parts[0].length > 64) {
    return false;
  }

  var domainParts = parts[1].split(".");
  if (domainParts.some(function (part) {
    return part.length > 63;
  })) {
    return false;
  }
  return true;
};

/**
 * Test for no special characters other than space, hyphen and apostrophe.
 * @param {String} string - String to test
 * @returns {Boolean} - Returns true if no special characters other than space, hyphen and apostrophe are found.
 */
var limitedSpecialCharacters = function limitedSpecialCharacters(string) {
  return !string.match(/([^\w\- ']|_)/gi);
};

/**
 * Strict test for special characters. Checks for limitedSpecialCharacters
 * then checks that permitted special characters are not found more than once.
 * @param {String} string - String to test
 * @returns {Boolean} - Returns true if no special characters and that there isn't more than 1 permitted special character.
 */
var strictSpecialCharacters = function strictSpecialCharacters(string) {
  var match = string.match(/('|-|\.| )/gi) || [];
  return !limitedSpecialCharacters(string) || match.length > 1;
};

/**
 * Test for whitespace at beginning of string
 * @param {String} string - String to test
 * @returns {String} - Returns true if string begins with whitespace
 */
var beginsWithWhitespace = function beginsWithWhitespace(string) {
  return string.match(/^\s+/i);
};

/**
 * Test for whitespace at the end of string
 * @param {String} string - String to test
 * @returns {String} - Returns true if string ends with whitespace
 */
var endsWithWhitespace = function endsWithWhitespace(string) {
  return string.match(/\s+$/i);
};

/**
 * Test for special character at the start of string
 * @param {String} string - String to test
 * @returns {String} - Returns true if string begins with a special character.
 */
var beginsWithSpecial = function beginsWithSpecial(string) {
  return !string.match(/^[A-Za-z]/i);
};

/**
 * Tests for special character at the end of string
 * @param {String} string - String to test
 * @returns {String} - Returns true if string ends with special character
 */
var endsWithSpecial = function endsWithSpecial(string) {
  return !string.match(/[A-Za-z]$/i);
};

/**
 * Test for capital at beginning of string.
 * @param {String} string - String to test
 * @returns {Boolean} - Returns true if string begins with capital letter.
 */
var beginsWithCapital = function beginsWithCapital(string) {
  var test = /^[A-Z]/;
  return Boolean(string.match(test));
};

/**
 * Test for numbers in string
 * @param {String} string - String to test
 * @returns {Boolean} - Returns true string contains numbers.
 */
var containsNumbers = function containsNumbers(string) {
  var test = /[0-9]/;
  return Boolean(string.match(test));
};

/**
 * Test for valid New Zealand area code
 * @param {String} string - String to test
 * @returns {Boolean} - Returns true for valid NewZealand area codes
 */
var NewZealandAreaCode = function NewZealandAreaCode(string) {
  var test = /^0(2|3|4|7|8|9)\d+$/;
  var subject = typeof string === "string" ? string : String(string);
  return Boolean(subject.match(test));
};

var NewZealandMobileNumber = function NewZealandMobileNumber(string) {
  var test = /^04\d+$/;
  var subject = typeof string === "string" ? string : String(string);
  return Boolean(subject.match(test));
};

var hasLowerUpperCase = function hasLowerUpperCase(string) {
  var test = new RegExp("^(?=.*[a-z])(?=.*[A-Z]).+$");
  var subject = typeof string === "string" ? string : String(string);
  return Boolean(test.exec(subject));
};

var lengthCheck = function lengthCheck(string, min, max) {
  var subject = typeof string === "string" ? string : String(string);
  return Boolean(subject !== "undefined" && subject.length >= min && subject.length <= max);
};

var hasNumber = function hasNumber(string) {
  var test = /^(?=.*\d).+$/;
  var subject = typeof string === "string" ? string : String(string);
  return Boolean(subject.match(test));
};

var hasSymbol = function hasSymbol(string) {
  var test = /^(?=.*(_|[^\w])).+$/;
  var subject = typeof string === "string" ? string : String(string);
  return Boolean(subject.match(test));
};

/**
 * Clears whitespace before and after value.
 * Trailing whitespace will only be cleared when context is onBlur
 * @param {String} value - Input string to sanitize
 * @param {Object} context - Validation context
 * @returns {String} - Returns true if string ends with whitespace
 */
var sanitizeValue = function sanitizeValue(value, _ref) {
  var onBlur = _ref.onBlur;

  if (beginsWithWhitespace(value)) {
    value = Object(__WEBPACK_IMPORTED_MODULE_0__string__["a" /* removeLeadingWhitespace */])(value);
  }
  if (onBlur && endsWithWhitespace(value)) {
    value = Object(__WEBPACK_IMPORTED_MODULE_0__string__["b" /* removeTrailingWhitespace */])(value);
  }
  return value;
};

var optional = function optional(validation) {
  return function (value) {
    validation = typeof validation === "undefined" ? function () {
      return {
        isValid: true
      };
    } : validation;
    var result = validation(value);
    var status = result.status,
        attributes = result.attributes;

    if (!value) {
      return {
        status: {
          isValid: true
        }
      };
    }
    return {
      status: status || result,
      attributes: attributes
    };
  };
};
var required = function required(validation, message, validationOptions) {
  return function (value, context) {
    validation = typeof validation === "undefined" ? function () {
      return {
        isValid: true
      };
    } : validation;
    var result = validation(value, context, validationOptions);
    var status = result.status,
        attributes = result.attributes;

    var requiredAttributes = {
      required: true
    };
    if (!value) {
      return {
        status: {
          isValid: false,
          message: message
        },
        attributes: _extends({}, attributes, requiredAttributes)
      };
    }
    return {
      status: status || result,
      attributes: _extends({}, attributes, requiredAttributes)
    };
  };
};

var validateName = function validateName(v) {
  return {
    isValid: true
  };
};

var validateDealersField = function validateDealersField(value) {
  return {
    isValid: Boolean(value && value.code)
  };
};

var validateVinRego = function validateVinRego(value) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onBlur = _ref2.onBlur;

  var validVin = function validVin(value) {
    return value.match(/^[0-9a-zA-Z]*$/);
  };
  var isValid = true;
  var message = void 0;
  if (value) {
    value = sanitizeValue(value, {
      onBlur: onBlur
    });

    if (!validVin(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].REGO_OR_VIN_REQUIRED;
    }
  }
  return {
    status: {
      modifiedValue: value,
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 17
    }
  };
};

/**
 * Firstname field validation.
 * Only special characters allowed are space, hyphen and apostrophe;
 * first letter must be capitalised;
 * Shouldn't be longer than 30 characters
 */
var validateFirstName = function validateFirstName(value) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onBlur = _ref3.onBlur;

  var isValid = true;
  var message = void 0;

  if (!value) {
    isValid = false;
  } else {
    value = sanitizeValue(value, {
      onBlur: onBlur
    });
    if (!beginsWithCapital(value)) {
      value = Object(__WEBPACK_IMPORTED_MODULE_0__string__["d" /* upperFirst */])(value);
    }
    if (value.length > 30) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].FIRSTNAME_MAXLENGTH;
    }
    if (beginsWithSpecial(value) || endsWithSpecial(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].FIRSTNAME_SPECIAL_CHARACTERS_POSITION;
    }
    if (strictSpecialCharacters(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].FIRSTNAME_SPECIAL_CHARACTERS;
    }
    if (containsNumbers(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].FIRSTNAME_NUMBERS;
    }
  }

  return {
    status: {
      modifiedValue: value,
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 30
    }
  };
};

var validateCaptcha = function validateCaptcha(value) {
  var isValid = value !== null;
  return {
    isValid: isValid
  };
};

var validateTime = function validateTime(value) {
  var isValid = value && value.match && value.match(/^[01]?[0-9]\/[0-5][0-9]$/);
  return {
    isValid: !!isValid,
    message: isValid ? undefined : __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].TIME_INVALID
  };
};

var validateOdometer = function validateOdometer(value) {
  var number = +value;
  var positive = number > 0;
  var integer = value && value.indexOf(".") === -1;
  var isValid = positive && integer;
  return {
    isValid: isValid,
    message: isValid ? undefined : __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].ODOMETER_INVALID
  };
};

/**
 * PostcodeSuggest / Location field validation.
 * User must select a suggestion (populating postcode, state and suburb).
 * Sometimes Google Map doesn't return a suburb name, so we only validate
 * postcode and state before throwing error.
 */
var validatePostcodeSuggest = function validatePostcodeSuggest(value) {
  if (value && !value.postcode) {
    return {
      isValid: false,
      message: __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].LOCATION_INVALID
    };
  }
  return {
    isValid: true
  };
};

/**
 * AddressSuggest / Location field validation.
 * User must select a suggestion (populating address, postcode, state and suburb).
 * Sometimes Google Map doesn't return a suburb name, so we only validate
 * postcode and state before throwing error.
 */
var validateAddressSuggest = function validateAddressSuggest(value) {
  if (value && !(value.number && value.postcode && value.suburb && value.address)) {
    return {
      isValid: false,
      message: __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].ADDRESS_LOCATION_INVALID
    };
  }
  return {
    isValid: true
  };
};

/**
 * LastName field validation.
 * Only special characters allowed are space, hyphen and apostrophe;
 * first letter must be capitalised;
 * Shouldn't be longer than 50 characters
 */
var validateLastName = function validateLastName(value) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onBlur = _ref4.onBlur;

  var isValid = true;
  var message = void 0;
  if (!value) {
    isValid = false;
  } else {
    value = sanitizeValue(value, {
      onBlur: onBlur
    });

    if (!beginsWithCapital(value)) {
      value = Object(__WEBPACK_IMPORTED_MODULE_0__string__["d" /* upperFirst */])(value);
    }
    if (value.length > 50) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].LASTNAME_MAXLENGTH;
    }
    if (beginsWithSpecial(value) || endsWithSpecial(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].LASTNAME_SPECIAL_CHARACTERS_POSITION;
    }
    if (strictSpecialCharacters(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].LASTNAME_SPECIAL_CHARACTERS;
    }
    if (containsNumbers(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].LASTNAME_NUMBERS;
    }
  }

  return {
    status: {
      modifiedValue: value,
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 50
    }
  };
};
/**
 * Phone number field validation.
 * Valid landline or mobile phone number by prefix i.e. 02, 03, 04, etc (i.e New Zealand phone numbers);
 * This field will be used by MA IT dedup tool to populate the Mobile Phone/Home Phone fields in the Prospect DB;
 */
var validatePhoneNumber = function validatePhoneNumber(value) {
  var isValid = true;
  var message = void 0;
  if (!value) {
    isValid = false;
  } else {
    if (value.length < 9) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].PHONE_NUMBER_INVALID;
    }
    if (!NewZealandAreaCode(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].PHONE_NUMBER_AREACODE_INVALID;
    }
  }
  return {
    status: {
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 11
    }
  };
};

var validateMobileNumber = function validateMobileNumber(value) {
  var isValid = true;
  var message = void 0;
  if (!value) {
    isValid = false;
  } else {
    if (value.length < 9) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].MOBILE_NUMBER_INVALID;
    }
    // if (!NewZealandMobileNumber(value)) {
    //   isValid = false
    //   message = FORM_ERRORS.MOBILE_NUMBER_INVALID
    // }
  }
  return {
    status: {
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 11
    }
  };
};

var validatePhoneExtension = function validatePhoneExtension(value) {
  var isValid = true;
  var message = void 0;
  if (!value) {
    isValid = false;
  } else if (!value.match(/\[?([0-9])\]?/g)) {
    isValid = false;
    message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].PHONE_EXTENSION_INVALID;
  }
  return {
    status: {
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 6
    }
  };
};

var validateVin = function validateVin(v) {
  v = ("" + v).toUpperCase();
  var transliterate = function transliterate(c) {
    return "0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ".indexOf(c) % 10;
  };
  var checkDigit = function checkDigit(vin) {
    var map = "0123456789X";
    var weights = "8765432X098765432";
    var sum = 0;
    for (var i = 0; i < 17; ++i) {
      sum += transliterate(vin[i]) * map.indexOf(weights[i]);
    }
    return map[sum % 11];
  };
  // https://en.wikipedia.org/wiki/Vehicle_identification_number#Check-digit_calculation
  // but it seems that check digit not used in New Zealand
  // const isValid = (v.length === 17) && v[8] === checkDigit(v)
  var isValid = Boolean(/[A-HJ-NPR-Z0-9]{13}[0-9]{4}/.exec(v));
  return {
    isValid: isValid,
    message: isValid ? undefined : __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].VIN_INVALID
  };
};

var validateRego = function validateRego(v) {
  var isValid = Boolean(/[A-Za-z0-9]{1,6}/.exec(v));
  return {
    isValid: isValid,
    message: isValid ? undefined : __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].REGISTRATION_INVALID
  };
};

var validateEmail = function validateEmail(value) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onBlur = _ref5.onBlur;

  var isValid = true;
  var message = void 0;

  if (!value) {
    isValid = false;
  } else {
    value = sanitizeValue(value, {
      onBlur: onBlur
    });
    if (value.length > 60) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].EMAIL_MAXLENGTH;
    }
    if (!isValidEmail(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].EMAIL_INVALID;
    }
  }

  return {
    status: {
      modifiedValue: value,
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 60
    }
  };
};

var postcodeValidation = function postcodeValidation(value) {
  var test = new RegExp("^\\d{4}$");
  var isValid = value.length <= 4 && !!test.exec(value);
  return {
    isValid: isValid,
    message: isValid ? undefined : __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* ERRORS */].POSTCODE_INVALID
  };
};

var validatePassword = function validatePassword(value) {
  var isValid = true;
  var message = void 0;

  if (!value) {
    isValid = false;
  } else {
    if (value.length < 8) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].PASSWORD_MINLENGTH;
    }
    if (value.length > 20) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].PASSWORD_MAXLENGTH;
    }
    if (!hasLowerUpperCase(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].PASSWORD_CASE;
    }
    if (!(hasNumber(value) || hasSymbol(value))) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["c" /* FORM_ERRORS */].PASSWORD_NUMBER_SYMBOL;
    }
  }

  return {
    status: {
      modifiedValue: value,
      isValid: isValid,
      message: message
    },
    attributes: {
      minLength: 8
    }
  };
};

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPlainObject */
/* unused harmony export mapKeys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapValues; });
/* unused harmony export mapKeysDeep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return omit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toPairs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return shallowEq; });
/* unused harmony export isEmpty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindAll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__function__ = __webpack_require__(35);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/*
**  Function to test if an object is a plain object, i.e. is constructed
**  by the built-in Object constructor and inherits directly from Object.prototype
**  or null. Some built-in objects pass the test, e.g. Math which is a plain object
**  and some host or exotic objects may pass also.
**  Modified from http://stackoverflow.com/questions/5876332/how-can-i-differentiate-between-an-object-literal-other-javascript-objects
**  See also http://stackoverflow.com/questions/10919915/ie8-getprototypeof-method
**
**  @param {} obj - value to test
**  @returns {Boolean} true if passes tests, false otherwise
*/
var isPlainObject = function isPlainObject(obj) {
  // Basic check for Type object that's not null
  if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" && obj !== null) {
    // If Object.getPrototypeOf supported, use it
    if (typeof Object.getPrototypeOf === "function") {
      var proto = Object.getPrototypeOf(obj);
      return proto === Object.prototype || proto === null;
    }

    // Otherwise, use internal class
    // This should be reliable as if getPrototypeOf not supported, is pre-ES5
    return Object.prototype.toString.call(obj) === "[object Object]";
  }

  // Not an object
  return false;
};

var mapKeys = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, obj) {
  return Object.keys(obj).reduce(function (result, key) {
    result[fn(key, obj[key])] = obj[key];
    return result;
  }, {});
});

var mapValues = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, obj) {
  return Object.keys(obj).reduce(function (result, key) {
    result[key] = fn(obj[key], key);
    return result;
  }, {});
});

var mapKeysDeep = function mapKeysDeep(fn) {
  return function (obj) {
    if (!isPlainObject(obj) && !Array.isArray(obj)) return obj;
    var mapper = mapKeysDeep(fn);
    return Object.keys(obj).reduce(function (result, key) {
      var val = obj[key];
      var mappedVal = val;
      if (Array.isArray(val)) mappedVal = val.map(mapper);else if (isPlainObject(val)) mappedVal = mapper(val);
      result[fn(key)] = mappedVal;
      return result;
    }, {});
  };
};

var get = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (pathSpec, obj) {
  var path = typeof pathSpec === "string" ? pathSpec.split(".") : pathSpec;

  if (!Array.isArray(path)) {
    console.warn("Expecting path to be a string or an array of strings");
    return undefined;
  }

  var shouldPick = function shouldPick(found) {
    return (typeof found === "undefined" ? "undefined" : _typeof(found)) === "object" && !Array.isArray(found) && found !== null;
  };
  var first = path[0],
      rest = path.slice(1);


  return rest.reduce(function (found, key) {
    return shouldPick(found) ? found[key] : found;
  }, obj[first]);
});

var pick = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (keys, obj) {
  return keys.reduce(function (o, key) {
    // Sometime we need to pick from special objects like Window, which in IE does not register
    // as a plain object
    if (!isPlainObject(obj) && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") o[key] = obj[key];else if (obj.hasOwnProperty(key)) o[key] = obj[key];
    return o;
  }, {});
});

var omit = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (keys, obj) {
  return Object.keys(obj).reduce(function (o, key) {
    if (!~keys.indexOf(key)) o[key] = obj[key];
    return o;
  }, {});
});

var toPairs = function toPairs(obj) {
  var isArray = Array.isArray(obj);

  return Object.keys(obj).reduce(function (pairs, key) {
    pairs.push([isArray ? parseInt(key, 10) : key, obj[key]]);
    return pairs;
  }, []);
};

var shallowEq = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (obj1, obj2) {
  var _map = [obj1, obj2].map(Object.keys),
      keys1 = _map[0],
      keys2 = _map[1];

  if (keys1.length !== keys2.length) return false;
  if (keys1.some(function (key) {
    return keys2.indexOf(key) === -1;
  })) return false;

  return keys1.every(function (key) {
    var _ref = [obj1[key], obj2[key]],
        v1 = _ref[0],
        v2 = _ref[1];

    return isNaN(v1) && isNaN(v1) ? true : v1 === v2;
  });
});

var isEmpty = function isEmpty(obj) {
  return isPlainObject(obj) ? !Object.keys(obj).length : true;
};

// !!Mutations be here, affects original object
var bindAll = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (attrs, context) {
  (Array.isArray(attrs) && attrs.length ? attrs : Object.keys(context)).filter(function (key) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(context[key]);
  }).forEach(function (key) {
    context[key] = context[key].bind(context);
  });
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(171),
    getRawTag = __webpack_require__(1032),
    objectToString = __webpack_require__(1033);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ChevronIcon.jsx";



var ChevronIcon = function ChevronIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 284.929 284.929", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "currentColor", d: "M282.082 195.285L149.028 62.24c-1.901-1.903-4.088-2.856-6.562-2.856s-4.665.953-6.567 2.856L2.856 195.285C.95 197.191 0 199.378 0 201.853c0 2.474.953 4.664 2.856 6.566l14.272 14.271c1.903 1.903 4.093 2.854 6.567 2.854s4.664-.951 6.567-2.854l112.204-112.202 112.208 112.209c1.902 1.903 4.093 2.848 6.563 2.848 2.478 0 4.668-.951 6.57-2.848l14.274-14.277c1.902-1.902 2.847-4.093 2.847-6.566.001-2.476-.944-4.666-2.846-6.569z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

ChevronIcon.displayName = "ChevronIcon";
ChevronIcon.displayName = "ChevronIcon";
ChevronIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (ChevronIcon);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dateHandler = function dateHandler(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  _classCallCheck(this, dateHandler);

  _initialiseProps.call(this);

  // date = "year, month, day, hours, minutes, seconds, milliseconds"
  // dateString = "October 13, 2014 11:13:00"
  this.date = new Date(date);
};

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.getDate = function () {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY/MM/DD hh:mm:ss';

    return _this.format(format);
  };

  this.getYear = function () {
    return _this.date.getFullYear();
  };

  this.getMonth = function () {
    var withZero = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (withZero && Number(_this.date.getMonth()) < 10) {
      return '0' + (Number(_this.date.getMonth()) + 1);
    }
    return Number(_this.date.getMonth()) + 1;
  };

  this.getDay = function () {
    var withZero = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (withZero && Number(_this.date.getDate()) < 10) {
      return '0' + Number(_this.date.getDate());
    }
    return Number(_this.date.getDate());
  };

  this.get24Hour = function () {
    var withZero = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (withZero && Number(_this.date.getHours()) < 10) {
      return '0' + Number(_this.date.getHours());
    }
    return _this.date.getHours();
  };

  this.get12Hour = function () {
    var withZero = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var hour = _this.get24Hour();
    if (Number(hour) === 0) {
      return 12;
    } else if (hour < 12) {
      if (withZero && Number(hour) < 10) {
        return '0' + Number(hour);
      }
      return hour;
    } else if (hour === 12) return hour;

    if (withZero && Number(hour % 12) < 10) {
      return '0' + Number(hour % 12);
    }
    return hour % 12;
  };

  this.getAMPM = function () {
    var hour = _this.get24Hour();
    if (hour < 12) {
      return 'am';
    }
    return 'pm';
  };

  this.getMinutes = function () {
    var withZero = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (withZero && Number(_this.date.getMinutes()) < 10) {
      return '0' + Number(_this.date.getMinutes());
    }
    return _this.date.getMinutes();
  };

  this.getSeconds = function () {
    var withZero = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (withZero && Number(_this.date.getSeconds()) < 10) {
      return '0' + Number(_this.date.getSeconds());
    }
    return _this.date.getSeconds();
  };

  this.getMilliseconds = function () {
    return _this.date.getMilliseconds();
  };

  this.getTimeStamps = function () {
    return _this.date.getTime();
  };

  this.getWeekDay = function () {
    return Number(_this.date.getDay()) + 1;
  };

  this.getWeekDayFullName = function () {
    var weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    return weekdays[_this.date.getDay()];
  };

  this.getWeekDayShortName = function () {
    var weekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    return weekdays[_this.date.getDay()];
  };

  this.getMonthFullName = function () {
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return months[_this.getMonth() - 1];
  };

  this.getMonthShortName = function () {
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[_this.getMonth() - 1];
  };

  this.format = function (string) {
    // possible String
    // YYYY -> Full Year
    // YY -> Short Year
    // MMM -> Month FullName
    // MM -> Month ShortName
    // 0M -> Month Number with Zero 1 - 12
    // M -> Month Number without Zero 1 - 12
    // DDD -> Day FullName
    // DD -> Day ShortName
    // 0D -> Day ShortName
    // D -> Day ShortName
    // hh -> hour 24 format
    // 0hh -> hour 24 format with zero
    // h -> hour 12 format
    // 0h -> hour 12 format with zero
    // 0mm -> minites with zero
    // mm -> minites
    // 0ss -> seconds with zero
    // ss -> seconds
    // a -> am or pm
    // A -> AM or PM


    if (string.includes("YYYY")) {
      string = string.replace("YYYY", _this.getYear());
    } else if (string.includes("YY")) {
      string = string.replace("YY", _this.getYear().substr(2, 2));
    }

    if (string.includes("MMM")) {
      string = string.replace("MMM", _this.getMonthFullName());
    } else if (string.includes("MM")) {
      string = string.replace("MM", _this.getMonthShortName());
    } else if (string.includes("0M")) {
      string = string.replace("0M", _this.getMonth(true));
    } else if (string.includes("M")) {
      string = string.replace("M", _this.getMonth());
    }

    if (string.includes("DDD")) {
      string = string.replace("DDD", _this.getWeekDayFullName());
    } else if (string.includes("DD")) {
      string = string.replace("DD", _this.getWeekDayShortName());
    } else if (string.includes("0D")) {
      string = string.replace("0D", _this.getDay(true));
    } else if (string.includes("D")) {
      string = string.replace("D", _this.getDay());
    }

    if (string.includes("0hh")) {
      string = string.replace("0hh", _this.get24Hour(true));
    } else if (string.includes("hh")) {
      string = string.replace("hh", _this.get24Hour());
    } else if (string.includes("0h")) {
      string = string.replace("0h", _this.get12Hour(true));
    } else if (string.includes("h")) {
      string = string.replace("h", _this.get12Hour());
    }

    if (string.includes("0mm")) {
      string = string.replace("0mm", _this.getMinutes(true));
    } else if (string.includes("mm")) {
      string = string.replace("mm", _this.getMinutes());
    }

    if (string.includes("0ss")) {
      string = string.replace("0ss", _this.getSeconds(true));
    } else if (string.includes("ss")) {
      string = string.replace("ss", _this.getSeconds());
    }

    if (string.includes("a")) {
      string = string.replace("a", _this.getAMPM());
    }

    if (string.includes("A")) {
      string = string.replace("A", _this.getAMPM().toUpperCase());
    }

    return string;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (dateHandler);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var TAB = exports.TAB = 9;
//# sourceMappingURL=keys.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\CheckIcon.jsx";


var CheckIcon = function CheckIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 10 10", style: style, fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M4.138 7.559L1.002 5.277 0 6.491 4.4 10 10 .818 8.7 0z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

CheckIcon.displayName = "CheckIcon";
CheckIcon.displayName = "CheckIcon";
/* harmony default export */ __webpack_exports__["a"] = (CheckIcon);

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(54);
var global = __webpack_require__(18);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(83) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(49);
var toLength = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(96);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 146 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(56);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(57);
var defined = __webpack_require__(64);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(20);
var cof = __webpack_require__(56);
var MATCH = __webpack_require__(23)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(23)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(108);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(325);
var redefine = __webpack_require__(45);
var hide = __webpack_require__(44);
var fails = __webpack_require__(19);
var defined = __webpack_require__(64);
var wks = __webpack_require__(23);
var regexpExec = __webpack_require__(221);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(45);
var redefineAll = __webpack_require__(102);
var meta = __webpack_require__(82);
var forOf = __webpack_require__(101);
var anInstance = __webpack_require__(100);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(19);
var $iterDetect = __webpack_require__(150);
var setToStringTag = __webpack_require__(107);
var inheritIfRequired = __webpack_require__(207);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var hide = __webpack_require__(44);
var uid = __webpack_require__(94);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(83) || !__webpack_require__(19)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(18)[K];
});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(6);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(6);
var aFunction = __webpack_require__(38);
var ctx = __webpack_require__(55);
var forOf = __webpack_require__(101);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cssRuleSetToString;

var _appendPxIfNeeded = __webpack_require__(345);

var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);

var _camelCasePropsToDashCase = __webpack_require__(347);

var _camelCasePropsToDashCase2 = _interopRequireDefault(_camelCasePropsToDashCase);

var _mapObject = __webpack_require__(346);

var _mapObject2 = _interopRequireDefault(_mapObject);

var _prefixer = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMarkupForStyles(style) {
  return Object.keys(style).map(function (property) {
    return property + ': ' + style[property] + ';';
  }).join('\n');
}

function cssRuleSetToString(selector, rules, userAgent) {
  if (!rules) {
    return '';
  }

  var rulesWithPx = (0, _mapObject2.default)(rules, function (value, key) {
    return (0, _appendPxIfNeeded2.default)(key, value);
  });
  var prefixedRules = (0, _prefixer.getPrefixedStyle)(rulesWithPx, userAgent);
  var cssPrefixedRules = (0, _camelCasePropsToDashCase2.default)(prefixedRules);
  var serializedRules = createMarkupForStyles(cssPrefixedRules);
  return selector + '{' + serializedRules + '}';
}
module.exports = exports['default'];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Based on https://github.com/jsstyles/css-vendor, but without having to
                                                                                                                                                                                                                                                                               * convert between different cases all the time.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 
                                                                                                                                                                                                                                                                               */

exports.getPrefixedKeyframes = getPrefixedKeyframes;
exports.getPrefixedStyle = getPrefixedStyle;

var _createPrefixer = __webpack_require__(858);

var _createPrefixer2 = _interopRequireDefault(_createPrefixer);

var _createPrefixer3 = __webpack_require__(860);

var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);

var _exenv = __webpack_require__(231);

var _exenv2 = _interopRequireDefault(_exenv);

var _static = __webpack_require__(864);

var _static2 = _interopRequireDefault(_static);

var _dynamic = __webpack_require__(878);

var _dynamic2 = _interopRequireDefault(_dynamic);

var _camelCasePropsToDashCase = __webpack_require__(347);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixAll = (0, _createPrefixer2.default)(_static2.default);
var InlineStylePrefixer = (0, _createPrefixer4.default)(_dynamic2.default, prefixAll);

function transformValues(style) {
  return Object.keys(style).reduce(function (newStyle, key) {
    var value = style[key];
    if (Array.isArray(value)) {
      value = value.join(';' + key + ':');
    } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.toString === 'function') {
      value = value.toString();
    }

    newStyle[key] = value;
    return newStyle;
  }, {});
}

// Flatten prefixed values that are arrays to strings.
//
// We get prefixed styles back in the form of:
// - `display: "flex"` OR
// - `display: "-webkit-flex"` OR
// - `display: [/* ... */, "-webkit-flex", "flex"]
//
// The last form is problematic for eventual use in the browser and server
// render. More confusingly, we have to do **different** things on the
// browser and server (noted inline below).
//
// https://github.com/FormidableLabs/radium/issues/958
function flattenStyleValues(style) {
  return Object.keys(style).reduce(function (newStyle, key) {
    var val = style[key];
    if (Array.isArray(val)) {
      if (_exenv2.default.canUseDOM) {
        // For the **browser**, when faced with multiple values, we just take
        // the **last** one, which is the original passed in value before
        // prefixing. This _should_ work, because `inline-style-prefixer`
        // we're just passing through what would happen without ISP.

        val = val[val.length - 1].toString();
      } else {
        // For the **server**, we just concatenate things together and convert
        // the style object values into a hacked-up string of like `display:
        // "-webkit-flex;display:flex"` that will SSR render correctly to like
        // `"display:-webkit-flex;display:flex"` but would otherwise be
        // totally invalid values.

        // We convert keys to dash-case only for the serialize values and
        // leave the real key camel-cased so it's as expected to React and
        // other parts of the processing chain.
        val = val.join(';' + (0, _camelCasePropsToDashCase.camelCaseToDashCase)(key) + ':');
      }
    }

    newStyle[key] = val;
    return newStyle;
  }, {});
}

var _hasWarnedAboutUserAgent = false;
var _lastUserAgent = void 0;
var _cachedPrefixer = void 0;

function getPrefixer(userAgent) {
  var actualUserAgent = userAgent || global && global.navigator && global.navigator.userAgent;

  if (false) {
    if (!actualUserAgent && !_hasWarnedAboutUserAgent) {
      /* eslint-disable no-console */
      console.warn('Radium: userAgent should be supplied for server-side rendering. See ' + 'https://github.com/FormidableLabs/radium/tree/master/docs/api#radium ' + 'for more information.');
      /* eslint-enable no-console */
      _hasWarnedAboutUserAgent = true;
    }
  }

  if (!_cachedPrefixer || actualUserAgent !== _lastUserAgent) {
    if (actualUserAgent === 'all') {
      _cachedPrefixer = {
        prefix: prefixAll,
        prefixedKeyframes: 'keyframes'
      };
    } else {
      _cachedPrefixer = new InlineStylePrefixer({ userAgent: actualUserAgent });
    }
    _lastUserAgent = actualUserAgent;
  }
  return _cachedPrefixer;
}

function getPrefixedKeyframes(userAgent) {
  return getPrefixer(userAgent).prefixedKeyframes;
}

// Returns a new style object with vendor prefixes added to property names and
// values.
function getPrefixedStyle(style, userAgent) {
  var styleWithFallbacks = transformValues(style);
  var prefixer = getPrefixer(userAgent);
  var prefixedStyle = prefixer.prefix(styleWithFallbacks);
  var flattenedStyle = flattenStyleValues(prefixedStyle);
  return flattenedStyle;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Composes a variable number of CSS helper functions.
 * Returns a function that accepts all the original arguments
 * of the functions it composed. If the original function
 * accepted multiple arguments, they must be passed as
 * an array.
 * @example
 * const translateXandRotateY = compose(translateX, rotateY);
 * const cssValue = translateXandRotateY('-5px', '30deg');
 */
var compose = exports.compose = function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, styleArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      styleArgs[_key2] = arguments[_key2];
    }

    var result = funcs.reduce(function (acc, func, i) {
      var arg = styleArgs[i];
      return acc + ' ' + (Array.isArray(arg) ? func.apply(undefined, _toConsumableArray(arg)) : func(arg));
    }, '');
    return result.trim();
  };
};
var cubicBezier = exports.cubicBezier = function cubicBezier(a, b, c, d) {
  return 'cubic-bezier(' + a + ', ' + b + ', ' + c + ', ' + d + ')';
};

var translate3d = exports.translate3d = function translate3d(a, b, c) {
  return 'translate3d(' + a + ', ' + b + ', ' + c + ')';
};

var translateX = exports.translateX = function translateX(a) {
  return 'translateX(' + a + ')';
};

var scale3d = exports.scale3d = function scale3d(a, b, c) {
  return 'scale3d(' + a + ', ' + b + ', ' + c + ')';
};

var scale = exports.scale = function scale(a) {
  return 'scale(' + a + ')';
};

var skewX = exports.skewX = function skewX(deg) {
  return 'skewX(' + deg + 'deg)';
};

var skewY = exports.skewY = function skewY(deg) {
  return 'skewY(' + deg + 'deg)';
};

var skewXY = exports.skewXY = function skewXY(x, y) {
  return skewX(x) + ' ' + skewY(y);
};

var rotateY = exports.rotateY = function rotateY(a) {
  return 'rotateY(' + a + ')';
};

var rotate3d = exports.rotate3d = function rotate3d(a, b, c, d) {
  return 'rotate3d(' + a + ', ' + b + ', ' + c + ', ' + d + 'deg)';
};

var perspective = exports.perspective = function perspective(a) {
  return 'perspective(' + a + ')';
};

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_SEARCH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(165);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var FETCH_SEARCH = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* createRequestTypes */])("FETCH_SEARCH");

var actionTypes = {
  LOAD_INITIAL_DATA: "LOAD_INITIAL_DATA",
  UPDATE_SEARCH_QUERY: "UPDATE_SEARCH_QUERY",
  UPDATE_NAV_SEARCH_QUERY: "UPDATE_NAV_SEARCH_QUERY",
  CHANGE_PAGE: "CHANGE_PAGE",
  REQUEST_PAGE: "REQUEST_PAGE",
  FETCH_SEARCH: FETCH_SEARCH
};

var getSiteSearch = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("search");
var getPages = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["J" /* pipe */])(getSiteSearch, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("pages"));
var getSiteStatus = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["J" /* pipe */])(getSiteSearch, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("status"));
var getNavSearchQuery = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["J" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("navQuery"));
var getQuery = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["J" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("query"));
var getSearchResults = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["J" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("results"));
var getCurrentPage = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["J" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("currentPage"));
var getPageCount = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["J" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("totalPage"));
var getResultsPerPage = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["J" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("resultsPerPage"));
var getPage = function getPage(page) {
  return function (state) {
    var pages = getPages(state);
    return pages[page];
  };
};
var getCurrentPageData = function getCurrentPageData(state) {
  var currentPage = getCurrentPage(state);
  return getPage(currentPage)(state);
};
var getPageResults = function getPageResults(page) {
  return function (state) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("results", getPage(page)(state));
  };
};

var getResults = function getResults(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("results", getPageResults(state));
};

var selectors = {
  getSiteStatus: getSiteStatus,
  getSearchResults: getSearchResults,
  getNavSearchQuery: getNavSearchQuery,
  getQuery: getQuery,
  getCurrentPage: getCurrentPage,
  getPageCount: getPageCount,
  getResultsPerPage: getResultsPerPage,
  getCurrentPageData: getCurrentPageData,
  getPage: getPage,
  getPageResults: getPageResults,
  getResults: getResults
};

var fetchSearch = {
  request: function request(page, query) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* action */])(FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* requestTypes */].REQUEST], { page: page, query: query });
  },
  success: function success(page, data) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* action */])(FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* requestTypes */].SUCCESS], _extends({ page: page }, data));
  },
  failure: function failure(page, error) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* action */])(FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* requestTypes */].FAILURE], { page: page, error: error });
  }
};

var loadInitialData = function loadInitialData(query) {
  return {
    type: actionTypes.LOAD_INITIAL_DATA,
    payload: query
  };
};

var updateNavSearchQuery = function updateNavSearchQuery(query) {
  return {
    type: actionTypes.UPDATE_NAV_SEARCH_QUERY,
    payload: query
  };
};

var updateSearchQuery = function updateSearchQuery(query) {
  return {
    type: actionTypes.UPDATE_SEARCH_QUERY,
    payload: query
  };
};

var changePage = function changePage(page) {
  return {
    type: actionTypes.CHANGE_PAGE,
    payload: page
  };
};

var requestPage = function requestPage(page) {
  return {
    type: actionTypes.REQUEST_PAGE,
    payload: page
  };
};

var actionCreators = {
  loadInitialData: loadInitialData,
  updateNavSearchQuery: updateNavSearchQuery,
  updateSearchQuery: updateSearchQuery,
  changePage: changePage,
  requestPage: requestPage,
  fetchSearch: fetchSearch
};

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createRequestTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = action;
/* unused harmony export generateActionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getInitialFromQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(12);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var REQUEST = "REQUEST";
var SUCCESS = "SUCCESS";
var FAILURE = "FAILURE";

var requestTypes = {
  REQUEST: REQUEST,
  SUCCESS: SUCCESS,
  FAILURE: FAILURE
};

var createRequestTypes = function createRequestTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce(function (acc, type) {
    acc[type] = base + "_" + type;
    return acc;
  }, {});
};

function action(type) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return { type: type, payload: payload };
}

var generateActionTypes = function generateActionTypes(names) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return names.reduce(function (t, name) {
    var _extends2;

    return _extends({}, t, (_extends2 = {}, _extends2[name] = "" + prefix + name + suffix, _extends2));
  }, {});
};

var getInitialFromQuery = function getInitialFromQuery(key) {
  return __WEBPACK_IMPORTED_MODULE_2__constants_environment__["i" /* WINDOW */] && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* get */])(key, __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(__WEBPACK_IMPORTED_MODULE_2__constants_environment__["i" /* WINDOW */].location.search));
};

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(135);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(52);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1019),
    baseMatchesProperty = __webpack_require__(1075),
    identity = __webpack_require__(1086),
    isArray = __webpack_require__(70),
    property = __webpack_require__(1087);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1021),
    listCacheDelete = __webpack_require__(1022),
    listCacheGet = __webpack_require__(1023),
    listCacheHas = __webpack_require__(1024),
    listCacheSet = __webpack_require__(1025);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(390);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(77);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1045);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1062),
    baseKeys = __webpack_require__(400),
    isArrayLike = __webpack_require__(176);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(391),
    isLength = __webpack_require__(250);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(136),
    isObjectLike = __webpack_require__(137);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(177);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createNewEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dispatchEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(17);
// Custom Event is Partially Supported in IE11


var createNewEvent = function createNewEvent(eventName) {
  if (!__WEBPACK_IMPORTED_MODULE_0__environment__["i" /* WINDOW */]) return;

  if (typeof Event === 'function') {
    var _event = new Event(eventName);
    return _event;
  }

  var event = __WEBPACK_IMPORTED_MODULE_0__environment__["i" /* WINDOW */].document.createEvent('Event');
  event.initEvent(eventName, true, true);
  return event;
};

var dispatchEvent = function dispatchEvent(event) {
  if (!__WEBPACK_IMPORTED_MODULE_0__environment__["i" /* WINDOW */]) return;
  if (!__WEBPACK_IMPORTED_MODULE_0__environment__["i" /* WINDOW */].dispatchEvent) return;

  __WEBPACK_IMPORTED_MODULE_0__environment__["i" /* WINDOW */].dispatchEvent(event);
};



/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scrollToElementId; });
/* unused harmony export scrollToNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var scrollToElementId = function scrollToElementId(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callBack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  var element = document.querySelector('[data-id="' + id + '"]');

  if (__WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__["b" /* IS_BROWSER */] && id && element) {
    scrollToNode(element, _extends({}, options), callBack);
  }
};

var scrollToNode = function scrollToNode(target) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$behavior = _ref.behavior,
      behavior = _ref$behavior === undefined ? 'smooth' : _ref$behavior,
      _ref$block = _ref.block,
      block = _ref$block === undefined ? 'start' : _ref$block;

  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  if (__WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__["b" /* IS_BROWSER */] && target) {
    target.scrollIntoView({
      behavior: behavior,
      block: block
    });
    setTimeout(callback, 1000);
  }
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};
//# sourceMappingURL=classNames.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;

var _DateUtils = __webpack_require__(120);

var _LocaleUtils = __webpack_require__(258);

var _classNames = __webpack_require__(181);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, _DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_nameplate_link__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\global-nav-item-grid\\index.jsx";





var mapCMScomponents = function mapCMScomponents(_ref) {
  var name = _ref.name,
      props = _ref.props;
  return {
    name: name === "FlexIconLink" ? "NameplateLink" : name,
    props: props
  };
};

var GlobalNavItemGridBlock = function GlobalNavItemGridBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["z" /* GlobalNavItemGrid */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    }
  }));
};

GlobalNavItemGridBlock.displayName = "GlobalNavItemGridBlock";
GlobalNavItemGridBlock.displayName = "GlobalNavItemGridBlock";
GlobalNavItemGridBlock.displayName = "FlexContent";

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["l" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3_components_nameplate_link__["a" /* default */]],
  mapInput: mapCMScomponents // @CMS-CHANGE in global nav FlexIconLink => NameplateLink
})(GlobalNavItemGridBlock));

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\nameplate-link\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * Flex Icon Link Component.
 * @param {String} name - Name Value.
 * @param {String} image - Image Url.
 * @param {String} type - Type Value.
 * @param {Url} href - Href Value.
 * @param {Boolean} external - Target is external.
 * @param {String} Interactive - Interactive Value.
 * @param {Boolean} fade - Fade Value.
 * @returns {ReactElement} React Component
 */

var NameplateLink = function (_PureComponent) {
  _inherits(NameplateLink, _PureComponent);

  function NameplateLink() {
    _classCallCheck(this, NameplateLink);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.state = {
      resetAnimations: false
    };
    return _this;
  }

  NameplateLink.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    /*
      This is a HACK to force the animations to re-run after mount (don't try this at home).
      Animations were not running on Safari and IE in the global nav.
      It could be a problem with radium keyframes - https://github.com/FormidableLabs/radium/issues/912
    */
    setTimeout(function () {
      return _this2.setState({ resetAnimations: true });
    }, 0);
  };

  NameplateLink.prototype.handleOnClick = function handleOnClick(e) {
    var _props = this.props,
        disabled = _props.disabled,
        external = _props.external,
        gtm = _props.gtm,
        onClick = _props.onClick,
        href = _props.href;


    !external && e && e.preventDefault();
    if (disabled) return;
    if (gtm && gtm.category) {
      // If not, use CMS gtm event
      Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
        pageCategory: gtm.category,
        pageAction: gtm.action
      });
    }

    // onclick button is for handling GTM calls, so it should be fired wheter if we have href or not!
    if (onClick && typeof onClick === "function") {
      onClick();
    }
    if (href && !external) {
      if (__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["f" /* IS_IOS */]) {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["i" /* WINDOW */].location.href = href;
        }, 300);
      } else {
        __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["i" /* WINDOW */].location.href = href;
      }
    }
  };

  NameplateLink.prototype.render = function render() {
    var _this3 = this;

    var _props2 = this.props,
        animationDelay = _props2.animationDelay,
        subNav = _props2.subNav,
        activate = _props2.activate,
        reset = _props2.reset,
        onClick = _props2.onClick,
        href = _props2.href,
        faded = _props2.faded,
        disabled = _props2.disabled,
        appearDisabled = _props2.appearDisabled,
        subheading = _props2.subheading,
        name = _props2.name,
        centerContent = _props2.centerContent,
        type = _props2.type,
        image = _props2.image,
        fade = _props2.fade,
        loading = _props2.loading,
        external = _props2.external;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "li",
      {
        "data-test": "flex-icon-link",
        "data-status": appearDisabled || disabled ? "disabled" : "enabled",
        style: [styles.base(centerContent), styles.animate, { animationDelay: animationDelay + "s" }, subNav ? subNavStyles.base : topNavStyles.base],
        key: this.state.resetAnimations ? "remounted" : "mounted",
        onMouseOver: activate,
        onFocus: activate,
        onMouseOut: reset,
        onBlur: reset, __source: {
          fileName: _jsxFileName,
          lineNumber: 88
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["a" /* A */],
        {
          withoutStyle: true,
          href: href,
          onClick: function onClick(e) {
            return _this3.handleOnClick(e);
          },
          target: external ? "_blank" : undefined, __source: {
            fileName: _jsxFileName,
            lineNumber: 102
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.textContent(centerContent), __source: {
              fileName: _jsxFileName,
              lineNumber: 107
            }
          },
          image && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { "data-info": "icon", style: [styles.icon], __source: {
                fileName: _jsxFileName,
                lineNumber: 109
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: [subNav ? styles.hide : "", appearDisabled || disabled || faded ? styles.fade : ""], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 110
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: [styles.img, fade ? styles.fade : ""], src: image, alt: name, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 115
                }
              })
            ),
            loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: {
                  position: "absolute",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  top: "10%",
                  width: "100%"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 118
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["W" /* LoadingSection */], { visible: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 127
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: {
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column'
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 132
              }
            },
            subheading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: [{ textTransform: "uppercase" }, styles.interactive], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 137
                }
              },
              subheading
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
              {
                withDetails: true,
                "data-test": "flex-title",
                style: [styles.name, appearDisabled || disabled || faded ? styles.fade : "", subNav ? subNavStyles.name : topNavStyles.name], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 138
                }
              },
              name
            ),
            subNav ? "" : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: styles.type, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 149
                }
              },
              type
            )
          )
        )
      )
    );
  };

  return NameplateLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

NameplateLink.displayName = "NameplateLink";


NameplateLink.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  Interactive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  animationDelay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  subNav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  faded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  appearDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])()(NameplateLink));

var dropOutKeyframes = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["j" /* keyframes */])({
  from: {
    opacity: 0,
    transform: "translateY(-1em)"
  },
  to: {
    opacity: 1,
    transform: "translateY(0)"
  }
});

var styles = {
  /*
    https://welovemdp.atlassian.net/projects/MR/issues/MR-2539
    IE 11 was not respecting flex-basis, using explicit width instead.
    TODO: Consider changing component prop name to reflect this in case container components
    expect different behaviour based on flex direction.
  */
  animate: {
    animation: "x .33s 0s forwards",
    animationName: dropOutKeyframes
  },
  base: function base(centerContent) {
    return {
      width: "100%",
      flexGrow: 0,
      flexShrink: 1,
      padding: "0",
      display: "block",
      opacity: 0,
      boxSizing: "border-box",
      "@media (min-width: 768px) and (max-width: 1079px)": {
        width: "50%"
      },
      "@media (min-width: 900px)": {
        width: centerContent ? "33.33%" : '50%'
      },
      "@media (min-width: 1080px)": {
        width: "33%"
      },
      "*": {
        boxSizing: "border-box"
      }
    };
  },
  container: {
    transition: ".5s",
    display: "flex",
    textDecoration: "none",
    color: "#101010",
    alignItems: "center",
    willChange: "opacity",
    "@media (min-width: 768px)": {
      flexWrap: "wrap"
    },
    ":focus": {
      outline: 0
    }
  },
  hide: {
    display: "none"
  },
  textContent: function textContent(centerContent) {
    return {
      display: "flex",
      margin: "auto",
      flexGrow: 1,
      boxSizing: 'border-box',
      width: "100%",
      flexDirection: "row",
      padding: "3px",
      "@media (min-width: 768px)": {
        padding: ".5em 1em .5em 0",
        flexDirection: "column"
      },
      "@media (min-width: 1080px)": {
        width: centerContent ? "300px" : "100%"
      }
    };
  },
  fade: {
    transition: ".5s",
    opacity: 0.33
  },
  interactive: {
    letterSpacing: ".2em",
    fontSize: "70%",
    fontWeight: 600,
    marginBottom: ".25em",
    color: "#910A2D",
    minHeight: "1em",
    lineHeight: "1.3"
  },
  name: {
    textTransform: "uppercase",
    display: "block",
    margin: "0.2em auto 0.5em auto"
  },
  type: {
    color: "#999999",
    textTransform: "none",
    fontSize: "85%",
    paddingTop: '0px',
    display: "block",
    lineHeight: "1.3"
  },
  icon: {
    order: -1,
    position: "relative",
    flex: '0 0 50%',
    boxSizing: 'border-box',
    padding: '10px',
    flexGrow: 0,
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    "@media (min-width: 768px)": {
      maxWidth: "100%",
      margin: "auto",
      flex: 'none'
    }
  },
  img: {
    width: "100%",
    height: "auto",
    "@media (min-width: 768px)": {
      display: "block",
      margin: "0 auto",
      transition: "opacity .33s"
    }
  }
};

var subNavStyles = {
  base: {
    textAlign: "left",
    padding: "0 1.5em",
    "@media (min-width: 768px)": {
      minWidth: "100%",
      maxWidth: "100%"
    }
  },
  name: {
    fontSize: "80%",
    color: "#808080",
    fontWeight: 400,
    textTransform: "none",
    "@media (min-width: 768px)": {
      fontSize: "1.6vw",
      letterSpacing: 0
    }
  }
};

var topNavStyles = {
  base: {
    textAlign: "left",
    "@media (min-width: 768px)": {
      textAlign: "center"
    }
  },
  name: {
    fontSize: "94%",
    "@media (min-width: 376px) and (max-width: 768px)": {
      fontSize: "120%"
    }
  }
};

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withContentRect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_resize_observer_polyfill__ = __webpack_require__(1255);







var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
function getTypes(props) {
  var allowedTypes = [];
  types.forEach(function (type) {
    if (props[type]) {
      allowedTypes.push(type);
    }
  });
  return allowedTypes;
}

function getContentRect(node, types) {
  var calculations = {};

  if (types.indexOf('client') > -1) {
    calculations.client = {
      top: node.clientTop,
      left: node.clientLeft,
      width: node.clientWidth,
      height: node.clientHeight
    };
  }

  if (types.indexOf('offset') > -1) {
    calculations.offset = {
      top: node.offsetTop,
      left: node.offsetLeft,
      width: node.offsetWidth,
      height: node.offsetHeight
    };
  }

  if (types.indexOf('scroll') > -1) {
    calculations.scroll = {
      top: node.scrollTop,
      left: node.scrollLeft,
      width: node.scrollWidth,
      height: node.scrollHeight
    };
  }

  if (types.indexOf('bounds') > -1) {
    var rect = node.getBoundingClientRect();
    calculations.bounds = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  }

  if (types.indexOf('margin') > -1) {
    var styles = getComputedStyle(node);
    calculations.margin = {
      top: styles ? parseInt(styles.marginTop) : 0,
      right: styles ? parseInt(styles.marginRight) : 0,
      bottom: styles ? parseInt(styles.marginBottom) : 0,
      left: styles ? parseInt(styles.marginLeft) : 0
    };
  }

  return calculations;
}

function withContentRect(types) {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(WithContentRect, _Component);

      function WithContentRect() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        };
        _this._animationFrameID = null;
        _this._resizeObserver = null;
        _this._node = null;

        _this.measure = function (entries) {
          var contentRect = getContentRect(_this._node, types || getTypes(_this.props));

          if (entries) {
            contentRect.entry = entries[0].contentRect;
          }

          _this._animationFrameID = window.requestAnimationFrame(function () {
            if (_this._resizeObserver !== null) {
              _this.setState({
                contentRect: contentRect
              });
            }
          });

          if (typeof _this.props.onResize === 'function') {
            _this.props.onResize(contentRect);
          }
        };

        _this._handleRef = function (node) {
          if (_this._resizeObserver !== null) {
            if (node !== null) {
              _this._resizeObserver.observe(node);
            } else {
              _this._resizeObserver.unobserve(_this._node);
            }
          }

          _this._node = node;
          var innerRef = _this.props.innerRef;

          if (innerRef) {
            if (typeof innerRef === 'function') {
              innerRef(node);
            } else {
              innerRef.current = node;
            }
          }
        };

        return _this;
      }

      var _proto = WithContentRect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        this._resizeObserver = new __WEBPACK_IMPORTED_MODULE_5_resize_observer_polyfill__["a" /* default */](this.measure);

        if (this._node !== null) {
          this._resizeObserver.observe(this._node);
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this._resizeObserver !== null) {
          this._resizeObserver.disconnect();

          this._resizeObserver = null;
        }

        window.cancelAnimationFrame(this._animationFrameID);
      };

      _proto.render = function render() {
        var _this$props = this.props,
            innerRef = _this$props.innerRef,
            onResize = _this$props.onResize,
            props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["innerRef", "onResize"]);

        return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          measureRef: this._handleRef,
          measure: this.measure,
          contentRect: this.state.contentRect
        }));
      };

      return WithContentRect;
    }(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]), _class.propTypes = {
      client: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      offset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      scroll: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      bounds: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      margin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      innerRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
      onResize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
    }, _temp;
  };
}

var Measure = withContentRect()(function (_ref) {
  var measure = _ref.measure,
      measureRef = _ref.measureRef,
      contentRect = _ref.contentRect,
      children = _ref.children;
  return children({
    measure: measure,
    measureRef: measureRef,
    contentRect: contentRect
  });
});
Measure.displayName = 'Measure';
Measure.propTypes.children = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func;

/* harmony default export */ __webpack_exports__["a"] = (Measure);



/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_nav_overlay__ = __webpack_require__(1265);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\global-nav-dropdown\\index.jsx";





var mapCMScomponents = function mapCMScomponents(_ref) {
  var name = _ref.name,
      props = _ref.props;
  return {
    name: name === "Overlay" ? "GlobalNavOverlayBlock" : name,
    props: props
  };
};

var GlobalNavDropdownBlock = function GlobalNavDropdownBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["y" /* GlobalNavDropdown */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    }
  }));
};

GlobalNavDropdownBlock.displayName = "GlobalNavDropdownBlock";
GlobalNavDropdownBlock.displayName = "GlobalNavDropdownBlock";
GlobalNavDropdownBlock.displayName = "NavDropdown"; // @CMS-CHANGE Offers => GlobalNavDropdownBlock

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["l" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__global_nav_overlay__["a" /* default */]],
  mapInput: mapCMScomponents // @CMS-CHANGE in global nav Overlay => GlobalNavOverlayBlock
})(GlobalNavDropdownBlock));

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* unused harmony export css */
/* unused harmony export keyframes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectGlobal; });
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && process.env.SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["a"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71), __webpack_require__(370)(module)))

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(596);
var enumBugKeys = __webpack_require__(281);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 192 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(92);
var dPs = __webpack_require__(1365);
var enumBugKeys = __webpack_require__(281);
var IE_PROTO = __webpack_require__(279)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(595)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1366).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(79).f;
var has = __webpack_require__(106);
var TAG = __webpack_require__(62)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(123);
var call = __webpack_require__(1392);
var isArrayIter = __webpack_require__(1393);
var anObject = __webpack_require__(92);
var toLength = __webpack_require__(277);
var getIterFn = __webpack_require__(608);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _captialize = __webpack_require__(1418);

Object.defineProperty(exports, 'captialize', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_captialize).default;
  }
});

var _clamp = __webpack_require__(1419);

Object.defineProperty(exports, 'clamp', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_clamp).default;
  }
});

var _distanceTo = __webpack_require__(1420);

Object.defineProperty(exports, 'distanceTo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_distanceTo).default;
  }
});

var _isDefined = __webpack_require__(1421);

Object.defineProperty(exports, 'isDefined', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isDefined).default;
  }
});

var _isNumber = __webpack_require__(1422);

Object.defineProperty(exports, 'isNumber', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isNumber).default;
  }
});

var _isObject = __webpack_require__(1423);

Object.defineProperty(exports, 'isObject', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isObject).default;
  }
});

var _length = __webpack_require__(1424);

Object.defineProperty(exports, 'length', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_length).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(400),
    getTag = __webpack_require__(402),
    isArguments = __webpack_require__(247),
    isArray = __webpack_require__(70),
    isArrayLike = __webpack_require__(176),
    isBuffer = __webpack_require__(248),
    isPrototype = __webpack_require__(401),
    isTypedArray = __webpack_require__(249);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GOOGLE_MAPS_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CAPTCHA_SITE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RELEASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SENTRY_URL; });
var GOOGLE_MAPS_API_KEY = String("production").toUpperCase() === "PRODUCTION" ? "AIzaSyCnTr8R9ZxC2UYSUk3q-tGOH87srhvbOlY" : "AIzaSyCnTr8R9ZxC2UYSUk3q-tGOH87srhvbOlY";
var CAPTCHA_SITE_KEY = "6LdkF0EUAAAAAKZoE_vD3lnKJIPLt613roLbW65N";
var RELEASE = "3.5";
var SENTRY_URL = "https://95a0afc8ae6344d4a5e2f81f44fd7c51@sentry.io/137626";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(18).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(54);
var LIBRARY = __webpack_require__(83);
var wksExt = __webpack_require__(307);
var defineProperty = __webpack_require__(29).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(144)('keys');
var uid = __webpack_require__(94);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 203 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(18).document;
module.exports = document && document.documentElement;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(16);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(55)(Function.call, __webpack_require__(50).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var setPrototypeOf = __webpack_require__(205).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(57);
var defined = __webpack_require__(64);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 209 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 210 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(83);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(45);
var hide = __webpack_require__(44);
var Iterators = __webpack_require__(110);
var $iterCreate = __webpack_require__(212);
var setToStringTag = __webpack_require__(107);
var getPrototypeOf = __webpack_require__(51);
var ITERATOR = __webpack_require__(23)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(97);
var descriptor = __webpack_require__(93);
var setToStringTag = __webpack_require__(107);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(44)(IteratorPrototype, __webpack_require__(23)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(149);
var defined = __webpack_require__(64);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(23)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(110);
var ITERATOR = __webpack_require__(23)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(29);
var createDesc = __webpack_require__(93);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(108);
var ITERATOR = __webpack_require__(23)('iterator');
var Iterators = __webpack_require__(110);
module.exports = __webpack_require__(54).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(742);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(96);
var toLength = __webpack_require__(24);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(84);
var step = __webpack_require__(324);
var Iterators = __webpack_require__(110);
var toIObject = __webpack_require__(49);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(211)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(131);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(148)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(55);
var invoke = __webpack_require__(314);
var html = __webpack_require__(204);
var cel = __webpack_require__(200);
var global = __webpack_require__(18);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(56)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var macrotask = __webpack_require__(223).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(56)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(38);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var DESCRIPTORS = __webpack_require__(28);
var LIBRARY = __webpack_require__(83);
var $typed = __webpack_require__(155);
var hide = __webpack_require__(44);
var redefineAll = __webpack_require__(102);
var fails = __webpack_require__(19);
var anInstance = __webpack_require__(100);
var toInteger = __webpack_require__(57);
var toLength = __webpack_require__(24);
var toIndex = __webpack_require__(334);
var gOPN = __webpack_require__(98).f;
var dP = __webpack_require__(29).f;
var arrayFill = __webpack_require__(219);
var setToStringTag = __webpack_require__(107);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export split */
/* unused harmony export trim */
/* unused harmony export upperCase */
/* unused harmony export lowerCase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return removeLeadingWhitespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeTrailingWhitespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return upperFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return titleCase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__function__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(342);



var split = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (sep, str) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(str && str.split) ? str.split(sep) : [];
});

var trim = function trim(str) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(str && str.trim) ? str.trim() : "";
};

var upperCase = function upperCase(str) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(str && str.toUpperCase) ? str.toUpperCase() : "";
};

var lowerCase = function lowerCase(str) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(str && str.toLowerCase) ? str.toLowerCase() : "";
};

var removeLeadingWhitespace = function removeLeadingWhitespace(string) {
  return string.replace(/^\s+/i, "");
};

var removeTrailingWhitespace = function removeTrailingWhitespace(string) {
  return string.replace(/\s+$/i, "");
};

var upperFirst = function upperFirst(str) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(str && str.slice) ? "" + upperCase(str.slice(0, 1)) + lowerCase(str.slice(1)) : "";
};

var titleCase = Object(__WEBPACK_IMPORTED_MODULE_0__function__["i" /* pipe */])(split(/\s/g), Object(__WEBPACK_IMPORTED_MODULE_1__array__["b" /* compactMap */])(Object(__WEBPACK_IMPORTED_MODULE_0__function__["i" /* pipe */])(trim, upperFirst)), Object(__WEBPACK_IMPORTED_MODULE_1__array__["e" /* join */])(" "));

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleKeeper = function () {
  function StyleKeeper(userAgent) {
    _classCallCheck(this, StyleKeeper);

    this._userAgent = userAgent;
    this._listeners = [];
    this._cssSet = {};
  }

  StyleKeeper.prototype.subscribe = function subscribe(listener) {
    var _this = this;

    if (this._listeners.indexOf(listener) === -1) {
      this._listeners.push(listener);
    }

    return {
      // Must be fat arrow to capture `this`
      remove: function remove() {
        var listenerIndex = _this._listeners.indexOf(listener);
        if (listenerIndex > -1) {
          _this._listeners.splice(listenerIndex, 1);
        }
      }
    };
  };

  StyleKeeper.prototype.addCSS = function addCSS(css) {
    var _this2 = this;

    if (!this._cssSet[css]) {
      this._cssSet[css] = true;
      this._emitChange();
    }

    return {
      // Must be fat arrow to capture `this`
      remove: function remove() {
        delete _this2._cssSet[css];
        _this2._emitChange();
      }
    };
  };

  StyleKeeper.prototype.getCSS = function getCSS() {
    return Object.keys(this._cssSet).join('\n');
  };

  StyleKeeper.prototype._emitChange = function _emitChange() {
    this._listeners.forEach(function (listener) {
      return listener();
    });
  };

  return StyleKeeper;
}();

exports.default = StyleKeeper;
module.exports = exports['default'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hash;


// a simple djb2 hash based on hash-string:
// https://github.com/MatthewBarker/hash-string/blob/master/source/hash-string.js
// returns a hex-encoded hash
function hash(text) {
  if (!text) {
    return '';
  }

  var hashValue = 5381;
  var index = text.length - 1;

  while (index) {
    hashValue = hashValue * 33 ^ text.charCodeAt(index);
    index -= 1;
  }

  return (hashValue >>> 0).toString(16);
}
module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(239);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(52);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// Action Types

var actionTypes = {
  INIT_OUTLET_STORE: "INIT_OUTLET_STORE",
  LOAD_OUTLET_STORE: "LOAD_OUTLET_STORE",
  STEP_CHANGE: "STEP_CHANGE",
  DEALER_RESET: "DEALER_RESET",
  DEALER_CONFIRM: "DELAER_CONFIRM",
  DEALER_CHANGE_REQUEST: "DEALER_CHANGE_REQUEST",
  DEALER_CHANGE_SUCCESS: "DEALER_CHANGE_SUCCESS",
  DEALER_CHANGE_NO_RESULTS: "DEALER_CHANGE_NO_RESULTS",
  DEALER_FETCH_START: "DEALER_FETCH_START",
  DEALER_FETCH_CANNOT_RESOLVE: "DEALER_FETCH_CANNOT_RESOLVE",
  DEALER_FETCH_SUCCESS: "DEALER_FETCH_SUCCESS",
  DEALER_FETCH_ERROR: "DEALER_FETCH_ERROR",
  NAMEPLATE_CHANGE: "NAMEPLATE_CHANGE",
  OUTLET_STOCKS_FETCH_REQUEST: "OUTLET_STOCKS_FETCH_REQUEST",
  OUTLET_STOCKS_FETCH_START: "OUTLET_STOCKS_FETCH_START",
  OUTLET_STOCKS_FETCH_SUCCESS: "OUTLET_STOCKS_FETCH_SUCCESS",
  OUTLET_STOCKS_FETCH_ERROR: "OUTLET_STOCKS_FETCH_ERROR",
  UPDATE_SORT: "UPDATE_SORT",
  UPDATE_FILTER: "UPDATE_FILTER"

  // Action Creators

};var initOutletStore = function initOutletStore(_ref) {
  var outletStockEndpoint = _ref.outletStockEndpoint;
  return {
    type: actionTypes.INIT_OUTLET_STORE,
    payload: { outletStockEndpoint: outletStockEndpoint }
  };
};

var dealerReset = function dealerReset() {
  return {
    type: actionTypes.DEALER_RESET
  };
};

var dealerConfirm = function dealerConfirm() {
  return {
    type: actionTypes.DEALER_CONFIRM,
    payload: { dealerConfirm: true }
  };
};

var dealerChangeRequest = function dealerChangeRequest(_ref2) {
  var dealerCode = _ref2.dealerCode,
      id = _ref2.id;
  return {
    type: actionTypes.DEALER_CHANGE_REQUEST,
    payload: { dealer: { dealerCode: dealerCode, id: id }, dealerConfirm: false }
  };
};

var stepChange = function stepChange(payload) {
  return {
    type: actionTypes.STEP_CHANGE,
    payload: payload
  };
};

var nameplateChange = function nameplateChange(payload) {
  return {
    type: actionTypes.NAMEPLATE_CHANGE,
    payload: payload
  };
};

var fetchRequest = function fetchRequest(params) {
  return {
    type: actionTypes.OUTLET_STOCKS_FETCH_REQUEST,
    payload: _extends({}, params)
  };
};

var fetchSuccess = function fetchSuccess(result) {
  return {
    type: actionTypes.OUTLET_STOCKS_FETCH_SUCCESS,
    payload: _extends({}, result)
  };
};

var fetchError = function fetchError(error) {
  return {
    type: actionTypes.OUTLET_STOCKS_FETCH_ERROR,
    payload: _extends({}, error)
  };
};

var updateSort = function updateSort(_ref3) {
  var key = _ref3.key,
      dir = _ref3.dir,
      gtmID = _ref3.gtmID,
      gtmPayload = _ref3.gtmPayload;
  return {
    type: actionTypes.UPDATE_SORT,
    payload: { sort: { key: key, dir: dir }, gtmID: gtmID, gtmPayload: gtmPayload }
  };
};

var updateFilters = function updateFilters(filter) {
  return {
    type: actionTypes.UPDATE_FILTER,
    payload: { filter: filter }
  };
};

var actionCreators = {
  initOutletStore: initOutletStore,
  dealerReset: dealerReset,
  dealerChangeRequest: dealerChangeRequest,
  nameplateChange: nameplateChange,
  fetchRequest: fetchRequest,
  dealerConfirm: dealerConfirm,
  fetchSuccess: fetchSuccess,
  fetchError: fetchError,
  stepChange: stepChange,
  updateSort: updateSort,
  updateFilters: updateFilters

  // Selectors

};var getOutlet = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("outlet");

var selectors = {
  getOutlet: getOutlet
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117),
    root = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1037),
    mapCacheDelete = __webpack_require__(1044),
    mapCacheGet = __webpack_require__(1046),
    mapCacheHas = __webpack_require__(1047),
    mapCacheSet = __webpack_require__(1048);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1049),
    isObjectLike = __webpack_require__(137);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1064),
    isObjectLike = __webpack_require__(137);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(77),
    stubFalse = __webpack_require__(1065);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(398)(module)))

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1066),
    baseUnary = __webpack_require__(1067),
    nodeUtil = __webpack_require__(1068);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(70),
    isSymbol = __webpack_require__(177);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_less__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Button_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_urlHandler__ = __webpack_require__(33);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Button\\Button.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Button = function (_React$PureComponent) {
  _inherits(Button, _React$PureComponent);

  function Button() {
    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handleOnClick = function () {
      var _this$props = _this.props,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick,
          external = _this$props.external,
          href = _this$props.href,
          disabled = _this$props.disabled,
          gtm = _this$props.gtm;

      onClick();

      // Delay for firing GTM before redirection
      // Call GTM if we have an gtm object
      if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
        Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: gtm.category,
          pageAction: gtm.action
        });
      }
      if (external && href && !disabled) {
        setTimeout(function () {
          new __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_urlHandler__["a" /* default */](href).newTab();
        }, 200);
      } else if (href && !disabled) {
        setTimeout(function () {
          new __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_urlHandler__["a" /* default */](href).redirect();
        }, 200);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Button.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        children = _props.children,
        fullWidth = _props.fullWidth,
        _props$disabled = _props.disabled,
        disabled = _props$disabled === undefined ? false : _props$disabled,
        _props$external = _props.external,
        external = _props$external === undefined ? false : _props$external,
        label = _props.label,
        href = _props.href,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? "red" : _props$styleName,
        _props$loading = _props.loading,
        loading = _props$loading === undefined ? false : _props$loading;


    var Tag = href && href != '' && !external ? 'a' : 'button';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      {
        "data-test": "button",
        href: href && href != '' && !external ? href : '',
        className: "Button " + __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Button_less___default.a.Button] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Button_less___default.a.ButtonRed] = styleName === "red", _classnames[__WEBPACK_IMPORTED_MODULE_2__Button_less___default.a.ButtonFullWidth] = fullWidth, _classnames[__WEBPACK_IMPORTED_MODULE_2__Button_less___default.a.ButtonWhite] = styleName === "white", _classnames[__WEBPACK_IMPORTED_MODULE_2__Button_less___default.a.ButtonBlack] = styleName === "black", _classnames[__WEBPACK_IMPORTED_MODULE_2__Button_less___default.a.ButtonBlackOutlined] = styleName === "blackOutlined", _classnames[__WEBPACK_IMPORTED_MODULE_2__Button_less___default.a.ButtonWhiteOutlined] = styleName === "whiteOutlined", _classnames[__WEBPACK_IMPORTED_MODULE_2__Button_less___default.a.ButtonWhiteOutlinedWithOpacity] = styleName === "whiteOutlinedWithOpacity", _classnames[__WEBPACK_IMPORTED_MODULE_2__Button_less___default.a.ButtonDisabled] = disabled, _classnames)),
        onClick: this._handleOnClick, __source: {
          fileName: _jsxFileName,
          lineNumber: 45
        }
      },
      loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Button_less___default.a.LoadingSection] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 62
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["V" /* LoadingIcon */], {
          styleName: "dark",
          style: {
            width: "16px",
            height: "16px"
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 66
          }
        })
      ),
      children && children,
      !children && label
    );
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Button.displayName = "Button";


/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionText_less__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AccordionText_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\AccordionText\\AccordionText.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var AccordionText = function (_React$Component) {
  _inherits(AccordionText, _React$Component);

  function AccordionText(props) {
    _classCallCheck(this, AccordionText);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleOnClick = function () {
      var _this$props = _this.props,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick,
          gtm = _this$props.gtm,
          title = _this$props.title,
          name = _this$props.name;
      var status = _this.state.status;

      _this.setState({
        status: status === 1 ? 0 : 1,
        height: status === 0 && _this.contentArea ? _this.contentArea.scrollHeight : 0
      }, function () {
        onClick(_this.state.status);

        // Delay for firing GTM before redirection
        // Call GTM if we have an gtm object
        if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
          var heading = title || name;
          Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__["a" /* default */])({
            pageCategory: gtm.category,
            pageAction: gtm.action + (" - \"" + (_this.state.status === 1 ? "EXPANDED" : "COLLAPSED") + "\"") + (" \"" + heading.toUpperCase() + "\"")
          });
        }
      });
    };

    _this.updateHeight = function (el) {
      var _this$state = _this.state,
          status = _this$state.status,
          height = _this$state.height;


      if (el && status === 1 && height !== el.scrollHeight) {
        setTimeout(function () {
          _this.setState({
            height: el.scrollHeight
          });
        }, 200);
      }
    };

    _this.state = {
      status: 0,
      height: 0
    };
    return _this;
  }

  AccordionText.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        status = _props.status,
        _props$isExpandedByDe = _props.isExpandedByDefault,
        isExpandedByDefault = _props$isExpandedByDe === undefined ? false : _props$isExpandedByDe;

    if ((status === 1 || isExpandedByDefault) && this.contentArea) {
      setTimeout(function () {
        _this2.setState({
          status: 1,
          height: _this2.contentArea ? _this2.contentArea.scrollHeight : 0
        });
      }, 200);
    }
  };

  AccordionText.prototype.render = function render() {
    var _classnames,
        _classnames2,
        _classnames3,
        _classnames4,
        _classnames5,
        _classnames6,
        _classnames7,
        _this3 = this,
        _classnames8,
        _classnames9,
        _classnames10,
        _classnames11,
        _classnames12;

    var _props2 = this.props,
        _props2$styleName = _props2.styleName,
        styleName = _props2$styleName === undefined ? "box" : _props2$styleName,
        children = _props2.children,
        title = _props2.title,
        name = _props2.name,
        components = _props2.components,
        titleTextAlign = _props2.titleTextAlign;
    var _state = this.state,
        height = _state.height,
        status = _state.status;

    var heading = title || name;
    var description = children || Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(components);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionText] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 71
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            "data-test": "accordion-title",
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionTitle] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 75
            }
          },
          styleName === 'simple' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["a" /* A */],
            {
              onClick: this._handleOnClick,
              styleName: "blue",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 81
              }
            },
            heading
          ),
          styleName === 'box' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionTitleBox] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionCenterAligned] = titleTextAlign === 'center', _classnames3)),
              onClick: this._handleOnClick, __source: {
                fileName: _jsxFileName,
                lineNumber: 89
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionTitleBoxText] = true, _classnames4)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 95
                }
              },
              heading
            ),
            description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionTitleBoxIcon] = true, _classnames5)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 99
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["c" /* AnimatedPlusMinus */], { open: status, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 102
                }
              })
            )
          ),
          styleName === 'disclaimer' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              onClick: this._handleOnClick,
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionTitleDisclaimer] = true, _classnames6)), __source: {
                fileName: _jsxFileName,
                lineNumber: 108
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 113
                }
              },
              heading
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionTitleDisclaimerIcon] = true, _classnames7)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 114
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["p" /* ChevronIcon */], { style: { transform: status ? 'none' : 'rotate(180deg)' }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 117
                }
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            ref: function ref(c) {
              return _this3.contentArea = c;
            },
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionContent] = true, _classnames8[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionContentBox] = styleName === 'box', _classnames8[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionContentDisclaimer] = styleName === 'disclaimer', _classnames8[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionContentInfo] = styleName === 'info', _classnames8)),
            style: {
              height: height + "px"
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 122
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              ref: function ref(el) {
                return _this3.updateHeight(el);
              },
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames9 = {}, _classnames9[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionContentInside] = true, _classnames9[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.LefAligned] = styleName === 'box' || styleName === 'info', _classnames9)), __source: {
                fileName: _jsxFileName,
                lineNumber: 134
              }
            },
            description
          )
        ),
        styleName === 'info' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames10 = {}, _classnames10[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionTitleInfo] = true, _classnames10)),
            onClick: this._handleOnClick, __source: {
              fileName: _jsxFileName,
              lineNumber: 144
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames11 = {}, _classnames11[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionTitleInfoIcon] = true, _classnames11)), __source: {
                fileName: _jsxFileName,
                lineNumber: 149
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["c" /* AnimatedPlusMinus */], { open: status, __source: {
                fileName: _jsxFileName,
                lineNumber: 152
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames12 = {}, _classnames12[__WEBPACK_IMPORTED_MODULE_6__AccordionText_less___default.a.AccordionTitleInfoText] = true, _classnames12)), __source: {
                fileName: _jsxFileName,
                lineNumber: 154
              }
            },
            status ? "Less Info" : "More Info"
          )
        )
      )
    );
  };

  return AccordionText;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AccordionText.displayName = "AccordionText";


/* harmony default export */ __webpack_exports__["a"] = (AccordionText);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArticlePage_less__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArticlePage_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ArticlePage_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_dateHandler__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\ArticlePage\\ArticlePage.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ArticleHeader = function ArticleHeader(props) {
  var _classnames;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__ArticlePage_less___default.a.ArticleHeader] = true, _classnames)), __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["i" /* BackButton */], {
      small: true,
      href: props.backUrl,
      backText: props.backText || "Beyond the drive", __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    }),
    props.publishDate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["l" /* Caption */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      },
      "POSTED ON ",
      props.publishDate
    )
  );
};

ArticleHeader.displayName = "ArticleHeader";
ArticleHeader.displayName = "ArticleHeader";

var ArticlePage = function (_Component) {
  _inherits(ArticlePage, _Component);

  function ArticlePage() {
    _classCallCheck(this, ArticlePage);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ArticlePage.prototype.render = function render() {
    var _props = this.props,
        preHeading = _props.preHeading,
        heading = _props.heading,
        description = _props.description,
        content = _props.content,
        featureImage = _props.featureImage,
        featureImageCaption = _props.featureImageCaption,
        styleName = _props.styleName,
        publishDate = _props.publishDate,
        backUrl = _props.backUrl,
        backgroundColor = _props.backgroundColor,
        children = _props.children,
        components = _props.components,
        hero = _props.hero;

    var dateString = new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_dateHandler__["a" /* default */](publishDate).format('D/M/YYYY');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_8" /* Section */],
      { fullWidth: true, backgroundColor: backgroundColor, __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleHeader, { publishDate: dateString, backUrl: backUrl, __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      }),
      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__["a" /* default */])(hero),
      styleName === "news" ? featureImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_8" /* Section */],
        { horizontalPadding: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["o" /* Image */], {
          src: featureImage,
          alt: heading, __source: {
            fileName: _jsxFileName,
            lineNumber: 50
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */],
          { textAlign: "center", __source: {
              fileName: _jsxFileName,
              lineNumber: 53
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 53
              }
            },
            featureImageCaption
          )
        )
      ) : featureImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["k" /* FullWidthImageSection */],
        {
          backgroundImage: featureImage,
          align: "center",
          textAlign: "center",
          height: "tall", __source: {
            fileName: _jsxFileName,
            lineNumber: 57
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["m" /* Heading */], { value: heading, preHeading: preHeading, white: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 62
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { xmlString: description, theme: "dark", __source: {
            fileName: _jsxFileName,
            lineNumber: 63
          }
        })
      ),
      styleName === "news" ? (heading || preHeading || description || content) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_8" /* Section */],
        { padding: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["m" /* Heading */], { value: heading, preHeading: preHeading, __source: {
            fileName: _jsxFileName,
            lineNumber: 71
          }
        }),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { xmlString: description, __source: {
            fileName: _jsxFileName,
            lineNumber: 72
          }
        }),
        content && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { xmlString: content, __source: {
            fileName: _jsxFileName,
            lineNumber: 73
          }
        })
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { xmlString: content, __source: {
          fileName: _jsxFileName,
          lineNumber: 77
        }
      }),
      components && Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__["a" /* default */])(components),
      !components && children
    );
  };

  return ArticlePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ArticlePage.displayName = "ArticlePage";


/* harmony default export */ __webpack_exports__["b"] = (ArticlePage);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardYoutubePlayer_less__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardYoutubePlayer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CardYoutubePlayer_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\CardYoutubePlayer\\CardYoutubePlayer.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CardYoutubePlayer = function (_React$Component) {
  _inherits(CardYoutubePlayer, _React$Component);

  function CardYoutubePlayer(props) {
    _classCallCheck(this, CardYoutubePlayer);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleOnClick = function (event) {
      _this.setState({
        showVideo: true
      });
    };

    _this._handleClose = function () {
      _this.setState({
        showVideo: false
      });
    };

    _this.state = {
      showVideo: false
    };
    return _this;
  }

  CardYoutubePlayer.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4;

    var _props = this.props,
        heading = _props.heading,
        imageSrc = _props.imageSrc,
        youtubeId = _props.youtubeId,
        linkText = _props.linkText,
        description = _props.description,
        videoSrc = _props.videoSrc,
        gtm = _props.gtm;


    var videoLink = youtubeId || videoSrc;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__CardYoutubePlayer_less___default.a.CardYoutubePlayer] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["m" /* Card */], _extends({}, this.props, {
        linkText: videoLink ? "Watch Video" : linkText,
        onClick: this._handleOnClick,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37
        }
      })),
      this.state.showVideo && videoLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__CardYoutubePlayer_less___default.a.YoutubeFrameShadow] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 43
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__CardYoutubePlayer_less___default.a.YoutubeFrame] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 46
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["k" /* ButtonIcon */],
            {
              styleName: "SquareWhite",
              onClick: this._handleClose,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 49
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["u" /* CrossIcon */], { style: {
                width: "15px",
                height: "15px"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 53
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__CardYoutubePlayer_less___default.a.YoutubeFrameIframe] = true, _classnames4)), __source: {
                fileName: _jsxFileName,
                lineNumber: 58
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_24" /* YoutubePlayer */], { youtubeId: videoLink, __source: {
                fileName: _jsxFileName,
                lineNumber: 61
              }
            })
          )
        )
      )
    );
  };

  return CardYoutubePlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CardYoutubePlayer.displayName = "CardYoutubePlayer";


/* harmony default export */ __webpack_exports__["a"] = (CardYoutubePlayer);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__ = __webpack_require__(17);



var checkVisible = function checkVisible(element) {
  if (!element || !__WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__["i" /* WINDOW */]) return false;
  var rect = element.getBoundingClientRect();
  var viewHeight = Math.max(__WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__["i" /* WINDOW */].document.documentElement.clientHeight, __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_environment__["i" /* WINDOW */].innerHeight) + 200;
  if (Math.abs(rect.top) <= viewHeight) return true;
  if (Math.abs(rect.bottom) <= viewHeight) return true;
  return false;
};

/* harmony default export */ __webpack_exports__["a"] = (checkVisible);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeroContent_less__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HeroContent_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\HeroContent\\HeroContent.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var HeroContent = function (_React$PureComponent) {
  _inherits(HeroContent, _React$PureComponent);

  function HeroContent() {
    _classCallCheck(this, HeroContent);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  HeroContent.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames7, _classnames8;

    var _props = this.props,
        imageSrc = _props.imageSrc,
        heading = _props.heading,
        description = _props.description,
        details = _props.details,
        _props$Icon = _props.Icon,
        Icon = _props$Icon === undefined ? null : _props$Icon,
        iconColor = _props.iconColor,
        _props$textAlign = _props.textAlign,
        textAlign = _props$textAlign === undefined ? 'center' : _props$textAlign,
        theme = _props.theme;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.HeroContent] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.HeroContentImageContainer] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        },
        imageSrc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.HeroContentImage] = true, _classnames3)),
          src: imageSrc, __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        })
      ),
      Icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.HeroContentIcon] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.HeroContentIconRed] = iconColor === 'red', _classnames4)),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 41
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.ContentArea] = true, _classnames5[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.Left] = textAlign === 'left', _classnames5[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.Right] = textAlign === 'right', _classnames5)), __source: {
            fileName: _jsxFileName,
            lineNumber: 44
          }
        },
        heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.ContentAreaHeading] = true, _classnames6[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.White] = theme === 'dark', _classnames6)), __source: {
              fileName: _jsxFileName,
              lineNumber: 50
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["B" /* H4 */],
            {
              withDetails: true,
              white: theme === 'dark',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 54
              }
            },
            heading
          )
        ),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.ContentAreaContent] = true, _classnames7)), __source: {
              fileName: _jsxFileName,
              lineNumber: 63
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], { xmlString: description, theme: theme, textAlign: textAlign, __source: {
              fileName: _jsxFileName,
              lineNumber: 67
            }
          })
        ),
        details && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_3__HeroContent_less___default.a.Details] = true, _classnames8)), __source: {
              fileName: _jsxFileName,
              lineNumber: 71
            }
          },
          details
        )
      )
    );
  };

  return HeroContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

HeroContent.displayName = "HeroContent";


/* harmony default export */ __webpack_exports__["a"] = (HeroContent);

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};
//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;

var _DateUtils = __webpack_require__(120);

var _Helpers = __webpack_require__(182);

/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, _DateUtils.isSameDay)(day, mod);
    }
    if ((0, _Helpers.isRangeOfDates)(mod)) {
      return (0, _DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, _DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeroContent_HeroContent__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecallDetail_RecallDetail__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Disclaimer_Disclaimer__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RecallDocument_less__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_parseRecallActivities__ = __webpack_require__(465);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\RecallDocument\\RecallDocument.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import dateHandler from "AtomicUtils/dateHandler"

var RecallDocument = function (_React$Component) {
  _inherits(RecallDocument, _React$Component);

  function RecallDocument(props) {
    _classCallCheck(this, RecallDocument);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleOnClickBook = function () {
      var Status = _this.state.Status;

      Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
        pageCategory: "Recalls",
        pageAction: "Recalls - Recall Status \"" + Status + "\" - Clicked \"" + "Book Your free repair".toUpperCase() + "\""
      });
    };

    _this._handleOnClickDownload = function () {
      var Status = _this.state.Status;

      Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
        pageCategory: "Recalls",
        pageAction: "Recalls - Recall Status \"" + Status + "\" - Clicked \"" + "Download Report".toUpperCase() + "\""
      });
    };

    _this._handleStatus = function () {
      var recallActivities = _this.props.recallActivities;

      var _parseRecallActivitie = Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_parseRecallActivities__["a" /* default */])(recallActivities),
          Status = _parseRecallActivitie.Status;

      _this.setState({
        Status: Status
      });
    };

    _this._handleNoRecall = function () {
      var _this$props$handleNoR = _this.props.handleNoRecall,
          handleNoRecall = _this$props$handleNoR === undefined ? function () {} : _this$props$handleNoR;

      handleNoRecall();
    };

    _this.state = {
      Status: ""
    };
    return _this;
  }

  RecallDocument.prototype.componentDidMount = function componentDidMount() {
    this._handleStatus();
  };

  RecallDocument.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames7, _classnames8, _classnames9, _classnames10, _classnames11, _classnames12, _classnames15;

    var _props = this.props,
        _props$heading = _props.heading,
        heading = _props$heading === undefined ? "MAZDA RECALLS" : _props$heading,
        _props$description = _props.description,
        description = _props$description === undefined ? "View you vehicles details below" : _props$description,
        modelDescription = _props.modelDescription,
        vin = _props.vin,
        productionYear = _props.productionYear,
        recallActivities = _props.recallActivities,
        activeToolTip = _props.activeToolTip,
        pendingToolTip = _props.pendingToolTip,
        accessedTime = _props.accessedTime,
        recallLink = _props.recallLink,
        pdfLink = _props.pdfLink,
        handleNoRecall = _props.handleNoRecall,
        findADealerCta = _props.findADealerCta,
        bookCTALink = _props.bookCTALink,
        noLongerOwningLink = _props.noLongerOwningLink;

    // This was a feature that we removed through the new needs
    // const accessedTime = new dateHandler(new Date()).format('0D/0M/YYYY 0h:0mm A')

    var _parseRecallActivitie2 = Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_parseRecallActivities__["a" /* default */])(recallActivities),
        Status = _parseRecallActivitie2.Status,
        NumberOfActive = _parseRecallActivitie2.NumberOfActive,
        NumberOfPending = _parseRecallActivitie2.NumberOfPending,
        NumberOfAll = _parseRecallActivitie2.NumberOfAll;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallDocument] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 91
        }
      },
      (heading || description) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
        { backgroundColor: "#F5F5F5", padding: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 95
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__HeroContent_HeroContent__["a" /* default */], {
          heading: heading,
          description: description, __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 101
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 102
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["s" /* Container */],
          { styleName: "screen", __source: {
              fileName: _jsxFileName,
              lineNumber: 103
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallResult] = true, _classnames2)), __source: {
                fileName: _jsxFileName,
                lineNumber: 104
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallDocumentInfo] = true, _classnames3)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 107
                }
              },
              modelDescription && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 111
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "strong",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 112
                    }
                  },
                  "Model:"
                ),
                " ",
                modelDescription
              ),
              vin && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 116
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "strong",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 117
                    }
                  },
                  "VIN:"
                ),
                " ",
                vin
              ),
              productionYear && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 121
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "strong",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 122
                    }
                  },
                  "Year:"
                ),
                " ",
                productionYear
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallBoxParent] = true, _classnames4)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 126
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
                { backgroundColor: "#FFFFFF", border: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 129
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallBox] = true, _classnames5)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 130
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallBoxHeading] = true, _classnames6[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallBoxHeadingRED] = NumberOfAll > 0, _classnames6[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallBoxHeadingGREEN] = NumberOfAll === 0, _classnames6)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 133
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 138
                        }
                      },
                      NumberOfAll > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["d" /* AlertIcon */], { style: {
                          width: "2em",
                          height: "2em"
                        }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 140
                        }
                      }),
                      NumberOfAll === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_17" /* TickModalIcon */], { style: {
                          width: "2em",
                          height: "2em"
                        }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 146
                        }
                      }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["A" /* H3 */],
                        { withDetails: true, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 151
                          }
                        },
                        Status
                      )
                    )
                  ),
                  NumberOfAll > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallActivePending] = true, _classnames7)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 157
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallActivePendingInfo] = true, _classnames8)), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 160
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "strong",
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 163
                          }
                        },
                        NumberOfActive
                      ),
                      "\xA0 Active Recall",
                      NumberOfActive > 1 ? "s" : "",
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6__Disclaimer_Disclaimer__["a" /* default */],
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 166
                          }
                        },
                        activeToolTip
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames9 = {}, _classnames9[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallActivePendingMiddle] = true, _classnames9)), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 168
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["l" /* Caption */],
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 171
                          }
                        },
                        "|"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames10 = {}, _classnames10[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallActivePendingInfo] = true, _classnames10)), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 173
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "strong",
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 176
                          }
                        },
                        NumberOfPending
                      ),
                      "\xA0 Pending Recall",
                      NumberOfPending > 1 ? "s" : "",
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6__Disclaimer_Disclaimer__["a" /* default */],
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 179
                          }
                        },
                        pendingToolTip
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames11 = {}, _classnames11[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallBoxButtons] = true, _classnames11[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallBoxButtonsOneButton] = !handleNoRecall && !recallLink, _classnames11)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 185
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
                      { styleName: "blackOutlined", external: true, href: pdfLink, onClick: this._handleOnClickDownload, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 189
                        }
                      },
                      "Download Report"
                    ),
                    NumberOfAll > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
                      {
                        styleName: "black",
                        external: bookCTALink && bookCTALink.props && bookCTALink.props.external,
                        onClick: this._handleOnClickBook,
                        href: bookCTALink && bookCTALink.props && bookCTALink.props.href, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 193
                        }
                      },
                      bookCTALink && bookCTALink.props && bookCTALink.props.label || "Book Your free repair"
                    ),
                    NumberOfAll === 0 && handleNoRecall && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
                      { styleName: "black", onClick: this._handleNoRecall, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 202
                        }
                      },
                      "Check another vehicle"
                    ),
                    NumberOfAll === 0 && !handleNoRecall && recallLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
                      { styleName: "black", external: true, href: recallLink, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 207
                        }
                      },
                      "Check another vehicle"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 212
                      }
                    },
                    "If you no longer own this vehicle ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
                      { href: noLongerOwningLink, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 213
                        }
                      },
                      " click here "
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 215
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 216
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "strong",
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 217
                        }
                      },
                      "Result returned on:"
                    ),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames12 = {}, _classnames12[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallWhiteSpace] = true, _classnames12)), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 217
                        }
                      },
                      accessedTime
                    )
                  )
                )
              )
            ),
            recallActivities && recallActivities.map(function (recall, index) {
              var _classnames13, _classnames14;

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  key: "RecallDetail-" + index,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames13 = {}, _classnames13[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallActivities] = true, _classnames13)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 225
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 230
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames14 = {}, _classnames14[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallDetail] = true, _classnames14[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallDetailBorder] = index < recallActivities.length - 1, _classnames14)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 231
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RecallDetail_RecallDetail__["a" /* default */], _extends({}, recall, {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 235
                      }
                    }))
                  )
                )
              );
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames15 = {}, _classnames15[__WEBPACK_IMPORTED_MODULE_7__RecallDocument_less___default.a.RecallBoxBottomButtons] = true, _classnames15)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 241
                }
              },
              handleNoRecall && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
                { styleName: NumberOfAll > 0 ? "white" : "black", onClick: this._handleNoRecall, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 245
                  }
                },
                "Check another vehicle"
              ),
              !handleNoRecall && recallLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
                { styleName: NumberOfAll > 0 ? "white" : "black", external: true, href: recallLink, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 250
                  }
                },
                "Check another vehicle"
              ),
              NumberOfAll > 0 && findADealerCta && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
                { styleName: "black", external: true, href: findADealerCta.props.href, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 255
                  }
                },
                findADealerCta.props.label
              )
            )
          )
        )
      )
    );
  };

  return RecallDocument;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RecallDocument.displayName = "RecallDocument";


/* harmony default export */ __webpack_exports__["a"] = (RecallDocument);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_wysiwyg_content_index_jsx__ = __webpack_require__(262);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\countdown-timer\\index.jsx";





var CountdownTimerBlock = function CountdownTimerBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["l" /* CountdownTimer */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};

CountdownTimerBlock.displayName = "CountdownTimerBlock";
CountdownTimerBlock.displayName = "CountdownTimerBlock";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["l" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3_components_wysiwyg_content_index_jsx__["a" /* default */]]
})(CountdownTimerBlock));

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\wysiwyg-content\\index.jsx";



var WysiwygContent = function WysiwygContent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["t" /* Content */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

WysiwygContent.displayName = "WysiwygContent";
WysiwygContent.displayName = "WysiwygContent";
WysiwygContent.displayName = "WysiwygContent";

/* harmony default export */ __webpack_exports__["a"] = (WysiwygContent);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_text_video_frame__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_location_text__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blocks_time_clock_video_frame__ = __webpack_require__(264);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\dynamic-text-video-frame\\index.jsx";






var dayOfTheWeek = function dayOfTheWeek() {
  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return days[new Date().getDay()];
};

var renderDynamicText = function renderDynamicText(_ref) {
  var type = _ref.type,
      text = _ref.text;

  switch (type) {
    case "Location":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_location_text__["a" /* default */], { fallbackText: text, __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      });
    case "Day":
      return dayOfTheWeek();
    case "Text":
      return text;
    case "Time":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_blocks_time_clock_video_frame__["a" /* default */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      });
    default:
      return null;
  }
};

var DynamicTextVideoFrameBlock = function DynamicTextVideoFrameBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_components_text_video_frame__["a" /* default */],
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: { fontFamily: "dseg7", fontSize: 0, position: "absolute" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        }
      },
      "."
    ),
    renderDynamicText(props)
  );
};

DynamicTextVideoFrameBlock.displayName = "DynamicTextVideoFrameBlock";
DynamicTextVideoFrameBlock.displayName = "DynamicTextVideoFrameBlock";
renderDynamicText.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["Location", "Day", "Text"]),
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (DynamicTextVideoFrameBlock);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\time-clock-video-frame\\index.jsx";



var TimeClockVideoFrameBlock = function TimeClockVideoFrameBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["_14" /* TimeComponent */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

TimeClockVideoFrameBlock.displayName = "TimeClockVideoFrameBlock";
TimeClockVideoFrameBlock.displayName = "TimeClockVideoFrameBlock";
/* harmony default export */ __webpack_exports__["a"] = (TimeClockVideoFrameBlock);

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\global-nav-link\\index.jsx";





/**
 * Navigation Link Component.
 * @todo  Dev mode complains that `active` and `subNav` are unknown props
* @param {String} label - Navigation Label
* @param {String} href - Navigation Url
* @returns {ReactElement} React Component
*/
var GlobalNavLink = function GlobalNavLink(_ref) {
  var subNav = _ref.subNav,
      gtm = _ref.gtm,
      active = _ref.active,
      onClick = _ref.onClick,
      type = _ref.type,
      href = _ref.href,
      label = _ref.label,
      children = _ref.children,
      chevron = _ref.chevron;

  var setButtonStyles = function setButtonStyles() {
    var base = [];
    var style = subNav ? subNavStyles : styles;
    base.push(styles.buttonBase);
    base.push(subNav ? subNavStyles.button : styles.button);
    base.push(active ? style.buttonActive : { borderBottomColor: "transparent" });
    base.push({
      ":focus": style.buttonFocus,
      ":hover": style.buttonFocus
    });
    return base;
  };
  var handleInteraction = function handleInteraction(event) {
    if (event.type === "keydown" && event.key !== "Enter") return;
    if (gtm && gtm.category) {
      // If not, use CMS gtm event
      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
        pageCategory: gtm.category,
        pageAction: gtm.action
      });
    }
    if (onClick) onClick(event);
  };
  var Tag = type || href ? "a" : "span";
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    {
      "data-test": "nav-link",
      style: [setButtonStyles()],
      tabIndex: "0",
      href: href,
      onKeyDown: handleInteraction,
      onClick: handleInteraction, __source: {
        fileName: _jsxFileName,
        lineNumber: 41
      }
    },
    children,
    label,
    chevron && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["i" /* ChevronIcon */], { style: {
        width: "10px",
        height: "10px",
        margin: "5px",
        color: active + " ? '#ffffff' : '#999999'",
        transformOrigin: "50% 50%",
        transform: "rotate(" + (active ? "0deg" : "-180deg") + ")",
        transitionDuration: "0.4s"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 51
      }
    })
  );
};

GlobalNavLink.displayName = "GlobalNavLink";
GlobalNavLink.displayName = "GlobalNavLink";
GlobalNavLink.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  chevron: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  subNav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])()(GlobalNavLink));

var styles = {
  buttonBase: {
    textDecoration: "none",
    textTransform: "uppercase",
    borderBottomColor: "transparent",
    display: "flex",
    cursor: "pointer",
    transition: ".25s",
    userSelect: "none",
    padding: ".5em 0",
    alignItems: "center",
    letterSpacing: ".2em",
    fontWeight: 600,
    fontSize: "80%"
  },
  button: {
    color: "#999999"
  },
  buttonActive: {
    color: "white",
    borderBottomColor: "#910A2D"
  },
  buttonFocus: {
    outline: 0
  }
};

var subNavStyles = {
  base: {
    display: "block",
    margin: "auto",
    flex: "1 1 100%"
  },
  button: {
    color: "#808080",
    margin: ".5em 2.5em",
    "@media (min-width: 1200px)": {
      fontSize: "1.8vw",
      padding: ".25em 0"
    },
    "@media (min-width: 768px) and (max-width: 1200px)": {
      fontSize: "2.7vw",
      padding: ".25em 0"
    }
  },
  buttonActive: {
    color: "#101010"
  },
  buttonFocus: {
    color: "#101010",
    outline: 0
  }
};

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\heading-section\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var HeadingSectionBlock = function HeadingSectionBlock(_ref) {
  var backgroundColor = _ref.backgroundColor,
      props = _objectWithoutProperties(_ref, ["backgroundColor"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["r" /* ColumnGroup */],
    _extends({ backgroundColor: backgroundColor }, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
      {
        textAlign: "center",
        textAlignMobile: "center", __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["s" /* HeadingBlock */], _extends({}, props, { white: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      }))
    )
  );
};

HeadingSectionBlock.displayName = "HeadingSectionBlock";
HeadingSectionBlock.displayName = "HeadingSectionBlock";
HeadingSectionBlock.propTypes = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (HeadingSectionBlock);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\account-password\\index.jsx";




var MyMazdaAccountPassword = function MyMazdaAccountPassword(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_containers__["I" /* MyMazdaWrapper */],
    { breadcrumb: ["MyMazda", "Account created"], __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["w" /* MyMazdaPassword */], _extends({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    }))
  );
};

MyMazdaAccountPassword.displayName = "MyMazdaAccountPassword";
MyMazdaAccountPassword.displayName = "MyMazdaAccountPassword";
/* harmony default export */ __webpack_exports__["a"] = (MyMazdaAccountPassword);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Button_Button_less__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Button_Button_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Button_Button_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Typography_Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\recall-notification\\index.jsx";











var MyMazdaRecallNotification = function MyMazdaRecallNotification(props) {
  var _classnames, _classnames2;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.wrapper(props.compact), __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { marginRight: props.compact ? "0" : "16px" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { display: "flex", flexDirection: props.compact ? "column" : "row", alignItems: props.compact ? "center" : "flex-start" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 15
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["d" /* AlertIcon */], { style: styles.icon(props.compact), __source: {
            fileName: _jsxFileName,
            lineNumber: 16
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["B" /* H4 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 17
            }
          },
          "Urgent recall(s) on your ",
          props.namePlate,
          " [",
          props.rego,
          "]"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["_1" /* P */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 22
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],
            {
              to: props.recallDetailPageUrl,
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Typography_Typography_less___default.a.blackColor] = true, _classnames)), __source: {
                fileName: _jsxFileName,
                lineNumber: 23
              }
            },
            "View recall details"
          ),
          " or request a service with your Service Dealer immediately."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["l" /* Caption */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 32
            }
          },
          props.timestamp
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          flex: "1 1 auto",
          alignSelf: "center",
          textAlign: props.compact ? "center" : "right"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],
        { to: props.requestServicePageUrl, style: { textDecoration: "none" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 41
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            className: "Button " + __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Button_Button_less___default.a.Button] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Button_Button_less___default.a.ButtonFullWidth] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Button_Button_less___default.a.ButtonRed] = true, _classnames2)),
            onClick: function onClick() {
              Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "MyMazda - Dashboard",
                pageAction: "\"RECALL BLOCK\" - clicked \"" + props.buttonLinkText.toUpperCase() + "\""
              });
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 42
            }
          },
          props.buttonLinkText
        )
      )
    )
  );
};

MyMazdaRecallNotification.displayName = "MyMazdaRecallNotification";
MyMazdaRecallNotification.displayName = "MyMazdaRecallNotification";
var styles = {
  wrapper: function wrapper(compact) {
    return {
      display: "flex",
      justifyContent: "space-between",
      flexWrap: compact ? "wrap" : "nowrap",
      margin: "5em 1em 0",
      padding: "2em",
      border: "1px solid " + __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY,
      background: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].WHITE,
      textAlign: compact ? "center" : "left"
    };
  },
  heading: function heading(compact) {
    return {
      color: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].BLACK,
      position: "relative",
      paddingLeft: compact ? "0" : "2em",
      textAlign: compact ? "center" : "left"
    };
  },
  icon: function icon(compact) {
    return {
      width: compact ? "20px" : "22px",
      height: compact ? "28px" : "28px",
      margin: compact ? "0 0 16px 0" : "0 16px 0 0"
    };
  }
};

MyMazdaRecallNotification.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  namePlate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rego: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  requestServicePageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonLinkText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  recallDetailPageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timestamp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["b" /* DetectCompact */])())(MyMazdaRecallNotification));

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\reset-password\\index.jsx";




var MyMazdaReset = function MyMazdaReset(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_containers__["I" /* MyMazdaWrapper */],
    { breadcrumb: ["MyMazda", "Reset Password"], __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["z" /* MyMazdaResetPassword */], _extends({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    }))
  );
};

MyMazdaReset.displayName = "MyMazdaReset";
MyMazdaReset.displayName = "MyMazdaReset";
/* harmony default export */ __webpack_exports__["a"] = (MyMazdaReset);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_portal__ = __webpack_require__(90);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\triggered-overlay\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var TriggeredOverlay = function (_Component) {
  _inherits(TriggeredOverlay, _Component);

  function TriggeredOverlay() {
    _classCallCheck(this, TriggeredOverlay);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      overlayActive: false
    };
    return _this;
  }

  TriggeredOverlay.prototype.activateOverlay = function activateOverlay(active) {
    this.setState({ overlayActive: active });
  };

  TriggeredOverlay.prototype.render = function render() {
    var _this2 = this;

    var trigger = this.props.trigger;
    var overlayActive = this.state.overlayActive;

    var triggerProps = { components: [trigger] };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: {
          display: "flex",
          justifyContent: "center"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 23
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_3_containers_utilities__["a" /* childParser */])(triggerProps, function () {
        return {
          onClick: function onClick(event) {
            if (event) event.preventDefault();
            _this2.activateOverlay(true);
          }
        };
      }),
      overlayActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_portal__["a" /* Portal */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 34
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_containers__["L" /* Overlay */],
          { close: function close() {
              return _this2.activateOverlay(false);
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 35
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_3_containers_utilities__["a" /* childParser */])(this.props, function () {
            return { overlay: true };
          })
        )
      )
    );
  };

  return TriggeredOverlay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TriggeredOverlay.displayName = "TriggeredOverlay";

TriggeredOverlay.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(TriggeredOverlay));

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _trackHelper = __webpack_require__(584);

var _objectAssign = __webpack_require__(53);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var helpers = {
  initialize: function initialize(props) {
    var slickList = _reactDom2.default.findDOMNode(this.list);

    var slideCount = _react2.default.Children.count(props.children);
    var listWidth = this.getWidth(slickList);
    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
    var slideWidth;

    if (!props.vertical) {
      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
    } else {
      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
    }

    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * props.slidesToShow;

    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;

    this.setState({
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth,
      currentSlide: currentSlide,
      slideHeight: slideHeight,
      listHeight: listHeight
    }, function () {

      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, props, this.state));
      // getCSS function needs previously set state
      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));

      this.setState({ trackStyle: trackStyle });

      this.autoPlay(); // once we're set up, trigger the initial autoplay.
    });
  },
  update: function update(props) {
    var slickList = _reactDom2.default.findDOMNode(this.list);
    // This method has mostly same code as initialize method.
    // Refactor it
    var slideCount = _react2.default.Children.count(props.children);
    var listWidth = this.getWidth(slickList);
    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
    var slideWidth;

    if (!props.vertical) {
      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
    } else {
      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
    }

    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * props.slidesToShow;

    // pause slider if autoplay is set to false
    if (!props.autoplay) {
      this.pause();
    } else {
      this.autoPlay();
    }

    this.setState({
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth,
      slideHeight: slideHeight,
      listHeight: listHeight
    }, function () {

      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, props, this.state));
      // getCSS function needs previously set state
      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));

      this.setState({ trackStyle: trackStyle });
    });
  },
  getWidth: function getWidth(elem) {
    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
  },
  getHeight: function getHeight(elem) {
    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
  },

  adaptHeight: function adaptHeight() {
    if (this.props.adaptiveHeight) {
      var selector = '[data-index="' + this.state.currentSlide + '"]';
      if (this.list) {
        var slickList = _reactDom2.default.findDOMNode(this.list);
        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
      }
    }
  },
  canGoNext: function canGoNext(opts) {
    var canGo = true;
    if (!opts.infinite) {
      if (opts.centerMode) {
        // check if current slide is last slide
        if (opts.currentSlide >= opts.slideCount - 1) {
          canGo = false;
        }
      } else {
        // check if all slides are shown in slider
        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
          canGo = false;
        }
      }
    }
    return canGo;
  },
  slideHandler: function slideHandler(index) {
    var _this = this;

    // Functionality of animateSlide and postSlide is merged into this function
    // console.log('slideHandler', index);
    var targetSlide, currentSlide;
    var targetLeft, currentLeft;
    var callback;

    if (this.props.waitForAnimate && this.state.animating) {
      return;
    }

    if (this.props.fade) {
      currentSlide = this.state.currentSlide;

      // Don't change slide if it's not infite and current slide is the first or last slide.
      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
        return;
      }

      //  Shifting targetSlide back into the range
      if (index < 0) {
        targetSlide = index + this.state.slideCount;
      } else if (index >= this.state.slideCount) {
        targetSlide = index - this.state.slideCount;
      } else {
        targetSlide = index;
      }

      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
        this.setState({
          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
        });
      }

      callback = function callback() {
        _this.setState({
          animating: false
        });
        if (_this.props.afterChange) {
          _this.props.afterChange(targetSlide);
        }
        delete _this.animationEndCallback;
      };

      this.setState({
        animating: true,
        currentSlide: targetSlide
      }, function () {
        this.animationEndCallback = setTimeout(callback, this.props.speed);
      });

      if (this.props.beforeChange) {
        this.props.beforeChange(this.state.currentSlide, targetSlide);
      }

      this.autoPlay();
      return;
    }

    targetSlide = index;
    if (targetSlide < 0) {
      if (this.props.infinite === false) {
        currentSlide = 0;
      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
      } else {
        currentSlide = this.state.slideCount + targetSlide;
      }
    } else if (targetSlide >= this.state.slideCount) {
      if (this.props.infinite === false) {
        currentSlide = this.state.slideCount - this.props.slidesToShow;
      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
        currentSlide = 0;
      } else {
        currentSlide = targetSlide - this.state.slideCount;
      }
    } else {
      currentSlide = targetSlide;
    }

    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: targetSlide,
      trackRef: this.track
    }, this.props, this.state));

    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: currentSlide,
      trackRef: this.track
    }, this.props, this.state));

    if (this.props.infinite === false) {
      targetLeft = currentLeft;
    }

    if (this.props.beforeChange) {
      this.props.beforeChange(this.state.currentSlide, currentSlide);
    }

    if (this.props.lazyLoad) {
      var loaded = true;
      var slidesToLoad = [];
      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
        if (!loaded) {
          slidesToLoad.push(i);
        }
      }
      if (!loaded) {
        this.setState({
          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
        });
      }
    }

    // Slide Transition happens here.
    // animated transition happens to target Slide and
    // non - animated transition happens to current Slide
    // If CSS transitions are false, directly go the current slide.

    if (this.props.useCSS === false) {

      this.setState({
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
      }, function () {
        if (this.props.afterChange) {
          this.props.afterChange(currentSlide);
        }
      });
    } else {

      var nextStateChanges = {
        animating: false,
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
        swipeLeft: null
      };

      callback = function callback() {
        _this.setState(nextStateChanges);
        if (_this.props.afterChange) {
          _this.props.afterChange(currentSlide);
        }
        delete _this.animationEndCallback;
      };

      this.setState({
        animating: true,
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
      }, function () {
        this.animationEndCallback = setTimeout(callback, this.props.speed);
      });
    }

    this.autoPlay();
  },
  swipeDirection: function swipeDirection(touchObject) {
    var xDist, yDist, r, swipeAngle;

    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);

    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
      return this.props.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return this.props.rtl === false ? 'right' : 'left';
    }
    if (this.props.verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 'down';
      } else {
        return 'up';
      }
    }

    return 'vertical';
  },
  play: function play() {
    var nextIndex;

    if (!this.state.mounted) {
      return false;
    }

    if (this.props.rtl) {
      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
    } else {
      if (this.canGoNext(_extends({}, this.props, this.state))) {
        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
      } else {
        return false;
      }
    }

    this.slideHandler(nextIndex);
  },
  autoPlay: function autoPlay() {
    if (this.state.autoPlayTimer) {
      clearTimeout(this.state.autoPlayTimer);
    }
    if (this.props.autoplay) {
      this.setState({
        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
      });
    }
  },
  pause: function pause() {
    if (this.state.autoPlayTimer) {
      clearTimeout(this.state.autoPlayTimer);
      this.setState({
        autoPlayTimer: null
      });
    }
  }
};

exports.default = helpers;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(80);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(275);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 275 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 276 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(278);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 278 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(280)('keys');
var uid = __webpack_require__(191);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(61);
var global = __webpack_require__(72);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(190) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 281 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 282 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(276);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1363)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(285)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(190);
var $export = __webpack_require__(78);
var redefine = __webpack_require__(601);
var hide = __webpack_require__(91);
var Iterators = __webpack_require__(143);
var $iterCreate = __webpack_require__(1364);
var setToStringTag = __webpack_require__(194);
var getPrototypeOf = __webpack_require__(1367);
var ITERATOR = __webpack_require__(62)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1368);
var global = __webpack_require__(72);
var hide = __webpack_require__(91);
var Iterators = __webpack_require__(143);
var TO_STRING_TAG = __webpack_require__(62)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(62);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(191)('meta');
var isObject = __webpack_require__(80);
var has = __webpack_require__(106);
var setDesc = __webpack_require__(79).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(124)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(72);
var core = __webpack_require__(61);
var LIBRARY = __webpack_require__(190);
var wksExt = __webpack_require__(287);
var defineProperty = __webpack_require__(79).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
 *
 * The decorator may be used on classes or methods
 * ```
 * @autobind
 * class FullBound {}
 *
 * class PartBound {
 *   @autobind
 *   method () {}
 * }
 * ```
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = autobind;

function autobind() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1) {
    return boundClass.apply(undefined, args);
  } else {
    return boundMethod.apply(undefined, args);
  }
}

/**
 * Use boundMethod to bind all methods on the target.prototype
 */
function boundClass(target) {
  // (Using reflect to get all keys including symbols)
  var keys = undefined;
  // Use Reflect if exists
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    keys = Reflect.ownKeys(target.prototype);
  } else {
    keys = Object.getOwnPropertyNames(target.prototype);
    // use symbols if support is provided
    if (typeof Object.getOwnPropertySymbols === 'function') {
      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
    }
  }

  keys.forEach(function (key) {
    // Ignore special case target method
    if (key === 'constructor') {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);

    // Only methods need binding
    if (typeof descriptor.value === 'function') {
      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
    }
  });
  return target;
}

/**
 * Return a descriptor removing the value and returning a getter
 * The getter will return a .bind version of the function
 * and memoize the result against a symbol on the instance
 */
function boundMethod(target, key, descriptor) {
  var fn = descriptor.value;

  if (typeof fn !== 'function') {
    throw new Error('@autobind decorator can only be applied to methods not: ' + typeof fn);
  }

  // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.
  var definingProperty = false;

  return {
    configurable: true,
    get: function get() {
      if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
        return fn;
      }

      var boundFn = fn.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        value: boundFn,
        configurable: true,
        writable: true
      });
      definingProperty = false;
      return boundFn;
    }
  };
}
module.exports = exports['default'];


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Highlighter = __webpack_require__(2);
	
	var _Highlighter2 = _interopRequireDefault(_Highlighter);

	exports['default'] = _Highlighter2['default'];
	module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Highlighter;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _highlightWordsCore = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(14);
	
	var _react2 = _interopRequireDefault(_react);
	
	Highlighter.propTypes = {
	  activeClassName: _propTypes2['default'].string,
	  activeIndex: _propTypes2['default'].number,
	  activeStyle: _propTypes2['default'].object,
	  autoEscape: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  highlightClassName: _propTypes2['default'].string,
	  highlightStyle: _propTypes2['default'].object,
	  highlightTag: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func, _propTypes2['default'].string]),
	  sanitize: _propTypes2['default'].func,
	  searchWords: _propTypes2['default'].arrayOf(_propTypes2['default'].string).isRequired,
	  textToHighlight: _propTypes2['default'].string.isRequired,
	  unhighlightClassName: _propTypes2['default'].string,
	  unhighlightStyle: _propTypes2['default'].object
	};
	
	/**
	 * Highlights all occurrences of search terms (searchText) within a string (textToHighlight).
	 * This function returns an array of strings and <span>s (wrapping highlighted words).
	 */
	
	function Highlighter(_ref) {
	  var _ref$activeClassName = _ref.activeClassName;
	  var activeClassName = _ref$activeClassName === undefined ? '' : _ref$activeClassName;
	  var _ref$activeIndex = _ref.activeIndex;
	  var activeIndex = _ref$activeIndex === undefined ? -1 : _ref$activeIndex;
	  var activeStyle = _ref.activeStyle;
	  var autoEscape = _ref.autoEscape;
	  var _ref$caseSensitive = _ref.caseSensitive;
	  var caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive;
	  var className = _ref.className;
	  var _ref$highlightClassName = _ref.highlightClassName;
	  var highlightClassName = _ref$highlightClassName === undefined ? '' : _ref$highlightClassName;
	  var _ref$highlightStyle = _ref.highlightStyle;
	  var highlightStyle = _ref$highlightStyle === undefined ? {} : _ref$highlightStyle;
	  var _ref$highlightTag = _ref.highlightTag;
	  var highlightTag = _ref$highlightTag === undefined ? 'mark' : _ref$highlightTag;
	  var sanitize = _ref.sanitize;
	  var searchWords = _ref.searchWords;
	  var textToHighlight = _ref.textToHighlight;
	  var _ref$unhighlightClassName = _ref.unhighlightClassName;
	  var unhighlightClassName = _ref$unhighlightClassName === undefined ? '' : _ref$unhighlightClassName;
	  var unhighlightStyle = _ref.unhighlightStyle;
	
	  var chunks = (0, _highlightWordsCore.findAll)({
	    autoEscape: autoEscape,
	    caseSensitive: caseSensitive,
	    sanitize: sanitize,
	    searchWords: searchWords,
	    textToHighlight: textToHighlight
	  });
	  var HighlightTag = highlightTag;
	  var highlightCount = -1;
	  var highlightClassNames = '';
	  var highlightStyles = undefined;
	
	  return _react2['default'].createElement(
	    'span',
	    { className: className },
	    chunks.map(function (chunk, index) {
	      var text = textToHighlight.substr(chunk.start, chunk.end - chunk.start);
	
	      if (chunk.highlight) {
	        highlightCount++;
	
	        var isActive = highlightCount === +activeIndex;
	
	        highlightClassNames = highlightClassName + ' ' + (isActive ? activeClassName : '');
	        highlightStyles = isActive === true && activeStyle != null ? Object.assign({}, highlightStyle, activeStyle) : highlightStyle;
	
	        return _react2['default'].createElement(
	          HighlightTag,
	          {
	            className: highlightClassNames,
	            key: index,
	            style: highlightStyles
	          },
	          text
	        );
	      } else {
	        return _react2['default'].createElement(
	          'span',
	          {
	            className: unhighlightClassName,
	            key: index,
	            style: unhighlightStyle
	          },
	          text
	        );
	      }
	    })
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _utils = __webpack_require__(2);
		
		Object.defineProperty(exports, 'combineChunks', {
		  enumerable: true,
		  get: function get() {
		    return _utils.combineChunks;
		  }
		});
		Object.defineProperty(exports, 'fillInChunks', {
		  enumerable: true,
		  get: function get() {
		    return _utils.fillInChunks;
		  }
		});
		Object.defineProperty(exports, 'findAll', {
		  enumerable: true,
		  get: function get() {
		    return _utils.findAll;
		  }
		});
		Object.defineProperty(exports, 'findChunks', {
		  enumerable: true,
		  get: function get() {
		    return _utils.findChunks;
		  }
		});
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		/**
		 * Creates an array of chunk objects representing both higlightable and non highlightable pieces of text that match each search word.
		 * @return Array of "chunks" (where a Chunk is { start:number, end:number, highlight:boolean })
		 */
		var findAll = exports.findAll = function findAll(_ref) {
		  var autoEscape = _ref.autoEscape,
		      _ref$caseSensitive = _ref.caseSensitive,
		      caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive,
		      sanitize = _ref.sanitize,
		      searchWords = _ref.searchWords,
		      textToHighlight = _ref.textToHighlight;
		  return fillInChunks({
		    chunksToHighlight: combineChunks({
		      chunks: findChunks({
		        autoEscape: autoEscape,
		        caseSensitive: caseSensitive,
		        sanitize: sanitize,
		        searchWords: searchWords,
		        textToHighlight: textToHighlight
		      })
		    }),
		    totalLength: textToHighlight.length
		  });
		};
		
		/**
		 * Takes an array of {start:number, end:number} objects and combines chunks that overlap into single chunks.
		 * @return {start:number, end:number}[]
		 */
		var combineChunks = exports.combineChunks = function combineChunks(_ref2) {
		  var chunks = _ref2.chunks;
		
		  chunks = chunks.sort(function (first, second) {
		    return first.start - second.start;
		  }).reduce(function (processedChunks, nextChunk) {
		    // First chunk just goes straight in the array...
		    if (processedChunks.length === 0) {
		      return [nextChunk];
		    } else {
		      // ... subsequent chunks get checked to see if they overlap...
		      var prevChunk = processedChunks.pop();
		      if (nextChunk.start <= prevChunk.end) {
		        // It may be the case that prevChunk completely surrounds nextChunk, so take the
		        // largest of the end indeces.
		        var endIndex = Math.max(prevChunk.end, nextChunk.end);
		        processedChunks.push({ start: prevChunk.start, end: endIndex });
		      } else {
		        processedChunks.push(prevChunk, nextChunk);
		      }
		      return processedChunks;
		    }
		  }, []);
		
		  return chunks;
		};
		
		/**
		 * Examine text for any matches.
		 * If we find matches, add them to the returned array as a "chunk" object ({start:number, end:number}).
		 * @return {start:number, end:number}[]
		 */
		var findChunks = exports.findChunks = function findChunks(_ref3) {
		  var autoEscape = _ref3.autoEscape,
		      caseSensitive = _ref3.caseSensitive,
		      _ref3$sanitize = _ref3.sanitize,
		      sanitize = _ref3$sanitize === undefined ? identity : _ref3$sanitize,
		      searchWords = _ref3.searchWords,
		      textToHighlight = _ref3.textToHighlight;
		
		  textToHighlight = sanitize(textToHighlight);
		
		  return searchWords.filter(function (searchWord) {
		    return searchWord;
		  }) // Remove empty words
		  .reduce(function (chunks, searchWord) {
		    searchWord = sanitize(searchWord);
		
		    if (autoEscape) {
		      searchWord = escapeRegExpFn(searchWord);
		    }
		
		    var regex = new RegExp(searchWord, caseSensitive ? 'g' : 'gi');
		
		    var match = void 0;
		    while (match = regex.exec(textToHighlight)) {
		      chunks.push({
		        start: match.index,
		        end: regex.lastIndex
		      });
		    }
		
		    return chunks;
		  }, []);
		};
		
		/**
		 * Given a set of chunks to highlight, create an additional set of chunks
		 * to represent the bits of text between the highlighted text.
		 * @param chunksToHighlight {start:number, end:number}[]
		 * @param totalLength number
		 * @return {start:number, end:number, highlight:boolean}[]
		 */
		var fillInChunks = exports.fillInChunks = function fillInChunks(_ref4) {
		  var chunksToHighlight = _ref4.chunksToHighlight,
		      totalLength = _ref4.totalLength;
		
		  var allChunks = [];
		  var append = function append(start, end, highlight) {
		    if (end - start > 0) {
		      allChunks.push({
		        start: start,
		        end: end,
		        highlight: highlight
		      });
		    }
		  };
		
		  if (chunksToHighlight.length === 0) {
		    append(0, totalLength, false);
		  } else {
		    var lastIndex = 0;
		    chunksToHighlight.forEach(function (chunk) {
		      append(lastIndex, chunk.start, false);
		      append(chunk.start, chunk.end, true);
		      lastIndex = chunk.end;
		    });
		    append(lastIndex, totalLength, false);
		  }
		  return allChunks;
		};
		
		function identity(value) {
		  return value;
		}
		
		function escapeRegExpFn(str) {
		  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
		}
	
	/***/ })
	/******/ ]);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(6)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(13)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	var invariant = __webpack_require__(8);
	var warning = __webpack_require__(9);
	var assign = __webpack_require__(10);
	
	var ReactPropTypesSecret = __webpack_require__(11);
	var checkPropTypes = __webpack_require__(12);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(8);
	  var warning = __webpack_require__(9);
	  var ReactPropTypesSecret = __webpack_require__(11);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	var invariant = __webpack_require__(8);
	var ReactPropTypesSecret = __webpack_require__(11);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__(0);

/***/ })
/******/ ]);
//# sourceMappingURL=main.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dealerInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__koala__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_cache__ = __webpack_require__(567);
var fetchFromApi = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dealersAPI, options) {
    var dealers;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_0__koala__["a" /* fetchKoalaData */])(dealersAPI, options);

          case 2:
            dealers = _context2.sent;
            return _context2.abrupt('return', { data: dealers });

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchFromApi(_x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var dealersAPI = '/api/dealers';

var dealerInfo = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
    var dealerCode = _ref2.dealerCode,
        postcode = _ref2.postcode,
        _ref2$dealerTypes = _ref2.dealerTypes,
        dealerTypes = _ref2$dealerTypes === undefined ? ['sales'] : _ref2$dealerTypes;

    var sortedDealerTypes, apiOptions, dealers, cacheKey, _ref3, response;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log('dealer search');
            console.log('dealer code:' + dealerCode);
            console.log('dealer post code:' + postcode);
            sortedDealerTypes = dealerTypes.sort();
            apiOptions = {
              DealerCode: dealerCode || null,
              postcode: postcode || null,
              DealerType: sortedDealerTypes.join(',')
            };
            dealers = void 0;
            _context.prev = 6;

            if (!(dealerCode || postcode)) {
              _context.next = 18;
              break;
            }

            cacheKey = 'localdealer_' + (dealerCode || postcode) + '_' + (sortedDealerTypes.join('_') || 'none');
            _context.next = 11;
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_cache__["a" /* cacheApiResponse */])(cacheKey, function () {
              return fetchFromApi(dealersAPI, apiOptions);
            });

          case 11:
            _ref3 = _context.sent;
            response = _ref3.response;


            dealers = response;
            console.log('dealer search response');
            console.log(dealers);
            _context.next = 19;
            break;

          case 18:
            throw new Error('Cannot complete dealer search without dealerCode or postcode');

          case 19:
            return _context.abrupt('return', { response: dealers });

          case 22:
            _context.prev = 22;
            _context.t0 = _context['catch'](6);
            return _context.abrupt('return', { error: _context.t0 });

          case 25:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[6, 22]]);
  }));

  return function dealerInfo(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\navigation\\animated-dropdown.jsx";




var AnimatedDropdown = function AnimatedDropdown(_ref) {
  var open = _ref.open,
      children = _ref.children;
  return open ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.sidebarWrapper, __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.transform, __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      },
      children
    )
  ) : null;
};

var foldIn = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["b" /* keyframes */])({
  "0%": {
    transform: "rotateX(30deg)"
  },
  "40%": {
    transform: "rotateX(-5deg)" // overshoot target to create bounce effect
  },
  "75%": {
    transform: "rotateX(2.5deg)"
  },
  "100%": {
    transform: "rotateX(0deg)"
  }
});

AnimatedDropdown.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(AnimatedDropdown));

var styles = {
  sidebarWrapper: {
    pointerEvents: "all",
    perspective: "5000px",
    width: "100%"
  },
  transform: {
    transformOrigin: "top",
    // animation: 'x .666s',
    // animationName: foldIn,
    transform: "rotateX(0deg)"
  }
};

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrimaryNavigationItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SecondaryNavigationItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__settings__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents_Typography_Typography_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _link,
    _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\navigation\\navigation-item.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var RadiumLink = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */]);

var onClickAnimation = {
  base: {
    backgroundPosition: "-100% 0",
    backgroundImage: "linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0))",
    backgroundSize: "50% 100%",
    backgroundRepeat: "no-repeat",
    overflow: "hidden"
  },
  animation: {
    animation: "x .666s ease-in reverse forwards",
    animationName: Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["j" /* keyframes */])({
      from: {
        backgroundPosition: "200% 0"
      },
      to: {
        backgroundPosition: "-100% 0"
      }
    })
  }
};

var navigationItemStyle = {
  baseItem: {
    height: "2.5rem",
    padding: "0 1.75em",
    display: "flex",
    alignItems: "center"
  },
  activeLink: {
    color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].WHITE
  },
  link: (_link = {
    fontSize: "13px",
    color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARK,
    display: "flex",
    transition: "color .2s",
    textDecoration: "none",
    margin: "1rem 0",
    ":focus": {
      outline: 0
    }
  }, _link[__WEBPACK_IMPORTED_MODULE_7__settings__["b" /* breakpointTablet */]] = {
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].WHITE
    }
  }, _link),
  line: {
    width: "3px",
    background: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].WHITE,
    transform: "translateX(-100%)",
    opacity: 0
  },
  activeLine: {
    opacity: 1,
    transform: "translateX(0%)"
  }
};

var StyledLink = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(function (_ref) {
  var fullReload = _ref.fullReload,
      href = _ref.href,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["fullReload", "href", "onClick"]);

  return fullReload ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, _extends({}, props, { href: href }), { onClick: function onClick() {
      Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_gtmHandler__["a" /* default */])({
        pageCategory: "MyMazda - Home",
        pageAction: "Account - clicked \"LOG OUT\""
      });
    }, __source: {
      fileName: _jsxFileName,
      lineNumber: 78
    }
  })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RadiumLink, _extends({ to: href, onClick: onClick }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85
    }
  }));
});

var PrimaryNavigationItem = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(function (_ref2) {
  var active = _ref2.active,
      imageUrl = _ref2.imageUrl,
      label = _ref2.label,
      description = _ref2.description,
      href = _ref2.href,
      fullReload = _ref2.fullReload,
      _onClick = _ref2.onClick,
      children = _ref2.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_components__["c" /* AnimationPlayer */],
    {
      baseAnimationStyle: onClickAnimation.base, __source: {
        fileName: _jsxFileName,
        lineNumber: 99
      }
    },
    function (_ref3) {
      var _classnames;

      var play = _ref3.play;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledLink,
        {
          fullReload: fullReload,
          style: _extends({}, primaryNavigationItemStyle.link, active ? primaryNavigationItemStyle.activeLink : {}),
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_10_AtomicComponents_Typography_Typography_less___default.a.withoutStyle] = true, _classnames)),
          onClick: function onClick() {
            play();
            if (_onClick) _onClick();
          },
          href: href, __source: {
            fileName: _jsxFileName,
            lineNumber: 102
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: primaryNavigationItemStyle.line, __source: {
            fileName: _jsxFileName,
            lineNumber: 116
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: primaryNavigationItemStyle.base, __source: {
              fileName: _jsxFileName,
              lineNumber: 117
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { flex: "1 1 100%" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 118
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: primaryNavigationItemStyle.label, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 119
                }
              },
              label
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: primaryNavigationItemStyle.description, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 122
                }
              },
              description
            )
          ),
          imageUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: imageUrl + "?height=80", alt: label, style: primaryNavigationItemStyle.img, __source: {
              fileName: _jsxFileName,
              lineNumber: 126
            }
          }),
          children
        )
      );
    }
  );
});

var primaryNavigationItemStyle = {
  base: _extends({}, navigationItemStyle.baseItem, {
    // color: COLOR_PALETTE.GRAY_DARK,
    flex: "1 1 100%",
    justifyContent: "space-between"
  }),
  activeLink: navigationItemStyle.activeLink,
  line: navigationItemStyle.line,
  activeLine: navigationItemStyle.activeLine,
  link: navigationItemStyle.link,
  img: {
    display: "block",
    height: "100%",
    width: "auto"
  },
  label: _extends({}, __WEBPACK_IMPORTED_MODULE_3_constants_general_style__["b" /* BASE_HEADING */], {
    margin: "0.2em 0",
    color: "inherit"
  }),
  description: _extends({}, __WEBPACK_IMPORTED_MODULE_3_constants_general_style__["a" /* BASE_COPY */], {
    margin: "0.2em 0",
    color: "inherit",
    fontSize: "90%"
  })
};

PrimaryNavigationItem.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var SecondaryNavigationItem = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(function (_ref4) {
  var active = _ref4.active,
      label = _ref4.label,
      href = _ref4.href,
      fullReload = _ref4.fullReload,
      _onClick2 = _ref4.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_components__["c" /* AnimationPlayer */],
    {
      baseAnimationStyle: onClickAnimation.base, __source: {
        fileName: _jsxFileName,
        lineNumber: 177
      }
    },
    function (_ref5) {
      var _classnames2;

      var play = _ref5.play;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledLink,
        {
          fullReload: fullReload,
          style: _extends({}, secondaryNavigationItemStyle.link, active ? secondaryNavigationItemStyle.activeLink : {}),
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_10_AtomicComponents_Typography_Typography_less___default.a.withoutStyle] = true, _classnames2)),
          onClick: function onClick() {
            play();
            if (_onClick2) _onClick2();
          },
          to: href, __source: {
            fileName: _jsxFileName,
            lineNumber: 180
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: [secondaryNavigationItemStyle.line, active && secondaryNavigationItemStyle.activeLine], __source: {
            fileName: _jsxFileName,
            lineNumber: 194
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: [secondaryNavigationItemStyle.base, active && secondaryNavigationItemStyle.activeLink], __source: {
              fileName: _jsxFileName,
              lineNumber: 198
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: secondaryNavigationItemStyle.label, __source: {
                fileName: _jsxFileName,
                lineNumber: 202
              }
            },
            label
          )
        )
      );
    }
  );
});

SecondaryNavigationItem.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var secondaryNavigationItemStyle = {
  link: _extends({}, navigationItemStyle.link, {
    margin: "0.5rem 0"
  }),
  base: _extends({}, navigationItemStyle.baseItem, {
    color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARK
  }),
  activeLink: navigationItemStyle.activeLink,
  line: navigationItemStyle.line,
  activeLine: navigationItemStyle.activeLine,
  label: _extends({}, __WEBPACK_IMPORTED_MODULE_3_constants_general_style__["a" /* BASE_COPY */], {
    margin: "0.2em 0",
    color: "inherit",
    fontWeight: "600",
    letterSpacing: "0.08em"
  })
};

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_0__timer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timer", function() { return __WEBPACK_IMPORTED_MODULE_0__timer__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timerFlush", function() { return __WEBPACK_IMPORTED_MODULE_0__timer__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeout__ = __webpack_require__(1612);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return __WEBPACK_IMPORTED_MODULE_1__timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__interval__ = __webpack_require__(1613);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interval", function() { return __WEBPACK_IMPORTED_MODULE_2__interval__["a"]; });







/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = now;
/* harmony export (immutable) */ __webpack_exports__["a"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = timer;
/* harmony export (immutable) */ __webpack_exports__["d"] = timerFlush;
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(639);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(300);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: function() {
    return this.rgb().hex();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: function() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apis_expose_global__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apis_koala__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_object__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_mymazda__ = __webpack_require__(36);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/** Base form class to handle field interaction & validation  */

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.assignFields = function (newObject) {
      var fields = Object.assign(_this.state.fields, newObject);
      return { fields: fields };
    };

    _this.updateField = function (id, getData) {
      var _this$setField;

      var field = _this.state.fields[id];
      _this.setField((_this$setField = {}, _this$setField[id] = _extends({}, field, getData(field)), _this$setField));
    };

    _this.setField = function (newObject, callback) {
      /**
      * Sets state for single field
      * @param {Object} [newObject] - Object containing new field state
      * @param {Function} [callback] - Callback on state updated
      */
      _this.setState(_extends({}, _this.assignFields(newObject), { error: null, errorMessages: [] }), callback);
    };

    _this.linkState = function (name) {
      var validation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return { isValid: true };
      };

      var validate = function validate(inputValue, _validate, context) {
        var result = validation(inputValue, context || {});
        var attributes = Object(__WEBPACK_IMPORTED_MODULE_3_utils_object__["b" /* get */])("attributes", result) ? result.attributes : {};
        var status = _validate || result.status && result.status.isValid ? Object(__WEBPACK_IMPORTED_MODULE_3_utils_object__["b" /* get */])("status", result) ? result.status : result : {};
        var value = typeof status.modifiedValue !== "undefined" ? status.modifiedValue : inputValue || undefined;
        return { status: status, attributes: attributes, value: value };
      };
      var fields = _this.state.fields;

      if (!fields[name]) {
        var _this$props$prefillFi = _this.props.prefillFields,
            prefillFields = _this$props$prefillFi === undefined ? {} : _this$props$prefillFi;

        var field = validate(false, true);
        if (prefillFields[name]) {
          var _this$setField2;

          field = validate(prefillFields[name], true, { onBlur: true });
          field.edited = true;
          /*
            Hack ALERT!! setting state in render is BAD
            This will set state for defaults then break out of render
          */
          _this.setField((_this$setField2 = {}, _this$setField2[name] = _extends({}, fields[name], field), _this$setField2));
          return null;
        }
        field.status = !field.attributes.required ? field.status : {};
        fields[name] = field;
      }
      var _fields$name = fields[name],
          status = _fields$name.status,
          value = _fields$name.value,
          _fields$name$attribut = _fields$name.attributes,
          attributes = _fields$name$attribut === undefined ? {} : _fields$name$attribut;
      var required = attributes.required,
          maxLength = attributes.maxLength;
      var isValid = status.isValid,
          message = status.message,
          modifiedValue = status.modifiedValue;

      return {
        name: name,
        required: required,
        isValid: isValid,
        message: message,
        id: name,
        maxLength: maxLength,
        ref: function ref(element) {
          _this.fieldRefs[name] = element;
        },
        focus: fields[name].focused,
        value: typeof modifiedValue !== "undefined" ? modifiedValue : value,
        onFocus: function onFocus() {
          var _this$setField3;

          _this.setField((_this$setField3 = {}, _this$setField3[name] = _extends({}, fields[name], validate(fields[name].value, fields[name].dirty, {
            onFocus: true
          }), {
            focused: true
          }), _this$setField3));
          Object.keys(fields).forEach(function (field) {
            if (field !== name && fields[field].focused) {
              var _this$setField4;

              _this.setField((_this$setField4 = {}, _this$setField4[field] = _extends({}, fields[field], {
                focused: false
              }), _this$setField4));
            }
          });
        },
        onBlur: function onBlur() {
          var _this$setField5;

          _this.setField((_this$setField5 = {}, _this$setField5[name] = _extends({}, fields[name], validate(fields[name].value, fields[name].dirty || fields[name].focused !== "undefined", { onBlur: true }), {
            edited: fields[name].focused !== "undefined",
            focused: false
          }), _this$setField5));
        },
        onChange: function onChange(x) {
          var _this$setField6;

          var value = x && x.target ? Object(__WEBPACK_IMPORTED_MODULE_3_utils_object__["b" /* get */])("target.value", x) || "" : x || x === 0 ? x : "";
          _this.setField((_this$setField6 = {}, _this$setField6[name] = _extends({}, fields[name], validate(value, fields[name].edited || !fields[name].focused, {
            onChange: true
          }), {
            edited: fields[name].edited || !fields[name].focused,
            dirty: true
          }), _this$setField6));
        }
      };
    };

    _this.state = {
      fields: {},
      submitting: false,
      error: null,
      errorMessages: [],
      displayThankYou: false
    };
    _this.fieldRefs = {};
    return _this;
  }

  Form.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    Object(__WEBPACK_IMPORTED_MODULE_1_apis_expose_global__["a" /* default */])("getCurrentFormFields", function () {
      return _this2.state.fields;
    });
  };
  /**
   * Links field changes to form state
   * @param {String} [name] - Unique name for field. Used in state.
   * @param {Function} [validation] - A validation function apply to field.
   * @returns {Object} - Props for fields.
   */


  Form.prototype.canSubmit = function canSubmit() {
    /**
     * Checks validity of all fields in state
     * @returns {Boolean} - true if all fields are valid
     */
    var fields = this.state.fields;

    var formIsValid = Object.keys(fields).every(function (key) {
      var field = fields[key];
      if (field.attributes && field.attributes.required) {
        if (!field.value || !field.status.isValid) {
          return false;
        }
      }
      if (field.value && field.status && !field.status.isValid) {
        return false;
      }
      return true;
    });
    return !this.state.submitting && formIsValid;
  };

  Form.prototype.submit = function submit(endpoint, data, mapping, additionalOptions) {
    var _this3 = this;

    var submitFunc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : __WEBPACK_IMPORTED_MODULE_2_apis_koala__["a" /* fetchKoalaData */];

    /**
     * Submits form to endpoint
     * @param {String} [endpoint] - Url for endpoint submission.
     * @param {Object} [data] - Field data to submit.
     * @param {Function} [mapping] - Mapping from field data in state to endpoint body object.
     */
    if (!endpoint || !data || !mapping) return Promise.resolve();

    // Show Warnings or Errors on all required inputs
    if (!this.canSubmit()) {
      Object.keys(this.fieldRefs).map(function (item) {
        if (_this3.fieldRefs[item] && _this3.fieldRefs[item].props && _this3.fieldRefs[item].props.required) {
          _this3.fieldRefs[item].props.onBlur();
        }
      });
      return Promise.resolve();
    }

    var payload = void 0;
    try {
      payload = mapping(data);
    } catch (error) {
      console.warn(error);
      return Promise.reject();
    }
    this.setState({ submitting: true, error: null, errorMessages: [] });
    return submitFunc(endpoint, payload, additionalOptions).then(function (data) {
      _this3.setState({
        data: data,
        error: null,
        errorMessages: [],
        submitting: false,
        displayThankYou: true
      });
      return { success: true };
    }).catch(function (error) {
      if (_this3.fieldRefs.captcha) {
        _this3.fieldRefs.captcha.reset();
        _this3.setField({
          captcha: {
            attributes: {
              required: true
            },
            status: {
              isValid: true
            },
            value: ""
          }
        });
      }
      _this3.setState({
        error: error.message || null,
        errorMessages: error.data || [],
        words: error.words && error.words.split(",") || [],
        submitting: false
      });
      return { error: true };
    });
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\forms\\form-section.jsx";




var FormSection = function FormSection(_ref) {
  var children = _ref.children,
      title = _ref.title,
      disabled = _ref.disabled,
      marginTop = _ref.marginTop;
  return (
    /**
     * Renders a form template
     * @param {Object} [props] - Component props object
     * @param {Node} [props.children] - Children to render inside.
     * @param {String} [props.title] - Field data to submit.
     * @returns {Component} - react form component
     */
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "inspectlet-sensitive",
        style: {
          color: "#999",
          marginTop: marginTop || "3em",
          opacity: disabled ? 0.5 : 1,
          transform: ".3s"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      },
      title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { padding: "1.5em 1em 0" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["F" /* Heading */], {
          value: title,
          tag: "h5",
          customHeadingStyle: {
            textAlign: "center"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          }
        })
      ),
      children
    )
  );
};

FormSection.displayName = "FormSection";
FormSection.displayName = "FormSection";
FormSection.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (FormSection);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\forms\\submit-section.jsx";





var SubmitSection = function SubmitSection(_ref) {
  var _ref$errorMessages = _ref.errorMessages,
      errorMessages = _ref$errorMessages === undefined ? [] : _ref$errorMessages,
      error = _ref.error,
      submitting = _ref.submitting,
      buttonText = _ref.buttonText,
      styleNameButton = _ref.styleNameButton,
      _ref$styleNameLoader = _ref.styleNameLoader,
      styleNameLoader = _ref$styleNameLoader === undefined ? "dark" : _ref$styleNameLoader,
      _ref$gtmEvents = _ref.gtmEvents,
      gtmEvents = _ref$gtmEvents === undefined ? [] : _ref$gtmEvents,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === undefined ? function () {} : _ref$onSubmit,
      canSubmit = _ref.canSubmit;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 18
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { margin: "1em 0" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 19
        }
      },
      error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["s" /* ErrorMessageSection */], { error: error, __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      }),
      errorMessages && Array.isArray(errorMessages) && errorMessages.map(function (errorItem, index) {
        return !__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(errorItem) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["s" /* ErrorMessageSection */], { key: index, error: errorItem, __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        });
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 27
        }
      },
      submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { margin: "1em auto" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 34
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["M" /* LoaderIcon */], { styleName: styleNameLoader === "dark" ? "light" : "dark", __source: {
            fileName: _jsxFileName,
            lineNumber: 35
          }
        })
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["e" /* Button */], {
        label: buttonText,
        styleName: styleNameButton || "black",
        display: "block",
        fullWidth: true,
        onClick: onSubmit,
        disabledStyle: !canSubmit,
        gtmEvents: canSubmit ? gtmEvents : undefined, __source: {
          fileName: _jsxFileName,
          lineNumber: 38
        }
      })
    )
  );
};

SubmitSection.displayName = "SubmitSection";
SubmitSection.displayName = "SubmitSection";
SubmitSection.propTypes = {
  buttonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  errorMessages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  styleNameButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  styleNameLoader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  canSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["a"] = (SubmitSection);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createEvents = function createEvents(eventDefinition, prevState, action, nextState) {
  return [].concat(eventDefinition(action, prevState, nextState)).filter(function (ifTruethy) {
    return ifTruethy;
  });
};

exports.default = createEvents;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(28) && !__webpack_require__(19)(function () {
  return Object.defineProperty(__webpack_require__(200)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(23);


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(48);
var toIObject = __webpack_require__(49);
var arrayIndexOf = __webpack_require__(145)(false);
var IE_PROTO = __webpack_require__(202)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(29);
var anObject = __webpack_require__(16);
var getKeys = __webpack_require__(95);

module.exports = __webpack_require__(28) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(49);
var gOPN = __webpack_require__(98).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(95);
var gOPS = __webpack_require__(146);
var pIE = __webpack_require__(130);
var toObject = __webpack_require__(31);
var IObject = __webpack_require__(129);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(19)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(38);
var isObject = __webpack_require__(20);
var invoke = __webpack_require__(314);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 314 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(18).parseInt;
var $trim = __webpack_require__(109).trim;
var ws = __webpack_require__(206);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(18).parseFloat;
var $trim = __webpack_require__(109).trim;

module.exports = 1 / $parseFloat(__webpack_require__(206) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(56);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(20);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 319 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(209);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(16);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(38);
var toObject = __webpack_require__(31);
var IObject = __webpack_require__(129);
var toLength = __webpack_require__(24);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(96);
var toLength = __webpack_require__(24);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(221);
__webpack_require__(6)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(28) && /./g.flags != 'g') __webpack_require__(29).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(131)
});


/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var isObject = __webpack_require__(20);
var newPromiseCapability = __webpack_require__(225);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(330);
var validate = __webpack_require__(111);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(154)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(29).f;
var create = __webpack_require__(97);
var redefineAll = __webpack_require__(102);
var ctx = __webpack_require__(55);
var anInstance = __webpack_require__(100);
var forOf = __webpack_require__(101);
var $iterDefine = __webpack_require__(211);
var step = __webpack_require__(324);
var setSpecies = __webpack_require__(99);
var DESCRIPTORS = __webpack_require__(28);
var fastKey = __webpack_require__(82).fastKey;
var validate = __webpack_require__(111);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(330);
var validate = __webpack_require__(111);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(154)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(66)(0);
var redefine = __webpack_require__(45);
var meta = __webpack_require__(82);
var assign = __webpack_require__(311);
var weak = __webpack_require__(333);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(19);
var validate = __webpack_require__(111);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(154)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(102);
var getWeak = __webpack_require__(82).getWeak;
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(20);
var anInstance = __webpack_require__(100);
var forOf = __webpack_require__(101);
var createArrayMethod = __webpack_require__(66);
var $has = __webpack_require__(48);
var validate = __webpack_require__(111);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(57);
var toLength = __webpack_require__(24);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(98);
var gOPS = __webpack_require__(146);
var anObject = __webpack_require__(16);
var Reflect = __webpack_require__(18).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(147);
var isObject = __webpack_require__(20);
var toLength = __webpack_require__(24);
var ctx = __webpack_require__(55);
var IS_CONCAT_SPREADABLE = __webpack_require__(23)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(24);
var repeat = __webpack_require__(208);
var defined = __webpack_require__(64);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(95);
var toIObject = __webpack_require__(49);
var isEnum = __webpack_require__(130).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(108);
var from = __webpack_require__(340);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(101);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 341 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export head */
/* unused harmony export last */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return join; });
/* unused harmony export map */
/* unused harmony export filter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return take; });
/* unused harmony export range */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compactMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return flatMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return compareArrays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__function__ = __webpack_require__(35);


var head = function head(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.slice) ? arr[0] : undefined;
};

var last = function last(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.slice) ? arr[arr.length - 1] : undefined;
};

var join = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (joiner, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.join) ? arr.join(joiner) : "";
});

var map = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.map) ? arr.map(Object(__WEBPACK_IMPORTED_MODULE_0__function__["j" /* unary */])(fn)) : [];
});

var filter = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.filter) ? arr.filter(Object(__WEBPACK_IMPORTED_MODULE_0__function__["j" /* unary */])(fn)) : [];
});

var compact = filter(Object(__WEBPACK_IMPORTED_MODULE_0__function__["i" /* pipe */])(__WEBPACK_IMPORTED_MODULE_0__function__["d" /* identity */], Boolean));

var take = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (n, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.slice) ? n < 0 ? arr.slice(n) : arr.slice(0, n) : [];
});

var range = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (min, max) {
  return Array(max - min).fill().map(function (_, idx) {
    return min + idx;
  });
});

var compactMap = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.reduce) ? arr.reduce(function (out, val) {
    var fnResult = fn(val);
    if (fnResult) out.push(fnResult);
    return out;
  }, []) : [];
});

var flatMap = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.reduce) ? arr.reduce(function (out, val) {
    return out.concat(fn(val));
  }, []) : [];
});

var compareArrays = function compareArrays(arr1, arr2) {
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;

  for (var i = 0, l = arr1.length; i < l; i++) {
    // Check if we have nested arrays
    if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
      // recurse into the nested arrays
      if (!compareArrays(arr1[i], arr2[i])) return false;
    } else if (arr1[i] !== arr2[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = enhanceWithRadium;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styleKeeper = __webpack_require__(229);

var _styleKeeper2 = _interopRequireDefault(_styleKeeper);

var _resolveStyles2 = __webpack_require__(344);

var _resolveStyles3 = _interopRequireDefault(_resolveStyles2);

var _getRadiumStyleState = __webpack_require__(354);

var _getRadiumStyleState2 = _interopRequireDefault(_getRadiumStyleState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES = ['arguments', 'callee', 'caller', 'length', 'name', 'prototype', 'type'];

function copyProperties(source, target) {
  Object.getOwnPropertyNames(source).forEach(function (key) {
    if (KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES.indexOf(key) < 0 && !target.hasOwnProperty(key)) {
      var descriptor = Object.getOwnPropertyDescriptor(source, key);
      Object.defineProperty(target, key, descriptor);
    }
  });
}

function isStateless(component) {
  return !component.render && !(component.prototype && component.prototype.render);
}

// Check if value is a real ES class in Native / Node code.
// See: https://stackoverflow.com/a/30760236
function isNativeClass(component) {
  return typeof component === 'function' && /^\s*class\s+/.test(component.toString());
}

// Manually apply babel-ish class inheritance.
function inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (superClass) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(subClass, superClass);
    } else {
      subClass.__proto__ = superClass; // eslint-disable-line no-proto
    }
  }
}

function enhanceWithRadium(configOrComposedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof configOrComposedComponent !== 'function') {
    var newConfig = _extends({}, config, configOrComposedComponent);
    return function (configOrComponent) {
      return enhanceWithRadium(configOrComponent, newConfig);
    };
  }

  var component = configOrComposedComponent;
  var ComposedComponent = component;

  // Handle Native ES classes.
  if (isNativeClass(ComposedComponent)) {
    // Manually approximate babel's class transpilation, but _with_ a real `new` call.
    ComposedComponent = function (OrigComponent) {
      function NewComponent() {
        // Ordinarily, babel would produce something like:
        //
        // ```
        // return _possibleConstructorReturn(this, OrigComponent.apply(this, arguments));
        // ```
        //
        // Instead, we just call `new` directly without the `_possibleConstructorReturn` wrapper.
        var source = new (Function.prototype.bind.apply(OrigComponent, [null].concat(Array.prototype.slice.call(arguments))))();

        // Then we manually update context with properties.
        copyProperties(source, this);

        return this;
      }

      inherits(NewComponent, OrigComponent);

      return NewComponent;
    }(ComposedComponent);
  }

  // Handle stateless components
  if (isStateless(ComposedComponent)) {
    ComposedComponent = function (_Component) {
      _inherits(ComposedComponent, _Component);

      function ComposedComponent() {
        _classCallCheck(this, ComposedComponent);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ComposedComponent.prototype.render = function render() {
        return component(this.props, this.context);
      };

      return ComposedComponent;
    }(_react.Component);

    ComposedComponent.displayName = component.displayName || component.name;
  }

  var RadiumEnhancer = (_temp = _class = function (_ComposedComponent) {
    _inherits(RadiumEnhancer, _ComposedComponent);

    function RadiumEnhancer() {
      _classCallCheck(this, RadiumEnhancer);

      var _this2 = _possibleConstructorReturn(this, _ComposedComponent.apply(this, arguments));

      _this2.state = _this2.state || {};
      _this2.state._radiumStyleState = {};
      _this2._radiumIsMounted = true;
      return _this2;
    }

    RadiumEnhancer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (_ComposedComponent.prototype.componentWillUnmount) {
        _ComposedComponent.prototype.componentWillUnmount.call(this);
      }

      this._radiumIsMounted = false;

      if (this._radiumMouseUpListener) {
        this._radiumMouseUpListener.remove();
      }

      if (this._radiumMediaQueryListenersByQuery) {
        Object.keys(this._radiumMediaQueryListenersByQuery).forEach(function (query) {
          this._radiumMediaQueryListenersByQuery[query].remove();
        }, this);
      }
    };

    RadiumEnhancer.prototype.getChildContext = function getChildContext() {
      var superChildContext = _ComposedComponent.prototype.getChildContext ? _ComposedComponent.prototype.getChildContext.call(this) : {};

      if (!this.props.radiumConfig) {
        return superChildContext;
      }

      var newContext = _extends({}, superChildContext);

      if (this.props.radiumConfig) {
        newContext._radiumConfig = this.props.radiumConfig;
      }

      return newContext;
    };

    RadiumEnhancer.prototype.render = function render() {
      var renderedElement = _ComposedComponent.prototype.render.call(this);
      var currentConfig = this.props.radiumConfig || this.context._radiumConfig || config;

      if (config && currentConfig !== config) {
        currentConfig = _extends({}, config, currentConfig);
      }

      var _resolveStyles = (0, _resolveStyles3.default)(this, renderedElement, currentConfig),
          extraStateKeyMap = _resolveStyles.extraStateKeyMap,
          element = _resolveStyles.element;

      this._extraRadiumStateKeys = Object.keys(extraStateKeyMap);

      return element;
    };

    /* eslint-disable react/no-did-update-set-state, no-unused-vars */


    RadiumEnhancer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (_ComposedComponent.prototype.componentDidUpdate) {
        _ComposedComponent.prototype.componentDidUpdate.call(this, prevProps, prevState);
      }

      if (this._extraRadiumStateKeys.length > 0) {
        var trimmedRadiumState = this._extraRadiumStateKeys.reduce(function (state, key) {
          var extraStateKey = state[key],
              remainingState = _objectWithoutProperties(state, [key]);

          return remainingState;
        }, (0, _getRadiumStyleState2.default)(this));

        this._lastRadiumState = trimmedRadiumState;
        this.setState({ _radiumStyleState: trimmedRadiumState });
      }
    };
    /* eslint-enable react/no-did-update-set-state, no-unused-vars */


    return RadiumEnhancer;
  }(ComposedComponent), _class._isRadiumEnhanced = true, _temp);

  // Class inheritance uses Object.create and because of __proto__ issues
  // with IE <10 any static properties of the superclass aren't inherited and
  // so need to be manually populated.
  // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-

  copyProperties(component, RadiumEnhancer);

  if (false) {
    // This also fixes React Hot Loader by exposing the original components top
    // level prototype methods on the Radium enhanced prototype as discussed in
    // https://github.com/FormidableLabs/radium/issues/219.
    copyProperties(ComposedComponent.prototype, RadiumEnhancer.prototype);
  }

  if (RadiumEnhancer.propTypes && RadiumEnhancer.propTypes.style) {
    RadiumEnhancer.propTypes = _extends({}, RadiumEnhancer.propTypes, {
      style: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
    });
  }

  RadiumEnhancer.displayName = component.displayName || component.name || 'Component';

  RadiumEnhancer.contextTypes = _extends({}, RadiumEnhancer.contextTypes, {
    _radiumConfig: _propTypes2.default.object,
    _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
  });

  RadiumEnhancer.childContextTypes = _extends({}, RadiumEnhancer.childContextTypes, {
    _radiumConfig: _propTypes2.default.object,
    _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
  });

  return RadiumEnhancer;
}
module.exports = exports['default'];

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _appendImportantToEachValue = __webpack_require__(857);

var _appendImportantToEachValue2 = _interopRequireDefault(_appendImportantToEachValue);

var _cssRuleSetToString = __webpack_require__(159);

var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);

var _getState = __webpack_require__(352);

var _getState2 = _interopRequireDefault(_getState);

var _getStateKey = __webpack_require__(891);

var _getStateKey2 = _interopRequireDefault(_getStateKey);

var _cleanStateKey = __webpack_require__(353);

var _cleanStateKey2 = _interopRequireDefault(_cleanStateKey);

var _getRadiumStyleState = __webpack_require__(354);

var _getRadiumStyleState2 = _interopRequireDefault(_getRadiumStyleState);

var _hash = __webpack_require__(232);

var _hash2 = _interopRequireDefault(_hash);

var _mergeStyles = __webpack_require__(892);

var _plugins = __webpack_require__(355);

var _plugins2 = _interopRequireDefault(_plugins);

var _exenv = __webpack_require__(231);

var _exenv2 = _interopRequireDefault(_exenv);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_CONFIG = {
  plugins: [_plugins2.default.mergeStyleArray, _plugins2.default.checkProps, _plugins2.default.resolveMediaQueries, _plugins2.default.resolveInteractionStyles, _plugins2.default.keyframes, _plugins2.default.visited, _plugins2.default.removeNestedStyles, _plugins2.default.prefix, _plugins2.default.checkProps]
};

// Gross
var globalState = {};

// Declare early for recursive helpers.
var resolveStyles = null;

var _shouldResolveStyles = function _shouldResolveStyles(component) {
  return component.type && !component.type._isRadiumEnhanced;
};

var _resolveChildren = function _resolveChildren(_ref) {
  var children = _ref.children,
      component = _ref.component,
      config = _ref.config,
      existingKeyMap = _ref.existingKeyMap,
      extraStateKeyMap = _ref.extraStateKeyMap;

  if (!children) {
    return children;
  }

  var childrenType = typeof children === 'undefined' ? 'undefined' : _typeof(children);

  if (childrenType === 'string' || childrenType === 'number') {
    // Don't do anything with a single primitive child
    return children;
  }

  if (childrenType === 'function') {
    // Wrap the function, resolving styles on the result
    return function () {
      var result = children.apply(this, arguments);

      if (_react2.default.isValidElement(result)) {
        var _key = (0, _getStateKey2.default)(result);
        delete extraStateKeyMap[_key];

        var _resolveStyles = resolveStyles(component, result, config, existingKeyMap, true, extraStateKeyMap),
            _element = _resolveStyles.element;

        return _element;
      }

      return result;
    };
  }

  if (_react2.default.Children.count(children) === 1 && children.type) {
    // If a React Element is an only child, don't wrap it in an array for
    // React.Children.map() for React.Children.only() compatibility.
    var onlyChild = _react2.default.Children.only(children);
    var _key2 = (0, _getStateKey2.default)(onlyChild);
    delete extraStateKeyMap[_key2];

    var _resolveStyles2 = resolveStyles(component, onlyChild, config, existingKeyMap, true, extraStateKeyMap),
        _element2 = _resolveStyles2.element;

    return _element2;
  }

  return _react2.default.Children.map(children, function (child) {
    if (_react2.default.isValidElement(child)) {
      var _key3 = (0, _getStateKey2.default)(child);
      delete extraStateKeyMap[_key3];

      var _resolveStyles3 = resolveStyles(component, child, config, existingKeyMap, true, extraStateKeyMap),
          _element3 = _resolveStyles3.element;

      return _element3;
    }

    return child;
  });
};

// Recurse over props, just like children
var _resolveProps = function _resolveProps(_ref2) {
  var component = _ref2.component,
      config = _ref2.config,
      existingKeyMap = _ref2.existingKeyMap,
      props = _ref2.props,
      extraStateKeyMap = _ref2.extraStateKeyMap;

  var newProps = props;

  Object.keys(props).forEach(function (prop) {
    // We already recurse over children above
    if (prop === 'children') {
      return;
    }

    var propValue = props[prop];
    if (_react2.default.isValidElement(propValue)) {
      var _key4 = (0, _getStateKey2.default)(propValue);
      delete extraStateKeyMap[_key4];
      newProps = _extends({}, newProps);

      var _resolveStyles4 = resolveStyles(component, propValue, config, existingKeyMap, true, extraStateKeyMap),
          _element4 = _resolveStyles4.element;

      newProps[prop] = _element4;
    }
  });

  return newProps;
};

var _buildGetKey = function _buildGetKey(_ref3) {
  var componentName = _ref3.componentName,
      existingKeyMap = _ref3.existingKeyMap,
      renderedElement = _ref3.renderedElement;

  // We need a unique key to correlate state changes due to user interaction
  // with the rendered element, so we know to apply the proper interactive
  // styles.
  var originalKey = (0, _getStateKey2.default)(renderedElement);
  var key = (0, _cleanStateKey2.default)(originalKey);

  var alreadyGotKey = false;
  var getKey = function getKey() {
    if (alreadyGotKey) {
      return key;
    }

    alreadyGotKey = true;

    if (existingKeyMap[key]) {
      var elementName = void 0;
      if (typeof renderedElement.type === 'string') {
        elementName = renderedElement.type;
      } else if (renderedElement.type.constructor) {
        elementName = renderedElement.type.constructor.displayName || renderedElement.type.constructor.name;
      }

      throw new Error('Radium requires each element with interactive styles to have a unique ' + 'key, set using either the ref or key prop. ' + (originalKey ? 'Key "' + originalKey + '" is a duplicate.' : 'Multiple elements have no key specified.') + ' ' + 'Component: "' + componentName + '". ' + (elementName ? 'Element: "' + elementName + '".' : ''));
    }

    existingKeyMap[key] = true;

    return key;
  };

  return getKey;
};

var _setStyleState = function _setStyleState(component, key, stateKey, value) {
  if (!component._radiumIsMounted) {
    return;
  }

  var existing = (0, _getRadiumStyleState2.default)(component);
  var state = { _radiumStyleState: _extends({}, existing) };

  state._radiumStyleState[key] = _extends({}, state._radiumStyleState[key]);
  state._radiumStyleState[key][stateKey] = value;

  component._lastRadiumState = state._radiumStyleState;
  component.setState(state);
};

var _runPlugins = function _runPlugins(_ref4) {
  var component = _ref4.component,
      config = _ref4.config,
      existingKeyMap = _ref4.existingKeyMap,
      props = _ref4.props,
      renderedElement = _ref4.renderedElement;

  // Don't run plugins if renderedElement is not a simple ReactDOMElement or has
  // no style.
  if (!_react2.default.isValidElement(renderedElement) || typeof renderedElement.type !== 'string' || !props.style) {
    return props;
  }

  var newProps = props;

  var plugins = config.plugins || DEFAULT_CONFIG.plugins;

  var componentName = component.constructor.displayName || component.constructor.name;
  var getKey = _buildGetKey({
    renderedElement: renderedElement,
    existingKeyMap: existingKeyMap,
    componentName: componentName
  });
  var getComponentField = function getComponentField(key) {
    return component[key];
  };
  var getGlobalState = function getGlobalState(key) {
    return globalState[key];
  };
  var componentGetState = function componentGetState(stateKey, elementKey) {
    return (0, _getState2.default)(component.state, elementKey || getKey(), stateKey);
  };
  var setState = function setState(stateKey, value, elementKey) {
    return _setStyleState(component, elementKey || getKey(), stateKey, value);
  };

  var addCSS = function addCSS(css) {
    var styleKeeper = component._radiumStyleKeeper || component.context._radiumStyleKeeper;
    if (!styleKeeper) {
      if (__isTestModeEnabled) {
        return {
          remove: function remove() {}
        };
      }

      throw new Error('To use plugins requiring `addCSS` (e.g. keyframes, media queries), ' + 'please wrap your application in the StyleRoot component. Component ' + 'name: `' + componentName + '`.');
    }

    return styleKeeper.addCSS(css);
  };

  var newStyle = props.style;

  plugins.forEach(function (plugin) {
    var result = plugin({
      ExecutionEnvironment: _exenv2.default,
      addCSS: addCSS,
      appendImportantToEachValue: _appendImportantToEachValue2.default,
      componentName: componentName,
      config: config,
      cssRuleSetToString: _cssRuleSetToString2.default,
      getComponentField: getComponentField,
      getGlobalState: getGlobalState,
      getState: componentGetState,
      hash: _hash2.default,
      mergeStyles: _mergeStyles.mergeStyles,
      props: newProps,
      setState: setState,
      isNestedStyle: _mergeStyles.isNestedStyle,
      style: newStyle
    }) || {};

    newStyle = result.style || newStyle;

    newProps = result.props && Object.keys(result.props).length ? _extends({}, newProps, result.props) : newProps;

    var newComponentFields = result.componentFields || {};
    Object.keys(newComponentFields).forEach(function (fieldName) {
      component[fieldName] = newComponentFields[fieldName];
    });

    var newGlobalState = result.globalState || {};
    Object.keys(newGlobalState).forEach(function (key) {
      globalState[key] = newGlobalState[key];
    });
  });

  if (newStyle !== props.style) {
    newProps = _extends({}, newProps, { style: newStyle });
  }

  return newProps;
};

// Wrapper around React.cloneElement. To avoid processing the same element
// twice, whenever we clone an element add a special prop to make sure we don't
// process this element again.
var _cloneElement = function _cloneElement(renderedElement, newProps, newChildren) {
  // Only add flag if this is a normal DOM element
  if (typeof renderedElement.type === 'string') {
    newProps = _extends({}, newProps, { 'data-radium': true });
  }

  return _react2.default.cloneElement(renderedElement, newProps, newChildren);
};

//
// The nucleus of Radium. resolveStyles is called on the rendered elements
// before they are returned in render. It iterates over the elements and
// children, rewriting props to add event handlers required to capture user
// interactions (e.g. mouse over). It also replaces the style prop because it
// adds in the various interaction styles (e.g. :hover).
//
/* eslint-disable max-params */
resolveStyles = function resolveStyles(component, // ReactComponent, flow+eslint complaining
renderedElement) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CONFIG;
  var existingKeyMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var shouldCheckBeforeResolve = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var extraStateKeyMap = arguments[5];

  // The extraStateKeyMap is for determining which keys should be erased from
  // the state (i.e. which child components are unmounted and should no longer
  // have a style state).
  if (!extraStateKeyMap) {
    var state = (0, _getRadiumStyleState2.default)(component);
    extraStateKeyMap = Object.keys(state).reduce(function (acc, key) {
      // 'main' is the auto-generated key when there is only one element with
      // interactive styles and if a custom key is not assigned. Because of
      // this, it is impossible to know which child is 'main', so we won't
      // count this key when generating our extraStateKeyMap.
      if (key !== 'main') {
        acc[key] = true;
      }
      return acc;
    }, {});
  }

  // ReactElement
  if (!renderedElement ||
  // Bail if we've already processed this element. This ensures that only the
  // owner of an element processes that element, since the owner's render
  // function will be called first (which will always be the case, since you
  // can't know what else to render until you render the parent component).
  renderedElement.props && renderedElement.props['data-radium'] ||
  // Bail if this element is a radium enhanced element, because if it is,
  // then it will take care of resolving its own styles.
  shouldCheckBeforeResolve && !_shouldResolveStyles(renderedElement)) {
    return { extraStateKeyMap: extraStateKeyMap, element: renderedElement };
  }

  var newChildren = _resolveChildren({
    children: renderedElement.props.children,
    component: component,
    config: config,
    existingKeyMap: existingKeyMap,
    extraStateKeyMap: extraStateKeyMap
  });

  var newProps = _resolveProps({
    component: component,
    config: config,
    existingKeyMap: existingKeyMap,
    extraStateKeyMap: extraStateKeyMap,
    props: renderedElement.props
  });

  newProps = _runPlugins({
    component: component,
    config: config,
    existingKeyMap: existingKeyMap,
    props: newProps,
    renderedElement: renderedElement
  });

  // If nothing changed, don't bother cloning the element. Might be a bit
  // wasteful, as we add the sentinal to stop double-processing when we clone.
  // Assume benign double-processing is better than unneeded cloning.
  if (newChildren === renderedElement.props.children && newProps === renderedElement.props) {
    return { extraStateKeyMap: extraStateKeyMap, element: renderedElement };
  }

  var element = _cloneElement(renderedElement, newProps !== renderedElement.props ? newProps : {}, newChildren);

  return { extraStateKeyMap: extraStateKeyMap, element: element };
};
/* eslint-enable max-params */

// Only for use by tests
var __isTestModeEnabled = false;
if (false) {
  resolveStyles.__clearStateForTests = function () {
    globalState = {};
  };
  resolveStyles.__setTestMode = function (isEnabled) {
    __isTestModeEnabled = isEnabled;
  };
}

exports.default = resolveStyles;
module.exports = exports['default'];

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = appendPxIfNeeded;


// Copied from https://github.com/facebook/react/blob/
// 102cd291899f9942a76c40a0e78920a6fe544dc1/
// src/renderers/dom/shared/CSSProperty.js
var isUnitlessNumber = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

function appendPxIfNeeded(propertyName, value) {
  var needsPxSuffix = !isUnitlessNumber[propertyName] && typeof value === 'number' && value !== 0;
  return needsPxSuffix ? value + 'px' : value;
}
module.exports = exports['default'];

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapObject;
function mapObject(object, mapper) {
  return Object.keys(object).reduce(function (result, key) {
    result[key] = mapper(object[key], key);
    return result;
  }, {});
}
module.exports = exports["default"];

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _camelCaseRegex = /([a-z])?([A-Z])/g;

var _camelCaseReplacer = function _camelCaseReplacer(match, p1, p2) {
  return (p1 || '') + '-' + p2.toLowerCase();
};

var camelCaseToDashCase = exports.camelCaseToDashCase = function camelCaseToDashCase(s) {
  return s.replace(_camelCaseRegex, _camelCaseReplacer);
};

var camelCasePropsToDashCase = function camelCasePropsToDashCase(prefixedStyle) {
  // Since prefix is expected to work on inline style objects, we must
  // translate the keys to dash case for rendering to CSS.
  return Object.keys(prefixedStyle).reduce(function (result, key) {
    var dashCaseKey = camelCaseToDashCase(key);

    // Fix IE vendor prefix
    if (/^ms-/.test(dashCaseKey)) {
      dashCaseKey = '-' + dashCaseKey;
    }

    result[dashCaseKey] = prefixedStyle[key];
    return result;
  }, {});
};

exports.default = camelCasePropsToDashCase;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(877);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cleanStateKey = __webpack_require__(353);

var _cleanStateKey2 = _interopRequireDefault(_cleanStateKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getState = function getState(state, elementKey, value) {
  var key = (0, _cleanStateKey2.default)(elementKey);

  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
};

exports.default = getState;
module.exports = exports['default'];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* flow */

var cleanStateKey = function cleanStateKey(key) {
  return key === null || typeof key === 'undefined' ? 'main' : key.toString();
};

exports.default = cleanStateKey;
module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getRadiumStyleState = function getRadiumStyleState(component) {
  return component._lastRadiumState || component.state && component.state._radiumStyleState || {};
};

exports.default = getRadiumStyleState;
module.exports = exports["default"];

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkPropsPlugin = __webpack_require__(893);

var _checkPropsPlugin2 = _interopRequireDefault(_checkPropsPlugin);

var _keyframesPlugin = __webpack_require__(894);

var _keyframesPlugin2 = _interopRequireDefault(_keyframesPlugin);

var _mergeStyleArrayPlugin = __webpack_require__(895);

var _mergeStyleArrayPlugin2 = _interopRequireDefault(_mergeStyleArrayPlugin);

var _prefixPlugin = __webpack_require__(896);

var _prefixPlugin2 = _interopRequireDefault(_prefixPlugin);

var _removeNestedStylesPlugin = __webpack_require__(897);

var _removeNestedStylesPlugin2 = _interopRequireDefault(_removeNestedStylesPlugin);

var _resolveInteractionStylesPlugin = __webpack_require__(898);

var _resolveInteractionStylesPlugin2 = _interopRequireDefault(_resolveInteractionStylesPlugin);

var _resolveMediaQueriesPlugin = __webpack_require__(900);

var _resolveMediaQueriesPlugin2 = _interopRequireDefault(_resolveMediaQueriesPlugin);

var _visitedPlugin = __webpack_require__(901);

var _visitedPlugin2 = _interopRequireDefault(_visitedPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  checkProps: _checkPropsPlugin2.default,
  keyframes: _keyframesPlugin2.default,
  mergeStyleArray: _mergeStyleArrayPlugin2.default,
  prefix: _prefixPlugin2.default,
  removeNestedStyles: _removeNestedStylesPlugin2.default,
  resolveInteractionStyles: _resolveInteractionStylesPlugin2.default,
  resolveMediaQueries: _resolveMediaQueriesPlugin2.default,
  visited: _visitedPlugin2.default
};
/* eslint-disable block-scoped-const */

module.exports = exports['default'];

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_layout__ = __webpack_require__(76);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var style = _ref.style;

  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["e" /* IS_IFRAME */]) return { style: style };

  var replaceVH = function replaceVH(match, number, unit, offset, string) {
    var fixed = Number(number) * (__WEBPACK_IMPORTED_MODULE_1__constants_layout__["a" /* DEFAULT_IFRAME_HEIGHT */] / 100);
    return fixed + "px";
  };
  var replaceStyles = function replaceStyles(style) {
    // Somehow in iframe we have an error with this style equal to null
    // So we added this condition below for checking the style
    var cloneStyle = style || {};
    return Object.keys(cloneStyle).reduce(function (newStyle, key) {
      var value = cloneStyle[key];
      var matchVH = /(\d+)(vh)/i;
      if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
        value = replaceStyles(value);
      } else if (typeof value === "string") {
        value = value.replace(matchVH, replaceVH);
      }
      newStyle[key] = value;
      return newStyle;
    }, {});
  };
  var rs = replaceStyles(style);
  return { style: rs };
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_component_error__ = __webpack_require__(358);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\missing-component\\index.jsx";



/**
 * Missing Component is rendered when a CMS component cannot be found on the frontend
 * (Since it is imported from HOC folder imports from folder indexs won't resolve. Hence /configured-radium)
 */
var MissingComponent = function MissingComponent(_ref) {
  var expectedComponentName = _ref.expectedComponentName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_components_component_error__["a" /* default */],
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    expectedComponentName || "Component",
    " not found"
  );
};

MissingComponent.displayName = "MissingComponent";
MissingComponent.displayName = "MissingComponent";
/* harmony default export */ __webpack_exports__["a"] = (MissingComponent);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\component-error\\index.jsx";





var ComponentError = function ComponentError(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: style.base, __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: style.copy, __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      },
      children
    )
  );
};

ComponentError.displayName = "ComponentError";
ComponentError.displayName = "ComponentError";
var style = {
  base: {
    background: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].RED,
    display: "inline-block",
    padding: "1em",
    margin: "0.5em"
  },
  copy: _extends({}, __WEBPACK_IMPORTED_MODULE_2_constants_general_style__["a" /* BASE_COPY */], {
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].WHITE,
    fontWeight: 600
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium__["a" /* default */])(ComponentError));

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(360);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(361);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(34);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StoryBookApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_radium__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_less__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__app_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_cookieHandler__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_AtomicUtils_scroll__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_AtomicUtils_newEvent__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_fix_it__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_fix_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_fix_it__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\app\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















// React-fix-it somehow magically fixes an error of React.Net


if (undefined && undefined === "dingo") {
  if (__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_environment__["i" /* WINDOW */]) {
    window.dataLayer = [];
  }
}

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App() {
    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._scrollToHash = function () {
      if (__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_environment__["i" /* WINDOW */] && !__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_environment__["i" /* WINDOW */].scrollToHash) {
        __WEBPACK_IMPORTED_MODULE_11_AtomicUtils_environment__["i" /* WINDOW */].scrollToHash = true;
        __WEBPACK_IMPORTED_MODULE_11_AtomicUtils_environment__["i" /* WINDOW */].stickyBar = false;
        var hash = new __WEBPACK_IMPORTED_MODULE_13_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_environment__["i" /* WINDOW */].location.href).getHash();
        if (hash !== '') {
          Object(__WEBPACK_IMPORTED_MODULE_14_AtomicUtils_scroll__["a" /* scrollToElementId */])(hash, {}, _this._callBackOnScroll);
        } else {
          _this._callBackOnScroll();
        }
      }
    }, _this._callBackOnScroll = function () {
      __WEBPACK_IMPORTED_MODULE_11_AtomicUtils_environment__["i" /* WINDOW */].stickyBar = true;
      var event = Object(__WEBPACK_IMPORTED_MODULE_15_AtomicUtils_newEvent__["a" /* createNewEvent */])('UPDATE_STICKY_NAV');
      Object(__WEBPACK_IMPORTED_MODULE_15_AtomicUtils_newEvent__["b" /* dispatchEvent */])(event);
    }, _this.setURLinCookie = function () {
      if (!__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_environment__["i" /* WINDOW */]) return;

      var cookieHandlerObject = new __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_cookieHandler__["a" /* default */]();
      var history = cookieHandlerObject.getCookie("history");
      var newHistory = [];
      if (history) {
        newHistory = JSON.parse(history);
      }
      var pathname = new __WEBPACK_IMPORTED_MODULE_13_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_environment__["i" /* WINDOW */].location.href).getPathname();

      if (newHistory.length && newHistory[newHistory.length - 1] && newHistory[newHistory.length - 1] === pathname) return;

      newHistory.push(pathname);
      if (newHistory.length > 5) {
        newHistory.shift();
      }
      cookieHandlerObject.setCookie("history", JSON.stringify(newHistory));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  App.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      _this2.setURLinCookie();
      _this2._scrollToHash();
    }, 1000);
  };

  App.prototype.render = function render() {
    var _props = this.props,
        _props$location = _props.location,
        location = _props$location === undefined ? { search: "", pathname: "" } : _props$location,
        components = _props.components,
        children = _props.children;

    var routerProps = __WEBPACK_IMPORTED_MODULE_6_constants_environment__["c" /* IS_BROWSER */] ? {} : {
      context: {},
      location: Object(__WEBPACK_IMPORTED_MODULE_5_utils__["q" /* get */])("pathname", location || {}) || "/"
    };
    var store = Object(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */])();
    var Router = __WEBPACK_IMPORTED_MODULE_6_constants_environment__["c" /* IS_BROWSER */] ? __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["a" /* BrowserRouter */] : __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* StaticRouter */];

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],
      { store: store, __source: {
          fileName: _jsxFileName,
          lineNumber: 93
        }
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_radium__["StyleRoot"],
        { radiumConfig: { userAgent: "all" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 94
          }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Router,
          _extends({}, routerProps, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 95
            }
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 96
              }
            },
            components && Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_componentParser__["a" /* default */])(components),
            !components && children
          )
        )
      )
    );
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

App.displayName = "App";


var StoryBookApp = Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["m" /* withRadium */])(__WEBPACK_IMPORTED_MODULE_16_react_fix_it___default.a)(App);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["m" /* withRadium */])(__WEBPACK_IMPORTED_MODULE_16_react_fix_it___default.a)(App));

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(364);










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(939);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(952);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(951);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(945);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(374);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(235);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_location__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\connect-location.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * Higher order component for connecting to Redux location state. Now a convenience thing
 * more than anything
 * @param {Object} options - Initial config options.
 * @param {String} options.exposeState - Name of the props object that contains state attributes.
 * @param {String} options.exposeActions - Name of the props object that contains actions which modify state.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$exposeState = _ref.exposeState,
      exposeState = _ref$exposeState === undefined ? 'locationState' : _ref$exposeState,
      _ref$exposeActions = _ref.exposeActions,
      exposeActions = _ref$exposeActions === undefined ? 'locationActions' : _ref$exposeActions;

  return function (Wrapped) {
    var ConnectLocation = function (_Component) {
      _inherits(ConnectLocation, _Component);

      function ConnectLocation() {
        _classCallCheck(this, ConnectLocation);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ConnectLocation.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 30
          }
        }));
      };

      return ConnectLocation;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    ConnectLocation.propTypes = {
      locationState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      locationActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
    };
    ConnectLocation.defaultProps = {
      locationActions: {
        requestPostcodeInput: __WEBPACK_IMPORTED_MODULE_4__utils__["C" /* noop */]
      }
    };
    ConnectLocation.displayName = 'ConnectLocation';


    ConnectLocation.displayName = 'ConnectLocation(' + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["s" /* getComponentDisplayName */])(Wrapped) + ')';

    var mapStateToProps = function mapStateToProps(state) {
      var _ref2;

      return _ref2 = {}, _ref2[exposeState] = __WEBPACK_IMPORTED_MODULE_3__store_actions_location__["c" /* selectors */].getLocation(state), _ref2;
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      var _ref3;

      return _ref3 = {}, _ref3[exposeActions] = Object.keys(__WEBPACK_IMPORTED_MODULE_3__store_actions_location__["a" /* actionCreators */]).reduce(function (actions, key) {
        actions[key] = function () {
          return dispatch(__WEBPACK_IMPORTED_MODULE_3__store_actions_location__["a" /* actionCreators */][key].apply(__WEBPACK_IMPORTED_MODULE_3__store_actions_location__["a" /* actionCreators */], arguments));
        };
        return actions;
      }, {}), _ref3;
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ConnectLocation);
  };
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_layout__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_environment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\detect-thresholds.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var resolveThresholds = function resolveThresholds(thresholds, win, rect) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["B" /* mapValues */])(function (thresh) {
    if (Object(__WEBPACK_IMPORTED_MODULE_7__utils__["y" /* isFunction */])(thresh)) return Boolean(thresh(win, rect));
    if (Array.isArray(thresh)) {
      return thresh.map(function (breakPoint) {
        return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["x" /* isFinite */])(breakPoint) ? win.innerWidth < breakPoint : false;
      });
    }
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["x" /* isFinite */])(thresh) ? win.innerWidth < thresh : false;
  }, thresholds);
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$thresholds = _ref.thresholds,
      thresholds = _ref$thresholds === undefined ? {
    compact: function compact(_ref2) {
      var innerWidth = _ref2.innerWidth;
      return innerWidth < __WEBPACK_IMPORTED_MODULE_5__constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */];
    },
    wide: function wide(_ref3) {
      var innerWidth = _ref3.innerWidth;
      return innerWidth >= __WEBPACK_IMPORTED_MODULE_5__constants_layout__["c" /* DEFAULT_THRESHOLD_WIDE */];
    }
  } : _ref$thresholds,
      _ref$defaultThreshold = _ref.defaultThresholds,
      defaultThresholds = _ref$defaultThreshold === undefined ? {
    compact: true,
    wide: false
  } : _ref$defaultThreshold,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === undefined ? __WEBPACK_IMPORTED_MODULE_7__utils__["C" /* noop */] : _ref$onChange,
      _ref$expose = _ref.expose,
      expose = _ref$expose === undefined ? "thresholds" : _ref$expose;

  return function (Wrapped) {
    var DetectThresholds = function (_PureComponent) {
      _inherits(DetectThresholds, _PureComponent);

      function DetectThresholds(props) {
        var _this$state;

        _classCallCheck(this, DetectThresholds);

        var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

        var initState = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["B" /* mapValues */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils__["i" /* constant */])(false), thresholds), Object(__WEBPACK_IMPORTED_MODULE_7__utils__["I" /* pick */])(Object.keys(thresholds), defaultThresholds || {}));

        _this.state = (_this$state = {}, _this$state[expose] = initState, _this$state);
        return _this;
      }

      DetectThresholds.prototype.stateFromProps = function stateFromProps(props) {
        var next = resolveThresholds(thresholds, props._WINDOW_SIZE_, this.domNode ? this.domNode.getBoundingClientRect() : {});

        if (!Object(__WEBPACK_IMPORTED_MODULE_7__utils__["R" /* shallowEq */])(this.state[expose], next) || !Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* compareArrays */])(Object.values(this.state[expose]), Object.values(next))) {
          var _setState;

          this.setState((_setState = {}, _setState[expose] = next, _setState));
          onChange(next);
        }
      };

      DetectThresholds.prototype.componentDidMount = function componentDidMount() {
        if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["i" /* WINDOW */]) this.domNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this); // TODO: some other way
        this.stateFromProps(this.props);
      };

      DetectThresholds.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.stateFromProps(nextProps);
      };

      DetectThresholds.prototype.render = function render() {
        var _extends2;

        var innerProps = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["E" /* omit */])(["_WINDOW_SIZE_"], this.props), (_extends2 = {}, _extends2[expose] = this.state[expose], _extends2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, innerProps, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 87
          }
        }));
      };

      return DetectThresholds;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

    DetectThresholds.displayName = "DetectThresholds";


    DetectThresholds.propTypes = {
      _WINDOW_SIZE_: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
      })
    };

    DetectThresholds.displayName = "DetectThresholds(" + Object(__WEBPACK_IMPORTED_MODULE_7__utils__["s" /* getComponentDisplayName */])(Wrapped) + ")";

    var mapStateToProps = function mapStateToProps(state) {
      return {
        _WINDOW_SIZE_: __WEBPACK_IMPORTED_MODULE_6__store_actions_environment__["c" /* selectors */].getWindowSize(state)
      };
    };

    return Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(DetectThresholds);
  };
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvent; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var gtmEvent = function gtmEvent(_ref) {
  var gtmID = _ref.gtmID,
      _ref$gtmPayload = _ref.gtmPayload,
      gtmPayload = _ref$gtmPayload === undefined ? {} : _ref$gtmPayload;

  var newGtmPayload = gtmPayload;
  if (gtmPayload.CMSGroupGTM) {
    newGtmPayload.CMSGroupGTM = _extends({}, gtmPayload.CMSGroupGTM, {
      eventID: gtmPayload.CMSGroupGTM.id,
      pageCategory: gtmPayload.CMSGroupGTM.category,
      pageAction: gtmPayload.CMSGroupGTM.action,
      customValue: gtmPayload.CMSGroupGTM.customValue,
      version: gtmPayload.CMSGroupGTM.version
    });
  }
  return _extends({
    type: gtmID
  }, newGtmPayload);
};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(114);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(381);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(240);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 382 */
/***/ (function(module, exports) {

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * Default configs.
 */
var DEFAULT_DELIMITER = '/'
var DEFAULT_DELIMITERS = './'

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?"]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined]
  '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = (options && options.delimiter) || DEFAULT_DELIMITER
  var delimiters = (options && options.delimiters) || DEFAULT_DELIMITERS
  var pathEscaped = false
  var res

  while ((res = PATH_REGEXP.exec(str)) !== null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      pathEscaped = true
      continue
    }

    var prev = ''
    var next = str[index]
    var name = res[2]
    var capture = res[3]
    var group = res[4]
    var modifier = res[5]

    if (!pathEscaped && path.length) {
      var k = path.length - 1

      if (delimiters.indexOf(path[k]) > -1) {
        prev = path[k]
        path = path.slice(0, k)
      }
    }

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
      pathEscaped = false
    }

    var partial = prev !== '' && next !== undefined && next !== prev
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prev || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prev,
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      pattern: pattern ? escapeGroup(pattern) : '[^' + escapeString(delimiter) + ']+?'
    })
  }

  // Push any remaining characters.
  if (path || index < str.length) {
    tokens.push(path + str.substr(index))
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (data, options) {
    var path = ''
    var encode = (options && options.encode) || encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token
        continue
      }

      var value = data ? data[token.name] : undefined
      var segment

      if (Array.isArray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but got array')
        }

        if (value.length === 0) {
          if (token.optional) continue

          throw new TypeError('Expected "' + token.name + '" to not be empty')
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        segment = encode(String(value))

        if (!matches[i].test(segment)) {
          throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"')
        }

        path += token.prefix + segment
        continue
      }

      if (token.optional) {
        // Prepend partial segment prefixes.
        if (token.partial) path += token.prefix

        continue
      }

      throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'))
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$/()])/g, '\\$1')
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  if (!keys) return path

  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        pattern: null
      })
    }
  }

  return path
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  return new RegExp('(?:' + parts.join('|') + ')', flags(options))
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var delimiter = escapeString(options.delimiter || DEFAULT_DELIMITER)
  var delimiters = options.delimiters || DEFAULT_DELIMITERS
  var endsWith = [].concat(options.endsWith || []).map(escapeString).concat('$').join('|')
  var route = ''
  var isEndDelimited = false

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
      isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1
    } else {
      var prefix = escapeString(token.prefix)
      var capture = token.repeat
        ? '(?:' + token.pattern + ')(?:' + prefix + '(?:' + token.pattern + '))*'
        : token.pattern

      if (keys) keys.push(token)

      if (token.optional) {
        if (token.partial) {
          route += prefix + '(' + capture + ')?'
        } else {
          route += '(?:' + prefix + '(' + capture + '))?'
        }
      } else {
        route += prefix + '(' + capture + ')'
      }
    }
  }

  if (end) {
    if (!strict) route += '(?:' + delimiter + ')?'

    route += endsWith === '$' ? '$' : '(?=' + endsWith + ')'
  } else {
    if (!strict) route += '(?:' + delimiter + '(?=' + endsWith + '))?'
    if (!isEndDelimited) route += '(?=' + delimiter + '|' + endsWith + ')'
  }

  return new RegExp('^' + route, flags(options))
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (path instanceof RegExp) {
    return regexpToRegexp(path, keys)
  }

  if (Array.isArray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), keys, options)
  }

  return stringToRegexp(/** @type {string} */ (path), keys, options)
}


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(386);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(167);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(52);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(168),
    baseUniq = __webpack_require__(1090);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(169),
    stackClear = __webpack_require__(1026),
    stackDelete = __webpack_require__(1027),
    stackGet = __webpack_require__(1028),
    stackHas = __webpack_require__(1029),
    stackSet = __webpack_require__(1030);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 390 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(136),
    isObject = __webpack_require__(172);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 393 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(395),
    arraySome = __webpack_require__(1052),
    cacheHas = __webpack_require__(396);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(244),
    setCacheAdd = __webpack_require__(1050),
    setCacheHas = __webpack_require__(1051);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 399 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(401),
    nativeKeys = __webpack_require__(1069);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1071),
    Map = __webpack_require__(243),
    Promise = __webpack_require__(1072),
    Set = __webpack_require__(403),
    WeakMap = __webpack_require__(1073),
    baseGetTag = __webpack_require__(136),
    toSource = __webpack_require__(393);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117),
    root = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(172);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 405 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(407),
    toKey = __webpack_require__(178);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(70),
    isKey = __webpack_require__(251),
    stringToPath = __webpack_require__(1077),
    toString = __webpack_require__(1080);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var BASE_URL = 'https://maps';
var DEFAULT_URL = BASE_URL + '.googleapis.com';
var API_PATH = '/maps/api/js?callback=_$_google_map_initialize_$_';

var getUrl = function getUrl(region) {
  if (region && region.toLowerCase() === 'cn') {
    return BASE_URL + '.google.cn';
  }
  return DEFAULT_URL;
};

var $script_ = null;

var loadPromise_ = void 0;

var resolveCustomPromise_ = void 0;

var _customPromise = new Promise(function (resolve) {
  resolveCustomPromise_ = resolve;
});

// TODO add libraries language and other map options

exports.default = function (bootstrapURLKeys, heatmapLibrary) {
  if (!$script_) {
    $script_ = __webpack_require__(1100); // eslint-disable-line
  }

  // call from outside google-map-react
  // will be as soon as loadPromise_ resolved
  if (!bootstrapURLKeys) {
    return _customPromise;
  }

  if (loadPromise_) {
    return loadPromise_;
  }

  loadPromise_ = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      reject(new Error('google map cannot be loaded outside browser env'));
      return;
    }

    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
      reject(new Error('google map initialization error'));
    }

    window._$_google_map_initialize_$_ = function () {
      delete window._$_google_map_initialize_$_;
      resolve(window.google.maps);
    };

    if (false) {
      if (Object.keys(bootstrapURLKeys).indexOf('callback') > -1) {
        var message = '"callback" key in bootstrapURLKeys is not allowed,\n                          use onGoogleApiLoaded property instead';
        // eslint-disable-next-line no-console
        console.error(message);
        throw new Error(message);
      }
    }

    var params = Object.keys(bootstrapURLKeys).reduce(function (r, key) {
      return r + '&' + key + '=' + bootstrapURLKeys[key];
    }, '');

    var baseUrl = getUrl(bootstrapURLKeys.region);
    var libraries = heatmapLibrary ? '&libraries=visualization' : '';

    $script_('' + baseUrl + API_PATH + params + libraries, function () {
      return typeof window.google === 'undefined' && reject(new Error('google map initialization error (not loaded)'));
    });
  });

  resolveCustomPromise_(loadPromise_);

  return loadPromise_;
};

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\accessories\\index.jsx';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Accessories = function (_Component) {
  _inherits(Accessories, _Component);

  function Accessories(props) {
    _classCallCheck(this, Accessories);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.pushHistory = function (newParams) {
      if (newParams.bodyStyle) {
        _this.props.search.pushParam({
          bodyStyle: newParams.bodyStyle
        });
      }
      if (newParams.category) {
        _this.props.search.pushParam({
          category: newParams.category
        });
      }
    };

    _this.handleChangeBodyTypeFilter = function (filter) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      if (!filter) return;
      var newState = _this.selectAccessoriesByValue(_this.structuredAccessories, filter.name, _this.state.activeCategoryFilterValue);
      _this.setState(newState, function () {
        _this.pushHistory({ bodyStyle: filter.name });
        if (typeof callback === 'function') callback();
      });
    };

    _this.handleChangeCategoryFilter = function (filter) {
      if (!filter) return;
      var newState = _this.selectAccessoriesByValue(_this.structuredAccessories, _this.state.activeBodyFilterValue, filter.name);
      _this.setState(newState, _this.pushHistory({ category: filter.name }));
    };

    _this.structuredAccessories = [];
    props.accessories.forEach(function (singleAccessory) {
      if (singleAccessory.bodyStyle && singleAccessory.bodyStyle.length && singleAccessory.category) {

        singleAccessory.bodyStyle.forEach(function (singleBodyStyle) {
          // if this bodystyle doesn't exist
          if (!_this.structuredAccessories[singleBodyStyle.bodyStyleName]) {
            _this.structuredAccessories[singleBodyStyle.bodyStyleName] = [];
            _this.structuredAccessories[singleBodyStyle.bodyStyleName]['All Accessories'] = [];
          }

          // if this category doesn't exit
          if (!_this.structuredAccessories[singleBodyStyle.bodyStyleName][singleAccessory.category]) {
            _this.structuredAccessories[singleBodyStyle.bodyStyleName][singleAccessory.category] = [];
          }

          // push to the right category and body style
          // data will be duplicated based on how many body style on accessory has
          _this.structuredAccessories[singleBodyStyle.bodyStyleName][singleAccessory.category].push(_extends({}, singleAccessory, {
            grades: singleBodyStyle.grades && singleBodyStyle.grades.length ? singleBodyStyle.grades : null
          }));
          _this.structuredAccessories[singleBodyStyle.bodyStyleName]['All Accessories'].push(_extends({}, singleAccessory, {
            grades: singleBodyStyle.grades && singleBodyStyle.grades.length ? singleBodyStyle.grades : null
          }));
        });
      }
    });

    _this.state = _this.selectAccessoriesByValue(_this.structuredAccessories);
    return _this;
  }

  Accessories.prototype.selectAccessoriesByValue = function selectAccessoriesByValue() {
    var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var selectBodyFilterValue = arguments[1];
    var selectCategoryFilterValue = arguments[2];

    var alphabetically = function alphabetically(a, b) {
      return a < b ? -1 : a > b ? 1 : 0;
    };
    var bodyFilters = Object.keys(source);
    var activeBodyFilterValue = bodyFilters.indexOf(selectBodyFilterValue) > -1 ? selectBodyFilterValue : bodyFilters[0];
    var categoryFilters = Object.keys(source[activeBodyFilterValue]).sort(alphabetically);
    var activeCategoryFilterValue = categoryFilters.indexOf(selectCategoryFilterValue) > -1 ? selectCategoryFilterValue : categoryFilters[0];
    return {
      bodyFilters: bodyFilters,
      activeBodyFilterValue: activeBodyFilterValue,
      categoryFilters: categoryFilters,
      activeCategoryFilterValue: activeCategoryFilterValue
    };
  };

  Accessories.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // Handle browser's back button, go back 2 steps to bypass redirection
    __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].onpopstate = function () {
      __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].history.go(-2);
    };
    if (Object(__WEBPACK_IMPORTED_MODULE_3_utils__["q" /* get */])('search.query.bodyStyle', this.props) || this.props.defaultBodyStyle) {
      this.handleChangeBodyTypeFilter({ name: Object(__WEBPACK_IMPORTED_MODULE_3_utils__["q" /* get */])('search.query.bodyStyle', this.props) || this.props.defaultBodyStyle }, function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_3_utils__["q" /* get */])('search.query.category', _this2.props) || _this2.props.defaultCategory) {
          _this2.handleChangeCategoryFilter({ name: Object(__WEBPACK_IMPORTED_MODULE_3_utils__["q" /* get */])('search.query.category', _this2.props) || _this2.props.defaultCategory });
        }
      });
    }
  };

  Accessories.prototype.render = function render() {
    var _props = this.props,
        vehicle = _props.vehicle,
        description = _props.description;
    var _state = this.state,
        bodyFilters = _state.bodyFilters,
        activeBodyFilterValue = _state.activeBodyFilterValue,
        categoryFilters = _state.categoryFilters,
        activeCategoryFilterValue = _state.activeCategoryFilterValue;

    var accessories = this.props.accessories && this.props.accessories.length ? this.structuredAccessories[activeBodyFilterValue][activeCategoryFilterValue] : [];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 130
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["i" /* BackButton */], { href: '/accessories', backText: 'CHANGE MODEL', __source: {
          fileName: _jsxFileName,
          lineNumber: 131
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_8" /* Section */],
        { horizontalPadding: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 132
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["z" /* H2 */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 133
            }
          },
          vehicle + ' accessories'
        ),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 134
            }
          },
          description
        ),
        this.props.accessories && !!this.props.accessories.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 136
            }
          },

          // Don't display body selector if we have only one body type
          bodyFilters.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["_11" /* Tabs */], {
            onChange: this.handleChangeBodyTypeFilter,
            active: bodyFilters.indexOf(activeBodyFilterValue),
            options: bodyFilters.map(function (name) {
              return { name: name };
            }),
            divider: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 140
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["_12" /* TabsResponsive */], {
            dropdown: true,
            topAndHeightIsActive: true,
            onChange: this.handleChangeCategoryFilter,
            active: categoryFilters.indexOf(activeCategoryFilterValue),
            options: categoryFilters.map(function (name) {
              return { name: name };
            }),
            animatedLine: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 146
            }
          })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 155
            }
          },
          'No accessories to show'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["g" /* CardYoutubePlayerList */],
          {
            numberOfColumns: 4,
            showCounting: false,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 157
            }
          },
          accessories && accessories.map(function (accessory, index) {
            return accessory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["a" /* AccessoryItem */], _extends({}, accessory, { grades: accessory.grades, key: 'AccessoryItem-' + index, __source: {
                fileName: _jsxFileName,
                lineNumber: 165
              }
            }));
          })
        )
      )
    );
  };

  return Accessories;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Accessories.displayName = 'Accessories';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["g" /* SearchParams */])({
  exposeParams: ['category', 'bodyStyle']
}))(Accessories));

Accessories.propTypes = {
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pushParam: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })
  }),
  vehicle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  defaultBodyStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Accessories.defaultProps = {
  defaultBodyStyle: '',
  defaultCategory: 'All Accessories',
  accessories: []
};

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\A.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var A = function (_React$PureComponent) {
  _inherits(A, _React$PureComponent);

  function A() {
    var _temp, _this, _ret;

    _classCallCheck(this, A);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handleOnClick = function (event) {
      if (event) event.preventDefault();

      var _this$props = _this.props,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick,
          external = _this$props.external,
          href = _this$props.href,
          disabled = _this$props.disabled,
          gtm = _this$props.gtm;

      onClick(event);

      // Delay for firing GTM before redirection
      // Call GTM if we have an gtm object
      if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
        Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: gtm.category,
          pageAction: gtm.action
        });
      }

      if (external && href && !disabled) {
        setTimeout(function () {
          new __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_urlHandler__["a" /* default */](href).newTab();
        }, 200);
      } else if (href && !disabled) {
        setTimeout(function () {
          new __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_urlHandler__["a" /* default */](href).redirect();
        }, 200);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  A.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        _props$withoutStyle = _props.withoutStyle,
        withoutStyle = _props$withoutStyle === undefined ? false : _props$withoutStyle,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? "red" : _props$styleName,
        _props$text = _props.text,
        text = _props$text === undefined ? null : _props$text,
        _props$active = _props.active,
        active = _props$active === undefined ? false : _props$active,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        external = _props.external,
        rest = _objectWithoutProperties(_props, ["children", "withoutStyle", "styleName", "text", "active", "className", "external"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      _extends({
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.A] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.withoutStyle] = withoutStyle, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.redColor] = styleName === "red", _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.whiteColor] = styleName === "white", _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.blackColor] = styleName === "black", _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.greyColor] = styleName === "grey", _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.active] = active, _classnames)) + " " + className
      }, rest, {
        onClick: this._handleOnClick,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45
        }
      }),
      !text && children,
      text && text
    );
  };

  return A;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

A.displayName = "A";


/* harmony default export */ __webpack_exports__["a"] = (A);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChevronIcon__ = __webpack_require__(138);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ArrowDownIcon.jsx';


var ArrowDownIcon = function ArrowDownIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      style: {
        transform: 'rotate(-180deg)',
        width: '15px',
        height: '18px'
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ChevronIcon__["a" /* default */], { style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    })
  );
};

ArrowDownIcon.displayName = 'ArrowDownIcon';
ArrowDownIcon.displayName = 'ArrowDownIcon';
/* harmony default export */ __webpack_exports__["a"] = (ArrowDownIcon);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ArrowRightThinIcon.jsx";



var ArrowRightThinIcon = function ArrowRightThinIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 27 52", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "currentColor", d: "M1.43,52L0,50.57,24.56,26,0,1.43,1.43,0,26.7,25.28a1,1,0,0,1,0,1.43Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

ArrowRightThinIcon.displayName = "ArrowRightThinIcon";
ArrowRightThinIcon.displayName = "ArrowRightThinIcon";
ArrowRightThinIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (ArrowRightThinIcon);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BackButton_less__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BackButton_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BackButton_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\BackButton\\BackButton.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var BackButton = function (_React$PureComponent) {
  _inherits(BackButton, _React$PureComponent);

  function BackButton() {
    var _temp, _this, _ret;

    _classCallCheck(this, BackButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handleOnClick = function () {
      var _this$props = _this.props,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick,
          external = _this$props.external,
          href = _this$props.href,
          disabled = _this$props.disabled,
          gtm = _this$props.gtm,
          components = _this$props.components,
          fallBackLink = _this$props.fallBackLink;

      onClick();

      // Delay for firing GTM before redirection
      // Call GTM if we have an gtm object
      if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: gtm.category,
          pageAction: gtm.action
        });
      }

      // legacy
      var newHref = href;
      var newExternal = external;
      if (fallBackLink && fallBackLink != "") {
        newHref = fallBackLink;
      }
      if (!href && components && components[0]) {
        newExternal = components[0].props.external;
        newHref = components[0].props.href;
      }

      if (newExternal && newHref && !disabled) {
        setTimeout(function () {
          new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__["a" /* default */](newHref).newTab();
        }, 200);
      } else if (newHref && !disabled) {
        setTimeout(function () {
          new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__["a" /* default */](newHref).redirect();
        }, 200);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  BackButton.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        _props$backText = _props.backText,
        backText = _props$backText === undefined ? 'Back' : _props$backText,
        _props$small = _props.small,
        small = _props$small === undefined ? false : _props$small;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5__BackButton_less___default.a.BackButton] = true, _classnames[__WEBPACK_IMPORTED_MODULE_5__BackButton_less___default.a.BackButtonSmall] = small, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 63
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
        {
          withoutStyle: true,
          onClick: this._handleOnClick,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 67
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["e" /* ArrowLeftIcon */], { style: {
            width: '15px',
            height: '15px',
            paddingBottom: '10px'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 71
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 76
            }
          },
          backText
        )
      )
    );
  };

  return BackButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

BackButton.displayName = "BackButton";


/* harmony default export */ __webpack_exports__["a"] = (BackButton);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ButtonGroup_less__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ButtonGroup_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ButtonGroup_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\ButtonGroup\\ButtonGroup.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ButtonGroup = function (_React$PureComponent) {
  _inherits(ButtonGroup, _React$PureComponent);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  ButtonGroup.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        components = _props.components,
        children = _props.children,
        _props$alignment = _props.alignment,
        alignment = _props$alignment === undefined ? "center" : _props$alignment,
        _props$stacked = _props.stacked,
        stacked = _props$stacked === undefined ? false : _props$stacked;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__ButtonGroup_less___default.a.ButtonGroup] = true, _classnames[__WEBPACK_IMPORTED_MODULE_3__ButtonGroup_less___default.a.ButtonGroupStacked] = stacked, _classnames[__WEBPACK_IMPORTED_MODULE_3__ButtonGroup_less___default.a.ButtonGroupCenter] = alignment === "center", _classnames[__WEBPACK_IMPORTED_MODULE_3__ButtonGroup_less___default.a.ButtonGroupRight] = alignment === "right", _classnames[__WEBPACK_IMPORTED_MODULE_3__ButtonGroup_less___default.a.ButtonGroupLeft] = alignment === "left", _classnames)),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_componentParser__["a" /* default */])(components) || children
    );
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

ButtonGroup.displayName = "ButtonGroup";


/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_accessories__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AtomicContainers_AccessoryDetails_AccessoryDetails__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AtomicContainers_AccessoryList_AccessoryList__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AtomicContainers_AccordionText_AccordionText__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AtomicContainers_AccordionTextList_AccordionTextList__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AtomicContainers_ArticlePage_ArticlePage__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AtomicContainers_ArticlePreview_ArticlePreview__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AtomicContainers_ArticleSelector_ArticleSelector__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AtomicComponents_BackButton_BackButton__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AtomicContainers_BookServiceForm_BookServiceForm__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AtomicContainers_BookTestDrive_BookTestDrive__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AtomicContainers_BrowserWarning_BrowserWarning__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AtomicComponents_ButtonGroup_ButtonGroup__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AtomicComponents_Button_Button__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AtomicComponents_Card_Card__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AtomicContainers_CardYoutubePlayer_CardYoutubePlayer__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AtomicContainers_CardYoutubePlayerList_CardYoutubePlayerList__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AtomicContainers_CompetitionForm_CompetitionForm__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AtomicComponents_Section_Section__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AtomicComponents_ColumnGroup_ColumnGroup__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__containers_compare_tool__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__containers_compare_vehicle_selector__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__containers_build__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AtomicContainers_ContentCard_ContentCard__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AtomicContainers_ContentCardList_ContentCardList__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__AtomicContainers_CorporateSelect_CorporateSelect__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__blocks_countdown_timer__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__blocks_dealer_map_page__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__blocks_dynamic_text_video_frame__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__AtomicContainers_FeaturedCategoriesTab_FeaturedCategoriesTab__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__AtomicContainers_FeatureFocusBlock_FeatureFocusBlock__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__AtomicContainers_FiftyFiftyBlock_FiftyFiftyBlock__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__AtomicContainers_Offers_Offers__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__blocks_global_nav_item_grid__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_nameplate_link__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__AtomicContainers_Footer_Footer__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_AtomicContainers_FullWidthImageSection_FullWidthImageSection__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__blocks_full_width_multi_video__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__containers_gallery__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__containers_gallery_full_width__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__containers_gallery_item__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_AtomicContainers_GetInTouch_GetInTouch__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__containers_global_nav__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__blocks_global_nav_dropdown__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_global_nav_link__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__AtomicContainers_GradePicker_GradePicker__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__blocks_gyroscope__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__AtomicContainers_Heading_Heading__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__blocks_heading_section__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__AtomicContainers_Hero_Hero__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__blocks_hero_video_with_timed_frames__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__AtomicComponents_Typography_A__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__containers_icon_tout_block__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__AtomicComponents_IdWrapper_IdWrapper__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__AtomicContainers_Image_Image__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__AtomicContainers_Image360_Image360__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_AtomicContainers_Gallery_Gallery__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__AtomicContainers_ImagesRotator_ImagesRotator__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__containers_image_tout_block__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__blocks_text_media_slider__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__AtomicContainers_InteriorPicker_InteriorPicker__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__blocks_map_search__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__blocks_map_select_state_index_js__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_AtomicContainers_ColorPicker_ColorPicker__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__blocks_mymazda__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__blocks_mymazda_confirm_change_email__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__blocks_mymazda_create_account__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__AtomicContainers_MyMazdaDashboard_MyMazdaDashboard__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__AtomicContainers_MyMazdaDashboard_MyMazdaDashboardItem__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__blocks_mymazda_dealer_block__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__blocks_mymazda_dynamic_resource__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__blocks_mymazda_dynamic_resource_item__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__blocks_mymazda_vehicle_specs__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__AtomicContainers_MyMazdaLogin_MyMazdaLogin__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__AtomicContainers_MyMazdaLoginContainer_MyMazdaLoginContainer__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__blocks_mymazda_manage_account__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__blocks_mymazda_manage_vehicles__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__blocks_mymazda_notifications__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__blocks_mymazda_account_password__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__blocks_mymazda_policies__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__blocks_mymazda_policies_detail__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__blocks_mymazda_policies_item__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__blocks_mymazda_policies_summary__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__blocks_mymazda_recall_notification__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__blocks_mymazda_registration__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__blocks_mymazda_reset_password__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__blocks_mymazda_service_export__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__blocks_mymazda_service_form__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__blocks_mymazda_service_summary__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__containers_mymazda_specifications_block__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__containers_mymazda_summary__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__blocks_mymazda_redirect__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__blocks_mymazda_vehicle_resource_list__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__blocks_mymazda_service_carousel__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__AtomicContainers_MyMazdaServiceHistory_MyMazdaServiceHistory__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__AtomicContainers_MyMazdaVehicleSummary_MyMazdaVehicleSummary__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__AtomicContainers_MyNewMazda_MyNewMazda__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__containers_offers__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__AtomicContainers_OfferTile_OfferTile__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__containers_offers_offer_tile__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__blocks_outlet_store_detail__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__containers_outlet_store__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__AtomicContainers_OutletStoreEnquiryForm_OutletStoreEnquiryForm__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__containers_outlet_store_specifications_block__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__containers_overlay__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__AtomicContainers_PDFTemplate_PDFTemplate__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__AtomicContainers_PersonalisationBlockContainer_PersonalisationBlockContainer__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__AtomicComponents_PersonalisationBlockItem_PersonalisationBlockItem__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__containers_postcode_popup__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__AtomicContainers_Price_Price__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__AtomicContainers_RecallDocument_RecallDocument__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__AtomicContainers_Recall_Recall__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__AtomicContainers_RegisterInterestForm_RegisterInterestForm__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__AtomicContainers_SaveForm_SaveForm__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__AtomicContainers_SaveShareCopy_SaveShareCopy__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__containers_scraped_page__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__containers_service_calculator_owner__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__containers_service_calculator_prospect__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__blocks_service_details_full__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__AtomicContainers_ShareForm_ShareForm__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__blocks_single_dealer_map__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__blocks_site_search__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__AtomicContainers_SixtyFourtyBlock_SixtyFourtyBlock__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__AtomicComponents_SocialIcons_SocialIcons__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__AtomicContainers_SpecificationsBlock_SpecificationsBlock__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__AtomicComponents_Spotlight_Spotlight__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__AtomicContainers_StickyNav_StickyNav__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__AtomicComponents_StickySection_StickySection__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__AtomicComponents_Testimonial_Testimonial__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__blocks_time_clock_video_frame__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__blocks_tout_block__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__containers_triggered_overlay__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__AtomicContainers_VehicleNotFoundPage_VehicleNotFoundPage__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__AtomicContainers_VideoPlayer_VideoPlayer__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_video_slideshow__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__AtomicComponents_Content_Content__ = __webpack_require__(588);
/* eslint-disable */
//:// Changed it to this way, because the memory leak of building it with webpack was annoying
// Look into this
// https://stackoverflow.com/questions/29875869/react-jsx-dynamic-component-name













































































































































var moduleImporter = function moduleImporter(name) {
  var components = {
    Accessories: __WEBPACK_IMPORTED_MODULE_0__containers_accessories__["a" /* default */],
    AccessoryDetails: __WEBPACK_IMPORTED_MODULE_1__AtomicContainers_AccessoryDetails_AccessoryDetails__["a" /* default */],
    AccessoryList: __WEBPACK_IMPORTED_MODULE_2__AtomicContainers_AccessoryList_AccessoryList__["a" /* default */],
    AccessoryPackDetails: __WEBPACK_IMPORTED_MODULE_1__AtomicContainers_AccessoryDetails_AccessoryDetails__["a" /* default */],
    Accordion: __WEBPACK_IMPORTED_MODULE_3__AtomicContainers_AccordionText_AccordionText__["a" /* default */],
    AccordionGroup: __WEBPACK_IMPORTED_MODULE_4__AtomicContainers_AccordionTextList_AccordionTextList__["a" /* default */],
    ArticlePage: __WEBPACK_IMPORTED_MODULE_5__AtomicContainers_ArticlePage_ArticlePage__["b" /* default */],
    ArticlePreview: __WEBPACK_IMPORTED_MODULE_6__AtomicContainers_ArticlePreview_ArticlePreview__["a" /* default */],
    ArticleSelector: __WEBPACK_IMPORTED_MODULE_7__AtomicContainers_ArticleSelector_ArticleSelector__["a" /* default */],
    BackButton: __WEBPACK_IMPORTED_MODULE_8__AtomicComponents_BackButton_BackButton__["a" /* default */],
    BookServiceForm: __WEBPACK_IMPORTED_MODULE_9__AtomicContainers_BookServiceForm_BookServiceForm__["a" /* default */],
    BookTestdriveForm: __WEBPACK_IMPORTED_MODULE_10__AtomicContainers_BookTestDrive_BookTestDrive__["a" /* default */],
    BrowserWarning: __WEBPACK_IMPORTED_MODULE_11__AtomicContainers_BrowserWarning_BrowserWarning__["a" /* default */],
    Button: __WEBPACK_IMPORTED_MODULE_13__AtomicComponents_Button_Button__["a" /* default */],
    ButtonGroup: __WEBPACK_IMPORTED_MODULE_12__AtomicComponents_ButtonGroup_ButtonGroup__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_14__AtomicComponents_Card_Card__["a" /* default */],
    CardYoutubePlayer: __WEBPACK_IMPORTED_MODULE_15__AtomicContainers_CardYoutubePlayer_CardYoutubePlayer__["a" /* default */],
    CardYoutubePlayerList: __WEBPACK_IMPORTED_MODULE_16__AtomicContainers_CardYoutubePlayerList_CardYoutubePlayerList__["a" /* default */],
    Column: __WEBPACK_IMPORTED_MODULE_18__AtomicComponents_Section_Section__["a" /* default */],
    ColumnGroup: __WEBPACK_IMPORTED_MODULE_19__AtomicComponents_ColumnGroup_ColumnGroup__["a" /* default */],
    CompareTool: __WEBPACK_IMPORTED_MODULE_20__containers_compare_tool__["a" /* default */],
    CompareVehicleSelector: __WEBPACK_IMPORTED_MODULE_21__containers_compare_vehicle_selector__["a" /* default */],
    CompetitionForm: __WEBPACK_IMPORTED_MODULE_17__AtomicContainers_CompetitionForm_CompetitionForm__["a" /* default */],
    Configurator: __WEBPACK_IMPORTED_MODULE_22__containers_build__["a" /* default */],
    ContactUsForm: __WEBPACK_IMPORTED_MODULE_41_AtomicContainers_GetInTouch_GetInTouch__["a" /* default */],
    ContentCard: __WEBPACK_IMPORTED_MODULE_23__AtomicContainers_ContentCard_ContentCard__["a" /* default */],
    ContentCardList: __WEBPACK_IMPORTED_MODULE_24__AtomicContainers_ContentCardList_ContentCardList__["a" /* default */],
    CorporateSelectForm: __WEBPACK_IMPORTED_MODULE_25__AtomicContainers_CorporateSelect_CorporateSelect__["a" /* default */],
    CountdownTimer: __WEBPACK_IMPORTED_MODULE_26__blocks_countdown_timer__["a" /* default */],
    DealerMapPage: __WEBPACK_IMPORTED_MODULE_27__blocks_dealer_map_page__["a" /* default */],
    DynamicTextVideoFrameBlock: __WEBPACK_IMPORTED_MODULE_28__blocks_dynamic_text_video_frame__["a" /* default */],
    FeaturedCategoriesTab: __WEBPACK_IMPORTED_MODULE_29__AtomicContainers_FeaturedCategoriesTab_FeaturedCategoriesTab__["a" /* default */],
    FeatureFocusBlock: __WEBPACK_IMPORTED_MODULE_30__AtomicContainers_FeatureFocusBlock_FeatureFocusBlock__["a" /* default */],
    FeatureYouTube: __WEBPACK_IMPORTED_MODULE_15__AtomicContainers_CardYoutubePlayer_CardYoutubePlayer__["a" /* default */],
    FiftyFiftyBlock: __WEBPACK_IMPORTED_MODULE_31__AtomicContainers_FiftyFiftyBlock_FiftyFiftyBlock__["a" /* default */],
    FlexContent: __WEBPACK_IMPORTED_MODULE_33__blocks_global_nav_item_grid__["a" /* default */],
    FlexIconLink: __WEBPACK_IMPORTED_MODULE_34__components_nameplate_link__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_35__AtomicContainers_Footer_Footer__["a" /* default */],
    FullWidthImageSection: __WEBPACK_IMPORTED_MODULE_36_AtomicContainers_FullWidthImageSection_FullWidthImageSection__["a" /* default */],
    FullWidthMultiVideoBlock: __WEBPACK_IMPORTED_MODULE_37__blocks_full_width_multi_video__["a" /* default */],
    Gallery: __WEBPACK_IMPORTED_MODULE_38__containers_gallery__["a" /* default */],
    GalleryFullWidth: __WEBPACK_IMPORTED_MODULE_39__containers_gallery_full_width__["a" /* default */],
    GalleryItem: __WEBPACK_IMPORTED_MODULE_40__containers_gallery_item__["a" /* default */],
    GlobalNav: __WEBPACK_IMPORTED_MODULE_42__containers_global_nav__["a" /* default */],
    NavDropdown: __WEBPACK_IMPORTED_MODULE_43__blocks_global_nav_dropdown__["a" /* default */],
    GlobalNavItemGridBlock: __WEBPACK_IMPORTED_MODULE_33__blocks_global_nav_item_grid__["a" /* default */],
    NavLink: __WEBPACK_IMPORTED_MODULE_44__components_global_nav_link__["a" /* default */],
    GradePicker: __WEBPACK_IMPORTED_MODULE_45__AtomicContainers_GradePicker_GradePicker__["a" /* default */],
    GyroscopeBlock: __WEBPACK_IMPORTED_MODULE_46__blocks_gyroscope__["a" /* default */],
    Heading: __WEBPACK_IMPORTED_MODULE_47__AtomicContainers_Heading_Heading__["a" /* default */],
    HeadingSectionBlock: __WEBPACK_IMPORTED_MODULE_48__blocks_heading_section__["a" /* default */],
    Hero: __WEBPACK_IMPORTED_MODULE_49__AtomicContainers_Hero_Hero__["a" /* default */],
    HeroVideoWithTimedFrames: __WEBPACK_IMPORTED_MODULE_50__blocks_hero_video_with_timed_frames__["a" /* default */],
    Hyperlink: __WEBPACK_IMPORTED_MODULE_51__AtomicComponents_Typography_A__["a" /* default */],
    IconToutBlock: __WEBPACK_IMPORTED_MODULE_52__containers_icon_tout_block__["a" /* default */],
    IdWrapper: __WEBPACK_IMPORTED_MODULE_53__AtomicComponents_IdWrapper_IdWrapper__["a" /* default */],
    Image: __WEBPACK_IMPORTED_MODULE_54__AtomicContainers_Image_Image__["a" /* default */],
    Image360: __WEBPACK_IMPORTED_MODULE_55__AtomicContainers_Image360_Image360__["a" /* default */],
    ImagesGallery: __WEBPACK_IMPORTED_MODULE_56_AtomicContainers_Gallery_Gallery__["a" /* default */],
    ImagesRotatorBlock: __WEBPACK_IMPORTED_MODULE_57__AtomicContainers_ImagesRotator_ImagesRotator__["a" /* default */],
    ImageToutBlock: __WEBPACK_IMPORTED_MODULE_58__containers_image_tout_block__["a" /* default */],
    InPageNavigation: __WEBPACK_IMPORTED_MODULE_126__AtomicContainers_StickyNav_StickyNav__["a" /* default */],
    InteractiveSlideshowBlock: __WEBPACK_IMPORTED_MODULE_59__blocks_text_media_slider__["a" /* default */],
    InteriorPicker: __WEBPACK_IMPORTED_MODULE_60__AtomicContainers_InteriorPicker_InteriorPicker__["a" /* default */],
    MapSearchBlock: __WEBPACK_IMPORTED_MODULE_61__blocks_map_search__["a" /* default */],
    MapSelectStateBlock: __WEBPACK_IMPORTED_MODULE_62__blocks_map_select_state_index_js__["a" /* default */],
    MiniConfigurator: __WEBPACK_IMPORTED_MODULE_63_AtomicContainers_ColorPicker_ColorPicker__["a" /* default */],
    MyMazda: __WEBPACK_IMPORTED_MODULE_64__blocks_mymazda__["a" /* default */],
    MyMazdaAccountPassword: __WEBPACK_IMPORTED_MODULE_78__blocks_mymazda_account_password__["a" /* default */],
    MyMazdaConfirmChangeEmailBlock: __WEBPACK_IMPORTED_MODULE_65__blocks_mymazda_confirm_change_email__["a" /* default */],
    MyMazdaCreateAccount: __WEBPACK_IMPORTED_MODULE_66__blocks_mymazda_create_account__["a" /* default */],
    MyMazdaDashboard: __WEBPACK_IMPORTED_MODULE_67__AtomicContainers_MyMazdaDashboard_MyMazdaDashboard__["a" /* default */],
    MyMazdaDashboardItem: __WEBPACK_IMPORTED_MODULE_68__AtomicContainers_MyMazdaDashboard_MyMazdaDashboardItem__["a" /* default */],
    MyMazdaDealerBlock: __WEBPACK_IMPORTED_MODULE_69__blocks_mymazda_dealer_block__["a" /* default */],
    MyMazdaDynamicResourceBlock: __WEBPACK_IMPORTED_MODULE_70__blocks_mymazda_dynamic_resource__["a" /* default */],
    MyMazdaDynamicResourceItem: __WEBPACK_IMPORTED_MODULE_71__blocks_mymazda_dynamic_resource_item__["a" /* default */],
    MyMazdaFullSpecBlock: __WEBPACK_IMPORTED_MODULE_72__blocks_mymazda_vehicle_specs__["a" /* default */],
    MyMazdaLogin: __WEBPACK_IMPORTED_MODULE_73__AtomicContainers_MyMazdaLogin_MyMazdaLogin__["a" /* default */],
    MyMazdaLoginBlock: __WEBPACK_IMPORTED_MODULE_74__AtomicContainers_MyMazdaLoginContainer_MyMazdaLoginContainer__["a" /* default */],
    MyMazdaManageAccountBlock: __WEBPACK_IMPORTED_MODULE_75__blocks_mymazda_manage_account__["a" /* default */],
    MyMazdaManageVehiclesBlock: __WEBPACK_IMPORTED_MODULE_76__blocks_mymazda_manage_vehicles__["a" /* default */],
    MyMazdaNotifications: __WEBPACK_IMPORTED_MODULE_77__blocks_mymazda_notifications__["a" /* default */],
    MyMazdaPolicies: __WEBPACK_IMPORTED_MODULE_79__blocks_mymazda_policies__["a" /* default */],
    MyMazdaPolicyDetail: __WEBPACK_IMPORTED_MODULE_80__blocks_mymazda_policies_detail__["a" /* default */],
    MyMazdaPolicyItem: __WEBPACK_IMPORTED_MODULE_81__blocks_mymazda_policies_item__["a" /* default */],
    MyMazdaPolicySummary: __WEBPACK_IMPORTED_MODULE_82__blocks_mymazda_policies_summary__["a" /* default */],
    MyMazdaRecallNotification: __WEBPACK_IMPORTED_MODULE_83__blocks_mymazda_recall_notification__["a" /* default */],
    MyMazdaRegistration: __WEBPACK_IMPORTED_MODULE_84__blocks_mymazda_registration__["a" /* default */],
    MyMazdaResetPassword: __WEBPACK_IMPORTED_MODULE_85__blocks_mymazda_reset_password__["a" /* default */],
    MyMazdaServiceHistoryExport: __WEBPACK_IMPORTED_MODULE_86__blocks_mymazda_service_export__["a" /* default */],
    MyMazdaServiceRequestFormBlock: __WEBPACK_IMPORTED_MODULE_87__blocks_mymazda_service_form__["a" /* default */],
    MyMazdaServiceSummaryBlock: __WEBPACK_IMPORTED_MODULE_88__blocks_mymazda_service_summary__["a" /* default */],
    MyMazdaSpecificationBlock: __WEBPACK_IMPORTED_MODULE_89__containers_mymazda_specifications_block__["a" /* default */],
    MyMazdaSummary: __WEBPACK_IMPORTED_MODULE_90__containers_mymazda_summary__["a" /* default */],
    MyMazdaUnauthRedirectBlock: __WEBPACK_IMPORTED_MODULE_91__blocks_mymazda_redirect__["a" /* default */],
    MyMazdaVehicleResourceList: __WEBPACK_IMPORTED_MODULE_92__blocks_mymazda_vehicle_resource_list__["a" /* default */],
    MyMazdaVehicleServiceCarouselBlock: __WEBPACK_IMPORTED_MODULE_93__blocks_mymazda_service_carousel__["a" /* default */],
    MyMazdaVehicleServiceHistoryBlock: __WEBPACK_IMPORTED_MODULE_94__AtomicContainers_MyMazdaServiceHistory_MyMazdaServiceHistory__["a" /* default */],
    MyMazdaVehicleSummaryBlock: __WEBPACK_IMPORTED_MODULE_95__AtomicContainers_MyMazdaVehicleSummary_MyMazdaVehicleSummary__["a" /* default */],
    MyNewMazda: __WEBPACK_IMPORTED_MODULE_96__AtomicContainers_MyNewMazda_MyNewMazda__["a" /* default */],
    NameplateLink: __WEBPACK_IMPORTED_MODULE_34__components_nameplate_link__["a" /* default */],
    FilteredOffers: __WEBPACK_IMPORTED_MODULE_32__AtomicContainers_Offers_Offers__["a" /* default */],
    Offers: __WEBPACK_IMPORTED_MODULE_97__containers_offers__["a" /* default */],
    OfferFilterItem: __WEBPACK_IMPORTED_MODULE_98__AtomicContainers_OfferTile_OfferTile__["a" /* default */],
    OfferItem: __WEBPACK_IMPORTED_MODULE_99__containers_offers_offer_tile__["a" /* default */],
    OutletDetail: __WEBPACK_IMPORTED_MODULE_100__blocks_outlet_store_detail__["a" /* default */],
    OutletStore: __WEBPACK_IMPORTED_MODULE_101__containers_outlet_store__["a" /* default */],
    OutletStoreEnquiryForm: __WEBPACK_IMPORTED_MODULE_102__AtomicContainers_OutletStoreEnquiryForm_OutletStoreEnquiryForm__["a" /* default */],
    OutletStoreSpecificationsBlock: __WEBPACK_IMPORTED_MODULE_103__containers_outlet_store_specifications_block__["a" /* default */],
    Overlay: __WEBPACK_IMPORTED_MODULE_104__containers_overlay__["a" /* default */],
    PDFTemplate: __WEBPACK_IMPORTED_MODULE_105__AtomicContainers_PDFTemplate_PDFTemplate__["a" /* default */],
    PersonalisationBlockContainer: __WEBPACK_IMPORTED_MODULE_106__AtomicContainers_PersonalisationBlockContainer_PersonalisationBlockContainer__["a" /* default */],
    PersonalisationBlockItem: __WEBPACK_IMPORTED_MODULE_107__AtomicComponents_PersonalisationBlockItem_PersonalisationBlockItem__["a" /* default */],
    PostcodePopup: __WEBPACK_IMPORTED_MODULE_108__containers_postcode_popup__["a" /* default */],
    Price: __WEBPACK_IMPORTED_MODULE_109__AtomicContainers_Price_Price__["a" /* default */],
    RecallDocument: __WEBPACK_IMPORTED_MODULE_110__AtomicContainers_RecallDocument_RecallDocument__["a" /* default */],
    RecallsBlock: __WEBPACK_IMPORTED_MODULE_111__AtomicContainers_Recall_Recall__["a" /* default */],
    RegisterInterestForm: __WEBPACK_IMPORTED_MODULE_112__AtomicContainers_RegisterInterestForm_RegisterInterestForm__["a" /* default */],
    SaveForm: __WEBPACK_IMPORTED_MODULE_113__AtomicContainers_SaveForm_SaveForm__["a" /* default */],
    SaveShareCopy: __WEBPACK_IMPORTED_MODULE_114__AtomicContainers_SaveShareCopy_SaveShareCopy__["a" /* default */],
    ScrapedPage: __WEBPACK_IMPORTED_MODULE_115__containers_scraped_page__["a" /* default */],
    ServiceCalculatorOwner: __WEBPACK_IMPORTED_MODULE_116__containers_service_calculator_owner__["a" /* default */],
    ServiceCalculatorProspect: __WEBPACK_IMPORTED_MODULE_117__containers_service_calculator_prospect__["a" /* default */],
    ServiceDetailsFull: __WEBPACK_IMPORTED_MODULE_118__blocks_service_details_full__["a" /* default */],
    ShareForm: __WEBPACK_IMPORTED_MODULE_119__AtomicContainers_ShareForm_ShareForm__["a" /* default */],
    SingleDealerMapBlock: __WEBPACK_IMPORTED_MODULE_120__blocks_single_dealer_map__["a" /* default */],
    SiteSearchBlock: __WEBPACK_IMPORTED_MODULE_121__blocks_site_search__["a" /* default */],
    SixtyFourtyBlock: __WEBPACK_IMPORTED_MODULE_122__AtomicContainers_SixtyFourtyBlock_SixtyFourtyBlock__["a" /* default */],
    SocialIcons: __WEBPACK_IMPORTED_MODULE_123__AtomicComponents_SocialIcons_SocialIcons__["a" /* default */],
    SpecificationsBlock: __WEBPACK_IMPORTED_MODULE_124__AtomicContainers_SpecificationsBlock_SpecificationsBlock__["a" /* default */],
    Spotlight: __WEBPACK_IMPORTED_MODULE_125__AtomicComponents_Spotlight_Spotlight__["a" /* default */],
    StickySection: __WEBPACK_IMPORTED_MODULE_127__AtomicComponents_StickySection_StickySection__["a" /* default */],
    Testimonial: __WEBPACK_IMPORTED_MODULE_128__AtomicComponents_Testimonial_Testimonial__["a" /* default */],
    TimeClockVideoFrameBlock: __WEBPACK_IMPORTED_MODULE_129__blocks_time_clock_video_frame__["a" /* default */],
    ToutBlock: __WEBPACK_IMPORTED_MODULE_130__blocks_tout_block__["a" /* default */],
    TriggeredOverlay: __WEBPACK_IMPORTED_MODULE_131__containers_triggered_overlay__["a" /* default */],
    VehicleNotFoundPage: __WEBPACK_IMPORTED_MODULE_132__AtomicContainers_VehicleNotFoundPage_VehicleNotFoundPage__["a" /* default */],
    VideoPlayer: __WEBPACK_IMPORTED_MODULE_133__AtomicContainers_VideoPlayer_VideoPlayer__["a" /* default */],
    VideoSlideshow: __WEBPACK_IMPORTED_MODULE_134__components_video_slideshow__["a" /* default */],
    WysiwygContent: __WEBPACK_IMPORTED_MODULE_135__AtomicComponents_Content_Content__["a" /* default */]
  };
  return components["" + name];
};

/* harmony default export */ __webpack_exports__["a"] = (moduleImporter);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccessoryDetails_less__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccessoryDetails_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AccessoryDetails_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\AccessoryDetails\\AccessoryDetails.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var AccessoryDetails = function (_React$Component) {
  _inherits(AccessoryDetails, _React$Component);

  function AccessoryDetails() {
    _classCallCheck(this, AccessoryDetails);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  AccessoryDetails.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        name = _props.name,
        description = _props.description,
        generalDisclaimer = _props.generalDisclaimer,
        priceText = _props.priceText,
        packNumber = _props.packNumber,
        partNumber = _props.partNumber,
        _props$backUrl = _props.backUrl,
        backUrl = _props$backUrl === undefined ? '/accessories' : _props$backUrl,
        media = _props.media;


    var cookieHandlerObject = new __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_cookieHandler__["a" /* default */]();
    var history = cookieHandlerObject.getCookie("history");
    var found = false;

    if (history) {
      var newHistory = JSON.parse(history);

      if (newHistory && newHistory.length > 0) {
        if (newHistory[newHistory.length - 1].indexOf(backUrl) !== -1) {
          found = true;
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__AccessoryDetails_less___default.a.AccessoryDetails] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["i" /* BackButton */], {
        href: found ? 'javascript:history.back()' : backUrl,
        backText: "BACK TO ACCESSORIES",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["n" /* HeroContent */], {
        heading: "MAZDA " + (packNumber ? 'ACCESSORY PACKS' : 'ACCESSORIES'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 59
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
        { padding: true, center: false, __source: {
            fileName: _jsxFileName,
            lineNumber: 63
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["r" /* ColumnGroup */],
          { center: false, __source: {
              fileName: _jsxFileName,
              lineNumber: 64
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
            { horizontalPadding: true, center: false, __source: {
                fileName: _jsxFileName,
                lineNumber: 65
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 66
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["B" /* H4 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 67
                }
              },
              name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 70
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["D" /* H6 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 71
                }
              },
              priceText,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["i" /* Disclaimer */],
                { text: "*", __source: {
                    fileName: _jsxFileName,
                    lineNumber: 73
                  }
                },
                generalDisclaimer
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 77
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["t" /* Content */], { xmlString: description, textAlign: "left", __source: {
                fileName: _jsxFileName,
                lineNumber: 78
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 79
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 80
              }
            }),
            partNumber && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["l" /* Caption */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 82
                }
              },
              "PART NUMBER: ",
              partNumber
            ),
            packNumber && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["l" /* Caption */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 87
                }
              },
              "PACK NUMBER: ",
              packNumber
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__AccessoryDetails_less___default.a.width100] = true, _classnames2)), __source: {
                fileName: _jsxFileName,
                lineNumber: 92
              }
            },
            media && media.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["G" /* Slideshow */], {
              slides: media.map(function (item, index) {
                return {
                  name: "name-" + index,
                  imageSrc: item.imageUrl,
                  youtubeId: item.videoId,
                  youtubeLink: item.videoUrl
                };
              }),
              __source: {
                fileName: _jsxFileName,
                lineNumber: 96
              }
            }),
            media && media.length == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], { src: media[0].imageUrl, __source: {
                fileName: _jsxFileName,
                lineNumber: 108
              }
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114
        }
      })
    );
  };

  return AccessoryDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AccessoryDetails.displayName = "AccessoryDetails";


/* harmony default export */ __webpack_exports__["a"] = (AccessoryDetails);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\AccessoryList\\AccessoryList.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AccessoryList = function (_React$Component) {
  _inherits(AccessoryList, _React$Component);

  function AccessoryList() {
    _classCallCheck(this, AccessoryList);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  AccessoryList.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        description = _props.description,
        gtm = _props.gtm,
        linkText = _props.linkText,
        storeLink = _props.storeLink,
        accessories = _props.accessories;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_8" /* Section */],
      { padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["g" /* CardYoutubePlayerList */],
        {
          heading: title,
          numberOfColumns: 4,
          showCounting: false,
          description: description,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        },
        accessories && accessories.length > 0 && accessories.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["a" /* AccessoryItem */], {
            key: 'AccessoryItem-' + index,
            name: item.name,
            priceText: item.priceText,
            partNumber: item.partNumber,
            description: item.description,
            isPack: item.isPack,
            imageUrl: item.imageUrl,
            gtm: {
              category: gtm && gtm.category ? gtm.category : title,
              action: gtm && gtm.action ? gtm.action : "Accessories"
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 36
            }
          });
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        }
      }),
      storeLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["j" /* Button */], {
        styleName: 'blackOutlined',
        href: storeLink,
        label: linkText || "browse all accessories",
        gtm: gtm,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        }
      })
    );
  };

  return AccessoryList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AccessoryList.displayName = 'AccessoryList';


/* harmony default export */ __webpack_exports__["a"] = (AccessoryList);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccordionTextList_less__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccordionTextList_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AccordionTextList_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\AccordionTextList\\AccordionTextList.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AccordionTextList = function (_React$Component) {
  _inherits(AccordionTextList, _React$Component);

  function AccordionTextList() {
    _classCallCheck(this, AccordionTextList);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  AccordionTextList.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        data = _props.data,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? "box" : _props$styleName,
        components = _props.components,
        alwaysOpen = _props.alwaysOpen,
        gtm = _props.gtm;

    if (!components && (!data || data === "" || data === undefined)) return "";
    if (!data && components) {
      components.map(function (item) {
        if (item.props.gtm && item.props.gtm.category && item.props.gtm.action) return item;
        item.props.gtm = gtm;
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_4__AccordionTextList_less___default.a.AccordionTextList] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      data && !Array.isArray(data) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["b" /* AccordionText */],
        _extends({
          status: alwaysOpen ? 1 : 0,
          styleName: styleName,
          title: data.title,
          gtm: gtm
        }, data, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        }),
        data.description
      ),
      data && Array.isArray(data) && data.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["b" /* AccordionText */],
          _extends({
            status: alwaysOpen ? 1 : 0,
            styleName: styleName,
            key: "AccordionText-" + index,
            title: item.title,
            gtm: gtm
          }, item, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 39
            }
          }),
          item.description
        );
      }),
      !data && components && Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__["a" /* default */])(components)
    );
  };

  return AccordionTextList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AccordionTextList.displayName = "AccordionTextList";


/* harmony default export */ __webpack_exports__["a"] = (AccordionTextList);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_dateHandler__ = __webpack_require__(139);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\ArticlePreview\\ArticlePreview.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ArticlePreview = function (_React$Component) {
  _inherits(ArticlePreview, _React$Component);

  function ArticlePreview() {
    _classCallCheck(this, ArticlePreview);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ArticlePreview.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        imageUrl = _props.imageUrl,
        articleDate = _props.articleDate,
        preHeading = _props.preHeading,
        categories = _props.categories,
        articleUrl = _props.articleUrl,
        _props$featured = _props.featured,
        featured = _props$featured === undefined ? false : _props$featured,
        gtm = _props.gtm;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["m" /* Card */], {
      heading: title,
      imageSrc: imageUrl,
      note: new __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_dateHandler__["a" /* default */](articleDate).format('0D/0M/YYYY'),
      preHeading: preHeading || categories && categories.length && categories[0],
      onClick: function onClick() {
        new __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_urlHandler__["a" /* default */](articleUrl).redirect();
      },
      linkText: 'Read more',
      featured: featured,
      gtm: gtm,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22
      }
    });
  };

  return ArticlePreview;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ArticlePreview.displayName = 'ArticlePreview';


/* harmony default export */ __webpack_exports__["a"] = (ArticlePreview);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers_ArticlePage_ArticlePage__ = __webpack_require__(254);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\ArticleSelector\\ArticleSelector.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ALL_FILTER = "All stories";

var ArticleSelector = function (_Component) {
  _inherits(ArticleSelector, _Component);

  function ArticleSelector(props) {
    _classCallCheck(this, ArticleSelector);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChangeCategoryFilter = function (index) {
      _this.setState({ activeIndex: index });
    };

    _this.itemMatching = function (item) {
      var _this$state = _this.state,
          activeIndex = _this$state.activeIndex,
          categoryFilters = _this$state.categoryFilters;


      return activeIndex === categoryFilters.length - 1 || item.categories && item.categories.indexOf(categoryFilters[activeIndex].name) !== -1;
    };

    _this.state = {
      items: props.components,
      activeIndex: 0,
      categoryFilters: [{
        name: ALL_FILTER
      }]
    };
    return _this;
  }

  ArticleSelector.prototype.componentDidMount = function componentDidMount() {
    var components = this.props.components;

    var items = components ? components.filter(function (i) {
      return i.name === "ArticlePreview";
    }).map(function (i) {
      return i.props;
    }) : [];

    var catgoriesInProps = {};
    items.forEach(function (i) {
      i.categories.forEach(function (s) {
        catgoriesInProps[s] = true;
      });
    });

    this.setState({
      items: items,
      categoryFilters: [].concat(Object.keys(catgoriesInProps).map(function (name) {
        return { name: name };
      }), [{ name: ALL_FILTER }])
    });
  };

  ArticleSelector.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        summary = _props.summary,
        hero = _props.hero,
        backButton = _props.backButton;
    var _state = this.state,
        items = _state.items,
        categoryFilters = _state.categoryFilters,
        activeIndex = _state.activeIndex;

    var filteredData = items.filter(this.itemMatching);
    var featuredFilteredData = filteredData.filter(function (item) {
      return !!item.featured;
    });
    var nonFeaturedFilteredData = filteredData.filter(function (item) {
      return !item.featured;
    });
    var filteredHero = hero && hero.length && hero.filter(function (item) {
      return categoryFilters[activeIndex] && item.category === categoryFilters[activeIndex].name;
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        }
      },
      backButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers_ArticlePage_ArticlePage__["a" /* ArticleHeader */], { backUrl: backButton.href, backText: backButton.name, __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_8" /* Section */],
        { padding: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 67
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["z" /* H2 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 68
            }
          },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["t" /* Content */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          },
          summary
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 71
          }
        }),
        categoryFilters && categoryFilters.length > 2 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["I" /* Tabs */], {
          onClick: this.handleChangeCategoryFilter,
          activeIndex: activeIndex,
          animatedLine: true,
          dropdown: true,
          options: categoryFilters, __source: {
            fileName: _jsxFileName,
            lineNumber: 75
          }
        }),
        categoryFilters && categoryFilters.length > 2 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 85
          }
        }),
        filteredHero && filteredHero.length ? filteredHero.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_8" /* Section */],
            { gutter: true, key: "ArticleSelectorHero-" + index, __source: {
                fileName: _jsxFileName,
                lineNumber: 91
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 92
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_21" /* Visible */],
              { visible: ["screen"], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 93
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["k" /* FullWidthImageSection */],
                {
                  backgroundImage: item.imageUrl,
                  height: "medium",
                  align: "center",
                  textAlign: "center", __source: {
                    fileName: _jsxFileName,
                    lineNumber: 94
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["m" /* Heading */], {
                  white: true,
                  tag: "h4",
                  value: item.heading,
                  preHeading: item.preHeading, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 99
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_21" /* Visible */],
              { visible: ["tablet"], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 106
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["k" /* FullWidthImageSection */],
                {
                  backgroundImage: item.imageUrl,
                  height: "tall",
                  align: "center",
                  textAlign: "center", __source: {
                    fileName: _jsxFileName,
                    lineNumber: 107
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["m" /* Heading */], {
                  white: true,
                  tag: "h4",
                  value: item.heading,
                  preHeading: item.preHeading, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 112
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_21" /* Visible */],
              { visible: ["mobile"], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 119
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["k" /* FullWidthImageSection */],
                {
                  backgroundImage: item.imageUrl,
                  height: "widescreen",
                  align: "center",
                  textAlign: "center", __source: {
                    fileName: _jsxFileName,
                    lineNumber: 120
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["m" /* Heading */], {
                  white: true,
                  tag: "h4",
                  value: item.heading,
                  preHeading: item.preHeading, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 125
                  }
                })
              )
            )
          );
        }) : null,
        activeIndex !== categoryFilters.length - 1 && featuredFilteredData && featuredFilteredData.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["g" /* CardYoutubePlayerList */],
          {
            numberOfColumns: 4,
            showCounting: false,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 140
            }
          },
          featuredFilteredData.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["e" /* ArticlePreview */], _extends({}, item, { key: "ArticlePreviewFeatured-" + index, __source: {
                fileName: _jsxFileName,
                lineNumber: 144
              }
            }));
          })
        ) : null,
        nonFeaturedFilteredData && nonFeaturedFilteredData.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["g" /* CardYoutubePlayerList */],
          {
            numberOfColumns: 4,
            showCounting: false,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 151
            }
          },
          nonFeaturedFilteredData.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["e" /* ArticlePreview */], _extends({}, item, { key: "ArticlePreview-" + index, __source: {
                fileName: _jsxFileName,
                lineNumber: 155
              }
            }));
          })
        ) : null
      )
    );
  };

  return ArticleSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ArticleSelector.displayName = "ArticleSelector";


/* harmony default export */ __webpack_exports__["a"] = (ArticleSelector);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ServiceSummary__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InputSearchable_InputSearchable__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_dateHandler__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TITLES__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TIMES__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\BookServiceForm\\BookServiceForm.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var BookServiceForm = function (_React$Component) {
  _inherits(BookServiceForm, _React$Component);

  function BookServiceForm(props) {
    var _this2 = this;

    _classCallCheck(this, BookServiceForm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.serviceType = function () {
      var serviceOptions = _this.props.serviceOptions;


      try {
        // trying to guess MSS vs SPG service type
        // MSS factoryCode starts with 'S' and SPG starts with 'M' (yes, it's counterintuitive)
        if (serviceOptions && serviceOptions.serviceItems[0].basePrice === 0) {
          return 'COMP';
        } else if (serviceOptions && serviceOptions.serviceItems.some(function (si) {
          return si.factoryCodeEntity.code[0] === 'M';
        })) {
          return 'SPG';
        }
        return 'MSS';
      } catch (e) {
        if (false) console.log(e);
        return false;
      }
    };

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$props$buttonTex, buttonText, _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props$buttonTex = _this.props.buttonText, buttonText = _this$props$buttonTex === undefined ? "Request a service" : _this$props$buttonTex;

                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _this$props, submitServiceFormEndPoint, vehicleNotesForDealer, serviceOptions, _this$state2, form, asmc, serviceCode, asmcDescriptions, baseDescription, body;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this$props = _this.props, submitServiceFormEndPoint = _this$props.submitServiceFormEndPoint, vehicleNotesForDealer = _this$props.vehicleNotesForDealer, serviceOptions = _this$props.serviceOptions;
                          _this$state2 = _this.state, form = _this$state2.form, asmc = _this$state2.asmc, serviceCode = _this$state2.serviceCode;
                          asmcDescriptions = [];

                          serviceOptions && serviceOptions.serviceItems.forEach(function (item, index) {
                            asmc.forEach(function (addtionalItemCode) {
                              if (item.factoryCode === addtionalItemCode) {
                                asmcDescriptions.push(item);
                              }
                            });
                          });
                          baseDescription = serviceCode && serviceOptions && serviceOptions.serviceItems.find(function (_ref3) {
                            var factoryCode = _ref3.factoryCode;
                            return factoryCode === serviceCode;
                          });
                          body = {
                            nameplate: form.model.value,
                            vinRego: form.vinRego.value,
                            odometer: form.odometer.value || "0",
                            email: form.email.value,
                            comments: form.comments.value,
                            firstName: form.firstName.value,
                            lastName: form.lastName.value,
                            phone: form.phone.value,
                            title: form.title.value,
                            dealerLocation: form.dealer.value.id,
                            dealerCode: form.dealer.value.dealerCode,
                            postCode: form.dealer.value.postCode,
                            suburb: form.dealer.value.suburb,
                            state: form.dealer.value.state,
                            preferredDate: form.date.value && new __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_dateHandler__["a" /* default */](form.date.value).format('0D/0M/YYYY') || '',
                            preferredDropOffTime: form.dropOff.value,
                            preferredPickUpTime: form.pickUp.value,
                            modelCode: serviceOptions && serviceOptions.modelCode,
                            serviceSpecCode: serviceOptions && serviceOptions.serviceSpecCode,
                            vehicleNotesForDealer: vehicleNotesForDealer,
                            serviceOptions: baseDescription ? [baseDescription].concat(asmcDescriptions) : null
                          };
                          _context2.next = 8;
                          return Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: submitServiceFormEndPoint,
                            body: body
                          }).then(function () {
                            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "Request A Service Form",
                                            pageAction: "Request A Service Form - Clicked \"" + buttonText.toUpperCase() + "\""
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref4.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 8:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this._handleOnBlurSearchableRegion = function (value) {
      if (value && value.display) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Request A Service Form",
          pageAction: "Request A Service Form - Selected \"DEALER\" - \"" + value.display.toUpperCase() + "\""
        });
      }

      if (value && value.description) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Request A Service Form",
          pageAction: "Request A Service Form - Selected \"POSTCODE/SUBURB\" - \"" + value.description.toUpperCase() + "\""
        });
      }
    };

    _this.selectDealer = function (dealer) {
      // no search, use the selected dealer only for the radio inputs
      // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
      _this.refs.dealerSearchComp.setState({
        dealers: [dealer],
        selected: dealer,
        loading: false
      });
    };

    _this.state = {
      form: {
        model: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].MODEL_FREETEXT_REQUIRED
          }
        },
        vinRego: {
          validations: {}
        },
        odometer: {
          validations: {
            odometer: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].ODOMETER_INVALID
          }
        },
        title: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].TITLE_REQUIRED
          }
        },
        region: {
          validations: {}
        },
        dealer: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].DEALERS_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_REQUIRED,
            phone: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        comments: {
          validations: {}
        },
        date: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].DATE_REQUIRED
          }
        },
        dropOff: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].TIME_REQUIRED
          }
        },
        pickUp: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].TIME_REQUIRED
          }
        },
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        privacy: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_14_AtomicConstants_MESSAGES__["a" /* default */].PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  BookServiceForm.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        vinRego = _props.vinRego,
        vehicle = _props.vehicle,
        models = _props.models,
        initialLocations = _props.initialLocations;

    var currentURL = new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_constants_environment__["i" /* WINDOW */].location.href);

    if (vinRego) {
      Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, { vinRego: vinRego });
    }

    if (vehicle) {
      if (vehicle.nameplate) {
        Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, { model: vehicle.nameplate });
      }
      if (vehicle.vin) {
        Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, { vinRego: vehicle.vin });
      }
    }

    Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, { dropOff: "09:00 AM" });
    Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, { pickUp: "12:00 PM" });

    // Handling pre-selecting models
    var queryModel = this.props.model || currentURL.query.model;
    if (queryModel) {
      var model = models.find(function (item) {
        return item.name.split(/[^a-zA-Z0-9]+/).join('-').toLowerCase() === queryModel;
      });

      if (model && model.value) {
        Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
          model: String(model.value)
        });
      }
    }

    if (initialLocations && initialLocations[0] && initialLocations[0].postCode) {
      Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
        region: initialLocations[0].postCode
      });
    }

    var _currentURL$query = currentURL.query,
        serviceCode = _currentURL$query.serviceCode,
        asmc = _currentURL$query.asmc,
        isChangeItemsEnabled = _currentURL$query.isChangeItemsEnabled;

    this.setState({
      serviceCode: serviceCode,
      asmc: Array.isArray(asmc) ? asmc : [asmc], // Store asmc as an array even if there's 1 element for easier data conversion,
      isChangeItemsEnabled: isChangeItemsEnabled
    });
  };

  BookServiceForm.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props2 = this.props,
        title = _props2.title,
        introText = _props2.introText,
        privacyPolicy = _props2.privacyPolicy,
        privacyPolicyLink = _props2.privacyPolicyLink,
        _props2$buttonText = _props2.buttonText,
        buttonText = _props2$buttonText === undefined ? "Request A Service" : _props2$buttonText,
        serviceOptions = _props2.serviceOptions,
        serviceSummaryDescription = _props2.serviceSummaryDescription,
        vinRego = _props2.vinRego,
        _props2$initialLocati = _props2.initialLocations,
        initialLocations = _props2$initialLocati === undefined ? [] : _props2$initialLocati,
        thankYouComponents = _props2.thankYouComponents,
        _props2$dealersEndPoi = _props2.dealersEndPoint,
        dealersEndPoint = _props2$dealersEndPoi === undefined ? "/api/dealer-search" : _props2$dealersEndPoi,
        dealerSearchEndPoint = _props2.dealerSearchEndPoint;
    var _state = this.state,
        loading = _state.loading,
        form = _state.form,
        success = _state.success,
        errorMessage = _state.errorMessage,
        serviceCode = _state.serviceCode,
        asmc = _state.asmc,
        isChangeItemsEnabled = _state.isChangeItemsEnabled;


    if (success) {
      return Object(__WEBPACK_IMPORTED_MODULE_13_AtomicUtils_componentParser__["a" /* default */])(thankYouComponents);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_8" /* Section */],
      { padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 321
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less___default.a.BookServiceForm] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 322
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["A" /* H3 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 325
            }
          },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["t" /* Content */], { xmlString: introText, __source: {
            fileName: _jsxFileName,
            lineNumber: 326
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less___default.a.BookServiceFormForm] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 327
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "form",
            { method: "POST", onSubmit: this._handleSubmit, noValidate: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 330
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              { center: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 331
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 332
                  }
                },
                "About Your Mazda"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 337
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["S" /* InputText */], _extends({
                name: "model",
                label: "Model"
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "model"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Entered \"" + form.model.value + "\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 338
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 350
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["S" /* InputText */], _extends({
                name: "vinRego",
                label: "Registration/VIN"
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "vinRego"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Entered \"VINREGO\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 351
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 363
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["S" /* InputText */], _extends({
                name: "odometer",
                label: "Odometer"
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "odometer"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Entered \"" + form.odometer.value + "\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 364
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              { center: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 377
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 378
                  }
                },
                "About You"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 383
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["R" /* InputSelect */], _extends({
                name: "title",
                label: "Title",
                options: __WEBPACK_IMPORTED_MODULE_15__TITLES__["a" /* default */]
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "title"), {
                onBlur: function onBlur() {
                  if (form.title.value) {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Request A Service Form",
                      pageAction: "Request A Service Form - Selected \"TITLE\" - \"" + form.title.value.toUpperCase() + "\""
                    });
                  }
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 384
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 400
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["S" /* InputText */], _extends({
                name: "firstName",
                label: "First Name"
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Entered \"FIRSTNAME\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 401
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 413
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["S" /* InputText */], _extends({
                name: "lastName",
                label: "Last Name"
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "lastName"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Entered \"LASTNAME\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 414
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 426
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["S" /* InputText */], _extends({
                name: "phone",
                label: "Phone"
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "phone"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Entered \"PHONE\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 427
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 439
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["N" /* InputEmail */], _extends({
                name: "email",
                label: "Email"
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Entered \"EMAIL\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 440
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["C" /* H5 */],
              { textAlign: "center", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 464
                }
              },
              "Find a dealer"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 465
                }
              },
              "Select your region and we'll give you a list of your local Mazda Dealerships."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components__["n" /* DealerSearchBoxNZ */], {
              searchType: "SERVICE",
              noMap: true,
              selectDealerVariant: true,
              selectDealer: this.selectDealer,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 467
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 473
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["h" /* DealerSearch */], _extends({
                dealersEndPoint: dealersEndPoint,
                endpoint: dealerSearchEndPoint,
                disabled: !form.region.value || !(form.region.value.postcode || form.region.value.value),
                type: "Service",
                name: "dealer",
                postcode: form.region.value && form.region.value.postcode || initialLocations && initialLocations[0] && initialLocations[0].postCode,
                dealerCode: form.region.value && form.region.value.value,
                ref: "dealerSearchComp"
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "dealer"), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 474
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              { center: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 486
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 487
                  }
                },
                "Your Service Requirements"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 492
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["r" /* InputDate */], _extends({
                name: "date",
                label: "Preferred Date"
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "date"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Entered \"DATE\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 493
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 505
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["R" /* InputSelect */], _extends({
                name: "dropOff",
                label: "Preferred Drop Off Time",
                options: __WEBPACK_IMPORTED_MODULE_16__TIMES__["a" /* default */]
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "dropOff"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Selected \"DROP OFF TIME\" - \"" + form.dropOff.value + "\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 506
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 519
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["R" /* InputSelect */], _extends({
                name: "pickUp",
                label: "Preferred Pick Up Time",
                options: __WEBPACK_IMPORTED_MODULE_16__TIMES__["a" /* default */]
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "pickUp"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Selected \"DROP OFF TIME\" - \"" + form.pickUp.value + "\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 520
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 533
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["S" /* InputText */], _extends({
                name: "comments",
                label: "Tell us your enquiry"
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "comments"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Request A Service Form",
                    pageAction: "Request A Service Form - Entered \"ENQUIRY\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 534
                }
              }))
            ),
            serviceCode && serviceOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 550
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ServiceSummary__["a" /* default */], {
                serviceType: this.serviceType,
                serviceData: serviceOptions && serviceOptions.serviceItems,
                serviceCode: serviceCode,
                vinRego: vinRego,
                asmc: asmc,
                isChangeItemsDisable: isChangeItemsEnabled === 'false',
                serviceSummaryDescription: serviceSummaryDescription, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 551
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 561
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              { show: true, checkbox: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 562
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["M" /* InputCheckBox */], _extends({
                name: "privacy",
                label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 566
                    }
                  },
                  privacyPolicy,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["a" /* A */],
                    {
                      href: privacyPolicyLink,
                      onClick: function onClick() {
                        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                          pageCategory: "Request A Service Form",
                          pageAction: "Request A Service Form - Clicked \"PRIVACYPOLICY\""
                        });
                      },
                      external: true, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 568
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "nobr",
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 577
                        }
                      },
                      "Privacy Policy"
                    )
                  )
                )
              }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "privacy", function () {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Request A Service Form",
                  pageAction: "Request A Service Form - Checked \"PRIVACYPOLICY\""
                });
              }), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 563
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 589
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 590
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 591
                }
              },
              errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 593
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["j" /* Button */],
                _extends({
                  styleName: "black",
                  loading: loading,
                  fullWidth: true
                }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 595
                  }
                }),
                buttonText
              )
            )
          )
        )
      )
    );
  };

  return BookServiceForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BookServiceForm.displayName = "BookServiceForm";


/* harmony default export */ __webpack_exports__["a"] = (BookServiceForm);

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BookServiceForm":"BookServiceForm__BookServiceForm___3Mze8","BookServiceFormForm":"BookServiceForm__BookServiceFormForm___2TX2y","ServiceSummary":"BookServiceForm__ServiceSummary___3nI8m","ServiceSummaryPrice":"BookServiceForm__ServiceSummaryPrice___2OckN"};

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_config__ = __webpack_require__(199);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var googleAutoComplete = function googleAutoComplete() {
  var _this = this;

  _classCallCheck(this, googleAutoComplete);

  this._init = function () {
    if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document && !__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].googleScript) {
      __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].googleScript = true;
      var script = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=" + __WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* GOOGLE_MAPS_API_KEY */] + "&libraries=places";
      __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document.body.appendChild(script);
    } else {
      setTimeout(function () {
        _this._init();
      }, 100);
    }
  };

  this.searchPostcode = function () {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    if (input === "" || !input) return;
    if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].google && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].googleScript) {
      var service = new __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].google.maps.places.AutocompleteService();
      console.log('places prediction');
      console.log(input);
      return service.getPlacePredictions({
        input: input,
        types: ["(regions)"],
        componentRestrictions: {
          country: "nz"
        }
      }, callback);
    } else {
      setTimeout(function () {
        _this.searchPostcode(input, callback);
      }, 100);
    }
  };

  this.searchAddress = function () {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].google && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].googleScript) {
      var service = new __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].google.maps.places.AutocompleteService();
      return service.getPlacePredictions({
        input: input,
        types: ["address"],
        componentRestrictions: {
          country: "nz"
        }
      }, callback);
    } else {
      setTimeout(function () {
        _this.searchAddress(input, callback);
      }, 100);
    }
  };

  this.getPostcode = function () {
    var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].google && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].googleScript) {

      var geocoder = new google.maps.Geocoder();
      return geocoder.geocode({
        "address": address
      }, callback);
    } else {
      setTimeout(function () {
        _this.getPostcode(address, callback);
      }, 100);
    }
  };

  this.getPlaceUsingPlaceId = function (placeId) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    console.log('placeId');

    if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].google && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].googleScript) {
      var geocoder = new google.maps.Geocoder();
      return geocoder.geocode({
        "placeId": placeId
      }, callback);
    } else {
      setTimeout(function () {
        _this.getPostcodeUsingLatLong(address, callback);
      }, 100);
    }
  };

  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].google || !__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].google.maps || !__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].google.maps.places || !__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].google.maps.places.AutocompleteService) {
    this._init();
  } else {
    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].googleScript = true;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (googleAutoComplete);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookTestDrive_less__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookTestDrive_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BookTestDrive_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputSearchable_InputSearchable__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TITLES__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\BookTestDrive\\BookTestDrive.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var BookTestDrive = function (_React$Component) {
  _inherits(BookTestDrive, _React$Component);

  function BookTestDrive(props) {
    var _this2 = this;

    _classCallCheck(this, BookTestDrive);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$props, financeOptionText, _this$props$buttonTex, buttonText, _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = _this.props, financeOptionText = _this$props.financeOptionText, _this$props$buttonTex = _this$props.buttonText, buttonText = _this$props$buttonTex === undefined ? "Book your test drive" : _this$props$buttonTex;

                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var submitFormEndPoint, form, body;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          submitFormEndPoint = _this.props.submitFormEndPoint;
                          form = _this.state.form;
                          body = {
                            title: form.title.value,
                            firstName: form.firstName.value,
                            lastName: form.lastName.value,
                            phone: form.phone.value,
                            email: form.email.value,
                            nameplate: form.model.value,
                            dealerLocation: form.dealer.value.id,
                            dealerCode: form.dealer.value.dealerCode,
                            postCode: form.dealer.value.postCode,
                            suburb: form.dealer.value.suburb,
                            state: form.dealer.value.state,
                            financeInterest: financeOptionText ? form.finance.value === true ? 'Yes' : null : undefined,
                            comments: form.comments.value || null
                          };
                          _context2.next = 5;
                          return Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: submitFormEndPoint,
                            body: body
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "Book A Test Drive Form",
                                            pageAction: "Book A Test Drive Form - Clicked \"" + buttonText.toUpperCase() + "\""
                                          });
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "Book A Test Drive Form",
                                            pageAction: "Book A Test Drive Form - Clicked Submitted - \"" + form.model.value + "\""
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this._handleOnBlurSearchableRegion = function (value) {
      if (value && value.display) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Book A Test Drive Form",
          pageAction: "Book A Test Drive Form - Selected \"DEALER\" - \"" + value.display.toUpperCase() + "\""
        });
      }

      if (value && value.description) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Book A Test Drive Form",
          pageAction: "Book A Test Drive Form - Selected \"POSTCODE/SUBURB\" - \"" + value.description.toUpperCase() + "\""
        });
      }
    };

    _this.selectDealer = function (dealer) {
      // no search, use the selected dealer only for the radio inputs
      // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
      _this.refs.dealerSearchComp.setState({
        dealers: [dealer],
        selected: dealer,
        loading: false
      });
    };

    _this.state = {
      form: {
        title: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__["a" /* default */].TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__["a" /* default */].LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_REQUIRED,
            phone: __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        model: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__["a" /* default */].MODEL_REQUIRED
          }
        },
        region: {
          validations: {}
        },
        dealer: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__["a" /* default */].DEALERS_REQUIRED
          }
        },
        comments: {
          validations: {}
        },
        finance: {
          validations: {}
        },
        privacy: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_12_AtomicConstants_MESSAGES__["a" /* default */].PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  BookTestDrive.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        models = _props.models,
        initialLocations = _props.initialLocations;

    var currentURL = new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_11_constants_environment__["i" /* WINDOW */].location.href);

    // Handling pre-selecting models
    if (currentURL.query.model) {
      var queryModel = currentURL.query.model;
      var model = models.find(function (item) {
        return item.name.split(/[^a-zA-Z0-9]+/).join('-').toLowerCase() === queryModel;
      });

      if (model && model.value) {
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
          model: String(model.value)
        });
      }
    }

    if (initialLocations && initialLocations[0] && initialLocations[0].postCode) {
      Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
        region: initialLocations[0].postCode
      });
    }
  };

  BookTestDrive.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props2 = this.props,
        title = _props2.title,
        introText = _props2.introText,
        models = _props2.models,
        privacyPolicy = _props2.privacyPolicy,
        privacyPolicyLink = _props2.privacyPolicyLink,
        _props2$dealersEndPoi = _props2.dealersEndPoint,
        dealersEndPoint = _props2$dealersEndPoi === undefined ? "/api/dealer-search" : _props2$dealersEndPoi,
        dealerSearchEndPoint = _props2.dealerSearchEndPoint,
        _props2$buttonText = _props2.buttonText,
        buttonText = _props2$buttonText === undefined ? "Book your test drive" : _props2$buttonText,
        _props2$initialLocati = _props2.initialLocations,
        initialLocations = _props2$initialLocati === undefined ? [] : _props2$initialLocati,
        financeOptionText = _props2.financeOptionText,
        thankYouComponents = _props2.thankYouComponents;
    var _state = this.state,
        loading = _state.loading,
        form = _state.form,
        success = _state.success,
        errorMessage = _state.errorMessage;


    if (success) {
      return Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_componentParser__["a" /* default */])(thankYouComponents);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_8" /* Section */],
      { padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 212
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__BookTestDrive_less___default.a.BookTestDrive] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 213
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["A" /* H3 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 216
            }
          },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { xmlString: introText, __source: {
            fileName: _jsxFileName,
            lineNumber: 217
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__BookTestDrive_less___default.a.BookTestDriveForm] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 218
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "form",
            { method: "POST", onSubmit: this._handleSubmit, noValidate: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 221
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              { center: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 222
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 223
                  }
                },
                "CHOOSE YOUR MAZDA"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 225
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["R" /* InputSelect */], _extends({
                name: "model",
                label: "Model",
                options: models.map(function (_ref4) {
                  var name = _ref4.name,
                      value = _ref4.value;
                  return { label: name, value: value };
                })
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "model"), {
                onBlur: function onBlur() {
                  form.model.value && Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Book A Test Drive Form",
                    pageAction: "Book A Test Drive Form - Selected \"MODEL\" - \"" + form.model.value.toUpperCase() + "\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 226
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              { center: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 240
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 241
                  }
                },
                "ENTER YOUR DETAILS"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 243
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["R" /* InputSelect */], _extends({
                name: "title",
                label: "Title",
                options: __WEBPACK_IMPORTED_MODULE_13__TITLES__["a" /* default */]
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "title"), {
                onBlur: function onBlur() {
                  if (form.title.value) {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Book A Test Drive Form",
                      pageAction: "Book A Test Drive Form - Selected \"TITLE\" - \"" + form.title.value.toUpperCase() + "\""
                    });
                  }
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 244
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 259
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["S" /* InputText */], _extends({
                name: "firstName",
                label: "First Name"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Book A Test Drive Form",
                    pageAction: "Book A Test Drive Form - Entered \"FIRSTNAME\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 260
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 272
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["S" /* InputText */], _extends({
                name: "lastName",
                label: "Last Name"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "lastName"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Book A Test Drive Form",
                    pageAction: "Book A Test Drive Form - Entered \"LASTNAME\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 273
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 285
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["S" /* InputText */], _extends({
                name: "phone",
                label: "Phone"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "phone"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Book A Test Drive Form",
                    pageAction: "Book A Test Drive Form - Entered \"PHONE\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 286
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 298
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["N" /* InputEmail */], _extends({
                name: "email",
                label: "Email"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Book A Test Drive Form",
                    pageAction: "Book A Test Drive Form - Entered \"EMAIL\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 299
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
              { textAlign: "center", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 322
                }
              },
              "Find a dealer"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_1" /* P */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 323
                }
              },
              "Select your region and we'll give you a list of your local Mazda Dealerships."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components__["n" /* DealerSearchBoxNZ */], {
              searchType: "SALES",
              noMap: true,
              selectDealerVariant: true,
              selectDealer: this.selectDealer,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 325
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 331
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["h" /* DealerSearch */], _extends({
                dealersEndPoint: dealersEndPoint,
                endpoint: dealerSearchEndPoint,
                disabled: !form.region.value || !(form.region.value.postcode || form.region.value.value),
                type: "Sales",
                name: "dealer",
                postcode: form.region.value && form.region.value.postcode || initialLocations && initialLocations[0] && initialLocations[0].postCode,
                dealerCode: form.region.value && form.region.value.value,
                ref: "dealerSearchComp"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "dealer"), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 332
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 343
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["S" /* InputText */], _extends({
                name: "comments",
                label: "Tell us your enquiry"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "comments"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Book A Test Drive Form",
                    pageAction: "Book A Test Drive Form - Entered \"ENQUIRY\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 344
                }
              }))
            ),
            financeOptionText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              { show: true, checkbox: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 358
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["M" /* InputCheckBox */], _extends({
                name: "finance",
                label: financeOptionText
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "finance", function (value) {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Book A Test Drive Form",
                  pageAction: "Book A Test Drive Form - " + (value ? 'Checked' : 'Unchecked') + " \"FINANCE\""
                });
              }), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 359
                }
              }))
            ),
            financeOptionText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              { show: true, checkbox: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 373
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: { height: "1px", width: "100%", border: "0", borderTop: "1px solid #D5D5D5" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 374
                }
              })
            ),
            !financeOptionText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 377
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 378
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              { show: true, checkbox: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 379
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["M" /* InputCheckBox */], _extends({
                name: "privacy",
                label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 383
                    }
                  },
                  privacyPolicy,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["a" /* A */],
                    {
                      href: privacyPolicyLink,
                      onClick: function onClick() {
                        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                          pageCategory: "Book A Test Drive Form",
                          pageAction: "Book A Test Drive Form - Clicked \"PRIVACYPOLICY\""
                        });
                      },
                      external: true, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 385
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "nobr",
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 394
                        }
                      },
                      "Privacy Policy"
                    )
                  )
                )
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "privacy", function (value) {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Book A Test Drive Form",
                  pageAction: "Book A Test Drive Form - " + (value ? 'Checked' : 'Unchecked') + " \"PRIVACYPOLICY\""
                });
              }), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 380
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 406
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 407
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 408
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 409
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */],
                _extends({
                  styleName: "black",
                  loading: loading,
                  fullWidth: true
                }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 410
                  }
                }),
                buttonText
              )
            )
          )
        )
      )
    );
  };

  return BookTestDrive;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BookTestDrive.displayName = "BookTestDrive";


/* harmony default export */ __webpack_exports__["a"] = (BookTestDrive);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BrowserWarning_less__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BrowserWarning_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BrowserWarning_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_oldBrowserDetector__ = __webpack_require__(1128);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\BrowserWarning\\BrowserWarning.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var BrowserWarning = function (_React$Component) {
  _inherits(BrowserWarning, _React$Component);

  function BrowserWarning(props) {
    _classCallCheck(this, BrowserWarning);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleClose = function () {
      _this.setState({
        showBrowserWarning: false
      }, function () {
        __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["i" /* WINDOW */].sessionStorage.setItem('BrowserWarning', 'visible');
      });
    };

    _this.state = {
      showBrowserWarning: false
    };
    return _this;
  }

  BrowserWarning.prototype.componentDidMount = function componentDidMount() {
    if (__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["i" /* WINDOW */]) {
      if (Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_oldBrowserDetector__["a" /* default */])() && !__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["i" /* WINDOW */].sessionStorage.getItem("BrowserWarning")) {
        this.setState({
          showBrowserWarning: true
        });
      }
    }
  };

  BrowserWarning.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6;

    var showBrowserWarning = this.state.showBrowserWarning;
    var warningMessage = this.props.warningMessage;


    if (!showBrowserWarning) return null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_4__BrowserWarning_less___default.a.BrowserWarning] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 47
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_4__BrowserWarning_less___default.a.closeButton] = true, _classnames2)),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 50
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["k" /* ButtonIcon */],
          {
            onClick: this._handleClose,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 55
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["u" /* CrossIcon */], { style: {
              width: "15px",
              height: "15px"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 58
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_4__BrowserWarning_less___default.a.TitleSection] = true, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 64
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_4__BrowserWarning_less___default.a.Icon] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 67
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["d" /* AlertIcon */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 70
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_4__BrowserWarning_less___default.a.Title] = true, _classnames5)), __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["A" /* H3 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 75
              }
            },
            "Please update your web browser"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_4__BrowserWarning_less___default.a.ContentSection] = true, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 80
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], {
          textAlign: 'center',
          xmlString: warningMessage,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 83
          }
        })
      )
    );
  };

  return BrowserWarning;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrowserWarning.displayName = "BrowserWarning";


/* harmony default export */ __webpack_exports__["a"] = (BrowserWarning);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__ = __webpack_require__(47);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\CardYoutubePlayerList\\CardYoutubePlayerList.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var CardYoutubePlayerList = function (_React$Component) {
  _inherits(CardYoutubePlayerList, _React$Component);

  function CardYoutubePlayerList(props) {
    _classCallCheck(this, CardYoutubePlayerList);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var _props$numberOfColumn = props.numberOfColumns,
        numberOfColumns = _props$numberOfColumn === undefined ? 3 : _props$numberOfColumn;


    var widthOfCard = 350;
    if (numberOfColumns === 3) widthOfCard = 350;
    if (numberOfColumns === 4) widthOfCard = 280;

    _this.state = {
      widthOfCard: widthOfCard,
      arrowLeft: false,
      arrowRight: false,
      centerScrolling: false
    };
    return _this;
  }

  CardYoutubePlayerList.prototype.componentDidMount = function componentDidMount() {
    // check for arrows
    var _props = this.props,
        scrolling = _props.scrolling,
        _props$showArrows = _props.showArrows,
        showArrows = _props$showArrows === undefined ? true : _props$showArrows;

    if (scrolling && showArrows) {
      this._checkForArrow({ reset: false });
      __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].addEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__["a" /* default */])(this._checkForArrow, 250));
    }
  };

  CardYoutubePlayerList.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].removeEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__["a" /* default */])(this._checkForArrow, 250));
  };

  CardYoutubePlayerList.prototype.render = function render() {
    var _classnames,
        _this2 = this,
        _classnames2,
        _classnames3,
        _classnames6,
        _classnames7;

    var _props2 = this.props,
        _props2$components = _props2.components,
        components = _props2$components === undefined ? [] : _props2$components,
        heading = _props2.heading,
        description = _props2.description,
        imageSrc = _props2.imageSrc,
        _props2$showCounting = _props2.showCounting,
        showCounting = _props2$showCounting === undefined ? true : _props2$showCounting,
        _props2$showArrows = _props2.showArrows,
        showArrows = _props2$showArrows === undefined ? true : _props2$showArrows,
        _props2$scrolling = _props2.scrolling,
        scrolling = _props2$scrolling === undefined ? false : _props2$scrolling,
        _props2$numberOfColum = _props2.numberOfColumns,
        numberOfColumns = _props2$numberOfColum === undefined ? 3 : _props2$numberOfColum,
        _props2$children = _props2.children,
        children = _props2$children === undefined ? [] : _props2$children,
        gtm = _props2.gtm;
    var _state = this.state,
        widthOfCard = _state.widthOfCard,
        arrowLeft = _state.arrowLeft,
        arrowRight = _state.arrowRight,
        centerScrolling = _state.centerScrolling;


    var length = components && components.length > 0 && components.length || children.length;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerList] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 120
        }
      },
      (heading || description || imageSrc || showCounting) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["n" /* HeroContent */], {
        heading: heading,
        description: description,
        imageSrc: imageSrc,
        details: showCounting && "Showing " + length + " items", __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          ref: function ref(c) {
            return _this2.listParent = c;
          },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerListRoot] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            ref: function ref(c) {
              return _this2.list = c;
            },
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerListView] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerListViewScrolling] = scrolling, _classnames3[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerListViewCenterScrolling] = centerScrolling, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 139
            }
          },
          components && components.length > 0 && Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])(components, { gtm: gtm }, undefined, false).map(function (item, index) {
            var _classnames4;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                key: "CardYoutubePlayer-" + index,
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerListViewItem] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerListViewItemFour] = numberOfColumns === 4, _classnames4[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerListViewItemFeatured] = item.props.featured, _classnames4)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 150
                }
              },
              item
            );
          }),
          children && children.length > 0 && children.map(function (item, index) {
            var _classnames5;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                key: "CardYoutubePlayer-" + index,
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerListViewItem] = true, _classnames5[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerListViewItemFour] = numberOfColumns === 4, _classnames5[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.CardYoutubePlayerListViewItemFeatured] = item.props.featured, _classnames5)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 165
                }
              },
              item
            );
          })
        ),
        scrolling && showArrows && arrowRight && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.Arrow] = true, _classnames6[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.ArrowRight] = true, _classnames6)), __source: {
              fileName: _jsxFileName,
              lineNumber: 178
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["k" /* ButtonIcon */],
            {
              onClick: this._handleRightClick,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 182
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["h" /* ArrowRightThinIcon */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 185
              }
            })
          )
        ),
        scrolling && showArrows && arrowLeft && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.Arrow] = true, _classnames7[__WEBPACK_IMPORTED_MODULE_6__CardYoutubePlayerList_less___default.a.ArrowLeft] = true, _classnames7)), __source: {
              fileName: _jsxFileName,
              lineNumber: 190
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["k" /* ButtonIcon */],
            {
              onClick: this._handleLeftClick,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 194
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["f" /* ArrowLeftThinIcon */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 197
              }
            })
          )
        )
      )
    );
  };

  return CardYoutubePlayerList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this._checkForArrow = function (_ref) {
    var _ref$reset = _ref.reset,
        reset = _ref$reset === undefined ? true : _ref$reset;

    setTimeout(function () {
      if (_this3.list && _this3.listParent) {
        var widthOfCard = _this3.state.widthOfCard;

        var maxMarginLeftPossible = _this3.list.scrollWidth - _this3.listParent.offsetWidth;
        var currentMarginLeft = Number(_this3.list.style.marginLeft.replace('px', '')) * -1;
        var unitSize = widthOfCard + 16;
        if (_this3.list.scrollWidth <= _this3.listParent.offsetWidth) {
          _this3.setState({
            arrowLeft: false,
            arrowRight: false,
            centerScrolling: true
          });
        } else {
          _this3.setState({
            arrowLeft: currentMarginLeft > 0,
            arrowRight: currentMarginLeft < maxMarginLeftPossible,
            centerScrolling: false
          });
        }
        if (reset) _this3.list.style.marginLeft = "0px";
      }
    }, 10);
  };

  this._handleRightClick = function () {
    var widthOfCard = _this3.state.widthOfCard;

    var unitSize = widthOfCard + 16;
    var maxMarginLeftPossible = _this3.list.scrollWidth - _this3.listParent.offsetWidth;
    var currentMarginLeft = Number(_this3.list.style.marginLeft.replace('px', '')) * -1;

    if (currentMarginLeft <= maxMarginLeftPossible - unitSize) {
      _this3.list.style.marginLeft = "-" + (currentMarginLeft + unitSize) + "px";
    } else {
      _this3.list.style.marginLeft = "-" + maxMarginLeftPossible + "px";
    }
    _this3._checkForArrow({ reset: false });
  };

  this._handleLeftClick = function () {
    var widthOfCard = _this3.state.widthOfCard;

    var unitSize = widthOfCard + 16;
    var currentMarginLeft = Number(_this3.list.style.marginLeft.replace('px', '')) * -1;

    if (currentMarginLeft > unitSize) {
      _this3.list.style.marginLeft = "-" + (currentMarginLeft - unitSize) + "px";
    } else {
      _this3.list.style.marginLeft = "0px";
    }
    _this3._checkForArrow({ reset: false });
  };
};

CardYoutubePlayerList.displayName = "CardYoutubePlayerList";


/* harmony default export */ __webpack_exports__["a"] = (CardYoutubePlayerList);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ColorPicker_less__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ColorPicker_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ColorPicker_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_componentParser__ = __webpack_require__(14);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\ColorPicker\\ColorPicker.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ColorPicker = function (_React$PureComponent) {
  _inherits(ColorPicker, _React$PureComponent);

  function ColorPicker(props) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._handleOnClickBodyStyle = function (index) {
      var _this$props = _this.props,
          gtm = _this$props.gtm,
          _this$props$bodyStyle = _this$props.bodyStyles,
          bodyStyles = _this$props$bodyStyle === undefined ? [] : _this$props$bodyStyle;

      _this.setState({
        bodyStyleIndex: index,
        colorIndex: 0
      }, function () {
        if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
          Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__["a" /* default */])({
            pageCategory: gtm.category,
            pageAction: gtm.action + " - Clicked \"" + bodyStyles[index].name + "\""
          });
        }
      });
    };

    _this._handleChangeColor = function (index) {
      var _this$props2 = _this.props,
          gtm = _this$props2.gtm,
          _this$props2$bodyStyl = _this$props2.bodyStyles,
          bodyStyles = _this$props2$bodyStyl === undefined ? [] : _this$props2$bodyStyl;
      var bodyStyleIndex = _this.state.bodyStyleIndex;

      _this.setState({
        colorIndex: index
      }, function () {
        if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
          Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__["a" /* default */])({
            pageCategory: gtm.category,
            pageAction: gtm.action + " - Clicked \"" + bodyStyles[bodyStyleIndex].colors[index].name + "\" - \"" + bodyStyles[bodyStyleIndex].name + "\""
          });
        }
      });
    };

    _this.state = {
      bodyStyleIndex: 0,
      colorIndex: 0
    };
    _this.ColorPicker = {};
    return _this;
  }

  ColorPicker.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames6;

    var _props = this.props,
        heading = _props.heading,
        description = _props.description,
        _props$bodyStyles = _props.bodyStyles,
        bodyStyles = _props$bodyStyles === undefined ? [] : _props$bodyStyles,
        components = _props.components;
    var _props2 = this.props,
        _props2$mobileHeading = _props2.mobileHeading,
        mobileHeading = _props2$mobileHeading === undefined ? heading : _props2$mobileHeading,
        _props2$mobileDescrip = _props2.mobileDescription,
        mobileDescription = _props2$mobileDescrip === undefined ? description : _props2$mobileDescrip;
    var _state = this.state,
        bodyStyleIndex = _state.bodyStyleIndex,
        colorIndex = _state.colorIndex;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__ColorPicker_less___default.a.ColorPicker] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 82
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 85
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_21" /* Visible */],
          { visible: ["screen", "tablet"], __source: {
              fileName: _jsxFileName,
              lineNumber: 86
            }
          },
          (heading || description) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["n" /* HeroContent */], {
            heading: heading,
            description: description, __source: {
              fileName: _jsxFileName,
              lineNumber: 88
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_21" /* Visible */],
          { visible: ["mobile"], __source: {
              fileName: _jsxFileName,
              lineNumber: 93
            }
          },
          (mobileHeading || mobileDescription) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["n" /* HeroContent */], {
            heading: mobileHeading,
            description: mobileDescription, __source: {
              fileName: _jsxFileName,
              lineNumber: 95
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__ColorPicker_less___default.a.Container] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 101
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__ColorPicker_less___default.a.Tabs] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 104
            }
          },
          bodyStyles && bodyStyles.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["I" /* Tabs */], {
            onClick: this._handleOnClickBodyStyle,
            scrolling: true,
            divider: true,
            options: bodyStyles.map(function (item) {
              return {
                name: item.name
              };
            }),
            __source: {
              fileName: _jsxFileName,
              lineNumber: 108
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["I" /* Tabs */],
            { scrolling: true, onClick: this._handleChangeColor, __source: {
                fileName: _jsxFileName,
                lineNumber: 119
              }
            },
            bodyStyles[bodyStyleIndex].colors.map(function (item, index) {
              var _classnames4, _classnames5;

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__ColorPicker_less___default.a.ColorIcon] = true, _classnames4)),
                  key: "colorIcon-" + bodyStyleIndex + "-" + index,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 122
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["q" /* ColorIcon */], { color: item.hex, active: colorIndex === index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 128
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_3__ColorPicker_less___default.a.Tooltip] = true, _classnames5)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 129
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["J" /* Tooltip */],
                    { size: "small", position: "bottomCenter", closeIcon: false, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 133
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
                      { withoutMargin: true, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 134
                        }
                      },
                      item.name
                    )
                  )
                )
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 144
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_21" /* Visible */],
            { visible: ["mobile"], __source: {
                fileName: _jsxFileName,
                lineNumber: 145
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { textAlign: 'center', width: '100%' }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 146
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 147
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 148
                  }
                },
                bodyStyles[bodyStyleIndex].colors[colorIndex].name
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 154
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 155
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 156
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["s" /* Container */],
            { styleName: "tablet-wide", __source: {
                fileName: _jsxFileName,
                lineNumber: 157
              }
            },
            bodyStyles && typeof bodyStyles[bodyStyleIndex].colors[colorIndex].src === "string" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], {
              loadingTheme: "light",
              src: bodyStyles[bodyStyleIndex].colors[colorIndex].src,
              type: "spinner",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 160
              }
            }),
            bodyStyles && typeof bodyStyles[bodyStyleIndex].colors[colorIndex].src !== "string" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["q" /* ImagesRotator */], {
              imagesSrc: bodyStyles[bodyStyleIndex].colors[colorIndex].src,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 168
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_3__ColorPicker_less___default.a.Children] = true, _classnames6)), __source: {
              fileName: _jsxFileName,
              lineNumber: 174
            }
          },
          components && Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_componentParser__["a" /* default */])(components)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 179
          }
        })
      )
    );
  };

  return ColorPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

ColorPicker.displayName = "ColorPicker";


/* harmony default export */ __webpack_exports__["a"] = (ColorPicker);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CompetitionForm_less__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CompetitionForm_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CompetitionForm_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TITLES__ = __webpack_require__(1133);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\CompetitionForm\\CompetitionForm.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var CompetitionForm = function (_React$Component) {
  _inherits(CompetitionForm, _React$Component);

  function CompetitionForm(props) {
    var _this2 = this;

    _classCallCheck(this, CompetitionForm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleOptInChange = function () {
      var bodyStyles = _this.props.bodyStyles;
      var form = _this.state.form;


      if (form.optedInDealer.value === "Yes" && bodyStyles && bodyStyles.length) {
        Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this, "bodyStyle", { required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].BODYSTYLE_REQUIRED });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this, "bodyStyle", {});
      }

      if (form && form.optedInDealer && form.optedInDealer.value) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Competition Form",
          pageAction: "Competition Form - Selected \"OPTIN\" - \"" + form.optedInDealer.value.toUpperCase() + "\""
        });
      }
    };

    _this._handleBodyStyleChange = function () {
      var form = _this.state.form;


      if (form && form.bodyStyle && form.bodyStyle.value) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Competition Form",
          pageAction: "Competition Form - Selected \"BODYSTYLE\" - \"" + form.bodyStyle.value.toUpperCase() + "\""
        });
      }
    };

    _this._handleOnBlurSearchableRegion = function () {
      var form = _this.state.form;

      if (form && form.region && form.region.value && form.region.value.description) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Competition Form",
          pageAction: "Competition Form - Selected \"POSTCODE/SUBURB\" - \"" + form.region.value.description.toUpperCase() + "\""
        });
      }
    };

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form, _this$props, submitFormEndpoint, title, _this$props$nameplate, nameplateTitle, _this$props$buttonTex, buttonText;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;
                _this$props = _this.props, submitFormEndpoint = _this$props.submitFormEndpoint, title = _this$props.title, _this$props$nameplate = _this$props.nameplateTitle, nameplateTitle = _this$props$nameplate === undefined ? '' : _this$props$nameplate, _this$props$buttonTex = _this$props.buttonText, buttonText = _this$props$buttonTex === undefined ? 'Keep me informed' : _this$props$buttonTex;

                if (!(form.reCaptcha && form.reCaptcha.dirty && !form.reCaptcha.isValid && _this.form && _this.form.reCaptcha)) {
                  _context3.next = 6;
                  break;
                }

                _this.form.reCaptcha.resetRecaptcha();
                return _context3.abrupt("return");

              case 6:
                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 9;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var form, body;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          form = _this.state.form;
                          body = {
                            nameplateTitle: nameplateTitle,
                            title: form.title.value,
                            firstName: form.firstName.value,
                            lastName: form.lastName.value,
                            mobile: form.phone.value,
                            email: form.email.value,
                            bodyStyle: form.bodyStyle.value || null,
                            optedInDealer: form.optedInDealer.value === "Yes" ? true : false
                          };

                          if (form.region.value) body.postcode = form.region.value.postcode;
                          if (form.region.value) body.state = form.region.value.state;
                          if (form.region.value) body.suburb = form.region.value.suburb;
                          _context2.next = 7;
                          return Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: submitFormEndpoint,
                            body: body
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg, words;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg, words = json.words;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          words: words && words.split(",") || [],
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "Competition Form",
                                            pageAction: "Competition Form - \"" + nameplateTitle + "\" - Clicked \"" + buttonText + "\" - Successfully submitted."
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              words: response.words && response.words.split(",") || [],
                              loading: false
                            });
                          });

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      form: {
        title: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_REQUIRED,
            phone: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        region: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].LOCATION_REQUIRED,
            postcodeSearchable: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].LOCATION_INVALID
          }
        },
        optedInDealer: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].OPTIN_REQUIRED
          }
        },
        bodyStyle: {
          validations: {}
        },
        privacy: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PRIVACY_POLICY_REQUIRED
          }
        },
        reCaptcha: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].RECAPTCHA_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  CompetitionForm.prototype.render = function render() {
    var _classnames,
        _classnames2,
        _classnames3,
        _classnames4,
        _classnames5,
        _classnames6,
        _this3 = this;

    var _props = this.props,
        title = _props.title,
        optInMessage = _props.optInMessage,
        imageUrl = _props.imageUrl,
        privacyPolicy = _props.privacyPolicy,
        privacyPolicyLink = _props.privacyPolicyLink,
        introText = _props.introText,
        bodyStyles = _props.bodyStyles,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? 'Keep me informed' : _props$buttonText,
        _props$showRecaptcha = _props.showRecaptcha,
        showRecaptcha = _props$showRecaptcha === undefined ? false : _props$showRecaptcha,
        thankYouComponents = _props.thankYouComponents;
    var _state = this.state,
        form = _state.form,
        errorMessage = _state.errorMessage,
        loading = _state.loading,
        success = _state.success;


    if (success) {
      return Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_componentParser__["a" /* default */])(thankYouComponents);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__CompetitionForm_less___default.a.RegisterInterest] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 225
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 228
          }
        },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 229
          }
        },
        introText
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["s" /* Container */],
        { styleName: imageUrl ? "tablet-wide" : "mobile", __source: {
            fileName: _jsxFileName,
            lineNumber: 230
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["r" /* ColumnGroup */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 231
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["s" /* Container */],
            { styleName: "mobile", __source: {
                fileName: _jsxFileName,
                lineNumber: 232
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__CompetitionForm_less___default.a.CompetitionForm] = !imageUrl, _classnames2)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 233
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "form",
                { method: "POST", onSubmit: this._handleSubmit, noValidate: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 236
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 237
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["R" /* InputSelect */], _extends({
                    name: "title",
                    label: "Title",
                    options: __WEBPACK_IMPORTED_MODULE_10__TITLES__["a" /* default */]
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "title"), {
                    onBlur: function onBlur() {
                      if (form.title.value) {
                        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                          pageCategory: "Competition Form",
                          pageAction: "Competition Form Form - Selected \"TITLE\" - " + form.title.value.toUpperCase()
                        });
                      }
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 238
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 253
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                    name: "firstName",
                    label: "First Name"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
                    onBlur: function onBlur() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Competition Form",
                        pageAction: "Competition Form Form - Entered \"FIRSTNAME\""
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 254
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 266
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                    name: "lastName",
                    label: "Last Name"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "lastName"), {
                    onBlur: function onBlur() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Competition Form",
                        pageAction: "Competition Form Form - Entered \"LASTNAME\""
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 267
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 279
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                    name: "phone",
                    label: "Phone"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "phone"), {
                    onBlur: function onBlur() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Competition Form",
                        pageAction: "Competition Form Form - Entered \"PHONE\""
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 280
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 292
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["N" /* InputEmail */], _extends({
                    name: "email",
                    label: "Email"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), {
                    onBlur: function onBlur() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Competition Form",
                        pageAction: "Competition Form Form - Entered \"EMAIL\""
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 293
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 305
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["s" /* InputSearchable */], _extends({
                    name: "region",
                    type: "postcode",
                    label: "Postcode/Suburb"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "region"), {
                    onBlur: this._handleOnBlurSearchableRegion,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 306
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  { center: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 314
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["C" /* H5 */],
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 315
                      }
                    },
                    "Register your interest"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 319
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__CompetitionForm_less___default.a.CompetitionFormText] = true, _classnames3)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 320
                      }
                    },
                    optInMessage || "Would you like to receive more information about the next-Gen Mazda3 via email? Please note, Mazda or Mazda Dealers may contact you in the future.",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__CompetitionForm_less___default.a.requiredStar] = true, _classnames4)), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 324
                        }
                      },
                      "*"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["P" /* InputRadio */], _extends({
                    name: "optedInDealer",
                    value: "Yes",
                    label: "Yes, I'd like to be contacted."
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "optedInDealer", this._handleOptInChange), {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 328
                    }
                  })),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["P" /* InputRadio */], _extends({
                    name: "optedInDealer",
                    value: "No",
                    label: "No, I'd just like to enter the competition."
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "optedInDealer", this._handleOptInChange), {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 334
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    hide: true,
                    show: form.optedInDealer.value === "Yes" && bodyStyles && bodyStyles.length,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 341
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__CompetitionForm_less___default.a.CompetitionFormText] = true, _classnames5)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 345
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "b",
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 348
                        }
                      },
                      "Tell us which body style interests you the most"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__CompetitionForm_less___default.a.requiredStar] = true, _classnames6)), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 349
                        }
                      },
                      "*"
                    )
                  ),
                  bodyStyles && bodyStyles.length && bodyStyles.map(function (bodyStyle) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["P" /* InputRadio */], _extends({
                      name: "bodyStyle",
                      key: bodyStyle.value,
                      value: bodyStyle.value,
                      label: bodyStyle.name
                    }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(_this3, "bodyStyle", _this3._handleBodyStyleChange), {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 358
                      }
                    }));
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 368
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: { height: "1px", border: "0", borderTop: "1px solid #D5D5D5" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 370
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 371
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  { show: true, checkbox: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 372
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
                    name: "privacy",
                    label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 376
                        }
                      },
                      privacyPolicy,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
                        {
                          href: privacyPolicyLink,
                          external: true, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 378
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "nobr",
                          {
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 381
                            }
                          },
                          " Privacy Policy"
                        )
                      )
                    )
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "privacy"), {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 373
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 388
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 389
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["L" /* InputCaptcha */], _extends({
                  name: "reCaptcha",
                  formType: showRecaptcha ? "normal" : "invisible"
                }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "reCaptcha"), {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 391
                  }
                })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 398
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 399
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
                    _extends({
                      styleName: "black",
                      loading: loading,
                      fullWidth: true
                    }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 400
                      }
                    }),
                    buttonText
                  )
                )
              )
            )
          ),
          imageUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["o" /* Image */], { src: imageUrl, __source: {
              fileName: _jsxFileName,
              lineNumber: 413
            }
          })
        )
      )
    );
  };

  return CompetitionForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CompetitionForm.displayName = "CompetitionForm";


/* harmony default export */ __webpack_exports__["a"] = (CompetitionForm);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentCard_less__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentCard_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContentCard_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardYoutubePlayer_CardYoutubePlayer__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__ = __webpack_require__(14);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\ContentCard\\ContentCard.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ContentCard = function (_React$Component) {
  _inherits(ContentCard, _React$Component);

  function ContentCard() {
    _classCallCheck(this, ContentCard);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ContentCard.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4;

    var _props = this.props,
        children = _props.children,
        heading = _props.heading,
        description = _props.description,
        card = _props.card,
        components = _props.components;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["s" /* Container */],
      { styleName: "screen", __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__ContentCard_less___default.a.ContentCard] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 15
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__ContentCard_less___default.a.LeftSide] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 18
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__ContentCard_less___default.a.LeftSideHeading] = true, _classnames3)), __source: {
                fileName: _jsxFileName,
                lineNumber: 21
              }
            },
            heading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], { xmlString: description, __source: {
              fileName: _jsxFileName,
              lineNumber: 26
            }
          }),
          components && Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])(components),
          !components && children
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__ContentCard_less___default.a.RightSide] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 30
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 33
              }
            },
            card && card.youtubeId && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CardYoutubePlayer_CardYoutubePlayer__["a" /* default */], _extends({}, card, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 35
              }
            })),
            card && !card.youtubeId && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["m" /* Card */], _extends({}, card, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 38
              }
            }))
          )
        )
      )
    );
  };

  return ContentCard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContentCard.displayName = "ContentCard";


/* harmony default export */ __webpack_exports__["a"] = (ContentCard);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentCardList_less__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentCardList_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ContentCardList_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\ContentCardList\\ContentCardList.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ContentCardList = function (_React$Component) {
  _inherits(ContentCardList, _React$Component);

  function ContentCardList() {
    _classCallCheck(this, ContentCardList);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ContentCardList.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        _props$components = _props.components,
        components = _props$components === undefined ? [] : _props$components,
        heading = _props.heading,
        description = _props.description,
        imageSrc = _props.imageSrc;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
        { backgroundColor: "#F5F5F5", __source: {
            fileName: _jsxFileName,
            lineNumber: 15
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["n" /* HeroContent */], {
          heading: heading,
          description: description,
          imageSrc: imageSrc,
          details: "Showing " + components.length + " items", __source: {
            fileName: _jsxFileName,
            lineNumber: 16
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["s" /* Container */],
          { styleName: "screen", __source: {
              fileName: _jsxFileName,
              lineNumber: 23
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5__ContentCardList_less___default.a.ContentCardListRoot] = true, _classnames)), __source: {
                fileName: _jsxFileName,
                lineNumber: 24
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 27
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_5__ContentCardList_less___default.a.ContentCardListView] = true, _classnames2)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 28
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(components).map(function (item, index) {
                var _classnames3;

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    key: "ContentCard-" + index,
                    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_5__ContentCardList_less___default.a.ContentCardListViewItem] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_5__ContentCardList_less___default.a.ContentCardListViewItemborderBottom] = index < components.length - 1, _classnames3)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 32
                    }
                  },
                  item
                );
              })
            )
          )
        )
      )
    );
  };

  return ContentCardList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContentCardList.displayName = "ContentCardList";


/* harmony default export */ __webpack_exports__["a"] = (ContentCardList);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CorporateSelect_less__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CorporateSelect_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CorporateSelect_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputSearchable_InputSearchable__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TITLES__ = __webpack_require__(1137);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\CorporateSelect\\CorporateSelect.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CorporateSelect = function (_React$Component) {
  _inherits(CorporateSelect, _React$Component);

  function CorporateSelect(props) {
    var _this2 = this;

    _classCallCheck(this, CorporateSelect);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$props$buttonTex, buttonText, _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props$buttonTex = _this.props.buttonText, buttonText = _this$props$buttonTex === undefined ? "Send enquiry" : _this$props$buttonTex;

                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _this$props, submitFormEndpoint, models, form, body;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this$props = _this.props, submitFormEndpoint = _this$props.submitFormEndpoint, models = _this$props.models;
                          form = _this.state.form;
                          body = {
                            title: form.title.value,
                            firstName: form.firstName.value,
                            lastName: form.lastName.value,
                            businessName: form.businessName.value,
                            phone: form.phone.value,
                            email: form.email.value,
                            models: form.models.value,
                            dealerLocation: form.dealer.value.id,
                            dealerCode: form.dealer.value.dealerCode,
                            postCode: form.dealer.value.postCode,
                            suburb: form.dealer.value.suburb,
                            state: form.dealer.value.state,
                            comments: form.comments.value
                          };
                          _context2.next = 5;
                          return Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: submitFormEndpoint,
                            body: body
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "Corporate select Form",
                                            pageAction: "Corporate select Form - Clicked \"" + buttonText.toUpperCase() + "\" - Successfully submitted."
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this._handleOnBlurCheckBoxGroup = function () {
      var form = _this.state.form;

      if (form && form.models && form.models.value && form.models.value.length) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Corporate Form",
          pageAction: "Corporate Form - Selected \"MODELS\" - \"" + form.models.value.map(function (item) {
            return item.toUpperCase() + " ";
          }) + "\""
        });
      }
    };

    _this._handleOnBlurSearchableRegion = function (value) {
      if (value && value.display) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Corporate Form",
          pageAction: "Corporate Form - Selected \"DEALER\" - \"" + value.display.toUpperCase() + "\""
        });
      }

      if (value && value.description) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Corporate Form",
          pageAction: "Corporate Form - Selected \"POSTCODE/SUBURB\" - \"" + value.description.toUpperCase() + "\""
        });
      }
    };

    _this.state = {
      form: {
        title: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].LASTNAME_REQUIRED
          }
        },
        businessName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].BUSINESS_REQUIRED,
            businessName: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].BUSINESS_INVALID
          }
        },
        phone: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_REQUIRED,
            phone: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        models: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].MODEL_REQUIRED
          }
        },
        region: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].DEALERS_NO_POSTCODE
          }
        },
        dealer: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].DEALERS_REQUIRED
          }
        },
        comments: {
          validations: {}
        },
        optIn: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].OPTIN_REQUIRED
          }
        },
        privacy: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  CorporateSelect.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        title = _props.title,
        description = _props.description,
        models = _props.models,
        privacyPolicy = _props.privacyPolicy,
        privacyPolicyLink = _props.privacyPolicyLink,
        _props$dealersEndPoin = _props.dealersEndPoint,
        dealersEndPoint = _props$dealersEndPoin === undefined ? "/api/dealer-search" : _props$dealersEndPoin,
        dealerApiEndPoint = _props.dealerApiEndPoint,
        optInText = _props.optInText,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Contact us" : _props$buttonText,
        thankYouComponents = _props.thankYouComponents;
    var _state = this.state,
        loading = _state.loading,
        form = _state.form,
        success = _state.success,
        errorMessage = _state.errorMessage;


    if (success) {
      return Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_componentParser__["a" /* default */])(thankYouComponents);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__CorporateSelect_less___default.a.CorporateSelect] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 190
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 193
          }
        },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 194
          }
        },
        description
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__CorporateSelect_less___default.a.CorporateSelectForm] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 195
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { method: "POST", onSubmit: this._handleSubmit, noValidate: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 198
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 199
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["R" /* InputSelect */], _extends({
              name: "title",
              label: "Title",
              options: __WEBPACK_IMPORTED_MODULE_11__TITLES__["a" /* default */]
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "title"), {
              onBlur: function onBlur() {
                if (form.title.value) {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Corporate select Form",
                    pageAction: "Corporate select Form - Selected \"TITLE\" - \"" + form.title.value.toUpperCase() + "\""
                  });
                }
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 200
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 215
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "firstName",
              label: "First Name"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Corporate select Form",
                  pageAction: "Corporate select Form - Entered \"FIRSTNAME\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 216
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 228
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "lastName",
              label: "Last Name"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "lastName"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Corporate select Form",
                  pageAction: "Corporate select Form - Entered \"LASTNAME\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 229
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 241
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "businessName",
              label: "Business Name"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "businessName"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Corporate select Form",
                  pageAction: "Corporate select Form - Entered \"Business Name\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 242
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 254
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "phone",
              label: "Phone"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "phone"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Corporate select Form",
                  pageAction: "Corporate select Form - Entered \"PHONE\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 255
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 267
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["N" /* InputEmail */], _extends({
              name: "email",
              label: "Email"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Corporate select Form",
                  pageAction: "Corporate select Form - Entered \"EMAIL\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 268
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 280
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["n" /* CheckBoxGroup */], _extends({
              heading: "Select model(s) of interest",
              items: models
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "models"), {
              onBlur: this._handleOnBlurCheckBoxGroup, __source: {
                fileName: _jsxFileName,
                lineNumber: 281
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 287
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputSearchable_InputSearchable__["a" /* default */], _extends({
              name: "region",
              type: "dealer",
              dealersEndPoint: dealersEndPoint,
              label: "Enter your postcode, suburb or Dealer name"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "region"), {
              onBlur: this._handleOnBlurSearchableRegion,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 288
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 297
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["h" /* DealerSearch */], _extends({
              dealersEndPoint: dealersEndPoint,
              endpoint: dealerApiEndPoint,
              disabled: !form.region.value || !(form.region.value.postcode || form.region.value.value),
              type: "Sales",
              name: "dealer",
              postcode: form.region.value && form.region.value.postcode || initialLocations && initialLocations[0] && initialLocations[0].postCode,
              dealerCode: form.region.value && form.region.value.value
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "dealer"), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 298
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 308
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "comments",
              label: "Tell us your enquiry"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "comments"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Corporate select Form",
                  pageAction: "Corporate select Form - Entered \"ENQUIRY\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 309
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 321
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { show: true, checkbox: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 322
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
              name: "optIn",
              label: optInText || "I acknowledge that Mazda or Mazda dealers may send me further information about Mazda products or services."
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "optIn", function () {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "Corporate select Form",
                pageAction: "Corporate select Form - checked \"Opt in\""
              });
            }), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 323
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 334
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { show: true, checkbox: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 335
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
              name: "privacy",
              label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 339
                  }
                },
                privacyPolicy,
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
                  {
                    href: privacyPolicyLink,
                    onClick: function onClick() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Corporate select Form",
                        pageAction: "Corporate select Form - Clicked \"PRIVACYPOLICY\""
                      });
                    },
                    external: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 341
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "nobr",
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 350
                      }
                    },
                    "Privacy Policy"
                  )
                )
              )
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "privacy", function () {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "Corporate select Form",
                pageAction: "Corporate select Form - Checked \"PRIVACYPOLICY\""
              });
            }), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 336
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 362
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 363
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 364
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 365
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              _extends({
                styleName: "black",
                loading: loading,
                fullWidth: true
              }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 366
                }
              }),
              buttonText
            )
          )
        )
      )
    );
  };

  return CorporateSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CorporateSelect.displayName = "CorporateSelect";


/* harmony default export */ __webpack_exports__["a"] = (CorporateSelect);

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"DealerSearch":"DealerSearch__DealerSearch___2_Jqo","DealerSearchDisabled":"DealerSearch__DealerSearchDisabled___lbanq","DealerSearchLoadingSection":"DealerSearch__DealerSearchLoadingSection___3ZL45","Dealer":"DealerSearch__Dealer___2mi9Z","DealerDetails":"DealerSearch__DealerDetails___1sIOf"};

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Disclaimer_less__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Disclaimer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Disclaimer_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Disclaimer\\Disclaimer.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Disclaimer = function (_React$Component) {
  _inherits(Disclaimer, _React$Component);

  function Disclaimer(props) {
    _classCallCheck(this, Disclaimer);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleOnClick = function () {
      _this.setState({
        show: true
      });
    };

    _this._handleOnClose = function () {
      _this.setState({
        show: false
      });
    };

    _this.state = {
      show: false,
      uniqueID: Math.random()
    };
    return _this;
  }

  Disclaimer.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var show = this.props.show;


    if (prevProps.show !== show && show) {
      this._handleOnClick();
    }
  };

  Disclaimer.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5;

    var _props = this.props,
        children = _props.children,
        _props$Icon = _props.Icon,
        Icon = _props$Icon === undefined ? __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["J" /* InfoIcon */] : _props$Icon,
        _props$text = _props.text,
        text = _props$text === undefined ? null : _props$text,
        gtm = _props.gtm;
    var _state = this.state,
        show = _state.show,
        uniqueID = _state.uniqueID;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__Disclaimer_less___default.a.Disclaimer] = true, _classnames[__WEBPACK_IMPORTED_MODULE_3__Disclaimer_less___default.a.DisclaimerText] = text, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__Disclaimer_less___default.a.DisclaimerIcon] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 43
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["k" /* ButtonIcon */],
          { onClick: this._handleOnClick, gtm: gtm, __source: {
              fileName: _jsxFileName,
              lineNumber: 46
            }
          },
          !text && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { style: { width: "0.5em", height: "0.5em", color: "#910A2D" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 48
            }
          }),
          text && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: { color: "#910A2D" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 50
              }
            },
            text
          )
        )
      ),
      show && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_18" /* ToastPopup */],
        {
          uniqueID: "DisclaimerID-" + uniqueID,
          onClose: this._handleOnClose,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 55
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__Disclaimer_less___default.a.DisclaimerToast] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__Disclaimer_less___default.a.DisclaimerToastIcon] = true, _classnames4)), __source: {
                fileName: _jsxFileName,
                lineNumber: 62
              }
            },
            !text ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 66
              }
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { fontSize: "3em" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 68
                }
              },
              text
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_3__Disclaimer_less___default.a.DisclaimerContent] = true, _classnames5)), __source: {
                fileName: _jsxFileName,
                lineNumber: 71
              }
            },
            children
          )
        )
      )
    );
  };

  return Disclaimer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Disclaimer.displayName = "Disclaimer";


/* harmony default export */ __webpack_exports__["a"] = (Disclaimer);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeaturedCategoriesTab_less__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeaturedCategoriesTab_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FeaturedCategoriesTab_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__ = __webpack_require__(47);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\FeaturedCategoriesTab\\FeaturedCategoriesTab.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var FeaturedCategoriesTab = function (_React$Component) {
  _inherits(FeaturedCategoriesTab, _React$Component);

  function FeaturedCategoriesTab(props) {
    _classCallCheck(this, FeaturedCategoriesTab);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._updateDimensions = function () {
      var _this$props = _this.props,
          _this$props$desktopTa = _this$props.desktopTabOptions,
          desktopTabOptions = _this$props$desktopTa === undefined ? 'scroll' : _this$props$desktopTa,
          _this$props$mobileTab = _this$props.mobileTabOptions,
          mobileTabOptions = _this$props$mobileTab === undefined ? 'scroll' : _this$props$mobileTab;


      if (__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].innerWidth && __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].innerWidth !== _this.state.windowWidth) {
        if (!_this.state.windowWidth || _this.state.windowWidth >= 768 && __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].innerWidth < 768 || _this.state.windowWidth < 768 && __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].innerWidth >= 768) {
          _this.setState({
            windowWidth: __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].innerWidth
          }, function () {
            _this.setState({
              tabType: _this.state.windowWidth >= 768 ? desktopTabOptions : mobileTabOptions
            });
          });
        }
      }
    };

    _this._handleClick = function (activeIndex) {
      _this.setState({
        activeIndex: activeIndex
      });
    };

    _this._handleChange = function (value) {
      var _this$props$component = _this.props.components,
          components = _this$props$component === undefined ? [] : _this$props$component;

      var changedIndex = components.findIndex(function (item) {
        return item.props.title === value;
      });
      if (!changedIndex || changedIndex < 0) changedIndex = 0;
      _this.setState({
        activeIndex: changedIndex
      });
    };

    _this.state = {
      activeIndex: 0,
      tabType: __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].innerWidth
    };
    return _this;
  }

  FeaturedCategoriesTab.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      _this2._updateDimensions();
    }, 100);
    __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__["a" /* default */])(this._updateDimensions, 250));
  };

  FeaturedCategoriesTab.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__["a" /* default */])(this._updateDimensions, 250));
  };

  FeaturedCategoriesTab.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        _props$components = _props.components,
        components = _props$components === undefined ? [] : _props$components,
        gtm = _props.gtm,
        heading = _props.heading,
        numberOfWrappedItems = _props.numberOfWrappedItems,
        description = _props.description;
    var _state = this.state,
        tabType = _state.tabType,
        activeIndex = _state.activeIndex;


    var tabNames = components.map(function (item) {
      return {
        name: item.props.title,
        label: item.props.title,
        value: item.props.title
      };
    });

    var activeComponents = components[activeIndex] && components[activeIndex].props.components;

    // legacy
    if (activeComponents) {
      if (activeComponents[0] && (activeComponents[0].name === 'ImageToutBlock' || activeComponents[0].name === 'FeatureYouTube' || activeComponents[0].name === 'CardYoutubePlayer' || activeComponents[0].name === 'ArticlePreview')) {
        activeComponents = [{
          name: 'CardYoutubePlayerList',
          props: {
            showCounting: false,
            scrolling: components[activeIndex].props.tabOptions === "stack" ? false : true,
            numberOfColumns: 4,
            components: activeComponents.map(function (item) {
              return _extends({}, item, {
                props: _extends({}, item.props, {
                  gtm: gtm
                }),
                videoSrc: item.props.youTubeId
              });
            })
          }
        }];
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__FeaturedCategoriesTab_less___default.a.FeaturedCategoriesTab] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 121
        }
      },
      (heading || description) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["n" /* HeroContent */], {
        heading: heading,
        description: description,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126
        }
      }),
      (tabType === 'scroll' || tabType === 'stack') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["I" /* Tabs */], {
        onClick: this._handleClick,
        options: tabNames,
        numberOfWrappedItems: numberOfWrappedItems,
        animatedLine: true,
        scrolling: tabType === 'scroll',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 135
        }
      }),
      tabType === 'dropdown' && tabNames && tabNames[0] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["R" /* InputSelect */], {
        onChange: this._handleChange,
        options: tabNames,
        required: true,
        withoutStar: true,
        defaultValue: tabNames[activeIndex],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 145
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 153
          }
        },
        activeComponents && tabType && Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(activeComponents),
        !activeComponents && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 159
          }
        })
      )
    );
  };

  return FeaturedCategoriesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FeaturedCategoriesTab.displayName = "FeaturedCategoriesTab";


/* harmony default export */ __webpack_exports__["a"] = (FeaturedCategoriesTab);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_checkVisible__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__ = __webpack_require__(17);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\FeatureFocusBlock\\FeatureFocusBlock.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var FeatureFocusBlock = function (_React$Component) {
  _inherits(FeatureFocusBlock, _React$Component);

  function FeatureFocusBlock(props) {
    _classCallCheck(this, FeatureFocusBlock);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._showOrHide = function () {
      var frames = _this.props.frames;
      var _this$state = _this.state,
          activeIndex = _this$state.activeIndex,
          visible = _this$state.visible;

      if (_this.video) {
        if (Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_checkVisible__["a" /* default */])(_this.video)) {
          if (!visible) {
            _this.setState({
              visible: true
            }, function () {
              if (_this.video && _this.video.currentTime != 0) {
                _this.video.currentTime = frames[activeIndex].props.start;
              }
              _this.video.play();
            });
          }
        } else {
          if (visible) {
            if (_this.video && _this.video.currentTime != 0) {
              _this.video.currentTime = frames[activeIndex].props.start;
            }
            _this.video.pause();

            _this.setState({
              visible: false,
              boxInPage: false
            });
          }
        }
      }
    };

    _this._updateDimensions = function () {
      _this.setState({
        windowWidth: __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__["i" /* WINDOW */].innerWidth
      });
    };

    _this._handleClickNext = function () {
      var activeIndex = _this.state.activeIndex;
      var frames = _this.props.frames;

      if (activeIndex !== frames.length - 1) {
        _this._playVideoOnNewTime(activeIndex + 1, true);
      } else {
        _this._playVideoOnNewTime(0);
      }
      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
        pageCategory: "Feature focus",
        pageAction: "Clicked chevron - \"NEXT\""
      });
    };

    _this._handleClickPrevious = function () {
      var activeIndex = _this.state.activeIndex;

      if (activeIndex !== 0) {
        _this._playVideoOnNewTime(activeIndex - 1);
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Feature focus",
          pageAction: "Clicked chevron - \"PREVIOUS\""
        });
      }
    };

    _this._playVideoOnNewTime = function () {
      var newActiveIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var justContinue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var frames = _this.props.frames;

      if (_this.video) {
        if (frames[newActiveIndex] && frames[newActiveIndex].props) {
          _this.setState({
            boxInPage: false
          }, function () {
            setTimeout(function () {
              _this.setState({
                activeIndex: newActiveIndex
              }, function () {
                if (!justContinue) {
                  _this.video.currentTime = frames[newActiveIndex].props.start;
                }
                _this.video.play();
              });
            }, 1000);
          });
        }
      } else {
        setTimeout(function () {
          _this._playVideoOnNewTime(newActiveIndex);
        }, 250);
      }
    };

    _this._onTimeUpdate = function () {
      // we need to pause video before reaching the next frame start time
      var frames = _this.props.frames;
      var activeIndex = _this.state.activeIndex;

      if (_this.video) {
        if (activeIndex !== frames.length - 1) {
          if (_this.video.currentTime > frames[activeIndex + 1].props.start) {
            _this.video.pause();
            _this.setState({
              boxInPage: true
            });
          }
        }
      }
    };

    _this._handleOnEnded = function () {
      _this.setState({
        boxInPage: true
      });
    };

    _this.state = {
      activeIndex: 0,
      boxInPage: false,
      visible: false,
      windowWidth: undefined
    };
    return _this;
  }

  FeatureFocusBlock.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      _this2._showOrHide();
      _this2._updateDimensions();
    }, 100);

    __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__["a" /* default */])(this._updateDimensions, 250));
    __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__["a" /* default */])(this._showOrHide, 250), {
      passive: true
    });
  };

  FeatureFocusBlock.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__["a" /* default */])(this._updateDimensions, 250));
    __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_debounce__["a" /* default */])(this._showOrHide, 250), {
      passive: true
    });
  };

  FeatureFocusBlock.prototype.render = function render() {
    var _classnames,
        _this3 = this,
        _classnames2,
        _classnames3,
        _classnames4,
        _classnames5,
        _classnames6,
        _classnames7,
        _classnames8,
        _classnames9,
        _classnames10,
        _classnames11;

    var _props = this.props,
        video = _props.video,
        _props$frames = _props.frames,
        frames = _props$frames === undefined ? [] : _props$frames;
    var _state = this.state,
        activeIndex = _state.activeIndex,
        fadeOut = _state.fadeOut,
        windowWidth = _state.windowWidth,
        boxInPage = _state.boxInPage;


    if (video === "" || !video) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 172
        }
      },
      " Video is not defined "
    );

    var CTA = frames[activeIndex].props.cta;
    var theme = 'dark';
    if (windowWidth >= 1200) {
      theme = 'dark';
      CTA.props.styleName = 'whiteOutlined';
    } else if (windowWidth < 1200) {
      theme = 'light';
      CTA.props.styleName = 'blackOutlined';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.FeatureFocusBlock] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 185
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["K" /* VideoPlayer */], {
        getRef: function getRef(c) {
          return _this3.video = c;
        },
        src: video,
        loop: false,
        autoPlay: false,
        onEnded: this._handleOnEnded,
        onTimeUpdate: this._onTimeUpdate,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 189
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.FeatureFocusContentBox] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.FeatureFocusContentBoxVisible] = boxInPage, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 197
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.FeatureFocusContentBoxInside] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 201
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 204
              }
            },
            frames.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.ArrowsBoxContainer] = true, _classnames4)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 206
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  onClick: this._handleClickPrevious,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.ArrowsBox] = true, _classnames5)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 209
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["e" /* ArrowLeftIcon */], { style: {
                    width: '15px',
                    hegiht: '15px'
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 214
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.Numbers] = true, _classnames6)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 219
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.SingleNumber] = true, _classnames7[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.ActiveNumber] = true, _classnames7)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 222
                    }
                  },
                  activeIndex + 1
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 226
                    }
                  },
                  "\u2014"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.SingleNumber] = true, _classnames8[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.ActiveNumber] = false, _classnames8)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 227
                    }
                  },
                  frames.length
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  onClick: this._handleClickNext,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames9 = {}, _classnames9[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.ArrowsBox] = true, _classnames9)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 232
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["g" /* ArrowRightIcon */], { style: {
                    width: '15px',
                    hegiht: '15px'
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 237
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames10 = {}, _classnames10[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.ContentBox] = true, _classnames10[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.Center] = theme === 'light', _classnames10[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.ContentBoxAnimation] = fadeOut, _classnames10)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 244
                }
              },
              frames[activeIndex].props.heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["C" /* H5 */],
                { withDetails: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 250
                  }
                },
                frames[activeIndex].props.heading
              ),
              frames[activeIndex].props.description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames11 = {}, _classnames11[__WEBPACK_IMPORTED_MODULE_2__FeatureFocusBlock_less___default.a.ContentArea] = true, _classnames11)),
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 255
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["t" /* Content */], {
                  textAlign: theme === 'dark' ? 'left' : 'center',
                  theme: theme,
                  xmlString: frames[activeIndex].props.description,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 260
                  }
                })
              ),
              CTA && Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])([CTA], {
                gtm: {
                  category: "Feature focus",
                  action: "Clicked button - " + CTA.props.label.toUpperCase()
                }
              })
            )
          )
        )
      )
    );
  };

  return FeatureFocusBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FeatureFocusBlock.displayName = "FeatureFocusBlock";


/* harmony default export */ __webpack_exports__["a"] = (FeatureFocusBlock);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\FiftyFiftyBlock\\FiftyFiftyBlock.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var FiftyFiftyBlock = function (_React$PureComponent) {
  _inherits(FiftyFiftyBlock, _React$PureComponent);

  function FiftyFiftyBlock() {
    var _temp, _this, _ret;

    _classCallCheck(this, FiftyFiftyBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._renderImage = function () {
      var _classnames, _classnames2;

      var _this$props = _this.props,
          imageUrl = _this$props.imageUrl,
          _this$props$size = _this$props.size,
          size = _this$props$size === undefined ? "disable" : _this$props$size,
          _this$props$overlay = _this$props.overlay,
          overlay = _this$props$overlay === undefined ? false : _this$props$overlay;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.Media] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.MediaImage] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.MediaImageLarge] = size === "large", _classnames2[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.MediaImageMedium] = size === "medium", _classnames2[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.MediaImageSmall] = size === "small", _classnames2[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.MediaImageInitial] = overlay, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 17
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["o" /* Image */], { src: imageUrl, __source: {
              fileName: _jsxFileName,
              lineNumber: 25
            }
          })
        )
      );
    }, _this._renderVideo = function () {
      var _classnames3;

      var _this$props2 = _this.props,
          imageUrl = _this$props2.imageUrl,
          videoUrl = _this$props2.videoUrl;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.Media] = true, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 34
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["K" /* VideoPlayer */], { src: videoUrl, poster: imageUrl, __source: {
            fileName: _jsxFileName,
            lineNumber: 38
          }
        })
      );
    }, _this._renderContent = function () {
      var _classnames4;

      var _this$props3 = _this.props,
          heading = _this$props3.heading,
          blurb = _this$props3.blurb,
          textAlign = _this$props3.textAlign,
          _this$props3$headingU = _this$props3.headingUppercase,
          headingUppercase = _this$props3$headingU === undefined ? true : _this$props3$headingU,
          _this$props3$componen = _this$props3.components,
          components = _this$props3$componen === undefined ? [] : _this$props3$componen,
          children = _this$props3.children;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.Content] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.ContentCenter] = textAlign === "center", _classnames4[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.ContentRight] = textAlign === "right", _classnames4[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.ContentHeading] = !headingUppercase, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          }
        },
        heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["A" /* H3 */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 53
            }
          },
          heading
        ),
        blurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], { xmlString: blurb, textAlign: textAlign, __source: {
            fileName: _jsxFileName,
            lineNumber: 54
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 55
          }
        }),
        Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(components) || children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FiftyFiftyBlock.prototype.render = function render() {
    var _classnames5;

    var _props = this.props,
        _props$imagePosition = _props.imagePosition,
        imagePosition = _props$imagePosition === undefined ? "left" : _props$imagePosition,
        _props$imagePositionM = _props.imagePositionMobile,
        imagePositionMobile = _props$imagePositionM === undefined ? false : _props$imagePositionM,
        _props$ratio = _props.ratio,
        ratio = _props$ratio === undefined ? 60 : _props$ratio,
        videoUrl = _props.videoUrl,
        backgroundColor = _props.backgroundColor,
        size = _props.size;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["r" /* ColumnGroup */],
      {
        sizes: [Number(ratio), 100 - Number(ratio)],
        size: size,
        backgroundColor: backgroundColor,
        reverseOnDesktop: imagePosition === "right",
        reverseOnMobile: !imagePositionMobile,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_5__FiftyFiftyBlock_less___default.a.ColumnParent] = true, _classnames5)),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 79
          }
        },
        !videoUrl && this._renderImage(),
        videoUrl && this._renderVideo()
      ),
      this._renderContent()
    );
  };

  return FiftyFiftyBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

FiftyFiftyBlock.displayName = "FiftyFiftyBlock";


/* harmony default export */ __webpack_exports__["a"] = (FiftyFiftyBlock);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer_less__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Footer_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_newEvent__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Footer\\Footer.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Footer = function (_React$PureComponent) {
  _inherits(Footer, _React$PureComponent);

  function Footer(props) {
    _classCallCheck(this, Footer);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._handleOpenPostcodePopup = function () {
      setTimeout(function () {
        var event = Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_newEvent__["a" /* createNewEvent */])('POSTCODE_POPUP_OPEN');
        Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_newEvent__["b" /* dispatchEvent */])(event);
      }, 100);
    };

    _this._updatePostcode = function () {

      _this.setState({
        postcode: '2601'
      });
    };

    _this.state = {
      postcode: null
    };
    return _this;
  }

  Footer.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.setState({
      postcode: new __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("postcode")
    });

    __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("POSTCODE_UPDATE", function () {
      return _this2._updatePostcode();
    }, false);
  };
  //new cookieHandler().getCookie("postcode")


  Footer.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames7;

    var postcode = this.state.postcode;
    var _props = this.props,
        gtm = _props.gtm,
        copyright = _props.copyright,
        links = _props.links,
        _props$components = _props.components,
        components = _props$components === undefined ? [] : _props$components;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Footer_less___default.a.Footer] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
        { horizontalPadding: true, fullWidth: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 66
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Footer_less___default.a.FooterInside] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 67
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__Footer_less___default.a.FooterLeft] = true, _classnames3)), __source: {
                fileName: _jsxFileName,
                lineNumber: 71
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__Footer_less___default.a.Socials] = true, _classnames4)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 75
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(components)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__Footer_less___default.a.FooterRight] = true, _classnames5)), __source: {
                fileName: _jsxFileName,
                lineNumber: 81
              }
            },
            links && links.length > 0 && links.map(function (link) {
              var _classnames6;

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  key: link.href,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__Footer_less___default.a.FooterRightLinks] = true, _classnames6)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 86
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["a" /* A */],
                  {
                    href: link.href,
                    styleName: "grey",
                    gtm: {
                      category: gtm && gtm.category ? gtm.category : "Footer Nav",
                      action: "Footer - Clicked \"" + link.label.toUpperCase() + "\""
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 91
                    }
                  },
                  link.label.toUpperCase()
                )
              );
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_2__Footer_less___default.a.CopyRight] = true, _classnames7)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 102
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["U" /* Interactive */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 105
                  }
                },
                copyright.toUpperCase()
              )
            )
          )
        )
      )
    );
  };

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Footer.displayName = "Footer";


/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_longPolling__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_componentParser__ = __webpack_require__(14);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\FullWidthImageSection\\FullWidthImageSection.jsx";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var FullWidthImageSection = function (_React$Component) {
  _inherits(FullWidthImageSection, _React$Component);

  function FullWidthImageSection(props) {
    _classCallCheck(this, FullWidthImageSection);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._callEverySecond = function () {
      var imageArrayIndex = _this.state.imageArrayIndex;

      var newImageArrayIndex = 0;
      var backgroundImageArray = _this.props.backgroundImageArray;

      if (imageArrayIndex !== backgroundImageArray.length - 1) {
        newImageArrayIndex = imageArrayIndex + 1;
      } else {
        newImageArrayIndex = 0;
      }

      _this.setState({
        imageArrayIndex: newImageArrayIndex
      });
    };

    _this.state = {
      polling: props.backgroundImageArray !== undefined,
      error: false,
      imageArrayIndex: 0,
      isIE: false
    };
    return _this;
  }

  FullWidthImageSection.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var backgroundImageArray = this.props.backgroundImageArray;

    if ((typeof backgroundImageArray === "undefined" ? "undefined" : _typeof(backgroundImageArray)) !== undefined) {
      Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_longPolling__["a" /* default */])({
        conditionFucntion: function conditionFucntion() {
          return _this2.state.polling;
        },
        callFunction: this._callEverySecond,
        errorFunction: function errorFunction() {
          return _this2.setState({ error: true });
        },
        interval: 3000
      });
    }

    setTimeout(function () {
      _this2.setState({
        isIE: __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["d" /* IS_IE */] || __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["c" /* IS_EDGE */]
      });
    }, 0);
  };

  FullWidthImageSection.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      polling: false
    });
  };

  FullWidthImageSection.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames7;

    var _props = this.props,
        backgroundImage = _props.backgroundImage,
        backgroundVideo = _props.backgroundVideo,
        heading = _props.heading,
        mobileHeading = _props.mobileHeading,
        mobileBackgroundImage = _props.mobileBackgroundImage,
        backgroundImageArray = _props.backgroundImageArray,
        textVerticalAlign = _props.textVerticalAlign,
        _props$textAlign = _props.textAlign,
        textAlign = _props$textAlign === undefined ? 'center' : _props$textAlign,
        width = _props.width,
        align = _props.align,
        height = _props.height,
        blurb = _props.blurb,
        components = _props.components,
        children = _props.children,
        _props$floating = _props.floating,
        floating = _props$floating === undefined ? false : _props$floating,
        _props$wysiwygTheme = _props.wysiwygTheme,
        wysiwygTheme = _props$wysiwygTheme === undefined ? 'dark' : _props$wysiwygTheme;
    var _state = this.state,
        imageArrayIndex = _state.imageArrayIndex,
        isIE = _state.isIE;


    if (!mobileBackgroundImage) mobileBackgroundImage = backgroundImage;
    if (!mobileHeading) mobileHeading = heading;

    var alignItems = 'center';
    if (textVerticalAlign === 'top') {
      alignItems = 'start';
    }
    if (textVerticalAlign === 'bottom') {
      alignItems = 'end';
    }

    var justifyContent = 'center';
    if (align === 'left') {
      justifyContent = 'left';
    }
    if (align === 'right') {
      justifyContent = 'right';
    }

    var minHeight = 'auto';
    if (height === 'widescreen') {
      minHeight = '60vw';
    }
    if (height === 'extra tall') {
      minHeight = '50vw';
    }
    if (height === 'tall') {
      minHeight = '40vw';
    }
    if (height === 'medium') {
      minHeight = '30vw';
    }
    if (height === 'compact') {
      minHeight = '20vw';
    }
    if (height === 'fit') {
      minHeight = 'auto';
    }

    // legacy
    if (wysiwygTheme === 'light') wysiwygTheme = 'dark';else if (wysiwygTheme === 'dark') {
      if (!backgroundImage && !backgroundVideo) {
        wysiwygTheme = 'light';
      }
    }

    if (blurb && blurb.indexOf('#000000') > -1) {
      wysiwygTheme = 'light';
    }

    if (blurb && blurb.indexOf('text-align: left;') > -1) {
      textAlign = 'left';
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.FullWidthImageSection] = true, _classnames[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.DarkTheme] = wysiwygTheme === 'dark', _classnames[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.GreyThemeFloating] = floating, _classnames)),
        style: {
          alignItems: alignItems,
          justifyContent: justifyContent,
          flexDirection: justifyContent === 'right' ? 'row-reverse' : 'row',
          textAlign: textAlign,
          minHeight: minHeight,
          height: isIE && minHeight
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 146
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.FullWidthImageSectionContent] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.FullWidth] = width === "full width", _classnames2[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.FullWidthLeftORRight] = align === "left" || align === 'right', _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 160
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_21" /* Visible */],
          { visible: ["screen", "tablet"], __source: {
              fileName: _jsxFileName,
              lineNumber: 165
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
            { horizontalPadding: align !== "center", __source: {
                fileName: _jsxFileName,
                lineNumber: 166
              }
            },
            (heading || blurb) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["n" /* HeroContent */], {
              textAlign: textAlign,
              theme: wysiwygTheme,
              heading: heading,
              description: blurb, __source: {
                fileName: _jsxFileName,
                lineNumber: 168
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.ChildrenSection] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.ChildrenSectionCenter] = justifyContent === 'center', _classnames3)),
                style: {
                  flexDirection: align != 'center' ? textAlign === 'right' ? 'row-reverse' : 'row' : 'column',
                  justifyContent: textAlign
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 174
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_componentParser__["a" /* default */])(components) || children
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_21" /* Visible */],
          { visible: ["mobile"], __source: {
              fileName: _jsxFileName,
              lineNumber: 188
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
            { horizontalPadding: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 189
              }
            },
            (mobileHeading || blurb) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["n" /* HeroContent */], {
              textAlign: textAlign,
              theme: wysiwygTheme,
              heading: mobileHeading,
              description: blurb, __source: {
                fileName: _jsxFileName,
                lineNumber: 191
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.ChildrenSection] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.ChildrenSectionCenter] = justifyContent === 'center', _classnames4)),
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 197
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_componentParser__["a" /* default */])(components) || children
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.FullWidthImageSectionInside] = true, _classnames5)), __source: {
            fileName: _jsxFileName,
            lineNumber: 208
          }
        },
        backgroundVideo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["K" /* VideoPlayer */], {
          height: isIE ? "100%" : minHeight,
          calculatedHeight: true,
          poster: backgroundImage,
          src: backgroundVideo,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 212
          }
        }),
        !backgroundVideo && (backgroundImage || mobileBackgroundImage) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.FullWidthImageSectionAsset] = true, _classnames6[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.FloatingAsset] = floating, _classnames6)), __source: {
              fileName: _jsxFileName,
              lineNumber: 220
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_21" /* Visible */],
            { visible: ["screen", "tablet"], __source: {
                fileName: _jsxFileName,
                lineNumber: 224
              }
            },
            backgroundImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["o" /* Image */], { src: backgroundImage, height: 200, __source: {
                fileName: _jsxFileName,
                lineNumber: 226
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_21" /* Visible */],
            { visible: ["mobile"], __source: {
                fileName: _jsxFileName,
                lineNumber: 229
              }
            },
            mobileBackgroundImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["o" /* Image */], { src: mobileBackgroundImage, height: 200, __source: {
                fileName: _jsxFileName,
                lineNumber: 231
              }
            })
          )
        ),
        backgroundImageArray && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_6__FullWidthImageSection_less___default.a.FullWidthImageSectionAsset] = true, _classnames7)), __source: {
              fileName: _jsxFileName,
              lineNumber: 237
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_21" /* Visible */],
            { visible: ["screen", "tablet", "mobile"], __source: {
                fileName: _jsxFileName,
                lineNumber: 240
              }
            },
            backgroundImageArray && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["o" /* Image */], { src: backgroundImageArray[imageArrayIndex].imageSrc, height: 200, __source: {
                fileName: _jsxFileName,
                lineNumber: 242
              }
            })
          )
        )
      )
    );
  };

  return FullWidthImageSection;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FullWidthImageSection.displayName = "FullWidthImageSection";


/* harmony default export */ __webpack_exports__["a"] = (FullWidthImageSection);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GetInTouch_less__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GetInTouch_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GetInTouch_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputSearchable_InputSearchable__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TOPICS__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TITLES__ = __webpack_require__(1149);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\GetInTouch\\GetInTouch.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var GetInTouch = function (_React$Component) {
  _inherits(GetInTouch, _React$Component);

  function GetInTouch(props) {
    _classCallCheck(this, GetInTouch);

    // Handling hiddenCategories -> /change-of-ownership
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var hiddenCategories = _this.props.hiddenCategories;

    var filteredTopic = __WEBPACK_IMPORTED_MODULE_13__TOPICS__["a" /* default */].filter(function (item) {
      var visible = true;
      hiddenCategories.forEach(function (cat) {
        if (Number(cat) === Number(item.value)) {
          visible = false;
        }
      });
      return visible;
    });

    _this.state = {
      form: {
        topic: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].TOPIC_REQUIRED
          }
        },
        title: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_REQUIRED,
            phone: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        address: {
          validations: {}
        },
        vinRego: {
          validations: {}
        },
        ownership: {
          validations: {}
        },
        enquiry: {
          validations: {}
        },
        privacy: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null,
      filteredTopic: filteredTopic
    };
    return _this;
  }

  GetInTouch.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var filteredTopic = this.state.filteredTopic;

    var currentURL = new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_12_constants_environment__["i" /* WINDOW */].location.href);
    // Handling pre-selecting with topic
    if (currentURL.query.topic || currentURL.query.TOPIC) {
      var topic = currentURL.query.topic || currentURL.query.TOPIC;
      Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
        topic: String(filteredTopic.findIndex(function (item) {
          return item.slug === topic;
        }) + 1)
      }, function () {
        _this2._handleTopicChange();
      });
    }

    // Handling If we only have one Topic
    if (filteredTopic.length === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
        topic: String(filteredTopic[0].value)
      }, function () {
        _this2._handleTopicChange();
      });
    }

    // Handling pre-filling the form by customer object
    if (this.props.customer) {
      Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
        firstName: this.props.customer.firstName,
        title: this.props.customer.title,
        lastName: this.props.customer.lastName,
        phone: this.props.customer.phone,
        email: this.props.customer.email
      });
    }
  };

  GetInTouch.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        title = _props.title,
        introText = _props.introText,
        privacyPolicy = _props.privacyPolicy,
        privacyPolicyLink = _props.privacyPolicyLink,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Contact us" : _props$buttonText,
        thankYouComponents = _props.thankYouComponents;
    var _state = this.state,
        loading = _state.loading,
        form = _state.form,
        success = _state.success,
        filteredTopic = _state.filteredTopic,
        errorMessage = _state.errorMessage;

    if (success) {
      return Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_componentParser__["a" /* default */])(thankYouComponents);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_8" /* Section */],
      { padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 260
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__GetInTouch_less___default.a.GetInTouch] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 261
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["A" /* H3 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 264
            }
          },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { xmlString: introText, __source: {
            fileName: _jsxFileName,
            lineNumber: 265
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__GetInTouch_less___default.a.GetInTouchForm] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 266
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "form",
            { method: "POST", onSubmit: this._handleSubmit, noValidate: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 269
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                hide: filteredTopic.length === 1,
                center: filteredTopic.length !== 1,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 270
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 274
                  }
                },
                "About Your enquiry"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                hide: filteredTopic.length === 1,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 278
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["R" /* InputSelect */], _extends({
                name: "topic",
                label: "I'd like to know more about",
                options: filteredTopic
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "topic", this._handleTopicChange), {
                onBlur: function onBlur() {
                  if (filteredTopic[filteredTopic.findIndex(function (item) {
                    return item.value === form.topic.value;
                  })]) {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Selected \"TOPIC\" - \"" + filteredTopic[filteredTopic.findIndex(function (item) {
                        return item.value === form.topic.value;
                      })].label.toUpperCase() + "\""
                    });
                  }
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 281
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              { center: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 296
                }
              },
              (form.topic.value === "5" || form.topic.value === "6") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 298
                  }
                },
                "Your current details"
              ),
              form.topic.value !== "5" && form.topic.value !== "6" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 303
                  }
                },
                "About You"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 308
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["R" /* InputSelect */], _extends({
                name: "title",
                label: "Title",
                options: __WEBPACK_IMPORTED_MODULE_14__TITLES__["a" /* default */]
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "title"), {
                onBlur: function onBlur() {
                  if (form.title.value) {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Selected \"TITLE\" - \"" + form.title.value.toUpperCase() + "\""
                    });
                  }
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 309
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 324
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["S" /* InputText */], _extends({
                name: "firstName",
                label: "First Name"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"FIRSTNAME\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 325
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 337
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["S" /* InputText */], _extends({
                name: "lastName",
                label: "Last Name"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "lastName"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"LASTNAME\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 338
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 350
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["S" /* InputText */], _extends({
                name: "phone",
                label: "Phone"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "phone"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"PHONE\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 351
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 363
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["N" /* InputEmail */], _extends({
                name: "email",
                label: "Email"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"EMAIL\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 364
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                hide: form.topic.value === "6",
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 376
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["S" /* InputText */], _extends({
                name: "vinRego",
                label: "VIN/Registration"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "vinRego"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"REGISTRATION OR VIN\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 379
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                hide: true,
                show: form.topic.value === "5",
                center: form.topic.value === "5",
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 393
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 398
                  }
                },
                "YOUR NEW DETAILS"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                hide: true,
                show: form.topic.value === "5",
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 402
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InputSearchable_InputSearchable__["a" /* default */], _extends({
                name: "address",
                type: "address",
                label: "Address"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "address"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"ADDRESS\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 406
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                hide: true,
                show: form.topic.value === "6",
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 421
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InputSearchable_InputSearchable__["a" /* default */], _extends({
                name: "address",
                type: "address",
                label: "Address"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "address"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"ADDRESS\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 425
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                hide: true,
                show: form.topic.value === "6",
                center: form.topic.value === "6",
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 438
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 443
                  }
                },
                "UPDATE YOUR VEHICLE OWNERSHIP STATUS"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                hide: true,
                show: form.topic.value === "6",
                center: true,
                radio: true,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 447
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["P" /* InputRadio */], _extends({
                name: "ownership",
                value: 1,
                label: "I've sold my Mazda",
                checked: true
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "ownership"), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 453
                }
              })),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["P" /* InputRadio */], _extends({
                name: "ownership",
                value: 2,
                label: "I've bought a Mazda"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "ownership"), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 460
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                hide: true,
                show: form.topic.value === "6",
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 467
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["S" /* InputText */], _extends({
                name: "vinRego",
                label: "VIN/Registration"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "vinRego"), {
                onBlur: function onBlur() {
                  if (form.ownership.value === 1) {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Entered \"OLDVINREGO\""
                    });
                  }
                  if (form.ownership.value === 2) {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Entered \"CURRENTVINREGO\""
                    });
                  }
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 471
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 493
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["S" /* InputText */], _extends({
                name: "enquiry",
                label: "Tell us your enquiry"
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "enquiry"), {
                onBlur: function onBlur() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"ENQUIRY\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 494
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 506
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              { show: true, checkbox: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 507
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["M" /* InputCheckBox */], _extends({
                name: "privacy",
                label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 511
                    }
                  },
                  privacyPolicy,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["a" /* A */],
                    {
                      href: privacyPolicyLink,
                      onClick: function onClick() {
                        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                          pageCategory: "Get In Touch Form",
                          pageAction: "Get In Touch Form - Clicked \"PRIVACYPOLICY\""
                        });
                      },
                      external: true, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 513
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "nobr",
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 522
                        }
                      },
                      "Privacy Policy"
                    )
                  )
                )
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "privacy", function () {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Get In Touch Form",
                  pageAction: "Get In Touch Form - Checked \"PRIVACYPOLICY\""
                });
              }), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 508
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 534
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 535
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["x" /* FormGroup */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 536
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 537
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */],
                _extends({
                  styleName: "black",
                  loading: loading,
                  fullWidth: true
                }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 538
                  }
                }),
                buttonText
              )
            )
          )
        )
      )
    );
  };

  return GetInTouch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this._handleTopicChange = function () {
    var currentURL = new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_12_constants_environment__["i" /* WINDOW */].location.href);
    var _state2 = _this3.state,
        form = _state2.form,
        filteredTopic = _state2.filteredTopic;

    if (form.topic.value) {
      if (form.topic.value === "1") {
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "vinRego", { required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].REGO_OR_VIN_REQUIRED });
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "address", {});
      }
      if (form.topic.value === "2") {
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "vinRego", { required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].REGO_OR_VIN_REQUIRED });
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "address", {});
      }
      if (form.topic.value === "3") {
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "vinRego", { required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].REGO_OR_VIN_REQUIRED });
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "address", {});
      }
      if (form.topic.value === "4") {
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "vinRego", { required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].REGO_OR_VIN_REQUIRED });
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "address", {});
      }
      if (form.topic.value === "5") {
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "vinRego", { required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].REGO_OR_VIN_REQUIRED });
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "address", {
          required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].ADDRESS_REQUIRED,
          address: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].ADDRESS_INVALID
        });
      }
      if (form.topic.value === "6") {
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "vinRego", { required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].REGO_OR_VIN_REQUIRED });
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "address", {});
      }
      if (form.topic.value === "7") {
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "vinRego", {});
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "address", {});
      }
      if (form.topic.value === "8") {
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "vinRego", {});
        Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["c" /* formSetValidations */])(_this3, "address", {});
      }

      var newIndex = filteredTopic.findIndex(function (item) {
        return item.value === form.topic.value;
      });
      if (filteredTopic[newIndex] && filteredTopic[newIndex].slug) {
        currentURL.setParam("topic", filteredTopic[newIndex].slug, true);
      }
    }
  };

  this._handleSubmit = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
      var _props$buttonText2, buttonText, _state3, loading, form;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _props$buttonText2 = _this3.props.buttonText, buttonText = _props$buttonText2 === undefined ? "Contact us" : _props$buttonText2;

              if (event) event.preventDefault();
              _state3 = _this3.state, loading = _state3.loading, form = _state3.form;

              if (!(!loading && !form.submitButton.disabled)) {
                _context3.next = 6;
                break;
              }

              _context3.next = 6;
              return _this3.setState({
                loading: true
              }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var submitFormEndpoint, form, body;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        submitFormEndpoint = _this3.props.submitFormEndpoint;
                        form = _this3.state.form;
                        body = {
                          categoryTypeId: form.topic.value,
                          email: form.email.value,
                          enquiry: form.enquiry.value,
                          firstName: form.firstName.value,
                          lastName: form.lastName.value,
                          phone: form.phone.value,
                          title: form.title.value
                        };

                        if (form.topic.value === "6") {
                          if (form.ownership.value === 2) body.currentVinRego = form.vinRego.value;
                          if (form.ownership.value === 1) body.oldVinRego = form.vinRego.value;
                        }
                        if (form.topic.value !== "6") {
                          if (form.vinRego.value) body.currentVinRego = form.vinRego.value;
                        }
                        if (form.address.value) body.address = form.address.value.description;
                        if (form.address.value) body.postCode = form.address.value.postcode;
                        if (form.address.value) body.state = form.address.value.state;
                        if (form.address.value) body.suburb = form.address.value.suburb;

                        _context2.next = 11;
                        return Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_fetchAPI__["a" /* default */])({
                          method: "POST",
                          url: submitFormEndpoint,
                          body: body
                        }).then(function () {
                          var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                            var json, success, errorMsg;
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    _context.next = 2;
                                    return response.json();

                                  case 2:
                                    json = _context.sent;
                                    success = json.success, errorMsg = json.errorMsg;

                                    if (!success) {
                                      _this3.setState({
                                        errorMessage: errorMsg,
                                        loading: false
                                      });
                                    } else {
                                      // successful
                                      _this3.setState({
                                        loading: false,
                                        success: true
                                      }, function () {
                                        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                          pageCategory: "Get In Touch Form",
                                          pageAction: "Get In Touch Form - Clicked \"" + buttonText.toUpperCase() + "\""
                                        });
                                      });
                                    }

                                  case 5:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee, _this3);
                          }));

                          return function (_x2) {
                            return _ref3.apply(this, arguments);
                          };
                        }()).catch(function (response) {
                          _this3.setState({
                            errorMessage: response.message || "Failed with status " + response.status,
                            loading: false
                          });
                        });

                      case 11:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, _this3);
              })));

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

GetInTouch.displayName = "GetInTouch";


/* harmony default export */ __webpack_exports__["a"] = (GetInTouch);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_cookieHandler__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_newEvent__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GradePicker_less__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__GradePicker_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\GradePicker\\GradePicker.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var GradePicker = function (_React$Component) {
  _inherits(GradePicker, _React$Component);

  function GradePicker(props) {
    _classCallCheck(this, GradePicker);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      isModalOpen: false,
      loading: true,
      form: {
        safetyModel: {
          validations: {}
        },
        safetyModelMobile: {
          validations: {}
        }
      }

      // First Tab is bodyStyle
    };var activeIndexFirstTab = _this._findingActiveFirstTabIndex();
    _this.state.activeIndexFirstTab = activeIndexFirstTab;

    var firstTabOptions = _this._findingFirstTabOptions();
    _this.state.firstTabOptions = firstTabOptions;

    // Second Tab is driveTrain

    var secondTabOptions = _this._findingSecondTabOptions();
    _this.state.secondTabOptions = secondTabOptions;

    var activeIndexSecondTab = _this._findingActiveSecondTabIndex();
    _this.state.activeIndexSecondTab = activeIndexSecondTab;

    // Third Tab is grade
    var thirdTabOptions = _this._findingThirdTabOptions();
    _this.state.thirdTabOptions = thirdTabOptions;

    var activeIndexThirdTab = _this._findingActiveThirdTabIndex();
    _this.state.activeIndexThirdTab = activeIndexThirdTab;

    _this.state.locationState = "";
    return _this;
  }
  //new cookieHandler().getCookie("state")


  GradePicker.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.setState({
      locationState: 'Act'
    });

    // pre-selecting based on queryParams
    setTimeout(function () {
      var currentURL = new __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__["i" /* WINDOW */].location.href);

      var _state = _this2.state,
          firstTabOptions = _state.firstTabOptions,
          activeIndexFirstTab = _state.activeIndexFirstTab;

      var firstTabIndex = activeIndexFirstTab;
      if (currentURL.query.bodyStyle) {
        firstTabIndex = firstTabOptions.findIndex(function (item) {
          return item.name === currentURL.query.bodyStyle;
        });
      }
      _this2._handleClickOnFirstTab(firstTabIndex, function () {
        var _state2 = _this2.state,
            secondTabOptions = _state2.secondTabOptions,
            activeIndexSecondTab = _state2.activeIndexSecondTab;

        var secondTabIndex = activeIndexSecondTab;
        if (currentURL.query.bodyStyle) {
          secondTabIndex = secondTabOptions.findIndex(function (item) {
            return item.name === currentURL.query.drivetrain;
          });
        }
        _this2._handleClickOnSecondTab(secondTabIndex, function () {
          var _state3 = _this2.state,
              thirdTabOptions = _state3.thirdTabOptions,
              activeIndexThirdTab = _state3.activeIndexThirdTab;

          var thirdTabIndex = activeIndexThirdTab;
          if (currentURL.query.bodyStyle) {
            thirdTabIndex = thirdTabOptions.findIndex(function (item) {
              return item.name === currentURL.query.grade;
            });
          }
          _this2._handleClickOnThirdTab(thirdTabIndex, function () {
            _this2.setState({
              loading: false
            });
          }, true);
        }, false);
      }, false);
    }, 10);

    __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("POSTCODE_UPDATE", function () {
      return _this2._updatePrice();
    }, false);
  };

  // there is a scenario to update the price after changing the postcode
  // POSTCODE_UPDATE fires in location-async at the moment


  GradePicker.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames7, _classnames8, _classnames9;

    var _props = this.props,
        heading = _props.heading,
        description = _props.description;
    var _state4 = this.state,
        thirdTabOptions = _state4.thirdTabOptions,
        activeIndexThirdTab = _state4.activeIndexThirdTab,
        firstTabOptions = _state4.firstTabOptions,
        secondTabOptions = _state4.secondTabOptions;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        "data-test": "grade-picker",
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.GradePicker] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 824
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 829
        }
      }),
      (heading || description) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["n" /* HeroContent */], {
        heading: heading,
        description: description,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 831
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 836
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_21" /* Visible */],
          { visible: ["screen", "tablet", "mobile"], __source: {
              fileName: _jsxFileName,
              lineNumber: 837
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.TabsContainer] = true, _classnames2)), __source: {
                fileName: _jsxFileName,
                lineNumber: 838
              }
            },
            firstTabOptions && firstTabOptions.length > 1 && secondTabOptions && secondTabOptions.length === 1 && this._renderFirstTab(),
            secondTabOptions && secondTabOptions.length > 1 && firstTabOptions && firstTabOptions.length === 1 && this._renderSecondTab(),
            firstTabOptions && firstTabOptions.length > 1 && secondTabOptions && secondTabOptions.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.GradePickerTwoTabs] = true, _classnames3)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 860
                }
              },
              this._renderFirstTab(),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                {
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.Span] = true, _classnames4)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 865
                  }
                },
                " ",
                "/",
                " "
              ),
              this._renderSecondTab()
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 879
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_21" /* Visible */],
          { visible: ["screen"], __source: {
              fileName: _jsxFileName,
              lineNumber: 880
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.TabsContainer] = true, _classnames5)), __source: {
                fileName: _jsxFileName,
                lineNumber: 881
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 885
              }
            }),
            this._renderThirdTabTablet()
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 891
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_21" /* Visible */],
          { visible: ["tablet", "mobile"], __source: {
              fileName: _jsxFileName,
              lineNumber: 892
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.TabsContainer] = true, _classnames6)), __source: {
                fileName: _jsxFileName,
                lineNumber: 893
              }
            },
            this._renderThirdTabTablet(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 897
              }
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_21" /* Visible */],
        { visible: ["screen", "tablet", "mobile"], __source: {
            fileName: _jsxFileName,
            lineNumber: 902
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
          { sizeName: "screen", gutter: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 903
            }
          },
          thirdTabOptions && thirdTabOptions.length > 0 && thirdTabOptions[activeIndexThirdTab] && thirdTabOptions[activeIndexThirdTab].features && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.ImageFeaturesParent] = true, _classnames7)), __source: {
                fileName: _jsxFileName,
                lineNumber: 908
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.ImageFeatures] = true, _classnames8)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 912
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames9 = {}, _classnames9[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.Image] = true, _classnames9)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 916
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: thirdTabOptions[activeIndexThirdTab].imageSrc, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 920
                  }
                })
              ),
              this._renderCommonFeaturesArea()
            ),
            this._renderCommonButtons()
          )
        )
      )
    );
  };

  return GradePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this._updatePrice = function () {
    //new cookieHandler().getCookie("state") - remove in order to have a hard coded value for NZ
    _this3.setState({
      locationState: 'ACT'
    }, function () {
      _this3.setState({
        thirdTabOptions: _this3._findingThirdTabOptions()
      }, _this3._handleOnChange);
    });
  };

  this._findingActiveFirstTabIndex = function () {
    var data = _this3.props.data;

    var activeIndexFirstTab = 0;
    if (data && data.children && data.children.length > 0) {
      if (data.children.length === 1) {
        activeIndexFirstTab = 0;
      } else {
        data.children.forEach(function (item, index) {
          if (item.default) {
            activeIndexFirstTab = index;
          }
        });
      }
    }
    return activeIndexFirstTab;
  };

  this._findingFirstTabOptions = function () {
    var data = _this3.props.data;

    if (data && data.children && data.children && data.children.length > 0) {
      return data.children.map(function (item) {
        var option = {};
        option.name = item.name;
        return option;
      });
    }
    return null;
  };

  this._findingActiveSecondTabIndex = function () {
    var data = _this3.props.data;
    var activeIndexFirstTab = _this3.state.activeIndexFirstTab;

    var activeIndexSecondTab = 0;
    if (data && data.children && data.children[activeIndexFirstTab].children && data.children[activeIndexFirstTab].children.length > 0) {
      if (data.children[activeIndexFirstTab].children.length === 1) {
        activeIndexSecondTab = 0;
      } else {
        data.children[activeIndexFirstTab].children.forEach(function (item, index) {
          if (item.default) {
            activeIndexSecondTab = index;
          }
        });
      }
    }
    return activeIndexSecondTab;
  };

  this._findingSecondTabOptions = function () {
    var data = _this3.props.data;
    var activeIndexFirstTab = _this3.state.activeIndexFirstTab;

    if (data && data.children && data.children[activeIndexFirstTab] && data.children[activeIndexFirstTab].children && data.children[activeIndexFirstTab].children.length > 0) {
      return data.children[activeIndexFirstTab].children.map(function (item) {
        var option = {};
        option.name = item.name;
        return option;
      });
    }
    return null;
  };

  this._findingActiveThirdTabIndex = function () {
    var _state5 = _this3.state,
        activeIndexFirstTab = _state5.activeIndexFirstTab,
        activeIndexSecondTab = _state5.activeIndexSecondTab;
    var data = _this3.props.data;

    var activeIndexThirdTab = 0;
    if (data && data.children && data.children && data.children.length > 0) {
      if (data.children[activeIndexFirstTab] && data.children[activeIndexFirstTab].children && data.children[activeIndexFirstTab].children[activeIndexSecondTab] && data.children[activeIndexFirstTab].children[activeIndexSecondTab].children && data.children[activeIndexFirstTab].children[activeIndexSecondTab].children.length > 0) {
        data.children[activeIndexFirstTab].children[activeIndexSecondTab].children.forEach(function (item, index) {
          if (item.default) {
            activeIndexThirdTab = index;
          }
        });
      }
    }
    return activeIndexThirdTab;
  };

  this._findingThirdTabOptions = function () {
    var _state6 = _this3.state,
        activeIndexFirstTab = _state6.activeIndexFirstTab,
        activeIndexSecondTab = _state6.activeIndexSecondTab,
        locationState = _state6.locationState,
        form = _state6.form;

    var thirdTabOptions = null;
    var _props2 = _this3.props,
        data = _props2.data,
        safetyModelExcess = _props2.safetyModelExcess,
        safetyModelDisclaimer = _props2.safetyModelDisclaimer,
        gtm = _props2.gtm;

    if (data && data.children && data.children && data.children.length > 0) {
      if (data.children[activeIndexFirstTab] && data.children[activeIndexFirstTab].children && data.children[activeIndexFirstTab].children[activeIndexSecondTab] && data.children[activeIndexFirstTab].children[activeIndexSecondTab].children && data.children[activeIndexFirstTab].children[activeIndexSecondTab].children.length > 0) {
        thirdTabOptions = data.children[activeIndexFirstTab].children[activeIndexSecondTab].children.map(function (item) {
          // finding price in item.price
          var option = {};
          var rightItemBasedOnState = {};
          option.name = item.name;

          if (locationState && item.price && item.price.length > 0) {
            rightItemBasedOnState = item.price[item.price.findIndex(function (priceItem) {
              return priceItem.state.toLowerCase() === locationState.toLowerCase();
            })];
            if (rightItemBasedOnState && rightItemBasedOnState.price) {
              var _classnames10;

              option.price = rightItemBasedOnState.price.toLocaleString();

              option.extraLabel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
                {
                  withoutStyle: true,
                  onClick: function onClick(event) {
                    if (event && event.target && event.target.querySelector('button')) {
                      event.target.querySelector('button').click();
                    }
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 271
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["l" /* Caption */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 279
                    }
                  },
                  "From"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames10 = {}, _classnames10[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.Price] = true, _classnames10)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 279
                    }
                  },
                  "$",
                  (form.safetyModel.value || form.safetyModelMobile.value) && rightItemBasedOnState.safetyModelPrice ? rightItemBasedOnState.safetyModelPrice.toLocaleString() : rightItemBasedOnState.price.toLocaleString(),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["i" /* Disclaimer */],
                    {
                      Icon: __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_14" /* StarIcon */],
                      gtm: {
                        category: gtm && gtm.category ? gtm.category : "Nameplates - " + _this3.props.nameplate,
                        action: (gtm && gtm.action ? gtm.action : "Grade Picker") + " - Clicked \"PRICE\" - \"" + item.name.toUpperCase() + "\""
                      }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 282
                      }
                    },
                    rightItemBasedOnState.disclaimer
                  )
                )
              );

              option.hasSafetyModelOption = !!rightItemBasedOnState.safetyModelPrice;

              option.safetyModelExcess = rightItemBasedOnState.safetyModelPrice && safetyModelExcess ? rightItemBasedOnState.price === rightItemBasedOnState.safetyModelPrice ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 298
                  }
                },
                "Included as standard"
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
                {
                  withoutStyle: true,
                  onClick: function onClick(event) {
                    if (event && event.target && event.target.querySelector('button')) {
                      event.target.querySelector('button').click();
                    }
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 299
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["l" /* Caption */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 307
                    }
                  },
                  "+$",
                  safetyModelExcess.toLocaleString(),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["i" /* Disclaimer */],
                    {
                      Icon: __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_14" /* StarIcon */],
                      gtm: {
                        category: gtm && gtm.category ? gtm.category : "Nameplates - " + _this3.props.nameplate,
                        action: (gtm && gtm.action ? gtm.action : "Grade Picker") + " - Clicked \"SAFETY MODEL PRICE\" - \"" + item.name.toUpperCase() + "\""
                      }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 309
                      }
                    },
                    safetyModelDisclaimer
                  )
                )
              ) : null;

              option.isSafetyModel = rightItemBasedOnState.price && rightItemBasedOnState.safetyModelPrice && rightItemBasedOnState.price === rightItemBasedOnState.safetyModelPrice;
            }
          }
          if (item.imageSrc) option.imageSrc = item.imageSrc;
          if (item.featuresHeading) option.featuresHeading = item.featuresHeading;
          if (item.features) option.features = item.features;

          return option;
        });
      }
    }
    return thirdTabOptions;
  };

  this._handleClickOnFirstTab = function (activeIndexFirstTab) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var callOnChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    _this3.setState({
      activeIndexFirstTab: activeIndexFirstTab
    }, function () {
      _this3.setState({
        secondTabOptions: _this3._findingSecondTabOptions()
      }, function () {
        _this3.setState({
          activeIndexSecondTab: _this3._findingActiveSecondTabIndex()
        }, function () {
          _this3.setState({
            thirdTabOptions: _this3._findingThirdTabOptions()
          }, function () {
            _this3.setState({
              activeIndexThirdTab: _this3._findingActiveThirdTabIndex()
            }, function () {
              var gtm = _this3.props.gtm;
              var _state7 = _this3.state,
                  firstTabOptions = _state7.firstTabOptions,
                  activeIndexFirstTab = _state7.activeIndexFirstTab;


              callback();
              if (callOnChange) {
                _this3._handleOnChange();

                if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
                  Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: gtm.category,
                    pageAction: gtm.action + " - Clicked \"" + firstTabOptions[activeIndexFirstTab].name + "\""
                  });
                }
              }
            });
          });
        });
      });
    });
  };

  this._handleClickOnSecondTab = function (activeIndexSecondTab) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var callOnChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    _this3.setState({
      activeIndexSecondTab: activeIndexSecondTab
    }, function () {
      _this3.setState({
        thirdTabOptions: _this3._findingThirdTabOptions()
      }, function () {
        _this3.setState({
          activeIndexThirdTab: _this3._findingActiveThirdTabIndex()
        }, function () {
          var gtm = _this3.props.gtm;
          var _state8 = _this3.state,
              secondTabOptions = _state8.secondTabOptions,
              activeIndexSecondTab = _state8.activeIndexSecondTab;


          callback();
          if (callOnChange) {
            _this3._handleOnChange();

            if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
              Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: gtm.category,
                pageAction: gtm.action + " - Clicked \"" + secondTabOptions[activeIndexSecondTab].name + "\""
              });
            }
          }
        });
      });
    });
  };

  this._handleClickOnThirdTab = function (activeIndexThirdTab) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var callOnChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    _this3.setState({
      activeIndexThirdTab: activeIndexThirdTab
    }, function () {
      var gtm = _this3.props.gtm;
      var _state9 = _this3.state,
          thirdTabOptions = _state9.thirdTabOptions,
          activeIndexThirdTab = _state9.activeIndexThirdTab;


      callback();
      if (callOnChange) {
        _this3._handleOnChange();

        if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
          Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__["a" /* default */])({
            pageCategory: gtm.category,
            pageAction: gtm.action + " - Clicked \"" + thirdTabOptions[activeIndexThirdTab].name + "\""
          });
        }
      }
    });
  };

  this._handleOnChange = function () {
    // We call On Change for Specification Block
    var _props3 = _this3.props,
        _props3$onChange = _props3.onChange,
        onChange = _props3$onChange === undefined ? function () {} : _props3$onChange,
        name = _props3.name,
        data = _props3.data;
    var _state10 = _this3.state,
        activeIndexFirstTab = _state10.activeIndexFirstTab,
        firstTabOptions = _state10.firstTabOptions,
        secondTabOptions = _state10.secondTabOptions,
        activeIndexSecondTab = _state10.activeIndexSecondTab,
        activeIndexThirdTab = _state10.activeIndexThirdTab,
        thirdTabOptions = _state10.thirdTabOptions;

    // Reset safety model to default on tab change

    Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(_this3, {
      safetyModel: thirdTabOptions[activeIndexThirdTab] && thirdTabOptions[activeIndexThirdTab].isSafetyModel || false,
      safetyModelMobile: thirdTabOptions[activeIndexThirdTab] && thirdTabOptions[activeIndexThirdTab].isSafetyModel || false
    });

    if (onChange && typeof onChange === "function") {
      if (firstTabOptions[activeIndexFirstTab] && firstTabOptions[activeIndexFirstTab].name && secondTabOptions[activeIndexSecondTab] && secondTabOptions[activeIndexSecondTab].name && thirdTabOptions[activeIndexThirdTab] && thirdTabOptions[activeIndexThirdTab].name) {
        onChange({
          bodystyle: firstTabOptions[activeIndexFirstTab].name,
          drivetrain: secondTabOptions[activeIndexSecondTab].name,
          grade: thirdTabOptions[activeIndexThirdTab].name,
          nameplate: data.name
        });
      }
    }
  };

  this._renderFirstTab = function () {
    var _state11 = _this3.state,
        firstTabOptions = _state11.firstTabOptions,
        activeIndexFirstTab = _state11.activeIndexFirstTab;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 489
        }
      },
      firstTabOptions && firstTabOptions.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["I" /* Tabs */], {
        scrolling: true,
        activeIndex: activeIndexFirstTab,
        onClick: _this3._handleClickOnFirstTab,
        options: firstTabOptions.map(function (item) {
          return {
            name: item.name
          };
        }),
        divider: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 492
        }
      })
    );
  };

  this._renderSecondTab = function () {
    var _state12 = _this3.state,
        secondTabOptions = _state12.secondTabOptions,
        activeIndexSecondTab = _state12.activeIndexSecondTab;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 511
        }
      },
      secondTabOptions && secondTabOptions.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["I" /* Tabs */], {
        scrolling: true,
        activeIndex: activeIndexSecondTab,
        onClick: _this3._handleClickOnSecondTab,
        options: secondTabOptions.map(function (item) {
          return {
            name: item.name
          };
        }),
        divider: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 514
        }
      })
    );
  };

  this._renderThirdTabScreen = function () {
    var _state13 = _this3.state,
        thirdTabOptions = _state13.thirdTabOptions,
        activeIndexFirstTab = _state13.activeIndexFirstTab,
        activeIndexThirdTab = _state13.activeIndexThirdTab;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 537
        }
      },
      thirdTabOptions && thirdTabOptions.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["I" /* Tabs */], {
        scrolling: true,
        key: "ThirdTab-" + activeIndexFirstTab,
        activeIndex: activeIndexThirdTab,
        onClick: _this3._handleClickOnThirdTab,
        options: thirdTabOptions.map(function (_ref) {
          var name = _ref.name;
          return { name: name };
        }),
        animatedLine: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 540
        }
      })
    );
  };

  this._renderThirdTabTablet = function () {
    var _state14 = _this3.state,
        thirdTabOptions = _state14.thirdTabOptions,
        activeIndexFirstTab = _state14.activeIndexFirstTab,
        activeIndexThirdTab = _state14.activeIndexThirdTab;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 560
        }
      },
      thirdTabOptions && thirdTabOptions.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["I" /* Tabs */],
        {
          manualScroll: true,
          animatedLine: true,
          key: "ThirdTab-" + activeIndexFirstTab,
          activeIndex: activeIndexThirdTab,
          onClick: _this3._handleClickOnThirdTab,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 563
          }
        },
        thirdTabOptions.map(function (item) {
          var _classnames11, _classnames12;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              key: item.name,
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames11 = {}, _classnames11[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.ThirdTab] = true, _classnames11)), __source: {
                fileName: _jsxFileName,
                lineNumber: 573
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 578
                }
              },
              item.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 579
              }
            }),
            item.price && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["l" /* Caption */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 580
                }
              },
              "From $" + item.price
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames12 = {}, _classnames12[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.ThirdTabImage] = true, _classnames12)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 581
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["o" /* Image */], { src: item.imageSrc + "?width=240", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 584
                }
              })
            )
          );
        })
      )
    );
  };

  this._renderCommonFeaturesArea = function () {
    var _classnames13, _classnames14, _classnames15, _classnames16;

    var mobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _props4 = _this3.props,
        safetyModelBlurb = _props4.safetyModelBlurb,
        fullSpecCta = _props4.fullSpecCta,
        data = _props4.data,
        _props4$onChange = _props4.onChange,
        onChange = _props4$onChange === undefined ? function () {} : _props4$onChange,
        gtm = _props4.gtm;
    var _state15 = _this3.state,
        firstTabOptions = _state15.firstTabOptions,
        activeIndexFirstTab = _state15.activeIndexFirstTab,
        secondTabOptions = _state15.secondTabOptions,
        activeIndexSecondTab = _state15.activeIndexSecondTab,
        thirdTabOptions = _state15.thirdTabOptions,
        activeIndexThirdTab = _state15.activeIndexThirdTab,
        locationState = _state15.locationState,
        loading = _state15.loading,
        form = _state15.form;

    var activeGrade = thirdTabOptions[activeIndexThirdTab];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames13 = {}, _classnames13[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.Features] = true, _classnames13)), __source: {
          fileName: _jsxFileName,
          lineNumber: 601
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames14 = {}, _classnames14[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.FeatureSingle] = true, _classnames14[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.FeatureLine] = true, _classnames14)), __source: {
            fileName: _jsxFileName,
            lineNumber: 605
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["C" /* H5 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 609
            }
          },
          activeGrade.name
        ),
        loading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["V" /* LoadingIcon */], {
          style: {
            width: "16px",
            height: "16px"
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 612
          }
        }) : activeGrade.extraLabel
      ),
      !locationState && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames15 = {}, _classnames15[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.FeatureSingle] = true, _classnames15[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.FeatureLine] = true, _classnames15)), __source: {
            fileName: _jsxFileName,
            lineNumber: 624
          }
        },
        _this3._renderPostcodePrompt()
      ),
      locationState && activeGrade.safetyModelExcess && activeGrade.hasSafetyModelOption && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames16 = {}, _classnames16[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.FeatureSingle] = true, _classnames16[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.FeatureLine] = true, _classnames16)), __source: {
            fileName: _jsxFileName,
            lineNumber: 635
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { display: "flex", alignItems: "center" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 639
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["M" /* InputCheckBox */], _extends({
            key: "VT-" + activeGrade.name,
            name: "vision",
            label: "Vision Technology",
            checked: activeGrade.isSafetyModel,
            disabled: activeGrade.isSafetyModel
          }, Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(_this3, "safetyModel" + (mobile ? 'Mobile' : ''), function (value) {
            _this3.setState({
              loading: false,
              thirdTabOptions: _this3._findingThirdTabOptions()
            }, function () {
              if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "" && (value || form["safetyModel" + (mobile ? 'Mobile' : '')].value)) {
                Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: gtm.category,
                  pageAction: gtm.action + " - " + (value ? "Checked" : "Unchecked") + " \"SAFETY MODEL\""
                });
              }
              if (onChange && typeof onChange === "function") {
                onChange({
                  bodystyle: firstTabOptions[activeIndexFirstTab].name,
                  drivetrain: secondTabOptions[activeIndexSecondTab].name,
                  grade: thirdTabOptions[activeIndexThirdTab].name,
                  nameplate: data.name,
                  isSafetyModel: !!_this3.state.form["safetyModel" + (mobile ? 'Mobile' : '')].value
                });
              }
            });
          }), {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 640
            }
          })),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            {
              onClick: function onClick() {
                _this3.setState({ isModalOpen: true }, function () {
                  if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
                    Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: gtm.category,
                      pageAction: gtm.action + " - Opened \"SAFETY MODEL\" modal"
                    });
                  }
                });
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 669
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["J" /* InfoIcon */], { style: {
                height: "16px",
                width: "16px",
                fill: "#999999",
                paddingLeft: "6px",
                cursor: "pointer",
                verticalAlign: "middle"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 680
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 690
            }
          },
          activeGrade.safetyModelExcess
        )
      ),
      _this3.state.isModalOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["Z" /* Modal */],
        {
          width: "600px",
          handleClose: function handleClose() {
            _this3.setState({ isModalOpen: false });
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 695
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], { xmlString: safetyModelBlurb, textAlign: "left", __source: {
            fileName: _jsxFileName,
            lineNumber: 700
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
          {
            styleName: "black",
            onClick: function onClick() {
              _this3.setState({ isModalOpen: false });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 701
            }
          },
          "Close"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 710
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */],
        { textAlign: "left", __source: {
            fileName: _jsxFileName,
            lineNumber: 711
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 712
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "b",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 712
              }
            },
            activeGrade.featuresHeading ? activeGrade.featuresHeading : thirdTabOptions.length === 1 || activeIndexThirdTab === 0 || thirdTabOptions.length === activeIndexThirdTab - 1 ? "Base features:" : "In addition to " + thirdTabOptions[activeIndexThirdTab - 1].name + ":"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 723
            }
          },
          activeGrade.features.map(function (item, index) {
            var _classnames17;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              {
                key: "Featuer-" + index,
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames17 = {}, _classnames17[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.FeatureSingle] = true, _classnames17)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 725
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["l" /* Caption */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 730
                  }
                },
                item.description
              )
            );
          })
        )
      ),
      fullSpecCta && fullSpecCta.href && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 738
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
          { styleName: "black", onClick: _this3._handleClickOnViewSpecification, __source: {
              fileName: _jsxFileName,
              lineNumber: 739
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["l" /* Caption */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 740
              }
            },
            fullSpecCta.label || 'View full specs >'
          )
        )
      )
    );
  };

  this._renderCommonButtons = function () {
    var _classnames18;

    var _props5 = _this3.props,
        fullSpecCta = _props5.fullSpecCta,
        components = _props5.components;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames18 = {}, _classnames18[__WEBPACK_IMPORTED_MODULE_10__GradePicker_less___default.a.Buttons] = true, _classnames18)), __source: {
          fileName: _jsxFileName,
          lineNumber: 751
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(components)
    );
  };

  this._handleClickOnViewSpecification = function () {
    var fullSpecCta = _this3.props.fullSpecCta;
    var _state16 = _this3.state,
        firstTabOptions = _state16.firstTabOptions,
        secondTabOptions = _state16.secondTabOptions,
        thirdTabOptions = _state16.thirdTabOptions,
        activeIndexFirstTab = _state16.activeIndexFirstTab,
        activeIndexSecondTab = _state16.activeIndexSecondTab,
        activeIndexThirdTab = _state16.activeIndexThirdTab;

    var newSpecsUrl = fullSpecCta.href;
    newSpecsUrl = newSpecsUrl + ("?bodyStyle=" + encodeURIComponent(firstTabOptions[activeIndexFirstTab].name));
    newSpecsUrl = newSpecsUrl + ("&drivetrain=" + encodeURIComponent(secondTabOptions[activeIndexSecondTab].name));
    newSpecsUrl = newSpecsUrl + ("&grade=" + encodeURIComponent(thirdTabOptions[activeIndexThirdTab].name));

    if (fullSpecCta.gtm && fullSpecCta.gtm.category && fullSpecCta.gtm.action && fullSpecCta.gtm.category !== "" && fullSpecCta.gtm.action !== "") {
      Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__["a" /* default */])({
        pageCategory: fullSpecCta.gtm.category,
        pageAction: fullSpecCta.gtm.action
      });
    }

    setTimeout(function () {
      new __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_urlHandler__["a" /* default */](newSpecsUrl).redirect(true);
    }, 200);
  };

  this._handleOpenPostcodePopup = function () {
    setTimeout(function () {

      var event = Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_newEvent__["a" /* createNewEvent */])('POSTCODE_POPUP_OPEN');
      Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_newEvent__["b" /* dispatchEvent */])(event);
    }, 100);
  };

  this._renderPostcodePrompt = function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 807
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["b" /* AddressIcon */], { style: { height: "16px", width: "16px", margin: "0 4px -4px 0", fill: "#910A2D" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 808
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
        { onClick: _this3._handleOpenPostcodePopup, __source: {
            fileName: _jsxFileName,
            lineNumber: 809
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["l" /* Caption */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 809
            }
          },
          "Enter postcode for pricing"
        )
      )
    );
  };
};

GradePicker.displayName = "GradePicker";


/* harmony default export */ __webpack_exports__["a"] = (GradePicker);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Heading\\Heading.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Heading = function (_React$Component) {
  _inherits(Heading, _React$Component);

  function Heading() {
    _classCallCheck(this, Heading);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Heading.prototype.render = function render() {
    var _props = this.props,
        _props$tag = _props.tag,
        tag = _props$tag === undefined ? 'h2' : _props$tag,
        value = _props.value,
        preHeading = _props.preHeading,
        white = _props.white,
        margin = _props.margin,
        backgroundColor = _props.backgroundColor;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_8" /* Section */],
      { padding: margin, backgroundColor: backgroundColor, __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      preHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["D" /* H6 */],
        { white: white, withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 18
          }
        },
        preHeading
      ),
      tag === 'h1' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["y" /* H1 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        }),
        value
      ),
      tag === 'h2' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["z" /* H2 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        }),
        value
      ),
      tag === 'h3' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["A" /* H3 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        }),
        value
      ),
      tag === 'h4' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["B" /* H4 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          }
        }),
        value
      ),
      tag === 'h5' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["C" /* H5 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        }),
        value
      ),
      tag === 'h6' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["D" /* H6 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        }),
        value
      )
    );
  };

  return Heading;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Heading.displayName = 'Heading';


/* harmony default export */ __webpack_exports__["a"] = (Heading);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Hero_less__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Hero_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Hero_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Hero\\Hero.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Hero = function (_React$PureComponent) {
  _inherits(Hero, _React$PureComponent);

  function Hero(props) {
    _classCallCheck(this, Hero);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._setHeight = function (height) {
      _this.setState({
        height: height
      });
    };

    _this.state = {
      height: 50
    };
    return _this;
  }

  Hero.prototype.render = function render() {
    var _classnames,
        _this2 = this,
        _classnames2,
        _classnames3,
        _classnames4,
        _classnames5,
        _classnames6,
        _classnames7,
        _classnames8;

    var _props = this.props,
        backgroundVideo = _props.backgroundVideo,
        heading = _props.heading,
        preHeading = _props.preHeading,
        components = _props.components,
        mobileBackgroundVideo = _props.mobileBackgroundVideo,
        mobileBackgroundImage = _props.mobileBackgroundImage,
        backgroundImage = _props.backgroundImage,
        mobileHeading = _props.mobileHeading,
        mobilePreHeading = _props.mobilePreHeading,
        glow = _props.glow,
        icon = _props.icon,
        scrollToSlug = _props.scrollToSlug,
        gtm = _props.gtm;
    var height = this.state.height;


    if (!mobileHeading) mobileHeading = heading;
    if (!mobilePreHeading) mobilePreHeading = preHeading;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.Hero] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 55
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["f" /* BrowserHeightSection */],
        { setHeight: this._setHeight, __source: {
            fileName: _jsxFileName,
            lineNumber: 58
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            ref: function ref(c) {
              return _this2.heroInside = c;
            },
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.HeroInside] = true, _classnames2)),
            __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_21" /* Visible */],
            { visible: ["screen", "tablet"], __source: {
                fileName: _jsxFileName,
                lineNumber: 65
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["K" /* VideoPlayer */], {
              poster: backgroundImage,
              src: backgroundVideo,
              height: __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_environment__["d" /* IS_IE */] || __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_environment__["c" /* IS_EDGE */] ? "100%" : height + "px",
              calculatedHeight: true,
              visible: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 66
              }
            }),
            heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.HeroContent] = true, _classnames3)),
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 74
                }
              },
              preHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["D" /* H6 */],
                { withDetails: true, white: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 80
                  }
                },
                preHeading
              ),
              heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["y" /* H1 */],
                { white: true, withDetails: true, glow: glow, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 83
                  }
                },
                heading
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_21" /* Visible */],
            { visible: ["mobile"], __source: {
                fileName: _jsxFileName,
                lineNumber: 90
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["K" /* VideoPlayer */], {
              poster: mobileBackgroundImage || backgroundImage,
              src: mobileBackgroundVideo || backgroundVideo,
              height: height + "px",
              calculatedHeight: true,
              visible: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 91
              }
            }),
            mobileHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.HeroContent] = true, _classnames4)),
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 99
                }
              },
              mobilePreHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["D" /* H6 */],
                { white: true, withDetails: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 105
                  }
                },
                mobilePreHeading
              ),
              mobileHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["y" /* H1 */],
                { white: true, withDetails: true, glow: glow, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 108
                  }
                },
                mobileHeading
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.Bottom] = true, _classnames5)),
              __source: {
                fileName: _jsxFileName,
                lineNumber: 116
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.ColumnIn] = true, _classnames6[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.ZoomZoom] = true, _classnames6)),
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 122
                }
              },
              icon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: icon, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 128
                }
              }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_25" /* ZoomZoomIcon */], {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 128
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.ColumnIn] = true, _classnames7[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.Center] = true, _classnames7[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.White] = true, _classnames7)),
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 130
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])(components)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.ColumnIn] = true, _classnames8[__WEBPACK_IMPORTED_MODULE_6__Hero_less___default.a.Slug] = true, _classnames8)),
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 140
                }
              },
              scrollToSlug && scrollToSlug != '' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["k" /* ButtonIcon */],
                {
                  href: "#" + scrollToSlug,
                  gtm: {
                    category: gtm && gtm.category ? gtm.category : "Hero",
                    action: gtm && gtm.action ? gtm.action : "Clicked Scroll to Slug - " + scrollToSlug
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 147
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_12" /* SlugIcon */], {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 153
                  }
                })
              )
            )
          )
        )
      )
    );
  };

  return Hero;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Hero.displayName = "Hero";


/* harmony default export */ __webpack_exports__["a"] = (Hero);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image_less__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Image_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_debounce__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_checkVisible__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Image\\Image.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Image = function (_React$Component) {
  _inherits(Image, _React$Component);

  function Image(props) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._removeScrollEventListener = function () {
      __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_debounce__["a" /* default */])(_this._checkVisibility, 250), {
        passive: true
      });
    };

    _this._loadImageInBackground = function (_ref) {
      var _ref$model = _ref.model,
          model = _ref$model === undefined ? "new" : _ref$model;
      var src = _this.props.src;
      var loading = _this.state.loading;


      if (model === "new" && !loading) return;

      _this.setState({
        loading: true,
        model: model
      }, function () {
        var img = document.createElement("img");
        img.src = src;
        var poll = setInterval(function () {
          if (_this.image && img.naturalWidth) {
            clearInterval(poll);
            _this.image.removeAttribute("data-src");
            _this.image.setAttribute("src", src);
            setTimeout(function () {
              _this.setState({ loading: false });
            }, 100);
          }
        }, 10);
      });
    };

    _this._checkVisibility = function () {
      var loading = _this.state.loading;


      if (_this.image && loading) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_checkVisible__["a" /* default */])(_this.image)) {
          _this._removeScrollEventListener();
          _this._loadImageInBackground({ model: "new" });
        }
      } else {
        setTimeout(_this._checkVisibility, 100);
      }
    };

    _this.state = {
      loading: true,
      model: "new",
      isIE: false
    };
    return _this;
  }

  Image.prototype.componentDidMount = function componentDidMount() {
    var src = this.props.src;

    if (!src) return;
    this._checkVisibility();
    __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_debounce__["a" /* default */])(this._checkVisibility, 250), {
      passive: true
    });

    this.setState({
      isIE: __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["d" /* IS_IE */]
    });
  };

  Image.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var src = this.props.src;

    if (src !== prevProps.src) {
      this._loadImageInBackground({ model: "replace" });
    }
  };

  Image.prototype.componentWillUnmount = function componentWillUnmount() {
    this._removeScrollEventListener();
  };

  Image.prototype.render = function render() {
    var _classnames,
        _this2 = this,
        _classnames2,
        _classnames3;

    var _props = this.props,
        src = _props.src,
        _props$type = _props.type,
        type = _props$type === undefined ? "normal" : _props$type,
        alt = _props.alt,
        _props$contain = _props.contain,
        contain = _props$contain === undefined ? false : _props$contain,
        _props$draggable = _props.draggable,
        draggable = _props$draggable === undefined ? true : _props$draggable,
        fallbackSrc = _props.fallbackSrc,
        _props$loadingTheme = _props.loadingTheme,
        loadingTheme = _props$loadingTheme === undefined ? "dark" : _props$loadingTheme;
    var _state = this.state,
        loading = _state.loading,
        isIE = _state.isIE;


    if (!src) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 105
      }
    });

    if (!fallbackSrc) fallbackSrc = src;

    if (type === "blurred") {
      fallbackSrc = fallbackSrc + "?blur=10&quality=0.1";
    }

    if (type === "normal" || type === "withoutSpinner") {
      fallbackSrc = "" + fallbackSrc;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Image_less___default.a.ImageContainer] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Image_less___default.a.ImageContainerLoading] = type === "blurred" && loading, _classnames[__WEBPACK_IMPORTED_MODULE_2__Image_less___default.a.ImageContainerLight] = loadingTheme === "light", _classnames[__WEBPACK_IMPORTED_MODULE_2__Image_less___default.a.ImageContainerDark] = loadingTheme === "dark", _classnames[__WEBPACK_IMPORTED_MODULE_2__Image_less___default.a.ImageContainerContain] = contain && !isIE, _classnames[__WEBPACK_IMPORTED_MODULE_2__Image_less___default.a.ImageContainerIE] = isIE, _classnames)), style: { minHeight: loading ? '67px' : '' }, __source: {
          fileName: _jsxFileName,
          lineNumber: 118
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        ref: function ref(c) {
          return _this2.image = c;
        },
        src: fallbackSrc,
        "data-src": src,
        alt: alt,
        draggable: draggable,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126
        }
      }),
      loading && type === "normal" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Image_less___default.a.LoadingLayer] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 136
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__Image_less___default.a.LoadingIcon] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 139
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["V" /* LoadingIcon */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 142
            }
          })
        )
      )
    );
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Image.displayName = "Image";


/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image360_less__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image360_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Image360_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_aframe__ = __webpack_require__(1155);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Image360\\Image360.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Image360 = function (_React$Component) {
  _inherits(Image360, _React$Component);

  function Image360(props) {
    _classCallCheck(this, Image360);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    if (process && process.env && "production" === 'test') {
      _this.randomIdName = 1;
    } else {
      _this.randomIdName = "image360" + Math.floor(Math.random() * 1000);
    }

    _this.state = {
      idName: _this.randomIdName,
      loading: true
    };

    _this.aframe = null;
    return _this;
  }

  Image360.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.aframe = new __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_aframe__["a" /* default */]();

    this.aframe.loadAframe({
      callback: function callback() {
        setTimeout(function () {
          _this2.setState({
            loading: false
          });
        }, 400);
      }
    });
  };

  Image360.prototype.render = function render() {
    var _classnames;

    var src = this.props.src;
    var _state = this.state,
        idName = _state.idName,
        loading = _state.loading;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        id: idName,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Image360_less___default.a.Image360] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 43
        }
      },
      !loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a-scene",
        { embedded: "true", __source: {
            fileName: _jsxFileName,
            lineNumber: 50
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a-entity",
          { rotation: "0 180 0", __source: {
              fileName: _jsxFileName,
              lineNumber: 51
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a-camera", { "touch-controls": true, "look-controls": "reverseMouseDrag: true; reverseTouchDrag: true", __source: {
              fileName: _jsxFileName,
              lineNumber: 52
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a-sky", { src: src, __source: {
            fileName: _jsxFileName,
            lineNumber: 54
          }
        })
      )
    );
  };

  return Image360;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Image360.displayName = "Image360";


/* harmony default export */ __webpack_exports__["a"] = (Image360);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Gallery_less__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Gallery_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Gallery_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Gallery\\Gallery.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Gallery = function (_Component) {
  _inherits(Gallery, _Component);

  function Gallery(props) {
    _classCallCheck(this, Gallery);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.activateModal = function (index) {
      _this.setState({
        modalActive: true,
        currentIndex: index
      });
    };

    _this.deactivateModal = function () {
      _this.setState({
        modalActive: false
      });
    };

    _this.state = {
      modalActive: false,
      currentIndex: 0
    };
    return _this;
  }

  Gallery.prototype.render = function render() {
    var _classnames,
        _this2 = this,
        _classnames3,
        _classnames4,
        _classnames5,
        _classnames6,
        _classnames7,
        _classnames8,
        _classnames10;

    var imagesArray = this.props.imagesArray;
    var _state = this.state,
        currentIndex = _state.currentIndex,
        modalActive = _state.modalActive;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
      { fullWidth: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.Gallery] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 36
          }
        },
        imagesArray.map(function (image, index) {
          var _classnames2;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              key: index,
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryItem] = true, _classnames2)),
              onClick: function onClick() {
                _this2.activateModal(index);
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 39
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], { src: image.src, alt: image.name, __source: {
                fileName: _jsxFileName,
                lineNumber: 47
              }
            })
          );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["z" /* H2 */],
          { withDetails: true, white: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 51
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_21" /* Visible */],
            { visible: ["screen"], __source: {
                fileName: _jsxFileName,
                lineNumber: 52
              }
            },
            imagesArray.length > 4 && "+" + (imagesArray.length - 4)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_21" /* Visible */],
            { visible: ["tablet", "mobile"], __source: {
                fileName: _jsxFileName,
                lineNumber: 53
              }
            },
            imagesArray.length > 3 && "+" + (imagesArray.length - 3)
          )
        ),
        modalActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["Z" /* Modal */],
          {
            fullWidth: true,
            width: "100%",
            handleClose: function handleClose() {
              _this2.setState({ modalActive: false });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 57
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModal] = true, _classnames3)), __source: {
                fileName: _jsxFileName,
                lineNumber: 63
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModalBody] = true, _classnames4)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 64
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["A" /* H3 */],
                { withDetails: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 65
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 65
                    }
                  },
                  currentIndex + 1
                ),
                " / ",
                imagesArray.length
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModalBodyImage] = true, _classnames5)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 66
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["G" /* Slideshow */], {
                  contain: true,
                  dotsEnabled: false,
                  activeIndex: currentIndex,
                  onClick: function onClick(activeIndex) {
                    return _this2.setState({ currentIndex: activeIndex });
                  },
                  slides: imagesArray.map(function (item, index) {
                    return {
                      name: "name-" + index,
                      imageSrc: item.src
                    };
                  }),
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 67
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModalFooter] = true, _classnames6)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 82
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModalFooterArrow] = true, _classnames7[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModalFooterArrowDisabled] = currentIndex === 0, _classnames7[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModalFooterArrowLeft] = true, _classnames7)),
                  onClick: function onClick() {
                    _this2.setState(function (prevState) {
                      return {
                        currentIndex: prevState.currentIndex === 0 ? 0 : prevState.currentIndex - 1
                      };
                    });
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 83
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["f" /* ArrowLeftThinIcon */], {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 94
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModalThumbnails] = true, _classnames8)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 96
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["I" /* Tabs */],
                  {
                    scrolling: true,
                    activeIndex: currentIndex,
                    onClick: function onClick(index) {
                      return _this2.setState({ currentIndex: index });
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 97
                    }
                  },
                  imagesArray.map(function (image, index) {
                    var _classnames9;

                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      {
                        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames9 = {}, _classnames9[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.Thumbnail] = true, _classnames9[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.ThumbnailActive] = currentIndex === index, _classnames9)),
                        key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 104
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], { src: image.src, alt: image.name, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 110
                        }
                      })
                    );
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames10 = {}, _classnames10[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModalFooterArrow] = true, _classnames10[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModalFooterArrowDisabled] = currentIndex === imagesArray.length - 1, _classnames10[__WEBPACK_IMPORTED_MODULE_2__Gallery_less___default.a.GalleryModalFooterArrowRight] = true, _classnames10)),
                  onClick: function onClick() {
                    _this2.setState(function (prevState) {
                      return {
                        currentIndex: prevState.currentIndex === imagesArray.length - 1 ? prevState.currentIndex : prevState.currentIndex + 1
                      };
                    });
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 117
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["h" /* ArrowRightThinIcon */], {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 128
                  }
                })
              )
            )
          )
        )
      )
    );
  };

  return Gallery;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Gallery.displayName = "Gallery";


/* harmony default export */ __webpack_exports__["a"] = (Gallery);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImagesRotator_less__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImagesRotator_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ImagesRotator_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\ImagesRotator\\ImagesRotator.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ImagesRotator = function (_React$Component) {
  _inherits(ImagesRotator, _React$Component);

  function ImagesRotator(props) {
    _classCallCheck(this, ImagesRotator);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleTouchStart = function (event) {
      var current = _this.state.current;

      _this.pointerPosition = _this.calculatePointerPosition(event);
      _this.startFrame = current;
      _this.setState({ started: true });
    };

    _this.handleTouchEnd = function (event) {
      event.preventDefault();
      _this.pointerPosition = null;
      _this.startFrame = null;
      _this.setState({ started: false });
    };

    _this.handleTouchMove = function (event) {
      var started = _this.state.started;

      if (!started) return;

      var _this$props = _this.props,
          vertical = _this$props.vertical,
          imagesSrc = _this$props.imagesSrc;

      if (typeof _this.pointerPosition !== "number") return;
      var _this$imagesRotator = _this.imagesRotator,
          offsetWidth = _this$imagesRotator.offsetWidth,
          offsetHeight = _this$imagesRotator.offsetHeight;

      var pointer = _this.calculatePointerPosition(event);
      var max = vertical ? offsetHeight : offsetWidth;
      var offset = pointer - _this.pointerPosition;
      var delta = Math.floor(offset / (max / 2) * imagesSrc.length);
      _this.setCurrentFrame(_this.startFrame + delta);
      _this.setState({ cursorIsPoint: false });
    };

    _this.imagesRotator = null;

    _this.state = {
      current: props.initialIndex ? props.initialIndex : 0,
      started: false
    };
    return _this;
  }

  ImagesRotator.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      if (_this2.imagesRotator) {
        _this2.imagesRotator.addEventListener("touchstart", _this2.handleTouchStart, false);
        _this2.imagesRotator.addEventListener("touchmove", _this2.handleTouchMove, false);
        _this2.imagesRotator.addEventListener("touchend", _this2.handleTouchEnd, false);
        _this2.imagesRotator.addEventListener("mousedown", _this2.handleTouchStart, false);
        _this2.imagesRotator.addEventListener("mousemove", _this2.handleTouchMove, false);
        _this2.imagesRotator.addEventListener("mouseup", _this2.handleTouchEnd, false);
        _this2.imagesRotator.addEventListener("mouseout", _this2.handleTouchEnd, false);
      }
    });
  };

  ImagesRotator.prototype.componentWillUnmount = function componentWillUnmount() {
    this.imagesRotator.removeEventListener("touchstart", this.handleTouchStart, false);
    this.imagesRotator.removeEventListener("touchmove", this.handleTouchMove, false);
    this.imagesRotator.removeEventListener("touchend", this.handleTouchEnd, false);
    this.imagesRotator.removeEventListener("mousedown", this.handleTouchStart, false);
    this.imagesRotator.removeEventListener("mousemove", this.handleTouchMove, false);
    this.imagesRotator.removeEventListener("mouseup", this.handleTouchEnd, false);
    this.imagesRotator.removeEventListener("mouseout", this.handleTouchEnd, false);
  };

  ImagesRotator.prototype.setCurrentFrame = function setCurrentFrame(frame) {
    var _props = this.props,
        _props$cycle = _props.cycle,
        cycle = _props$cycle === undefined ? true : _props$cycle,
        imagesSrc = _props.imagesSrc,
        _props$onChange = _props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;
    var current = this.state.current;

    var length = imagesSrc.length;
    var newCurrent = frame;
    if (newCurrent < 0) newCurrent = cycle ? newCurrent + length : 0;
    if (newCurrent > length - 1) newCurrent = cycle ? newCurrent - length : length - 1;
    if (newCurrent !== current) {
      this.setState({
        current: Math.abs(newCurrent % length)
      });
      onChange(current);
    }
  };

  ImagesRotator.prototype.calculatePointerPosition = function calculatePointerPosition(event) {
    var vertical = this.props.vertical;

    var touch = event.type.indexOf("touch") === 0 ? event.changedTouches[0] : event;
    var clientX = touch.clientX,
        clientY = touch.clientY;
    var _imagesRotator = this.imagesRotator,
        offsetTop = _imagesRotator.offsetTop,
        offsetLeft = _imagesRotator.offsetLeft;

    return vertical ? clientY - offsetTop : clientX - offsetLeft;
  };

  ImagesRotator.prototype.render = function render() {
    var _this3 = this,
        _classnames;

    var _props2 = this.props,
        _props2$imagesSrc = _props2.imagesSrc,
        imagesSrc = _props2$imagesSrc === undefined ? [] : _props2$imagesSrc,
        _props2$cycle = _props2.cycle,
        cycle = _props2$cycle === undefined ? true : _props2$cycle;
    var _state = this.state,
        current = _state.current,
        started = _state.started;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        ref: function ref(c) {
          return _this3.imagesRotator = c;
        },
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__ImagesRotator_less___default.a.ImagesRotator] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__ImagesRotator_less___default.a.Grabbed] = started, _classnames)),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        }
      },
      imagesSrc && imagesSrc.length > 0 && imagesSrc.map(function (image, index) {
        var _classnames2;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: "imagesRotator-image-" + index,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__ImagesRotator_less___default.a.Image] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_2__ImagesRotator_less___default.a.ImageVisible] = current === index, _classnames2)),
            __source: {
              fileName: _jsxFileName,
              lineNumber: 121
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], { src: image, height: 400, draggable: false, __source: {
              fileName: _jsxFileName,
              lineNumber: 128
            }
          })
        );
      }),
      imagesSrc && imagesSrc[0] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { opacity: 0 }, __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: imagesSrc[0] + "?blur=10&quality=0.1", draggable: "false", __source: {
            fileName: _jsxFileName,
            lineNumber: 135
          }
        })
      ),
      cycle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 140
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_21" /* Visible */],
          { visible: ["mobile", "tablet"], __source: {
              fileName: _jsxFileName,
              lineNumber: 141
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { width: "100%", textAlign: "right" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 142
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 143
                }
              },
              "360\xB0",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["H" /* Icon360Icon */], { style: {
                  width: "20px",
                  height: "17px",
                  fill: "#999999",
                  paddingLeft: "7px",
                  verticalAlign: "bottom"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 145
                }
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_21" /* Visible */],
          { visible: ["screen"], __source: {
              fileName: _jsxFileName,
              lineNumber: 155
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { width: "100%", textAlign: "center" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 156
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 157
                }
              },
              "Drag to view 360\xB0",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["H" /* Icon360Icon */], { style: {
                  width: "20px",
                  height: "17px",
                  fill: "#999999",
                  paddingLeft: "7px",
                  verticalAlign: "bottom"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 159
                }
              })
            )
          )
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
        { withoutMargin: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 171
          }
        },
        "Drag to explore",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["G" /* Icon180Icon */], { style: {
            width: '22px',
            height: '11px',
            paddingLeft: '7px',
            fill: '#999999'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 173
          }
        })
      )
    );
  };

  return ImagesRotator;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ImagesRotator.displayName = "ImagesRotator";


/* harmony default export */ __webpack_exports__["a"] = (ImagesRotator);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__ = __webpack_require__(11);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\InteriorPicker\\InteriorPicker.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var InteriorPicker = function (_React$PureComponent) {
  _inherits(InteriorPicker, _React$PureComponent);

  function InteriorPicker(props) {
    _classCallCheck(this, InteriorPicker);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._setDimension = function () {
      if (_this.interiorPicker) {
        _this.setState({
          width: null
        }, function () {
          setTimeout(function () {
            var newWidth = _this.interiorPicker.offsetWidth;
            var newHeight = newWidth > 768 ? newWidth * 0.5 : newWidth;
            _this.setState({
              width: _this.interiorPicker.offsetWidth,
              height: newHeight
            });
          }, 250);
        });
      }
    };

    _this._handleOnClick = function (activeIndex) {
      var _this$props = _this.props,
          gtm = _this$props.gtm,
          _this$props$options = _this$props.options,
          options = _this$props$options === undefined ? [] : _this$props$options;

      _this.setState({
        activeIndex: activeIndex
      }, function () {
        _this._setDimension();
        if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
          Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__["a" /* default */])({
            pageCategory: gtm.category,
            pageAction: gtm.action + " - Clicked \"" + options[_this.state.activeIndex].name + "\""
          });
        }
      });
    };

    _this.state = {
      activeIndex: 0,
      width: null,
      height: null
    };
    _this.interiorPicker = {};
    return _this;
  }

  InteriorPicker.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      _this2._setDimension();
    }, 250);
  };

  InteriorPicker.prototype.render = function render() {
    var _classnames,
        _this3 = this,
        _classnames2,
        _classnames3,
        _classnames8,
        _classnames9,
        _classnames10,
        _classnames11,
        _classnames12;

    var _props = this.props,
        heading = _props.heading,
        description = _props.description,
        _props$options = _props.options,
        options = _props$options === undefined ? [] : _props$options;
    var _state = this.state,
        activeIndex = _state.activeIndex,
        width = _state.width,
        height = _state.height;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPicker] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 80
        }
      },
      (heading || description) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["n" /* HeroContent */], {
        heading: heading,
        description: description, __source: {
          fileName: _jsxFileName,
          lineNumber: 84
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          ref: function ref(c) {
            return _this3.interiorPicker = c;
          },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerContainer] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 88
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.TabsInside] = true, _classnames3)),
            __source: {
              fileName: _jsxFileName,
              lineNumber: 93
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["I" /* Tabs */],
            {
              onClick: this._handleOnClick,
              scrolling: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 98
              }
            },
            options && options.map(function (option, index) {
              var _classnames4, _classnames5, _classnames6, _classnames7;

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  key: "InteriorPicker-" + index,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerIcon] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerIconActive] = activeIndex === index, _classnames4)),
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 104
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerIconInside] = true, _classnames5)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 111
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], {
                    type: "withoutShowing",
                    src: option.icon,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 115
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    {
                      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerIconCheckIcon] = true, _classnames6)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 119
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["o" /* CheckIcon */], { style: {
                        color: 'white',
                        width: '1em',
                        height: '1em'
                      }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 123
                      }
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerTooltip] = true, _classnames7)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 130
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["J" /* Tooltip */],
                    { size: "small", position: "bottomCenter", closeIcon: false, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 134
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
                      { withoutMargin: true, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 135
                        }
                      },
                      option.name
                    )
                  )
                )
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 145
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 146
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { "data-key": "InteriorPickerContent-" + activeIndex, __source: {
              fileName: _jsxFileName,
              lineNumber: 147
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerNameForTablet] = true, _classnames8)), __source: {
                fileName: _jsxFileName,
                lineNumber: 148
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 151
                }
              },
              options[activeIndex].name
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 155
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames9 = {}, _classnames9[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerImage] = true, _classnames9)),
              __source: {
                fileName: _jsxFileName,
                lineNumber: 156
              }
            },
            options[activeIndex].image360 && width && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 161
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["p" /* Image360 */], {
                src: options[activeIndex].image360,
                width: width,
                height: height,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 162
                }
              })
            ),
            !options[activeIndex].image360 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 170
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], {
                src: options[activeIndex].src,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 171
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames10 = {}, _classnames10[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerDisclaimer] = true, _classnames10[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerDisclaimer360] = options[activeIndex].image360, _classnames10)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 176
                }
              },
              options[activeIndex].image360 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames11 = {}, _classnames11[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerDisclaimer360Text] = true, _classnames11)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 181
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["l" /* Caption */],
                  { white: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 184
                    }
                  },
                  "Drag to view 360\xB0"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames12 = {}, _classnames12[__WEBPACK_IMPORTED_MODULE_3__InteriorPicker_less___default.a.InteriorPickerDisclaimer360TextIcon] = true, _classnames12)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 187
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["H" /* Icon360Icon */], {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 190
                    }
                  })
                )
              ),
              options[activeIndex].disclaimer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["l" /* Caption */],
                { white: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 195
                  }
                },
                options[activeIndex].disclaimer
              )
            )
          )
        )
      )
    );
  };

  return InteriorPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InteriorPicker.displayName = "InteriorPicker";


/* harmony default export */ __webpack_exports__["a"] = (InteriorPicker);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MyMazdaDashboard_less__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MyMazdaDashboard_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MyMazdaDashboard_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaDashboard\\MyMazdaDashboard.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MyMazdaDashboard = function (_React$Component) {
  _inherits(MyMazdaDashboard, _React$Component);

  function MyMazdaDashboard() {
    _classCallCheck(this, MyMazdaDashboard);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  MyMazdaDashboard.prototype.render = function render() {
    var _classnames;

    var components = this.props.components;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
      { backgroundColor: "#F5F5F5", padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__MyMazdaDashboard_less___default.a.MyMazdaDashboard] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        },
        components && Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(components)
      )
    );
  };

  return MyMazdaDashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaDashboard.displayName = "MyMazdaDashboard";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaDashboard);

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaDashboard":"MyMazdaDashboard__MyMazdaDashboard___1-88y","MyMazdaDashboardItem":"MyMazdaDashboard__MyMazdaDashboardItem___3ts0n","MyMazdaDashboardItemWide":"MyMazdaDashboard__MyMazdaDashboardItemWide___YJoJn","MyMazdaDashboardItemWideImage":"MyMazdaDashboard__MyMazdaDashboardItemWideImage___1xPti","MyMazdaDashboardItemHeading":"MyMazdaDashboard__MyMazdaDashboardItemHeading___2MuTD","MyMazdaDashboardItemImage":"MyMazdaDashboard__MyMazdaDashboardItemImage___1Oy0O","MyMazdaDashboardItemService":"MyMazdaDashboard__MyMazdaDashboardItemService___2YbuL","MyMazdaDashboardItemServiceContent":"MyMazdaDashboard__MyMazdaDashboardItemServiceContent___3a0yp","MyMazdaDashboardItemPolicy":"MyMazdaDashboard__MyMazdaDashboardItemPolicy___2Smor","MyMazdaDashboardItemPolicyItem":"MyMazdaDashboard__MyMazdaDashboardItemPolicyItem___3IaxA","MyMazdaDashboardItemPolicyProgress":"MyMazdaDashboard__MyMazdaDashboardItemPolicyProgress___3jEgx"};

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents_Button_Button_less__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents_Button_Button_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents_Button_Button_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_AtomicComponents_Typography_Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaDashboard\\MyMazdaDashboardItem.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MyMazdaDashboardItem = function (_React$Component) {
  _inherits(MyMazdaDashboardItem, _React$Component);

  function MyMazdaDashboardItem(props) {
    _classCallCheck(this, MyMazdaDashboardItem);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      mounted: false
    };
    return _this;
  }

  MyMazdaDashboardItem.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      mounted: true
    });
  };

  MyMazdaDashboardItem.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames7, _classnames8, _classnames12, _classnames13;

    var _props = this.props,
        _props$wide = _props.wide,
        wide = _props$wide === undefined ? false : _props$wide,
        heading = _props.heading,
        description = _props.description,
        progress = _props.progress,
        imageSrc = _props.imageSrc,
        scheduledServiceImage = _props.scheduledServiceImage,
        nextServiceDate = _props.nextServiceDate,
        policyItems = _props.policyItems,
        _props$isExternal = _props.isExternal,
        isExternal = _props$isExternal === undefined ? false : _props$isExternal,
        buttonUrl = _props.buttonUrl,
        buttonLinkText = _props.buttonLinkText;
    var mounted = this.state.mounted;

    var progressValue = progress / 100 >= 1 ? 0 : 691.15 * (1 - progress / 100);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItem] = true, _classnames[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItemWide] = wide, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 31
        }
      },
      wide && imageSrc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItemWideImage] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 37
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: imageSrc, __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItemHeading] = true, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 43
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["C" /* H5 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 46
            }
          },
          heading
        ),
        wide ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 49
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItemImage] = true, _classnames4)), __source: {
                fileName: _jsxFileName,
                lineNumber: 50
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: imageSrc + "?width=104", __source: {
                fileName: _jsxFileName,
                lineNumber: 53
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
            { withoutMargin: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 55
              }
            },
            description
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 57
            }
          },
          description
        ),
        progress > 100 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
          { withoutMargin: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_16" /* Tag */],
            { color: "red", __source: {
                fileName: _jsxFileName,
                lineNumber: 59
              }
            },
            "OVERDUE"
          )
        ) : !wide && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 59
          }
        }),
        !wide && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 60
          }
        })
      ),
      !wide && imageSrc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItemImage] = true, _classnames5)), __source: {
            fileName: _jsxFileName,
            lineNumber: 64
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: imageSrc + "?width=626", __source: {
            fileName: _jsxFileName,
            lineNumber: 67
          }
        })
      ),
      nextServiceDate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItemService] = true, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 72
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "svg",
          { viewBox: "0 0 224 224", __source: {
              fileName: _jsxFileName,
              lineNumber: 75
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
            cx: "112",
            cy: "112",
            r: "110",
            fill: "none",
            stroke: "#E7E7E7",
            strokeWidth: "4", __source: {
              fileName: _jsxFileName,
              lineNumber: 76
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
            cx: "112",
            cy: "112",
            r: "110",
            fill: "none",
            stroke: "#910A2D",
            strokeWidth: "4",
            strokeDasharray: "691.15",
            strokeDashoffset: mounted ? progressValue : "691.15",
            style: {
              transitionDuration: ".8s",
              transitionDelay: "1s",
              transitionTimingFunction: "cubic-bezier(0, 0.6, 1, 1)",
              willChange: "stroke-dashoffset"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 83
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItemServiceContent] = true, _classnames7)), __source: {
              fileName: _jsxFileName,
              lineNumber: 99
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: scheduledServiceImage, alt: "Next service", __source: {
              fileName: _jsxFileName,
              lineNumber: 102
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 103
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 104
              }
            },
            "Due before"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
            { withoutMargin: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 105
              }
            },
            nextServiceDate
          )
        )
      ),
      policyItems && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItemPolicy] = true, _classnames8)), __source: {
            fileName: _jsxFileName,
            lineNumber: 111
          }
        },
        policyItems.map(function (policy, index) {
          var _classnames9, _classnames10, _classnames11;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              key: index,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 116
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 119
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames9 = {}, _classnames9[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItemPolicyItem] = true, _classnames9)),
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 120
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["l" /* Caption */],
                { grey: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 125
                  }
                },
                policy.heading.toUpperCase()
              ),
              policy.buttonType === "external" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
                { external: true, withoutStyle: true, href: policy.buttonUrl, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 127
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["l" /* Caption */],
                  { grey: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 128
                    }
                  },
                  policy.buttonLinkText
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
                {
                  to: policy.buttonUrl,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames10 = {}, _classnames10[__WEBPACK_IMPORTED_MODULE_7_AtomicComponents_Typography_Typography_less___default.a.withoutStyle] = !policy.isExpired || policy.policyType === "Warranty", _classnames10)),
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 131
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["l" /* Caption */],
                  {
                    grey: !policy.isExpired || policy.policyType === "Warranty",
                    black: policy.buttonType === "date",
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 137
                    }
                  },
                  policy.buttonLinkText
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames11 = {}, _classnames11[__WEBPACK_IMPORTED_MODULE_5__MyMazdaDashboard_less___default.a.MyMazdaDashboardItemPolicyProgress] = true, _classnames11)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 146
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { width: policy.policyType !== "Warranty" ? policy.progress + "%" : "0%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 149
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 151
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 152
              }
            })
          );
        })
      ),
      !wide && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158
        }
      }),
      isExternal ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */], {
        styleName: "blackOutlined",
        href: buttonUrl,
        label: buttonLinkText,
        gtm: {
          category: "MyMazda - Dashboard",
          action: heading.toUpperCase() + " - clicked \"" + buttonLinkText.toUpperCase() + "\""
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161
        }
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
        {
          to: buttonUrl,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames12 = {}, _classnames12[__WEBPACK_IMPORTED_MODULE_7_AtomicComponents_Typography_Typography_less___default.a.withoutStyle] = true, _classnames12)), __source: {
            fileName: _jsxFileName,
            lineNumber: 171
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            className: "Button " + __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames13 = {}, _classnames13[__WEBPACK_IMPORTED_MODULE_6_AtomicComponents_Button_Button_less___default.a.Button] = true, _classnames13[__WEBPACK_IMPORTED_MODULE_6_AtomicComponents_Button_Button_less___default.a.ButtonFullWidth] = true, _classnames13[__WEBPACK_IMPORTED_MODULE_6_AtomicComponents_Button_Button_less___default.a.ButtonBlackOutlined] = true, _classnames13)),
            onClick: function onClick() {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "MyMazda - Dashboard",
                pageAction: heading.toUpperCase() + " - clicked \"" + buttonLinkText.toUpperCase() + "\""
              });
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 176
            }
          },
          buttonLinkText
        )
      )
    );
  };

  return MyMazdaDashboardItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaDashboardItem.displayName = "MyMazdaDashboardItem";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaDashboardItem);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaLogin_less__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaLogin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MyMazdaLogin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_urlHandler__ = __webpack_require__(33);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaLogin\\MyMazdaLogin.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var MyMazdaLogin = function (_React$Component) {
  _inherits(MyMazdaLogin, _React$Component);

  function MyMazdaLogin(props) {
    var _this2 = this;

    _classCallCheck(this, MyMazdaLogin);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda Login Form",
                  pageAction: "MyMazda Login Form - Login"
                });
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _this$props, loginApiEndpoint, successfulLoginPageUrl, form;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this$props = _this.props, loginApiEndpoint = _this$props.loginApiEndpoint, successfulLoginPageUrl = _this$props.successfulLoginPageUrl;
                          form = _this.state.form;
                          _context2.next = 4;
                          return Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: loginApiEndpoint,
                            body: {
                              username: form.email.value,
                              password: form.password.value,
                              rememberMe: form.rememberMe.value
                            }
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        new __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_urlHandler__["a" /* default */](successfulLoginPageUrl).redirect();
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      form: {
        password: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PASSWORD_REQUIRED
          }
        },
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        rememberMe: {
          validations: {}
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  MyMazdaLogin.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "LOG IN" : _props$buttonText,
        resetPasswordPageUrl = _props.resetPasswordPageUrl;
    var _state = this.state,
        loading = _state.loading,
        errorMessage = _state.errorMessage;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__MyMazdaLogin_less___default.a.MyMazdaLogin] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__MyMazdaLogin_less___default.a.MyMazdaLoginForm] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 95
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { method: "POST", onSubmit: this._handleSubmit, __source: {
              fileName: _jsxFileName,
              lineNumber: 98
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 99
              }
            },
            buttonText
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 102
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["N" /* InputEmail */], _extends({
              name: "email",
              label: "Email"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda Login Form",
                  pageAction: "MyMazda Login Form - Entered \"EMAIL\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 103
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 115
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["O" /* InputPassword */], _extends({
              name: "password",
              label: "Password"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "password"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda Login Form",
                  pageAction: "MyMazda Login Form - Entered \"PASSWORD\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 116
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { show: true, checkbox: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 128
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
              name: "rememberMe",
              label: "Remember me"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "rememberMe", function () {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "MyMazda Login Form",
                pageAction: "MyMazda Login Form - checked \"Keep me logged in\""
              });
            }), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 129
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 141
              }
            },
            errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 143
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              _extends({
                styleName: "black",
                loading: loading,
                fullWidth: true
              }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 145
                }
              }),
              buttonText
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 153
              }
            }),
            resetPasswordPageUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
              {
                href: resetPasswordPageUrl,
                onClick: function onClick() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "MyMazda Login Form",
                    pageAction: "MyMazda Forgot password Form - Reset\""
                  });
                },
                styleName: "black",
                external: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 155
                }
              },
              "Forgot my password >"
            )
          )
        )
      )
    );
  };

  return MyMazdaLogin;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaLogin.displayName = "MyMazdaLogin";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaLogin);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaLoginContainer\\MyMazdaLoginContainer.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var MyMazdaLoginContainer = function (_React$Component) {
  _inherits(MyMazdaLoginContainer, _React$Component);

  function MyMazdaLoginContainer() {
    var _temp, _this, _ret;

    _classCallCheck(this, MyMazdaLoginContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._handleClickOnRegister = function () {
      var _this$props$createAcc = _this.props.createAccountButtonText,
          createAccountButtonText = _this$props$createAcc === undefined ? "Create my account" : _this$props$createAcc;

      Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__["a" /* default */])({
        pageCategory: "MyMazda - Home",
        pageAction: "CREATE AN ACCOUNT BLOCK - Clicked \"" + createAccountButtonText.toUpperCase() + "\""
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MyMazdaLoginContainer.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames7;

    var _props = this.props,
        img = _props.img,
        registerPageUrl = _props.registerPageUrl,
        _props$createAccountB = _props.createAccountButtonText,
        createAccountButtonText = _props$createAccountB === undefined ? "Create my account" : _props$createAccountB,
        rest = _objectWithoutProperties(_props, ["img", "registerPageUrl", "createAccountButtonText"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less___default.a.ParentMyMazdaLoginContainer] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["s" /* Container */],
        { styleName: "screen", __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
          { backgroundColor: "#ffffff", sizeName: "screen", __source: {
              fileName: _jsxFileName,
              lineNumber: 25
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less___default.a.MyMazdaLoginContainer] = true, _classnames2)), __source: {
                fileName: _jsxFileName,
                lineNumber: 26
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less___default.a.MyMazdaLoginContainerBox] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less___default.a.MyMazdaLoginContainerBoxRegister] = true, _classnames3)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 29
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less___default.a.Box1] = true, _classnames4)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 33
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_21" /* Visible */],
                  { visible: ["screen"], __source: {
                      fileName: _jsxFileName,
                      lineNumber: 36
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["A" /* H3 */],
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 37
                      }
                    },
                    "Create an account"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 41
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_21" /* Visible */],
                    { visible: ["screen"], __source: {
                        fileName: _jsxFileName,
                        lineNumber: 42
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less___default.a.BoxImage] = true, _classnames5)), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 43
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["o" /* Image */], {
                        src: img || "/globalassets/mymazda/mazda-ownership2x.png", __source: {
                          fileName: _jsxFileName,
                          lineNumber: 46
                        }
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less___default.a.BoxPadding] = true, _classnames6)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 50
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 53
                        }
                      },
                      " Own a Mazda? Create your account now. "
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["j" /* Button */],
                      {
                        fullWidth: true,
                        onClick: this._handleClickOnRegister,
                        styleName: "blackOutlined",
                        href: registerPageUrl,
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 54
                        }
                      },
                      createAccountButtonText
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_4__MyMazdaLoginContainer_less___default.a.MyMazdaLoginContainerBox] = true, _classnames7)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 66
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["v" /* MyMazdaLogin */], _extends({}, rest, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 69
                }
              }))
            )
          )
        )
      )
    );
  };

  return MyMazdaLoginContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaLoginContainer.displayName = "MyMazdaLoginContainer";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaLoginContainer);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceHistory_less__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceHistory_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceHistory_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaServiceHistory\\MyMazdaServiceHistory.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MyMazdaServiceHistory = function (_React$Component) {
  _inherits(MyMazdaServiceHistory, _React$Component);

  function MyMazdaServiceHistory() {
    _classCallCheck(this, MyMazdaServiceHistory);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  MyMazdaServiceHistory.prototype.columns = function columns(date, distance, price, dealer, slug) {
    var _classnames;

    var printAllLink = this.props.printAllLink;

    var viewButtonText = "View";
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceHistory_less___default.a.MyMazdaServiceHistoryColumns] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 15
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "b",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 15
            }
          },
          date
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 16
          }
        },
        distance
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 17
          }
        },
        price
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 18
          }
        },
        dealer
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 19
          }
        },
        slug ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
          {
            withoutStyle: true,
            styleName: "black",
            external: true,
            href: printAllLink + "&slug=" + slug,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 22
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["v" /* ExternalLinkIcon */], {
            style: {
              height: "11px",
              width: "14px",
              marginRight: "0.5em"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 28
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["l" /* Caption */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 34
              }
            },
            viewButtonText
          )
        ) : "Print"
      )
    );
  };

  MyMazdaServiceHistory.prototype.accordionTitle = function accordionTitle(service) {
    var _classnames2;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["I" /* IdWrapper */],
      { key: service.slug, slug: service.slug, __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceHistory_less___default.a.MyMazdaServiceHistoryTitle] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 50
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 51
              }
            },
            this.columns(service.serviceDates, service.distance, service.formattedPrice, service.dealerName, service.slug)
          )
        )
      )
    );
  };

  MyMazdaServiceHistory.prototype.render = function render() {
    var _classnames3,
        _classnames4,
        _this2 = this,
        _classnames6,
        _classnames7;

    var _props = this.props,
        heading = _props.heading,
        blurb = _props.blurb,
        emptyHistoryText = _props.emptyHistoryText,
        serviceHistoryData = _props.serviceHistoryData,
        printAllLink = _props.printAllLink,
        _props$printButtonTex = _props.printButtonText,
        printButtonText = _props$printButtonTex === undefined ? "Print view" : _props$printButtonTex;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
      { backgroundColor: "#FFFFFF", padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["B" /* H4 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 71
          }
        },
        heading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], { xmlString: blurb, textAlign: "center", __source: {
          fileName: _jsxFileName,
          lineNumber: 73
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceHistory_less___default.a.MyMazdaServiceHistory] = true, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 74
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceHistory_less___default.a.MyMazdaServiceHistoryHeader] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 80
              }
            },
            this.columns("DATE", "ODOMETER (KM)", "PRICE", "SERVICE LOCATION", null)
          )
        ),
        serviceHistoryData ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["c" /* AccordionTextList */], {
          data: serviceHistoryData.map(function (service, index) {
            var _classnames5;

            return {
              title: _this2.accordionTitle(service),
              description: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 91
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceHistory_less___default.a.MyMazdaServiceHistoryDetails] = true, _classnames5)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 92
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 95
                      }
                    },
                    "ODOMETER (KM)"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
                    { withoutMargin: true, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 96
                      }
                    },
                    service.distance
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 97
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 98
                      }
                    },
                    "PRICE"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
                    { withoutMargin: true, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 99
                      }
                    },
                    service.formattedPrice
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 100
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 101
                      }
                    },
                    "SERVICE LOCATION"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
                    { withoutMargin: true, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 102
                      }
                    },
                    service.dealerName
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 103
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 105
                    }
                  },
                  "SERVICE DESCRIPTION"
                ),
                service.completedServiceItems.map(function (item, i) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
                    { key: i, withoutMargin: true, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 108
                      }
                    },
                    item.serviceDescription
                  );
                })
              )
            };
          }),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 86
          }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceHistory_less___default.a.MyMazdaServiceHistoryEmpty] = true, _classnames6)), __source: {
              fileName: _jsxFileName,
              lineNumber: 119
            }
          },
          emptyHistoryText || "We'll automatically keep your service records here when you complete a Mazda Genuine Service."
        ),
        serviceHistoryData && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceHistory_less___default.a.MyMazdaServiceHistoryFooter] = true, _classnames7)), __source: {
              fileName: _jsxFileName,
              lineNumber: 127
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
            {
              styleName: "blackOutlined",
              href: printAllLink,
              gtm: {
                category: "MyMazda - Servicing",
                action: "History - Clicked \"" + printButtonText.toUpperCase() + "\""
              },
              external: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 130
              }
            },
            printButtonText
          )
        )
      )
    );
  };

  return MyMazdaServiceHistory;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaServiceHistory.displayName = "MyMazdaServiceHistory";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaServiceHistory);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MyMazdaVehicleSummary_less__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MyMazdaVehicleSummary_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MyMazdaVehicleSummary_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaVehicleSummary\\MyMazdaVehicleSummary.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MyMazdaVehicleSummary = function (_React$Component) {
  _inherits(MyMazdaVehicleSummary, _React$Component);

  function MyMazdaVehicleSummary() {
    _classCallCheck(this, MyMazdaVehicleSummary);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  MyMazdaVehicleSummary.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        header = _props.header,
        description = _props.description,
        bodyStyle = _props.bodyStyle,
        grade = _props.grade,
        imageUrl = _props.imageUrl,
        nameplate = _props.nameplate,
        rego = _props.rego,
        vin = _props.vin;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
      { backgroundColor: "#F5F5F5", padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["z" /* H2 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        },
        header
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], { xmlString: description, textAlign: "center", __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["j" /* FiftyFiftyBlock */],
        { backgroundColor: "#F5F5F5", ratio: 60, size: "small", imageUrl: imageUrl, imagePosition: "right", textAlign: "left", textAlignMobile: "left", imagePositionMobile: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 15
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_4__MyMazdaVehicleSummary_less___default.a.MyMazdaVehicleSummary] = true, _classnames)), __source: {
              fileName: _jsxFileName,
              lineNumber: 16
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 19
              }
            },
            "Model"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
            { withoutMargin: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 20
              }
            },
            nameplate,
            " ",
            grade || "",
            " ",
            bodyStyle || ""
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 21
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 22
              }
            },
            "Registration"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
            { withoutMargin: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 23
              }
            },
            rego || "Contact dealer"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 24
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 25
              }
            },
            "VIN"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
            { withoutMargin: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 26
              }
            },
            vin
          )
        )
      )
    );
  };

  return MyMazdaVehicleSummary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaVehicleSummary.displayName = "MyMazdaVehicleSummary";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaVehicleSummary);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MyNewMazda_less__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MyNewMazda_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MyNewMazda_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_fetchAPI__ = __webpack_require__(21);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyNewMazda\\MyNewMazda.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MyNewMazda = function (_React$Component) {
  _inherits(MyNewMazda, _React$Component);

  function MyNewMazda(props) {
    var _this2 = this;

    _classCallCheck(this, MyNewMazda);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var endpoint, form, url;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          endpoint = _this.props.endpoint;
                          form = _this.state.form;
                          url = endpoint + "?vinrego=" + encodeURIComponent(form.vinOrRego.value);
                          _context2.next = 5;
                          return Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: url,
                            body: {}
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, errorMessage, errorCode;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      errorMessage = json.errorMessage, errorCode = json.errorCode;


                                      if (response.status !== 200) {
                                        _this.setState({
                                          errorMessage: errorMessage || __WEBPACK_IMPORTED_MODULE_4_AtomicConstants_MESSAGES__["a" /* default */][errorCode],
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_gtmHandler__["a" /* default */])({
                                          pageCategory: "MyMazda",
                                          pageAction: "MyMazda Login - Enter VIN/Rego - Submitted \"" + (form.vinOrRego.value.length > 6 ? "VIN" : "REGO") + "\""
                                        });
                                        _this.setState({
                                          success: true
                                        }, function () {
                                          var redirectUrl = _this.props.redirectUrl;

                                          var url = new __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_urlHandler__["a" /* default */](redirectUrl).buildNewUrl(json);
                                          new __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_urlHandler__["a" /* default */](url).redirect();
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      form: {
        vinOrRego: {
          value: props.vinRego || "",
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_4_AtomicConstants_MESSAGES__["a" /* default */].REGO_OR_VIN_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      loading: false
    };
    return _this;
  }

  MyNewMazda.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6;

    var _props = this.props,
        heading = _props.heading,
        description = _props.description,
        components = _props.components;
    var _state = this.state,
        loading = _state.loading,
        errorMessage = _state.errorMessage;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])(components, {}, "", false),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
        { padding: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 87
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["s" /* Container */],
          { styleName: "screen", __source: {
              fileName: _jsxFileName,
              lineNumber: 88
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_7__MyNewMazda_less___default.a.MyNewMazda] = true, _classnames)), __source: {
                fileName: _jsxFileName,
                lineNumber: 89
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["A" /* H3 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 92
                }
              },
              heading
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], { xmlString: description, __source: {
                fileName: _jsxFileName,
                lineNumber: 93
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_7__MyNewMazda_less___default.a.MyNewMazdaForm] = true, _classnames2)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 94
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "form",
                { method: "POST", onSubmit: this._handleSubmit, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 97
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 98
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_7__MyNewMazda_less___default.a.MyNewMazdaFormWrapper] = true, _classnames3)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 99
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_7__MyNewMazda_less___default.a.MyNewMazdaFormInput] = true, _classnames4)), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 102
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["S" /* InputText */], _extends({
                        name: "vinOrRego",
                        label: "ENTER VIN OR REGO"
                      }, Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "vinOrRego"), {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 105
                        }
                      }))
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_7__MyNewMazda_less___default.a.MyNewMazdaFormButton] = true, _classnames5)), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 111
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
                        _extends({ styleName: "black", loading: loading }, Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 114
                          }
                        }),
                        "View details"
                      )
                    )
                  )
                ),
                loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_7__MyNewMazda_less___default.a.MyNewMazdaLoadingSection] = true, _classnames6)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 122
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["W" /* LoadingSection */], { visible: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 125
                    }
                  })
                ),
                errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 130
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 131
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 132
                    }
                  })
                )
              )
            )
          )
        )
      )
    );
  };

  return MyNewMazda;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyNewMazda.displayName = "MyNewMazda";


/* harmony default export */ __webpack_exports__["a"] = (MyNewMazda);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Offers_less__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Offers_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Offers_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_scroll__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicContainers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Offers\\Offers.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Offers = function (_React$Component) {
  _inherits(Offers, _React$Component);

  function Offers(props) {
    _classCallCheck(this, Offers);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleChange = function (filters) {
      if (filters.nameplate && filters.nameplate.length !== _this.state.filters.nameplate.length || filters.price && filters.price.min && (filters.price.min !== _this.state.filters.price.min || filters.price.max !== _this.state.filters.price.max) || filters.transmission && filters.transmission.length !== _this.state.filters.transmission.length || filters.drivetrain && filters.drivetrain.length !== _this.state.filters.drivetrain.length) {
        _this.setState({
          filters: filters
        }, function () {
          var gtmAction = "";
          if (filters.nameplate.length) {
            filters.nameplate.map(function (nameplate, i) {
              i === 0 ? gtmAction += nameplate : gtmAction += " and " + nameplate;
            });
            gtmAction += " / ";
          }
          gtmAction += filters.price.min + " to " + filters.price.max;
          if (filters.transmission.length) {
            gtmAction += " / ";
            filters.transmission.map(function (transmission, i) {
              i === 0 ? gtmAction += transmission : gtmAction += " and " + transmission;
            });
          }
          if (filters.drivetrain.length) {
            gtmAction += " / ";
            filters.drivetrain.map(function (drivetrain, i) {
              i === 0 ? gtmAction += drivetrain : gtmAction += " and " + drivetrain;
            });
          }

          Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_gtmHandler__["a" /* default */])({
            pageCategory: "Offers",
            pageAction: "Filtering - \"" + gtmAction + "\""
          });
        });
      }
    };

    _this.handleSortChange = function (value) {
      _this.setState({
        sort: value
      });
    };

    _this.handleOnClose = function () {
      _this.setState({
        mobileFiltersOpen: false
      });
    };

    _this.handleOnShow = function () {
      _this.setState({
        mobileFiltersOpen: true
      });
    };

    _this.state = {
      filters: {
        nameplate: [],
        price: {},
        transmission: [],
        drivetrain: []
      },
      sort: props.sortOptions && props.sortOptions.options && props.sortOptions.options[0].value,
      mobileFiltersOpen: false
    };
    return _this;
  }

  Offers.prototype.componentDidMount = function componentDidMount() {
    var hash = new __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["i" /* WINDOW */].location.href).getHash();

    if (hash) {
      setTimeout(function () {
        Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_scroll__["a" /* scrollToElementId */])(hash);
      }, 1000);
    }
  };

  Offers.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames7;

    var _props = this.props,
        offers = _props.offers,
        imageSrc = _props.imageSrc,
        description = _props.description,
        sortOptions = _props.sortOptions,
        termsAndConditions = _props.termsAndConditions,
        promoComponent = _props.promoComponent;
    var _state = this.state,
        filters = _state.filters,
        mobileFiltersOpen = _state.mobileFiltersOpen,
        sort = _state.sort;

    var noOfOffers = filters.nameplate.length + filters.transmission.length + filters.drivetrain.length;
    var SORT = sortOptions && sortOptions.options && sortOptions.options.map(function (_ref) {
      var name = _ref.name,
          value = _ref.value;
      return {
        label: name,
        value: value
      };
    });

    var filteredOffers = offers.filter(function (c) {
      return (filters.nameplate.indexOf(c.props.nameplateFilter) !== -1 || filters.nameplate.length === 0) && c.props.priceFilter >= filters.price.min && c.props.priceFilter <= filters.price.max && (filters.transmission.indexOf(c.props.transmissionFilter) !== -1 || c.props.transmissionFilter === "all" || filters.transmission.length === 0) && (filters.drivetrain.length === 0 || c.props.drivetrainFilter.some(function (r) {
        return filters.drivetrain.indexOf(r) !== -1;
      }));
    }).sort(function (a, b) {
      return sort === "price--low-to-high-" ? a.props.priceFilter - b.props.priceFilter : sort === "price--high-to-low-" ? b.props.priceFilter - a.props.priceFilter : 0;
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Offers_less___default.a.Offers] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 119
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_AtomicContainers__["B" /* OffersFilters */], _extends({}, this.props, { onChange: this.handleChange, open: mobileFiltersOpen, onClose: this.handleOnClose, __source: {
          fileName: _jsxFileName,
          lineNumber: 123
        }
      })),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Offers_less___default.a.OffersContent] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 124
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__Offers_less___default.a.OffersFiltersTrigger] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 128
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["j" /* Button */],
            {
              styleName: "black",
              fullWidth: true,
              onClick: this.handleOnShow,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 132
              }
            },
            "Refine Search"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__Offers_less___default.a.OffersListInfo] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 140
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["l" /* Caption */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 144
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 145
                }
              },
              "Filters applied (",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "b",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 145
                  }
                },
                noOfOffers
              ),
              ")"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__Offers_less___default.a.OffersListInfoHideMobile] = true, _classnames5)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 146
                }
              },
              "Vehicles available (",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "b",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 149
                  }
                },
                filteredOffers.length
              ),
              ")"
            )
          ),
          sortOptions && sortOptions.options && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 153
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["R" /* InputSelect */], {
              name: "sort",
              label: "Sort by",
              formType: "compact",
              options: SORT,
              onChange: this.handleSortChange,
              required: true,
              withoutStar: true,
              defaultValue: SORT[0],
              __source: {
                fileName: _jsxFileName,
                lineNumber: 154
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 167
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__Offers_less___default.a.OffersList] = true, _classnames6)), __source: {
              fileName: _jsxFileName,
              lineNumber: 181
            }
          },
          filteredOffers.length ? filteredOffers.map(function (offer, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["I" /* IdWrapper */],
              { key: index, slug: offer.props.slug, standalone: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 186
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])([offer]),
              (index === 0 && filteredOffers.length === 1 || index === 1) && promoComponent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: {
                    borderTop: "1px solid #D5D5D5",
                    borderBottom: filteredOffers.length === 1 || filteredOffers.length === 2 ? "1px solid #D5D5D5" : 0 }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 191
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])([promoComponent])
              )
            );
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_2__Offers_less___default.a.OffersListZero] = true, _classnames7)), __source: {
                fileName: _jsxFileName,
                lineNumber: 199
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_1" /* P */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 203
                }
              },
              "Your search returned no results. Search again."
            )
          )
        )
      )
    );
  };

  return Offers;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Offers.displayName = "Offers";


/* harmony default export */ __webpack_exports__["a"] = (Offers);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OfferTile_less__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OfferTile_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OfferTile_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\OfferTile\\OfferTile.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OfferTile = function (_React$Component) {
  _inherits(OfferTile, _React$Component);

  function OfferTile(props) {
    _classCallCheck(this, OfferTile);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      open: 0
    };
    return _this;
  }

  OfferTile.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5;

    var _props = this.props,
        imageSrc = _props.imageSrc,
        nameplate = _props.nameplate,
        bodyGrade = _props.bodyGrade,
        heading = _props.heading,
        subHeading = _props.subHeading,
        offerPoints = _props.offerPoints,
        components = _props.components,
        disclaimer = _props.disclaimer,
        _props$isFeatured = _props.isFeatured,
        isFeatured = _props$isFeatured === undefined ? false : _props$isFeatured;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__OfferTile_less___default.a.OfferTile] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__OfferTile_less___default.a.OfferTileFeatured] = isFeatured, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__OfferTile_less___default.a.OfferTileVehicle] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["D" /* H6 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 30
            }
          },
          nameplate
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 31
            }
          },
          bodyGrade
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__OfferTile_less___default.a.OfferTileImage] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 33
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["o" /* Image */], { src: imageSrc, height: 200, type: "spinner", __source: {
              fileName: _jsxFileName,
              lineNumber: 37
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__OfferTile_less___default.a.OfferTileContent] = true, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 44
            }
          },
          heading
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 45
            }
          },
          subHeading
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          }
        }),
        offerPoints && offerPoints.map(function (point, index) {
          return index <= 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_1" /* P */],
            { key: index, withoutMargin: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 49
              }
            },
            point
          );
        }),
        offerPoints && offerPoints.length > 2 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["b" /* AccordionText */],
          {
            styleName: "info",
            onClick: function onClick() {
              Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "Offers",
                pageAction: "More Info - \"" + nameplate + " / " + bodyGrade + " / " + heading + "\" - \"MORE INFO\""
              });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 54
            }
          },
          offerPoints.map(function (point, index) {
            return index > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_1" /* P */],
              { key: index, withoutMargin: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 63
                }
              },
              point
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 67
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__OfferTile_less___default.a.OfferTileButtons] = true, _classnames5)), __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__["a" /* default */])(components)
        ),
        disclaimer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["b" /* AccordionText */],
          {
            title: "Disclaimer",
            styleName: "disclaimer",
            onClick: function onClick() {
              Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "Offers",
                pageAction: "Disclaimers - \"" + nameplate + " / " + bodyGrade + " / " + heading + "\" - \"DISCLAIMERS\""
              });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 86
              }
            },
            disclaimer
          )
        )
      )
    );
  };

  return OfferTile;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

OfferTile.displayName = "OfferTile";


/* harmony default export */ __webpack_exports__["a"] = (OfferTile);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OutletStoreEnquiryForm_less__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OutletStoreEnquiryForm_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OutletStoreEnquiryForm_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TITLES__ = __webpack_require__(1196);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\OutletStoreEnquiryForm\\OutletStoreEnquiryForm.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var OutletStoreEnquiryForm = function (_React$Component) {
  _inherits(OutletStoreEnquiryForm, _React$Component);

  function OutletStoreEnquiryForm(props) {
    var _this2 = this;

    _classCallCheck(this, OutletStoreEnquiryForm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$props, financeOptionText, _this$props$buttonTex, buttonText, _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = _this.props, financeOptionText = _this$props.financeOptionText, _this$props$buttonTex = _this$props.buttonText, buttonText = _this$props$buttonTex === undefined ? "Submit" : _this$props$buttonTex;

                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _this$props2, stockData, dealer, _this$props2$prospect, prospectApiSource, _this$props2$prospect2, prospectApiProperty, _this$props2$prospect3, prospectApiPropertyValue, submitFormEndPoint, form, body;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this$props2 = _this.props, stockData = _this$props2.stockData, dealer = _this$props2.dealer, _this$props2$prospect = _this$props2.prospectApiSource, prospectApiSource = _this$props2$prospect === undefined ? "Web_OutletStore" : _this$props2$prospect, _this$props2$prospect2 = _this$props2.prospectApiProperty, prospectApiProperty = _this$props2$prospect2 === undefined ? "communicationPermissions" : _this$props2$prospect2, _this$props2$prospect3 = _this$props2.prospectApiPropertyValue, prospectApiPropertyValue = _this$props2$prospect3 === undefined ? "Mazda_Dealer_Opt_In" : _this$props2$prospect3, submitFormEndPoint = _this$props2.submitFormEndPoint;
                          form = _this.state.form;
                          body = {
                            email: form.email.value,
                            comments: form.comments.value || null,
                            firstName: form.firstName.value,
                            lastName: form.lastName.value,
                            phone: form.phone.value,
                            title: form.title.value,
                            financeInterest: financeOptionText ? form.finance.value === true ? 'Yes' : null : undefined,
                            nameplate: stockData.nameplate,
                            stockNumber: stockData.stockNumber,
                            dealerLocation: dealer.id,
                            dealerCode: dealer.dealerCode,
                            prospectApiSource: prospectApiSource,
                            prospectApiProperty: prospectApiProperty,
                            prospectApiPropertyValue: prospectApiPropertyValue
                          };
                          _context2.next = 5;
                          return Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: submitFormEndPoint,
                            body: body
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "Outlet Store",
                                            pageAction: "Outlet Store Form - Clicked \"" + buttonText.toUpperCase() + "\""
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this._handleOnBlurSearchableRegion = function () {
      var form = _this.state.form;

      if (form && form.region && form.region.value && form.region.value.description) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Outlet Store",
          pageAction: "Outlet Store Form - Selected \"POSTCODE/SUBURB\" - \"" + form.region.value.description.toUpperCase() + "\""
        });
      }
    };

    _this.state = {
      form: {
        title: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_REQUIRED,
            phone: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        comments: {
          validations: {}
        },
        finance: {
          validations: {}
        },
        optedInDealer: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].OPTIN_REQUIRED
          }
        },
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        privacy: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_10_AtomicConstants_MESSAGES__["a" /* default */].PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  OutletStoreEnquiryForm.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames7;

    var _props = this.props,
        title = _props.title,
        description = _props.description,
        optInMessage = _props.optInMessage,
        privacyPolicy = _props.privacyPolicy,
        privacyPolicyLink = _props.privacyPolicyLink,
        financeOptionText = _props.financeOptionText,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Submit" : _props$buttonText,
        dealer = _props.dealer,
        stockData = _props.stockData,
        thankYouComponents = _props.thankYouComponents;
    var _state = this.state,
        loading = _state.loading,
        form = _state.form,
        success = _state.success,
        errorMessage = _state.errorMessage;

    if (success) {
      return Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_componentParser__["a" /* default */])(thankYouComponents);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 182
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
        { padding: true, backgroundColor: "#f5f5f5", __source: {
            fileName: _jsxFileName,
            lineNumber: 183
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__OutletStoreEnquiryForm_less___default.a.OutletStoreEnquiryForm] = true, _classnames)), __source: {
              fileName: _jsxFileName,
              lineNumber: 184
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__OutletStoreEnquiryForm_less___default.a.OutletStoreEnquiryFormForm] = true, _classnames2)), __source: {
                fileName: _jsxFileName,
                lineNumber: 187
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["D" /* H6 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 190
                }
              },
              title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 191
                }
              },
              "CONTACT " + dealer.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 192
                }
              },
              description
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
        { horizontalPadding: true, backgroundColor: "#FFFFFF", __source: {
            fileName: _jsxFileName,
            lineNumber: 196
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__OutletStoreEnquiryForm_less___default.a.OutletStoreEnquiryFormDealer] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 197
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 200
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 201
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 202
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 203
                }
              },
              "Dealer"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
              { withoutMargin: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 204
                }
              },
              dealer.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 205
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 206
                }
              },
              "Model"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
              { withoutMargin: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 207
                }
              },
              stockData.nameplate + " " + stockData.bodyStyle + " " + stockData.grade
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 208
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__OutletStoreEnquiryForm_less___default.a.OutletStoreEnquiryFormDealerPrice] = true, _classnames4)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 209
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["D" /* H6 */],
                { withDetails: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 212
                  }
                },
                "Delivered price in ",
                dealer.state
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
                {
                  withoutStyle: true,
                  onClick: function onClick(event) {
                    if (event && event.target && event.target.querySelector('button')) {
                      event.target.querySelector('button').click();
                    }
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 213
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
                  { withDetails: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 221
                    }
                  },
                  "$",
                  stockData.price.toLocaleString(),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["i" /* Disclaimer */],
                    { Icon: __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_14" /* StarIcon */], __source: {
                        fileName: _jsxFileName,
                        lineNumber: 223
                      }
                    },
                    stockData.disclaimer
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_environment__["g" /* IS_MOBILE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__OutletStoreEnquiryForm_less___default.a.OutletStoreEnquiryFormDealerMobile] = true, _classnames5)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 231
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 234
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 235
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
                { href: "tel:" + dealer.departments[0].phone, fullWidth: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 236
                  }
                },
                "Call dealer"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 237
                  }
                },
                "Or fill the form below and your dealer will contact you directly."
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
        { horizontalPadding: true, backgroundColor: "#f5f5f5", __source: {
            fileName: _jsxFileName,
            lineNumber: 243
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__OutletStoreEnquiryForm_less___default.a.OutletStoreEnquiryForm] = true, _classnames6)), __source: {
              fileName: _jsxFileName,
              lineNumber: 244
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_2__OutletStoreEnquiryForm_less___default.a.OutletStoreEnquiryFormForm] = true, _classnames7)), __source: {
                fileName: _jsxFileName,
                lineNumber: 247
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "form",
              { method: "POST", onSubmit: this._handleSubmit, noValidate: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 250
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                { center: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 251
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["C" /* H5 */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 252
                    }
                  },
                  "Enter your details"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 257
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["R" /* InputSelect */], _extends({
                  name: "title",
                  label: "Title",
                  options: __WEBPACK_IMPORTED_MODULE_11__TITLES__["a" /* default */]
                }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "title"), {
                  onBlur: function onBlur() {
                    if (form.title.value) {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Outlet Store",
                        pageAction: "Outlet Store Form - Selected \"TITLE\" - \"" + form.title.value.toUpperCase() + "\""
                      });
                    }
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 258
                  }
                }))
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 274
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                  name: "firstName",
                  label: "First Name"
                }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
                  onBlur: function onBlur() {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Outlet Store",
                      pageAction: "Outlet store enquiry Form - Entered \"FIRSTNAME\""
                    });
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 275
                  }
                }))
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 287
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                  name: "lastName",
                  label: "Last Name"
                }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "lastName"), {
                  onBlur: function onBlur() {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Outlet Store",
                      pageAction: "Outlet store enquiry Form - Entered \"LASTNAME\""
                    });
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 288
                  }
                }))
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 300
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                  name: "phone",
                  label: "Phone"
                }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "phone"), {
                  onBlur: function onBlur() {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Outlet Store",
                      pageAction: "Outlet store enquiry Form - Entered \"PHONE\""
                    });
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 301
                  }
                }))
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 313
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["N" /* InputEmail */], _extends({
                  name: "email",
                  label: "Email"
                }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), {
                  onBlur: function onBlur() {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Outlet Store",
                      pageAction: "Outlet store enquiry Form - Entered \"EMAIL\""
                    });
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 314
                  }
                }))
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 327
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                  name: "comments",
                  label: "Questions / Comments"
                }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "comments"), {
                  onBlur: function onBlur() {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Outlet Store",
                      pageAction: "Outlet store enquiry Form - Entered \"ENQUIRY\""
                    });
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 328
                  }
                }))
              ),
              financeOptionText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                { show: true, checkbox: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 342
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
                  name: "finance",
                  label: financeOptionText
                }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "finance", function (value) {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Outlet store",
                    pageAction: "Outlet store enquiry Form - " + (value ? 'Checked' : 'Unchecked') + " \"FINANCE\""
                  });
                }), {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 343
                  }
                }))
              ),
              financeOptionText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                { show: true, checkbox: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 357
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: { height: "1px", width: "100%", border: "0", borderTop: "1px solid #D5D5D5" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 358
                  }
                })
              ),
              !financeOptionText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 361
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                { show: true, checkbox: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 362
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
                  name: "optedInDealer",
                  label: optInMessage || "I acknowledge that Mazda or Mazda dealers may send me further information about Mazda products or services."
                }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "optedInDealer", function (value) {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Outlet store",
                    pageAction: "Outlet store enquiry Form - " + (value ? 'Checked' : 'Unchecked') + " \"OPT IN\""
                  });
                }), {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 363
                  }
                }))
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 374
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                { show: true, checkbox: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 375
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
                  name: "privacy",
                  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 379
                      }
                    },
                    privacyPolicy,
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
                      {
                        href: privacyPolicyLink,
                        onClick: function onClick() {
                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                            pageCategory: "Outlet Store",
                            pageAction: "Outlet store enquiry Form - Clicked \"PRIVACYPOLICY\""
                          });
                        },
                        external: true, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 381
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "nobr",
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 390
                          }
                        },
                        "Privacy Policy"
                      )
                    )
                  )
                }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "privacy", function (value) {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "Outlet Store",
                    pageAction: "Outlet store enquiry Form - " + (value ? 'Checked' : 'Unchecked') + " \"PRIVACYPOLICY\""
                  });
                }), {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 376
                  }
                }))
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 402
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 403
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 404
                  }
                },
                errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 406
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
                  _extends({
                    styleName: "black",
                    loading: loading,
                    fullWidth: true
                  }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 408
                    }
                  }),
                  buttonText
                )
              )
            )
          )
        )
      )
    );
  };

  return OutletStoreEnquiryForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

OutletStoreEnquiryForm.displayName = "OutletStoreEnquiryForm";


/* harmony default export */ __webpack_exports__["a"] = (OutletStoreEnquiryForm);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PDFTemplate_less__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PDFTemplate_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PDFTemplate_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\PDFTemplate\\PDFTemplate.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PDFTemplate = function (_React$PureComponent) {
  _inherits(PDFTemplate, _React$PureComponent);

  function PDFTemplate() {
    _classCallCheck(this, PDFTemplate);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PDFTemplate.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3;

    var _props = this.props,
        _props$components = _props.components,
        components = _props$components === undefined ? [] : _props$components,
        imageSrc = _props.imageSrc;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_4__PDFTemplate_less___default.a.PDFTemplate] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_4__PDFTemplate_less___default.a.PDFTemplateHeader] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 18
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["o" /* Image */], { src: imageSrc, __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_componentParser__["a" /* default */])(components),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_4__PDFTemplate_less___default.a.PDFTemplateFooter] = true, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["o" /* Image */], { src: imageSrc, __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        })
      )
    );
  };

  return PDFTemplate;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

PDFTemplate.displayName = "PDFTemplate";


/* harmony default export */ __webpack_exports__["a"] = (PDFTemplate);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_debounce__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\PersonalisationBlockContainer\\PersonalisationBlockContainer.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PersonalisationBlockContainer = function (_React$Component) {
  _inherits(PersonalisationBlockContainer, _React$Component);

  function PersonalisationBlockContainer(props) {
    _classCallCheck(this, PersonalisationBlockContainer);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._updateDimensions = function () {
      _this.setState({
        windowWidth: __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].innerWidth
      });
    };

    _this.state = {
      windowWidth: __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].innerWidth
    };
    return _this;
  }

  PersonalisationBlockContainer.prototype.componentDidMount = function componentDidMount() {
    this._updateDimensions();
    __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_debounce__["a" /* default */])(this._updateDimensions, 250));
  };

  PersonalisationBlockContainer.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_debounce__["a" /* default */])(this._updateDimensions, 250));
  };

  PersonalisationBlockContainer.prototype.render = function render() {
    var _props$items = this.props.items,
        items = _props$items === undefined ? [] : _props$items;
    var windowWidth = this.state.windowWidth;


    if (items.length === 0) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37
      }
    });

    var filteredItems = [].concat(items);
    // Filtering items based on iFrameOptions
    if (filteredItems.length > 1) {
      filteredItems = filteredItems.filter(function (item) {
        if (item.props.iFrameOptions === 'showInIframe' && !__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["e" /* IS_IFRAME */]) return false;
        if (item.props.iFrameOptions === 'hideInIframe' && __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["e" /* IS_IFRAME */]) return false;
        return true;
      });
    }

    // Filtering based on urlList
    var cookieHandlerObject = new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_cookieHandler__["a" /* default */]();
    var history = cookieHandlerObject.getCookie("history");
    var newHistory = JSON.parse(history);

    filteredItems = filteredItems.filter(function (item) {
      if (item.urlList && item.urlList.length > 0 && newHistory && newHistory.length > 0) {
        var found = false;
        newHistory.map(function (singleHistory) {
          if (item.urlList.includes(singleHistory)) {
            found = true;
          }
        });
        return found;
      }
      return true;
    });

    // Filtering based on mobile,desktop and tablet
    // Filtering based on window size 1200px 768px 529px
    if (windowWidth >= 768 && filteredItems.length > 1) {
      filteredItems = filteredItems.filter(function (item) {
        return item.props.desktop;
      });
    } else if (windowWidth >= 529 && windowWidth < 768 && filteredItems.length > 1) {
      filteredItems = filteredItems.filter(function (item) {
        return item.props.tablet;
      });
    } else if (windowWidth < 529 && filteredItems.length > 1) {
      filteredItems = filteredItems.filter(function (item) {
        return item.props.mobile;
      });
    }

    var itemToRender = [];
    if (filteredItems.length > 0) {
      itemToRender.push(filteredItems[0]);
    }

    if (!itemToRender || !itemToRender[0] || itemToRender[0].name !== 'PersonalisationBlockItem') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88
      }
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 91
        }
      },
      itemToRender.length > 0 && Object(__WEBPACK_IMPORTED_MODULE_1_AtomicUtils_componentParser__["a" /* default */])(itemToRender)
    );
  };

  return PersonalisationBlockContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PersonalisationBlockContainer.displayName = "PersonalisationBlockContainer";


/* harmony default export */ __webpack_exports__["a"] = (PersonalisationBlockContainer);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_cookieHandler__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Price_less__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Price_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Price_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Price\\Price.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Price = function (_React$Component) {
  _inherits(Price, _React$Component);

  function Price(props) {
    _classCallCheck(this, Price);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      locationState: ""
    };
    return _this;
  }

  Price.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.updatePrice();

    __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("POSTCODE_UPDATE", function () {
      return _this2.updatePrice();
    }, false);
  };

  // getPrice = async () => {
  //   const { api, nameplate } = this.props
  //   const locationState = new cookieHandler().getCookie("state")

  //   if (locationState) {
  //     await this.setState({
  //       locationState
  //     }, async () => {
  //       await fetchAPI({
  //         method: "POST",
  //         url: api,
  //         body: { nameplate }
  //       })
  //       .then(async (response) => {
  //         const json = await response.json()
  //         const { success, errorMsg, data } = json
  //         if (!success) {
  //           this.setState({
  //             errorMessage: errorMsg,
  //             loading: false
  //           })
  //         } else {
  //           // successful
  //           this.setState({
  //             loading: false,
  //             success: true,
  //             data,
  //             rightItemBasedOnState: data[data.findIndex(priceItem => priceItem.state.toLowerCase() === locationState.toLowerCase())]
  //           })
  //         }
  //       })
  //       .catch((response) => {
  //         this.setState({
  //           errorMessage: response.message || `Failed with status ${response.status}`,
  //           loading: false
  //         })
  //       })
  //     })
  //   }
  // }

  Price.prototype.updatePrice = function updatePrice() {
    var data = this.props.data;
    //const locationState = new cookieHandler().getCookie("state")

    var locationState = 'ACT';

    if (data && locationState) {
      this.setState({
        locationState: locationState,
        rightItemBasedOnState: data[data.findIndex(function (priceItem) {
          return priceItem.state.toLowerCase() === locationState.toLowerCase();
        })]
      });
    }
  };

  Price.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props$white = this.props.white,
        white = _props$white === undefined ? true : _props$white;
    var _state = this.state,
        locationState = _state.locationState,
        rightItemBasedOnState = _state.rightItemBasedOnState;


    if (!locationState || !rightItemBasedOnState) return null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5__Price_less___default.a.Price] = true, _classnames[__WEBPACK_IMPORTED_MODULE_5__Price_less___default.a.PriceWhite] = white, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 89
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
        { white: white, withoutMargin: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 93
          }
        },
        rightItemBasedOnState.disclaimerCode ? rightItemBasedOnState.disclaimerCode + " from" : 'From',
        "\xA0",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["a" /* A */],
          {
            withoutStyle: true,
            onClick: function onClick(event) {
              if (event && event.target && event.target.querySelector('button')) {
                event.target.querySelector('button').click();
              }
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 95
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_5__Price_less___default.a.PriceText] = true, _classnames2)), __source: {
                fileName: _jsxFileName,
                lineNumber: 102
              }
            },
            "$",
            rightItemBasedOnState.lowestPrice.toLocaleString(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["i" /* Disclaimer */],
              { Icon: __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_14" /* StarIcon */], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 105
                }
              },
              rightItemBasedOnState.disclaimer
            ),
            "\xA0-\xA0 $",
            rightItemBasedOnState.highestPrice.toLocaleString(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["i" /* Disclaimer */],
              { Icon: __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_14" /* StarIcon */], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 107
                }
              },
              rightItemBasedOnState.disclaimer
            )
          )
        )
      )
    );
  };

  return Price;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Price.displayName = "Price";


/* harmony default export */ __webpack_exports__["a"] = (Price);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccordionText_AccordionText__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HeroContent_HeroContent__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecallDocument_RecallDocument__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_parseRecallActivities__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Recall_less__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Recall_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Recall_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants_environment__ = __webpack_require__(12);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Recall\\Recall.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Recall = function (_React$Component) {
  _inherits(Recall, _React$Component);

  function Recall(props) {
    var _this2 = this;

    _classCallCheck(this, Recall);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form, currentURL;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;
                currentURL = new __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_13_constants_environment__["i" /* WINDOW */].location.href);

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var endpoint, form;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          endpoint = _this.props.endpoint;
                          form = _this.state.form;
                          _context2.next = 4;
                          return Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: endpoint,
                            body: {
                              vin: form.vinOrRegoInput.value
                            }
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, message, recallResponse, statusCode;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      message = json.message, recallResponse = json.recallResponse, statusCode = json.statusCode;

                                      if (statusCode !== 200) {
                                        _this.setState({
                                          errorMessage: message,
                                          loading: false
                                        });
                                      } else {
                                        currentURL.removeParam("VIN");
                                        currentURL.setParam("vin", form.vinOrRegoInput.value, true);
                                        _this.setState({
                                          recallData: recallResponse,
                                          loading: false
                                        }, function () {
                                          _this._gtmCall(recallResponse);
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function () {
                            _this.setState({
                              loading: false
                            });
                          });

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this._handleNoRecall = function () {
      var currentURL = new __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_13_constants_environment__["i" /* WINDOW */].location.href);
      _this.setState({
        form: {
          vinOrRegoInput: {
            validations: {
              required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].REGO_OR_VIN_REQUIRED
            }
          },
          submitButton: { disabled: true }
        },
        recallData: null
      }, function () {
        currentURL.removeParam("vin", true);
      });
    };

    _this._gtmCall = function (response) {
      var _parseRecallActivitie = Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_parseRecallActivities__["a" /* default */])(response.recallActivities),
          NumberOfAll = _parseRecallActivitie.NumberOfAll,
          Status = _parseRecallActivitie.Status;

      Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_gtmHandler__["a" /* default */])({
        pageCategory: "Recalls",
        pageAction: "Recalls - Enter VIN - Recall Status \"" + Status + "\""
      });
    };

    _this.state = {
      form: {
        vinOrRegoInput: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].REGO_OR_VIN_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      recallData: props.recallData
    };
    return _this;
  }

  Recall.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    var currentURL = new __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_13_constants_environment__["i" /* WINDOW */].location.href);
    if (currentURL.query.vin || currentURL.query.VIN || this.props.vin) {
      var vin = currentURL.query.vin || currentURL.query.VIN || this.props.vin;
      Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, { vinOrRegoInput: vin });
      setTimeout(function () {
        _this3._handleSubmit();
      }, 100);
    }
  };

  Recall.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5;

    var _props = this.props,
        heading = _props.heading,
        recallMessageDescription = _props.recallMessageDescription,
        mainHeading = _props.mainHeading,
        mainDescription = _props.mainDescription,
        mainDescriptionWithRecallData = _props.mainDescriptionWithRecallData,
        recallDocument = _props.recallDocument;
    var _state = this.state,
        form = _state.form,
        loading = _state.loading,
        errorMessage = _state.errorMessage,
        recallData = _state.recallData;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_12__Recall_less___default.a.Recall] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 125
        }
      },
      !recallData && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
        { backgroundColor: "#F5F5F5", __source: {
            fileName: _jsxFileName,
            lineNumber: 129
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__HeroContent_HeroContent__["a" /* default */], {
          heading: mainHeading,
          description: mainDescription,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 130
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
        { backgroundColor: "#FFFFFF", __source: {
            fileName: _jsxFileName,
            lineNumber: 136
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["s" /* Container */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 137
            }
          },
          !recallData && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_12__Recall_less___default.a.RecallFormSection] = true, _classnames2)), __source: {
                fileName: _jsxFileName,
                lineNumber: 139
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["A" /* H3 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 142
                }
              },
              heading
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "form",
              { method: "POST", onSubmit: this._handleSubmit, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 145
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_12__Recall_less___default.a.Form] = true, _classnames3)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 146
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_12__Recall_less___default.a.FormInput] = true, _classnames4)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 149
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["S" /* InputText */], _extends({
                    name: "vinOrRegoInput",
                    label: "Enter your VIN here"
                  }, Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "vinOrRegoInput"), {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 152
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_12__Recall_less___default.a.FormInputButton] = true, _classnames5)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 158
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
                    _extends({
                      styleName: "black",
                      loading: loading
                    }, Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 161
                      }
                    }),
                    "CHECK"
                  )
                )
              )
            ),
            errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["c" /* Alert */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 172
                }
              },
              errorMessage
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 176
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__AccordionText_AccordionText__["a" /* default */],
                {
                  styleName: "simple",
                  status: 1,
                  title: "Where is my VIN located?", __source: {
                    fileName: _jsxFileName,
                    lineNumber: 177
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 181
                    }
                  },
                  recallMessageDescription
                )
              )
            )
          )
        )
      ),
      recallData && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RecallDocument_RecallDocument__["a" /* default */], _extends({
        handleNoRecall: this._handleNoRecall
      }, recallDocument && recallDocument.props, recallData, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 191
        }
      }))
    );
  };

  return Recall;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Recall.displayName = "Recall";


/* harmony default export */ __webpack_exports__["a"] = (Recall);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecallDetail_less__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\RecallDetail\\RecallDetail.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var RecallDetail = function (_React$Component) {
  _inherits(RecallDetail, _React$Component);

  function RecallDetail() {
    _classCallCheck(this, RecallDetail);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RecallDetail.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames7, _classnames8, _classnames9, _classnames10, _classnames11, _classnames12, _classnames13, _classnames14, _classnames15, _classnames16, _classnames17;

    var _props = this.props,
        serviceActivityCode = _props.serviceActivityCode,
        summaryText = _props.summaryText,
        description = _props.description,
        riskText = _props.riskText,
        remedyText = _props.remedyText,
        pendingInitiationDate = _props.pendingInitiationDate,
        completedDate = _props.completedDate,
        vehicleStatus = _props.vehicleStatus,
        critical = _props.critical,
        pra = _props.pra;
    // 'ACTIVE' | 'PENDING' | 'COMPLETED'

    var status = vehicleStatus && vehicleStatus.toUpperCase();
    var statusText = vehicleStatus;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetail] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 24
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["B" /* H4 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        },
        description
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        }
      }),
      critical && (status === "ACTIVE" || status === "PENDING") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_16" /* Tag */],
        { color: "red", __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        },
        "CRITICAL"
      ),
      !critical && status !== "ACTIVE" && status !== "PENDING" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_16" /* Tag */],
        { checked: true, color: "green", __source: {
            fileName: _jsxFileName,
            lineNumber: 37
          }
        },
        "COMPLETED"
      ),
      critical && status !== "ACTIVE" && status !== "PENDING" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_16" /* Tag */],
        { checked: true, color: "green", __source: {
            fileName: _jsxFileName,
            lineNumber: 42
          }
        },
        "COMPLETED"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        }
      }),
      status && status !== "ACTIVE" && status !== "PENDING" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeading] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.WithoutPadding] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingSection] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 52
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingLabel] = true, _classnames4)), __source: {
                fileName: _jsxFileName,
                lineNumber: 55
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 58
                }
              },
              "STATUS"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailStatus] = true, _classnames5)), __source: {
                fileName: _jsxFileName,
                lineNumber: 62
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 65
                }
              },
              statusText
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeading] = true, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        },
        status && (status === "ACTIVE" || status === "PENDING") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingSection] = true, _classnames7)), __source: {
              fileName: _jsxFileName,
              lineNumber: 74
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingLabel] = true, _classnames8)), __source: {
                fileName: _jsxFileName,
                lineNumber: 77
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 80
                }
              },
              "STATUS"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames9 = {}, _classnames9[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailStatus] = true, _classnames9[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailStatusRed] = status === "ACTIVE", _classnames9[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailStatusAmber] = status === "PENDING", _classnames9)), __source: {
                fileName: _jsxFileName,
                lineNumber: 84
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 89
                }
              },
              statusText
            )
          )
        ),
        status === "PENDING" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames10 = {}, _classnames10[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingSection] = true, _classnames10)), __source: {
              fileName: _jsxFileName,
              lineNumber: 94
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames11 = {}, _classnames11[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingLabel] = true, _classnames11)), __source: {
                fileName: _jsxFileName,
                lineNumber: 97
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 100
                }
              },
              "DATE\xA0INITIATED"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 104
              }
            },
            pendingInitiationDate
          )
        ),
        status !== "ACTIVE" && status !== "PENDING" && completedDate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames12 = {}, _classnames12[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingSection] = true, _classnames12)), __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames13 = {}, _classnames13[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingLabel] = true, _classnames13)), __source: {
                fileName: _jsxFileName,
                lineNumber: 113
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 116
                }
              },
              "DATE\xA0COMPLETED"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 120
              }
            },
            completedDate
          )
        ),
        serviceActivityCode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames14 = {}, _classnames14[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingSection] = true, _classnames14)), __source: {
              fileName: _jsxFileName,
              lineNumber: 126
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames15 = {}, _classnames15[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingLabel] = true, _classnames15)), __source: {
                fileName: _jsxFileName,
                lineNumber: 129
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 132
                }
              },
              "RECALL\xA0CODE"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 136
              }
            },
            serviceActivityCode
          )
        ),
        pra && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames16 = {}, _classnames16[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingSection] = true, _classnames16)), __source: {
              fileName: _jsxFileName,
              lineNumber: 142
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames17 = {}, _classnames17[__WEBPACK_IMPORTED_MODULE_3__RecallDetail_less___default.a.RecallDetailHeadingLabel] = true, _classnames17)), __source: {
                fileName: _jsxFileName,
                lineNumber: 145
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 148
                }
              },
              "PRA\xA0NUMBER"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 152
              }
            },
            pra
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 158
          }
        },
        summaryText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 160
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 161
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 162
              }
            },
            "Summary"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], { textAlign: "left", xmlString: "<p>" + summaryText + "</p>", __source: {
              fileName: _jsxFileName,
              lineNumber: 165
            }
          })
        ),
        riskText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 169
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 170
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 171
              }
            },
            "Risk"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], { textAlign: "left", xmlString: "<p>" + riskText + "</p>", __source: {
              fileName: _jsxFileName,
              lineNumber: 174
            }
          })
        ),
        remedyText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 178
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 179
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 180
              }
            },
            "Remedy"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], { textAlign: "left", xmlString: "<p>" + remedyText + "</p>", __source: {
              fileName: _jsxFileName,
              lineNumber: 183
            }
          })
        )
      )
    );
  };

  return RecallDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RecallDetail.displayName = "RecallDetail";


/* harmony default export */ __webpack_exports__["a"] = (RecallDetail);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var parseRecallActivities = function parseRecallActivities(recallActivities) {
  var NumberOfActive = 0;
  var NumberOfPending = 0;
  var NumberOfCompleted = 0;
  var NumberOfAll = 0;

  // 'ACTIVE' | 'PENDING' | 'COMPLETED'
  // We have the same thing in RecallDocument
  if (recallActivities) {
    recallActivities.forEach(function (recall) {
      var status = recall.vehicleStatus && recall.vehicleStatus.toUpperCase();
      if (status !== "ACTIVE" && status !== "PENDING") {
        status = "COMPLETED";
      }

      if (status === "ACTIVE") {
        NumberOfActive += 1;
        NumberOfAll += 1;
      }
      if (status === "PENDING") {
        NumberOfPending += 1;
        NumberOfAll += 1;
      }
      if (status === "COMPLETED") {
        NumberOfCompleted += 1;
      }
    });
  }

  var Status = "";
  if (NumberOfAll > 0) {
    Status = "YOUR VEHICLE IS AFFECTED BY " + NumberOfAll + " RECALL" + (NumberOfAll > 1 ? "s" : "");
  } else {
    Status = "NO OUTSTANDING RECALLS";
  }

  return {
    NumberOfActive: NumberOfActive,
    NumberOfPending: NumberOfPending,
    NumberOfCompleted: NumberOfCompleted,
    NumberOfAll: NumberOfAll,
    Status: Status
  };
};

/* harmony default export */ __webpack_exports__["a"] = (parseRecallActivities);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegisterInterestForm_less__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegisterInterestForm_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RegisterInterestForm_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TITLES__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\RegisterInterestForm\\RegisterInterestForm.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var RegisterInterestForm = function (_React$Component) {
  _inherits(RegisterInterestForm, _React$Component);

  function RegisterInterestForm(props) {
    var _this2 = this;

    _classCallCheck(this, RegisterInterestForm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form, _this$props, submitFormEndpoint, title, _this$props$nameplate, nameplateTitle, _this$props$buttonTex, buttonText, _this$props$eloquaFor, eloquaFormName, source;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;
                _this$props = _this.props, submitFormEndpoint = _this$props.submitFormEndpoint, title = _this$props.title, _this$props$nameplate = _this$props.nameplateTitle, nameplateTitle = _this$props$nameplate === undefined ? '' : _this$props$nameplate, _this$props$buttonTex = _this$props.buttonText, buttonText = _this$props$buttonTex === undefined ? 'Keep me informed' : _this$props$buttonTex, _this$props$eloquaFor = _this$props.eloquaFormName, eloquaFormName = _this$props$eloquaFor === undefined ? 'register-your-interest' : _this$props$eloquaFor, source = _this$props.source;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var form, body;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          form = _this.state.form;
                          body = {
                            nameplateTitle: nameplateTitle,
                            title: form.title.value,
                            firstName: form.firstName.value,
                            lastName: form.lastName.value,
                            phone: form.phone.value,
                            email: form.email.value,
                            bodyStyle: form.bodyStyle.value || null,
                            optedInDealer: form.optedInDealer.value,
                            eloquaFormName: eloquaFormName,
                            source: source,
                            dealerCode: form.preferredDealer.value.dealerCode,
                            dealerPostCode: form.preferredDealer.value.postCode,
                            state: form.preferredDealer.value.state || localStorage.getItem('selectedRegion') || ''
                            // if (form.region.value) body.postcode = form.region.value.postcode
                            // if (form.region.value) body.state = form.region.value.state
                            // if (form.region.value) body.suburb = form.region.value.suburb
                          };
                          _context2.next = 4;
                          return Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: submitFormEndpoint,
                            body: body
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg, words;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg, words = json.words;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          words: words && words.split(",") || [],
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "Register Your Interest Form",
                                            pageAction: "Register Your Interest Form - \"" + nameplateTitle + "\" - Clicked \"" + buttonText + "\" - Successfully submitted."
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              words: response.words && response.words.split(",") || [],
                              loading: false
                            });
                          });

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this._handleBodyStyleChange = function () {
      var form = _this.state.form;


      if (form && form.bodyStyle && form.bodyStyle.value) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Register Your Interest Form",
          pageAction: "Register Your Interest Form - Selected \"BODYSTYLE\" - \"" + form.bodyStyle.value.toUpperCase() + "\""
        });
      }
    };

    _this._handleOnBlurSearchableRegion = function () {
      var form = _this.state.form;

      if (form && form.region && form.region.value && form.region.value.description) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Register Your Interest Form",
          pageAction: "Register Your Interest Form - Selected \"POSTCODE/SUBURB\" - \"" + form.region.value.description.toUpperCase() + "\""
        });
      }
    };

    _this.selectDealer = function (dealer) {
      // no search, use the selected dealer only for the radio inputs
      // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
      _this.refs.dealerSearchComp.setState({
        dealers: [dealer],
        selected: dealer,
        loading: false
      });
    };

    _this.state = {
      form: {
        title: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_REQUIRED
            // phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        region: {
          validations: {
            // required: MESSAGES.LOCATION_REQUIRED,
            // postcodeSearchable: MESSAGES.LOCATION_INVALID
          }
        },
        preferredDealer: {
          validations: {}
        },
        bodyStyle: {
          validations: {}
        },
        optedInDealer: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].OPTIN_REQUIRED
          }
        },
        privacy: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PRIVACY_POLICY_REQUIRED
          }
        },
        reCaptcha: {
          validations: {}
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };

    if (props.bodyStyles && props.bodyStyles.length) {
      _this.state.form.bodyStyle.validations = {
        required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].BODYSTYLE_REQUIRED
      };
    }

    if (props.isOptInMandatory) {
      _this.state.form.optedInDealer.validations = {
        required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].OPTIN_REQUIRED
      };
    }

    if (props.showRecaptcha) {
      _this.state.form.reCaptcha.validations = {
        required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].RECAPTCHA_REQUIRED
      };
    }
    return _this;
  }

  RegisterInterestForm.prototype.componentDidMount = function componentDidMount() {
    var bodyStyles = this.props.bodyStyles;


    if (bodyStyles && bodyStyles.length && bodyStyles.length === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
        bodyStyle: bodyStyles[0].value
      });
    }
  };

  RegisterInterestForm.prototype.render = function render() {
    var _classnames,
        _classnames2,
        _classnames3,
        _classnames4,
        _this3 = this;

    var _props = this.props,
        title = _props.title,
        optInMessage = _props.optInMessage,
        imageUrl = _props.imageUrl,
        privacyPolicy = _props.privacyPolicy,
        privacyPolicyLink = _props.privacyPolicyLink,
        introText = _props.introText,
        bodyStyles = _props.bodyStyles,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? 'Keep me informed' : _props$buttonText,
        _props$showRecaptcha = _props.showRecaptcha,
        showRecaptcha = _props$showRecaptcha === undefined ? false : _props$showRecaptcha,
        thankYouComponents = _props.thankYouComponents,
        _props$initialLocatio = _props.initialLocations,
        initialLocations = _props$initialLocatio === undefined ? [] : _props$initialLocatio,
        _props$dealersEndPoin = _props.dealersEndPoint,
        dealersEndPoint = _props$dealersEndPoin === undefined ? "/api/dealer-search" : _props$dealersEndPoin,
        _props$dealerSearchEn = _props.dealerSearchEndPoint,
        dealerSearchEndPoint = _props$dealerSearchEn === undefined ? "/api/dealers" : _props$dealerSearchEn;
    var _state = this.state,
        form = _state.form,
        errorMessage = _state.errorMessage,
        loading = _state.loading,
        success = _state.success;


    if (success) {
      return Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_componentParser__["a" /* default */])(thankYouComponents);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__RegisterInterestForm_less___default.a.RegisterInterest] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 249
        }
      },
      (title || introText) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["n" /* HeroContent */], {
        heading: title,
        description: introText, __source: {
          fileName: _jsxFileName,
          lineNumber: 253
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["s" /* Container */],
        { styleName: imageUrl ? "tablet-wide" : "mobile", __source: {
            fileName: _jsxFileName,
            lineNumber: 257
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["r" /* ColumnGroup */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 258
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["s" /* Container */],
            { styleName: "mobile", __source: {
                fileName: _jsxFileName,
                lineNumber: 259
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__RegisterInterestForm_less___default.a.RegisterInterestForm] = !imageUrl, _classnames2)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 260
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "form",
                { method: "POST", onSubmit: this._handleSubmit, noValidate: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 263
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 264
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["R" /* InputSelect */], _extends({
                    name: "title",
                    label: "Title",
                    options: __WEBPACK_IMPORTED_MODULE_10__TITLES__["a" /* default */]
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "title"), {
                    onBlur: function onBlur() {
                      if (form.title.value) {
                        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                          pageCategory: "Register Your Interest Form",
                          pageAction: "Register Your Interest Form Form - Selected \"TITLE\" - " + form.title.value.toUpperCase()
                        });
                      }
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 265
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 280
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                    name: "firstName",
                    label: "First Name"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
                    onBlur: function onBlur() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Register Your Interest Form",
                        pageAction: "Register Your Interest Form Form - Entered \"FIRSTNAME\""
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 281
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 293
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                    name: "lastName",
                    label: "Last Name"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "lastName"), {
                    onBlur: function onBlur() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Register Your Interest Form",
                        pageAction: "Register Your Interest Form Form - Entered \"LASTNAME\""
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 294
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 306
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                    name: "phone",
                    label: "Phone"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "phone"), {
                    onBlur: function onBlur() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Register Your Interest Form",
                        pageAction: "Register Your Interest Form Form - Entered \"PHONE\""
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 307
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 319
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["N" /* InputEmail */], _extends({
                    name: "email",
                    label: "Email"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), {
                    onBlur: function onBlur() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Register Your Interest Form",
                        pageAction: "Register Your Interest Form Form - Entered \"EMAIL\""
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 320
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["n" /* DealerSearchBoxNZ */], {
                  searchType: "SALES",
                  noMap: true,
                  selectDealerVariant: true,
                  selectDealer: this.selectDealer,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 342
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 349
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["h" /* DealerSearch */], _extends({
                    dealersEndPoint: dealersEndPoint,
                    endpoint: dealerSearchEndPoint,
                    disabled: !form.region.value || !(form.region.value.postcode || form.region.value.value),
                    type: "Sales",
                    name: "preferredDealer",
                    postcode: form.region.value && form.region.value.postcode || initialLocations && initialLocations[0] && initialLocations[0].postCode,
                    dealerCode: form.region.value && form.region.value.value,
                    ref: "dealerSearchComp"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "preferredDealer"), {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 350
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    hide: true,
                    show: bodyStyles && bodyStyles.length,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 362
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__RegisterInterestForm_less___default.a.RegisterInterestFormText] = true, _classnames3)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 366
                      }
                    },
                    bodyStyles && bodyStyles.length === 1 ? "The body style I am interested in is" : "Tell us which body style interests you the most",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__RegisterInterestForm_less___default.a.requiredStar] = true, _classnames4)), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 375
                        }
                      },
                      "*"
                    )
                  ),
                  bodyStyles && bodyStyles.length && bodyStyles.map(function (bodyStyle) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["P" /* InputRadio */], _extends({
                      name: "bodyStyle",
                      key: bodyStyle.value,
                      value: bodyStyle.value,
                      label: bodyStyle.name
                    }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(_this3, "bodyStyle", _this3._handleBodyStyleChange), {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 384
                      }
                    }));
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 395
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  { show: true, checkbox: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 396
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
                    name: "optedInDealer",
                    label: optInMessage || "I understand that in registering my interest, Mazda or Mazda Dealers can send me further information about Mazda products or services."
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "optedInDealer"), {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 397
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 403
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  { show: true, checkbox: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 404
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
                    name: "privacy",
                    label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 408
                        }
                      },
                      privacyPolicy,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
                        {
                          href: privacyPolicyLink,
                          external: true, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 410
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "nobr",
                          {
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 413
                            }
                          },
                          " Privacy Policy"
                        )
                      )
                    )
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "privacy"), {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 405
                    }
                  }))
                ),
                showRecaptcha && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 422
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 423
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["L" /* InputCaptcha */], _extends({
                    name: "reCaptcha"
                  }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "reCaptcha"), {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 424
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 430
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 431
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 432
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
                    _extends({
                      styleName: "black",
                      loading: loading,
                      fullWidth: true
                    }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 433
                      }
                    }),
                    buttonText
                  )
                )
              )
            )
          ),
          imageUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["o" /* Image */], { src: imageUrl, __source: {
              fileName: _jsxFileName,
              lineNumber: 446
            }
          })
        )
      )
    );
  };

  return RegisterInterestForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RegisterInterestForm.displayName = "RegisterInterestForm";


/* harmony default export */ __webpack_exports__["a"] = (RegisterInterestForm);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SaveForm_less__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SaveForm_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SaveForm_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\SaveForm\\SaveForm.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-deprecated */













var SaveForm = function (_React$Component) {
  _inherits(SaveForm, _React$Component);

  function SaveForm(props) {
    var _this2 = this;

    _classCallCheck(this, SaveForm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _this$props, endPoint, namePlate, bodyStyle, _this$props$location, location, _this$props$safetyMod, safetyModelExcess, buildUrl, testDriveUrl, findDealerUrl, compareUrl, financeOptionText, form;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this$props = _this.props, endPoint = _this$props.endPoint, namePlate = _this$props.namePlate, bodyStyle = _this$props.bodyStyle, _this$props$location = _this$props.location, location = _this$props$location === undefined ? {} : _this$props$location, _this$props$safetyMod = _this$props.safetyModelExcess, safetyModelExcess = _this$props$safetyMod === undefined ? null : _this$props$safetyMod, buildUrl = _this$props.buildUrl, testDriveUrl = _this$props.testDriveUrl, findDealerUrl = _this$props.findDealerUrl, compareUrl = _this$props.compareUrl, financeOptionText = _this$props.financeOptionText;
                          form = _this.state.form;
                          _context2.next = 4;
                          return Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: endPoint,
                            body: {
                              email: form.email.value,
                              name: form.firstName.value,
                              surname: form.lastName.value,
                              mobile: form.phone.value,
                              // postcode: form.postcode.value.postcode || location.postcode || "",
                              financeInterest: financeOptionText ? form.finance.value === true ? 'Yes' : null : undefined,
                              namePlate: namePlate,
                              bodyStyle: bodyStyle,
                              safetyModelExcess: safetyModelExcess,
                              buildUrl: buildUrl,
                              findDealerUrl: findDealerUrl,
                              compareUrl: compareUrl,
                              testDriveUrl: testDriveUrl ? __WEBPACK_IMPORTED_MODULE_9_constants_environment__["i" /* WINDOW */].location.origin + "/" + testDriveUrl : undefined,
                              optedInDealer: form.optIn.value,
                              dealerCode: form.preferredDealer.value.dealerCode,
                              dealerPostCode: form.preferredDealer.value.postCode,
                              state: form.preferredDealer.value.state || localStorage.getItem('selectedRegion') || ''
                            }
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg, words;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg, words = json.words;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          words: words && words.split(",") || [],
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: (_this.props.gtmEvents ? _this.props.gtmEvents.category + " | " : "") + "Save Form",
                                            pageAction: (_this.props.gtmEvents ? _this.props.gtmEvents.action + " - " : "") + "Clicked \"SEND\" - Successfully submitted."
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              words: response.words && response.words.split(",") || [],
                              loading: false
                            });
                          });

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.selectDealer = function (dealer) {
      // no search, use the selected dealer only for the radio inputs
      // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
      _this.refs.dealerSearchComp.setState({
        dealers: [dealer],
        selected: dealer,
        loading: false
      });
    };

    _this.state = {
      form: {
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].LASTNAME_REQUIRED
          }
        },
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        phone: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_REQUIRED,
            phone: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        region: {
          validations: {}
        },
        // postcode: {
        //   validations:  {
        //     required: MESSAGES.ADDRESS1_REQUIRED
        //   }
        // },
        preferredDealer: {
          validations: {}
        },
        finance: {
          validations: {}
        },
        optIn: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].OPTIN_REQUIRED
          }
        },
        privacyPolicy: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  SaveForm.prototype.componentDidMount = function componentDidMount() {
    var location = this.props.location;


    if (location && location.postcode) {
      Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
        postcode: location.postcode
      });
    }
  };

  SaveForm.prototype.render = function render() {
    var _classnames4, _classnames5;

    var _props = this.props,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Send" : _props$buttonText,
        _props$heading = _props.heading,
        heading = _props$heading === undefined ? "Save" : _props$heading,
        description = _props.description,
        optInMessage = _props.optInMessage,
        privacyPolicy = _props.privacyPolicy,
        privacyPolicyLink = _props.privacyPolicyLink,
        successMessage = _props.successMessage,
        _props$closeButtonTex = _props.closeButtonText,
        closeButtonText = _props$closeButtonTex === undefined ? "Close" : _props$closeButtonTex,
        _props$fullWidth = _props.fullWidth,
        fullWidth = _props$fullWidth === undefined ? false : _props$fullWidth,
        financeOptionText = _props.financeOptionText,
        namePlate = _props.namePlate,
        imageSrc = _props.imageSrc,
        handleClose = _props.handleClose,
        _props$initialLocatio = _props.initialLocations,
        initialLocations = _props$initialLocatio === undefined ? [] : _props$initialLocatio,
        _props$dealersEndPoin = _props.dealersEndPoint,
        dealersEndPoint = _props$dealersEndPoin === undefined ? "/api/dealer-search" : _props$dealersEndPoin,
        _props$dealerSearchEn = _props.dealerSearchEndPoint,
        dealerSearchEndPoint = _props$dealerSearchEn === undefined ? "/api/dealers" : _props$dealerSearchEn;
    var _state = this.state,
        loading = _state.loading,
        success = _state.success,
        errorMessage = _state.errorMessage,
        words = _state.words,
        form = _state.form;


    if (words && words.length > 0) {
      var newForm = form;

      words.map(function (item) {
        if (item === "Name") {
          newForm.firstName.isValid = false;
          newForm.firstName.message = __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PROFANITY_FILTER;
        }
        if (item === "Surname") {
          newForm.lastName.isValid = false;
          newForm.lastName.message = __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PROFANITY_FILTER;
        }
        if (item === "Email") {
          newForm.email.isValid = false;
          newForm.email.message = __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PROFANITY_FILTER;
        }
        if (item === "Mobile") {
          newForm.phone.isValid = false;
          newForm.phone.message = __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PROFANITY_FILTER;
        }
      });
      this.setState({
        form: newForm,
        words: []
      });
    }

    if (success) {
      var _classnames, _classnames2, _classnames3;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__SaveForm_less___default.a.SaveForm] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 222
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__SaveForm_less___default.a.SaveFormForm] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 223
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 224
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_17" /* TickModalIcon */], { style: { width: "2.25em", height: "2.25em", margin: "0 auto" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 225
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["z" /* H2 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 226
                }
              },
              "Success"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], { xmlString: successMessage || "<span>A link to your vehicle" + (Array.isArray(namePlate) && namePlate.length > 1 ? "s" : "") + " was sent to:<br /><strong>" + form.email.value + "</strong></span>", __source: {
                fileName: _jsxFileName,
                lineNumber: 227
              }
            }),
            imageSrc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__SaveForm_less___default.a.SaveFormImage] = true, _classnames3)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 230
                }
              },
              imageSrc.map(function (img, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["o" /* Image */], { key: index, src: img, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 231
                  }
                });
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 234
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              { styleName: "blackOutlined", onClick: handleClose, fullWidth: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 235
                }
              },
              closeButtonText
            )
          )
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__SaveForm_less___default.a.SaveForm] = true, _classnames4)), __source: {
          fileName: _jsxFileName,
          lineNumber: 245
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__SaveForm_less___default.a.SaveFormForm] = true, _classnames5)), __source: {
            fileName: _jsxFileName,
            lineNumber: 246
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { method: "POST", onSubmit: this._handleSubmit, noValidate: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 247
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 248
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["z" /* H2 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 249
                }
              },
              heading
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], { xmlString: description, __source: {
                fileName: _jsxFileName,
                lineNumber: 250
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 251
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 253
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "firstName",
              label: "First Name"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Save Form",
                  pageAction: "Save Form - Entered \"FIRSTNAME\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 254
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 266
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "lastName",
              label: "Last Name"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "lastName"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Save Form",
                  pageAction: "Save Form - Entered \"LASTNAME\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 267
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 279
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["N" /* InputEmail */], _extends({
              name: "email",
              label: "Email"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Save Form",
                  pageAction: "Save Form - Entered \"EMAIL\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 280
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 292
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "phone",
              label: "Mobile"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "phone"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Save Form",
                  pageAction: "Save Form - Entered \"MOBILE\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 293
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["n" /* DealerSearchBoxNZ */], {
            searchType: "SALES",
            noMap: true,
            selectDealerVariant: true,
            selectDealer: this.selectDealer,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 320
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 327
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["h" /* DealerSearch */], _extends({
              dealersEndPoint: dealersEndPoint,
              endpoint: dealerSearchEndPoint,
              disabled: !form.region.value || !(form.region.value.postcode || form.region.value.value),
              type: "Sales",
              name: "preferredDealer",
              postcode: form.region.value && form.region.value.postcode || initialLocations && initialLocations[0] && initialLocations[0].postCode,
              dealerCode: form.region.value && form.region.value.value,
              ref: "dealerSearchComp"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "preferredDealer"), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 328
              }
            }))
          ),
          financeOptionText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { show: true, checkbox: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 342
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
              name: "finance",
              label: financeOptionText
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "finance", function (value) {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "Save Form Form",
                pageAction: "Save Form Form - " + (value ? 'Checked' : 'Unchecked') + " \"FINANCE\""
              });
            }), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 343
              }
            }))
          ),
          financeOptionText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { show: true, checkbox: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 357
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: { height: "1px", width: "100%", border: "0", borderTop: "1px solid #D5D5D5" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 358
              }
            })
          ),
          !financeOptionText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 361
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, show: true, checkbox: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 362
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
              name: "optIn",
              label: optInMessage || "I acknowledge that Mazda or Mazda dealers may send me further information about Mazda products or services."
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "optIn", function (value) {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "Save Form",
                pageAction: "Save Form - " + (value ? 'Checked' : 'Unchecked') + " \"OPT IN\""
              });
            }), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 363
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 374
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, show: true, checkbox: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 375
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
              name: "privacyPolicy",
              label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 379
                  }
                },
                privacyPolicy || "I have read and agree to Mazda New Zealand's ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
                  {
                    href: privacyPolicyLink || "/privacy-policy/",
                    onClick: function onClick() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Save Form",
                        pageAction: "Save Form - Clicked \"PRIVACYPOLICY\""
                      });
                    },
                    external: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 381
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "nobr",
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 390
                      }
                    },
                    "Privacy Policy"
                  )
                )
              )
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "privacyPolicy", function (value) {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "Save Form",
                pageAction: "Save Form - " + (value ? 'Checked' : 'Unchecked') + " \"PRIVACYPOLICY\""
              });
            }), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 376
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 402
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 403
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 404
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 405
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              _extends({ styleName: "black", loading: loading, fullWidth: true }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 406
                }
              }),
              buttonText
            )
          )
        )
      )
    );
  };

  return SaveForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SaveForm.displayName = "SaveForm";


/* harmony default export */ __webpack_exports__["a"] = (SaveForm);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SaveShareCopy_less__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SaveShareCopy_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SaveShareCopy_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__ = __webpack_require__(11);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\SaveShareCopy\\SaveShareCopy.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SaveShareCopy = function (_Component) {
  _inherits(SaveShareCopy, _Component);

  function SaveShareCopy(props) {
    _classCallCheck(this, SaveShareCopy);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._handleClickOnOpeningSaveModal = function () {
      var _this$props$gtmEvents = _this.props.gtmEvents,
          gtmEvents = _this$props$gtmEvents === undefined ? {} : _this$props$gtmEvents;


      _this.setState({ saveFormOpen: true }, function () {
        Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: gtmEvents.category,
          pageAction: gtmEvents.action + " - Clicked \"SAVE\""
        });
      });
    };

    _this.state = {
      saveFormOpen: false,
      shareFormOpen: false,
      showMobileShare: true,
      showTooltipOfSaveInSummary: false
    };
    return _this;
  }

  SaveShareCopy.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        _props$disableSavePro = _props.disableSavePrompt,
        disableSavePrompt = _props$disableSavePro === undefined ? false : _props$disableSavePro,
        _props$delayToShowSav = _props.delayToShowSavePrompt,
        delayToShowSavePrompt = _props$delayToShowSav === undefined ? 1000 : _props$delayToShowSav,
        _props$delayToCloseSa = _props.delayToCloseSavePrompt,
        delayToCloseSavePrompt = _props$delayToCloseSa === undefined ? 3000 : _props$delayToCloseSa,
        enabled = _props.enabled;
    var showTooltipOfSaveInSummary = this.state.showTooltipOfSaveInSummary;

    if (!disableSavePrompt && enabled && !showTooltipOfSaveInSummary) {
      setTimeout(function () {
        _this2.setState({
          showTooltipOfSaveInSummary: true
        }, function () {
          setTimeout(function () {
            _this2.setState({
              showTooltipOfSaveInSummary: false
            });
          }, delayToCloseSavePrompt);
        });
      }, delayToShowSavePrompt);
    }
  };

  SaveShareCopy.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this3 = this;

    var _props2 = this.props,
        enabled = _props2.enabled,
        _props2$disableSavePr = _props2.disableSavePrompt,
        disableSavePrompt = _props2$disableSavePr === undefined ? false : _props2$disableSavePr,
        _props2$delayToShowSa = _props2.delayToShowSavePrompt,
        delayToShowSavePrompt = _props2$delayToShowSa === undefined ? 1000 : _props2$delayToShowSa,
        _props2$delayToCloseS = _props2.delayToCloseSavePrompt,
        delayToCloseSavePrompt = _props2$delayToCloseS === undefined ? 3000 : _props2$delayToCloseS;
    var showTooltipOfSaveInSummary = this.state.showTooltipOfSaveInSummary;

    if (prevProps.enabled != enabled && !disableSavePrompt && enabled && !showTooltipOfSaveInSummary) {
      setTimeout(function () {
        _this3.setState({
          showTooltipOfSaveInSummary: true
        }, function () {
          setTimeout(function () {
            _this3.setState({
              showTooltipOfSaveInSummary: false
            });
          }, delayToCloseSavePrompt);
        });
      }, delayToShowSavePrompt);
    }
  };

  SaveShareCopy.prototype.render = function render() {
    var _classnames,
        _classnames2,
        _this4 = this,
        _classnames3,
        _React$createElement,
        _classnames4,
        _classnames5,
        _React$createElement2;

    var _props3 = this.props,
        _props3$enabled = _props3.enabled,
        enabled = _props3$enabled === undefined ? true : _props3$enabled,
        descriptionSave = _props3.descriptionSave,
        descriptionShare = _props3.descriptionShare,
        locationState = _props3.locationState,
        imageSrc = _props3.imageSrc,
        namePlate = _props3.namePlate,
        bodyStyle = _props3.bodyStyle,
        safetyModelExcess = _props3.safetyModelExcess,
        compareUrl = _props3.compareUrl,
        saveEndPoint = _props3.saveEndPoint,
        shareEndPoint = _props3.shareEndPoint,
        findDealerUrl = _props3.findDealerUrl,
        financeOptionText = _props3.financeOptionText,
        gtmEvents = _props3.gtmEvents;
    var showTooltipOfSaveInSummary = this.state.showTooltipOfSaveInSummary;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        "data-test": "save-share",
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_4__SaveShareCopy_less___default.a.ShareSection] = true, _classnames[__WEBPACK_IMPORTED_MODULE_4__SaveShareCopy_less___default.a.ShareSectionDisabled] = !enabled, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 99
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_4__SaveShareCopy_less___default.a.ShareSectionColumn] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 105
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          (_React$createElement = {
            onClick: function onClick() {
              _this4.setState({ saveFormOpen: true });
              Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: gtmEvents.category,
                pageAction: gtmEvents.action + " - Clicked \"SAVE\""
              });
            },
            key: "SavePart",
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_4__SaveShareCopy_less___default.a.ShareSectionText] = true, _classnames3))
          }, _React$createElement["key"] = "SaveText", _React$createElement.__source = {
            fileName: _jsxFileName,
            lineNumber: 106
          }, _React$createElement),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_6" /* SaveIcon */], {
            style: { width: "22px", height: "22px", margin: "0 8px 0 0" },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 117
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 120
              }
            },
            "SAVE"
          )
        ),
        showTooltipOfSaveInSummary && enabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["J" /* Tooltip */],
          { position: "bottomLeft", __source: {
              fileName: _jsxFileName,
              lineNumber: 123
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { letterSpacing: 0 }, __source: {
                fileName: _jsxFileName,
                lineNumber: 124
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
              { withoutMargin: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 125
                }
              },
              "You can now ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
                { onClick: this._handleClickOnOpeningSaveModal, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 126
                  }
                },
                " save your ",
                namePlate && namePlate.length === 2 ? namePlate[0] + " and " + namePlate[1] : "cars",
                " "
              ),
              " for future reference."
            )
          )
        )
      ),
      this.state.saveFormOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["Z" /* Modal */],
        {
          width: "600px",
          handleClose: function handleClose() {
            _this4.setState({ saveFormOpen: false });
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["D" /* SaveForm */], {
          endPoint: saveEndPoint,
          description: descriptionSave,
          location: locationState,
          imageSrc: imageSrc,
          namePlate: namePlate,
          bodyStyle: bodyStyle,
          safetyModelExcess: safetyModelExcess,
          financeOptionText: financeOptionText,
          compareUrl: compareUrl,
          findDealerUrl: findDealerUrl,
          gtmEvents: gtmEvents,
          fullWidth: true,
          handleClose: function handleClose() {
            _this4.setState({ saveFormOpen: false });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 139
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_4__SaveShareCopy_less___default.a.ShareSectionColumn] = true, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 158
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          (_React$createElement2 = {
            onClick: function onClick() {
              _this4.setState({ shareFormOpen: true });
              !__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["g" /* IS_MOBILE */] && Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: gtmEvents.category,
                pageAction: gtmEvents.action + " - Clicked \"SHARE\""
              });
            },
            key: "SharePart",
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_4__SaveShareCopy_less___default.a.ShareSectionText] = true, _classnames5))
          }, _React$createElement2["key"] = "ShareText", _React$createElement2.__source = {
            fileName: _jsxFileName,
            lineNumber: 159
          }, _React$createElement2),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_10" /* ShareIcon */], {
            style: { width: "22px", height: "22px", margin: "0 8px 0 0" },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 171
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 174
              }
            },
            "SHARE"
          )
        )
      ),
      this.state.shareFormOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["Z" /* Modal */],
        {
          width: "600px",
          handleClose: function handleClose() {
            _this4.setState({
              shareFormOpen: false,
              showShareForm: false,
              showMobileShare: true
            });
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 179
          }
        },
        __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["g" /* IS_MOBILE */] && this.state.showMobileShare && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers__["B" /* MobileShare */], {
          mobileDescription: "How would you like to share your Mazda comparision?",
          description: "Check out the " + (namePlate && namePlate.length === 2 ? namePlate[0] + " and " + namePlate[1] : "cars") + " I compared: ",
          EmailShareFunc: function EmailShareFunc() {
            _this4.setState({
              showShareForm: true,
              showMobileShare: false
            });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 190
          }
        }),
        (!__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["g" /* IS_MOBILE */] || this.state.showShareForm) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["F" /* ShareForm */], {
          endPoint: shareEndPoint,
          description: descriptionShare,
          location: locationState,
          imageSrc: imageSrc,
          namePlate: namePlate,
          bodyStyle: bodyStyle,
          safetyModelExcess: safetyModelExcess,
          compareUrl: compareUrl,
          findDealerUrl: findDealerUrl,
          gtmEvents: gtmEvents,
          fullWidth: true,
          handleClose: function handleClose() {
            _this4.setState({ shareFormOpen: false });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 206
          }
        })
      )
    );
  };

  return SaveShareCopy;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SaveShareCopy.displayName = "SaveShareCopy";


/* harmony default export */ __webpack_exports__["a"] = (SaveShareCopy);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShareForm_less__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShareForm_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ShareForm_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\ShareForm\\ShareForm.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-deprecated */












var ShareForm = function (_React$Component) {
  _inherits(ShareForm, _React$Component);

  function ShareForm(props) {
    var _this2 = this;

    _classCallCheck(this, ShareForm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _this$props, endPoint, namePlate, bodyStyle, _this$props$location, location, _this$props$safetyMod, safetyModelExcess, buildUrl, findDealerUrl, compareUrl, form, recipients;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this$props = _this.props, endPoint = _this$props.endPoint, namePlate = _this$props.namePlate, bodyStyle = _this$props.bodyStyle, _this$props$location = _this$props.location, location = _this$props$location === undefined ? {} : _this$props$location, _this$props$safetyMod = _this$props.safetyModelExcess, safetyModelExcess = _this$props$safetyMod === undefined ? null : _this$props$safetyMod, buildUrl = _this$props.buildUrl, findDealerUrl = _this$props.findDealerUrl, compareUrl = _this$props.compareUrl;
                          form = _this.state.form;
                          recipients = [];

                          _this.state.recipients.map(function (item, index) {
                            recipients.push({
                              firstName: form["recipient" + item + "firstName"].value,
                              email: form["recipient" + item + "email"].value
                            });
                          });
                          _context2.next = 6;
                          return Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: endPoint,
                            body: {
                              sender: {
                                email: form.email.value,
                                firstName: form.firstName.value
                              },
                              message: form.message.value,
                              // postcode: form.postcode.value.postcode || location.postcode || "",
                              namePlate: namePlate,
                              bodyStyle: bodyStyle,
                              recipients: recipients,
                              safetyModelExcess: safetyModelExcess,
                              buildUrl: buildUrl,
                              findDealerUrl: findDealerUrl,
                              compareUrl: compareUrl,
                              optedInDealer: form.optIn.value,
                              dealerCode: form.preferredDealer.value.dealerCode,
                              dealerPostCode: form.preferredDealer.value.postCode,
                              state: form.preferredDealer.value.state || localStorage.getItem('selectedRegion') || ''
                            }
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg, words;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg, words = json.words;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          words: words && words.split(",") || [],
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: (_this.props.gtmEvents ? _this.props.gtmEvents.category + " | " : "") + "Share Form",
                                            pageAction: (_this.props.gtmEvents ? _this.props.gtmEvents.action + " - " : "") + "Clicked \"SEND\" - Successfully submitted."
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              words: response.words && response.words.split(",") || [],
                              loading: false
                            });
                          });

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.selectDealer = function (dealer) {
      // no search, use the selected dealer only for the radio inputs
      // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
      _this.refs.dealerSearchComp.setState({
        dealers: [dealer],
        selected: dealer,
        loading: false
      });
    };

    _this.state = {
      form: {
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        // postcode: {
        //   validations: {
        //     required: MESSAGES.ADDRESS1_REQUIRED
        //   }
        // },
        region: {
          validations: {}
        },
        preferredDealer: {
          validations: {}
        },
        message: {
          validations: {}
        },
        optIn: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].OPTIN_REQUIRED
          }
        },
        recipient0firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        recipient0email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        privacyPolicy: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      recipients: [0],
      success: false,
      errorMessage: null
    };
    return _this;
  }

  ShareForm.prototype.componentDidMount = function componentDidMount() {
    var location = this.props.location;


    if (location && location.postcode) {
      Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
        postcode: location.postcode
      });
    }
  };

  ShareForm.prototype.recipient = function recipient(id, index) {
    var _classnames,
        _this3 = this;

    var fullWidth = this.props.fullWidth;
    var _state = this.state,
        form = _state.form,
        recipients = _state.recipients;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { key: id, __source: {
          fileName: _jsxFileName,
          lineNumber: 178
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 179
          }
        },
        id !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__ShareForm_less___default.a.ShareFormTrigger] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__ShareForm_less___default.a.floating] = true, _classnames)),
            onClick: function onClick() {
              var newRecipientArray = recipients.filter(function (item) {
                return item !== id;
              });
              var newForm = form;
              delete newForm["recipient" + id + "firstName"];
              delete newForm["recipient" + id + "email"];

              _this3.setState({
                recipients: newRecipientArray,
                fields: newForm
              });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 182
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_4" /* RemoveCircleIcon */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 198
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_21" /* Visible */],
            { visible: ["screen"], __source: {
                fileName: _jsxFileName,
                lineNumber: 199
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 200
                }
              },
              "Remove"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["B" /* H4 */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 206
            }
          },
          "RECIPIENT ",
          index + 1
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 208
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
          name: "recipient" + id + "firstName",
          label: "First Name"
        }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "recipient" + id + "firstName"), {
          onBlur: function onBlur() {
            Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
              pageCategory: "Share Form",
              pageAction: "Share Form - Entered \"FIRSTNAME\""
            });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 209
          }
        }))
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
        { fullWidth: fullWidth, __source: {
            fileName: _jsxFileName,
            lineNumber: 221
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["N" /* InputEmail */], _extends({
          name: "recipient" + id + "email",
          label: "Email"
        }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "recipient" + id + "email"), {
          onBlur: function onBlur() {
            Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
              pageCategory: "Share Form",
              pageAction: "Share Form - Entered \"EMAIL\""
            });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 222
          }
        }))
      )
    );
  };

  ShareForm.prototype.render = function render() {
    var _classnames5,
        _classnames6,
        _this4 = this,
        _classnames7;

    var _props = this.props,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Send" : _props$buttonText,
        _props$heading = _props.heading,
        heading = _props$heading === undefined ? "Share" : _props$heading,
        imageSrc = _props.imageSrc,
        namePlate = _props.namePlate,
        description = _props.description,
        optInMessage = _props.optInMessage,
        privacyPolicy = _props.privacyPolicy,
        privacyPolicyLink = _props.privacyPolicyLink,
        successMessage = _props.successMessage,
        _props$closeButtonTex = _props.closeButtonText,
        closeButtonText = _props$closeButtonTex === undefined ? "Close" : _props$closeButtonTex,
        _props$fullWidth = _props.fullWidth,
        fullWidth = _props$fullWidth === undefined ? false : _props$fullWidth,
        handleClose = _props.handleClose,
        _props$initialLocatio = _props.initialLocations,
        initialLocations = _props$initialLocatio === undefined ? [] : _props$initialLocatio,
        _props$dealersEndPoin = _props.dealersEndPoint,
        dealersEndPoint = _props$dealersEndPoin === undefined ? "/api/dealer-search" : _props$dealersEndPoin,
        _props$dealerSearchEn = _props.dealerSearchEndPoint,
        dealerSearchEndPoint = _props$dealerSearchEn === undefined ? "/api/dealers" : _props$dealerSearchEn;
    var _state2 = this.state,
        loading = _state2.loading,
        success = _state2.success,
        errorMessage = _state2.errorMessage,
        recipients = _state2.recipients,
        form = _state2.form,
        words = _state2.words;


    if (words && words.length > 0) {
      var newForm = form;

      words.map(function (item) {
        if (item === "FirstName") {
          newForm.firstName.isValid = true;
          newForm.firstName.message = __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PROFANITY_FILTER;
        }
        if (item === "Message") {
          newForm.message.isValid = true;
          newForm.message.message = __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PROFANITY_FILTER;
        }
        if (item === "Email") {
          newForm.email.isValid = true;
          newForm.email.message = __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PROFANITY_FILTER;
        }
        // Looking for recipients
        var recipient = item.split(".");
        if (recipient[0] && recipient[0].includes("Recipient")) {
          var recipientsNumber = Number(recipient[0].replace("Recipient", "")) - 1;

          newForm["recipient" + recipientsNumber + (recipient[1] === "Email" ? "email" : "firstName")].isValid = true;
          newForm["recipient" + recipientsNumber + (recipient[1] === "Email" ? "email" : "firstName")].message = __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PROFANITY_FILTER;
        }
      });
      this.setState({
        form: newForm,
        words: []
      });
    }

    if (success) {
      var _classnames2, _classnames3, _classnames4;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__ShareForm_less___default.a.ShareForm] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 301
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__ShareForm_less___default.a.ShareFormForm] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 302
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 303
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_17" /* TickModalIcon */], { style: { width: "2.25em", height: "2.25em", margin: "0 auto" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 304
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["z" /* H2 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 305
                }
              },
              "Success"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], {
              xmlString: successMessage || "A link to your vehicle" + (Array.isArray(namePlate) && namePlate.length > 1 ? "s" : "") + " was sent to:<br />\n                  " + recipients.map(function (item) {
                return "\n                        <strong>\n                          " + form["recipient" + item + "email"].value + "\n                        </strong>\n                      ";
              }).reduce(function (output, recipient, index) {
                return "\n                      <span>" + output + " " + (index > 0 ? " and " : "") + " " + recipient + "</span>";
              }, "<span />"), __source: {
                fileName: _jsxFileName,
                lineNumber: 306
              }
            }),
            imageSrc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__ShareForm_less___default.a.ShareFormImage] = true, _classnames4)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 324
                }
              },
              imageSrc.map(function (img, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["o" /* Image */], { key: index, src: img, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 325
                  }
                });
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 328
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              { styleName: "blackOutlined", onClick: handleClose, fullWidth: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 329
                }
              },
              closeButtonText
            )
          )
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__ShareForm_less___default.a.ShareForm] = true, _classnames5)), __source: {
          fileName: _jsxFileName,
          lineNumber: 339
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__ShareForm_less___default.a.ShareFormForm] = true, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 340
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { method: "POST", onSubmit: this._handleSubmit, noValidate: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 341
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 342
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["z" /* H2 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 343
                }
              },
              heading
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], { xmlString: description, __source: {
                fileName: _jsxFileName,
                lineNumber: 344
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 345
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 347
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "firstName",
              label: "First Name"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Share Form",
                  pageAction: "Share Form - Entered \"FIRSTNAME\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 348
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 360
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["N" /* InputEmail */], _extends({
              name: "email",
              label: "Email"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Share Form",
                  pageAction: "Share Form - Entered \"EMAIL\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 361
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["n" /* DealerSearchBoxNZ */], {
            searchType: "SALES",
            noMap: true,
            selectDealerVariant: true,
            selectDealer: this.selectDealer,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 389
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 396
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["h" /* DealerSearch */], _extends({
              dealersEndPoint: dealersEndPoint,
              endpoint: dealerSearchEndPoint,
              disabled: !form.region.value || !(form.region.value.postcode || form.region.value.value),
              type: "Sales",
              name: "preferredDealer",
              postcode: form.region.value && form.region.value.postcode || initialLocations && initialLocations[0] && initialLocations[0].postCode,
              dealerCode: form.region.value && form.region.value.value,
              ref: "dealerSearchComp"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "preferredDealer"), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 397
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 409
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "message",
              label: "Your message"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "message"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Share Form",
                  pageAction: "Share Form - Entered \"MESSAGE\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 410
              }
            }))
          ),
          recipients.map(function (recipient, index) {
            return _this4.recipient(recipient, index);
          }),
          recipients.length < 5 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 429
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_2__ShareForm_less___default.a.ShareFormTrigger] = true, _classnames7)),
                onClick: function onClick() {
                  var newForm = form;
                  newForm["recipient" + (recipients[recipients.length - 1] + 1) + "firstName"] = {
                    validations: {
                      required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
                    }
                  };
                  newForm["recipient" + (recipients[recipients.length - 1] + 1) + "email"] = {
                    validations: {
                      required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
                      email: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
                    }
                  };
                  var newRecipientArray = recipients;
                  newRecipientArray.push(recipients[recipients.length - 1] + 1);
                  _this4.setState({
                    form: newForm,
                    recipients: newRecipientArray
                  });
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 430
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_3" /* PlusCircleIcon */], {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 452
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 453
                  }
                },
                "Add another recipient"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, show: true, checkbox: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 459
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
              name: "optIn",
              label: optInMessage || "I acknowledge that Mazda or Mazda dealers may send me further information about Mazda products or services."
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "optIn", function () {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "Share Form",
                pageAction: "Share Form - checked \"Opt in\""
              });
            }), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 460
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 471
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, show: true, checkbox: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 472
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
              name: "privacyPolicy",
              label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 476
                  }
                },
                privacyPolicy || "I have read and agree to Mazda New Zealand's ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
                  {
                    href: privacyPolicyLink || "/privacy-policy/",
                    onClick: function onClick() {
                      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "Share Form",
                        pageAction: "Share Form - Clicked \"PRIVACYPOLICY\""
                      });
                    },
                    external: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 478
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "nobr",
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 487
                      }
                    },
                    "Privacy Policy"
                  )
                )
              )
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "privacyPolicy", function () {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "Share Form",
                pageAction: "Share Form - checked \"Privacy policy\""
              });
            }), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 473
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 499
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 500
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { fullWidth: fullWidth, __source: {
                fileName: _jsxFileName,
                lineNumber: 501
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 502
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              _extends({ styleName: "black", loading: loading, fullWidth: true }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 503
                }
              }),
              buttonText
            )
          )
        )
      )
    );
  };

  return ShareForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ShareForm.displayName = "ShareForm";


/* harmony default export */ __webpack_exports__["a"] = (ShareForm);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\SixtyFourtyBlock\\SixtyFourtyBlock.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SixtyFourtyBlock = function (_React$PureComponent) {
  _inherits(SixtyFourtyBlock, _React$PureComponent);

  function SixtyFourtyBlock() {
    var _temp, _this, _ret;

    _classCallCheck(this, SixtyFourtyBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._renderImage = function () {
      var _classnames, _classnames2;

      var _this$props = _this.props,
          imageUrl = _this$props.imageUrl,
          _this$props$size = _this$props.size,
          size = _this$props$size === undefined ? "disable" : _this$props$size,
          _this$props$overlay = _this$props.overlay,
          overlay = _this$props$overlay === undefined ? false : _this$props$overlay;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default.a.Media] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default.a.MediaImage] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default.a.MediaImageLarge] = size === "large", _classnames2[__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default.a.MediaImageMedium] = size === "medium", _classnames2[__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default.a.MediaImageSmall] = size === "small", _classnames2[__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default.a.MediaImageInitial] = overlay, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 17
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["o" /* Image */], { src: imageUrl, __source: {
              fileName: _jsxFileName,
              lineNumber: 25
            }
          })
        )
      );
    }, _this._renderVideo = function () {
      var _classnames3;

      var _this$props2 = _this.props,
          imageUrl = _this$props2.imageUrl,
          videoUrl = _this$props2.videoUrl;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default.a.Media] = true, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 34
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["K" /* VideoPlayer */], { src: videoUrl, poster: imageUrl, __source: {
            fileName: _jsxFileName,
            lineNumber: 38
          }
        })
      );
    }, _this._renderContent = function () {
      var _classnames4;

      var _this$props3 = _this.props,
          heading = _this$props3.heading,
          blurb = _this$props3.blurb,
          textAlign = _this$props3.textAlign,
          _this$props3$componen = _this$props3.components,
          components = _this$props3$componen === undefined ? [] : _this$props3$componen,
          children = _this$props3.children;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default.a.Content] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default.a.ContentCenter] = textAlign === "center", _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          }
        },
        heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["A" /* H3 */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 51
            }
          },
          heading
        ),
        blurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["t" /* Content */], { xmlString: blurb, textAlign: textAlign, __source: {
            fileName: _jsxFileName,
            lineNumber: 52
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 53
          }
        }),
        Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(components) || children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SixtyFourtyBlock.prototype.render = function render() {
    var _classnames5;

    var _props = this.props,
        _props$imagePosition = _props.imagePosition,
        imagePosition = _props$imagePosition === undefined ? "left" : _props$imagePosition,
        _props$imagePositionM = _props.imagePositionMobile,
        imagePositionMobile = _props$imagePositionM === undefined ? false : _props$imagePositionM,
        _props$ratio = _props.ratio,
        ratio = _props$ratio === undefined ? 60 : _props$ratio,
        videoUrl = _props.videoUrl,
        backgroundColor = _props.backgroundColor,
        size = _props.size;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["r" /* ColumnGroup */],
      {
        sizes: [Number(ratio), 100 - Number(ratio)],
        size: size,
        backgroundColor: backgroundColor,
        reverseOnDesktop: imagePosition === "right",
        reverseOnMobile: !imagePositionMobile,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_5__SixtyFourtyBlock_less___default.a.ColumnParent] = true, _classnames5)),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 77
          }
        },
        !videoUrl && this._renderImage(),
        videoUrl && this._renderVideo()
      ),
      this._renderContent()
    );
  };

  return SixtyFourtyBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

SixtyFourtyBlock.displayName = "SixtyFourtyBlock";


/* harmony default export */ __webpack_exports__["a"] = (SixtyFourtyBlock);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_fetchAPI__ = __webpack_require__(21);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\SpecificationsBlock\\SpecificationsBlock.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SpecificationsBlock = function (_React$Component) {
  _inherits(SpecificationsBlock, _React$Component);

  function SpecificationsBlock(props) {
    var _this2 = this;

    _classCallCheck(this, SpecificationsBlock);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleChange = function (_ref) {
      var _ref$bodystyle = _ref.bodystyle,
          bodystyle = _ref$bodystyle === undefined ? "" : _ref$bodystyle,
          _ref$drivetrain = _ref.drivetrain,
          drivetrain = _ref$drivetrain === undefined ? "" : _ref$drivetrain,
          _ref$grade = _ref.grade,
          grade = _ref$grade === undefined ? "" : _ref$grade,
          _ref$nameplate = _ref.nameplate,
          nameplate = _ref$nameplate === undefined ? "" : _ref$nameplate,
          _ref$isSafetyModel = _ref.isSafetyModel,
          isSafetyModel = _ref$isSafetyModel === undefined ? false : _ref$isSafetyModel;
      var specsApiEndpoint = _this.props.specsApiEndpoint;

      _this.setState({
        loading: true,
        categories: null,
        disclaimers: null
      }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_fetchAPI__["a" /* default */])({
                  method: "POST",
                  url: specsApiEndpoint,
                  body: {
                    bodystyle: bodystyle,
                    drivetrain: drivetrain,
                    grade: grade,
                    nameplate: nameplate,
                    isSafetyModel: isSafetyModel
                  }
                }).then(function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                    var json, success, errorMsg, data;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return response.json();

                          case 2:
                            json = _context.sent;
                            success = json.success, errorMsg = json.errorMsg;

                            if (!success) {
                              _this.setState({
                                errorMessage: errorMsg,
                                loading: false
                              });
                            } else {
                              // successful
                              data = json.data;

                              _this.setState({
                                loading: false,
                                success: true,
                                categories: data.categories,
                                disclaimers: data.disclaimers
                              });
                            }

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }()).catch(function () {
                  _this.setState({
                    loading: false
                  });
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      })));
    };

    _this._handleOpeningDisclaimer = function (uniqueNumber) {
      _this.setState({
        activeDisclaimerCode: uniqueNumber
      });
    };

    _this.state = {
      loading: false,
      disclaimers: null,
      categories: null,
      activeDisclaimerCode: null
    };
    return _this;
  }

  SpecificationsBlock.prototype.render = function render() {
    var _classnames,
        _this3 = this;

    var _props = this.props,
        gradePickerData = _props.gradePickerData,
        heading = _props.heading,
        safetyModelBlurb = _props.safetyModelBlurb,
        safetyModelExcess = _props.safetyModelExcess,
        safetyModelDisclaimer = _props.safetyModelDisclaimer;
    var _state = this.state,
        categories = _state.categories,
        loading = _state.loading,
        activeDisclaimerCode = _state.activeDisclaimerCode;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less___default.a.SpecificationsBlock] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 82
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["l" /* GradePicker */], {
        heading: heading,
        data: gradePickerData,
        onChange: this._handleChange,
        safetyModelBlurb: safetyModelBlurb,
        safetyModelExcess: safetyModelExcess,
        safetyModelDisclaimer: safetyModelDisclaimer,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 93
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
        { sizeName: "screen", horizontalPadding: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 94
          }
        },
        !loading && categories && categories.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["c" /* AccordionTextList */], {
          styleName: "box",
          data: categories.map(function (category, categoryIndex) {
            return {
              title: category.name,
              description: category.items.map(function (singleItem, singleItemIndex) {
                var _classnames2, _classnames3, _classnames4;

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    key: "singleItemIndex-" + categoryIndex + "-" + singleItemIndex,
                    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less___default.a.Description] = true, _classnames2)), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 102
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less___default.a.DescriptionName] = true, _classnames3)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 107
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["D" /* H6 */],
                      { withDetails: true, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 110
                        }
                      },
                      singleItem.name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 113
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less___default.a.DescriptionContent] = true, _classnames4)), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 115
                      }
                    },
                    singleItem.items.map(function (singleSpecs, singleSpecsIndex) {
                      var _classnames5, _classnames6, _classnames7, _classnames8;

                      var uniqueNumber = categoryIndex * 1000000 + singleItemIndex * 10000 + singleSpecsIndex * 100;
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        {
                          key: uniqueNumber,
                          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less___default.a.DescriptionSingleSpecs] = true, _classnames5)), __source: {
                            fileName: _jsxFileName,
                            lineNumber: 121
                          }
                        },
                        singleSpecs && (!singleSpecs.disclaimer || !singleSpecs.disclaimer.disclaimerCode) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "div",
                          {
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 127
                            }
                          },
                          singleSpecs.key,
                          " ",
                          singleSpecs.content && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "span",
                            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less___default.a.GreyDark] = true, _classnames6)), __source: {
                                fileName: _jsxFileName,
                                lineNumber: 128
                              }
                            },
                            singleSpecs.content
                          )
                        ),
                        singleSpecs && singleSpecs.disclaimer && singleSpecs.disclaimer.disclaimerCode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "span",
                          {
                            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less___default.a.DescriptionSingleSpecsDisclaimer] = true, _classnames7)),
                            onClick: function onClick() {
                              return _this3._handleOpeningDisclaimer(uniqueNumber);
                            },
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 134
                            }
                          },
                          singleSpecs.key,
                          " ",
                          singleSpecs.content && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "span",
                            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_2__SpecificationsBlock_less___default.a.GreyDark] = true, _classnames8)), __source: {
                                fileName: _jsxFileName,
                                lineNumber: 140
                              }
                            },
                            singleSpecs.content
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["i" /* Disclaimer */],
                            {
                              key: "Disclaimer-" + uniqueNumber,
                              text: singleSpecs.disclaimer.disclaimerCode,
                              show: activeDisclaimerCode === uniqueNumber,
                              __source: {
                                fileName: _jsxFileName,
                                lineNumber: 143
                              }
                            },
                            singleSpecs.disclaimer.disclaimerText
                          )
                        )
                      );
                    })
                  )
                );
              })
            };
          }), __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          }
        }),
        loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["W" /* LoadingSection */], { visible: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 161
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 163
        }
      })
    );
  };

  return SpecificationsBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SpecificationsBlock.displayName = "SpecificationsBlock";


/* harmony default export */ __webpack_exports__["a"] = (SpecificationsBlock);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_scroll__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StickyNav_less__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StickyNav_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__StickyNav_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\StickyNav\\StickyNav.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var StickyNav = function (_React$Component) {
  _inherits(StickyNav, _React$Component);

  function StickyNav(props) {
    _classCallCheck(this, StickyNav);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.scrollToHash = function () {
      var activeHash = _this.state.activeHash;

      var hash = new __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].location.href).getHash();
      if (hash && activeHash !== hash) Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_scroll__["a" /* scrollToElementId */])(hash);
    };

    _this.checkPageOffset = function () {
      if (__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].stickyBar) {
        var items = _this.props.items;
        var height = _this.state.height;

        var pageOffset = __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].pageYOffset;
        _this.setState({ pageOffset: pageOffset });

        items && items.map(function (item, index) {
          var element = __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].document.querySelector("[data-name=\"" + item.slug + "\"]");

          if (element) {
            var elementOffset = element.offsetTop;

            if (elementOffset <= pageOffset + height && elementOffset + element.clientHeight > pageOffset + height + 50) {
              new __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].location.href).setHash(item.slug);
              _this.setState({ activeIndex: index, activeHash: item.slug });
            }
          }
        });

        return pageYOffset;
      }
    };

    _this.handleClick = function (index) {
      var _this$props = _this.props,
          items = _this$props.items,
          gtm = _this$props.gtm;

      // Delay for firing GTM before redirection
      // Call GTM if we have an gtm object

      if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
        Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: gtm.category,
          pageAction: gtm.action + (" - \"" + items[index].name.toUpperCase() + "\"")
        });
      }

      Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_scroll__["a" /* scrollToElementId */])(items[index].slug);
    };

    _this._handleClickOnLogo = function () {
      Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_scroll__["a" /* scrollToElementId */])('header');
    };

    _this.state = {
      height: 60,
      pageOffset: 0,
      activeIndex: 0,
      isIE: false
    };
    return _this;
  }

  StickyNav.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.stickyNav) {
      this.setState({
        height: this.stickyNav.clientHeight
      });
    }

    __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("scroll", __WEBPACK_IMPORTED_MODULE_2_debounce___default()(this.checkPageOffset, 250), {
      passive: true
    });

    __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("hashchange", __WEBPACK_IMPORTED_MODULE_2_debounce___default()(this.scrollToHash, 400), {
      passive: true
    });

    setTimeout(this.checkPageOffset, 0);
    setTimeout(function () {
      _this2.setState({
        isIE: __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["d" /* IS_IE */]
      });
    }, 0);

    __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("UPDATE_STICKY_NAV", function () {
      return _this2.checkPageOffset();
    }, false);
  };

  StickyNav.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("scroll", __WEBPACK_IMPORTED_MODULE_2_debounce___default()(this.checkPageOffset, 250), {
      passive: true
    });

    __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("hashchange", __WEBPACK_IMPORTED_MODULE_2_debounce___default()(this.scrollToHash, 250), {
      passive: true
    });
  };

  StickyNav.prototype.render = function render() {
    var _this3 = this,
        _classnames,
        _classnames2,
        _classnames3,
        _classnames4;

    var _props = this.props,
        logo = _props.logo,
        imageAlt = _props.imageAlt,
        items = _props.items,
        components = _props.components;
    var _state = this.state,
        activeIndex = _state.activeIndex,
        isIE = _state.isIE;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_15" /* StickySection */],
      { alwaysOnTop: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 120
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          ref: function ref(c) {
            return _this3.stickyNav = c;
          },
          id: "sticky-nav",
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_10__StickyNav_less___default.a.StickyNav] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 121
          }
        },
        logo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_10__StickyNav_less___default.a.StickyNavImage] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_10__StickyNav_less___default.a.StickyNavImageIE] = isIE, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 129
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["k" /* ButtonIcon */],
            {
              onClick: this._handleClickOnLogo,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 133
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
              src: logo,
              alt: imageAlt,
              height: "25",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 136
              }
            })
          )
        ),
        items && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_10__StickyNav_less___default.a.StickyNavItems] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 146
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["I" /* Tabs */], {
            options: items,
            scrolling: true,
            activeLineOnly: true,
            onClick: this.handleClick,
            activeIndex: activeIndex,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 149
            }
          })
        ),
        components && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_10__StickyNav_less___default.a.StickyNavButton] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 160
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_componentParser__["a" /* default */])(components)
        )
      )
    );
  };

  return StickyNav;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

StickyNav.displayName = "StickyNav";


/* harmony default export */ __webpack_exports__["a"] = (StickyNav);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VehicleNotFoundPage_less__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VehicleNotFoundPage_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VehicleNotFoundPage_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__ = __webpack_require__(14);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\VehicleNotFoundPage\\VehicleNotFoundPage.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var VehicleNotFoundPage = function (_React$Component) {
  _inherits(VehicleNotFoundPage, _React$Component);

  function VehicleNotFoundPage() {
    _classCallCheck(this, VehicleNotFoundPage);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  VehicleNotFoundPage.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        heading = _props.heading,
        description = _props.description,
        vehicles = _props.vehicles,
        _props$ctas = _props.ctas,
        ctas = _props$ctas === undefined ? [] : _props$ctas;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
      { horizontalPadding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      (heading || description) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["n" /* HeroContent */], {
        heading: heading,
        description: description,
        Icon: __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["d" /* AlertIcon */],
        iconColor: 'red',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 18
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__VehicleNotFoundPage_less___default.a.VehicleNotFoundPage] = true, _classnames)),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          }
        },
        vehicles && vehicles.map(function (vehicle) {
          var _classnames2;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__VehicleNotFoundPage_less___default.a.VehicleNotFoundPageVehicle] = true, _classnames2)),
              __source: {
                fileName: _jsxFileName,
                lineNumber: 32
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], { src: vehicle.imageSrc, height: 100, __source: {
                fileName: _jsxFileName,
                lineNumber: 37
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 38
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 39
                }
              },
              vehicle.ctas && Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])(vehicle.ctas)
            )
          );
        })
      ),
      ctas && Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])(ctas),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 47
        }
      })
    );
  };

  return VehicleNotFoundPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

VehicleNotFoundPage.displayName = "VehicleNotFoundPage";


/* harmony default export */ __webpack_exports__["a"] = (VehicleNotFoundPage);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VideoPlayer_less__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VideoPlayer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__VideoPlayer_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_debounce__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_checkVisible__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\VideoPlayer\\VideoPlayer.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var VideoPlayer = function (_React$PureComponent) {
  _inherits(VideoPlayer, _React$PureComponent);

  function VideoPlayer(props) {
    _classCallCheck(this, VideoPlayer);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._handleSound = function () {
      var muted = _this.state.muted;

      _this.setState({
        muted: !muted
      });
    };

    _this._showOrHide = function () {
      var visible = _this.state.visible;
      var _this$props = _this.props,
          _this$props$getRef = _this$props.getRef,
          getRef = _this$props$getRef === undefined ? function () {} : _this$props$getRef,
          src = _this$props.src;

      if (_this.videoParent) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_checkVisible__["a" /* default */])(_this.videoParent) && !visible) {
          _this.setState({
            visible: true,
            opacity: 0
          }, function () {
            getRef(_this.video);
            setTimeout(function () {
              _this.setState({
                opacity: 1
              });
            }, 200);
          });
        }
        if (_this.video && src) {
          var isPlaying = _this.video.currentTime > 0 && !_this.video.paused && !_this.video.ended && _this.video.readyState > 2;
          if (Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_checkVisible__["a" /* default */])(_this.video)) {
            if (!isPlaying) _this.video.play();
          } else {
            if (isPlaying) _this.video.pause();
          }
        }
      }
    };

    _this.state = {
      muted: true,
      visible: props.visible || false,
      opacity: props.visible ? 1 : 0,
      height: props.height || 400
    };
    return _this;
  }

  VideoPlayer.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        _props$getRef = _props.getRef,
        getRef = _props$getRef === undefined ? function () {} : _props$getRef,
        visible = _props.visible;

    getRef(this.video);
    if (!visible) {
      this._showOrHide();
      __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_debounce__["a" /* default */])(this._showOrHide, 250), {
        passive: true
      });
    }
  };

  VideoPlayer.prototype.componentDidUpdate = function componentDidUpdate(prevProp) {
    if (prevProp.height != this.props.height) {
      this.setState({
        height: this.props.height
      });
    }
  };

  VideoPlayer.prototype.componentWillUnmount = function componentWillUnmount() {
    var visible = this.props.visible;


    if (!visible) {
      __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_debounce__["a" /* default */])(this._showOrHide, 250), {
        passive: true
      });
    }
  };

  VideoPlayer.prototype.render = function render() {
    var _this2 = this,
        _classnames,
        _classnames2,
        _classnames3,
        _classnames4;

    var _props2 = this.props,
        src = _props2.src,
        _props2$loop = _props2.loop,
        loop = _props2$loop === undefined ? true : _props2$loop,
        _props2$autoPlay = _props2.autoPlay,
        autoPlay = _props2$autoPlay === undefined ? true : _props2$autoPlay,
        _props2$soundDirectio = _props2.soundDirection,
        soundDirection = _props2$soundDirectio === undefined ? "left" : _props2$soundDirectio,
        poster = _props2.poster,
        _props2$showSoundIcon = _props2.showSoundIcon,
        showSoundIcon = _props2$showSoundIcon === undefined ? false : _props2$showSoundIcon,
        onTimeUpdate = _props2.onTimeUpdate,
        onEnded = _props2.onEnded,
        onCanPlay = _props2.onCanPlay,
        _props2$calculatedHei = _props2.calculatedHeight,
        calculatedHeight = _props2$calculatedHei === undefined ? false : _props2$calculatedHei;
    var _state = this.state,
        muted = _state.muted,
        visible = _state.visible,
        height = _state.height,
        opacity = _state.opacity;


    var extraProps = {};
    if (loop) extraProps.loop = true;
    if (autoPlay) extraProps.autoPlay = true;
    if (muted) extraProps.muted = true;
    if (onTimeUpdate) extraProps.onTimeUpdate = onTimeUpdate;
    if (onCanPlay) extraProps.onCanPlay = onCanPlay;
    if (onEnded) extraProps.onEnded = onEnded;
    if (calculatedHeight && height) extraProps.style = {
      height: height,
      width: "100%"
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        ref: function ref(c) {
          return _this2.videoParent = c;
        },
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__VideoPlayer_less___default.a.VideoPlayer] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 114
        }
      },
      !visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["W" /* LoadingSection */], {
        visible: true,
        height: height,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 120
        }
      }),
      visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__VideoPlayer_less___default.a.VideoParent] = true, _classnames2)),
          style: {
            opacity: opacity === 0 ? 0.8 : 1
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 126
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video", _extends({
          ref: function ref(c) {
            return _this2.video = c;
          },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__VideoPlayer_less___default.a.Video] = true, _classnames3)),
          playsInline: true,
          src: src,
          poster: poster,
          type: "video/mp4"
        }, extraProps, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        })),
        showSoundIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__VideoPlayer_less___default.a.Icon] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_3__VideoPlayer_less___default.a.IconRight] = soundDirection === "right", _classnames4[__WEBPACK_IMPORTED_MODULE_3__VideoPlayer_less___default.a.IconLeft] = soundDirection === "left", _classnames4)),
            onClick: this._handleSound, __source: {
              fileName: _jsxFileName,
              lineNumber: 147
            }
          },
          muted && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_0" /* MuteIcon */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 154
            }
          }),
          !muted && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_20" /* UnMuteIcon */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 155
            }
          })
        )
      )
    );
  };

  return VideoPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

VideoPlayer.displayName = "VideoPlayer";


/* harmony default export */ __webpack_exports__["a"] = (VideoPlayer);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Card_less__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Card_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Card_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Card\\Card.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Card = function (_React$PureComponent) {
  _inherits(Card, _React$PureComponent);

  function Card() {
    var _temp, _this, _ret;

    _classCallCheck(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handleOnClick = function () {
      var _this$props = _this.props,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick,
          gtm = _this$props.gtm,
          heading = _this$props.heading,
          linkText = _this$props.linkText;

      onClick();

      // Call GTM if we have an gtm object
      if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
        Object(__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: gtm.category,
          pageAction: gtm.action + ("" + (linkText ? " - Clicked " + linkText : '')) + ("" + (heading ? " - " + heading : ''))
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Card.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames7;

    var _props = this.props,
        imageSrc = _props.imageSrc,
        note = _props.note,
        preHeading = _props.preHeading,
        heading = _props.heading,
        linkText = _props.linkText,
        description = _props.description,
        disclaimer = _props.disclaimer,
        _props$featured = _props.featured,
        featured = _props$featured === undefined ? false : _props$featured,
        _props$transparent = _props.transparent,
        transparent = _props$transparent === undefined ? false : _props$transparent,
        _props$contain = _props.contain,
        contain = _props$contain === undefined ? false : _props$contain,
        _props$outline = _props.outline,
        outline = _props$outline === undefined ? true : _props$outline,
        onClick = _props.onClick;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.Card] = true, _classnames[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.CardFeatured] = featured, _classnames[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.CardTransparent] = transparent, _classnames[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.CardLink] = linkText || onClick, _classnames[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.CardOutline] = outline, _classnames)),
        "data-test": "card",
        onClick: this._handleOnClick,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 48
        }
      },
      imageSrc && imageSrc != "" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.FirstSection] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.FirstSectionContain] = contain, _classnames2)),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 61
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], { src: imageSrc, type: "withoutShowing", __source: {
            fileName: _jsxFileName,
            lineNumber: 67
          }
        }),
        disclaimer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.FirstSectionDisclaimer] = true, _classnames3)),
            __source: {
              fileName: _jsxFileName,
              lineNumber: 70
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["l" /* Caption */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 75
              }
            },
            disclaimer
          )
        )
      ),
      (heading || description) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.SecondSection] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.CardWithLink] = linkText && linkText != "", _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 82
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 86
            }
          },
          note && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
            { withoutMargin: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 88
              }
            },
            note
          ),
          preHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 93
              }
            },
            preHeading
          ),
          preHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 97
            }
          }),
          heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["D" /* H6 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 99
              }
            },
            heading
          ),
          (description || linkText) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 103
            }
          }),
          description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.CardAreaContent] = true, _classnames5)), __source: {
                fileName: _jsxFileName,
                lineNumber: 105
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["t" /* Content */], { xmlString: description, __source: {
                fileName: _jsxFileName,
                lineNumber: 109
              }
            })
          )
        )
      ),
      linkText && linkText != "" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.ThirdSection] = true, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 117
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["a" /* A */],
          {
            withoutStyle: true,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_5__Card_less___default.a.ThirdSectionLink] = true, _classnames7)), __source: {
              fileName: _jsxFileName,
              lineNumber: 120
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 125
              }
            },
            linkText
          )
        )
      )
    );
  };

  return Card;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Card.displayName = "Card";


/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Section_less__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Section_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Section_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Container_Container__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Section\\Section.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Section = function (_React$PureComponent) {
  _inherits(Section, _React$PureComponent);

  function Section() {
    _classCallCheck(this, Section);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Section.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        fullWidth = _props.fullWidth,
        overlay = _props.overlay,
        backgroundColor = _props.backgroundColor,
        children = _props.children,
        _props$components = _props.components,
        components = _props$components === undefined ? [] : _props$components,
        border = _props.border,
        _props$center = _props.center,
        center = _props$center === undefined ? true : _props$center,
        sizeName = _props.sizeName,
        gutter = _props.gutter,
        horizontalPadding = _props.horizontalPadding,
        verticalPadding = _props.verticalPadding,
        padding = _props.padding;


    var sizeNameTranspiled = "screen";

    if (!sizeName) {
      if (fullWidth) sizeNameTranspiled = "";else if (overlay) sizeNameTranspiled = "";
    } else {
      sizeNameTranspiled = sizeName;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Section_less___default.a.Section] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Section_less___default.a.horizontalPadding] = horizontalPadding || padding, _classnames[__WEBPACK_IMPORTED_MODULE_2__Section_less___default.a.gutterPadding] = gutter, _classnames[__WEBPACK_IMPORTED_MODULE_2__Section_less___default.a.verticalPadding] = verticalPadding || padding, _classnames[__WEBPACK_IMPORTED_MODULE_2__Section_less___default.a.SectionBorder] = border, _classnames)),
        style: {
          backgroundColor: backgroundColor || "transparent"
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Container_Container__["a" /* default */],
        { styleName: sizeNameTranspiled, __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Section_less___default.a.ContainerInsideSection] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Section_less___default.a.Center] = center, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 48
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(components, this.props, "Section") || children
        )
      )
    );
  };

  return Section;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Section.displayName = "Section";


/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Container_less__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Container_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Container_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Container\\Container.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Container = function (_React$PureComponent) {
  _inherits(Container, _React$PureComponent);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Container.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        styleName = _props.styleName;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Container_less___default.a.Container] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Container_less___default.a.ContainerScreen] = styleName === "screen", _classnames[__WEBPACK_IMPORTED_MODULE_2__Container_less___default.a.ContainerTabletWide] = styleName === "tablet-wide", _classnames[__WEBPACK_IMPORTED_MODULE_2__Container_less___default.a.ContainerTabletNormal] = styleName === "tablet-normal", _classnames[__WEBPACK_IMPORTED_MODULE_2__Container_less___default.a.ContainerMobile] = styleName === "mobile", _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    );
  };

  return Container;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Container.displayName = "Container";


/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ColumnGroup_less__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ColumnGroup_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ColumnGroup_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\ColumnGroup\\ColumnGroup.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// This Comopnents tries to put everything in one row

var ColumnGroup = function (_React$PureComponent) {
  _inherits(ColumnGroup, _React$PureComponent);

  function ColumnGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, ColumnGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._map = function (items) {
      if (!items || items.length === 0) return;

      if (!Array.isArray(items)) items = [items];

      // remove undefined ones
      items = items.filter(function (item) {
        if (typeof item === "undefined") return false;
        if (item === null) return false;
        return true;
      });

      var _this$props$sizes = _this.props.sizes,
          sizes = _this$props$sizes === undefined ? [] : _this$props$sizes;

      return items.map(function (item, index) {
        var _classnames;

        var ratio = 100;
        if (!sizes || sizes.length === 0) ratio = 100 / items.length;else ratio = sizes[index];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: "ColumnGroupItem-" + index,
            style: {
              flex: "1 1 " + ratio + "%",
              display: "flex",
              alignItems: item.props && item.props.alignMiddle ? "center" : "flex-start",
              justifyContent: item.justifyContent || "center",
              overflow: "hidden",
              maxWidth: "100%"
            },
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__ColumnGroup_less___default.a.ColumnGroupItem] = true, _classnames)), __source: {
              fileName: _jsxFileName,
              lineNumber: 30
            }
          },
          item
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ColumnGroup.prototype.render = function render() {
    var _classnames2;

    var _props = this.props,
        _props$components = _props.components,
        components = _props$components === undefined ? [] : _props$components,
        children = _props.children,
        backgroundColor = _props.backgroundColor,
        _props$fullWidth = _props.fullWidth,
        fullWidth = _props$fullWidth === undefined ? true : _props$fullWidth,
        _props$reverseOnDeskt = _props.reverseOnDesktop,
        reverseOnDesktop = _props$reverseOnDeskt === undefined ? false : _props$reverseOnDeskt,
        _props$reverseOnMobil = _props.reverseOnMobile,
        reverseOnMobile = _props$reverseOnMobil === undefined ? false : _props$reverseOnMobil,
        _props$size = _props.size,
        size = _props$size === undefined ? "disable" : _props$size,
        _props$center = _props.center,
        center = _props$center === undefined ? true : _props$center;


    var minHeight = "initial";
    // size definition for columnsgroup
    if (size === "large") minHeight = "40vw";
    if (size === "medium") minHeight = "30vw";
    if (size === "small") minHeight = "20vw";
    if (size === "disable") minHeight = "initial";

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_8" /* Section */],
      {
        backgroundColor: backgroundColor,
        fullWidth: fullWidth,
        center: center,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          "data-test": "column-group",
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__ColumnGroup_less___default.a.ColumnGroup] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_3__ColumnGroup_less___default.a.ColumnGroup__ReverseDesktop] = reverseOnDesktop, _classnames2[__WEBPACK_IMPORTED_MODULE_3__ColumnGroup_less___default.a.ColumnGroup__ReverseMobile] = reverseOnMobile, _classnames2)),
          style: {
            minHeight: minHeight,
            overflow: "hidden"
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 75
          }
        },
        components && components.length > 0 && this._map(Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(components, this.props)),
        (!components || components.length === 0) && this._map(children)
      )
    );
  };

  return ColumnGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

ColumnGroup.displayName = "ColumnGroup";


/* harmony default export */ __webpack_exports__["a"] = (ColumnGroup);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CompareTool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apis_expose_global__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_AtomicUtils_debounce__ = __webpack_require__(47);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\compare-tool\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Redux






var Arrows = function Arrows() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 29 29", fill: "#aaa", width: "2em", __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M1.25,9H24.5l-4,3.92a1.22,1.22,0,1,0,1.74,1.71l6.44-6.14a1.21,1.21,0,0,0,0-1.71L22.17,0.35a1.21,1.21,0,0,0-1.71,1.71L24.5,6H1.25A1.53,1.53,0,0,0,1.25,9Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 30
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M29,21.5A1.52,1.52,0,0,0,27.75,20H4.5l4-3.94a1.21,1.21,0,1,0-1.71-1.71L0.35,20.78a1.21,1.21,0,0,0,0,1.71l6.44,6.14a1.22,1.22,0,0,0,1.74-1.71L4.5,23H27.75A1.52,1.52,0,0,0,29,21.5Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 31
      }
    })
  );
};

Arrows.displayName = "Arrows";
Arrows.displayName = "Arrows";
var X = function X() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { "data-test": "cross", viewBox: "0 0 18 18", height: "1em", __source: {
        fileName: _jsxFileName,
        lineNumber: 36
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      fill: "#910A2D",
      d: "M10.74,9l6.9-6.9A1.23,1.23,0,1,0,15.9.36L9,7.26,2.1,0.36A1.23,1.23,0,0,0,.36,2.1L7.26,9l-6.9,6.9A1.23,1.23,0,1,0,2.1,17.64L9,10.74l6.9,6.9a1.23,1.23,0,1,0,1.74-1.74Z",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37
      }
    })
  );
};

X.displayName = "X";
X.displayName = "X";
var Check = function Check() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { "data-test": "check", viewBox: "0 0 22 18", height: "1em", __source: {
        fileName: _jsxFileName,
        lineNumber: 45
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      fill: "#4C607E",
      d: "M8.46,18a1.22,1.22,0,0,1-.87-0.37L0.36,10.3a1.26,1.26,0,0,1,0-1.77,1.22,1.22,0,0,1,1.74,0l6.26,6.35L19.81,0.46A1.22,1.22,0,0,1,21.54.28,1.26,1.26,0,0,1,21.73,2L9.41,17.54a1.23,1.23,0,0,1-.89.46H8.46Z",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46
      }
    })
  );
};

Check.displayName = "Check";
Check.displayName = "Check";
var RenderPrice = function RenderPrice(_ref) {
  var selected = _ref.selected,
      price = _ref.price,
      sticky = _ref.sticky,
      compact = _ref.compact,
      displayPrice = _ref.displayPrice,
      safetyModel = _ref.safetyModel,
      dataTest = _ref.dataTest,
      onClickPriceDisclaimer = _ref.onClickPriceDisclaimer;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { "data-test": dataTest, style: priceStyles.pricingDiv(selected, compact), __source: {
        fileName: _jsxFileName,
        lineNumber: 63
      }
    },
    displayPrice && price && price.price && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: priceStyles.priceWrapper(compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: priceStyles.rdp(compact), __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        },
        "RRP FROM"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_containers__["w" /* InlineDisclaimerBlock */],
        {
          message: price.disclaimer,
          gtmEvents: [{ func: onClickPriceDisclaimer }],
          blockStyling: priceStyles.actualPrice(sticky),
          disclaimerStyling: {
            marginLeft: ".1em",
            color: "inherit",
            fontSize: "inherit"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 69
          }
        },
        "$",
        safetyModel && price.safetyModelPrice ? price.safetyModelPrice.toLocaleString('nz') : price.price.toLocaleString('nz')
      )
    ),
    displayPrice && price && !price.price && price.message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: priceStyles.pricingSpan, __source: {
          fileName: _jsxFileName,
          lineNumber: 86
        }
      },
      price.message
    ),
    !displayPrice && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: priceStyles.pricingSpan, __source: {
          fileName: _jsxFileName,
          lineNumber: 89
        }
      },
      "Choose a grade to see price"
    )
  );
};

RenderPrice.displayName = "RenderPrice";
RenderPrice.displayName = "RenderPrice";
RenderPrice.propTypes = {
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dataTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  sticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  displayPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClickPriceDisclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var priceStyles = {
  pricingDiv: function pricingDiv(selected, compact) {
    return {
      flex: "1 1 33%",
      padding: "1em",
      display: "flex",
      justifyContent: "center",
      opacity: selected ? 1 : compact ? 0.5 : 1
    };
  },
  priceWrapper: function priceWrapper(compact) {
    return {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      flexDirection: compact ? "column" : "row",
      justifyContent: "center"
    };
  },
  rdp: function rdp(compact) {
    return {
      fontSize: "80%",
      maxWidth: compact ? "initial" : "50px",
      textAlign: "right",
      lineHeight: 1.25,
      display: "block",
      marginRight: ".5em",
      fontWeight: 600
    };
  },
  actualPrice: function actualPrice(sticky) {
    return {
      fontSize: sticky ? "220%" : "180%",
      transition: ".3s",
      whiteSpace: "nowrap",
      fontWeight: 400
    };
  },
  pricingSpan: {
    maxWidth: "180px",
    lineHeight: 1.5,
    margin: "auto",
    display: "block",
    textTransform: "uppercase",
    fontSize: "80%",
    fontWeight: "600",
    textAlign: "center",
    letterSpacing: ".2em",
    opacity: 0.8
  }

  // Lines that compare specs inside the accordion
};var DuoLine = function DuoLine(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: dstyles.base, __source: {
        fileName: _jsxFileName,
        lineNumber: 150
      }
    },
    props.compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: dstyles.div, __source: {
          fileName: _jsxFileName,
          lineNumber: 151
        }
      },
      props.title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 152
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: dstyles.span, __source: {
            fileName: _jsxFileName,
            lineNumber: 158
          }
        },
        props.showLeft ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
          {
            withoutStyle: true,
            style: { fontSize: "22px" },
            onClick: function onClick(event) {
              if (event && event.target && event.target.querySelector('button')) {
                event.target.querySelector('button').click();
              }
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 160
            }
          },
          props.contentA ? props.contentA === "Standard" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Check, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 170
            }
          }) : props.contentA : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(X, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 175
            }
          }),
          props.disclaimerA && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_AtomicContainers__["i" /* Disclaimer */],
            { text: props.disclaimerA && props.disclaimerA.disclaimerCode, __source: {
                fileName: _jsxFileName,
                lineNumber: 179
              }
            },
            props.disclaimerA && props.disclaimerA.disclaimerText
          )
        ) : ""
      ),
      !props.compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: dstyles.div, __source: {
            fileName: _jsxFileName,
            lineNumber: 188
          }
        },
        props.title
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: dstyles.span, __source: {
            fileName: _jsxFileName,
            lineNumber: 189
          }
        },
        props.showRight ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
          {
            withoutStyle: true,
            style: { fontSize: "22px" },
            onClick: function onClick(event) {
              if (event && event.target && event.target.querySelector('button')) {
                event.target.querySelector('button').click();
              }
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 191
            }
          },
          props.contentB ? props.contentB === "Standard" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Check, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 201
            }
          }) : props.contentB : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(X, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 206
            }
          }),
          props.disclaimerB && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_AtomicContainers__["i" /* Disclaimer */],
            { text: props.disclaimerB && props.disclaimerB.disclaimerCode, __source: {
                fileName: _jsxFileName,
                lineNumber: 210
              }
            },
            props.disclaimerB && props.disclaimerB.disclaimerText
          )
        ) : ""
      )
    )
  );
};

DuoLine.displayName = "DuoLine";
DuoLine.displayName = "DuoLine";
DuoLine.propTypes = {
  showLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentB: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disclaimerA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disclaimerB: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var dstyles = {
  base: {
    padding: "2em 0",
    borderBottom: "2px solid #eee"
  },
  div: {
    fontWeight: 800,
    color: "#aaaaaa",
    letterSpacing: ".2em",
    textAlign: "center",
    lineHeight: 2,
    textTransform: "uppercase",
    fontSize: "80%",
    flex: "0 0 33%"
  },
  span: {
    flex: "1 1 33%",
    textAlign: "center",
    paddingTop: ".2em"
  }
};

var RenderSelection = function RenderSelection(_ref2) {
  var heading = _ref2.heading,
      options = _ref2.options,
      onChange = _ref2.onChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { "data-test": "compare-tool-selection", style: { width: "100%" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 257
      }
    },
    heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["C" /* H5 */],
      { withDetails: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 259
        }
      },
      options.nameplate.name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { width: "100%", margin: "auto", position: "relative", overflow: "hidden" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 261
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["_12" /* TabsResponsive */], {
        options: options.bodyStyles,
        onChange: onChange,
        active: options.bodyStyles.indexOf(options.bodyStyle),
        label: "Body",
        divider: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 262
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 269
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["_2" /* Select */], {
          key: "SelectBody-" + options.bodyStyles.indexOf(options.bodyStyle),
          options: options.grades,
          onChange: onChange,
          active: options.grades.indexOf(options.grade),
          label: "Grade",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 270
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 278
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["_2" /* Select */], {
          key: "SelectBodyGrade-" + options.bodyStyles.indexOf(options.bodyStyle) + "-" + options.grades.indexOf(options.grade),
          options: options.engines.filter(function (engine) {
            return !engine.isSafetyModel;
          }),
          onChange: onChange,
          active: options.engines.indexOf(options.engine),
          disabled: !options.grade,
          label: "Engine",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 279
          }
        })
      )
    )
  );
};

RenderSelection.displayName = "RenderSelection";
RenderSelection.displayName = "RenderSelection";
var CTAPair = function CTAPair(_ref3) {
  var gtmID = _ref3.gtmID,
      isVisible = _ref3.isVisible,
      findDealerUrl = _ref3.findDealerUrl,
      compact = _ref3.compact,
      vehicle = _ref3.vehicle,
      onClickCTA = _ref3.onClickCTA;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        flex: compact ? "1 1 100%" : "1 1 auto",
        visibility: isVisible ? "visible" : "hidden",
        alignItems: "center",
        flexDirection: compact ? "column" : "row",
        boxSizing: "border-box",
        padding: "0 1em"
      },
      "data-test": vehicle.nameplate.name + "-ctas", __source: {
        fileName: _jsxFileName,
        lineNumber: 300
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["r" /* ColumnGroup */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 310
        }
      },
      findDealerUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */], {
        type: "a",
        label: "Find a dealer",
        href: findDealerUrl,
        styleName: "red",
        fullWidth: compact,
        onClick: function onClick() {
          onClickCTA(gtmID[0], "FIND A DEALER", vehicle);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 312
        }
      }),
      compact ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 323
        }
      }) : undefined,
      vehicle.nameplate.vehicleLandingPageUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */], {
        type: "a",
        label: "Learn more",
        href: vehicle.nameplate.vehicleLandingPageUrl,
        styleName: "blackOutlined",
        fullWidth: compact,
        onClick: function onClick() {
          onClickCTA(gtmID[1], "LEARN MORE", vehicle);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 325
        }
      })
    )
  );
};
CTAPair.displayName = "CTAPair";
CTAPair.displayName = "CTAPair";
CTAPair.propTypes = {
  gtmID: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  isVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  findDealerUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vehicle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClickCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var VehicleCTAs = function VehicleCTAs(_ref4) {
  var isLeftCTAsVisible = _ref4.isLeftCTAsVisible,
      isRightCTAsVisible = _ref4.isRightCTAsVisible,
      vehicleLeft = _ref4.vehicleLeft,
      vehicleRight = _ref4.vehicleRight,
      findDealerUrl = _ref4.findDealerUrl,
      compact = _ref4.compact,
      activeOptions = _ref4.activeOptions,
      onClickCTA = _ref4.onClickCTA;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        padding: "1em 0 4em",
        fontSize: "0.96em",
        textAlign: "center"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 358
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { flex: !compact || activeOptions === 0 ? "1 0 33%" : "inherit" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 369
        }
      },
      (!compact || activeOptions === 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CTAPair, {
        gtmID: ["FED010", "FED011"],
        isVisible: isLeftCTAsVisible,
        findDealerUrl: findDealerUrl,
        compact: compact,
        vehicle: vehicleLeft,
        onClickCTA: onClickCTA,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 371
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { flex: !compact ? "0 0 33%" : "inherit" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 381
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { flex: !compact || activeOptions === 1 ? "1 0 33%" : "inherit" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 382
        }
      },
      (!compact || activeOptions === 1) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CTAPair, {
        gtmID: ["FED012", "FED013"],
        isVisible: isRightCTAsVisible,
        findDealerUrl: findDealerUrl,
        compact: compact,
        vehicle: vehicleRight,
        onClickCTA: onClickCTA,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 384
        }
      })
    )
  );
};

VehicleCTAs.displayName = "VehicleCTAs";
VehicleCTAs.displayName = "VehicleCTAs";
VehicleCTAs.propTypes = {
  isLeftCTAsVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isRightCTAsVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vehicleLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  vehicleRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  findDealerUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  onClickCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var getnameIfDefault = function getnameIfDefault(option) {
  return option && Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("name", option);
};

var stateToParamsMapping = function stateToParamsMapping(optionsLeft, optionsRight) {
  var safetyModelLeft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var safetyModelRight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return {
    bodyStyleLeft: optionsLeft && getnameIfDefault(optionsLeft.bodyStyle),
    gradeLeft: optionsLeft && getnameIfDefault(optionsLeft.grade),
    engineLeft: optionsLeft && getnameIfDefault(optionsLeft.engine),
    modelCodeLeft: safetyModelLeft ? optionsLeft && optionsLeft.engine && Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("safetyModelCode", optionsLeft.engine) : optionsLeft && optionsLeft.engine && Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("modelCode", optionsLeft.engine),
    bodyStyleRight: optionsRight && getnameIfDefault(optionsRight.bodyStyle),
    gradeRight: optionsRight && getnameIfDefault(optionsRight.grade),
    engineRight: optionsRight && getnameIfDefault(optionsRight.engine),
    modelCodeRight: safetyModelRight ? optionsRight && optionsRight.engine && Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("safetyModelCode", optionsRight.engine) : optionsRight && optionsRight.engine && Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("modelCode", optionsRight.engine)
  };
};

var TopNav = function (_Component) {
  _inherits(TopNav, _Component);

  function TopNav() {
    _classCallCheck(this, TopNav);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TopNav.prototype.render = function render() {
    var _props = this.props,
        style = _props.style,
        backLink = _props.backLink,
        hideLinks = _props.hideLinks,
        locationState = _props.locationState,
        savedCompareEndPoint = _props.savedCompareEndPoint,
        sharedCompareEndPoint = _props.sharedCompareEndPoint,
        findDealerUrl = _props.findDealerUrl,
        optionsLeft = _props.optionsLeft,
        optionsRight = _props.optionsRight,
        form = _props.form,
        safetyModelExcess = _props.safetyModelExcess,
        financeOptionText = _props.financeOptionText,
        bubbleDirection = _props.bubbleDirection;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: _extends({
          display: "flex",
          flexWrap: "nowrap"
        }, style, {
          borderBottom: "1px solid #D7D7D7",
          justifyContent: "space-between"
        }), __source: {
          fileName: _jsxFileName,
          lineNumber: 440
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
        { withoutStyle: true, style: shareStyles.trigger, href: backLink, __source: {
            fileName: _jsxFileName,
            lineNumber: 448
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_5" /* RestartIcon */], { style: { height: "22px", width: "22px", marginRight: "8px" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 449
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 450
            }
          },
          "Restart"
        )
      ),
      !hideLinks && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicContainers__["E" /* SaveShareCopy */], {
        locationState: locationState,
        bubbleDirection: bubbleDirection,
        disableSavePrompt: this.props.disableSavePrompt,
        delayToShowSavePrompt: this.props.delayToShowSavePrompt,
        descriptionSave: "Save time and conveniently save your Mazda comparison for future reference.",
        descriptionShare: "Send a link of your Mazda compare via email",
        imageSrc: [optionsLeft.grade.imageSrc, optionsRight.grade.imageSrc],
        findDealerUrl: findDealerUrl,
        saveEndPoint: savedCompareEndPoint,
        shareEndPoint: sharedCompareEndPoint,
        enabled: _extends({}, optionsLeft.engine, optionsRight.engine),
        namePlate: [getnameIfDefault(optionsLeft.nameplate), getnameIfDefault(optionsRight.nameplate)],
        bodyStyle: [getnameIfDefault(optionsLeft.bodyStyle), getnameIfDefault(optionsRight.bodyStyle)],
        safetyModelExcess: [form.safetyModelLeft.value && Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("safetyModelCode", optionsLeft.engine) ? Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("modelCode", optionsLeft.engine) === Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("safetyModelCode", optionsLeft.engine) ? "Included as standard" : "+$" + safetyModelExcess : null, form.safetyModelRight.value && Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("safetyModelCode", optionsRight.engine) ? Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("modelCode", optionsRight.engine) === Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("safetyModelCode", optionsRight.engine) ? "Included as standard" : "+$" + safetyModelExcess : null],
        financeOptionText: financeOptionText,
        gtmEvents: {
          category: "Compare tool",
          action: "Compare \"" + getnameIfDefault(optionsLeft.nameplate) + "\", \"" + getnameIfDefault(optionsLeft.bodyStyle) + "\", \"" + getnameIfDefault(optionsLeft.grade) + "\", \"" + getnameIfDefault(optionsLeft.engine) + "\" and \"" + getnameIfDefault(optionsRight.nameplate) + "\", \"" + getnameIfDefault(optionsRight.bodyStyle) + "\", \"" + getnameIfDefault(optionsRight.grade) + "\", \"" + getnameIfDefault(optionsRight.engine) + "\""
        },
        compareUrl: __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_environment__["i" /* WINDOW */].location.href,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 455
        }
      })
    );
  };

  return TopNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TopNav.displayName = "TopNav";


TopNav.propTypes = {
  backLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideLinks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  locationState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  savedCompareEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sharedCompareEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  findDealerUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  optionsLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  optionsRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var shareStyles = {
  trigger: {
    cursor: "pointer",
    fill: "#aaa",
    color: "#aaa",
    display: "flex",
    padding: "1em 1.8em 1em 1.5em",
    alignItems: "center",
    textTransform: "uppercase",
    letterSpacing: "0.2em",
    fontWeight: "600",
    textDecoration: "none"
  },
  link: {
    color: "#aaa",
    textDecoration: "none",
    fontSize: "90%",
    padding: "0em 0em 5em",
    ":hover": {
      color: "#101010"
    }
  }
};

var apiMapping = function apiMapping(stateOptions) {
  return {
    nameplate: stateOptions.nameplate.name,
    bodystyle: stateOptions.bodyStyle.name,
    drivetrain: stateOptions.engine.drivetrain,
    grade: stateOptions.grade.name,
    transmission: stateOptions.engine.transmission,
    engineSize: stateOptions.engine.engineSize,
    fueltype: stateOptions.engine.fuelType,
    modelCode: stateOptions.engine.modelCode
  };
};

/* Compare Tool */
var CompareTool = function (_Component2) {
  _inherits(CompareTool, _Component2);

  function CompareTool(props) {
    _classCallCheck(this, CompareTool);

    var _this2 = _possibleConstructorReturn(this, _Component2.call(this, props));

    var _take$map = Object(__WEBPACK_IMPORTED_MODULE_7_utils__["S" /* take */])(2, props.vehicles).map(function (data) {
      return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7_utils__["H" /* parseKoalaData */])(data, { type: "compare" }), {
        grade: false,
        engine: false
      });
    }),
        optionsLeft = _take$map[0],
        optionsRight = _take$map[1];

    _this2.state = {
      optionsLeft: optionsLeft,
      optionsRight: optionsRight,
      activeOptions: 0,
      compareUrl: "",
      form: {
        safetyModelLeft: {
          validations: {}
        },
        safetyModelRight: {
          validations: {}
        },
        showDifferences: {
          validations: {}
        }
      },
      isModalOpen: false
    };

    Object(__WEBPACK_IMPORTED_MODULE_7_utils__["d" /* bindAll */])(["handleChangeOptionLeft", "handleChangeOptionRight", "updateActiveOptions", "getPrice", "getSpecs", "handleScroll", "updateStickyNav", "onClickCTA"], _this2);
    return _this2;
  }

  CompareTool.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    var _props2 = this.props,
        specifications = _props2.specifications,
        initialResults = _props2.initialResults,
        price = _props2.price,
        specsApiEndpoint = _props2.specsApiEndpoint;
    var _state = this.state,
        optionsLeft = _state.optionsLeft,
        optionsRight = _state.optionsRight;


    price.setOptions({
      mapping: apiMapping,
      fetchURL: this.props.priceApiEndpoint
    });
    specifications.setOptions({
      mapping: apiMapping,
      initial: initialResults && { categories: initialResults },
      fetchURL: specsApiEndpoint,
      featured: false
    }, this.getSpecs);
    this.updateStickyNav();
    this.scrollEvent = Object(__WEBPACK_IMPORTED_MODULE_7_utils__["M" /* rafThrottle */])(this.handleScroll);
    __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_13_AtomicUtils_debounce__["a" /* default */])(this.scrollEvent, 250), {
      passive: true
    });

    Object(__WEBPACK_IMPORTED_MODULE_8_apis_expose_global__["a" /* default */])("getComparedVehicles", function () {
      var left = _this3.state.optionsLeft;
      var right = _this3.state.optionsRight;
      left.price = _this3.props.price.data[0];
      right.price = _this3.props.price.data[1];
      return {
        leftVehicle: left,
        rightVehicle: right
      };
    });

    this.handleOptionChange(optionsLeft.grades.find(function (item) {
      return !!item.default;
    }), "optionsLeft", 0);
    this.handleOptionChange(optionsRight.grades.find(function (item) {
      return !!item.default;
    }), "optionsRight", 1);
  };

  CompareTool.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_13_AtomicUtils_debounce__["a" /* default */])(this.scrollEvent, 250), {
      passive: true
    });
  };

  CompareTool.prototype.handleScroll = function handleScroll() {
    this.updateStickyNav();
  };

  CompareTool.prototype.updateStickyNav = function updateStickyNav() {
    if (this.priceBarEl && this.priceBarEl.getBoundingClientRect().top > 0) {
      // Checking if value should update improves performance
      if (this.state.stickyTransform === this.overflowEl.clientHeight) return;
      this.setState({ stickyTransform: this.overflowEl.clientHeight });
    } else {
      if (this.state.stickyTransform === 0) return;
      this.setState({ stickyTransform: 0 });
    }
  };

  CompareTool.prototype.handleOptionChange = function handleOptionChange(newSelection, key, index) {
    var _this4 = this,
        _setState;

    if (!newSelection) return;

    var form = this.state.form;

    var currentOptions = this.state[key];

    if (Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])("name", newSelection) === Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])([newSelection.type, "name"], currentOptions)) return;

    var options = Object(__WEBPACK_IMPORTED_MODULE_7_utils__["H" /* parseKoalaData */])(this.props.vehicles[index], {
      newSelection: newSelection,
      stateOptions: this.state[key],
      type: "compare"
    }, true);
    if (newSelection.type === "bodyStyle") options.grade = options.engine = false;else if (newSelection.type === "grade") {
      this.handleOptionChange({ type: "drivetrain" }, key, index);
    }

    var onState = ["bodyStyle", "grade", "engine"].every(function (attr) {
      return !!Object(__WEBPACK_IMPORTED_MODULE_7_utils__["q" /* get */])(attr, options);
    }) ? function () {
      _this4.getPrice(options, index);
      _this4.getSpecs();
      _this4.setState({ activeOptions: index }, function () {
        Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(_this4, {
          safetyModelLeft: _this4.state.optionsLeft.engine.modelCode === _this4.state.optionsLeft.engine.safetyModelCode,
          safetyModelRight: _this4.state.optionsRight.engine.modelCode === _this4.state.optionsRight.engine.safetyModelCode
        });
      });

      _this4.props.search.pushParam(_extends({}, stateToParamsMapping(_this4.state.optionsLeft, _this4.state.optionsRight, form.safetyModelLeft.value, form.safetyModelRight.value)));
    } : function () {
      _this4.props.search.pushParam(_extends({}, stateToParamsMapping(_this4.state.optionsLeft, _this4.state.optionsRight, form.safetyModelLeft.value, form.safetyModelRight.value)));
    };
    this.setState((_setState = {}, _setState[key] = options, _setState), onState);
  };

  CompareTool.prototype.handleChangeOptionLeft = function handleChangeOptionLeft(option) {
    // Get gtmEventID based on which component being selected
    var gtmEventID = function gtmEventID(change) {
      switch (change.type) {
        case "bodyStyle":
          return "FED002";
        case "grade":
          return "FED003";
        case "engine":
          return "FED004";
        default:
          return "ERROR!";
      }
    };
    // Constructing the pageAction message
    var model1 = this.state.optionsLeft.nameplate.name;
    var model2 = this.state.optionsRight.nameplate.name;
    var message = "Compared \"" + model1.toUpperCase() + "\" and \"" + model2.toUpperCase() + "\" - Selected \"" + model1.toUpperCase() + "\" " + option.type + " \"" + option.name.toUpperCase() + "\"";
    // Dispatch gtm event
    this.props.gtmEvent({
      gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["a" /* compareToolActionTypes */].COMPARE_TOOL_CHANGE_SELECTION,
      gtmPayload: {
        eventID: gtmEventID(option),
        actionMessage: message
      }
    });
    // Continue with react logic
    this.handleOptionChange(option, "optionsLeft", 0);
  };

  CompareTool.prototype.handleChangeOptionRight = function handleChangeOptionRight(option) {
    var gtmEventID = function gtmEventID(change) {
      switch (change.type) {
        case "bodyStyle":
          return "FED005";
        case "grade":
          return "FED006";
        case "engine":
          return "FED007";
        default:
          return "ERROR!";
      }
    };
    var model1 = this.state.optionsLeft.nameplate.name;
    var model2 = this.state.optionsRight.nameplate.name;
    var message = "Compared \"" + model1.toUpperCase() + "\" and \"" + model2.toUpperCase() + "\" - Selected \"" + model2.toUpperCase() + "\" " + option.type + " \"" + option.name.toUpperCase() + "\"";
    this.props.gtmEvent({
      gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["a" /* compareToolActionTypes */].COMPARE_TOOL_CHANGE_SELECTION,
      gtmPayload: {
        eventID: gtmEventID(option),
        actionMessage: message
      }
    });

    this.handleOptionChange(option, "optionsRight", 1);
  };

  CompareTool.prototype.getPrice = function getPrice(options) {
    var update = this.props.price.update;


    if (!options.grade) return;
    update([this.state.optionsLeft || false, this.state.optionsRight || false]);
  };

  CompareTool.prototype.getSpecs = function getSpecs() {
    var update = this.props.specifications.update;
    var _state2 = this.state,
        optionsLeft = _state2.optionsLeft,
        optionsRight = _state2.optionsRight,
        _state2$form = _state2.form,
        safetyModelLeft = _state2$form.safetyModelLeft,
        safetyModelRight = _state2$form.safetyModelRight;


    if (!optionsLeft.engine && !optionsRight.engine) return;

    update([_extends({}, optionsLeft, {
      engine: _extends({}, optionsLeft.engine, {
        modelCode: safetyModelLeft.value ? optionsLeft.engine.safetyModelCode : optionsLeft.engine.modelCode
      })
    }), _extends({}, optionsRight, {
      engine: _extends({}, optionsRight.engine, {
        modelCode: safetyModelRight.value ? optionsRight.engine.safetyModelCode : optionsRight.engine.modelCode
      })
    })]);
  };

  CompareTool.prototype.updateActiveOptions = function updateActiveOptions(index) {
    this.setState({ activeOptions: index });
  };

  // CTA clicking event for GTM


  CompareTool.prototype.onClickCTA = function onClickCTA(eventID, CTAname, vehicle) {
    var model1 = this.state.optionsLeft.nameplate.name;
    var model2 = this.state.optionsRight.nameplate.name;
    var actionMessage = "Compared \"" + model1.toUpperCase() + "\" and \"" + model2.toUpperCase() + "\" - Clicked \"" + CTAname.toUpperCase() + "\" - \"" + vehicle.nameplate.name.toUpperCase() + "/" + vehicle.bodyStyle.name.toUpperCase() + "/" + vehicle.grade.name.toUpperCase() + "/" + vehicle.engine.name.toUpperCase() + "\"";
    this.props.gtmEvent({
      gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["a" /* compareToolActionTypes */].COMPARE_TOOL_CLICK_CTA,
      gtmPayload: {
        eventID: eventID,
        actionMessage: actionMessage
      }
    });
  };

  // Price disclaimer clicking event for GTM


  CompareTool.prototype.onClickPriceDisclaimer = function onClickPriceDisclaimer(eventID, vehicle) {
    var model1 = this.state.optionsLeft.nameplate.name;
    var model2 = this.state.optionsRight.nameplate.name;
    var actionMessage = "Compared \"" + model1.toUpperCase() + "\" and \"" + model2.toUpperCase() + "\" - Clicked Pricing Disclaimer - \"" + vehicle.nameplate.name.toUpperCase() + "/" + vehicle.bodyStyle.name.toUpperCase() + "/" + vehicle.grade.name.toUpperCase() + "/" + vehicle.engine.name.toUpperCase() + "\"";
    this.props.gtmEvent({
      gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["a" /* compareToolActionTypes */].COMPARE_TOOL_CLICK_PRICE_DISCLAIMER,
      gtmPayload: {
        eventID: eventID,
        actionMessage: actionMessage
      }
    });
  };

  CompareTool.prototype.renderSafetyModelOption = function renderSafetyModelOption() {
    var _this5 = this;

    var isLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var _props3 = this.props,
        safetyModelExcess = _props3.safetyModelExcess,
        safetyModelDisclaimer = _props3.safetyModelDisclaimer,
        isInitialSafetyModelLeft = _props3.isInitialSafetyModelLeft,
        isInitialSafetyModelRight = _props3.isInitialSafetyModelRight;
    var _state3 = this.state,
        optionsLeft = _state3.optionsLeft,
        optionsRight = _state3.optionsRight;

    var price = isLeft ? this.props.price.data[0] : this.props.price.data[1];

    if (isLeft && (!optionsLeft.engine || optionsLeft.engine && !optionsLeft.engine.safetyModelCode)) {
      return null;
    }

    if (!isLeft && (!optionsRight.engine || optionsRight.engine && !optionsRight.engine.safetyModelCode)) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { width: "100%", margin: "auto", textAlign: "left" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 919
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 920
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 921
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 922
              }
            },
            "Options"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.safetyModel, __source: {
                fileName: _jsxFileName,
                lineNumber: 923
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { display: "flex", alignItems: "center" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 924
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
                key: "SafetyModel-" + (isLeft ? 'Left' : 'Right'),
                name: isLeft ? "safetyModelLeft" : "safetyModelRight",
                label: "Vision Technology",
                checked: price && price.price && (price.price === price.safetyModelPrice || (isLeft ? isInitialSafetyModelLeft : isInitialSafetyModelRight)),
                disabled: price && price.price && price.price === price.safetyModelPrice
              }, Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, isLeft ? "safetyModelLeft" : "safetyModelRight", function () {
                setTimeout(function () {
                  _this5.getSpecs();
                  _this5.props.search.pushParam(_extends({}, stateToParamsMapping(_this5.state.optionsLeft, _this5.state.optionsRight, _this5.state.form.safetyModelLeft.value, _this5.state.form.safetyModelRight.value)));
                }, 400);
              }), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 925
                }
              })),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                {
                  onClick: function onClick() {
                    _this5.setState({ isModalOpen: true });
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 945
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["J" /* InfoIcon */], { style: styles.infoIcon, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 949
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 952
                }
              },
              price && price.price && price.price === price.safetyModelPrice ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 955
                  }
                },
                "Included as standard"
              ) : safetyModelExcess && price && safetyModelDisclaimer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 959
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_containers__["w" /* InlineDisclaimerBlock */],
                  {
                    message: safetyModelDisclaimer,
                    disclaimerStyling: {
                      fontSize: "16px"
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 960
                    }
                  },
                  "+$",
                  safetyModelExcess.toLocaleString()
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["V" /* LoadingIcon */], {
                style: {
                  width: "16px",
                  height: "16px"
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 969
                }
              })
            )
          )
        )
      )
    );
  };

  CompareTool.prototype.render = function render() {
    var _this6 = this;

    var _props4 = this.props,
        specifications = _props4.specifications,
        price = _props4.price,
        compact = _props4.compact,
        hideLinks = _props4.hideLinks,
        findDealerUrl = _props4.findDealerUrl,
        backLink = _props4.backLink,
        savedCompareEndPoint = _props4.savedCompareEndPoint,
        sharedCompareEndPoint = _props4.sharedCompareEndPoint,
        delayToShowSavePrompt = _props4.delayToShowSavePrompt,
        disableSavePrompt = _props4.disableSavePrompt,
        safetyModelBlurb = _props4.safetyModelBlurb,
        safetyModelExcess = _props4.safetyModelExcess,
        financeOptionText = _props4.financeOptionText,
        locationState = _props4.locationState,
        components = _props4.components;
    var _state4 = this.state,
        optionsLeft = _state4.optionsLeft,
        optionsRight = _state4.optionsRight,
        activeOptions = _state4.activeOptions,
        stickyTransform = _state4.stickyTransform,
        form = _state4.form;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.base, "data-test": "compare-tool", __source: {
          fileName: _jsxFileName,
          lineNumber: 1011
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: [{
            backgroundColor: "white",
            position: "fixed",
            zIndex: 5,
            width: "100%",
            top: 0
          }, {
            transition: ".5s",
            transform: "translateY(-" + stickyTransform + "px)"
          }], __source: {
            fileName: _jsxFileName,
            lineNumber: 1012
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopNav, {
          optionsLeft: optionsLeft,
          optionsRight: optionsRight,
          form: form,
          safetyModelExcess: safetyModelExcess,
          bubbleDirection: "bottom",
          delayToShowSavePrompt: delayToShowSavePrompt,
          disableSavePrompt: disableSavePrompt,
          hideLinks: hideLinks,
          backLink: backLink,
          locationState: locationState,
          savedCompareEndPoint: savedCompareEndPoint,
          sharedCompareEndPoint: sharedCompareEndPoint,
          financeOptionText: financeOptionText,
          style: { display: stickyTransform ? "none" : "flex" },
          findDealerUrl: findDealerUrl,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 1026
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1045
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              ref: function ref(c) {
                _this6.overflowEl = c;
              },
              style: styles.options(!this.state.stickyTransform), __source: {
                fileName: _jsxFileName,
                lineNumber: 1046
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: {
                  flex: compact ? "0 0 35%" : "1 1 33%",
                  alignItems: "center",
                  opacity: !compact || activeOptions === 0 ? 1 : 0.5
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1051
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["D" /* H6 */],
                { withDetails: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1057
                  }
                },
                optionsLeft.nameplate.name
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["l" /* Caption */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1058
                  }
                },
                optionsLeft.grade.name,
                " - ",
                optionsLeft.engine.name
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: {
                  flex: compact ? "0 0 15%" : "0 0 15%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1062
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Arrows, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1069
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: {
                  flex: compact ? "0 0 35%" : "1 1 33%",
                  alignItems: "center",
                  opacity: !compact || activeOptions === 1 ? 1 : 0.5
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1071
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["D" /* H6 */],
                { withDetails: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1077
                  }
                },
                optionsRight.nameplate.name
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["l" /* Caption */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1078
                  }
                },
                optionsRight.grade.name,
                " - ",
                optionsRight.engine.name
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { background: "#565c65", color: "white" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 1087
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1088
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: {
                  display: this.state.stickyTransform ? "none" : "flex",
                  justifyContent: compact ? "space-around" : "center",
                  width: '100%'
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1089
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderPrice, {
                dataTest: "price-left",
                selected: activeOptions === 0,
                displayPrice: !!optionsLeft.engine,
                compact: compact,
                safetyModel: form.safetyModelLeft.value,
                onClickPriceDisclaimer: function onClickPriceDisclaimer() {
                  return _this6.onClickPriceDisclaimer("FED014", _this6.state.optionsLeft);
                },
                price: price.data[0],
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1095
                }
              }),
              !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { flex: "0 0 15%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1109
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderPrice, {
                dataTest: "price-right",
                selected: activeOptions === 1,
                displayPrice: !!optionsRight.engine,
                compact: compact,
                safetyModel: form.safetyModelRight.value,
                onClickPriceDisclaimer: function onClickPriceDisclaimer() {
                  return _this6.onClickPriceDisclaimer("FED015", _this6.state.optionsRight);
                },
                price: price.data[1],
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1110
                }
              })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: [{
            position: "relative",
            backgroundColor: compact ? "#fff" : "#f5f5f5"
          }, { opacity: this.state.stickyTransform ? 1 : 0 }], __source: {
            fileName: _jsxFileName,
            lineNumber: 1128
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopNav, {
          optionsLeft: optionsLeft,
          optionsRight: optionsRight,
          form: form,
          safetyModelExcess: safetyModelExcess,
          bubbleDirection: "top",
          compact: compact,
          delayToShowSavePrompt: delayToShowSavePrompt,
          disableSavePrompt: disableSavePrompt,
          hideLinks: hideLinks,
          backLink: backLink,
          locationState: locationState,
          savedCompareEndPoint: savedCompareEndPoint,
          sharedCompareEndPoint: sharedCompareEndPoint,
          financeOptionText: financeOptionText,
          findDealerUrl: findDealerUrl,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 1136
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
          { textAlign: "center", __source: {
              fileName: _jsxFileName,
              lineNumber: 1153
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.header, __source: {
                fileName: _jsxFileName,
                lineNumber: 1154
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { flex: "0 1 33%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1155
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  style: [compact && styles.vehicleIcon(activeOptions === 0, compact)],
                  onClick: function onClick() {
                    _this6.updateActiveOptions(0);
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1156
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["j" /* ConfiguredVehicle */], {
                  src: optionsLeft.grade ? optionsLeft.grade.imageSrc : optionsLeft.grades[0].imageSrc,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1164
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { flex: compact ? "0 0 20%" : "0 0 33%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1173
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Arrows, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1174
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { flex: "0 1 33%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1176
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  style: [compact && styles.vehicleIcon(activeOptions === 1, compact)],
                  onClick: function onClick() {
                    _this6.updateActiveOptions(1);
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1177
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["j" /* ConfiguredVehicle */], {
                  src: optionsRight.grade ? optionsRight.grade.imageSrc : optionsRight.grades[0].imageSrc,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1185
                  }
                })
              )
            )
          )
        ),
        compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
          { textAlign: "center", __source: {
              fileName: _jsxFileName,
              lineNumber: 1197
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { position: "relative", width: "100%" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 1198
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "center"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1199
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  style: [{ flex: "0 1 33%" }, compact && styles.vehicleIcon(activeOptions === 0, compact)],
                  onClick: function onClick() {
                    _this6.updateActiveOptions(0);
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1204
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
                  { withDetails: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1213
                    }
                  },
                  optionsLeft.nameplate.name
                ),
                activeOptions === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.arrow, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1216
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { flex: "0 0 20%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1219
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  style: [{ flex: "0 1 33%" }, compact && styles.vehicleIcon(activeOptions === 1, compact)],
                  onClick: function onClick() {
                    _this6.updateActiveOptions(1);
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1220
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
                  { withDetails: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1229
                    }
                  },
                  optionsRight.nameplate.name
                ),
                activeOptions === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.arrow, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1232
                  }
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
          { horizontalPadding: compact ? false : true, __source: {
              fileName: _jsxFileName,
              lineNumber: 1239
            }
          },
          compact ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: [styles.options(false), { backgroundColor: "#f5f5f5" }], __source: {
                fileName: _jsxFileName,
                lineNumber: 1241
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { flex: "0 1 90%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1242
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderSelection, {
                options: this.state[!activeOptions ? "optionsLeft" : "optionsRight"],
                onChange: !activeOptions ? this.handleChangeOptionLeft : this.handleChangeOptionRight,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1243
                }
              }),
              this.renderSafetyModelOption(!activeOptions)
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.options(false), __source: {
                fileName: _jsxFileName,
                lineNumber: 1259
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { "data-test": "selection-left", style: { flex: "0 1 33%", width: "33%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1260
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderSelection, {
                options: optionsLeft,
                onChange: this.handleChangeOptionLeft,
                heading: true,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1261
                }
              }),
              this.renderSafetyModelOption()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { flex: "0 1 33%", width: "33%" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 1268
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { "data-test": "selection-right", style: { flex: "0 1 33%", width: "33%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1269
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderSelection, {
                options: optionsRight,
                onChange: this.handleChangeOptionRight,
                heading: true,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1270
                }
              }),
              this.renderSafetyModelOption(false)
            )
          ),
          this.state.isModalOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["Z" /* Modal */],
            {
              width: "600px",
              handleClose: function handleClose() {
                _this6.setState({ isModalOpen: false });
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 1281
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], { xmlString: safetyModelBlurb, textAlign: "left", __source: {
                fileName: _jsxFileName,
                lineNumber: 1286
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              {
                styleName: "black",
                onClick: function onClick() {
                  _this6.setState({ isModalOpen: false });
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1287
                }
              },
              "Close"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.pricing, __source: {
              fileName: _jsxFileName,
              lineNumber: 1300
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1301
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                ref: function ref(c) {
                  _this6.priceBarEl = c;
                },
                style: { display: "flex", justifyContent: "center", width: '100%' }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1302
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderPrice, {
                dataTest: "price-left",
                selected: activeOptions === 0,
                displayPrice: !!optionsLeft.engine,
                compact: compact,
                safetyModel: form.safetyModelLeft.value,
                onClickPriceDisclaimer: function onClickPriceDisclaimer() {
                  return _this6.onClickPriceDisclaimer("FED014", _this6.state.optionsLeft);
                },
                price: price.data[0],
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1307
                }
              }),
              !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { flex: "0 0 33%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1321
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderPrice, {
                dataTest: "price-right",
                selected: activeOptions === 1,
                displayPrice: !!optionsRight.engine,
                compact: compact,
                safetyModel: form.safetyModelRight.value,
                onClickPriceDisclaimer: function onClickPriceDisclaimer() {
                  return _this6.onClickPriceDisclaimer("FED015", _this6.state.optionsRight);
                },
                price: price.data[1],
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1322
                }
              })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
        { horizontalPadding: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 1340
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { width: '100%' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 1341
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["C" /* H5 */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1342
              }
            },
            "Vehicle specifications"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { center: true, show: true, checkbox: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 1343
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
              label: "Only show differences"
            }, Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "showDifferences"), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1344
              }
            }))
          ),
          specifications.data && specifications.data.categories.map(function (category, index) {
            var differentItems = [];
            if (category.items && category.items.length && form.showDifferences.value) {
              differentItems = category.items.filter(function (item) {
                return item.contentA !== item.contentB;
              });
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_AtomicContainers__["b" /* AccordionText */],
              {
                styleName: "box",
                isExpandedByDefault: 1,
                titleTextAlign: "center",
                title: category.name,
                key: index,
                status: 1, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1355
                }
              },
              form.showDifferences.value && optionsLeft.engine && optionsRight.engine ? differentItems.length ? differentItems.map(function (item, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DuoLine, _extends({
                  compact: compact
                }, item, {
                  key: i,
                  showLeft: !!optionsLeft.engine,
                  showRight: !!optionsRight.engine,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1369
                  }
                }));
              }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { padding: "2em 0", textAlign: "center" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1377
                  }
                },
                "There are no differences for your selection."
              ) : category.items && category.items.length && category.items.map(function (item, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DuoLine, _extends({
                  compact: compact
                }, item, {
                  key: i,
                  showLeft: !!optionsLeft.engine,
                  showRight: !!optionsRight.engine,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1385
                  }
                }));
              })
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VehicleCTAs, {
        isLeftCTAsVisible: !!this.state.optionsLeft.engine,
        isRightCTAsVisible: !!this.state.optionsRight.engine,
        findDealerUrl: findDealerUrl,
        vehicleLeft: this.state.optionsLeft,
        vehicleRight: this.state.optionsRight,
        activeOptions: activeOptions,
        compact: compact,
        onClickCTA: this.onClickCTA,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1400
        }
      }),
      components && components.length ? Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_componentParser__["a" /* default */])(components) : null
    );
  };

  return CompareTool;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CompareTool.displayName = "CompareTool";
CompareTool.propTypes = {
  vehicles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  initialResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  findDealerUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideLinks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  priceApiEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  specsApiEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  savedCompareEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sharedCompareEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locationState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  specifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
    update: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    setOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
    update: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    setOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["g" /* SearchParams */])({
  exposeParams: ["cars", "selectionLeft", "selectionRight", "bodyStyleLeft", "gradeLeft", "engineLeft", "modelCodeLeft", "bodyStyleRight", "gradeRight", "engineRight", "modelCodeRight"]
}), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["a" /* ConnectLocation */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["i" /* gtmEvent */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["e" /* Price */])({ expose: "price" }), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["h" /* Specs */])({ expose: "specifications" }))(CompareTool));

var styles = {
  base: {
    boxSizing: "border-box"
  },
  options: function options(sticky) {
    return {
      display: "flex",
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center",
      padding: sticky ? "1.5em 0" : 0,
      width: '100%'
    };
  },
  vehicleIcon: function vehicleIcon(selected, compact) {
    return {
      opacity: selected ? 1 : compact ? 0.5 : 1,
      cursor: "pointer"
    };
  },
  header: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    width: '100%',
    height: '100%',
    justifyContent: "center"
  },
  pricing: {
    background: "#565c65",
    alignItems: "space-around",
    color: "white"
  },
  safetyModel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #D5D5D5",
    minHeight: "49px"
  },
  infoIcon: {
    height: "16px",
    width: "16px",
    fill: "#999999",
    paddingLeft: "6px",
    cursor: "pointer",
    verticalAlign: "middle"
  },
  arrow: {
    width: 0,
    height: 0,
    margin: "0 auto",
    borderLeft: "10px solid transparent",
    borderRight: "10px solid transparent",
    borderBottom: "10px solid #f5f5f5"
  }
};

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



/* Ducks is a modular redux model where you put a duck.js file
in the same folder of the react component that uses it.
More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  BOOK_TESTDRIVE_CLICK_BOOK_TEST_DRIVE: "BOOK_TESTDRIVE_BTDF_CLICK_BOOK_TEST_DRIVE",
  BOOK_TESTDRIVE_CLICK_SUBMIT: "BOOK_TESTDRIVE_BTDF_CLICK_SUBMIT",
  BOOK_TESTDRIVE_SELECT_MODEL: "BOOK_TESTDRIVE_BTDF_SELECT_MODEL",
  BOOK_TESTDRIVE_SELECT_TITLE: "BOOK_TESTDRIVE_BTDF_SELECT_TITLE",
  BOOK_TESTDRIVE_ENTER_FIRSTNAME: "BOOK_TESTDRIVE_BTDF_ENTER_FIRSTNAME",
  BOOK_TESTDRIVE_ENTER_LASTNAME: "BOOK_TESTDRIVE_BTDF_ENTER_LASTNAME",
  BOOK_TESTDRIVE_ENTER_PHONE: "BOOK_TESTDRIVE_BTDF_ENTER_PHONE",
  BOOK_TESTDRIVE_ENTER_EMAIL: "BOOK_TESTDRIVE_BTDF_ENTER_EMAIL",
  BOOK_TESTDRIVE_SELECT_POSTCODE_SUBURB: "BOOK_TESTDRIVE_BTDF_SELECT_POSTCODE_SUBURB",
  BOOK_TESTDRIVE_DEALER_CLICK_ADDRESS: "BOOK_TESTDRIVE_BTDF_DEALER_CLICK_ADDRESS",
  BOOK_TESTDRIVE_DEALER_CLICK_WEBSITE: "BOOK_TESTDRIVE_BTDF_DEALER_CLICK_WEBSITE",
  BOOK_TESTDRIVE_DEALER_CLICK_PHONE: "BOOK_TESTDRIVE_BTDF_DEALER_CLICK_PHONE",
  BOOK_TESTDRIVE_ENTER_COMMENTS: "BOOK_TESTDRIVE_BTDF_ENTER_COMMENTS",
  BOOK_TESTDRIVE_CHECK_OPTIN: "BOOK_TESTDRIVE_BTDF_CHECK_OPTIN",
  BOOK_TESTDRIVE_CHECK_PRIVACY_POLICY: "BOOK_TESTDRIVE_BTDF_CHECK_PRIVACY_POLICY",
  BOOK_TESTDRIVE_CLICK_PRIVACY_POLICY: "BOOK_TESTDRIVE_BTDF_CLICK_PRIVACY_POLICY",
  BOOK_TESTDRIVE_CLICK_GO_BACK: "BOOK_TESTDRIVE_BTDF_CLICK_GO_BACK"

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CLICK_BOOK_TEST_DRIVE] = function (_ref) {
  var _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === undefined ? "" : _ref$buttonText;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_BOOK_TEST_DRIVE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-001",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CLICK_SUBMIT] = function (_ref2) {
  var _ref2$model = _ref2.model,
      model = _ref2$model === undefined ? "" : _ref2$model;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_SUBMIT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-002",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Clicked Submitted - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_SELECT_MODEL] = function (_ref3) {
  var _ref3$model = _ref3.model,
      model = _ref3$model === undefined ? "" : _ref3$model;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_SELECT_MODEL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-003",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Selected \"MODEL - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_SELECT_TITLE] = function (_ref4) {
  var _ref4$model = _ref4.model,
      model = _ref4$model === undefined ? "" : _ref4$model;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_SELECT_TITLE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-004",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Selected \"TITLE\" - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_ENTER_FIRSTNAME] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_FIRSTNAME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-005",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Entered \"FIRSTNAME\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_ENTER_LASTNAME] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_LASTNAME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-006",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Entered \"LASTNAME\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_ENTER_PHONE] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_PHONE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-007",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Entered \"PHONE\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_ENTER_EMAIL] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_EMAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-008",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Entered \"EMAIL\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_SELECT_POSTCODE_SUBURB] = function (_ref5) {
  var _ref5$model = _ref5.model,
      model = _ref5$model === undefined ? "" : _ref5$model;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_SELECT_POSTCODE_SUBURB,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-009",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Selected \"POSTCODE/SUBURB\" - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_ADDRESS] = function (_ref6) {
  var dealerName = _ref6.dealerName,
      address = _ref6.address;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_ADDRESS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-010",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - " + dealerName + " - Address \"" + address + "\" - Clicked \"ADDRESS\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_WEBSITE] = function (_ref7) {
  var dealerName = _ref7.dealerName,
      address = _ref7.address,
      website = _ref7.website;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_WEBSITE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-011",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - " + dealerName + " - Address \"" + address + "\" - Clicked \"WEBSITE " + website + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_PHONE] = function (_ref8) {
  var dealerName = _ref8.dealerName,
      address = _ref8.address,
      phone = _ref8.phone;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_PHONE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-012",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - " + dealerName + " - Address " + address + " - Clicked \"PHONE " + phone + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_ENTER_COMMENTS] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_COMMENTS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-013",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Entered \"COMMENTS\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CHECK_OPTIN] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CHECK_OPTIN,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-014",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Checked \"OPTIN\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CHECK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CHECK_PRIVACY_POLICY,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-015",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Checked \"PRIVACYPOLICY\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CLICK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_PRIVACY_POLICY,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-016",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Clicked \"PRIVACYPOLICY\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CLICK_GO_BACK] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_GO_BACK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-BTDF-017",
    pageCategory: "Book A Test Drive Form",
    pageAction: "Book A Test Drive Form - Clicked \"GO BACK\""
  };
}, _gtmEvents);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



// Action types
var gtmEventTypes = {
  COMPARE_TOOL_CHANGE_SELECTION: "COMPARE_TOOL_CHANGE_SELECTION",
  COMPARE_TOOL_TOGGLE_ACCORDION: "COMPARE_TOOL_TOGGLE_ACCORDION",
  COMPARE_TOOL_CLICK_CTA: "COMPARE_TOOL_CLICK_CTA",
  COMPARE_TOOL_CLICK_PRICE_DISCLAIMER: "COMPARE_TOOL_CLICK_PRICE_DISCLAIMER"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.COMPARE_TOOL_CHANGE_SELECTION] = function (_ref) {
  var eventID = _ref.eventID,
      actionMessage = _ref.actionMessage;
  return {
    type: gtmEventTypes.CHANGE_SELECTION,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: eventID,
    pageCategory: "Compare Tool",
    pageAction: actionMessage
  };
}, _gtmEvents[gtmEventTypes.COMPARE_TOOL_TOGGLE_ACCORDION] = function (_ref2) {
  var eventID = _ref2.eventID,
      actionMessage = _ref2.actionMessage;
  return {
    type: gtmEventTypes.TOGGLE_ACCORDION,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: eventID,
    pageCategory: "Compare Tool",
    pageAction: actionMessage
  };
}, _gtmEvents[gtmEventTypes.COMPARE_TOOL_CLICK_CTA] = function (_ref3) {
  var eventID = _ref3.eventID,
      actionMessage = _ref3.actionMessage;
  return {
    type: gtmEventTypes.CLICK_CTA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: eventID,
    pageCategory: "Compare Tool",
    pageAction: actionMessage
  };
}, _gtmEvents[gtmEventTypes.COMPARE_TOOL_CLICK_PRICE_DISCLAIMER] = function (_ref4) {
  var eventID = _ref4.eventID,
      actionMessage = _ref4.actionMessage;
  return {
    type: gtmEventTypes.CLICK_PRICE_DISCLAIMER,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: eventID,
    pageCategory: "Compare Tool",
    pageAction: actionMessage
  };
}, _gtmEvents);

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE: "COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE] = function (_ref) {
  var model1 = _ref.model1,
      model2 = _ref.model2;
  return {
    type: gtmEventTypes.CLICK_COMPARE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED001",
    pageCategory: "Compare Tool",
    pageAction: "Compare Home - Clicked Compare Cars \"" + model1.toUpperCase() + "\" and \"" + model2.toUpperCase() + "\""
  };
}, _gtmEvents);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// GTM event driven by the CMS
var gtmEventTypes = {
  BADGE_CLICK: "CMS-GLH-001",
  CLICK_ICON: "CMS-GLH-002",
  NAV_LINK_CLICK: "CMS-GLH-003",
  NAV_LINK_SECONDARY_CLICK: "CMS-GLH-004",
  HAMBURGER_EXPAND: "CMS-GLH-005",
  HAMBURGER_COLLAPSE: "CMS-GLH-006",
  OVERLAY_CLOSED: "CMS-GLH-007",
  CLOSED_MORE: "CMS-GLH-008"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.BADGE_CLICK] = function () {
  return {
    type: gtmEventTypes.BADGE_CLICK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BADGE_CLICK,
    pageCategory: "Header Nav",
    pageAction: "Nav - Clicked home badge"
  };
}, _gtmEvents[gtmEventTypes.CLICK_ICON] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      itemName = _ref.itemName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_ICON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action + " - Clicked \"" + itemName.toUpperCase() + "\""
  });
}, _gtmEvents[gtmEventTypes.NAV_LINK_CLICK] = function (_ref2) {
  var CMSGroupGTM = _ref2.CMSGroupGTM;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.NAV_LINK_CLICK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action
  });
}, _gtmEvents[gtmEventTypes.NAV_LINK_SECONDARY_CLICK] = function (_ref3) {
  var CMSGroupGTM = _ref3.CMSGroupGTM;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.NAV_LINK_SECONDARY_CLICK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action
  });
}, _gtmEvents[gtmEventTypes.HAMBURGER_EXPAND] = function () {
  return {
    type: gtmEventTypes.HAMBURGER_EXPAND,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.HAMBURGER_EXPAND,
    pageCategory: "Header Nav",
    pageAction: "Nav - Expanded hamburger menu"
  };
}, _gtmEvents[gtmEventTypes.HAMBURGER_COLLAPSE] = function () {
  return {
    type: gtmEventTypes.HAMBURGER_COLLAPSE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.HAMBURGER_COLLAPSE,
    pageCategory: "Header Nav",
    pageAction: "Nav - Collapsed hamburger menu"
  };
}, _gtmEvents[gtmEventTypes.OVERLAY_CLOSED] = function (_ref4) {
  var CMSGroupGTM = _ref4.CMSGroupGTM;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.OVERLAY_CLOSED,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action
  });
}, _gtmEvents[gtmEventTypes.CLOSED_MORE] = function () {
  return {
    type: gtmEventTypes.CLOSED_MORE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLOSED_MORE,
    pageCategory: "Header Nav",
    pageAction: "Nav  - Closed \"MORE\""
  };
}, _gtmEvents);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// Action types
var gtmEventTypes = {
  SOCIAL_ICON_CLICK: "FED-GLF-001",
  CLICKED_EDIT_POSTCODE: "FED-GLF-002",
  CLICKED_FOOTER_LINK: "CMS-GLF-003"

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.SOCIAL_ICON_CLICK] = function (_ref) {
  var platform = _ref.platform;
  return {
    type: gtmEventTypes.SOCIAL_ICON_CLICK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SOCIAL_ICON_CLICK,
    pageCategory: "Footer Nav",
    pageAction: "Footer - Clicked \"" + platform.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICKED_EDIT_POSTCODE] = function () {
  return {
    type: gtmEventTypes.CLICKED_EDIT_POSTCODE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICKED_EDIT_POSTCODE,
    pageCategory: "Footer Nav",
    pageAction: "Footer - Selected Change Postcode"
  };
}, _gtmEvents[gtmEventTypes.CLICKED_FOOTER_LINK] = function (_ref2) {
  var CMSGroupGTM = _ref2.CMSGroupGTM;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICKED_FOOTER_LINK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action
  });
}, _gtmEvents);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



/* Ducks is a modular redux model where you put a duck.js file
in the same folder of the react component that uses it.
More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  CONTACT_US_SELECT_TOPIC: "CONTACT_US_GITF_SELECT_TOPIC",
  CONTACT_US_SELECT_TITLE: "CONTACT_US_GITF_SELECT_TITLE",
  CONTACT_US_ENTER_FIRSTNAME: "CONTACT_US_GITF_ENTER_FIRSTNAME",
  CONTACT_US_ENTER_LASTNAME: "CONTACT_US_GITF_ENTER_LASTNAME",
  CONTACT_US_ENTER_PHONE: "CONTACT_US_GITF_ENTER_PHONE",
  CONTACT_US_ENTER_EMAIL: "CONTACT_US_GITF_ENTER_EMAIL",
  CONTACT_US_ENTER_ENQUIRY: "CONTACT_US_GITF_ENTER_ENQUIRY",
  CONTACT_US_ENTER_REGISTRATION_OR_VIN: "CONTACT_US_GITF_ENTER_REGISTRATION_OR_VIN",
  CONTACT_US_ENTER_ADDRESS: "CONTACT_US_GITF_ENTER_ADDRESS",
  CONTACT_US_SELECT_POSTCODE_SUBURB: "CONTACT_US_GITF_SELECT_POSTCODE_SUBURB",
  CONTACT_US_ENTER_OLD_VIN_REGO: "CONTACT_US_GITF_ENTER_OLD_VIN_REGO",
  CONTACT_US_ENTER_CURRENT_VIN_REGO: "CONTACT_US_GITF_ENTER_CURRENT_VIN_REGO",
  CONTACT_US_CHECK_PRIVACY_POLICY: "CONTACT_US_GITF_CHECK_PRIVACY_POLICY",
  CONTACT_US_CLICK_PRIVACY_POLICY: "CONTACT_US_GITF_CLICK_PRIVACY_POLICY",
  CONTACT_US_CLICK_GO_BACK: "CONTACT_US_GITF_CLICK_GO_BACK",
  CONTACT_US_CLICK_SUBMIT: "CONTACT_US_GITF_CLICK_SUBMIT"

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CONTACT_US_SELECT_TOPIC] = function (_ref) {
  var _ref$model = _ref.model,
      model = _ref$model === undefined ? "" : _ref$model;
  return {
    type: gtmEventTypes.CONTACT_US_SELECT_TOPIC,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-001",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Selected \"TOPIC\" - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_SELECT_TITLE] = function (_ref2) {
  var _ref2$model = _ref2.model,
      model = _ref2$model === undefined ? "" : _ref2$model;
  return {
    type: gtmEventTypes.CONTACT_US_SELECT_TITLE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-002",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Selected \"TITLE\" - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_FIRSTNAME] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_FIRSTNAME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-003",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"FIRSTNAME\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_LASTNAME] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_LASTNAME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-004",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"LASTNAME\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_PHONE] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_PHONE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-005",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"PHONE\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_EMAIL] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_EMAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-006",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"EMAIL\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_ENQUIRY] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_ENQUIRY,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-007",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"ENQUIRY\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_REGISTRATION_OR_VIN] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_REGISTRATION_OR_VIN,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-008",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"REGISTRATION OR VIN\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_ADDRESS] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_ADDRESS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-009",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"ADDRESS\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_SELECT_POSTCODE_SUBURB] = function (_ref3) {
  var _ref3$model = _ref3.model,
      model = _ref3$model === undefined ? "" : _ref3$model;
  return {
    type: gtmEventTypes.CONTACT_US_SELECT_POSTCODE_SUBURB,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-010",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Selected \"POSTCODE/SUBURB\" - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_OLD_VIN_REGO] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_OLD_VIN_REGO,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-011",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"OLDVINREGO\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_CURRENT_VIN_REGO] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_CURRENT_VIN_REGO,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-012",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"CURRENTVINREGO\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_CHECK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_CHECK_PRIVACY_POLICY,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-013",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Checked \"PRIVACYPOLICY\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_CLICK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_CLICK_PRIVACY_POLICY,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-014",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Clicked \"PRIVACYPOLICY\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_CLICK_SUBMIT] = function (_ref4) {
  var _ref4$model = _ref4.model,
      model = _ref4$model === undefined ? "" : _ref4$model;
  return {
    type: gtmEventTypes.CONTACT_US_CLICK_SUBMIT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-015",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Clicked \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_CLICK_GO_BACK] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_CLICK_GO_BACK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-GITF-016",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Clicked \"GO BACK\""
  };
}, _gtmEvents);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var gtmEventTypes = {
  CLICK_BUTTON: "ACCESSORY_LIST_CLICK_BUTTON"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_BUTTON] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      ctaName = _ref.ctaName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_BUTTON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action + " - Clicked \"" + ctaName.toUpperCase() + "\""
  });
}, _gtmEvents);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// This is GTM events for Accordion block in the CMS

var gtmEventTypes = {
  EXPAND_ACCORDION: "CMS-ACCORDION-001",
  COLLAPSE_ACCORDION: "CMS-ACCORDION-002"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.EXPAND_ACCORDION] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      accordionName = _ref.accordionName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.EXPAND_ACCORDION,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action + " - Expanded \"" + accordionName.toUpperCase() + "\""
  });
}, _gtmEvents[gtmEventTypes.COLLAPSE_ACCORDION] = function (_ref2) {
  var CMSGroupGTM = _ref2.CMSGroupGTM,
      accordionName = _ref2.accordionName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.COLLAPSE_ACCORDION,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action + " - Collapsed \"" + accordionName.toUpperCase() + "\""
  });
}, _gtmEvents);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// CMS GTM for Backgroun Image Selector
var gtmEventTypes = {
  CLICK_IMAGE: "CMS-BACKGROUNDIMAGESELECTOR-001"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_IMAGE] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      imageName = _ref.imageName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_IMAGE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action + " - Clicked \"" + imageName.toUpperCase() + "\""
  });
}, _gtmEvents);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



/* Ducks is a modular redux model where you put a duck.js file
in the same folder of the react component that uses it.
More info: https://github.com/erikras/ducks-modular-redux
 */

var gtmEventTypes = {
  FED_BUILDTOOL_002: "FED_BUILDTOOL_002",
  BUILDTOOL_LOAD_CONFIG: "FED-BUILDTOOL-003",
  BUILDTOOL_STEP_BODY_CHANGE: "FED-BUILDTOOL-004",
  BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON: "FED-BUILDTOOL-005",
  BUILDTOOL_CLICKED_SIDE_NAV: "FED-BUILDTOOL-006",
  BUILDTOOL_STEP_DRIVE_CHANGE: "FED-BUILDTOOL-007",
  BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON: "FED-BUILDTOOL-008",
  BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON: "FED-BUILDTOOL-009",
  BUILDTOOL_STEP_GRADE_CHANGE: "FED-BUILDTOOL-010",
  BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON: "FED-BUILDTOOL-011",
  BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON: "FED-BUILDTOOL-012",
  BUILDTOOL_STEP_COLOR_CHANGE: "FED-BUILDTOOL-013",
  BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR: "FED-BUILDTOOL-014",
  BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR: "FED-BUILDTOOL-015",
  BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS: "FED-BUILDTOOL-016",
  BUILDTOOL_STEP_COLOR_CLICKED_NEXT: "FED-BUILDTOOL-017",
  BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS: "FED-BUILDTOOL-018",
  BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE: "FED-BUILDTOOL-019",
  BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON: "FED-BUILDTOOL-020",
  BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS: "FED-BUILDTOOL-021",
  FED_BUILDTOOL_022: "FED-BUILDTOOL-022",
  FED_BUILDTOOL_023: "FED-BUILDTOOL-023",
  FED_BUILDTOOL_024: "FED-BUILDTOOL-024",
  BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST: "FED-BUILDTOOL-025",
  BUILDTOOL_CLICKED_PRICE_DISCLAIMER: "FED-BUILDTOOL-026",
  BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER: "FED-BUILDTOOL-027",
  BUILDTOOL_CLICKED_SAVE: "FED-BUILDTOOL-028",
  BUILDTOOL_SEND_SAVE_FORM: "FED-BUILDTOOL-029",
  BUILDTOOL_CLICKED_COPY_URL: "FED-BUILDTOOL-030",
  BUILDTOOL_CLICKED_SHARE: "FED-BUILDTOOL-031",
  BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT: "FED-BUILDTOOL-032",
  BUILDTOOL_SEND_SHARE_FORM: "FED-BUILDTOOL-033"
};

var getShortModel = function getShortModel(modelName) {
  return (modelName.split(" ")[1] || modelName.split(" ")[0]).toUpperCase();
};

// Action creators => EventsMap
var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.BUILDTOOL_LOAD_CONFIG] = function (_ref) {
  var _ref$modelName = _ref.modelName,
      modelName = _ref$modelName === undefined ? "" : _ref$modelName,
      _ref$stepNumber = _ref.stepNumber,
      stepNumber = _ref$stepNumber === undefined ? "" : _ref$stepNumber,
      _ref$stepName = _ref.stepName,
      stepName = _ref$stepName === undefined ? "" : _ref$stepName,
      _ref$bodyName = _ref.bodyName,
      bodyName = _ref$bodyName === undefined ? "" : _ref$bodyName,
      _ref$driveName = _ref.driveName,
      driveName = _ref$driveName === undefined ? "" : _ref$driveName,
      _ref$gradeName = _ref.gradeName,
      gradeName = _ref$gradeName === undefined ? "" : _ref$gradeName,
      _ref$colorName = _ref.colorName,
      colorName = _ref$colorName === undefined ? "" : _ref$colorName,
      _ref$interiorName = _ref.interiorName,
      interiorName = _ref$interiorName === undefined ? "" : _ref$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_LOAD_CONFIG,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_LOAD_CONFIG,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " " + stepName + " - \"" + bodyName.toUpperCase() + "\" - \"" + driveName.toUpperCase() + "\" - \"" + gradeName.toUpperCase() + "\" - \"" + colorName.toUpperCase() + "\" - \"" + interiorName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_SIDE_NAV] = function (_ref2) {
  var _ref2$modelName = _ref2.modelName,
      modelName = _ref2$modelName === undefined ? "" : _ref2$modelName,
      _ref2$stepNumber = _ref2.stepNumber,
      stepNumber = _ref2$stepNumber === undefined ? "" : _ref2$stepNumber,
      _ref2$stepName = _ref2.stepName,
      stepName = _ref2$stepName === undefined ? "" : _ref2$stepName,
      _ref2$newStepName = _ref2.newStepName,
      newStepName = _ref2$newStepName === undefined ? "" : _ref2$newStepName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_SIDE_NAV,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_SIDE_NAV,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" Step " + stepNumber + " " + stepName + " - Clicked side step nav \"" + newStepName + "\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_BODY_CHANGE] = function (_ref3) {
  var _ref3$modelName = _ref3.modelName,
      modelName = _ref3$modelName === undefined ? "" : _ref3$modelName,
      _ref3$stepNumber = _ref3.stepNumber,
      stepNumber = _ref3$stepNumber === undefined ? "" : _ref3$stepNumber,
      _ref3$bodyName = _ref3.bodyName,
      bodyName = _ref3$bodyName === undefined ? "" : _ref3$bodyName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_BODY_CHANGE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_BODY_CHANGE,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" Step " + stepNumber + " BODY - Clicked \"" + bodyName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON] = function (_ref4) {
  var _ref4$modelName = _ref4.modelName,
      modelName = _ref4$modelName === undefined ? "" : _ref4$modelName,
      _ref4$stepNumber = _ref4.stepNumber,
      stepNumber = _ref4$stepNumber === undefined ? "" : _ref4$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " BODY - Clicked \"NEXT STEP\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_DRIVE_CHANGE] = function (_ref5) {
  var _ref5$modelName = _ref5.modelName,
      modelName = _ref5$modelName === undefined ? "" : _ref5$modelName,
      _ref5$stepNumber = _ref5.stepNumber,
      stepNumber = _ref5$stepNumber === undefined ? "" : _ref5$stepNumber,
      _ref5$driveName = _ref5.driveName,
      driveName = _ref5$driveName === undefined ? "" : _ref5$driveName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CHANGE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CHANGE,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " DRIVE - Clicked drive\"" + driveName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON] = function (_ref6) {
  var _ref6$modelName = _ref6.modelName,
      modelName = _ref6$modelName === undefined ? "" : _ref6$modelName,
      _ref6$stepNumber = _ref6.stepNumber,
      stepNumber = _ref6$stepNumber === undefined ? "" : _ref6$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " DRIVE - Clicked \"PREVIOUS\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON] = function (_ref7) {
  var _ref7$modelName = _ref7.modelName,
      modelName = _ref7$modelName === undefined ? "" : _ref7$modelName,
      _ref7$stepNumber = _ref7.stepNumber,
      stepNumber = _ref7$stepNumber === undefined ? "" : _ref7$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " DRIVE - Clicked \"NEXT STEP\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_GRADE_CHANGE] = function (_ref8) {
  var _ref8$modelName = _ref8.modelName,
      modelName = _ref8$modelName === undefined ? "" : _ref8$modelName,
      _ref8$stepNumber = _ref8.stepNumber,
      stepNumber = _ref8$stepNumber === undefined ? "" : _ref8$stepNumber,
      _ref8$gradeName = _ref8.gradeName,
      gradeName = _ref8$gradeName === undefined ? "" : _ref8$gradeName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_GRADE_CHANGE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_GRADE_CHANGE,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " GRADE - Clicked grade \"" + gradeName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON] = function (_ref9) {
  var _ref9$modelName = _ref9.modelName,
      modelName = _ref9$modelName === undefined ? "" : _ref9$modelName,
      _ref9$stepNumber = _ref9.stepNumber,
      stepNumber = _ref9$stepNumber === undefined ? "" : _ref9$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " GRADE - Clicked \"NEXT STEP\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON] = function (_ref10) {
  var _ref10$modelName = _ref10.modelName,
      modelName = _ref10$modelName === undefined ? "" : _ref10$modelName,
      _ref10$stepNumber = _ref10.stepNumber,
      stepNumber = _ref10$stepNumber === undefined ? "" : _ref10$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " GRADE - Clicked \"PREVIOUS\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE] = function (_ref11) {
  var _ref11$modelName = _ref11.modelName,
      modelName = _ref11$modelName === undefined ? "" : _ref11$modelName,
      _ref11$stepNumber = _ref11.stepNumber,
      stepNumber = _ref11$stepNumber === undefined ? "" : _ref11$stepNumber,
      _ref11$colorName = _ref11.colorName,
      colorName = _ref11$colorName === undefined ? "" : _ref11$colorName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " COLOUR - Clicked \"" + colorName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR] = function (_ref12) {
  var _ref12$modelName = _ref12.modelName,
      modelName = _ref12$modelName === undefined ? "" : _ref12$modelName,
      _ref12$stepNumber = _ref12.stepNumber,
      stepNumber = _ref12$stepNumber === undefined ? "" : _ref12$stepNumber,
      _ref12$typeName = _ref12.typeName,
      typeName = _ref12$typeName === undefined ? "" : _ref12$typeName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " COLOUR - Clicked \"" + typeName + "\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR] = function (_ref13) {
  var _ref13$modelName = _ref13.modelName,
      modelName = _ref13$modelName === undefined ? "" : _ref13$modelName,
      _ref13$stepNumber = _ref13.stepNumber,
      stepNumber = _ref13$stepNumber === undefined ? "" : _ref13$stepNumber,
      _ref13$interiorName = _ref13.interiorName,
      interiorName = _ref13$interiorName === undefined ? "" : _ref13$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " INTERIOR COLOUR - Clicked \"" + interiorName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS] = function (_ref14) {
  var _ref14$modelName = _ref14.modelName,
      modelName = _ref14$modelName === undefined ? "" : _ref14$modelName,
      _ref14$stepNumber = _ref14.stepNumber,
      stepNumber = _ref14$stepNumber === undefined ? "" : _ref14$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " COLOUR - Clicked \"PREVIOUS\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_NEXT] = function (_ref15) {
  var _ref15$modelName = _ref15.modelName,
      modelName = _ref15$modelName === undefined ? "" : _ref15$modelName,
      _ref15$stepNumber = _ref15.stepNumber,
      stepNumber = _ref15$stepNumber === undefined ? "" : _ref15$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_NEXT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_NEXT,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " COLOUR - Clicked \"NEXT STEP\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS] = function (_ref16) {
  var _ref16$modelName = _ref16.modelName,
      modelName = _ref16$modelName === undefined ? "" : _ref16$modelName,
      _ref16$stepNumber = _ref16.stepNumber,
      stepNumber = _ref16$stepNumber === undefined ? "" : _ref16$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " SUMMARY - Clicked \"PREVIOUS\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE] = function (_ref17) {
  var _ref17$modelName = _ref17.modelName,
      modelName = _ref17$modelName === undefined ? "" : _ref17$modelName,
      _ref17$stepNumber = _ref17.stepNumber,
      stepNumber = _ref17$stepNumber === undefined ? "" : _ref17$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " SUMMARY - Clicked \"BOOK A TEST DRIVE\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON] = function (_ref18) {
  var _ref18$modelName = _ref18.modelName,
      modelName = _ref18$modelName === undefined ? "" : _ref18$modelName,
      _ref18$stepNumber = _ref18.stepNumber,
      stepNumber = _ref18$stepNumber === undefined ? "" : _ref18$stepNumber,
      newStepNumber = _ref18.newStepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " SUMMARY - Clicked \"EDIT SUMMARY ITEM STEP " + newStepNumber + "\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS] = function (_ref19) {
  var _ref19$modelName = _ref19.modelName,
      modelName = _ref19$modelName === undefined ? "" : _ref19$modelName,
      _ref19$stepNumber = _ref19.stepNumber,
      stepNumber = _ref19$stepNumber === undefined ? "" : _ref19$stepNumber,
      _ref19$newStatusName = _ref19.newStatusName,
      newStatusName = _ref19$newStatusName === undefined ? "" : _ref19$newStatusName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " SUMMARY - " + newStatusName
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER] = function (_ref20) {
  var _ref20$modelName = _ref20.modelName,
      modelName = _ref20$modelName === undefined ? "" : _ref20$modelName,
      _ref20$stepNumber = _ref20.stepNumber,
      stepNumber = _ref20$stepNumber === undefined ? "" : _ref20$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " SUMMARY - Clicked \"FEATURE SPECS DISCLAIMER\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST] = function (_ref21) {
  var _ref21$modelName = _ref21.modelName,
      modelName = _ref21$modelName === undefined ? "" : _ref21$modelName,
      _ref21$stepNumber = _ref21.stepNumber,
      stepNumber = _ref21$stepNumber === undefined ? "" : _ref21$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " SUMMARY - Clicked \"EXPLORE FULL " + getShortModel(modelName) + " SPECIFICATION\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_PRICE_DISCLAIMER] = function (_ref22) {
  var _ref22$modelName = _ref22.modelName,
      modelName = _ref22$modelName === undefined ? "" : _ref22$modelName,
      _ref22$stepNumber = _ref22.stepNumber,
      stepNumber = _ref22$stepNumber === undefined ? "" : _ref22$stepNumber,
      _ref22$stepName = _ref22.stepName,
      stepName = _ref22$stepName === undefined ? "" : _ref22$stepName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_PRICE_DISCLAIMER,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_PRICE_DISCLAIMER,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\" - Step " + stepNumber + " " + stepName + " - Clicked \"PRICE DISCLAIMER\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_SAVE] = function (_ref23) {
  var _ref23$modelName = _ref23.modelName,
      modelName = _ref23$modelName === undefined ? "" : _ref23$modelName,
      _ref23$stepNumber = _ref23.stepNumber,
      stepNumber = _ref23$stepNumber === undefined ? "" : _ref23$stepNumber,
      _ref23$stepName = _ref23.stepName,
      stepName = _ref23$stepName === undefined ? "" : _ref23$stepName,
      _ref23$bodyName = _ref23.bodyName,
      bodyName = _ref23$bodyName === undefined ? "" : _ref23$bodyName,
      _ref23$driveName = _ref23.driveName,
      driveName = _ref23$driveName === undefined ? "" : _ref23$driveName,
      _ref23$gradeName = _ref23.gradeName,
      gradeName = _ref23$gradeName === undefined ? "" : _ref23$gradeName,
      _ref23$colorName = _ref23.colorName,
      colorName = _ref23$colorName === undefined ? "" : _ref23$colorName,
      _ref23$interiorName = _ref23.interiorName,
      interiorName = _ref23$interiorName === undefined ? "" : _ref23$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_SAVE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_SAVE,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\", \"" + bodyName + "\", \"" + driveName + "\", \"" + gradeName + "\", \"" + colorName + "\", \"" + interiorName + "\" - Step \"" + stepNumber + " " + stepName + "\" - Clicked \"SAVE\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_SEND_SAVE_FORM] = function (_ref24) {
  var _ref24$modelName = _ref24.modelName,
      modelName = _ref24$modelName === undefined ? "" : _ref24$modelName,
      _ref24$stepNumber = _ref24.stepNumber,
      stepNumber = _ref24$stepNumber === undefined ? "" : _ref24$stepNumber,
      _ref24$stepName = _ref24.stepName,
      stepName = _ref24$stepName === undefined ? "" : _ref24$stepName,
      _ref24$bodyName = _ref24.bodyName,
      bodyName = _ref24$bodyName === undefined ? "" : _ref24$bodyName,
      _ref24$driveName = _ref24.driveName,
      driveName = _ref24$driveName === undefined ? "" : _ref24$driveName,
      _ref24$gradeName = _ref24.gradeName,
      gradeName = _ref24$gradeName === undefined ? "" : _ref24$gradeName,
      _ref24$colorName = _ref24.colorName,
      colorName = _ref24$colorName === undefined ? "" : _ref24$colorName,
      _ref24$interiorName = _ref24.interiorName,
      interiorName = _ref24$interiorName === undefined ? "" : _ref24$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_SEND_SAVE_FORM,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_SEND_SAVE_FORM,
    pageCategory: "Build Save \"" + getShortModel(modelName) + "\"",
    pageAction: "Build Save \"" + getShortModel(modelName) + "\", \"" + bodyName + "\", \"" + driveName + "\", \"" + gradeName + "\", \"" + colorName + "\", \"" + interiorName + "\" - Step \"" + stepNumber + " " + stepName + "\" - Clicked \"SEND\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_COPY_URL] = function (_ref25) {
  var _ref25$modelName = _ref25.modelName,
      modelName = _ref25$modelName === undefined ? "" : _ref25$modelName,
      _ref25$stepNumber = _ref25.stepNumber,
      stepNumber = _ref25$stepNumber === undefined ? "" : _ref25$stepNumber,
      _ref25$stepName = _ref25.stepName,
      stepName = _ref25$stepName === undefined ? "" : _ref25$stepName,
      _ref25$bodyName = _ref25.bodyName,
      bodyName = _ref25$bodyName === undefined ? "" : _ref25$bodyName,
      _ref25$driveName = _ref25.driveName,
      driveName = _ref25$driveName === undefined ? "" : _ref25$driveName,
      _ref25$gradeName = _ref25.gradeName,
      gradeName = _ref25$gradeName === undefined ? "" : _ref25$gradeName,
      _ref25$colorName = _ref25.colorName,
      colorName = _ref25$colorName === undefined ? "" : _ref25$colorName,
      _ref25$interiorName = _ref25.interiorName,
      interiorName = _ref25$interiorName === undefined ? "" : _ref25$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_COPY_URL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_COPY_URL,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\", \"" + bodyName + "\", \"" + driveName + "\", \"" + gradeName + "\", \"" + colorName + "\", \"" + interiorName + "\" - Step \"" + stepNumber + " " + stepName + "\" - Clicked \"COPY URL\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_SHARE] = function (_ref26) {
  var _ref26$modelName = _ref26.modelName,
      modelName = _ref26$modelName === undefined ? "" : _ref26$modelName,
      _ref26$stepNumber = _ref26.stepNumber,
      stepNumber = _ref26$stepNumber === undefined ? "" : _ref26$stepNumber,
      _ref26$stepName = _ref26.stepName,
      stepName = _ref26$stepName === undefined ? "" : _ref26$stepName,
      _ref26$bodyName = _ref26.bodyName,
      bodyName = _ref26$bodyName === undefined ? "" : _ref26$bodyName,
      _ref26$driveName = _ref26.driveName,
      driveName = _ref26$driveName === undefined ? "" : _ref26$driveName,
      _ref26$gradeName = _ref26.gradeName,
      gradeName = _ref26$gradeName === undefined ? "" : _ref26$gradeName,
      _ref26$colorName = _ref26.colorName,
      colorName = _ref26$colorName === undefined ? "" : _ref26$colorName,
      _ref26$interiorName = _ref26.interiorName,
      interiorName = _ref26$interiorName === undefined ? "" : _ref26$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_SHARE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_SHARE,
    pageCategory: "Build Tool \"" + getShortModel(modelName) + "\"",
    pageAction: "Build \"" + getShortModel(modelName) + "\", \"" + bodyName + "\", \"" + driveName + "\", \"" + gradeName + "\", \"" + colorName + "\", \"" + interiorName + "\" - Step \"" + stepNumber + " " + stepName + "\" - Clicked \"SHARE\""
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT] = function (_ref27) {
  var _ref27$modelName = _ref27.modelName,
      modelName = _ref27$modelName === undefined ? "" : _ref27$modelName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT,
    pageCategory: "Build Share \"" + getShortModel(modelName) + "\"",
    pageAction: "Build Share \"" + getShortModel(modelName) + "\", Share - Clicked \"Add another recipient\"\n"
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_SEND_SHARE_FORM] = function (_ref28) {
  var _ref28$modelName = _ref28.modelName,
      modelName = _ref28$modelName === undefined ? "" : _ref28$modelName,
      _ref28$bodyName = _ref28.bodyName,
      bodyName = _ref28$bodyName === undefined ? "" : _ref28$bodyName,
      _ref28$driveName = _ref28.driveName,
      driveName = _ref28$driveName === undefined ? "" : _ref28$driveName,
      _ref28$gradeName = _ref28.gradeName,
      gradeName = _ref28$gradeName === undefined ? "" : _ref28$gradeName,
      _ref28$colorName = _ref28.colorName,
      colorName = _ref28$colorName === undefined ? "" : _ref28$colorName,
      _ref28$interiorName = _ref28.interiorName,
      interiorName = _ref28$interiorName === undefined ? "" : _ref28$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_SEND_SHARE_FORM,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.BUILDTOOL_SEND_SHARE_FORM,
    pageCategory: "Build Share \"" + getShortModel(modelName) + "\"",
    pageAction: "Build Share \"" + getShortModel(modelName) + "\", \"" + bodyName + "\" \"" + gradeName + "\", \"" + driveName + "\", \"" + colorName + " \", \"" + interiorName + " \" Share - Clicked \"SEND\""
  };
}, _gtmEvents);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// CMS GTM for button
var gtmEventTypes = {
  CLICK_BUTTON: "CMS-BUTTON-001"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_BUTTON] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      buttonName = _ref.buttonName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_BUTTON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action + " - Clicked \"" + buttonName.toUpperCase() + "\""
  });
}, _gtmEvents);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var gtmEventTypes = {
  CLICK_PLAY_WATCH_VIDEO: "YB_CLICK_PLAY_WATCH_VIDEO"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_PLAY_WATCH_VIDEO] = function (_ref) {
  var _ref$CMSGroupGTM = _ref.CMSGroupGTM,
      CMSGroupGTM = _ref$CMSGroupGTM === undefined ? {} : _ref$CMSGroupGTM,
      isPlay = _ref.isPlay,
      videoName = _ref.videoName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_PLAY_WATCH_VIDEO,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action + " - Clicked " + (isPlay ? "PLAY" : "WATCH VIDEO") + " \"" + videoName.toUpperCase() + "\""
  });
}, _gtmEvents);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



var gtmEventTypes = {
  ENTER_LOCATION: "FED-FAD-001",
  event: "reactjs.event",
  userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
  CLICK_CTA: "FED-FAD-008",
  CHECK_DEALERTYPE: "FED-FAD-CHECK_DEALERTYPE",
  CLICK_ADDRESS: "FED-FAD-009",
  CLICK_PHONE: "FED-FAD-010",
  CLICK_WEBSITE: "FED-FAD-011",
  SELECT_DEALER_NAME: "FED-FAD-012",
  SELECT_DEALER_DEPARTMENT: "FED-FAD-013"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.ENTER_LOCATION] = function (_ref) {
  var location = _ref.location;
  return {
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_LOCATION,
    pageCategory: "Find a Dealer",
    pageAction: "Find a Dealer - Entered \"" + location.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CHECK_DEALERTYPE] = function (_ref2) {
  var dealerType = _ref2.dealerType,
      eventID = _ref2.eventID;
  return {
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: eventID,
    pageCategory: "Find a Dealer",
    pageAction: "Find a Dealer - Checked \"" + dealerType.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_CTA] = function (_ref3) {
  var dealerName = _ref3.dealerName,
      ctaName = _ref3.ctaName,
      departments = _ref3.departments,
      address = _ref3.address;
  return {
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: "Find a Dealer",
    pageAction: "Find a Dealer - " + dealerName + " - Clicked \"CTA BUTTON " + ctaName.toUpperCase() + "\" - " + departments.toString() + " - " + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_ADDRESS] = function (_ref4) {
  var dealerName = _ref4.dealerName,
      departments = _ref4.departments,
      address = _ref4.address;
  return {
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_ADDRESS,
    pageCategory: "Find a Dealer",
    pageAction: "Find a Dealer - " + dealerName + " - Clicked \"ADDRESS " + address.toUpperCase() + "\" - " + departments.toString() + " - " + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_PHONE] = function (_ref5) {
  var dealerName = _ref5.dealerName,
      phone = _ref5.phone,
      departments = _ref5.departments,
      address = _ref5.address;
  return {
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_PHONE,
    pageCategory: "Find a Dealer",
    pageAction: "Find a Dealer - " + dealerName + " - Clicked \"PHONE " + phone + "\" - " + departments.toString() + " - " + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_WEBSITE] = function (_ref6) {
  var dealerName = _ref6.dealerName,
      website = _ref6.website,
      departments = _ref6.departments,
      address = _ref6.address;
  return {
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_WEBSITE,
    pageCategory: "Find a Dealer",
    pageAction: "Find a Dealer - " + dealerName + " - Clicked \"WEBSITE " + website.toUpperCase() + "\" - " + departments.toString() + " - " + address
  };
}, _gtmEvents[gtmEventTypes.SELECT_DEALER_NAME] = function (_ref7) {
  var dealerName = _ref7.dealerName,
      department = _ref7.department,
      address = _ref7.address;
  return {
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SELECT_DEALER_NAME,
    pageCategory: "Find a Dealer",
    pageAction: "Find a Dealer - Selected \"" + dealerName + "\" - " + department.toUpperCase() + " - " + address
  };
}, _gtmEvents[gtmEventTypes.SELECT_DEALER_DEPARTMENT] = function (_ref8) {
  var dealerName = _ref8.dealerName,
      department = _ref8.department,
      address = _ref8.address;
  return {
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SELECT_DEALER_DEPARTMENT,
    pageCategory: "Find a Dealer",
    pageAction: "Find a Dealer - " + dealerName + " - Clicked \"DEPARTMENT MENU - " + department.toUpperCase() + "\" - " + address
  };
}, _gtmEvents);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// CMS GTM for Icon Tout Block
var gtmEventTypes = {
  CLICK_LINK: "CMS-ICONTOUTBLOCK-001"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_LINK] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      _ref$blockTitle = _ref.blockTitle,
      blockTitle = _ref$blockTitle === undefined ? "" : _ref$blockTitle,
      ctaName = _ref.ctaName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_LINK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: ctaName ? CMSGroupGTM.action + " \"" + (blockTitle && blockTitle.toUpperCase()) + "\" - Clicked \"" + ctaName.toUpperCase() + "\"" : CMSGroupGTM.action
  });
}, _gtmEvents);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var gtmEventTypes = {
  CLICK_SUB_NAV_LINK: "FED-IPN-001",
  CLICK_SUB_NAV_BUTTON: "FED-IPN-002"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_SUB_NAV_LINK] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      itemName = _ref.itemName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_SUB_NAV_LINK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: "Clicked Sub Nav Link - \"" + itemName.toUpperCase() + "\""
  });
}, _gtmEvents[gtmEventTypes.CLICK_SUB_NAV_BUTTON] = function (_ref2) {
  var CMSGroupGTM = _ref2.CMSGroupGTM,
      ctaName = _ref2.ctaName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_SUB_NAV_BUTTON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: "Clicked Sub Nav Button - \"" + ctaName.toUpperCase() + "\""
  });
}, _gtmEvents);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



var gtmEventTypes = {
  SELECT_FILTER_OPTION: "FED-MCB-001",
  CLICK_ADDRESS: "FED-MCB-002",
  CLICK_PHONE: "FED-MCB-003",
  CLICK_WEBSITE: "FED-MCB-004",
  SELECT_DEALER_NAME: "FED-MCB-005",
  SELECT_DEALER_DEPARTMENT: "FED-MCB-006",
  CLICK_CTA: "FED-MCB-007"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.SELECT_FILTER_OPTION] = function (_ref) {
  var option = _ref.option;
  return {
    type: gtmEventTypes.SELECT_FILTER_OPTION,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SELECT_FILTER_OPTION,
    pageCategory: "Dealer Map Block",
    pageAction: "Dealer Map Block - Selected \"" + option.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_ADDRESS] = function (_ref2) {
  var dealerName = _ref2.dealerName,
      departments = _ref2.departments,
      address = _ref2.address;
  return {
    type: gtmEventTypes.CLICK_ADDRESS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_ADDRESS,
    pageCategory: "Dealer Map Block",
    pageAction: "Dealer Map Block - " + dealerName + " - Clicked \"ADDRESS " + address.toUpperCase() + "\" - " + departments.toString() + " - " + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_PHONE] = function (_ref3) {
  var dealerName = _ref3.dealerName,
      phone = _ref3.phone,
      departments = _ref3.departments,
      address = _ref3.address;
  return {
    type: gtmEventTypes.CLICK_PHONE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_PHONE,
    pageCategory: "Dealer Map Block",
    pageAction: "Dealer Map Block - " + dealerName + " - Clicked \"PHONE " + phone + "\" - " + departments.toString() + " - " + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_WEBSITE] = function (_ref4) {
  var dealerName = _ref4.dealerName,
      website = _ref4.website,
      departments = _ref4.departments,
      address = _ref4.address;
  return {
    type: gtmEventTypes.CLICK_WEBSITE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_WEBSITE,
    pageCategory: "Dealer Map Block",
    pageAction: "Dealer Map Block - " + dealerName + " - Clicked \"WEBSITE " + website.toUpperCase() + "\" - " + departments.toString() + " - " + address
  };
}, _gtmEvents[gtmEventTypes.SELECT_DEALER_NAME] = function (_ref5) {
  var dealerName = _ref5.dealerName,
      department = _ref5.department,
      address = _ref5.address;
  return {
    type: gtmEventTypes.SELECT_DEALER_NAME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SELECT_DEALER_NAME,
    pageCategory: "Dealer Map Block",
    pageAction: "Dealer Map Block - Selected \"" + dealerName + "\" - " + department.toUpperCase() + " - " + address
  };
}, _gtmEvents[gtmEventTypes.SELECT_DEALER_DEPARTMENT] = function (_ref6) {
  var dealerName = _ref6.dealerName,
      department = _ref6.department,
      address = _ref6.address;
  return {
    type: gtmEventTypes.SELECT_DEALER_DEPARTMENT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SELECT_DEALER_DEPARTMENT,
    pageCategory: "Dealer Map Block",
    pageAction: "Dealer Map Block - " + dealerName + " - Clicked \"DEPARTMENT MENU - " + department.toUpperCase() + "\" - " + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_CTA] = function (_ref7) {
  var dealerName = _ref7.dealerName,
      ctaName = _ref7.ctaName,
      departments = _ref7.departments,
      address = _ref7.address;
  return {
    type: gtmEventTypes.CLICK_CTA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: "Dealer Map Block",
    pageAction: "Dealer Map Block - " + dealerName + " - Clicked \"CTA BUTTON " + ctaName.toUpperCase() + "\" - " + departments.toString() + " - " + address
  };
}, _gtmEvents);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// CMS GTM event for color picker
var gtmEventTypes = {
  CLICK_COLOR: "CMS-MINICONFIGURATOR-001",
  CLICK_CTA: "CMS-MINICONFIGURATOR-002"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_COLOR] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      color = _ref.color;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_COLOR,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action + " - Clicked \"" + color.toUpperCase() + "\""
  });
}, _gtmEvents[gtmEventTypes.CLICK_CTA] = function (_ref2) {
  var CMSGroupGTM = _ref2.CMSGroupGTM,
      ctaLabel = _ref2.ctaLabel;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_CTA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action + " - Clicked \"" + ctaLabel.toUpperCase() + "\""
  });
}, _gtmEvents);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



var gtmEventTypes = {
  SUBMIT_LOGIN: "FED-MYMAZDA-001",
  FAIL_LOGIN: "FED-MYMAZDA-002",
  ENTER_EMAIL: "FED-MYMAZDA_ENTER_EMAIL",
  ENTER_PASSWORD: "FED-MYMAZDA_ENTER_PASSWORD",
  LOGIN: "LOGIN",
  PERSIST_LOGIN: "PERSIST_LOGIN",
  RESET_PASSWORD: "RESET_PASSWORD"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.SUBMIT_LOGIN] = function (_ref) {
  var isVin = _ref.isVin;
  return {
    type: gtmEventTypes.SUBMIT_LOGIN,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SUBMIT_LOGIN,
    pageCategory: "MyMazda",
    pageAction: "MyMazda Login - Enter VIN/Rego - Submitted \"" + (isVin ? "VIN" : "REGO") + "\""
  };
}, _gtmEvents[gtmEventTypes.FAIL_LOGIN] = function (_ref2) {
  var isVin = _ref2.isVin;
  return {
    type: gtmEventTypes.FAIL_LOGIN,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.FAIL_LOGIN,
    pageCategory: "MyMazda",
    pageAction: "MyMazda Login - Enter VIN/Rego - Failed Login \"" + (isVin ? "VIN" : "REGO") + "\""
  };
}, _gtmEvents[gtmEventTypes.ENTER_EMAIL] = function () {
  return {
    type: gtmEventTypes.ENTER_EMAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_EMAIL,
    pageCategory: "MyMazda Login Form",
    pageAction: "MyMazda Login Form - Entered \"EMAIL\""
  };
}, _gtmEvents[gtmEventTypes.ENTER_PASSWORD] = function () {
  return {
    type: gtmEventTypes.ENTER_PASSWORD,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_PASSWORD,
    pageCategory: "MyMazda Login Form",
    pageAction: "MyMazda Login Form - Entered \"PASSWORD\""
  };
}, _gtmEvents[gtmEventTypes.LOGIN] = function () {
  return {
    type: gtmEventTypes.LOGIN,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.LOGIN,
    pageCategory: "MyMazda Login Form",
    pageAction: "MyMazda Login Form - Login"
  };
}, _gtmEvents[gtmEventTypes.LOGIN] = function () {
  return {
    type: gtmEventTypes.LOGIN,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.LOGIN,
    pageCategory: "MyMazda Login Form",
    pageAction: "MyMazda Login Form - checked \"Keep me logged in\""
  };
}, _gtmEvents[gtmEventTypes.RESET_PASSWORD] = function () {
  return {
    type: gtmEventTypes.RESET_PASSWORD,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.RESET_PASSWORD,
    pageCategory: "MyMazda Forgot password Form",
    pageAction: "MyMazda Forgot password Form - Reset\""
  };
}, _gtmEvents);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



var gtmEventTypes = {
  SUBMIT_LOGIN: "FED-MYMAZDA2-001",
  CREATE_ACCOUNT: "FED-MYMAZDA2-002",
  CONTACT_US: "FED-MYMAZDA2-003",
  DEACTIVATE_ACCOUNT: "FED-MYMAZDA2-004",
  CHECK_EMAIL_REGISTER: "FED-MYMAZDA2-005",
  CREATE_PASSWORD: "FED-MYMAZDA2-006",
  CONTINUE_TO_MYMAZDA: "FED-MYMAZDA2-007",
  SUBMIT_REGISTER: "FED-MYMAZDA2-008",
  CAROUSEL_CLICK: "FED-MYMAZDA2-009",
  SERVICE_HISTORY_CLICK: "FED-MYMAZDA2-010",
  CALCULATOR_CLICK: "FED-MYMAZDA2-011",
  CALCULATOR_REQUEST_SERVICE: "FED-MYMAZDA2-012"
};

var pageCategories = {
  home: "MyMazda - Home",
  getInTouch: "MyMazda - Get In Touch",
  manage: "MyMazda - Manage Account",
  register: "MyMazda - Create Account",
  servicing: "MyMazda - Servicing"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.SUBMIT_LOGIN] = function (_ref) {
  var buttonText = _ref.buttonText;
  return {
    type: gtmEventTypes.SUBMIT_LOGIN,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SUBMIT_LOGIN,
    pageCategory: pageCategories.home,
    pageAction: "LOG IN BLOCK - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CREATE_ACCOUNT] = function (_ref2) {
  var buttonText = _ref2.buttonText;
  return {
    type: gtmEventTypes.CREATE_ACCOUNT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CREATE_ACCOUNT,
    pageCategory: pageCategories.home,
    pageAction: "CREATE AN ACCOUNT BLOCK - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US] = function (_ref3) {
  var buttonText = _ref3.buttonText;
  return {
    type: gtmEventTypes.CONTACT_US,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CONTACT_US,
    pageCategory: pageCategories.home,
    pageAction: "CREATE AN ACCOUNT BLOCK - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.DEACTIVATE_ACCOUNT] = function (_ref4) {
  var buttonText = _ref4.buttonText;
  return {
    type: gtmEventTypes.DEACTIVATE_ACCOUNT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.DEACTIVATE_ACCOUNT,
    pageCategory: pageCategories.manage,
    pageAction: "DEACTIVATE ACCOUNT - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CHECK_EMAIL_REGISTER] = function (_ref5) {
  var buttonText = _ref5.buttonText;
  return {
    type: gtmEventTypes.CHECK_EMAIL_REGISTER,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CHECK_EMAIL_REGISTER,
    pageCategory: pageCategories.register,
    pageAction: "REGISTRATION FORM - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.SUBMIT_REGISTER] = function (_ref6) {
  var buttonText = _ref6.buttonText;
  return {
    type: gtmEventTypes.SUBMIT_REGISTER,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SUBMIT_REGISTER,
    pageCategory: pageCategories.register,
    pageAction: "CREATE ACCOUNT - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CREATE_PASSWORD] = function (_ref7) {
  var buttonText = _ref7.buttonText;
  return {
    type: gtmEventTypes.CREATE_PASSWORD,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CREATE_PASSWORD,
    pageCategory: pageCategories.register,
    pageAction: "CREATE PASSWORD - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CONTINUE_TO_MYMAZDA] = function (_ref8) {
  var buttonText = _ref8.buttonText;
  return {
    type: gtmEventTypes.CONTINUE_TO_MYMAZDA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CONTINUE_TO_MYMAZDA,
    pageCategory: pageCategories.register,
    pageAction: "MYMAZDA ACCOUNT CREATED - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CAROUSEL_CLICK] = function (_ref9) {
  var buttonText = _ref9.buttonText;
  return {
    type: gtmEventTypes.CAROUSEL_CLICK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CAROUSEL_CLICK,
    pageCategory: pageCategories.servicing,
    pageAction: "CAROUSEL - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.SERVICE_HISTORY_CLICK] = function (_ref10) {
  var buttonText = _ref10.buttonText;
  return {
    type: gtmEventTypes.SERVICE_HISTORY_CLICK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SERVICE_HISTORY_CLICK,
    pageCategory: pageCategories.servicing,
    pageAction: "HISTORY - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CALCULATOR_CLICK] = function (_ref11) {
  var buttonText = _ref11.buttonText;
  return {
    type: gtmEventTypes.CALCULATOR_CLICK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CALCULATOR_CLICK,
    pageCategory: pageCategories.servicing,
    pageAction: "CALCULATOR - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CALCULATOR_REQUEST_SERVICE] = function (_ref12) {
  var buttonText = _ref12.buttonText;
  return {
    type: gtmEventTypes.CALCULATOR_REQUEST_SERVICE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CALCULATOR_REQUEST_SERVICE,
    pageCategory: pageCategories.servicing,
    pageAction: "CALCULATOR FORM - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



var gtmEventTypes = {
  CLICK_SPECS_CTA: "FED-MYMAZDA-003"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_SPECS_CTA] = function (_ref) {
  var ctaName = _ref.ctaName;
  return {
    type: gtmEventTypes.CLICK_SPECS_CTA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_SPECS_CTA,
    pageCategory: "MyMazda",
    pageAction: "MyMazda Home - Specifications - Clicked \"" + ctaName.toUpperCase() + "\""
  };
}, _gtmEvents);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



var gtmEventTypes = {
  CLICK_SUB_NAV_LINK: "FED-OFFERS-001",
  EXPAND_ACCORDION: "FED-OFFERS-002",
  COLLAPSE_ACCORDION: "FED-OFFERS-003",
  CLICK_CTA: "FED-OFFERS-004",
  CLICK_RECOMMENDED_CONTENT: "FED-OFFERS_005"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_SUB_NAV_LINK] = function (_ref) {
  var itemName = _ref.itemName;
  return {
    type: gtmEventTypes.CLICK_SUB_NAV_LINK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_SUB_NAV_LINK,
    pageCategory: "Offers",
    pageAction: "Offers - Sub Nav - Clicked \"" + itemName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.EXPAND_ACCORDION] = function (_ref2) {
  var modelName = _ref2.modelName,
      bodyGradeTitle = _ref2.bodyGradeTitle,
      offerPrice = _ref2.offerPrice,
      expandedText = _ref2.expandedText;
  return {
    type: gtmEventTypes.EXPAND_ACCORDION,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.EXPAND_ACCORDION,
    pageCategory: "Offers",
    pageAction: "Offers - \"" + modelName.toUpperCase() + "/" + bodyGradeTitle.toUpperCase() + "/" + offerPrice + "\" - \"" + expandedText + "\""
  };
}, _gtmEvents[gtmEventTypes.COLLAPSE_ACCORDION] = function (_ref3) {
  var modelName = _ref3.modelName,
      bodyGradeTitle = _ref3.bodyGradeTitle,
      offerPrice = _ref3.offerPrice,
      collapsedText = _ref3.collapsedText;
  return {
    type: gtmEventTypes.COLLAPSE_ACCORDION,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.COLLAPSE_ACCORDION,
    pageCategory: "Offers",
    pageAction: "Offers - \"" + modelName.toUpperCase() + "/" + bodyGradeTitle.toUpperCase() + "/" + offerPrice + "\" - \"" + collapsedText + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_CTA] = function (_ref4) {
  var modelName = _ref4.modelName,
      bodyGradeTitle = _ref4.bodyGradeTitle,
      offerPrice = _ref4.offerPrice,
      ctaLabel = _ref4.ctaLabel;
  return {
    type: gtmEventTypes.CLICK_CTA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: "Offers",
    pageAction: "Offers - \"" + modelName.toUpperCase() + "/" + bodyGradeTitle.toUpperCase() + "/" + offerPrice + "\" - Clicked CTA - \"" + ctaLabel.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_RECOMMENDED_CONTENT] = function (_ref5) {
  var sectionTitle = _ref5.sectionTitle,
      tileTitle = _ref5.tileTitle,
      tileLabel = _ref5.tileLabel;
  return {
    type: gtmEventTypes.CLICK_RECOMMENDED_CONTENT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_RECOMMENDED_CONTENT,
    pageCategory: "Offers",
    pageAction: "Offers - \"" + sectionTitle.toUpperCase() + "\" - Clicked \"" + tileTitle.toUpperCase() + "\" - \"" + tileLabel.toUpperCase() + "\""
  };
}, _gtmEvents);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



/* Ducks is a modular redux model where you put a duck.js file
in the same folder of the react component that uses it.
More info: https://github.com/erikras/ducks-modular-redux
 */

var gtmEventTypes = {
  NO_STOCK_FOR_MODEL: "NOT-IMPLEMENTED",
  ENTER_LOCATION: "FED-OL-001",
  SELECT_DEALER_NAME: "FED-OL-002",
  CLICK_ADDRESS: "FED-OL-003",
  CLICK_WEBSITE: "FED-OL-004",
  CLICK_PHONE: "FED-OL-005",
  EDIT_DEALER: "FED-OL-006",
  CONFIRM_DEALER: "FED-OL-007",
  SELECT_NAMEPLATE: "FED-OL-008",
  CLICK_NO_STOCK_CHANGE: "FED-OL-009",
  CLICK_NO_STOCK_BUILD: "FED-OL-010",
  SELECT_STOCK_TILE: "FED-OL-011",
  CLEARANCE_UNCHECKED: "FED-OL-012",
  DEMO_UNCHECKED: "FED-OL-013",
  CLEARANCE_CHECKED: "FED-OL-014",
  DEMO_CHECKED: "FED-OL-015",
  EDIT_MODEL: "FED-OL-016",
  CLICK_INFO: "FED-OL-017",
  CLICK_SORT_OPTION: "FED-OL-018",
  CLICK_PRICE_DISCLAIMER: "FED-OL-019",
  SLIDESHOW_INTERACTION_DETAIL: "FED-OL-020",
  CLICK_PRICE_DISCLAIMER_DETAIL: "FED-OL-021",
  EXPAND_ACCORDION_DETAIL: "FED-OL-022",
  COLLAPSE_ACCORDION_DETAIL: "FED-OL-023",
  CLICK_FULL_SPECS_DETAIL: "FED-OL-024",
  CLICK_BACK_DETAIL: "FED-OL-025",
  CLICK_NEXT_DETAIL: "FED-OL-026"

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.NO_STOCK_FOR_MODEL] = function (_ref) {
  var dealerName = _ref.dealerName,
      nameplate = _ref.nameplate,
      buttonText = _ref.buttonText;
  return {
    type: gtmEventTypes.NO_STOCK_FOR_MODEL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.NO_STOCK_FOR_MODEL,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Model - No Stock Available - " + dealerName.toUpperCase() + " - " + nameplate.toUpperCase() + " - Clicked - \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.ENTER_LOCATION] = function (_ref2) {
  var location = _ref2.location;
  return {
    type: gtmEventTypes.ENTER_LOCATION,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_LOCATION,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Dealer - Entered \"" + location.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.SELECT_DEALER_NAME] = function (_ref3) {
  var dealerName = _ref3.dealerName;
  return {
    type: gtmEventTypes.SELECT_DEALER_NAME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SELECT_DEALER_NAME,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Dealer - Selected \"" + dealerName + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_ADDRESS] = function (_ref4) {
  var dealerName = _ref4.dealerName,
      address = _ref4.address;
  return {
    type: gtmEventTypes.CLICK_ADDRESS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_ADDRESS,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Dealer - " + dealerName + " - Clicked \"ADDRESS " + address.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_WEBSITE] = function (_ref5) {
  var dealerName = _ref5.dealerName,
      website = _ref5.website;
  return {
    type: gtmEventTypes.CLICK_WEBSITE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_WEBSITE,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Dealer - " + dealerName + " - Clicked \"WEBSITE " + website.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_PHONE] = function (_ref6) {
  var dealerName = _ref6.dealerName,
      phone = _ref6.phone;
  return {
    type: gtmEventTypes.CLICK_PHONE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_PHONE,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Dealer - " + dealerName + " - Clicked \"PHONE " + phone + "\""
  };
}, _gtmEvents[gtmEventTypes.ENTER_LOCATION] = function (_ref7) {
  var location = _ref7.location;
  return {
    type: gtmEventTypes.ENTER_LOCATION,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_LOCATION,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Dealer - Entered \"" + location.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.EDIT_DEALER] = function (_ref8) {
  var buttonText = _ref8.buttonText,
      dealerName = _ref8.dealerName;
  return {
    type: gtmEventTypes.EDIT_DEALER,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.EDIT_DEALER,
    pageCategory: "Outlet Store",
    pageAction: "Footer Nav - Clicked \"" + buttonText.toUpperCase() + "\" - \"" + dealerName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CONFIRM_DEALER] = function (_ref9) {
  var buttonText = _ref9.buttonText,
      dealerAddress = _ref9.dealerAddress;
  return {
    type: gtmEventTypes.CONFIRM_DEALER,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CONFIRM_DEALER,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Dealer - Clicked \"" + buttonText.toUpperCase() + "\" - " + dealerAddress.toUpperCase()
  };
}, _gtmEvents[gtmEventTypes.SELECT_NAMEPLATE] = function (_ref10) {
  var nameplate = _ref10.nameplate,
      dealerName = _ref10.dealerName;
  return {
    type: gtmEventTypes.SELECT_NAMEPLATE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SELECT_NAMEPLATE,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Model - Selected \"" + nameplate.toUpperCase() + "\" - \"" + dealerName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_NO_STOCK_CHANGE] = function (_ref11) {
  var buttonText = _ref11.buttonText,
      dealerName = _ref11.dealerName;
  return {
    type: gtmEventTypes.CLICK_NO_STOCK_CHANGE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_NO_STOCK_CHANGE,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Model - No Stock Available - " + dealerName.toUpperCase() + " - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_NO_STOCK_BUILD] = function (_ref12) {
  var buttonText = _ref12.buttonText,
      nameplate = _ref12.nameplate,
      dealerName = _ref12.dealerName;
  return {
    type: gtmEventTypes.CLICK_NO_STOCK_BUILD,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_NO_STOCK_BUILD,
    pageCategory: "Outlet Store",
    pageAction: "Select Your Model - No Stock Available - " + dealerName.toUpperCase() + " - " + nameplate.toUpperCase() + " - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.SELECT_STOCK_TILE] = function (_ref13) {
  var storeTypeCategory = _ref13.storeTypeCategory,
      nameplate = _ref13.nameplate,
      bodyStyle = _ref13.bodyStyle,
      grade = _ref13.grade,
      engineSize = _ref13.engineSize,
      transmissionType = _ref13.transmissionType,
      fuelType = _ref13.fuelType,
      fittedAccessories = _ref13.fittedAccessories,
      price = _ref13.price,
      odometer = _ref13.odometer,
      generation = _ref13.generation,
      interiorTitle = _ref13.interiorTitle,
      dealerName = _ref13.dealerName;
  return {
    type: gtmEventTypes.SELECT_STOCK_TILE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SELECT_STOCK_TILE,
    pageCategory: "Outlet Store",
    pageAction: "Search Result - Selected \"" + storeTypeCategory.toUpperCase() + "\" - " + [nameplate, bodyStyle, grade, engineSize, transmissionType, fuelType, fittedAccessories, "$" + price.toLocaleString('nz'), odometer, generation, interiorTitle].map(function (string) {
      return "\"" + String(string).toUpperCase() + "\"";
    }).join(",") + " - \"" + dealerName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLEARANCE_UNCHECKED] = function (_ref14) {
  var label = _ref14.label;
  return {
    type: gtmEventTypes.CLEARANCE_UNCHECKED,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLEARANCE_UNCHECKED,
    pageCategory: "Outlet Store",
    pageAction: "Search Result - Unchecked \"" + label.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.DEMO_UNCHECKED] = function (_ref15) {
  var label = _ref15.label;
  return {
    type: gtmEventTypes.DEMO_UNCHECKED,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.DEMO_UNCHECKED,
    pageCategory: "Outlet Store",
    pageAction: "Search Result - Unchecked \"" + label.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLEARANCE_CHECKED] = function (_ref16) {
  var label = _ref16.label;
  return {
    type: gtmEventTypes.CLEARANCE_CHECKED,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLEARANCE_CHECKED,
    pageCategory: "Outlet Store",
    pageAction: "Search Result - Checked \"" + label.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.DEMO_CHECKED] = function (_ref17) {
  var label = _ref17.label;
  return {
    type: gtmEventTypes.DEMO_CHECKED,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.DEMO_CHECKED,
    pageCategory: "Outlet Store",
    pageAction: "Search Result - Checked \"" + label.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.EDIT_MODEL] = function (_ref18) {
  var buttonText = _ref18.buttonText,
      nameplate = _ref18.nameplate;
  return {
    type: gtmEventTypes.EDIT_MODEL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.EDIT_MODEL,
    pageCategory: "Outlet Store",
    pageAction: "Footer Nav - Clicked \"" + buttonText.toUpperCase() + "\" - \"" + nameplate.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_INFO] = function (_ref19) {
  var buttonText = _ref19.buttonText;
  return {
    type: gtmEventTypes.CLICK_INFO,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_INFO,
    pageCategory: "Outlet Store",
    pageAction: "Footer Nav - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_SORT_OPTION] = function (_ref20) {
  var label = _ref20.label;
  return {
    type: gtmEventTypes.CLICK_SORT_OPTION,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_SORT_OPTION,
    pageCategory: "Outlet Store",
    pageAction: "Search Result - Sort Results Dropdown - Selected \"" + label.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_PRICE_DISCLAIMER] = function (_ref21) {
  var nameplate = _ref21.nameplate,
      storeTypeCategory = _ref21.storeTypeCategory,
      grade = _ref21.grade;
  return {
    type: gtmEventTypes.CLICK_PRICE_DISCLAIMER,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_PRICE_DISCLAIMER,
    pageCategory: "Outlet Store",
    pageAction: "Search Result - \"" + nameplate.toUpperCase() + "\", \"" + storeTypeCategory.toUpperCase() + "\" \"" + grade.toUpperCase() + "\" - Clicked \"PRICE DISCLAIMER\""
  };
}, _gtmEvents[gtmEventTypes.SLIDESHOW_INTERACTION_DETAIL] = function (_ref22) {
  var nameplate = _ref22.nameplate,
      bodyStyle = _ref22.bodyStyle,
      storeTypeCategory = _ref22.storeTypeCategory,
      grade = _ref22.grade,
      imageLabel = _ref22.imageLabel;
  return {
    type: gtmEventTypes.SLIDESHOW_INTERACTION_DETAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SLIDESHOW_INTERACTION_DETAIL,
    pageCategory: "Outlet Store",
    pageAction: "Vehicle Details Page - \"" + nameplate.toUpperCase() + " " + bodyStyle.toUpperCase() + "\", \"" + storeTypeCategory.toUpperCase() + "\", \"" + grade.toUpperCase() + "\" - Engaged Carousel \"" + imageLabel.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_PRICE_DISCLAIMER_DETAIL] = function (_ref23) {
  var nameplate = _ref23.nameplate,
      bodyStyle = _ref23.bodyStyle,
      storeTypeCategory = _ref23.storeTypeCategory,
      grade = _ref23.grade;
  return {
    type: gtmEventTypes.CLICK_PRICE_DISCLAIMER_DETAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_PRICE_DISCLAIMER_DETAIL,
    pageCategory: "Outlet Store",
    pageAction: "Vehicle Details Page - \"" + nameplate.toUpperCase() + " " + bodyStyle.toUpperCase() + "\", \"" + storeTypeCategory.toUpperCase() + "\", \"" + grade.toUpperCase() + "\" - Clicked \"PRICE DISCLAIMER\""
  };
}, _gtmEvents[gtmEventTypes.EXPAND_ACCORDION_DETAIL] = function (_ref24) {
  var nameplate = _ref24.nameplate,
      bodyStyle = _ref24.bodyStyle,
      storeTypeCategory = _ref24.storeTypeCategory,
      grade = _ref24.grade,
      sectionTitle = _ref24.sectionTitle;
  return {
    type: gtmEventTypes.EXPAND_ACCORDION_DETAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.EXPAND_ACCORDION_DETAIL,
    pageCategory: "Outlet Store",
    pageAction: "Vehicle Details Page - \"" + nameplate.toUpperCase() + " " + bodyStyle.toUpperCase() + "\", \"" + storeTypeCategory.toUpperCase() + "\", \"" + grade.toUpperCase() + "\" - Expanded \"" + sectionTitle.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.COLLAPSE_ACCORDION_DETAIL] = function (_ref25) {
  var nameplate = _ref25.nameplate,
      bodyStyle = _ref25.bodyStyle,
      storeTypeCategory = _ref25.storeTypeCategory,
      grade = _ref25.grade,
      sectionTitle = _ref25.sectionTitle;
  return {
    type: gtmEventTypes.COLLAPSE_ACCORDION_DETAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.COLLAPSE_ACCORDION_DETAIL,
    pageCategory: "Outlet Store",
    pageAction: "Vehicle Details Page - \"" + nameplate.toUpperCase() + " " + bodyStyle.toUpperCase() + "\", \"" + storeTypeCategory.toUpperCase() + "\", \"" + grade.toUpperCase() + "\" - Collapsed \"" + sectionTitle.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_FULL_SPECS_DETAIL] = function (_ref26) {
  var nameplate = _ref26.nameplate,
      bodyStyle = _ref26.bodyStyle,
      storeTypeCategory = _ref26.storeTypeCategory,
      grade = _ref26.grade,
      buttonText = _ref26.buttonText;
  return {
    type: gtmEventTypes.CLICK_FULL_SPECS_DETAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_FULL_SPECS_DETAIL,
    pageCategory: "Outlet Store",
    pageAction: "Vehicle Details Page - \"" + nameplate.toUpperCase() + " " + bodyStyle.toUpperCase() + "\" \"" + storeTypeCategory.toUpperCase() + "\", \"" + grade.toUpperCase() + "\" - Clicked " + buttonText.toUpperCase()
  };
}, _gtmEvents[gtmEventTypes.CLICK_BACK_DETAIL] = function (_ref27) {
  var buttonText = _ref27.buttonText;
  return {
    type: gtmEventTypes.CLICK_BACK_DETAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_BACK_DETAIL,
    pageCategory: "Outlet Store",
    pageAction: "Vehicle Details Page - Footer Nav - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_NEXT_DETAIL] = function (_ref28) {
  var nameplate = _ref28.nameplate,
      bodyStyle = _ref28.bodyStyle,
      storeTypeCategory = _ref28.storeTypeCategory,
      grade = _ref28.grade,
      hasAccessories = _ref28.hasAccessories,
      fittedAccessories = _ref28.fittedAccessories,
      dealerName = _ref28.dealerName,
      buttonText = _ref28.buttonText;
  return {
    type: gtmEventTypes.CLICK_NEXT_DETAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_NEXT_DETAIL,
    pageCategory: "Outlet Store",
    pageAction: "Vehicle Details Page - Footer Nav - Clicked \"" + buttonText.toUpperCase() + "\" - \"" + storeTypeCategory.toUpperCase() + "\", \"" + nameplate.toUpperCase() + " " + bodyStyle.toUpperCase() + "\", \"" + grade.toUpperCase() + "\", ACCESSORIES \"" + hasAccessories.toUpperCase() + "\", \"" + fittedAccessories.toUpperCase() + "\" - " + dealerName.toUpperCase() + "\""
  };
}, _gtmEvents);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



/* Ducks is a modular redux model where you put a duck.js file
in the same folder of the react component that uses it.
More info: https://github.com/erikras/ducks-modular-redux
 */

var gtmEventTypes = {
  SELECT_TITLE: "FED-OL-ENQ-001",
  ENTER_FIRSTNAME: "FED-OL-ENQ-002",
  ENTER_LASTNAME: "FED-OL-ENQ-003",
  ENTER_PHONE: "FED-OL-ENQ-004",
  ENTER_EMAIL: "FED-OL-ENQ-005",
  ENTER_COMMENTS: "FED-OL-ENQ-006",
  CHECK_OPTIN: "FED-OL-ENQ-007",
  CHECK_PRIVACY_POLICY: "FED-OL-ENQ-008",
  CLICK_PRIVACY_POLICY: "FED-OL-ENQ-009",
  CLICK_SUBMIT: "FED-OL-ENQ-010",
  CLICK_SUBMIT_WITH_DATA: "FED-OL-ENQ-011",
  CLICK_BACK: "FED-OL-ENQ-012"

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.SELECT_TITLE] = function (_ref) {
  var selection = _ref.selection;
  return {
    type: gtmEventTypes.SELECT_TITLE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SELECT_TITLE,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Store Form - Selected \"TITLE\" - \"" + selection.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.ENTER_FIRSTNAME] = function () {
  return {
    type: gtmEventTypes.ENTER_FIRSTNAME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_FIRSTNAME,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Store Form - Entered \"FIRSTNAME\""
  };
}, _gtmEvents[gtmEventTypes.ENTER_LASTNAME] = function () {
  return {
    type: gtmEventTypes.ENTER_LASTNAME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_LASTNAME,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Store Form - Entered \"LASTNAME\""
  };
}, _gtmEvents[gtmEventTypes.ENTER_PHONE] = function () {
  return {
    type: gtmEventTypes.ENTER_PHONE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_PHONE,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Store Form - Entered \"PHONE\""
  };
}, _gtmEvents[gtmEventTypes.ENTER_EMAIL] = function () {
  return {
    type: gtmEventTypes.ENTER_EMAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_EMAIL,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Store Form - Entered \"EMAIL\""
  };
}, _gtmEvents[gtmEventTypes.ENTER_COMMENTS] = function () {
  return {
    type: gtmEventTypes.ENTER_COMMENTS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_COMMENTS,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Store Form - Entered \"COMMENTS\""
  };
}, _gtmEvents[gtmEventTypes.CHECK_OPTIN] = function () {
  return {
    type: gtmEventTypes.CHECK_OPTIN,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CHECK_OPTIN,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Form - Checked \"OPTIN\""
  };
}, _gtmEvents[gtmEventTypes.CHECK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.CHECK_PRIVACY_POLICY,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CHECK_PRIVACY_POLICY,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Form - Checked \"PRIVACYPOLICY\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_PRIVACY_POLICY] = function (_ref2) {
  var buttonText = _ref2.buttonText;
  return {
    type: gtmEventTypes.CLICK_PRIVACY_POLICY,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_PRIVACY_POLICY,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Store Form - Clicked " + buttonText.toUpperCase()
  };
}, _gtmEvents[gtmEventTypes.CLICK_SUBMIT] = function (_ref3) {
  var buttonText = _ref3.buttonText;
  return {
    type: gtmEventTypes.CLICK_SUBMIT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_SUBMIT,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Store Form - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_SUBMIT_WITH_DATA] = function (_ref4) {
  var nameplate = _ref4.nameplate,
      bodyStyle = _ref4.bodyStyle,
      storeTypeCategory = _ref4.storeTypeCategory,
      grade = _ref4.grade,
      hasAccessories = _ref4.hasAccessories,
      fittedAccessories = _ref4.fittedAccessories,
      dealerName = _ref4.dealerName;
  return {
    type: gtmEventTypes.CLICK_SUBMIT_WITH_DATA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_SUBMIT_WITH_DATA,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Store Form - Clicked Submitted - \"" + storeTypeCategory.toUpperCase() + "\", \"" + nameplate.toUpperCase() + " " + bodyStyle.toUpperCase() + "\", \"" + grade.toUpperCase() + "\", ACCESSORIES \"" + hasAccessories.toUpperCase() + "\", \"" + fittedAccessories.toUpperCase() + "\" - " + dealerName.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_BACK] = function (_ref5) {
  var buttonText = _ref5.buttonText;
  return {
    type: gtmEventTypes.CLICK_BACK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_BACK,
    pageCategory: "Outlet Store",
    pageAction: "Outlet Form - Clicked - Clicked \"" + buttonText.toUpperCase() + "\""
  };
}, _gtmEvents);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



var gtmEventTypes = {
  CHECK_VIN: "FED-RECALLS-001",
  CLICK_CTA: "FED-RECALLS-002"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CHECK_VIN] = function (_ref) {
  var result = _ref.result;
  return {
    type: gtmEventTypes.CHECK_VIN,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CHECK_VIN,
    pageCategory: "Recalls",
    pageAction: "Recalls - Enter VIN - Recall Status \"" + result.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.CLICK_CTA] = function (_ref2) {
  var ctaName = _ref2.ctaName,
      result = _ref2.result;
  return {
    type: gtmEventTypes.CLICK_CTA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: "Recalls",
    pageAction: "Recalls - Recall Status \"" + result + "\" - Clicked \"" + ctaName.toUpperCase() + "\""
  };
}, _gtmEvents);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



var gtmEventTypes = {
  REGISTER_YOUR_INTEREST_FORM: "RYIF-001"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.REGISTER_YOUR_INTEREST_FORM] = function (_ref) {
  var nameplate = _ref.nameplate;
  return {
    type: gtmEventTypes.REGISTER_YOUR_INTEREST_FORM,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.REGISTER_YOUR_INTEREST_FORM,
    pageCategory: "Register Your Interest Form",
    pageAction: "Register Your Interest Form - \"" + nameplate + "\" - Clicked \"KEEP ME INFORMED\"."
  };
}, _gtmEvents);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



var gtmEventTypes = {
  CLICK_SEARCH_ICON: "FED-SEARCH-001",
  SITE_SEARCH_BAR_SEARCHED: "FED-SEARCH-002",
  SITE_SEARCH_RESULTS: "FED-SEARCH-003",
  SITE_SEARCH_RESULTS_CLICKED: "FED-SEARCH-004"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_SEARCH_ICON] = function (_ref) {
  var pageName = _ref.pageName;
  return {
    type: gtmEventTypes.CLICK_SEARCH_ICON,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_SEARCH_ICON,
    pageCategory: "Site Search Bar",
    pageAction: "Site Search Bar - Search icon clicked on " + pageName + " page"
  };
}, _gtmEvents[gtmEventTypes.SITE_SEARCH_BAR_SEARCHED] = function (_ref2) {
  var query = _ref2.query;
  return {
    type: gtmEventTypes.SITE_SEARCH_BAR_SEARCHED,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SITE_SEARCH_BAR_SEARCHED,
    pageCategory: "Site Search Bar",
    pageAction: "Site Search Bar - Searched \"" + query + "\""
  };
}, _gtmEvents[gtmEventTypes.SITE_SEARCH_RESULTS] = function (_ref3) {
  var query = _ref3.query;
  return {
    type: gtmEventTypes.SITE_SEARCH_RESULTS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SITE_SEARCH_RESULTS,
    pageCategory: "Site Search Results",
    pageAction: "Site Search Results - Searched \"" + query + "\""
  };
}, _gtmEvents[gtmEventTypes.SITE_SEARCH_RESULTS_CLICKED] = function (_ref4) {
  var query = _ref4.query,
      clicked = _ref4.clicked;
  return {
    type: gtmEventTypes.SITE_SEARCH_RESULTS_CLICKED,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.SITE_SEARCH_RESULTS_CLICKED,
    pageCategory: "Site Search Results",
    pageAction: "Site Search Results - Searched \"" + query + "\" and clicked \"" + clicked + "\""
  };
}, _gtmEvents);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



/* Ducks is a modular redux model where you put a duck.js file

 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  ITB_CLICK: "ITB_CLICK"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.ITB_CLICK] = function (_ref) {
  var name = _ref.name,
      id = _ref.id,
      category = _ref.category,
      actionMessage = _ref.actionMessage,
      customValue = _ref.customValue,
      version = _ref.version;
  return {
    type: gtmEventTypes.ITB_CLICK,
    event: gtmEventTypes.ITB_CLICK,
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: id,
    pageCategory: category,
    customValue: customValue,
    version: version
  };
}, _gtmEvents);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



// Event types
var gtmEventTypes = {
  PCPU_ENTER_POSTCODE: "PCPU_ENTER_POSTCODE",
  PCPU_CLOSE_POSTCODE: "PCPU_CLOSE_POSTCODE"

  // Event creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.PCPU_ENTER_POSTCODE] = function (_ref) {
  var postcode = _ref.postcode;
  return {
    type: gtmEventTypes.PCPU_ENTER_POSTCODE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-PCPU-001",
    pageCategory: "Postcode Pop-up",
    pageAction: "Postcode Pop-up - Entered \"" + postcode + "\""
  };
}, _gtmEvents[gtmEventTypes.PCPU_CLOSE_POSTCODE] = function () {
  return {
    type: gtmEventTypes.PCPU_CLOSE_POSTCODE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-PCPU-002",
    pageCategory: "Postcode Pop-up",
    pageAction: "Postcode Pop-up - closed"
  };
}, _gtmEvents);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



/* Ducks is a modular redux model where you put a duck.js file
in the same folder of the react component that uses it.
More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  BOOK_SERVICE_ENTER_MODEL: "BOOK_SERVICE_RASF_ENTER_MODEL",
  BOOK_SERVICE_ENTER_VIN_REGO: "BOOK_SERVICE_RASF_ENTER_VIN_REGO",
  BOOK_SERVICE_ENTER_ODOMETER: "BOOK_SERVICE_RASF_ENTER_ODOMETER",
  BOOK_SERVICE_SELECT_TITLE: "BOOK_SERVICE_RASF_SELECT_TITLE",
  BOOK_SERVICE_ENTER_FIRSTNAME: "BOOK_SERVICE_RASF_ENTER_FIRSTNAME",
  BOOK_SERVICE_ENTER_LASTNAME: "BOOK_SERVICE_RASF_ENTER_LASTNAME",
  BOOK_SERVICE_ENTER_PHONE: "BOOK_SERVICE_RASF_ENTER_PHONE",
  BOOK_SERVICE_ENTER_EMAIL: "BOOK_SERVICE_RASF_ENTER_EMAIL",
  BOOK_SERVICE_SELECT_POSTCODE_SUBURB: "BOOK_SERVICE_RASF_SELECT_POSTCODE_SUBURB",
  BOOK_SERVICE_DEALER_CLICK_ADDRESS: "BOOK_SERVICE_RASF_DEALER_CLICK_ADDRESS",
  BOOK_SERVICE_DEALER_CLICK_WEBSITE: "BOOK_SERVICE_RASF_DEALER_CLICK_WEBSITE",
  BOOK_SERVICE_DEALER_CLICK_PHONE: "BOOK_SERVICE_RASF_DEALER_CLICK_PHONE",
  BOOK_SERVICE_ENTER_DATE_INPUT: "BOOK_SERVICE_RASF_ENTER_DATE_INPUT",
  BOOK_SERVICE_SELECT_DROP_OFF_TIME: "BOOK_SERVICE_RASF_SELECT_DROP_OFF_TIME",
  BOOK_SERVICE_SELECT_PICK_UP_TIME: "BOOK_SERVICE_RASF_SELECT_PICK_UP_TIME",
  BOOK_SERVICE_ENTER_ENQUIRY: "BOOK_SERVICE_RASF_ENTER_ENQUIRY",
  BOOK_SERVICE_CHECK_PRIVACY_POLICY: "BOOK_SERVICE_RASF_CHECK_PRIVACY_POLICY",
  BOOK_SERVICE_CLICK_PRIVACY_POLICY: "BOOK_SERVICE_RASF_CLICK_PRIVACY_POLICY",
  BOOK_SERVICE_CLICK_SUBMIT: "BOOK_SERVICE_RASF_CLICK_SUBMIT",
  BOOK_SERVICE_CLICK_GO_BACK: "BOOK_SERVICE_RASF_CLICK_GO_BACK",
  BOOK_SERVICE_CLICK_EDIT_SERVICE: "BOOK_SERVICE_RASF_CLICK_EDIT_SERVICE" // Service summary section


  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_MODEL] = function (_ref) {
  var _ref$model = _ref.model,
      model = _ref$model === undefined ? "" : _ref$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_MODEL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-001",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Entered \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_VIN_REGO] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_VIN_REGO,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-002",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Entered \"VINREGO\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_ODOMETER] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_ODOMETER,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-003",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Entered \"ODOMETER\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_SELECT_TITLE] = function (_ref2) {
  var _ref2$model = _ref2.model,
      model = _ref2$model === undefined ? "" : _ref2$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_SELECT_TITLE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-004",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Entered \"TITLE\" - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_FIRSTNAME] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_FIRSTNAME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-005",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Entered \"FIRSTNAME\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_LASTNAME] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_LASTNAME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-006",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Entered \"LASTNAME\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_PHONE] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_PHONE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-007",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Entered \"PHONE\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_EMAIL] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_EMAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-008",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Entered \"EMAIL\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_SELECT_POSTCODE_SUBURB] = function (_ref3) {
  var _ref3$model = _ref3.model,
      model = _ref3$model === undefined ? "" : _ref3$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_SELECT_POSTCODE_SUBURB,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-009",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Selected \"POSTCODE/SUBURB\" - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_ADDRESS] = function (_ref4) {
  var dealerName = _ref4.dealerName,
      address = _ref4.address;
  return {
    type: gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_ADDRESS,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-010",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - " + dealerName + " - Address \"" + address + "\" - Clicked \"ADDRESS\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_WEBSITE] = function (_ref5) {
  var dealerName = _ref5.dealerName,
      address = _ref5.address,
      website = _ref5.website;
  return {
    type: gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_WEBSITE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-011",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - " + dealerName + " - Address \"" + address + "\" - Clicked \"WEBSITE " + website + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_PHONE] = function (_ref6) {
  var dealerName = _ref6.dealerName,
      address = _ref6.address,
      phone = _ref6.phone;
  return {
    type: gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_PHONE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-012",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - " + dealerName + " - Address " + address + " - Clicked \"PHONE " + phone + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_DATE_INPUT] = function (_ref7) {
  var _ref7$model = _ref7.model,
      model = _ref7$model === undefined ? "" : _ref7$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_DATE_INPUT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-013",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Entered \"" + (model ? model.format('DD/MM/YYYY') : 'DATE') + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_SELECT_DROP_OFF_TIME] = function (_ref8) {
  var _ref8$model = _ref8.model,
      model = _ref8$model === undefined ? "" : _ref8$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_SELECT_DROP_OFF_TIME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-014",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Submitted Preferred Drop Off Time - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_SELECT_PICK_UP_TIME] = function (_ref9) {
  var _ref9$model = _ref9.model,
      model = _ref9$model === undefined ? "" : _ref9$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_SELECT_PICK_UP_TIME,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-015",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Submitted Preferred Pick Up Time - \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_ENQUIRY] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_ENQUIRY,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-016",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Entered \"ENQUIRY\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_CHECK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_CHECK_PRIVACY_POLICY,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-017",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Checked \"PRIVACYPOLICY\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_CLICK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_CLICK_PRIVACY_POLICY,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-018",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Clicked \"PRIVACYPOLICY\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_CLICK_SUBMIT] = function (_ref10) {
  var _ref10$model = _ref10.model,
      model = _ref10$model === undefined ? "" : _ref10$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_CLICK_SUBMIT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-019",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Clicked \"" + model.toUpperCase() + "\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_CLICK_GO_BACK] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_CLICK_GO_BACK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-020",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Clicked \"GO BACK\""
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_CLICK_EDIT_SERVICE] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_CLICK_EDIT_SERVICE,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-RASF-021",
    pageCategory: "Request A Service Form",
    pageAction: "Request A Service Form - Clicked \"EDIT SERVICE\""
  };
}, _gtmEvents);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  CLICK_LINK: "WYSIWYG_CLICK_LINK"

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_LINK] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_LINK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    pageAction: CMSGroupGTM.action
  });
}, _gtmEvents);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



/* Ducks is a modular redux model where you put a duck.js file
in the same folder of the react component that uses it.
More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  COMPETITION_FROM_CLICK_SUBMIT: "COMPETITION_FROM_CLICK_SUBMIT"

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.COMPETITION_FROM_CLICK_SUBMIT] = function (_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === undefined ? "" : _ref$label,
      _ref$modelName = _ref.modelName,
      modelName = _ref$modelName === undefined ? "" : _ref$modelName,
      _ref$competitionGTMTi = _ref.competitionGTMTitle,
      competitionGTMTitle = _ref$competitionGTMTi === undefined ? "" : _ref$competitionGTMTi;
  return {
    type: gtmEventTypes.COMPETITION_FROM_CLICK_SUBMIT,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: "FED-CF-001",
    pageCategory: "Competition Form",
    pageAction: "Competition Form - Clicked \"" + label + "\" - \"" + modelName + "\" - \"" + competitionGTMTitle + "\""
  };
}, _gtmEvents);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_gtm_events__ = __webpack_require__(22);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\compare-vehicle-selector\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Redux


var closeIcon = function closeIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { "data-test": "compare-remove", viewBox: "0 0 17 17", style: { fill: "#910A2D" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M8.5,0A8.5,8.5,0,1,0,17,8.5,8.5,8.5,0,0,0,8.5,0Zm3.24,10.62a0.75,0.75,0,0,1,0,1.14,1,1,0,0,1-1.26,0l-2-2-2,2a1,1,0,0,1-1.26,0,0.75,0.75,0,0,1,0-1.14L7.32,8.5,5.26,6.38a0.75,0.75,0,0,1,0-1.14,1,1,0,0,1,1.26,0l2,2,2-2a1,1,0,0,1,1.26,0,0.75,0.75,0,0,1,0,1.14L9.68,8.5Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    })
  );
};

closeIcon.displayName = "closeIcon";
closeIcon.displayName = "closeIcon";
var carOutline = function carOutline() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { "data-test": "car-outline", viewBox: "0 0 111 54", style: { height: "3em" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 19
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M110.88,24.73a6.66,6.66,0,0,0-.16-1.07c-0.22-1.8-1-3.56-1.2-5.34-0.26-.61.63-4.7-1.15-4.31a44.53,44.53,0,0,1-3.88-2.66c-1.16-1-2.2-2.19-3.27-3.31-1.36-.9-2.31-2.18-3.51-3a27.75,27.75,0,0,0-4.58-2.77A44.4,44.4,0,0,0,86.52.56C85.32,0.39,83.9.4,82.58,0.29,79,0,75.64,0,72,0S64.74,0.2,61.12.4c-2.42.13-4.89,0.73-7.28,0.73a16.47,16.47,0,0,0-2.18.26,17.86,17.86,0,0,0-3.55.51C47.88,2,47,2.22,46.26,2.49h0A17.57,17.57,0,0,0,44,3.37l-0.1.05a17.25,17.25,0,0,0-1.72.9L41,5c-0.34.17-.72,0.37-1.09,0.57h0a7.44,7.44,0,0,0-.82.52L36.28,7.8l0,0a22.11,22.11,0,0,0-2.11,1.63c-0.4.15-2.8,1.89-2.84,1.91h0c-0.3.17-.59,0.34-0.89,0.53a2.85,2.85,0,0,0-.92.48,5.58,5.58,0,0,0-.3,1,1.45,1.45,0,0,1-.61.4,9,9,0,0,1-3.53.82,50,50,0,0,0-10,2.29,24,24,0,0,0-3.37,1.37c-1.15.6-2.12,1.45-3.24,2-0.4.2-4.4,2.14-5.45,2.83H3l-0.42.19-0.23.18h0A4.06,4.06,0,0,0,2,26.76c0.22,0.22-.93,1.48-1,1.62-0.48.79-.93,6.27-1,7.51a12.56,12.56,0,0,0,.24,2.67c0.17,1.23-.29,2.53,0,3.74a6.64,6.64,0,0,0,.63,1c0,0.8,2.08,1.94,2.67,2.26,0.92,0.5.93,0.16,1.84,0.22a4.6,4.6,0,0,1,1.34.7c0.61,0.23,1.32,0,1.91.18a1.26,1.26,0,0,1,.44.28,8.39,8.39,0,0,0,12.72.33,2.84,2.84,0,0,1,1.36-.17c1.42,0,26.27,1.14,30,1.48a7.19,7.19,0,0,1,1.67.45,2.28,2.28,0,0,1,.81,0,4.49,4.49,0,0,1,.75,1.09,6.25,6.25,0,0,0,1.74,1.68A7.71,7.71,0,0,0,59.62,53a8,8,0,0,0,8,0l0.1,0a2.17,2.17,0,0,0,.31-0.2,9.15,9.15,0,0,0,4.24-7,1.74,1.74,0,0,1,.66-0.94c0.85-.54,22.59-5,23.44-5.09,0,0,1.22,0,1.25,0a1.59,1.59,0,0,0,0,.83,4.52,4.52,0,0,0,.5.29c0.12,0.12.23,0.33,0.41,0.52,0.87,0.89,1.3,1.56,2.63,1.77,1.69,0.27,4.7.54,6-.79,1.59-1.64,1.85-4.18,2.22-6.42,0.19-1.15.81-2.11,1-3.33a13.51,13.51,0,0,0,.34-2.57C110.74,28.22,111.22,26.46,110.88,24.73Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      }
    })
  );
};

carOutline.displayName = "carOutline";
carOutline.displayName = "carOutline";

/** Renders a Compare vehicle selector */
var CompareVehicleSelectorContainer = function (_Component) {
  _inherits(CompareVehicleSelectorContainer, _Component);

  function CompareVehicleSelectorContainer(props) {
    _classCallCheck(this, CompareVehicleSelectorContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.hover = function (position, state) {
      var _this$setState;

      _this.setState((_this$setState = {}, _this$setState[position + "hover"] = state, _this$setState));
    };

    _this.selectedVehicle = function (position) {
      var pos = _this.state[position];
      var hover = _this.state[position + "hover"];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: [styles.icon, styles[position]],
          key: position,
          onClick: function onClick() {
            _this.setSelection(position);
          },
          onMouseOver: function onMouseOver() {
            return _this.hover(position, true);
          },
          onMouseOut: function onMouseOut() {
            return _this.hover(position, false);
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 63
          }
        },
        /* Always show 'x' icon on touch device, on desktop only show when hover */
        pos && __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["a" /* HAS_TOUCH */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.closeIcon, __source: {
              fileName: _jsxFileName,
              lineNumber: 73
            }
          },
          closeIcon()
        ) : pos && hover && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.closeIcon, __source: {
              fileName: _jsxFileName,
              lineNumber: 75
            }
          },
          closeIcon()
        ),
        pos ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["j" /* ConfiguredVehicle */], { src: pos.selectionImageSrc, __source: {
            fileName: _jsxFileName,
            lineNumber: 77
          }
        }) : carOutline()
      );
    };

    _this.handleSelection = function (index) {
      var item = Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_componentParser__["a" /* default */])(_this.props.components)[index].props;
      if (!_this.state.selectionLeft) {
        _this.setSelectionValue("selectionLeft", item);
      } else if (!_this.state.selectionRight) {
        _this.setSelectionValue("selectionRight", item);
      }
      _this.refs.compare.reset();
    };

    _this.setSelectionValue = function (selection, item) {
      var _search$pushParam;

      var search = _this.props.search;

      search.pushParam((_search$pushParam = {}, _search$pushParam[selection] = item.slug, _search$pushParam));
      _this.setState({ selection: selection }, function () {
        var _this$setState2;

        _this.setState((_this$setState2 = {}, _this$setState2[_this.state.selection] = item, _this$setState2));
      });
    };

    _this.setSelection = function (position) {
      var _search$pushParam2, _this$setState3;

      var search = _this.props.search;

      search.pushParam((_search$pushParam2 = {}, _search$pushParam2[position] = false, _search$pushParam2));
      _this.setState((_this$setState3 = {}, _this$setState3[position] = false, _this$setState3.selection = position, _this$setState3));
    };

    _this.childProps = function (index) {
      return {
        onClick: function onClick() {
          return _this.handleSelection(index);
        }
      };
    };

    var preSelectLeft = props.search.query.selectionLeft || "";
    var preSelectRight = props.search.query.selectionRight || "";
    var findNameplate = function findNameplate(preSelectSlug) {
      return Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_componentParser__["a" /* default */])(props.components).find(function (_ref) {
        var slug = _ref.props.slug;
        return slug && slug.toLowerCase() === preSelectSlug.toLowerCase();
      });
    };
    var findNameplateProps = function findNameplateProps(preSelectSlug) {
      var comp = findNameplate(preSelectSlug);
      return comp ? comp.props : false;
    };
    _this.state = {
      selectionLeft: findNameplateProps(preSelectLeft),
      selectionRight: findNameplateProps(preSelectRight),
      selection: "selectionLeft"
    };
    return _this;
  }

  /**
   * @param {String} Heading - Heading text.
   * @returns {ReactElement} react component
   */
  CompareVehicleSelectorContainer.prototype.render = function render() {
    var _this2 = this;

    var message = !this.state.selectionLeft ? "Select first model" : !this.state.selectionRight ? "Select second model" : false;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_8" /* Section */],
        { textAlign: "center", padding: true, backgroundColor: "#F5F5F5", __source: {
            fileName: _jsxFileName,
            lineNumber: 116
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_componentParser__["a" /* default */])(this.props.components.slice(0, 1)),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: [{ width: "100%" }, this.state.selectionLeft && this.state.selectionRight && {
              pointerEvents: "none",
              opacity: 0.33,
              transition: ".25s"
            }], __source: {
              fileName: _jsxFileName,
              lineNumber: 118
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_components__["z" /* GlobalNavItemGrid */],
            { ref: "compare", __source: {
                fileName: _jsxFileName,
                lineNumber: 127
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_componentParser__["a" /* default */])(this.props.components).slice(1).map(function (comp, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(comp, _this2.childProps(index + 1));
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_containers__["n" /* FixedBar */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 133
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              textAlign: "center",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              height: message ? "4em" : "5em",
              transition: ".3s"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 134
            }
          },
          this.selectedVehicle("selectionLeft"),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { "data-test": "message", style: styles.message, __source: {
                fileName: _jsxFileName,
                lineNumber: 144
              }
            },
            message || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */], {
              display: "inline",
              disabled: !(this.state.selectionLeft && this.state.selectionRight),
              label: __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].innerWidth > 481 ? this.props.ctaText : this.props.ctaText.substring(0, 7),
              href: this.props.ctaHref + "?cars=" + this.state.selectionLeft.slug + "," + this.state.selectionRight.slug,
              onClick: function onClick() {
                return _this2.props.gtmEvent({
                  gtmID: __WEBPACK_IMPORTED_MODULE_8_store_gtm_events__["b" /* compareVehicleSelectorActionTypes */].COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE,
                  gtmPayload: {
                    model1: _this2.state.selectionLeft.slug,
                    model2: _this2.state.selectionRight.slug
                  }
                });
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 146
              }
            })
          ),
          this.selectedVehicle("selectionRight")
        )
      )
    );
  };

  return CompareVehicleSelectorContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CompareVehicleSelectorContainer.propTypes = {
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ctaText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ctaHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      selectionLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      selectionRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })
  }),
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
CompareVehicleSelectorContainer.displayName = "CompareVehicleSelectorContainer";


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["g" /* SearchParams */])({
  expose: "search",
  exposeParams: ["selectionLeft", "selectionRight"]
}), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["i" /* gtmEvent */])())(CompareVehicleSelectorContainer));

var styles = {
  closeIcon: {
    fill: "#910A2D",
    height: "1em",
    width: "1em",
    right: 0,
    top: 0,
    position: "absolute",
    pointerEvents: "none"
  },
  message: {
    letterSpacing: "0.2em",
    fontWeight: "600",
    color: "#101010",
    textTransform: "uppercase"
  },
  icon: {
    flex: "0 0 7em",
    display: "flex",
    alignItems: "center",
    position: "relative",
    cursor: "pointer",
    fill: "#dbdbdb",
    verticalAlign: "middle",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: "2em",
    marginRight: "2em",
    "@media (max-width: 30em)": {
      marginLeft: ".2em",
      marginRight: ".2em",
      flex: "1 1 7em"
    }
  },
  selectionLeft: {
    marginLeft: "auto"
  },
  selectionRight: {
    marginRight: "auto"
  }
};

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Configurator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_apis_expose_global__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__singularity_bar__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__build_compact_nav__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__build_body_step__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__build_drive_step__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__build_grade_step__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__build_color_step__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__build_summary_step__ = __webpack_require__(1230);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\build\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var getnameIfDefault = function getnameIfDefault(option) {
  return option && Object(__WEBPACK_IMPORTED_MODULE_9_utils__["q" /* get */])("name", option);
};
var getShortModel = function getShortModel(modelName) {
  return (modelName.split(" ")[1] || modelName.split(" ")[0]).toUpperCase();
};

var stateToParamsMapping = function stateToParamsMapping(options) {
  var safetyModel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    bodyStyle: getnameIfDefault(options.bodyStyle),
    drivetrain: getnameIfDefault(options.drivetrain),
    grade: getnameIfDefault(options.grade),
    transmission: getnameIfDefault(options.transmission),
    engine: getnameIfDefault(options.engine),
    engineSize: options.engine && Object(__WEBPACK_IMPORTED_MODULE_9_utils__["q" /* get */])("engineSize", options.engine),
    fuelType: options.engine && Object(__WEBPACK_IMPORTED_MODULE_9_utils__["q" /* get */])("fuelType", options.engine),
    modelCode: safetyModel ? options.engine && Object(__WEBPACK_IMPORTED_MODULE_9_utils__["q" /* get */])("safetyModelCode", options.engine) : options.engine && Object(__WEBPACK_IMPORTED_MODULE_9_utils__["q" /* get */])("modelCode", options.engine),
    color: getnameIfDefault(options.color),
    colorCode: options.color && Object(__WEBPACK_IMPORTED_MODULE_9_utils__["q" /* get */])("ref", options.color),
    interiorDesign: getnameIfDefault(options.interiorDesign),
    interiorDesignCode: options.interiorDesign && Object(__WEBPACK_IMPORTED_MODULE_9_utils__["q" /* get */])("ref", options.interiorDesign)
  };
};

var Configurator = function (_Component) {
  _inherits(Configurator, _Component);

  function Configurator(props) {
    _classCallCheck(this, Configurator);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var _this$paramsToState = _this.paramsToState(_this.props.search.query),
        options = _this$paramsToState.options,
        activeStep = _this$paramsToState.activeStep;

    var newAllData = [];
    newAllData.push({}); // for 0 to be nothing
    if (options.bodyStyles.length > 1) {
      newAllData.push({
        name: "Body",
        stepType: "bodyStep",
        heading: props.bodyStyleHeading,
        message: "Choose body " + (options.drivetrains.length > 1 ? "& drive " : "") + "to see price",
        radioGroup: [{ groupName: "bodyStyles", itemName: "bodyStyle" }],
        fullWidth: true,
        imageSelector: true,
        finePrint: true,
        prevCTA: false,
        nextCTA: {
          label: "Next Step",
          onClick: function onClick() {
            _this.props.gtmEvent({
              gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON,
              gtmPayload: {
                modelName: _this.state.options.nameplate.name,
                stepNumber: _this.state.activeStep
              }
            });
            _this.changeStep(1);
          }
        }
      });
    }
    if (options.drivetrains.length > 1) {
      newAllData.push({
        name: "Drive",
        stepType: "driveStep",
        heading: props.drivetrainHeading,
        message: "Choose drive to see price",
        radioGroup: [{ groupName: "drivetrains", itemName: "drivetrain" }],
        configuredVehicle: true,
        prevCTA: {
          label: "Previous",
          onClick: function onClick() {
            _this.props.gtmEvent({
              gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON,
              gtmPayload: {
                modelName: _this.state.options.nameplate.name,
                stepNumber: _this.state.activeStep
              }
            });
            _this.changeStep(-1);
          }
        },
        nextCTA: {
          label: "Next Step",
          onClick: function onClick() {
            _this.props.gtmEvent({
              gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON,
              gtmPayload: {
                modelName: _this.state.options.nameplate.name,
                stepNumber: _this.state.activeStep
              }
            });
            _this.changeStep(1);
          }
        }
      });
    }
    // Grade step is always visible
    newAllData.push({
      name: "Grade",
      stepType: "gradeStep",
      heading: props.gradeHeading,
      radioGroup: [{ groupName: "grades", itemName: "grade" }, { groupName: "transmissions", itemName: "transmission" }, { groupName: "engines", itemName: "engine" }],
      showPrice: true,
      configuredVehicle: true,
      featureList: true,
      finePrint: true,
      specifications: true,
      features: true,
      prevCTA: {
        label: "Previous",
        onClick: function onClick() {
          _this.props.gtmEvent({
            gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON,
            gtmPayload: {
              modelName: _this.state.options.nameplate.name,
              stepNumber: _this.state.activeStep
            }
          });
          _this.changeStep(-1);
        }
      },
      nextCTA: {
        label: "Next Step",
        onClick: function onClick() {
          _this.props.gtmEvent({
            gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON,
            gtmPayload: {
              modelName: _this.state.options.nameplate.name,
              stepNumber: _this.state.activeStep
            }
          });
          _this.changeStep(1);
        }
      }
    });
    if (options.colors.length > 1) {
      newAllData.push({
        name: "Color",
        stepType: "colorStep",
        heading: props.colorHeading,
        radioGroup: [{ groupName: "colors", itemName: "color" }, { groupName: "interiorDesigns", itemName: "interiorDesign" }],
        showPrice: true,
        colorSelector: true,
        configuredVehicle: true,
        prevCTA: {
          label: "Previous",
          onClick: function onClick() {
            _this.props.gtmEvent({
              gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS,
              gtmPayload: {
                modelName: _this.state.options.nameplate.name,
                stepNumber: _this.state.activeStep
              }
            });
            _this.changeStep(-1);
          }
        },
        nextCTA: {
          label: "Next Step",
          onClick: function onClick() {
            _this.props.gtmEvent({
              gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_COLOR_CLICKED_NEXT,
              gtmPayload: {
                modelName: _this.state.options.nameplate.name,
                stepNumber: _this.state.activeStep
              }
            });
            _this.changeStep(1);
          }
        }
      });
    }
    newAllData.push({
      name: "Summary",
      stepType: "summaryStep",
      heading: props.summaryHeading,
      summary: true,
      specifications: true,
      features: true,
      showChildren: true,
      prevCTA: {
        label: "Previous",
        onClick: function onClick() {
          _this.props.gtmEvent({
            gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS,
            gtmPayload: {
              modelName: _this.state.options.nameplate.name,
              stepNumber: _this.state.activeStep
            }
          });
          _this.changeStep(-1);
        }
      },
      lastCTA: {
        label: props.finalCta.label,
        href: props.finalCta.href,
        external: props.finalCta.external
      }
    });
    _this.state = {
      activeStep: activeStep || 1,
      loading: true,
      options: options,
      selectColorInterior: false,
      newAllData: newAllData,
      form: {
        safetyModel: {
          validations: {}
        }
      },
      isModalOpen: false,
      colorStepVisited: false
    };
    return _this;
  }

  Configurator.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.props.price.setOptions({
      mapping: function mapping(temp) {
        return {
          nameplate: temp.nameplate.name,
          bodystyle: temp.bodyStyle.name,
          drivetrain: temp.drivetrain.name,
          grade: temp.grade.name,
          transmission: temp.transmission.name,
          engineSize: temp.engine.engineSize,
          fueltype: temp.engine.fuelType,
          modelCode: temp.engine.modelCode,
          color: temp.color.ref,
          interior: temp.interiorDesign.ref
        };
      },
      fetchURL: this.props.priceApiEndpoint
    });
    this.props.specifications.setOptions({
      mapping: function mapping(temp) {
        return {
          nameplate: temp.nameplate.name,
          bodystyle: temp.bodyStyle.name,
          grade: temp.grade.name,
          drivetrain: temp.drivetrain.name,
          engineSize: temp.engine.engineSize,
          fueltype: temp.engine.fuelType,
          modelCode: temp.engine.modelCode,
          transmission: temp.transmission.name,
          featured: true
        };
      },
      fetchURL: this.props.specsApiEndpoint,
      featured: true
    });
    setTimeout(function () {
      _this2.props.gtmEvent({
        gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_LOAD_CONFIG,
        gtmPayload: {
          modelName: _this2.state.options.nameplate.name,
          stepNumber: _this2.state.activeStep,
          stepName: _this2.state.newAllData[_this2.state.activeStep].name,
          bodyName: _this2.state.options.bodyStyle.name,
          driveName: _this2.state.options.drivetrain.name,
          gradeName: _this2.state.options.grade.name,
          colorName: _this2.state.options.color.name,
          interiorName: _this2.state.options.interiorDesign.name
        }
      });
      _this2.updateData();
      _this2.setState({ loading: false }, function () {
        Object(__WEBPACK_IMPORTED_MODULE_9_utils__["P" /* scrollToNode */])(_this2.node);
      });
    }, 100);
    Object(__WEBPACK_IMPORTED_MODULE_11_apis_expose_global__["a" /* default */])("getConfiguredVehicle", function () {
      var options = _this2.state.options;
      var bodyStyle = options.bodyStyle,
          color = options.color,
          drivetrain = options.drivetrain,
          engine = options.engine,
          grade = options.grade,
          interiorDesign = options.interiorDesign,
          nameplate = options.nameplate,
          transmission = options.transmission;

      return {
        step: _this2.state.activeStep,
        bodyStyle: bodyStyle,
        color: color,
        drivetrain: drivetrain,
        engine: engine,
        grade: grade,
        interiorDesign: interiorDesign,
        nameplate: nameplate,
        transmission: transmission,
        price: _this2.props.price.data[0].price,
        stepName: _this2.state.newAllData[_this2.state.activeStep].heading || false,
        summary: _this2.state.newAllData[_this2.state.activeStep].summary || false
      };
    });
  };

  Configurator.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var compact = this.props.compact;
    var _state = this.state,
        activeStep = _state.activeStep,
        options = _state.options,
        safetyModel = _state.form.safetyModel;


    if (prevState.activeStep && prevState.activeStep !== activeStep || prevProps.compact && prevProps.compact !== compact) {
      if (safetyModel.value) {
        Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
          safetyModel: safetyModel.value
        });
      }
    }

    if (activeStep === 2 && (prevState.options.engine && prevState.options.engine.name !== options.engine.name || prevState.options.grade && prevState.options.grade.name !== options.grade.name || prevState.options.transmission && prevState.options.transmission.name !== options.transmission.name)) {
      Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
        safetyModel: options.engine.modelCode === options.engine.safetyModelCode
      });
    }
  };

  Configurator.prototype.updateData = function updateData() {
    this.pushHistory();
    this.updateSpecifications();
    this.updatePrice();
    this.updateVehicleInLocalStorage();
  };

  Configurator.prototype.updateVehicleInLocalStorage = function updateVehicleInLocalStorage() {
    var localVehicle = this.props.localVehicle;
    var _state2 = this.state,
        options = _state2.options,
        form = _state2.form;

    localVehicle.updateVehicle(getnameIfDefault(options.nameplate), stateToParamsMapping(options, form.safetyModel.value));
  };

  Configurator.prototype.safetyModel = function safetyModel() {
    var _this3 = this;

    var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _props = this.props,
        safetyModelExcess = _props.safetyModelExcess,
        safetyModelBlurb = _props.safetyModelBlurb,
        safetyModelDisclaimer = _props.safetyModelDisclaimer;

    var price = ((this.props.price || {}).data || [])[0] || {};
    var included = price && price.safetyModelPrice && price.price === price.safetyModelPrice;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.feature(summary), __source: {
          fileName: _jsxFileName,
          lineNumber: 538
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { display: "flex", alignItems: "center" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 539
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["M" /* InputCheckBox */], _extends({
          name: "safetyModel",
          label: "Vision Technology",
          checked: this.props.isInitialSafetyModel || included,
          disabled: included
        }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "safetyModel", function () {
          _this3.updateData();
        }), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 540
          }
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            onClick: function onClick() {
              _this3.setState({ isModalOpen: true });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 549
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["J" /* InfoIcon */], { style: {
              height: "16px",
              width: "16px",
              fill: "#999999",
              paddingLeft: "6px",
              cursor: "pointer",
              verticalAlign: "middle"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 553
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 563
          }
        },
        included ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 565
            }
          },
          "Included as standard"
        ) : safetyModelExcess && safetyModelDisclaimer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["l" /* Caption */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 568
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_containers__["w" /* InlineDisclaimerBlock */],
            {
              message: safetyModelDisclaimer,
              disclaimerStyling: {
                fontSize: "16px",
                top: "0.3em"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 569
              }
            },
            "+$",
            safetyModelExcess.toLocaleString()
          )
        )
      ),
      this.state.isModalOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["Z" /* Modal */],
        {
          width: "600px",
          handleClose: function handleClose() {
            _this3.setState({ isModalOpen: false });
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 581
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { xmlString: safetyModelBlurb, textAlign: "left", __source: {
            fileName: _jsxFileName,
            lineNumber: 586
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */],
          {
            styleName: "black",
            onClick: function onClick() {
              _this3.setState({ isModalOpen: false });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 587
            }
          },
          "Close"
        )
      )
    );
  };

  Configurator.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        backgroundColor = _props2.backgroundColor,
        safetyModelExcess = _props2.safetyModelExcess,
        finance = _props2.finance,
        financeOptionText = _props2.financeOptionText;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        ref: function ref(node) {
          _this4.node = node;
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 604
        }
      },
      this.state.loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["f" /* BrowserHeightSection */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 609
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["N" /* Loading */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 610
          }
        })
      ),
      !this.state.loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.base(backgroundColor, 50), "data-test": "configurator", __source: {
            fileName: _jsxFileName,
            lineNumber: 614
          }
        },
        this.props.compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__build_compact_nav__["a" /* default */], {
          active: this.state.activeStep,
          title: this.state.newAllData[this.state.activeStep].heading,
          back: function back() {
            return _this4.changeStep(-1);
          },
          reload: function reload() {
            return _this4.setState({ options: Object(__WEBPACK_IMPORTED_MODULE_9_utils__["H" /* parseKoalaData */])(_this4.props.data) }, function () {
              _this4.setStep(1);
            });
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 616
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.container, __source: {
              fileName: _jsxFileName,
              lineNumber: 625
            }
          },
          !this.props.compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.dots, "data-test": "configurator-step-counter", __source: {
                fileName: _jsxFileName,
                lineNumber: 627
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_7" /* StepCounter */], {
              steps: this.state.newAllData.filter(function (item, index) {
                return index !== 0;
              }),
              active: this.state.activeStep,
              setStep: function setStep(index) {
                _this4.setStep(index);
                setTimeout(function () {
                  // Somehow GTM for sidenav is not firing on tbalet
                  // I added this timeout for fixing that issue
                  _this4.props.gtmEvent({
                    gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_CLICKED_SIDE_NAV,
                    gtmPayload: {
                      modelName: _this4.state.options.nameplate.name,
                      stepNumber: _this4.state.activeStep,
                      stepName: _this4.state.newAllData[_this4.state.activeStep].name,
                      newStepName: _this4.state.newAllData[index].name
                    }
                  });
                }, 100);
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 628
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 649
              }
            },
            this.state.newAllData[this.state.activeStep].stepType === "bodyStep" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__build_body_step__["a" /* default */], {
              stepData: this.state.newAllData[this.state.activeStep],
              compact: this.props.compact,
              price: this.props.price,
              fullSpecCta: this.props.fullSpecCta,
              mainHeading: this.props.mainHeading,
              activeStep: this.state.activeStep,
              search: this.props.search,
              options: this.state.options,
              handleChangeOption: this.handleChangeOption, __source: {
                fileName: _jsxFileName,
                lineNumber: 651
              }
            }),
            this.state.newAllData[this.state.activeStep].stepType === "driveStep" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__build_drive_step__["a" /* default */], {
              stepData: this.state.newAllData[this.state.activeStep],
              compact: this.props.compact,
              price: this.props.price,
              fullSpecCta: this.props.fullSpecCta,
              mainHeading: this.props.mainHeading,
              activeStep: this.state.activeStep,
              search: this.props.search,
              options: this.state.options,
              handleChangeOption: this.handleChangeOption, __source: {
                fileName: _jsxFileName,
                lineNumber: 663
              }
            }),
            this.state.newAllData[this.state.activeStep].stepType === "gradeStep" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__build_grade_step__["a" /* default */], {
              price: this.props.price,
              stepData: this.state.newAllData[this.state.activeStep],
              compact: this.props.compact,
              fullSpecCta: this.props.fullSpecCta,
              mainHeading: this.props.mainHeading,
              activeStep: this.state.activeStep,
              specifications: this.props.specifications,
              search: this.props.search,
              options: this.state.options,
              handleChangeOption: this.handleChangeOption,
              safetyModel: this.safetyModel(),
              includeSafetyModel: this.state.form.safetyModel.value,
              finance: finance, __source: {
                fileName: _jsxFileName,
                lineNumber: 675
              }
            }),
            this.state.newAllData[this.state.activeStep].stepType === "colorStep" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__build_color_step__["a" /* default */], {
              stepData: this.state.newAllData[this.state.activeStep],
              compact: this.props.compact,
              display360: this.props.display360,
              price: this.props.price,
              fullSpecCta: this.props.fullSpecCta,
              mainHeading: this.props.mainHeading,
              activeStep: this.state.activeStep,
              selectColorInterior: this.state.selectColorInterior,
              handleChangeInterior: this.handleChangeInterior,
              search: this.props.search,
              options: this.state.options,
              handleChangeOption: this.handleChangeOption, __source: {
                fileName: _jsxFileName,
                lineNumber: 691
              }
            }),
            this.state.newAllData[this.state.activeStep].stepType === "summaryStep" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__build_summary_step__["a" /* default */], {
              allData: this.state.newAllData,
              stepData: this.state.newAllData[this.state.activeStep],
              compact: this.props.compact,
              mainHeading: this.props.mainHeading,
              price: this.props.price,
              disableSavePrompt: this.props.disableSavePrompt,
              delayToShowSavePrompt: this.props.delayToShowSavePrompt,
              fullSpecCta: this.props.fullSpecCta,
              hideLinks: this.props.hideLinks,
              activeStep: this.state.activeStep,
              safetyModel: this.safetyModel(true),
              safetyModelExcess: safetyModelExcess,
              selectColorInterior: this.state.selectColorInterior,
              savedBuildEndPoint: this.props.savedBuildEndPoint,
              sharedBuildEndPoint: this.props.sharedBuildEndPoint,
              search: this.props.search,
              setStep: function setStep(index) {
                _this4.props.gtmEvent({
                  gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON,
                  gtmPayload: {
                    modelName: _this4.state.options.nameplate.name,
                    stepNumber: _this4.state.activeStep,
                    newStepNumber: index
                  }
                });
                _this4.setStep(index);
              },
              specifications: this.props.specifications,
              includeSafetyModel: this.state.form.safetyModel.value,
              finance: finance,
              financeOptionText: financeOptionText,
              gtmEvents: {
                collapse: [{
                  func: this.props.gtmEvent,
                  args: [{
                    gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS,
                    gtmPayload: {
                      modelName: this.state.options.nameplate.name,
                      stepNumber: this.state.activeStep,
                      newStatusName: "collapse"
                    }
                  }]
                }],
                expand: [{
                  func: this.props.gtmEvent,
                  args: [{
                    gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS,
                    gtmPayload: {
                      modelName: this.state.options.nameplate.name,
                      stepNumber: this.state.activeStep,
                      newStatusName: "expand"
                    }
                  }]
                }]
              },
              gtmEventsDisclaimers: [{
                func: this.props.gtmEvent,
                args: [{
                  gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER,
                  gtmPayload: {
                    modelName: this.state.options.nameplate.name,
                    stepNumber: this.state.activeStep
                  }
                }]
              }],
              gtmEventPriceDisclaimer: [{
                func: this.props.gtmEvent,
                args: [{
                  gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_CLICKED_PRICE_DISCLAIMER,
                  gtmPayload: {
                    modelName: this.state.options.nameplate.name,
                    stepNumber: this.state.activeStep,
                    stepName: this.state.newAllData[this.state.activeStep].name
                  }
                }]
              }],
              gtmEventsFullSpecLink: [{
                func: this.props.gtmEvent,
                args: [{
                  gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST,
                  gtmPayload: {
                    modelName: this.state.options.nameplate.name,
                    stepNumber: this.state.activeStep
                  }
                }]
              }],
              options: this.state.options,
              testDriveUrl: this.props.finalCta.href,
              handleChangeOption: this.handleChangeOption,
              gtmEvent: this.props.gtmEvent,
              gtmBuildToolActionTypes: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */], __source: {
                fileName: _jsxFileName,
                lineNumber: 706
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 825
            }
          },
          this.state.newAllData[this.state.activeStep].showChildren && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 827
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_8_containers_utilities__["a" /* childParser */])(this.props)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__singularity_bar__["a" /* default */],
          {
            nameplate: this.state.options.nameplate.name,
            grade: this.state.options.grade.name,
            compact: this.props.compact,
            drive: this.state.options.drivetrains.length >= 2,
            price: this.props.price,
            includeSafetyModel: this.state.form.safetyModel.value,
            src: this.state.options.color.imageSrc,
            hidden: !this.state.newAllData[this.state.activeStep].showPrice,
            gtmEvents: [{
              func: this.props.gtmEvent,
              args: [{
                gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_CLICKED_PRICE_DISCLAIMER,
                gtmPayload: {
                  modelName: this.state.options.nameplate.name,
                  stepNumber: this.state.activeStep,
                  stepName: this.state.newAllData[this.state.activeStep].name
                }
              }]
            }],
            disclaimer: !this.props.disclaimer,
            summary: this.state.newAllData[this.state.activeStep].stepType === "summaryStep", __source: {
              fileName: _jsxFileName,
              lineNumber: 830
            }
          },
          this.props.backLink && this.state.activeStep === 1 && !this.props.compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */], {
            label: "Previous",
            href: this.props.backLink,
            styleName: "blackOutlined",
            display: "inline", __source: {
              fileName: _jsxFileName,
              lineNumber: 859
            }
          }),
          this.state.activeStep !== 1 && this.state.newAllData[this.state.activeStep].prevCTA && !!this.state.activeStep && !this.props.compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */], _extends({}, this.state.newAllData[this.state.activeStep].prevCTA, {
            styleName: "blackOutlined",
            display: "inline", __source: {
              fileName: _jsxFileName,
              lineNumber: 869
            }
          })),
          this.state.newAllData[this.state.activeStep].nextCTA && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */], _extends({}, this.state.newAllData[this.state.activeStep].nextCTA, {
            display: "inline",
            margin: "0", __source: {
              fileName: _jsxFileName,
              lineNumber: 875
            }
          })),
          this.state.newAllData[this.state.activeStep].lastCTA && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */], _extends({}, this.state.newAllData[this.state.activeStep].lastCTA, {
            display: "inline",
            margin: "0",
            gtm: {
              action: "Build \"" + getShortModel(this.state.options.nameplate.name) + "\" - Step " + this.state.activeStep + " SUMMARY - Clicked \"BOOK A TEST DRIVE\"",
              category: "Build Tool \"" + getShortModel(this.state.options.nameplate.name) + "\""
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 881
            }
          }))
        )
      )
    );
  };

  return Configurator;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.setStep = function (index) {
    if (index > 0 && index <= _this5.state.newAllData.length) {
      _this5.setState({ activeStep: index }, function () {
        Object(__WEBPACK_IMPORTED_MODULE_9_utils__["P" /* scrollToNode */])(_this5.node);
        _this5.updateData();
        _this5.checkColorStepVisitingStatus();
      });
    }
  };

  this.checkColorStepVisitingStatus = function () {
    if (_this5.state.newAllData[_this5.state.activeStep].stepType === "colorStep") {
      _this5.setState({ colorStepVisited: true });
    }
  };

  this.changeStep = function (change) {
    _this5.setState({
      activeStep: _this5.state.activeStep + change
    }, function () {
      Object(__WEBPACK_IMPORTED_MODULE_9_utils__["P" /* scrollToNode */])(_this5.node);
      _this5.updateData();
      _this5.checkColorStepVisitingStatus();
    });
  };

  this.handleChangeOption = function (option) {
    _this5.setState({
      options: Object(__WEBPACK_IMPORTED_MODULE_9_utils__["H" /* parseKoalaData */])(_this5.props.data, {
        newSelection: option,
        stateOptions: _this5.state.options
      }, _this5.state.colorStepVisited)
    }, function () {
      _this5.handleGTMChange(option);
      _this5.pushHistory();
      _this5.updatePrice();
      _this5.updateSpecifications();
    });
  };

  this.handleGTMChange = function (option) {
    switch (option.type) {
      case "bodyStyle":
        _this5.props.gtmEvent({
          gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_BODY_CHANGE,
          gtmPayload: {
            modelName: _this5.state.options.nameplate.name,
            stepNumber: _this5.state.activeStep,
            bodyName: option.name
          }
        });
        break;
      case "drivetrain":
        _this5.props.gtmEvent({
          gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_DRIVE_CHANGE,
          gtmPayload: {
            modelName: _this5.state.options.nameplate.name,
            stepNumber: _this5.state.activeStep,
            driveName: option.name
          }
        });
        break;
      case "grade":
      case "transmission":
      case "engine":
        _this5.props.gtmEvent({
          gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_GRADE_CHANGE,
          gtmPayload: {
            modelName: _this5.state.options.nameplate.name,
            stepNumber: _this5.state.activeStep,
            gradeName: _this5.state.options.grade.name + " " + _this5.state.options.transmission.name + " " + _this5.state.options.engine.name
          }
        });
        break;
      case "color":
        _this5.props.gtmEvent({
          gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_COLOR_CHANGE,
          gtmPayload: {
            modelName: _this5.state.options.nameplate.name,
            stepNumber: _this5.state.activeStep,
            colorName: option.name
          }
        });
        break;
      case "interiorDesign":
        _this5.props.gtmEvent({
          gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR,
          gtmPayload: {
            modelName: _this5.state.options.nameplate.name,
            stepNumber: _this5.state.activeStep,
            interiorName: option.name
          }
        });
        break;

      default:
        break;
    }
  };

  this.handleChangeInterior = function (newIndex) {
    _this5.props.gtmEvent({
      gtmID: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["d" /* gtmBuildToolActionTypes */].BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR,
      gtmPayload: {
        modelName: _this5.state.options.nameplate.name,
        stepNumber: _this5.state.activeStep,
        typeName: newIndex === 1 ? "INTERIOR" : "EXTERIOR"
      }
    });
    _this5.setState({
      selectColorInterior: newIndex
    }, function () {
      _this5.pushHistory();
      _this5.updatePrice();
    });
  };

  this.pushHistory = function () {
    var step = _this5.state.activeStep;
    _this5.props.search.pushParam(_extends({}, stateToParamsMapping(_this5.state.options, _this5.state.form.safetyModel.value), {
      step: step && step !== 1 && step
    }));
  };

  this.updateSpecifications = function () {
    var _state3 = _this5.state,
        options = _state3.options,
        safetyModel = _state3.form.safetyModel;

    _this5.props.specifications.update(_extends({}, options, {
      engine: _extends({}, options.engine, {
        modelCode: safetyModel.value ? options.engine.safetyModelCode : options.engine.modelCode
      })
    }));
  };

  this.updatePrice = function () {
    var price = _this5.props.price;

    price.update(_this5.state.options);
  };

  this.paramsToState = function (newParams) {
    var options = null;
    var activeStep = 1;
    if (newParams) {
      Object.keys(newParams).forEach(function (key) {
        var value = newParams[key];
        if (key === "step") {
          activeStep = Number(value);
        } else {
          options = Object(__WEBPACK_IMPORTED_MODULE_9_utils__["H" /* parseKoalaData */])(_this5.props.data, {
            newSelection: { type: key, name: value },
            stateOptions: options
          });
        }
      });
    }
    options = options || Object(__WEBPACK_IMPORTED_MODULE_9_utils__["H" /* parseKoalaData */])(_this5.props.data);
    return { options: options, activeStep: activeStep };
  };
};

Configurator.displayName = "Configurator";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["g" /* SearchParams */])({
  trackParams: ["step"],
  exposeParams: ["step", "bodyStyle", "drivetrain", "grade", "transmission", "engine", "color", "interiorDesign"]
}), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["i" /* gtmEvent */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["d" /* LocalVehicle */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["e" /* Price */])({ expose: "price" }), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["h" /* Specs */])({ expose: "specifications" }))(Configurator));

Configurator.propTypes = {
  mainHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyStyleHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  drivetrainHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  finalCta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  backLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  priceApiEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  specsApiEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  summaryHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fullSpecCta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  localVehicle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    updateVehicle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  specifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
    update: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    setOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
    update: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    setOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    pushParam: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    queryString: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

Configurator.defaultProps = {
  mainHeading: "",
  bodyStyleHeading: "",
  drivetrainHeading: "",
  gradeHeading: "",
  colorHeading: "",
  finalCta: {},
  fullSpecCta: {},
  priceApiEndpoint: "",
  hideLinks: false,
  specsApiEndpoint: "",
  summaryHeading: "",
  data: {},
  specifications: { data: false, update: __WEBPACK_IMPORTED_MODULE_9_utils__["C" /* noop */], setOptions: __WEBPACK_IMPORTED_MODULE_9_utils__["C" /* noop */] },
  price: { data: false, update: __WEBPACK_IMPORTED_MODULE_9_utils__["C" /* noop */], setOptions: __WEBPACK_IMPORTED_MODULE_9_utils__["C" /* noop */] }
};

var styles = {
  base: function base(backgroundColor, singularityBarHeight) {
    return {
      background: backgroundColor || "#f5f5f5",
      position: "relative",
      textAlign: "center",
      maxWidth: "100vw",
      overflow: "hidden",
      minHeight: "calc(100vh - " + singularityBarHeight + "px)"
    };
  },
  dots: {
    position: "fixed",
    top: "50%",
    left: "1em",
    transform: "translateY(-50%)",
    zIndex: 10
  },
  container: {
    flex: "1 1 100%",
    margin: "0 auto"
  },
  feature: function feature(summary) {
    return {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: !summary && "1px solid #e7e7e7",
      minHeight: !summary && "44px"
    };
  }
};

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\dealer-map-page\\index.jsx";




var DealerMapPage = function DealerMapPage(_ref) {
  var dealerName = _ref.dealerName,
      lat = _ref.lat,
      lng = _ref.lng;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["P" /* MapWithMarkers */], {
    map: {
      center: {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      },
      zoom: 17
    },
    activeIndex: 0,
    locations: [{
      name: dealerName,
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    }],
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    }
  });
};

DealerMapPage.displayName = "DealerMapPage";
DealerMapPage.displayName = "DealerMapPage";
DealerMapPage.propTypes = {
  dealerName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  lat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  lng: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DealerMapPage);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\text-video-frame\\index.jsx";





var TextVideoFrame = function TextVideoFrame(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.wrapper, __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h1",
      { style: styles.text, __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      },
      children
    )
  );
};

TextVideoFrame.displayName = "TextVideoFrame";
TextVideoFrame.displayName = "TextVideoFrame";
var styles = {
  wrapper: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "100%",
    margin: "0 auto"
  },
  text: _extends({}, __WEBPACK_IMPORTED_MODULE_2_constants_general_style__["b" /* BASE_HEADING */], {
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].WHITE,
    fontSize: "400%",
    textAlign: "center",
    letterSpacing: "0.1em"
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium__["a" /* default */])(TextVideoFrame));

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_persist__ = __webpack_require__(69);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\location-text\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LocationText = function (_Component) {
  _inherits(LocationText, _Component);

  function LocationText(props) {
    _classCallCheck(this, LocationText);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    if (!Object(__WEBPACK_IMPORTED_MODULE_4__apis_persist__["c" /* load */])("locality")) {
      var updatePostcode = _this.props.locationActions.updatePostcode;
      // updatePostcode(load("postcode"))

      updatePostcode('2601');
    }
    return _this;
  }

  LocationText.prototype.render = function render() {
    var fallbackText = this.props.fallbackText;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_4__apis_persist__["c" /* load */])("locality") || fallbackText
    );
  };

  return LocationText;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LocationText.displayName = "LocationText";


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["a" /* ConnectLocation */])())(LocationText));

LocationText.propTypes = {
  fallbackText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locationState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  locationActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

LocationText.defaultProps = {
  fallbackText: "Right here",
  locationState: {},
  locationActions: {
    updatePostcode: __WEBPACK_IMPORTED_MODULE_2_utils__["C" /* noop */]
  }
};

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\full-width-multi-video\\index.jsx";




var FullWidthMultiVideoBlock = function FullWidthMultiVideoBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_23" /* VideoSlideshow */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};

FullWidthMultiVideoBlock.displayName = "FullWidthMultiVideoBlock";
FullWidthMultiVideoBlock.displayName = "FullWidthMultiVideoBlock";
// withDataComponent strips off the backend `name` and `props` structure and just exposes the props
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["k" /* withDataComponents */])({
  expectedComponent: "FullWidthVideoItemBlock",
  mapInputToOutput: [["items", "videos"]]
})(FullWidthMultiVideoBlock));

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers_utilities__ = __webpack_require__(43);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\gallery\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/** Render a full width image section */

var Gallery = function (_React$PureComponent) {
  _inherits(Gallery, _React$PureComponent);

  function Gallery(props) {
    _classCallCheck(this, Gallery);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this.state = {
      hoverIndex: -1
    };
    return _this;
  }

  Gallery.prototype.handleMouseEnter = function handleMouseEnter(index) {
    this.setState({
      hoverIndex: index
    });
  };

  Gallery.prototype.handleMouseLeave = function handleMouseLeave() {
    this.setState({
      hoverIndex: -1
    });
  };

  /**
   * @param {String} heading - Heading text.
   * @param {Array|statList} [statList] - List of stats for StatList.
   * @param {Array|GalleryGrid} [galleryItems] - roundIconButton component props.
   * @returns {ReactElement} React Component
   */


  Gallery.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        description = _props.description,
        statList = _props.statList,
        heading = _props.heading,
        galleryItems = _props.galleryItems,
        layoutsItems = _props.layoutsItems,
        compact = _props.compact;
    var hoverIndex = this.state.hoverIndex;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
      { padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { width: "100%", overflow: "hidden" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 53
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["B" /* H4 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 54
            }
          },
          heading
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 55
          }
        }),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          { style: styles.description, __source: {
              fileName: _jsxFileName,
              lineNumber: 56
            }
          },
          description
        ),
        false && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { margin: "1em 0" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 58
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["_4" /* StatList */], { stats: statList, __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_containers__["o" /* GalleryGrid */],
          { layouts: layoutsItems, __source: {
              fileName: _jsxFileName,
              lineNumber: 62
            }
          },
          galleryItems.map(function (item, index) {
            return item.name === "GalleryItem" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["p" /* GalleryItem */], _extends({
              key: index
            }, item.props, {
              active: hoverIndex === index,
              fade: hoverIndex !== -1 && hoverIndex !== index,
              compact: compact,
              slideShowItems: galleryItems.map(function (item) {
                return {
                  name: "SlideshowItem",
                  props: {
                    imageSrc: item.props.imageSrc,
                    heading: item.props.title,
                    blurb: item.props.blurb
                  }
                };
              }),
              index: index,
              handleMouseEnter: _this2.handleMouseEnter.bind(_this2, index),
              handleMouseLeave: _this2.handleMouseLeave.bind(_this2, index), __source: {
                fileName: _jsxFileName,
                lineNumber: 65
              }
            })) : Object(__WEBPACK_IMPORTED_MODULE_5_containers_utilities__["b" /* renderComponent */])(item);
          })
        )
      )
    );
  };

  return Gallery;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Gallery.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  galleryItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  layoutsItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  statList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};
Gallery.displayName = "Gallery";


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(Gallery));

var styles = {
  description: {
    fontWeight: "200",
    fontSize: "100%",
    lineHeight: "1.6",
    margin: "1.5em 0",
    letterSpacing: "0.01em"
  }
};

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_swipeable_views__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_swipeable_views___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_swipeable_views__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\gallery-full-width\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var GalleryFullWidth = function (_Component) {
  _inherits(GalleryFullWidth, _Component);

  function GalleryFullWidth(props) {
    _classCallCheck(this, GalleryFullWidth);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      active: 0,
      highlight: 0
    };
    _this.handleChange = function (index, indexLatest) {
      _this.active = index;
    };

    _this.toggleNext = function () {
      _this.setState({
        active: _this.state.active + 1,
        highlight: _this.state.active === _this.props.galleryItems.length - 2 ? 0 : undefined
      });
    };

    _this.togglePrev = function () {
      _this.setState({
        active: _this.state.active - 1,
        highlight: _this.state.active === 1 ? 0 : undefined
      });
    };
    return _this;
  }

  /**
   * @param {String} name - Name to displayed on accordion.
   * @param {Array} components - Array of components.
   * @returns {ReactElement} React Component
   */
  GalleryFullWidth.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        highlight = _state.highlight,
        active = _state.active;
    var galleryItems = this.props.galleryItems;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.base, 'data-test': 'gallery-full-width', __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_swipeable_views___default.a,
        {
          animateTransitions: true,
          index: active,
          onChangeIndex: this.handleChange,
          containerStyle: {
            marginLeft: highlight * 10 + '%',
            transition: '0.7s',
            width: '100%',
            display: 'flex',
            alignContent: 'center'
          },
          slideStyle: {
            alignSelf: 'center',
            overflow: 'hidden'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        galleryItems.map(function (component, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'figure',
            { key: index, style: styles.figure, __source: {
                fileName: _jsxFileName,
                lineNumber: 63
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 64
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["d" /* BackgroundImage */], { position: 'absolute', src: component.imageSrc, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 65
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: component.imageSrc, style: styles.img, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 66
                }
              })
            ),
            component.title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["t" /* ImageDisclaimer */], {
              textAlign: 'left',
              size: 'small',
              uppercase: true,
              content: component.title, __source: {
                fileName: _jsxFileName,
                lineNumber: 69
              }
            })
          );
        })
      ),
      active > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        style: styles.scrollLeft,
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({ highlight: 1 });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({ highlight: 0 });
        },
        onClick: this.togglePrev, __source: {
          fileName: _jsxFileName,
          lineNumber: 79
        }
      }),
      active < galleryItems.length - 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        style: styles.scrollRight,
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({ highlight: -1 });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({ highlight: 0 });
        },
        onClick: this.toggleNext, __source: {
          fileName: _jsxFileName,
          lineNumber: 86
        }
      })
    );
  };

  return GalleryFullWidth;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

GalleryFullWidth.propTypes = {
  galleryItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array };
GalleryFullWidth.displayName = 'GalleryFullWidth';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(GalleryFullWidth));

var styles = {
  base: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden'
  },
  img: {
    height: '100%',
    width: '100%',
    position: 'relative',
    zIndex: 2,
    opacity: 0
  },
  figure: {
    color: 'white',
    margin: 0,
    position: 'relative',
    height: '100%',
    width: '100%'
  },
  scrollLeft: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '25%',
    height: '100%',
    display: 'none',
    backgroundColor: 'rgba(100, 100, 100, 0)',
    '@media (min-width: 768px)': {
      display: 'inline-block'
    }
  },
  scrollRight: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: '25%',
    height: '100%',
    display: 'none',
    backgroundColor: 'rgba(100, 100, 100, 0)',
    '@media (min-width: 768px)': {
      display: 'inline-block'
    }
  }
};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(89);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SwipeableViews = _interopRequireDefault(__webpack_require__(1231));

var _default = _SwipeableViews.default;
exports.default = _default;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  RESISTANCE_COEF: 0.6,
  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px

};
exports.default = _default;

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_portal__ = __webpack_require__(90);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\gallery-item\\index.jsx";








/** Render a gallery item */
/**
 * @param {String} [imageSrc] - URL for image asset.
 * @param {String} [overLayImageSrc] - URL for image asset on the overlay.
 * @param {Array} [overLayImagesArray] - Array of images for the overlay with transitions
 * @param {Number} [interval] - Interval (in ms) in-between image transitions
 * @param {Boolean} [loop] - Flag if the transition should loop or not
 * @param {String} [videoId] - Youtube video ID. If specified the gallery item will display video.
 * @param {String} title - Heading text.
 * @param {String} [blurb] - blurb text as xhtml string.
 * @param {Boolean} [disclaimerUppercase=true] - Display disclaimer as all uppercase.
 * @param {Function} [onClick] - Callback to run on button click.
 * @param {Array|Button} [components] - Array of nested components.
 * @returns {ReactElement} React Component
 */
var GalleryItem = function GalleryItem(_ref) {
  var imageSrc = _ref.imageSrc,
      overLayImageSrc = _ref.overLayImageSrc,
      overLayImagesArray = _ref.overLayImagesArray,
      interval = _ref.interval,
      loop = _ref.loop,
      videoId = _ref.videoId,
      title = _ref.title,
      blurb = _ref.blurb,
      _ref$additionalStyles = _ref.additionalStyles,
      additionalStyles = _ref$additionalStyles === undefined ? {} : _ref$additionalStyles,
      disclaimerUppercase = _ref.disclaimerUppercase,
      active = _ref.active,
      fade = _ref.fade,
      slideShowItems = _ref.slideShowItems,
      index = _ref.index,
      handleMouseEnter = _ref.handleMouseEnter,
      handleMouseLeave = _ref.handleMouseLeave,
      compact = _ref.compact,
      components = _ref.components;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_react_portal__["b" /* PortalWithState */],
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51
      }
    },
    function (_ref2) {
      var openPortal = _ref2.openPortal,
          closePortal = _ref2.closePortal,
          portal = _ref2.portal;
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        {
          key: imageSrc,
          style: _extends({}, styles.figure(fade), additionalStyles),
          "data-test": "gallery-item",
          onClick: openPortal,
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave, __source: {
            fileName: _jsxFileName,
            lineNumber: 53
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { tabIndex: 0, style: styles.href(active), __source: {
              fileName: _jsxFileName,
              lineNumber: 60
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_containers__["d" /* BackgroundImage */], { position: "absolute", src: imageSrc, __source: {
              fileName: _jsxFileName,
              lineNumber: 61
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["o" /* Image */], { type: "blurred", src: imageSrc, alt: title, style: styles.img, __source: {
              fileName: _jsxFileName,
              lineNumber: 62
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_containers__["t" /* ImageDisclaimer */], {
          textAlign: compact ? "right" : "left",
          size: "small",
          uppercase: disclaimerUppercase,
          content: compact ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["J" /* InfoIcon */], { style: { width: "15px", height: "15px" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 68
            }
          }) : title,
          active: active, __source: {
            fileName: _jsxFileName,
            lineNumber: 64
          }
        })
      ), portal(videoId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_containers__["_9" /* VideoOverlay */], { videoId: videoId, close: closePortal, __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        }
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_containers__["L" /* Overlay */],
        { close: closePortal, __source: {
            fileName: _jsxFileName,
            lineNumber: 74
          }
        },
        compact ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_containers__["_6" /* TextMediaSliderContainer */], {
          bulletsBelow: true,
          displayOnTop: true,
          padding: false,
          active: index,
          items: slideShowItems, __source: {
            fileName: _jsxFileName,
            lineNumber: 77
          }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_containers__["m" /* FiftyFiftyBlock */], {
          heading: title,
          blurb: blurb,
          textAlign: "center",
          headingUppercase: disclaimerUppercase,
          textVerticalAlign: "center",
          backgroundImageArray: overLayImagesArray,
          interval: interval,
          overlay: true,
          loop: loop,
          imageUrl: overLayImageSrc || imageSrc,
          components: components, __source: {
            fileName: _jsxFileName,
            lineNumber: 84
          }
        })
      ))];
    }
  );
};

GalleryItem.displayName = "GalleryItem";
GalleryItem.displayName = "GalleryItem";
GalleryItem.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  blurb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overLayImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overLayImagesArray: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  loop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  videoId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disclaimerUppercase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  additionalStyles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  handleMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  handleMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  slideShowItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

GalleryItem.defaultProps = {
  disclaimerUppercase: true
};

GalleryItem.displayName = "GalleryItem";

/* harmony default export */ __webpack_exports__["a"] = (GalleryItem);

var styles = {
  figure: function figure(fade) {
    return {
      display: "block",
      margin: 0,
      position: "absolute",
      left: 0,
      top: 0,
      height: "100%",
      width: "100%",
      overflow: "hidden",
      transform: "translate3d(0,0,0) scale(1.005)",
      transition: !__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["a" /* HAS_TOUCH */] && "filter .5s",
      filter: "brightness(" + (fade ? "0.3" : "1") + ")",
      color: "white"
    };
  },
  img: {
    height: "100%",
    width: "100%",
    position: "relative",
    zIndex: 2,
    opacity: 0
  },
  slideshowItem: {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    overflow: "hidden" // Fix overflow problem in IE11
  },
  href: function href(active) {
    return {
      cursor: "pointer",
      display: "block",
      height: "100%",
      width: "100%",
      outline: 0,
      transform: "scale(" + (!__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["a" /* HAS_TOUCH */] && active ? "1.2" : "1") + ")",
      transition: !__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["a" /* HAS_TOUCH */] && "transform 0.5s"
    };
  }
};

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Portal__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LegacyPortal__ = __webpack_require__(1253);





var Portal = void 0;

if (__WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.createPortal) {
  Portal = __WEBPACK_IMPORTED_MODULE_1__Portal__["a" /* default */];
} else {
  Portal = __WEBPACK_IMPORTED_MODULE_2__LegacyPortal__["a" /* default */];
}

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_measure__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_actions_environment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_actions_search__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_zoom_zoom_js__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mazda_logo_svg__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mazda_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__mazda_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mazda_logo_compact_svg__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mazda_logo_compact_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__mazda_logo_compact_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sub_nav_large__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sub_nav_compact__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__global_nav_search__ = __webpack_require__(1261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\global-nav\\index.jsx",
    _logo;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-deprecated */














 // @todo inline these SVGs in icons
 // @todo inline these SVGs in icons




/* Top Level Navigation Component. */

var subNavTranslate = ["+3em", "+40px"];

var GlobalNavContainer = function (_PureComponent) {
  _inherits(GlobalNavContainer, _PureComponent);

  function GlobalNavContainer(props) {
    _classCallCheck(this, GlobalNavContainer);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.handleOnSearch = function (q) {
      if (q.length) {
        _this.props.gtmEvent({
          gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["o" /* gtmSearchActionTypes */].SITE_SEARCH_BAR_SEARCHED,
          gtmPayload: { query: q }
        });
        __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].location.href = _this.props.searchPageUrl + "?q=" + _this.props.navSearchQuery;
      }
    };

    _this.handleOnSearchClear = function () {
      _this.props.setNavSearchQuery("");
      _this.setState({
        searchOpen: false,
        resultsOpen: false
      });
    };

    _this.handleOnSearchChange = function (_ref) {
      var value = _ref.target.value;

      _this.props.setNavSearchQuery(value);
    };

    _this.handleCompactSearchFocus = function () {
      _this.setState({ mobileSearchFocus: true });
    };

    _this.handleCompactSearchBlur = function () {
      _this.setState({ mobileSearchFocus: false });
    };

    _this.state = {
      active: -1,
      mainNavItemCount: _this.props.compact ? 1 : _this.props.forMyMazdaAccountsOnly ? 4 : 3,
      loaded: false,
      open: false,
      searchOpen: false,
      resultsOpen: false,
      mobileSearchFocus: false
    };

    Object(__WEBPACK_IMPORTED_MODULE_10_utils__["d" /* bindAll */])(["shouldComponentUpdate", "handleDesktopNav", "handleOnResize", "toggleActive", "makeActive", "toggle", "open", "close"], _this);
    return _this;
  }

  GlobalNavContainer.prototype.componentDidMount = function componentDidMount() {
    Object(__WEBPACK_IMPORTED_MODULE_12_utils_zoom_zoom_js__["a" /* default */])();
    this.setState({
      loaded: true,
      mainNavItemCount: this.props.compact ? 1 : this.props.forMyMazdaAccountsOnly ? 4 : 3
    });
  };

  GlobalNavContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.compact !== nextProps.compact) {
      if (this.state.open && this.props.compact) {
        // Close mobile subnav if open when exiting compact
        __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].slide(false);
        this.setState({ open: false, active: -1 }, function () {
          return __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].unlock();
        });
      }
      this.props.setNavSearchQuery("");
      this.setState({
        searchOpen: false,
        resultsOpen: false
      });
    }
    if (nextProps.navSearchQuery.trim().length) {
      this.setState({ resultsOpen: true });
    } else {
      this.setState({ resultsOpen: false });
    }
    this.setState({
      mainNavItemCount: nextProps.compact ? 1 : nextProps.forMyMazdaAccountsOnly ? 4 : 3
    });
  };

  GlobalNavContainer.prototype.componentDidUpdate = function componentDidUpdate() {
    if (__WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */]) {
      if (!this.props.compact && this.state.open) __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].slide(false);else if (this.state.open) __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].slide(subNavTranslate);
    }
  };

  /**
   * @param {object} event - click / keyDown event
   */


  GlobalNavContainer.prototype.toggle = function toggle(event) {
    event.persist();

    if (event.type === "keydown" && event.key !== "Enter") return;

    if (this.state.open) this.close();else this.open();

    if (!this.props.compact) {
      this.setState({ active: this.state.mainNavItemCount });
    } else {
      this.props.gtmEvent({
        gtmID: this.state.open ? __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["g" /* gtmGlobalNavActionTypes */].HAMBURGER_COLLAPSE : __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["g" /* gtmGlobalNavActionTypes */].HAMBURGER_EXPAND,
        gtmPayload: {}
      });
    }
  };

  /**
   * @param {number} index - Index to toggle active
   */


  GlobalNavContainer.prototype.toggleActive = function toggleActive(index) {
    var _this2 = this;

    if (this.state.active === index) {
      this.setState({ active: -1 }, function () {
        if (!_this2.state.open) __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].unlock();
      });
    } else {
      this.makeActive(index);
    }
  };

  GlobalNavContainer.prototype.makeActive = function makeActive(index) {
    if (this.state.open && index < this.state.mainNavItemCount) {
      this.setState({ active: index, open: false }, function () {
        return __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].lock(true);
      });
    } else {
      this.setState({ active: index }, function () {
        return __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].lock(true);
      });
    }
  };

  GlobalNavContainer.prototype.open = function open() {
    if (__WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */]) {
      if (this.props.compact) __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].slide(subNavTranslate);else __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].slide(false);
      this.setState({ open: true, active: -1 }, function () {
        return __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].lock(true);
      });
    }
  };

  GlobalNavContainer.prototype.close = function close(event) {
    if (event && event.type === "keydown" && event.key !== "Escape") return;
    this.props.setNavSearchQuery("");
    __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].slide(false);
    this.setState({ open: false, active: -1 }, function () {
      return __WEBPACK_IMPORTED_MODULE_11_containers__["e" /* Body */].unlock();
    });
  };

  /**
   * @param {Array|NavDropdown|GlobalNavLink} components - Nested Components.
   * @returns {ReactElement} React Component
   */
  GlobalNavContainer.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        compact = _props.compact,
        navSearchQuery = _props.navSearchQuery,
        searchPageUrl = _props.searchPageUrl,
        searchPlaceholderText = _props.searchPlaceholderText,
        compactSearchPlaceholderText = _props.compactSearchPlaceholderText,
        setGlobalHeaderHeight = _props.setGlobalHeaderHeight,
        displaySearchBox = _props.displaySearchBox,
        image = _props.image,
        mobileImage = _props.mobileImage;
    var mainNavItemCount = this.state.mainNavItemCount;

    var mainNavComponents = this.props.components.slice(0, mainNavItemCount);
    var subNavProps = {
      navItems: this.props.components.slice(mainNavItemCount),
      activeItemIndex: this.state.active - mainNavItemCount,
      toggleActive: function toggleActive(index) {
        return _this3.toggleActive(mainNavItemCount + index);
      },
      close: this.close,
      offsetTop: this.props.globalHeaderHeight
    };
    var searchEnabled = displaySearchBox;
    var compactSearch = searchEnabled && compact;
    var desktopSearch = searchEnabled && !compact;
    // let pageName = WINDOW.location.pathname
    // if (pageName === '/') pageName = "home"

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { id: "header", "data-id": "header", style: styles.navWrapper, __source: {
          fileName: _jsxFileName,
          lineNumber: 223
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_measure__["a" /* default */],
        {
          client: true,
          bounds: true,
          onResize: function onResize(_ref2) {
            var height = _ref2.client.height,
                top = _ref2.bounds.top;

            setGlobalHeaderHeight(height);
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 224
          }
        },
        function (_ref3) {
          var measureRef = _ref3.measureRef;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "nav",
            {
              ref: measureRef,
              style: [styles.base, _this3.state.loaded ? { opacity: 1 } : { opacity: 0 }],
              "data-test": "global-nav", __source: {
                fileName: _jsxFileName,
                lineNumber: 231
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_components__["H" /* Hyperlink */],
              {
                style: styles.logoLink,
                withoutStyle: true,
                gtm: {
                  category: "Header Nav",
                  action: "Nav - Clicked home badge"
                },
                href: "/", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 235
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: styles.logo, src: compact ? mobileImage : image, alt: "Mazda", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 243
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: {
                  flex: "1 1 100%",
                  position: "relative",
                  display: "flex",
                  justifyContent: "flex-end"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 245
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 252
                  }
                },
                mainNavComponents.map(function (Component, index) {
                  var active = _this3.state.active === index;
                  if (Component.name === "PersonalisationBlockItem") {
                    if (compact && (Component.props.mobile || Component.props.tablet) || !compact && Component.props.desktop) {
                      Component = Component.props.components[0];
                    } else {
                      return null;
                    }
                  }
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { key: index, style: { display: "inline-block", margin: "0 1.2em" }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 266
                      }
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_18_AtomicUtils_componentParser__["a" /* default */])([Component], {
                      active: active,
                      toggleActive: function toggleActive() {
                        return _this3.toggleActive(index);
                      },
                      close: _this3.close,
                      height: _this3.props.globalHeaderHeight
                    })
                  );
                }),
                !desktopSearch && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: styles.divider, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 276
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { style: { display: "inline-block", margin: "1.5em 1.8em" }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 277
                    }
                  },
                  compact ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components__["b" /* AnimatedHamburgerIcon */], { onClick: _this3.toggle, open: _this3.state.open, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 279
                    }
                  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13_components__["y" /* GlobalNavDropdown */],
                    {
                      toggleActive: _this3.toggle,
                      gtm: {
                        category: "Header Nav",
                        action: "Nav - Clicked \"MORE\""
                      },
                      close: function close() {
                        Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_gtmHandler__["a" /* default */])({
                          pageCategory: "Header Nav",
                          pageAction: "Nav - Closed \"MORE\""
                        });
                        _this3.close();
                      },
                      label: "More",
                      active: _this3.state.open,
                      height: _this3.props.globalHeaderHeight, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 281
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_13_components__["D" /* GlobalNavOverlay */],
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 297
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__sub_nav_large__["a" /* default */], _extends({}, _extends({}, subNavProps, {
                        navItems: subNavProps.navItems.map(function (item) {
                          if (item.name === "PersonalisationBlockItem") {
                            if (item.props.desktop) {
                              return item.props.components[0];
                            }
                            return null;
                          }
                          return item;
                        })
                      }), {
                        toggleActive: function toggleActive(index) {
                          return _this3.makeActive(mainNavItemCount + index);
                        }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 298
                        }
                      }))
                    )
                  )
                ),
                desktopSearch && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: styles.divider, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 318
                  }
                }),
                desktopSearch && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__global_nav_search__["b" /* GlobalNavSearchFieldSlider */], {
                  innerInputRef: function innerInputRef(input) {
                    _this3.searchInput = input;
                  },
                  value: navSearchQuery,
                  open: _this3.state.searchOpen,
                  placeholderText: searchPlaceholderText,
                  onSearch: _this3.handleOnSearch,
                  onChange: _this3.handleOnSearchChange,
                  onClear: _this3.handleOnSearchClear,
                  onSlideEnd: function onSlideEnd(e, open) {
                    if (open) Object(__WEBPACK_IMPORTED_MODULE_10_utils__["n" /* focusWithoutScroll */])(_this3.searchInput);
                  },
                  onOpen: function onOpen() {
                    _this3.searchInput.blur();
                    _this3.setState({ searchOpen: !_this3.state.searchOpen });
                    _this3.props.gtmEvent({
                      gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["o" /* gtmSearchActionTypes */].CLICK_SEARCH_ICON,
                      gtmPayload: { pageName: Object(__WEBPACK_IMPORTED_MODULE_10_utils__["u" /* getPageName */])() }
                    });
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 320
                  }
                })
              )
            )
          );
        }
      ),
      !!this.state.open && compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_17__sub_nav_compact__["a" /* default */],
        _extends({
          hideNavItems: this.state.mobileSearchFocus
        }, _extends({}, subNavProps, {
          navItems: subNavProps.navItems.map(function (item) {
            if (item.name === "PersonalisationBlockItem") {
              if (item.props.mobile || item.props.tablet) {
                return item.props.components[0];
              }
              return null;
            }
            return item;
          })
        }), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 349
          }
        }),
        compactSearch && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__global_nav_search__["a" /* GlobalNavSearchFieldCompact */], {
          innerInputRef: function innerInputRef(input) {
            _this3.searchInput = input;
          },
          height: this.props.globalHeaderHeight,
          value: navSearchQuery,
          placeholderText: compactSearchPlaceholderText,
          onSearch: this.handleOnSearch,
          onChange: this.handleOnSearchChange,
          onClear: this.handleOnSearchClear,
          onFocus: this.handleCompactSearchFocus,
          onBlur: this.handleCompactSearchBlur, __source: {
            fileName: _jsxFileName,
            lineNumber: 367
          }
        }),
        compactSearch && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_19__global_nav_search__["c" /* GlobalNavSearchResultsDrawer */],
          { open: this.state.resultsOpen, __source: {
              fileName: _jsxFileName,
              lineNumber: 381
            }
          },
          this.state.resultsOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13_components__["H" /* Hyperlink */],
            {
              gtm: {
                category: "Site Search Bar",
                action: "Site Search Bar - Searched \"" + navSearchQuery + "\""
              },
              href: searchPageUrl + "?q=" + navSearchQuery, __source: {
                fileName: _jsxFileName,
                lineNumber: 383
              }
            },
            "View all results >"
          )
        )
      ),
      desktopSearch && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_19__global_nav_search__["c" /* GlobalNavSearchResultsDrawer */],
        { open: this.state.resultsOpen, __source: {
            fileName: _jsxFileName,
            lineNumber: 397
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              margin: "0 3em 0 10em"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 398
            }
          },
          this.state.resultsOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13_components__["H" /* Hyperlink */],
            {
              gtm: {
                category: "Site Search Bar",
                action: "Site Search Bar - Searched \"" + navSearchQuery + "\""
              },
              href: searchPageUrl + "?q=" + navSearchQuery, __source: {
                fileName: _jsxFileName,
                lineNumber: 403
              }
            },
            "View all results for \"",
            navSearchQuery,
            "\""
          )
        )
      )
    );
  };

  return GlobalNavContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

GlobalNavContainer.displayName = "GlobalNavContainer";


GlobalNavContainer.propTypes = {
  navSearchQuery: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setNavSearchQuery: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setGlobalHeaderHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  globalHeaderHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  searchPageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  searchEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  displaySearchBox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  searchPlaceholderText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  forMyMazdaAccountsOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  compactSearchPlaceholderText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

GlobalNavContainer.defaultProps = {
  setGlobalHeaderHeight: __WEBPACK_IMPORTED_MODULE_10_utils__["C" /* noop */],
  globalHeaderHeight: 0,
  compact: true,
  forMyMazdaAccountsOnly: false,
  compactSearchPlaceholderText: "Search",
  searchPlaceholderText: "What are you looking for?",
  searchPageUrl: "/search"
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    globalHeaderHeight: __WEBPACK_IMPORTED_MODULE_6_store_actions_environment__["c" /* selectors */].getGlobalHeaderHeight(state),
    navSearchQuery: __WEBPACK_IMPORTED_MODULE_7_store_actions_search__["c" /* selectors */].getNavSearchQuery(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setGlobalHeaderHeight: function setGlobalHeaderHeight(height) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6_store_actions_environment__["a" /* actionCreators */].updateGlobalHeaderHeight(height));
    },
    setNavSearchQuery: function setNavSearchQuery(query) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7_store_actions_search__["a" /* actionCreators */].updateNavSearchQuery(query));
    }
  };
};

/** Top Level Navigation Component. */
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["b" /* DetectCompact */])({
  threshold: 900
}), Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["i" /* gtmEvent */])(), Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps))(GlobalNavContainer));

var logoKeyframes = Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["j" /* keyframes */])({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});

var breakpoint1 = "@media (min-width: 900px)";

var styles = {
  navWrapper: {
    width: "100%",
    display: "block",
    position: "relative",
    background: "#101010",
    zIndex: 3
  },
  base: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    transition: "transform .44s, opacity .25s",
    alignItems: "center",
    background: "#101010",
    color: "white",
    width: "100%"
  },
  divider: {
    width: "1px",
    display: "inline-block",
    background: "#999",
    height: "35px",
    opacity: ".2",
    verticalAlign: "middle"
  },
  logo: (_logo = {
    height: "35px",
    width: "auto",
    opacity: 0,
    margin: "1.2em 1em 1em 1.5em",
    animation: "x .75s .1s forwards",
    animationName: logoKeyframes
  }, _logo[breakpoint1] = {
    height: "65px"
  }, _logo),
  logoLink: {
    outline: 0,
    maxWidth: '75px'
  }
};

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\gyroscope\\index.jsx";



var GyroscopeBlock = function GyroscopeBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["E" /* Gyroscope */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    }
  }));
};

GyroscopeBlock.displayName = "GyroscopeBlock";
GyroscopeBlock.displayName = "GyroscopeBlock";
/* harmony default export */ __webpack_exports__["a"] = (GyroscopeBlock);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_hero_video_with_timed_frames__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_dynamic_text_video_frame__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_heading_video_frame__ = __webpack_require__(1266);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\hero-video-with-timed-frames\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var HeroVideoWithTimedFrames = function HeroVideoWithTimedFrames(_ref) {
  var frames = _ref.frames,
      props = _objectWithoutProperties(_ref, ["frames"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers_hero_video_with_timed_frames__["a" /* default */]
  // This will translate `components` as json from backend to `components` as reactElements for each frame
  , _extends({ frames: frames.map(function (frameProps) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_utils__["j" /* constructOutputProps */])(frameProps, [["components", "components"]], Object(__WEBPACK_IMPORTED_MODULE_2_utils__["A" /* jsonToComponents */])([__WEBPACK_IMPORTED_MODULE_5_blocks_dynamic_text_video_frame__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_blocks_heading_video_frame__["a" /* default */]]) // componentWhitelist for `components` inside frames
      );
    })
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    }
  }));
};

HeroVideoWithTimedFrames.displayName = "HeroVideoWithTimedFrames";
HeroVideoWithTimedFrames.displayName = "HeroVideoWithTimedFrames";
HeroVideoWithTimedFrames.propTypes = {
  frames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired

  // withDataComponent strips off the backend `name` and `props` structure and just exposes the props
};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["k" /* withDataComponents */])({
  expectedComponent: "VideoFrameOverlayBlock",
  mapInputToOutput: [["frames", "frames"]]
})(HeroVideoWithTimedFrames));

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\hero-video-with-timed-frames\\index.jsx";






/**
 * Renders a Hero Video With Timed Frames Component.
 * @returns {ReactElement} React Component
 */
var HeroVideoWithTimedFrames = function HeroVideoWithTimedFrames(_ref) {
  var videoSrc = _ref.videoSrc,
      _ref$frames = _ref.frames,
      frames = _ref$frames === undefined ? [] : _ref$frames,
      loopVideo = _ref.loopVideo,
      fallbackImage = _ref.fallbackImage,
      muted = _ref.muted,
      _ref$compact = _ref.compact,
      compact = _ref$compact === undefined ? "false" : _ref$compact,
      scrollToSlug = _ref.scrollToSlug;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { "data-test": "hero-video-with-timed-frames", __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    },
    compact && frames && frames.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: {
          width: "100%",
          height: "100vw"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_24" /* VideoWithTimedFrames */], {
        styles: { height: "100%" },
        loopVideo: loopVideo,
        muted: muted,
        useInView: false,
        scrollToSlug: scrollToSlug,
        videoSrc: videoSrc,
        poster: fallbackImage,
        frames: frames, __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      })
    ),
    !compact && frames && frames.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["f" /* BrowserHeightSection */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_24" /* VideoWithTimedFrames */], {
        styles: { height: "100%" },
        loopVideo: loopVideo,
        muted: muted,
        useInView: false,
        scrollToSlug: scrollToSlug,
        videoSrc: videoSrc,
        poster: fallbackImage,
        frames: frames, __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        }
      })
    ),
    !frames || frames.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48
      }
    })
  );
};

HeroVideoWithTimedFrames.displayName = "HeroVideoWithTimedFrames";
HeroVideoWithTimedFrames.displayName = "HeroVideoWithTimedFrames";
HeroVideoWithTimedFrames.propTypes = {
  videoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  loopVideo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  muted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollToSlug: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fallbackImage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  frames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    time: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
  }))
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(HeroVideoWithTimedFrames));

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bowser__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\icon-tout-block\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * There's two ways to specify an href to make the whole block clickable using that href:
 * 1. In "components" prop (for CTA button/link) if there's a link it will pick up that link
 * 2. In "blurb" prop (wysiwyg content) if there's a link it will pick up that link
 */








/** Render a tout block with icon */

var IconToutBlock = function (_Component) {
  _inherits(IconToutBlock, _Component);

  function IconToutBlock(props) {
    _classCallCheck(this, IconToutBlock);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleClick = function () {
      var href = _this.state.href;

      if (href) {
        if (__WEBPACK_IMPORTED_MODULE_4_bowser___default.a.ios) {
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_3_constants_environment__["i" /* WINDOW */].location.href = href;
          }, 300);
        } else {
          __WEBPACK_IMPORTED_MODULE_3_constants_environment__["i" /* WINDOW */].location.href = href;
        }
      }
    };

    _this.state = {
      href: null
    };
    return _this;
  }

  IconToutBlock.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        blurb = _props.blurb,
        components = _props.components;
    // If there's a link in wysiwyg, get the first link and put it in state

    if (Array.isArray(components) && components[0].props) {
      this.setState({ href: components[0].props.href });
    } else if (blurb.includes("<a href=")) {
      var matchHref = blurb.match(/<a href="(.*?)"/);
      this.setState({ href: matchHref[1] });
    }
  };

  /**
   * @param {String} [preHeading] - preheading text.
   * @param {String} heading - heading text.
   * @param {String} imageSrc - Icon image src url.
   * @param {String} [imageAlt] - Icom alt text.
   * @param {String} [blurb] - blurb content to render as html.
   * @returns {ReactElement} React Component
   */
  IconToutBlock.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        imageAlt = _props2.imageAlt,
        imageSrc = _props2.imageSrc,
        preHeading = _props2.preHeading,
        heading = _props2.heading,
        blurb = _props2.blurb,
        components = _props2.components,
        gtm = _props2.gtm,
        textAlign = _props2.textAlign;
    var href = this.state.href;

    var isClickable = !!href;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.base(isClickable, textAlign), onClick: function onClick() {
          return _this2.handleClick();
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 68
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 69
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: styles.img, src: imageSrc, alt: imageAlt, __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        }),
        preHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 73
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 74
              }
            },
            preHeading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 80
            }
          },
          heading
        ),
        blurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { xmlString: blurb, __source: {
            fileName: _jsxFileName,
            lineNumber: 81
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 83
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_2_containers_utilities__["a" /* childParser */])(this.props, function (index) {
          return {
            gtm: {
              category: gtm.category,
              action: gtm.action + " - \"" + heading + "\" - Clicked \"" + components[index].props.text + "\""
            }
          };
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 91
        }
      })
    );
  };

  return IconToutBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

IconToutBlock.propTypes = {
  preHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  blurb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  imageAlt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  gtm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
IconToutBlock.displayName = "IconToutBlock";


/* harmony default export */ __webpack_exports__["a"] = (IconToutBlock);

var styles = {
  base: function base(isClickable, textAlign) {
    return {
      margin: "0 auto",
      textAlign: !textAlign ? "center" : textAlign,
      display: "flex",
      width: '80%',
      flexDirection: "column",
      justifyContent: "space-between",
      cursor: isClickable && "pointer"
    };
  },
  img: {
    height: "10em",
    width: "auto"
  }
};

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IdWrapper_less__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IdWrapper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__IdWrapper_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\IdWrapper\\IdWrapper.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var IdWrapper = function (_React$PureComponent) {
  _inherits(IdWrapper, _React$PureComponent);

  function IdWrapper() {
    _classCallCheck(this, IdWrapper);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  IdWrapper.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        slug = _props.slug,
        components = _props.components,
        children = _props.children,
        _props$standalone = _props.standalone,
        standalone = _props$standalone === undefined ? false : _props$standalone;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "section",
      {
        "data-test": "id-wrapper",
        "data-name": slug,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__IdWrapper_less___default.a.IdWrapper] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 11
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        "data-id": slug,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__IdWrapper_less___default.a.IdWrapperSlug] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_3__IdWrapper_less___default.a.IdWrapperSlugStandalone] = standalone, _classnames2)), __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      }),
      Object(__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_componentParser__["a" /* default */])(components, this.props) || children
    );
  };

  return IdWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

IdWrapper.displayName = "IdWrapper";


/* harmony default export */ __webpack_exports__["a"] = (IdWrapper);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bowser__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\image-tout-block\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * There's many ways to specify an href to make the whole block clickable using that href:
 * 1. Pass in a direct "href" prop
 * 2. In "components" prop (for CTA button/link) if there's a link it will pick up that link
 * 3. In "blurb" prop (wysiwyg content) if there's a link it will pick up that link
 */










/** Render an image tout block */

var ImageToutBlock = function (_Component) {
  _inherits(ImageToutBlock, _Component);

  function ImageToutBlock(props) {
    _classCallCheck(this, ImageToutBlock);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleClick = function () {
      var gtm = _this.props.gtm;
      // Dispatch GTM action

      if (gtm && gtm.category) {
        // If not, use CMS gtm event
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: gtm.category,
          pageAction: gtm.action
        });
      }

      // Proceed with the link
      var href = _this.state.href;

      if (href) {
        if (__WEBPACK_IMPORTED_MODULE_7_bowser___default.a.ios) {
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].location.href = href;
          }, 300);
        } else {
          __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["i" /* WINDOW */].location.href = href;
        }
      }
    };

    _this.state = {
      href: props.href
    };
    return _this;
  }

  ImageToutBlock.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        blurb = _props.blurb,
        components = _props.components;
    // If there's a link in wysiwyg, get the first link and put it in state

    if (Array.isArray(components) && components[0].props) {
      this.setState({ href: components[0].props.href });
    } else if (blurb && blurb.includes("<a href=")) {
      var matchHref = blurb.match(/<a href="(.*?)"/);
      this.setState({ href: matchHref[1] });
    }
  };

  ImageToutBlock.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        blurb = _props2.blurb,
        _props2$outline = _props2.outline,
        outline = _props2$outline === undefined ? false : _props2$outline,
        preHeading = _props2.preHeading,
        heading = _props2.heading,
        horizontalLine = _props2.horizontalLine;
    var href = this.state.href;

    var clickable = !!href;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: [styles.base(clickable), outline && styles.border],
        onClick: function onClick() {
          return _this2.handleClick();
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.img, __source: {
            fileName: _jsxFileName,
            lineNumber: 69
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["o" /* Image */], { src: this.props.imageSrc, alt: this.props.imageAlt, __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.content, __source: {
            fileName: _jsxFileName,
            lineNumber: 72
          }
        },
        preHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 75
            }
          },
          preHeading
        ),
        preHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 77
          }
        }),
        heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              minHeight: '42px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 80
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["D" /* H6 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 88
              }
            },
            heading
          )
        ),
        blurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: horizontalLine && {
              borderTop: "1px solid #d5d5d5",
              marginTop: "1em",
              padding: "1em 0"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 92
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["t" /* Content */], { xmlString: blurb, __source: {
              fileName: _jsxFileName,
              lineNumber: 100
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "center"
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 103
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(this.props.components)
        )
      )
    );
  };

  return ImageToutBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ImageToutBlock.displayName = "ImageToutBlock";


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])()(ImageToutBlock));

ImageToutBlock.propTypes = {
  preHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  blurb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  imageAlt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  horizontalLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var styles = {
  border: {
    border: "1px solid #d5d5d5",
    background: "#fff"
  },
  base: function base(clickable) {
    return {
      margin: "0px 0px 1em 0px",
      height: "100%",
      width: "100%",
      cursor: clickable && "pointer"
    };
  },
  content: {
    padding: "1em",
    textAlign: "center"
  },
  img: {
    marginBottom: "1em",
    width: "100%"
  }
};

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_hyperlink__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\text-media-slider\\index.jsx";






var TextMediaSliderBlock = function TextMediaSliderBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["_6" /* TextMediaSliderContainer */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    }
  }));
};

TextMediaSliderBlock.displayName = "TextMediaSliderBlock";
TextMediaSliderBlock.displayName = "TextMediaSliderBlock";
TextMediaSliderBlock.displayName = "InteractiveSlideshowBlock"; // @CMS-CHANGE InteractiveSlideshowBlock => TextMediaSliderBlock

/* harmony default export */ __webpack_exports__["a"] = (TextMediaSliderBlock);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicComponents__ = __webpack_require__(2);


var Hyperlink = __WEBPACK_IMPORTED_MODULE_0_AtomicComponents__["a" /* A */];

/* harmony default export */ __webpack_exports__["a"] = (Hyperlink);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_gtm_events__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\map-search\\index.jsx";




var MapSearchBlock = function MapSearchBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["A" /* MapLocationContainer */], _extends({
    searchType: "search",
    gtmMapping: __WEBPACK_IMPORTED_MODULE_2_store_gtm_events__["f" /* gtmFindADealerActionTypes */],
    mapFixedHeight: true,
    flexSizing: true,
    mapFixHeightStyle: {
      height: "60vh",
      minHeight: "500px"
    }
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};

MapSearchBlock.displayName = "MapSearchBlock";
MapSearchBlock.displayName = "MapSearchBlock";
/* harmony default export */ __webpack_exports__["a"] = (MapSearchBlock);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_gtm_events__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\map-select-state\\index.js";




var MapSelectStateBlock = function MapSelectStateBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["A" /* MapLocationContainer */], _extends({}, props, {
    searchType: "select",
    gtmMapping: __WEBPACK_IMPORTED_MODULE_2_store_gtm_events__["h" /* gtmMapCampaignBlockActionTypes */],
    flexSizing: true,
    scrollToMain: false,
    mapFixHeightStyle: {
      height: "60vh",
      minHeight: "500px"
    }, __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};

MapSelectStateBlock.displayName = "MapSelectStateBlock";
MapSelectStateBlock.displayName = "MapSelectStateBlock";
/* harmony default export */ __webpack_exports__["a"] = (MapSelectStateBlock);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\index.jsx";



var MyMazda = function MyMazda(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["E" /* MyMazdaContainer */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

MyMazda.displayName = "MyMazda";
MyMazda.displayName = "MyMazda";
/* harmony default export */ __webpack_exports__["a"] = (MyMazda);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\confirm-change-email\\index.jsx";





var MyMazdaConfirmChangeEmailBlock = function MyMazdaConfirmChangeEmailBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_containers__["I" /* MyMazdaWrapper */],
    { breadcrumb: ["MyMazda", "Confirm Change of Email"], __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["t" /* MyMazdaChangeEmail */], _extends({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    }))
  );
};

MyMazdaConfirmChangeEmailBlock.displayName = "MyMazdaConfirmChangeEmailBlock";
MyMazdaConfirmChangeEmailBlock.displayName = "MyMazdaConfirmChangeEmailBlock";
MyMazdaConfirmChangeEmailBlock.propTypes = {
  buttonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  successHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  changeEmailEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  continueButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  changeEmailSuccessMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  submitInstructionsText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

MyMazdaConfirmChangeEmailBlock.defaultProps = {
  buttonText: "Login",
  successHeading: "New Email Confirmed",
  changeEmailEndpoint: "/api/mymazda/ChangeEmail",
  continueButtonText: "Continue to MyMazda",
  changeEmailSuccessMessage: "We've updated your email address. Click below to continue to MyMazda.",
  submitInstructionsText: "<p>Login with your password to confirm your updated email address: <strong>$newEmail$</strong></p>"
};

/* harmony default export */ __webpack_exports__["a"] = (MyMazdaConfirmChangeEmailBlock);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicContainers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\create-account\\index.jsx";




var MyMazdaCreateAccount = function MyMazdaCreateAccount(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_containers__["I" /* MyMazdaWrapper */],
    { breadcrumb: ["MyMazda", "Create account"], __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicContainers__["u" /* MyMazdaDetails */], _extends({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    }))
  );
};

MyMazdaCreateAccount.displayName = "MyMazdaCreateAccount";
MyMazdaCreateAccount.displayName = "MyMazdaCreateAccount";
/* harmony default export */ __webpack_exports__["a"] = (MyMazdaCreateAccount);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\dealer-block\\index.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var MyMazdaDealerBlock = function MyMazdaDealerBlock(_ref) {
  var salesDealer = _ref.salesDealer,
      salesCTA = _ref.salesCTA,
      serviceCTA = _ref.serviceCTA,
      emailCTA = _ref.emailCTA,
      serviceDealer = _ref.serviceDealer,
      description = _ref.description,
      heading = _ref.heading,
      _ref$defaultSelection = _ref.defaultSelection,
      defaultSelection = _ref$defaultSelection === undefined ? "Sales" : _ref$defaultSelection;

  var dealers = [{
    info: _extends({}, salesDealer, {
      primaryCTA: _extends({}, salesCTA, {
        isMyMazdaLink: true
      }),
      emailCTA: emailCTA
    }),
    label: "Sales"
  }, {
    info: _extends({}, serviceDealer, {
      primaryCTA: _extends({}, serviceCTA, {
        isMyMazdaLink: true
      }),
      emailCTA: emailCTA
    }),
    label: "Service"
  }];

  if (!serviceDealer || !salesDealer) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_components__["_6" /* StaticDealerMapWithToggle */],
    {
      initialDepartmentIndex: dealers.map(function (_ref2) {
        var label = _ref2.label;
        return label;
      }).indexOf(defaultSelection),
      dealers: dealers,
      gtm: {
        category: "MyMazda - Dealer"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 45
      }
    },
    function (_ref3) {
      var selector = _ref3.selector,
          mapBlock = _ref3.mapBlock;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { textAlign: "center" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 52
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_containers__["g" /* ColumnGroup */],
          {
            horizontalPadding: true,
            style: { padding: "3em 0 2em 0", background: __WEBPACK_IMPORTED_MODULE_1_constants_color_palette__["a" /* default */].GRAY_LIGHTER }, __source: {
              fileName: _jsxFileName,
              lineNumber: 53
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_containers__["f" /* Column */],
            { textAlign: "center", __source: {
                fileName: _jsxFileName,
                lineNumber: 56
              }
            },
            heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["B" /* H4 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 57
                }
              },
              heading
            ),
            selector,
            description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_25" /* WysiwygContent */], { xmlString: description, __source: {
                fileName: _jsxFileName,
                lineNumber: 59
              }
            })
          )
        ),
        mapBlock
      );
    }
  );
};

MyMazdaDealerBlock.displayName = "MyMazdaDealerBlock";
MyMazdaDealerBlock.displayName = "MyMazdaDealerBlock";
/* harmony default export */ __webpack_exports__["a"] = (MyMazdaDealerBlock);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\dynamic-resource\\index.jsx";






var MyMazdaDynamicResourceBlock = function MyMazdaDynamicResourceBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
    { padding: true, backgroundColor: props.backgroundColor, __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["B" /* H4 */],
      { withDetails: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      props.heading
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["t" /* Content */], { xmlString: props.description, __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.list, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__["a" /* default */])(props.components, { gtm: { category: props.heading } })
    )
  );
};

MyMazdaDynamicResourceBlock.displayName = "MyMazdaDynamicResourceBlock";
MyMazdaDynamicResourceBlock.displayName = "MyMazdaDynamicResourceBlock";
var styles = {
  list: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    marginTop: "3em"
  }
};

MyMazdaDynamicResourceBlock.propTypes = {
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

MyMazdaDynamicResourceBlock.defaultProps = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].WHITE
};

/* harmony default export */ __webpack_exports__["a"] = (MyMazdaDynamicResourceBlock);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Typography_Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\dynamic-resource\\item.jsx";











var RadiumLink = Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["f" /* Radium */])(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */]);

var MyMazdaDynamicResourceItem = function MyMazdaDynamicResourceItem(props) {
  var _classnames;

  var compact = props.compact,
      gtm = props.gtm,
      heading = props.heading,
      description = props.description,
      imageSrc = props.imageSrc,
      buttonLinkText = props.buttonLinkText,
      buttonUrl = props.buttonUrl,
      _props$isDownload = props.isDownload,
      isDownload = _props$isDownload === undefined ? false : _props$isDownload,
      _props$isExternal = props.isExternal,
      isExternal = _props$isExternal === undefined ? false : _props$isExternal,
      itemLayout = props.itemLayout;

  var tall = itemLayout === "tall";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.tile(compact, tall), __source: {
        fileName: _jsxFileName,
        lineNumber: 30
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          display: itemLayout === "tall" ? "block" : "flex",
          flexDirection: itemLayout === "tall" ? "column" : "row",
          position: "relative"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 31
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.image(tall), __source: {
            fileName: _jsxFileName,
            lineNumber: 37
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { maxWidth: "100%" }, src: imageSrc, __source: {
            fileName: _jsxFileName,
            lineNumber: 38
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { padding: "0 0 2em " + (tall ? "0" : "1em"), flex: "1 1 78%" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["C" /* H5 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 41
            }
          },
          heading
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 42
          }
        }),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["t" /* Content */], {
          xmlString: description,
          textAlign: "left",
          style: { color: tall ? __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].BLACK : __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_DARK }, __source: {
            fileName: _jsxFileName,
            lineNumber: 44
          }
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { padding: tall ? "0" : "0 0 1em", textAlign: "center" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.hr, __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        }
      }),
      isDownload || isExternal ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["a" /* A */],
        {
          href: buttonUrl,
          withoutStyle: true,
          external: true,
          onClick: function onClick() {
            Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
              pageCategory: "MyMazda - " + gtm.category,
              pageAction: heading.toUpperCase() + " - clicked \"" + buttonLinkText.toUpperCase() + "\""
            });
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 54
          }
        },
        isDownload && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["p" /* DownloadIcon */], {
          style: {
            height: "12px",
            width: "14px",
            fill: "#999999",
            marginRight: "0.5em"
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 66
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 75
            }
          },
          buttonLinkText
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        RadiumLink,
        {
          to: buttonUrl,
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Typography_Typography_less___default.a.withoutStyle] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 78
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 83
            }
          },
          buttonLinkText
        )
      )
    )
  );
};

MyMazdaDynamicResourceItem.displayName = "MyMazdaDynamicResourceItem";
MyMazdaDynamicResourceItem.displayName = "MyMazdaDynamicResourceItem";
var styles = {
  tile: function tile(compact, tall) {
    return {
      position: "relative",
      overflow: "hidden",
      display: "flex",
      backgroundColor: "white",
      boxSizing: "border-box",
      border: "1px solid " + __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY,
      flexDirection: "column",
      padding: tall ? "1.5em 1em 1em" : compact ? "2em 1.5em 0" : "3em 2.5em 0",
      margin: tall ? "0 1em 2em 1em" : compact ? "0 0 2em" : "0 1em 2em",
      justifyContent: "space-between",
      textAlign: tall ? "center" : "left",
      width: tall ? "280px" : "100%",
      maxWidth: tall ? "280px" : compact ? "470px" : "420px"
    };
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid rgb(229, 229, 229)",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1em"
  },
  button: {
    color: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_DARK,
    transition: "color 0.25s",
    cursor: "pointer",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_DARKER,
      fill: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_DARKER
    },
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "87%"
  },
  image: function image(tall) {
    return {
      position: "relative",
      boxSizing: "border-box",
      flex: "1 1 30%",
      maxHeight: tall ? "none" : "85px",
      paddingBottom: "2em"
    };
  }
};

MyMazdaDynamicResourceItem.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  itemLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["wide", "tall"]),
  buttonLinkText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isDownload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

MyMazdaDynamicResourceItem.defaultProps = {
  itemLayout: "wide"
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["b" /* DetectCompact */])())(MyMazdaDynamicResourceItem));

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\vehicle-specs\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var MyMazdaFullSpecBlock = function MyMazdaFullSpecBlock(_ref) {
  var heading = _ref.heading,
      props = _objectWithoutProperties(_ref, ["heading"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_containers__["g" /* ColumnGroup */],
    { verticalPadding: true, horizontalPadding: true, backgroundColor: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_LIGHT, __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_containers__["f" /* Column */],
      { textAlignMobile: "center", textAlign: "center", __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["B" /* H4 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 11
          }
        },
        heading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_21" /* VehicleSpecifications */], _extends({}, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 13
        }
      }))
    )
  );
};

MyMazdaFullSpecBlock.displayName = "MyMazdaFullSpecBlock";
MyMazdaFullSpecBlock.displayName = "MyMazdaFullSpecBlock";
MyMazdaFullSpecBlock.displayName = "MyMazdaFullSpecBlock";

MyMazdaFullSpecBlock.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (MyMazdaFullSpecBlock);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\manage-account\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MyMazdaManageAccountBlock = function (_Component) {
  _inherits(MyMazdaManageAccountBlock, _Component);

  function MyMazdaManageAccountBlock() {
    _classCallCheck(this, MyMazdaManageAccountBlock);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      showDeactivateAccountFlow: false
    };
    return _this;
  }

  MyMazdaManageAccountBlock.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        deactivateAccount = _props.deactivateAccount,
        props = _objectWithoutProperties(_props, ["deactivateAccount"]);

    var showDeactivateAccountFlow = this.state.showDeactivateAccountFlow;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
      { padding: true, backgroundColor: "#FFFFFF", __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["x" /* FormGroup */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["A" /* H3 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 22
            }
          },
          "Manage account"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["C" /* MyMazdaAccountDetails */], _extends({}, props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { textAlign: "left" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 26
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["a" /* A */],
            {
              styleName: "black",
              onClick: function onClick() {
                return _this2.setState({ showDeactivateAccountFlow: true });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 27
              }
            },
            deactivateAccount.startDeactivateFlowButton
          )
        ),
        showDeactivateAccountFlow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["F" /* MyMazdaDeactivateAccountFlow */], _extends({
          onClose: function onClose() {
            return _this2.setState({ showDeactivateAccountFlow: false });
          }
        }, deactivateAccount, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35
          }
        }))
      )
    );
  };

  return MyMazdaManageAccountBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMazdaManageAccountBlock.displayName = "MyMazdaManageAccountBlock";


MyMazdaManageAccountBlock.propTypes = {
  deactivateAccount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    deactivateAccountEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    deactivateAccountHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    deactivateAccountDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    deactivateAccountButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    cancelDeactivateAccountButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  resendEmailEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  emailPendingApproval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  changeEmailDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  changeEmailEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  changePasswordEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

MyMazdaManageAccountBlock.defaultProps = {
  deactivateAccount: {
    deactivateAccountEndpoint: "/api/mymazda/Customer",
    startDeactivateFlowButton: "Deactivate account",
    deactivateAccountHeading: "Deactivate your account",
    deactivateAccountDescription: "To deactivate your MyMazda account, please provide your password and click the button below, which will end your session. To reactivate your account, you’ll need to register again.",
    deactivateAccountButton: "Yes, deactivate my account",
    cancelDeactivateAccountButton: "Cancel"
  },
  emailPendingApproval: false,
  changeEmailEndpoint: "/api/mymazda/VerifyEmail",
  resendEmailEndpoint: "/api/mymazda/ResendVerifyEmail",
  changeEmailDescription: "To change your email address, you'll be sent a confirmation link to your new email address, and your old email address."
};

/* harmony default export */ __webpack_exports__["a"] = (MyMazdaManageAccountBlock);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_persist__ = __webpack_require__(69);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\manage-vehicles\\index.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var addStatus = function addStatus(status) {
  return function (item) {
    return _extends({}, item, { status: status });
  };
};
var addDisabled = function addDisabled(item) {
  return _extends({}, item, { disabled: true });
};

var MyMazdaManageVehiclesBlock = function (_Component) {
  _inherits(MyMazdaManageVehiclesBlock, _Component);

  function MyMazdaManageVehiclesBlock() {
    _classCallCheck(this, MyMazdaManageVehiclesBlock);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      showRemoveVehicleFlow: false,
      removeVehicleIndex: 0,
      showAddVehicleFlow: false
    };
    return _this;
  }

  MyMazdaManageVehiclesBlock.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        ownedVehicleDataList = _props.ownedVehicleDataList,
        drivenVehicleDataList = _props.drivenVehicleDataList,
        reservedVehicleDataList = _props.reservedVehicleDataList,
        requestedVehicleDataList = _props.requestedVehicleDataList,
        leasedVehicleDataList = _props.leasedVehicleDataList,
        nextServiceDisclaimer = _props.nextServiceDisclaimer,
        errorMessage = _props.errorMessage;

    var vehicles = [].concat(ownedVehicleDataList, drivenVehicleDataList, reservedVehicleDataList.map(addStatus("Vehicle reserved")).map(addDisabled), requestedVehicleDataList.map(addStatus("Transfer requested")).map(addDisabled), leasedVehicleDataList);
    var _state = this.state,
        showRemoveVehicleFlow = _state.showRemoveVehicleFlow,
        removeVehicleIndex = _state.removeVehicleIndex,
        showAddVehicleFlow = _state.showAddVehicleFlow;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
      { backgroundColor: "#FFFFFF", padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["z" /* H2 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        "Manage Vehicles"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["R" /* MyMazdaVehicleList */], {
        dashboardButtonText: "View Dashboard",
        removeButtontext: "Remove Vehicle",
        removeOnClick: function removeOnClick(index) {
          return _this2.setState({ showRemoveVehicleFlow: true, removeVehicleIndex: index });
        },
        nextServiceDisclaimer: nextServiceDisclaimer,
        vehicles: vehicles, __source: {
          fileName: _jsxFileName,
          lineNumber: 48
        }
      }),
      showRemoveVehicleFlow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["G" /* MyMazdaRemoveVehicleFlow */], _extends({}, this.props.removeVehicleProps, {
        vehicle: vehicles[removeVehicleIndex],
        onClose: function onClose() {
          if (__WEBPACK_IMPORTED_MODULE_5_apis_persist__["b" /* isLocalStorageSupported */] && Object(__WEBPACK_IMPORTED_MODULE_5_apis_persist__["a" /* getLocal */])("addRemoveVehicleLastStep")) {
            Object(__WEBPACK_IMPORTED_MODULE_5_apis_persist__["e" /* removeLocal */])("addRemoveVehicleLastStep");
            window.location.reload();
          }
          _this2.setState({ showRemoveVehicleFlow: false });
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 57
        }
      })),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          },
          this.props.addVehicleProps.addVehicleDescription
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["j" /* Button */],
          {
            styleName: "blackOutlined",
            onClick: function onClick() {
              return _this2.setState({ showAddVehicleFlow: true });
            },
            customWrapperStyle: { margin: "0 auto" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 70
            }
          },
          this.props.addVehicleProps.addVehicleButtonText
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["t" /* ExpandableArea */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 76
            }
          },
          function (_ref) {
            var RenderArea = _ref.RenderArea,
                toggleExpanded = _ref.toggleExpanded;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { margin: "2em 0 0" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 78
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_components__["H" /* Hyperlink */],
                { onClick: toggleExpanded, styleName: "black", __source: {
                    fileName: _jsxFileName,
                    lineNumber: 79
                  }
                },
                _this2.props.addVehicleProps.vinHitLabel
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                RenderArea,
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 82
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "p",
                  { style: { fontSize: "90%", color: "#aaaaaa", padding: "1em 0" }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 83
                    }
                  },
                  _this2.props.addVehicleProps.vinHintDescription
                )
              )
            );
          }
        )
      ),
      showAddVehicleFlow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["D" /* MyMazdaAddVehiclFlow */], _extends({}, this.props.addVehicleProps, {
        errorMessage: errorMessage,
        onClose: function onClose() {
          if (__WEBPACK_IMPORTED_MODULE_5_apis_persist__["b" /* isLocalStorageSupported */] && Object(__WEBPACK_IMPORTED_MODULE_5_apis_persist__["a" /* getLocal */])("addRemoveVehicleLastStep")) {
            Object(__WEBPACK_IMPORTED_MODULE_5_apis_persist__["e" /* removeLocal */])("addRemoveVehicleLastStep");
            window.location.reload();
          }
          _this2.setState({ showAddVehicleFlow: false });
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        }
      }))
    );
  };

  return MyMazdaManageVehiclesBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMazdaManageVehiclesBlock.displayName = "MyMazdaManageVehiclesBlock";


MyMazdaManageVehiclesBlock.propTypes = {
  ownedVehicleDataList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  drivenVehicleDataList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  reservedVehicleDataList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  requestedVehicleDataList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  leasedVehicleDataList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  nextServiceDisclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  errorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  removeVehicleProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    removeVehicleEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    removeDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    confirmationDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  addVehicleProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    addVehicleConfirmationDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    addVehicleDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    addVehicleButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    addVehicleDescriptionExtended: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    addVehicleHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    addSearchButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    retrySearchButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    confirmHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    confirmButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    vehicleSearchEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    vinHitLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    vinHintDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    linkVehicleEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

MyMazdaManageVehiclesBlock.defaultProps = {
  ownedVehicleDataList: [],
  drivenVehicleDataList: [],
  reservedVehicleDataList: [],
  requestedVehicleDataList: [],
  removeVehicleProps: {
    removeVehicleEndpoint: "/api/mymazda/vehicle/",
    confirmationDescription: "<p>By removing this vehicle you are updating the Mazda New Zealand database...</p><p>Do you wish to remove this vehicle?</p>",
    removeDescription: "<p>You've requested to remove the $nameplate$ $bodyStyle$ [$registrationNumber$]. Please confirm the reason you're removing this vehicle.</p>"
  },
  addVehicleProps: {
    addVehicleButtonText: "+ Add Vehicle",
    addVehicleDescription: "Add as second hand vehicle with a registration or VIN number.",
    addVehicleDescriptionExtended: "Add a second vehicle to your MyMazda account using your registration number or Vehicle Registration Number (VIN)",
    retrySearchButtonText: "Search Again",
    addVehicleHeading: "Add A Vehicle",
    addSearchButtonText: "Search",
    confirmHeading: "Confirm your vehicle",
    confirmButtonText: "Add Vehicle",
    vinHitLabel: "Where is my VIN located?",
    vinHintDescription: "The Vehicle Identification Number [VIN] is a unique number that identifies your vehicle. Please refer to the Specifications section of your owner's manual for the exact location of this number.",
    vehicleSearchEndPoint: "/api/model-details",
    linkVehicleEndPoint: "/api/mymazda/vehicle"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (MyMazdaManageVehiclesBlock);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\notifications\\index.jsx";





var MyMazdaNotifications = function MyMazdaNotifications(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
    { padding: true, backgroundColor: "#ffffff", __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["z" /* H2 */],
      { withDetails: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      },
      props.heading
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["t" /* Content */], {
      xmlString: props.description, textAlign: "center", __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["U" /* NotificationsList */], { items: props.notificationItems, __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    })
  );
};

MyMazdaNotifications.displayName = "MyMazdaNotifications";
MyMazdaNotifications.displayName = "MyMazdaNotifications";
MyMazdaNotifications.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  notificationItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["a"] = (MyMazdaNotifications);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__ = __webpack_require__(14);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\policies\\index.jsx";







var MyMazdaPolicies = function MyMazdaPolicies(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_containers__["g" /* ColumnGroup */],
    {
      verticalPadding: true,
      horizontalPadding: true,
      backgroundColor: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].WHITE,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_containers__["f" /* Column */],
      { textAlign: "center", __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["B" /* H4 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 15
          }
        },
        props.heading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.list, __source: {
            fileName: _jsxFileName,
            lineNumber: 17
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])(props.components)
      )
    )
  );
};

MyMazdaPolicies.displayName = "MyMazdaPolicies";
MyMazdaPolicies.displayName = "MyMazdaPolicies";
var styles = {
  list: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: "3em"
  }
};

MyMazdaPolicies.propTypes = {
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (MyMazdaPolicies);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\policies\\detail.jsx";








var MyMazdaPolicyDetail = function MyMazdaPolicyDetail(props) {
  var policyNumber = props.policyNumber,
      startDate = props.startDate,
      expiryDate = props.expiryDate,
      policyStatus = props.policyStatus,
      isExpired = props.isExpired,
      contactBlurb = props.contactBlurb;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.wrapper, __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    },
    policyNumber && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyMazdaPolicyDetailItem, { label: "Policy number", description: policyNumber, __source: {
        fileName: _jsxFileName,
        lineNumber: 16
      }
    }),
    startDate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyMazdaPolicyDetailItem, { label: "Start date", description: startDate, __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      }
    }),
    expiryDate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyMazdaPolicyDetailItem, { label: "Expiry date", description: expiryDate, __source: {
        fileName: _jsxFileName,
        lineNumber: 18
      }
    }),
    policyStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyMazdaPolicyDetailItem, {
      label: "Policy status",
      description: policyStatus,
      isExpired: isExpired, __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      }
    }),
    contactBlurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyMazdaPolicyDetailItem, {
      label: "Contact",
      description: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["t" /* Content */], { textAlign: "left", xmlString: contactBlurb, __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        }
      }), __source: {
        fileName: _jsxFileName,
        lineNumber: 26
      }
    })
  );
};

MyMazdaPolicyDetail.displayName = "MyMazdaPolicyDetail";
MyMazdaPolicyDetail.displayName = "MyMazdaPolicyDetail";
var MyMazdaPolicyDetailItem = Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(function (_ref) {
  var label = _ref.label,
      description = _ref.description,
      isExpired = _ref.isExpired;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { key: label, style: { textAlign: "left" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 36
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["U" /* Interactive */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37
        }
      },
      label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 40
        }
      },
      description
    )
  );
});

var styles = {
  wrapper: {
    background: __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].WHITE,
    border: "1px solid " + __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY,
    padding: "2em 1.5em 0.5em"
  }
};

MyMazdaPolicyDetail.propTypes = {
  policyNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  expiryDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  policyStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isExpired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  contactBlurb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(MyMazdaPolicyDetail));

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Typography_Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\policies\\item.jsx";










var MyMazdaPolicyItem = function MyMazdaPolicyItem(props) {
  var _classnames;

  var heading = props.heading,
      description = props.description,
      imageSrc = props.imageSrc,
      buttonLinkText = props.buttonLinkText,
      buttonUrl = props.buttonUrl,
      isActive = props.isActive,
      isExpired = props.isExpired,
      policyType = props.policyType;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.tile, __source: {
        fileName: _jsxFileName,
        lineNumber: 24
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.image(isActive), __source: {
          fileName: _jsxFileName,
          lineNumber: 25
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { maxHeight: "100%" }, src: imageSrc, __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        }
      }),
      isExpired ? policyType === "Warranty" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["d" /* AlertIcon */], { style: styles.icon, __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        }
      }) : isActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_17" /* TickModalIcon */], { style: styles.icon, __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { padding: (isActive ? "1.5em" : "0") + " 1em 1em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["D" /* H6 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 36
          }
        },
        heading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37
        }
      }),
      description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_25" /* WysiwygContent */], {
        xmlString: description,
        style: {
          color: isExpired && policyType !== "Warranty" ? __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].RED : "inherit"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { padding: "0 1em 1em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.hr, __source: {
          fileName: _jsxFileName,
          lineNumber: 47
        }
      }),
      isActive ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
        {
          to: buttonUrl,
          style: styles.button,
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Typography_Typography_less___default.a.withoutStyle] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 49
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 55
            }
          },
          buttonLinkText
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["a" /* A */],
        { href: buttonUrl, withoutStyle: true, external: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 58
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["U" /* Interactive */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          },
          buttonLinkText
        )
      )
    )
  );
};

MyMazdaPolicyItem.displayName = "MyMazdaPolicyItem";
MyMazdaPolicyItem.displayName = "MyMazdaPolicyItem";
var styles = {
  tile: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    backgroundColor: "white",
    boxSizing: "border-box",
    border: "1px solid " + __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY,
    flexDirection: "column",
    margin: "0 1em 2em 1em",
    justifyContent: "space-between",
    textAlign: "center",
    width: "280px",
    maxWidth: "280px",
    flex: "1 0 auto"
  },
  icon: {
    width: "2.25em",
    height: "2.25em",
    position: "absolute",
    bottom: "-1.125em",
    left: "50%",
    marginLeft: "-1.125em"
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid rgb(229, 229, 229)",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1em",
    paddingBottom: "0.5em"
  },
  button: {
    color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARK,
    transition: "color 0.25s",
    cursor: "pointer",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARKER
    },
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "87%"
  },
  image: function image(isActive) {
    return {
      padding: "1.5em",
      position: "relative",
      width: "100%",
      boxSizing: "border-box",
      height: "200px",
      backgroundColor: isActive ? __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_LIGHTER : "transparent"
    };
  }
};

MyMazdaPolicyItem.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  policyType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonLinkText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isExpired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["f" /* Radium */])(MyMazdaPolicyItem));

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blocks__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\policies\\summary.jsx";








var policyTypesWithExpiredMessage = ["RoadSide", "Allianz", "Assist", "Insurance", "CMP", "LPI", "VPI"];

var MyMazdaPolicySummary = function MyMazdaPolicySummary(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    },
    policyTypesWithExpiredMessage.includes(props.policyType) && props.isExpired && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["w" /* FlashMessge */], {
      style: { backgroundColor: "white" },
      type: "ERROR",
      message: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 20
          }
        },
        "This policy is expired. ",
        props.policyType === "Allianz" || props.policyType === "Assist" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 23
            }
          },
          "Please contact us on 1800 034 411."
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 25
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["a" /* A */],
            { styleName: "black", external: true, href: props.upgradeOptionsUrl || "/mymazda", __source: {
                fileName: _jsxFileName,
                lineNumber: 25
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 25
                }
              },
              "View upgrade options"
            )
          ),
          " or contact your dealer."
        )
      ),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_8" /* Section */],
      { padding: true, backgroundColor: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_LIGHTER, __source: {
          fileName: _jsxFileName,
          lineNumber: 31
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { paddingBottom: "2em", textAlign: "center" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
          src: props.imageSrc,
          alt: props.heading,
          style: { maxWidth: "10em", display: "block", margin: "0 auto 1em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 33
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["A" /* H3 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 37
            }
          },
          props.heading
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.wrapper(props.compact), __source: {
            fileName: _jsxFileName,
            lineNumber: 39
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.wrapperLeft(props.compact), __source: {
              fileName: _jsxFileName,
              lineNumber: 40
            }
          },
          props.warrantyInteractive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["C" /* H5 */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 41
              }
            },
            props.warrantyInteractive
          ),
          props.warrantyInteractive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 42
            }
          }),
          props.warrantyblurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["t" /* Content */], { textAlign: "left", xmlString: "<p>" + props.warrantyblurb + "</p>", __source: {
              fileName: _jsxFileName,
              lineNumber: 44
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["t" /* Content */], { textAlign: "left", xmlString: props.blurb, __source: {
              fileName: _jsxFileName,
              lineNumber: 46
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.wrapperRight(props.compact), __source: {
              fileName: _jsxFileName,
              lineNumber: 48
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_blocks__["a" /* MyMazdaPolicyDetail */], _extends({}, props, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 49
            }
          }))
        )
      )
    )
  );
};

MyMazdaPolicySummary.displayName = "MyMazdaPolicySummary";
MyMazdaPolicySummary.displayName = "MyMazdaPolicySummary";
var styles = {
  wrapper: function wrapper(compact) {
    return {
      width: "100%",
      borderTop: "1px solid " + __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY,
      display: "flex",
      justifyContent: "space-between",
      paddingTop: "4em",
      flexDirection: compact ? "column" : "row"
    };
  },
  wrapperLeft: function wrapperLeft(compact) {
    return {
      order: compact ? "2" : "1",
      flex: "1 1 " + (compact ? "100" : "70") + "%",
      paddingRight: compact ? "0" : "2em"
    };
  },
  wrapperRight: function wrapperRight(compact) {
    return {
      order: compact ? "1" : "2",
      flex: "1 1 " + (compact ? "100" : "30") + "%",
      marginBottom: compact ? "2em" : "0"
    };
  }
};

MyMazdaPolicySummary.propTypes = {
  policyType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(policyTypesWithExpiredMessage),
  upgradeOptionsUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isExpired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  warrantyInteractive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  warrantyblurb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  blurb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["b" /* DetectCompact */])())(MyMazdaPolicySummary));

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\single-dealer-map\\index.jsx";




var SingleDealerMapBlock = function SingleDealerMapBlock(_ref) {
  var dealerDetails = _ref.dealerDetails;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["P" /* MapWithMarkers */], {
    locations: [dealerDetails],
    activeIndex: 0,
    options: { disableDefaultUI: true },
    map: {
      center: {
        lat: Number(dealerDetails.lat),
        lng: Number(dealerDetails.lng)
      },
      zoom: 17
    }, __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  });
};

SingleDealerMapBlock.displayName = "SingleDealerMapBlock";
SingleDealerMapBlock.displayName = "SingleDealerMapBlock";
SingleDealerMapBlock.propTypes = {
  dealerDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (SingleDealerMapBlock);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\registration\\index.jsx";




var MyMazdaRegistration = function MyMazdaRegistration(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_containers__["I" /* MyMazdaWrapper */],
    {
      breadcrumb: ["MyMazda", "Registration"],
      backButton: true,
      onLoadMessage: {
        message: props.registrationTokenExpiredText,
        type: "ERROR"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicContainers__["y" /* MyMazdaRegister */], _extends({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    }))
  );
};

MyMazdaRegistration.displayName = "MyMazdaRegistration";
MyMazdaRegistration.displayName = "MyMazdaRegistration";
/* harmony default export */ __webpack_exports__["a"] = (MyMazdaRegistration);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\service\\export.jsx";



var MyMazdaServiceHistoryExport = function MyMazdaServiceHistoryExport(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["_18" /* VehicleServiceExport */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

MyMazdaServiceHistoryExport.displayName = "MyMazdaServiceHistoryExport";
MyMazdaServiceHistoryExport.displayName = "MyMazdaServiceHistoryExport";
/* harmony default export */ __webpack_exports__["a"] = (MyMazdaServiceHistoryExport);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\service\\form.jsx";








var MyMazdaServiceRequestFormBlock = function MyMazdaServiceRequestFormBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_8" /* Section */],
    { padding: true, backgroundColor: "#ffffff", __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["A" /* MyMazdaServiceRequest */], _extends({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    }))
  );
};

MyMazdaServiceRequestFormBlock.displayName = "MyMazdaServiceRequestFormBlock";
MyMazdaServiceRequestFormBlock.displayName = "MyMazdaServiceRequestFormBlock";
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    service: props.serviceOptions ? __WEBPACK_IMPORTED_MODULE_3_store_actions_mymazda__["f" /* selectors */].getService(props.serviceOptions.vehicle.vin)(state) : {}
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_3_store_actions_mymazda__["a" /* actionCreators */], dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps))(MyMazdaServiceRequestFormBlock));

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_gtm_events__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\service\\summary.jsx";







var MyMazdaServiceSummaryBlock = function MyMazdaServiceSummaryBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
    {
      padding: true,
      backgroundColor: props.expandDetails ? __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].WHITE : __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_LIGHTER, __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_20" /* VehicleServiceSummary */], _extends({ gtmOnClickContinue: createGtmAction.clickContinue }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    }))
  );
};

MyMazdaServiceSummaryBlock.displayName = "MyMazdaServiceSummaryBlock";
MyMazdaServiceSummaryBlock.displayName = "MyMazdaServiceSummaryBlock";
var createGtmAction = {
  clickContinue: function clickContinue(_ref) {
    var buttonText = _ref.buttonText;
    return {
      gtmID: __WEBPACK_IMPORTED_MODULE_5_store_gtm_events__["i" /* gtmMyMazda2ActionTypes */].CALCULATOR_CLICK,
      gtmPayload: { buttonText: buttonText }
    };
  }
};

MyMazdaServiceSummaryBlock.propTypes = {
  expandDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (MyMazdaServiceSummaryBlock);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MyMazdaUnauthRedirectBlock = function (_Component) {
  _inherits(MyMazdaUnauthRedirectBlock, _Component);

  function MyMazdaUnauthRedirectBlock(props) {
    _classCallCheck(this, MyMazdaUnauthRedirectBlock);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    window.location = props.redirectUrl;
    return _this;
  }

  MyMazdaUnauthRedirectBlock.prototype.render = function render() {
    return null;
  };

  return MyMazdaUnauthRedirectBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMazdaUnauthRedirectBlock.displayName = "MyMazdaUnauthRedirectBlock";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaUnauthRedirectBlock);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\vehicle-resource-list\\index.jsx";



var MyMazdaVehicleResourceList = function MyMazdaVehicleResourceList(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["_16" /* VehicleResourceList */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

MyMazdaVehicleResourceList.displayName = "MyMazdaVehicleResourceList";
MyMazdaVehicleResourceList.displayName = "MyMazdaVehicleResourceList";
/* harmony default export */ __webpack_exports__["a"] = (MyMazdaVehicleResourceList);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_gtm_events__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\service\\carousel.jsx";




var MyMazdaVehicleServiceCarouselBlock = function MyMazdaVehicleServiceCarouselBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["_17" /* VehicleServiceCarousel */], _extends({
    gtmOnCarouselButtonClick: createGtmAction.checkEmailRegister
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};

MyMazdaVehicleServiceCarouselBlock.displayName = "MyMazdaVehicleServiceCarouselBlock";
MyMazdaVehicleServiceCarouselBlock.displayName = "MyMazdaVehicleServiceCarouselBlock";
var createGtmAction = {
  checkEmailRegister: function checkEmailRegister(_ref) {
    var buttonText = _ref.buttonText;
    return {
      gtmID: __WEBPACK_IMPORTED_MODULE_2_store_gtm_events__["i" /* gtmMyMazda2ActionTypes */].CAROUSEL_CLICK,
      gtmPayload: { buttonText: buttonText }
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (MyMazdaVehicleServiceCarouselBlock);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_mymazda_recall_notification__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_mymazda_account_password__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blocks_mymazda_reset_password__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_heading_section__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_triggered_overlay__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_higher_order_components__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\full-width-image-section\\index.jsx";









var FullWidthImageSectionBlock = function FullWidthImageSectionBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["x" /* FullWidthImageSection */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    }
  }));
};

FullWidthImageSectionBlock.displayName = "FullWidthImageSectionBlock";
FullWidthImageSectionBlock.displayName = "FullWidthImageSectionBlock";
FullWidthImageSectionBlock.displayName = "FullWidthImageSection"; // @CMS-CHANGE FullWidthImageSection => FullWidthImageSectionBlock

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["l" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_1_components__["e" /* Button */], __WEBPACK_IMPORTED_MODULE_6_containers_triggered_overlay__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_blocks_mymazda_recall_notification__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_blocks_mymazda_account_password__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_blocks_mymazda_reset_password__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_components__["H" /* Hyperlink */], __WEBPACK_IMPORTED_MODULE_5_blocks_heading_section__["a" /* default */]]
})(FullWidthImageSectionBlock));

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_utilities__ = __webpack_require__(43);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\column-group\\index.jsx";





/**
 * @param {Boolean} [fullWidth=false] - True sets columns to full width. This overrides maxWidth.
 * @param {Boolean} [gutter] - Adds gutter spacing to all columns.
 * @param {Boolean} [divider] - Adds divider between each column.
 * @param {Number} [maxWidth=1200] - Maximum width of column group (px).
 * @param {Boolean} [verticalPadding] - Adds padding before and after module.
 * @param {String} [backgroundColor] - Hex code for background color.
 * @param {String} [textColor] - Hex code for text color.
 * @param {Array|Column} components - Array of Column components.
 * @returns {ReactElement} React Component
 */
var ColumnGroup = function ColumnGroup() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      components = _ref.components,
      children = _ref.children,
      compact = _ref.compact,
      backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor,
      verticalPadding = _ref.verticalPadding,
      _ref$horizontalPaddin = _ref.horizontalPadding,
      horizontalPadding = _ref$horizontalPaddin === undefined ? true : _ref$horizontalPaddin,
      fullWidth = _ref.fullWidth,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === undefined ? 1200 : _ref$maxWidth,
      gutter = _ref.gutter,
      divider = _ref.divider,
      style = _ref.style;

  var columns = !compact;
  var childrenCount = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) || components.length;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      "data-test": "column-group",
      style: [backgroundColor && { background: backgroundColor }, textColor && { color: textColor }, { width: "100%" }, _extends({}, style)], __source: {
        fileName: _jsxFileName,
        lineNumber: 34
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: [styles.base, styles.padding({
          verticalPadding: verticalPadding,
          horizontalPadding: !fullWidth && horizontalPadding
        }), columns ? styles.columns : styles.row, fullWidth ? "" : styles.maxWidth(maxWidth)], __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_3_containers_utilities__["a" /* childParser */])({ components: components, children: children }, function (index) {
        return {
          gutter: gutter,
          count: childrenCount,
          divider: divider && index < childrenCount - 1
        };
      })
    )
  );
};

ColumnGroup.displayName = "ColumnGroup";
ColumnGroup.displayName = "ColumnGroup";
ColumnGroup.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  maxWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  fullWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  gutter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  verticalPadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  horizontalPadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  textColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])({
  threshold: 820
}))(ColumnGroup));

var styles = {
  base: {
    boxSizing: "border-box",
    display: "flex",
    flex: "1 1 auto",
    width: "100%"
  },
  padding: function padding(_ref2) {
    var verticalPadding = _ref2.verticalPadding,
        horizontalPadding = _ref2.horizontalPadding;
    return {
      padding: (verticalPadding && 5 || 0) + "em " + (horizontalPadding && 5 || 0) + "vw"
    };
  },
  columns: {
    flexWrap: "wrap"
  },
  row: {
    flexDirection: "column"
  },
  maxWidth: function maxWidth(number) {
    return {
      maxWidth: "calc(" + number + "px + " + 2 * 5 + "vw)",
      margin: "0 auto"
    };
  }
};

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\outlet-store-detail\\index.jsx";



var OutletStoreDetailBlock = function OutletStoreDetailBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["K" /* OutletStoreDetailContainer */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

OutletStoreDetailBlock.displayName = "OutletStoreDetailBlock";
OutletStoreDetailBlock.displayName = "OutletStoreDetailBlock";
OutletStoreDetailBlock.displayName = "OutletDetail"; // @CMS-CHANGE OutletDetail => OutletStoreDetailBlock

/* harmony default export */ __webpack_exports__["a"] = (OutletStoreDetailBlock);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\service-details-full\\index.jsx";



var ServiceDetailsFull = function ServiceDetailsFull(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["U" /* ServiceDetailsFullContainer */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

ServiceDetailsFull.displayName = "ServiceDetailsFull";
ServiceDetailsFull.displayName = "ServiceDetailsFull";
/* harmony default export */ __webpack_exports__["a"] = (ServiceDetailsFull);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\site-search\\index.jsx";



var SiteSearchBlock = function SiteSearchBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["Z" /* SiteSearchContainer */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

SiteSearchBlock.displayName = "SiteSearchBlock";
SiteSearchBlock.displayName = "SiteSearchBlock";
/* harmony default export */ __webpack_exports__["a"] = (SiteSearchBlock);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\tout-block\\index.jsx",
    _this = this;




var ToutBlock = function ToutBlock(props) {
  var newComponent = function newComponent() {};
  if (props.youTubeId) {
    newComponent = function newComponent() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["l" /* FeatureYouTube */], _extends({
        outline: _this.props.outline,
        CMSGroupGTM: _this.props.gtm,
        videoSrc: props.youTubeId
      }, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      }));
    };
  } else {
    newComponent = function newComponent() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["v" /* ImageToutBlock */], _extends({ CMSGroupGTM: _this.props.gtm, outline: _this.props.outline }, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      }));
    };
  }
  return newComponent;
};

/* harmony default export */ __webpack_exports__["a"] = (ToutBlock);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mymazda_header__ = __webpack_require__(1277);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda-specifications-block\\index.jsx";







var MyMazdaSpecificationBlock = function MyMazdaSpecificationBlock(props) {
  /**
   * @param {String} heading - Heading text.
   * @param {Object} vehicleProps - Vehicle properties.
   * @param {Object|BackHyperlink} backButton - props for back button
   * @param {Object} specifications - Specifications data object.
   * @returns {ReactElement} React Component
   */
  var specifications = props.specifications,
      _props$Interactive = props.Interactive,
      Interactive = _props$Interactive === undefined ? "" : _props$Interactive,
      _props$heading = props.heading,
      heading = _props$heading === undefined ? "" : _props$heading,
      vehicleProps = props.vehicleProps,
      backButton = props.backButton,
      logo = props.logo;

  if (props.error) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { color: "red", textAlign: "center" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      props.error
    );
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__mymazda_header__["a" /* default */], { backButton: backButton, logo: logo, __source: {
        fileName: _jsxFileName,
        lineNumber: 24
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_containers__["g" /* ColumnGroup */],
      { maxWidth: 800, __source: {
          fileName: _jsxFileName,
          lineNumber: 25
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_containers__["f" /* Column */],
        { textAlignMobile: "center", textAlign: "center", __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["F" /* Heading */], { tag: "h3", margin: true, value: heading.replace("{nameplate}", vehicleProps.nameplate), __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: vehicleProps.imageSrc, alt: heading, style: { maxWidth: "100%" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["H" /* MyMazdaSummary */], _extends({}, vehicleProps, {
          heading: Interactive.replace("{nameplate}", vehicleProps.nameplate), __source: {
            fileName: _jsxFileName,
            lineNumber: 29
          }
        })),
        specifications && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["_2" /* SpecificationList */], { specs: specifications.data.categories, __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        })
      )
    )
  );
};

MyMazdaSpecificationBlock.displayName = "MyMazdaSpecificationBlock";
MyMazdaSpecificationBlock.displayName = "MyMazdaSpecificationBlock";
MyMazdaSpecificationBlock.propTypes = {
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  Interactive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vehicleProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  logo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    logo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  specifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      categories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      disclaimers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
    })
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(MyMazdaSpecificationBlock));

/**
 * @typedef {Object} BackHyperlink
 * @property {String} name - Displayed Name.
 * @property {String} href - Hyperlink href.
 */

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda-summary\\index.jsx";







/*

exterior
:
"Cool White"
grade
:
"XTR"
modelCode
:
"B32QAPDS4"
nameplate
:
"BT-50"
rego
:
"CZF29G"
transmission
:
"4X4 - 6-SP Auto"
vin
:
"MM0UP0YF100426374"
*/

var Desc = function Desc(_ref) {
  var name = _ref.name,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        padding: "1em",
        textAlign: "left",
        boxSizing: "border-box"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 34
      }
    },
    value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { color: "#999", fontSize: "90%", whiteSpace: "nowrap" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["U" /* Interactive */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 42
          }
        },
        name
      )
    ),
    value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { color: "#101010", fontWeight: 200 }, __source: {
          fileName: _jsxFileName,
          lineNumber: 45
        }
      },
      value
    )
  );
};

Desc.displayName = "Desc";
Desc.displayName = "Desc";
Desc.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var MyMazdaSummary = function MyMazdaSummary(props) {
  var heading = props.heading,
      description = props.description,
      rego = props.rego,
      vin = props.vin,
      grade = props.grade,
      exterior = props.exterior,
      compact = props.compact,
      drive = props.drive,
      transmission = props.transmission,
      engine = props.engine,
      fullSpecificationsUrl = props.fullSpecificationsUrl,
      error = props.error,
      style = props.style,
      gtmEvent = props.gtmEvent;

  if (error) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          margin: "auto",
          maxWidth: "50vw",
          textAlign: "center",
          padding: "4em",
          color: "red"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 73
        }
      },
      error
    );
  }

  var ctaLabel = "view full specification";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: _extends({ padding: "2em" }, style), __source: {
        fileName: _jsxFileName,
        lineNumber: 89
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { textAlign: "center", margin: "auto" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 90
        }
      },
      heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { padding: "2em 0" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 92
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], { value: heading, textAlign: "center", __source: {
            fileName: _jsxFileName,
            lineNumber: 93
          }
        })
      ),
      description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: { fontWeight: 300, lineHeight: 1.8 },
        dangerouslySetInnerHTML: { __html: description }, __source: {
          fileName: _jsxFileName,
          lineNumber: 97
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.details(compact), __source: {
            fileName: _jsxFileName,
            lineNumber: 101
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              flexBasis: "33%",
              flexGrow: 0,
              flexShrink: 0
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 102
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Registration number", value: rego || "Contact Dealer", __source: {
              fileName: _jsxFileName,
              lineNumber: 108
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Vin", value: vin, __source: {
              fileName: _jsxFileName,
              lineNumber: 109
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              flexGrow: 0,
              flexShrink: 1
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 111
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Grade", value: grade, __source: {
              fileName: _jsxFileName,
              lineNumber: 116
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Exterior", value: exterior, __source: {
              fileName: _jsxFileName,
              lineNumber: 117
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              flexBasis: "33%",
              flexGrow: 0,
              flexShrink: 0
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 119
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Drive & transmission", value: drive + " " + transmission, __source: {
              fileName: _jsxFileName,
              lineNumber: 125
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Engine", value: engine, __source: {
              fileName: _jsxFileName,
              lineNumber: 126
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: {
            display: 'flex',
            justifyContent: 'center'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 129
          }
        },
        fullSpecificationsUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["e" /* Button */], {
          type: "a",
          display: "inline",
          styleName: "blackOutlined",
          href: fullSpecificationsUrl,
          label: ctaLabel,
          gtm: {
            category: "My New Mazda Home",
            action: "Specifications - Clicked \"" + ctaLabel.toUpperCase() + "\""
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        })
      )
    )
  );
};

MyMazdaSummary.displayName = "MyMazdaSummary";
MyMazdaSummary.displayName = "MyMazdaSummary";
MyMazdaSummary.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.heading,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rego: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  grade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  drive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  exterior: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  transmission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fullSpecificationsUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var styles = {
  details: function details(compact) {
    return {
      display: compact ? "block" : "flex",
      justifyContent: "space-around",
      maxWidth: "70em",
      fontSize: "95%",
      borderTop: "1px solid #cccccc",
      borderBottom: "1px solid #cccccc",
      margin: "0 auto",
      padding: "2em 0",
      marginTop: "2em",
      marginBottom: "2em"
    };
  },
  detailItem: {
    flexGrow: 0,
    flexShrink: 0
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["i" /* gtmEvent */])())(MyMazdaSummary));

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_gtm_events__ = __webpack_require__(22);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\offers\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OffersContainer = function (_PureComponent) {
  _inherits(OffersContainer, _PureComponent);

  function OffersContainer() {
    _classCallCheck(this, OffersContainer);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  OffersContainer.prototype.render = function render() {
    var _this2 = this;

    /* Todo the backend should only send offers array not array of OfferItem components */
    var offerCategories = this.props.offers.filter(function (c) {
      return c.name === "OfferItem";
    }).map(function (o) {
      return {
        notDisplay: false,
        name: o.props.title,
        slug: o.props.slug,
        rootPath: "/offers"
      };
    }).reduce(function () {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var item = arguments[1];
      return items.every(function (_ref) {
        var slug = _ref.slug;
        return slug !== item.slug;
      }) ? [].concat(items, [item]) : items;
    }, []);
    var components = this.props.components;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        }
      },
      offerCategories.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["H" /* StickyNav */], { items: offerCategories, gtm: { category: "Offers", action: "Clicked Sub Nav Link" }, gtmMapping: __WEBPACK_IMPORTED_MODULE_6_store_gtm_events__["l" /* gtmOffersActionTypes */], __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        }
      }),
      Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])(components),
      offerCategories && offerCategories.map(function (_ref2) {
        var slug = _ref2.slug;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["I" /* IdWrapper */],
          { key: slug, slug: slug, __source: {
              fileName: _jsxFileName,
              lineNumber: 34
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])(_this2.props.offers.filter(function (_ref3) {
            var props = _ref3.props;
            return props.slug === slug;
          }))
        );
      })
    );
  };

  return OffersContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

OffersContainer.displayName = "OffersContainer";


OffersContainer.propTypes = {
  offers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(OffersContainer));

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_outlet__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_actions_environment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_actions_outlet__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__navigation_bar__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__select_nameplate__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__select_dealer__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__show_results__ = __webpack_require__(1281);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\outlet-store\\index.jsx';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var OutletStoreContainer = function (_PureComponent) {
  _inherits(OutletStoreContainer, _PureComponent);

  function OutletStoreContainer(props) {
    _classCallCheck(this, OutletStoreContainer);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.filterDataMapping = function (filter) {
      switch (filter) {
        case 'DEMO':
          return 0;
        case 'RUNOUT':
          return 1;
        default:
          return 0;
      }
    };

    _this.filterCategory = function () {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return function (result) {
        return result && filters.some(function (filter) {
          return _this.filterDataMapping(filter) === result.storeType;
        });
      };
    };

    _this.generateHref = function (stock) {
      var _this$props = _this.props,
          outletState = _this$props.outletState,
          detailUrl = _this$props.detailUrl;

      var params = {
        stockNumber: stock.stockNumber,
        dealerCode: outletState.dealer.dealerCode,
        locationId: outletState.dealer.id,
        nameplate: stock.nameplate
      };
      return _extends({}, stock, {
        href: detailUrl + '?' + __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.stringify(params)
      });
    };

    _this.addExtraLabel = function (stock) {
      var _this$props$showResul = _this.props.showResults,
          accessoryWithPremiumTrayIncludedLabel = _this$props$showResul.accessoryWithPremiumTrayIncludedLabel,
          accessoryIncludedLabel = _this$props$showResul.accessoryIncludedLabel;

      return _extends({}, stock, {
        extraInfo: stock.accessories.length ? [stock.isPremiumTrayIncluded ? accessoryWithPremiumTrayIncludedLabel : accessoryIncludedLabel] : []
      });
    };

    _this.gtmTags = function (stock) {
      return _extends({}, stock, {
        gtmEvents: {
          click: [{
            func: _this.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].SELECT_STOCK_TILE,
              gtmPayload: _extends({}, stock, {
                fittedAccessories: stock.accessories.length ? 'Fitted with Accessories' : 'No Accessories',
                dealerName: Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('outletState.dealer.name', _this.props)
              })
            }]
          }],
          disclaimer: [{
            func: _this.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLICK_PRICE_DISCLAIMER,
              gtmPayload: stock
            }]
          }]
        }
      });
    };

    _this.addBackgroundImage = function (stock) {
      var stockTileBackgroundUrl = _this.props.stockTileBackgroundUrl;

      return _extends({}, stock, { backgroundImage: stockTileBackgroundUrl });
    };

    _this.state = {
      navHeight: 0,
      vehicleNotAvailableError: 0
    };
    Object(__WEBPACK_IMPORTED_MODULE_8_utils__["d" /* bindAll */])(['nameplateChange', 'dealerChange', 'updateSearchParams', 'stepChange', 'handleNameplateClick', 'sortedResults', 'handleFilterChange', 'handleSortChange', 'changeStep'], _this);
    return _this;
  }

  OutletStoreContainer.prototype.componentWillMount = function componentWillMount() {
    var outletStockEndpoint = this.props.outletStockEndpoint;

    this.props.initOutletStore({ outletStockEndpoint: outletStockEndpoint });
  };

  OutletStoreContainer.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.setState({ navHeight: this.navBar.clientHeight });
    this.props.search.pushQuery(_extends({}, this.props.search.query, {
      previousDealer: undefined // clear off previous Dealer from url (already in redux)
    }));
    // Check if there is an error param
    if (Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('search.query.error')(this.props)) {
      // If there is, get the error and set to state for displaying error message,
      // then remove it to prevent further error displaying in the next actions
      this.setState({ vehicleNotAvailableError: Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('search.query.error')(this.props) }, function () {
        return _this2.props.search.pushQuery(_extends({}, _this2.props.search.query, { error: undefined }));
      });
    }
  };

  OutletStoreContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    var onPropChange = function onPropChange(path, expose, action) {
      var value = Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])(path);
      if (value(nextProps) !== value(_this3.props)) {
        var _action;

        action((_action = {}, _action[expose] = value(nextProps), _action));
      }
    };
    onPropChange('search.query.nameplate', 'nameplate', this.nameplateChange);
    onPropChange('search.query.dealerCode', 'dealerCode', this.dealerChange);
    onPropChange('search.query.locationId', 'id', this.dealerChange);

    onPropChange('outletState.nameplate', 'nameplate', this.updateSearchParams);
    onPropChange('outletState.dealer.dealerCode', 'dealerCode', this.updateSearchParams);
    onPropChange('outletState.dealer.id', 'locationId', this.updateSearchParams);
    onPropChange('search.query.error', 'error', this.updateSearchParams);

    onPropChange('outletState.step', 'step', this.stepChange);
    onPropChange('search.query.step', 'stepIndex', this.stepChange);
  };

  OutletStoreContainer.prototype.stepChange = function stepChange(_ref) {
    var step = _ref.step,
        stepIndex = _ref.stepIndex,
        context = _ref.context;
    var stepChange = this.props.stepChange;

    var steps = ['SELECT_DEALER', 'SELECT_NAMEPLATE', 'SHOW_RESULTS'];
    if (step) {
      this.updateSearchParams({ step: steps.indexOf(step) });
    } else {
      stepChange({ step: steps[stepIndex], context: context });
    }
    __WEBPACK_IMPORTED_MODULE_13_constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_13_constants_environment__["i" /* WINDOW */].scrollTo(0, this.props.globalHeaderHeight);
  };

  OutletStoreContainer.prototype.nameplateChange = function nameplateChange(_ref2) {
    var nameplate = _ref2.nameplate;

    this.props.nameplateChange({ nameplate: nameplate });
  };

  OutletStoreContainer.prototype.handleNameplateClick = function handleNameplateClick(_ref3) {
    var nameplate = _ref3.nameplate;
    var _props = this.props,
        stepChange = _props.stepChange,
        outletState = _props.outletState;

    this.nameplateChange({ nameplate: nameplate });
    this.props.gtmEvent({
      gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].SELECT_NAMEPLATE,
      gtmPayload: { nameplate: nameplate, dealerName: Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('dealer.name', outletState) }
    });
    stepChange({ step: 'SHOW_RESULTS' });
  };

  OutletStoreContainer.prototype.dealerChange = function dealerChange(_ref4) {
    var dealerCode = _ref4.dealerCode,
        id = _ref4.id;
    var dealerChangeRequest = this.props.dealerChangeRequest;

    dealerChangeRequest({ dealerCode: dealerCode, id: id });
  };

  OutletStoreContainer.prototype.updateSearchParams = function updateSearchParams(param) {
    this.props.search.pushParam(param);
  };

  OutletStoreContainer.prototype.changeStep = function changeStep(stepID) {
    var _props2 = this.props,
        dealerReset = _props2.dealerReset,
        stepChange = _props2.stepChange;

    switch (stepID) {
      case 'SELECT_DEALER':
        dealerReset();
        stepChange({ step: 'SELECT_DEALER', copyMode: 'CHANGE' });
        break;
      case 'SELECT_NAMEPLATE':
        stepChange({
          step: 'SELECT_NAMEPLATE',
          copyMode: 'CHANGE',
          nameplate: false
        });
        break;
      default:
        return null;
    }
  };

  OutletStoreContainer.prototype.handleFilterChange = function handleFilterChange(_ref5) {
    var key = _ref5.key,
        checked = _ref5.checked;
    var _props3 = this.props,
        updateFilters = _props3.updateFilters,
        filter = _props3.outletState.filter;

    var updatedFilters = void 0;
    if (!checked) {
      updatedFilters = filter.filter(function (filter) {
        return filter !== key;
      });
    } else {
      updatedFilters = [].concat(filter, [key]);
    }
    var deDupedFilters = updatedFilters.filter(function (item, index, self) {
      return self.indexOf(item) === index;
    });
    updateFilters(deDupedFilters);
  };

  OutletStoreContainer.prototype.handleSortChange = function handleSortChange(_ref6) {
    var key = _ref6.key,
        dir = _ref6.dir,
        label = _ref6.label;
    var updateSort = this.props.updateSort;

    updateSort({
      key: key,
      dir: dir,
      gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLICK_SORT_OPTION,
      gtmPayload: { label: label }
    });
  };

  OutletStoreContainer.prototype.sortedResults = function sortedResults() {
    var _this4 = this;

    var _props4 = this.props,
        _props4$outletState = _props4.outletState,
        sort = _props4$outletState.sort,
        filter = _props4$outletState.filter,
        _props4$outletState$r = _props4$outletState.results,
        results = _props4$outletState$r === undefined ? [] : _props4$outletState$r,
        bestMatchMode = _props4.bestMatchMode;

    // Sort the stocklist by key, if those values of given key are the
    // same, sort by price

    var sortKey = function sortKey(key) {
      return function (result1, result2) {
        if (result1[key] === result2[key]) {
          return result1.price - result2.price;
        }
        return result1[key] - result2[key];
      };
    };

    var sortCategory = function sortCategory(items) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['DEMO', 'RUNOUT'];
      return order.map(_this4.filterDataMapping).reduce(function (all, category) {
        return [].concat(all, items.filter(function (item) {
          return item.storeType === category;
        }));
      }, []);
    };

    var filteredResults = results.filter(this.filterCategory(filter));

    var sortBestMatch = function sortBestMatch(items) {
      switch (bestMatchMode.toLowerCase()) {
        case 'demo-first':
          return sortCategory(items, ['DEMO', 'RUNOUT']);
        case 'clearance-first':
          return sortCategory(items, ['RUNOUT', 'DEMO']);
        default:
          return items;
      }
    };

    switch (sort.dir) {
      case 'BMATCH':
        return sortBestMatch(filteredResults.sort(sortKey(sort.key)).reverse());
      case 'ASC':
        return filteredResults.sort(sortKey(sort.key));
      case 'DESC':
        return filteredResults.sort(sortKey(sort.key)).reverse();
      default:
        return filteredResults;
    }
  };

  OutletStoreContainer.prototype.featuredResults = function featuredResults() {
    var _props$outletState$re = this.props.outletState.results,
        results = _props$outletState$re === undefined ? [] : _props$outletState$re;

    return results.filter(function (_ref7) {
      var featured = _ref7.featured;
      return featured;
    });
  };

  OutletStoreContainer.prototype.generateStockTileProps = function generateStockTileProps(tiles) {
    return tiles.map(this.generateHref).map(this.gtmTags).map(this.addBackgroundImage).map(this.addExtraLabel);
  };

  OutletStoreContainer.prototype.filterCount = function filterCount(filter) {
    var _props$outletState$re2 = this.props.outletState.results,
        results = _props$outletState$re2 === undefined ? [] : _props$outletState$re2;

    return results.filter(this.filterCategory([filter])).length;
  };

  OutletStoreContainer.prototype.render = function render() {
    var _this5 = this;

    var _props5 = this.props,
        globalHeaderHeight = _props5.globalHeaderHeight,
        selectNameplate = _props5.selectNameplate,
        selectDealer = _props5.selectDealer,
        showResults = _props5.showResults,
        nameplates = _props5.nameplates,
        outletState = _props5.outletState,
        compact = _props5.compact,
        noStockErrorMessage = _props5.noStockErrorMessage,
        noResultsFoundMessage = _props5.noResultsFoundMessage;


    var nameplateStock = nameplates.map(function (stock) {
      var _outletState$availabi = outletState.availability,
          availability = _outletState$availabi === undefined ? [] : _outletState$availabi;

      var stockData = availability.find(function (_ref8) {
        var nameplate = _ref8.nameplate;
        return nameplate === stock.nameplate;
      });
      return _extends({}, stock, stockData, {
        gtmEvents: stockData && !stockData.inStock && [{
          func: _this5.props.gtmEvent,
          args: {
            gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLICK_NO_STOCK_BUILD,
            gtmPayload: {
              dealerName: Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('dealer.name', outletState),
              nameplate: stock.nameplate,
              buttonText: stock.unavailableCta.label
            }
          }
        }]
      });
    });

    var selectedStock = nameplateStock.find(function (_ref9) {
      var nameplate = _ref9.nameplate;
      return nameplate === outletState.nameplate;
    });

    var getpreHeading = function getpreHeading() {
      var _props6 = _this5.props,
          outletHeading = _props6.outletHeading,
          welcomeHeading = _props6.welcomeHeading;

      switch (outletState.copyMode) {
        case 'WELCOME':
          return welcomeHeading;
        case 'NORMAL':
          return outletHeading;
        default:
          return outletHeading;
      }
    };

    var getDescription = function getDescription(step) {
      var welcomeDescription = step.welcomeDescription,
          description = step.description,
          changeDescription = step.changeDescription;

      switch (outletState.copyMode) {
        case 'WELCOME':
          return welcomeDescription;
        case 'NORMAL':
          return description;
        case 'CHANGE':
          return changeDescription;
        default:
          return description;
      }
    };

    var getHeading = function getHeading(step) {
      var heading = step.heading,
          changeHeading = step.changeHeading;

      switch (outletState.copyMode) {
        case 'NORMAL':
          return heading;
        case 'CHANGE':
          return changeHeading;
        default:
          return heading;
      }
    };

    var noStockMessage = function noStockMessage(dealer, nameplate) {
      var key = Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])(Object(__WEBPACK_IMPORTED_MODULE_5_apis_outlet__["a" /* cacheKeyGen */])(dealer, nameplate));
      var message = noStockErrorMessage || 'Sorry, there\'s no ' + nameplate + ' stock available at this dealer. ';
      return key(outletState.noResultMessages) && message;
    };
    var NoStockMessage = function NoStockMessage(_ref10) {
      var dealer = _ref10.dealer,
          cta = _ref10.cta,
          nameplate = _ref10.nameplate,
          message = _ref10.message,
          onClick = _ref10.onClick;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        _extends({ onClick: onClick }, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 391
          }
        }),
        message,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          {
            style: {
              fontWeight: '500',
              cursor: 'pointer',
              textDecoration: 'underline',
              display: 'block'
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 393
            }
          },
          cta,
          ' >'
        )
      );
    };

    var noStockChangeModelMessage = function noStockChangeModelMessage(dealer, nameplate) {
      var message = noStockMessage(dealer, nameplate);
      return message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoStockMessage, _extends({ dealer: dealer, nameplate: nameplate, message: message }, {
        cta: 'Change model',
        onClick: function onClick() {
          _this5.props.gtmEvent({
            gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLICK_NO_STOCK_CHANGE,
            gtmPayload: {
              dealerName: Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('name', dealer),
              nameplate: nameplate,
              buttonText: 'Change model'
            }
          });
          _this5.props.dealerConfirm();
          _this5.changeStep('SELECT_NAMEPLATE');
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 409
        }
      }));
    };

    var noStockChangeDealerMessage = function noStockChangeDealerMessage(dealer, nameplate) {
      var message = noStockMessage(dealer, nameplate);
      return message ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoStockMessage, _extends({ dealer: dealer, nameplate: nameplate, message: message }, {
        cta: 'Change dealer',
        onClick: function onClick() {
          _this5.props.gtmEvent({
            gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLICK_NO_STOCK_CHANGE,
            gtmPayload: {
              dealerName: Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('name', dealer),
              nameplate: nameplate,
              buttonText: 'Change dealer'
            }
          });
          _this5.changeStep('SELECT_DEALER');
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 431
        }
      })) : null;
    };

    var step = function step(stepID) {
      switch (stepID) {
        case 'SELECT_DEALER':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__select_dealer__["a" /* default */], _extends({
            preHeading: getpreHeading(),
            description: getDescription(selectDealer),
            heading: getHeading(selectDealer),
            mapBlockProps: _extends({}, selectDealer.mapBlockProps, {
              gtmMapping: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */],
              searchOverride: outletState.previousDealer,
              onDealerChange: function onDealerChange(_ref11) {
                var selected = _ref11.selected;

                if (!selected) return;
                if (selected.dealerCode === outletState.dealer.dealerCode && selected.id === outletState.dealer.id) {
                  return;
                }
                _this5.dealerChange(selected);
              },
              mapLocationData: function mapLocationData(location) {
                var key = Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])(Object(__WEBPACK_IMPORTED_MODULE_5_apis_outlet__["a" /* cacheKeyGen */])(location, outletState.nameplate));
                var noStock = key(outletState.noResultMessages);
                return _extends({}, location, {
                  message: noStock && noStockChangeModelMessage(location, outletState.nameplate),
                  selectCTA: !noStock && (outletState.isFetchingStock ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["M" /* LoaderIcon */], {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 477
                    }
                  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["e" /* Button */], {
                    display: compact ? 'block' : 'inline',
                    onClick: function onClick(e) {
                      _this5.props.dealerConfirm();
                      e && e.stopPropagation();
                    },
                    label: 'Select Dealer', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 479
                    }
                  }))
                });
              }
            }),
            components: outletState.copyMode === 'CHANGE' ? [] : selectDealer.headerComponents
          }, extra, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 452
            }
          }));
        case 'SELECT_NAMEPLATE':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__select_nameplate__["a" /* default */], _extends({
            preHeading: getpreHeading(),
            description: getDescription(selectNameplate),
            heading: getHeading(selectNameplate),
            components: !(outletState.copyMode === 'CHANGE') && selectNameplate.headerComponents,
            onNameplateChange: _this5.handleNameplateClick,
            nameplateStock: nameplateStock,
            noStockError: noStockChangeDealerMessage(outletState.dealer, outletState.nameplate)
          }, extra, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 495
            }
          }));
        case 'SHOW_RESULTS':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__show_results__["a" /* default */], _extends({
            preHeading: getpreHeading(),
            description: getDescription(showResults),
            pageDisclaimer: Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('pageDisclaimer', showResults),
            priceDisclaimer: Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('priceDisclaimer', showResults),
            heading: showResults.heading + ' ' + (selectedStock && selectedStock.nameplate),
            components: showResults.footerComponents,
            showLoader: outletState.isFetchingStock,
            dealerState: outletState.dealer.state,
            filters: [{
              label: 'Clearance',
              count: _this5.filterCount('RUNOUT'),
              key: 'RUNOUT',
              color: "blue",
              checked: outletState.filter.includes('RUNOUT'),
              onClick: _this5.handleFilterChange,
              gtmEvents: {
                checked: [{
                  func: _this5.props.gtmEvent,
                  args: {
                    gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLEARANCE_CHECKED,
                    gtmPayload: { label: 'Clearance' }
                  }
                }],
                unchecked: [{
                  func: _this5.props.gtmEvent,
                  args: {
                    gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLEARANCE_UNCHECKED,
                    gtmPayload: { label: 'Clearance' }
                  }
                }]
              }
            }, {
              label: 'Demo',
              count: _this5.filterCount('DEMO'),
              key: 'DEMO',
              color: "orange",
              checked: outletState.filter.includes('DEMO'),
              onClick: _this5.handleFilterChange,
              gtmEvents: {
                checked: [{
                  func: _this5.props.gtmEvent,
                  args: {
                    gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].DEMO_CHECKED,
                    gtmPayload: { label: 'Demo' }
                  }
                }],
                unchecked: [{
                  func: _this5.props.gtmEvent,
                  args: {
                    gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].DEMO_UNCHECKED,
                    gtmPayload: { label: 'Demo' }
                  }
                }]
              }
            }],
            sortOptions: [{
              label: 'Best Match',
              key: 'price',
              dir: 'BMATCH'
            }, {
              label: 'Price High to Low',
              key: 'price',
              dir: 'DESC'
            }, {
              label: 'Price Low to High',
              key: 'price',
              dir: 'ASC'
            }],
            handleSortChange: _this5.handleSortChange,
            featuredStockList: {
              stockList: _this5.generateStockTileProps(_this5.featuredResults()),
              heading: 'Featured by',
              dealerName: outletState.dealer.name
            },
            stockList: _this5.generateStockTileProps(_this5.sortedResults())
          }, extra, {
            vehicleNotAvailableError: _this5.state.vehicleNotAvailableError,
            nameplate: selectedStock && selectedStock.nameplate,
            noResultsFoundMessage: noResultsFoundMessage, __source: {
              fileName: _jsxFileName,
              lineNumber: 507
            }
          }));
        default:
          return null;
      }
    };
    var navHeight = this.state.navHeight;

    var extra = { compact: compact, globalHeaderHeight: globalHeaderHeight };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: [{ minHeight: 'calc(100vh - ' + navHeight + 'px)' }, styles.main(outletState.step)], __source: {
          fileName: _jsxFileName,
          lineNumber: 610
        }
      },
      outletState.storeLoading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            display: 'flex',
            justifyContent: 'center',
            margin: '2em 0'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 612
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["M" /* LoaderIcon */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 618
          }
        })
      ) : step(outletState.step),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__navigation_bar__["a" /* default */], _extends({
        innerRef: function innerRef(element) {
          _this5.navBar = element;
        },
        gtmEvents: {
          editDealer: [{
            func: this.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].EDIT_DEALER,
              gtmPayload: {
                buttonText: 'Edit',
                dealerName: Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('dealer.name', outletState) || 'Not Selected'
              }
            }]
          }],
          editNameplate: [{
            func: this.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].EDIT_MODEL,
              gtmPayload: {
                buttonText: 'Edit',
                nameplate: Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('nameplate', outletState) || 'Not Selected'
              }
            }]
          }]
        },
        dealerButton: {
          disabled: outletState.step === 'SELECT_DEALER',
          active: outletState.step === 'SELECT_DEALER',
          selectionLabel: 'Step 1',
          selectedText: outletState.dealer && outletState.dealerConfirm ? Object(__WEBPACK_IMPORTED_MODULE_8_utils__["q" /* get */])('dealer.name', outletState) : '',
          fallbackText: outletState.copyMode === 'CHANGE' ? 'Change dealer' : 'Select dealer',
          onClick: function onClick() {
            _this5.changeStep('SELECT_DEALER');
          }
        },
        nameplateButton: {
          disabled: outletState.step !== 'SHOW_RESULTS',
          active: outletState.step === 'SELECT_NAMEPLATE',
          selectionLabel: 'Step 2',
          selectedText: selectedStock ? selectedStock.nameplate : '',
          image: selectedStock ? selectedStock.imageSrcFront : '',
          fallbackText: outletState.copyMode === 'CHANGE' ? 'Change model' : 'Select model',
          onClick: function onClick() {
            _this5.changeStep('SELECT_NAMEPLATE');
          }
        },
        showLoader: outletState.isFetchingStock || outletState.isFetchingDealer,
        hint: outletState.step === 'SHOW_RESULTS' ? {
          label: showResults.hintLabel,
          disclaimer: showResults.hintCopy,
          gtmEvents: [{
            func: this.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_12_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLICK_INFO,
              gtmPayload: { buttonText: showResults.hintLabel }
            }]
          }]
        } : null
      }, globalHeaderHeight, {
        step: outletState.step, __source: {
          fileName: _jsxFileName,
          lineNumber: 623
        }
      }))
    );
  };

  return OutletStoreContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

OutletStoreContainer.displayName = 'OutletStoreContainer';


var styles = {
  main: function main(step) {
    if (step === 'SELECT_DEALER') {
      return {
        display: 'flex',
        flexDirection: 'column'
      };
    }
  }
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    outletState: __WEBPACK_IMPORTED_MODULE_10_store_actions_outlet__["c" /* selectors */].getOutlet(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_11_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_10_store_actions_outlet__["a" /* actionCreators */], dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["i" /* gtmEvent */])(), Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return {
    globalHeaderHeight: __WEBPACK_IMPORTED_MODULE_6_store_actions_environment__["c" /* selectors */].getGlobalHeaderHeight(state)
  };
}), Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["g" /* SearchParams */])({
  expose: 'search',
  exposeParams: ['nameplate', 'dealerCode', 'step', 'locationId', 'error'],
  trackParams: ['step']
}))(OutletStoreContainer));

OutletStoreContainer.propTypes = {
  globalHeaderHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  outletStockEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  stockTileBackgroundUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  detailUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  nameplates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  outletState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  initOutletStore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dealerReset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dealerConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  stepChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  updateFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  updateSort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  nameplateChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dealerChangeRequest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  outletHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  welcomeHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  noStockErrorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  noResultsFoundMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectNameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    changeHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    welcomeDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    changeDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    headerComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  selectDealer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    changeHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    welcomeDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    changeDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mapBlockProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    headerComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  showResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    hintLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    hintCopy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    welcomeDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    footerComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    accessoryWithPremiumTrayIncludedLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    accessoryIncludedLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  bestMatchMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['Clearance-first', 'Demo-first'])
};

OutletStoreContainer.defaultProps = {
  search: {},
  outletState: {},
  outletActions: {},
  bestMatchMode: 'Clearance-first'
};

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchStockData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cacheKeyGen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_cache__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(12);
var fetchFromApi = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url, { method: "GET" });

          case 2:
            response = _context2.sent;

            if (!(response.status !== 200)) {
              _context2.next = 5;
              break;
            }

            throw new Error("Failed with status " + response.status);

          case 5:
            return _context2.abrupt("return", response.json());

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchFromApi(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





var getRequestURL = function getRequestURL(endpoint, params) {
  return endpoint + "?" + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
};

var fetchStockData = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        nameplate = _ref2.nameplate,
        locationId = _ref2.locationId,
        dealerCode = _ref2.dealerCode,
        outletStockEndpoint = _ref2.outletStockEndpoint;

    var checksum, getRequestedNameplateData, invalidateCache, cacheKey, cache, _JSON$parse, _data, _getRequestedNameplat2, lastModified, count, url, data, _ref4, response;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!(!nameplate && !dealerCode)) {
              _context.next = 3;
              break;
            }

            throw new Error("A nameplate or dealercode is required to fetch stock");

          case 3:
            if (dealerCode && locationId) {
              _context.next = 5;
              break;
            }

            throw new Error("DealerCode should be used in combination with location locationId");

          case 5:
            if (!(nameplate && !dealerCode)) {
              _context.next = 7;
              break;
            }

            throw new Error("Nameplate results without dealer is not supported");

          case 7:
            if (outletStockEndpoint) {
              _context.next = 9;
              break;
            }

            throw new Error("Cannot fetch without endpoint");

          case 9:
            checksum = 0;

            getRequestedNameplateData = function getRequestedNameplateData(data) {
              return data.find(function (savedNameplate) {
                return savedNameplate.nameplate === nameplate;
              });
            };

            invalidateCache = function invalidateCache(_ref3) {
              var data = _ref3.data;
              return function () {
                if (!nameplate) return true; // If the query is for all stock always invalidate the cache

                var _getRequestedNameplat = getRequestedNameplateData(data),
                    lastModified = _getRequestedNameplat.lastModified,
                    count = _getRequestedNameplat.count;

                return checksum !== checksumGen({ lastModified: lastModified, count: count });
              };
            };

            cacheKey = cacheKeyGen({ dealerCode: dealerCode, id: locationId }, nameplate);
            cache = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["i" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_2__constants_environment__["i" /* WINDOW */].localStorage.getItem(cacheKey);


            if (cache && nameplate) {
              _JSON$parse = JSON.parse(cache), _data = _JSON$parse.data;
              _getRequestedNameplat2 = getRequestedNameplateData(_data), lastModified = _getRequestedNameplat2.lastModified, count = _getRequestedNameplat2.count;

              checksum = checksumGen({ lastModified: lastModified, count: count });
            }
            url = getRequestURL(outletStockEndpoint, {
              nameplate: nameplate,
              locationId: locationId,
              dealerCode: dealerCode,
              checksum: checksum
            });
            _context.next = 18;
            return fetchFromApi(url);

          case 18:
            data = _context.sent;
            _context.next = 21;
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_cache__["a" /* cacheApiResponse */])(cacheKey, function () {
              return data;
            }, invalidateCache(data));

          case 21:
            _ref4 = _context.sent;
            response = _ref4.response;
            return _context.abrupt("return", { response: response });

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](0);

            console.warn("OUTLET FETCH", _context.t0);
            return _context.abrupt("return", { error: _context.t0 });

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 26]]);
  }));

  return function fetchStockData() {
    return _ref.apply(this, arguments);
  };
}();

var checksumGen = function checksumGen(_ref6) {
  var lastModified = _ref6.lastModified,
      count = _ref6.count;

  if (lastModified && count) return String(lastModified) + String(count);
  return 0;
};

var cacheKeyGen = function cacheKeyGen(dealer, nameplate) {
  return ((nameplate || 0) + "_" + (dealer.dealerCode || 0) + "_" + (dealer.id || 0)).replace(/-|\s/g, "");
};

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cacheApiResponse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persist__ = __webpack_require__(69);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var hourToMs = function hourToMs(ms) {
  return ms * 3600000;
};

var expireAfterHours = function expireAfterHours(time) {
  return function (_ref) {
    var timestamp = _ref.timestamp;

    var cacheLife = hourToMs(time); // 30 minute cache
    timestamp = parseInt(timestamp);
    var now = new Date().getTime();
    return now - timestamp > cacheLife;
  };
};

var cacheApiResponse = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cacheKey, api) {
    var invalidateCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : expireAfterHours(0.5);

    var cache, _JSON$parse, timestamp, _data, _ref3, data, _timestamp;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].localStorage && Object(__WEBPACK_IMPORTED_MODULE_1__persist__["b" /* isLocalStorageSupported */])())) {
              _context.next = 6;
              break;
            }

            cache = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].localStorage.getItem(cacheKey);

            if (!cache) {
              _context.next = 6;
              break;
            }

            _JSON$parse = JSON.parse(cache), timestamp = _JSON$parse.timestamp, _data = _JSON$parse.data;

            if (invalidateCache({ timestamp: timestamp, storedData: _data })) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", { response: _data });

          case 6:
            _context.next = 8;
            return api();

          case 8:
            _ref3 = _context.sent;
            data = _ref3.data;

            if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */] && Object(__WEBPACK_IMPORTED_MODULE_1__persist__["b" /* isLocalStorageSupported */])()) {
              _timestamp = new Date().getTime();

              __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].localStorage.setItem(cacheKey, JSON.stringify({ data: data, timestamp: _timestamp }));
            }
            return _context.abrupt("return", { response: data });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function cacheApiResponse(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PostcodeIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_function__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\outlet-store\\navigation-bar.jsx',
    _class,
    _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var CarOutline = function CarOutline() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    {
      'data-test': 'car-outline',
      viewBox: '0 0 111 54',
      style: { height: '3em', margin: 'auto 1em auto 0', fill: '#DBDBDB' }, __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M110.88,24.73a6.66,6.66,0,0,0-.16-1.07c-0.22-1.8-1-3.56-1.2-5.34-0.26-.61.63-4.7-1.15-4.31a44.53,44.53,0,0,1-3.88-2.66c-1.16-1-2.2-2.19-3.27-3.31-1.36-.9-2.31-2.18-3.51-3a27.75,27.75,0,0,0-4.58-2.77A44.4,44.4,0,0,0,86.52.56C85.32,0.39,83.9.4,82.58,0.29,79,0,75.64,0,72,0S64.74,0.2,61.12.4c-2.42.13-4.89,0.73-7.28,0.73a16.47,16.47,0,0,0-2.18.26,17.86,17.86,0,0,0-3.55.51C47.88,2,47,2.22,46.26,2.49h0A17.57,17.57,0,0,0,44,3.37l-0.1.05a17.25,17.25,0,0,0-1.72.9L41,5c-0.34.17-.72,0.37-1.09,0.57h0a7.44,7.44,0,0,0-.82.52L36.28,7.8l0,0a22.11,22.11,0,0,0-2.11,1.63c-0.4.15-2.8,1.89-2.84,1.91h0c-0.3.17-.59,0.34-0.89,0.53a2.85,2.85,0,0,0-.92.48,5.58,5.58,0,0,0-.3,1,1.45,1.45,0,0,1-.61.4,9,9,0,0,1-3.53.82,50,50,0,0,0-10,2.29,24,24,0,0,0-3.37,1.37c-1.15.6-2.12,1.45-3.24,2-0.4.2-4.4,2.14-5.45,2.83H3l-0.42.19-0.23.18h0A4.06,4.06,0,0,0,2,26.76c0.22,0.22-.93,1.48-1,1.62-0.48.79-.93,6.27-1,7.51a12.56,12.56,0,0,0,.24,2.67c0.17,1.23-.29,2.53,0,3.74a6.64,6.64,0,0,0,.63,1c0,0.8,2.08,1.94,2.67,2.26,0.92,0.5.93,0.16,1.84,0.22a4.6,4.6,0,0,1,1.34.7c0.61,0.23,1.32,0,1.91.18a1.26,1.26,0,0,1,.44.28,8.39,8.39,0,0,0,12.72.33,2.84,2.84,0,0,1,1.36-.17c1.42,0,26.27,1.14,30,1.48a7.19,7.19,0,0,1,1.67.45,2.28,2.28,0,0,1,.81,0,4.49,4.49,0,0,1,.75,1.09,6.25,6.25,0,0,0,1.74,1.68A7.71,7.71,0,0,0,59.62,53a8,8,0,0,0,8,0l0.1,0a2.17,2.17,0,0,0,.31-0.2,9.15,9.15,0,0,0,4.24-7,1.74,1.74,0,0,1,.66-0.94c0.85-.54,22.59-5,23.44-5.09,0,0,1.22,0,1.25,0a1.59,1.59,0,0,0,0,.83,4.52,4.52,0,0,0,.5.29c0.12,0.12.23,0.33,0.41,0.52,0.87,0.89,1.3,1.56,2.63,1.77,1.69,0.27,4.7.54,6-.79,1.59-1.64,1.85-4.18,2.22-6.42,0.19-1.15.81-2.11,1-3.33a13.51,13.51,0,0,0,.34-2.57C110.74,28.22,111.22,26.46,110.88,24.73Z', __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    })
  );
};

CarOutline.displayName = 'CarOutline';
CarOutline.displayName = 'CarOutline';
var PostcodeIcon = function PostcodeIcon(_ref) {
  var fill = _ref.fill;
  return (
    /* width: 2em for IE */
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'svg',
      { viewBox: '0 0 26 36', style: { height: '100%', width: '2em', fill: fill }, __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        d: 'M26 12.98c0 5.72-2.98 10-6 14-1.62 2.12-5.74 7.38-5.74 7.38L13 36l-1.24-1.6S7.62 29.14 6 27.02c-3.04-4-6-8.3-6-14C-.011 5.84 5.8.011 12.98 0 20.16-.011 25.989 5.8 26 12.98zm-8.8-1.3h-.08A4.12 4.12 0 0 0 13 7.58a4.12 4.12 0 1 0 4.2 4.1z',
        fillRule: 'nonzero', __source: {
          fileName: _jsxFileName,
          lineNumber: 22
        }
      })
    )
  );
};

PostcodeIcon.displayName = 'PostcodeIcon';
PostcodeIcon.displayName = 'PostcodeIcon';
PostcodeIcon.propTypes = {
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Pencil = function Pencil() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    { viewBox: '0 0 14 14', style: { height: '1em', width: '1em', marginLeft: "1em", fill: '#910A2D' }, __source: {
        fileName: _jsxFileName,
        lineNumber: 33
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M10.39,6l0.9,0.9L6.22,11.91,0,14,2.1,7.79,7.15,2.73,8,3.62,3.2,8.47,2.32,11.08l0.6,0.59,2.61-.88ZM4,9.4A0.63,0.63,0,0,1,4.16,9L8.77,4.34l0.9,0.9L5.05,9.85A0.63,0.63,0,0,1,4.6,10,0.65,0.65,0,0,1,4,9.4Zm10-6a1.66,1.66,0,0,1-.48,1.16L12,6.13,7.88,2,9.4,0.48a1.65,1.65,0,0,1,2.33,0l1.8,1.79A1.66,1.66,0,0,1,14,3.45Zm-1.27,0a0.37,0.37,0,0,0-.1-0.27l-1.8-1.8a0.38,0.38,0,0,0-.54,0L9.67,2,12,4.34l0.63-.63A0.35,0.35,0,0,0,12.73,3.45Z', __source: {
        fileName: _jsxFileName,
        lineNumber: 34
      }
    })
  );
};

Pencil.displayName = 'Pencil';
Pencil.displayName = 'Pencil';
var Info = function Info() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    { width: '17', height: '17', viewBox: '0 0 17 17', __source: {
        fileName: _jsxFileName,
        lineNumber: 39
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd', __source: {
          fileName: _jsxFileName,
          lineNumber: 40
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { fill: 'currentColor', cx: '8.5', cy: '8.5', r: '8.5', __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        d: 'M11.419 5.909c0-1.528-1.215-2.33-2.994-2.33-1.303 0-2.343.576-3.057 1.29l.84.99c.626-.602 1.252-.977 2.18-.977 1.077 0 1.69.4 1.69 1.102 0 .601-.288.89-.927 1.24-1.39.764-1.653 1.265-1.653 2.73h1.365c0-.951.126-1.252.94-1.703 1.052-.588 1.616-1.127 1.616-2.342zm-2.305 6.67a.957.957 0 0 0-.94-.953.957.957 0 0 0-.94.952c0 .514.427.94.94.94.514 0 .94-.426.94-.94z',
        fill: '#FFF', __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      })
    )
  );
};

Info.displayName = 'Info';
Info.displayName = 'Info';
var NavButton = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])((_temp2 = _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    var _temp, _this, _ret;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          gtmEvents = _this$props.gtmEvents,
          onClick = _this$props.onClick;

      e && e.stopPropagation();
      if (gtmEvents) Object(__WEBPACK_IMPORTED_MODULE_6_utils_function__["e" /* invokeFuncs */])(gtmEvents);
      if (onClick) onClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _class.prototype.render = function render() {
    var _props = this.props,
        disabled = _props.disabled,
        active = _props.active,
        _props$dataTest = _props.dataTest,
        dataTest = _props$dataTest === undefined ? '' : _props$dataTest,
        _props$selectionLabel = _props.selectionLabel,
        selectionLabel = _props$selectionLabel === undefined ? '' : _props$selectionLabel,
        _props$selectedText = _props.selectedText,
        selectedText = _props$selectedText === undefined ? '' : _props$selectedText,
        _props$fallbackText = _props.fallbackText,
        fallbackText = _props$fallbackText === undefined ? '' : _props$fallbackText,
        _props$href = _props.href,
        href = _props$href === undefined ? null : _props$href,
        image = _props.image;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["a" /* A */],
      {
        withoutStyle: true,
        'data-test': dataTest,
        onClick: !disabled ? this.handleClick : null,
        href: !disabled ? href : null, __source: {
          fileName: _jsxFileName,
          lineNumber: 79
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'flex' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 84
          }
        },
        image,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.selectionWrapper, __source: {
              fileName: _jsxFileName,
              lineNumber: 86
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: [styles.text, styles.secondaryText, { display: 'flex' }], __source: {
                fileName: _jsxFileName,
                lineNumber: 87
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 93
                }
              },
              selectionLabel
            ),
            !disabled && selectedText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pencil, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 94
              }
            }),
            !disabled && selectedText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 97
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#910A2D', marginLeft: "8px" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 98
                  }
                },
                'Edit'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["D" /* H6 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 102
              }
            },
            selectedText || fallbackText
          )
        )
      )
    );
  };

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  dataTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectionLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fallbackText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _temp2));

var renderError = function renderError(error) {
  if (error) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: {
          margin: '0',
          flex: '1 1 auto',
          textAlign: 'center'
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        }
      },
      error
    );
  }
};

var NavigationBar = function NavigationBar(_ref2) {
  var _ref2$nameplateButton = _ref2.nameplateButton,
      nameplateButton = _ref2$nameplateButton === undefined ? {} : _ref2$nameplateButton,
      _ref2$dealerButton = _ref2.dealerButton,
      dealerButton = _ref2$dealerButton === undefined ? {} : _ref2$dealerButton,
      _ref2$showLoader = _ref2.showLoader,
      showLoader = _ref2$showLoader === undefined ? false : _ref2$showLoader,
      error = _ref2.error,
      _ref2$onNextStep = _ref2.onNextStep,
      onNextStep = _ref2$onNextStep === undefined ? __WEBPACK_IMPORTED_MODULE_5_utils__["C" /* noop */] : _ref2$onNextStep,
      backButton = _ref2.backButton,
      _ref2$nextButton = _ref2.nextButton,
      nextButton = _ref2$nextButton === undefined ? false : _ref2$nextButton,
      _ref2$hint = _ref2.hint,
      hint = _ref2$hint === undefined ? false : _ref2$hint,
      _ref2$innerRef = _ref2.innerRef,
      innerRef = _ref2$innerRef === undefined ? __WEBPACK_IMPORTED_MODULE_5_utils__["C" /* noop */] : _ref2$innerRef,
      _ref2$compact = _ref2.compact,
      compact = _ref2$compact === undefined ? [true, true] : _ref2$compact,
      step = _ref2.step,
      gtmEvents = _ref2.gtmEvents;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_containers__["n" /* FixedBar */],
    { innerRef: innerRef, __source: {
        fileName: _jsxFileName,
        lineNumber: 141
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { display: 'flex', flexDirection: 'column', flex: 1 }, __source: {
          fileName: _jsxFileName,
          lineNumber: 142
        }
      },
      compact[1] && renderError(error),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 144
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: {
              display: 'flex',
              listStyleType: 'none',
              padding: '.5em 1em',
              alignItems: 'center'
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 145
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavButton, _extends({}, dealerButton, {
            dataTest: 'select-dealer',
            image: !compact[0] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["b" /* AddressIcon */], {
              style: {
                width: "35px",
                height: "42px",
                margin: "auto 8px auto 16px",
                fill: !dealerButton.selectedText ? '#999999' : '#910A2D'
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 156
              }
            }),
            gtmEvents: gtmEvents.editDealer, __source: {
              fileName: _jsxFileName,
              lineNumber: 152
            }
          })),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            style: {
              borderLeft: '1px solid #E7E7E7',
              height: '3em',
              margin: compact[0] ? '0 1em' : '0 1em 0 2em'
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 166
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavButton, _extends({}, nameplateButton, {
            dataTest: 'select-nameplate',
            image: !compact[0] && (nameplateButton.image ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              style: {
                width: 'auto', // height and negative padding to keep the component height as 3em
                height: '4em',
                margin: '-0.5em 1em -0.5em 0'
              },
              src: nameplateButton.image, __source: {
                fileName: _jsxFileName,
                lineNumber: 178
              }
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarOutline, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 186
              }
            })),
            gtmEvents: gtmEvents.editNameplate, __source: {
              fileName: _jsxFileName,
              lineNumber: 172
            }
          }))
        ),
        !compact[1] && renderError(error),
        !compact[1] && showLoader && step === 'SELECT_NAMEPLATE' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: { margin: '0 2em' // in show results step we have a loader in the main page already so this should be disabled
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 193
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["M" /* LoaderIcon */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 196
            }
          })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: 'flex', paddingRight: "2em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 199
            }
          },
          backButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["e" /* Button */], _extends({}, backButton, {
            styleName: 'blackOutlined',
            display: 'inline',
            gtmEvents: gtmEvents.selectBack, __source: {
              fileName: _jsxFileName,
              lineNumber: 201
            }
          })),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '10px' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 207
            }
          }),
          nextButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["e" /* Button */], _extends({}, nextButton, {
            disabled: !!error || nextButton.disabled,
            display: 'inline',
            styleName: 'red',
            gtmEvents: gtmEvents.selectNext, __source: {
              fileName: _jsxFileName,
              lineNumber: 209
            }
          }))
        ),
        !compact[0] && hint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { textAlign: 'left', margin: '0 2em' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 220
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_containers__["w" /* InlineDisclaimerBlock */],
            {
              message: hint.disclaimer,
              yOffset: -6,
              isIdentifierHidden: true,
              isIdentifierHiddenInPopUp: true,
              gtmEvents: hint.gtmEvents, __source: {
                fileName: _jsxFileName,
                lineNumber: 221
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  display: 'flex',
                  color: '#999999',
                  fontWeight: '200',
                  cursor: 'pointer',
                  alignItems: 'center',
                  transition: 'color .25s',
                  ':hover': { color: '#191919' }
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 227
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Info, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 237
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { marginLeft: '.5em' }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 238
                  }
                },
                hint.label
              )
            )
          )
        )
      )
    )
  );
};

NavigationBar.displayName = 'NavigationBar';
NavigationBar.displayName = 'NavigationBar';
var styles = {
  navItem: {
    transition: 'opacity .25s',
    margin: '0 1em',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textDecoration: 'inherit',
    color: 'inherit'
  },
  text: {
    textTransform: 'uppercase',
    margin: 0
  },
  secondaryText: {
    color: '#999999'
  },
  primaryText: {
    fontSize: '100%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  selectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '41vw',
    '@media (min-width: 768px)': {
      maxWidth: '25vw'
    },
    '@media (min-width: 1100px)': {
      maxWidth: '35vw'
    }
  }
};

NavigationBar.propTypes = {
  onNextStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showLoader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  nameplateButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  dealerButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  backButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  nextButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  step: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    editNameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    editDealer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    selectNext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    selectBack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])({ threshold: [768, 1400] }))(NavigationBar));

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\outlet-store-specifications-block\\index.jsx";






var OutletStoreSpecificationsBlock = function OutletStoreSpecificationsBlock(props) {
  /**
   * @param {String} heading - Heading text.
   * @param {Object} vehicleProps - Vehicle properties.
   * @param {Object|BackHyperlink} backButton - props for back button
   * @param {Object} specifications - Specifications data object.
   * @returns {ReactElement} React Component
   */
  var specifications = props.specifications,
      _props$Interactive = props.Interactive,
      Interactive = _props$Interactive === undefined ? "" : _props$Interactive,
      _props$heading = props.heading,
      heading = _props$heading === undefined ? "" : _props$heading,
      vehicleProps = props.vehicleProps,
      compact = props.compact;

  if (props.error) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { color: "red", textAlign: "center" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        }
      },
      props.error
    );
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_containers__["g" /* ColumnGroup */],
      { maxWidth: 800, __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_containers__["f" /* Column */],
        { textAlignMobile: "center", textAlign: "center", __source: {
            fileName: _jsxFileName,
            lineNumber: 31
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["s" /* HeadingBlock */], {
          margin: true,
          preHeading: Interactive.replace("{nameplate}", vehicleProps.nameplate),
          value: heading.replace("{nameplate}", vehicleProps.nameplate), __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          {
            style: {
              fontSize: "90%",
              color: "#939393",
              fontWeight: 200,
              lineHeight: 1.4
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 36
            }
          },
          vehicleProps.imageDisclaimer || "Image is for illustration purposes only"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: vehicleProps.imageSrc, alt: heading, style: { maxWidth: "100%" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 45
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["H" /* MyMazdaSummary */], _extends({}, vehicleProps, { style: { padding: "2em 0" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          }
        })),
        specifications && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["_2" /* SpecificationList */], { specs: specifications.data.categories, __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_containers__["n" /* FixedBar */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { padding: compact ? "0 1em" : ".5em 1.5em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 51
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["e" /* Button */], {
          label: "BACK",
          href: "javascript:history.back()",
          styleName: "blackOutlined",
          display: "inline", __source: {
            fileName: _jsxFileName,
            lineNumber: 52
          }
        })
      )
    )
  );
};

OutletStoreSpecificationsBlock.displayName = "OutletStoreSpecificationsBlock";
OutletStoreSpecificationsBlock.displayName = "OutletStoreSpecificationsBlock";
OutletStoreSpecificationsBlock.propTypes = {
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  Interactive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vehicleProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    rego: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    nameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    grade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    exterior: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    imageDisclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    drive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    transmission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    modelCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  specifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      categories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      disclaimers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
    })
  }),
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(OutletStoreSpecificationsBlock));

/**
 * @typedef {Object} BackHyperlink
 * @property {String} name - Displayed Name.
 * @property {String} href - Hyperlink href.
 */

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Overlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_portal__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils__ = __webpack_require__(9);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\overlay\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/** Overlay Component. */
var Overlay = function (_Component) {
  _inherits(Overlay, _Component);

  function Overlay(props) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleKey = _this.handleKey.bind(_this);
    return _this;
  }

  Overlay.prototype.componentDidMount = function componentDidMount() {
    this.scrollY = Object(__WEBPACK_IMPORTED_MODULE_7_utils__["v" /* getScrollTop */])();
    __WEBPACK_IMPORTED_MODULE_6_containers__["e" /* Body */].lock();
  };

  Overlay.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_6_containers__["e" /* Body */].unlock(this.scrollY);
  };

  /**
   * @param {object} event - keyDown event
   */


  Overlay.prototype.handleKey = function handleKey(event) {
    if (event.key === "Escape") this.props.close(event);
  };

  /**
   * @param {Array|FlexContent} components - Nested Components
   * @returns {ReactElement} React Component
   */


  Overlay.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { id: "Overlay", "data-test": "overlay", style: [styles.base], onKeyDown: this.handleKey, __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: {
            background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0))",
            position: "absolute",
            height: "75px",
            width: "100%",
            zIndex: "20"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["j" /* CloseButton */], { dataTest: "overlay-close", onClick: this.props.close, styleName: __WEBPACK_IMPORTED_MODULE_5_components__["j" /* CloseButton */].STYLE_NAMES.LIGHT, __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_4_containers_utilities__["a" /* childParser */])(this.props)
    );
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Overlay.displayName = "Overlay";
Overlay.propTypes = {
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(Overlay));

// TODO
// fix animations

var styles = {
  base: {
    left: 0,
    top: 0,
    right: 0,
    height: "100%",
    overflowY: "auto",
    display: "flex",
    zIndex: 60,
    WebkitOverflowScrolling: "touch",
    position: "fixed",
    transition: "opacity .5s",
    backgroundColor: "#f5f5f5"
  }
};

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\PersonalisationBlockItem\\PersonalisationBlockItem.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PersonalisationBlockItem = function (_React$PureComponent) {
  _inherits(PersonalisationBlockItem, _React$PureComponent);

  function PersonalisationBlockItem() {
    _classCallCheck(this, PersonalisationBlockItem);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PersonalisationBlockItem.prototype.render = function render() {
    var _props = this.props,
        _props$iFrameOptions = _props.iFrameOptions,
        iFrameOptions = _props$iFrameOptions === undefined ? 'showInBoth' : _props$iFrameOptions,
        _props$mobile = _props.mobile,
        mobile = _props$mobile === undefined ? false : _props$mobile,
        _props$desktop = _props.desktop,
        desktop = _props$desktop === undefined ? false : _props$desktop,
        _props$tablet = _props.tablet,
        tablet = _props$tablet === undefined ? false : _props$tablet,
        _props$urlList = _props.urlList,
        urlList = _props$urlList === undefined ? null : _props$urlList,
        _props$components = _props.components,
        components = _props$components === undefined ? [] : _props$components;


    var cookieHandlerObject = new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_cookieHandler__["a" /* default */]();
    var history = cookieHandlerObject.getCookie("history");
    if (history) {
      var newHistory = JSON.parse(history);

      if (urlList && urlList.length > 0 && newHistory && newHistory.length > 0) {
        var found = false;
        newHistory.map(function (item) {
          if (urlList.includes(item)) {
            found = true;
          }
        });
        if (!found) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 31
          }
        });
      }
    }

    // iFrameOptions true means, do not show it in iFrame
    if (iFrameOptions === 'showInIframe' && !__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["e" /* IS_IFRAME */]) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36
      }
    });
    if (iFrameOptions === 'hideInIframe' && __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["e" /* IS_IFRAME */]) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37
      }
    });

    // visibility of block in different sizes
    var visibleArray = [];
    if (desktop) visibleArray.push('screen');

    if (tablet) visibleArray.push('tablet');

    if (mobile) visibleArray.push('mobile');

    if (visibleArray.length === 0) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47
      }
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { width: "100%" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 50
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_21" /* Visible */],
        { visible: visibleArray, __source: {
            fileName: _jsxFileName,
            lineNumber: 51
          }
        },
        components && components.length > 0 && Object(__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_componentParser__["a" /* default */])(components)
      )
    );
  };

  return PersonalisationBlockItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

PersonalisationBlockItem.displayName = "PersonalisationBlockItem";


/* harmony default export */ __webpack_exports__["a"] = (PersonalisationBlockItem);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apis_geo__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_actions_location__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_validation__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__postcode_popup_less__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__postcode_popup_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__postcode_popup_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__crosshairs_svg__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__crosshairs_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__crosshairs_svg__);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\postcode-popup\\index.jsx';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














// Redux




var PostcodePopup = function (_PureComponent) {
  _inherits(PostcodePopup, _PureComponent);

  function PostcodePopup(props) {
    _classCallCheck(this, PostcodePopup);

    //const { postcode } = this.props.locationState
    //- 2601
    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _initialiseProps.call(_this);

    var postcode = _this.props.locationState.postcode;


    _this.state = {
      // Decouple from props since we only want to update postcode on submit
      postcode: postcode,
      isEditing: false,
      validationError: '',
      focus: false,
      open: false
    };
    return _this;
  }

  PostcodePopup.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var locationState = _ref.locationState;

    if (this.state.isEditing) return;

    var fetchError = locationState.fetchError,
        postcode = locationState.postcode,
        isFetching = locationState.isFetching,
        postcodePopupOpen = locationState.postcodePopupOpen;


    var shouldFocus = postcodePopupOpen && (fetchError || postcodePopupOpen !== this.props.locationState.postcodePopupOpen);

    this.setState(_extends({}, fetchError ? { validationError: Object(__WEBPACK_IMPORTED_MODULE_3_apis_geo__["e" /* getErrorMessage */])(fetchError) } : {}, postcode && !isFetching && !fetchError ? { postcode: postcode } : {}, shouldFocus ? { focus: true } : {}));
  };

  PostcodePopup.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.postcodePopupOpenAutomatically && !this.props.locationState.postcode) {
      var requestPostcodeInput = this.props.locationActions.requestPostcodeInput;

      requestPostcodeInput();
    }
    __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("POSTCODE_POPUP_OPEN", function () {
      return _this2._handleOpen();
    }, false);
  };

  PostcodePopup.prototype.getTitle = function getTitle() {
    var _props$locationState = this.props.locationState,
        postcode = _props$locationState.postcode,
        locationConfirmed = _props$locationState.locationConfirmed;


    if (!postcode) return 'Set your location';
    return locationConfirmed ? 'Change your location' : 'Confirm your location';
  };

  PostcodePopup.prototype.getMessage = function getMessage(styles) {
    var postcode = this.state.postcode;
    var propsPostcode = this.props.locationState.postcode;


    return propsPostcode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { style: styles.span, __source: {
          fileName: _jsxFileName,
          lineNumber: 120
        }
      },
      'Your current postcode ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 121
          }
        },
        postcode
      ),
      ' will be used to determine prices. Is this correct?'
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { style: styles.span, __source: {
          fileName: _jsxFileName,
          lineNumber: 125
        }
      },
      'Your postcode will be used to determine prices.'
    );
  };

  PostcodePopup.prototype.render = function render() {
    var _classnames,
        _classnames2,
        _classnames3,
        _classnames4,
        _this3 = this;

    var isFetching = this.props.locationState.isFetching;
    var _state = this.state,
        postcode = _state.postcode,
        validationError = _state.validationError,
        focus = _state.focus,
        open = _state.open;

    var styles = PostcodePopupStyles(this.props.thresholds);
    var show = this.props.locationState.postcodePopupOpen || open;

    if (!show) return null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 150
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_18" /* ToastPopup */],
        { onClose: this.handleClose, __source: {
            fileName: _jsxFileName,
            lineNumber: 151
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_10__postcode_popup_less___default.a.PostCodePopup] = true, _classnames)), __source: {
              fileName: _jsxFileName,
              lineNumber: 152
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_10__postcode_popup_less___default.a.First] = true, _classnames2)), __source: {
                fileName: _jsxFileName,
                lineNumber: 155
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.crosshairs, __source: {
                fileName: _jsxFileName,
                lineNumber: 158
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 159
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["F" /* Heading */], {
                withDetails: true,
                value: this.getTitle(), tag: 'h5', applyTopMargin: false, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 160
                }
              }),
              this.getMessage(styles)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_10__postcode_popup_less___default.a.Form] = true, _classnames3)), onSubmit: this.submitPostcode, __source: {
                fileName: _jsxFileName,
                lineNumber: 166
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_10__postcode_popup_less___default.a.Input] = true, _classnames4)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 169
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["J" /* InputText */], {
                ref: function ref(c) {
                  _this3.postcodeInput = c;
                },
                value: postcode,
                placeholder: 'Enter your postcode',
                isValid: !validationError,
                maxLength: 4,
                message: validationError || '',
                onChange: this.handlePostcodeInputChange,
                onFocus: this.handlePostcodeInputFocus,
                onBlur: this.handlePostcodeInputBlur,
                disabled: isFetching,
                focus: focus,
                margin: '0',
                styleName: 'dark', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 172
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 189
                }
              },
              isFetching && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { position: 'absolute', left: '66%', top: '26%' }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 191
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["M" /* LoaderIcon */], { styleName: 'light', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 192
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: isFetching ? { opacity: 0, pointerEvents: 'none' } : null, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 196
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["e" /* Button */], { label: 'Submit', display: 'block', onClick: this.submitPostcode, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 197
                  }
                })
              )
            )
          )
        )
      )
    );
  };

  return PostcodePopup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handlePostcodeInputChange = function (_ref3) {
    var target = _ref3.target;
    var value = target.value;

    var number = value.replace(/[^0-9]/g, '');
    var post = 2601;
    _this4.setState({
      postcode: '2601',
      validationError: ''
    });
  };

  this.handlePostcodeInputFocus = function () {
    _this4.setState({ isEditing: true, focus: true });
  };

  this.handlePostcodeInputBlur = function () {
    _this4.setState({ isEditing: false, focus: false });
  };

  this.submitPostcode = function (event) {
    //this.state
    var postcode = _this4.state.postcode;

    _this4.handlePostcodeInputBlur();
    if (event) event.preventDefault();

    //const { isValid, message } = postcodeValidation(postcode ? postcode.toString() : '')
    var isValid = true;
    if (!isValid) {
      _this4.setState({ validationError: message });
    } else {
      _this4.setState({
        open: false
      });
      //this.props.locationActions.updatePostcode(postcode)
      _this4.props.locationActions.updatePostcode('2601');
    }
  };

  this._handleOpen = function () {
    _this4.setState({
      open: true
    });
  };

  this.handleClose = function () {
    var cancelPostcodeInput = _this4.props.locationActions.cancelPostcodeInput;

    Object(__WEBPACK_IMPORTED_MODULE_12_AtomicUtils_gtmHandler__["a" /* default */])({
      pageCategory: "Postcode Pop-up",
      pageAction: "Postcode Pop-up - closed"
    });
    cancelPostcodeInput();
    _this4.setState({
      open: false
    });
  };
};

PostcodePopup.displayName = 'PostcodePopup';


var mapStateToProps = function mapStateToProps(state) {
  return {
    locationState: __WEBPACK_IMPORTED_MODULE_4_store_actions_location__["c" /* selectors */].getLocation(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    locationActions: Object.keys(__WEBPACK_IMPORTED_MODULE_4_store_actions_location__["a" /* actionCreators */]).reduce(function (actions, key) {
      actions[key] = function () {
        return dispatch(__WEBPACK_IMPORTED_MODULE_4_store_actions_location__["a" /* actionCreators */][key].apply(__WEBPACK_IMPORTED_MODULE_4_store_actions_location__["a" /* actionCreators */], arguments));
      };
      return actions;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["c" /* DetectThresholds */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["a" /* ConnectLocation */])(), Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps))(PostcodePopup));

PostcodePopup.propTypes = {
  locationState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  locationActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  postcodePopupOpenAutomatically: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  thresholds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    wide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
};

PostcodePopup.defaultProps = {
  locationState: {},
  postcodePopupOpenAutomatically: false,
  locationActions: {
    cancelPostcodeInput: __WEBPACK_IMPORTED_MODULE_8_utils__["C" /* noop */],
    updatePostcode: __WEBPACK_IMPORTED_MODULE_8_utils__["C" /* noop */],
    fetchLocation: __WEBPACK_IMPORTED_MODULE_8_utils__["C" /* noop */]
  },
  thresholds: {
    compact: true,
    wide: false
  }
};

var rotateKeyframes = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["j" /* keyframes */])({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '33%, 100%': {
    transform: 'rotate(90deg)'
  }
});

var PostcodePopupStyles = function PostcodePopupStyles(_ref2) {
  var compact = _ref2.compact,
      wide = _ref2.wide;
  return {
    span: {
      display: 'inline-block',
      width: '100%',
      lineHeight: 1.4
    },
    wrapper: _extends({
      display: "flex",
      textAlign: "center",
      flexGrow: 1,
      alignItems: "center",
      minHeight: '120px',
      width: '100%',
      flexDirection: "column"
    }, compact ? {} : {
      paddingRight: "2em",
      textAlign: "left",
      flexDirection: "row"
    }),
    content: {
      flexGrow: 1,
      textAlign: compact ? 'center' : 'left',
      maxWidth: !compact && '42vw',
      marginLeft: wide && '2em',
      borderLeft: wide && '1px solid #d5d5d5',
      paddingLeft: wide && '2em'
    },
    actions: {
      display: 'flex',
      width: '100%',
      padding: '0 15px',
      margin: '0 auto',
      flexGrow: 0,
      flexDirection: compact ? 'column' : 'row',
      justifyContent: compact ? 'center' : 'flex-end',
      alignItems: 'center',
      flexShrink: 10
    },
    inputContainer: {
      flexGrow: 0,
      width: '100%',
      marginRight: !compact && '1em',
      marginTop: '-10px',
      height: compact ? '140px' : '115px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    buttonContainer: {
      flexGrow: 0,
      flexShrink: 0,
      position: 'relative'
    },
    crosshairs: _extends({
      animation: 'x 2s infinite ease-in-out',
      animationName: rotateKeyframes,
      margin: '15px',
      display: wide ? 'block' : 'none'
    }, wide ? {
      width: '2em',
      height: '2em',
      flex: '0 0 2em',
      backgroundImage: 'url(' + __WEBPACK_IMPORTED_MODULE_14__crosshairs_svg___default.a + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'center'
    } : {})
  };
};

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\scraped-page\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ErrorScreen = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(function (_ref) {
  var scrapeError = _ref.scrapeError;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: [styles.fill].concat(styles.error), __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_25" /* WysiwygContent */], { xmlString: scrapeError, theme: "light", __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    })
  );
});

var ScrapedPage = function (_PureComponent) {
  _inherits(ScrapedPage, _PureComponent);

  function ScrapedPage() {
    _classCallCheck(this, ScrapedPage);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  ScrapedPage.prototype.render = function render() {
    var html = this.props.html;


    if (html) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorScreen, { scrapeError: html, __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      });
    }
  };

  return ScrapedPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ScrapedPage.displayName = "ScrapedPage";
/* harmony default export */ __webpack_exports__["a"] = (ScrapedPage);


var styles = {
  fill: {
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box"
  },

  center: {
    alignItems: "center",
    justifyContent: "center"
  },

  error: {
    backgroundColor: "#d00",
    color: "#fff",
    padding: "4em",
    wordBreak: "break-word"
  }
};

ScrapedPage.propTypes = {
  html: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ServiceCalculatorOwner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_portal__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_my_json_valid__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_my_json_valid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_is_my_json_valid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_history__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_layout__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_apis_expose_global__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_schema_js__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__spinner_svg__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__spinner_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__spinner_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__close_svg__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__close_svg__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\service-calculator-owner\\index.jsx",
    _container,
    _mainCTAButtons,
    _mainCTAButtonsFiller,
    _regoInput,
    _changeVinRegoDesktop,
    _changeVinRegoMobile;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var validateServiceData = __WEBPACK_IMPORTED_MODULE_3_is_my_json_valid___default()(__WEBPACK_IMPORTED_MODULE_12__data_schema_js__["a" /* default */]);

var scheduledOnly = function scheduledOnly(s) {
  return s.factoryCodeEntity.type === "Scheduled Maintenance" && s.factoryCodeEntity.distance > 0;
};

var VinLocator = function VinLocator() {
  var descriptionText = "\n      The Vehicle Identification Number [VIN] is a unique\n      number that identifies your vehicle. Please refer\n      to the Specifications section of your owner's manual\n      for the exact location of this number.\n    ";
  var mainText = "Where is my VIN located?";
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers__["k" /* ExpandableInfo */], { mainText: mainText, description: descriptionText, __source: {
      fileName: _jsxFileName,
      lineNumber: 35
    }
  });
};

VinLocator.displayName = "VinLocator";
VinLocator.displayName = "VinLocator";
var ServiceCalculatorOwner = function (_Component) {
  _inherits(ServiceCalculatorOwner, _Component);

  function ServiceCalculatorOwner(props) {
    _classCallCheck(this, ServiceCalculatorOwner);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateSelectedAddtionalServices = function (selectedAdditionalServices) {
      _this.setState({ selectedAdditionalServices: selectedAdditionalServices }, function () {
        _this.props.search.pushParam({
          asmc: Object.keys(selectedAdditionalServices).filter(function (item) {
            return selectedAdditionalServices[item];
          })
        });
      });
    };

    _this.generateBookServiceHref = function () {
      var selectedAdditionalServices = _this.state.selectedAdditionalServices;

      var asmcArray = selectedAdditionalServices && Object.keys(selectedAdditionalServices).filter(function (k) {
        return selectedAdditionalServices[k];
      });
      var asmcQueryString = asmcArray && asmcArray.map(function (item) {
        return "&asmc=" + item;
      }).join("");
      var formHref = _this.props.serviceBookingUrl + "?vinrego=" + _this.state.serviceData.vehicle.vin + "&serviceCode=" + _this.state.activeFactoryCode + asmcQueryString;
      return formHref;
    };

    _this.state = {
      displaySpinner: false,
      serviceData: null,
      factoryCode: null,
      vinOrRegoInput: "",
      activeFactoryCode: null,
      isUpdatingVINRego: false
    };

    _this.fetchServicesForVinOrRego = function () {
      if (_this.state.vinOrRegoInput && _this.state.vinOrRegoInput !== "") {
        var url = "" + _this.props.endpoint + encodeURIComponent(_this.state.vinOrRegoInput);
        _this.setState({
          errorMessage: "",
          displaySpinner: true,
          isPopupOpen: false
        });
        var options = {
          method: "GET",
          headers: {
            "content-type": "application/json"
          }

          /** @todo convert this to use apis/koala/fetchKoalaData * */
        };fetch(url, options).then(function (response) {
          if (response.status) return response.json();

          throw new Error("Unfortunately the service is unavailable. Please try again later or contact your Mazda Dealer (Status " + response.status + ").");
        }).then(function (json) {
          var errorCode = json.errorCode;

          var isValid = validateServiceData(json);
          /** @todo Handle this in validateServiceData if possible */
          var preferErrorCode = ["NOTFOUND", "MULTIPLERESULTS"].indexOf(errorCode || "") !== -1 || json.errorMessage;

          if (!isValid && !preferErrorCode) {
            _this.setState({
              displaySpinner: false,
              errorMessage: "Unfortunately data received from the server is invalid. Please try again later or contact your Mazda Dealer"
            });

            return;
          }

          var errorMessage = json.errorMessage ? json.errorMessage : json.errorCode === "NOTFOUND" ? _this.props.errorMessageNOTFOUND : json.errorCode === "MULTIPLERESULTS" ? _this.props.errorMessageMULTIPLERESULTS : null;

          _this.setState({
            displaySpinner: false,
            errorMessage: errorMessage,
            serviceData: errorMessage ? null : json
          }, function () {
            return _this.syncUrl();
          });
        }).catch(function (error) {
          _this.setState({
            displaySpinner: false,
            errorMessage: "The VIN/Rego look up is currently unavailable, please try again later or contact your nearest dealer."
          });
          console.warn("URL: " + url, error);
        });
      }
    };

    _this.setVinOrRego = function (value) {
      _this.setState({ vinOrRegoInput: value ? value.trim() : "", errorMessage: "" });
    };

    _this.handleNext = function () {
      _this.setState({ isUpdatingVINRego: false });
      _this.fetchServicesForVinOrRego();
    };

    // If user click on "Change VIN/Rego" button, reset the state of the component
    _this.handleChangeVinOrRego = function () {
      _this.setState({
        displaySpinner: false,
        serviceData: null,
        factoryCode: null,
        vinOrRegoInput: "",
        activeFactoryCode: null,
        isUpdatingVINRego: true
      });
      // Remove all params
      _this.props.search.pushParam({
        VIN: undefined,
        factoryCode: undefined,
        asmc: undefined
      });
    };

    _this.setService = function (s) {
      _this.setState({
        activeFactoryCode: s
      }, function () {
        return _this.syncUrl();
      });
    };

    _this.syncUrl = function () {
      if (!_this.state.serviceData || !__WEBPACK_IMPORTED_MODULE_5_constants_environment__["c" /* IS_BROWSER */]) return;

      if (_this.state.serviceData.serviceItems) {
        var activeService = _this.state.serviceData.serviceItems.find(function (s) {
          return s.factoryCode === _this.state.activeFactoryCode;
        });

        if (!activeService) return;

        _this.props.search.pushParam({
          factoryCode: _this.state.activeFactoryCode,
          VIN: _this.state.serviceData.vehicle.vin,
          asmc: undefined
        });
      }
    };
    return _this;
  }

  ServiceCalculatorOwner.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!__WEBPACK_IMPORTED_MODULE_5_constants_environment__["c" /* IS_BROWSER */]) return;
    Object(__WEBPACK_IMPORTED_MODULE_11_apis_expose_global__["a" /* default */])("getCurrentFormFields", function () {
      var activeFactoryCode = _this2.state.activeFactoryCode;

      return { activeFactoryCode: activeFactoryCode };
    });
    var searchParams = this.props.search.query;
    var vin = this.props.vin || searchParams.VIN;
    var factoryCode = this.props.factoryCode || searchParams.factoryCode || "";

    if (vin) {
      this.setState({
        vinOrRegoInput: vin,
        activeFactoryCode: factoryCode
      }, function () {
        _this2.fetchServicesForVinOrRego();
      });
    }
  };

  ServiceCalculatorOwner.prototype.renderServiceSelect = function renderServiceSelect() {
    var _this3 = this;

    var options = this.state.serviceData.serviceItems.filter(scheduledOnly).map(function (s, index) {
      return {
        name: s.factoryCodeEntity.description,
        code: s.factoryCodeEntity.code,
        label: s.factoryCodeEntity.description,
        value: s.factoryCodeEntity.code,
        index: index
      };
    });
    var activeServiceIndex = options.findIndex(function (s) {
      return s.code === _this3.state.activeFactoryCode;
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["R" /* InputSelect */], {
      label: "Please Select",
      defaultValue: { value: this.state.activeFactoryCode },
      options: options,
      onChange: this.setService, __source: {
        fileName: _jsxFileName,
        lineNumber: 222
      }
    });
  };

  ServiceCalculatorOwner.prototype.isSPG = function isSPG() {
    try {
      // trying to guess MSS vs SPG service type
      // MSS factoryCode starts with 'S' and SPG starts with 'M' (yes, it's counterintuitive)
      return this.state.serviceData && this.state.serviceData.serviceItems.some(function (si) {
        return si.factoryCode[0] === "M";
      });
    } catch (e) {
      if (false) console.log(e);
      return false;
    }
  };

  ServiceCalculatorOwner.prototype.render = function render() {
    var _this4 = this;

    var compact = this.props.compact;

    var renderInput = !this.state.serviceData || this.state.serviceData.serviceItems.length === 0 || this.state.isUpdatingVINRego;
    var renderSelect = this.state.serviceData && this.state.serviceData.serviceItems.length > 0 && !this.state.errorMessage && !this.state.isUpdatingVINRego;

    var showDetails = this.state.serviceData && !this.state.displaySpinner && !this.state.isUpdatingVINRego && !this.state.errorMessage && this.state.activeFactoryCode;

    var mssDisclaimer = this.state.serviceData && !this.isSPG() ? "The total service price is the Base Scheduled Maintenance, plus any Additional Scheduled Maintenance items that are required." : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.container, __source: {
          fileName: _jsxFileName,
          lineNumber: 287
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers__["s" /* HeadingBlock */], {
        tag: "h3",
        value: this.state.isUpdatingVINRego ? "Update your car details" : this.props.title,
        textAlign: "center", __source: {
          fileName: _jsxFileName,
          lineNumber: 288
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            padding: "1em",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 292
          }
        },
        !this.state.isUpdatingVINRego && this.state.serviceData && this.state.serviceData.vehicle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers__["Y" /* ServiceModelDetails */], {
          model: this.state.serviceData.vehicle.modelGroup + " " + this.state.serviceData.vehicle.grade,
          vin: this.state.serviceData.vehicle.vin,
          registration: this.state.serviceData.vehicle.rego,
          compact: compact, __source: {
            fileName: _jsxFileName,
            lineNumber: 302
          }
        }) : this.state.isUpdatingVINRego ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.textCenter, __source: {
              fileName: _jsxFileName,
              lineNumber: 309
            }
          },
          "Enter a different VIN/Rego to get a new set of servicing costs."
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.textCenter, __source: {
              fileName: _jsxFileName,
              lineNumber: 313
            }
          },
          this.props.description
        ),
        mssDisclaimer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.textCenter, __source: {
              fileName: _jsxFileName,
              lineNumber: 315
            }
          },
          mssDisclaimer
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.regoInput, __source: {
              fileName: _jsxFileName,
              lineNumber: 316
            }
          },
          renderInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                flex: "1 1 auto" /* auto can be changed to 100% when support for ios 9 drops */
                , marginRight: "2em"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 318
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["S" /* InputText */], {
              onKeyDown: function onKeyDown(e) {
                e.key === "Enter" && _this4.handleNext();
              },
              label: "Enter your VIN/Rego",
              value: this.state.vinOrRegoInput,
              onChange: this.setVinOrRego, __source: {
                fileName: _jsxFileName,
                lineNumber: 323
              }
            })
          ),
          renderInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                flex: "0 3 auto" /* auto can be changed to 100% when support for ios 9 drops */
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 333
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["j" /* Button */], {
              styleName: "black",
              label: this.state.isUpdatingVINRego ? "update" : "next",
              onClick: this.handleNext,
              display: "block",
              disabled: !this.state.vinOrRegoInput || this.state.displaySpinner,
              fullWidth: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 337
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 346
              }
            },
            renderSelect && this.renderServiceSelect()
          )
        ),
        renderInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VinLocator, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 350
          }
        }),
        this.state.isPopupOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_portal__["a" /* Portal */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 352
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.popup, __source: {
                fileName: _jsxFileName,
                lineNumber: 353
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
              style: styles.popupCloseButton,
              onClick: function onClick() {
                return _this4.setState({ isPopupOpen: false });
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 354
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 357
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers__["s" /* HeadingBlock */], { value: "not quite right?", textAlign: "center", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 358
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers__["s" /* HeadingBlock */], {
                tag: "h6",
                value: "update your selection to get new set of servicing costs",
                textAlign: "center", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 359
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                type: "text",
                onKeyDown: function onKeyDown(event) {
                  event.key === "Enter" && _this4.handleNext();
                },
                placeholder: "YOUR VIN/REGO",
                value: this.state.vinOrRegoInput,
                onChange: this.setVinOrRego,
                style: [styles.input, { flexGrow: 1, width: "100%" }], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 363
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["j" /* Button */], {
                styleName: "black",
                label: "next",
                onClick: this.handleNext,
                disabled: !this.state.vinOrRegoInput || this.state.displaySpinner,
                fullWidth: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 372
                }
              })
            )
          )
        ),
        !renderInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: [styles.changeVinRego, styles.changeVinRegoDesktop],
            onClick: this.handleChangeVinOrRego, __source: {
              fileName: _jsxFileName,
              lineNumber: 383
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 386
              }
            },
            "Change VIN/REGO \u203A"
          )
        ),
        !renderInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: [styles.changeVinRego, styles.changeVinRegoMobile],
            onClick: function onClick() {
              return _this4.setState({ isPopupOpen: true });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 390
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 393
              }
            },
            "Change VIN/REGO \u203A"
          )
        ),
        this.state.displaySpinner && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "1em"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 397
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_13__spinner_svg___default.a, style: { width: "5vw", height: "5vw", margin: "5em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 404
            }
          })
        ),
        this.state.errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { "data-test": "error-message", style: styles.error, __source: {
              fileName: _jsxFileName,
              lineNumber: 408
            }
          },
          this.state.errorMessage
        )
      ),
      showDetails && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["_8" /* Section */],
        { padding: true, backgroundColor: "#ffffff", __source: {
            fileName: _jsxFileName,
            lineNumber: 414
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers__["T" /* ServiceDetails */], {
          data: this.state.serviceData,
          factoryCode: this.state.activeFactoryCode,
          selectAdditionalItems: true,
          updateSelectedAddtionalServices: this.updateSelectedAddtionalServices, __source: {
            fileName: _jsxFileName,
            lineNumber: 415
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 420
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["_1" /* P */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 421
            }
          },
          "Further details or need help please contact a Dealer"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.mainCTAButtons, __source: {
              fileName: _jsxFileName,
              lineNumber: 422
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                textAlign: "center",
                padding: "0.5em",
                boxSizing: "border-box"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 423
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["j" /* Button */], {
              label: "Request a service",
              fullWidth: true,
              styleName: "red",
              href: this.generateBookServiceHref(), __source: {
                fileName: _jsxFileName,
                lineNumber: 429
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                textAlign: "center",
                padding: "0.5em",
                boxSizing: "border-box"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 435
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["j" /* Button */], {
              label: "Find a dealer",
              fullWidth: true,
              styleName: "blackOutlined",
              href: this.props.dealerSearchUrl, __source: {
                fileName: _jsxFileName,
                lineNumber: 441
              }
            })
          )
        ),
        this.props.termsAndConditions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { backgroundColor: "white", padding: "1.5em 0 2em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 449
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { maxWidth: "70em", margin: "auto" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 450
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers__["k" /* ExpandableInfo */], {
              color: "rgb(170, 170, 170)",
              mainText: "* Read full terms and conditions",
              description: this.props.termsAndConditions, __source: {
                fileName: _jsxFileName,
                lineNumber: 451
              }
            })
          )
        )
      )
    );
  };

  return ServiceCalculatorOwner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ServiceCalculatorOwner.propTypes = {
  endpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  errorMessageNOTFOUND: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  errorMessageMULTIPLERESULTS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  termsAndConditions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  serviceBookingUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dealerSearchUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  factoryCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ServiceCalculatorOwner.defaultProps = {
  endpoint: "/api/ownerserviceschedule?vinRego=",
  errorMessageNOTFOUND: __WEBPACK_IMPORTED_MODULE_6_constants_errors__["h" /* SERVICE_SCHEDULE_ERRORS */].NOTFOUND,
  errorMessageMULTIPLERESULTS: __WEBPACK_IMPORTED_MODULE_6_constants_errors__["h" /* SERVICE_SCHEDULE_ERRORS */].MULTIPLERESULTS
};
ServiceCalculatorOwner.displayName = "ServiceCalculatorOwner";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_8_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_8_higher_order_components__["g" /* SearchParams */])({ exposeParams: ["factoryCode", "VIN", "asmc"] }))(ServiceCalculatorOwner));

var breakpoint1 = "@media (min-width: " + __WEBPACK_IMPORTED_MODULE_7_constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */] + "px)";

var styles = {
  container: (_container = {
    backgroundColor: "#f5f5f5",
    paddingTop: "3em"
  }, _container[breakpoint1] = {
    paddingTop: "5.5em"
  }, _container),
  textCenter: {
    textAlign: "center",
    fontWeight: 200,
    padding: ".6em 1em 1em 1em"
  },
  error: {
    textAlign: "center",
    fontWeight: 200,
    color: "#910A2D",
    padding: "1em",
    margin: "1em auto",
    lineHeight: 1.8
  },
  mainCTAButtons: (_mainCTAButtons = {
    boxSizing: "border-box",
    display: "flex",
    backgroundColor: "white",
    justifyContent: "center",
    flexDirection: "column"
  }, _mainCTAButtons[breakpoint1] = {
    flexDirection: "row"
  }, _mainCTAButtons),
  mainCTAButtonsFiller: (_mainCTAButtonsFiller = {
    display: "none"
  }, _mainCTAButtonsFiller[breakpoint1] = {
    flexGrow: 1,
    display: "block"
  }, _mainCTAButtonsFiller),
  regoInput: (_regoInput = {
    width: "100%",
    margin: "auto",
    display: "flex",
    flexDirection: "column"
  }, _regoInput[breakpoint1] = {
    flexDirection: "row",
    maxWidth: "30em",
    alignItems: "center"
  }, _regoInput),
  popup: {
    position: "fixed",
    left: "0px",
    right: "0px",
    bottom: "0px",
    top: "0px",
    padding: "2em",
    backgroundColor: "#e5e6e9",
    zIndex: "100"
  },
  popupCloseButton: {
    width: "100%",
    height: "2em",
    padding: "0em",
    backgroundImage: "url(" + __WEBPACK_IMPORTED_MODULE_14__close_svg___default.a + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center right",
    cursor: "pointer",
    ":hover": {
      opacity: ".5"
    }
  },
  changeVinRego: {
    fontWeight: 600,
    letterSpacing: 1.8,
    color: "#aaaaaa",
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: "81%",
    textTransform: "uppercase",
    padding: "1em 1em 3em"
  },
  changeVinRegoDesktop: (_changeVinRegoDesktop = {}, _changeVinRegoDesktop[breakpoint1] = {
    display: "block"
  }, _changeVinRegoDesktop.display = "none", _changeVinRegoDesktop),
  changeVinRegoMobile: (_changeVinRegoMobile = {}, _changeVinRegoMobile[breakpoint1] = {
    display: "none"
  }, _changeVinRegoMobile.display = "block", _changeVinRegoMobile)
};

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isProperty(str) {
  return /^[$A-Z\_a-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc][$A-Z\_a-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc0-9\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u0669\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u06f0-\u06f9\u0711\u0730-\u074a\u07a6-\u07b0\u07c0-\u07c9\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u09e6-\u09ef\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0e50-\u0e59\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1040-\u1049\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b4-\u17d3\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u18a9\u1920-\u192b\u1930-\u193b\u1946-\u194f\u19b0-\u19c0\u19c8\u19c9\u19d0-\u19d9\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b00-\u1b04\u1b34-\u1b44\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1bad\u1bb0-\u1bb9\u1be6-\u1bf3\u1c24-\u1c37\u1c40-\u1c49\u1c50-\u1c59\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf2-\u1cf4\u1dc0-\u1de6\u1dfc-\u1dff\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua620-\ua629\ua66f\ua674-\ua67d\ua69f\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua880\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8e0-\ua8f1\ua900-\ua909\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\ua9d0-\ua9d9\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa50-\uaa59\uaa7b\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uaaeb-\uaaef\uaaf5\uaaf6\uabe3-\uabea\uabec\uabed\uabf0-\uabf9\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f]*$/.test(str)
}
module.exports = isProperty

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_portal__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_history__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apis_expose_global__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__close_svg__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__spinner_svg__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__spinner_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__spinner_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\service-calculator-prospect\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var ServiceCalculatorProspect = function (_Component) {
  _inherits(ServiceCalculatorProspect, _Component);

  function ServiceCalculatorProspect(props) {
    _classCallCheck(this, ServiceCalculatorProspect);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      displaySpinner: false,
      serviceItems: null,
      selection: null,
      prevSelection: null,
      isUpdatingFilters: false
    };

    _this.handleFilterSubmit = function (serviceCode, selection) {
      _this.fetchService(serviceCode, selection);
    };

    // If user click on "Edit Selection" button, reset the state of the component
    _this.handleEditSelection = function () {
      _this.setState({
        displaySpinner: false,
        serviceItems: null,
        selection: null,
        prevSelection: null,
        isUpdatingFilters: true
      });
    };

    _this.cancelFilterEdit = function () {
      _this.setState({ isUpdatingFilters: false });
    };

    _this.fetchService = function (modelCode, selection) {
      _this.setState({
        selection: selection,
        prevSelection: selection,
        displaySpinner: true,
        isUpdatingFilters: false
      });
      var url = '' + _this.props.endpoint + modelCode;
      var options = {
        method: 'GET',
        headers: {
          'content-type': 'application/json'
        }
      };

      fetch(url, options).then(function (response) {
        if (response.status !== 200) {
          throw new Error('Unfortunately the service is unavailable. Please try again later (Status ' + response.status + ').');
        }
        return response.json();
      }).then(function (json) {
        if (json.errorCode || json.errorCode === 0) {
          throw new Error('Failed with errorCode ' + json.errorCode);
        } else if (json.errorMessage) {
          throw new Error('Failed with errorMessage ' + json.errorMessage);
        }

        return json;
      }).then(function (allServiceItems) {
        // Only get the first five 'Scheduled Maintenance' and first two 'Additional Scheduled Maintenance' items
        var displayItems = [];
        var smCount = 0;
        var asmCount = 0;
        allServiceItems.serviceItems.forEach(function (item, index) {
          if (item.factoryCodeEntity.type === 'Scheduled Maintenance') {
            smCount += 1;
            if (smCount < 6) {
              displayItems.push(item);
            }
          } else {
            asmCount += 1;
            if (asmCount < 3) displayItems.push(item);
          }
        });
        allServiceItems.serviceItems = displayItems;
        _this.setState({
          serviceItems: allServiceItems,
          displaySpinner: false
        });
      }).catch(function (error) {
        _this.setState({ displaySpinner: false });
        console.warn('URL: ' + url, error);
      });
    };
    return _this;
  }

  ServiceCalculatorProspect.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!__WEBPACK_IMPORTED_MODULE_4_constants_environment__["c" /* IS_BROWSER */]) return;
    Object(__WEBPACK_IMPORTED_MODULE_7_apis_expose_global__["a" /* default */])('getCurrentFormFields', function () {
      return _this2.state.currentSelection;
    });
    var readUrl = function readUrl(url) {
      var search = new window.URL(url.pathname + url.search, window.location).searchParams;
      var model = search.get('model');
      var body = search.get('body');
      var grade = search.get('grade');
      var engine = search.get('engine');
      var newSelection = [model, body, grade, engine];
      if (search || model || body || grade || engine) {
        _this2.setState({
          isUpdatingFilters: !!_this2.state.prevSelection,
          currentSelection: newSelection,
          prevSelection: _this2.state.selection
        }, function () {
          var selection = _this2.filterComponent.getSelection();
          var newModelCode = selection.modelCode;
          if (newModelCode) {
            _this2.fetchService(selection.modelCode, selection.selection);
          }
        });
      }
    };
    readUrl(window.location);
    this.unlistenHistory = __WEBPACK_IMPORTED_MODULE_3_utils_history__["b" /* history */].listen(function (url) {
      readUrl(url);
    });
  };

  ServiceCalculatorProspect.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlistenHistory();
  };

  ServiceCalculatorProspect.prototype.pushUrl = function pushUrl() {
    if (!this.state.currentSelection || !__WEBPACK_IMPORTED_MODULE_4_constants_environment__["c" /* IS_BROWSER */]) return;
    this.props.search.pushParam({
      model: this.state.currentSelection[0],
      body: this.state.currentSelection[1],
      grade: this.state.currentSelection[2],
      engine: this.state.currentSelection[3],
      modelCode: this.state.currentSelection[4]
    });
  };

  ServiceCalculatorProspect.prototype.renderMainFilter = function renderMainFilter() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers__["S" /* ServiceCalculatorFilter */], {
      ref: function ref(comp) {
        _this3.filterComponent = comp;
      },
      key: 'serviceCalcFilterMain',
      vehiclesData: this.props.data,
      onSubmit: this.handleFilterSubmit,
      ctaLabel: this.state.isUpdatingFilters ? 'Update' : 'Submit',
      selection: this.state.currentSelection,
      onChange: function onChange(modelCode, selection) {
        _this3.setState({
          modelCode: modelCode,
          currentSelection: selection
        }, function () {
          return _this3.pushUrl();
        });
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 165
      }
    });
  };

  ServiceCalculatorProspect.prototype.renderFilter = function renderFilter(compact) {
    return compact ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 187
        }
      },
      this.renderMainFilter(),
      this.state.isUpdatingFilters && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_portal__["a" /* Portal */],
        { key: 'serviceCalcFilterEdit', __source: {
            fileName: _jsxFileName,
            lineNumber: 190
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.popup, __source: {
              fileName: _jsxFileName,
              lineNumber: 191
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.popupCloseButton, onClick: this.cancelFilterEdit, __source: {
              fileName: _jsxFileName,
              lineNumber: 192
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers__["s" /* HeadingBlock */], { value: 'Not part of the family yet?', textAlign: 'center', __source: {
              fileName: _jsxFileName,
              lineNumber: 193
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers__["s" /* HeadingBlock */], {
            tag: 'h6',
            textAlign: 'center',
            value: 'Update your selection to get a new set of servicing costs', __source: {
              fileName: _jsxFileName,
              lineNumber: 194
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers__["S" /* ServiceCalculatorFilter */], {
            vehiclesData: this.props.data,
            onSubmit: this.handleFilterSubmit,
            selection: this.state.prevSelection,
            ctaLabel: 'Update', __source: {
              fileName: _jsxFileName,
              lineNumber: 198
            }
          })
        )
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.filterContainerLarge, __source: {
          fileName: _jsxFileName,
          lineNumber: 208
        }
      },
      this.renderMainFilter()
    );
  };

  ServiceCalculatorProspect.prototype.render = function render() {
    var compact = this.props.compact;
    var _state = this.state,
        selection = _state.selection,
        displaySpinner = _state.displaySpinner,
        serviceItems = _state.serviceItems,
        isUpdatingFilters = _state.isUpdatingFilters;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 218
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["_8" /* Section */],
        { padding: true, backgroundColor: '#f5f5f5', __source: {
            fileName: _jsxFileName,
            lineNumber: 219
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 220
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers__["s" /* HeadingBlock */], {
            tag: 'h4',
            margin: false,
            value: selection ? 'Your service summary' : this.props.name ? this.props.name : 'Mazda service calculator',
            textAlign: 'center', __source: {
              fileName: _jsxFileName,
              lineNumber: 221
            }
          }),
          selection ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.textCenter, __source: {
                fileName: _jsxFileName,
                lineNumber: 231
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { lineHeight: 2 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 232
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'b',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 233
                  }
                },
                'Currently viewing:'
              ),
              ' ',
              selection.join(' ')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { lineHeight: 1.8 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 235
                }
              },
              'The total service price is the Base Scheduled Maintenance, plus any Additional Scheduled Maintenance items that are required.'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.textCenter, __source: {
                fileName: _jsxFileName,
                lineNumber: 241
              }
            },
            this.props.description
          ),
          (isUpdatingFilters || !selection) && this.renderFilter(compact),
          selection && !isUpdatingFilters && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.ctaButton, __source: {
                fileName: _jsxFileName,
                lineNumber: 246
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["e" /* Button */], {
              styleName: 'black',
              label: 'Edit selection',
              onClick: this.handleEditSelection,
              disabled: displaySpinner, __source: {
                fileName: _jsxFileName,
                lineNumber: 247
              }
            })
          ),
          displaySpinner && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.spinnerContainer, __source: {
                fileName: _jsxFileName,
                lineNumber: 255
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_10__spinner_svg___default.a, style: styles.spinnerGraphic, __source: {
                fileName: _jsxFileName,
                lineNumber: 256
              }
            })
          )
        )
      ),
      serviceItems && !isUpdatingFilters && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["_8" /* Section */],
        { padding: true, backgroundColor: '#ffffff', __source: {
            fileName: _jsxFileName,
            lineNumber: 263
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers__["T" /* ServiceDetails */], { data: this.state.serviceItems, __source: {
            fileName: _jsxFileName,
            lineNumber: 264
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { backgroundColor: 'white', paddingTop: '2em' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 265
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { maxWidth: '70em', margin: 'auto' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 266
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers__["k" /* ExpandableInfo */], {
              color: '#cccccc',
              mainText: 'Read full terms and conditions',
              description: this.props.termsAndConditions, __source: {
                fileName: _jsxFileName,
                lineNumber: 267
              }
            })
          )
        )
      )
    );
  };

  return ServiceCalculatorProspect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ServiceCalculatorProspect.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  endpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  termsAndConditions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.obj,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ServiceCalculatorProspect.defaultProps = {
  endpoint: '/api/prospectserviceschedule?modelCode=',
  description: 'Take the guesswork out of service pricing. Use the service schedule guide below to view current service details and pricing'
};
ServiceCalculatorProspect.displayName = 'ServiceCalculatorProspect';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["g" /* SearchParams */])())(ServiceCalculatorProspect));

var styles = {
  textCenter: {
    paddingTop: '1.2em',
    textAlign: 'center',
    fontWeight: 200
  },
  filterContainerLarge: {
    transition: 'max-height 1s cubic-bezier(0.99, 0.03, 1, 1)',
    maxHeight: '1000px',
    display: 'block'
  },
  ctaButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '1em'
  },
  popup: {
    position: 'fixed',
    boxSizing: 'border-box',
    left: '0px',
    right: '0px',
    bottom: '0px',
    top: '0px',
    padding: '2em',
    backgroundColor: '#e5e6e9',
    zIndex: '100',
    overflow: 'auto'
  },
  popupCloseButton: {
    width: '100%',
    height: '2em',
    padding: '0em',
    backgroundImage: 'url(' + __WEBPACK_IMPORTED_MODULE_9__close_svg___default.a + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center right',
    cursor: 'pointer',
    ':hover': {
      opacity: '.5'
    }
  },
  spinnerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '1em'
  },
  spinnerGraphic: {
    width: '5vw',
    height: '5vw',
    margin: '5em'
  }
};

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SocialIcons_less__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SocialIcons_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SocialIcons_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\SocialIcons\\SocialIcons.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SocialIcons = function (_React$PureComponent) {
  _inherits(SocialIcons, _React$PureComponent);

  function SocialIcons() {
    var _temp, _this, _ret;

    _classCallCheck(this, SocialIcons);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handleOnClick = function (platform) {
      var gtm = _this.props.gtm;

      // Delay for firing GTM before redirection
      // Call GTM with the gtm object or default to Footer

      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
        pageCategory: gtm && gtm.category ? gtm.category : "Footer Nav",
        pageAction: gtm && gtm.action ? gtm.action : "Footer - Clicked \"" + platform.toUpperCase() + "\""
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SocialIcons.prototype.render = function render() {
    var _classnames,
        _this2 = this;

    var _props$platforms = this.props.platforms,
        platforms = _props$platforms === undefined ? [] : _props$platforms;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_4__SocialIcons_less___default.a.SocialIcons] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "ul",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        },
        platforms.map(function (platform) {
          var Icon = null;
          if (platform.name === 'facebook') Icon = __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["w" /* FacebookIcon */];
          if (platform.name === 'instagram') Icon = __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["T" /* InstagramIcon */];
          if (platform.name === 'twitter') Icon = __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_19" /* TwitterIcon */];
          if (platform.name === 'youtube') Icon = __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_23" /* YoutubeIcon */];
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { key: platform.name, __source: {
                fileName: _jsxFileName,
                lineNumber: 41
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
              {
                styleName: "grey",
                onClick: function onClick() {
                  return _this2._handleOnClick(platform.name);
                },
                href: platform.href,
                external: true,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 42
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 48
                }
              })
            )
          );
        })
      )
    );
  };

  return SocialIcons;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

SocialIcons.displayName = "SocialIcons";


/* harmony default export */ __webpack_exports__["a"] = (SocialIcons);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Spotlight_less__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Spotlight_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Spotlight_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Spotlight\\Spotlight.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Spotlight = function (_React$PureComponent) {
  _inherits(Spotlight, _React$PureComponent);

  function Spotlight() {
    var _temp, _this, _ret;

    _classCallCheck(this, Spotlight);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handleDevice = function (event) {
      // beta === 90 means vertically in center and More means up and less means down
      // gamma === 0 means horizontally in center

      var height = _this.spotlight.clientHeight;
      var width = _this.spotlight.clientWidth;

      var newX = width / 2;
      var newY = height / 2;

      newY = height / 2 + Math.round(event.beta) * (height / 2) / 180 - 90;
      newX = width / 2 + Math.round(event.gamma) * (width / 2) / 90;

      _this.spotlightShadow.style.backgroundImage = "radial-gradient(circle at " + newX + "px " + newY + "px, transparent 20%, rgba(0,0,0,.96) 30%)";
    }, _this._handleOnMouseMove = function (event) {
      var x = event.pageX - _this.spotlight.offsetLeft;
      var y = event.pageY - _this.spotlight.offsetTop;
      _this.spotlightShadow.style.backgroundImage = "radial-gradient(circle at " + x + "px " + y + "px, transparent 20%, rgba(0,0,0,.96) 30%)";
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Spotlight.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      if (__WEBPACK_IMPORTED_MODULE_2_constants_environment__["i" /* WINDOW */].DeviceOrientationEvent) {
        __WEBPACK_IMPORTED_MODULE_2_constants_environment__["i" /* WINDOW */].addEventListener("deviceorientation", _this2._handleDevice);
      }
    }, 100);
  };

  Spotlight.prototype.render = function render() {
    var _this3 = this,
        _classnames,
        _classnames2,
        _classnames3;

    var _props = this.props,
        components = _props.components,
        children = _props.children,
        heading = _props.heading,
        description = _props.description;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        ref: function ref(c) {
          return _this3.spotlight = c;
        },
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5__Spotlight_less___default.a.Spotlight] = true, _classnames)),
        onMouseMove: this._handleOnMouseMove,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44
        }
      },
      heading && description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_5__Spotlight_less___default.a.SpotlightHeroContent] = true, _classnames2)),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 52
          }
        },
        heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["z" /* H2 */],
          { white: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 58
            }
          },
          heading
        ),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
          { white: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 63
            }
          },
          description
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        ref: function ref(c) {
          return _this3.spotlightShadow = c;
        },
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_5__Spotlight_less___default.a.SpotlightShadow] = true, _classnames3)),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69
        }
      }),
      Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__["a" /* default */])(components) || children
    );
  };

  return Spotlight;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Spotlight.displayName = "Spotlight";


/* harmony default export */ __webpack_exports__["a"] = (Spotlight);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StickySection_less__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StickySection_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StickySection_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_debounce__ = __webpack_require__(47);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\StickySection\\StickySection.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var StickySection = function (_React$PureComponent) {
  _inherits(StickySection, _React$PureComponent);

  function StickySection(props) {
    _classCallCheck(this, StickySection);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._checkOffset = function () {
      if (_this.stickySectionParent) {
        if (_this.stickySectionParent.offsetTop + _this.stickySection.offsetHeight / 2 < __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_environment__["i" /* WINDOW */].scrollY) {
          _this.stickySectionParent.style.height = _this.stickySection.offsetHeight + "px";
          _this.setState({
            fixed: true
          });
        } else {
          _this.setState({
            fixed: false
          });
        }
      }
    };

    _this.state = {
      fixed: false
    };
    return _this;
  }

  StickySection.prototype.componentDidMount = function componentDidMount() {
    this._checkOffset();
    __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_debounce__["a" /* default */])(this._checkOffset, 0), {
      passive: true
    });
  };

  StickySection.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_debounce__["a" /* default */])(this._checkOffset, 0), {
      passive: true
    });
  };

  StickySection.prototype.render = function render() {
    var _classnames,
        _this2 = this,
        _classnames2;

    var _props = this.props,
        _props$components = _props.components,
        components = _props$components === undefined ? [] : _props$components,
        _props$alwaysOnTop = _props.alwaysOnTop,
        alwaysOnTop = _props$alwaysOnTop === undefined ? false : _props$alwaysOnTop,
        children = _props.children;
    var fixed = this.state.fixed;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__StickySection_less___default.a.StickySectionParent] = true, _classnames)),
        ref: function ref(c) {
          return _this2.stickySectionParent = c;
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 48
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          ref: function ref(c) {
            return _this2.stickySection = c;
          },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__StickySection_less___default.a.StickySection] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_2__StickySection_less___default.a.StickySectionTop] = alwaysOnTop, _classnames2[__WEBPACK_IMPORTED_MODULE_2__StickySection_less___default.a.StickySectionFixed] = fixed, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 53
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__["a" /* default */])(components, this.props) || children
      )
    );
  };

  return StickySection;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

StickySection.displayName = "StickySection";


/* harmony default export */ __webpack_exports__["a"] = (StickySection);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Testimonial_less__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Testimonial_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Testimonial_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Testimonial\\Testimonial.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Testimonial = function (_React$PureComponent) {
  _inherits(Testimonial, _React$PureComponent);

  function Testimonial() {
    _classCallCheck(this, Testimonial);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Testimonial.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4;

    var _props = this.props,
        citizenName = _props.citizenName,
        citizenImageUrl = _props.citizenImageUrl,
        product = _props.product,
        productImageUrl = _props.productImageUrl,
        options = _props.options;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__Testimonial_less___default.a.Testimonial] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__Testimonial_less___default.a.TestimonialColumns] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__Testimonial_less___default.a.TestimonialColumn] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_3__Testimonial_less___default.a.TestimonialColumnWhite] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 16
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: citizenImageUrl, __source: {
              fileName: _jsxFileName,
              lineNumber: 20
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["D" /* H6 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 21
              }
            },
            citizenName
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__Testimonial_less___default.a.TestimonialColumn] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 23
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
            { withoutMargin: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 26
              }
            },
            product
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: productImageUrl + '?width=240', __source: {
              fileName: _jsxFileName,
              lineNumber: 27
            }
          })
        ),
        options && options.length && options.map(function (option, index) {
          var _classnames5, _classnames6;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_3__Testimonial_less___default.a.TestimonialColumn] = true, _classnames5)), __source: {
                fileName: _jsxFileName,
                lineNumber: 33
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
              { withoutMargin: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 36
                }
              },
              option.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_3__Testimonial_less___default.a.TestimonialColumnValue] = true, _classnames6)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 37
                }
              },
              index === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["z" /* H2 */],
                { withDetails: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 40
                  }
                },
                option.value
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["C" /* H5 */],
                { withDetails: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 40
                  }
                },
                option.value
              )
            )
          );
        })
      )
    );
  };

  return Testimonial;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Testimonial.displayName = "Testimonial";


/* harmony default export */ __webpack_exports__["a"] = (Testimonial);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__slick_css__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__slick_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\video-slideshow\\index.jsx';

var _templateObject = _taggedTemplateLiteralLoose(['\n    ', '\n  '], ['\n    ', '\n  ']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }











if (undefined && undefined === 'dingo') {
  Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["b" /* injectGlobal */])(_templateObject, __WEBPACK_IMPORTED_MODULE_8__slick_css___default.a);
} else {
  __webpack_require__(587);
}

var VideoSlideshow = function (_Component) {
  _inherits(VideoSlideshow, _Component);

  function VideoSlideshow() {
    _classCallCheck(this, VideoSlideshow);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.resetAndPlayAll = function () {
      _this.videoElements.forEach(function (video) {
        if (video) {
          video.currentTime = 0;
          video.play();
        }
      });
    };

    _this.videoElements = [];
    return _this;
  }

  VideoSlideshow.prototype.next = function next() {
    this._slider.slickNext();
  };

  VideoSlideshow.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        _props$videos = _props.videos,
        videos = _props$videos === undefined ? [] : _props$videos,
        heading = _props.heading,
        preHeading = _props.preHeading,
        content = _props.content,
        annotation = _props.annotation,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? 'CHOOSE YOUR PLACE' : _props$buttonText,
        _props$autoAdvance = _props.autoAdvance,
        autoAdvance = _props$autoAdvance === undefined ? true : _props$autoAdvance;


    var settings = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      swipeToSlide: false,
      fade: true,
      useCSS: true,
      speed: 500,
      cssEase: 'linear',
      draggable: false,
      slidesToScroll: 1
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.base(this.props.compact), 'data-test': 'slideshow', __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.content(this.props.compact), __source: {
            fileName: _jsxFileName,
            lineNumber: 63
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: {
              maxWidth: '60em',
              margin: '0 auto',
              textShadow: '0 0px 150px #000000'
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 64
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["s" /* HeadingBlock */], {
            preHeading: preHeading,
            value: heading,
            applyTopMargin: false,
            tag: 'h1',
            margin: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          }),
          content && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_25" /* WysiwygContent */], {
            theme: 'dark',
            style: { color: '#FFF' },
            xmlString: content, __source: {
              fileName: _jsxFileName,
              lineNumber: 75
            }
          }),
          annotation && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 80
              }
            },
            annotation
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            position: 'relative',
            zIndex: 1
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 84
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_slick___default.a,
          _extends({
            swipe: false,
            ref: function ref(element) {
              _this2._slider = element;
            }
          }, settings, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 90
            }
          }),
          videos && videos.map(function (video, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, style: styles.slideItem, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 98
                }
              },
              video && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_22" /* VideoBackground */], {
                onEnded: function onEnded() {
                  if (index === 0) _this2.resetAndPlayAll();
                  autoAdvance && _this2.next();
                },
                getVideoRef: function getVideoRef(element) {
                  _this2.videoElements[index] = element;
                },
                index: index,
                poster: _this2.props.compact ? video.mobileBackgroundImage || video.backgroundImage : video.backgroundImage,
                loop: false // Dont loop videos. We will trigger play manually
                , src: _this2.props.compact ? '' : video.videoSrc, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 99
                }
              })
            );
          })
        )
      ),
      buttonText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.buttom(this.props.compact), __source: {
            fileName: _jsxFileName,
            lineNumber: 114
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: {
              maxWidth: '60em',
              margin: '0 auto',
              display: 'flex',
              justifyContent: 'center'
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 115
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["e" /* Button */], {
            onClick: function onClick() {
              _this2.next();
            },
            styleName: 'white',
            label: buttonText, __source: {
              fileName: _jsxFileName,
              lineNumber: 121
            }
          })
        )
      )
    );
  };

  return VideoSlideshow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

VideoSlideshow.displayName = 'VideoSlideshow';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["b" /* DetectCompact */])())(VideoSlideshow));

var styles = {
  base: function base(compact) {
    return {
      color: '#FFF',
      textAlign: 'center',
      backgroundColor: compact ? __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__["a" /* default */].BLACK : 'none',
      position: 'relative',
      padding: compact ? '3em 0' : 'initial'
    };
  },
  content: function content(compact) {
    return {
      position: compact ? 'relative' : 'absolute',
      top: compact ? '0.5em' : '5em',
      zIndex: 2,
      width: '100%',
      padding: '0 2em',
      boxSizing: 'border-box'
    };
  },
  buttom: function buttom(compact) {
    return {
      position: compact ? 'relative' : 'absolute',
      bottom: compact ? '0' : '2em',
      width: '100%',
      zIndex: 2
    };
  },
  slideItem: {
    minHeight: '50vw',
    zIndex: 11,
    position: 'relative'
  }
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1304);

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _objectAssign = __webpack_require__(53);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error('Keys Missing', spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);

  var trackWidth, trackHeight;

  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    if (spec.variableWidth) {
      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
    } else if (spec.centerMode) {
      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
    } else {
      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
    }
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
    transition: '',
    WebkitTransition: '',
    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
  };

  if (trackWidth) {
    (0, _objectAssign2.default)(style, { width: trackWidth });
  }

  if (trackHeight) {
    (0, _objectAssign2.default)(style, { height: trackHeight });
  }

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + 'px';
    } else {
      style.marginTop = spec.left + 'px';
    }
  }

  return style;
};

var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);

  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
  return style;
};

var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {

  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);

  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (spec.fade) {
    return 0;
  }

  if (spec.infinite) {
    if (spec.slideCount >= spec.slidesToShow) {
      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
    }
    if (spec.slideCount % spec.slidesToScroll !== 0) {
      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
        if (spec.slideIndex > spec.slideCount) {
          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
        } else {
          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
        }
      }
    }
  } else {

    if (spec.slideCount % spec.slidesToScroll !== 0) {
      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
        slideOffset = slidesToOffset * spec.slideWidth;
      }
    }
  }

  if (spec.centerMode) {
    if (spec.infinite) {
      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
    } else {
      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
    }
  }

  if (!spec.vertical) {
    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
  } else {
    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
  }

  if (spec.variableWidth === true) {
    var targetSlideIndex;
    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
    } else {
      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
    }
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (spec.centerMode === true) {
      if (spec.infinite === false) {
        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
      } else {
        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
      }

      if (targetSlide) {
        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
      }
    }
  }

  return targetLeft;
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
    className: '',
    accessibility: true,
    adaptiveHeight: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    centerMode: false,
    centerPadding: '50px',
    cssEase: 'ease',
    customPaging: function customPaging(i) {
        return _react2.default.createElement(
            'button',
            null,
            i + 1
        );
    },
    dots: false,
    dotsClass: 'slick-dots',
    draggable: true,
    easing: 'linear',
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: false,
    pauseOnHover: true,
    responsive: null,
    rtl: false,
    slide: 'div',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    swipe: true,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true,
    afterChange: null,
    beforeChange: null,
    edgeEvent: null,
    init: null,
    swipeEvent: null,
    // nextArrow, prevArrow are react componets
    nextArrow: null,
    prevArrow: null
};

module.exports = defaultProps;

/***/ }),
/* 586 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"slick-initialized":"slick-initialized","slick-slide":"slick-slide","slick-active":"slick-active","slick-slider":"slick-slider","slick-track":"slick-track"};

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_less__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Content_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Content\\Content.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Content = function (_React$PureComponent) {
  _inherits(Content, _React$PureComponent);

  function Content() {
    var _temp, _this, _ret;

    _classCallCheck(this, Content);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handleOnClick = function () {
      var _this$props$onClick = _this.props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick;

      onClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Content.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        xmlString = _props.xmlString,
        replaceVariables = _props.replaceVariables,
        textAlign = _props.textAlign,
        textAlignMobile = _props.textAlignMobile,
        theme = _props.theme;


    var content = replaceVariables ? Object.entries(replaceVariables).reduce(function (string, _ref) {
      var key = _ref[0],
          value = _ref[1];
      return string.replace("$" + key + "$", value || "");
    }, xmlString) : xmlString;

    if (content && (content.indexOf('white;') > -1 || content.indexOf('#ffffff') > -1 || content.indexOf('#fff') > -1 || content.indexOf('#FFFFFF') > -1 || content.indexOf('#e7e7e7') > -1)) {
      theme = 'dark';
    }

    if (content) content.replace("/<p>&nbsp;</p>/g", '');

    if (content && content.indexOf('#000000') > -1) {
      theme = 'light';
      content = content.replace('#000000', '#101010');
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Content_less___default.a.Content] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Content_less___default.a.ContentLeft] = textAlign == "left", _classnames[__WEBPACK_IMPORTED_MODULE_2__Content_less___default.a.ContentRight] = textAlign == "right", _classnames[__WEBPACK_IMPORTED_MODULE_2__Content_less___default.a.ContentMobileCenter] = textAlignMobile == "center", _classnames[__WEBPACK_IMPORTED_MODULE_2__Content_less___default.a.ContentMobileLeft] = textAlignMobile == "left", _classnames[__WEBPACK_IMPORTED_MODULE_2__Content_less___default.a.ContentMobileRight] = textAlignMobile == "right", _classnames[__WEBPACK_IMPORTED_MODULE_2__Content_less___default.a.ContentDark] = theme === 'dark', _classnames)),
        "data-test": "wysiwyg",
        dangerouslySetInnerHTML: children ? undefined : { __html: content }, __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      },
      children
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Content.displayName = "Content";


/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ButtonIcon_less__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ButtonIcon_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ButtonIcon_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__ = __webpack_require__(33);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\ButtonIcon\\ButtonIcon.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ButtonIcon = function (_React$PureComponent) {
  _inherits(ButtonIcon, _React$PureComponent);

  function ButtonIcon() {
    var _temp, _this, _ret;

    _classCallCheck(this, ButtonIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handleOnClick = function () {
      var _this$props = _this.props,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick,
          external = _this$props.external,
          href = _this$props.href,
          disabled = _this$props.disabled,
          gtm = _this$props.gtm;

      onClick();

      // Delay for firing GTM before redirection
      // Call GTM if we have an gtm object
      if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: gtm.category,
          pageAction: gtm.action
        });
      }
      if (external && href && !disabled) {
        setTimeout(function () {
          new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__["a" /* default */](href).newTab();
        }, 200);
      } else if (href && !disabled) {
        setTimeout(function () {
          new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__["a" /* default */](href).redirect();
        }, 200);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ButtonIcon.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? '' : _props$styleName;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__ButtonIcon_less___default.a.ButtonIcon] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__ButtonIcon_less___default.a.ButtonSquareWhite] = styleName === 'SquareWhite', _classnames[__WEBPACK_IMPORTED_MODULE_2__ButtonIcon_less___default.a.ButtonWhiteColor] = styleName === 'whiteColor', _classnames)),
        onClick: this._handleOnClick, __source: {
          fileName: _jsxFileName,
          lineNumber: 33
        }
      },
      children
    );
  };

  return ButtonIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

ButtonIcon.displayName = 'ButtonIcon';


/* harmony default export */ __webpack_exports__["a"] = (ButtonIcon);

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InputCheckBox":"InputCheckBox__InputCheckBox___2Orfn","InputCheckBoxInput":"InputCheckBox__InputCheckBoxInput___RPHWY","LabelCheckBox":"InputCheckBox__LabelCheckBox___3D2nQ","LabelCheckBoxWithValue":"InputCheckBox__LabelCheckBoxWithValue___1sHGU","Label":"InputCheckBox__Label___1JVQL","requiredStar":"InputCheckBox__requiredStar___2ikv1","message":"InputCheckBox__message___3vA_B","messageShow":"InputCheckBox__messageShow___3wT7Z","InputCheckBoxLarge":"InputCheckBox__InputCheckBoxLarge___PJdIb"};

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\CrossIcon.jsx";


var CrossIcon = function CrossIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 31 31", fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M 31 1.4 L 29.6 0 L 15.5 14.1 L 1.4 0 L 0 1.4 l 14.1 14.1 L 0 29.6 L 1.4 31 l 14.1 -14.1 L 29.6 31 l 1.4 -1.4 l -14.1 -14.1 Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

CrossIcon.displayName = "CrossIcon";
CrossIcon.displayName = "CrossIcon";
/* harmony default export */ __webpack_exports__["a"] = (CrossIcon);

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1355);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(81) && !__webpack_require__(124)(function () {
  return Object.defineProperty(__webpack_require__(595)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
var document = __webpack_require__(72).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(106);
var toIObject = __webpack_require__(125);
var arrayIndexOf = __webpack_require__(1359)(false);
var IE_PROTO = __webpack_require__(279)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(600);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1361);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1370);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(91);


/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(275);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(596);
var hiddenKeys = __webpack_require__(281).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(192);
var createDesc = __webpack_require__(188);
var toIObject = __webpack_require__(125);
var toPrimitive = __webpack_require__(273);
var has = __webpack_require__(106);
var IE8_DOM_DEFINE = __webpack_require__(594);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(81) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 606 */
/***/ (function(module, exports) {



/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1377);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1381);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(600);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(609);
var ITERATOR = __webpack_require__(62)('iterator');
var Iterators = __webpack_require__(143);
module.exports = __webpack_require__(61).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(275);
var TAG = __webpack_require__(62)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(91);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Label;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 * @param {Object} props
 * @param {InputRangeClassNames} props.classNames
 * @param {Function} props.formatLabel
 * @param {string} props.type
 */
function Label(props) {
  var labelValue = props.formatLabel ? props.formatLabel(props.children, props.type) : props.children;

  return _react2.default.createElement(
    'span',
    { className: props.classNames[props.type + 'Label'] },
    _react2.default.createElement(
      'span',
      { className: props.classNames.labelContainer },
      labelValue
    )
  );
}

/**
 * @type {Object}
 * @property {Function} children
 * @property {Function} classNames
 * @property {Function} formatLabel
 * @property {Function} type
 */
Label.propTypes = {
  children: _propTypes2.default.node.isRequired,
  classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
  formatLabel: _propTypes2.default.func,
  type: _propTypes2.default.string.isRequired
};
module.exports = exports['default'];
//# sourceMappingURL=label.js.map

/***/ }),
/* 614 */
/***/ (function(module, exports) {

(function(root) {
  var isOn = false;
  var scrollbarSize;
  var scrollTop;

  function getScrollbarSize() {
    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return scrollbarSize;
  }

  function hasScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
  }

  function on(options) {
    if (typeof document === 'undefined' || isOn) return;
    var doc = document.documentElement;
    scrollTop = window.pageYOffset;
    if (hasScrollbar()) {
      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = -scrollTop + 'px';
    doc.style.overflow = 'hidden';
    isOn = true;
  }

  function off() {
    if (typeof document === 'undefined' || !isOn) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, scrollTop);
    isOn = false;
  }

  function toggle() {
    if (isOn) {
      off();
      return;
    }
    on();
  }

  var noScroll = {
    on: on,
    off: off,
    toggle: toggle,
  };

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = noScroll;
  } else {
    root.noScroll = noScroll;
  }
})(this);


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Visible_less__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Visible_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Visible_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Visible\\Visible.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Visible = function (_React$PureComponent) {
  _inherits(Visible, _React$PureComponent);

  function Visible() {
    _classCallCheck(this, Visible);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Visible.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        _props$visible = _props.visible,
        visible = _props$visible === undefined ? ["screen", "tablet", "mobile"] : _props$visible;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Visible_less___default.a.Visible] = visible, _classnames[__WEBPACK_IMPORTED_MODULE_2__Visible_less___default.a.VisibleScreen] = visible.includes("screen"), _classnames[__WEBPACK_IMPORTED_MODULE_2__Visible_less___default.a.VisibleTablet] = visible.includes("tablet"), _classnames[__WEBPACK_IMPORTED_MODULE_2__Visible_less___default.a.VisibleMobile] = visible.includes("mobile"), _classnames)),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      },
      children
    );
  };

  return Visible;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Visible.displayName = "Visible";


/* harmony default export */ __webpack_exports__["a"] = (Visible);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\heading\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Heading = function (_React$Component) {
  _inherits(Heading, _React$Component);

  function Heading() {
    _classCallCheck(this, Heading);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Heading.prototype.render = function render() {
    var _props = this.props,
        _props$tag = _props.tag,
        tag = _props$tag === undefined ? 'h2' : _props$tag,
        value = _props.value,
        white = _props.white,
        withDetails = _props.withDetails,
        children = _props.children;


    var newValue = value || children;

    if (tag === 'h1') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["y" /* H1 */],
      _extends({ withDetails: withDetails, white: white }, this.props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      }),
      newValue
    );
    if (tag === 'h2') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["z" /* H2 */],
      _extends({ withDetails: withDetails, white: white }, this.props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      }),
      newValue
    );
    if (tag === 'h3') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["A" /* H3 */],
      _extends({ withDetails: withDetails, white: white }, this.props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 18
        }
      }),
      newValue
    );
    if (tag === 'h4') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["B" /* H4 */],
      _extends({ withDetails: withDetails, white: white }, this.props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 19
        }
      }),
      newValue
    );
    if (tag === 'h5') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["C" /* H5 */],
      _extends({ withDetails: withDetails, white: white }, this.props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      }),
      newValue
    );
    if (tag === 'h6') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["D" /* H6 */],
      _extends({ withDetails: withDetails, white: white }, this.props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      }),
      newValue
    );
  };

  return Heading;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Heading.displayName = 'Heading';

/* harmony default export */ __webpack_exports__["a"] = (Heading);

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = __webpack_require__(618);

var _omit2 = _interopRequireDefault(_omit);

var _shallowEqual = __webpack_require__(619);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// utils


var mainStyle = {
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  margin: 0,
  padding: 0,
  position: 'absolute'
};

var style = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  backgroundColor: 'transparent',
  position: 'absolute'
};

var GoogleMapMarkers = function (_Component) {
  _inherits(GoogleMapMarkers, _Component);

  /* eslint-disable react/forbid-prop-types */
  function GoogleMapMarkers(props) {
    _classCallCheck(this, GoogleMapMarkers);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._getState = function () {
      return {
        children: _this.props.dispatcher.getChildren(),
        updateCounter: _this.props.dispatcher.getUpdateCounter()
      };
    };

    _this._onChangeHandler = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var prevChildCount = (_this.state.children || []).length;
      var state = _this._getState();

      _this.setState(state, function () {
        return (state.children || []).length !== prevChildCount && _this._onMouseChangeHandler();
      });
    };

    _this._onChildClick = function () {
      if (_this.props.onChildClick) {
        if (_this.hoverChildProps_) {
          var hoverKey = _this.hoverKey_;
          var childProps = _this.hoverChildProps_;
          // click works only on hovered item
          _this.props.onChildClick(hoverKey, childProps);
        }
      }
    };

    _this._onChildMouseDown = function () {
      if (_this.props.onChildMouseDown) {
        if (_this.hoverChildProps_) {
          var hoverKey = _this.hoverKey_;
          var childProps = _this.hoverChildProps_;
          // works only on hovered item
          _this.props.onChildMouseDown(hoverKey, childProps);
        }
      }
    };

    _this._onChildMouseEnter = function (hoverKey, childProps) {
      if (!_this.dimensionsCache_) {
        return;
      }

      if (_this.props.onChildMouseEnter) {
        _this.props.onChildMouseEnter(hoverKey, childProps);
      }

      _this.hoverChildProps_ = childProps;
      _this.hoverKey_ = hoverKey;
      _this.setState({ hoverKey: hoverKey });
    };

    _this._onChildMouseLeave = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var hoverKey = _this.hoverKey_;
      var childProps = _this.hoverChildProps_;

      if (hoverKey !== undefined && hoverKey !== null) {
        if (_this.props.onChildMouseLeave) {
          _this.props.onChildMouseLeave(hoverKey, childProps);
        }

        _this.hoverKey_ = null;
        _this.hoverChildProps_ = null;
        _this.setState({ hoverKey: null });
      }
    };

    _this._onMouseAllow = function (value) {
      if (!value) {
        _this._onChildMouseLeave();
      }

      _this.allowMouse_ = value;
    };

    _this._onMouseChangeHandler = function () {
      if (_this.allowMouse_) {
        _this._onMouseChangeHandlerRaf();
      }
    };

    _this._onMouseChangeHandlerRaf = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var mp = _this.props.dispatcher.getMousePosition();

      if (mp) {
        var distances = [];
        var hoverDistance = _this.props.getHoverDistance();

        _react2.default.Children.forEach(_this.state.children, function (child, childIndex) {
          if (!child) return;
          // layers
          if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
            return;
          }

          var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
          var dist = _this.props.distanceToMouse(_this.dimensionsCache_[childKey], mp, child.props);
          if (dist < hoverDistance) {
            distances.push({
              key: childKey,
              dist: dist,
              props: child.props
            });
          }
        });

        if (distances.length) {
          distances.sort(function (a, b) {
            return a.dist - b.dist;
          });
          var hoverKey = distances[0].key;
          var childProps = distances[0].props;

          if (_this.hoverKey_ !== hoverKey) {
            _this._onChildMouseLeave();

            _this._onChildMouseEnter(hoverKey, childProps);
          }
        } else {
          _this._onChildMouseLeave();
        }
      } else {
        _this._onChildMouseLeave();
      }
    };

    _this._getDimensions = function (key) {
      var childKey = key;
      return _this.dimensionsCache_[childKey];
    };

    _this.props.dispatcher.on('kON_CHANGE', _this._onChangeHandler);
    _this.props.dispatcher.on('kON_MOUSE_POSITION_CHANGE', _this._onMouseChangeHandler);
    _this.props.dispatcher.on('kON_CLICK', _this._onChildClick);
    _this.props.dispatcher.on('kON_MDOWN', _this._onChildMouseDown);

    _this.dimensionsCache_ = {};
    _this.hoverKey_ = null;
    _this.hoverChildProps_ = null;
    _this.allowMouse_ = true;

    _this.state = _extends({}, _this._getState(), { hoverKey: null });
    return _this;
  }
  /* eslint-enable react/forbid-prop-types */

  GoogleMapMarkers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (this.props.experimental === true) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)((0, _omit2.default)(this.state, ['hoverKey']), (0, _omit2.default)(nextState, ['hoverKey']));
    }

    return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
  };

  GoogleMapMarkers.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.dispatcher.removeListener('kON_CHANGE', this._onChangeHandler);
    this.props.dispatcher.removeListener('kON_MOUSE_POSITION_CHANGE', this._onMouseChangeHandler);
    this.props.dispatcher.removeListener('kON_CLICK', this._onChildClick);
    this.props.dispatcher.removeListener('kON_MDOWN', this._onChildMouseDown);

    this.dimensionsCache_ = null;
  };

  GoogleMapMarkers.prototype.render = function render() {
    var _this2 = this;

    var mainElementStyle = this.props.style || mainStyle;
    this.dimensionsCache_ = {};

    var markers = _react2.default.Children.map(this.state.children, function (child, childIndex) {
      if (!child) return undefined;
      if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
        return _react2.default.cloneElement(child, {
          $geoService: _this2.props.geoService,
          $onMouseAllow: _this2._onMouseAllow,
          $prerender: _this2.props.prerender
        });
      }

      var latLng = child.props.latLng !== undefined ? child.props.latLng : { lat: child.props.lat, lng: child.props.lng };

      var pt = _this2.props.insideMapPanes ? _this2.props.geoService.fromLatLngToDivPixel(latLng) : _this2.props.geoService.fromLatLngToCenterPixel(latLng);

      var stylePtPos = {
        left: pt.x,
        top: pt.y
      };

      // If the component has a southeast corner defined (either as a LatLng, or a separate
      // lat and lng pair), set the width and height based on the distance between the northwest
      // and the southeast corner to lock the overlay to the correct geographic bounds.
      if (child.props.seLatLng !== undefined || child.props.seLat !== undefined && child.props.seLng !== undefined) {
        var seLatLng = child.props.seLatLng !== undefined ? child.props.seLatLng : { lat: child.props.seLat, lng: child.props.seLng };

        var sePt = _this2.props.insideMapPanes ? _this2.props.geoService.fromLatLngToDivPixel(seLatLng) : _this2.props.geoService.fromLatLngToCenterPixel(seLatLng);

        stylePtPos.width = sePt.x - pt.x;
        stylePtPos.height = sePt.y - pt.y;
      }

      var containerPt = _this2.props.geoService.fromLatLngToContainerPixel(latLng);

      // to prevent rerender on child element i need to pass
      // const params $getDimensions and $dimensionKey instead of dimension object
      var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;

      _this2.dimensionsCache_[childKey] = _extends({
        x: containerPt.x,
        y: containerPt.y
      }, latLng);

      return _react2.default.createElement(
        'div',
        {
          key: childKey,
          style: _extends({}, style, stylePtPos),
          className: child.props.$markerHolderClassName
        },
        _react2.default.cloneElement(child, {
          $hover: childKey === _this2.state.hoverKey,
          $getDimensions: _this2._getDimensions,
          $dimensionKey: childKey,
          $geoService: _this2.props.geoService,
          $onMouseAllow: _this2._onMouseAllow,
          $prerender: _this2.props.prerender
        })
      );
    });

    return _react2.default.createElement(
      'div',
      { style: mainElementStyle },
      markers
    );
  };

  return GoogleMapMarkers;
}(_react.Component);

GoogleMapMarkers.propTypes = {
  geoService: _propTypes2.default.any,
  style: _propTypes2.default.any,
  distanceToMouse: _propTypes2.default.func,
  dispatcher: _propTypes2.default.any,
  onChildClick: _propTypes2.default.func,
  onChildMouseDown: _propTypes2.default.func,
  onChildMouseLeave: _propTypes2.default.func,
  onChildMouseEnter: _propTypes2.default.func,
  getHoverDistance: _propTypes2.default.func,
  insideMapPanes: _propTypes2.default.bool,
  prerender: _propTypes2.default.bool
};
GoogleMapMarkers.defaultProps = {
  insideMapPanes: false,
  prerender: false
};
exports.default = GoogleMapMarkers;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/omit.js
var omit = function omit(obj, keys) {
  var rest = _objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key in rest) {
      delete rest[key];
    }
  }
  return rest;
};

exports.default = omit;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }
  // Step 6.a: NaN == NaN
  // eslint-disable-next-line no-self-compare
  return x !== x && y !== y;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;
/* src: https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/shallowEqual.js */

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Point;

/**
 * A standalone point geometry with useful accessor, comparison, and
 * modification methods.
 *
 * @class Point
 * @param {Number} x the x-coordinate. this could be longitude or screen
 * pixels, or any other sort of unit.
 * @param {Number} y the y-coordinate. this could be latitude or screen
 * pixels, or any other sort of unit.
 * @example
 * var point = new Point(-77, 38);
 */
function Point(x, y) {
    this.x = x;
    this.y = y;
}

Point.prototype = {

    /**
     * Clone this point, returning a new point that can be modified
     * without affecting the old one.
     * @return {Point} the clone
     */
    clone: function() { return new Point(this.x, this.y); },

    /**
     * Add this point's x & y coordinates to another point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    add:     function(p) { return this.clone()._add(p); },

    /**
     * Subtract this point's x & y coordinates to from point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    sub:     function(p) { return this.clone()._sub(p); },

    /**
     * Multiply this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    multByPoint:    function(p) { return this.clone()._multByPoint(p); },

    /**
     * Divide this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    divByPoint:     function(p) { return this.clone()._divByPoint(p); },

    /**
     * Multiply this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    mult:    function(k) { return this.clone()._mult(k); },

    /**
     * Divide this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    div:     function(k) { return this.clone()._div(k); },

    /**
     * Rotate this point around the 0, 0 origin by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @return {Point} output point
     */
    rotate:  function(a) { return this.clone()._rotate(a); },

    /**
     * Rotate this point around p point by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @param {Point} p Point to rotate around
     * @return {Point} output point
     */
    rotateAround:  function(a,p) { return this.clone()._rotateAround(a,p); },

    /**
     * Multiply this point by a 4x1 transformation matrix
     * @param {Array<Number>} m transformation matrix
     * @return {Point} output point
     */
    matMult: function(m) { return this.clone()._matMult(m); },

    /**
     * Calculate this point but as a unit vector from 0, 0, meaning
     * that the distance from the resulting point to the 0, 0
     * coordinate will be equal to 1 and the angle from the resulting
     * point to the 0, 0 coordinate will be the same as before.
     * @return {Point} unit vector point
     */
    unit:    function() { return this.clone()._unit(); },

    /**
     * Compute a perpendicular point, where the new y coordinate
     * is the old x coordinate and the new x coordinate is the old y
     * coordinate multiplied by -1
     * @return {Point} perpendicular point
     */
    perp:    function() { return this.clone()._perp(); },

    /**
     * Return a version of this point with the x & y coordinates
     * rounded to integers.
     * @return {Point} rounded point
     */
    round:   function() { return this.clone()._round(); },

    /**
     * Return the magitude of this point: this is the Euclidean
     * distance from the 0, 0 coordinate to this point's x and y
     * coordinates.
     * @return {Number} magnitude
     */
    mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },

    /**
     * Judge whether this point is equal to another point, returning
     * true or false.
     * @param {Point} other the other point
     * @return {boolean} whether the points are equal
     */
    equals: function(other) {
        return this.x === other.x &&
               this.y === other.y;
    },

    /**
     * Calculate the distance from this point to another point
     * @param {Point} p the other point
     * @return {Number} distance
     */
    dist: function(p) {
        return Math.sqrt(this.distSqr(p));
    },

    /**
     * Calculate the distance from this point to another point,
     * without the square root step. Useful if you're comparing
     * relative distances.
     * @param {Point} p the other point
     * @return {Number} distance
     */
    distSqr: function(p) {
        var dx = p.x - this.x,
            dy = p.y - this.y;
        return dx * dx + dy * dy;
    },

    /**
     * Get the angle from the 0, 0 coordinate to this point, in radians
     * coordinates.
     * @return {Number} angle
     */
    angle: function() {
        return Math.atan2(this.y, this.x);
    },

    /**
     * Get the angle from this point to another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleTo: function(b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },

    /**
     * Get the angle between this point and another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleWith: function(b) {
        return this.angleWithSep(b.x, b.y);
    },

    /*
     * Find the angle of the two vectors, solving the formula for
     * the cross product a x b = |a||b|sin(θ) for θ.
     * @param {Number} x the x-coordinate
     * @param {Number} y the y-coordinate
     * @return {Number} the angle in radians
     */
    angleWithSep: function(x, y) {
        return Math.atan2(
            this.x * y - this.y * x,
            this.x * x + this.y * y);
    },

    _matMult: function(m) {
        var x = m[0] * this.x + m[1] * this.y,
            y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _add: function(p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },

    _sub: function(p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },

    _mult: function(k) {
        this.x *= k;
        this.y *= k;
        return this;
    },

    _div: function(k) {
        this.x /= k;
        this.y /= k;
        return this;
    },

    _multByPoint: function(p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },

    _divByPoint: function(p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },

    _unit: function() {
        this._div(this.mag());
        return this;
    },

    _perp: function() {
        var y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },

    _rotate: function(angle) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = cos * this.x - sin * this.y,
            y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _rotateAround: function(angle, p) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y),
            y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },

    _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
};

/**
 * Construct a point from an array if necessary, otherwise if the input
 * is already a Point, or an unknown type, return it unchanged
 * @param {Array<Number>|Point|*} a any kind of input value
 * @return {Point} constructed point, or passed-through value.
 * @example
 * // this
 * var point = Point.convert([0, 1]);
 * // is equivalent to
 * var point = new Point(0, 1);
 */
Point.convert = function (a) {
    if (a instanceof Point) {
        return a;
    }
    if (Array.isArray(a)) {
        return new Point(a[0], a[1]);
    }
    return a;
};


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _wrap2 = __webpack_require__(622);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LatLng = function () {
  function LatLng(lat, lng) {
    _classCallCheck(this, LatLng);

    if (isNaN(lat) || isNaN(lng)) {
      throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
    }
    this.lat = +lat;
    this.lng = +lng;
  }

  LatLng.prototype.wrap = function wrap() {
    return new LatLng(this.lat, (0, _wrap2.wrap)(this.lng, -180, 180));
  };

  return LatLng;
}();

LatLng.convert = function (a) {
  if (a instanceof LatLng) {
    return a;
  }

  if (Array.isArray(a)) {
    return new LatLng(a[0], a[1]);
  }

  if ('lng' in a && 'lat' in a) {
    return new LatLng(a.lat, a.lng);
  }

  return a;
};

exports.default = LatLng;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.wrap = wrap;
/* eslint-disable import/prefer-default-export */

function wrap(n, min, max) {
  var d = max - min;
  return n === max ? n : ((n - min) % d + d) % d + min;
}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var log2 = Math.log2 ? Math.log2 : function (x) {
  return Math.log(x) / Math.LN2;
};

exports.default = log2;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addPassiveEventListener;
// feature detection for passive support
// see: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
function hasPassiveSupport() {
  var passiveSupported = false;

  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, options);
  } catch (err) {
    passiveSupported = false;
  }

  return passiveSupported;
}

function addPassiveEventListener(element, eventName, func, capture) {
  element.addEventListener(eventName, func, hasPassiveSupport() ? {
    capture: capture,
    passive: true
  } : capture);
}

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\map-location\\locations-section.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LocationsSectionMapLocationContainer = function (_PureComponent) {
  _inherits(LocationsSectionMapLocationContainer, _PureComponent);

  function LocationsSectionMapLocationContainer() {
    _classCallCheck(this, LocationsSectionMapLocationContainer);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  LocationsSectionMapLocationContainer.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setInterval(function () {
      _this2.forceUpdate();
    }, 100);
  };

  LocationsSectionMapLocationContainer.prototype.render = function render() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "ul",
      {
        key: "LocationsSectionMapLocationContainer",
        "data-test": "location-list",
        style: styles.locationsContainer, __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      },
      this.props.locations.length < 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { style: styles.messagePane, __source: {
            fileName: _jsxFileName,
            lineNumber: 20
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "em",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 21
            }
          },
          this.props.fresh ? this.props.entryMessage || __WEBPACK_IMPORTED_MODULE_2_constants_errors__["a" /* DEALER_ERRORS */].FIRST_VISIT : __WEBPACK_IMPORTED_MODULE_2_constants_errors__["a" /* DEALER_ERRORS */].NO_DEALERS_FOUND
        )
      ),
      this.props.locations.map(function (marker, index) {
        var active = _this3.props.activeIndex === index;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          {
            key: index,
            ref: function ref(c) {
              if (active) _this3.props.getActiveTileRef(c);
            },
            style: [index === 0 && { borderTop: "1px solid #d5d5d5" }, _this3.props.activeIndex !== index && _this3.props.activeIndex !== index + 1 && {
              borderBottom: "1px solid #d5d5d5"
            }, { display: "block" }], __source: {
              fileName: _jsxFileName,
              lineNumber: 31
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["z" /* LocationTile */], _extends({
            index: index,
            disableCategories: true,
            salesCTA: _this3.props.salesCTA && _extends({}, _this3.props.salesCTA, {
              href: _this3.props.salesCTA.href + "?dealerCode=" + marker.dealerCode + "&dealerLocationId=" + marker.id
            }),
            serviceCTA: _this3.props.serviceCTA && _extends({}, _this3.props.serviceCTA, {
              href: _this3.props.serviceCTA.href + "?dealerCode=" + marker.dealerCode + "&dealerLocationId=" + marker.id
            }),
            emailCTA: _this3.props.emailCTA,
            compact: _this3.props.compact,
            onClick: function onClick(event, callback) {
              // setting scroll to false (not needed for nz maps)
              _this3.props.handleClickOnLocation(index, false, callback);
            },
            mouseEnter: _this3.props.handleMouseEnterOnLocation,
            mouseLeave: _this3.props.handleMouseLeaveOnLocation,
            active: active,
            gtm: _this3.props.gtm
          }, marker, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 44
            }
          }))
        );
      })
    );
  };

  return LocationsSectionMapLocationContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

LocationsSectionMapLocationContainer.displayName = "LocationsSectionMapLocationContainer";


LocationsSectionMapLocationContainer.defaultProps = {
  handleClickOnLocation: function handleClickOnLocation() {}
};

LocationsSectionMapLocationContainer.propTypes = {
  locations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  entryMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fresh: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  handleMouseEnterOnLocation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  handleMouseLeaveOnLocation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  handleClickOnLocation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getActiveTileRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  salesCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  serviceCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  gtmMapping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  emailCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var styles = {
  locationsContainer: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto"
  },
  messagePane: {
    height: "100%",
    flex: "1 1 auto",
    display: "flex",
    justifyContent: "center",
    padding: "3em",
    alignItems: "center",
    boxSizing: "border-box",
    fontSize: "120%",
    fontWeight: "200",
    color: "#AAAAAA",
    textAlign: "center"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["m" /* withRadium */])()(LocationsSectionMapLocationContainer));

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__item__ = __webpack_require__(1522);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\summary\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function Summary(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === undefined ? "" : _ref$heading,
      previousGeneration = _ref.previousGeneration,
      _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items,
      _ref$disableBase = _ref.disableBase,
      disableBase = _ref$disableBase === undefined ? false : _ref$disableBase,
      ruleBelowHeading = _ref.ruleBelowHeading,
      children = _ref.children,
      _ref$horizontalLayout = _ref.horizontalLayout,
      horizontalLayout = _ref$horizontalLayout === undefined ? false : _ref$horizontalLayout;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: [!disableBase && styles.base(horizontalLayout)], "data-test": "summary", __source: {
        fileName: _jsxFileName,
        lineNumber: 19
      }
    },
    heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["C" /* H5 */],
      { withDetails: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      heading
    ),
    ruleBelowHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: styles.hr, __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    }),
    previousGeneration && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { fontWeight: 200, marginTop: "1em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 23
        }
      },
      "Previous Model"
    ),
    items.filter(Boolean).map(function (_ref2, index) {
      var ruleAfter = _ref2.ruleAfter,
          props = _objectWithoutProperties(_ref2, ["ruleAfter"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: index, style: { flexGrow: "1", padding: horizontalLayout ? "1em" : "" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__item__["a" /* default */], _extends({}, props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 29
          }
        })),
        ruleAfter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: [styles.hr, { margin: "2em 0 1em" }], __source: {
            fileName: _jsxFileName,
            lineNumber: 30
          }
        })
      );
    }),
    children
  );
}

Summary.displayName = "Summary";
Summary.displayName = "Summary";
Summary.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  previousGeneration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_4__item__["a" /* default */].propTypes)),
  ruleBelowHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  priceTemplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disableBase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(Summary));

var styles = {
  base: function base(horizontalLayout) {
    return {
      display: horizontalLayout ? "flex" : "block",
      maxWidth: horizontalLayout ? "100%" : "350px",
      margin: "auto",
      width: horizontalLayout ? "100%" : "auto"
    };
  },
  hr: {
    borderColor: "currentColor",
    borderStyle: "solid",
    borderWidth: "1px 0 0 0",
    opacity: 0.1
  },
  label: {
    color: "#aaa",
    textTransform: "uppercase",
    fontSize: "80%",
    margin: ".5em 0",
    display: "block",
    fontWeight: 600,
    letterSpacing: ".2em",
    textAlign: "left",
    flex: "1 1 40%"
  }
};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * in-view 0.6.1 - Get notified when a DOM element enters or exits the viewport.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/in-view
 * License: MIT
 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.inView=e():t.inView=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}var i=n(2),o=r(i);t.exports=o["default"]},function(t,e){function n(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}t.exports=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(9),o=r(i),u=n(3),f=r(u),s=n(4),c=function(){if("undefined"!=typeof window){var t=100,e=["scroll","resize","load"],n={history:[]},r={offset:{},threshold:0,test:s.inViewport},i=(0,o["default"])(function(){n.history.forEach(function(t){n[t].check()})},t);e.forEach(function(t){return addEventListener(t,i)}),window.MutationObserver&&addEventListener("DOMContentLoaded",function(){new MutationObserver(i).observe(document.body,{attributes:!0,childList:!0,subtree:!0})});var u=function(t){if("string"==typeof t){var e=[].slice.call(document.querySelectorAll(t));return n.history.indexOf(t)>-1?n[t].elements=e:(n[t]=(0,f["default"])(e,r),n.history.push(t)),n[t]}};return u.offset=function(t){if(void 0===t)return r.offset;var e=function(t){return"number"==typeof t};return["top","right","bottom","left"].forEach(e(t)?function(e){return r.offset[e]=t}:function(n){return e(t[n])?r.offset[n]=t[n]:null}),r.offset},u.threshold=function(t){return"number"==typeof t&&t>=0&&t<=1?r.threshold=t:r.threshold},u.test=function(t){return"function"==typeof t?r.test=t:r.test},u.is=function(t){return r.test(t,r)},u.offset(0),u}};e["default"]=c()},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,r){n(this,t),this.options=r,this.elements=e,this.current=[],this.handlers={enter:[],exit:[]},this.singles={enter:[],exit:[]}}return r(t,[{key:"check",value:function(){var t=this;return this.elements.forEach(function(e){var n=t.options.test(e,t.options),r=t.current.indexOf(e),i=r>-1,o=n&&!i,u=!n&&i;o&&(t.current.push(e),t.emit("enter",e)),u&&(t.current.splice(r,1),t.emit("exit",e))}),this}},{key:"on",value:function(t,e){return this.handlers[t].push(e),this}},{key:"once",value:function(t,e){return this.singles[t].unshift(e),this}},{key:"emit",value:function(t,e){for(;this.singles[t].length;)this.singles[t].pop()(e);for(var n=this.handlers[t].length;--n>-1;)this.handlers[t][n](e);return this}}]),t}();e["default"]=function(t,e){return new i(t,e)}},function(t,e){"use strict";function n(t,e){var n=t.getBoundingClientRect(),r=n.top,i=n.right,o=n.bottom,u=n.left,f=n.width,s=n.height,c={t:o,r:window.innerWidth-u,b:window.innerHeight-r,l:i},a={x:e.threshold*f,y:e.threshold*s};return c.t>e.offset.top+a.y&&c.r>e.offset.right+a.x&&c.b>e.offset.bottom+a.y&&c.l>e.offset.left+a.x}Object.defineProperty(e,"__esModule",{value:!0}),e.inViewport=n},function(t,e){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(e,function(){return this}())},function(t,e,n){var r=n(5),i="object"==typeof self&&self&&self.Object===Object&&self,o=r||i||Function("return this")();t.exports=o},function(t,e,n){function r(t,e,n){function r(e){var n=x,r=m;return x=m=void 0,E=e,w=t.apply(r,n)}function a(t){return E=t,j=setTimeout(h,e),M?r(t):w}function l(t){var n=t-O,r=t-E,i=e-n;return _?c(i,g-r):i}function d(t){var n=t-O,r=t-E;return void 0===O||n>=e||n<0||_&&r>=g}function h(){var t=o();return d(t)?p(t):void(j=setTimeout(h,l(t)))}function p(t){return j=void 0,T&&x?r(t):(x=m=void 0,w)}function v(){void 0!==j&&clearTimeout(j),E=0,x=O=m=j=void 0}function y(){return void 0===j?w:p(o())}function b(){var t=o(),n=d(t);if(x=arguments,m=this,O=t,n){if(void 0===j)return a(O);if(_)return j=setTimeout(h,e),r(O)}return void 0===j&&(j=setTimeout(h,e)),w}var x,m,g,w,j,O,E=0,M=!1,_=!1,T=!0;if("function"!=typeof t)throw new TypeError(f);return e=u(e)||0,i(n)&&(M=!!n.leading,_="maxWait"in n,g=_?s(u(n.maxWait)||0,e):g,T="trailing"in n?!!n.trailing:T),b.cancel=v,b.flush=y,b}var i=n(1),o=n(8),u=n(10),f="Expected a function",s=Math.max,c=Math.min;t.exports=r},function(t,e,n){var r=n(6),i=function(){return r.Date.now()};t.exports=i},function(t,e,n){function r(t,e,n){var r=!0,f=!0;if("function"!=typeof t)throw new TypeError(u);return o(n)&&(r="leading"in n?!!n.leading:r,f="trailing"in n?!!n.trailing:f),i(t,e,{leading:r,maxWait:e,trailing:f})}var i=n(7),o=n(1),u="Expected a function";t.exports=r},function(t,e){function n(t){return t}t.exports=n}])});

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * fetch-please v0.4.3
 * HTTP-transport that supports Promises and cancelable requests (XHR)
 * @author Alexander Burtsev, https://github.com/albburtsev
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["FetchPlease"] = factory();
	else
		root["FetchPlease"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ERROR_RESOURCE_FAILED = exports.ERROR_RESOURCE_ABORTED = exports.ERROR_CONNECTION_TIMEOUT = exports.ERROR_JSON_PARSE = exports.ERROR_INVALID_DATA = exports.ERROR_UNACCEPTABLE_HTTP_CODE = exports.ERROR_UNKNOWN_HTTP_METHOD = exports.ERROR_PROMISE_NOT_FOUND = exports.ERROR_XHR_NOT_FOUND = exports.MAX_SUCCESSFUL_HTTP_CODE = exports.MIN_SUCCESSFUL_HTTP_CODE = exports.CONTENT_TYPE_JSON = exports.ALLOWED_METHODS = exports.HTTP_METHOD_DELETE = exports.HTTP_METHOD_POST = exports.HTTP_METHOD_PUT = exports.HTTP_METHOD_GET = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helpers = __webpack_require__(1);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var HTTP_METHOD_GET = exports.HTTP_METHOD_GET = 'GET';
	var HTTP_METHOD_PUT = exports.HTTP_METHOD_PUT = 'PUT';
	var HTTP_METHOD_POST = exports.HTTP_METHOD_POST = 'POST';
	var HTTP_METHOD_DELETE = exports.HTTP_METHOD_DELETE = 'DELETE';
	var ALLOWED_METHODS = exports.ALLOWED_METHODS = [HTTP_METHOD_GET, HTTP_METHOD_PUT, HTTP_METHOD_POST, HTTP_METHOD_DELETE];

	var CONTENT_TYPE_JSON = exports.CONTENT_TYPE_JSON = 'application/json';
	var MIN_SUCCESSFUL_HTTP_CODE = exports.MIN_SUCCESSFUL_HTTP_CODE = 200;
	var MAX_SUCCESSFUL_HTTP_CODE = exports.MAX_SUCCESSFUL_HTTP_CODE = 299;

	var ERROR_XHR_NOT_FOUND = exports.ERROR_XHR_NOT_FOUND = 'Constructor XMLHttpRequest not found';
	var ERROR_PROMISE_NOT_FOUND = exports.ERROR_PROMISE_NOT_FOUND = 'Constructor Promise not found';
	var ERROR_UNKNOWN_HTTP_METHOD = exports.ERROR_UNKNOWN_HTTP_METHOD = 'Unknown HTTP method';
	var ERROR_UNACCEPTABLE_HTTP_CODE = exports.ERROR_UNACCEPTABLE_HTTP_CODE = 'Unacceptable HTTP code';
	var ERROR_INVALID_DATA = exports.ERROR_INVALID_DATA = 'Invalid data for sending';
	var ERROR_JSON_PARSE = exports.ERROR_JSON_PARSE = 'Invalid JSON';

	var ERROR_CONNECTION_TIMEOUT = exports.ERROR_CONNECTION_TIMEOUT = 'Connection timeout';
	var ERROR_RESOURCE_ABORTED = exports.ERROR_RESOURCE_ABORTED = 'Resource has been aborted';
	var ERROR_RESOURCE_FAILED = exports.ERROR_RESOURCE_FAILED = 'Resource failed to load';

	/**
	 * @class HTTP-transport based on XHR
	 * @property {String} path Common path
	 * @property {Number} timeout Timeout (in milliseconds)
	 * @property {Object} headers Common headers
	 * @property {Array} opened List of opened requests
	 * @property {Boolean} cors  Use `withCredentials`
	 * @property {XMLHttpRequest} XMLHttpRequest XHR interface
	 * @property {Boolean} cors ```true``` if supported Cross-Origin Resource Sharing
	 * @see https://xhr.spec.whatwg.org/
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest
	 * @see http://www.html5rocks.com/en/tutorials/cors/
	 */

	var FetchPlease = function () {
	    /**
	     * @param {String} path Common path for all requests
	     * @param {Object} [settings] Object with settings
	     * @param {Number} [settings.timeout = 0]
	     * @param {Object} [settings.XMLHttpRequest = global.XMLHttpRequest]
	     * @param {Object} [settings.cors = false]
	     * @param {Function} [settings.onProgress] Handler for xhr.onprogress
	     * @param {Function} [settings.onProgressUpload] Handler for xhr.upload.onprogress
	     * @param {Object|Function} [settings.headers = {}]
	     */
	    function FetchPlease() {
	        var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	        _classCallCheck(this, FetchPlease);

	        this.path = path;
	        this.opened = [];

	        (0, _helpers.assign)(this, {
	            timeout: 0,
	            headers: {},
	            cors: false,
	            XMLHttpRequest: global.XMLHttpRequest
	        }, settings);

	        var XMLHttpRequest = this.XMLHttpRequest;

	        if (XMLHttpRequest) {
	            this.cors = settings.cors && 'withCredentials' in new XMLHttpRequest();
	        }
	    }

	    /**
	     * Creates XHR instance and Promise instance
	     * @param {String} method HTTP method
	     * @param {String} path
	     * @param {Object} data
	     * @param {Object} settings
	     * @return {Object}
	     */


	    _createClass(FetchPlease, [{
	        key: 'request',
	        value: function request(method, path) {
	            var _this = this;

	            var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var settings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	            if (!this.XMLHttpRequest) {
	                throw new Error(ERROR_XHR_NOT_FOUND);
	            }

	            if (!global.Promise) {
	                throw new Error(ERROR_PROMISE_NOT_FOUND);
	            }

	            if (ALLOWED_METHODS.indexOf(method) === -1) {
	                throw new Error(ERROR_UNKNOWN_HTTP_METHOD);
	            }

	            var xhr = new this.XMLHttpRequest(),
	                promise = new Promise(function (resolve, reject) {
	                xhr.addEventListener('error', function () {
	                    return reject(ERROR_RESOURCE_FAILED);
	                });
	                xhr.addEventListener('abort', function () {
	                    return reject(ERROR_RESOURCE_ABORTED);
	                });
	                xhr.addEventListener('timeout', function () {
	                    return reject(ERROR_CONNECTION_TIMEOUT);
	                });
	                xhr.addEventListener('load', function () {
	                    if (xhr.status) {
	                        resolve(xhr);
	                    }
	                });
	            });

	            settings = settings || {};

	            var handleJson = settings.handleJson || this.handleJson,
	                handleError = settings.handleError || this.handleError,
	                handleResponse = settings.handleResponse || this.handleResponse;

	            promise = promise
	            // Remove request from list of opened requests
	            .then(function () {
	                return _this.close(xhr);
	            }, function (reason) {
	                _this.close(xhr);
	                throw new Error(reason);
	            })
	            // Handle response
	            .then(handleResponse)
	            // Handle JSON in response
	            .then(handleJson)
	            // Handle errors
	            .catch(handleError);

	            // Add optinal `onProgress` handler
	            if (settings.onProgress) {
	                xhr.addEventListener('progress', settings.onProgress);
	            }

	            // Add optinal `onProgressUpload` handler
	            if (settings.onProgressUpload) {
	                xhr.upload.addEventListener('progress', settings.onProgressUpload);
	            }

	            // Form URL without normalizing and open request
	            var url = this.path + path;
	            xhr.open(method, url);

	            // Set headers
	            // Order of method's calls is important
	            // You must call setRequestHeader() after open(), but before send()
	            // @see: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#setRequestHeader()
	            var headers = (0, _helpers.assign)({}, typeof this.headers === 'function' ? this.headers() : this.headers, settings.headers);
	            this.setHeaders(xhr, headers);

	            // Set timeout (before send() too)
	            // @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Synchronous_and_Asynchronous_Requests#Example_using_a_timeout
	            var timeout = this.timeout || settings.timeout || 0;
	            xhr.timeout = timeout;

	            // Serialize data and send request
	            data = this.serialize(data);

	            if (this.cors) {
	                xhr.withCredentials = true;
	            }

	            xhr.send(data);

	            // Add request into list of opened requests
	            this.add(xhr);

	            return { xhr: xhr, promise: promise };
	        }

	        /**
	         * Serializes data for request
	         * @param {*} data
	         * @return {String|FormData|Blob}
	         */

	    }, {
	        key: 'serialize',
	        value: function serialize(data) {
	            // Do nothing with FormData instance
	            if (global.FormData && data instanceof FormData) {
	                return data;
	            }

	            // Do nothing with Blob instance
	            if (global.Blob && data instanceof Blob) {
	                return data;
	            }

	            // Do nothing with string or null
	            if (data === null || typeof data === 'string') {
	                return data;
	            }

	            try {
	                // Serialize other data as JSON
	                return JSON.stringify(data);
	            } catch (e) {
	                throw new Error(ERROR_INVALID_DATA);
	            }
	        }

	        /**
	         * Iterates given headers and set them for XHR object
	         * @param {XMLHttpRequest} xhr
	         * @param {Object} headers
	         * @return {XMLHttpRequest}
	         */

	    }, {
	        key: 'setHeaders',
	        value: function setHeaders(xhr) {
	            var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            return Object.keys(headers).reduce(function (xhr, header) {
	                var value = headers[header];

	                if (value !== false && value !== null && value !== undefined) {
	                    xhr.setRequestHeader(header, value);
	                }

	                return xhr;
	            }, xhr);
	        }

	        /**
	         * Aborts all opened requests
	         */

	    }, {
	        key: 'abort',
	        value: function abort() {
	            this.opened.forEach(function (xhr) {
	                return xhr.abort();
	            });
	        }

	        /**
	         * Adds request to list of opened requests
	         * @param {XMLHttpRequest} xhr
	         */

	    }, {
	        key: 'add',
	        value: function add(xhr) {
	            this.opened.push(xhr);
	        }

	        /**
	         * Deletes request from list of opened requests
	         * @param {XMLHttpRequest} xhr
	         * @return {XMLHtpRequest}
	         */

	    }, {
	        key: 'close',
	        value: function close(xhr) {
	            var idx = this.opened.indexOf(xhr);
	            if (idx !== -1) {
	                this.opened.splice(idx, 1);
	            }
	            return xhr;
	        }

	        /**
	         * Sends GET request
	         * @param {String} url
	         * @param {Object} [params]
	         * @param {Object} [settings]
	         * @return {Promise}
	         */

	    }, {
	        key: 'get',
	        value: function get(url, params, settings) {
	            var _getRequest = this.getRequest(url, params, settings),
	                promise = _getRequest.promise;

	            return promise;
	        }

	        /**
	         * Sends PUT request
	         * @param {String} url
	         * @param {Object} data
	         * @param {Object} [settings]
	         * @return {Promise}
	         */

	    }, {
	        key: 'put',
	        value: function put(url, data, settings) {
	            var _putRequest = this.putRequest(url, data, settings),
	                promise = _putRequest.promise;

	            return promise;
	        }

	        /**
	         * Sends POST request
	         * @param {String} url
	         * @param {Object} data
	         * @param {Object} [settings]
	         * @return {Promise}
	         */

	    }, {
	        key: 'post',
	        value: function post(url, data, settings) {
	            var _postRequest = this.postRequest(url, data, settings),
	                promise = _postRequest.promise;

	            return promise;
	        }

	        /**
	         * Sends DELETE request
	         * @param {String} url
	         * @param {Object} [params]
	         * @param {Object} [settings]
	         * @return {Promise}
	         */

	    }, {
	        key: 'delete',
	        value: function _delete(url, params, settings) {
	            var _deleteRequest = this.deleteRequest(url, params, settings),
	                promise = _deleteRequest.promise;

	            return promise;
	        }

	        /**
	         * Sends same GET request but returns object with instances of XHR and Promise
	         * @param {String} url
	         * @param {Object} [params]
	         * @param {Object} [settings]
	         * @return {Object}
	         */

	    }, {
	        key: 'getRequest',
	        value: function getRequest(url) {
	            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	            url = (0, _helpers.joinParams)(url, params);
	            return this.request(HTTP_METHOD_GET, url, null, settings);
	        }

	        /**
	         * Sends same PUT request but returns object with instances of XHR and Promise
	         * @param {String} url
	         * @param {Object} data
	         * @param {Object} [settings]
	         * @return {Object}
	         */

	    }, {
	        key: 'putRequest',
	        value: function putRequest(url, data) {
	            var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	            return this.request(HTTP_METHOD_PUT, url, data, settings);
	        }

	        /**
	         * Sends same POST request but returns object with instances of XHR and Promise
	         * @param {String} url
	         * @param {Object} data
	         * @param {Object} [settings]
	         * @return {Object}
	         */

	    }, {
	        key: 'postRequest',
	        value: function postRequest(url, data) {
	            var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	            return this.request(HTTP_METHOD_POST, url, data, settings);
	        }

	        /**
	         * Sends same DELETE request but returns object with instances of XHR and Promise
	         * @param {String} url
	         * @param {Object} [params]
	         * @param {Object} [settings]
	         * @return {Object}
	         */

	    }, {
	        key: 'deleteRequest',
	        value: function deleteRequest(url) {
	            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	            url = (0, _helpers.joinParams)(url, params);
	            return this.request(HTTP_METHOD_DELETE, url, null, settings);
	        }

	        /**
	         * Handles JSON in response
	         * @param {XMLHttpRequest} xhr
	         * @param {String} xhr.responseText
	         * @return {Object}
	         */

	    }, {
	        key: 'handleJson',
	        value: function handleJson(xhr) {
	            var responseText = xhr.responseText,
	                contentType = xhr.getResponseHeader('Content-Type') || '';


	            contentType = contentType.toLowerCase();

	            // If header Content-Type has value "application/json" then parse text as JSON
	            if (contentType.indexOf(CONTENT_TYPE_JSON) !== -1) {
	                try {
	                    return JSON.parse(responseText);
	                } catch (e) {
	                    throw new Error(ERROR_JSON_PARSE);
	                }
	            }

	            // Just return given xhr
	            return xhr;
	        }

	        /**
	         * Handles XHR response
	         * @param {XMLHttpRequest} xhr
	         * @param {Number} xhr.status
	         * @see https://xhr.spec.whatwg.org/#interface-xmlhttprequest
	         * @return {XMLHttpRequest}
	         */

	    }, {
	        key: 'handleResponse',
	        value: function handleResponse(xhr) {
	            var status = xhr.status;

	            // If status < 200 or status >= 200 then return error

	            if (status < MIN_SUCCESSFUL_HTTP_CODE || status > MAX_SUCCESSFUL_HTTP_CODE) {
	                var error = new Error(ERROR_UNACCEPTABLE_HTTP_CODE);
	                error.statusCode = status;
	                throw error;
	            }

	            // Just return given xhr
	            return xhr;
	        }

	        /**
	         * Handles any occured errors
	         * @param {Error} error
	         * @return {Error}
	         */

	    }, {
	        key: 'handleError',
	        value: function handleError(error) {
	            // Really do nothing
	            throw error;
	        }
	    }]);

	    return FetchPlease;
	}();

	exports.default = FetchPlease;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.assign = assign;
	exports.joinParams = joinParams;
	/**
	 * Naive polyfill for Object.assign()
	 * Why I did it? Because even modular lodash adds too much code in final build
	 * @param {Object} target
	 * @return {Object}
	 */
	function assign(target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var obj = Object(arguments[i]),
	            keys = Object.keys(obj);

	        for (var j = 0; j < keys.length; j++) {
	            var key = keys[j];

	            if (!obj.hasOwnProperty(key)) {
	                continue;
	            }

	            target[key] = obj[key];
	        }
	    }

	    return target;
	}

	/**
	 * Returns URL with query string
	 * @param {String} url
	 * @param {Object} params
	 * @return {String}
	 */
	function joinParams(url) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	    if (!params) {
	        return url;
	    }

	    var queryString = Object.keys(params).filter(function (key) {
	        var value = params[key];
	        return value !== null && value !== undefined;
	    }).map(function (key) {
	        var value = params[key].toString();

	        key = encodeURIComponent(key);
	        value = encodeURIComponent(value);

	        return key + '=' + value;
	    }).join('&');

	    if (!queryString) {
	        return url;
	    }

	    // Trim trailing "?"
	    url = url.replace(/\?+$/, '');

	    return url + (url.indexOf('?') === -1 ? '?' : '&') + queryString;
	}

/***/ }
/******/ ])
});
;

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export Value */
/* unused harmony export Option */
/* unused harmony export defaultMenuRenderer */
/* unused harmony export defaultArrowRenderer */
/* unused harmony export defaultClearRenderer */
/* unused harmony export defaultFilterOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_autosize__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);






function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
}

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
}

function trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);

		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    labelKey = _ref.labelKey,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] == option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
}

function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'blockEvent',
		value: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]);

var instanceId = 1;

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleRequired', 'handleTouchOutside', 'handleTouchMove', 'handleTouchStart', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleValueClick', 'getOptionLabel', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				}
				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// TODO: This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true
				});
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			if (this.state.isOpen) {
				this.closeMenu();
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: this.handleInputValueChange('')
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;
			var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: newInputValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						return;
					}
					event.preventDefault();
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					return;
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						return;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						return;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				case 33:
					// page up
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						return;
					}
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						return;
					}
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				default:
					return;
			}
			event.preventDefault();
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'handleRequired',
		value: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param	{String|Number|Array}	value		- the value of the select input
   * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value, nextProps) {
			var _this2 = this;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return _this2.expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}

		/**
   * Retrieve a value from the given options and valueKey
   * @param	{String|Number|Array}	value	- the selected value(s)
   * @param	{Object}		props	- the Select component's props (or nextProps)
   */

	}, {
		key: 'expandValue',
		value: function expandValue(value, props) {
			var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
			if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
			var options = props.options,
			    valueKey = props.valueKey;

			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (String(options[i][valueKey]) === String(value)) return options[i];
			}
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this3 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.onChange) {
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this3.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this4 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			if (this.props.multi) {
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this4.getValueArray(_this4.props.value);
					if (valueArray.some(function (i) {
						return i[_this4.props.valueKey] === value[_this4.props.valueKey];
					})) {
						_this4.removeValue(value);
					} else {
						_this4.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this4.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this5 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this5.props.valueKey] !== value[_this5.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.preventDefault();
			this.setValue(this.getResetValue());
			this.setState({
				isOpen: false,
				inputValue: this.handleInputValueChange('')
			}, this.focus);
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var potentialIndex = focusedIndex + this.props.pageSize;
				if (potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this6 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						ValueComponent,
						{
							id: _this6._instancePrefix + '-value-' + i,
							instancePrefix: _this6._instancePrefix,
							disabled: _this6.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this6.props.valueKey],
							onClick: onClick,
							onRemove: _this6.removeValue,
							value: value
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					ValueComponent,
					{
						id: this._instancePrefix + '-value-item',
						disabled: this.props.disabled,
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this7 = this;

			var className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = !!this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
			var inputProps = _extends({}, this.props.inputProps, {
				role: 'combobox',
				'aria-expanded': '' + isOpen,
				'aria-owns': ariaOwns,
				'aria-haspopup': '' + isOpen,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-label': this.props['aria-label'],
				className: className,
				tabIndex: this.props.tabIndex,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this7.input = _ref;
				},
				required: this.state.required,
				value: this.state.inputValue
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var _props$inputProps = this.props.inputProps,
				    inputClassName = _props$inputProps.inputClassName,
				    divProps = objectWithoutProperties(_props$inputProps, ['inputClassName']);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, divProps, {
					role: 'combobox',
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-label': this.props['aria-label'],
					className: className,
					tabIndex: this.props.tabIndex || 0,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this7.input = _ref2;
					},
					'aria-disabled': '' + !!this.props.disabled,
					style: { border: 0, width: 1, display: 'inline-block' } }));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap' },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					valueKey: this.props.valueKey,
					trimFilter: this.props.trimFilter
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					selectValue: this.selectValue,
					removeValue: this.removeValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey,
					onOptionRef: this.onOptionRef
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this8 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this8.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
					type: 'hidden',
					ref: function ref(_ref3) {
						return _this8.value = _ref3;
					},
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this8.props.name,
					value: stringifyValue(item[_this8.props.valueKey]),
					disabled: _this8.props.disabled });
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this9 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this9.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref4) {
							return _this9.menu = _ref4;
						}, role: 'listbox', tabIndex: -1, className: 'Select-menu', id: this._instancePrefix + '-list',
						style: this.props.menuStyle,
						onScroll: this.handleMenuScroll,
						onMouseDown: this.handleMouseDownOnMenu },
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this10 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'Select--single': !this.props.multi,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length,
				'Select--rtl': this.props.rtl
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this10.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this10.control = _ref6;
						},
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove
					},
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onSelectResetsInput: true,
	onCloseResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    multi = _props3.multi,
			    onChange = _props3.onChange,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Select$1, props);
}

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option, event) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    newOptionCreator = _props4.newOptionCreator,
			    shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption', 'ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



function defaultChildren$2(props) {
	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Select$1, props);
}

function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
}

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
}

function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
}

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
}

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



function defaultChildren$1(props) {
	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Select$1, props);
}

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["a"] = (Select$1);


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Accessor = __webpack_require__(631);
var React = __webpack_require__(0);
var TypeaheadSelector = __webpack_require__(1588);
var KeyEvent = __webpack_require__(632);
var fuzzy = __webpack_require__(1590);
var classNames = __webpack_require__(5);
var createReactClass = __webpack_require__(122);
var PropTypes = __webpack_require__(1);

/**
 * A "typeahead", an auto-completing text input
 *
 * Renders an text input that shows options nearby that you can use the
 * keyboard or mouse to select.  Requires CSS for MASSIVE DAMAGE.
 */
var Typeahead = createReactClass({
  displayName: 'Typeahead',

  propTypes: {
    name: PropTypes.string,
    customClasses: PropTypes.object,
    maxVisible: PropTypes.number,
    resultsTruncatedMessage: PropTypes.string,
    options: PropTypes.array,
    allowCustomValues: PropTypes.number,
    initialValue: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    textarea: PropTypes.bool,
    inputProps: PropTypes.object,
    onOptionSelected: PropTypes.func,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    onKeyPress: PropTypes.func,
    onKeyUp: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    filterOption: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    searchOptions: PropTypes.func,
    displayOption: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    inputDisplayOption: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    formInputOption: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    defaultClassNames: PropTypes.bool,
    customListComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    showOptionsWhenEmpty: PropTypes.bool
  },

  getDefaultProps: function () {
    return {
      options: [],
      customClasses: {},
      allowCustomValues: 0,
      initialValue: "",
      value: "",
      placeholder: "",
      disabled: false,
      textarea: false,
      inputProps: {},
      onOptionSelected: function (option) {},
      onChange: function (event) {},
      onKeyDown: function (event) {},
      onKeyPress: function (event) {},
      onKeyUp: function (event) {},
      onFocus: function (event) {},
      onBlur: function (event) {},
      filterOption: null,
      searchOptions: null,
      inputDisplayOption: null,
      defaultClassNames: true,
      customListComponent: TypeaheadSelector,
      showOptionsWhenEmpty: false,
      resultsTruncatedMessage: null
    };
  },

  getInitialState: function () {
    return {
      // The options matching the entry value
      searchResults: this.getOptionsForValue(this.props.initialValue, this.props.options),

      // This should be called something else, "entryValue"
      entryValue: this.props.value || this.props.initialValue,

      // A valid typeahead value
      selection: this.props.value,

      // Index of the selection
      selectionIndex: null,

      // Keep track of the focus state of the input element, to determine
      // whether to show options when empty (if showOptionsWhenEmpty is true)
      isFocused: false,

      // true when focused, false onOptionSelected
      showResults: false
    };
  },

  _shouldSkipSearch: function (input) {
    var emptyValue = !input || input.trim().length == 0;

    // this.state must be checked because it may not be defined yet if this function
    // is called from within getInitialState
    var isFocused = this.state && this.state.isFocused;
    return !(this.props.showOptionsWhenEmpty && isFocused) && emptyValue;
  },

  getOptionsForValue: function (value, options) {
    if (this._shouldSkipSearch(value)) {
      return [];
    }

    var searchOptions = this._generateSearchFunction();
    return searchOptions(value, options);
  },

  setEntryText: function (value) {
    this.refs.entry.value = value;
    this._onTextEntryUpdated();
  },

  focus: function () {
    this.refs.entry.focus();
  },

  _hasCustomValue: function () {
    if (this.props.allowCustomValues > 0 && this.state.entryValue.length >= this.props.allowCustomValues && this.state.searchResults.indexOf(this.state.entryValue) < 0) {
      return true;
    }
    return false;
  },

  _getCustomValue: function () {
    if (this._hasCustomValue()) {
      return this.state.entryValue;
    }
    return null;
  },

  _renderIncrementalSearchResults: function () {
    // Nothing has been entered into the textbox
    if (this._shouldSkipSearch(this.state.entryValue)) {
      return "";
    }

    // Something was just selected
    if (this.state.selection) {
      return "";
    }

    return React.createElement(this.props.customListComponent, {
      ref: 'sel', options: this.props.maxVisible ? this.state.searchResults.slice(0, this.props.maxVisible) : this.state.searchResults,
      areResultsTruncated: this.props.maxVisible && this.state.searchResults.length > this.props.maxVisible,
      resultsTruncatedMessage: this.props.resultsTruncatedMessage,
      onOptionSelected: this._onOptionSelected,
      allowCustomValues: this.props.allowCustomValues,
      customValue: this._getCustomValue(),
      customClasses: this.props.customClasses,
      selectionIndex: this.state.selectionIndex,
      defaultClassNames: this.props.defaultClassNames,
      displayOption: Accessor.generateOptionToStringFor(this.props.displayOption) });
  },

  getSelection: function () {
    var index = this.state.selectionIndex;
    if (this._hasCustomValue()) {
      if (index === 0) {
        return this.state.entryValue;
      } else {
        index--;
      }
    }
    return this.state.searchResults[index];
  },

  _onOptionSelected: function (option, event) {
    var nEntry = this.refs.entry;
    nEntry.focus();

    var displayOption = Accessor.generateOptionToStringFor(this.props.inputDisplayOption || this.props.displayOption);
    var optionString = displayOption(option, 0);

    var formInputOption = Accessor.generateOptionToStringFor(this.props.formInputOption || displayOption);
    var formInputOptionString = formInputOption(option);

    nEntry.value = optionString;
    this.setState({ searchResults: this.getOptionsForValue(optionString, this.props.options),
      selection: formInputOptionString,
      entryValue: optionString,
      showResults: false });
    return this.props.onOptionSelected(option, event);
  },

  _onTextEntryUpdated: function () {
    var value = this.refs.entry.value;
    this.setState({ searchResults: this.getOptionsForValue(value, this.props.options),
      selection: '',
      entryValue: value });
  },

  _onEnter: function (event) {
    var selection = this.getSelection();
    if (!selection) {
      return this.props.onKeyDown(event);
    }
    return this._onOptionSelected(selection, event);
  },

  _onEscape: function () {
    this.setState({
      selectionIndex: null
    });
  },

  _onTab: function (event) {
    var selection = this.getSelection();
    var option = selection ? selection : this.state.searchResults.length > 0 ? this.state.searchResults[0] : null;

    if (option === null && this._hasCustomValue()) {
      option = this._getCustomValue();
    }

    if (option !== null) {
      return this._onOptionSelected(option, event);
    }
  },

  eventMap: function (event) {
    var events = {};

    events[KeyEvent.DOM_VK_UP] = this.navUp;
    events[KeyEvent.DOM_VK_DOWN] = this.navDown;
    events[KeyEvent.DOM_VK_RETURN] = events[KeyEvent.DOM_VK_ENTER] = this._onEnter;
    events[KeyEvent.DOM_VK_ESCAPE] = this._onEscape;
    events[KeyEvent.DOM_VK_TAB] = this._onTab;

    return events;
  },

  _nav: function (delta) {
    if (!this._hasHint()) {
      return;
    }
    var newIndex = this.state.selectionIndex === null ? delta == 1 ? 0 : delta : this.state.selectionIndex + delta;
    var length = this.props.maxVisible ? this.state.searchResults.slice(0, this.props.maxVisible).length : this.state.searchResults.length;
    if (this._hasCustomValue()) {
      length += 1;
    }

    if (newIndex < 0) {
      newIndex += length;
    } else if (newIndex >= length) {
      newIndex -= length;
    }

    this.setState({ selectionIndex: newIndex });
  },

  navDown: function () {
    this._nav(1);
  },

  navUp: function () {
    this._nav(-1);
  },

  _onChange: function (event) {
    if (this.props.onChange) {
      this.props.onChange(event);
    }

    this._onTextEntryUpdated();
  },

  _onKeyDown: function (event) {
    // If there are no visible elements, don't perform selector navigation.
    // Just pass this up to the upstream onKeydown handler.
    // Also skip if the user is pressing the shift key, since none of our handlers are looking for shift
    if (!this._hasHint() || event.shiftKey) {
      return this.props.onKeyDown(event);
    }

    var handler = this.eventMap()[event.keyCode];

    if (handler) {
      handler(event);
    } else {
      return this.props.onKeyDown(event);
    }
    // Don't propagate the keystroke back to the DOM/browser
    event.preventDefault();
  },

  componentWillReceiveProps: function (nextProps) {
    var searchResults = this.getOptionsForValue(this.state.entryValue, nextProps.options);
    var showResults = Boolean(searchResults.length) && this.state.isFocused;
    this.setState({
      searchResults: searchResults,
      showResults: showResults
    });
  },

  render: function () {
    var inputClasses = {};
    inputClasses[this.props.customClasses.input] = !!this.props.customClasses.input;
    var inputClassList = classNames(inputClasses);

    var classes = {
      typeahead: this.props.defaultClassNames
    };
    classes[this.props.className] = !!this.props.className;
    var classList = classNames(classes);

    var InputElement = this.props.textarea ? 'textarea' : 'input';
    return React.createElement(
      'div',
      { className: classList },
      this._renderHiddenInput(),
      React.createElement(InputElement, _extends({ ref: 'entry', type: 'text',
        disabled: this.props.disabled
      }, this.props.inputProps, {
        placeholder: this.props.placeholder,
        className: inputClassList,
        value: this.state.entryValue,
        onChange: this._onChange,
        onKeyDown: this._onKeyDown,
        onKeyPress: this.props.onKeyPress,
        onKeyUp: this.props.onKeyUp,
        onFocus: this._onFocus,
        onBlur: this._onBlur
      })),
      this.state.showResults && this._renderIncrementalSearchResults()
    );
  },

  _onFocus: function (event) {
    this.setState({ isFocused: true, showResults: true }, function () {
      this._onTextEntryUpdated();
    }.bind(this));
    if (this.props.onFocus) {
      return this.props.onFocus(event);
    }
  },

  _onBlur: function (event) {
    this.setState({ isFocused: false }, function () {
      this._onTextEntryUpdated();
    }.bind(this));
    if (this.props.onBlur) {
      return this.props.onBlur(event);
    }
  },

  _renderHiddenInput: function () {
    if (!this.props.name) {
      return null;
    }

    return React.createElement('input', {
      type: 'hidden',
      name: this.props.name,
      value: this.state.selection
    });
  },

  _generateSearchFunction: function () {
    var searchOptionsProp = this.props.searchOptions;
    var filterOptionProp = this.props.filterOption;
    if (typeof searchOptionsProp === 'function') {
      if (filterOptionProp !== null) {
        console.warn('searchOptions prop is being used, filterOption prop will be ignored');
      }
      return searchOptionsProp;
    } else if (typeof filterOptionProp === 'function') {
      return function (value, options) {
        return options.filter(function (o) {
          return filterOptionProp(value, o);
        });
      };
    } else {
      var mapper;
      if (typeof filterOptionProp === 'string') {
        mapper = Accessor.generateAccessor(filterOptionProp);
      } else {
        mapper = Accessor.IDENTITY_FN;
      }
      return function (value, options) {
        return fuzzy.filter(value, options, { extract: mapper }).map(function (res) {
          return options[res.index];
        });
      };
    }
  },

  _hasHint: function () {
    return this.state.searchResults.length > 0 || this._hasCustomValue();
  }
});

module.exports = Typeahead;

/***/ }),
/* 631 */
/***/ (function(module, exports) {

var Accessor = {
  IDENTITY_FN: function (input) {
    return input;
  },

  generateAccessor: function (field) {
    return function (object) {
      return object[field];
    };
  },

  generateOptionToStringFor: function (prop) {
    if (typeof prop === 'string') {
      return this.generateAccessor(prop);
    } else if (typeof prop === 'function') {
      return prop;
    } else {
      return this.IDENTITY_FN;
    }
  },

  valueForOption: function (option, object) {
    if (typeof option === 'string') {
      return object[option];
    } else if (typeof option === 'function') {
      return option(object);
    } else {
      return object;
    }
  }
};

module.exports = Accessor;

/***/ }),
/* 632 */
/***/ (function(module, exports) {

/**
 * PolyFills make me sad
 */
var KeyEvent = KeyEvent || {};
KeyEvent.DOM_VK_UP = KeyEvent.DOM_VK_UP || 38;
KeyEvent.DOM_VK_DOWN = KeyEvent.DOM_VK_DOWN || 40;
KeyEvent.DOM_VK_BACK_SPACE = KeyEvent.DOM_VK_BACK_SPACE || 8;
KeyEvent.DOM_VK_RETURN = KeyEvent.DOM_VK_RETURN || 13;
KeyEvent.DOM_VK_ENTER = KeyEvent.DOM_VK_ENTER || 14;
KeyEvent.DOM_VK_ESCAPE = KeyEvent.DOM_VK_ESCAPE || 27;
KeyEvent.DOM_VK_TAB = KeyEvent.DOM_VK_TAB || 9;

module.exports = KeyEvent;

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NotificationsButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__top_navigation_item__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__animated_dropdown__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__navigation_item__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicComponents_Button_Button_less__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicComponents_Button_Button_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_AtomicComponents_Button_Button_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_AtomicUtils_gtmHandler__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\navigation\\notifications.jsx",
    _menu;
















var NotificationsButton = function NotificationsButton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__top_navigation_item__["a" /* default */], _extends({
    label: "Notifications",
    Icon: __WEBPACK_IMPORTED_MODULE_6_components__["T" /* NotificationsIcon */]
  }, props, {
    badge: props.notifications.length,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    }
  }));
};

NotificationsButton.displayName = "NotificationsButton";
NotificationsButton.displayName = "NotificationsButton";
NotificationsButton.propTypes = {
  notifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var NotificationType = function NotificationType(_ref) {
  var item = _ref.item,
      isDropdown = _ref.isDropdown;

  switch (item.notificationType) {
    case "RECALL":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "b",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 36
            }
          },
          "URGENT RECALL ON YOUR ",
          item.namePlate,
          " [",
          item.rego,
          "]"
        ),
        ".",
        isDropdown ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 39
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 40
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 41
            }
          })
        ) : " ",
        item.detailUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 47
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],
            {
              to: item.detailUrl,
              style: {
                color: isDropdown ? __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].WHITE : __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].BLACK
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 48
              }
            },
            "View details about this recall"
          ),
          " ",
          "or request a service now to rectify this issue."
        )
      );

    case "ROADSIDE_EXPIRY":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 64
          }
        },
        "Your ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "b",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 65
            }
          },
          "Roadside Assistance"
        ),
        " policy for your",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "b",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 66
            }
          },
          item.namePlate,
          " [",
          item.rego,
          "]"
        ),
        " ",
        "will expire soon.",
        isDropdown ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 70
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 71
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          })
        ) : " ",
        "Call",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            href: item.contactNumber && "tel:" + item.contactNumber.replace(/ /g, ""),
            style: {
              color: isDropdown ? __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].WHITE : __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].BLACK,
              whiteSpace: "nowrap"
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          },
          item.contactNumber
        ),
        " ",
        "to discuss a renewal or view your policy page for details."
      );

    case "INSURANCE_EXPIRY":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 95
          }
        },
        "Your ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "b",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 96
            }
          },
          item.policyTitle
        ),
        " for your",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "b",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 97
            }
          },
          item.namePlate,
          " [",
          item.rego,
          "]"
        ),
        " ",
        "will expire soon.",
        isDropdown ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 101
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 102
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 103
            }
          })
        ) : " ",
        "Call",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            href: item.contactNumber && "tel:" + item.contactNumber.replace(/ /g, ""),
            style: {
              color: isDropdown ? __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].WHITE : __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].BLACK,
              whiteSpace: "nowrap"
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 108
            }
          },
          item.contactNumber
        ),
        " ",
        "to discuss a renewal or view your policy page for details."
      );

    case "SERVICE_DUE":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 126
          }
        },
        "It looks like your",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "b",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 128
            }
          },
          item.namePlate,
          " [",
          item.rego,
          "]"
        ),
        " ",
        "is due for a service soon."
      );

    case "SERVICE_OVERDUE":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 137
          }
        },
        "It looks like your",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "b",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 139
            }
          },
          item.namePlate,
          " [",
          item.rego,
          "]"
        ),
        " ",
        "is overdue for a service."
      );

    case "LINK_VEHICLE":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 148
          }
        },
        "We have added your",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "b",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 150
            }
          },
          item.namePlate,
          " [",
          item.rego,
          "]"
        ),
        " ",
        "to your account."
      );

    case "UNLINK_VEHICLE":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 159
          }
        },
        "We have transferred the",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "b",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 161
            }
          },
          item.namePlate,
          " [",
          item.rego,
          "]"
        ),
        " ",
        "from your account.",
        isDropdown ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 165
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 166
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 167
            }
          })
        ) : " ",
        "For further enquiries contact us online or phone",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            href: item.contactNumber && "tel:" + item.contactNumber.replace(/ /g, ""),
            style: {
              color: isDropdown ? __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].WHITE : __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].BLACK,
              whiteSpace: "nowrap"
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 172
            }
          },
          item.contactNumber
        ),
        "."
      );

    case "USER_DETAILS_UPDATE":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 189
          }
        },
        "Your personal details have recently been updated. You can review and update these on the Manage Account page."
      );

    default:
      return null;
  }
};

var NotificationsDropdown = function NotificationsDropdown(_ref2) {
  var open = _ref2.open,
      buttonUrl = _ref2.buttonUrl,
      buttonLinkText = _ref2.buttonLinkText,
      notifications = _ref2.notifications;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__animated_dropdown__["a" /* default */],
    { open: open, __source: {
        fileName: _jsxFileName,
        lineNumber: 206
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: style.menu, __source: {
          fileName: _jsxFileName,
          lineNumber: 207
        }
      },
      notifications.length ? notifications.map(function (item, index) {
        var _classnames;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: index,
            style: {
              borderBottom: "1px solid #545454",
              color: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].WHITE,
              padding: "1em 3em 1.5em"
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 210
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            { style: { lineHeight: "21px", fontWeight: "200" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 218
              }
            },
            item.notificationStatus === "NEW" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
              style: {
                display: "inline-block",
                width: "10px",
                height: "10px",
                borderRadius: "10px",
                margin: "0 10px 0 -20px",
                background: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].RED
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 220
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationType, { item: item, isDropdown: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 231
              }
            })
          ),
          item.buttonUrl && item.buttonLinkText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],
            { to: item.buttonUrl, style: { textDecoration: "none" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 234
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                className: "Button " + __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_11_AtomicComponents_Button_Button_less___default.a.Button] = true, _classnames[__WEBPACK_IMPORTED_MODULE_11_AtomicComponents_Button_Button_less___default.a.ButtonFullWidth] = true, _classnames[__WEBPACK_IMPORTED_MODULE_11_AtomicComponents_Button_Button_less___default.a.ButtonWhiteOutlined] = item.notificationType !== "RECALL", _classnames[__WEBPACK_IMPORTED_MODULE_11_AtomicComponents_Button_Button_less___default.a.ButtonRed] = item.notificationType === "RECALL", _classnames)),
                onClick: function onClick() {
                  Object(__WEBPACK_IMPORTED_MODULE_13_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "MyMazda - Notifications",
                    pageAction: "Drop down \"" + item.notificationType + "\" - clicked \"" + item.buttonLinkText.toUpperCase() + "\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 235
                }
              },
              item.buttonLinkText
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 251
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 252
              }
            },
            item.notificationDate
          )
        );
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        {
          style: {
            color: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_DARK,
            padding: "3.5em 0",
            margin: "0",
            textAlign: "center",
            borderBottom: "1px solid #545454"
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 256
          }
        },
        "No unread notifications."
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { textAlign: "center" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 269
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__navigation_item__["a" /* PrimaryNavigationItem */], {
          href: buttonUrl,
          label: buttonLinkText,
          fullReload: false,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 270
          }
        })
      )
    )
  );
};

NotificationsDropdown.displayName = "NotificationsDropdown";
NotificationsDropdown.displayName = "NotificationsDropdown";
var style = {
  menu: (_menu = {
    background: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY3,
    marginLeft: "auto",
    width: "100%",
    maxHeight: "calc(100vh - 9rem)",
    overflow: "auto"
  }, _menu[__WEBPACK_IMPORTED_MODULE_10__settings__["b" /* breakpointTablet */]] = {
    width: __WEBPACK_IMPORTED_MODULE_10__settings__["d" /* dropdownWidth */],
    maxHeight: "calc(100vh - 4.5rem)"
  }, _menu)
};

NotificationsDropdown.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  buttonUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonLinkText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  notifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(NotificationsDropdown));

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__animated_arrow_icon__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__settings__ = __webpack_require__(126);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\navigation\\top-navigation-item.jsx",
    _showOnDesktop,
    _showOnCompact,
    _wrapper,
    _line,
    _extendedInfo;









var TopNavigationItem = function TopNavigationItem(_ref) {
  var label = _ref.label,
      open = _ref.open,
      onClick = _ref.onClick,
      _ref$CloseIcon = _ref.CloseIcon,
      CloseIcon = _ref$CloseIcon === undefined ? null : _ref$CloseIcon,
      _ref$Icon = _ref.Icon,
      Icon = _ref$Icon === undefined ? null : _ref$Icon,
      badge = _ref.badge;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: [styles.wrapper, open && { background: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY3, color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].WHITE }], __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.line, __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.base, onClick: onClick, __source: {
          fileName: _jsxFileName,
          lineNumber: 18
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: styles.showOnCompact, __source: {
            fileName: _jsxFileName,
            lineNumber: 19
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: open ? "open" : "closed", style: styles.closeIconAnimation, __source: {
              fileName: _jsxFileName,
              lineNumber: 21
            }
          },
          open ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["m" /* CrossIcon */], { style: styles.icon, __source: {
              fileName: _jsxFileName,
              lineNumber: 22
            }
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { style: styles.icon, __source: {
              fileName: _jsxFileName,
              lineNumber: 22
            }
          })
        ),
        !open && badge > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { style: styles.badge, __source: {
              fileName: _jsxFileName,
              lineNumber: 24
            }
          },
          badge
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: styles.showOnDesktop, __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { style: styles.icon, __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        }),
        badge > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { style: styles.badge, __source: {
              fileName: _jsxFileName,
              lineNumber: 28
            }
          },
          badge
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: styles.extendedInfo, __source: {
            fileName: _jsxFileName,
            lineNumber: 30
          }
        },
        label,
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__animated_arrow_icon__["a" /* default */], { flip: open, __source: {
            fileName: _jsxFileName,
            lineNumber: 31
          }
        })
      )
    )
  );
};

TopNavigationItem.displayName = "TopNavigationItem";
TopNavigationItem.displayName = "TopNavigationItem";
var fadeInKeyframes = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["b" /* keyframes */])({
  from: {
    opacity: 0,
    transform: "translateZ(1px) translateY(-10%)"
  }
});

var styles = {
  closeIconAnimation: {
    // add translateZ to fix position fixed glitches in IOS - https://stackoverflow.com/questions/20832531/mobile-safari-positionfixed-z-index-glitch-when-scrolling
    transform: "translateZ(1px)",
    animation: "x .25s",
    animationName: fadeInKeyframes
  },
  showOnDesktop: (_showOnDesktop = {
    display: "none"
  }, _showOnDesktop[__WEBPACK_IMPORTED_MODULE_6__settings__["b" /* breakpointTablet */]] = {
    display: "block",
    position: "relative"
  }, _showOnDesktop),
  showOnCompact: (_showOnCompact = {
    display: "block",
    position: "relative"
  }, _showOnCompact[__WEBPACK_IMPORTED_MODULE_6__settings__["b" /* breakpointTablet */]] = {
    display: "none"
  }, _showOnCompact),
  wrapper: (_wrapper = {
    position: "relative",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    transition: "background 0.66s, color .666s",
    width: "4.5rem",
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_DARK
  }, _wrapper[__WEBPACK_IMPORTED_MODULE_6__settings__["b" /* breakpointTablet */]] = {
    width: "auto",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].WHITE
    }
  }, _wrapper),
  base: {
    cursor: "pointer",
    height: "100%",
    fontWeight: 600,
    letterSpacing: "0.08em",
    display: "flex",
    alignItems: "center",
    padding: "0 1.5em"
  },
  line: (_line = {
    margin: "1em 0",
    borderLeft: "1px solid #474747",
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0
  }, _line[__WEBPACK_IMPORTED_MODULE_6__settings__["b" /* breakpointTablet */]] = {
    display: "none",
    borderLeft: "none"
  }, _line),
  extendedInfo: (_extendedInfo = {
    whiteSpace: "nowrap",
    paddingLeft: "0.5em",
    display: "none"
  }, _extendedInfo[__WEBPACK_IMPORTED_MODULE_6__settings__["b" /* breakpointTablet */]] = {
    display: "block"
  }, _extendedInfo),
  icon: {
    fill: "currentColor",
    height: "1em",
    width: "1em",
    verticalAlign: "text-top"
  },
  badge: {
    display: "inline-block",
    position: "absolute",
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].WHITE,
    top: "-4px",
    right: "-4px",
    height: "12px",
    padding: "0 4px",
    borderRadius: "6px",
    fontSize: "10px",
    background: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].RED,
    textAlign: "center",
    lineHeight: "13px",
    zIndex: "9"
  }
};

TopNavigationItem.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  CloseIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  Icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  badge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(TopNavigationItem));

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\navigation\\animated-arrow-icon.jsx";





var AnimatedArrowIcon = function AnimatedArrowIcon(_ref) {
  var flip = _ref.flip;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: style.iconStyle(flip), __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["o" /* DownArrowIcon */], { style: style.svg, __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    })
  );
};

AnimatedArrowIcon.displayName = "AnimatedArrowIcon";
AnimatedArrowIcon.displayName = "AnimatedArrowIcon";
AnimatedArrowIcon.propTypes = {
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var style = {
  iconStyle: function iconStyle(flip) {
    return {
      display: "inline-block",
      // transition: 'transform 0.25s',
      // add translateZ to fix position fixed glitches in IOS - https://stackoverflow.com/questions/20832531/mobile-safari-positionfixed-z-index-glitch-when-scrolling
      transform: flip ? "translateZ(1px) rotateX(180deg)" : "translateZ(1px) rotateX(0)",
      verticalAlign: flip ? "initial" : "middle"
    };
  },
  svg: {
    width: "12px",
    height: "12px",
    display: "block",
    fill: "currentColor"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(AnimatedArrowIcon));

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(128);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(301);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(298);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(298);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(198);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(408),
    baseIteratee = __webpack_require__(168),
    toInteger = __webpack_require__(1659);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicUtils_debounce__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var defaultConfig = {
  offset: -60,
  scrollDuration: 400,
  keepLastAnchorHash: false
};

var Manager = function Manager() {
  var _this = this;

  _classCallCheck(this, Manager);

  this.addListeners = function () {
    __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_1_AtomicUtils_debounce__["a" /* default */])(_this.scrollHandler, 250), {
      passive: true
    });
    __WEBPACK_IMPORTED_MODULE_0__utils__["w" /* history */].listen(_this.handleHashChange);
  };

  this.removeListeners = function () {
    __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_1_AtomicUtils_debounce__["a" /* default */])(_this.scrollHandler, 250), {
      passive: true
    });
  };

  this.configure = function (config) {
    _this.config = _extends({}, defaultConfig, config);
  };

  this.goToTop = function () {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* getScrollTop */])() === 0) return;
    _this.forcedHash = true;
    window.scroll(0, 0);
  };

  this.addAnchor = function (id, component) {
    // if this is the first anchor, set up listeners
    if (Object.keys(_this.anchors).length === 0) {
      _this.addListeners();
    }
    _this.forceHashUpdate();
    _this.anchors[id] = component;
  };

  this.removeAnchor = function (id) {
    delete _this.anchors[id];
    // if this is the last anchor, remove listeners
    if (Object.keys(_this.anchors).length === 0) {
      _this.removeListeners();
    }
  };

  this.handleScroll = function () {
    var _config = _this.config,
        offset = _config.offset,
        keepLastAnchorHash = _config.keepLastAnchorHash;

    var bestAnchorId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["r" /* getBestAnchorGivenScrollLocation */])(_this.anchors, offset);

    if (bestAnchorId && Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* getHash */])() !== bestAnchorId) {
      _this.forcedHash = true;
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["V" /* updateHash */])(bestAnchorId, false);
    } else if (!bestAnchorId && !keepLastAnchorHash) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["N" /* removeHash */])();
    }
  };

  this.handleHashChange = function (e) {
    if (_this.forcedHash) {
      _this.forcedHash = false;
    } else {
      _this.goToSection(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* getHash */])());
    }
  };

  this.goToSection = function (id) {
    var element = _this.anchors[id];
    if (element) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["P" /* scrollToNode */])(element, {
        duration: _this.config.scrollDuration,
        offset: _this.config.offset
      });
    } else {
      // make sure that standard hash anchors don't break.
      // simply jump to them.
      element = document.getElementById(id);
      if (element) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["P" /* scrollToNode */])(element, {
          duration: 0,
          offset: _this.config.offset
        });
      }
    }
  };

  this.anchors = {};
  this.forcedHash = false;
  this.config = defaultConfig;

  this.scrollHandler = Object(__WEBPACK_IMPORTED_MODULE_1_AtomicUtils_debounce__["a" /* default */])(this.handleScroll, 100);
  this.forceHashUpdate = Object(__WEBPACK_IMPORTED_MODULE_1_AtomicUtils_debounce__["a" /* default */])(this.handleHashChange, 1);
};

/* harmony default export */ __webpack_exports__["a"] = (new Manager());

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"slick-slider":"slick-slider","slick-list":"slick-list","dragging":"dragging","slick-track":"slick-track","slick-loading":"slick-loading","slick-slide":"slick-slide","slick-initialized":"slick-initialized","slick-vertical":"slick-vertical","slick-arrow":"slick-arrow","slick-hidden":"slick-hidden","slick-prev":"slick-prev","slick-next":"slick-next","slick-disabled":"slick-disabled","slick-dotted":"slick-dotted","slick-dots":"slick-dots","slick-active":"slick-active"};

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_actions_mymazda__ = __webpack_require__(36);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\navigation\\flash-message-banner.jsx";







var FlashMessageBanner = function FlashMessageBanner(_ref) {
  var messages = _ref.messages,
      removeMessage = _ref.removeMessage;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    messages.map(function (message, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["w" /* FlashMessge */], _extends({
        key: message.id,
        index: index,
        onDismiss: function onDismiss() {
          return removeMessage(message.id);
        }
      }, message, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 11
        }
      }));
    })
  );
};

FlashMessageBanner.displayName = "FlashMessageBanner";
FlashMessageBanner.displayName = "FlashMessageBanner";
FlashMessageBanner.propTypes = {
  messages: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    message: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })),
  removeMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    removeMessage: function removeMessage(id) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5_store_actions_mymazda__["a" /* actionCreators */].removeFlashMessage(id));
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    messages: __WEBPACK_IMPORTED_MODULE_5_store_actions_mymazda__["f" /* selectors */].getFlashMessages(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps))(FlashMessageBanner));

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function registerEvents(events, target) {
  var extensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var action = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var logger = extensions.logger,
      offlineStorage = extensions.offlineStorage;


  var ifLoggerLog = function ifLoggerLog() {
    if (typeof logger === 'function') {
      logger.apply(undefined, arguments);
    }
  };

  if (offlineStorage === undefined) {
    target(events);
    ifLoggerLog(events, action, state);
  } else if (offlineStorage.isConnected(state)) {
    target(events);
    ifLoggerLog(events, action, state);
    offlineStorage.purgeEvents(function (oldEvents) {
      if (Array.isArray(oldEvents) && oldEvents.length > 0) {
        target(oldEvents);
        ifLoggerLog(oldEvents, null, null, false, true);
      }
    });
  } else {
    offlineStorage.saveEvents(events);
    ifLoggerLog(events, action, state, true, false);
  }
}

exports.default = registerEvents;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var options = { log: console.log };

exports.default = options;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(652);

__webpack_require__(848);

__webpack_require__(849);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(653);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(666);
__webpack_require__(667);
__webpack_require__(668);
__webpack_require__(669);
__webpack_require__(670);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(675);
__webpack_require__(676);
__webpack_require__(677);
__webpack_require__(678);
__webpack_require__(679);
__webpack_require__(680);
__webpack_require__(681);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(684);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(689);
__webpack_require__(690);
__webpack_require__(691);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(694);
__webpack_require__(695);
__webpack_require__(696);
__webpack_require__(697);
__webpack_require__(698);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(703);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(708);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(711);
__webpack_require__(712);
__webpack_require__(713);
__webpack_require__(714);
__webpack_require__(715);
__webpack_require__(716);
__webpack_require__(717);
__webpack_require__(718);
__webpack_require__(719);
__webpack_require__(720);
__webpack_require__(721);
__webpack_require__(722);
__webpack_require__(723);
__webpack_require__(724);
__webpack_require__(725);
__webpack_require__(726);
__webpack_require__(727);
__webpack_require__(728);
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(732);
__webpack_require__(733);
__webpack_require__(735);
__webpack_require__(736);
__webpack_require__(737);
__webpack_require__(738);
__webpack_require__(739);
__webpack_require__(740);
__webpack_require__(741);
__webpack_require__(743);
__webpack_require__(744);
__webpack_require__(745);
__webpack_require__(746);
__webpack_require__(747);
__webpack_require__(748);
__webpack_require__(749);
__webpack_require__(750);
__webpack_require__(751);
__webpack_require__(752);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(220);
__webpack_require__(756);
__webpack_require__(325);
__webpack_require__(757);
__webpack_require__(326);
__webpack_require__(758);
__webpack_require__(759);
__webpack_require__(760);
__webpack_require__(761);
__webpack_require__(762);
__webpack_require__(329);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(763);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(770);
__webpack_require__(771);
__webpack_require__(772);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(787);
__webpack_require__(788);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(798);
__webpack_require__(799);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(802);
__webpack_require__(803);
__webpack_require__(804);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(809);
__webpack_require__(810);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(815);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(830);
__webpack_require__(831);
__webpack_require__(832);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(840);
__webpack_require__(841);
__webpack_require__(842);
__webpack_require__(843);
__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(846);
__webpack_require__(847);
module.exports = __webpack_require__(54);


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(18);
var has = __webpack_require__(48);
var DESCRIPTORS = __webpack_require__(28);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(45);
var META = __webpack_require__(82).KEY;
var $fails = __webpack_require__(19);
var shared = __webpack_require__(144);
var setToStringTag = __webpack_require__(107);
var uid = __webpack_require__(94);
var wks = __webpack_require__(23);
var wksExt = __webpack_require__(307);
var wksDefine = __webpack_require__(201);
var enumKeys = __webpack_require__(654);
var isArray = __webpack_require__(147);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(20);
var toIObject = __webpack_require__(49);
var toPrimitive = __webpack_require__(63);
var createDesc = __webpack_require__(93);
var _create = __webpack_require__(97);
var gOPNExt = __webpack_require__(310);
var $GOPD = __webpack_require__(50);
var $DP = __webpack_require__(29);
var $keys = __webpack_require__(95);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(98).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(130).f = $propertyIsEnumerable;
  __webpack_require__(146).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(83)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(44)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(95);
var gOPS = __webpack_require__(146);
var pIE = __webpack_require__(130);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(97) });


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperty: __webpack_require__(29).f });


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperties: __webpack_require__(309) });


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(49);
var $getOwnPropertyDescriptor = __webpack_require__(50).f;

__webpack_require__(65)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(31);
var $getPrototypeOf = __webpack_require__(51);

__webpack_require__(65)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(31);
var $keys = __webpack_require__(95);

__webpack_require__(65)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(65)('getOwnPropertyNames', function () {
  return __webpack_require__(310).f;
});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(82).onFreeze;

__webpack_require__(65)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(82).onFreeze;

__webpack_require__(65)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(82).onFreeze;

__webpack_require__(65)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(20);

__webpack_require__(65)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(20);

__webpack_require__(65)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(20);

__webpack_require__(65)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(6);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(311) });


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(6);
$export($export.S, 'Object', { is: __webpack_require__(312) });


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(6);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(205).set });


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(108);
var test = {};
test[__webpack_require__(23)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(45)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(6);

$export($export.P, 'Function', { bind: __webpack_require__(313) });


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(29).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(28) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(20);
var getPrototypeOf = __webpack_require__(51);
var HAS_INSTANCE = __webpack_require__(23)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(29).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
var $parseInt = __webpack_require__(315);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
var $parseFloat = __webpack_require__(316);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var has = __webpack_require__(48);
var cof = __webpack_require__(56);
var inheritIfRequired = __webpack_require__(207);
var toPrimitive = __webpack_require__(63);
var fails = __webpack_require__(19);
var gOPN = __webpack_require__(98).f;
var gOPD = __webpack_require__(50).f;
var dP = __webpack_require__(29).f;
var $trim = __webpack_require__(109).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(97)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(28) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(45)(global, NUMBER, $Number);
}


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var toInteger = __webpack_require__(57);
var aNumberValue = __webpack_require__(317);
var repeat = __webpack_require__(208);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(19)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $fails = __webpack_require__(19);
var aNumberValue = __webpack_require__(317);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(6);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(6);
var _isFinite = __webpack_require__(18).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(6);

$export($export.S, 'Number', { isInteger: __webpack_require__(318) });


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(6);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(6);
var isInteger = __webpack_require__(318);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(6);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(6);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
var $parseFloat = __webpack_require__(316);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
var $parseInt = __webpack_require__(315);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(6);
var log1p = __webpack_require__(319);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(6);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(6);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(6);
var sign = __webpack_require__(209);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(6);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(6);
var $expm1 = __webpack_require__(210);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', { fround: __webpack_require__(320) });


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(6);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(6);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(19)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', { log1p: __webpack_require__(319) });


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', { sign: __webpack_require__(209) });


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(6);
var expm1 = __webpack_require__(210);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(19)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(6);
var expm1 = __webpack_require__(210);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
var toAbsoluteIndex = __webpack_require__(96);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
var toIObject = __webpack_require__(49);
var toLength = __webpack_require__(24);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(109)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(148)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(211)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $at = __webpack_require__(148)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(6);
var toLength = __webpack_require__(24);
var context = __webpack_require__(213);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(214)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(6);
var context = __webpack_require__(213);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(214)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(208)
});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(6);
var toLength = __webpack_require__(24);
var context = __webpack_require__(213);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(214)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(46)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(46)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(46)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(46)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(46)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(46)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(46)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(46)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(46)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(46)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(46)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(46)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(46)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(6);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var toObject = __webpack_require__(31);
var toPrimitive = __webpack_require__(63);

$export($export.P + $export.F * __webpack_require__(19)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(6);
var toISOString = __webpack_require__(731);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(19);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(45)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(23)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(44)(proto, TO_PRIMITIVE, __webpack_require__(734));


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(63);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(6);

$export($export.S, 'Array', { isArray: __webpack_require__(147) });


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(55);
var $export = __webpack_require__(6);
var toObject = __webpack_require__(31);
var call = __webpack_require__(321);
var isArrayIter = __webpack_require__(215);
var toLength = __webpack_require__(24);
var createProperty = __webpack_require__(216);
var getIterFn = __webpack_require__(217);

$export($export.S + $export.F * !__webpack_require__(150)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var createProperty = __webpack_require__(216);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(19)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(6);
var toIObject = __webpack_require__(49);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(129) != Object || !__webpack_require__(58)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var html = __webpack_require__(204);
var cof = __webpack_require__(56);
var toAbsoluteIndex = __webpack_require__(96);
var toLength = __webpack_require__(24);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(19)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var aFunction = __webpack_require__(38);
var toObject = __webpack_require__(31);
var fails = __webpack_require__(19);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(58)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $forEach = __webpack_require__(66)(0);
var STRICT = __webpack_require__(58)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var isArray = __webpack_require__(147);
var SPECIES = __webpack_require__(23)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $map = __webpack_require__(66)(1);

$export($export.P + $export.F * !__webpack_require__(58)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $filter = __webpack_require__(66)(2);

$export($export.P + $export.F * !__webpack_require__(58)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $some = __webpack_require__(66)(3);

$export($export.P + $export.F * !__webpack_require__(58)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $every = __webpack_require__(66)(4);

$export($export.P + $export.F * !__webpack_require__(58)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $reduce = __webpack_require__(322);

$export($export.P + $export.F * !__webpack_require__(58)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $reduce = __webpack_require__(322);

$export($export.P + $export.F * !__webpack_require__(58)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $indexOf = __webpack_require__(145)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(58)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var toIObject = __webpack_require__(49);
var toInteger = __webpack_require__(57);
var toLength = __webpack_require__(24);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(58)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(6);

$export($export.P, 'Array', { copyWithin: __webpack_require__(323) });

__webpack_require__(84)('copyWithin');


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(6);

$export($export.P, 'Array', { fill: __webpack_require__(219) });

__webpack_require__(84)('fill');


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(6);
var $find = __webpack_require__(66)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(84)(KEY);


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(6);
var $find = __webpack_require__(66)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(84)(KEY);


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99)('Array');


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var inheritIfRequired = __webpack_require__(207);
var dP = __webpack_require__(29).f;
var gOPN = __webpack_require__(98).f;
var isRegExp = __webpack_require__(149);
var $flags = __webpack_require__(131);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(28) && (!CORRECT_NEW || __webpack_require__(19)(function () {
  re2[__webpack_require__(23)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(45)(global, 'RegExp', $RegExp);
}

__webpack_require__(99)('RegExp');


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(326);
var anObject = __webpack_require__(16);
var $flags = __webpack_require__(131);
var DESCRIPTORS = __webpack_require__(28);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(45)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(19)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(16);
var toLength = __webpack_require__(24);
var advanceStringIndex = __webpack_require__(222);
var regExpExec = __webpack_require__(151);

// @@match logic
__webpack_require__(152)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(16);
var toObject = __webpack_require__(31);
var toLength = __webpack_require__(24);
var toInteger = __webpack_require__(57);
var advanceStringIndex = __webpack_require__(222);
var regExpExec = __webpack_require__(151);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(152)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(16);
var sameValue = __webpack_require__(312);
var regExpExec = __webpack_require__(151);

// @@search logic
__webpack_require__(152)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(149);
var anObject = __webpack_require__(16);
var speciesConstructor = __webpack_require__(132);
var advanceStringIndex = __webpack_require__(222);
var toLength = __webpack_require__(24);
var callRegExpExec = __webpack_require__(151);
var regexpExec = __webpack_require__(221);
var fails = __webpack_require__(19);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(152)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(83);
var global = __webpack_require__(18);
var ctx = __webpack_require__(55);
var classof = __webpack_require__(108);
var $export = __webpack_require__(6);
var isObject = __webpack_require__(20);
var aFunction = __webpack_require__(38);
var anInstance = __webpack_require__(100);
var forOf = __webpack_require__(101);
var speciesConstructor = __webpack_require__(132);
var task = __webpack_require__(223).set;
var microtask = __webpack_require__(224)();
var newPromiseCapabilityModule = __webpack_require__(225);
var perform = __webpack_require__(327);
var userAgent = __webpack_require__(153);
var promiseResolve = __webpack_require__(328);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(23)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(102)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(107)($Promise, PROMISE);
__webpack_require__(99)(PROMISE);
Wrapper = __webpack_require__(54)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(150)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(333);
var validate = __webpack_require__(111);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(154)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var $typed = __webpack_require__(155);
var buffer = __webpack_require__(226);
var anObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(96);
var toLength = __webpack_require__(24);
var isObject = __webpack_require__(20);
var ArrayBuffer = __webpack_require__(18).ArrayBuffer;
var speciesConstructor = __webpack_require__(132);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(19)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(99)(ARRAY_BUFFER);


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
$export($export.G + $export.W + $export.F * !__webpack_require__(155).ABV, {
  DataView: __webpack_require__(226).DataView
});


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(6);
var aFunction = __webpack_require__(38);
var anObject = __webpack_require__(16);
var rApply = (__webpack_require__(18).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(19)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(6);
var create = __webpack_require__(97);
var aFunction = __webpack_require__(38);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(19);
var bind = __webpack_require__(313);
var rConstruct = (__webpack_require__(18).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(29);
var $export = __webpack_require__(6);
var anObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(63);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(19)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(6);
var gOPD = __webpack_require__(50).f;
var anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(6);
var anObject = __webpack_require__(16);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(212)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(50);
var getPrototypeOf = __webpack_require__(51);
var has = __webpack_require__(48);
var $export = __webpack_require__(6);
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(16);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(50);
var $export = __webpack_require__(6);
var anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(6);
var getProto = __webpack_require__(51);
var anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(6);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(6);
var anObject = __webpack_require__(16);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(6);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(335) });


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(6);
var anObject = __webpack_require__(16);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(29);
var gOPD = __webpack_require__(50);
var getPrototypeOf = __webpack_require__(51);
var has = __webpack_require__(48);
var $export = __webpack_require__(6);
var createDesc = __webpack_require__(93);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(20);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(6);
var setProto = __webpack_require__(205);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(6);
var $includes = __webpack_require__(145)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(84)('includes');


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(6);
var flattenIntoArray = __webpack_require__(336);
var toObject = __webpack_require__(31);
var toLength = __webpack_require__(24);
var aFunction = __webpack_require__(38);
var arraySpeciesCreate = __webpack_require__(218);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(84)('flatMap');


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(6);
var flattenIntoArray = __webpack_require__(336);
var toObject = __webpack_require__(31);
var toLength = __webpack_require__(24);
var toInteger = __webpack_require__(57);
var arraySpeciesCreate = __webpack_require__(218);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(84)('flatten');


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(6);
var $at = __webpack_require__(148)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(6);
var $pad = __webpack_require__(337);
var userAgent = __webpack_require__(153);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(6);
var $pad = __webpack_require__(337);
var userAgent = __webpack_require__(153);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(109)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(109)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(6);
var defined = __webpack_require__(64);
var toLength = __webpack_require__(24);
var isRegExp = __webpack_require__(149);
var getFlags = __webpack_require__(131);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(212)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(201)('asyncIterator');


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(201)('observable');


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(6);
var ownKeys = __webpack_require__(335);
var toIObject = __webpack_require__(49);
var gOPD = __webpack_require__(50);
var createProperty = __webpack_require__(216);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(6);
var $values = __webpack_require__(338)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(6);
var $entries = __webpack_require__(338)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var toObject = __webpack_require__(31);
var aFunction = __webpack_require__(38);
var $defineProperty = __webpack_require__(29);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(28) && $export($export.P + __webpack_require__(156), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var toObject = __webpack_require__(31);
var aFunction = __webpack_require__(38);
var $defineProperty = __webpack_require__(29);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(28) && $export($export.P + __webpack_require__(156), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var toObject = __webpack_require__(31);
var toPrimitive = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(51);
var getOwnPropertyDescriptor = __webpack_require__(50).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(28) && $export($export.P + __webpack_require__(156), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6);
var toObject = __webpack_require__(31);
var toPrimitive = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(51);
var getOwnPropertyDescriptor = __webpack_require__(50).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(28) && $export($export.P + __webpack_require__(156), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(6);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(339)('Map') });


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(6);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(339)('Set') });


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(157)('Map');


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(157)('Set');


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(157)('WeakMap');


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(157)('WeakSet');


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(158)('Map');


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(158)('Set');


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(158)('WeakMap');


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(158)('WeakSet');


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(6);

$export($export.G, { global: __webpack_require__(18) });


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(6);

$export($export.S, 'System', { global: __webpack_require__(18) });


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(6);
var cof = __webpack_require__(56);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);
var scale = __webpack_require__(341);
var fround = __webpack_require__(320);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);

$export($export.S, 'Math', { scale: __webpack_require__(341) });


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(6);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(6);
var core = __webpack_require__(54);
var global = __webpack_require__(18);
var speciesConstructor = __webpack_require__(132);
var promiseResolve = __webpack_require__(328);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(6);
var newPromiseCapability = __webpack_require__(225);
var perform = __webpack_require__(327);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(74);
var anObject = __webpack_require__(16);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(74);
var anObject = __webpack_require__(16);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(74);
var anObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(51);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(331);
var from = __webpack_require__(340);
var metadata = __webpack_require__(74);
var anObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(51);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(74);
var anObject = __webpack_require__(16);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(74);
var anObject = __webpack_require__(16);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(74);
var anObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(51);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(74);
var anObject = __webpack_require__(16);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(74);
var anObject = __webpack_require__(16);
var aFunction = __webpack_require__(38);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(6);
var microtask = __webpack_require__(224)();
var process = __webpack_require__(18).process;
var isNode = __webpack_require__(56)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(6);
var global = __webpack_require__(18);
var core = __webpack_require__(54);
var microtask = __webpack_require__(224)();
var OBSERVABLE = __webpack_require__(23)('observable');
var aFunction = __webpack_require__(38);
var anObject = __webpack_require__(16);
var anInstance = __webpack_require__(100);
var redefineAll = __webpack_require__(102);
var hide = __webpack_require__(44);
var forOf = __webpack_require__(101);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(99)('Observable');


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(18);
var $export = __webpack_require__(6);
var userAgent = __webpack_require__(153);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
var $task = __webpack_require__(223);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(220);
var getKeys = __webpack_require__(95);
var redefine = __webpack_require__(45);
var global = __webpack_require__(18);
var hide = __webpack_require__(44);
var Iterators = __webpack_require__(110);
var wks = __webpack_require__(23);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(850);
module.exports = __webpack_require__(54).RegExp.escape;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(6);
var $re = __webpack_require__(851)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(1784);

var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
      ? global
      : typeof self !== 'undefined'
        ? self
        : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
}

function isDOMError(value) {
  return Object.prototype.toString.call(value) === '[object DOMError]';
}

function isDOMException(value) {
  return Object.prototype.toString.call(value) === '[object DOMException]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMError() {
  try {
    new DOMError(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMException() {
  try {
    new DOMException(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if stacktrace is malformed
  if (frames1 === undefined || frames2 === undefined) return false;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'undefined'
  ) {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]')
    return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function(acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function(val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function(key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
    return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function(val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function(acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isDOMError: isDOMError,
  isDOMException: isDOMException,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsDOMError: supportsDOMError,
  supportsDOMException: supportsDOMException,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_radium__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_animations_lib_fade_in__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_animations_lib_fade_in___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_animations_lib_fade_in__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_animations_lib_slide_in_left__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_animations_lib_slide_in_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_animations_lib_slide_in_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_animations_lib_slide_in_up__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_animations_lib_slide_in_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_animations_lib_slide_in_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_animations_lib_bounce_in_right__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_animations_lib_bounce_in_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_animations_lib_bounce_in_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_animations_lib_zoom_in_down__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_animations_lib_zoom_in_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_animations_lib_zoom_in_down__);









var animate = function animate(animation) {
  var myAnimation = {
    animation: "x .5s",
    animationName: __WEBPACK_IMPORTED_MODULE_0_radium___default.a.keyframes(__WEBPACK_IMPORTED_MODULE_2_react_animations_lib_fade_in___default.a, "fadeIn")
  };

  if (animation) {
    if (animation.duration) {
      myAnimation.animation = "x " + animation.duration + "ms";
    }

    switch (animation.effect) {
      case "fadeIn":
        myAnimation.animationName = __WEBPACK_IMPORTED_MODULE_0_radium___default.a.keyframes(__WEBPACK_IMPORTED_MODULE_2_react_animations_lib_fade_in___default.a, "fadeIn");
        break;
      case "slideInLeft":
        myAnimation.animationName = __WEBPACK_IMPORTED_MODULE_0_radium___default.a.keyframes(__WEBPACK_IMPORTED_MODULE_3_react_animations_lib_slide_in_left___default.a, "slideInLeft");
        break;
      case "slideInUp":
        myAnimation.animationName = __WEBPACK_IMPORTED_MODULE_0_radium___default.a.keyframes(__WEBPACK_IMPORTED_MODULE_4_react_animations_lib_slide_in_up___default.a, "slideInUp");
        break;
      case "bounceInRight":
        myAnimation.animationName = __WEBPACK_IMPORTED_MODULE_0_radium___default.a.keyframes(__WEBPACK_IMPORTED_MODULE_5_react_animations_lib_bounce_in_right___default.a, "bounceInRight");
        break;
      case "zoomInDown":
        myAnimation.animationName = __WEBPACK_IMPORTED_MODULE_0_radium___default.a.keyframes(__WEBPACK_IMPORTED_MODULE_6_react_animations_lib_zoom_in_down___default.a, "zoomInDown");
        break;
      case "cut":
        myAnimation.animationName = __WEBPACK_IMPORTED_MODULE_0_radium___default.a.keyframes(cutKeyframes, "cut");
        break;
      default:
        myAnimation.animationName = __WEBPACK_IMPORTED_MODULE_0_radium___default.a.keyframes(__WEBPACK_IMPORTED_MODULE_2_react_animations_lib_fade_in___default.a, "fadeIn");
    }
  }

  return myAnimation;
};

var cutKeyframes = Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___["b" /* keyframes */])({
  from: {
    opacity: 1
  }
});

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.7.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(53),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,A=n?Symbol.for("react.memo"):
60115,B=n?Symbol.for("react.lazy"):60116,C="function"===typeof Symbol&&Symbol.iterator;function aa(a,b,e,c,d,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[e,c,d,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},F={};
function G(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}G.prototype.isReactComponent={};G.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};G.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function H(){}H.prototype=G.prototype;function I(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}var J=I.prototype=new H;
J.constructor=I;k(J,G.prototype);J.isPureReactComponent=!0;var K={current:null,currentDispatcher:null},L=Object.prototype.hasOwnProperty,M={key:!0,ref:!0,__self:!0,__source:!0};
function N(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:d,_owner:K.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,e,c){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return e(c,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+U(d,h);g+=T(d,f,e,c)}else if(null===a||"object"!==typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,h++),g+=T(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function V(a,b,e){return null==a?0:T(a,"",b,e)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,function(a){return a}):null!=a&&(O(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(P,"$&/")+"/");b=R(b,g,c,d);V(a,da,b);S(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=R(null,null,b,e);V(a,ca,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){O(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:G,PureComponent:I,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:B,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:A,type:a,compare:void 0===b?null:b}},Fragment:r,StrictMode:t,Suspense:z,createElement:N,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;
if(null!=b){void 0!==b.ref&&(h=b.ref,f=K.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=N.bind(null,a);b.type=a;return b},isValidElement:O,version:"16.7.0",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:K,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(856);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = appendImportantToEachValue;

var _appendPxIfNeeded = __webpack_require__(345);

var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);

var _mapObject = __webpack_require__(346);

var _mapObject2 = _interopRequireDefault(_mapObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function appendImportantToEachValue(style) {
  return (0, _mapObject2.default)(style, function (result, key) {
    return (0, _appendPxIfNeeded2.default)(key, style[key]) + ' !important';
  });
}
module.exports = exports['default'];

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(859);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(348);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(349);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(350);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports['default'];

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(230);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = (0, _capitalizeString2.default)(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}
module.exports = exports['default'];

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createPrefixer;

var _getBrowserInformation = __webpack_require__(861);

var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);

var _getPrefixedKeyframes = __webpack_require__(863);

var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);

var _capitalizeString = __webpack_require__(230);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _addNewValuesOnly = __webpack_require__(349);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(350);

var _isObject2 = _interopRequireDefault(_isObject);

var _prefixValue = __webpack_require__(348);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
    return style;
  };

  return function () {
    /**
     * Instantiante a new prefixer
     * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
     * @param {string} keepUnprefixed - keeps unprefixed properties and values
     */
    function Prefixer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Prefixer);

      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

      this._userAgent = options.userAgent || defaultUserAgent;
      this._keepUnprefixed = options.keepUnprefixed || false;

      if (this._userAgent) {
        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
      }

      // Checks if the userAgent was resolved correctly
      if (this._browserInfo && this._browserInfo.cssPrefix) {
        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
      } else {
        this._useFallback = true;
        return false;
      }

      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
      if (prefixData) {
        this._requiresPrefix = {};

        for (var property in prefixData) {
          if (prefixData[property] >= this._browserInfo.browserVersion) {
            this._requiresPrefix[property] = true;
          }
        }

        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
      } else {
        this._useFallback = true;
      }

      this._metaData = {
        browserVersion: this._browserInfo.browserVersion,
        browserName: this._browserInfo.browserName,
        cssPrefix: this._browserInfo.cssPrefix,
        jsPrefix: this._browserInfo.jsPrefix,
        keepUnprefixed: this._keepUnprefixed,
        requiresPrefix: this._requiresPrefix
      };
    }

    _createClass(Prefixer, [{
      key: 'prefix',
      value: function prefix(style) {
        // use static prefixer as fallback if userAgent can not be resolved
        if (this._useFallback) {
          return fallback(style);
        }

        // only add prefixes if needed
        if (!this._hasPropsRequiringPrefix) {
          return style;
        }

        return this._prefixStyle(style);
      }
    }, {
      key: '_prefixStyle',
      value: function _prefixStyle(style) {
        for (var property in style) {
          var value = style[property];

          // handle nested objects
          if ((0, _isObject2.default)(value)) {
            style[property] = this.prefix(value);
            // handle array values
          } else if (Array.isArray(value)) {
            var combinedValue = [];

            for (var i = 0, len = value.length; i < len; ++i) {
              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
            }

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (combinedValue.length > 0) {
              style[property] = combinedValue;
            }
          } else {
            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (_processedValue) {
              style[property] = _processedValue;
            }

            // add prefixes to properties
            if (this._requiresPrefix.hasOwnProperty(property)) {
              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
              if (!this._keepUnprefixed) {
                delete style[property];
              }
            }
          }
        }

        return style;
      }

      /**
       * Returns a prefixed version of the style object using all vendor prefixes
       * @param {Object} styles - Style object that gets prefixed properties added
       * @returns {Object} - Style object with prefixed properties and values
       */

    }], [{
      key: 'prefixAll',
      value: function prefixAll(styles) {
        return fallback(styles);
      }
    }]);

    return Prefixer;
  }();
}
module.exports = exports['default'];

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBrowserInformation;

var _bowser = __webpack_require__(67);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixByBrowser = {
  chrome: 'Webkit',
  safari: 'Webkit',
  ios: 'Webkit',
  android: 'Webkit',
  phantom: 'Webkit',
  opera: 'Webkit',
  webos: 'Webkit',
  blackberry: 'Webkit',
  bada: 'Webkit',
  tizen: 'Webkit',
  chromium: 'Webkit',
  vivaldi: 'Webkit',
  firefox: 'Moz',
  seamoney: 'Moz',
  sailfish: 'Moz',
  msie: 'ms',
  msedge: 'ms'
};


var browserByCanIuseAlias = {
  chrome: 'chrome',
  chromium: 'chrome',
  safari: 'safari',
  firfox: 'firefox',
  msedge: 'edge',
  opera: 'opera',
  vivaldi: 'opera',
  msie: 'ie'
};

function getBrowserName(browserInfo) {
  if (browserInfo.firefox) {
    return 'firefox';
  }

  if (browserInfo.mobile || browserInfo.tablet) {
    if (browserInfo.ios) {
      return 'ios_saf';
    } else if (browserInfo.android) {
      return 'android';
    } else if (browserInfo.opera) {
      return 'op_mini';
    }
  }

  for (var browser in browserByCanIuseAlias) {
    if (browserInfo.hasOwnProperty(browser)) {
      return browserByCanIuseAlias[browser];
    }
  }
}

/**
 * Uses bowser to get default browser browserInformation such as version and name
 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
 * @param {string} userAgent - userAgent that gets evaluated
 */
function getBrowserInformation(userAgent) {
  var browserInfo = _bowser2.default._detect(userAgent);

  if (browserInfo.yandexbrowser) {
    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
  }

  for (var browser in prefixByBrowser) {
    if (browserInfo.hasOwnProperty(browser)) {
      var prefix = prefixByBrowser[browser];

      browserInfo.jsPrefix = prefix;
      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
      break;
    }
  }

  browserInfo.browserName = getBrowserName(browserInfo);

  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  if (browserInfo.version) {
    browserInfo.browserVersion = parseFloat(browserInfo.version);
  } else {
    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
  }

  browserInfo.osVersion = parseFloat(browserInfo.osversion);

  // iOS forces all browsers to use Safari under the hood
  // as the Safari version seems to match the iOS version
  // we just explicitely use the osversion instead
  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
    browserInfo.browserName = 'and_chr';
  }

  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // Samsung browser are basically build on Chrome > 44
  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
    browserInfo.browserName = 'and_chr';
    browserInfo.browserVersion = 44;
  }

  return browserInfo;
}
module.exports = exports['default'];

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedKeyframes;
function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
  var prefixedKeyframes = 'keyframes';

  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
    return cssPrefix + prefixedKeyframes;
  }
  return prefixedKeyframes;
}
module.exports = exports['default'];

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(865);

var _calc2 = _interopRequireDefault(_calc);

var _crossFade = __webpack_require__(866);

var _crossFade2 = _interopRequireDefault(_crossFade);

var _cursor = __webpack_require__(867);

var _cursor2 = _interopRequireDefault(_cursor);

var _filter = __webpack_require__(868);

var _filter2 = _interopRequireDefault(_filter);

var _flex = __webpack_require__(869);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(870);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(871);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(872);

var _gradient2 = _interopRequireDefault(_gradient);

var _imageSet = __webpack_require__(873);

var _imageSet2 = _interopRequireDefault(_imageSet);

var _position = __webpack_require__(874);

var _position2 = _interopRequireDefault(_position);

var _sizing = __webpack_require__(875);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(876);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var w = ['Webkit'];
var m = ['Moz'];
var ms = ['ms'];
var wm = ['Webkit', 'Moz'];
var wms = ['Webkit', 'ms'];
var wmms = ['Webkit', 'Moz', 'ms'];

exports.default = {
  plugins: [_calc2.default, _crossFade2.default, _cursor2.default, _filter2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default],
  prefixMap: {
    transform: wms,
    transformOrigin: wms,
    transformOriginX: wms,
    transformOriginY: wms,
    backfaceVisibility: w,
    perspective: w,
    perspectiveOrigin: w,
    transformStyle: w,
    transformOriginZ: w,
    animation: w,
    animationDelay: w,
    animationDirection: w,
    animationFillMode: w,
    animationDuration: w,
    animationIterationCount: w,
    animationName: w,
    animationPlayState: w,
    animationTimingFunction: w,
    appearance: wm,
    userSelect: wmms,
    fontKerning: w,
    textEmphasisPosition: w,
    textEmphasis: w,
    textEmphasisStyle: w,
    textEmphasisColor: w,
    boxDecorationBreak: w,
    clipPath: w,
    maskImage: w,
    maskMode: w,
    maskRepeat: w,
    maskPosition: w,
    maskClip: w,
    maskOrigin: w,
    maskSize: w,
    maskComposite: w,
    mask: w,
    maskBorderSource: w,
    maskBorderMode: w,
    maskBorderSlice: w,
    maskBorderWidth: w,
    maskBorderOutset: w,
    maskBorderRepeat: w,
    maskBorder: w,
    maskType: w,
    textDecorationStyle: wm,
    textDecorationSkip: wm,
    textDecorationLine: wm,
    textDecorationColor: wm,
    filter: w,
    fontFeatureSettings: wm,
    breakAfter: wmms,
    breakBefore: wmms,
    breakInside: wmms,
    columnCount: wm,
    columnFill: wm,
    columnGap: wm,
    columnRule: wm,
    columnRuleColor: wm,
    columnRuleStyle: wm,
    columnRuleWidth: wm,
    columns: wm,
    columnSpan: wm,
    columnWidth: wm,
    writingMode: wms,
    flex: wms,
    flexBasis: w,
    flexDirection: wms,
    flexGrow: w,
    flexFlow: wms,
    flexShrink: w,
    flexWrap: wms,
    alignContent: w,
    alignItems: w,
    alignSelf: w,
    justifyContent: w,
    order: w,
    transitionDelay: w,
    transitionDuration: w,
    transitionProperty: w,
    transitionTimingFunction: w,
    backdropFilter: w,
    scrollSnapType: wms,
    scrollSnapPointsX: wms,
    scrollSnapPointsY: wms,
    scrollSnapDestination: wms,
    scrollSnapCoordinate: wms,
    shapeImageThreshold: w,
    shapeImageMargin: w,
    shapeImageOutside: w,
    hyphens: wmms,
    flowInto: wms,
    flowFrom: wms,
    regionFragment: wms,
    boxSizing: m,
    textAlignLast: m,
    tabSize: m,
    wrapFlow: ms,
    wrapThrough: ms,
    wrapMargin: ms,
    touchAction: ms,
    gridTemplateColumns: ms,
    gridTemplateRows: ms,
    gridTemplateAreas: ms,
    gridTemplate: ms,
    gridAutoColumns: ms,
    gridAutoRows: ms,
    gridAutoFlow: ms,
    grid: ms,
    gridRowStart: ms,
    gridColumnStart: ms,
    gridRowEnd: ms,
    gridRow: ms,
    gridColumn: ms,
    gridColumnEnd: ms,
    gridColumnGap: ms,
    gridRowGap: ms,
    gridArea: ms,
    gridGap: ms,
    textSizeAdjust: wms,
    borderImage: w,
    borderImageOutset: w,
    borderImageRepeat: w,
    borderImageSlice: w,
    borderImageSource: w,
    borderImageWidth: w
  }
};
module.exports = exports['default'];

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _isPrefixedValue = __webpack_require__(112);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(112);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(112);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style) {
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(112);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return value.replace(values, function (grad) {
        return prefix + grad;
      });
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(112);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
module.exports = exports['default'];

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(351);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(112);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(230);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(879);

var _calc2 = _interopRequireDefault(_calc);

var _crossFade = __webpack_require__(880);

var _crossFade2 = _interopRequireDefault(_crossFade);

var _cursor = __webpack_require__(881);

var _cursor2 = _interopRequireDefault(_cursor);

var _filter = __webpack_require__(882);

var _filter2 = _interopRequireDefault(_filter);

var _flex = __webpack_require__(883);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(884);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(885);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(886);

var _gradient2 = _interopRequireDefault(_gradient);

var _imageSet = __webpack_require__(887);

var _imageSet2 = _interopRequireDefault(_imageSet);

var _position = __webpack_require__(888);

var _position2 = _interopRequireDefault(_position);

var _sizing = __webpack_require__(889);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(890);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _crossFade2.default, _cursor2.default, _filter2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default],
  prefixMap: {
    chrome: {
      transform: 35,
      transformOrigin: 35,
      transformOriginX: 35,
      transformOriginY: 35,
      backfaceVisibility: 35,
      perspective: 35,
      perspectiveOrigin: 35,
      transformStyle: 35,
      transformOriginZ: 35,
      animation: 42,
      animationDelay: 42,
      animationDirection: 42,
      animationFillMode: 42,
      animationDuration: 42,
      animationIterationCount: 42,
      animationName: 42,
      animationPlayState: 42,
      animationTimingFunction: 42,
      appearance: 66,
      userSelect: 53,
      fontKerning: 32,
      textEmphasisPosition: 66,
      textEmphasis: 66,
      textEmphasisStyle: 66,
      textEmphasisColor: 66,
      boxDecorationBreak: 66,
      clipPath: 54,
      maskImage: 66,
      maskMode: 66,
      maskRepeat: 66,
      maskPosition: 66,
      maskClip: 66,
      maskOrigin: 66,
      maskSize: 66,
      maskComposite: 66,
      mask: 66,
      maskBorderSource: 66,
      maskBorderMode: 66,
      maskBorderSlice: 66,
      maskBorderWidth: 66,
      maskBorderOutset: 66,
      maskBorderRepeat: 66,
      maskBorder: 66,
      maskType: 66,
      textDecorationStyle: 56,
      textDecorationSkip: 56,
      textDecorationLine: 56,
      textDecorationColor: 56,
      filter: 52,
      fontFeatureSettings: 47,
      breakAfter: 49,
      breakBefore: 49,
      breakInside: 49,
      columnCount: 49,
      columnFill: 49,
      columnGap: 49,
      columnRule: 49,
      columnRuleColor: 49,
      columnRuleStyle: 49,
      columnRuleWidth: 49,
      columns: 49,
      columnSpan: 49,
      columnWidth: 49,
      writingMode: 47
    },
    safari: {
      flex: 8,
      flexBasis: 8,
      flexDirection: 8,
      flexGrow: 8,
      flexFlow: 8,
      flexShrink: 8,
      flexWrap: 8,
      alignContent: 8,
      alignItems: 8,
      alignSelf: 8,
      justifyContent: 8,
      order: 8,
      transition: 6,
      transitionDelay: 6,
      transitionDuration: 6,
      transitionProperty: 6,
      transitionTimingFunction: 6,
      transform: 8,
      transformOrigin: 8,
      transformOriginX: 8,
      transformOriginY: 8,
      backfaceVisibility: 8,
      perspective: 8,
      perspectiveOrigin: 8,
      transformStyle: 8,
      transformOriginZ: 8,
      animation: 8,
      animationDelay: 8,
      animationDirection: 8,
      animationFillMode: 8,
      animationDuration: 8,
      animationIterationCount: 8,
      animationName: 8,
      animationPlayState: 8,
      animationTimingFunction: 8,
      appearance: 11,
      userSelect: 11,
      backdropFilter: 11,
      fontKerning: 9,
      scrollSnapType: 10.1,
      scrollSnapPointsX: 10.1,
      scrollSnapPointsY: 10.1,
      scrollSnapDestination: 10.1,
      scrollSnapCoordinate: 10.1,
      textEmphasisPosition: 7,
      textEmphasis: 7,
      textEmphasisStyle: 7,
      textEmphasisColor: 7,
      boxDecorationBreak: 11,
      clipPath: 11,
      maskImage: 11,
      maskMode: 11,
      maskRepeat: 11,
      maskPosition: 11,
      maskClip: 11,
      maskOrigin: 11,
      maskSize: 11,
      maskComposite: 11,
      mask: 11,
      maskBorderSource: 11,
      maskBorderMode: 11,
      maskBorderSlice: 11,
      maskBorderWidth: 11,
      maskBorderOutset: 11,
      maskBorderRepeat: 11,
      maskBorder: 11,
      maskType: 11,
      textDecorationStyle: 11,
      textDecorationSkip: 11,
      textDecorationLine: 11,
      textDecorationColor: 11,
      shapeImageThreshold: 10,
      shapeImageMargin: 10,
      shapeImageOutside: 10,
      filter: 9,
      hyphens: 11,
      flowInto: 11,
      flowFrom: 11,
      breakBefore: 8,
      breakAfter: 8,
      breakInside: 8,
      regionFragment: 11,
      columnCount: 8,
      columnFill: 8,
      columnGap: 8,
      columnRule: 8,
      columnRuleColor: 8,
      columnRuleStyle: 8,
      columnRuleWidth: 8,
      columns: 8,
      columnSpan: 8,
      columnWidth: 8,
      writingMode: 10.1
    },
    firefox: {
      appearance: 60,
      userSelect: 60,
      boxSizing: 28,
      textAlignLast: 48,
      textDecorationStyle: 35,
      textDecorationSkip: 35,
      textDecorationLine: 35,
      textDecorationColor: 35,
      tabSize: 60,
      hyphens: 42,
      fontFeatureSettings: 33,
      breakAfter: 51,
      breakBefore: 51,
      breakInside: 51,
      columnCount: 51,
      columnFill: 51,
      columnGap: 51,
      columnRule: 51,
      columnRuleColor: 51,
      columnRuleStyle: 51,
      columnRuleWidth: 51,
      columns: 51,
      columnSpan: 51,
      columnWidth: 51
    },
    opera: {
      flex: 16,
      flexBasis: 16,
      flexDirection: 16,
      flexGrow: 16,
      flexFlow: 16,
      flexShrink: 16,
      flexWrap: 16,
      alignContent: 16,
      alignItems: 16,
      alignSelf: 16,
      justifyContent: 16,
      order: 16,
      transform: 22,
      transformOrigin: 22,
      transformOriginX: 22,
      transformOriginY: 22,
      backfaceVisibility: 22,
      perspective: 22,
      perspectiveOrigin: 22,
      transformStyle: 22,
      transformOriginZ: 22,
      animation: 29,
      animationDelay: 29,
      animationDirection: 29,
      animationFillMode: 29,
      animationDuration: 29,
      animationIterationCount: 29,
      animationName: 29,
      animationPlayState: 29,
      animationTimingFunction: 29,
      appearance: 50,
      userSelect: 40,
      fontKerning: 19,
      textEmphasisPosition: 50,
      textEmphasis: 50,
      textEmphasisStyle: 50,
      textEmphasisColor: 50,
      boxDecorationBreak: 50,
      clipPath: 41,
      maskImage: 50,
      maskMode: 50,
      maskRepeat: 50,
      maskPosition: 50,
      maskClip: 50,
      maskOrigin: 50,
      maskSize: 50,
      maskComposite: 50,
      mask: 50,
      maskBorderSource: 50,
      maskBorderMode: 50,
      maskBorderSlice: 50,
      maskBorderWidth: 50,
      maskBorderOutset: 50,
      maskBorderRepeat: 50,
      maskBorder: 50,
      maskType: 50,
      textDecorationStyle: 43,
      textDecorationSkip: 43,
      textDecorationLine: 43,
      textDecorationColor: 43,
      filter: 39,
      fontFeatureSettings: 34,
      breakAfter: 36,
      breakBefore: 36,
      breakInside: 36,
      columnCount: 36,
      columnFill: 36,
      columnGap: 36,
      columnRule: 36,
      columnRuleColor: 36,
      columnRuleStyle: 36,
      columnRuleWidth: 36,
      columns: 36,
      columnSpan: 36,
      columnWidth: 36,
      writingMode: 34
    },
    ie: {
      flex: 10,
      flexDirection: 10,
      flexFlow: 10,
      flexWrap: 10,
      transform: 9,
      transformOrigin: 9,
      transformOriginX: 9,
      transformOriginY: 9,
      userSelect: 11,
      wrapFlow: 11,
      wrapThrough: 11,
      wrapMargin: 11,
      scrollSnapType: 11,
      scrollSnapPointsX: 11,
      scrollSnapPointsY: 11,
      scrollSnapDestination: 11,
      scrollSnapCoordinate: 11,
      touchAction: 10,
      hyphens: 11,
      flowInto: 11,
      flowFrom: 11,
      breakBefore: 11,
      breakAfter: 11,
      breakInside: 11,
      regionFragment: 11,
      gridTemplateColumns: 11,
      gridTemplateRows: 11,
      gridTemplateAreas: 11,
      gridTemplate: 11,
      gridAutoColumns: 11,
      gridAutoRows: 11,
      gridAutoFlow: 11,
      grid: 11,
      gridRowStart: 11,
      gridColumnStart: 11,
      gridRowEnd: 11,
      gridRow: 11,
      gridColumn: 11,
      gridColumnEnd: 11,
      gridColumnGap: 11,
      gridRowGap: 11,
      gridArea: 11,
      gridGap: 11,
      textSizeAdjust: 11,
      writingMode: 11
    },
    edge: {
      userSelect: 17,
      wrapFlow: 17,
      wrapThrough: 17,
      wrapMargin: 17,
      scrollSnapType: 17,
      scrollSnapPointsX: 17,
      scrollSnapPointsY: 17,
      scrollSnapDestination: 17,
      scrollSnapCoordinate: 17,
      hyphens: 17,
      flowInto: 17,
      flowFrom: 17,
      breakBefore: 17,
      breakAfter: 17,
      breakInside: 17,
      regionFragment: 17,
      gridTemplateColumns: 15,
      gridTemplateRows: 15,
      gridTemplateAreas: 15,
      gridTemplate: 15,
      gridAutoColumns: 15,
      gridAutoRows: 15,
      gridAutoFlow: 15,
      grid: 15,
      gridRowStart: 15,
      gridColumnStart: 15,
      gridRowEnd: 15,
      gridRow: 15,
      gridColumn: 15,
      gridColumnEnd: 15,
      gridColumnGap: 15,
      gridRowGap: 15,
      gridArea: 15,
      gridGap: 15
    },
    ios_saf: {
      flex: 8.1,
      flexBasis: 8.1,
      flexDirection: 8.1,
      flexGrow: 8.1,
      flexFlow: 8.1,
      flexShrink: 8.1,
      flexWrap: 8.1,
      alignContent: 8.1,
      alignItems: 8.1,
      alignSelf: 8.1,
      justifyContent: 8.1,
      order: 8.1,
      transition: 6,
      transitionDelay: 6,
      transitionDuration: 6,
      transitionProperty: 6,
      transitionTimingFunction: 6,
      transform: 8.1,
      transformOrigin: 8.1,
      transformOriginX: 8.1,
      transformOriginY: 8.1,
      backfaceVisibility: 8.1,
      perspective: 8.1,
      perspectiveOrigin: 8.1,
      transformStyle: 8.1,
      transformOriginZ: 8.1,
      animation: 8.1,
      animationDelay: 8.1,
      animationDirection: 8.1,
      animationFillMode: 8.1,
      animationDuration: 8.1,
      animationIterationCount: 8.1,
      animationName: 8.1,
      animationPlayState: 8.1,
      animationTimingFunction: 8.1,
      appearance: 11,
      userSelect: 11,
      backdropFilter: 11,
      fontKerning: 11,
      scrollSnapType: 10.3,
      scrollSnapPointsX: 10.3,
      scrollSnapPointsY: 10.3,
      scrollSnapDestination: 10.3,
      scrollSnapCoordinate: 10.3,
      boxDecorationBreak: 11,
      clipPath: 11,
      maskImage: 11,
      maskMode: 11,
      maskRepeat: 11,
      maskPosition: 11,
      maskClip: 11,
      maskOrigin: 11,
      maskSize: 11,
      maskComposite: 11,
      mask: 11,
      maskBorderSource: 11,
      maskBorderMode: 11,
      maskBorderSlice: 11,
      maskBorderWidth: 11,
      maskBorderOutset: 11,
      maskBorderRepeat: 11,
      maskBorder: 11,
      maskType: 11,
      textSizeAdjust: 11,
      textDecorationStyle: 11,
      textDecorationSkip: 11,
      textDecorationLine: 11,
      textDecorationColor: 11,
      shapeImageThreshold: 10,
      shapeImageMargin: 10,
      shapeImageOutside: 10,
      filter: 9,
      hyphens: 11,
      flowInto: 11,
      flowFrom: 11,
      breakBefore: 8.1,
      breakAfter: 8.1,
      breakInside: 8.1,
      regionFragment: 11,
      columnCount: 8.1,
      columnFill: 8.1,
      columnGap: 8.1,
      columnRule: 8.1,
      columnRuleColor: 8.1,
      columnRuleStyle: 8.1,
      columnRuleWidth: 8.1,
      columns: 8.1,
      columnSpan: 8.1,
      columnWidth: 8.1,
      writingMode: 10.3
    },
    android: {
      borderImage: 4.2,
      borderImageOutset: 4.2,
      borderImageRepeat: 4.2,
      borderImageSlice: 4.2,
      borderImageSource: 4.2,
      borderImageWidth: 4.2,
      flex: 4.2,
      flexBasis: 4.2,
      flexDirection: 4.2,
      flexGrow: 4.2,
      flexFlow: 4.2,
      flexShrink: 4.2,
      flexWrap: 4.2,
      alignContent: 4.2,
      alignItems: 4.2,
      alignSelf: 4.2,
      justifyContent: 4.2,
      order: 4.2,
      transition: 4.2,
      transitionDelay: 4.2,
      transitionDuration: 4.2,
      transitionProperty: 4.2,
      transitionTimingFunction: 4.2,
      transform: 4.4,
      transformOrigin: 4.4,
      transformOriginX: 4.4,
      transformOriginY: 4.4,
      backfaceVisibility: 4.4,
      perspective: 4.4,
      perspectiveOrigin: 4.4,
      transformStyle: 4.4,
      transformOriginZ: 4.4,
      animation: 4.4,
      animationDelay: 4.4,
      animationDirection: 4.4,
      animationFillMode: 4.4,
      animationDuration: 4.4,
      animationIterationCount: 4.4,
      animationName: 4.4,
      animationPlayState: 4.4,
      animationTimingFunction: 4.4,
      appearance: 62,
      userSelect: 4.4,
      fontKerning: 4.4,
      textEmphasisPosition: 62,
      textEmphasis: 62,
      textEmphasisStyle: 62,
      textEmphasisColor: 62,
      boxDecorationBreak: 62,
      clipPath: 4.4,
      maskImage: 62,
      maskMode: 62,
      maskRepeat: 62,
      maskPosition: 62,
      maskClip: 62,
      maskOrigin: 62,
      maskSize: 62,
      maskComposite: 62,
      mask: 62,
      maskBorderSource: 62,
      maskBorderMode: 62,
      maskBorderSlice: 62,
      maskBorderWidth: 62,
      maskBorderOutset: 62,
      maskBorderRepeat: 62,
      maskBorder: 62,
      maskType: 62,
      filter: 4.4,
      fontFeatureSettings: 4.4,
      breakAfter: 4.4,
      breakBefore: 4.4,
      breakInside: 4.4,
      columnCount: 4.4,
      columnFill: 4.4,
      columnGap: 4.4,
      columnRule: 4.4,
      columnRuleColor: 4.4,
      columnRuleStyle: 4.4,
      columnRuleWidth: 4.4,
      columns: 4.4,
      columnSpan: 4.4,
      columnWidth: 4.4,
      writingMode: 4.4
    },
    and_chr: {
      appearance: 62,
      textEmphasisPosition: 62,
      textEmphasis: 62,
      textEmphasisStyle: 62,
      textEmphasisColor: 62,
      boxDecorationBreak: 62,
      maskImage: 62,
      maskMode: 62,
      maskRepeat: 62,
      maskPosition: 62,
      maskClip: 62,
      maskOrigin: 62,
      maskSize: 62,
      maskComposite: 62,
      mask: 62,
      maskBorderSource: 62,
      maskBorderMode: 62,
      maskBorderSlice: 62,
      maskBorderWidth: 62,
      maskBorderOutset: 62,
      maskBorderRepeat: 62,
      maskBorder: 62,
      maskType: 62
    },
    and_uc: {
      flex: 11.4,
      flexBasis: 11.4,
      flexDirection: 11.4,
      flexGrow: 11.4,
      flexFlow: 11.4,
      flexShrink: 11.4,
      flexWrap: 11.4,
      alignContent: 11.4,
      alignItems: 11.4,
      alignSelf: 11.4,
      justifyContent: 11.4,
      order: 11.4,
      transform: 11.4,
      transformOrigin: 11.4,
      transformOriginX: 11.4,
      transformOriginY: 11.4,
      backfaceVisibility: 11.4,
      perspective: 11.4,
      perspectiveOrigin: 11.4,
      transformStyle: 11.4,
      transformOriginZ: 11.4,
      animation: 11.4,
      animationDelay: 11.4,
      animationDirection: 11.4,
      animationFillMode: 11.4,
      animationDuration: 11.4,
      animationIterationCount: 11.4,
      animationName: 11.4,
      animationPlayState: 11.4,
      animationTimingFunction: 11.4,
      appearance: 11.4,
      userSelect: 11.4,
      textEmphasisPosition: 11.4,
      textEmphasis: 11.4,
      textEmphasisStyle: 11.4,
      textEmphasisColor: 11.4,
      clipPath: 11.4,
      maskImage: 11.4,
      maskMode: 11.4,
      maskRepeat: 11.4,
      maskPosition: 11.4,
      maskClip: 11.4,
      maskOrigin: 11.4,
      maskSize: 11.4,
      maskComposite: 11.4,
      mask: 11.4,
      maskBorderSource: 11.4,
      maskBorderMode: 11.4,
      maskBorderSlice: 11.4,
      maskBorderWidth: 11.4,
      maskBorderOutset: 11.4,
      maskBorderRepeat: 11.4,
      maskBorder: 11.4,
      maskType: 11.4,
      textSizeAdjust: 11.4,
      filter: 11.4,
      hyphens: 11.4,
      fontFeatureSettings: 11.4,
      breakAfter: 11.4,
      breakBefore: 11.4,
      breakInside: 11.4,
      columnCount: 11.4,
      columnFill: 11.4,
      columnGap: 11.4,
      columnRule: 11.4,
      columnRuleColor: 11.4,
      columnRuleStyle: 11.4,
      columnRuleWidth: 11.4,
      columns: 11.4,
      columnSpan: 11.4,
      columnWidth: 11.4,
      writingMode: 11.4
    },
    op_mini: {}
  }
};
module.exports = exports['default'];

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calc(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function crossFade(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('cross-fade(') > -1 && (browserName === 'chrome' || browserName === 'opera' || browserName === 'and_chr' || (browserName === 'ios_saf' || browserName === 'safari') && browserVersion < 10)) {
    return (0, _getPrefixedValue2.default)(value.replace(/cross-fade\(/g, cssPrefix + 'cross-fade('), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var grabValues = {
  grab: true,
  grabbing: true
};


var zoomValues = {
  'zoom-in': true,
  'zoom-out': true
};

function cursor(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  // adds prefixes for firefox, chrome, safari, and opera regardless of
  // version until a reliable browser support info can be found
  // see: https://github.com/rofrischmann/inline-style-prefixer/issues/79
  if (property === 'cursor' && grabValues[value] && (browserName === 'firefox' || browserName === 'chrome' || browserName === 'safari' || browserName === 'opera')) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }

  if (property === 'cursor' && zoomValues[value] && (browserName === 'firefox' && browserVersion < 24 || browserName === 'chrome' && browserVersion < 37 || browserName === 'safari' && browserVersion < 9 || browserName === 'opera' && browserVersion < 24)) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filter(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('filter(') > -1 && (browserName === 'ios_saf' || browserName === 'safari' && browserVersion < 9.1)) {
    return (0, _getPrefixedValue2.default)(value.replace(/filter\(/g, cssPrefix + 'filter('), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = {
  flex: true,
  'inline-flex': true
};
function flex(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};

var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};


var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
var properties = Object.keys(alternativeProps).concat(otherProps);

function flexboxOld(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'flexDirection' && typeof value === 'string') {
      if (value.indexOf('column') > -1) {
        style.WebkitBoxOrient = 'vertical';
      } else {
        style.WebkitBoxOrient = 'horizontal';
      }
      if (value.indexOf('reverse') > -1) {
        style.WebkitBoxDirection = 'reverse';
      } else {
        style.WebkitBoxDirection = 'normal';
      }
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
function gradient(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    return (0, _getPrefixedValue2.default)(value.replace(values, function (grad) {
      return cssPrefix + grad;
    }), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function imageSet(property, value, style, _ref) {
  var browserName = _ref.browserName,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('image-set(') > -1 && (browserName === 'chrome' || browserName === 'opera' || browserName === 'and_chr' || browserName === 'and_uc' || browserName === 'ios_saf' || browserName === 'safari')) {
    return (0, _getPrefixedValue2.default)(value.replace(/image-set\(/g, cssPrefix + 'image-set('), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function position(property, value, style, _ref) {
  var browserName = _ref.browserName,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'position' && value === 'sticky' && (browserName === 'safari' || browserName === 'ios_saf')) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _getPrefixedValue = __webpack_require__(59);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};

var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true

  // TODO: chrome & opera support it
};function sizing(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(351);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var requiresPrefixDashCased = void 0;

function transition(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    // memoize the prefix array for later use
    if (!requiresPrefixDashCased) {
      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _hyphenateProperty2.default)(prop);
      });
    }

    // only split multi values, not cubic beziers
    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

    requiresPrefixDashCased.forEach(function (prop) {
      multipleValues.forEach(function (val, index) {
        if (val.indexOf(prop) > -1 && prop !== 'order') {
          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
        }
      });
    });

    return multipleValues.join(',');
  }
}
module.exports = exports['default'];

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getStateKey = function getStateKey(renderedElement) {
  return typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
};

exports.default = getStateKey;
module.exports = exports['default'];

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isNestedStyle = isNestedStyle;
exports.mergeStyles = mergeStyles;
function isNestedStyle(value) {
  // Don't merge objects overriding toString, since they should be converted
  // to string values.
  return value && value.constructor === Object && value.toString === Object.prototype.toString;
}

// Merge style objects. Deep merge plain object values.
function mergeStyles(styles) {
  var result = {};

  styles.forEach(function (style) {
    if (!style || (typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') {
      return;
    }

    if (Array.isArray(style)) {
      style = mergeStyles(style);
    }

    Object.keys(style).forEach(function (key) {
      // Simple case, nothing nested
      if (!isNestedStyle(style[key]) || !isNestedStyle(result[key])) {
        result[key] = style[key];
        return;
      }

      // If nested media, don't merge the nested styles, append a space to the
      // end (benign when converted to CSS). This way we don't end up merging
      // media queries that appear later in the chain with those that appear
      // earlier.
      if (key.indexOf('@media') === 0) {
        var newKey = key;
        // eslint-disable-next-line no-constant-condition
        while (true) {
          newKey += ' ';
          if (!result[newKey]) {
            result[newKey] = style[key];
            return;
          }
        }
      }

      // Merge all other nested styles recursively
      result[key] = mergeStyles([result[key], style[key]]);
    });
  });

  return result;
}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _checkProps = function checkProps() {};

if (false) {
  // Warn if you use longhand and shorthand properties in the same style
  // object.
  // https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties

  var shorthandPropertyExpansions = {
    background: ['backgroundAttachment', 'backgroundBlendMode', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundRepeatX', 'backgroundRepeatY', 'backgroundSize'],
    border: ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
    borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
    borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
    font: ['fontFamily', 'fontKerning', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantLigatures', 'fontWeight', 'lineHeight'],
    listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
    margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
    padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
    transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']
  };

  _checkProps = function checkProps(config) {
    var componentName = config.componentName,
        style = config.style;

    if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object' || !style) {
      return;
    }

    var styleKeys = Object.keys(style);
    styleKeys.forEach(function (styleKey) {
      if (Array.isArray(shorthandPropertyExpansions[styleKey]) && shorthandPropertyExpansions[styleKey].some(function (sp) {
        return styleKeys.indexOf(sp) !== -1;
      })) {
        if (process.env.NODE_ENV !== 'production') {
          /* eslint-disable no-console */
          console.warn('Radium: property "' + styleKey + '" in style object', style, ': do not mix longhand and ' + 'shorthand properties in the same style object. Check the render ' + 'method of ' + componentName + '.', 'See https://github.com/FormidableLabs/radium/issues/95 for more ' + 'information.');
          /* eslint-enable no-console */
        }
      }
    });

    styleKeys.forEach(function (k) {
      return _checkProps(_extends({}, config, { style: style[k] }));
    });
    return;
  };
}

exports.default = _checkProps;
module.exports = exports['default'];

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyframesPlugin;
function keyframesPlugin(_ref // eslint-disable-line no-shadow
) {
  var addCSS = _ref.addCSS,
      config = _ref.config,
      style = _ref.style;

  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
    var value = style[key];
    if (key === 'animationName' && value && value.__radiumKeyframes) {
      var keyframesValue = value;

      var _keyframesValue$__pro = keyframesValue.__process(config.userAgent),
          animationName = _keyframesValue$__pro.animationName,
          css = _keyframesValue$__pro.css;

      addCSS(css);
      value = animationName;
    }

    newStyleInProgress[key] = value;
    return newStyleInProgress;
  }, {});
  return { style: newStyle };
}
module.exports = exports['default'];

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


// Convenient syntax for multiple styles: `style={[style1, style2, etc]}`
// Ignores non-objects, so you can do `this.state.isCool && styles.cool`.
var mergeStyleArrayPlugin = function mergeStyleArrayPlugin(_ref) {
  var style = _ref.style,
      mergeStyles = _ref.mergeStyles;

  // eslint-disable-line no-shadow
  var newStyle = Array.isArray(style) ? mergeStyles(style) : style;
  return { style: newStyle };
};

exports.default = mergeStyleArrayPlugin;
module.exports = exports['default'];

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixPlugin;

var _prefixer = __webpack_require__(160);

function prefixPlugin(_ref // eslint-disable-line no-shadow
) {
  var config = _ref.config,
      style = _ref.style;

  var newStyle = (0, _prefixer.getPrefixedStyle)(style, config.userAgent);
  return { style: newStyle };
}
module.exports = exports['default'];

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeNestedStyles;
function removeNestedStyles(_ref) {
  var isNestedStyle = _ref.isNestedStyle,
      style = _ref.style;

  // eslint-disable-line no-shadow
  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
    var value = style[key];
    if (!isNestedStyle(value)) {
      newStyleInProgress[key] = value;
    }
    return newStyleInProgress;
  }, {});

  return {
    style: newStyle
  };
}

module.exports = exports['default'];

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mouseUpListener = __webpack_require__(899);

var _mouseUpListener2 = _interopRequireDefault(_mouseUpListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _isInteractiveStyleField = function _isInteractiveStyleField(styleFieldName) {
  return styleFieldName === ':hover' || styleFieldName === ':active' || styleFieldName === ':focus';
};

var resolveInteractionStyles = function resolveInteractionStyles(config) {
  var ExecutionEnvironment = config.ExecutionEnvironment,
      getComponentField = config.getComponentField,
      getState = config.getState,
      mergeStyles = config.mergeStyles,
      props = config.props,
      setState = config.setState,
      style = config.style;


  var newComponentFields = {};
  var newProps = {};

  // Only add handlers if necessary
  if (style[':hover']) {
    // Always call the existing handler if one is already defined.
    // This code, and the very similar ones below, could be abstracted a bit
    // more, but it hurts readability IMO.
    var existingOnMouseEnter = props.onMouseEnter;
    newProps.onMouseEnter = function (e) {
      existingOnMouseEnter && existingOnMouseEnter(e);
      setState(':hover', true);
    };

    var existingOnMouseLeave = props.onMouseLeave;
    newProps.onMouseLeave = function (e) {
      existingOnMouseLeave && existingOnMouseLeave(e);
      setState(':hover', false);
    };
  }

  if (style[':active']) {
    var existingOnMouseDown = props.onMouseDown;
    newProps.onMouseDown = function (e) {
      existingOnMouseDown && existingOnMouseDown(e);
      newComponentFields._lastMouseDown = Date.now();
      setState(':active', 'viamousedown');
    };

    var existingOnKeyDown = props.onKeyDown;
    newProps.onKeyDown = function (e) {
      existingOnKeyDown && existingOnKeyDown(e);
      if (e.key === ' ' || e.key === 'Enter') {
        setState(':active', 'viakeydown');
      }
    };

    var existingOnKeyUp = props.onKeyUp;
    newProps.onKeyUp = function (e) {
      existingOnKeyUp && existingOnKeyUp(e);
      if (e.key === ' ' || e.key === 'Enter') {
        setState(':active', false);
      }
    };
  }

  if (style[':focus']) {
    var existingOnFocus = props.onFocus;
    newProps.onFocus = function (e) {
      existingOnFocus && existingOnFocus(e);
      setState(':focus', true);
    };

    var existingOnBlur = props.onBlur;
    newProps.onBlur = function (e) {
      existingOnBlur && existingOnBlur(e);
      setState(':focus', false);
    };
  }

  if (style[':active'] && !getComponentField('_radiumMouseUpListener') && ExecutionEnvironment.canUseEventListeners) {
    newComponentFields._radiumMouseUpListener = _mouseUpListener2.default.subscribe(function () {
      Object.keys(getComponentField('state')._radiumStyleState).forEach(function (key) {
        if (getState(':active', key) === 'viamousedown') {
          setState(':active', false, key);
        }
      });
    });
  }

  // Merge the styles in the order they were defined
  var interactionStyles = props.disabled ? [style[':disabled']] : Object.keys(style).filter(function (name) {
    return _isInteractiveStyleField(name) && getState(name);
  }).map(function (name) {
    return style[name];
  });

  var newStyle = mergeStyles([style].concat(interactionStyles));

  // Remove interactive styles
  newStyle = Object.keys(newStyle).reduce(function (styleWithoutInteractions, name) {
    if (!_isInteractiveStyleField(name) && name !== ':disabled') {
      styleWithoutInteractions[name] = newStyle[name];
    }
    return styleWithoutInteractions;
  }, {});

  return {
    componentFields: newComponentFields,
    props: newProps,
    style: newStyle
  };
};

exports.default = resolveInteractionStyles;
module.exports = exports['default'];

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _callbacks = [];
var _mouseUpListenerIsActive = false;

function _handleMouseUp() {
  _callbacks.forEach(function (callback) {
    callback();
  });
}

var subscribe = function subscribe(callback) {
  if (_callbacks.indexOf(callback) === -1) {
    _callbacks.push(callback);
  }

  if (!_mouseUpListenerIsActive) {
    window.addEventListener('mouseup', _handleMouseUp);
    _mouseUpListenerIsActive = true;
  }

  return {
    remove: function remove() {
      var index = _callbacks.indexOf(callback);
      _callbacks.splice(index, 1);

      if (_callbacks.length === 0 && _mouseUpListenerIsActive) {
        window.removeEventListener('mouseup', _handleMouseUp);
        _mouseUpListenerIsActive = false;
      }
    }
  };
};

exports.default = {
  subscribe: subscribe,
  __triggerForTests: _handleMouseUp
};
module.exports = exports['default'];

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = resolveMediaQueries;
var _windowMatchMedia = void 0;
function _getWindowMatchMedia(ExecutionEnvironment) {
  if (_windowMatchMedia === undefined) {
    _windowMatchMedia = !!ExecutionEnvironment.canUseDOM && !!window && !!window.matchMedia && function (mediaQueryString) {
      return window.matchMedia(mediaQueryString);
    } || null;
  }
  return _windowMatchMedia;
}

function _filterObject(obj, predicate) {
  return Object.keys(obj).filter(function (key) {
    return predicate(obj[key], key);
  }).reduce(function (result, key) {
    result[key] = obj[key];
    return result;
  }, {});
}

function _removeMediaQueries(style) {
  return Object.keys(style).reduce(function (styleWithoutMedia, key) {
    if (key.indexOf('@media') !== 0) {
      styleWithoutMedia[key] = style[key];
    }
    return styleWithoutMedia;
  }, {});
}

function _topLevelRulesToCSS(_ref) {
  var addCSS = _ref.addCSS,
      appendImportantToEachValue = _ref.appendImportantToEachValue,
      cssRuleSetToString = _ref.cssRuleSetToString,
      hash = _ref.hash,
      isNestedStyle = _ref.isNestedStyle,
      style = _ref.style,
      userAgent = _ref.userAgent;

  var className = '';
  Object.keys(style).filter(function (name) {
    return name.indexOf('@media') === 0;
  }).map(function (query) {
    var topLevelRules = appendImportantToEachValue(_filterObject(style[query], function (value) {
      return !isNestedStyle(value);
    }));

    if (!Object.keys(topLevelRules).length) {
      return;
    }

    var ruleCSS = cssRuleSetToString('', topLevelRules, userAgent);

    // CSS classes cannot start with a number
    var mediaQueryClassName = 'rmq-' + hash(query + ruleCSS);
    var css = query + '{ .' + mediaQueryClassName + ruleCSS + '}';

    addCSS(css);

    className += (className ? ' ' : '') + mediaQueryClassName;
  });
  return className;
}

function _subscribeToMediaQuery(_ref2) {
  var listener = _ref2.listener,
      listenersByQuery = _ref2.listenersByQuery,
      matchMedia = _ref2.matchMedia,
      mediaQueryListsByQuery = _ref2.mediaQueryListsByQuery,
      query = _ref2.query;

  query = query.replace('@media ', '');

  var mql = mediaQueryListsByQuery[query];
  if (!mql && matchMedia) {
    mediaQueryListsByQuery[query] = mql = matchMedia(query);
  }

  if (!listenersByQuery || !listenersByQuery[query]) {
    mql.addListener(listener);

    listenersByQuery[query] = {
      remove: function remove() {
        mql.removeListener(listener);
      }
    };
  }
  return mql;
}

function resolveMediaQueries(_ref3) {
  var ExecutionEnvironment = _ref3.ExecutionEnvironment,
      addCSS = _ref3.addCSS,
      appendImportantToEachValue = _ref3.appendImportantToEachValue,
      config = _ref3.config,
      cssRuleSetToString = _ref3.cssRuleSetToString,
      getComponentField = _ref3.getComponentField,
      getGlobalState = _ref3.getGlobalState,
      hash = _ref3.hash,
      isNestedStyle = _ref3.isNestedStyle,
      mergeStyles = _ref3.mergeStyles,
      props = _ref3.props,
      setState = _ref3.setState,
      style = _ref3.style;

  // eslint-disable-line no-shadow
  var newStyle = _removeMediaQueries(style);
  var mediaQueryClassNames = _topLevelRulesToCSS({
    addCSS: addCSS,
    appendImportantToEachValue: appendImportantToEachValue,
    cssRuleSetToString: cssRuleSetToString,
    hash: hash,
    isNestedStyle: isNestedStyle,
    style: style,
    userAgent: config.userAgent
  });

  var newProps = mediaQueryClassNames ? {
    className: mediaQueryClassNames + (props.className ? ' ' + props.className : '')
  } : null;

  var matchMedia = config.matchMedia || _getWindowMatchMedia(ExecutionEnvironment);

  if (!matchMedia) {
    return {
      props: newProps,
      style: newStyle
    };
  }

  var listenersByQuery = _extends({}, getComponentField('_radiumMediaQueryListenersByQuery'));
  var mediaQueryListsByQuery = getGlobalState('mediaQueryListsByQuery') || {};

  Object.keys(style).filter(function (name) {
    return name.indexOf('@media') === 0;
  }).map(function (query) {
    var nestedRules = _filterObject(style[query], isNestedStyle);

    if (!Object.keys(nestedRules).length) {
      return;
    }

    var mql = _subscribeToMediaQuery({
      listener: function listener() {
        return setState(query, mql.matches, '_all');
      },
      listenersByQuery: listenersByQuery,
      matchMedia: matchMedia,
      mediaQueryListsByQuery: mediaQueryListsByQuery,
      query: query
    });

    // Apply media query states
    if (mql.matches) {
      newStyle = mergeStyles([newStyle, nestedRules]);
    }
  });

  return {
    componentFields: {
      _radiumMediaQueryListenersByQuery: listenersByQuery
    },
    globalState: { mediaQueryListsByQuery: mediaQueryListsByQuery },
    props: newProps,
    style: newStyle
  };
}
module.exports = exports['default'];

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = visited;
function visited(_ref) {
  var addCSS = _ref.addCSS,
      appendImportantToEachValue = _ref.appendImportantToEachValue,
      config = _ref.config,
      cssRuleSetToString = _ref.cssRuleSetToString,
      hash = _ref.hash,
      props = _ref.props,
      style = _ref.style;

  // eslint-disable-line no-shadow
  var className = props.className;

  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
    var value = style[key];
    if (key === ':visited') {
      value = appendImportantToEachValue(value);
      var ruleCSS = cssRuleSetToString('', value, config.userAgent);
      var visitedClassName = 'rad-' + hash(ruleCSS);
      var css = '.' + visitedClassName + ':visited' + ruleCSS;

      addCSS(css);
      className = (className ? className + ' ' : '') + visitedClassName;
    } else {
      newStyleInProgress[key] = value;
    }

    return newStyleInProgress;
  }, {});

  return {
    props: className === props.className ? null : { className: className },
    style: newStyle
  };
}

module.exports = exports['default'];

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _class, _temp;

var _cssRuleSetToString = __webpack_require__(159);

var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Style = (_temp = _class = function (_PureComponent) {
  _inherits(Style, _PureComponent);

  function Style() {
    _classCallCheck(this, Style);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  Style.prototype._buildStyles = function _buildStyles(styles) {
    var _this2 = this;

    var userAgent = this.props.radiumConfig && this.props.radiumConfig.userAgent || this.context && this.context._radiumConfig && this.context._radiumConfig.userAgent;

    var scopeSelector = this.props.scopeSelector;

    var rootRules = Object.keys(styles).reduce(function (accumulator, selector) {
      if (_typeof(styles[selector]) !== 'object') {
        accumulator[selector] = styles[selector];
      }

      return accumulator;
    }, {});
    var rootStyles = Object.keys(rootRules).length ? (0, _cssRuleSetToString2.default)(scopeSelector || '', rootRules, userAgent) : '';

    return rootStyles + Object.keys(styles).reduce(function (accumulator, selector) {
      var rules = styles[selector];

      if (selector === 'mediaQueries') {
        accumulator += _this2._buildMediaQueryString(rules);
      } else if (_typeof(styles[selector]) === 'object') {
        var completeSelector = scopeSelector ? selector.split(',').map(function (part) {
          return scopeSelector + ' ' + part.trim();
        }).join(',') : selector;

        accumulator += (0, _cssRuleSetToString2.default)(completeSelector, rules, userAgent);
      }

      return accumulator;
    }, '');
  };

  Style.prototype._buildMediaQueryString = function _buildMediaQueryString(stylesByMediaQuery) {
    var _this3 = this;

    var mediaQueryString = '';

    Object.keys(stylesByMediaQuery).forEach(function (query) {
      mediaQueryString += '@media ' + query + '{' + _this3._buildStyles(stylesByMediaQuery[query]) + '}';
    });

    return mediaQueryString;
  };

  Style.prototype.render = function render() {
    if (!this.props.rules) {
      return null;
    }

    var styles = this._buildStyles(this.props.rules);

    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: styles } });
  };

  return Style;
}(_react.PureComponent), _class.propTypes = {
  radiumConfig: _propTypes2.default.object,
  rules: _propTypes2.default.object,
  scopeSelector: _propTypes2.default.string
}, _class.contextTypes = {
  _radiumConfig: _propTypes2.default.object
}, _class.defaultProps = {
  scopeSelector: ''
}, _temp);
exports.default = Style;
module.exports = exports['default'];

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _enhancer = __webpack_require__(343);

var _enhancer2 = _interopRequireDefault(_enhancer);

var _styleKeeper = __webpack_require__(229);

var _styleKeeper2 = _interopRequireDefault(_styleKeeper);

var _styleSheet = __webpack_require__(904);

var _styleSheet2 = _interopRequireDefault(_styleSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _getStyleKeeper(instance) {
  if (!instance._radiumStyleKeeper) {
    var userAgent = instance.props.radiumConfig && instance.props.radiumConfig.userAgent || instance.context._radiumConfig && instance.context._radiumConfig.userAgent;
    instance._radiumStyleKeeper = new _styleKeeper2.default(userAgent);
  }

  return instance._radiumStyleKeeper;
}

var StyleRoot = function (_PureComponent) {
  _inherits(StyleRoot, _PureComponent);

  function StyleRoot() {
    _classCallCheck(this, StyleRoot);

    var _this = _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));

    _getStyleKeeper(_this);
    return _this;
  }

  StyleRoot.prototype.getChildContext = function getChildContext() {
    return { _radiumStyleKeeper: _getStyleKeeper(this) };
  };

  StyleRoot.prototype.render = function render() {
    /* eslint-disable no-unused-vars */
    // Pass down all props except config to the rendered div.
    var _props = this.props,
        radiumConfig = _props.radiumConfig,
        otherProps = _objectWithoutProperties(_props, ['radiumConfig']);
    /* eslint-enable no-unused-vars */

    return _react2.default.createElement(
      'div',
      otherProps,
      this.props.children,
      _react2.default.createElement(_styleSheet2.default, null)
    );
  };

  return StyleRoot;
}(_react.PureComponent);

StyleRoot.contextTypes = {
  _radiumConfig: _propTypes2.default.object,
  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
};

StyleRoot.childContextTypes = {
  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
};

StyleRoot = (0, _enhancer2.default)(StyleRoot);

exports.default = StyleRoot;
module.exports = exports['default'];

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styleKeeper = __webpack_require__(229);

var _styleKeeper2 = _interopRequireDefault(_styleKeeper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StyleSheet = (_temp = _class = function (_PureComponent) {
  _inherits(StyleSheet, _PureComponent);

  function StyleSheet() {
    _classCallCheck(this, StyleSheet);

    var _this = _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));

    _this._onChange = function () {
      setTimeout(function () {
        _this._isMounted && _this.setState(_this._getCSSState());
      }, 0);
    };

    _this.state = _this._getCSSState();
    return _this;
  }

  StyleSheet.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._subscription = this.context._radiumStyleKeeper.subscribe(this._onChange);
    this._onChange();
  };

  StyleSheet.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    if (this._subscription) {
      this._subscription.remove();
    }
  };

  StyleSheet.prototype._getCSSState = function _getCSSState() {
    return { css: this.context._radiumStyleKeeper.getCSS() };
  };

  StyleSheet.prototype.render = function render() {
    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: this.state.css } });
  };

  return StyleSheet;
}(_react.PureComponent), _class.contextTypes = {
  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
}, _temp);
exports.default = StyleSheet;
module.exports = exports['default'];

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyframes;

var _cssRuleSetToString = __webpack_require__(159);

var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);

var _hash = __webpack_require__(232);

var _hash2 = _interopRequireDefault(_hash);

var _prefixer = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function keyframes(keyframeRules, name) {
  return {
    __radiumKeyframes: true,
    __process: function __process(userAgent) {
      var keyframesPrefixed = (0, _prefixer.getPrefixedKeyframes)(userAgent);
      var rules = Object.keys(keyframeRules).map(function (percentage) {
        return (0, _cssRuleSetToString2.default)(percentage, keyframeRules[percentage], userAgent);
      }).join('\n');
      var animationName = (name ? name + '-' : '') + 'radium-animation-' + (0, _hash2.default)(rules);
      var css = '@' + keyframesPrefixed + ' ' + animationName + ' {\n' + rules + '\n}\n';
      return { css: css, animationName: animationName };
    }
  };
}

module.exports = exports['default'];

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_radium_lib_css_rule_set_to_string__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_radium_lib_css_rule_set_to_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_radium_lib_css_rule_set_to_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium_lib_hash__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium_lib_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_radium_lib_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_radium_lib_prefixer__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_radium_lib_prefixer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_radium_lib_prefixer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vh_px_plugin_js__ = __webpack_require__(356);





var keyframes = function keyframes(keyframeRules, name) {
  return {
    __radiumKeyframes: true,
    __process: function __process(userAgent) {
      var keyframesPrefixed = Object(__WEBPACK_IMPORTED_MODULE_2_radium_lib_prefixer__["getPrefixedKeyframes"])(userAgent);
      var rules = Object.keys(keyframeRules).map(function (percentage) {
        var newKeyframeRules = Object(__WEBPACK_IMPORTED_MODULE_3__vh_px_plugin_js__["a" /* default */])({
          style: keyframeRules[percentage]
        });
        return __WEBPACK_IMPORTED_MODULE_0_radium_lib_css_rule_set_to_string___default()(percentage, newKeyframeRules.style, userAgent);
      }).join("\n");
      var animationName = (name ? name + "-" : "") + "radium-animation-" + __WEBPACK_IMPORTED_MODULE_1_radium_lib_hash___default()(rules);
      var css = "@" + keyframesPrefixed + " " + animationName + " {\n" + rules + "\n}\n";
      return { css: css, animationName: animationName };
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (keyframes);

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var fadeIn = {
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
};
exports.default = fadeIn;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(161);

var slideInLeft = {
  from: {
    transform: (0, _utils.translate3d)('-100%', 0, 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, _utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInLeft;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(161);

var slideInUp = {
  from: {
    transform: (0, _utils.translate3d)(0, '100%', 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, _utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInUp;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(161);

var timing = {
  animationTimingFunction: (0, _utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceInRight = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, _utils.translate3d)('3000px', 0, 0)
  },
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, _utils.translate3d)('-25px', 0, 0)
  }),
  '75%': _extends({}, timing, {
    transform: (0, _utils.translate3d)('10px', 0, 0)
  }),
  '90%': _extends({}, timing, {
    transform: (0, _utils.translate3d)('-5px', 0, 0)
  }),
  to: _extends({}, timing, {
    transform: 'none'
  })
};

exports.default = bounceInRight;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(161);

var scaleAndTranslate = (0, _utils.compose)(_utils.scale3d, _utils.translate3d);


var zoomInDown = {
  from: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '-1000px', 0]),
    animationTimingFunction: (0, _utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  '60%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '60px', 0]),
    animationTimingFunction: (0, _utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomInDown;

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolveAfter */
/* unused harmony export makeCancelable */
var resolveAfter = function resolveAfter(duration, resolveWith) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve(resolveWith);
    }, duration);
  });
};

/**
 * Make a given promise cancelable. Taken from:
 * http://stackoverflow.com/a/37492399
 * https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
 * NOTE: calling cancel() will not immediately reject the promise. If there are no other errors
 * in execution, the promise will run the duration until then is called, and reject if the
 * canceled flag was set.
 *
 * @param {Promise} promise - Promise to convert
 * @returns {Object} Contains the wrapped promise and a cancel function
 * */
var makeCancelable = function makeCancelable(promise) {
  var hasCanceled_ = false;

  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
    });
    promise.catch(function (error) {
      return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
    });
  });

  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled_ = true;
    }
  };
};

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return nullCheckProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return constructOutputProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getComponentDisplayName; });
/* unused harmony export matchComponentName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return jsonToComponents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_missing_component__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(9);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\utils\\component.js";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * Handle null values from backend as undefined to make default assignment work proerly
 */
var nullCheckProps = function nullCheckProps(props) {
  var newProps = props;
  Object.entries(props).forEach(function (_ref) {
    var key = _ref[0],
        val = _ref[1];

    if (val === null) {
      newProps[key] = undefined; // change all null values to undefined
    }
  });
  return newProps;
};

/**
 * Constructs transformed output props excluding inputs.
 * Executes outputFunc on each input-output mapping.
 */
var constructOutputProps = function constructOutputProps(props) {
  var mapInputToOutput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [["components", "children"]];
  var outputFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (outputProps) {
    return outputProps;
  };
  var initialProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_utils__["E" /* omit */])(mapInputToOutput.reduce(function (prev, _ref2) {
    var input = _ref2[0];
    return [].concat(prev, [input]);
  }, []), props), mapInputToOutput.reduce(function (prev, _ref3) {
    var _extends2;

    var input = _ref3[0],
        output = _ref3[1];
    return _extends({}, prev, (_extends2 = {}, _extends2[output] = outputFunc(props[input]), _extends2));
  }, initialProps));
};

var getComponentDisplayName = function getComponentDisplayName(Component) {
  return Component.displayName || Component.name || "Component";
};

var matchComponentName = function matchComponentName(name, list) {
  return list.find(function (comp) {
    return getComponentDisplayName(comp) === name;
  }) || // Try first to derive exact component name
  list.find(function (comp) {
    return getComponentDisplayName(comp).indexOf("(" + name + ")") > -1;
  });
}; // try next partial match - this occurs when a component is wrapped in HOCs

/**
 * Constructs transformed output props excluding inputs.
 */
var jsonToComponents = function jsonToComponents(componentWhitelist) {
  var mapInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (comp) {
    return comp;
  };
  var wrappedComponentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "wrappedComponent";
  return function () {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (json == null) return null;
    return json.map(mapInput).map(function (_ref4, index) {
      var name = _ref4.name,
          props = _ref4.props;

      var components = (typeof componentWhitelist === "undefined" ? "undefined" : _typeof(componentWhitelist)) === "object" ? Object.values(componentWhitelist) : componentWhitelist;

      if (components.some(function (Comp) {
        return typeof Comp === "undefined";
      })) {
        throw Error("Some componentWhitelist items are undefined for " + wrappedComponentName + " component. Check your imports.");
      }
      var Component = matchComponentName(name, components);

      var newProps = props;
      Object.entries(props).forEach(function (_ref5) {
        var key = _ref5[0],
            val = _ref5[1];

        if (val === null) {
          newProps[key] = undefined; // change all null values to undefined
        }
      });

      if (!Component) {
        console.error("\"" + name + "\" component was not found in componentWhitelist for " + wrappedComponentName + ".");
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_missing_component__["a" /* default */], _extends({}, nullCheckProps(props), { key: index, expectedComponentName: name, __source: {
            fileName: _jsxFileName,
            lineNumber: 83
          }
        }));
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({ key: index }, nullCheckProps(props), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86
        }
      }));
    });
  };
};

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rafThrottle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearTransform; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__function__ = __webpack_require__(35);



var TRANSFORM_PROP = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["c" /* IS_BROWSER */] ? function () {
  var _DOCUMENT$createEleme = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].createElement("div"),
      style = _DOCUMENT$createEleme.style;

  var prefixed = ["msTransform", "mozTransform", "webkitTransform"].find(function (key) {
    return key in style;
  });
  return prefixed || "transform";
}() : "transform";

/**
 * Throttles a function using WINDOW.requestAnimationFrame.
 * @see https://github.com/wuct/raf-throttle
 * @param {function} callback - Callback to run no more than once per animation frame.
 * @returns {function} A throttled callback function suitable for a listener.
 */
var rafThrottle = function rafThrottle() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__function__["g" /* noop */];

  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["c" /* IS_BROWSER */]) {
    return {
      cancel: __WEBPACK_IMPORTED_MODULE_1__function__["g" /* noop */]
    };
  }

  var requestId = void 0;
  var later = function later(args) {
    return function () {
      requestId = null;
      callback.apply(undefined, args);
    };
  };
  var throttled = function throttled() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (requestId == null) requestId = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].cancelAnimationFrame && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].requestAnimationFrame(later(args));
  };
  throttled.cancel = function () {
    return __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].cancelAnimationFrame && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].cancelAnimationFrame(requestId);
  };
  return throttled;
};

var applyTransform = Object(__WEBPACK_IMPORTED_MODULE_1__function__["c" /* curry */])(function (transform, el) {
  el.style[TRANSFORM_PROP] = transform;
});

// IE 11 does not appreciate null when clearing transform styles
var clearTransform = applyTransform("");

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isOldBrowser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__object__ = __webpack_require__(134);




var oldBrowser = function oldBrowser(browserList) {
  if (!__WEBPACK_IMPORTED_MODULE_1__constants_environment__["c" /* IS_BROWSER */]) return false;
  // Check if the browser is NOT NEW
  return !Object.keys(browserList).some(function (key) {
    var browser = Object(__WEBPACK_IMPORTED_MODULE_2__object__["b" /* get */])(key, __WEBPACK_IMPORTED_MODULE_0_bowser___default.a);
    if (typeof __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.version !== "undefined") {
      return browser && __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.version >= browserList[key];
    }
    // Show browser as supported if browser version cannot be determined but browser name exists on browserList
    return browser;
  });
};

var isOldBrowser = function isOldBrowser() {
  return oldBrowser(__WEBPACK_IMPORTED_MODULE_1__constants_environment__["h" /* MIN_BROWSERS */]);
};

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeHash; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__history__ = __webpack_require__(103);



var getHash = function getHash() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__history__["a" /* getLocation */])().hash.slice(1);
};

var updateHash = function updateHash(hash, affectHistory) {
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */]) return;
  // Keep search params when pushing hash

  var _getLocation = Object(__WEBPACK_IMPORTED_MODULE_1__history__["a" /* getLocation */])(),
      search = _getLocation.search;

  if (affectHistory) {
    __WEBPACK_IMPORTED_MODULE_1__history__["b" /* history */].push({ search: search, hash: hash });
  } else {
    __WEBPACK_IMPORTED_MODULE_1__history__["b" /* history */].replace({ search: search, hash: hash });
  }
};

// remove hash in url without affecting history or forcing reload
var removeHash = function removeHash() {
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */]) return;
  // Keep search params when pushing hash

  var _getLocation2 = Object(__WEBPACK_IMPORTED_MODULE_1__history__["a" /* getLocation */])(),
      search = _getLocation2.search;

  if (getHash().length) {
    __WEBPACK_IMPORTED_MODULE_1__history__["b" /* history */].replace({ search: search, hash: "" });
  }
};

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(34);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(60);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(359);

var _PathUtils = __webpack_require__(233);

var _createTransitionManager = __webpack_require__(362);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(918);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(34);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(233);

var _LocationUtils = __webpack_require__(359);

var _createTransitionManager = __webpack_require__(362);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findColorFromCombinations */
/* unused harmony export findInteriorsFromCombinations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseKoalaData; });
var findColorFromCombinations = function findColorFromCombinations(options, colorReferances) {
  var foundColors = [];
  // If there are colors at engine level, use those, otherwise fall back to
  // ones at grade level
  var matchRef = function matchRef(ref) {
    for (var _iterator = colorReferances, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var combination = _ref;

      if (ref === combination.colorRef) return combination;
    }
  };
  var level = options.engine.colors.length > 0 ? "engine" : "grade";
  for (var _iterator2 = options[level].colors, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref2 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref2 = _i2.value;
    }

    var color = _ref2;

    if (!color.ref) {
      throw new Error("Color ref should not be null.");
    }
    var match = matchRef(color.ref);
    if (match) {
      foundColors.push(Object.assign(color, {
        children: match.children,
        default: match.default
      }));
    }
  }
  return foundColors;
};

var findInteriorsFromCombinations = function findInteriorsFromCombinations(options, interiorReferences) {
  var foundInteriors = [];
  for (var _iterator3 = interiorReferences, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray3) {
      if (_i3 >= _iterator3.length) break;
      _ref3 = _iterator3[_i3++];
    } else {
      _i3 = _iterator3.next();
      if (_i3.done) break;
      _ref3 = _i3.value;
    }

    var interiorReference = _ref3;

    for (var _iterator4 = options.grade.interiorDesigns, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref4 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref4 = _i4.value;
      }

      var interiorDesign = _ref4;

      if (!interiorDesign.ref) {
        throw new Error("Grade level interiorDesign ref should not be null.");
      }
      if (interiorDesign.ref === interiorReference.interiorDesignRef) {
        foundInteriors.push(Object.assign(interiorDesign, {
          default: interiorReference.default
        }));
      }
    }
  }
  return foundInteriors;
};

/** Recursively update options from data tree based on selection
 * @param {Object} newSelection - New selection object.
 * @returns {Object} new options object.
 */
var parseKoalaData = function parseKoalaData(data) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      newSelection = _ref5.newSelection,
      stateOptions = _ref5.stateOptions,
      type = _ref5.type;

  var colorStepVisited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var configNames = [{
    groupName: "bodyStyles",
    itemName: "bodyStyle"
  }, {
    groupName: "drivetrains",
    itemName: "drivetrain"
  }, {
    groupName: "grades",
    itemName: "grade"
  }, {
    groupName: "transmissions",
    itemName: "transmission"
  }, {
    groupName: "engines",
    itemName: "engine"
  }, {
    groupName: "colors",
    itemName: "color"
  }, {
    groupName: "interiorDesigns",
    itemName: "interiorDesign"
  }];

  var compareNames = [{
    groupName: "bodyStyles",
    itemName: "bodyStyle"
  }, {
    groupName: "grades",
    itemName: "grade"
  }, {
    groupName: "engines",
    itemName: "engine"
  }];

  var optionNames = type === "compare" ? compareNames : configNames;

  /** Choose item from array based on selection / fallback hierarchy
   * @param {Array} items - Array of objects to select from.
   * @param {Object} selection - New selection object.
   * @returns {Object} selected object.
   */
  var selectItem = function selectItem(items, selection, itemName) {
    var compareObjects = function compareObjects(object1, object2) {
      return object1.type === object2.type && object1.name === object2.name;
    };
    // Return item if it matches selection
    for (var _iterator5 = items, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
      var _ref6;

      if (_isArray5) {
        if (_i5 >= _iterator5.length) break;
        _ref6 = _iterator5[_i5++];
      } else {
        _i5 = _iterator5.next();
        if (_i5.done) break;
        _ref6 = _i5.value;
      }

      var _item = _ref6;

      if (selection && compareObjects(selection, _item)) {
        return _item;
      }
    }
    // Return item in state if it exists
    if (stateOptions) {
      if (selection.type === "grade" && itemName === "color" && !colorStepVisited) {
        // Nothing
      } else {
        for (var _iterator6 = items, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
          var _ref7;

          if (_isArray6) {
            if (_i6 >= _iterator6.length) break;
            _ref7 = _iterator6[_i6++];
          } else {
            _i6 = _iterator6.next();
            if (_i6.done) break;
            _ref7 = _i6.value;
          }

          var item = _ref7;

          if (stateOptions[item.type] && compareObjects(stateOptions[item.type], item)) {
            return item;
          }
        }
      }
    }
    // Return item marked default
    for (var _iterator7 = items, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
      var _ref8;

      if (_isArray7) {
        if (_i7 >= _iterator7.length) break;
        _ref8 = _iterator7[_i7++];
      } else {
        _i7 = _iterator7.next();
        if (_i7.done) break;
        _ref8 = _i7.value;
      }

      var _item2 = _ref8;

      if (_item2.default) {
        return _item2;
      }
    }
    // Return first item in array (failsafe)
    return items[0];
  };
  var options = {};
  options.nameplate = data;
  var buildStateOptions = function buildStateOptions(previousItem, optionIndex) {
    if (typeof optionIndex === "undefined") optionIndex = 0;
    var option = optionNames[optionIndex || 0];
    if (!previousItem.children || !previousItem.children.length) return;
    if (option.itemName === "color") {
      options[option.groupName] = findColorFromCombinations(options, previousItem.children);
    } else if (option.itemName === "interiorDesign") {
      options[option.groupName] = findInteriorsFromCombinations(options, previousItem.children);
    } else {
      options[option.groupName] = previousItem.children;
    }
    options[option.itemName] = selectItem(options[option.groupName], newSelection, option.itemName);
    if (typeof options[option.itemName] === "undefined") {
      throw new Error("Option name " + option.itemName + " does not exist in options.");
    }
    if (options[option.itemName].type !== option.itemName) {
      throw new Error("Option type (" + options[option.itemName].type + ") does not match expected type. (" + option.itemName + ")");
    }
    buildStateOptions(options[option.itemName], optionIndex + 1);
  };
  try {
    buildStateOptions(data);
  } catch (error) {
    console.warn(error, options);
  }
  return options;
};

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inRange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isFinite; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__function__ = __webpack_require__(35);


var inRange = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (min, max, val) {
  return val >= min && val < max;
});

var isFinite = function isFinite(val) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(Number.isFinite)) return Number.isFinite(val);
  return typeof val === "number" ? !isNaN(val) && val !== -Infinity && val !== Infinity : false;
};

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPageName; });
var getPageName = function getPageName() {
  var pageName = window.location.pathname || "";
  if (pageName === "/") pageName = "Home";
  return pageName.charAt(0).toUpperCase() + pageName.slice(1);
};

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pushParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pushQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filteredParamsFromLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return paramsFromLocation; });
/* unused harmony export filterParams */
/* unused harmony export paramsToString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shallow_equals__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shallow_equals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shallow_equals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__history__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__object__ = __webpack_require__(134);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






// pushParam will merge supplied params with current url params and push them to url
var pushParam = function pushParam(param) {
  var trackParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var exposeParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var currentParams = paramsFromLocation(location);
  var params = _extends({}, currentParams, param);
  var omitParams = Object.keys(params).filter(function (key) {
    return params[key] === false || typeof params[key] === "undefined";
  });
  var sanitizedParams = Object(__WEBPACK_IMPORTED_MODULE_3__object__["d" /* omit */])(omitParams, params);
  pushQuery(sanitizedParams, trackParams, exposeParams);
};

// pushQuery will push a new query string from query object supplied
var pushQuery = function pushQuery(query) {
  var trackParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var exposeParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var currentParams = filteredParamsFromLocation(location, exposeParams);
  if (__WEBPACK_IMPORTED_MODULE_1_shallow_equals___default()(currentParams, query)) return;
  var push = Object.keys(query).some(function (key) {
    return trackParams.some(function (param) {
      return param === key && String(currentParams[key]) !== String(query[key]);
    });
  });
  var search = paramsToString(query);
  if (push) {
    __WEBPACK_IMPORTED_MODULE_2__history__["b" /* history */].push({ search: search, breakLoop: true });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__history__["b" /* history */].replace({ search: search, breakLoop: true });
  }
};

var filteredParamsFromLocation = function filteredParamsFromLocation(location) {
  var exposeParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return filterParams(paramsFromLocation(location), exposeParams);
};

var paramsFromLocation = function paramsFromLocation(location) {
  return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location && location.search);
};

var filterParams = function filterParams(params) {
  var exposeParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var filderedParams = exposeParams.reduce(function (accepted, param) {
    var _extends2;

    return _extends({}, accepted, (_extends2 = {}, _extends2[param] = Object(__WEBPACK_IMPORTED_MODULE_3__object__["b" /* get */])(param, params), _extends2));
  }, {});
  Object.keys(filderedParams).forEach(function (key) {
    return filderedParams[key] === undefined && delete filderedParams[key];
  });
  return filderedParams;
};

var paramsToString = function paramsToString(params) {
  /**
   * This kind of content specific function does not belong here.
   * @todo - Allow search params to be ordered.
   */

  // step should be always first in QueryParam because of GTM
  if (params.step === undefined) {
    return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
  }
  var step = params.step;
  delete params.step;
  var newParams = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
  newParams = "step=" + step + "&" + newParams;
  return newParams;
};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = shallow

function shallow(a, b, compare) {
  var aIsNull = a === null
  var bIsNull = b === null

  if (aIsNull !== bIsNull) return false

  var aIsArray = Array.isArray(a)
  var bIsArray = Array.isArray(b)

  if (aIsArray !== bIsArray) return false

  var aTypeof = typeof a
  var bTypeof = typeof b

  if (aTypeof !== bTypeof) return false
  if (flat(aTypeof)) return compare
    ? compare(a, b)
    : a === b

  return aIsArray
    ? shallowArray(a, b, compare)
    : shallowObject(a, b, compare)
}

function shallowArray(a, b, compare) {
  var l = a.length
  if (l !== b.length) return false

  if (compare) {
    for (var i = 0; i < l; i++)
      if (!compare(a[i], b[i])) return false
  } else {
    for (var i = 0; i < l; i++) {
      if (a[i] !== b[i]) return false
    }
  }

  return true
}

function shallowObject(a, b, compare) {
  var ka = 0
  var kb = 0

  if (compare) {
    for (var key in a) {
      if (
        a.hasOwnProperty(key) &&
        !compare(a[key], b[key])
      ) return false

      ka++
    }
  } else {
    for (var key in a) {
      if (
        a.hasOwnProperty(key) &&
        a[key] !== b[key]
      ) return false

      ka++
    }
  }

  for (var key in b) {
    if (b.hasOwnProperty(key)) kb++
  }

  return ka === kb
}

function flat(type) {
  return (
    type !== 'function' &&
    type !== 'object'
  )
}


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focusWithoutScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getScrollTop; });
/* unused harmony export getElementOffset */
/* unused harmony export doesElementContainScrollTop */
/* unused harmony export checkLocationRelevance */
/* unused harmony export checkElementRelevance */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBestAnchorGivenScrollLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return scrollToElementId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return scrollToNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return scrollToOffset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweet_scroll__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweet_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweet_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_environment__ = __webpack_require__(12);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var focusWithoutScroll = function focusWithoutScroll(element) {
  var x = __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */].scrollX;
  var y = __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */].scrollY;
  element.focus();
  __WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* WINDOW */].scrollTo(x, y);
};

var getScrollTop = function getScrollTop() {
  return document.body.scrollTop || document.documentElement.scrollTop;
};

// get vertical offsets of element, taking scrollTop into consideration
var getElementOffset = function getElementOffset(element) {
  var scrollTop = getScrollTop();

  var _element$getBoundingC = element.getBoundingClientRect(),
      top = _element$getBoundingC.top,
      bottom = _element$getBoundingC.bottom;

  return {
    top: Math.floor(top + scrollTop),
    bottom: Math.floor(bottom + scrollTop)
  };
};

// does scrollTop live within element bounds?
var doesElementContainScrollTop = function doesElementContainScrollTop(element) {
  var extraOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var scrollTop = getScrollTop();
  var offsetTop = getElementOffset(element).top + extraOffset;
  return scrollTop >= offsetTop && scrollTop < offsetTop + element.offsetHeight;
};

// is el2's location more relevant than el2,
// parent-child relationship aside?
var checkLocationRelevance = function checkLocationRelevance(el1, el2) {
  var _getElementOffset = getElementOffset(el1),
      top1 = _getElementOffset.top,
      bottom1 = _getElementOffset.bottom;

  var _getElementOffset2 = getElementOffset(el2),
      top2 = _getElementOffset2.top,
      bottom2 = _getElementOffset2.bottom;

  if (top1 === top2) {
    if (bottom1 === bottom2) {
      // top and bottom of compared elements are the same,
      // so return one randomly in a deterministic way
      return el1 < el2;
    }
    // top of compared elements is the same, so return whichever
    // element has its bottom higher on the page
    return bottom2 < bottom1;
  }
  // top of compared elements differ, so return true
  // if tested element has its top lower on the page
  return top2 > top1;
};

// check if el2 is more relevant than el1, considering child-parent
// relationships as well as node location.
var checkElementRelevance = function checkElementRelevance(el1, el2) {
  if (el1.contains(el2)) {
    // el2 is child, so it gains relevance priority
    return true;
  } else if (!el2.contains(el1) && checkLocationRelevance(el1, el2)) {
    // el1 and el2 are unrelated, but el2 has a better location,
    // so it gains relevance priority
    return true;
  }
  return false;
};

// given a set of anchors, find which one is, given the following logic:
// 1. children nodes are more relevant than parent nodes
// 2. if neither node contains the other, and their top locations differ,
//    the node with the top lower on the page is more relevant
// 3. if neither node contains the other, and their top locations are the same,
//    the node with the bottom higher on the page is more relevant
// 4. if neither node contains the other, and their top and bottom locations
//    are the same, a node is chosen at random, in a deterministic way,
//    to be more relevant.
var getBestAnchorGivenScrollLocation = function getBestAnchorGivenScrollLocation(anchors, offset) {
  var bestId = void 0,
      bestElement = void 0;

  Object.keys(anchors).forEach(function (id) {
    var element = anchors[id];
    if (anchors && anchors[id] && element) {
      if (doesElementContainScrollTop(element, offset)) {
        if (!bestElement || checkElementRelevance(bestElement, element)) {
          bestElement = element;
          bestId = id;
        }
      }
    }
  });
  return bestId;
};

var scrollToElementId = function scrollToElementId(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callBack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  var element = document.querySelector("[data-id=\"" + id + "\"]");
  if (!__WEBPACK_IMPORTED_MODULE_1__constants_environment__["c" /* IS_BROWSER */] || !id || !element) {} else {
    scrollToNode(element, _extends({}, options), callBack);
  }
};

var scrollToNode = function scrollToNode(target) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 1000 : _ref$duration,
      _ref$container = _ref.container,
      container = _ref$container === undefined ? "body, html" : _ref$container,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset;

  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  if (!__WEBPACK_IMPORTED_MODULE_1__constants_environment__["c" /* IS_BROWSER */] || !target) return;
  var sweetScroll = new __WEBPACK_IMPORTED_MODULE_0_sweet_scroll___default.a({
    duration: duration,
    offset: offset,
    stopPropagation: false,
    afterScroll: callback
  }, container);
  sweetScroll.toElement(target);
};

var scrollToOffset = function scrollToOffset() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$duration = _ref2.duration,
      duration = _ref2$duration === undefined ? 1000 : _ref2$duration,
      _ref2$container = _ref2.container,
      container = _ref2$container === undefined ? "body, html" : _ref2$container;

  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  if (!__WEBPACK_IMPORTED_MODULE_1__constants_environment__["c" /* IS_BROWSER */]) return Promise.resolve();
  var sweetScroll = new __WEBPACK_IMPORTED_MODULE_0_sweet_scroll___default.a({
    duration: duration,
    stopPropagation: false,
    afterScroll: callback
  }, container);
  sweetScroll.to(offset);
  return new Promise(function (resolve) {
    return setTimeout(resolve, duration);
  });
};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

/*! @preserve sweet-scroll v3.0.1 - tsuyoshiwada | MIT License */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.SweetScroll = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    // @link https://github.com/JedWatson/exenv/blob/master/index.js
    var canUseDOM = !!(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
    var canUseHistory = !canUseDOM
        ? false
        : (window.history &&
            'pushState' in window.history &&
            window.location.protocol !== 'file:');
    var canUsePassiveOption = (function () {
        var support = false;
        if (!canUseDOM) {
            return support;
        }
        /* tslint:disable:no-empty */
        try {
            window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
                get: function () {
                    support = true;
                },
            }));
        }
        catch (e) { }
        /* tslint:enable */
        return support;
    })();

    var isString = function (obj) { return typeof obj === 'string'; };
    var isFunction = function (obj) { return typeof obj === 'function'; };
    var isArray = function (obj) { return Array.isArray(obj); };
    var isNumeric = function (obj) { return !isArray(obj) && ((obj - parseFloat(obj)) + 1) >= 0; };
    var isElement = function (obj) { return obj instanceof Element; };
    var hasProp = function (obj, key) { return (obj && obj.hasOwnProperty(key)); };

    var raf = canUseDOM ? window.requestAnimationFrame.bind(window) : null;
    var caf = canUseDOM ? window.cancelAnimationFrame.bind(window) : null;

    /* tslint:disable:curly */
    /* tslint:disable:no-conditional-assignment */
    var cos = Math.cos, sin = Math.sin, pow = Math.pow, sqrt = Math.sqrt, PI = Math.PI;
    var easings = {
        linear: function (p) { return p; },
        easeInQuad: function (_, t, b, c, d) { return (c * (t /= d) * t + b); },
        easeOutQuad: function (_, t, b, c, d) { return (-c * (t /= d) * (t - 2) + b); },
        easeInOutQuad: function (_, t, b, c, d) { return ((t /= d / 2) < 1 ? c / 2 * t * t + b : -c / 2 * ((--t) * (t - 2) - 1) + b); },
        easeInCubic: function (_, t, b, c, d) { return (c * (t /= d) * t * t + b); },
        easeOutCubic: function (_, t, b, c, d) { return (c * ((t = t / d - 1) * t * t + 1) + b); },
        easeInOutCubic: function (_, t, b, c, d) { return ((t /= d / 2) < 1 ? c / 2 * t * t * t + b : c / 2 * ((t -= 2) * t * t + 2) + b); },
        easeInQuart: function (_, t, b, c, d) { return (c * (t /= d) * t * t * t + b); },
        easeOutQuart: function (_, t, b, c, d) { return (-c * ((t = t / d - 1) * t * t * t - 1) + b); },
        easeInOutQuart: function (_, t, b, c, d) { return ((t /= d / 2) < 1 ? c / 2 * t * t * t * t + b : -c / 2 * ((t -= 2) * t * t * t - 2) + b); },
        easeInQuint: function (_, t, b, c, d) { return (c * (t /= d) * t * t * t * t + b); },
        easeOutQuint: function (_, t, b, c, d) { return (c * ((t = t / d - 1) * t * t * t * t + 1) + b); },
        easeInOutQuint: function (_, t, b, c, d) { return ((t /= d / 2) < 1 ? c / 2 * t * t * t * t * t + b : c / 2 * ((t -= 2) * t * t * t * t + 2) + b); },
        easeInSine: function (_, t, b, c, d) { return (-c * cos(t / d * (PI / 2)) + c + b); },
        easeOutSine: function (_, t, b, c, d) { return (c * sin(t / d * (PI / 2)) + b); },
        easeInOutSine: function (_, t, b, c, d) { return (-c / 2 * (cos(PI * t / d) - 1) + b); },
        easeInExpo: function (_, t, b, c, d) { return ((t === 0) ? b : c * pow(2, 10 * (t / d - 1)) + b); },
        easeOutExpo: function (_, t, b, c, d) { return ((t === d) ? b + c : c * (-pow(2, -10 * t / d) + 1) + b); },
        easeInOutExpo: function (_, t, b, c, d) {
            if (t === 0)
                return b;
            if (t === d)
                return b + c;
            if ((t /= d / 2) < 1)
                return c / 2 * pow(2, 10 * (t - 1)) + b;
            return c / 2 * (-pow(2, -10 * --t) + 2) + b;
        },
        easeInCirc: function (_, t, b, c, d) { return (-c * (sqrt(1 - (t /= d) * t) - 1) + b); },
        easeOutCirc: function (_, t, b, c, d) { return (c * sqrt(1 - (t = t / d - 1) * t) + b); },
        easeInOutCirc: function (_, t, b, c, d) { return ((t /= d / 2) < 1 ? -c / 2 * (sqrt(1 - t * t) - 1) + b : c / 2 * (sqrt(1 - (t -= 2) * t) + 1) + b); },
    };

    var directionMethodMap = {
        y: 'scrollTop',
        x: 'scrollLeft',
    };
    var directionPropMap = {
        y: 'pageYOffset',
        x: 'pageXOffset',
    };
    var getScroll = function ($el, direction) { return ($el[directionMethodMap[direction]]); };
    var setScroll = function ($el, offset, direction) {
        $el[directionMethodMap[direction]] = offset;
    };
    var getOffset = function ($el, $context) {
        var rect = $el.getBoundingClientRect();
        if (rect.width || rect.height) {
            var scroll_1 = { top: 0, left: 0 };
            var $ctx = void 0;
            if (isRootContainer($context)) {
                $ctx = document.documentElement;
                scroll_1.top = window[directionPropMap.y];
                scroll_1.left = window[directionPropMap.x];
            }
            else {
                $ctx = $context;
                var cRect = $ctx.getBoundingClientRect();
                scroll_1.top = (cRect.top * -1) + $ctx[directionMethodMap.y];
                scroll_1.left = (cRect.left * -1) + $ctx[directionMethodMap.x];
            }
            return {
                top: (rect.top + scroll_1.top) - $ctx.clientTop,
                left: (rect.left + scroll_1.left) - $ctx.clientLeft,
            };
        }
        return rect;
    };

    var $$ = function (selector) { return (Array.prototype.slice.call((!selector ? [] : document.querySelectorAll(selector)))); };
    var $ = function (selector) { return ($$(selector).shift() || null); };
    var matches = function ($el, selector) {
        if (isElement(selector)) {
            return $el === selector;
        }
        var results = $$(selector);
        var i = results.length;
        // tslint:disable-next-line no-empty
        while (--i >= 0 && results[i] !== $el) { }
        return i > -1;
    };
    var isRootContainer = function ($el) { return ($el === document.documentElement || $el === document.body); };
    var findScrollable = function (selectors, direction) {
        var method = directionMethodMap[direction];
        var $elements = isElement(selectors) ? [selectors] : $$(selectors);
        var $div = document.createElement('div');
        for (var i = 0; i < $elements.length; i += 1) {
            var $el = $elements[i];
            var $result = null;
            if ($el[method] > 0) {
                $result = $el;
            }
            else {
                var outerWidth_1 = window.outerWidth, innerWidth_1 = window.innerWidth;
                var zoom = outerWidth_1 ? outerWidth_1 / innerWidth_1 : 1;
                $div.style.width = $el.clientWidth + 1 + "px";
                $div.style.height = $el.clientHeight + 1 + "px";
                $el.appendChild($div);
                $el[method] = Math.max(1, 1.5 / zoom);
                if ($el[method] > 0) {
                    $result = $el;
                }
                $el[method] = 0;
                $el.removeChild($div);
            }
            if ($result) {
                return $result;
            }
        }
        return null;
    };

    var getHeight = function ($el) { return (Math.max($el.scrollHeight, $el.clientHeight, $el.offsetHeight)); };
    var getWidth = function ($el) { return (Math.max($el.scrollWidth, $el.clientWidth, $el.offsetWidth)); };
    var getSize = function ($el) { return ({
        width: getWidth($el),
        height: getHeight($el),
    }); };
    var getViewportAndElementSizes = function ($el) {
        var isRoot = isRootContainer($el);
        return {
            viewport: {
                width: isRoot
                    ? Math.min(window.innerWidth, document.documentElement.clientWidth)
                    : $el.clientWidth,
                height: isRoot ? window.innerHeight : $el.clientHeight,
            },
            size: isRoot
                ? {
                    width: Math.max(getWidth(document.body), getWidth(document.documentElement)),
                    height: Math.max(getHeight(document.body), getHeight(document.documentElement)),
                }
                : getSize($el),
        };
    };

    var wheelEventName = (function () {
        if (!canUseDOM) {
            return 'wheel';
        }
        return 'onwheel' in document ? 'wheel' : 'mousewheel';
    })();
    var eventName = function (name) { return (name === 'wheel' ? wheelEventName : name); };
    var apply = function ($el, method, event, listener, passive) {
        event.split(' ').forEach(function (name) {
            $el[method](eventName(name), listener, canUsePassiveOption ? { passive: passive } : false);
        });
    };
    var addEvent = function ($el, event, listener, passive) {
        apply($el, 'addEventListener', event, listener, passive);
    };
    var removeEvent = function ($el, event, listener, passive) {
        apply($el, 'removeEventListener', event, listener, passive);
    };

    var reRelativeToken = /^(\+|-)=(\d+(?:\.\d+)?)$/;
    var parseCoordinate = function (coordinate, enableVertical) {
        var res = { top: 0, left: 0, relative: false };
        // Object ({ top: {n}, left: {n} })
        if (hasProp(coordinate, 'top') || hasProp(coordinate, 'left')) {
            res = __assign({}, res, coordinate);
            // Array ([{n}, [{n}])
        }
        else if (isArray(coordinate)) {
            if (coordinate.length > 1) {
                res.top = coordinate[0];
                res.left = coordinate[1];
            }
            else if (coordinate.length === 1) {
                res.top = enableVertical ? coordinate[0] : 0;
                res.left = !enableVertical ? coordinate[0] : 0;
            }
            else {
                return null;
            }
            // Number
        }
        else if (isNumeric(coordinate)) {
            if (enableVertical) {
                res.top = coordinate;
            }
            else {
                res.left = coordinate;
            }
            // String ('+={n}', '-={n}')
        }
        else if (isString(coordinate)) {
            var m = coordinate.trim().match(reRelativeToken);
            if (!m) {
                return null;
            }
            var op = m[1];
            var val = parseInt(m[2], 10);
            if (op === '+') {
                res.top = enableVertical ? val : 0;
                res.left = !enableVertical ? val : 0;
            }
            else {
                res.top = enableVertical ? -val : 0;
                res.left = !enableVertical ? -val : 0;
            }
            res.relative = true;
        }
        else {
            return null;
        }
        return res;
    };

    var defaultOptions = {
        trigger: '[data-scroll]',
        header: '[data-scroll-header]',
        duration: 1000,
        easing: 'easeOutQuint',
        offset: 0,
        vertical: true,
        horizontal: false,
        cancellable: true,
        updateURL: false,
        preventDefault: true,
        stopPropagation: true,
        quickMode: false,
        // Callbacks
        before: null,
        after: null,
        cancel: null,
        complete: null,
        step: null,
    };

    var CONTAINER_CLICK_EVENT = 'click';
    var CONTAINER_STOP_EVENT = 'wheel touchstart touchmove';
    var SweetScroll = /** @class */ (function () {
        /**
         * Constructor
         */
        function SweetScroll(options, container) {
            var _this = this;
            this.ctx = {
                $trigger: null,
                opts: null,
                progress: false,
                pos: null,
                startPos: null,
                easing: null,
                start: 0,
                id: 0,
                cancel: false,
                hash: null,
            };
            /**
             * Handle each frame of the animation.
             */
            this.loop = function (time) {
                var _a = _this, $el = _a.$el, ctx = _a.ctx;
                if (!ctx.start) {
                    ctx.start = time;
                }
                if (!ctx.progress || !$el) {
                    _this.stop();
                    return;
                }
                var options = ctx.opts;
                var offset = ctx.pos;
                var start = ctx.start;
                var startOffset = ctx.startPos;
                var easing = ctx.easing;
                var duration = options.duration;
                var directionMap = { top: 'y', left: 'x' };
                var timeElapsed = time - start;
                var t = Math.min(1, Math.max(timeElapsed / duration, 0));
                Object.keys(offset).forEach(function (key) {
                    var value = offset[key];
                    var initial = startOffset[key];
                    var delta = value - initial;
                    if (delta !== 0) {
                        var val = easing(t, duration * t, 0, 1, duration);
                        setScroll($el, Math.round(initial + delta * val), directionMap[key]);
                    }
                });
                if (timeElapsed <= duration) {
                    _this.hook(options, 'step', t);
                    ctx.id = SweetScroll.raf(_this.loop);
                }
                else {
                    _this.stop(true);
                }
            };
            /**
             * Handling of container click event.
             */
            this.handleClick = function (e) {
                var opts = _this.opts;
                var $el = e.target;
                for (; $el && $el !== document; $el = $el.parentNode) {
                    if (!matches($el, opts.trigger)) {
                        continue;
                    }
                    var dataOptions = JSON.parse($el.getAttribute('data-scroll-options') || '{}');
                    var data = $el.getAttribute('data-scroll');
                    var to = data || $el.getAttribute('href');
                    var options = __assign({}, opts, dataOptions);
                    var preventDefault = options.preventDefault, stopPropagation = options.stopPropagation, vertical = options.vertical, horizontal = options.horizontal;
                    if (preventDefault) {
                        e.preventDefault();
                    }
                    if (stopPropagation) {
                        e.stopPropagation();
                    }
                    // Passes the trigger element to callback
                    _this.ctx.$trigger = $el;
                    if (horizontal && vertical) {
                        _this.to(to, options);
                    }
                    else if (vertical) {
                        _this.toTop(to, options);
                    }
                    else if (horizontal) {
                        _this.toLeft(to, options);
                    }
                }
            };
            /**
             * Handling of container stop events.
             */
            this.handleStop = function (e) {
                var ctx = _this.ctx;
                var opts = ctx.opts;
                if (opts && opts.cancellable) {
                    ctx.cancel = true;
                    _this.stop();
                }
                else {
                    e.preventDefault();
                }
            };
            var opts = __assign({}, defaultOptions, (options || {}));
            var vertical = opts.vertical, horizontal = opts.horizontal;
            var selector = container === undefined ? 'body,html' : container;
            var $container = null;
            if (canUseDOM) {
                if (vertical) {
                    $container = findScrollable(selector, 'y');
                }
                if (!$container && horizontal) {
                    $container = findScrollable(selector, 'x');
                }
            }
            if ($container) {
                this.opts = opts;
                this.$el = $container;
                this.bind(true, false);
            }
        }
        /**
         * SweetScroll instance factory.
         */
        SweetScroll.create = function (options, container) {
            return new SweetScroll(options, container);
        };
        /**
         * Scroll animation to the specified position.
         */
        SweetScroll.prototype.to = function (distance, options) {
            if (!canUseDOM) {
                return;
            }
            var _a = this, $el = _a.$el, ctx = _a.ctx, currentOptions = _a.opts;
            var $trigger = ctx.$trigger;
            var opts = __assign({}, currentOptions, options || {});
            var optOffset = opts.offset, vertical = opts.vertical, horizontal = opts.horizontal;
            var $header = isElement(opts.header) ? opts.header : $(opts.header);
            var hash = isString(distance) && /^#/.test(distance) ? distance : null;
            ctx.opts = opts; // Temporary options
            ctx.cancel = false; // Disable the call flag of `cancel`
            ctx.hash = hash;
            // Stop current animation
            this.stop();
            // Does not move if the container is not found
            if (!$el) {
                return;
            }
            // Get scroll offset
            var offset = parseCoordinate(optOffset, vertical);
            var coordinate = parseCoordinate(distance, vertical);
            var scroll = { top: 0, left: 0 };
            if (coordinate) {
                if (coordinate.relative) {
                    var current = getScroll($el, vertical ? 'y' : 'x');
                    scroll.top = vertical ? current + coordinate.top : coordinate.top;
                    scroll.left = !vertical ? current + coordinate.left : coordinate.left;
                }
                else {
                    scroll = coordinate;
                }
            }
            else if (isString(distance) && distance !== '#') {
                var $target = $(distance);
                if (!$target) {
                    return;
                }
                scroll = getOffset($target, $el);
            }
            if (offset) {
                scroll.top += offset.top;
                scroll.left += offset.left;
            }
            if ($header) {
                scroll.top = Math.max(0, scroll.top - getSize($header).height);
            }
            // Normalize scroll offset
            var _b = getViewportAndElementSizes($el), viewport = _b.viewport, size = _b.size;
            scroll.top = vertical
                ? Math.max(0, Math.min(size.height - viewport.height, scroll.top))
                : getScroll($el, 'y');
            scroll.left = horizontal
                ? Math.max(0, Math.min(size.width - viewport.width, scroll.left))
                : getScroll($el, 'x');
            // Call `before`
            // Stop scrolling when it returns false
            if (this.hook(opts, 'before', scroll, $trigger) === false) {
                ctx.opts = null;
                return;
            }
            // Set offset
            ctx.pos = scroll;
            // Run animation!!
            this.start(opts);
            // Bind stop events
            this.bind(false, true);
        };
        /**
         * Scroll animation to specified left position.
         */
        SweetScroll.prototype.toTop = function (distance, options) {
            this.to(distance, __assign({}, options || {}, { vertical: true, horizontal: false }));
        };
        /**
         * Scroll animation to specified top position.
         */
        SweetScroll.prototype.toLeft = function (distance, options) {
            this.to(distance, __assign({}, options || {}, { vertical: false, horizontal: true }));
        };
        /**
         * Scroll animation to specified element.
         */
        SweetScroll.prototype.toElement = function ($element, options) {
            var $el = this.$el;
            if (!canUseDOM || !$el) {
                return;
            }
            this.to(getOffset($element, $el), options || {});
        };
        /**
         * Stop the current scroll animation.
         */
        SweetScroll.prototype.stop = function (gotoEnd) {
            if (gotoEnd === void 0) { gotoEnd = false; }
            var _a = this, $el = _a.$el, ctx = _a.ctx;
            var pos = ctx.pos;
            if (!$el || !ctx.progress) {
                return;
            }
            SweetScroll.caf(ctx.id);
            ctx.progress = false;
            ctx.start = 0;
            ctx.id = 0;
            if (gotoEnd && pos) {
                setScroll($el, pos.left, 'x');
                setScroll($el, pos.top, 'y');
            }
            this.complete();
        };
        /**
         * Update options.
         */
        SweetScroll.prototype.update = function (options) {
            if (this.$el) {
                var opts = __assign({}, this.opts, options);
                this.stop();
                this.unbind(true, true);
                this.opts = opts;
                this.bind(true, false);
            }
        };
        /**
         * Destroy instance.
         */
        SweetScroll.prototype.destroy = function () {
            if (this.$el) {
                this.stop();
                this.unbind(true, true);
                this.$el = null;
            }
        };
        /**
         * Callback methods.
         */
        /* tslint:disable:no-empty */
        SweetScroll.prototype.onBefore = function (_, __) { return true; };
        SweetScroll.prototype.onStep = function (_) { };
        SweetScroll.prototype.onAfter = function (_, __) { };
        SweetScroll.prototype.onCancel = function () { };
        SweetScroll.prototype.onComplete = function (_) { };
        /* tslint:enable */
        /**
         * Start scrolling animation.
         */
        SweetScroll.prototype.start = function (opts) {
            var ctx = this.ctx;
            ctx.opts = opts;
            ctx.progress = true;
            ctx.easing = isFunction(opts.easing)
                ? opts.easing
                : easings[opts.easing];
            // Update start offset.
            var $container = this.$el;
            var offset = ctx.pos;
            var start = {
                top: getScroll($container, 'y'),
                left: getScroll($container, 'x'),
            };
            if (opts.quickMode) {
                var _a = getViewportAndElementSizes($container).viewport, width = _a.width, height = _a.height;
                if (Math.abs(start.top - offset.top) > height) {
                    start.top = start.top > offset.top ? offset.top + height : offset.top - height;
                }
                if (Math.abs(start.left - offset.left) > width) {
                    start.left = start.left > offset.left ? offset.left + width : offset.left - width;
                }
            }
            ctx.startPos = start;
            // Loop
            ctx.id = SweetScroll.raf(this.loop);
        };
        /**
         * Handle the completion of scrolling animation.
         */
        SweetScroll.prototype.complete = function () {
            var _a = this, $el = _a.$el, ctx = _a.ctx;
            var hash = ctx.hash, cancel = ctx.cancel, opts = ctx.opts, pos = ctx.pos, $trigger = ctx.$trigger;
            if (!$el || !opts) {
                return;
            }
            if (hash != null && hash !== window.location.hash) {
                var updateURL = opts.updateURL;
                if (canUseDOM && canUseHistory && updateURL !== false) {
                    window.history[updateURL === 'replace' ? 'replaceState' : 'pushState'](null, '', hash);
                }
            }
            this.unbind(false, true);
            ctx.opts = null;
            ctx.$trigger = null;
            if (cancel) {
                this.hook(opts, 'cancel');
            }
            else {
                this.hook(opts, 'after', pos, $trigger);
            }
            this.hook(opts, 'complete', cancel);
        };
        /**
         * Callback function and method call.
         */
        SweetScroll.prototype.hook = function (options, type) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            var callback = options[type];
            var callbackResult;
            var methodResult;
            // callback
            if (isFunction(callback)) {
                callbackResult = callback.apply(this, args.concat([this]));
            }
            // method
            methodResult = this["on" + (type[0].toUpperCase() + type.slice(1))].apply(this, args);
            return callbackResult !== undefined ? callbackResult : methodResult;
        };
        /**
         * Bind events of container element.
         */
        SweetScroll.prototype.bind = function (click, stop) {
            var _a = this, $el = _a.$el, opts = _a.ctx.opts;
            if ($el) {
                if (click) {
                    addEvent($el, CONTAINER_CLICK_EVENT, this.handleClick, false);
                }
                if (stop) {
                    addEvent($el, CONTAINER_STOP_EVENT, this.handleStop, opts ? opts.cancellable : true);
                }
            }
        };
        /**
         * Unbind events of container element.
         */
        SweetScroll.prototype.unbind = function (click, stop) {
            var _a = this, $el = _a.$el, opts = _a.ctx.opts;
            if ($el) {
                if (click) {
                    removeEvent($el, CONTAINER_CLICK_EVENT, this.handleClick, false);
                }
                if (stop) {
                    removeEvent($el, CONTAINER_STOP_EVENT, this.handleStop, opts ? opts.cancellable : true);
                }
            }
        };
        /**
         * You can set Polyfill (or Ponyfill) for browsers that do not support requestAnimationFrame.
         */
        SweetScroll.raf = raf;
        SweetScroll.caf = caf;
        return SweetScroll;
    }());

    return SweetScroll;

})));


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatAddress; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(228);


var formatPhoneNumber = function formatPhoneNumber(number) {
  var match = number.match(/^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?)(\d[- ]?\d{3})$/);
  if (match && match.length === 5) {
    return "(" + match[2].trim() + ") " + match[3].trim() + " " + match[4].trim();
  }
  return number;
};

var formatAddress = function formatAddress(_ref) {
  var address1 = _ref.address1,
      address2 = _ref.address2,
      address3 = _ref.address3,
      postcode = _ref.postcode,
      state = _ref.state,
      townName = _ref.townName;
  return [address1, address2, address3].filter(Boolean).join(" ") + ", " + Object(__WEBPACK_IMPORTED_MODULE_0__string__["c" /* titleCase */])(townName) + " " + state + " " + postcode;
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["React"] = __webpack_require__(0);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["ReactDOM"] = __webpack_require__(32);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.7.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(53),ba=__webpack_require__(933);function ca(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[c,d,e,f,g,h],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function t(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:t("227");function da(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,h,k){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,h,k){ka.apply(this,arguments);if(ea){if(ea){var l=fa;ea=!1;fa=null}else t("198"),l=void 0;ha||(ha=!0,ia=l)}}var ma=null,na={};
function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:t("96",a);if(!pa[c]){b.extractEvents?void 0:t("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.hasOwnProperty(h)?t("99",h):void 0;qa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:t("98",d,a)}}}}
function ra(a,b,c){sa[a]?t("100",a):void 0;sa[a]=b;ta[a]=b.eventTypes[c].dependencies}var pa=[],qa={},sa={},ta={},ua=null,va=null,wa=null;function xa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=wa(c);la(d,b,void 0,a);a.currentTarget=null}function ya(a,b){null==b?t("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Aa=null;function Ba(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)xa(a,b[d],c[d]);else b&&xa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ca={injectEventPluginOrder:function(a){ma?t("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?t("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?t("231",b,typeof c):void 0;
return c}function Ea(a){null!==a&&(Aa=ya(Aa,a));a=Aa;Aa=null;if(a&&(za(a,Ba),Aa?t("95"):void 0,ha))throw a=ia,ha=!1,ia=null,a;}var Fa=Math.random().toString(36).slice(2),Ga="__reactInternalInstance$"+Fa,Ha="__reactEventHandlers$"+Fa;function Ia(a){if(a[Ga])return a[Ga];for(;!a[Ga];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ga];return 5===a.tag||6===a.tag?a:null}function Ja(a){a=a[Ga];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ka(a){if(5===a.tag||6===a.tag)return a.stateNode;t("33")}function La(a){return a[Ha]||null}function Ma(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Na(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a)}
function Oa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Ma(b);for(b=c.length;0<b--;)Na(c[b],"captured",a);for(b=0;b<c.length;b++)Na(c[b],"bubbled",a)}}function Pa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a))}function Qa(a){a&&a.dispatchConfig.registrationName&&Pa(a._targetInst,null,a)}
function Ra(a){za(a,Oa)}var Sa=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ta(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ua={animationend:Ta("Animation","AnimationEnd"),animationiteration:Ta("Animation","AnimationIteration"),animationstart:Ta("Animation","AnimationStart"),transitionend:Ta("Transition","TransitionEnd")},Va={},Wa={};
Sa&&(Wa=document.createElement("div").style,"AnimationEvent"in window||(delete Ua.animationend.animation,delete Ua.animationiteration.animation,delete Ua.animationstart.animation),"TransitionEvent"in window||delete Ua.transitionend.transition);function Xa(a){if(Va[a])return Va[a];if(!Ua[a])return a;var b=Ua[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Wa)return Va[a]=b[c];return a}
var Ya=Xa("animationend"),Za=Xa("animationiteration"),$a=Xa("animationstart"),ab=Xa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,eb=null,fb=null;
function gb(){if(fb)return fb;var a,b=eb,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return fb=e.slice(a,1<d?1-d:void 0)}function hb(){return!0}function ib(){return!1}
function z(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?hb:ib;this.isPropagationStopped=ib;return this}
n(z.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=hb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=hb)},persist:function(){this.isPersistent=hb},isPersistent:ib,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ib;this._dispatchInstances=this._dispatchListeners=null}});z.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
z.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;jb(c);return c};jb(z);function kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function lb(a){a instanceof this?void 0:t("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function jb(a){a.eventPool=[];a.getPooled=kb;a.release=lb}var mb=z.extend({data:null}),nb=z.extend({data:null}),ob=[9,13,27,32],pb=Sa&&"CompositionEvent"in window,qb=null;Sa&&"documentMode"in document&&(qb=document.documentMode);
var rb=Sa&&"TextEvent"in window&&!qb,sb=Sa&&(!pb||qb&&8<qb&&11>=qb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
function wb(a,b){switch(a){case "keyup":return-1!==ob.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function zb(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
function Ab(a,b){if(yb)return"compositionend"===a||!pb&&wb(a,b)?(a=gb(),fb=eb=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Bb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(pb)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=gb()):(cb=d,eb="value"in cb?cb.value:cb.textContent,yb=
!0)),e=mb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Ra(e),f=e):f=null;(a=rb?zb(a,c):Ab(a,c))?(b=nb.getPooled(ub.beforeInput,b,c,d),b.data=a,Ra(b)):b=null;return null===f?b:null===b?f:[f,b]}},Cb=null,Db=null,Eb=null;function Hb(a){if(a=va(a)){"function"!==typeof Cb?t("280"):void 0;var b=ua(a.stateNode);Cb(a.stateNode,a.type,b)}}function Ib(a){Db?Eb?Eb.push(a):Eb=[a]:Db=a}function Jb(){if(Db){var a=Db,b=Eb;Eb=Db=null;Hb(a);if(b)for(a=0;a<b.length;a++)Hb(b[a])}}
function Kb(a,b){return a(b)}function Lb(a,b,c){return a(b,c)}function Mb(){}var Nb=!1;function Ob(a,b){if(Nb)return a(b);Nb=!0;try{return Kb(a,b)}finally{if(Nb=!1,null!==Db||null!==Eb)Mb(),Jb()}}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Sa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yb=/^(.*)[\\\/]/,D="function"===typeof Symbol&&Symbol.for,Zb=D?Symbol.for("react.element"):60103,$b=D?Symbol.for("react.portal"):60106,ac=D?Symbol.for("react.fragment"):60107,bc=D?Symbol.for("react.strict_mode"):60108,cc=D?Symbol.for("react.profiler"):60114,dc=D?Symbol.for("react.provider"):60109,ec=D?Symbol.for("react.context"):60110,fc=D?Symbol.for("react.concurrent_mode"):60111,gc=D?Symbol.for("react.forward_ref"):60112,hc=D?Symbol.for("react.suspense"):
60113,ic=D?Symbol.for("react.memo"):60115,jc=D?Symbol.for("react.lazy"):60116,kc="function"===typeof Symbol&&Symbol.iterator;function lc(a){if(null===a||"object"!==typeof a)return null;a=kc&&a[kc]||a["@@iterator"];return"function"===typeof a?a:null}
function mc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fc:return"ConcurrentMode";case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ic:return mc(a.type);case jc:if(a=1===a._status?a._result:null)return mc(a)}return null}function nc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=mc(a.type);c=null;d&&(c=mc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var oc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(oc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function E(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var F={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new E(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new E(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new E(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new E(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new E(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){F[a]=new E(a,3,!0,a,null)});
["capture","download"].forEach(function(a){F[a]=new E(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){F[a]=new E(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){F[a]=new E(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function wc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
wc);F[b]=new E(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,wc);F[b]=new E(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,wc);F[b]=new E(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});F.tabIndex=new E("tabIndex",1,!1,"tabindex",null);
function xc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function yc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function zc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ac(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=yc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bc(a,b){b=b.checked;null!=b&&xc(a,"checked",b,!1)}
function Cc(a,b){Bc(a,b);var c=yc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Dc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Dc(a,b.type,yc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ec(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Dc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Fc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Gc(a,b,c){a=z.getPooled(Fc.change,a,b,c);a.type="change";Ib(c);Ra(a);return a}var Jc=null,Kc=null;function Lc(a){Ea(a)}
function Mc(a){var b=Ka(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Sa&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){"value"===a.propertyName&&Mc(Kc)&&(a=Gc(Kc,a,Rb(a)),Ob(Lc,a))}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}
function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
var Vc={eventTypes:Fc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ka(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,g=Rc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Gc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Dc(e,"number",e.value)}},Wc=z.extend({view:null,detail:null}),Xc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ia(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=dd,h=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=ed,h=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var m=null==f?e:Ka(f);e=null==b?e:Ka(b);a=g.getPooled(h,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Ma(g))l++;g=0;for(k=e;k;k=Ma(k))g++;for(;0<l-g;)b=Ma(b),l--;for(;0<g-l;)e=Ma(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Ma(b);e=Ma(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Ma(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Ma(d)}for(d=0;d<b.length;d++)Pa(b[d],"bubbled",a);for(d=f.length;0<d--;)Pa(f[d],"captured",c);return[a,c]}},hd=Object.prototype.hasOwnProperty;function id(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function jd(a,b){if(id(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!hd.call(b,c[d])||!id(a[c[d]],b[c[d]]))return!1;return!0}function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?t("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?t("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}t("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:t("189")}}c.alternate!==d?t("190"):void 0}3!==c.tag?t("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var od=z.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=z.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=Wc.extend({relatedTarget:null});function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=Wc.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=dd.extend({dataTransfer:null}),wd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),xd=z.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[Ya,"animationEnd"],[Za,"animationIteration"],[$a,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ab,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case Ya:case Za:case $a:a=od;break;case ab:a=xd;break;case "scroll":a=Wc;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=z}b=a.getPooled(e,b,c,d);Ra(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ia(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<pa.length;h++){var k=pa[h];k&&(k=k.extractEvents(d,b,f,e))&&(g=ya(g,k))}Ea(g)}}var Hd=!0;
function H(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!1)}function Kd(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!0)}function Id(a,b){Lb(Jd,a,b)}
function Jd(a,b){if(Hd){var c=Rb(b);c=Ia(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Ob(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}var Ld={},Md=0,Nd="_reactListenersID"+(""+Math.random()).slice(2);
function Od(a){Object.prototype.hasOwnProperty.call(a,Nd)||(a[Nd]=Md++,Ld[a[Nd]]={});return Ld[a[Nd]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=Sa&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&jd(Zd,c)?null:(Zd=c,a=z.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ra(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Od(e);f=ta.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ka(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua=La;va=Ja;wa=Ka;Ca.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:be,BeforeInputEventPlugin:Bb});function de(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function ee(a,b){a=n({children:void 0},b);if(b=de(b.children))a.children=b;return a}function fe(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+yc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function ge(a,b){null!=b.dangerouslySetInnerHTML?t("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function he(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?t("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:t("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:yc(c)}}
function ie(a,b){var c=yc(b.value),d=yc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function je(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var ke={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function le(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function me(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?le(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ne=void 0,oe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==ke.svg||"innerHTML"in a)a.innerHTML=b;else{ne=ne||document.createElement("div");ne.innerHTML="<svg>"+b+"</svg>";for(b=ne.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},re=["Webkit","ms","Moz","O"];Object.keys(qe).forEach(function(a){re.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qe[b]=qe[a]})});function se(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qe.hasOwnProperty(a)&&qe[a]?(""+b).trim():b+"px"}
function te(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=se(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ue=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function ve(a,b){b&&(ue[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?t("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?t("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:t("61")),null!=b.style&&"object"!==typeof b.style?t("62",""):void 0)}
function we(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function xe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Od(a);b=ta[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Kd("scroll",a);break;case "focus":case "blur":Kd("focus",a);Kd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Sb(e)&&Kd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&H(e,a)}c[e]=!0}}}function ye(){}var ze=null,Ae=null;
function Be(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ce(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var De="function"===typeof setTimeout?setTimeout:void 0,Ee="function"===typeof clearTimeout?clearTimeout:void 0;
function Fe(a,b,c,d,e){a[Ha]=e;"input"===c&&"radio"===e.type&&null!=e.name&&Bc(a,e);we(c,d);d=we(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?te(a,h):"dangerouslySetInnerHTML"===g?oe(a,h):"children"===g?pe(a,h):xc(a,g,h,d)}switch(c){case "input":Cc(a,e);break;case "textarea":ie(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?fe(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?fe(a,!!e.multiple,e.defaultValue,
!0):fe(a,!!e.multiple,e.multiple?[]:"",!1))}}function Ge(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function He(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Ie=[],Je=-1;function I(a){0>Je||(a.current=Ie[Je],Ie[Je]=null,Je--)}function J(a,b){Je++;Ie[Je]=a.current;a.current=b}var Ke={},K={current:Ke},L={current:!1},Le=Ke;
function Me(a,b){var c=a.type.contextTypes;if(!c)return Ke;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function M(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ne(a){I(L,a);I(K,a)}function Oe(a){I(L,a);I(K,a)}
function Pe(a,b,c){K.current!==Ke?t("168"):void 0;J(K,b,a);J(L,c,a)}function Qe(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:t("108",mc(b)||"Unknown",e);return n({},c,d)}function Re(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Ke;Le=K.current;J(K,b,a);J(L,L.current,a);return!0}
function Se(a,b,c){var d=a.stateNode;d?void 0:t("169");c?(b=Qe(a,b,Le),d.__reactInternalMemoizedMergedChildContext=b,I(L,a),I(K,a),J(K,b,a)):I(L,a);J(L,c,a)}var Te=null,Ue=null;function Ve(a){return function(b){try{return a(b)}catch(c){}}}
function We(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Te=Ve(function(a){return b.onCommitFiberRoot(c,a)});Ue=Ve(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Xe(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function N(a,b,c,d){return new Xe(a,b,c,d)}
function Ye(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Ze(a){if("function"===typeof a)return Ye(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===ic)return 14}return 2}
function $e(a,b){var c=a.alternate;null===c?(c=N(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.firstContextDependency=a.firstContextDependency;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function af(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ye(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ac:return bf(c.children,e,f,b);case fc:return cf(c,e|3,f,b);case bc:return cf(c,e|2,f,b);case cc:return a=N(12,c,b,e|4),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=N(13,c,b,e),a.elementType=hc,a.type=hc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:g=10;break a;case ec:g=9;break a;case gc:g=11;break a;case ic:g=
14;break a;case jc:g=16;d=null;break a}t("130",null==a?a:typeof a,"")}b=N(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function bf(a,b,c,d){a=N(7,a,d,b);a.expirationTime=c;return a}function cf(a,b,c,d){a=N(8,a,d,b);b=0===(b&1)?bc:fc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function df(a,b,c){a=N(6,a,null,b);a.expirationTime=c;return a}
function ef(a,b,c){b=N(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function ff(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);gf(b,a)}
function hf(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);gf(b,a)}function jf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}
function gf(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var kf=!1;function lf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function mf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function of(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=lf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=lf(a.memoizedState),e=c.updateQueue=lf(c.memoizedState)):d=a.updateQueue=mf(e):null===e&&(e=c.updateQueue=mf(d));null===e||d===e?of(d,b):null===d.lastUpdate||null===e.lastUpdate?(of(d,b),of(e,b)):(of(d,b),e.lastUpdate=b)}
function qf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=lf(a.memoizedState):rf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function rf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=mf(b));return b}
function sf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:kf=!0}return d}
function tf(a,b,c,d,e){kf=!1;b=rf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(l=sf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var r=k.expirationTime;r<e?(null===m&&(m=k,null===g&&(f=l)),h<r&&(h=r)):(l=sf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=
32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=l}
function uf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);vf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;vf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function vf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?t("191",c):void 0;c.call(d)}a=a.nextEffect}}
function wf(a,b){return{value:a,source:b,stack:nc(b)}}var xf={current:null},yf=null,zf=null,Af=null;function Bf(a,b){var c=a.type._context;J(xf,c._currentValue,a);c._currentValue=b}function Cf(a){var b=xf.current;I(xf,a);a.type._context._currentValue=b}function Df(a){yf=a;Af=zf=null;a.firstContextDependency=null}
function Ef(a,b){if(Af!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Af=a,b=1073741823;b={context:a,observedBits:b,next:null};null===zf?(null===yf?t("293"):void 0,yf.firstContextDependency=zf=b):zf=zf.next=b}return a._currentValue}var Ff={},O={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?t("174"):void 0;return a}
function Jf(a,b){J(Hf,b,a);J(Gf,a,a);J(O,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:me(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=me(b,c)}I(O,a);J(O,b,a)}function Kf(a){I(O,a);I(Gf,a);I(Hf,a)}function Lf(a){If(Hf.current);var b=If(O.current);var c=me(b,a.type);b!==c&&(J(Gf,a,a),J(O,c,a))}function Mf(a){Gf.current===a&&(I(O,a),I(Gf,a))}
function P(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}function Nf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status=0,b=a._ctor,b=b(),b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)}),a._result=b,b;}}var Of=Xb.ReactCurrentOwner,Pf=(new aa.Component).refs;
function Qf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Vf={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Rf();d=Sf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Tf();pf(a,e);Uf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Rf();d=Sf(d,a);var e=nf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Tf();pf(a,e);Uf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Rf();c=Sf(c,a);var d=nf(c);d.tag=
2;void 0!==b&&null!==b&&(d.callback=b);Tf();pf(a,d);Uf(a,c)}};function Wf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
function Xf(a,b,c){var d=!1,e=Ke;var f=b.contextType;"object"===typeof f&&null!==f?f=Of.currentDispatcher.readContext(f):(e=M(b)?Le:K.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Me(a,e):Ke);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Vf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Zf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Vf.enqueueReplaceState(b,b.state,null)}
function $f(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Pf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Of.currentDispatcher.readContext(f):(f=M(b)?Le:K.current,e.context=Me(a,f));f=a.updateQueue;null!==f&&(tf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Qf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&
"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Vf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(tf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var ag=Array.isArray;
function bg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?t("289"):void 0,d=c.stateNode);d?void 0:t("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Pf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?t("284"):void 0;c._owner?void 0:t("290",a)}return a}
function cg(a,b){"textarea"!==a.type&&t("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function dg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=$e(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=df(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=bg(a,b,c),d.return=a,d;d=af(c.type,c.key,c.props,null,a.mode,d);d.ref=bg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=ef(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,g){if(null===b||7!==b.tag)return b=bf(c,a.mode,d,g),b.return=a,b;b=e(b,c,d);b.return=a;return b}function r(a,b,c){if("string"===typeof b||"number"===typeof b)return b=df(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=af(b.type,b.key,b.props,null,a.mode,c),c.ref=bg(a,null,b),c.return=a,c;case $b:return b=ef(b,a.mode,c),b.return=a,b}if(ag(b)||
lc(b))return b=bf(b,a.mode,c,null),b.return=a,b;cg(a,b)}return null}function w(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(ag(c)||lc(c))return null!==e?null:m(a,b,c,d,null);cg(a,c)}return null}function y(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(ag(d)||lc(d))return a=a.get(c)||null,m(b,a,d,e,null);cg(b,d)}return null}function B(e,g,h,k){for(var l=null,q=null,m=g,u=g=0,p=null;null!==m&&u<h.length;u++){m.index>u?(p=m,m=null):p=m.sibling;var v=w(e,m,h[u],k);if(null===v){null===m&&(m=p);break}a&&
m&&null===v.alternate&&b(e,m);g=f(v,g,u);null===q?l=v:q.sibling=v;q=v;m=p}if(u===h.length)return c(e,m),l;if(null===m){for(;u<h.length;u++)if(m=r(e,h[u],k))g=f(m,g,u),null===q?l=m:q.sibling=m,q=m;return l}for(m=d(e,m);u<h.length;u++)if(p=y(m,e,u,h[u],k))a&&null!==p.alternate&&m.delete(null===p.key?u:p.key),g=f(p,g,u),null===q?l=p:q.sibling=p,q=p;a&&m.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=lc(h);"function"!==typeof l?t("150"):void 0;h=l.call(h);null==h?t("151"):void 0;
for(var m=l=null,q=g,u=g=0,p=null,v=h.next();null!==q&&!v.done;u++,v=h.next()){q.index>u?(p=q,q=null):p=q.sibling;var A=w(e,q,v.value,k);if(null===A){q||(q=p);break}a&&q&&null===A.alternate&&b(e,q);g=f(A,g,u);null===m?l=A:m.sibling=A;m=A;q=p}if(v.done)return c(e,q),l;if(null===q){for(;!v.done;u++,v=h.next())v=r(e,v.value,k),null!==v&&(g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);return l}for(q=d(e,q);!v.done;u++,v=h.next())v=y(q,e,u,v.value,k),null!==v&&(a&&null!==v.alternate&&q.delete(null===v.key?u:
v.key),g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,h);d.ref=bg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===ac?(d=bf(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=af(f.type,f.key,f.props,null,a.mode,h),h.ref=bg(a,d,f),h.return=a,a=h)}return g(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ef(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=df(f,a.mode,h),d.return=a,a=d),g(a);if(ag(f))return B(a,d,f,h);if(lc(f))return R(a,d,f,h);l&&cg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,t("152",h.displayName||h.name||"Component")}return c(a,d)}}var eg=dg(!0),fg=dg(!1),gg=null,hg=null,ig=!1;
function jg(a,b){var c=N(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function kg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function lg(a){if(ig){var b=hg;if(b){var c=b;if(!kg(a,b)){b=Ge(c);if(!b||!kg(a,b)){a.effectTag|=2;ig=!1;gg=a;return}jg(gg,c)}gg=a;hg=He(b)}else a.effectTag|=2,ig=!1,gg=a}}function mg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;gg=a}function ng(a){if(a!==gg)return!1;if(!ig)return mg(a),ig=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ce(b,a.memoizedProps))for(b=hg;b;)jg(a,b),b=Ge(b);mg(a);hg=gg?Ge(a.stateNode):null;return!0}function og(){hg=gg=null;ig=!1}var pg=Xb.ReactCurrentOwner;
function Q(a,b,c,d){b.child=null===a?fg(b,null,c,d):eg(b,a.child,c,d)}function qg(a,b,c,d,e){c=c.render;var f=b.ref;Df(b,e);d=c(d,f);b.effectTag|=1;Q(a,b,d,e);return b.child}
function rg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ye(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,sg(a,b,g,d,e,f);a=af(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return tg(a,b,f);b.effectTag|=1;a=$e(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function sg(a,b,c,d,e,f){return null!==a&&e<f&&jd(a.memoizedProps,d)&&a.ref===b.ref?tg(a,b,f):ug(a,b,c,d,f)}function vg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function ug(a,b,c,d,e){var f=M(c)?Le:K.current;f=Me(b,f);Df(b,e);c=c(d,f);b.effectTag|=1;Q(a,b,c,e);return b.child}
function wg(a,b,c,d,e){if(M(c)){var f=!0;Re(b)}else f=!1;Df(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Xf(b,c,d,e),$f(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=Of.currentDispatcher.readContext(l):(l=M(c)?Le:K.current,l=Me(b,l));var m=c.getDerivedStateFromProps,r="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;r||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Zf(b,g,d,l);kf=!1;var w=b.memoizedState;k=g.state=w;var y=b.updateQueue;null!==y&&(tf(b,y,d,g,e),k=b.memoizedState);h!==d||w!==k||L.current||kf?("function"===typeof m&&(Qf(b,c,m,d),k=b.memoizedState),(h=kf||Wf(b,c,h,d,w,k,l))?(r||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:P(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=Of.currentDispatcher.readContext(l):(l=M(c)?Le:K.current,l=Me(b,l)),m=c.getDerivedStateFromProps,
(r="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Zf(b,g,d,l),kf=!1,k=b.memoizedState,w=g.state=k,y=b.updateQueue,null!==y&&(tf(b,y,d,g,e),w=b.memoizedState),h!==d||k!==w||L.current||kf?("function"===typeof m&&(Qf(b,c,m,d),w=b.memoizedState),(m=kf||Wf(b,c,h,d,k,w,l))?(r||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,w,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,w,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=w),g.props=d,g.state=w,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return xg(a,b,c,d,f,e)}
function xg(a,b,c,d,e,f){vg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Se(b,c,!1),tg(a,b,f);d=b.stateNode;pg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=eg(b,a.child,null,f),b.child=eg(b,null,h,f)):Q(a,b,h,f);b.memoizedState=d.state;e&&Se(b,c,!0);return b.child}function yg(a){var b=a.stateNode;b.pendingContext?Pe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Pe(a,b.context,!1);Jf(a,b.containerInfo)}
function zg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=bf(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=bf(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=fg(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=$e(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=$e(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=eg(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=bf(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=bf(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=eg(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function tg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?t("153"):void 0;if(null!==b.child){a=b.child;c=$e(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=$e(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Ag(a,b,c){var d=b.expirationTime;if(null!==a&&a.memoizedProps===b.pendingProps&&!L.current&&d<c){switch(b.tag){case 3:yg(b);og();break;case 5:Lf(b);break;case 1:M(b.type)&&Re(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Bf(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return zg(a,b,c);b=tg(a,b,c);return null!==b?b.sibling:null}}return tg(a,b,c)}b.expirationTime=0;switch(b.tag){case 2:d=b.elementType;null!==
a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Me(b,K.current);Df(b,c);e=d(a,e);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;if(M(d)){var f=!0;Re(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Qf(b,d,g,a);e.updater=Vf;b.stateNode=e;e._reactInternalFiber=b;$f(b,d,a,c);b=xg(null,b,d,!0,f,c)}else b.tag=0,Q(null,b,e,c),b=b.child;
return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=Nf(e);b.type=a;e=b.tag=Ze(a);f=P(a,f);g=void 0;switch(e){case 0:g=ug(null,b,a,f,c);break;case 1:g=wg(null,b,a,f,c);break;case 11:g=qg(null,b,a,f,c);break;case 14:g=rg(null,b,a,P(a.type,f),d,c);break;default:t("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),ug(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),wg(a,b,
d,e,c);case 3:yg(b);d=b.updateQueue;null===d?t("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;tf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)og(),b=tg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)hg=He(b.stateNode.containerInfo),gg=b,e=ig=!0;e?(b.effectTag|=2,b.child=fg(b,null,d,c)):(Q(a,b,d,c),og());b=b.child}return b;case 5:return Lf(b),null===a&&lg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ce(d,e)?g=null:null!==
f&&Ce(d,f)&&(b.effectTag|=16),vg(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=1,b=null):(Q(a,b,g,c),b=b.child),b;case 6:return null===a&&lg(b),null;case 13:return zg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=eg(b,null,d,c):Q(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),qg(a,b,d,e,c);case 7:return Q(a,b,b.pendingProps,c),b.child;case 8:return Q(a,b,b.pendingProps.children,c),b.child;case 12:return Q(a,b,b.pendingProps.children,
c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Bf(b,f);if(null!==g){var h=g.value;f=h===f&&(0!==h||1/h===1/f)||h!==h&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!L.current){b=tg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){h=g.firstContextDependency;if(null!==h){do{if(h.context===d&&0!==(h.observedBits&f)){if(1===g.tag){var k=nf(c);k.tag=2;pf(g,k)}g.expirationTime<
c&&(g.expirationTime=c);k=g.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);for(var l=g.return;null!==l;){k=l.alternate;if(l.childExpirationTime<c)l.childExpirationTime=c,null!==k&&k.childExpirationTime<c&&(k.childExpirationTime=c);else if(null!==k&&k.childExpirationTime<c)k.childExpirationTime=c;else break;l=l.return}}k=g.child;h=h.next}while(null!==h)}else k=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==k)k.return=g;else for(k=g;null!==k;){if(k===b){k=null;break}g=k.sibling;
if(null!==g){g.return=k.return;k=g;break}k=k.return}g=k}}Q(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Df(b,c),e=Ef(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,Q(a,b,d,c),b.child;case 14:return e=b.type,f=P(e,b.pendingProps),f=P(e.type,f),rg(a,b,e,f,d,c);case 15:return sg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,M(d)?(a=
!0,Re(b)):a=!1,Df(b,c),Xf(b,d,e,c),$f(b,d,e,c),xg(null,b,d,!0,a,c);default:t("156")}}function Bg(a){a.effectTag|=4}var Cg=void 0,Gg=void 0,Hg=void 0,Ig=void 0;Cg=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Gg=function(){};
Hg=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(O.current);a=null;switch(c){case "input":f=zc(g,f);d=zc(g,d);a=[];break;case "option":f=ee(g,f);d=ee(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=ge(g,f);d=ge(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ye)}ve(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(g in k)k.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(sa.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(g in k)!k.hasOwnProperty(g)||l&&l.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in l)l.hasOwnProperty(g)&&k[g]!==l[g]&&(h||
(h={}),h[g]=l[g])}else h||(a||(a=[]),a.push(c,h)),h=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(sa.hasOwnProperty(c)?(null!=l&&xe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&Bg(b)}};Ig=function(a,b,c,d){c!==d&&Bg(b)};
var Jg="function"===typeof WeakSet?WeakSet:Set;function Kg(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=nc(c));null!==c&&mc(c.type);b=b.value;null!==a&&1===a.tag&&mc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Lg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Mg(a,c)}else b.current=null}
function Ng(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=se("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function Og(a){"function"===typeof Ue&&Ue(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(null!==d){var e=a;try{d()}catch(f){Mg(e,f)}}c=c.next}while(c!==b)}break;case 1:Lg(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){Mg(a,f)}break;case 5:Lg(a);break;case 4:Pg(a)}}
function Qg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Rg(a){a:{for(var b=a.return;null!==b;){if(Qg(b)){var c=b;break a}b=b.return}t("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:t("161")}c.effectTag&16&&(pe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Qg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=ye)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Pg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?t("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Og(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Og(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Sg(a,b){switch(b.tag){case 0:case 11:case 14:case 15:break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Fe(c,f,e,a,d,b)}break;case 6:null===b.stateNode?t("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=Rf()));null!==a&&Ng(a,d);c=b.updateQueue;
if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new Jg);c.forEach(function(a){var c=Tg.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:t("163")}}var Ug="function"===typeof WeakMap?WeakMap:Map;function Vg(a,b,c){c=nf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Wg(d);Kg(a,b)};return c}
function Xg(a,b,c){c=nf(c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Yg?Yg=new Set([this]):Yg.add(this));var c=b.value,e=b.stack;Kg(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Zg(a){switch(a.tag){case 1:M(a.type)&&Ne(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Oe(a),b=a.effectTag,0!==(b&64)?t("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 4:return Kf(a),null;case 10:return Cf(a),null;default:return null}}
var $g={readContext:Ef},ah=Xb.ReactCurrentOwner,bh=1073741822,ch=0,dh=!1,S=null,T=null,U=0,eh=-1,fh=!1,V=null,gh=!1,hh=null,ih=null,Yg=null;function jh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ne(b);break;case 3:Kf(b);Oe(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Cf(b)}a=a.return}T=null;U=0;eh=-1;fh=!1;S=null}function Tf(){null!==ih&&(ba.unstable_cancelCallback(hh),ih())}
function kh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){S=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:M(b.type)&&Ne(b);break;case 3:Kf(b);Oe(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)ng(b),b.effectTag&=-3;Gg(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)Hg(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var k=If(O.current);if(ng(b)){g=b;e=g.stateNode;var l=g.type,m=g.memoizedProps,r=h;e[Ga]=g;e[Ha]=m;f=void 0;h=l;switch(h){case "iframe":case "object":H("load",e);break;case "video":case "audio":for(l=0;l<bb.length;l++)H(bb[l],e);break;case "source":H("error",e);break;case "img":case "image":case "link":H("error",e);H("load",e);break;case "form":H("reset",e);H("submit",e);break;case "details":H("toggle",e);break;case "input":Ac(e,m);H("invalid",e);xe(r,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};H("invalid",e);xe(r,"onChange");break;case "textarea":he(e,m),H("invalid",e),xe(r,"onChange")}ve(h,m);l=null;for(f in m)m.hasOwnProperty(f)&&(k=m[f],"children"===f?"string"===typeof k?e.textContent!==k&&(l=["children",k]):"number"===typeof k&&e.textContent!==""+k&&(l=["children",""+k]):sa.hasOwnProperty(f)&&null!=k&&xe(r,f));switch(h){case "input":Vb(e);Ec(e,m,!0);break;case "textarea":Vb(e);je(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=ye)}f=l;g.updateQueue=f;g=null!==f?!0:!1;g&&Bg(b)}else{m=b;e=f;r=g;l=9===h.nodeType?h:h.ownerDocument;k===ke.html&&(k=le(e));k===ke.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof r.is?l=l.createElement(e,{is:r.is}):(l=l.createElement(e),"select"===e&&r.multiple&&(l.multiple=!0)):l=l.createElementNS(k,e);e=l;e[Ga]=m;e[Ha]=g;Cg(e,b,!1,!1);r=e;l=f;m=g;var w=h,y=we(l,m);switch(l){case "iframe":case "object":H("load",
r);h=m;break;case "video":case "audio":for(h=0;h<bb.length;h++)H(bb[h],r);h=m;break;case "source":H("error",r);h=m;break;case "img":case "image":case "link":H("error",r);H("load",r);h=m;break;case "form":H("reset",r);H("submit",r);h=m;break;case "details":H("toggle",r);h=m;break;case "input":Ac(r,m);h=zc(r,m);H("invalid",r);xe(w,"onChange");break;case "option":h=ee(r,m);break;case "select":r._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});H("invalid",r);xe(w,"onChange");break;case "textarea":he(r,
m);h=ge(r,m);H("invalid",r);xe(w,"onChange");break;default:h=m}ve(l,h);k=void 0;var B=l,R=r,v=h;for(k in v)if(v.hasOwnProperty(k)){var q=v[k];"style"===k?te(R,q):"dangerouslySetInnerHTML"===k?(q=q?q.__html:void 0,null!=q&&oe(R,q)):"children"===k?"string"===typeof q?("textarea"!==B||""!==q)&&pe(R,q):"number"===typeof q&&pe(R,""+q):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(sa.hasOwnProperty(k)?null!=q&&xe(w,k):null!=q&&xc(R,k,q,y))}switch(l){case "input":Vb(r);
Ec(r,m,!1);break;case "textarea":Vb(r);je(r,m);break;case "option":null!=m.value&&r.setAttribute("value",""+yc(m.value));break;case "select":h=r;h.multiple=!!m.multiple;r=m.value;null!=r?fe(h,!!m.multiple,r,!1):null!=m.defaultValue&&fe(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(r.onclick=ye)}(g=Be(f,g))&&Bg(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?t("166"):void 0;break;case 6:e&&null!=b.stateNode?Ig(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?t("166"):void 0),e=If(Hf.current),If(O.current),ng(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Ga]=g,(g=f.nodeValue!==e)&&Bg(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Ga]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;S=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g!==f||0===(b.effectTag&1)&&g)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);Gg(b);break;case 10:Cf(b);break;case 9:break;case 14:break;case 17:M(b.type)&&Ne(b);break;default:t("156")}S=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==S)return S;null!==c&&0===(c.effectTag&1024)&&(null===
c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Zg(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function lh(a){var b=Ag(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=kh(a));ah.current=null;return b}
function mh(a,b){dh?t("243"):void 0;Tf();dh=!0;ah.currentDispatcher=$g;var c=a.nextExpirationTimeToWorkOn;if(c!==U||a!==T||null===S)jh(),T=a,U=c,S=$e(T.current,null,U),a.pendingCommitExpirationTime=0;var d=!1;do{try{if(b)for(;null!==S&&!nh();)S=lh(S);else for(;null!==S;)S=lh(S)}catch(B){if(Af=zf=yf=null,null===S)d=!0,Wg(B);else{null===S?t("271"):void 0;var e=S,f=e.return;if(null===f)d=!0,Wg(B);else{a:{var g=a,h=f,k=e,l=B;f=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===
typeof l&&"function"===typeof l.then){var m=l;l=h;var r=-1,w=-1;do{if(13===l.tag){var y=l.alternate;if(null!==y&&(y=y.memoizedState,null!==y)){w=10*(1073741822-y.timedOutAt);break}y=l.pendingProps.maxDuration;if("number"===typeof y)if(0>=y)r=0;else if(-1===r||y<r)r=y}l=l.return}while(null!==l);l=h;do{if(y=13===l.tag)y=void 0===l.memoizedProps.fallback?!1:null===l.memoizedState;if(y){h=l.updateQueue;null===h?l.updateQueue=new Set([m]):h.add(m);if(0===(l.mode&1)){l.effectTag|=64;k.effectTag&=-1957;
1===k.tag&&(null===k.alternate?k.tag=17:(f=nf(1073741823),f.tag=2,pf(k,f)));k.expirationTime=1073741823;break a}k=g.pingCache;null===k?(k=g.pingCache=new Ug,h=new Set,k.set(m,h)):(h=k.get(m),void 0===h&&(h=new Set,k.set(m,h)));h.has(f)||(h.add(f),k=oh.bind(null,g,m,f),m.then(k,k));-1===r?g=1073741823:(-1===w&&(w=10*(1073741822-jf(g,f))-5E3),g=w+r);0<=g&&eh<g&&(eh=g);l.effectTag|=2048;l.expirationTime=f;break a}l=l.return}while(null!==l);l=Error((mc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
nc(k))}fh=!0;l=wf(l,k);g=h;do{switch(g.tag){case 3:g.effectTag|=2048;g.expirationTime=f;f=Vg(g,l,f);qf(g,f);break a;case 1:if(m=l,r=g.type,w=g.stateNode,0===(g.effectTag&64)&&("function"===typeof r.getDerivedStateFromError||null!==w&&"function"===typeof w.componentDidCatch&&(null===Yg||!Yg.has(w)))){g.effectTag|=2048;g.expirationTime=f;f=Xg(g,m,f);qf(g,f);break a}}g=g.return}while(null!==g)}S=kh(e);continue}}}break}while(1);dh=!1;Af=zf=yf=ah.currentDispatcher=null;if(d)T=null,a.finishedWork=null;
else if(null!==S)a.finishedWork=null;else{d=a.current.alternate;null===d?t("281"):void 0;T=null;if(fh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<c||0!==f&&f<c||0!==g&&g<c){hf(a,c);ph(a,d,c,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;c=a.nextExpirationTimeToWorkOn=c;b=a.expirationTime=1073741823;ph(a,d,c,b,-1);return}}b&&-1!==eh?(hf(a,c),b=10*(1073741822-jf(a,c)),b<eh&&(eh=b),b=10*(1073741822-Rf()),b=eh-b,ph(a,d,c,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=
c,a.finishedWork=d)}}function Mg(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Yg||!Yg.has(d))){a=wf(b,a);a=Xg(c,a,1073741823);pf(c,a);Uf(c,1073741823);return}break;case 3:a=wf(b,a);a=Vg(c,a,1073741823);pf(c,a);Uf(c,1073741823);return}c=c.return}3===a.tag&&(c=wf(b,a),c=Vg(a,c,1073741823),pf(a,c),Uf(a,1073741823))}
function Sf(a,b){0!==ch?a=ch:dh?a=gh?1073741823:U:b.mode&1?(a=qh?1073741822-10*(((1073741822-a+15)/10|0)+1):1073741822-25*(((1073741822-a+500)/25|0)+1),null!==T&&a===U&&--a):a=1073741823;qh&&(0===rh||a<rh)&&(rh=a);return a}function oh(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==T&&U===c)T=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;gf(c,a);c=a.expirationTime;0!==c&&sh(a,c)}}
function Tg(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=Rf();b=Sf(b,a);a=th(a,b);null!==a&&(ff(a,b),b=a.expirationTime,0!==b&&sh(a,b))}
function th(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function Uf(a,b){a=th(a,b);null!==a&&(!dh&&0!==U&&b>U&&jh(),ff(a,b),dh&&!gh&&T===a||sh(a,a.expirationTime),uh>vh&&(uh=0,t("185")))}function wh(a,b,c,d,e){var f=ch;ch=1073741823;try{return a(b,c,d,e)}finally{ch=f}}var xh=null,W=null,yh=0,zh=void 0,X=!1,Ah=null,Y=0,rh=0,Bh=!1,Ch=null,Z=!1,Dh=!1,qh=!1,Eh=null,Fh=ba.unstable_now(),Gh=1073741822-(Fh/10|0),Hh=Gh,vh=50,uh=0,Ih=null;function Jh(){Gh=1073741822-((ba.unstable_now()-Fh)/10|0)}
function Kh(a,b){if(0!==yh){if(b<yh)return;null!==zh&&ba.unstable_cancelCallback(zh)}yh=b;a=ba.unstable_now()-Fh;zh=ba.unstable_scheduleCallback(Lh,{timeout:10*(1073741822-b)-a})}function ph(a,b,c,d,e){a.expirationTime=d;0!==e||nh()?0<e&&(a.timeoutHandle=De(Mh.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Mh(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;Jh();Hh=Gh;Nh(a,c)}function Rf(){if(X)return Hh;Oh();if(0===Y||1===Y)Jh(),Hh=Gh;return Hh}
function sh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===W?(xh=W=a,a.nextScheduledRoot=a):(W=W.nextScheduledRoot=a,W.nextScheduledRoot=xh)):b>a.expirationTime&&(a.expirationTime=b);X||(Z?Dh&&(Ah=a,Y=1073741823,Ph(a,1073741823,!1)):1073741823===b?Qh(1073741823,!1):Kh(a,b))}
function Oh(){var a=0,b=null;if(null!==W)for(var c=W,d=xh;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===W?t("244"):void 0;if(d===d.nextScheduledRoot){xh=W=d.nextScheduledRoot=null;break}else if(d===xh)xh=e=d.nextScheduledRoot,W.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===W){W=c;W.nextScheduledRoot=xh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===W)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}Ah=b;Y=a}var Rh=!1;function nh(){return Rh?!0:ba.unstable_shouldYield()?Rh=!0:!1}function Lh(){try{if(!nh()&&null!==xh){Jh();var a=xh;do{var b=a.expirationTime;0!==b&&Gh<=b&&(a.nextExpirationTimeToWorkOn=Gh);a=a.nextScheduledRoot}while(a!==xh)}Qh(0,!0)}finally{Rh=!1}}
function Qh(a,b){Oh();if(b)for(Jh(),Hh=Gh;null!==Ah&&0!==Y&&a<=Y&&!(Rh&&Gh>Y);)Ph(Ah,Y,Gh>Y),Oh(),Jh(),Hh=Gh;else for(;null!==Ah&&0!==Y&&a<=Y;)Ph(Ah,Y,!1),Oh();b&&(yh=0,zh=null);0!==Y&&Kh(Ah,Y);uh=0;Ih=null;if(null!==Eh)for(a=Eh,Eh=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Bh||(Bh=!0,Ch=d)}}if(Bh)throw a=Ch,Ch=null,Bh=!1,a;}function Nh(a,b){X?t("253"):void 0;Ah=a;Y=b;Ph(a,b,!1);Qh(1073741823,!1)}
function Ph(a,b,c){X?t("245"):void 0;X=!0;if(c){var d=a.finishedWork;null!==d?Sh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),mh(a,c),d=a.finishedWork,null!==d&&(nh()?a.finishedWork=d:Sh(a,d,b)))}else d=a.finishedWork,null!==d?Sh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),mh(a,c),d=a.finishedWork,null!==d&&Sh(a,d,b));X=!1}
function Sh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===Eh?Eh=[d]:Eh.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===Ih?uh++:(Ih=a,uh=0);gh=dh=!0;a.current===b?t("177"):void 0;c=a.pendingCommitExpirationTime;0===c?t("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=e>d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=
0):(d<a.latestPingedTime&&(a.latestPingedTime=0),e=a.latestPendingTime,0!==e&&(e>d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?ff(a,d):d<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,ff(a,d)):d>e&&ff(a,d));gf(0,a);ah.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ze=Hd;e=Td();if(Ud(e)){if("selectionStart"in
e)var f={start:e.selectionStart,end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var h=g.anchorOffset,k=g.focusNode;g=g.focusOffset;try{f.nodeType,k.nodeType}catch(db){f=null;break a}var l=0,m=-1,r=-1,w=0,y=0,B=e,R=null;b:for(;;){for(var v;;){B!==f||0!==h&&3!==B.nodeType||(m=l+h);B!==k||0!==g&&3!==B.nodeType||(r=l+g);3===B.nodeType&&(l+=B.nodeValue.length);if(null===(v=B.firstChild))break;R=B;B=v}for(;;){if(B===
e)break b;R===f&&++w===h&&(m=l);R===k&&++y===g&&(r=l);if(null!==(v=B.nextSibling))break;B=R;R=B.parentNode}B=v}f=-1===m||-1===r?null:{start:m,end:r}}else f=null}f=f||{start:0,end:0}}else f=null;Ae={focusedElem:e,selectionRange:f};Hd=!1;for(V=d;null!==V;){e=!1;f=void 0;try{for(;null!==V;){if(V.effectTag&256)a:{var q=V.alternate;h=V;switch(h.tag){case 0:case 11:case 15:break a;case 1:if(h.effectTag&256&&null!==q){var u=q.memoizedProps,A=q.memoizedState,Yf=h.stateNode,Vh=Yf.getSnapshotBeforeUpdate(h.elementType===
h.type?u:P(h.type,u),A);Yf.__reactInternalSnapshotBeforeUpdate=Vh}break a;case 3:case 5:case 6:case 4:case 17:break a;default:t("163")}}V=V.nextEffect}}catch(db){e=!0,f=db}e&&(null===V?t("178"):void 0,Mg(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){q=!1;u=void 0;try{for(;null!==V;){var x=V.effectTag;x&16&&pe(V.stateNode,"");if(x&128){var C=V.alternate;if(null!==C){var p=C.ref;null!==p&&("function"===typeof p?p(null):p.current=null)}}switch(x&14){case 2:Rg(V);V.effectTag&=-3;break;case 6:Rg(V);
V.effectTag&=-3;Sg(V.alternate,V);break;case 4:Sg(V.alternate,V);break;case 8:A=V;Pg(A);A.return=null;A.child=null;A.memoizedState=null;A.updateQueue=null;var G=A.alternate;null!==G&&(G.return=null,G.child=null,G.memoizedState=null,G.updateQueue=null)}V=V.nextEffect}}catch(db){q=!0,u=db}q&&(null===V?t("178"):void 0,Mg(V,u),null!==V&&(V=V.nextEffect))}p=Ae;C=Td();x=p.focusedElem;q=p.selectionRange;if(C!==x&&x&&x.ownerDocument&&Sd(x.ownerDocument.documentElement,x)){null!==q&&Ud(x)&&(C=q.start,p=q.end,
void 0===p&&(p=C),"selectionStart"in x?(x.selectionStart=C,x.selectionEnd=Math.min(p,x.value.length)):(p=(C=x.ownerDocument||document)&&C.defaultView||window,p.getSelection&&(p=p.getSelection(),u=x.textContent.length,G=Math.min(q.start,u),q=void 0===q.end?G:Math.min(q.end,u),!p.extend&&G>q&&(u=q,q=G,G=u),u=Rd(x,G),A=Rd(x,q),u&&A&&(1!==p.rangeCount||p.anchorNode!==u.node||p.anchorOffset!==u.offset||p.focusNode!==A.node||p.focusOffset!==A.offset)&&(C=C.createRange(),C.setStart(u.node,u.offset),p.removeAllRanges(),
G>q?(p.addRange(C),p.extend(A.node,A.offset)):(C.setEnd(A.node,A.offset),p.addRange(C))))));C=[];for(p=x;p=p.parentNode;)1===p.nodeType&&C.push({element:p,left:p.scrollLeft,top:p.scrollTop});"function"===typeof x.focus&&x.focus();for(x=0;x<C.length;x++)p=C[x],p.element.scrollLeft=p.left,p.element.scrollTop=p.top}Ae=null;Hd=!!ze;ze=null;a.current=b;for(V=d;null!==V;){d=!1;x=void 0;try{for(C=c;null!==V;){var Fb=V.effectTag;if(Fb&36){var Gb=V.alternate;p=V;G=C;switch(p.tag){case 0:case 11:case 15:break;
case 1:var Hc=p.stateNode;if(p.effectTag&4)if(null===Gb)Hc.componentDidMount();else{var ii=p.elementType===p.type?Gb.memoizedProps:P(p.type,Gb.memoizedProps);Hc.componentDidUpdate(ii,Gb.memoizedState,Hc.__reactInternalSnapshotBeforeUpdate)}var Dg=p.updateQueue;null!==Dg&&uf(p,Dg,Hc,G);break;case 3:var Eg=p.updateQueue;if(null!==Eg){q=null;if(null!==p.child)switch(p.child.tag){case 5:q=p.child.stateNode;break;case 1:q=p.child.stateNode}uf(p,Eg,q,G)}break;case 5:var ji=p.stateNode;null===Gb&&p.effectTag&
4&&Be(p.type,p.memoizedProps)&&ji.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:t("163")}}if(Fb&128){var Ic=V.ref;if(null!==Ic){var Fg=V.stateNode;switch(V.tag){case 5:var ce=Fg;break;default:ce=Fg}"function"===typeof Ic?Ic(ce):Ic.current=ce}}V=V.nextEffect}}catch(db){d=!0,x=db}d&&(null===V?t("178"):void 0,Mg(V,x),null!==V&&(V=V.nextEffect))}dh=gh=!1;"function"===typeof Te&&Te(b.stateNode);Fb=b.expirationTime;b=b.childExpirationTime;b=b>Fb?b:Fb;0===b&&(Yg=
null);a.expirationTime=b;a.finishedWork=null}function Wg(a){null===Ah?t("246"):void 0;Ah.expirationTime=0;Bh||(Bh=!0,Ch=a)}function Th(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||X||Qh(1073741823,!1)}}function Uh(a,b){if(Z&&!Dh){Dh=!0;try{return a(b)}finally{Dh=!1}}return a(b)}function Wh(a,b,c){if(qh)return a(b,c);Z||X||0===rh||(Qh(rh,!1),rh=0);var d=qh,e=Z;Z=qh=!0;try{return a(b,c)}finally{qh=d,(Z=e)||X||Qh(1073741823,!1)}}
function Xh(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===kd(c)&&1===c.tag?void 0:t("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(M(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);t("171");g=void 0}if(1===c.tag){var h=c.type;if(M(h)){c=Qe(c,h,g);break a}}c=g}else c=Ke;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
Tf();pf(f,e);Uf(f,d);return d}function Yh(a,b,c,d){var e=b.current,f=Rf();e=Sf(f,e);return Xh(a,b,c,e,d)}function Zh(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function $h(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Cb=function(a,b,c){switch(b){case "input":Cc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=La(d);e?void 0:t("90");Wb(d);Cc(d,e)}}}break;case "textarea":ie(a,c);break;case "select":b=c.value,null!=b&&fe(a,!!c.multiple,b,!1)}};
function ai(a){var b=1073741822-25*(((1073741822-Rf()+500)/25|0)+1);b>=bh&&(b=bh-1);this._expirationTime=bh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}ai.prototype.render=function(a){this._defer?void 0:t("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new bi;Xh(a,b,null,c,d._onCommit);return d};
ai.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ai.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:t("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?t("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Nh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};ai.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function bi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}bi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
bi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?t("191",c):void 0;c()}}};
function ci(a,b,c){b=N(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
ci.prototype.render=function(a,b){var c=this._internalRoot,d=new bi;b=void 0===b?null:b;null!==b&&d.then(b);Yh(a,c,null,d._onCommit);return d};ci.prototype.unmount=function(a){var b=this._internalRoot,c=new bi;a=void 0===a?null:a;null!==a&&c.then(a);Yh(null,b,null,c._onCommit);return c};ci.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new bi;c=void 0===c?null:c;null!==c&&e.then(c);Yh(b,d,a,e._onCommit);return e};
ci.prototype.createBatch=function(){var a=new ai(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function di(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Kb=Th;Lb=Wh;Mb=function(){X||0===rh||(Qh(rh,!1),rh=0)};
function ei(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new ci(a,!1,b)}
function fi(a,b,c,d,e){di(c)?void 0:t("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Zh(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ei(c,d);if("function"===typeof e){var h=e;e=function(){var a=Zh(f._internalRoot);h.call(a)}}Uh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Zh(f._internalRoot)}
function gi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;di(b)?void 0:t("200");return $h(a,b,null,c)}
var ki={createPortal:gi,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?t("188"):t("268",Object.keys(a)));a=nd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return fi(null,a,b,!0,c)},render:function(a,b,c){return fi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?t("38"):void 0;return fi(a,b,c,!1,d)},unmountComponentAtNode:function(a){di(a)?
void 0:t("40");return a._reactRootContainer?(Uh(function(){fi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return gi.apply(void 0,arguments)},unstable_batchedUpdates:Th,unstable_interactiveUpdates:Wh,flushSync:function(a,b){X?t("187"):void 0;var c=Z;Z=!0;try{return wh(a,b)}finally{Z=c,Qh(1073741823,!1)}},unstable_createRoot:hi,unstable_flushControlled:function(a){var b=Z;Z=!0;try{wh(a)}finally{(Z=b)||X||Qh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ja,
Ka,La,Ca.injectEventPluginsByName,qa,Ra,function(a){za(a,Qa)},Ib,Jb,Jd,Ea]}};function hi(a,b){di(a)?void 0:t("299","unstable_createRoot");return new ci(a,!0,null!=b&&!0===b.hydrate)}(function(a){var b=a.findFiberByHostInstance;return We(n({},a,{overrideProps:null,findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ia,bundleType:0,version:"16.7.0",rendererPackageName:"react-dom"});
var li={default:ki},mi=li&&ki||li;module.exports=mi.default||mi;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(934);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.12.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var c=null,f=!1,h=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=c.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=c,b=c.next;if(c===b)c=null;else{var d=c.previous;c=d.next=b;b.previous=d}a.next=a.previous=null;d=a.callback;b=a.expirationTime;a=a.priorityLevel;var e=h,Q=l;h=a;l=b;try{var g=d()}finally{h=e,l=Q}if("function"===typeof g)if(g={callback:g,priorityLevel:a,expirationTime:b,next:null,previous:null},null===c)c=g.next=g.previous=g;else{d=null;a=c;do{if(a.expirationTime>=b){d=a;break}a=a.next}while(a!==c);null===d?d=c:d===c&&(c=g,p());b=d.previous;b.next=d.previous=g;g.next=d;g.previous=
b}}function v(){if(-1===k&&null!==c&&1===c.priorityLevel){m=!0;try{do u();while(null!==c&&1===c.priorityLevel)}finally{m=!1,null!==c?p():n=!1}}}function t(a){m=!0;var b=f;f=a;try{if(a)for(;null!==c;){var d=exports.unstable_now();if(c.expirationTime<=d){do u();while(null!==c&&c.expirationTime<=d)}else break}else if(null!==c){do u();while(null!==c&&!w())}}finally{m=!1,f=b,null!==c?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var d=exports.unstable_now(),e=!1;if(0>=P-d)if(-1!==b&&b<=d)e=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(e)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var d=h,e=k;h=a;k=exports.unstable_now();try{return b()}finally{h=d,k=e,v()}};
exports.unstable_scheduleCallback=function(a,b){var d=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=d+b.timeout;else switch(h){case 1:b=d+-1;break;case 2:b=d+250;break;case 5:b=d+1073741823;break;case 4:b=d+1E4;break;default:b=d+5E3}a={callback:a,priorityLevel:h,expirationTime:b,next:null,previous:null};if(null===c)c=a.next=a.previous=a,p();else{d=null;var e=c;do{if(e.expirationTime>b){d=e;break}e=e.next}while(e!==c);null===d?d=c:d===c&&(c=a,p());
b=d.previous;b.next=d.previous=a;a.next=d;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)c=null;else{a===c&&(c=b);var d=a.previous;d.next=b;b.previous=d}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=h;return function(){var d=h,e=k;h=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{h=d,k=e,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return h};
exports.unstable_shouldYield=function(){return!f&&(null!==c&&c.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==c&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return c};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Koala"] = __webpack_require__(936);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(363);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "App", function() { return __WEBPACK_IMPORTED_MODULE_0____["a"]; });




/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(235);





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.7.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(960);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(373);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(948);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(946);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(369);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(950);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(953);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37), __webpack_require__(370)(module)))

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(371);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(372);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(373);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(374);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(961);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(235);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_layout__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detect_thresholds__ = __webpack_require__(376);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\detect-compact.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === undefined ? __WEBPACK_IMPORTED_MODULE_2_constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */] : _ref$threshold,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === undefined ? __WEBPACK_IMPORTED_MODULE_3_utils__["C" /* noop */] : _ref$onChange,
      _ref$expose = _ref.expose,
      expose = _ref$expose === undefined ? "compact" : _ref$expose;

  return function (Wrapped) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__detect_thresholds__["a" /* default */])({
      thresholds: { compact: threshold },
      defaultThresholds: {
        compact: Array.isArray(threshold) ? threshold.map(function () {
          return true;
        }) : true
      },
      expose: "_THRESH_",
      onChange: Object(__WEBPACK_IMPORTED_MODULE_3_utils__["J" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_3_utils__["q" /* get */])("compact"), onChange)
    })(function () {
      var DetectCompact = function (_PureComponent) {
        _inherits(DetectCompact, _PureComponent);

        function DetectCompact(props) {
          var _this$state;

          _classCallCheck(this, DetectCompact);

          var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

          var compactProp = _this.props._THRESH_.compact;
          _this.state = (_this$state = {}, _this$state[expose] = Array.isArray(compactProp) ? compactProp : !!compactProp, _this$state);
          return _this;
        }

        DetectCompact.prototype.stateFromProps = function stateFromProps(props) {
          var next = props.hasOwnProperty(expose) ? props[expose] : Array.isArray(props._THRESH_.compact) ? props._THRESH_.compact : !!props._THRESH_.compact;

          if (this.state[expose] !== next) {
            var _setState;

            this.setState((_setState = {}, _setState[expose] = next, _setState));
            onChange(next);
          }
        };

        DetectCompact.prototype.componentDidMount = function componentDidMount() {
          this.stateFromProps(this.props);
        };

        DetectCompact.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          this.stateFromProps(nextProps);
        };

        DetectCompact.prototype.render = function render() {
          var _extends2, _ref2;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_utils__["E" /* omit */])(["_THRESH_"], this.props), (_extends2 = {}, _extends2[expose] = this.state[expose], _extends2), this.props.hasOwnProperty(expose) ? (_ref2 = {}, _ref2[expose] = this.props[expose], _ref2) : {}), {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 48
            }
          }));
        };

        return DetectCompact;
      }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

      DetectCompact.displayName = "DetectCompact";


      DetectCompact.propTypes = {
        _THRESH_: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool)])
        })
      };

      DetectCompact.displayName = "DetectCompact(" + Object(__WEBPACK_IMPORTED_MODULE_3_utils__["s" /* getComponentDisplayName */])(Wrapped) + ")";

      return DetectCompact;
    }());
  };
});

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_history__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\search-params.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var pushQueryTracked = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* curry */])(__WEBPACK_IMPORTED_MODULE_1__utils__["L" /* pushQuery */]);
var pushParamTracked = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* curry */])(__WEBPACK_IMPORTED_MODULE_1__utils__["K" /* pushParam */]);

/**
 * Higher order component for Fetching and determining price based on geographical location.
 * @param {Object} options - Initial config options.
 * @param {String} options.expose - Name of the prop object that contains price data & methods.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$expose = _ref.expose,
      expose = _ref$expose === undefined ? "search" : _ref$expose,
      _ref$trackParams = _ref.trackParams,
      trackParams = _ref$trackParams === undefined ? [] : _ref$trackParams,
      _ref$exposeParams = _ref.exposeParams,
      exposeParams = _ref$exposeParams === undefined ? [] : _ref$exposeParams;

  return function (Wrapped) {
    var SearchParams = function (_Component) {
      _inherits(SearchParams, _Component);

      function SearchParams(props) {
        _classCallCheck(this, SearchParams);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.update = true;
        _this.state = {
          searchParams: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* filteredParamsFromLocation */])(Object(__WEBPACK_IMPORTED_MODULE_2_utils_history__["a" /* getLocation */])(), exposeParams)
        };
        return _this;
      }

      SearchParams.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        this.hashHistoryListener = __WEBPACK_IMPORTED_MODULE_2_utils_history__["b" /* history */].listen(function (location) {
          if (location.breakLoop) _this2.update = false;
          _this2.setState({ searchParams: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* filteredParamsFromLocation */])(location, exposeParams) }, function () {
            _this2.update = true;
          });
        });
      };

      SearchParams.prototype.componentWillUnmount = function componentWillUnmount() {
        this.hashHistoryListener();
      };

      SearchParams.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.update; // Only update component on url pop
      };

      SearchParams.prototype.render = function render() {
        var _extends2;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props, (_extends2 = {}, _extends2[expose] = {
          query: this.state.searchParams,
          pushQuery: pushQueryTracked(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* PLACEHOLDER */], trackParams, exposeParams),
          pushParam: pushParamTracked(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* PLACEHOLDER */], trackParams, exposeParams),
          queryString: Object(__WEBPACK_IMPORTED_MODULE_2_utils_history__["a" /* getLocation */])().search // TO DO: Remove this it's not always up to date
        }, _extends2)), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        }));
      };

      return SearchParams;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    SearchParams.displayName = "SearchParams";


    SearchParams.displayName = "SearchParams(" + Object(__WEBPACK_IMPORTED_MODULE_1__utils__["s" /* getComponentDisplayName */])(Wrapped) + ")";

    return SearchParams;
  };
});

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_environment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(9);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\detect-window-scroll.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === undefined ? __WEBPACK_IMPORTED_MODULE_4__utils__["C" /* noop */] : _ref$onChange,
      _ref$expose = _ref.expose,
      expose = _ref$expose === undefined ? "windowScroll" : _ref$expose;

  return function (Wrapped) {
    var DetectWindowScroll = function (_PureComponent) {
      _inherits(DetectWindowScroll, _PureComponent);

      function DetectWindowScroll(props) {
        var _this$state;

        _classCallCheck(this, DetectWindowScroll);

        var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

        _this.state = (_this$state = {}, _this$state[expose] = _extends({}, _this.props._WINDOW_SCROLL_), _this$state);
        return _this;
      }

      DetectWindowScroll.prototype.componentDidMount = function componentDidMount() {
        var _setState;

        this.setState((_setState = {}, _setState[expose] = _extends({}, this.props._WINDOW_SCROLL_), _setState));
      };

      DetectWindowScroll.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
        var next = nextProps._WINDOW_SCROLL_;

        if (!Object(__WEBPACK_IMPORTED_MODULE_4__utils__["R" /* shallowEq */])(this.state[expose], next)) {
          var _setState2;

          this.setState((_setState2 = {}, _setState2[expose] = next, _setState2));
          onChange(next);
        }
      };

      DetectWindowScroll.prototype.render = function render() {
        var _extends2;

        var innerProps = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["E" /* omit */])(["_WINDOW_SCROLL_"], this.props), (_extends2 = {}, _extends2[expose] = this.state[expose], _extends2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, innerProps, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        }));
      };

      return DetectWindowScroll;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

    DetectWindowScroll.displayName = "DetectWindowScroll";


    DetectWindowScroll.propTypes = {
      _WINDOW_SCROLL_: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ scrollY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number })
    };

    DetectWindowScroll.displayName = "DetectWindowScroll(" + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["s" /* getComponentDisplayName */])(Wrapped) + ")";

    var mapStateToProps = function mapStateToProps(state) {
      return {
        _WINDOW_SCROLL_: __WEBPACK_IMPORTED_MODULE_3__store_actions_environment__["c" /* selectors */].getWindowScroll(state)
      };
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(DetectWindowScroll);
  };
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apis_koala__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configured_radium__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__connect_location__ = __webpack_require__(375);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\price.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var PriceUnavailable = Object(__WEBPACK_IMPORTED_MODULE_5__configured_radium__["a" /* default */])(function (_ref) {
  var _ref$currentState = _ref.currentState,
      currentState = _ref$currentState === undefined ? "Act" : _ref$currentState,
      _ref$locationError = _ref.locationError,
      locationError = _ref$locationError === undefined ? "" : _ref$locationError,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? __WEBPACK_IMPORTED_MODULE_4_utils__["C" /* noop */] : _ref$onClick;

  if (!currentState) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { style: priceStyles.button, onClick: onClick, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      "Enter your ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: priceStyles.highlight, __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        },
        "postcode"
      ),
      " to see accurate pricing in your area."
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    { style: priceStyles.button, onClick: onClick, __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      }
    },
    __WEBPACK_IMPORTED_MODULE_2_constants_errors__["f" /* PRICE_ERRORS */].LAST_RESORT
  );
});

var priceStyles = {
  button: {
    letterSpacing: "0.1em",
    outline: "none",
    border: "none",
    backgroundColor: "transparent",
    margin: 0,
    padding: 0,
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: 1.4,
    color: "inherit",
    cursor: "pointer",
    textTransform: "inherit",
    ":hover": {
      outline: "none"
    },
    ":active": {
      outline: "none"
    },
    ":focus": {
      outline: "none"
    }
  },
  highlight: {
    color: "#ab0000",
    borderBottom: "1px solid #999"
  }

  /**
   * Higher order component for Fetching and determining price based on geographical location.
   * @param {Object} options - Initial config options.
   * @param {String} options.expose - Name of the prop object that contains price data & methods.
   * @returns {Function} The configured higher order component, which in turn will return a component class.
   */
};/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$expose = _ref2.expose,
      expose = _ref2$expose === undefined ? "price" : _ref2$expose;

  return function (Wrapped) {
    var Price = function (_Component) {
      _inherits(Price, _Component);

      function Price(props) {
        _classCallCheck(this, Price);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
          currentState: 'Act', //this.props.locationState.state,
          data: [false],
          fetchURL: false,
          fetch: false,
          mapping: {}
        };

        Object(__WEBPACK_IMPORTED_MODULE_4_utils__["d" /* bindAll */])(["setOptions", "fetchPrice", "renderPriceUnavailable", "updatePriceLocation", "updatePriceLocationToState", "updatePriceStaticData", "testMapping", "updatePrice", "priceMode"], _this);
        return _this;
      }
      /**
       * Set options for specs api on componentDidMount() / componentWillMount()
       * @param {Object} options - Options object.
       * @param {String} options.fetchURL - Url for spec api endpoint.
       * @param {Function} options.mapping - A mapping function between api values and state.
       * @param {Function} [callback] - Callback when new options have been updated in state.
       */


      Price.prototype.setOptions = function setOptions(options, callback) {
        var fetchURL = options.fetchURL,
            mapping = options.mapping;

        this.setState({
          fetchURL: fetchURL,
          mapping: mapping,
          fetch: true
        }, function () {
          if (typeof callback === "function") callback();
        });
      };

      Price.prototype.fetchPrice = function fetchPrice(stateOptions) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_apis_koala__["a" /* fetchKoalaData */])(this.state.fetchURL, this.state.mapping(stateOptions));
      };
      /**
       * Applys business logic to array of state prices
       * @param {Array} priceArray - Array of objects containing geographic state prices.
       * @returns {Array} - Objects containing price or error messages
       */


      Price.prototype.updatePriceLocation = function updatePriceLocation(priceArray) {
        var _this2 = this;

        var currentState = this.state.currentState;

        if (!Array.isArray(priceArray)) priceArray = [priceArray];
        return priceArray.map(function (priceStateArray) {
          if (!priceStateArray) return false;
          //const locationPrice = priceStateArray.find(item => item.state.toUpperCase() === currentState.toUpperCase())
          var locationPrice = priceStateArray.find(function (item) {
            return 'ACT' === 'ACT';
          });
          return locationPrice && locationPrice.price ? locationPrice : { message: _this2.renderPriceUnavailable() };
        });
      };
      /**
       * Update price when connect-location HOC receives the current state
       */


      Price.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {
        var _this3 = this;

        var locationState = _ref3.locationState;
        var currentState = this.state.currentState;
        //locationState.state = 'Act';

        if (locationState.state && locationState.state !== currentState) {
          // this.setState({ currentState:' locationState.state' }, () =>
          //   this.updatePriceLocationToState(this.rawPriceArray))
          this.setState({ currentState: 'Act' }, function () {
            return _this3.updatePriceLocationToState(_this3.rawPriceArray);
          });
        }
      };

      Price.prototype.updatePriceStaticData = function updatePriceStaticData(priceArray) {
        this.rawPriceArray = priceArray;
        this.updatePriceLocationToState(this.rawPriceArray);
      };
      /**
       * Takes array of prices by state and saves the current states price to state
       * @param {Array} priceArray - Array of objects containing geographic state prices.
       */


      Price.prototype.updatePriceLocationToState = function updatePriceLocationToState(priceArray) {
        var data = this.state.data;

        var newData = this.updatePriceLocation(priceArray).map(function (price, index) {
          return price || data[index];
        });
        this.setState({ data: newData });
      };

      Price.prototype.testMapping = function testMapping(stateOptions) {
        var test = void 0;
        try {
          test = this.state.mapping(stateOptions);
        } catch (error) {
          return false;
        }
        return Object.keys(test).every(function (key) {
          return typeof test[key] !== "undefined";
        });
      };
      /**
       * Take state object & maps it to API values then makes fetch request & updates state.
       * @param {Object} stateOptions - Options stored in state
       */


      Price.prototype.updatePrice = function updatePrice(stateOptions) {
        var _this4 = this;

        if (!this.state.fetch) throw new Error("Set setOptions() before update()");
        if (!Array.isArray(stateOptions)) stateOptions = [stateOptions];

        var data = this.state.data;

        var newData = stateOptions.map(function (opt, index) {
          return opt ? { message: __WEBPACK_IMPORTED_MODULE_2_constants_errors__["f" /* PRICE_ERRORS */].LOADING } : data[index];
        });

        this.setState({ data: newData }, function () {
          Promise.all(stateOptions.map(function (optionSet) {
            var resp = _this4.testMapping(optionSet);
            return resp && _this4.fetchPrice(optionSet);
          })).then(function (priceArray) {
            // Store this so that it can be re-parsed when postcode is received.
            _this4.rawPriceArray = priceArray || [];
            _this4.updatePriceLocationToState(_this4.rawPriceArray);
          }).catch(function (error) {
            return console.warn(error);
          });
        });
      };

      Price.prototype.priceMode = function priceMode() {
        return this.state.fetch ? { update: this.updatePrice } : { update: this.updatePriceStaticData };
      };

      Price.prototype.renderPriceUnavailable = function renderPriceUnavailable() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PriceUnavailable, {
          currentState: this.state.currentState,
          locationError: this.props.locationState.fetchError,
          onClick: this.props.locationActions.requestPostcodeInput, __source: {
            fileName: _jsxFileName,
            lineNumber: 195
          }
        });
      };

      Price.prototype.render = function render() {
        var _extends2;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props, (_extends2 = {}, _extends2[expose] = _extends({
          data: this.state.data,
          setOptions: this.setOptions,
          renderPriceUnavailable: this.renderPriceUnavailable
        }, this.priceMode()), _extends2)), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 203
          }
        }));
      };

      return Price;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Price.displayName = "Price";


    Price.propTypes = {
      locationState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      locationActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    };

    Price.displayName = "Price(" + Object(__WEBPACK_IMPORTED_MODULE_4_utils__["s" /* getComponentDisplayName */])(Wrapped) + ")";

    return Object(__WEBPACK_IMPORTED_MODULE_6__connect_location__["a" /* default */])({
      exposeState: "locationState",
      exposeActions: "locationActions"
    })(Price);
  };
});

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_koala__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\specs.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * Higher order component for Fetching specs.
 * @param {Object} options - Initial config options.
 * @param {String} options.expose - Name of the prop object that contains spec data & methods.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$expose = _ref.expose,
      expose = _ref$expose === undefined ? "specs" : _ref$expose;

  return function (Wrapped) {
    var Specs = function (_Component) {
      _inherits(Specs, _Component);

      function Specs(props) {
        _classCallCheck(this, Specs);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
          data: false,
          fetchURL: false,
          loading: true
        };

        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* bindAll */])(["setOptions", "testMapping", "fetchSpecs", "update"], _this);
        return _this;
      }
      /**
       * Set options for specs api on componentDidMount() / componentWillMount()
       * @param {Object} options - Options object.
       * @param {String} options.fetchURL - Url for spec api endpoint.
       * @param {Object} [options.initial] - Initial value for returned data object.
       * @param {Function} options.mapping - A mapping function between api values and state.
       * @param {Function} [callback] - Callback when new options have been updated in state.
       */


      Specs.prototype.setOptions = function setOptions(options, callback) {
        var fetchURL = options.fetchURL,
            initial = options.initial,
            mapping = options.mapping,
            loading = options.loading;

        this.setState({
          fetchURL: fetchURL,
          data: initial,
          mapping: mapping,
          loading: loading
        }, function () {
          if (typeof callback === "function") callback();
        });
      };

      Specs.prototype.testMapping = function testMapping(stateOptions) {
        var test = void 0;
        try {
          test = this.state.mapping(stateOptions);
        } catch (error) {
          return false;
        }
        return Object.keys(test).every(function (key) {
          return typeof test[key] !== "undefined";
        });
      };

      Specs.prototype.fetchSpecs = function fetchSpecs(fetchOptions) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__apis_koala__["a" /* fetchKoalaData */])(this.state.fetchURL, fetchOptions);
      };
      /**
       * Take state object & maps it to API values then makes fetch request & updates state.
       * @param {Object} stateOptions - Options stored in state
       */


      Specs.prototype.update = function update(stateOptions) {
        var _this2 = this;

        this.setState({ loading: true, data: false });
        if (!this.state.fetchURL) return;
        var mapping = this.state.mapping;

        var fetchOptions = void 0;
        if (!Array.isArray(stateOptions)) {
          fetchOptions = this.testMapping(stateOptions) && mapping(stateOptions) || {};
        } else {
          fetchOptions = stateOptions.map(function (optionSet) {
            return _this2.testMapping(optionSet) && mapping(optionSet) || {};
          });
        }

        return this.fetchSpecs(fetchOptions).then(function (specs) {
          _this2.setState({ data: specs || false, loading: false });
        }).catch(function (error) {
          return console.warn(error);
        });
      };

      Specs.prototype.render = function render() {
        var _extends2;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props, (_extends2 = {}, _extends2[expose] = {
          data: this.state.data,
          setOptions: this.setOptions,
          update: this.update,
          loading: this.state.loading
        }, _extends2)), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 84
          }
        }));
      };

      return Specs;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Specs.displayName = "Specs";


    Specs.displayName = "Specs(" + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["s" /* getComponentDisplayName */])(Wrapped) + ")";

    return Specs;
  };
});

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_gtm__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\gtm-event.jsx";






/* harmony default export */ __webpack_exports__["a"] = (function () {
  return function (Wrapped) {
    var GtmEvent = function GtmEvent(props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, props), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      }));
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({ gtmEvent: __WEBPACK_IMPORTED_MODULE_3__store_actions_gtm__["a" /* gtmEvent */] }, dispatch);
    };

    GtmEvent.displayName = "GtmEvent(" + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["s" /* getComponentDisplayName */])(Wrapped) + ")";

    return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined, mapDispatchToProps)(GtmEvent);
  };
});

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apis_persist__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\local-vehicle.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var LOCALKEY = 'LOCALVEHICLE';

// This higher order component is used for saving vehicle options to cookie and read it somewhere else
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return function (Wrapped) {
    var LocalVehicle = function (_Component) {
      _inherits(LocalVehicle, _Component);

      function LocalVehicle(props) {
        _classCallCheck(this, LocalVehicle);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.getVehicle = function (nameplate) {
          if (_this.localStorageSupported) {
            var vehicles = _this.getVehicles() || {};
            var vehicle = vehicles[nameplate.toUpperCase()];
            if (vehicle) return vehicle;
          }
        };

        _this.getVehicles = function () {
          var data = Object(__WEBPACK_IMPORTED_MODULE_2_apis_persist__["a" /* getLocal */])(LOCALKEY);
          if (typeof data === 'string') {
            return JSON.parse(data);
          }
        };

        _this.setVehicle = function (value) {
          return Object(__WEBPACK_IMPORTED_MODULE_2_apis_persist__["f" /* setLocal */])(LOCALKEY, JSON.stringify(value));
        };

        _this.updateVehicle = function (nameplate, params) {
          var _this$setVehicle;

          return _this.setVehicle((_this$setVehicle = {}, _this$setVehicle[nameplate.toUpperCase()] = params, _this$setVehicle));
        };

        _this.localStorageSupported = Object(__WEBPACK_IMPORTED_MODULE_2_apis_persist__["b" /* isLocalStorageSupported */])();

        _this.state = {
          details: _this.getVehicle(props.nameplate || '')
        };
        return _this;
      }

      LocalVehicle.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props, {
          localVehicle: {
            details: this.state.details,
            updateVehicle: this.updateVehicle
          }
        }), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49
          }
        }));
      };

      return LocalVehicle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    LocalVehicle.propTypes = {
      nameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    };
    LocalVehicle.defaultProps = {
      nameplate: ''
    };
    LocalVehicle.displayName = 'LocalVehicle';


    LocalVehicle.displayName = 'LocalVehicle(' + Object(__WEBPACK_IMPORTED_MODULE_3__utils__["s" /* getComponentDisplayName */])(Wrapped) + ')';

    return LocalVehicle;
  };
});

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = __webpack_require__(970);

var _Cookies2 = _interopRequireDefault(_Cookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Cookies2.default;
module.exports = exports['default'];

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = __webpack_require__(971);

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__(53);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _utils = __webpack_require__(972);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = function () {
  function Cookies(cookies, hooks) {
    _classCallCheck(this, Cookies);

    this.changeListeners = [];

    this.cookies = parseCookies(cookies);
    this.hooks = hooks;
    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
  }

  _createClass(Cookies, [{
    key: '_updateBrowserValues',
    value: function _updateBrowserValues() {
      if (!this.HAS_DOCUMENT_COOKIE) {
        return;
      }

      this.cookies = _cookie2.default.parse(document.cookie);
    }
  }, {
    key: 'get',
    value: function get(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._updateBrowserValues();
      return readCookie(this.cookies[name], options);
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._updateBrowserValues();
      var result = {};

      for (var name in this.cookies) {
        result[name] = readCookie(this.cookies[name], options);
      }

      return result;
    }
  }, {
    key: 'set',
    value: function set(name, value, options) {
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        value = JSON.stringify(value);
      }

      if (this.hooks && this.hooks.onSet) {
        this.hooks.onSet(name, value, options);
      }

      this.cookies[name] = value;

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, value, options);
      }

      this._emitChange({ name: name, value: value, options: options });
    }
  }, {
    key: 'remove',
    value: function remove(name, options) {
      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
        expires: new Date(1970, 1, 1, 0, 0, 1),
        maxAge: 0
      });

      if (this.hooks && this.hooks.onRemove) {
        this.hooks.onRemove(name, finalOptions);
      }

      delete this.cookies[name];

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
      }

      this._emitChange({ name: name, value: undefined, options: options });
    }
  }, {
    key: '_emitChange',
    value: function _emitChange(params) {
      for (var i = 0; i < this.changeListeners.length; ++i) {
        this.changeListeners[i](params);
      }
    }
  }, {
    key: 'addChangeListener',
    value: function addChangeListener(callback) {
      this.changeListeners.push(callback);
    }
  }, {
    key: 'removeChangeListener',
    value: function removeChangeListener(callback) {
      var idx = this.changeListeners.indexOf(callback);
      if (idx >= 0) {
        this.changeListeners.splice(idx, 1);
      }
    }
  }]);

  return Cookies;
}();

exports.default = Cookies;


function parseCookies(cookies) {
  if (typeof cookies === 'string') {
    return _cookie2.default.parse(cookies);
  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isParsingCookie(value, options.doNotParse)) {
    try {
      return JSON.parse(value);
    } catch (e) {
      // At least we tried
    }
  }

  return value;
}
module.exports = exports['default'];

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.hasDocumentCookie = hasDocumentCookie;
exports.cleanCookies = cleanCookies;
// Can we get/set cookies on document.cookie?

function hasDocumentCookie() {
  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
}

//backwards compatibility
var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();

function cleanCookies() {
  document.cookie.split(';').forEach(function (c) {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
}

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\with-hash.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  return function (Wrapped) {
    var withHash = function (_Component) {
      _inherits(withHash, _Component);

      function withHash(props) {
        _classCallCheck(this, withHash);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.updateHash = function (hash) {
          _this.setState({ currentHash: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["t" /* getHash */])() });
        };

        _this.state = {
          currentHash: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["t" /* getHash */])()
        };
        return _this;
      }

      withHash.prototype.componentDidMount = function componentDidMount() {
        __WEBPACK_IMPORTED_MODULE_1__utils__["w" /* history */].listen(this.updateHash);
      };

      withHash.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props, {
          currentHash: this.state.currentHash
        }), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        }));
      };

      return withHash;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    withHash.displayName = 'withHash';


    withHash.displayName = 'withHash(' + Object(__WEBPACK_IMPORTED_MODULE_1__utils__["s" /* getComponentDisplayName */])(Wrapped) + ')';

    return withHash;
  };
});

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_search__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\with-search.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/* harmony default export */ __webpack_exports__["a"] = (function () {
  return function (Wrapped) {
    var withSearch = function (_Component) {
      _inherits(withSearch, _Component);

      function withSearch(props) {
        _classCallCheck(this, withSearch);

        // Populate search store from initialSearchApiData
        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        props.loadInitialData();
        // Parse query from initialQueryString from backend for server-side render
        if (!__WEBPACK_IMPORTED_MODULE_6__constants_environment__["i" /* WINDOW */] && props.initialQueryString) {
          var _queryString$parse = __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(props.initialQueryString),
              q = _queryString$parse.q;

          _this.serverSideQuery = q;
        }
        return _this;
      }

      withSearch.prototype.render = function render() {
        var _props = this.props,
            _props$initialSearchA = _props.initialSearchApiData,
            hits = _props$initialSearchA.hits,
            page = _props$initialSearchA.page,
            initialQueryString = _props.initialQueryString,
            _props$siteSearch = _props.siteSearch,
            query = _props$siteSearch.query,
            siteSearch = _objectWithoutProperties(_props$siteSearch, ["query"]),
            props = _objectWithoutProperties(_props, ["initialSearchApiData", "initialQueryString", "siteSearch"]);
        // Get searchResults directly from initialSearchProps on server side


        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, props, {
          query: query || "",
          searchResultsData: __WEBPACK_IMPORTED_MODULE_6__constants_environment__["i" /* WINDOW */] ? siteSearch : { results: hits }, __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        }));
      };

      return withSearch;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    withSearch.displayName = "withSearch";


    withSearch.propTypes = {
      initialSearchApiData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      initialQueryString: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      injestSearchData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    };

    var mapStateToProps = function mapStateToProps(state) {
      return {
        siteSearch: _extends({}, __WEBPACK_IMPORTED_MODULE_5__store_actions_search__["c" /* selectors */].getCurrentPageData(state), __WEBPACK_IMPORTED_MODULE_5__store_actions_search__["c" /* selectors */].getSiteStatus(state))
      };
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_5__store_actions_search__["a" /* actionCreators */], dispatch);
    };

    withSearch.displayName = "withSearch(" + Object(__WEBPACK_IMPORTED_MODULE_7__utils__["s" /* getComponentDisplayName */])(Wrapped) + ")";

    return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(withSearch);
  };
});

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\with-dynamic-components.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import { ComponentError } from 'components'


var whiteListToObject = function whiteListToObject(list) {
  return list.filter(Boolean).reduce(function (all, entry) {
    var _extends2;

    return _extends({}, all, (_extends2 = {}, _extends2[entry.displayName || entry.name] = entry, _extends2));
  }, {});
};

/**
 * Higher order component for parsing (json) CMS components from to react children
 * @param {Object} options - Initial config options.
 * @param {Array} options.componentWhiteList -
 * Array of components that can be used as children.
 * @param {Array} options.mapInputToOutput -
 * Array of input key output key mappings for multiple dynamic component areas.
 * @returns {Function} The configured higher order component,
 * which in turn will return a component class.
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$componentWhiteli = _ref.componentWhitelist,
      componentWhitelist = _ref$componentWhiteli === undefined ? [] : _ref$componentWhiteli,
      _ref$mapInputToOutput = _ref.mapInputToOutput,
      mapInputToOutput = _ref$mapInputToOutput === undefined ? [["components", "children"]] : _ref$mapInputToOutput,
      _ref$mapInput = _ref.mapInput,
      mapInput = _ref$mapInput === undefined ? function (comp) {
    return comp;
  } : _ref$mapInput;

  return function (Wrapped) {
    var withDynamicComponents = function (_React$Component) {
      _inherits(withDynamicComponents, _React$Component);

      function withDynamicComponents() {
        _classCallCheck(this, withDynamicComponents);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      withDynamicComponents.prototype.getChildContext = function getChildContext() {
        var _context$componentWhi = this.context.componentWhitelist,
            parentComponentWhitelist = _context$componentWhi === undefined ? {} : _context$componentWhi;

        return {
          componentWhitelist: _extends({}, parentComponentWhitelist, whiteListToObject(componentWhitelist))
        };
      };

      withDynamicComponents.prototype.render = function render() {
        var _props = this.props,
            children = _props.children,
            props = _objectWithoutProperties(_props, ["children"]);

        var _context$componentWhi2 = this.context.componentWhitelist,
            parentComponentWhitelist = _context$componentWhi2 === undefined ? {} : _context$componentWhi2;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["j" /* constructOutputProps */])(props, mapInputToOutput, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["A" /* jsonToComponents */])(_extends({}, parentComponentWhitelist, whiteListToObject(componentWhitelist)), mapInput, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["s" /* getComponentDisplayName */])(Wrapped), {
          children: children
        })), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 44
          }
        }));
      };

      return withDynamicComponents;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

    withDynamicComponents.displayName = "withDynamicComponents";


    withDynamicComponents.contextTypes = {
      componentWhitelist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    };

    withDynamicComponents.childContextTypes = {
      componentWhitelist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    };

    withDynamicComponents.displayName = "withDynamicComponents(" + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["s" /* getComponentDisplayName */])(Wrapped) + ")";

    withDynamicComponents.propTypes = {
      components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
    };

    return withDynamicComponents;
  };
});

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\higher-order-components\\with-data-components.jsx";




var jsonToData = function jsonToData(expectedComponent) {
  return function (json) {
    if (!Array.isArray(json)) return undefined;
    return json.map(function (_ref) {
      var name = _ref.name,
          props = _ref.props;

      if (!expectedComponent) {
        throw Error("jsonToData expectedComponent not provided.");
      } else if (expectedComponent !== name) {
        console.warn("jsonToData expecting " + expectedComponent + " but received " + name);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["D" /* nullCheckProps */])(props);
    });
  };
};
/**
 * Higher order component for parsing cms components to data components
 *
 * input: [{
 *    name: 'DataComponent',
 *    props: {
 *      someData: 1000
 *    }
 * } ...]
 * becomes
 * output: [{
 *    someData: 1000
 * } ...]
 *
 * @param {Object} options - Initial config options.
 * @param {Array} options.mapInputToOutput - Array of input key output key mappings for multiple dynamic component areas.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      expectedComponent = _ref2.expectedComponent,
      _ref2$mapInputToOutpu = _ref2.mapInputToOutput,
      mapInputToOutput = _ref2$mapInputToOutpu === undefined ? [["components", "data"]] : _ref2$mapInputToOutpu;

  return function (Wrapped) {
    var withDataComponents = function withDataComponents(props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["j" /* constructOutputProps */])(props, mapInputToOutput, jsonToData(expectedComponent)), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36
        }
      }));
    };
    withDataComponents.displayName = "withDataComponents(" + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["s" /* getComponentDisplayName */])(Wrapped) + ")";

    withDataComponents.propTypes = {
      components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
    };

    return withDataComponents;
  };
});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(238);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(378);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(378);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(237);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(238);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(983);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(239);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(379);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(986);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(988);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(383);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(990);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(239);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(992);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(240);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(383);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(240);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(996);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(381);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export configureStore */
/* harmony export (immutable) */ __webpack_exports__["a"] = getStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension_developmentOnly__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension_developmentOnly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension_developmentOnly__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_reducers__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_actions__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_gtm_events_index_main__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_beacon__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_beacon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_beacon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_beacon_extensions_logger__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_beacon_extensions_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_redux_beacon_extensions_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_beacon_targets_google_tag_manager__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_beacon_targets_google_tag_manager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_redux_beacon_targets_google_tag_manager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_beacon_extensions_offline_web__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_beacon_extensions_offline_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_redux_beacon_extensions_offline_web__);









// GTM






var store = null;

// For futire if we want to develop offiline mode (state) => isConnected
var offlineStorage = Object(__WEBPACK_IMPORTED_MODULE_11_redux_beacon_extensions_offline_web__["offlineWeb"])(function () {
  return true;
});
var googleTagManagerMiddleware = Object(__WEBPACK_IMPORTED_MODULE_8_redux_beacon__["createMiddleware"])(__WEBPACK_IMPORTED_MODULE_7_store_gtm_events_index_main__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_10_redux_beacon_targets_google_tag_manager__["GoogleTagManager"])(), {
  logger: __WEBPACK_IMPORTED_MODULE_3_constants_environment__["d" /* IS_DEV */] ? __WEBPACK_IMPORTED_MODULE_9_redux_beacon_extensions_logger__["logger"] : null, // Disable logging for unit tests
  offlineStorage: offlineStorage
});
// const googleTagManagerMiddleware = createMiddleware(gtmEventMap, GoogleTagManager())
var sagaMiddleware = Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["a" /* default */])();
var composeEnhancers = Object(__WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension_developmentOnly__["composeWithDevTools"])({
  name: "KOALA",
  actionCreators: __WEBPACK_IMPORTED_MODULE_5_store_actions__["b" /* locationActions */]
});
var enhancer = composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(sagaMiddleware, googleTagManagerMiddleware));

function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_4_store_reducers__["a" /* default */], initialState, enhancer);
}

function getStore(initalProps) {
  if (store) {
    return store;
  }
  // dbg && console.trace('Configuring new store') // eslint-disable-line
  store = configureStore({ data: initalProps });
  if (__WEBPACK_IMPORTED_MODULE_3_constants_environment__["c" /* IS_BROWSER */] && __WEBPACK_IMPORTED_MODULE_3_constants_environment__["i" /* WINDOW */]) {
    sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_5_store_actions__["d" /* rootSagas */]);

    // Initiate a location fetch always regardless of the presence of location aware components

    var _locationSelectors$ge = __WEBPACK_IMPORTED_MODULE_5_store_actions__["c" /* locationSelectors */].getLocation(store.getState()),
        state = _locationSelectors$ge.state;

    if (!state) store.dispatch(__WEBPACK_IMPORTED_MODULE_5_store_actions__["b" /* locationActions */].fetchLocation());

    // Handle resize and scroll in one spot
    var pickDimensions = Object(__WEBPACK_IMPORTED_MODULE_6_utils__["I" /* pick */])(["innerWidth", "innerHeight"]);
    var pickScroll = Object(__WEBPACK_IMPORTED_MODULE_6_utils__["I" /* pick */])(["scrollY"]);

    store.dispatch(__WEBPACK_IMPORTED_MODULE_5_store_actions__["a" /* environmentActions */].updateWindowSize(pickDimensions(__WEBPACK_IMPORTED_MODULE_3_constants_environment__["i" /* WINDOW */])));
    store.dispatch(__WEBPACK_IMPORTED_MODULE_5_store_actions__["a" /* environmentActions */].updateWindowScroll(pickScroll(__WEBPACK_IMPORTED_MODULE_3_constants_environment__["i" /* WINDOW */])));

    __WEBPACK_IMPORTED_MODULE_3_constants_environment__["i" /* WINDOW */].addEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_6_utils__["M" /* rafThrottle */])(function () {
      return store.dispatch(__WEBPACK_IMPORTED_MODULE_5_store_actions__["a" /* environmentActions */].updateWindowSize(pickDimensions(__WEBPACK_IMPORTED_MODULE_3_constants_environment__["i" /* WINDOW */])));
    }));
  }

  return store;
}

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(42).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
   false ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
   false ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(385);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(115);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(167);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(387);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(52);
/* unused harmony reexport delay */
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(87);
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1005);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(385);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(115);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(115);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(52);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["b"] = takeLatest;
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(387);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["f" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["f" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["f" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(52);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(87);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(386);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__environment__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__location__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__outlet__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mymazda__ = __webpack_require__(1013);








/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  environment: __WEBPACK_IMPORTED_MODULE_1__environment__["a" /* default */],
  location: __WEBPACK_IMPORTED_MODULE_2__location__["a" /* default */],
  outlet: __WEBPACK_IMPORTED_MODULE_3__outlet__["a" /* default */],
  search: __WEBPACK_IMPORTED_MODULE_4__search__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */],
  mymazda: __WEBPACK_IMPORTED_MODULE_6__mymazda__["a" /* default */]
}));

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = location;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_environment__ = __webpack_require__(85);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// Reducer

var initialState = {
  globalHeaderHeight: 0,
  inPageNavHeight: 0,
  footerHeight: 0,
  isBrowser: __WEBPACK_IMPORTED_MODULE_0__constants_environment__["c" /* IS_BROWSER */],
  window: { innerWidth: 0, innerHeight: 0, scrollY: 0 },
  isOldBrowser: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* isOldBrowser */])()
};

function location() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_environment__["b" /* actionTypes */].UPDATE_GLOBAL_HEADER_HEIGHT:
      return _extends({}, state, { globalHeaderHeight: payload.height });
    case __WEBPACK_IMPORTED_MODULE_2__actions_environment__["b" /* actionTypes */].UPDATE_FOOTER_HEIGHT:
      return _extends({}, state, { footerHeight: payload.height });
    case __WEBPACK_IMPORTED_MODULE_2__actions_environment__["b" /* actionTypes */].UPDATE_IN_PAGE_NAV_HEIGHT:
      return _extends({}, state, { inPageNavHeight: payload.height });
    case __WEBPACK_IMPORTED_MODULE_2__actions_environment__["b" /* actionTypes */].UPDATE_WINDOW_SIZE:
      return _extends({}, state, {
        window: _extends({}, state.window || {}, __WEBPACK_IMPORTED_MODULE_2__actions_environment__["c" /* selectors */].pickDimensions(payload))
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_environment__["b" /* actionTypes */].UPDATE_WINDOW_SCROLL:
      return _extends({}, state, {
        window: _extends({}, state.window || {}, __WEBPACK_IMPORTED_MODULE_2__actions_environment__["c" /* selectors */].pickScroll(payload))
      });
    default:
      return state;
  }
}

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = location;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_persist__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_location__ = __webpack_require__(113);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// Reducer

var initialState = {
  latitude: Number(Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])("latitude")) || undefined,
  longitude: Number(Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])("longitude")) || undefined,
  postcode: Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])("postcode") || undefined,
  state: Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])("state") || "",
  locality: Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])("locality") || "",
  locationConfirmed: Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])("locationConfirmed") === "true",
  isFetching: false,
  fetchError: "",
  postcodePopupOpen: false
};

function location() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].LOCATION_FETCH_START:
      return _extends({}, state, { fetchError: "", isFetching: true });
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].LOCATION_FETCH_ERROR:
      return _extends({}, state, { fetchError: payload.error, isFetching: false });
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].LOCATION_FETCH_SUCCESS:
      return _extends({}, state, payload, { fetchError: "", isFetching: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].POSTCODE_POPUP_SHOW:
      return _extends({}, state, { postcodePopupOpen: true });
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].POSTCODE_POPUP_HIDE:
      return _extends({}, state, { postcodePopupOpen: false });
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].LOCATION_CONFIRMED:
      return _extends({}, state, { locationConfirmed: true });
    default:
      return state;
  }
}

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = outlet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_persist__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_outlet__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(165);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var canShowResultsReducer = function canShowResultsReducer(_ref, payload) {
  var nameplate = _ref.nameplate,
      dealerConfirm = _ref.dealerConfirm,
      _ref$dealer = _ref.dealer,
      dealer = _ref$dealer === undefined ? {} : _ref$dealer,
      results = _ref.results,
      isFetchingStock = _ref.isFetchingStock;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* get */])("fetched", dealer) && nameplate ? results && results.length > 0 && dealerConfirm || isFetchingStock : false;
};

var stepChangeReducer = function stepChangeReducer(_ref2, _ref3) {
  var dealer = _ref2.dealer,
      nameplate = _ref2.nameplate,
      canShowResults = _ref2.canShowResults;
  var step = _ref3.step;

  switch (step) {
    case "SELECT_DEALER":
      break;
    case "SELECT_NAMEPLATE":
      if (!dealer || !dealer.fetched) return "SELECT_DEALER";
      if (!nameplate) return "SELECT_NAMEPLATE";
      break;
    case "SHOW_RESULTS":
      if (!dealer || !dealer.fetched) return "SELECT_DEALER";
      if (!nameplate) return "SELECT_NAMEPLATE";
      if (!canShowResults) return "SELECT_NAMEPLATE";
      break;
    default:
      return step;
  }
  return step;
};

var queryDealer = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])("dealerCode");
var queryLocationId = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])("locationId");

var initialState = {
  step: "SELECT_DEALER",
  storeLoading: true,
  previousDealer: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])("previousDealer") || "",
  nameplate: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])("nameplate"),
  isFetchingDealer: false,
  isFetchingStock: false,
  canShowResults: false,
  dealerConfirm: false,
  noResultMessages: {},
  dealer: queryDealer && {
    dealerCode: queryDealer,
    id: queryLocationId
  } || Object(__WEBPACK_IMPORTED_MODULE_1__apis_persist__["c" /* load */])("localDealer") || {},
  copyMode: "WELCOME",
  outletStockEndpoint: false,
  fetchError: "",
  results: [],
  availability: [],
  sort: {
    key: "price",
    dir: "BMATCH"
  },
  filter: ["DEMO", "RUNOUT"]
};

function outlet() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].INIT_OUTLET_STORE:
      return _extends({}, state, payload, {
        storeLoading: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].LOAD_OUTLET_STORE:
      return _extends({}, state, payload, {
        storeLoading: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].DEALER_CHANGE_REQUEST:
      return _extends({}, state, payload, {
        canShowResults: canShowResultsReducer(state, payload)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].DEALER_CHANGE_SUCCESS:
      return _extends({}, state, payload, {
        canShowResults: canShowResultsReducer(state, payload)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].DEALER_CHANGE_NO_RESULTS:
      return _extends({}, state, payload, {
        canShowResults: canShowResultsReducer(state, payload),
        noResultMessages: _extends({}, state.noResultMessages, payload.noResultMessage)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].DEALER_CONFIRM:
      return _extends({}, state, {
        dealerConfirm: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].DEALER_RESET:
      return _extends({}, state, {
        previousDealer: state.dealer.name,
        dealer: false,
        dealerConfirm: false,
        availability: [],
        results: []
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].NAMEPLATE_CHANGE:
      return _extends({}, state, payload);
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].DEALER_FETCH_START:
      return _extends({}, state, {
        isFetchingDealer: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].DEALER_FETCH_SUCCESS:
      return _extends({}, state, payload, {
        fetchError: "",
        isFetchingDealer: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].DEALER_FETCH_ERROR:
      return _extends({}, state, {
        fetchError: payload.error,
        isFetchingDealer: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].DEALER_FETCH_CANNOT_RESOLVE:
      return _extends({}, state, {
        isFetchingDealer: false,
        canShowResults: canShowResultsReducer(state, payload)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].OUTLET_STOCKS_FETCH_START:
      return _extends({}, state, {
        isFetchingStock: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].OUTLET_STOCKS_FETCH_SUCCESS:
      return _extends({}, state, payload, {
        fetchError: "",
        isFetchingStock: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].OUTLET_STOCKS_FETCH_ERROR:
      return _extends({}, state, {
        fetchError: payload.error,
        isFetchingStock: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].STEP_CHANGE:
      var canShowResults = canShowResultsReducer(state, payload);
      return _extends({}, state, {
        copyMode: "NORMAL"
      }, payload, {
        canShowResults: canShowResults,
        step: stepChangeReducer(_extends({}, state, {
          canShowResults: canShowResults
        }), payload)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].UPDATE_FILTER:
      return _extends({}, state, payload);
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["b" /* actionTypes */].UPDATE_SORT:
      return _extends({}, state, {
        sort: _extends({}, state.sort, payload.sort)
      });
    default:
      return state;
  }
}

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__paginate__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_search__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(165);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var initialState = {
  currentPage: Number(Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])("page")) || 1,
  resultsPerPage: 25,
  error: false,
  totalHits: 0,
  totalPage: 0,
  query: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])("q") || "",
  navQuery: "" // This needs its own reducer when developed further
};

var pages = Object(__WEBPACK_IMPORTED_MODULE_1__paginate__["a" /* default */])({
  mapActionToKey: function mapActionToKey(action) {
    return String(action.payload.page);
  },
  types: [__WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].REQUEST], __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].SUCCESS], __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].FAILURE], __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].UPDATE_SEARCH_QUERY // Set updateSearchQuery as clear type to flush data.
  ]
});

var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].UPDATE_SEARCH_QUERY:
      return _extends({}, state, { currentPage: 1, query: payload });
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].UPDATE_NAV_SEARCH_QUERY:
      return _extends({}, state, { navQuery: payload });
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].REQUEST]:
      return _extends({}, state, { error: false });
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].SUCCESS]:
      var totalHits = payload.totalHits,
          totalPage = payload.totalPage;

      return _extends({}, state, { error: false, totalHits: totalHits, totalPage: totalPage
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].FAILURE]:
      return _extends({}, state, { error: payload.error });
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].CHANGE_PAGE:
      return _extends({}, state, { currentPage: payload });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  status: status,
  pages: pages
}));

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var paginate = function paginate(_ref) {
  var types = _ref.types,
      mapActionToKey = _ref.mapActionToKey;

  if (!Array.isArray(types) || types.length !== 4) {
    throw new Error("Expected types to be an array of four elements.");
  }
  if (!types.every(function (t) {
    return typeof t === "string";
  })) {
    throw new Error("Expected types to be strings.");
  }
  if (typeof mapActionToKey !== "function") {
    throw new Error("Expected mapActionToKey to be a function.");
  }

  var requestType = types[0],
      successType = types[1],
      failureType = types[2],
      clearType = types[3];


  var initialPaginationState = {
    isFetching: false,
    pageCount: 0,
    results: []
  };

  var updatePagination = function updatePagination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPaginationState;
    var action = arguments[1];

    switch (action.type) {
      case requestType:
        return _extends({}, state, {
          isFetching: true
        });
      case successType:
        return _extends({}, state, {
          isFetching: false,
          results: action.payload.hits
        });
      case failureType:
        return _extends({}, state, {
          isFetching: false
        });
      default:
        return state;
    }
  };

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 1: initialPaginationState };
    var action = arguments[1];

    // Update pagination by key
    if (action.type === requestType || action.type === successType || action.type === failureType) {
      var _extends2;

      var key = mapActionToKey(action);
      if (typeof key !== "string") {
        throw new Error("Expected key to be a string.");
      }
      return _extends({}, state, (_extends2 = {}, _extends2[key] = updatePagination(state[key], action), _extends2));
    } else if (action.type === clearType) {
      return {
        1: initialPaginationState
      };
    }
    return state;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (paginate);

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = data;
var initialState = {};

function data() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  return state;
}

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// Reducer

var flashMessageReducer = function flashMessageReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref = arguments[1];
  var payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["c" /* flashActionTypes */].MYMAZDA_FLASH_ADD_MESSAGE:
      return [].concat(state, [{
        id: payload.id,
        message: payload.message,
        type: payload.type
      }]);
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["c" /* flashActionTypes */].MYMAZDA_FLASH_REMOVE_MESSAGE:
      return state.filter(function (message) {
        return message.id !== payload.id;
      });
    default:
      return state;
  }
};

var mymazdaRouteReducer = function mymazdaRouteReducer() {
  var _extends2, _extends3, _extends4, _extends5;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    cache: {}
  };

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      payload = _ref2.payload,
      type = _ref2.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["e" /* routerActionTypes */].MYMAZDA_HYDRATE_ROUTE_COMPONENTS:
      return _extends({}, state, (_extends2 = {}, _extends2[payload.route] = _extends({}, state[payload.route]), _extends2));
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["e" /* routerActionTypes */].MYMAZDA_REGISTER_ROUTES:
      return _extends({}, state, payload.routes);
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["e" /* routerActionTypes */].MYMAZDA_FETCH_START:
      return _extends({}, state, (_extends3 = {}, _extends3[payload.route] = _extends({}, state[payload.route], {
        fetchError: "",
        isFetching: true
      }), _extends3));
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["e" /* routerActionTypes */].MYMAZDA_FETCH_ERROR:
      return _extends({}, state, (_extends4 = {}, _extends4[payload.route] = _extends({}, state[payload.route], {
        fetchError: payload.error,
        isFetching: false
      }), _extends4));
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["e" /* routerActionTypes */].MYMAZDA_FETCH_SUCCESS:
      return _extends({}, state, (_extends5 = {}, _extends5[payload.route] = _extends({}, state[payload.route], {
        fetchError: "",
        isFetching: false
      }), _extends5));
    default:
      return state;
  }
};

var pageCacheReducer = function pageCacheReducer() {
  var _extends6, _extends7;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      payload = _ref3.payload,
      type = _ref3.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["e" /* routerActionTypes */].MYMAZDA_HYDRATE_ROUTE_COMPONENTS:
      return _extends({}, state, (_extends6 = {}, _extends6[payload.key] = payload.components, _extends6));
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["e" /* routerActionTypes */].MYMAZDA_FETCH_SUCCESS:
      return _extends({}, state, (_extends7 = {}, _extends7[payload.key] = payload.components, _extends7));
    default:
      return state;
  }
};

var serviceReducer = function serviceReducer() {
  var _extends8;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      payload = _ref4.payload,
      type = _ref4.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["g" /* serviceActionTypes */].MYMAZDA_UPDATE_SERVICE_DETAILS:
      return _extends({}, state, (_extends8 = {}, _extends8[payload.vin] = payload.service, _extends8));
    default:
      return state;
  }
};

var notificationsReducer = function notificationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      payload = _ref5.payload,
      type = _ref5.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["d" /* notificationsActionTypes */].MYMAZDA_SAVE_NOTIFICATIONS:
      return __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default()([].concat(payload.notifications, state), "notificationID");
    default:
      return state;
  }
};

var uiStateReducer = function uiStateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    expandedNavItemIndex: -1,
    navigationOpen: false,
    userMenuOpen: false,
    notificationMenuOpen: false
  };

  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      payload = _ref6.payload,
      type = _ref6.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["h" /* uiStateActionTypes */].MYMAZDA_TOGGLE_USER:
      return _extends({}, state, {
        navigationOpen: false,
        notificationMenuOpen: false,
        userMenuOpen: !state.userMenuOpen
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["h" /* uiStateActionTypes */].MYMAZDA_TOGGLE_NOTIFICATIONS:
      return _extends({}, state, {
        navigationOpen: false,
        userMenuOpen: false,
        notificationMenuOpen: !state.notificationMenuOpen
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["h" /* uiStateActionTypes */].MYMAZDA_TOGGLE_NAV:
      return _extends({}, state, {
        userMenuOpen: false,
        notificationMenuOpen: false,
        navigationOpen: !state.navigationOpen
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["h" /* uiStateActionTypes */].MYMAZDA_CLOSE_ALL:
      return _extends({}, state, {
        navigationOpen: false,
        userMenuOpen: false,
        notificationMenuOpen: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["h" /* uiStateActionTypes */].MYMAZDA_EXPAND_NAV_ITEM:
      return _extends({}, state, {
        expandedNavItemIndex: payload.index
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_mymazda__["h" /* uiStateActionTypes */].MYMAZDA_TOGGLE_NAV_ITEM:
      return _extends({}, state, {
        expandedNavItemIndex: payload.index === state.expandedNavItemIndex ? -1 : payload.index
      });
    default:
      return state;
  }
};

var mymazda = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  routes: mymazdaRouteReducer,
  flashMessages: flashMessageReducer,
  cache: pageCacheReducer,
  service: serviceReducer,
  notifications: notificationsReducer,
  uiState: uiStateReducer
});

/* harmony default export */ __webpack_exports__["a"] = (mymazda);

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1015);
var bytesToUuid = __webpack_require__(1016);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1018);

/***/ }),
/* 1018 */
/***/ (function(module, exports) {


/*
	shorthash
	(c) 2013 Bibig
	
	https://github.com/bibig/node-shorthash
	shorthash may be freely distributed under the MIT license.
*/

exports.bitwise = bitwise;
exports.binaryTransfer = binaryTransfer;
exports.unique = unique;
exports.random = random;

// refer to: http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
function bitwise(str){
	var hash = 0;
	if (str.length == 0) return hash;
	for (var i = 0; i < str.length; i++) {
		var ch = str.charCodeAt(i);
		hash = ((hash<<5)-hash) + ch;
		hash = hash & hash; // Convert to 32bit integer
	}
	return hash;
}

// 10进制转化成62进制以内的进制
// convert 10 binary to customized binary, max is 62
function binaryTransfer(integer, binary) {
	binary = binary || 62;
	var stack = [];
	var num;
	var result = '';
	var sign = integer < 0 ? '-' : '';
	
	function table (num) {
		var t = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
		return t[num];
	}
	
	integer = Math.abs(integer);
	
	while (integer >= binary) {
		num = integer % binary;
		integer = Math.floor(integer / binary);
		stack.push(table(num));
	}
	
	if (integer > 0) {
		stack.push(table(integer));
	}
	
	for (var i = stack.length - 1; i >= 0; i--) {
		result += stack[i];
	} 
	
	return sign + result;
}


/**
 * why choose 61 binary, because we need the last element char to replace the minus sign
 * eg: -aGtzd will be ZaGtzd
 */
function unique (text) {
	var id = binaryTransfer(bitwise(text), 61);
	return id.replace('-', 'Z');
}

function random (_len) {
	/*
	var len = _len || 8 ;
	return require('crypto').randomBytes(len).toString('hex');
	*/
	
	var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
	var rs = '';
	var len = _len || 8 ;
	for (var i=0; i< len; i++) {
		var pos = Math.floor( Math.random() * chars.length);
		rs += chars.substring(pos, pos + 1);
	}
	return rs;
}

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1020),
    getMatchData = __webpack_require__(1074),
    matchesStrictComparable = __webpack_require__(405);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(389),
    baseIsEqual = __webpack_require__(245);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1021 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(170);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(170);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(170);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(170);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(169);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(169),
    Map = __webpack_require__(243),
    MapCache = __webpack_require__(244);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(391),
    isMasked = __webpack_require__(1034),
    isObject = __webpack_require__(172),
    toSource = __webpack_require__(393);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(171);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1035);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(77);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1038),
    ListCache = __webpack_require__(169),
    Map = __webpack_require__(243);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1039),
    hashDelete = __webpack_require__(1040),
    hashGet = __webpack_require__(1041),
    hashHas = __webpack_require__(1042),
    hashSet = __webpack_require__(1043);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1040 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(174);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1045 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(174);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(174);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(174);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(389),
    equalArrays = __webpack_require__(394),
    equalByTag = __webpack_require__(1053),
    equalObjects = __webpack_require__(1056),
    getTag = __webpack_require__(402),
    isArray = __webpack_require__(70),
    isBuffer = __webpack_require__(248),
    isTypedArray = __webpack_require__(249);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1050 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1051 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(171),
    Uint8Array = __webpack_require__(1054),
    eq = __webpack_require__(390),
    equalArrays = __webpack_require__(394),
    mapToArray = __webpack_require__(1055),
    setToArray = __webpack_require__(246);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(77);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1057);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1058),
    getSymbols = __webpack_require__(1060),
    keys = __webpack_require__(175);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1059),
    isArray = __webpack_require__(70);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(397),
    stubArray = __webpack_require__(1061);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1061 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1063),
    isArguments = __webpack_require__(247),
    isArray = __webpack_require__(70),
    isBuffer = __webpack_require__(248),
    isIndex = __webpack_require__(399),
    isTypedArray = __webpack_require__(249);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(136),
    isObjectLike = __webpack_require__(137);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(136),
    isLength = __webpack_require__(250),
    isObjectLike = __webpack_require__(137);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1067 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(392);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(398)(module)))

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1070);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1070 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117),
    root = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117),
    root = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117),
    root = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(404),
    keys = __webpack_require__(175);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(245),
    get = __webpack_require__(1076),
    hasIn = __webpack_require__(1083),
    isKey = __webpack_require__(251),
    isStrictComparable = __webpack_require__(404),
    matchesStrictComparable = __webpack_require__(405),
    toKey = __webpack_require__(178);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(406);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1078);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1079);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(244);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1081);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(171),
    arrayMap = __webpack_require__(1082),
    isArray = __webpack_require__(70),
    isSymbol = __webpack_require__(177);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1084),
    hasPath = __webpack_require__(1085);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1084 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(407),
    isArguments = __webpack_require__(247),
    isArray = __webpack_require__(70),
    isIndex = __webpack_require__(399),
    isLength = __webpack_require__(250),
    toKey = __webpack_require__(178);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1086 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1088),
    basePropertyDeep = __webpack_require__(1089),
    isKey = __webpack_require__(251),
    toKey = __webpack_require__(178);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1088 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(406);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(395),
    arrayIncludes = __webpack_require__(1091),
    arrayIncludesWith = __webpack_require__(1095),
    cacheHas = __webpack_require__(396),
    createSet = __webpack_require__(1096),
    setToArray = __webpack_require__(246);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1092);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(408),
    baseIsNaN = __webpack_require__(1093),
    strictIndexOf = __webpack_require__(1094);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1093 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1094 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1095 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(403),
    noop = __webpack_require__(1097),
    setToArray = __webpack_require__(246);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1097 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return rootSagas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location_async__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mymazda_async__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__outlet_async__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_async__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__location__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__environment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mymazda__ = __webpack_require__(36);
/* unused harmony reexport locationTypes */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__location__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__location__["c"]; });
/* unused harmony reexport mymazdaTypes */
/* unused harmony reexport mymazdaActions */
/* unused harmony reexport mymazdaSelectors */
/* unused harmony reexport environmentTypes */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__environment__["a"]; });
/* unused harmony reexport environmentSelectors */
var _marked = /*#__PURE__*/regeneratorRuntime.mark(rootSagas);












/** Root saga for state side effect management.
 * https://redux-saga.github.io/redux-saga/docs/introduction/index.html
 * */
function rootSagas() {
  return regeneratorRuntime.wrap(function rootSagas$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_1__location_async__["a" /* default */]), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_3__outlet_async__["a" /* default */]), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_4__search_async__["a" /* default */]), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_2__mymazda_async__["a" /* default */])]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}



/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_geo__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_persist__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_newEvent__ = __webpack_require__(179);
var _marked = /*#__PURE__*/regeneratorRuntime.mark(updatePostcode),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchLocation),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(requestPostcodeInput),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(cancelPostcodeInput),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(_callee5);








var LOCATION_FETCH_START = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].LOCATION_FETCH_START,
    LOCATION_FETCH_SUCCESS = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].LOCATION_FETCH_SUCCESS,
    LOCATION_FETCH_ERROR = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].LOCATION_FETCH_ERROR,
    LOCATION_FETCH_REQUEST = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].LOCATION_FETCH_REQUEST,
    UPDATE_POSTCODE_REQUEST = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].UPDATE_POSTCODE_REQUEST,
    UPDATE_POSTCODE_SUCCESS = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].UPDATE_POSTCODE_SUCCESS,
    POSTCODE_INPUT_REQUEST = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].POSTCODE_INPUT_REQUEST,
    POSTCODE_INPUT_CANCEL = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].POSTCODE_INPUT_CANCEL,
    POSTCODE_POPUP_SHOW = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].POSTCODE_POPUP_SHOW,
    POSTCODE_POPUP_HIDE = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].POSTCODE_POPUP_HIDE,
    LOCATION_CONFIRMED = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].LOCATION_CONFIRMED;


function updatePostcode(_ref) {
  var payload = _ref.payload;

  var _ref2, state, locality, newPostcode;

  return regeneratorRuntime.wrap(function updatePostcode$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: LOCATION_FETCH_START
          });

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__apis_geo__["c" /* fetchGeoDataFromPostcode */], payload.postcode);

        case 5:
          _ref2 = _context.sent;
          state = _ref2.state;
          locality = _ref2.locality;
          newPostcode = _ref2.postcode;


          Object(__WEBPACK_IMPORTED_MODULE_3__apis_persist__["d" /* persist */])({
            postcode: newPostcode,
            state: state,
            locality: locality,
            localDealer: ""
          });

          _context.next = 12;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: UPDATE_POSTCODE_SUCCESS
          });

        case 12:
          _context.next = 14;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: LOCATION_FETCH_SUCCESS,
            payload: {
              state: state,
              locality: locality,
              postcode: newPostcode
            }
          });

        case 14:
          // Fire a GTM action
          setTimeout(function () {
            Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
              pageCategory: "Postcode Pop-up",
              pageAction: "Postcode Pop-up - Entered \"" + newPostcode + "\""
            });
          }, 100);
          // Fire an action to update price ( gradepicker )
          setTimeout(function () {
            var event = Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_newEvent__["a" /* createNewEvent */])("POSTCODE_UPDATE");
            Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_newEvent__["b" /* dispatchEvent */])(event);
          }, 100);
          _context.next = 23;
          break;

        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](2);

          console.warn(_context.t0);
          _context.next = 23;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: LOCATION_FETCH_ERROR,
            payload: {
              error: _context.t0
            }
          });

        case 23:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this, [[2, 18]]);
}

function fetchLocation() {
  var _ref3, latitude, longitude, _ref4, coords, _ref5, postcode, locality, state, _ref6, locationConfirmed;

  return regeneratorRuntime.wrap(function fetchLocation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__location__["c" /* selectors */].getLocation);

        case 2:
          _ref3 = _context2.sent;
          latitude = _ref3.latitude;
          longitude = _ref3.longitude;
          _context2.prev = 5;

          if (Number(latitude) && Number(longitude)) {
            _context2.next = 13;
            break;
          }

          _context2.next = 9;
          return Object(__WEBPACK_IMPORTED_MODULE_2__apis_geo__["d" /* getCurrentPosition */])();

        case 9:
          _ref4 = _context2.sent;
          coords = _ref4.coords;

          latitude = coords.latitude;
          longitude = coords.longitude;

        case 13:

          Object(__WEBPACK_IMPORTED_MODULE_3__apis_persist__["d" /* persist */])({
            latitude: latitude,
            longitude: longitude
          });

          _context2.next = 16;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: LOCATION_FETCH_START
          });

        case 16:
          _context2.next = 18;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__apis_geo__["b" /* fetchGeoDataFromPosition */], {
            latitude: latitude,
            longitude: longitude
          });

        case 18:
          _ref5 = _context2.sent;
          postcode = _ref5.postcode;
          locality = _ref5.locality;
          state = _ref5.state;

          Object(__WEBPACK_IMPORTED_MODULE_3__apis_persist__["d" /* persist */])({
            postcode: postcode,
            state: state,
            locality: locality,
            localDealer: ""
          });

          _context2.next = 25;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__location__["c" /* selectors */].getLocation);

        case 25:
          _ref6 = _context2.sent;
          locationConfirmed = _ref6.locationConfirmed;
          _context2.next = 29;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: LOCATION_FETCH_SUCCESS,
            payload: {
              state: state,
              locality: locality,
              postcode: postcode
            }
          });

        case 29:
          _context2.next = 35;
          break;

        case 31:
          _context2.prev = 31;
          _context2.t0 = _context2["catch"](5);
          _context2.next = 35;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: LOCATION_FETCH_ERROR,
            payload: {
              error: _context2.t0
            }
          });

        case 35:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this, [[5, 31]]);
}

function requestPostcodeInput() {
  var _ref7, postcodePopupOpen, _ref8, gotPostcode, closed;

  return regeneratorRuntime.wrap(function requestPostcodeInput$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__location__["c" /* selectors */].getLocation);

        case 2:
          _ref7 = _context3.sent;
          postcodePopupOpen = _ref7.postcodePopupOpen;

          if (postcodePopupOpen) {
            _context3.next = 19;
            break;
          }

          _context3.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: POSTCODE_POPUP_SHOW
          });

        case 7:
          _context3.next = 9;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* race */])({
            gotPostcode: Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* take */])(UPDATE_POSTCODE_SUCCESS),
            closed: Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* take */])(POSTCODE_POPUP_HIDE)
          });

        case 9:
          _ref8 = _context3.sent;
          gotPostcode = _ref8.gotPostcode;
          closed = _ref8.closed;

          if (!(gotPostcode || closed)) {
            _context3.next = 19;
            break;
          }

          Object(__WEBPACK_IMPORTED_MODULE_3__apis_persist__["d" /* persist */])({
            locationConfirmed: true
          });
          _context3.next = 16;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: LOCATION_CONFIRMED
          });

        case 16:
          if (closed) {
            _context3.next = 19;
            break;
          }

          _context3.next = 19;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: POSTCODE_POPUP_HIDE
          });

        case 19:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function cancelPostcodeInput() {
  return regeneratorRuntime.wrap(function cancelPostcodeInput$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: POSTCODE_POPUP_HIDE
          });

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function _callee5() {
  return regeneratorRuntime.wrap(function _callee5$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(LOCATION_FETCH_REQUEST, fetchLocation);

                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(UPDATE_POSTCODE_REQUEST, updatePostcode);

                  case 2:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee2, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(POSTCODE_INPUT_REQUEST, requestPostcodeInput);

                  case 2:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee3, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            return regeneratorRuntime.wrap(function _callee4$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(POSTCODE_INPUT_CANCEL, cancelPostcodeInput);

                  case 2:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee4, this);
          }))]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked5, this);
}

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export refreshCurrentRoute */
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apis_mymazda__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__environment__ = __webpack_require__(85);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchPageComponents),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(handleFlashMessage),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(refreshCurrentRoute),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(handleToggleNav),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(_callee5);











var MYMAZDA_FETCH_START = __WEBPACK_IMPORTED_MODULE_6__mymazda__["b" /* actionTypes */].MYMAZDA_FETCH_START,
    MYMAZDA_FETCH_SUCCESS = __WEBPACK_IMPORTED_MODULE_6__mymazda__["b" /* actionTypes */].MYMAZDA_FETCH_SUCCESS,
    MYMAZDA_FETCH_ERROR = __WEBPACK_IMPORTED_MODULE_6__mymazda__["b" /* actionTypes */].MYMAZDA_FETCH_ERROR,
    MYMAZDA_UPDATE_ROUTE_COMPONENTS = __WEBPACK_IMPORTED_MODULE_6__mymazda__["b" /* actionTypes */].MYMAZDA_UPDATE_ROUTE_COMPONENTS,
    MYMAZDA_FLASH_ADD_MESSAGE = __WEBPACK_IMPORTED_MODULE_6__mymazda__["b" /* actionTypes */].MYMAZDA_FLASH_ADD_MESSAGE,
    MYMAZDA_REFRESH_CURRENT_ROUTE = __WEBPACK_IMPORTED_MODULE_6__mymazda__["b" /* actionTypes */].MYMAZDA_REFRESH_CURRENT_ROUTE,
    MYMAZDA_TOGGLE_NAV = __WEBPACK_IMPORTED_MODULE_6__mymazda__["b" /* actionTypes */].MYMAZDA_TOGGLE_NAV,
    MYMAZDA_CLOSE_ALL = __WEBPACK_IMPORTED_MODULE_6__mymazda__["b" /* actionTypes */].MYMAZDA_CLOSE_ALL,
    MYMAZDA_TOGGLE_USER = __WEBPACK_IMPORTED_MODULE_6__mymazda__["b" /* actionTypes */].MYMAZDA_TOGGLE_USER,
    MYMAZDA_TOGGLE_NOTIFICATIONS = __WEBPACK_IMPORTED_MODULE_6__mymazda__["b" /* actionTypes */].MYMAZDA_TOGGLE_NOTIFICATIONS;


function fetchPageComponents(_ref) {
  var payload = _ref.payload;

  var route, _route$fetchUrl$split, _route$fetchUrl$split2, pathname, _route$fetchUrl$split3, search, combinedSearch, _ref2, errorMsg, errorCode, data;

  return regeneratorRuntime.wrap(function fetchPageComponents$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_6__mymazda__["f" /* selectors */].getRoute(payload.route));

        case 2:
          route = _context.sent;

          if (!(typeof route === "undefined" || !route.fetchUrl)) {
            _context.next = 7;
            break;
          }

          _context.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: MYMAZDA_FETCH_ERROR,
            payload: {
              route: payload.route,
              error: "Route not found"
            }
          });

        case 6:
          return _context.abrupt("return");

        case 7:
          _context.prev = 7;
          _context.next = 10;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: MYMAZDA_FETCH_START,
            payload: {
              route: payload.route
            }
          });

        case 10:
          _route$fetchUrl$split = route.fetchUrl.split("?"), _route$fetchUrl$split2 = _route$fetchUrl$split[0], pathname = _route$fetchUrl$split2 === undefined ? "" : _route$fetchUrl$split2, _route$fetchUrl$split3 = _route$fetchUrl$split[1], search = _route$fetchUrl$split3 === undefined ? "" : _route$fetchUrl$split3;
          combinedSearch = __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(_extends({}, __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(payload.search), __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(search)));
          _context.next = 14;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_apis_mymazda__["b" /* fetchMyMazdaComponents */], "" + pathname + (combinedSearch && "?" + combinedSearch));

        case 14:
          _ref2 = _context.sent;
          errorMsg = _ref2.errorMsg;
          errorCode = _ref2.errorCode;
          data = _ref2.data;


          if (__WEBPACK_IMPORTED_MODULE_1_constants_environment__["i" /* WINDOW */]) {
            window.scrollTo(0, 0);
          }

          if (!(errorMsg || errorCode || !data || !data.length)) {
            _context.next = 25;
            break;
          }

          _context.next = 22;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: MYMAZDA_FETCH_ERROR,
            payload: {
              route: payload.route,
              error: errorMsg || "Something went wrong"
            }
          });

        case 22:
          _context.next = 24;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_6__mymazda__["a" /* actionCreators */].addFlashMessage("Sorry, there was a problem loading this page. Please try again later.", "ERROR"));

        case 24:
          return _context.abrupt("return");

        case 25:
          _context.next = 27;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: MYMAZDA_FETCH_SUCCESS,
            payload: {
              route: payload.route,
              components: data,
              key: payload.key
            }
          });

        case 27:
          _context.next = 36;
          break;

        case 29:
          _context.prev = 29;
          _context.t0 = _context["catch"](7);

          console.warn(_context.t0);

          _context.next = 34;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: MYMAZDA_FETCH_ERROR,
            payload: {
              route: payload.route,
              error: _context.t0.message
            }
          });

        case 34:
          _context.next = 36;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_6__mymazda__["a" /* actionCreators */].addFlashMessage("Sorry, there was a problem loading this page. Please try again later.", "ERROR"));

        case 36:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this, [[7, 29]]);
}

function handleFlashMessage(_ref3) {
  var payload = _ref3.payload;
  return regeneratorRuntime.wrap(function handleFlashMessage$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(payload.timeout <= 0)) {
            _context2.next = 2;
            break;
          }

          return _context2.abrupt("return");

        case 2:
          _context2.next = 4;
          return new Promise(function (resolve) {
            return setTimeout(resolve, payload.timeout);
          });

        case 4:
          _context2.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_6__mymazda__["a" /* actionCreators */].removeFlashMessage(payload.id));

        case 6:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function refreshCurrentRoute() {
  var _window$location, pathname, search;

  return regeneratorRuntime.wrap(function refreshCurrentRoute$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (__WEBPACK_IMPORTED_MODULE_1_constants_environment__["i" /* WINDOW */]) {
            _context3.next = 2;
            break;
          }

          return _context3.abrupt("return");

        case 2:
          _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search;
          _context3.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_6__mymazda__["a" /* actionCreators */].updateRouteComponents(pathname, search));

        case 5:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

var body = __WEBPACK_IMPORTED_MODULE_4_containers__["e" /* Body */];

function handleToggleNav() {
  var _ref4, navigationOpen, userMenuOpen, notificationMenuOpen, globalNavHeight;

  return regeneratorRuntime.wrap(function handleToggleNav$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (body) {
            _context4.next = 2;
            break;
          }

          return _context4.abrupt("return");

        case 2:
          _context4.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_6__mymazda__["f" /* selectors */].getUiState);

        case 4:
          _ref4 = _context4.sent;
          navigationOpen = _ref4.navigationOpen;
          userMenuOpen = _ref4.userMenuOpen;
          notificationMenuOpen = _ref4.notificationMenuOpen;

          if (!(window.innerWidth < 620 && ( // never lock body for tablet or desktop
          navigationOpen || userMenuOpen || notificationMenuOpen))) {
            _context4.next = 18;
            break;
          }

          _context4.next = 11;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7__environment__["c" /* selectors */].getGlobalHeaderHeight);

        case 11:
          globalNavHeight = _context4.sent;

          if (!(window.scrollY < globalNavHeight)) {
            _context4.next = 15;
            break;
          }

          _context4.next = 15;
          return Object(__WEBPACK_IMPORTED_MODULE_5_utils__["Q" /* scrollToOffset */])(globalNavHeight);

        case 15:
          if (body) body.lock();
          _context4.next = 19;
          break;

        case 18:
          if (body) body.unlock();

        case 19:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function _callee5() {
  return regeneratorRuntime.wrap(function _callee5$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(MYMAZDA_REFRESH_CURRENT_ROUTE, refreshCurrentRoute);

                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(MYMAZDA_UPDATE_ROUTE_COMPONENTS, fetchPageComponents);

                  case 2:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee2, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeEvery */])(MYMAZDA_FLASH_ADD_MESSAGE, handleFlashMessage);

                  case 2:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee3, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            return regeneratorRuntime.wrap(function _callee4$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])([MYMAZDA_TOGGLE_NAV, MYMAZDA_CLOSE_ALL, MYMAZDA_TOGGLE_USER, MYMAZDA_TOGGLE_NOTIFICATIONS], handleToggleNav);

                  case 2:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee4, this);
          }))]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked5, this);
}

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\animation-player\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AnimationPlayer = function (_PureComponent) {
  _inherits(AnimationPlayer, _PureComponent);

  function AnimationPlayer(props) {
    _classCallCheck(this, AnimationPlayer);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.state = {
      playAnimation: false
    };
    _this.playAnimation = _this.playAnimation.bind(_this);
    return _this;
  }

  AnimationPlayer.prototype.playAnimation = function playAnimation() {
    this.setState({ playAnimation: true });
  };

  AnimationPlayer.prototype.render = function render() {
    var _this2 = this;

    var children = this.props.children({
      play: this.playAnimation
    });

    var _props$baseAnimationS = this.props.baseAnimationStyle,
        baseAnimationStyle = _props$baseAnimationS === undefined ? {} : _props$baseAnimationS;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      {
        style: _extends({
          transform: "translate3d(0, 0, 0)",
          display: "block"
        }, baseAnimationStyle),
        onAnimationEnd: function onAnimationEnd() {
          _this2.setState({ playAnimation: false });
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        }
      },
      children
    );
  };

  return AnimationPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

AnimationPlayer.displayName = "AnimationPlayer";


/* harmony default export */ __webpack_exports__["a"] = (AnimationPlayer);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\bubble\\index.jsx";





/**
 * Bubble component
 * @param {Object} props - Component props
 * @param {String} props.content - Content for bubble.
 * @param {Boolean} props.show - Hide / show bubble.
 * @param {Number} props.bottom - Distance from bottom
 * @returns {ReactElement} React Component
 */
var Bubble = function Bubble(_ref) {
  var _ref$hideOnMobile = _ref.hideOnMobile,
      hideOnMobile = _ref$hideOnMobile === undefined ? true : _ref$hideOnMobile,
      _ref$direction = _ref.direction,
      direction = _ref$direction === undefined ? "bottom" : _ref$direction,
      _ref$show = _ref.show,
      show = _ref$show === undefined ? false : _ref$show,
      _ref$compact = _ref.compact,
      compact = _ref$compact === undefined ? false : _ref$compact,
      _ref$content = _ref.content,
      content = _ref$content === undefined ? "" : _ref$content,
      _ref$desktopArrowLeft = _ref.desktopArrowLeft,
      desktopArrowLeft = _ref$desktopArrowLeft === undefined ? null : _ref$desktopArrowLeft,
      _ref$desktopLeft = _ref.desktopLeft,
      desktopLeft = _ref$desktopLeft === undefined ? null : _ref$desktopLeft,
      _ref$mobileArrowLeft = _ref.mobileArrowLeft,
      mobileArrowLeft = _ref$mobileArrowLeft === undefined ? null : _ref$mobileArrowLeft,
      _ref$mobileLeft = _ref.mobileLeft,
      mobileLeft = _ref$mobileLeft === undefined ? null : _ref$mobileLeft,
      _ref$bottom = _ref.bottom,
      bottom = _ref$bottom === undefined ? 0 : _ref$bottom;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      key: "bubble-" + (compact ? "0" : "1"),
      style: [hideOnMobile ? styles.base : styles.baseVisibleMobileAndDesktop, styles.pos(bottom), !compact && desktopLeft && { left: desktopLeft + "px" } || {}, compact && mobileLeft && { left: mobileLeft + "px" } || {}],
      "data-test": "bubble", __source: {
        fileName: _jsxFileName,
        lineNumber: 26
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: [!show && styles.hide, { position: "relative", display: "inline-block", transition: ".25s" }], __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        }
      },
      direction === "bottom" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["a" /* AnimatedArrow */], {
        bgColor: "#fff",
        borderColor: "#ddd",
        leftPercent: compact && mobileArrowLeft || !compact && desktopArrowLeft || 50, __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { "data-test": "bubble-span", style: styles.span, __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          }
        },
        content
      ),
      direction === "top" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["a" /* AnimatedArrow */], {
        bgColor: "#fff",
        borderColor: "#ddd",
        leftPercent: compact && mobileArrowLeft || !compact && desktopArrowLeft || 50,
        down: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 50
        }
      })
    )
  );
};

Bubble.displayName = "Bubble";
Bubble.displayName = "Bubble";
Bubble.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["b" /* DetectCompact */])())(Bubble));

var styles = {
  pos: function pos(bottom) {
    return {
      bottom: bottom + "em"
    };
  },
  base: {
    display: "none",
    "@media (min-width: 768px)": {
      display: "block",
      position: "absolute",
      boxSizing: "border-box",
      width: "100vw",
      maxWidth: "300px",
      left: "50%",
      transform: "translate(-50%, 0)",
      zIndex: 20,
      pointerEvents: "none",
      textAlign: "center"
    }
  },
  baseVisibleMobileAndDesktop: {
    display: "block",
    position: "absolute",
    boxSizing: "border-box",
    width: "100vw",
    maxWidth: "300px",
    left: "40%",
    color: "#101010",
    transform: "translate(-50%, 0)",
    zIndex: 10,
    pointerEvents: "none",
    textAlign: "center"
  },
  span: {
    transition: ".4s",
    display: "inline-block",
    boxSizing: "border-box",
    background: "#FFF",
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
    fontWeight: 300,
    position: "relative",
    padding: "0.5em 1.2em",
    borderRadius: "5px"
  },
  hide: {
    opacity: 0,
    transform: "translateY(.5em)"
  }
};

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\AddressIcon.jsx";


var AddressIcon = function AddressIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 20 20", fill: "currentColor", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M17 7.3c0 3.1-1.6 5.5-3.3 7.6-.9 1.1-3.1 4-3.1 4l-.6.9-.7-.9s-2.2-2.9-3.1-4C4.6 12.8 3 10.4 3 7.3 3 3.4 6.2.2 10 .2s7 3.2 7 7.1zm-1.6-.1c0-3-2.4-5.4-5.4-5.4S4.6 4.3 4.6 7.2c0 2.4 1.1 4.2 2.9 6.6.6.8 1.7 2.2 2.4 3.2.7-1 1.9-2.4 2.4-3.2 2-2.3 3.1-4.2 3.1-6.6zm-3.2-.6c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2.9 2.2 2.2z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

AddressIcon.displayName = "AddressIcon";
AddressIcon.displayName = "AddressIcon";
/* harmony default export */ __webpack_exports__["a"] = (AddressIcon);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert_less__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Alert_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Alert\\Alert.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Alert = function (_React$PureComponent) {
  _inherits(Alert, _React$PureComponent);

  function Alert() {
    _classCallCheck(this, Alert);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? "red" : _props$styleName;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Alert_less___default.a.Alert] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Alert_less___default.a.AlertRed] = styleName === "red", _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["d" /* AlertIcon */], { style: {
          width: "16px",
          height: "16px",
          margin: "2px 12px 0 0",
          flexShrink: 0
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["l" /* Caption */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        },
        children
      )
    );
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Alert.displayName = "Alert";


/* harmony default export */ __webpack_exports__["a"] = (Alert);

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Alert":"Alert__Alert___Qmerw","AlertRed":"Alert__AlertRed___279sL"};

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\AlertIcon.jsx";


var AlertIcon = function AlertIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 18 17", fill: "#910A2D", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M8.623 0l8.623 16.875H0L8.623 0zm0 3.438L2.559 15.312h12.128L8.623 3.438zM7.842 13.75v-1.563h1.562v1.563H7.842zm0-6.875h1.562V8.75l-.312 2.5h-.938l-.312-2.5V6.875z", id: "a", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

AlertIcon.displayName = "AlertIcon";
AlertIcon.displayName = "AlertIcon";
/* harmony default export */ __webpack_exports__["a"] = (AlertIcon);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChevronIcon__ = __webpack_require__(138);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ArrowLeftIcon.jsx';


var ArrowLeftIcon = function ArrowLeftIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      style: {
        transform: 'rotate(-90deg)'
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ChevronIcon__["a" /* default */], { style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    })
  );
};

ArrowLeftIcon.displayName = 'ArrowLeftIcon';
ArrowLeftIcon.displayName = 'ArrowLeftIcon';
/* harmony default export */ __webpack_exports__["a"] = (ArrowLeftIcon);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArrowRightThinIcon__ = __webpack_require__(413);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ArrowLeftThinIcon.jsx";




var ArrowLeftThinIcon = function ArrowLeftThinIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        transform: 'rotate(-180deg)'
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ArrowRightThinIcon__["a" /* default */], { style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    })
  );
};

ArrowLeftThinIcon.displayName = "ArrowLeftThinIcon";
ArrowLeftThinIcon.displayName = "ArrowLeftThinIcon";
ArrowLeftThinIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (ArrowLeftThinIcon);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChevronIcon__ = __webpack_require__(138);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ArrowRightIcon.jsx';


var ArrowRightIcon = function ArrowRightIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      style: {
        transform: 'rotate(90deg)'
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ChevronIcon__["a" /* default */], { style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    })
  );
};

ArrowRightIcon.displayName = 'ArrowRightIcon';
ArrowRightIcon.displayName = 'ArrowRightIcon';
/* harmony default export */ __webpack_exports__["a"] = (ArrowRightIcon);

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BackButton":"BackButton__BackButton___10qIr","BackButtonSmall":"BackButton__BackButtonSmall___2BM8S"};

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AccessoryDetails":"AccessoryDetails__AccessoryDetails___2_v9h","width100":"AccessoryDetails__width100___Kz-xZ"};

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_urlHandler__ = __webpack_require__(33);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\AccessoryItem\\AccessoryItem.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AccessoryItem = function (_React$Component) {
  _inherits(AccessoryItem, _React$Component);

  function AccessoryItem() {
    var _temp, _this, _ret;

    _classCallCheck(this, AccessoryItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._handleClick = function () {
      var _this$props = _this.props,
          partNumber = _this$props.partNumber,
          isPack = _this$props.isPack;

      var href = '' + (isPack ? "/accessory-pack/" : "/accessory/") + encodeURIComponent(partNumber);
      new __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_urlHandler__["a" /* default */](href).redirect();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  AccessoryItem.prototype.render = function render() {
    var _props = this.props,
        name = _props.name,
        imageUrl = _props.imageUrl,
        priceText = _props.priceText,
        grades = _props.grades,
        gtm = _props.gtm;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["m" /* Card */], {
      heading: name,
      imageSrc: imageUrl,
      description: priceText,
      onClick: this._handleClick,
      linkText: 'READ MORE +',
      disclaimer: grades && grades.length && 'Only available on ' + grades.join(", ") + ' models',
      gtm: gtm,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27
      }
    });
  };

  return AccessoryItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AccessoryItem.displayName = 'AccessoryItem';


/* harmony default export */ __webpack_exports__["a"] = (AccessoryItem);

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AccordionText":"AccordionText__AccordionText___2oZhL","AccordionTitle":"AccordionText__AccordionTitle___3mA7j","AccordionContent":"AccordionText__AccordionContent___2GQxn","AccordionContentInside":"AccordionText__AccordionContentInside___1NU5z","LefAligned":"AccordionText__LefAligned___27LN_","AccordionTitleBox":"AccordionText__AccordionTitleBox___1Cz3v","AccordionCenterAligned":"AccordionText__AccordionCenterAligned___3eJrg","AccordionTitleBoxText":"AccordionText__AccordionTitleBoxText___8b2XP","AccordionTitleBoxIcon":"AccordionText__AccordionTitleBoxIcon___1J4C1","AccordionContentBox":"AccordionText__AccordionContentBox___Ql_Lz","AccordionTitleInfo":"AccordionText__AccordionTitleInfo___17ivS","AccordionTitleInfoText":"AccordionText__AccordionTitleInfoText___1IOnG","AccordionTitleInfoIcon":"AccordionText__AccordionTitleInfoIcon___3Noxi","AccordionContentInfo":"AccordionText__AccordionContentInfo___3buRr","AccordionTitleDisclaimer":"AccordionText__AccordionTitleDisclaimer___3RaZd","AccordionTitleDisclaimerIcon":"AccordionText__AccordionTitleDisclaimerIcon___1E4h7","AccordionContentDisclaimer":"AccordionText__AccordionContentDisclaimer___MMyEb"};

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AccordionTextList":"AccordionTextList__AccordionTextList___EMXOp"};

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlertList_less__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlertList_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AlertList_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\AlertList\\AlertList.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AlertList = function (_React$Component) {
  _inherits(AlertList, _React$Component);

  function AlertList() {
    _classCallCheck(this, AlertList);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  AlertList.prototype.render = function render() {
    var _classnames;

    var data = this.props.data;

    if (!data || data === "" || data === undefined) return "";
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__AlertList_less___default.a.AlertList] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      !Array.isArray(data) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["c" /* Alert */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 17
          }
        },
        data
      ),
      Array.isArray(data) && data.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["c" /* Alert */],
          { key: "Alert-" + index, __source: {
              fileName: _jsxFileName,
              lineNumber: 21
            }
          },
          item
        );
      })
    );
  };

  return AlertList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AlertList.displayName = "AlertList";


/* harmony default export */ __webpack_exports__["a"] = (AlertList);

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AlertList":"AlertList__AlertList___1b7sS"};

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ArticleHeader":"ArticlePage__ArticleHeader___3t8Mc"};

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\BookServiceForm\\ServiceSummary.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ServiceSummary = function (_React$PureComponent) {
  _inherits(ServiceSummary, _React$PureComponent);

  function ServiceSummary() {
    _classCallCheck(this, ServiceSummary);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  ServiceSummary.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3;

    var _props = this.props,
        _props$serviceType = _props.serviceType,
        serviceType = _props$serviceType === undefined ? "MSS" : _props$serviceType,
        serviceData = _props.serviceData,
        serviceCode = _props.serviceCode,
        asmc = _props.asmc,
        vinRego = _props.vinRego,
        _props$serviceSummary = _props.serviceSummaryDescription,
        serviceSummaryDescription = _props$serviceSummary === undefined ? "The total service price is the Base Scheduled Maintenance, plus any Additional Scheduled Maintenance items that are required." : _props$serviceSummary,
        isChangeItemsDisable = _props.isChangeItemsDisable;

    var scheduledMaintenance = [];
    var totalPrice = 0;
    serviceData.forEach(function (item) {
      if (item.factoryCode === serviceCode) {
        totalPrice += item.basePrice;
        scheduledMaintenance.push({
          description: item.factoryCodeEntity.description,
          price: item.basePrice
        });
      }
    });
    var additionalMaintenance = [];
    serviceData.forEach(function (item) {
      asmc.forEach(function (addtionalItemCode) {
        if (item.factoryCode === addtionalItemCode) {
          totalPrice += item.basePrice;
          additionalMaintenance.push({
            description: item.factoryCodeEntity.description,
            price: item.basePrice
          });
        }
      });
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["C" /* H5 */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 43
          }
        },
        "SERVICE SUMMARY"
      ),
      serviceType === "MSS" && serviceSummaryDescription && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 45
          }
        },
        serviceSummaryDescription
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less___default.a.ServiceSummary] = true, _classnames)), __source: {
              fileName: _jsxFileName,
              lineNumber: 48
            }
          },
          serviceType !== "COMP" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_9" /* ServiceIcon */], { style: { height: "20px", width: "20px", margin: "2px 16px 0 0" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 52
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { flexGrow: 1 }, __source: {
                fileName: _jsxFileName,
                lineNumber: 54
              }
            },
            serviceType !== "COMP" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
              { withoutMargin: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 56
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "b",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 57
                  }
                },
                serviceType === "MSS" ? "Base Scheduled Maintenance" : "Scheduled Maintenance"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 60
              }
            }),
            scheduledMaintenance.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
                { withoutMargin: true, key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 62
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 63
                    }
                  },
                  item.description
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { style: { float: "right" }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 64
                    }
                  },
                  "$",
                  item.price
                )
              );
            })
          )
        ),
        additionalMaintenance.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 70
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less___default.a.ServiceSummary] = true, _classnames2)), __source: {
                fileName: _jsxFileName,
                lineNumber: 71
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["Y" /* MaintenanceIcon */], { style: { height: "20px", width: "20px", margin: "2px 16px 0 0" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 74
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { flexGrow: 1 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 75
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
                { withoutMargin: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 76
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "b",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 76
                    }
                  },
                  "Additional Scheduled Maintenance"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 77
                }
              }),
              additionalMaintenance.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
                  { withoutMargin: true, key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 79
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 80
                      }
                    },
                    item.description
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { style: { float: "right" }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 81
                      }
                    },
                    "$",
                    item.price
                  )
                );
              })
            )
          )
        ),
        !isChangeItemsDisable && serviceType !== "COMP" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { textAlign: "right", margin: "1em 0" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 90
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["a" /* A */],
            {
              gtm: {
                category: "Request A Service Form",
                action: "Request A Service Form - Clicked \"EDIT SERVICE\""
              },
              href: "/owners/servicing/owners-service-calculator/?factoryCode=" + serviceCode + "&VIN=" + vinRego + (asmc && asmc.map(function (item) {
                return item && "&asmc=" + item;
              }).join("")), __source: {
                fileName: _jsxFileName,
                lineNumber: 91
              }
            },
            "Edit Service"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__BookServiceForm_less___default.a.ServiceSummaryPrice] = true, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 103
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["C" /* H5 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 106
            }
          },
          "TOTAL SERVICE PRICE"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["C" /* H5 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 107
            }
          },
          "$",
          totalPrice
        )
      )
    );
  };

  return ServiceSummary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

ServiceSummary.displayName = "ServiceSummary";


/* harmony default export */ __webpack_exports__["a"] = (ServiceSummary);

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InputSearchable":"InputSearchable__InputSearchable___2B1cw","InputSearchableIcon":"InputSearchable__InputSearchableIcon___2n16s","InputSearchableIconInnerInvalid":"InputSearchable__InputSearchableIconInnerInvalid___3bOUh","InputSearchableIconInner":"InputSearchable__InputSearchableIconInner___K0iZh","selectOptions":"InputSearchable__selectOptions___2941Q","selectOptionsUL":"InputSearchable__selectOptionsUL___1pd7U","selectOptionsLI":"InputSearchable__selectOptionsLI___2QBzR","selectOptionsLIHover":"InputSearchable__selectOptionsLIHover___3b8pB"};

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TITLES = "Mr|Mrs|Ms|Miss|Dr|Master|Prof".split("|").map(function (label) {
  return {
    label: label,
    value: label
  };
});

/* harmony default export */ __webpack_exports__["a"] = (TITLES);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TIMES = "12:00 AM|12:15 AM|12:30 AM|12:45 AM|01:00 AM|01:15 AM|01:30 AM|01:45 AM|02:00 AM|02:15 AM|02:30 AM|02:45 AM|03:00 AM|03:15 AM|03:30 AM|03:45 AM|04:00 AM|04:15 AM|04:30 AM|04:45 AM|05:00 AM|05:15 AM|05:30 AM|05:45 AM|06:00 AM|06:15 AM|06:30 AM|06:45 AM|07:00 AM|07:15 AM|07:30 AM|07:45 AM|08:00 AM|08:15 AM|08:30 AM|08:45 AM|09:00 AM|09:15 AM|09:30 AM|09:45 AM|10:00 AM|10:15 AM|10:30 AM|10:45 AM|11:00 AM|11:15 AM|11:30 AM|11:45 AM|12:00 PM|12:15 PM|12:30 PM|12:45 PM|01:00 PM|01:15 PM|01:30 PM|01:45 PM|02:00 PM|02:15 PM|02:30 PM|02:45 PM|03:00 PM|03:15 PM|03:30 PM|03:45 PM|04:00 PM|04:15 PM|04:30 PM|04:45 PM|05:00 PM|05:15 PM|05:30 PM|05:45 PM|06:00 PM|06:15 PM|06:30 PM|06:45 PM|07:00 PM|07:15 PM|07:30 PM|07:45 PM|08:00 PM|08:15 PM|08:30 PM|08:45 PM|09:00 PM|09:15 PM|09:30 PM|09:45 PM|10:00 PM|10:15 PM|10:30 PM|10:45 PM|11:00 PM|11:15 PM|11:30 PM|11:45 PM".split("|").map(function (label) {
  return {
    label: label,
    value: label
  };
});

/* harmony default export */ __webpack_exports__["a"] = (TIMES);

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BookTestDrive":"BookTestDrive__BookTestDrive___as7OB","BookTestDriveForm":"BookTestDrive__BookTestDriveForm___3sCbZ","BookTestDriveFormText":"BookTestDrive__BookTestDriveFormText___267RK","requiredStar":"BookTestDrive__requiredStar___3j0sg"};

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TITLES = "Mr|Mrs|Ms|Miss|Dr|Master|Prof".split("|").map(function (label) {
  return {
    label: label,
    value: label
  };
});

/* harmony default export */ __webpack_exports__["a"] = (TITLES);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BrowserHeightSection_less__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BrowserHeightSection_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BrowserHeightSection_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_debounce__ = __webpack_require__(47);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\BrowserHeightSection\\BrowserHeightSection.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// BrowserHeightSection
// Sets the div to be the browserHeight
// withHeader -> minus header height
// withFooter -> minus footer Height

var BrowserHeightSection = function (_React$Component) {
  _inherits(BrowserHeightSection, _React$Component);

  function BrowserHeightSection(props) {
    _classCallCheck(this, BrowserHeightSection);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._setHeight = function () {
      var _this$props$setHeight = _this.props.setHeight,
          setHeight = _this$props$setHeight === undefined ? function () {} : _this$props$setHeight;

      _this.setState({
        height: "" + _this._calculatingHeight()
      }, function () {
        setHeight(_this.state.height);
      });
    };

    _this._calculatingHeight = function () {
      var newHeight = _this.state.height;

      // IN IS_IFRAME height is not limited to the browser
      if (!__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["e" /* IS_IFRAME */]) {
        newHeight = Number(__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].innerHeight);
        if (__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].document) {
          if (__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].document.getElementById("header")) {
            newHeight = Number(newHeight) - Number(__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].document.getElementById("header").clientHeight);
          }
          if (__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].document.getElementById("sticky-nav")) {
            newHeight = Number(newHeight) - Number(__WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].document.getElementById("sticky-nav").clientHeight);
          }
        }
      } else {
        return 700;
      }
      return newHeight;
    };

    _this.state = {
      height: 700,
      loading: true,
      visible: true
    };
    return _this;
  }

  BrowserHeightSection.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_debounce__["a" /* default */])(this._setHeight, 250));
    this._setHeight();
    this.setState({
      loading: false
    }, function () {
      setTimeout(function () {
        _this2.setState({
          visible: false
        });
      }, 200);
    });
  };

  BrowserHeightSection.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_debounce__["a" /* default */])(this._setHeight, 250));
  };

  BrowserHeightSection.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        children = _props.children,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? "light" : _props$styleName;
    var _state = this.state,
        height = _state.height,
        loading = _state.loading,
        visible = _state.visible;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__BrowserHeightSection_less___default.a.BrowserHeightSection] = true, _classnames)),
        style: { height: height + "px" },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 73
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "BrowserHeightSection-" + height,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__BrowserHeightSection_less___default.a.BrowserHeightChildren] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_3__BrowserHeightSection_less___default.a.BrowserHeightChildrenVisible] = !loading, _classnames2)),
          style: { height: height + "px" },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 79
          }
        },
        children
      ),
      visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["W" /* LoadingSection */], { visible: loading, height: height, styleName: styleName, __source: {
          fileName: _jsxFileName,
          lineNumber: 90
        }
      })
    );
  };

  return BrowserHeightSection;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrowserHeightSection.displayName = "BrowserHeightSection";


/* harmony default export */ __webpack_exports__["a"] = (BrowserHeightSection);

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BrowserHeightSection":"BrowserHeightSection__BrowserHeightSection___ufeAb","BrowserHeightChildren":"BrowserHeightSection__BrowserHeightChildren___2HCdx","BrowserHeightChildrenVisible":"BrowserHeightSection__BrowserHeightChildrenVisible___1CXb8"};

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BrowserWarning":"BrowserWarning__BrowserWarning___3dEae","closeButton":"BrowserWarning__closeButton___3705h","TitleSection":"BrowserWarning__TitleSection___3k32N","Icon":"BrowserWarning__Icon___2mzen","Title":"BrowserWarning__Title___9AWBa","ContentSection":"BrowserWarning__ContentSection___34eR8"};

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__environment__ = __webpack_require__(17);



var oldBrowserDetector = function oldBrowserDetector() {
  if (!__WEBPACK_IMPORTED_MODULE_1__environment__["b" /* IS_BROWSER */]) return false;

  if (!__WEBPACK_IMPORTED_MODULE_0_bowser___default.a.version) return false;

  if (__WEBPACK_IMPORTED_MODULE_0_bowser___default.a.name) {
    var browserName = __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.name.toLowerCase();
    if (__WEBPACK_IMPORTED_MODULE_1__environment__["h" /* MIN_BROWSERS */][browserName]) {
      if (__WEBPACK_IMPORTED_MODULE_0_bowser___default.a.version && Number(__WEBPACK_IMPORTED_MODULE_0_bowser___default.a.version) >= Number(__WEBPACK_IMPORTED_MODULE_1__environment__["h" /* MIN_BROWSERS */][browserName])) {
        return false;
      } else {
        return true;
      }
    }
  }

  // default is browser is not an old one
  return false;
};

/* harmony default export */ __webpack_exports__["a"] = (oldBrowserDetector);

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CardYoutubePlayer":"CardYoutubePlayer__CardYoutubePlayer___1fGWW","YoutubeFrameShadow":"CardYoutubePlayer__YoutubeFrameShadow___wK6C_","YoutubeFrame":"CardYoutubePlayer__YoutubeFrame___1DL9I","YoutubeFrameIframe":"CardYoutubePlayer__YoutubeFrameIframe___Yao8l"};

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CardYoutubePlayerList":"CardYoutubePlayerList__CardYoutubePlayerList___3s6tN","CardYoutubePlayerListRoot":"CardYoutubePlayerList__CardYoutubePlayerListRoot___e98BD","CardYoutubePlayerListView":"CardYoutubePlayerList__CardYoutubePlayerListView___1LnWw","CardYoutubePlayerListViewItem":"CardYoutubePlayerList__CardYoutubePlayerListViewItem___3Sq7j","CardYoutubePlayerListViewItemFour":"CardYoutubePlayerList__CardYoutubePlayerListViewItemFour___1lkjn","CardYoutubePlayerListViewItemFeatured":"CardYoutubePlayerList__CardYoutubePlayerListViewItemFeatured___1Ic0_","CardYoutubePlayerListViewScrolling":"CardYoutubePlayerList__CardYoutubePlayerListViewScrolling___zrpRI","CardYoutubePlayerListViewCenterScrolling":"CardYoutubePlayerList__CardYoutubePlayerListViewCenterScrolling___2FFeq","Arrow":"CardYoutubePlayerList__Arrow___2VBBM","ArrowRight":"CardYoutubePlayerList__ArrowRight___1bHnM","ArrowLeft":"CardYoutubePlayerList__ArrowLeft___3inJJ"};

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ColorPicker":"ColorPicker__ColorPicker___4bzT9","Container":"ColorPicker__Container___1rCax","Tabs":"ColorPicker__Tabs___2dzdj","ColorIcon":"ColorPicker__ColorIcon___8RTRD","Tooltip":"ColorPicker__Tooltip___3elQ6","Children":"ColorPicker__Children___2b4oI"};

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"RegisterInterest":"CompetitionForm__RegisterInterest___2aaK-","CompetitionForm":"CompetitionForm__CompetitionForm___L8zX5","CompetitionFormText":"CompetitionForm__CompetitionFormText___2W0Fv","requiredStar":"CompetitionForm__requiredStar___3_hLr"};

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TITLES = "Mr|Mrs|Ms|Miss|Dr|Master|Prof".split("|").map(function (label) {
  return {
    label: label,
    value: label
  };
});

/* harmony default export */ __webpack_exports__["a"] = (TITLES);

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ContentCard":"ContentCard__ContentCard___qhfzz","LeftSide":"ContentCard__LeftSide___2yyUD","LeftSideHeading":"ContentCard__LeftSideHeading___d6DMi","RightSide":"ContentCard__RightSide___1gAon"};

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ContentCardListRoot":"ContentCardList__ContentCardListRoot___29vOX","ContentCardListView":"ContentCardList__ContentCardListView___28pIs","ContentCardListViewItem":"ContentCardList__ContentCardListViewItem___3Fyxx","ContentCardListViewItemborderBottom":"ContentCardList__ContentCardListViewItemborderBottom___J2IAF"};

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CorporateSelect":"CorporateSelect__CorporateSelect___3b7cD","CorporateSelectForm":"CorporateSelect__CorporateSelectForm___OGcXz"};

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TITLES = "Mr|Mrs|Ms|Miss|Dr|Master|Prof".split("|").map(function (label) {
  return {
    label: label,
    value: label
  };
});

/* harmony default export */ __webpack_exports__["a"] = (TITLES);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DealerSearch_less__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DealerSearch_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DealerSearch_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DealerDetails__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_fetchAPI__ = __webpack_require__(21);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\DealerSearch\\DealerSearch.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DealerSearch = function (_React$Component) {
  _inherits(DealerSearch, _React$Component);

  function DealerSearch(props) {
    var _this2 = this;

    _classCallCheck(this, DealerSearch);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._onChangeHandler = function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;


      if (!value || value === "") {
        _this.setState({
          selected: {}
        });
        return;
      }

      _this.setState({
        selected: value
      }, function () {
        onChange(_this.state.selected);
      });
    };

    _this._search = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(postcode, dealerCode) {
        var type, loading;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("search for a dealer by post code / dealer code");
                type = _this.props.type;
                loading = _this.state.loading;

                if (!(!loading && (postcode || dealerCode))) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this.setState({
                  loading: true,
                  dealers: null
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _this$props, endpoint, _this$props$onChange2, onChange;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this$props = _this.props, endpoint = _this$props.endpoint, _this$props$onChange2 = _this$props.onChange, onChange = _this$props$onChange2 === undefined ? function () {} : _this$props$onChange2;
                          _context2.next = 3;
                          return Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: endpoint,
                            body: {
                              DealerCode: dealerCode,
                              DealerType: type || null,
                              PostCode: dealerCode ? null : postcode
                            }
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, errorMsg, errorCode, success, data;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      errorMsg = json.errorMsg, errorCode = json.errorCode, success = json.success, data = json.data;


                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          errorCode: errorCode,
                                          loading: false
                                        });
                                      } else {
                                        _this.setState({
                                          dealers: data,
                                          selected: data[0],
                                          loading: false
                                        }, function () {
                                          onChange(_this.state.selected);
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x4) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function () {
                            _this.setState({
                              loading: false
                            });
                          });

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      dealers: props.dealers || [],
      selected: {}
    };
    return _this;
  }

  DealerSearch.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        postcode = _props.postcode,
        dealerCode = _props.dealerCode,
        _props$onChange = _props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;


    if (postcode) {
      onChange({});
      this._search(postcode, null);
    }

    if (dealerCode) {
      onChange({});
      this._search(null, dealerCode);
    }
  };

  DealerSearch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props2 = this.props,
        postcode = _props2.postcode,
        dealerCode = _props2.dealerCode,
        _props2$onChange = _props2.onChange,
        onChange = _props2$onChange === undefined ? function () {} : _props2$onChange;


    if (prevProps.postcode !== postcode || prevProps.dealerCode !== dealerCode) {
      onChange({});
      this._search(postcode, dealerCode);
    }
  };

  DealerSearch.prototype.render = function render() {
    var _classnames,
        _classnames2,
        _this3 = this;

    var _props3 = this.props,
        disabled = _props3.disabled,
        type = _props3.type;
    var _state = this.state,
        loading = _state.loading,
        dealers = _state.dealers,
        selected = _state.selected;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__DealerSearch_less___default.a.DealerSearch] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__DealerSearch_less___default.a.DealerSearchDisabled] = false, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 113
        }
      },
      loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__DealerSearch_less___default.a.DealerSearchLoadingSection] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 120
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["W" /* LoadingSection */], { visible: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 123
          }
        })
      ),
      !dealers || !dealers.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126
        }
      }),
      dealers && dealers.map(function (dealer) {
        var department = dealer.departments.find(function (department) {
          return department.name.toLowerCase() === type.toLowerCase();
        });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["P" /* InputRadio */], {
          name: "dealers",
          key: dealer.id,
          value: dealer,
          checked: selected.id === dealer.id,
          onChange: _this3._onChangeHandler,
          label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DealerDetails__["a" /* default */], { dealer: dealer, department: department, __source: {
              fileName: _jsxFileName,
              lineNumber: 137
            }
          }),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 131
          }
        });
      })
    );
  };

  return DealerSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DealerSearch.displayName = "DealerSearch";


/* harmony default export */ __webpack_exports__["a"] = (DealerSearch);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DealerSearch_less__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DealerSearch_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DealerSearch_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\DealerSearch\\DealerDetails.jsx";





var Icon = function Icon(_ref) {
  var name = _ref.name;

  var style = {
    fill: '#999999',
    marginRight: '8px',
    padding: '3px 0',
    flexShrink: 0,
    height: '20px',
    width: '20px'
  };

  switch (name) {
    case "hours":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["F" /* HoursIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 18
        }
      });
    case "address":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["b" /* AddressIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      });
    case "website":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_22" /* WebsiteIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 22
        }
      });
    case "phone":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_2" /* PhoneIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 24
        }
      });
    case "info":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["J" /* InfoIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        }
      });
  }
};

var DealerDetails = function DealerDetails(_ref2) {
  var _classnames, _classnames2;

  var dealer = _ref2.dealer,
      department = _ref2.department;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__DealerSearch_less___default.a.Dealer] = true, _classnames)), __source: {
        fileName: _jsxFileName,
        lineNumber: 31
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["D" /* H6 */],
      { withDetails: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        }
      },
      dealer.name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "ul",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__DealerSearch_less___default.a.DealerDetails] = true, _classnames2)), __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 38
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "address", __source: {
            fileName: _jsxFileName,
            lineNumber: 39
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
          { withoutMargin: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 40
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["a" /* A */],
            {
              external: true,
              styleName: "blue",
              href: "https://google.com.au/maps?q=" + dealer.address + "+" + dealer.suburb + "+" + dealer.state + "+" + dealer.postCode + "/", __source: {
                fileName: _jsxFileName,
                lineNumber: 41
              }
            },
            dealer.address,
            ", ",
            dealer.suburb,
            ", ",
            dealer.state,
            " ",
            dealer.postCode
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "hours", __source: {
            fileName: _jsxFileName,
            lineNumber: 50
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 51
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 52
              }
            },
            "Opening hours:"
          ),
          department.hours.map(function (label, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
              { withoutMargin: true, key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 53
                }
              },
              label
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 56
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "website", __source: {
            fileName: _jsxFileName,
            lineNumber: 57
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
          { withoutMargin: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 58
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["a" /* A */],
            {
              external: true,
              styleName: "blue",
              href: dealer.website, __source: {
                fileName: _jsxFileName,
                lineNumber: 59
              }
            },
            dealer.websiteLabel
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 67
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "phone", __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
          { withoutMargin: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          },
          department.phoneLabel
        )
      )
    )
  );
};

DealerDetails.displayName = "DealerDetails";
DealerDetails.displayName = "DealerDetails";
/* harmony default export */ __webpack_exports__["a"] = (DealerDetails);

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Disclaimer":"Disclaimer__Disclaimer___3EeaY","DisclaimerIcon":"Disclaimer__DisclaimerIcon___BCCPp","DisclaimerText":"Disclaimer__DisclaimerText___2o4I4","DisclaimerToast":"Disclaimer__DisclaimerToast___2OqMJ","DisclaimerToastIcon":"Disclaimer__DisclaimerToastIcon___3YTVp","DisclaimerContent":"Disclaimer__DisclaimerContent___1rW6s"};

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FeaturedCategoriesTab":"FeaturedCategoriesTab__FeaturedCategoriesTab___3JVxJ"};

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FeatureFocusBlock":"FeatureFocusBlock__FeatureFocusBlock___2c-TF","FeatureFocusContentBox":"FeatureFocusBlock__FeatureFocusContentBox___2QaHQ","FeatureFocusContentBoxInside":"FeatureFocusBlock__FeatureFocusContentBoxInside___2YQxA","ArrowsBoxContainer":"FeatureFocusBlock__ArrowsBoxContainer___1DfMH","ArrowsBox":"FeatureFocusBlock__ArrowsBox___swt1z","Numbers":"FeatureFocusBlock__Numbers___twlSl","SingleNumber":"FeatureFocusBlock__SingleNumber___1nY3F","ActiveNumber":"FeatureFocusBlock__ActiveNumber___29C6u","ContentBox":"FeatureFocusBlock__ContentBox___3Yrsx","ContentBoxAnimation":"FeatureFocusBlock__ContentBoxAnimation___bJN8r","Center":"FeatureFocusBlock__Center___2PAqY","ContentArea":"FeatureFocusBlock__ContentArea___1BQhn","FeatureFocusContentBoxVisible":"FeatureFocusBlock__FeatureFocusContentBoxVisible___FswsE"};

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ColumnParent":"FiftyFiftyBlock__ColumnParent___GNUF5","Media":"FiftyFiftyBlock__Media___2cKy4","MediaImage":"FiftyFiftyBlock__MediaImage___3aui1","MediaImageLarge":"FiftyFiftyBlock__MediaImageLarge___2Gkuu","MediaImageMedium":"FiftyFiftyBlock__MediaImageMedium___3D_6d","MediaImageSmall":"FiftyFiftyBlock__MediaImageSmall___1OknN","MediaImageInitial":"FiftyFiftyBlock__MediaImageInitial___3QPwc","Content":"FiftyFiftyBlock__Content___257UB","ContentCenter":"FiftyFiftyBlock__ContentCenter___2rF6R","ContentRight":"FiftyFiftyBlock__ContentRight___2pmAa","ContentHeading":"FiftyFiftyBlock__ContentHeading___5ewSk"};

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer__Footer___28d93","FooterInside":"Footer__FooterInside___2mEu5","FooterRight":"Footer__FooterRight___gmAjf","FooterRightLinks":"Footer__FooterRightLinks___gt4kg","CopyRight":"Footer__CopyRight___1J1EN","FooterLeft":"Footer__FooterLeft___1Egw8","PostCode":"Footer__PostCode___3szQk","Socials":"Footer__Socials___2Tt3H"};

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var longPolling = function longPolling(_ref) {
  var _ref$conditionFucntio = _ref.conditionFucntion,
      conditionFucntion = _ref$conditionFucntio === undefined ? function () {} : _ref$conditionFucntio,
      _ref$callFunction = _ref.callFunction,
      callFunction = _ref$callFunction === undefined ? function () {} : _ref$callFunction,
      _ref$errorFunction = _ref.errorFunction,
      errorFunction = _ref$errorFunction === undefined ? function () {} : _ref$errorFunction,
      _ref$interval = _ref.interval,
      interval = _ref$interval === undefined ? 1000 : _ref$interval;

  var innerFunction = function innerFunction() {
    try {
      callFunction();
    } catch (e) {
      errorFunction(e);
    }

    setTimeout(function () {
      if (conditionFucntion()) {
        return innerFunction();
      }
    }, interval);
  };

  return innerFunction();
};

/* harmony default export */ __webpack_exports__["a"] = (longPolling);

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FullWidthImageSection":"FullWidthImageSection__FullWidthImageSection___38OcS","DarkTheme":"FullWidthImageSection__DarkTheme___1qgqp","GreyThemeFloating":"FullWidthImageSection__GreyThemeFloating___1s6vC","FullWidthImageSectionContent":"FullWidthImageSection__FullWidthImageSectionContent___3Psvt","FullWidth":"FullWidthImageSection__FullWidth___c5MdT","FullWidthLeftORRight":"FullWidthImageSection__FullWidthLeftORRight___3u5Ls","ChildrenSection":"FullWidthImageSection__ChildrenSection___3b7F1","ChildrenSectionCenter":"FullWidthImageSection__ChildrenSectionCenter___kEECb","FullWidthImageSectionInside":"FullWidthImageSection__FullWidthImageSectionInside___1ziHH","FullWidthImageSectionAsset":"FullWidthImageSection__FullWidthImageSectionAsset___1mfl7","FloatingAsset":"FullWidthImageSection__FloatingAsset___1voGe"};

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GetInTouch":"GetInTouch__GetInTouch___xJULs","GetInTouchForm":"GetInTouch__GetInTouchForm___17Laa"};

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TOPICS = [{
  value: "1",
  label: "Recalls",
  slug: "recalls"
}, {
  value: "2",
  label: "Warranty",
  slug: "warranty"
}, {
  value: "3",
  label: "Infotainment & maps",
  slug: "infotainment-maps"
}, {
  value: "4",
  label: "Servicing",
  slug: "servicing"
}, {
  value: "5",
  label: "Updating my personal details",
  slug: "updating-my-personal-details"
}, {
  value: "6",
  label: "Changing my ownership status",
  slug: "changing-my-ownership-status"
}, {
  value: "8",
  label: "MyMazda",
  slug: "mymazda"
}, {
  value: "7",
  label: "Other",
  slug: "other"
}];

/* harmony default export */ __webpack_exports__["a"] = (TOPICS);

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TITLES = "Mr|Mrs|Ms|Miss|Dr|Master|Prof".split("|").map(function (label) {
  return {
    label: label,
    value: label
  };
});

/* harmony default export */ __webpack_exports__["a"] = (TITLES);

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GradePicker":"GradePicker__GradePicker___26mzv","TabsContainer":"GradePicker__TabsContainer___3cUxR","GradePickerTwoTabs":"GradePicker__GradePickerTwoTabs___YWTbj","Span":"GradePicker__Span___1BD4R","PostcodePrompt":"GradePicker__PostcodePrompt___GZouU","GradePickerUL":"GradePicker__GradePickerUL___1SELZ","GradePickerLI":"GradePicker__GradePickerLI___1-m0l","Link":"GradePicker__Link___3RbAy","LinkLine":"GradePicker__LinkLine___1PoTQ","LinkActive":"GradePicker__LinkActive___2D_74","Divider":"GradePicker__Divider____DC1-","ThirdTab":"GradePicker__ThirdTab___TjL8D","ThirdTabImage":"GradePicker__ThirdTabImage___mbHFr","ImageFeaturesParent":"GradePicker__ImageFeaturesParent___3pfJj","ImageFeatures":"GradePicker__ImageFeatures___Zwwho","Image":"GradePicker__Image___3ibEc","Features":"GradePicker__Features___YXH5a","Price":"GradePicker__Price___c0tac","FeatureSingle":"GradePicker__FeatureSingle___2aaJZ","FeatureLine":"GradePicker__FeatureLine___2hRDL","Buttons":"GradePicker__Buttons___1Pvk9"};

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Hero":"Hero__Hero___3SbxE","HeroInside":"Hero__HeroInside___23jsD","HeroContent":"Hero__HeroContent___1Tbx2","Bottom":"Hero__Bottom___2IL3J","ColumnIn":"Hero__ColumnIn___324Yz","ZoomZoom":"Hero__ZoomZoom___3M7JM","Center":"Hero__Center___A44FB","Slug":"Hero__Slug___36xUr"};

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"HeroContent":"HeroContent__HeroContent___3NjVg","HeroContentImageContainer":"HeroContent__HeroContentImageContainer___3p3f2","HeroContentImage":"HeroContent__HeroContentImage___1qc9H","HeroContentIcon":"HeroContent__HeroContentIcon___1OAKa","HeroContentIconRed":"HeroContent__HeroContentIconRed___3tr6B","ContentArea":"HeroContent__ContentArea___jZisz","Left":"HeroContent__Left___1KevN","Right":"HeroContent__Right___2JSnY","ContentAreaHeading":"HeroContent__ContentAreaHeading___3GDrL","White":"HeroContent__White___2_QOf","ContentAreaContent":"HeroContent__ContentAreaContent___btYtZ","Details":"HeroContent__Details___2Ji7G"};

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ImageContainer":"Image__ImageContainer___svIcL","ImageContainerIE":"Image__ImageContainerIE___1p3h3","ImageContainerContain":"Image__ImageContainerContain___3iPNP","ImageContainerLoading":"Image__ImageContainerLoading___1qaUK","ImageContainerLight":"Image__ImageContainerLight___S3Q1H","ImageContainerDark":"Image__ImageContainerDark___2BI2-","LoadingLayer":"Image__LoadingLayer___1Zgxl","LoadingIcon":"Image__LoadingIcon___1_gJp"};

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Image360":"Image360__Image360___12QaF"};

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Library Documentation
// https://aframe.io/docs/0.9.0/introduction/



var aframe = function aframe() {
  var _this = this;

  _classCallCheck(this, aframe);

  this._init = function () {
    if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document && !__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].aframe) {
      __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].aframe = true;
      var script = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document.createElement("script");
      script.src = "https://aframe.io/releases/0.8.2/aframe.min.js";
      __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document.body.appendChild(script);
      var style = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document.createElement("style");
      style.type = 'text/css';
      var css = '.a-fullscreen, .a-html { position: relative !important } .a-body { position: relative !important; overflow: initial!important; height: auto!important; width: auto!important; }';
      style.appendChild(__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document.createTextNode(css));
      __WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].document.body.appendChild(style);
    }
  };

  this.loadAframe = function (_ref) {
    var callback = _ref.callback;

    if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].AFRAME) {
      if (callback) {
        setTimeout(function () {
          callback();
        }, 200);
      }
    } else {
      setTimeout(function () {
        _this.loadAframe({
          callback: callback
        });
      }, 200);
    }
  };

  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["i" /* WINDOW */].AFRAME) {
    this._init();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (aframe);

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Gallery":"Gallery__Gallery___1Quv2","GalleryItem":"Gallery__GalleryItem___2Pr_Q","GalleryModal":"Gallery__GalleryModal___3NPRf","GalleryModalBody":"Gallery__GalleryModalBody___E5jqi","GalleryModalBodyImage":"Gallery__GalleryModalBodyImage___VpzfS","GalleryModalFooter":"Gallery__GalleryModalFooter___3yWJc","GalleryModalFooterArrow":"Gallery__GalleryModalFooterArrow___3MFMo","GalleryModalFooterArrowDisabled":"Gallery__GalleryModalFooterArrowDisabled___PkiEs","GalleryModalFooterArrowLeft":"Gallery__GalleryModalFooterArrowLeft___2xtH2","GalleryModalFooterArrowRight":"Gallery__GalleryModalFooterArrowRight___1ZwG7","GalleryModalThumbnails":"Gallery__GalleryModalThumbnails___1rXu8","Thumbnail":"Gallery__Thumbnail___1YLwf","ThumbnailActive":"Gallery__ThumbnailActive___3GO3S"};

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ImagesRotator":"ImagesRotator__ImagesRotator___3BtnM","Image":"ImagesRotator__Image___2hYmU","ImageVisible":"ImagesRotator__ImageVisible___3Ofq8","Grabbed":"ImagesRotator__Grabbed___3yZjP","Center":"ImagesRotator__Center___BQxra"};

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputDate_less__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputDate_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InputDate_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_day_picker_DayPickerInput__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_day_picker_DayPickerInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_day_picker_DayPickerInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_dateHandler__ = __webpack_require__(139);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\InputDate\\InputDate.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var InputDate = function (_React$PureComponent) {
  _inherits(InputDate, _React$PureComponent);

  function InputDate(props) {
    _classCallCheck(this, InputDate);

    // for testing purposes
    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._getThisInput = function (inputThis) {
      var _this$props$getThisIn = _this.props.getThisInput,
          getThisInput = _this$props$getThisIn === undefined ? function () {} : _this$props$getThisIn;

      getThisInput(_this.inputDate);
    };

    _this._dirtyClass = function (value) {
      if (_this.label) {
        if (value && value != "") {
          _this.label.classList.add(__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.PlaceholderWithValue);
        } else {
          _this.label.classList.remove(__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.PlaceholderWithValue);
        }
      }
    };

    _this._handleOnClickOnLabel = function () {
      _this.inputDate.focus();
    };

    _this._handleDayChange = function (selectedDay, modifiers) {
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;


      _this._dirtyClass(selectedDay);
      onChange(selectedDay);

      _this.setState({
        selectedDay: selectedDay
      });
    };

    if (process && process.env && "production" === 'test') {
      _this.random = 1;
    } else {
      _this.random = Math.random();
    }
    _this.state = {
      selectedDay: null
    };
    _this.inputDate = null;
    return _this;
  }

  InputDate.prototype.render = function render() {
    var _classnames,
        _classnames2,
        _this2 = this,
        _classnames3,
        _classnames4,
        _classnames5,
        _classnames6;

    var _props = this.props,
        label = _props.label,
        name = _props.name,
        required = _props.required,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? "light" : _props$styleName,
        _props$isValid = _props.isValid,
        isValid = _props$isValid === undefined ? true : _props$isValid,
        _props$type = _props.type,
        type = _props$type === undefined ? 'text' : _props$type,
        focused = _props.focused,
        _props$min = _props.min,
        min = _props$min === undefined ? new Date(new Date().getTime() + 24 * 60 * 60 * 1000) : _props$min,
        message = _props.message,
        defaultValue = _props.defaultValue;
    var _state$selectedDay = this.state.selectedDay,
        selectedDay = _state$selectedDay === undefined ? defaultValue : _state$selectedDay;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.Input] = true, _classnames)),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.InputInput] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.Focused] = focused, _classnames2[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.InputInvalid] = !isValid, _classnames2[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.InputDark] = styleName === "dark", _classnames2[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.InputLight] = styleName === "light", _classnames2)),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 73
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_day_picker_DayPickerInput___default.a, {
          component: function component(props) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({}, props, {
              ref: function ref(c) {
                return _this2.inputDate = c;
              },
              name: name + "-" + _this2.random,
              type: type,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 84
              }
            }));
          },
          format: "D/M/YYYY",
          formatDate: function formatDate(date) {
            return new __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_dateHandler__["a" /* default */](date).format('0D/0M/YYYY');
          },
          value: selectedDay,
          onDayChange: this._handleDayChange,
          dayPickerProps: {
            selectedDays: selectedDay,
            disabledDays: { before: min }
          },
          placeholder: '',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 82
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        {
          ref: function ref(c) {
            return _this2.label = c;
          },
          htmlFor: name + "-" + this.random,
          onClick: this._handleOnClickOnLabel,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.Placeholder] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.PlaceholderWithValue] = false, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 102
          }
        },
        label,
        required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.requiredStar] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 112
            }
          },
          "*"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.icon] = true, _classnames5[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.iconShow] = !isValid, _classnames5)), __source: {
            fileName: _jsxFileName,
            lineNumber: 117
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["d" /* AlertIcon */], { style: { height: "1em", width: "1em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 121
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.message] = true, _classnames6[__WEBPACK_IMPORTED_MODULE_3__InputDate_less___default.a.messageShow] = !isValid, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 123
          }
        },
        message
      )
    );
  };

  return InputDate;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InputDate.displayName = "InputDate";


/* harmony default export */ __webpack_exports__["a"] = (InputDate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Focused":"InputDate__Focused___1_IO8","Input":"InputDate__Input___2tp6P","Placeholder":"InputDate__Placeholder___2Ykyv","PlaceholderWithValue":"InputDate__PlaceholderWithValue___2mW6P","InputInput":"InputDate__InputInput___22dQN","InputDark":"InputDate__InputDark___2eMj9","InputLight":"InputDate__InputLight___2YP-O","InputInvalid":"InputDate__InputInvalid___1JUE2","requiredStar":"InputDate__requiredStar___1IIf4","icon":"InputDate__icon___1uG1t","iconShow":"InputDate__iconShow___eAS9V","message":"InputDate__message___ehvTt","messageShow":"InputDate__messageShow___yhptg"};

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

/*
  Used to import DayPickerInput. e.g. `import DayPickerInput from 'react-day-picker/DayPickerInput'`
*/

/* eslint-disable no-var */
/* eslint-env node */

var DayPickerInput = __webpack_require__(1161);

module.exports = DayPickerInput;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_TIMEOUT = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.OverlayComponent = OverlayComponent;
exports.defaultFormat = defaultFormat;
exports.defaultParse = defaultParse;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DayPicker = __webpack_require__(1162);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _DateUtils = __webpack_require__(120);

var _ModifiersUtils = __webpack_require__(259);

var _keys = __webpack_require__(140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// When clicking on a day cell, overlay will be hidden after this timeout
var HIDE_TIMEOUT = exports.HIDE_TIMEOUT = 100;

/**
 * The default component used as Overlay.
 *
 * @param {Object} props
 */
function OverlayComponent(_ref) {
  var input = _ref.input,
      selectedDay = _ref.selectedDay,
      month = _ref.month,
      children = _ref.children,
      classNames = _ref.classNames,
      props = _objectWithoutProperties(_ref, ['input', 'selectedDay', 'month', 'children', 'classNames']);

  return _react2.default.createElement(
    'div',
    _extends({ className: classNames.overlayWrapper }, props),
    _react2.default.createElement(
      'div',
      { className: classNames.overlay },
      children
    )
  );
}

OverlayComponent.propTypes =  false ? {
  input: _propTypes2.default.any,
  selectedDay: _propTypes2.default.any,
  month: _propTypes2.default.instanceOf(Date),
  children: _propTypes2.default.node,
  classNames: _propTypes2.default.object
} : {};

/**
 * The default function used to format a Date to String, passed to the `format`
 * prop.
 * @param {Date} d
 * @return {String}
 */
function defaultFormat(d) {
  if ((0, _DateUtils.isDate)(d)) {
    var year = d.getFullYear();
    var month = '' + (d.getMonth() + 1);
    var day = '' + d.getDate();
    return year + '-' + month + '-' + day;
  }
  return '';
}

/**
 * The default function used to parse a String as Date, passed to the `parse`
 * prop.
 * @param {String} str
 * @return {Date}
 */
function defaultParse(str) {
  if (typeof str !== 'string') {
    return undefined;
  }
  var split = str.split('-');
  if (split.length !== 3) {
    return undefined;
  }
  var year = parseInt(split[0], 10);
  var month = parseInt(split[1], 10) - 1;
  var day = parseInt(split[2], 10);
  if (isNaN(year) || String(year).length > 4 || isNaN(month) || isNaN(day) || day <= 0 || day > 31 || month < 0 || month >= 12) {
    return undefined;
  }

  return new Date(year, month, day);
}

var DayPickerInput = function (_React$Component) {
  _inherits(DayPickerInput, _React$Component);

  function DayPickerInput(props) {
    _classCallCheck(this, DayPickerInput);

    var _this = _possibleConstructorReturn(this, (DayPickerInput.__proto__ || Object.getPrototypeOf(DayPickerInput)).call(this, props));

    _this.input = null;
    _this.daypicker = null;
    _this.clickTimeout = null;
    _this.hideTimeout = null;
    _this.inputBlurTimeout = null;
    _this.inputFocusTimeout = null;


    _this.state = _this.getInitialStateFromProps(props);
    _this.state.showOverlay = props.showOverlay;

    _this.hideAfterDayClick = _this.hideAfterDayClick.bind(_this);
    _this.handleInputClick = _this.handleInputClick.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
    _this.handleInputKeyUp = _this.handleInputKeyUp.bind(_this);
    _this.handleDayClick = _this.handleDayClick.bind(_this);
    _this.handleMonthChange = _this.handleMonthChange.bind(_this);
    _this.handleOverlayFocus = _this.handleOverlayFocus.bind(_this);
    _this.handleOverlayBlur = _this.handleOverlayBlur.bind(_this);
    return _this;
  }

  _createClass(DayPickerInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var newState = {};

      // Current props
      var _props = this.props,
          value = _props.value,
          formatDate = _props.formatDate,
          format = _props.format,
          dayPickerProps = _props.dayPickerProps;

      // Update the input value if the `value` prop has changed

      if (value !== prevProps.value) {
        if ((0, _DateUtils.isDate)(value)) {
          newState.value = formatDate(value, format, dayPickerProps.locale);
        } else {
          newState.value = value;
        }
      }

      // Update the month if the months from props changed
      var prevMonth = prevProps.dayPickerProps.month;
      if (dayPickerProps.month && dayPickerProps.month !== prevMonth && !(0, _DateUtils.isSameMonth)(dayPickerProps.month, prevMonth)) {
        newState.month = dayPickerProps.month;
      }

      // Updated the selected days from props if they changed
      if (prevProps.dayPickerProps.selectedDays !== dayPickerProps.selectedDays) {
        newState.selectedDays = dayPickerProps.selectedDays;
      }

      if (Object.keys(newState).length > 0) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState(newState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.clickTimeout);
      clearTimeout(this.hideTimeout);
      clearTimeout(this.inputFocusTimeout);
      clearTimeout(this.inputBlurTimeout);
      clearTimeout(this.overlayBlurTimeout);
    }
  }, {
    key: 'getInitialMonthFromProps',
    value: function getInitialMonthFromProps(props) {
      var dayPickerProps = props.dayPickerProps,
          format = props.format;

      var day = void 0;
      if (props.value) {
        if ((0, _DateUtils.isDate)(props.value)) {
          day = props.value;
        } else {
          day = props.parseDate(props.value, format, dayPickerProps.locale);
        }
      }
      return dayPickerProps.initialMonth || dayPickerProps.month || day || new Date();
    }
  }, {
    key: 'getInitialStateFromProps',
    value: function getInitialStateFromProps(props) {
      var dayPickerProps = props.dayPickerProps,
          formatDate = props.formatDate,
          format = props.format;
      var value = props.value;

      if (props.value && (0, _DateUtils.isDate)(props.value)) {
        value = formatDate(props.value, format, dayPickerProps.locale);
      }
      return {
        value: value,
        month: this.getInitialMonthFromProps(props),
        selectedDays: dayPickerProps.selectedDays
      };
    }
  }, {
    key: 'getInput',
    value: function getInput() {
      return this.input;
    }
  }, {
    key: 'getDayPicker',
    value: function getDayPicker() {
      return this.daypicker;
    }

    /**
     * Update the component's state and fire the `onDayChange` event passing the
     * day's modifiers to it.
     *
     * @param {Date} day - Will be used for changing the month
     * @param {String} value - Input field value
     * @private
     */

  }, {
    key: 'updateState',
    value: function updateState(day, value, callback) {
      var _this2 = this;

      var _props2 = this.props,
          dayPickerProps = _props2.dayPickerProps,
          onDayChange = _props2.onDayChange;

      this.setState({ month: day, value: value, typedValue: undefined }, function () {
        if (callback) {
          callback();
        }
        if (!onDayChange) {
          return;
        }
        var modifiersObj = _extends({
          disabled: dayPickerProps.disabledDays,
          selected: dayPickerProps.selectedDays
        }, dayPickerProps.modifiers);
        var modifiers = (0, _ModifiersUtils.getModifiersForDay)(day, modifiersObj).reduce(function (obj, modifier) {
          return _extends({}, obj, _defineProperty({}, modifier, true));
        }, {});
        onDayChange(day, modifiers, _this2);
      });
    }

    /**
     * Show the Day Picker overlay.
     *
     * @memberof DayPickerInput
     */

  }, {
    key: 'showDayPicker',
    value: function showDayPicker() {
      var _props3 = this.props,
          parseDate = _props3.parseDate,
          format = _props3.format,
          dayPickerProps = _props3.dayPickerProps;
      var _state = this.state,
          value = _state.value,
          showOverlay = _state.showOverlay;

      if (showOverlay) {
        return;
      }
      // Reset the current displayed month when showing the overlay
      var month = value ? parseDate(value, format, dayPickerProps.locale) // Use the month in the input field
      : this.getInitialMonthFromProps(this.props); // Restore the month from the props
      this.setState(function (state) {
        return {
          showOverlay: true,
          month: month || state.month
        };
      });
    }

    /**
     * Hide the Day Picker overlay
     *
     * @memberof DayPickerInput
     */

  }, {
    key: 'hideDayPicker',
    value: function hideDayPicker() {
      var _this3 = this;

      if (this.state.showOverlay === false) {
        return;
      }
      this.setState({ showOverlay: false }, function () {
        if (_this3.props.onDayPickerHide) _this3.props.onDayPickerHide();
      });
    }
  }, {
    key: 'hideAfterDayClick',
    value: function hideAfterDayClick() {
      var _this4 = this;

      if (!this.props.hideOnDayClick) {
        return;
      }
      this.hideTimeout = setTimeout(function () {
        return _this4.hideDayPicker();
      }, HIDE_TIMEOUT);
    }
  }, {
    key: 'handleInputClick',
    value: function handleInputClick(e) {
      this.showDayPicker();
      if (this.props.inputProps.onClick) {
        e.persist();
        this.props.inputProps.onClick(e);
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus(e) {
      var _this5 = this;

      this.showDayPicker();
      // Set `overlayHasFocus` after a timeout so the overlay can be hidden when
      // the input is blurred
      this.inputFocusTimeout = setTimeout(function () {
        _this5.overlayHasFocus = false;
      }, 2);
      if (this.props.inputProps.onFocus) {
        e.persist();
        this.props.inputProps.onFocus(e);
      }
    }

    // When the input is blurred, the overlay should disappear. However the input
    // is blurred also when the user interacts with the overlay (e.g. the overlay
    // get the focus by clicking it). In these cases, the overlay should not be
    // hidden. There are different approaches to avoid hiding the overlay when
    // this happens, but the only cross-browser hack we’ve found is to set all
    // these timeouts in code before changing `overlayHasFocus`.

  }, {
    key: 'handleInputBlur',
    value: function handleInputBlur(e) {
      var _this6 = this;

      this.inputBlurTimeout = setTimeout(function () {
        if (!_this6.overlayHasFocus) {
          _this6.hideDayPicker();
        }
      }, 1);
      if (this.props.inputProps.onBlur) {
        e.persist();
        this.props.inputProps.onBlur(e);
      }
    }
  }, {
    key: 'handleOverlayFocus',
    value: function handleOverlayFocus(e) {
      e.preventDefault();
      this.overlayHasFocus = true;
      if (!this.props.keepFocus || !this.input || typeof this.input.focus !== 'function') {
        return;
      }
      this.input.focus();
    }
  }, {
    key: 'handleOverlayBlur',
    value: function handleOverlayBlur() {
      var _this7 = this;

      // We need to set a timeout otherwise IE11 will hide the overlay when
      // focusing it
      this.overlayBlurTimeout = setTimeout(function () {
        _this7.overlayHasFocus = false;
      }, 3);
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      var _props4 = this.props,
          dayPickerProps = _props4.dayPickerProps,
          format = _props4.format,
          inputProps = _props4.inputProps,
          onDayChange = _props4.onDayChange,
          parseDate = _props4.parseDate;

      if (inputProps.onChange) {
        e.persist();
        inputProps.onChange(e);
      }
      var value = e.target.value;

      if (value.trim() === '') {
        this.setState({ value: value, typedValue: undefined });
        if (onDayChange) onDayChange(undefined, {}, this);
        return;
      }
      var day = parseDate(value, format, dayPickerProps.locale);
      if (!day) {
        // Day is invalid: we save the value in the typedValue state
        this.setState({ value: value, typedValue: value });
        if (onDayChange) onDayChange(undefined, {}, this);
        return;
      }
      this.updateState(day, value);
    }
  }, {
    key: 'handleInputKeyDown',
    value: function handleInputKeyDown(e) {
      if (e.keyCode === _keys.TAB) {
        this.hideDayPicker();
      } else {
        this.showDayPicker();
      }
      if (this.props.inputProps.onKeyDown) {
        e.persist();
        this.props.inputProps.onKeyDown(e);
      }
    }
  }, {
    key: 'handleInputKeyUp',
    value: function handleInputKeyUp(e) {
      if (e.keyCode === _keys.ESC) {
        this.hideDayPicker();
      } else {
        this.showDayPicker();
      }
      if (this.props.inputProps.onKeyUp) {
        e.persist();
        this.props.inputProps.onKeyUp(e);
      }
    }
  }, {
    key: 'handleMonthChange',
    value: function handleMonthChange(month) {
      var _this8 = this;

      this.setState({ month: month }, function () {
        if (_this8.props.dayPickerProps && _this8.props.dayPickerProps.onMonthChange) {
          _this8.props.dayPickerProps.onMonthChange(month);
        }
      });
    }
  }, {
    key: 'handleDayClick',
    value: function handleDayClick(day, modifiers, e) {
      var _this9 = this;

      var _props5 = this.props,
          clickUnselectsDay = _props5.clickUnselectsDay,
          dayPickerProps = _props5.dayPickerProps,
          onDayChange = _props5.onDayChange,
          formatDate = _props5.formatDate,
          format = _props5.format;

      if (dayPickerProps.onDayClick) {
        dayPickerProps.onDayClick(day, modifiers, e);
      }

      // Do nothing if the day is disabled
      if (modifiers.disabled || dayPickerProps && dayPickerProps.classNames && modifiers[dayPickerProps.classNames.disabled]) {
        return;
      }

      // If the clicked day is already selected, remove the clicked day
      // from the selected days and empty the field value
      if (modifiers.selected && clickUnselectsDay) {
        var selectedDays = this.state.selectedDays;

        if (Array.isArray(selectedDays)) {
          selectedDays = selectedDays.slice(0);
          var selectedDayIdx = selectedDays.indexOf(day);
          selectedDays.splice(selectedDayIdx, 1);
        } else if (selectedDays) {
          selectedDays = null;
        }
        this.setState({ value: '', typedValue: undefined, selectedDays: selectedDays }, this.hideAfterDayClick);
        if (onDayChange) {
          onDayChange(undefined, modifiers, this);
        }
        return;
      }

      var value = formatDate(day, format, dayPickerProps.locale);
      this.setState({ value: value, typedValue: undefined, month: day }, function () {
        if (onDayChange) {
          onDayChange(day, modifiers, _this9);
        }
        _this9.hideAfterDayClick();
      });
    }
  }, {
    key: 'renderOverlay',
    value: function renderOverlay() {
      var _this10 = this;

      var _props6 = this.props,
          classNames = _props6.classNames,
          dayPickerProps = _props6.dayPickerProps,
          parseDate = _props6.parseDate,
          formatDate = _props6.formatDate,
          format = _props6.format;
      var _state2 = this.state,
          selectedDays = _state2.selectedDays,
          value = _state2.value;

      var selectedDay = void 0;
      if (!selectedDays && value) {
        var day = parseDate(value, format, dayPickerProps.locale);
        if (day) {
          selectedDay = day;
        }
      } else if (selectedDays) {
        selectedDay = selectedDays;
      }
      var onTodayButtonClick = void 0;
      if (dayPickerProps.todayButton) {
        // Set the current day when clicking the today button
        onTodayButtonClick = function onTodayButtonClick() {
          return _this10.updateState(new Date(), formatDate(new Date(), format, dayPickerProps.locale), _this10.hideAfterDayClick);
        };
      }
      var Overlay = this.props.overlayComponent;
      return _react2.default.createElement(
        Overlay,
        {
          classNames: classNames,
          month: this.state.month,
          selectedDay: selectedDay,
          input: this.input,
          tabIndex: 0 // tabIndex is necessary to catch focus/blur events on Safari
          , onFocus: this.handleOverlayFocus,
          onBlur: this.handleOverlayBlur
        },
        _react2.default.createElement(_DayPicker2.default, _extends({
          ref: function ref(el) {
            return _this10.daypicker = el;
          },
          onTodayButtonClick: onTodayButtonClick
        }, dayPickerProps, {
          month: this.state.month,
          selectedDays: selectedDay,
          onDayClick: this.handleDayClick,
          onMonthChange: this.handleMonthChange
        }))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this11 = this;

      var Input = this.props.component;
      var inputProps = this.props.inputProps;

      return _react2.default.createElement(
        'div',
        { className: this.props.classNames.container },
        _react2.default.createElement(Input, _extends({
          ref: function ref(el) {
            return _this11.input = el;
          },
          placeholder: this.props.placeholder
        }, inputProps, {
          value: this.state.typedValue || this.state.value,
          onChange: this.handleInputChange,
          onFocus: this.handleInputFocus,
          onBlur: this.handleInputBlur,
          onKeyDown: this.handleInputKeyDown,
          onKeyUp: this.handleInputKeyUp,
          onClick: !inputProps.disabled ? this.handleInputClick : undefined
        })),
        this.state.showOverlay && this.renderOverlay()
      );
    }
  }]);

  return DayPickerInput;
}(_react2.default.Component);

DayPickerInput.defaultProps = {
  dayPickerProps: {},
  value: '',
  placeholder: 'YYYY-M-D',
  format: 'L',
  formatDate: defaultFormat,
  parseDate: defaultParse,
  showOverlay: false,
  hideOnDayClick: true,
  clickUnselectsDay: false,
  keepFocus: true,
  component: 'input',
  inputProps: {},
  overlayComponent: OverlayComponent,
  classNames: {
    container: 'DayPickerInput',
    overlayWrapper: 'DayPickerInput-OverlayWrapper',
    overlay: 'DayPickerInput-Overlay'
  }
};
exports.default = DayPickerInput;
DayPickerInput.propTypes =  false ? {
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
  inputProps: _propTypes2.default.object,
  placeholder: _propTypes2.default.string,

  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

  formatDate: _propTypes2.default.func,
  parseDate: _propTypes2.default.func,

  showOverlay: _propTypes2.default.bool,
  dayPickerProps: _propTypes2.default.object,
  hideOnDayClick: _propTypes2.default.bool,
  clickUnselectsDay: _propTypes2.default.bool,
  keepFocus: _propTypes2.default.bool,
  component: _propTypes2.default.any,
  overlayComponent: _propTypes2.default.any,

  classNames: _propTypes2.default.shape({
    container: _propTypes2.default.string,
    overlayWrapper: _propTypes2.default.string,
    overlay: _propTypes2.default.string.isRequired
  }),

  onDayChange: _propTypes2.default.func,
  onDayPickerHide: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func
} : {};
//# sourceMappingURL=DayPickerInput.js.map

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Caption = __webpack_require__(1163);

var _Caption2 = _interopRequireDefault(_Caption);

var _Navbar = __webpack_require__(1164);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Month = __webpack_require__(1165);

var _Month2 = _interopRequireDefault(_Month);

var _Weekday = __webpack_require__(1168);

var _Weekday2 = _interopRequireDefault(_Weekday);

var _Helpers = __webpack_require__(182);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(120);

var DateUtils = _interopRequireWildcard(_DateUtils);

var _LocaleUtils = __webpack_require__(258);

var LocaleUtils = _interopRequireWildcard(_LocaleUtils);

var _ModifiersUtils = __webpack_require__(259);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _classNames = __webpack_require__(181);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(140);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayPicker = exports.DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.dayPicker = null;

    _this.showNextMonth = function (callback) {
      if (!_this.allowNextMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var nextMonth = DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
      _this.showMonth(nextMonth, callback);
    };

    _this.showPreviousMonth = function (callback) {
      if (!_this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var previousMonth = DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
      _this.showMonth(previousMonth, callback);
    };

    _this.handleKeyDown = function (e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          _this.showPreviousMonth();
          break;
        case _keys.RIGHT:
          _this.showNextMonth();
          break;
        case _keys.UP:
          _this.showPreviousYear();
          break;
        case _keys.DOWN:
          _this.showNextYear();
          break;
        default:
          break;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleDayKeyDown = function (day, modifiers, e) {
      e.persist();
      switch (e.keyCode) {
        case _keys.LEFT:
          Helpers.cancelEvent(e);
          _this.focusPreviousDay(e.target);
          break;
        case _keys.RIGHT:
          Helpers.cancelEvent(e);
          _this.focusNextDay(e.target);
          break;
        case _keys.UP:
          Helpers.cancelEvent(e);
          _this.focusPreviousWeek(e.target);
          break;
        case _keys.DOWN:
          Helpers.cancelEvent(e);
          _this.focusNextWeek(e.target);
          break;
        case _keys.ENTER:
        case _keys.SPACE:
          Helpers.cancelEvent(e);
          if (_this.props.onDayClick) {
            _this.handleDayClick(day, modifiers, e);
          }
          break;
        default:
          break;
      }
      if (_this.props.onDayKeyDown) {
        _this.props.onDayKeyDown(day, modifiers, e);
      }
    };

    _this.handleDayClick = function (day, modifiers, e) {
      e.persist();

      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
        _this.handleOutsideDayClick(day);
      }
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, modifiers, e);
      }
    };

    _this.handleTodayButtonClick = function (e) {
      var today = new Date();
      var month = new Date(today.getFullYear(), today.getMonth());
      _this.showMonth(month);
      e.target.blur();
      if (_this.props.onTodayButtonClick) {
        e.persist();
        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
      }
    };

    var currentMonth = _this.getCurrentMonthFromProps(props);
    _this.state = { currentMonth: currentMonth };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Changing the `month` props means changing the current displayed month
      if (prevProps.month !== this.props.month && !DateUtils.isSameMonth(prevProps.month, this.props.month)) {
        var currentMonth = this.getCurrentMonthFromProps(this.props);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ currentMonth: currentMonth });
      }
    }

    /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */

  }, {
    key: 'getCurrentMonthFromProps',
    value: function getCurrentMonthFromProps(props) {
      var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth);
      var currentMonth = initialMonth;

      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
        var fromMonth = Helpers.startOfMonth(props.fromMonth);
        var diffInMonths = Helpers.getMonthsDiff(fromMonth, currentMonth);
        currentMonth = DateUtils.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
        currentMonth = DateUtils.addMonths(Helpers.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
      }
      return currentMonth;
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        month: this.state.currentMonth,
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);
      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils.addMonths(this.state.currentMonth, i);
        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.props.todayButton) {
        return _react2.default.createElement(
          'div',
          { className: this.props.classNames.footer },
          this.renderTodayButton()
        );
      }
      return null;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          tabIndex: 0,
          className: this.props.classNames.todayButton,
          'aria-label': this.props.todayButton,
          onClick: this.handleTodayButtonClick
        },
        this.props.todayButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement(
        'div',
        _extends({}, this.props.containerProps, {
          className: className,
          ref: function ref(el) {
            return _this7.dayPicker = el;
          },
          lang: this.props.locale
        }),
        _react2.default.createElement(
          'div',
          {
            className: this.props.classNames.wrapper,
            tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
            onKeyDown: this.handleKeyDown,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur
          },
          this.renderNavbar(),
          _react2.default.createElement(
            'div',
            { className: this.props.classNames.months },
            this.renderMonths()
          ),
          this.renderFooter()
        )
      );
    }
  }]);

  return DayPicker;
}(_react.Component);

DayPicker.VERSION = '7.2.4';
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  initialMonth: new Date(),
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils,
  showOutsideDays: false,
  enableOutsideDaysClick: true,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  showWeekDays: true,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  renderWeek: function renderWeek(weekNumber) {
    return weekNumber;
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};
DayPicker.propTypes =  false ? {
  // Rendering months
  initialMonth: _propTypes2.default.instanceOf(Date),
  month: _propTypes2.default.instanceOf(Date),
  numberOfMonths: _propTypes2.default.number,
  fromMonth: _propTypes2.default.instanceOf(Date),
  toMonth: _propTypes2.default.instanceOf(Date),
  canChangeMonth: _propTypes2.default.bool,
  reverseMonths: _propTypes2.default.bool,
  pagedNavigation: _propTypes2.default.bool,
  todayButton: _propTypes2.default.string,
  showWeekNumbers: _propTypes2.default.bool,
  showWeekDays: _propTypes2.default.bool,

  // Modifiers
  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),

  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,

  // Localization
  dir: _propTypes2.default.string,
  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _propTypes2.default.shape({
    nextMonth: _propTypes2.default.string.isRequired,
    previousMonth: _propTypes2.default.string.isRequired
  }),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Customization
  showOutsideDays: _propTypes2.default.bool,
  enableOutsideDaysClick: _propTypes2.default.bool,
  fixedWeeks: _propTypes2.default.bool,

  // CSS and HTML
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string,
    container: _propTypes2.default.string,
    day: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    footer: _propTypes2.default.string,
    interactionDisabled: _propTypes2.default.string,
    months: _propTypes2.default.string,
    month: _propTypes2.default.string,
    navBar: _propTypes2.default.string,
    outside: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    todayButton: _propTypes2.default.string,
    week: _propTypes2.default.string,
    wrapper: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  containerProps: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,

  // Custom elements
  renderDay: _propTypes2.default.func,
  renderWeek: _propTypes2.default.func,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),

  // Events
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onCaptionClick: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func,
  onTodayButtonClick: _propTypes2.default.func
} : {};


DayPicker.DateUtils = DateUtils;
DayPicker.LocaleUtils = LocaleUtils;
DayPicker.ModifiersUtils = ModifiersUtils;

exports.DateUtils = DateUtils;
exports.LocaleUtils = LocaleUtils;
exports.ModifiersUtils = ModifiersUtils;
exports.default = DayPicker;
//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LocaleUtils = __webpack_require__(258);

var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);

var _keys = __webpack_require__(140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption(props) {
    _classCallCheck(this, Caption);

    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === _keys.ENTER) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement(
        'div',
        { className: classNames.caption, role: 'heading' },
        _react2.default.createElement(
          'div',
          { onClick: onClick, onKeyUp: this.handleKeyUp },
          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
        )
      );
    }
  }]);

  return Caption;
}(_react.Component);

Caption.defaultProps = {
  localeUtils: _LocaleUtils2.default
};
exports.default = Caption;
Caption.propTypes =  false ? {
  date: _propTypes2.default.instanceOf(Date),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired
  }).isRequired
} : {};
//# sourceMappingURL=Caption.js.map

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classNames = __webpack_require__(181);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;


      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement(
        'div',
        { className: className || classNames.navBar },
        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
      );
    }
  }]);

  return Navbar;
}(_react.Component);

Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;
Navbar.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    navBar: _propTypes2.default.string.isRequired,
    navButtonPrev: _propTypes2.default.string.isRequired,
    navButtonNext: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  showPreviousButton: _propTypes2.default.bool,
  showNextButton: _propTypes2.default.bool,
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  dir: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    previousMonth: _propTypes2.default.string.isRequired,
    nextMonth: _propTypes2.default.string.isRequired
  })
} : {};
//# sourceMappingURL=Navbar.js.map

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Weekdays = __webpack_require__(1166);

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _Day = __webpack_require__(1167);

var _Day2 = _interopRequireDefault(_Day);

var _keys = __webpack_require__(140);

var _ModifiersUtils = __webpack_require__(259);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _Helpers = __webpack_require__(182);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(120);

var DateUtils = _interopRequireWildcard(_DateUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(
        _Day2.default,
        {
          key: '' + (isOutside ? 'outside-' : '') + key,
          classNames: _this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: _this.props.modifiersStyles,
          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
          ariaSelected: dayModifiers.indexOf('selected') > -1,
          onClick: _this.props.onDayClick,
          onFocus: _this.props.onDayFocus,
          onKeyDown: _this.props.onDayKeyDown,
          onMouseEnter: _this.props.onDayMouseEnter,
          onMouseLeave: _this.props.onDayMouseLeave,
          onMouseDown: _this.props.onDayMouseDown,
          onMouseUp: _this.props.onDayMouseUp,
          onTouchEnd: _this.props.onDayTouchEnd,
          onTouchStart: _this.props.onDayTouchStart
        },
        _this.props.renderDay(day, modifiers)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          showWeekNumbers = _props.showWeekNumbers,
          showWeekDays = _props.showWeekDays,
          onWeekClick = _props.onWeekClick;


      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
      return _react2.default.createElement(
        'div',
        { className: classNames.month, role: 'grid' },
        caption,
        showWeekDays && _react2.default.createElement(_Weekdays2.default, {
          classNames: classNames,
          weekdaysShort: weekdaysShort,
          weekdaysLong: weekdaysLong,
          firstDayOfWeek: firstDayOfWeek,
          showWeekNumbers: showWeekNumbers,
          locale: locale,
          localeUtils: localeUtils,
          weekdayElement: weekdayElement
        }),
        _react2.default.createElement(
          'div',
          { className: classNames.body, role: 'rowgroup' },
          weeks.map(function (week) {
            var weekNumber = void 0;
            if (showWeekNumbers) {
              weekNumber = DateUtils.getWeekNumber(week[6]);
            }
            return _react2.default.createElement(
              'div',
              {
                key: week[0].getTime(),
                className: classNames.week,
                role: 'row'
              },
              showWeekNumbers && _react2.default.createElement(
                'div',
                {
                  className: classNames.weekNumber,
                  tabIndex: 0,
                  role: 'gridcell',
                  onClick: onWeekClick ? function (e) {
                    return onWeekClick(weekNumber, week, e);
                  } : undefined,
                  onKeyUp: onWeekClick ? function (e) {
                    return e.keyCode === _keys.ENTER && onWeekClick(weekNumber, week, e);
                  } : undefined
                },
                _this2.props.renderWeek(weekNumber, week, month)
              ),
              week.map(_this2.renderDay)
            );
          })
        )
      );
    }
  }]);

  return Month;
}(_react.Component);

exports.default = Month;
Month.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    month: _propTypes2.default.string.isRequired,
    outside: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    week: _propTypes2.default.string.isRequired
  }).isRequired,
  tabIndex: _propTypes2.default.number,

  month: _propTypes2.default.instanceOf(Date).isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),

  modifiersStyles: _propTypes2.default.object,

  showWeekDays: _propTypes2.default.bool,
  showOutsideDays: _propTypes2.default.bool,

  renderDay: _propTypes2.default.func.isRequired,
  renderWeek: _propTypes2.default.func.isRequired,

  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),

  fixedWeeks: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,

  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  firstDayOfWeek: _propTypes2.default.number.isRequired,

  onCaptionClick: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
} : {};
//# sourceMappingURL=Month.js.map

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement(
        'div',
        { className: classNames.weekdays, role: 'rowgroup' },
        _react2.default.createElement(
          'div',
          { className: classNames.weekdaysRow, role: 'row' },
          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
          days
        )
      );
    }
  }]);

  return Weekdays;
}(_react.Component);

exports.default = Weekdays;
Weekdays.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    weekday: _propTypes2.default.string.isRequired,
    weekdays: _propTypes2.default.string.isRequired,
    weekdaysRow: _propTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _propTypes2.default.number.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showWeekNumbers: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
} : {};
//# sourceMappingURL=Weekdays.js.map

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateUtils = __webpack_require__(120);

var _Helpers = __webpack_require__(182);

var _classNames = __webpack_require__(181);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;


      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = _extends({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement(
        'div',
        {
          className: className,
          tabIndex: tabIndex,
          style: style,
          role: 'gridcell',
          'aria-label': ariaLabel,
          'aria-disabled': ariaDisabled,
          'aria-selected': ariaSelected,
          onClick: handleEvent(onClick, day, modifiers),
          onKeyDown: handleEvent(onKeyDown, day, modifiers),
          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
          onMouseUp: handleEvent(onMouseUp, day, modifiers),
          onMouseDown: handleEvent(onMouseDown, day, modifiers),
          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
          onTouchStart: handleEvent(onTouchStart, day, modifiers),
          onFocus: handleEvent(onFocus, day, modifiers)
        },
        children
      );
    }
  }]);

  return Day;
}(_react.Component);

Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;
Day.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    day: _propTypes2.default.string.isRequired
  }).isRequired,

  day: _propTypes2.default.instanceOf(Date).isRequired,
  children: _propTypes2.default.node.isRequired,

  ariaDisabled: _propTypes2.default.bool,
  ariaLabel: _propTypes2.default.string,
  ariaSelected: _propTypes2.default.bool,
  empty: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
} : {};
//# sourceMappingURL=Day.js.map

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement(
        'div',
        { className: className, role: 'columnheader' },
        _react2.default.createElement(
          'abbr',
          { title: title },
          content
        )
      );
    }
  }]);

  return Weekday;
}(_react.Component);

exports.default = Weekday;
Weekday.propTypes =  false ? {
  weekday: _propTypes2.default.number,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,

  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
} : {};
//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InteriorPicker":"InteriorPicker__InteriorPicker___2mg1I","InteriorPickerContainer":"InteriorPicker__InteriorPickerContainer___2mmqc","TabsInside":"InteriorPicker__TabsInside___sEM-g","InteriorPickerIcon":"InteriorPicker__InteriorPickerIcon___rLENQ","InteriorPickerTooltip":"InteriorPicker__InteriorPickerTooltip___3PUNX","InteriorPickerIconInside":"InteriorPicker__InteriorPickerIconInside___2yKtJ","InteriorPickerIconActive":"InteriorPicker__InteriorPickerIconActive___12Af-","InteriorPickerIconCheckIcon":"InteriorPicker__InteriorPickerIconCheckIcon___38xu7","InteriorPickerImage":"InteriorPicker__InteriorPickerImage___3pRPX","InteriorPickerDisclaimer":"InteriorPicker__InteriorPickerDisclaimer___2lqS2","InteriorPickerNameForTablet":"InteriorPicker__InteriorPickerNameForTablet___2919Q","InteriorPickerDisclaimer360":"InteriorPicker__InteriorPickerDisclaimer360___51iHK","InteriorPickerDisclaimer360Text":"InteriorPicker__InteriorPickerDisclaimer360Text___EbhLk","InteriorPickerDisclaimer360TextIcon":"InteriorPicker__InteriorPickerDisclaimer360TextIcon___2pCLO"};

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaChangeEmail_less__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaChangeEmail_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MyMazdaChangeEmail_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__ = __webpack_require__(30);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaChangeEmail\\MyMazdaChangeEmail.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var MyMazdaChangeEmail = function (_React$Component) {
  _inherits(MyMazdaChangeEmail, _React$Component);

  function MyMazdaChangeEmail(props) {
    var _this2 = this;

    _classCallCheck(this, MyMazdaChangeEmail);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var changeEmailEndpoint, form;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          changeEmailEndpoint = _this.props.changeEmailEndpoint;
                          form = _this.state.form;
                          _context2.next = 4;
                          return Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: changeEmailEndpoint,
                            body: {
                              email: _this.props.newEmail,
                              password: form.password.value
                            }
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "MyMazda Change email Form",
                                            pageAction: "MyMazda Change email Form - Confirm"
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      form: {
        password: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].PASSWORD_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  MyMazdaChangeEmail.prototype.render = function render() {
    var _classnames3, _classnames4;

    var _props = this.props,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Login" : _props$buttonText,
        heading = _props.heading,
        successHeading = _props.successHeading,
        submitInstructionsText = _props.submitInstructionsText,
        changeEmailSuccessMessage = _props.changeEmailSuccessMessage,
        continueButtonText = _props.continueButtonText,
        newEmail = _props.newEmail;
    var _state = this.state,
        loading = _state.loading,
        success = _state.success,
        errorMessage = _state.errorMessage,
        redirectUrl = _state.data;


    if (success) {
      var _classnames, _classnames2;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__MyMazdaChangeEmail_less___default.a.MyMazdaChangeEmail] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 91
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__MyMazdaChangeEmail_less___default.a.MyMazdaChangeEmailForm] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 92
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 93
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_17" /* TickModalIcon */], { style: { width: "2.25em", height: "2.25em", margin: "0 auto" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 94
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["n" /* HeroContent */], {
              heading: successHeading || "New Email Confirmed",
              description: changeEmailSuccessMessage || "We've updated your email address. Click below to continue to MyMazda.", __source: {
                fileName: _jsxFileName,
                lineNumber: 95
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              { styleName: "black", href: redirectUrl, fullWidth: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 98
                }
              },
              continueButtonText || "Continue to MyMazda"
            )
          )
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__MyMazdaChangeEmail_less___default.a.MyMazdaChangeEmail] = true, _classnames3)), __source: {
          fileName: _jsxFileName,
          lineNumber: 108
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__MyMazdaChangeEmail_less___default.a.MyMazdaChangeEmailForm] = true, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 109
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { method: "POST", onSubmit: this._handleSubmit, __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 111
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 112
                }
              },
              heading || "Confirm your updated email"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], { replaceVariables: { newEmail: newEmail }, xmlString: submitInstructionsText, __source: {
                fileName: _jsxFileName,
                lineNumber: 113
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 115
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["O" /* InputPassword */], _extends({
              name: "password",
              label: "Password"
            }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "password"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda Confirm email Form",
                  pageAction: "MyMazda Confirm email Form - Entered \"PASSWORD\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 116
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 128
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 129
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              _extends({ styleName: "black", loading: loading, fullWidth: true }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 130
                }
              }),
              buttonText
            )
          )
        )
      )
    );
  };

  return MyMazdaChangeEmail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaChangeEmail.displayName = "MyMazdaChangeEmail";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaChangeEmail);

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaChangeEmail":"MyMazdaChangeEmail__MyMazdaChangeEmail___2rZYP","MyMazdaChangeEmailForm":"MyMazdaChangeEmail__MyMazdaChangeEmailForm___qyDyK"};

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaDetails_less__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaDetails_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MyMazdaDetails_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputSearchable_InputSearchable__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_environment__ = __webpack_require__(12);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaDetails\\MyMazdaDetails.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-deprecated */














var MyMazdaDetails = function (_React$Component) {
  _inherits(MyMazdaDetails, _React$Component);

  function MyMazdaDetails(props) {
    var _this2 = this;

    _classCallCheck(this, MyMazdaDetails);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var createAccountApiEndpoint, form;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          createAccountApiEndpoint = _this.props.createAccountApiEndpoint;
                          form = _this.state.form;
                          _context2.next = 4;
                          return Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: createAccountApiEndpoint,
                            body: {
                              email: form.email.value,
                              firstName: form.firstName.value,
                              lastName: form.lastName.value,
                              phone: form.phone.value,
                              address: form.address.value.description,
                              vinOrRegistration: form.vinRego.value
                            }
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "MyMazda Details Form",
                                            pageAction: "MyMazda Details Form - Submit"
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      form: {
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_REQUIRED,
            phone: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        address: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].ADDRESS_REQUIRED,
            address: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].ADDRESS_INVALID
          }
        },
        vinRego: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].REGO_OR_VIN_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  MyMazdaDetails.prototype.componentDidMount = function componentDidMount() {
    var currentURL = new __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_11_constants_environment__["i" /* WINDOW */].location.href);

    // if queryParams doesnt have email redirect it back
    var _props$unsuccessfulRe = this.props.unsuccessfulRedirectUrl,
        unsuccessfulRedirectUrl = _props$unsuccessfulRe === undefined ? "/" : _props$unsuccessfulRe;

    if (!currentURL.query.email) {
      new __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_urlHandler__["a" /* default */](unsuccessfulRedirectUrl).redirect();
    }

    this.setState({
      form: _extends({}, this.state.form, {
        email: {
          value: currentURL.query.email
        }
      })
    });
  };

  MyMazdaDetails.prototype.render = function render() {
    var _classnames3, _classnames4;

    var _props = this.props,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Submit" : _props$buttonText,
        heading = _props.heading,
        blurb = _props.blurb,
        submitInstructionsText = _props.submitInstructionsText,
        createAccountApiEndpoint = _props.createAccountApiEndpoint,
        registrationSuccessfulText = _props.registrationSuccessfulText,
        successfulRedirectUrl = _props.successfulRedirectUrl;
    var _state = this.state,
        loading = _state.loading,
        success = _state.success,
        errorMessage = _state.errorMessage;


    if (success) {
      var _classnames, _classnames2;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__MyMazdaDetails_less___default.a.MyMazdaDetails] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__MyMazdaDetails_less___default.a.MyMazdaDetailsForm] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 135
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 136
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["n" /* HeroContent */], {
              heading: "Thank you",
              description: registrationSuccessfulText || "We're setting up your account. We'll be in touch when it's ready for you to use.", __source: {
                fileName: _jsxFileName,
                lineNumber: 137
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 141
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              { styleName: "black", href: successfulRedirectUrl, fullWidth: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 142
                }
              },
              "MyMazda home"
            )
          )
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__MyMazdaDetails_less___default.a.MyMazdaDetails] = true, _classnames3)), __source: {
          fileName: _jsxFileName,
          lineNumber: 152
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__MyMazdaDetails_less___default.a.MyMazdaDetailsForm] = true, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 153
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { method: "POST", onSubmit: this._handleSubmit, __source: {
              fileName: _jsxFileName,
              lineNumber: 154
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 155
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 156
                }
              },
              heading || "MyMazda Registration"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], { xmlString: blurb || "Please share your details below to complete the process.", __source: {
                fileName: _jsxFileName,
                lineNumber: 157
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 159
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "firstName",
              label: "First Name"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Get In Touch Form",
                  pageAction: "Get In Touch Form - Entered \"FIRSTNAME\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 160
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 172
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "lastName",
              label: "Last Name"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "lastName"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Get In Touch Form",
                  pageAction: "Get In Touch Form - Entered \"LASTNAME\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 173
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 185
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "phone",
              label: "Phone"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "phone"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Get In Touch Form",
                  pageAction: "Get In Touch Form - Entered \"PHONE\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 186
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 198
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__InputSearchable_InputSearchable__["a" /* default */], _extends({
              name: "address",
              type: "address",
              label: "Address"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "address"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Get In Touch Form",
                  pageAction: "Get In Touch Form - Selected address"
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 199
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 212
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "vinRego",
              label: "Registration or VIN"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "vinRego"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Get In Touch Form",
                  pageAction: "Get In Touch Form - Entered \"REGISTRATION OR VIN\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 213
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { center: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 225
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], { xmlString: submitInstructionsText, __source: {
                fileName: _jsxFileName,
                lineNumber: 226
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 228
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 229
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              _extends({ styleName: "black", loading: loading, fullWidth: true }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 230
                }
              }),
              buttonText
            )
          )
        )
      )
    );
  };

  return MyMazdaDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaDetails.displayName = "MyMazdaDetails";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaDetails);

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaDetails":"MyMazdaDetails__MyMazdaDetails___10sAm","MyMazdaDetailsForm":"MyMazdaDetails__MyMazdaDetailsForm___VuU4y"};

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaLogin":"MyMazdaLogin__MyMazdaLogin___3PKtN","MyMazdaLoginForm":"MyMazdaLogin__MyMazdaLoginForm___36lc7"};

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ParentMyMazdaLoginContainer":"MyMazdaLoginContainer__ParentMyMazdaLoginContainer___2Tnz3","MyMazdaLoginContainer":"MyMazdaLoginContainer__MyMazdaLoginContainer___1VhFc","MyMazdaLoginContainerBox":"MyMazdaLoginContainer__MyMazdaLoginContainerBox___1J21d","MyMazdaLoginContainerBoxRegister":"MyMazdaLoginContainer__MyMazdaLoginContainerBoxRegister___vXDZR","Box1":"MyMazdaLoginContainer__Box1___3lUrg","BoxImage":"MyMazdaLoginContainer__BoxImage___1ZFQE","BoxPadding":"MyMazdaLoginContainer__BoxPadding___2kya8"};

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaPassword_less__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaPassword_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MyMazdaPassword_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_string__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__ = __webpack_require__(30);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaPassword\\MyMazdaPassword.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var MyMazdaPassword = function (_React$Component) {
  _inherits(MyMazdaPassword, _React$Component);

  function MyMazdaPassword(props) {
    var _this2 = this;

    _classCallCheck(this, MyMazdaPassword);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();

                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var currentURL, _this$props, accountActivationApiEndpoint, buttonText, form;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          currentURL = new __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_urlHandler__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_constants_environment__["i" /* WINDOW */].location.href);
                          _this$props = _this.props, accountActivationApiEndpoint = _this$props.accountActivationApiEndpoint, buttonText = _this$props.buttonText;
                          form = _this.state.form;
                          _context2.next = 5;
                          return Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: accountActivationApiEndpoint,
                            body: {
                              email: currentURL.query.email,
                              guid: currentURL.query.token,
                              password: form.password.value
                            }
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "MyMazda Password Form",
                                            pageAction: "MyMazda Password Form - " + buttonText
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      form: {
        password: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].PASSWORD_REQUIRED
          }
        },
        confirmPassword: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].PASSWORD_REQUIRED,
            confirmPassword: "Passwords do not match"
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  MyMazdaPassword.prototype.passwordStrengthIndicator = function passwordStrengthIndicator() {
    var _classnames, _classnames2;

    var form = this.state.form;

    var icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_17" /* TickModalIcon */], {
      style: {
        height: '20px',
        float: 'left',
        margin: '1px 0.5em 0 0',
        width: '20px'
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 92
      }
    });
    var invalid = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__MyMazdaPassword_less___default.a.MyMazdaPasswordInvalid] = true, _classnames)), __source: {
        fileName: _jsxFileName,
        lineNumber: 102
      }
    });
    var style = { lineHeight: '20px', color: '#191919' };
    var val = form.password.value;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__MyMazdaPassword_less___default.a.MyMazdaPasswordStrength] = true, _classnames2)), __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["t" /* Content */], { xmlString: 'Please select a password that has', __source: {
          fileName: _jsxFileName,
          lineNumber: 113
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 114
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_string__["d" /* lengthCheck */])(val, 8, 20) ? icon : invalid,
        " 8-20 characters."
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 115
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_string__["a" /* hasLowerUpperCase */])(val) ? icon : invalid,
        " Upper and lowercase letters."
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 116
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_string__["b" /* hasNumber */])(val) || Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_string__["c" /* hasSymbol */])(val) ? icon : invalid,
        " One number or one symbol."
      )
    );
  };

  MyMazdaPassword.prototype.render = function render() {
    var _classnames5, _classnames6;

    var _props = this.props,
        heading = _props.heading,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Next" : _props$buttonText,
        successHeading = _props.successHeading,
        passswordUpdateSuccessfulText = _props.passswordUpdateSuccessfulText,
        successfulPageUrl = _props.successfulPageUrl,
        redirectPageUrl = _props.redirectPageUrl;
    var _state = this.state,
        loading = _state.loading,
        errorMessage = _state.errorMessage,
        success = _state.success;


    if (success) {
      var _classnames3, _classnames4;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__MyMazdaPassword_less___default.a.MyMazdaPassword] = true, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 129
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__MyMazdaPassword_less___default.a.MyMazdaPasswordForm] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 130
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 131
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_17" /* TickModalIcon */], { style: { width: "2.25em", height: "2.25em", margin: "0 auto" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 132
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["n" /* HeroContent */], {
              heading: successHeading || "New password created",
              description: passswordUpdateSuccessfulText, __source: {
                fileName: _jsxFileName,
                lineNumber: 133
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["j" /* Button */],
              { styleName: "black", href: successfulPageUrl, fullWidth: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 136
                }
              },
              "Login to MyMazda"
            )
          )
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__MyMazdaPassword_less___default.a.MyMazdaPassword] = true, _classnames5)), __source: {
          fileName: _jsxFileName,
          lineNumber: 146
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__MyMazdaPassword_less___default.a.MyMazdaPasswordForm] = true, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 149
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { method: "POST", onSubmit: this._handleSubmit, __source: {
              fileName: _jsxFileName,
              lineNumber: 152
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 153
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["A" /* H3 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 154
                }
              },
              heading
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 158
              }
            },
            this.passwordStrengthIndicator()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 162
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["O" /* InputPassword */], _extends({
              name: "password",
              label: "Create password"
            }, Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "password"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda Password Form",
                  pageAction: "MyMazda Password Form - Entered \"PASSWORD\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 163
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 175
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["O" /* InputPassword */], _extends({
              name: "confirmPassword",
              label: "Confirm password"
            }, Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "confirmPassword"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda Password Form",
                  pageAction: "MyMazda Password Form - Entered \"CONFIRM PASSWORD\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 176
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 189
              }
            },
            errorMessage && errorMessage === "TokenExpired" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["c" /* Alert */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 193
                }
              },
              "Oh no! Your password has expired. Please ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["a" /* A */],
                { href: redirectPageUrl, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 194
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["l" /* Caption */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 194
                    }
                  },
                  "click this link"
                )
              ),
              " and follow the prompts to create a new one."
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 197
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["j" /* Button */],
              _extends({
                styleName: "black",
                loading: loading,
                fullWidth: true
              }, Object(__WEBPACK_IMPORTED_MODULE_10_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 200
                }
              }),
              buttonText
            )
          )
        )
      )
    );
  };

  return MyMazdaPassword;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaPassword.displayName = "MyMazdaPassword";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaPassword);

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaPassword":"MyMazdaPassword__MyMazdaPassword___3ubso","MyMazdaPasswordForm":"MyMazdaPassword__MyMazdaPasswordForm___3w0T1","MyMazdaPasswordStrength":"MyMazdaPassword__MyMazdaPasswordStrength___1Np9p","MyMazdaPasswordInvalid":"MyMazdaPassword__MyMazdaPasswordInvalid___pqGrf"};

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasLowerUpperCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lengthCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasSymbol; });
var hasLowerUpperCase = function hasLowerUpperCase(string) {
  var test = new RegExp("^(?=.*[a-z])(?=.*[A-Z]).+$");
  var subject = typeof string === "string" ? string : String(string);
  return Boolean(test.exec(subject));
};

var lengthCheck = function lengthCheck(string, min, max) {
  var subject = typeof string === "string" ? string : String(string);
  return Boolean(subject !== "undefined" && subject.length >= min && subject.length <= max);
};

var hasNumber = function hasNumber(string) {
  var test = /^(?=.*\d).+$/;
  var subject = typeof string === "string" ? string : String(string);
  return Boolean(subject.match(test));
};

var hasSymbol = function hasSymbol(string) {
  var test = /^(?=.*(_|[^\w])).+$/;
  var subject = typeof string === "string" ? string : String(string);
  return Boolean(subject.match(test));
};

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaPersonalDetails_less__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaPersonalDetails_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MyMazdaPersonalDetails_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputSearchable_InputSearchable__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaPersonalDetails\\MyMazdaPersonalDetails.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-deprecated */













var TITLES = "Mr|Mrs|Ms|Miss|Dr|Master|Prof".split("|").map(function (label) {
  return { label: label, value: label };
});

var STATES = "ACT|NSW|NT|QLD|SA|TAS|VIC|WA".split("|").map(function (label) {
  return { label: label, value: label.toLowerCase() };
});

var MyMazdaPersonalDetails = function (_React$Component) {
  _inherits(MyMazdaPersonalDetails, _React$Component);

  function MyMazdaPersonalDetails(props) {
    var _this2 = this;

    _classCallCheck(this, MyMazdaPersonalDetails);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _this$props, updatePersonalDetailsEndpoint, customer, form;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this$props = _this.props, updatePersonalDetailsEndpoint = _this$props.updatePersonalDetailsEndpoint, customer = _this$props.customer;
                          form = _this.state.form;
                          _context2.next = 4;
                          return Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "PUT",
                            url: updatePersonalDetailsEndpoint,
                            body: _extends({}, customer, {
                              title: form.title.value,
                              firstName: form.firstName.value,
                              surname: form.surname.value,
                              mobilePhone: form.mobilePhone.value,
                              afterHoursPhone: form.afterHoursPhone.value,
                              businessHoursPhone: form.businessHoursPhone.value,
                              businessHoursPhoneExtension: form.businessHoursPhoneExtension.value,
                              address: _extends({}, customer.address, {
                                address1: form.address1.value,
                                address2: form.address2.value,
                                address3: form.address3.value,
                                townName: form.townName.value,
                                postcode: form.postcode.value,
                                state: form.state.value
                              })
                            })
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "MyMazda Details Form",
                                            pageAction: "MyMazda Details Form - Submit"
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleAddressChange = function (address) {
      if (address) {
        if (address.structured_formatting && address.structured_formatting.main_text) {
          Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(_this, { address1: address.structured_formatting.main_text });
        }
        if (address.suburb) {
          Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(_this, { townName: address.suburb });
        }
        if (address.postcode) {
          Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(_this, { postcode: address.postcode });
        }
        if (address.state) {
          Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(_this, { state: address.state.toLowerCase() });
        }

        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: "Personal details Form",
          pageAction: "Personal details Form - Selected address"
        });
      }
    };

    _this.state = {
      form: {
        title: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].FIRSTNAME_REQUIRED
          }
        },
        surname: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].LASTNAME_REQUIRED
          }
        },
        mobilePhone: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_REQUIRED,
            mobilePhone: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        afterHoursPhone: {
          validations: {
            phone: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        businessHoursPhone: {
          validations: {
            phone: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PHONE_NUMBER_INVALID
          }
        },
        businessHoursPhoneExtension: {
          validations: {
            extension: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].PHONE_EXTENSION_INVALID
          }
        },
        address: {
          validations: {
            address: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].ADDRESS_INVALID
          }
        },
        manualAddress: {
          validations: {}
        },
        address1: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].ADDRESS_REQUIRED
          }
        },
        address2: {
          validations: {}
        },
        address3: {
          validations: {}
        },
        townName: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].ADDRESS2_REQUIRED
          }
        },
        postcode: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].ADDRESS3_REQUIRED
          }
        },
        state: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_9_AtomicConstants_MESSAGES__["a" /* default */].STATE_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  MyMazdaPersonalDetails.prototype.componentDidMount = function componentDidMount() {
    var customer = this.props.customer;


    if (customer) {
      Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, {
        title: customer.title,
        firstName: customer.firstName,
        surname: customer.surname,
        mobilePhone: customer.mobilePhone,
        afterHoursPhone: customer.afterHoursPhone,
        businessHoursPhone: customer.businessHoursPhone,
        businessHoursPhoneExtension: customer.businessHoursPhoneExtension,
        address1: customer.address.address1,
        address2: customer.address.address2,
        address3: customer.address.address3,
        townName: customer.address.townName,
        postcode: customer.address.postcode,
        state: customer.address.state.toLowerCase()
      });
    }
  };

  MyMazdaPersonalDetails.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4;

    var onUpdate = this.props.onUpdate;
    var _state = this.state,
        loading = _state.loading,
        success = _state.success,
        errorMessage = _state.errorMessage,
        form = _state.form;

    var editAdressManually = form.manualAddress ? form.manualAddress.value : false;

    if (success) {
      onUpdate({ success: true });
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__MyMazdaPersonalDetails_less___default.a.MyMazdaPersonalDetails] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 227
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__MyMazdaPersonalDetails_less___default.a.MyMazdaPersonalDetailsForm] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 228
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { onSubmit: this._handleSubmit, __source: {
              fileName: _jsxFileName,
              lineNumber: 229
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 230
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__MyMazdaPersonalDetails_less___default.a.MyMazdaPersonalDetailsFormWrapper] = true, _classnames3)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 231
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 232
                  }
                },
                "Update Personal Details"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { onClick: onUpdate, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__MyMazdaPersonalDetails_less___default.a.MyMazdaPersonalDetailsFormCancel] = true, _classnames4)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 233
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["g" /* CancelIcon */], { style: { fill: "currentColor", width: "1em", height: "1em", marginRight: "0.5em" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 234
                  }
                }),
                "Cancel"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 238
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 240
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["R" /* InputSelect */], _extends({
              name: "title",
              label: "Title",
              options: TITLES
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "title"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Get In Touch Form",
                  pageAction: "Get In Touch Form - Selected \"TITLE\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 241
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 254
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "firstName",
              label: "First Name"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "firstName"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Personal details Form",
                  pageAction: "Personal details Form - Entered \"FIRSTNAME\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 255
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 267
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "surname",
              label: "Last Name"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "surname"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Personal details Form",
                  pageAction: "Personal details Form - Entered \"LASTNAME\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 268
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 280
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "mobilePhone",
              label: "Mobile Phone"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "mobilePhone"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Personal details Form",
                  pageAction: "Personal details Form - Entered \"MOBILE PHONE\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 281
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 293
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "afterHoursPhone",
              label: "After hours phone"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "afterHoursPhone"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Personal details Form",
                  pageAction: "Personal details Form - Entered \"AFTER HOURS PHONE\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 294
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 306
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { display: "flex" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 307
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { flex: "0 1 100%", marginRight: "1em" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 308
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                  name: "businessHoursPhone",
                  label: "Business hours phone"
                }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "businessHoursPhone"), {
                  onBlur: function onBlur() {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Personal details Form",
                      pageAction: "Personal details Form - Entered \"BUSINESS HOURS PHONE\""
                    });
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 309
                  }
                }))
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { flex: "0 1 50%" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 321
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                  name: "businessHoursPhoneExtension",
                  label: "Extension"
                }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "businessHoursPhoneExtension"), {
                  onBlur: function onBlur() {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Personal details Form",
                      pageAction: "Personal details Form - Entered \"EXTENSION\""
                    });
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 322
                  }
                }))
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 336
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 337
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 338
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 339
                }
              },
              "Edit address"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__InputSearchable_InputSearchable__["a" /* default */], _extends({
              name: "address",
              type: "address",
              label: "Address"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "address"), {
              onBlur: this.handleAddressChange,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 340
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 348
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["M" /* InputCheckBox */], _extends({
              name: "privacy",
              label: "Enter address manually"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "manualAddress", function () {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "Personal details Form",
                pageAction: "Personal details Form - Checked \"Manual Addess\""
              });
            }), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 349
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { hide: !editAdressManually, __source: {
                fileName: _jsxFileName,
                lineNumber: 360
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "address1",
              label: "Address (Line 1)"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "address1"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Personal details Form",
                  pageAction: "Personal details Form - Entered \"Address1\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 361
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { hide: !editAdressManually, __source: {
                fileName: _jsxFileName,
                lineNumber: 373
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "address2",
              label: "Address (Line 2)"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "address2"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Personal details Form",
                  pageAction: "Personal details Form - Entered \"Address2\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 374
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { hide: !editAdressManually, __source: {
                fileName: _jsxFileName,
                lineNumber: 386
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "address3",
              label: "Address (Line 3)"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "address3"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Personal details Form",
                  pageAction: "Personal details Form - Entered \"Address3\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 387
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { hide: !editAdressManually, __source: {
                fileName: _jsxFileName,
                lineNumber: 399
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
              name: "townName",
              label: "Suburb"
            }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "townName"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "Personal details Form",
                  pageAction: "Personal details Form - Entered \"Suburb\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 400
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            { hide: !editAdressManually, __source: {
                fileName: _jsxFileName,
                lineNumber: 412
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { display: "flex", alignItems: "flex-end" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 413
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { flex: "0 1 50%", marginRight: "1em" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 414
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["S" /* InputText */], _extends({
                  name: "postcode",
                  label: "Postcode"
                }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "postcode"), {
                  onBlur: function onBlur() {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Personal details Form",
                      pageAction: "Personal details Form - Entered \"postcode\""
                    });
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 415
                  }
                }))
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { flex: "0 1 50%" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 427
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["R" /* InputSelect */], _extends({
                  name: "state",
                  label: "State",
                  options: STATES
                }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "state"), {
                  onBlur: function onBlur() {
                    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "Personal details Form",
                      pageAction: "Personal details Form - Selected \"STATE\""
                    });
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 428
                  }
                }))
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 443
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 444
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              _extends({ styleName: "black", loading: loading, fullWidth: true }, Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 445
                }
              }),
              "Save"
            )
          )
        )
      )
    );
  };

  return MyMazdaPersonalDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaPersonalDetails.displayName = "MyMazdaPersonalDetails";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaPersonalDetails);

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaPersonalDetails":"MyMazdaPersonalDetails__MyMazdaPersonalDetails___38Cwx","MyMazdaPersonalDetailsForm":"MyMazdaPersonalDetails__MyMazdaPersonalDetailsForm___3WH_1","MyMazdaPersonalDetailsFormWrapper":"MyMazdaPersonalDetails__MyMazdaPersonalDetailsFormWrapper___NLJVp","MyMazdaPersonalDetailsFormCancel":"MyMazdaPersonalDetails__MyMazdaPersonalDetailsFormCancel___271LP","MyMazdaPersonalDetailsFormIcon":"MyMazdaPersonalDetails__MyMazdaPersonalDetailsFormIcon___2i8xG"};

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaRegister_less__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaRegister_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MyMazdaRegister_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_urlHandler__ = __webpack_require__(33);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaRegister\\MyMazdaRegister.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var MyMazdaRegister = function (_React$Component) {
  _inherits(MyMazdaRegister, _React$Component);

  function MyMazdaRegister(props) {
    var _this2 = this;

    _classCallCheck(this, MyMazdaRegister);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _this$props, registerApiEndpoint, createAccountPageUrl, passwordResetPageUrl, form;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this$props = _this.props, registerApiEndpoint = _this$props.registerApiEndpoint, createAccountPageUrl = _this$props.createAccountPageUrl, passwordResetPageUrl = _this$props.passwordResetPageUrl;
                          form = _this.state.form;
                          _context2.next = 4;
                          return Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: registerApiEndpoint,
                            body: {
                              username: form.email.value
                            }
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg, data;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg, data = json.data;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          data: data,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "MyMazda Registration Form",
                                            pageAction: "MyMazda Registration Form - Register"
                                          });
                                          if (data === "NotUnique") {
                                            setTimeout(function () {
                                              // add email to the query params
                                              var createAcountURL = new __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_urlHandler__["a" /* default */](createAccountPageUrl);
                                              createAcountURL.setParam("email", form.email.value);
                                              createAcountURL.redirect();
                                            }, 200);
                                          }
                                          if (data === "AlreadyRegistered") {
                                            setTimeout(function () {
                                              // add email to the query params
                                              var createAcountURL = new __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_urlHandler__["a" /* default */](passwordResetPageUrl);
                                              createAcountURL.setParam("email", form.email.value);
                                              createAcountURL.setParam("alreadyRegistered", "true");
                                              createAcountURL.redirect();
                                            }, 200);
                                          }
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      form: {
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  MyMazdaRegister.prototype.componentDidMount = function componentDidMount() {
    var email = this.props.email;


    if (email) {
      Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, { email: decodeURIComponent(email) });
    }
  };

  MyMazdaRegister.prototype.render = function render() {
    var _classnames3, _classnames4;

    var _props = this.props,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Next" : _props$buttonText,
        heading = _props.heading,
        blurb = _props.blurb,
        registrationSuccessfulText = _props.registrationSuccessfulText;
    var _state = this.state,
        loading = _state.loading,
        success = _state.success,
        data = _state.data,
        errorMessage = _state.errorMessage;


    if (success && data !== "NotUnique" && data !== "AlreadyRegistered") {
      var _classnames, _classnames2;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__MyMazdaRegister_less___default.a.MyMazdaRegister] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 116
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__MyMazdaRegister_less___default.a.MyMazdaRegisterForm] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 117
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 118
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["X" /* MailIcon */], {
              style: {
                fill: "#101010",
                height: "29px",
                margin: "0 auto 1em",
                width: "37px"
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 119
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["n" /* HeroContent */], {
              heading: "Verify your email",
              description: registrationSuccessfulText || "We've sent you an email to confirm your details. Simply click the link in the email to confirm your registration.", __source: {
                fileName: _jsxFileName,
                lineNumber: 127
              }
            })
          )
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__MyMazdaRegister_less___default.a.MyMazdaRegister] = true, _classnames3)), __source: {
          fileName: _jsxFileName,
          lineNumber: 137
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__MyMazdaRegister_less___default.a.MyMazdaRegisterForm] = true, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 138
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { method: "POST", onSubmit: this._handleSubmit, __source: {
              fileName: _jsxFileName,
              lineNumber: 139
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 140
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 141
                }
              },
              heading || "Create account"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], { xmlString: blurb, __source: {
                fileName: _jsxFileName,
                lineNumber: 142
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 144
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["N" /* InputEmail */], _extends({ name: "email", label: "Email" }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), { onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda Registration Form",
                  pageAction: "MyMazda Registration Form - Entered \"EMAIL\""
                });
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 145
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 153
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 154
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              _extends({ styleName: "black", loading: loading, fullWidth: true }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 155
                }
              }),
              buttonText
            )
          )
        )
      )
    );
  };

  return MyMazdaRegister;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaRegister.displayName = "MyMazdaRegister";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaRegister);

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaRegister":"MyMazdaRegister__MyMazdaRegister___1lIhk","MyMazdaRegisterForm":"MyMazdaRegister__MyMazdaRegisterForm___GpQOQ"};

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaResetPassword_less__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaResetPassword_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MyMazdaResetPassword_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__ = __webpack_require__(30);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaResetPassword\\MyMazdaResetPassword.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var MyMazdaResetPassword = function (_React$Component) {
  _inherits(MyMazdaResetPassword, _React$Component);

  function MyMazdaResetPassword(props) {
    var _this2 = this;

    _classCallCheck(this, MyMazdaResetPassword);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var resetPasswordApiEndpoint, form;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          resetPasswordApiEndpoint = _this.props.resetPasswordApiEndpoint;
                          form = _this.state.form;
                          _context2.next = 4;
                          return Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: resetPasswordApiEndpoint,
                            body: {
                              username: form.email.value
                            }
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg || "null",
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "MyMazda Reset password Form",
                                            pageAction: "MyMazda Reset password Form - Reset my password"
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      form: {
        email: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_REQUIRED,
            email: __WEBPACK_IMPORTED_MODULE_8_AtomicConstants_MESSAGES__["a" /* default */].EMAIL_INVALID
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  MyMazdaResetPassword.prototype.render = function render() {
    var _classnames3, _classnames4;

    var _props = this.props,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Reset my password" : _props$buttonText,
        successfulResetText = _props.successfulResetText,
        alreadyRegisteredHeading = _props.alreadyRegisteredHeading,
        alreadyRegisteredText = _props.alreadyRegisteredText,
        loginPageUrl = _props.loginPageUrl,
        heading = _props.heading,
        blurb = _props.blurb;
    var _state = this.state,
        loading = _state.loading,
        success = _state.success,
        errorMessage = _state.errorMessage;


    if (success) {
      var _classnames, _classnames2;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__MyMazdaResetPassword_less___default.a.MyMazdaResetPassword] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 91
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__MyMazdaResetPassword_less___default.a.MyMazdaResetPasswordForm] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 92
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 93
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_17" /* TickModalIcon */], { style: { width: "2.25em", height: "2.25em", margin: "0 auto" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 94
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["n" /* HeroContent */], {
              heading: "We've sent your reset link",
              description: successfulResetText || "If it hasn’t appeared in your inbox, please check your junk folder.", __source: {
                fileName: _jsxFileName,
                lineNumber: 95
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              { styleName: "black", href: loginPageUrl, fullWidth: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 98
                }
              },
              "Return to login"
            )
          )
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__MyMazdaResetPassword_less___default.a.MyMazdaResetPassword] = true, _classnames3)), __source: {
          fileName: _jsxFileName,
          lineNumber: 108
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__MyMazdaResetPassword_less___default.a.MyMazdaResetPasswordForm] = true, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 109
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { method: "POST", onSubmit: this._handleSubmit, __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 111
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["A" /* H3 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 112
                }
              },
              alreadyRegisteredHeading || heading || "Forgotten your password?"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["t" /* Content */], { xmlString: alreadyRegisteredText || blurb, __source: {
                fileName: _jsxFileName,
                lineNumber: 113
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 115
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["N" /* InputEmail */], _extends({ name: "email", label: "Email address" }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "email"), { onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda Reset password Form",
                  pageAction: "MyMazda Reset password Form - Entered \"EMAIL\""
                });
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 116
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 124
              }
            },
            errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 126
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["j" /* Button */],
              _extends({ styleName: "black", loading: loading, fullWidth: true }, Object(__WEBPACK_IMPORTED_MODULE_7_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 128
                }
              }),
              buttonText
            )
          )
        )
      )
    );
  };

  return MyMazdaResetPassword;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaResetPassword.displayName = "MyMazdaResetPassword";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaResetPassword);

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaResetPassword":"MyMazdaResetPassword__MyMazdaResetPassword___3dJvp","MyMazdaResetPasswordForm":"MyMazdaResetPassword__MyMazdaResetPasswordForm___2BQlS"};

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaServiceHistory":"MyMazdaServiceHistory__MyMazdaServiceHistory___3TDRI","MyMazdaServiceHistoryHeader":"MyMazdaServiceHistory__MyMazdaServiceHistoryHeader___3m2aF","MyMazdaServiceHistoryEmpty":"MyMazdaServiceHistory__MyMazdaServiceHistoryEmpty___1vbR3","MyMazdaServiceHistoryColumns":"MyMazdaServiceHistory__MyMazdaServiceHistoryColumns___QborL","MyMazdaServiceHistoryTitle":"MyMazdaServiceHistory__MyMazdaServiceHistoryTitle___1-zl1","MyMazdaServiceHistoryDetails":"MyMazdaServiceHistory__MyMazdaServiceHistoryDetails___5AJai","MyMazdaServiceHistoryFooter":"MyMazdaServiceHistory__MyMazdaServiceHistoryFooter___2fbB-"};

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceRequest_less__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceRequest_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceRequest_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents_Typography_Typography_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_dateHandler__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TIMES__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\MyMazdaServiceRequest\\MyMazdaServiceRequest.jsx";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var MyMazdaServiceRequest = function (_React$Component) {
  _inherits(MyMazdaServiceRequest, _React$Component);

  function MyMazdaServiceRequest(props) {
    var _this2 = this;

    _classCallCheck(this, MyMazdaServiceRequest);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
        var _this$props$buttonTex, buttonText, _this$state, loading, form;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props$buttonTex = _this.props.buttonText, buttonText = _this$props$buttonTex === undefined ? "Request A Service" : _this$props$buttonTex;

                if (event) event.preventDefault();
                _this$state = _this.state, loading = _this$state.loading, form = _this$state.form;

                if (!(!loading && !form.submitButton.disabled)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this.setState({
                  loading: true
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _this$props, serviceRequestSubmissionApiEndPoint, service, serviceOptions, isComplementaryPage, form, baseDescription, additionalDescriptions, body;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this$props = _this.props, serviceRequestSubmissionApiEndPoint = _this$props.serviceRequestSubmissionApiEndPoint, service = _this$props.service, serviceOptions = _this$props.serviceOptions, isComplementaryPage = _this$props.isComplementaryPage;
                          form = _this.state.form;
                          baseDescription = serviceOptions && (isComplementaryPage ? serviceOptions.serviceItems.find(function (s) {
                            return s.factoryCodeEntity.distance === 0;
                          }) : service && serviceOptions.serviceItems.filter(function (s) {
                            return s.factoryCodeEntity.distance > 0;
                          })[service.activeServiceCodeIndex]);
                          additionalDescriptions = [];

                          serviceOptions && service && service.selectedAdditionalServices && serviceOptions.serviceItems.forEach(function (item, index) {
                            Object.keys(service.selectedAdditionalServices).forEach(function (addtionalItemCode) {
                              if (item.factoryCode === addtionalItemCode && service.selectedAdditionalServices[addtionalItemCode]) {
                                additionalDescriptions.push(item);
                              }
                            });
                          });

                          body = {
                            optedIn: true,
                            odometer: form.odometer.value,
                            comments: form.comments.value,
                            dealerLocation: form.dealer.value.id,
                            dealerCode: form.dealer.value.dealerCode,
                            preferredDate: form.date.value && new __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_dateHandler__["a" /* default */](form.date.value).format('0D/0M/YYYY') || '',
                            preferredDropOffTime: form.dropOff.value,
                            preferredPickUpTime: form.pickUp.value,
                            serviceOptions: baseDescription ? [baseDescription].concat(additionalDescriptions) : null
                          };
                          _context2.next = 8;
                          return Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_fetchAPI__["a" /* default */])({
                            method: "POST",
                            url: serviceRequestSubmissionApiEndPoint,
                            body: body
                          }).then(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                              var json, success, errorMsg;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return response.json();

                                    case 2:
                                      json = _context.sent;
                                      success = json.success, errorMsg = json.errorMsg;

                                      if (!success) {
                                        _this.setState({
                                          errorMessage: errorMsg,
                                          loading: false
                                        });
                                      } else {
                                        // successful
                                        _this.setState({
                                          loading: false,
                                          success: true
                                        }, function () {
                                          Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
                                            pageCategory: "MyMazda - Servicing",
                                            pageAction: "Calculator Form - Clicked \"" + buttonText.toUpperCase() + "\""
                                          });
                                        });
                                      }

                                    case 5:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this2);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }()).catch(function (response) {
                            _this.setState({
                              errorMessage: response.message || "Failed with status " + response.status,
                              loading: false
                            });
                          });

                        case 8:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.selectDealer = function (dealer) {
      // no search, use the selected dealer only for the radio inputs
      // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
      _this.refs.dealerSearchComp.setState({
        dealers: [dealer],
        selected: dealer,
        loading: false
      });
    };

    _this.state = {
      form: {
        odometer: {
          validations: {
            odometer: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].ODOMETER_INVALID
          }
        },
        dealer: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].DEALERS_REQUIRED
          }
        },
        comments: {
          validations: {}
        },
        date: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].DATE_REQUIRED
          }
        },
        dropOff: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].TIME_REQUIRED
          }
        },
        pickUp: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].TIME_REQUIRED
          }
        },
        privacy: {
          validations: {
            required: __WEBPACK_IMPORTED_MODULE_11_AtomicConstants_MESSAGES__["a" /* default */].PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    };
    return _this;
  }

  MyMazdaServiceRequest.prototype.componentDidMount = function componentDidMount() {
    Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, { dropOff: "09:00 AM" });
    Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["b" /* formSetDefaultValues */])(this, { pickUp: "12:00 PM" });
  };

  MyMazdaServiceRequest.prototype.render = function render() {
    var _classnames3, _classnames4, _classnames5;

    var _props = this.props,
        heading = _props.heading,
        description = _props.description,
        privacyPolicyText = _props.privacyPolicyText,
        privacyPolicyUrl = _props.privacyPolicyUrl,
        _props$buttonText = _props.buttonText,
        buttonText = _props$buttonText === undefined ? "Request A Service" : _props$buttonText,
        contactHeading = _props.contactHeading,
        initialLocations = _props.initialLocations,
        dealerApiEndPoint = _props.dealerApiEndPoint,
        isComplementaryPage = _props.isComplementaryPage,
        contactDetails = _props.contactDetails;
    var _state = this.state,
        loading = _state.loading,
        form = _state.form,
        success = _state.success,
        errorMessage = _state.errorMessage;


    if (success) {
      var _classnames, _classnames2;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceRequest_less___default.a.MyMazdaServiceRequest] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 191
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceRequest_less___default.a.MyMazdaServiceRequestForm] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 192
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 193
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_17" /* TickModalIcon */], { style: { width: "2.25em", height: "2.25em", margin: "0 auto" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 194
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 195
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["A" /* H3 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 196
                }
              },
              "Service requested"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 197
                }
              },
              "Your dealer will get in touch with you to confirm your service request."
            )
          )
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceRequest_less___default.a.MyMazdaServiceRequest] = true, _classnames3)), __source: {
          fileName: _jsxFileName,
          lineNumber: 205
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["A" /* H3 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 208
          }
        },
        heading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["t" /* Content */], { xmlString: description, __source: {
          fileName: _jsxFileName,
          lineNumber: 209
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__MyMazdaServiceRequest_less___default.a.MyMazdaServiceRequestForm] = true, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 210
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { method: "POST", onSubmit: this._handleSubmit, __source: {
              fileName: _jsxFileName,
              lineNumber: 213
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 214
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["r" /* InputDate */], _extends({
              name: "date",
              label: "Preferred Date"
            }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "date"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda - Servicing",
                  pageAction: "Request A Service Form - Entered \"DATE\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 215
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 227
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["R" /* InputSelect */], _extends({
              name: "dropOff",
              label: "Preferred Drop Off Time",
              options: __WEBPACK_IMPORTED_MODULE_12__TIMES__["a" /* default */]
            }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "dropOff"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda - Servicing",
                  pageAction: "Calculator Form - Selected \"DROP OFF TIME\" - \"" + form.dropOff.value + "\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 228
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 241
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["R" /* InputSelect */], _extends({
              name: "pickUp",
              label: "Preferred Pick Up Time",
              options: __WEBPACK_IMPORTED_MODULE_12__TIMES__["a" /* default */]
            }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "pickUp"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda - Servicing",
                  pageAction: "Calculator Form - Selected \"PICK UP TIME\" - \"" + form.pickUp.value + "\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 242
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 255
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["S" /* InputText */], _extends({
              name: "odometer",
              label: "Odometer"
            }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "odometer"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda - Servicing",
                  pageAction: "Calculator Form - Entered \"" + form.odometer.value + "\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 256
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 268
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["S" /* InputText */], _extends({
              name: "comments",
              label: "Tell us your enquiry"
            }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "comments"), {
              onBlur: function onBlur() {
                Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda - Servicing",
                  pageAction: "Request A Service Form - Entered \"ENQUIRY\""
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 269
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["C" /* H5 */],
            { textAlign: "center", __source: {
                fileName: _jsxFileName,
                lineNumber: 282
              }
            },
            "Find a dealer"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 283
              }
            },
            "Select your region and we'll give you a list of your local Mazda Dealerships."
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components__["n" /* DealerSearchBoxNZ */], {
            searchType: "SERVICE",
            noMap: true,
            selectDealerVariant: true,
            selectDealer: this.selectDealer,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 285
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 292
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["h" /* DealerSearch */], _extends({
              endpoint: dealerApiEndPoint,
              disabled: !initialLocations,
              type: "Service",
              name: "dealer",
              postcode: initialLocations && initialLocations[0] && initialLocations[0].postCode,
              ref: "dealerSearchComp"
            }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "dealer"), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 293
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            { center: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 303
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["C" /* H5 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 304
                }
              },
              contactHeading || "Your Contact Details"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 309
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 310
                }
              },
              contactDetails.name,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 312
                }
              }),
              contactDetails.email,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 314
                }
              }),
              contactDetails.phone
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 317
                }
              },
              "To update your details, visit the",
              " ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],
                {
                  to: contactDetails.manageAccountPageUrl,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_3_AtomicComponents_Typography_Typography_less___default.a.blackColor] = true, _classnames5)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 318
                  }
                },
                "manage account"
              ),
              " ",
              "page."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 327
                }
              },
              "Your details will be sent to",
              " ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "b",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 329
                  }
                },
                form.dealer.value ? form.dealer.value.name : "your dealer"
              ),
              " and they will contact you to confirm the booking"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 335
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 336
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["M" /* InputCheckBox */], _extends({
              name: "privacy",
              label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 340
                  }
                },
                privacyPolicyText,
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["a" /* A */],
                  {
                    href: privacyPolicyUrl,
                    onClick: function onClick() {
                      Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "MyMazda - Servicing",
                        pageAction: "Request A Service Form - Clicked \"PRIVACYPOLICY\""
                      });
                    },
                    external: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 342
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "nobr",
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 351
                      }
                    },
                    "Privacy Policy"
                  )
                )
              )
            }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "privacy", function () {
              Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "MyMazda - Servicing",
                pageAction: "Request A Service Form - Checked \"PRIVACYPOLICY\""
              });
            }), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 337
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["x" /* FormGroup */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 364
              }
            },
            errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicContainers__["d" /* AlertList */], { data: errorMessage, __source: {
                fileName: _jsxFileName,
                lineNumber: 366
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["j" /* Button */],
              _extends({
                styleName: "black",
                loading: loading,
                fullWidth: true
              }, Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_formHandler__["a" /* formLinkSubmit */])(this, this._handleSubmit), {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 368
                }
              }),
              isComplementaryPage ? "Request Inspection" : buttonText
            )
          )
        )
      )
    );
  };

  return MyMazdaServiceRequest;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyMazdaServiceRequest.displayName = "MyMazdaServiceRequest";


/* harmony default export */ __webpack_exports__["a"] = (MyMazdaServiceRequest);

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaServiceRequest":"MyMazdaServiceRequest__MyMazdaServiceRequest___27gYD","MyMazdaServiceRequestForm":"MyMazdaServiceRequest__MyMazdaServiceRequestForm___30Yeq"};

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TIMES = "12:00 AM|12:15 AM|12:30 AM|12:45 AM|01:00 AM|01:15 AM|01:30 AM|01:45 AM|02:00 AM|02:15 AM|02:30 AM|02:45 AM|03:00 AM|03:15 AM|03:30 AM|03:45 AM|04:00 AM|04:15 AM|04:30 AM|04:45 AM|05:00 AM|05:15 AM|05:30 AM|05:45 AM|06:00 AM|06:15 AM|06:30 AM|06:45 AM|07:00 AM|07:15 AM|07:30 AM|07:45 AM|08:00 AM|08:15 AM|08:30 AM|08:45 AM|09:00 AM|09:15 AM|09:30 AM|09:45 AM|10:00 AM|10:15 AM|10:30 AM|10:45 AM|11:00 AM|11:15 AM|11:30 AM|11:45 AM|12:00 PM|12:15 PM|12:30 PM|12:45 PM|01:00 PM|01:15 PM|01:30 PM|01:45 PM|02:00 PM|02:15 PM|02:30 PM|02:45 PM|03:00 PM|03:15 PM|03:30 PM|03:45 PM|04:00 PM|04:15 PM|04:30 PM|04:45 PM|05:00 PM|05:15 PM|05:30 PM|05:45 PM|06:00 PM|06:15 PM|06:30 PM|06:45 PM|07:00 PM|07:15 PM|07:30 PM|07:45 PM|08:00 PM|08:15 PM|08:30 PM|08:45 PM|09:00 PM|09:15 PM|09:30 PM|09:45 PM|10:00 PM|10:15 PM|10:30 PM|10:45 PM|11:00 PM|11:15 PM|11:30 PM|11:45 PM".split("|").map(function (label) {
  return {
    label: label,
    value: label
  };
});

/* harmony default export */ __webpack_exports__["a"] = (TIMES);

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaVehicleSummary":"MyMazdaVehicleSummary__MyMazdaVehicleSummary___1-bZb"};

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyNewMazda":"MyNewMazda__MyNewMazda___2dROG","MyNewMazdaForm":"MyNewMazda__MyNewMazdaForm___13Qh0","MyNewMazdaFormWrapper":"MyNewMazda__MyNewMazdaFormWrapper___3z2-6","MyNewMazdaFormInput":"MyNewMazda__MyNewMazdaFormInput___1fqjq","MyNewMazdaFormButton":"MyNewMazda__MyNewMazdaFormButton___2rgMM","MyNewMazdaLoadingSection":"MyNewMazda__MyNewMazdaLoadingSection___K3mDW"};

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Offers":"Offers__Offers___2kJw1","OffersContent":"Offers__OffersContent___2_Fpy","OffersFiltersTrigger":"Offers__OffersFiltersTrigger___2CFzS","OffersListInfo":"Offers__OffersListInfo___awvYQ","OffersListInfoHideMobile":"Offers__OffersListInfoHideMobile___1n3DB","OffersListHeader":"Offers__OffersListHeader___3_Eow","OffersListHeaderImage":"Offers__OffersListHeaderImage___1W9HR","OffersList":"Offers__OffersList___EWqvx","OffersListZero":"Offers__OffersListZero___uzuhh"};

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OffersFilters_less__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OffersFilters_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OffersFilters_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_formHandler__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\OffersFilters\\OffersFilters.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var OffersFilters = function (_React$Component) {
  _inherits(OffersFilters, _React$Component);

  function OffersFilters(props) {
    _classCallCheck(this, OffersFilters);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      form: {
        nameplate: {},
        price: {},
        transmission: {},
        drivetrain: {}
      }
    };
    return _this;
  }

  OffersFilters.prototype.componentDidUpdate = function componentDidUpdate() {
    var _props$onChange = this.props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;
    var form = this.state.form;

    var filters = {};

    Object.keys(form).map(function (filter) {
      filters[filter] = form[filter].value ? form[filter].value : [];
    });

    onChange(filters);
  };

  OffersFilters.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5;

    var _props = this.props,
        nameplateFilters = _props.nameplateFilters,
        transmissionFilter = _props.transmissionFilter,
        priceFilter = _props.priceFilter,
        drivetrainFilters = _props.drivetrainFilters,
        _props$open = _props.open,
        open = _props$open === undefined ? false : _props$open,
        _props$onClose = _props.onClose,
        onClose = _props$onClose === undefined ? function () {} : _props$onClose;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__OffersFilters_less___default.a.OffersFilters] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__OffersFilters_less___default.a.OffersFiltersTablet] = open, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          onClick: onClose,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__OffersFilters_less___default.a.OffersFiltersTabletClose] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["u" /* CrossIcon */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 52
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 54
          }
        },
        "REFINE SEARCH"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55
        }
      }),
      nameplateFilters && nameplateFilters.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 58
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__OffersFilters_less___default.a.OffersFiltersLabel] = true, _classnames3)), __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          },
          "Nameplate"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["n" /* CheckBoxGroup */], _extends({
          styleName: "compact",
          items: nameplateFilters.map(function (filter) {
            return {
              name: filter.props.name,
              value: filter.props.value,
              checked: filter.props.checked
            };
          })
        }, Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "nameplate"), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 63
          }
        }))
      ),
      priceFilter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 75
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__OffersFilters_less___default.a.OffersFiltersLabel] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 76
            }
          },
          priceFilter.title || "Price Range (AU$)"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["Q" /* InputRange */], _extends({
          min: priceFilter.minValue,
          max: priceFilter.maxValue,
          step: priceFilter.increment
        }, Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_formHandler__["d" /* fromLinkInputs */])(this, "price"), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 80
          }
        }))
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__OffersFilters_less___default.a.OffersFiltersTabletUpdate] = true, _classnames5)), __source: {
            fileName: _jsxFileName,
            lineNumber: 120
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */],
          {
            styleName: "blackOutlined",
            fullWidth: true,
            onClick: onClose,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 124
            }
          },
          "Update Search"
        )
      )
    );
  };

  return OffersFilters;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

OffersFilters.displayName = "OffersFilters";


/* harmony default export */ __webpack_exports__["a"] = (OffersFilters);

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OffersFilters":"OffersFilters__OffersFilters___1Z44X","OffersFiltersLabel":"OffersFilters__OffersFiltersLabel___2hWKf","OffersFiltersTabletClose":"OffersFilters__OffersFiltersTabletClose___xFW7V","OffersFiltersTabletUpdate":"OffersFilters__OffersFiltersTabletUpdate___2qY2K","OffersFiltersTablet":"OffersFilters__OffersFiltersTablet___2lX47"};

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OfferTile":"OfferTile__OfferTile___omte4","OfferTileVehicle":"OfferTile__OfferTileVehicle___1LGAs","OfferTileImage":"OfferTile__OfferTileImage___2D2jq","OfferTileContent":"OfferTile__OfferTileContent___q-SB8","OfferTileButtons":"OfferTile__OfferTileButtons___3EuD1","OfferTileFeatured":"OfferTile__OfferTileFeatured___11LHm"};

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OutletStoreEnquiryForm":"OutletStoreEnquiryForm__OutletStoreEnquiryForm___MpiRT","OutletStoreEnquiryFormText":"OutletStoreEnquiryForm__OutletStoreEnquiryFormText___262E4","requiredStar":"OutletStoreEnquiryForm__requiredStar___CPkc6","OutletStoreEnquiryFormDealer":"OutletStoreEnquiryForm__OutletStoreEnquiryFormDealer___1Dz0F","OutletStoreEnquiryFormDealerPrice":"OutletStoreEnquiryForm__OutletStoreEnquiryFormDealerPrice___3Myti","OutletStoreEnquiryFormDealerMobile":"OutletStoreEnquiryForm__OutletStoreEnquiryFormDealerMobile___ZH9kw","OutletStoreEnquiryFormForm":"OutletStoreEnquiryForm__OutletStoreEnquiryFormForm___27IFw"};

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TITLES = "Mr|Mrs|Ms|Miss|Dr|Master|Prof".split("|").map(function (label) {
  return {
    label: label,
    value: label
  };
});

/* harmony default export */ __webpack_exports__["a"] = (TITLES);

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PDFTemplate":"PDFTemplate__PDFTemplate___1X1tT","PDFTemplateHeader":"PDFTemplate__PDFTemplateHeader___WJWfn","PDFTemplateFooter":"PDFTemplate__PDFTemplateFooter___27j0x"};

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Price":"Price__Price___2gcSD","PriceText":"Price__PriceText___sWoZm","PriceWhite":"Price__PriceWhite___74PHd"};

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"RecallDetail":"RecallDetail__RecallDetail___2ljZh","RecallDetailHeading":"RecallDetail__RecallDetailHeading___2p01Z","WithoutPadding":"RecallDetail__WithoutPadding___4vX6e","RecallDetailHeadingSection":"RecallDetail__RecallDetailHeadingSection___1ykZE","RecallDetailHeadingLabel":"RecallDetail__RecallDetailHeadingLabel___HjXID","RecallDetailStatus":"RecallDetail__RecallDetailStatus___nV4BM","RecallDetailStatusAmber":"RecallDetail__RecallDetailStatusAmber___1J0FX","RecallDetailStatusRed":"RecallDetail__RecallDetailStatusRed___1fDzf"};

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"RecallDocument":"RecallDocument__RecallDocument___28M-u","RecallResult":"RecallDocument__RecallResult___mHm4X","RecallDocumentInfo":"RecallDocument__RecallDocumentInfo___2harq","RecallBoxParent":"RecallDocument__RecallBoxParent___p9YVn","RecallBox":"RecallDocument__RecallBox___1SAs4","RecallBoxHeading":"RecallDocument__RecallBoxHeading___tv8v0","RecallBoxHeadingRED":"RecallDocument__RecallBoxHeadingRED___2IHfr","RecallBoxHeadingGREEN":"RecallDocument__RecallBoxHeadingGREEN___1j7DC","RecallActivePending":"RecallDocument__RecallActivePending___1MMD3","RecallActivePendingMiddle":"RecallDocument__RecallActivePendingMiddle___2WLvX","RecallActivePendingInfo":"RecallDocument__RecallActivePendingInfo___TCkJ-","RecallBoxButtons":"RecallDocument__RecallBoxButtons___3am0A","RecallBoxButtonsOneButton":"RecallDocument__RecallBoxButtonsOneButton___qUR92","RecallWhiteSpace":"RecallDocument__RecallWhiteSpace___1QAy9","RecallActivities":"RecallDocument__RecallActivities___3pXwW","RecallDetail":"RecallDocument__RecallDetail___2Ilz0","RecallDetailBorder":"RecallDocument__RecallDetailBorder___3BZXT","RecallBoxBottomButtons":"RecallDocument__RecallBoxBottomButtons___pW24R"};

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Recall":"Recall__Recall___1YckP","RecallFormSection":"Recall__RecallFormSection___GWgw-","Form":"Recall__Form___1yEL-","FormInput":"Recall__FormInput___1vHN2","FormInputButton":"Recall__FormInputButton___2sahr"};

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"RegisterInterest":"RegisterInterestForm__RegisterInterest___1sVNk","RegisterInterestForm":"RegisterInterestForm__RegisterInterestForm___LhVx7","RegisterInterestFormText":"RegisterInterestForm__RegisterInterestFormText___1ZpQG","requiredStar":"RegisterInterestForm__requiredStar___2FWoi"};

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TITLES = "Mr|Mrs|Ms|Miss|Dr|Master|Prof".split("|").map(function (label) {
  return {
    label: label,
    value: label
  };
});

/* harmony default export */ __webpack_exports__["a"] = (TITLES);

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SaveForm":"SaveForm__SaveForm___1reQZ","SaveFormForm":"SaveForm__SaveFormForm___1lY7R","SaveFormImage":"SaveForm__SaveFormImage___2HbMC","SaveFormText":"SaveForm__SaveFormText___3j7Vr","requiredStar":"SaveForm__requiredStar___2ZA-d"};

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ShareSection":"SaveShareCopy__ShareSection___2r2ab","ShareSectionDisabled":"SaveShareCopy__ShareSectionDisabled___1EhpY","ShareSectionColumn":"SaveShareCopy__ShareSectionColumn___1z8_D","ShareSectionText":"SaveShareCopy__ShareSectionText___1C8sY"};

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ShareForm":"ShareForm__ShareForm___9RkfK","ShareFormForm":"ShareForm__ShareFormForm___EwSFc","ShareFormTrigger":"ShareForm__ShareFormTrigger___3_PoN","floating":"ShareForm__floating___30Rt7","ShareFormImage":"ShareForm__ShareFormImage___3_g5j"};

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ColumnParent":"SixtyFourtyBlock__ColumnParent___EyYsU","Media":"SixtyFourtyBlock__Media___KyhMh","MediaImage":"SixtyFourtyBlock__MediaImage___3V6Yo","MediaImageLarge":"SixtyFourtyBlock__MediaImageLarge___zXjBL","MediaImageMedium":"SixtyFourtyBlock__MediaImageMedium___M_sut","MediaImageSmall":"SixtyFourtyBlock__MediaImageSmall___1dBPG","MediaImageInitial":"SixtyFourtyBlock__MediaImageInitial___2-hMo","Content":"SixtyFourtyBlock__Content___uU2cL","ContentCenter":"SixtyFourtyBlock__ContentCenter___odvl4"};

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Slideshow_less__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Slideshow_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Slideshow_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Slideshow\\Slideshow.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Slideshow = function (_React$Component) {
  _inherits(Slideshow, _React$Component);

  function Slideshow(props) {
    _classCallCheck(this, Slideshow);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._handleDown = function (e) {
      var screenX = 0;
      if (e.screenX) screenX = e.screenX;
      if (e.touches && e.touches[0] && e.touches[0].clientX) screenX = e.touches[0].clientX;
      _this.setState({
        xStart: screenX
      });
    };

    _this._handleUp = function (e) {
      var xEnd = 0;
      if (e.screenX) xEnd = e.screenX;
      if (e.changedTouches && e.changedTouches[0] && e.changedTouches[0].clientX) xEnd = e.changedTouches[0].clientX;
      _this.setState({
        xEnd: xEnd
      }, function () {
        var _this$state = _this.state,
            xStart = _this$state.xStart,
            xEnd = _this$state.xEnd,
            activeIndex = _this$state.activeIndex;
        var slides = _this.props.slides;

        if (xStart - xEnd > 30 && activeIndex < slides.length - 1) {
          _this._handleClick(activeIndex + 1);
        } else if (xEnd - xStart > 30 && activeIndex > 0) {
          _this._handleClick(activeIndex - 1);
        }
      });
    };

    _this._handleClick = function (activeIndex) {
      var callOnClickOfParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props$onClick = _this.props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick;

      _this.setState({
        activeIndex: activeIndex
      }, function () {
        if (callOnClickOfParent) onClick(activeIndex);
      });
    };

    _this.state = {
      activeIndex: props.activeIndex || 0,
      xStart: 0,
      xEnd: 0
    };
    return _this;
  }

  Slideshow.prototype.componentDidMount = function componentDidMount() {
    var activeIndex = this.props.activeIndex;

    if (this.slideshow) {
      this.slideshow.addEventListener("mousedown", this._handleDown);
      this.slideshow.addEventListener("touchstart", this._handleDown);

      this.slideshow.addEventListener("mouseup", this._handleUp);
      this.slideshow.addEventListener("touchend", this._handleUp);
    }

    // we don't want to call the parent if slideshow is just updated
    // from outside
    this._handleClick(activeIndex || 0, false);
  };

  // ComponentWillRecieveProps is depricated!


  Slideshow.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var activeIndex = this.props.activeIndex;

    if (activeIndex !== prevProps.activeIndex) {
      this.setState({
        activeIndex: activeIndex
      });
    }
  };

  Slideshow.prototype.render = function render() {
    var _classnames,
        _this2 = this,
        _classnames2;

    var _props = this.props,
        slides = _props.slides,
        _props$dotsEnabled = _props.dotsEnabled,
        dotsEnabled = _props$dotsEnabled === undefined ? true : _props$dotsEnabled,
        _props$contain = _props.contain,
        contain = _props$contain === undefined ? false : _props$contain;
    var activeIndex = this.state.activeIndex;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Slideshow_less___default.a.Slideshow] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Slideshow_less___default.a.SlideshowContain] = contain, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 90
        }
      },
      slides && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { ref: function ref(c) {
            return _this2.slideshow = c;
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          }
        },
        slides[activeIndex].imageSrc && !(slides[activeIndex].youtubeId || slides[activeIndex].youtubeLink) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["o" /* Image */], {
          contain: contain,
          src: slides[activeIndex].imageSrc,
          height: 300,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 100
          }
        }),
        (slides[activeIndex].youtubeId || slides[activeIndex].youtubeLink) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_24" /* YoutubePlayer */], {
          youtubeId: slides[activeIndex].youtubeId,
          youtubeLink: !slides[activeIndex].youtubeId && slides[activeIndex].youtubeLink,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 108
          }
        })
      ),
      dotsEnabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "ul",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Slideshow_less___default.a.dots] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 116
          }
        },
        slides.map(function (item, index) {
          var _classnames3;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { key: "Slides-" + index, __source: {
                fileName: _jsxFileName,
                lineNumber: 121
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */], {
              withoutStyle: true,
              onClick: function onClick() {
                return _this2._handleClick(index);
              },
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__Slideshow_less___default.a.dotSingle] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_2__Slideshow_less___default.a.dotSingleActive] = activeIndex === index, _classnames3)),
              __source: {
                fileName: _jsxFileName,
                lineNumber: 122
              }
            })
          );
        })
      )
    );
  };

  return Slideshow;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Slideshow.displayName = "Slideshow";


/* harmony default export */ __webpack_exports__["a"] = (Slideshow);

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Slideshow":"Slideshow__Slideshow___5aSaF","SlideshowContain":"Slideshow__SlideshowContain___i72Sp","dots":"Slideshow__dots___EdEXM","dotSingle":"Slideshow__dotSingle___26-tC","dotSingleActive":"Slideshow__dotSingleActive___3rsyz"};

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SpecificationsBlock":"SpecificationsBlock__SpecificationsBlock___1hib8","dots":"SpecificationsBlock__dots___1nyu2","dotSingle":"SpecificationsBlock__dotSingle___3xsUV","dotSingleActive":"SpecificationsBlock__dotSingleActive___105GN","Description":"SpecificationsBlock__Description___2cpk0","DescriptionName":"SpecificationsBlock__DescriptionName___3jSOr","DescriptionContent":"SpecificationsBlock__DescriptionContent___3l4D2","DescriptionSingleSpecs":"SpecificationsBlock__DescriptionSingleSpecs___31wwJ","GreyDark":"SpecificationsBlock__GreyDark___1M1AL","DescriptionSingleSpecsDisclaimer":"SpecificationsBlock__DescriptionSingleSpecsDisclaimer___2NYym"};

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"StickyNav":"StickyNav__StickyNav___1VYhS","StickyNavImage":"StickyNav__StickyNavImage___39633","StickyNavImageIE":"StickyNav__StickyNavImageIE___9upor","StickyNavItems":"StickyNav__StickyNavItems___3sIS7","StickyNavButton":"StickyNav__StickyNavButton___3_z-p"};

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tabs_less__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tabs_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tabs_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_debounce__ = __webpack_require__(47);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Tabs\\Tabs.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Tabs = function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._setDimension = function () {
      if (_this.tabsUL && _this.tabsUL.scrollWidth <= _this.tabs.offsetWidth) {
        _this.setState({
          justifyContent: 'center',
          calculated: true
        });
      } else {
        _this.setState({
          justifyContent: 'left',
          calculated: true
        });
        if (_this.tabsUL) {
          _this.tabsUL.style.marginLeft = "0px";
        }
      }
    };

    _this._handleClick = function (activeIndex) {
      var callOnClickOfParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props = _this.props,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick,
          scrolling = _this$props.scrolling,
          manualScroll = _this$props.manualScroll;
      var isIE = _this.state.isIE;

      var shouldScroll = activeIndex !== _this.state.activeIndex;

      _this.setState({
        activeIndex: Number(activeIndex)
      }, function () {
        if (callOnClickOfParent) onClick(activeIndex);

        // handling scrolling tor right if scrolling is enabled
        if (scrolling && _this.tabs && _this.tabsUL && _this.tabsUL.children && _this.tabsUL.children.length && shouldScroll) {
          var unitSize = _this.tabsUL.children[activeIndex].offsetWidth;
          var maxMarginLeftPossible = _this.tabsUL.scrollWidth - _this.tabs.offsetWidth;
          var currentMarginLeft = Number(_this.tabsUL.style.marginLeft.replace('px', '')) * -1;
          var unitScrollLeft = _this.tabsUL.children[activeIndex].offsetLeft;
          var centerMargin = (_this.tabs.offsetWidth - unitSize) / 2;

          if (_this.tabsUL.children[activeIndex]) {
            if (unitScrollLeft < centerMargin) {
              _this.tabsUL.style.marginLeft = "-" + Math.max(0, currentMarginLeft - centerMargin) + "px";
            } else if (unitScrollLeft > centerMargin + unitSize) {
              _this.tabsUL.style.marginLeft = "-" + Math.min(maxMarginLeftPossible, currentMarginLeft + centerMargin) + "px";
            }
          }
        }

        // Smooth scrolling does not work on IE (and is not needed as well)
        if (manualScroll && !isIE && _this.tabs && _this.tabsUL && _this.tabsUL.children && _this.tabsUL.children.length && shouldScroll) {
          var _unitSize = _this.tabsUL.children[activeIndex].offsetWidth;
          var _unitScrollLeft = _this.tabsUL.children[activeIndex].offsetLeft;
          var currentScrollLeft = _this.tabs.scrollLeft;

          if (_this.tabsUL.children[activeIndex]) {
            if (_unitScrollLeft < currentScrollLeft) {
              _this.tabs.scroll({ left: _unitScrollLeft - 75, behavior: 'smooth' });
            } else if (_unitScrollLeft + _unitSize > currentScrollLeft + _this.tabs.offsetWidth) {
              _this.tabs.scroll({ left: _unitScrollLeft + _unitSize - _this.tabs.offsetWidth + 75, behavior: 'smooth' });
            }
          }
        }
      });
    };

    _this.state = {
      activeIndex: props.activeIndex || props.active,
      calculated: false,
      justifyContent: 'center',
      isIE: false
    };
    _this.tabs = null;
    _this.tabsUL = null;
    return _this;
  }

  Tabs.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        activeIndex = _props.activeIndex,
        scrolling = _props.scrolling,
        active = _props.active;

    this.setState({
      isIE: __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["d" /* IS_IE */] || __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["c" /* IS_EDGE */]
    }, function () {
      _this2._handleClick(activeIndex || active || 0, false);
    });
    if (scrolling) {
      setTimeout(function () {
        _this2._setDimension();
        __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_debounce__["a" /* default */])(_this2._setDimension, 250));
      }, 250);
    }
  };

  Tabs.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var newActive = this.state.activeIndex;
    if (typeof this.props.active !== "undefined") {
      newActive = Number(this.props.active);
    } else if (typeof this.props.activeIndex !== "undefined") {
      newActive = Number(this.props.activeIndex);
    }
    var oldActive = Number(prevState.activeIndex);

    if (!isNaN(newActive) && !isNaN(oldActive) && newActive !== oldActive) {
      this._handleClick(newActive, false);
    }
  };

  Tabs.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_2_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_debounce__["a" /* default */])(this._setDimension, 250));
  };

  Tabs.prototype.render = function render() {
    var _this3 = this,
        _classnames,
        _classnames2;

    // animatedLine is the redline!
    var _props2 = this.props,
        options = _props2.options,
        _props2$animatedLine = _props2.animatedLine,
        animatedLine = _props2$animatedLine === undefined ? false : _props2$animatedLine,
        _props2$activeLineOnl = _props2.activeLineOnly,
        activeLineOnly = _props2$activeLineOnl === undefined ? false : _props2$activeLineOnl,
        _props2$divider = _props2.divider,
        divider = _props2$divider === undefined ? false : _props2$divider,
        scrolling = _props2.scrolling,
        _props2$manualScroll = _props2.manualScroll,
        manualScroll = _props2$manualScroll === undefined ? false : _props2$manualScroll,
        children = _props2.children,
        numberOfWrappedItems = _props2.numberOfWrappedItems,
        _props2$limited = _props2.limited,
        limited = _props2$limited === undefined ? true : _props2$limited;


    var model = 0; // means options and 1 means read children

    if (options && options.length > 0) model = 0;else if (children && children.length > 0) model = 1;

    var tabItems = model === 1 ? children : options;

    var _state = this.state,
        activeIndex = _state.activeIndex,
        calculated = _state.calculated,
        justifyContent = _state.justifyContent;


    var liStyle = {};
    if (numberOfWrappedItems && numberOfWrappedItems > 1) {
      liStyle = {
        minWidth: 100 / numberOfWrappedItems + "%"
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        ref: function ref(c) {
          return _this3.tabs = c;
        },
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.Tabs] = true, _classnames[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.TabsScrolling] = scrolling, _classnames[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.TabsManualScroll] = manualScroll, _classnames[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.TabsScrollingCenter] = justifyContent === 'center', _classnames[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.TabsScrollingCalculated] = calculated, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 151
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "ul",
        {
          ref: function ref(c) {
            return _this3.tabsUL = c;
          },
          "data-test": "tabs",
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.TabsUL] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 160
          }
        },
        tabItems && tabItems.length > 0 && tabItems.map(function (item, index) {
          var _classnames3, _classnames4, _classnames5, _classnames6;

          if (model === 0 && !item.name) return;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              key: "Tabs-" + index,
              "data-test": "tab-item",
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.TabsLI] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.TabsLILimited] = limited && model === 0 && item.name.length > 15, _classnames3)),
              style: liStyle,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 169
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
              {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.Link] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.LinkWithChildren] = model === 1, _classnames4[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.LinkLine] = animatedLine, _classnames4[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.LineLineTransparent] = activeLineOnly, _classnames4[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.LinkActive] = index === activeIndex, _classnames4[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.IgnoreUppercase] = !!item.ignoreUppercase, _classnames4)),
                onClick: function onClick(element) {
                  _this3._handleClick(index);
                },
                withoutStyle: true,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 178
                }
              },
              model === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
                {
                  withDetails: true,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 191
                  }
                },
                item.name
              ),
              model === 1 && item
            ),
            divider && tabItems.length - 1 !== index && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.Divider] = true, _classnames5)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 201
                }
              },
              " | "
            ),
            item.extraLabel && index === activeIndex && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_3__Tabs_less___default.a.ExtraLabel] = true, _classnames6)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 207
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { withDetails: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 210
                  }
                },
                item.extraLabel
              )
            )
          );
        })
      )
    );
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tabs.displayName = "Tabs";


/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Tabs":"Tabs__Tabs___37XRY","TabsUL":"Tabs__TabsUL___i_OXR","TabsLI":"Tabs__TabsLI___11Oly","Link":"Tabs__Link___1nNPr","LinkLine":"Tabs__LinkLine___3-2qP","LinkActive":"Tabs__LinkActive___2-LWa","LineLineTransparent":"Tabs__LineLineTransparent___Xyn71","LinkWithChildren":"Tabs__LinkWithChildren___3Kc3B","IgnoreUppercase":"Tabs__IgnoreUppercase___3xqp1","Divider":"Tabs__Divider___2DJk2","ExtraLabel":"Tabs__ExtraLabel___3EgSd","TabsLILimited":"Tabs__TabsLILimited___2rmhH","TabsScrolling":"Tabs__TabsScrolling___3E-5p","TabsScrollingCenter":"Tabs__TabsScrollingCenter___1bq_3","TabsScrollingCalculated":"Tabs__TabsScrollingCalculated___2QcuT","TabsManualScroll":"Tabs__TabsManualScroll___153Ui"};

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tooltip_less__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tooltip_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicContainers\\Tooltip\\Tooltip.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Tooltip = function (_React$PureComponent) {
  _inherits(Tooltip, _React$PureComponent);

  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._handleClose = function (event) {
      _this.setState({
        show: false
      });
    };

    _this.state = {
      show: false
    };
    return _this;
  }

  Tooltip.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      show: true
    });
  };

  Tooltip.prototype.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4;

    var _props = this.props,
        children = _props.children,
        _props$position = _props.position,
        position = _props$position === undefined ? 'bottomRight' : _props$position,
        _props$closeIcon = _props.closeIcon,
        closeIcon = _props$closeIcon === undefined ? true : _props$closeIcon,
        _props$size = _props.size,
        size = _props$size === undefined ? 'medium' : _props$size;
    var show = this.state.show;


    if (!show) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 39
      }
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.Tooltip] = true, _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipSmall] = size === 'small', _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipMedium] = size === 'medium', _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipLarge] = size === 'large', _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipBottomRight] = position === 'bottomRight', _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipBottomLeft] = position === 'bottomLeft', _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipTopRight] = position === 'topRight', _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipTopLeft] = position === 'topLeft', _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipTopCenter] = position === 'topCenter', _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipBottomCenter] = position === 'bottomCenter', _classnames[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipWithCloseIcon] = closeIcon, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      },
      closeIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipIcon] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 57
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["k" /* ButtonIcon */],
          {
            onClick: this._handleClose,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 60
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["u" /* CrossIcon */], { style: {
              width: "10px",
              height: "10px"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 63
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.TooltipTriangle] = true, _classnames3)), __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_3__Tooltip_less___default.a.Children] = true, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 73
          }
        },
        children
      )
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Tooltip.displayName = "Tooltip";


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Tooltip":"Tooltip__Tooltip___pvJP-","TooltipTriangle":"Tooltip__TooltipTriangle___3hcCu","TooltipSmall":"Tooltip__TooltipSmall___307i2","TooltipMedium":"Tooltip__TooltipMedium___TxQf7","TooltipLarge":"Tooltip__TooltipLarge___Ii0ik","TooltipTopRight":"Tooltip__TooltipTopRight___3KsKd","TooltipBottomRight":"Tooltip__TooltipBottomRight___3SHFz","TooltipTopLeft":"Tooltip__TooltipTopLeft___Aauzw","TooltipBottomLeft":"Tooltip__TooltipBottomLeft___3BeTN","TooltipTopCenter":"Tooltip__TooltipTopCenter___1NQmL","TooltipBottomCenter":"Tooltip__TooltipBottomCenter___2vxOK","TooltipWithCloseIcon":"Tooltip__TooltipWithCloseIcon___ek13J","Children":"Tooltip__Children___KReP_","TooltipIcon":"Tooltip__TooltipIcon___2AMs7"};

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"VehicleNotFoundPage":"VehicleNotFoundPage__VehicleNotFoundPage___BMjhj","VehicleNotFoundPageVehicle":"VehicleNotFoundPage__VehicleNotFoundPageVehicle___eCfIF"};

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"VideoPlayer":"VideoPlayer__VideoPlayer___1p3x9","VideoParent":"VideoPlayer__VideoParent___29o6z","Video":"VideoPlayer__Video___2qOdm","Icon":"VideoPlayer__Icon___HXEBt","IconRight":"VideoPlayer__IconRight___1YDYD","IconLeft":"VideoPlayer__IconLeft___hK5D1"};

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Card":"Card__Card___1saPf","CardFeatured":"Card__CardFeatured___hry0i","CardLink":"Card__CardLink___30OuT","CardOutline":"Card__CardOutline___1tF-I","CardTransparent":"Card__CardTransparent___3DBSg","FirstSection":"Card__FirstSection___1OVAO","FirstSectionContain":"Card__FirstSectionContain___1yEmh","FirstSectionDisclaimer":"Card__FirstSectionDisclaimer___24CfB","SecondSection":"Card__SecondSection___9RK9L","CardWithLink":"Card__CardWithLink___3oGU4","CardAreaContent":"Card__CardAreaContent___3kZBa","ThirdSection":"Card__ThirdSection___34tI6","ThirdSectionLink":"Card__ThirdSectionLink___3gYLD"};

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Section":"Section__Section___MPokR","SectionBorder":"Section__SectionBorder___16rJU","SectionDivider":"Section__SectionDivider___2plaR","horizontalPadding":"Section__horizontalPadding___21im-","verticalPadding":"Section__verticalPadding___2fkst","gutterPadding":"Section__gutterPadding___3pL97","ContainerInsideSection":"Section__ContainerInsideSection___3Ia5p","Center":"Section__Center___2QZFw"};

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Container":"Container__Container___JtIeY","ContainerScreen":"Container__ContainerScreen___3c8j9","ContainerTabletWide":"Container__ContainerTabletWide___fqMoN","ContainerTabletNormal":"Container__ContainerTabletNormal___K_zGb","ContainerMobile":"Container__ContainerMobile___3YSC9"};

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ColumnGroup":"ColumnGroup__ColumnGroup___2r1td","ColumnGroup__ReverseDesktop":"ColumnGroup__ColumnGroup__ReverseDesktop___2smpY","ColumnGroup__ReverseMobile":"ColumnGroup__ColumnGroup__ReverseMobile___2N2Ij","ColumnGroupItem":"ColumnGroup__ColumnGroupItem___2LiIt"};

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* unused harmony export gtmEvents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__ = __webpack_require__(15);
var _gtmEvents;



var gtmEventTypes = {
  WAIT_MAZDA: "WAIT_MAZDA",
  OWN_MAZDA: "OWN_MAZDA",
  DONT_OWN_MAZDA: "DONT_OWN_MAZDA",
  NEXT_STEP: "NEXT_STEP",
  STEP_GO_BACK: "STEP_GO_BACK",
  ENTER_EMAIL: "FED-MYMAZDA_ENTER_EMAIL",
  ENTER_PASSWORD: "ENTER_PASSWORD",
  REGISTER: "REGISTER"
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.WAIT_MAZDA] = function () {
  return {
    type: gtmEventTypes.WAIT_MAZDA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.WAIT_MAZDA,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Waiting on a mazda"
  };
}, _gtmEvents[gtmEventTypes.OWN_MAZDA] = function () {
  return {
    type: gtmEventTypes.OWN_MAZDA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.OWN_MAZDA,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Own mazda"
  };
}, _gtmEvents[gtmEventTypes.DONT_OWN_MAZDA] = function () {
  return {
    type: gtmEventTypes.DONT_OWN_MAZDA,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.DONT_OWN_MAZDA,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Don't Own mazda"
  };
}, _gtmEvents[gtmEventTypes.NEXT_STEP] = function () {
  return {
    type: gtmEventTypes.NEXT_STEP,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.NEXT_STEP,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Next step"
  };
}, _gtmEvents[gtmEventTypes.STEP_GO_BACK] = function () {
  return {
    type: gtmEventTypes.STEP_GO_BACK,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.STEP_GO_BACK,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Go back a step"
  };
}, _gtmEvents[gtmEventTypes.ENTER_EMAIL] = function () {
  return {
    type: gtmEventTypes.ENTER_EMAIL,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_EMAIL,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Entered \"EMAIL\""
  };
}, _gtmEvents[gtmEventTypes.ENTER_PASSWORD] = function () {
  return {
    type: gtmEventTypes.ENTER_PASSWORD,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_PASSWORD,
    pageCategory: "MyMazda Create password Form",
    pageAction: "MyMazda Register Form - Entered \"Password\""
  };
}, _gtmEvents[gtmEventTypes.REGISTER] = function () {
  return {
    type: gtmEventTypes.REGISTER,
    event: "reactjs.event",
    userId: new __WEBPACK_IMPORTED_MODULE_0_AtomicUtils_cookieHandler__["a" /* default */]().getCookie("userId"),
    eventID: gtmEventTypes.REGISTER,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Register"
  };
}, _gtmEvents);

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Build_less__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Build_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Build_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\build\\singularity-bar.jsx";










/* Singularity Bar Component. */
var SingularityBar = function SingularityBar(_ref) {
  var _classnames;

  var src = _ref.src,
      summary = _ref.summary,
      compact = _ref.compact,
      nameplate = _ref.nameplate,
      grade = _ref.grade,
      hidden = _ref.hidden,
      includeSafetyModel = _ref.includeSafetyModel,
      price = _ref.price,
      disclaimer = _ref.disclaimer,
      children = _ref.children,
      gtmEvents = _ref.gtmEvents,
      innerRef = _ref.innerRef,
      components = _ref.components;

  var currentPrice = ((price || {}).data || [])[0] || {};
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { "data-test": "singularity-bar", __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_containers__["n" /* FixedBar */],
      { innerRef: innerRef, __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        }
      },
      !summary ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: styles.left // Display nothing here if it reaches the summary step
          , __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        },
        !summary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: styles.vehicle, src: src, __source: {
            fileName: _jsxFileName,
            lineNumber: 36
          }
        }),
        compact && !summary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              textTransform: "uppercase",
              flexBasis: "100%",
              padding: ".125em 0 0",
              fontWeight: 600
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 39
            }
          },
          nameplate
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.price, __source: {
              fileName: _jsxFileName,
              lineNumber: 49
            }
          },
          !hidden && !currentPrice.price && !summary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: [styles.hidden, styles.animate], __source: {
                fileName: _jsxFileName,
                lineNumber: 53
              }
            },
            currentPrice.message
          ),
          (!hidden && !!currentPrice.price || compact && summary) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.grade, __source: {
                fileName: _jsxFileName,
                lineNumber: 56
              }
            },
            " ",
            grade,
            " "
          ),
          (!hidden && !!currentPrice.price || compact && summary) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.divider, __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          }),
          (!hidden && !!currentPrice.price || compact && summary) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.animate, __source: {
                fileName: _jsxFileName,
                lineNumber: 62
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.small, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 63
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "small",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 64
                  }
                },
                "RRP FROM"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: styles.priceValue, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 66
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { whiteSpace: "noWrap" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 67
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["a" /* A */],
                  {
                    withoutStyle: true,
                    style: { fontSize: "26px" },
                    onClick: function onClick(event) {
                      if (event && event.target && event.target.querySelector('button')) {
                        event.target.querySelector('button').click();
                      }
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 68
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "sup",
                    { style: { lineHeight: 0.5, fontSize: "12px" }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 76
                      }
                    },
                    "$"
                  ),
                  !!currentPrice.price && includeSafetyModel ? currentPrice.safetyModelPrice.toLocaleString() : currentPrice.price.toLocaleString(),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_AtomicContainers__["i" /* Disclaimer */],
                    { Icon: __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["_14" /* StarIcon */], __source: {
                        fileName: _jsxFileName,
                        lineNumber: 78
                      }
                    },
                    currentPrice.disclaimer
                  )
                )
              )
            )
          )
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 89
        }
      }) // This div is to ensure there's alway a div rendered here in the summary step where we display nothing, just to keep the CTA button on the right
      ,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5__Build_less___default.a.ButtonsInside] = true, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 92
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_3_containers_utilities__["a" /* childParser */])({ children: children, components: components })
      )
    )
  );
};

SingularityBar.displayName = "SingularityBar";
SingularityBar.displayName = "SingularityBar";
SingularityBar.propTypes = {
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  grade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
    price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(SingularityBar));

var dropOutKeyframes = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["b" /* keyframes */])({
  from: {
    opacity: 0,
    top: ".5em"
  },
  to: {
    opacity: 1,
    top: 0
  }
});

var styles = {
  left: {
    display: "flex",
    marginLeft: "1em",
    flexWrap: "wrap"
  },
  right: {
    display: "flex",
    flex: "1 0 50vw",
    justifyContent: "flex-end",
    "@media (min-width: 768px)": {
      display: "flex",
      minWidth: '360px',
      flex: 'none',
      justifyContent: "space-between"
    }
  },
  vehicle: {
    display: "none",
    "@media (min-width: 768px)": {
      width: "auto",
      height: "4em",
      display: "block",
      margin: "auto 1em auto 0"
    }
  },
  hidden: {
    color: "#999",
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "90%",
    letterSpacing: ".2em"
  },
  grade: {
    color: "#999",
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "90%",
    letterSpacing: ".2em",
    maxWidth: "200px",
    "@media (max-width: 768px)": {
      display: "none"
    }
  },
  divider: {
    display: "inline-block",
    width: "1px",
    height: "2.4em",
    margin: "0 1em",
    verticalAlign: "middle",
    background: "#d5d5d5",
    "@media (max-width: 768px)": {
      display: "none"
    }
  },
  price: {
    display: "flex",
    alignItems: "center"
  },
  small: {
    marginBottom: ".25em"
  },
  priceValue: {
    fontSize: "1.6em",
    fontWeight: "300"
  },
  /**
   * Radium x Safari keyframe animation bug
   * @todo find a solution to keyframe animations not triggering on Safari
  */
  animate: {
    // animation: 'x .666s forwards',
    // animationName: dropOutKeyframes,
    // opacity: 0,
    position: "relative"
  }
};

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ButtonsInside":"Build__ButtonsInside___2GY6l"};

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\build\\build-compact-nav.jsx";



var BuildCompactNav = function BuildCompactNav(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.base, __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { onClick: props.back, style: styles.icon, __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      props.active !== 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["f" /* ArrowLeftThinIcon */], { style: styles.icon, __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["D" /* H6 */],
      { withDetails: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      props.title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { onClick: props.reload, style: styles.icon, __source: {
          fileName: _jsxFileName,
          lineNumber: 13
        }
      },
      props.active !== 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_5" /* RestartIcon */], { style: styles.icon, __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      })
    )
  );
};

BuildCompactNav.displayName = "BuildCompactNav";
BuildCompactNav.displayName = "BuildCompactNav";
var styles = {
  base: {
    display: "flex",
    width: "100%",
    overflow: "hidden",
    background: "#fff",
    justifyContent: "space-between",
    borderBottom: "1px solid #e5e5e5",
    padding: "1em",
    boxSizing: "border-box",
    position: "relative",
    zIndex: "5"
  },
  icon: {
    width: "22px",
    height: "22px",
    display: "block",
    color: "#999999",
    cursor: "pointer"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (BuildCompactNav);

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\build\\build-body-step.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var BuildBodyStep = function (_Component) {
  _inherits(BuildBodyStep, _Component);

  function BuildBodyStep() {
    var _temp, _this, _ret;

    _classCallCheck(this, BuildBodyStep);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._renderToggles = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 12
          }
        },
        _this.props.stepData.radioGroup.map(function (radio, index) {
          var props = {
            onChange: _this.props.handleChangeOption,
            options: _this.props.options[radio.groupName],
            active: _this.props.options[radio.groupName].indexOf(_this.props.options[radio.itemName]),
            only: _this.props.options[radio.groupName].length <= 1
          };
          if (index === 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, style: { marginBottom: '1em' }, 'data-test': radio.groupName, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 22
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({ animatedLine: true, primary: true }, props, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 23
                }
              }))
            );
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              key: index,
              style: { display: 'inline-block', marginBottom: '1em' },
              'data-test': radio.groupName, __source: {
                fileName: _jsxFileName,
                lineNumber: 28
              }
            },
            index === _this.props.stepData.radioGroup.length - 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: stepStyles.divider, __source: {
                fileName: _jsxFileName,
                lineNumber: 33
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, style: { display: 'inline-block' }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 35
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({ divider: true }, props, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 36
                }
              }))
            )
          );
        })
      );
    }, _this._renderCompact = function () {
      var currentPrice = ((_this.props.price || {}).data || [])[0] || {};
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["O" /* RenderConfiguredVehicleCompact */], {
          display360: _this.props.display360,
          step: _this.props.stepData,
          isSelectColorInterior: _this.props.selectColorInterior,
          options: _this.props.options,
          onChange: _this.props.handleChangeOption,
          currentPriceArray: currentPrice,
          showDescription: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        })
      );
    }, _this._render = function () {
      var currentPrice = ((_this.props.price || {}).data || [])[0] || {};
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 63
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: stepStyles.stepHeader, __source: {
              fileName: _jsxFileName,
              lineNumber: 64
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["D" /* H6 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 65
              }
            },
            _this.props.mainHeading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["z" /* H2 */],
            {
              withDetails: true,
              align: 'center',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 68
              }
            },
            _this.props.stepData.heading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 74
            }
          }),
          _this._renderToggles()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: '0em 15vw' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["N" /* RenderConfiguredVehicle */], {
            display360: _this.props.display360,
            step: _this.props.stepData,
            isSelectColorInterior: Boolean(_this.props.selectColorInterior),
            options: _this.props.options,
            onChange: _this.props.handleChangeOption,
            selectIndex: _this.props.stepData.colorSelector && (_this.props.selectColorInterior ? 1 : 0),
            showDescription: true,
            background: !_this.props.stepData.fullWidth, __source: {
              fileName: _jsxFileName,
              lineNumber: 78
            }
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  BuildBodyStep.prototype.render = function render() {
    return this.props.compact ? this._renderCompact() : this._render();
  };

  return BuildBodyStep;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BuildBodyStep.displayName = 'BuildBodyStep';

/* harmony default export */ __webpack_exports__["a"] = (BuildBodyStep);

var stepStyles = {
  divider: {
    height: '2em',
    width: '1px',
    margin: '0px 1.8em 0 1.7em',
    background: '#cbcbcb',
    transform: 'rotate(30deg)',
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  stepHeader: {
    paddingTop: '30px',
    minHeight: '20vh'
  }
};

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\build\\build-drive-step.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var BuildDriveStep = function (_Component) {
  _inherits(BuildDriveStep, _Component);

  function BuildDriveStep() {
    var _temp, _this, _ret;

    _classCallCheck(this, BuildDriveStep);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._renderToggles = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 12
          }
        },
        _this.props.stepData.radioGroup.map(function (radio, index) {
          var props = {
            onChange: _this.props.handleChangeOption,
            options: _this.props.options[radio.groupName],
            active: _this.props.options[radio.groupName].indexOf(_this.props.options[radio.itemName]),
            only: _this.props.options[radio.groupName].length <= 1
          };
          if (index === 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, style: { marginBottom: '1em' }, 'data-test': radio.groupName, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 22
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({ limited: false, animatedLine: true, primary: true }, props, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 23
                }
              }))
            );
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              key: index,
              style: { display: 'inline-block', marginBottom: '1em' },
              'data-test': radio.groupName, __source: {
                fileName: _jsxFileName,
                lineNumber: 28
              }
            },
            index === _this.props.stepData.radioGroup.length - 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: stepStyles.divider, __source: {
                fileName: _jsxFileName,
                lineNumber: 33
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, style: { display: 'inline-block' }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 35
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({ limited: false, divider: true }, props, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 36
                }
              }))
            )
          );
        })
      );
    }, _this._renderToggles = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 45
          }
        },
        _this.props.stepData.radioGroup.map(function (radio, index) {
          var props = {
            onChange: _this.props.handleChangeOption,
            options: _this.props.options[radio.groupName],
            active: _this.props.options[radio.groupName].indexOf(_this.props.options[radio.itemName]),
            only: _this.props.options[radio.groupName].length <= 1
          };
          if (index === 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, style: { marginBottom: '1em' }, 'data-test': radio.groupName, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 55
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({ limited: false, animatedLine: true, primary: true }, props, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 56
                }
              }))
            );
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              key: index,
              style: { display: 'inline-block', marginBottom: '1em' },
              'data-test': radio.groupName, __source: {
                fileName: _jsxFileName,
                lineNumber: 61
              }
            },
            index === _this.props.stepData.radioGroup.length - 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: stepStyles.divider, __source: {
                fileName: _jsxFileName,
                lineNumber: 66
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, style: { display: 'inline-block' }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 68
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({ limited: false, divider: true }, props, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 69
                }
              }))
            )
          );
        })
      );
    }, _this._renderCompact = function () {
      var currentPrice = ((_this.props.price || {}).data || [])[0] || {};
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 80
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["O" /* RenderConfiguredVehicleCompact */], {
          display360: _this.props.display360,
          step: _this.props.stepData,
          isSelectColorInterior: _this.props.selectColorInterior,
          options: _this.props.options,
          onChange: _this.props.handleChangeOption,
          currentPriceArray: currentPrice,
          showDescription: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 81
          }
        })
      );
    }, _this._render = function () {
      var currentPrice = ((_this.props.price || {}).data || [])[0] || {};
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: stepStyles.stepHeader, __source: {
              fileName: _jsxFileName,
              lineNumber: 97
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["D" /* H6 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 98
              }
            },
            _this.props.mainHeading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["z" /* H2 */],
            {
              withDetails: true,
              align: 'center',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 101
              }
            },
            _this.props.stepData.heading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 107
            }
          }),
          _this._renderToggles()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: '0em 15vw' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["N" /* RenderConfiguredVehicle */], {
            display360: _this.props.display360,
            step: _this.props.stepData,
            isSelectColorInterior: Boolean(_this.props.selectColorInterior),
            options: _this.props.options,
            onChange: _this.props.handleChangeOption,
            selectIndex: _this.props.stepData.colorSelector && (_this.props.selectColorInterior ? 1 : 0),
            showDescription: true,
            background: !_this.props.stepData.fullWidth, __source: {
              fileName: _jsxFileName,
              lineNumber: 111
            }
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  BuildDriveStep.prototype.render = function render() {
    var currentPrice = ((this.props.price || {}).data || [])[0] || {};
    return this.props.compact ? this._renderCompact() : this._render();
  };

  return BuildDriveStep;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BuildDriveStep.displayName = 'BuildDriveStep';

/* harmony default export */ __webpack_exports__["a"] = (BuildDriveStep);

var stepStyles = {
  divider: {
    height: '2em',
    width: '1px',
    margin: '0px 1.8em 0 1.7em',
    background: '#cbcbcb',
    transform: 'rotate(30deg)',
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  stepHeader: {
    paddingTop: '30px',
    minHeight: '20vh'
  }
};

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\build\\build-grade-step.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var BuildGradeStep = function (_Component) {
  _inherits(BuildGradeStep, _Component);

  function BuildGradeStep() {
    var _temp, _this, _ret;

    _classCallCheck(this, BuildGradeStep);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._renderToggles = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 12
          }
        },
        _this.props.stepData.radioGroup.map(function (radio, index) {
          var props = {
            onChange: _this.props.handleChangeOption,
            options: _this.props.options[radio.groupName],
            active: _this.props.options[radio.groupName].indexOf(_this.props.options[radio.itemName]),
            only: _this.props.options[radio.groupName].length <= 1
          };
          if (index === 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, style: { marginBottom: '1em' }, 'data-test': radio.groupName, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 22
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({ animatedLine: true, primary: true }, props, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 23
                }
              }))
            );
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              key: index,
              style: { display: 'inline-block', marginBottom: '1em' },
              'data-test': radio.groupName, __source: {
                fileName: _jsxFileName,
                lineNumber: 28
              }
            },
            index === _this.props.stepData.radioGroup.length - 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: stepStyles.divider, __source: {
                fileName: _jsxFileName,
                lineNumber: 33
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, style: { display: 'inline-block' }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 35
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({ divider: true }, props, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 36
                }
              }))
            )
          );
        })
      );
    }, _this._renderCompact = function () {
      var currentPrice = ((_this.props.price || {}).data || [])[0] || {};
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["O" /* RenderConfiguredVehicleCompact */], {
          display360: _this.props.display360,
          step: _this.props.stepData,
          isSelectColorInterior: _this.props.selectColorInterior,
          options: _this.props.options,
          onChange: _this.props.handleChangeOption,
          safetyModel: _this.props.safetyModel,
          includeSafetyModel: _this.props.includeSafetyModel,
          price: currentPrice,
          finance: _this.props.finance,
          showDescription: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        })
      );
    }, _this._render = function () {
      var currentPrice = ((_this.props.price || {}).data || [])[0] || {};
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 66
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: stepStyles.stepHeader, __source: {
              fileName: _jsxFileName,
              lineNumber: 67
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["D" /* H6 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 68
              }
            },
            _this.props.mainHeading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["z" /* H2 */],
            {
              withDetails: true,
              align: 'center',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 71
              }
            },
            _this.props.stepData.heading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          }),
          _this._renderToggles()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
          { horizontalPadding: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 80
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["N" /* RenderConfiguredVehicle */], {
            display360: _this.props.display360,
            step: _this.props.stepData,
            isSelectColorInterior: Boolean(_this.props.selectColorInterior),
            price: currentPrice,
            options: _this.props.options,
            onChange: _this.props.handleChangeOption,
            safetyModel: _this.props.safetyModel,
            includeSafetyModel: _this.props.includeSafetyModel,
            finance: _this.props.finance,
            selectIndex: _this.props.stepData.colorSelector && (_this.props.selectColorInterior ? 1 : 0),
            showDescription: true,
            background: !_this.props.stepData.fullWidth, __source: {
              fileName: _jsxFileName,
              lineNumber: 81
            }
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  BuildGradeStep.prototype.render = function render() {
    var currentPrice = ((this.props.price || {}).data || [])[0] || {};
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 103
        }
      },
      this.props.compact ? this._renderCompact() : this._render(),
      this.props.specifications && this.props.specifications.data && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { maxWidth: '850px', margin: '0 auto', padding: '0 20px' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 107
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["_2" /* SpecificationList */], {
          alwaysOpen: !this.props.stepData.summary,
          key: this.props.stepData.summary ? 'summary' : 'other',
          specs: this.props.specifications.data.categories, __source: {
            fileName: _jsxFileName,
            lineNumber: 108
          }
        }),
        this.props.stepData.summary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { textAlign: 'right', padding: '0px 0em 5em', width: '100%' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 113
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              target: this.props.fullSpecCta.external ? '_blank' : null,
              href: '' + this.props.fullSpecCta.href + this.props.search.queryString,
              style: styles.link, __source: {
                fileName: _jsxFileName,
                lineNumber: 114
              }
            },
            this.props.fullSpecCta.label,
            ' \u203A'
          )
        )
      )
    );
  };

  return BuildGradeStep;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BuildGradeStep.displayName = 'BuildGradeStep';

/* harmony default export */ __webpack_exports__["a"] = (BuildGradeStep);

var stepStyles = {
  divider: {
    height: '2em',
    width: '1px',
    margin: '0px 1.8em 0 1.7em',
    background: '#cbcbcb',
    transform: 'rotate(30deg)',
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  stepHeader: {
    paddingTop: '30px',
    minHeight: '20vh'
  }
};
var styles = {
  link: {
    color: '#aaa',
    textDecoration: 'none',
    fontSize: '90%',
    padding: '0em 0em 5em',
    ':hover': {
      color: '#191919'
    }
  }
};

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\build\\build-color-step.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var BuildColorStep = function (_Component) {
  _inherits(BuildColorStep, _Component);

  function BuildColorStep(props) {
    _classCallCheck(this, BuildColorStep);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      display360Status: false
    };
    return _this;
  }

  BuildColorStep.prototype.render = function render() {
    return this.props.compact ? this._renderCompact() : this._render();
  };

  return BuildColorStep;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.mutateColorOptions = function (options) {
    return options.map(function (option) {
      var newOption = Object.assign({}, option);
      newOption.label = newOption.priceDifference ? option.name + ' | $' + Number(option.priceDifference).toLocaleString('nz') : option.name;
      return newOption;
    });
  };

  this.changeDisplay360Status = function (newValue) {
    _this2.setState({
      display360Status: newValue
    });
  };

  this._renderColors = function () {
    var radio = _this2.props.stepData.radioGroup[_this2.props.selectColorInterior ? 1 : 0];
    var props = {
      onChange: _this2.props.handleChangeOption,
      options: _this2.mutateColorOptions(_this2.props.options[radio.groupName]),
      active: _this2.props.options[radio.groupName].indexOf(_this2.props.options[radio.itemName]),
      only: _this2.props.options[radio.groupName].length <= 1
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], {
        divider: true,
        options: [{ name: 'exterior' }, { name: 'interior' }],
        active: _this2.props.selectColorInterior ? 1 : 0,
        onChange: function onChange(option, index) {
          _this2.props.handleChangeInterior(index);
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 40
        }
      }),
      _this2.props.selectColorInterior ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["K" /* InteriorSelector */], _extends({ padding: '0 0 1em 0' }, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 48
        }
      })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["k" /* ColorSelector */], _extends({ padding: '0 0 1em 0' }, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50
        }
      }))
    );
  };

  this._renderCompact = function () {
    var newSelectIndex = _this2.props.stepData.colorSelector && (_this2.props.selectColorInterior ? 1 : 0);
    var activeOption = _this2.props.options[_this2.props.stepData.radioGroup[newSelectIndex].itemName];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { minHeight: '20vh', padding: '1em' }, __source: {
          fileName: _jsxFileName,
          lineNumber: 61
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 62
          }
        },
        activeOption.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["B" /* H4 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 63
            }
          },
          activeOption.name
        ),
        _this2._renderColors()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 66
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["N" /* RenderConfiguredVehicle */], {
          display360: _this2.props.display360,
          display360Status: _this2.state.display360Status,
          step: _this2.props.stepData,
          isSelectColorInterior: Boolean(_this2.props.selectColorInterior),
          options: _this2.props.options,
          changeDisplay360Status: _this2.changeDisplay360Status,
          onChange: _this2.props.handleChangeOption,
          compact: _this2.props.compact,
          selectIndex: newSelectIndex,
          showDescription: true,
          background: !_this2.props.stepData.fullWidth, __source: {
            fileName: _jsxFileName,
            lineNumber: 67
          }
        })
      )
    );
  };

  this._render = function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: stepStyles.stepHeader, __source: {
            fileName: _jsxFileName,
            lineNumber: 86
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["D" /* H6 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          },
          _this2.props.mainHeading
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["z" /* H2 */],
          {
            withDetails: true,
            align: 'center',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 90
            }
          },
          _this2.props.stepData.heading
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          }
        }),
        _this2._renderColors()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { padding: '0em 15vw' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 99
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["N" /* RenderConfiguredVehicle */], {
          display360: _this2.props.display360,
          display360Status: _this2.state.display360Status,
          step: _this2.props.stepData,
          isSelectColorInterior: Boolean(_this2.props.selectColorInterior),
          options: _this2.props.options,
          changeDisplay360Status: _this2.changeDisplay360Status,
          onChange: _this2.props.handleChangeOption,
          compact: _this2.props.compact,
          selectIndex: _this2.props.stepData.colorSelector && (_this2.props.selectColorInterior ? 1 : 0),
          showDescription: true,
          background: !_this2.props.stepData.fullWidth, __source: {
            fileName: _jsxFileName,
            lineNumber: 100
          }
        })
      )
    );
  };
};

BuildColorStep.displayName = 'BuildColorStep';

/* harmony default export */ __webpack_exports__["a"] = (BuildColorStep);

var stepStyles = {
  divider: {
    height: '2em',
    width: '1px',
    margin: '0px 1.8em 0 1.7em',
    background: '#cbcbcb',
    transform: 'rotate(30deg)',
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  stepHeader: {
    paddingTop: '30px',
    minHeight: '20vh'
  }
};

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AtomicUtils_gtmHandler__ = __webpack_require__(11);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\build\\build-summary-step.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var getShortModel = function getShortModel(modelName) {
  return (modelName.split(" ")[1] || modelName.split(" ")[0]).toUpperCase();
};

var BuildSummaryStep = function (_Component) {
  _inherits(BuildSummaryStep, _Component);

  function BuildSummaryStep(props) {
    _classCallCheck(this, BuildSummaryStep);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._handleClickOnOpeningSaveModal = function () {
      _this.setState({ saveFormOpen: true }, function () {
        _this.props.gtmEvent({
          gtmID: _this.props.gtmBuildToolActionTypes.BUILDTOOL_CLICKED_SAVE,
          gtmPayload: {
            modelName: _this.props.options.nameplate.name,
            stepNumber: _this.props.activeStep,
            stepName: _this.props.stepData.name,
            bodyName: _this.props.options.bodyStyle.name,
            driveName: _this.props.options.drivetrain.name,
            gradeName: _this.props.options.grade.name,
            colorName: _this.props.options.color.name,
            interiorName: _this.props.options.interiorDesign.name
          }
        });
      });
    };

    _this._renderShareSection = function () {
      var currentPrice = ((_this.props.price || {}).data || [])[0] || {};
      var _this$props = _this.props,
          includeSafetyModel = _this$props.includeSafetyModel,
          safetyModelExcess = _this$props.safetyModelExcess,
          _this$props$financeOp = _this$props.financeOptionText,
          financeOptionText = _this$props$financeOp === undefined ? false : _this$props$financeOp;
      var showTooltipOfSaveInSummary = _this.state.showTooltipOfSaveInSummary;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { "data-test": "share-build", style: styles.shareSection, __source: {
            fileName: _jsxFileName,
            lineNumber: 71
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { position: "relative" }, key: "SavePart", __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.shareSectionColumn, onClick: _this._handleClickOnOpeningSaveModal, __source: {
                fileName: _jsxFileName,
                lineNumber: 73
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 74
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_6" /* SaveIcon */], { style: styles.shareSectionIcon, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 75
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.shareSectionText, key: "SaveText", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 77
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["U" /* Interactive */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 78
                  }
                },
                "SAVE"
              )
            )
          ),
          showTooltipOfSaveInSummary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["J" /* Tooltip */],
            { position: "bottomRight", __source: {
                fileName: _jsxFileName,
                lineNumber: 82
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { letterSpacing: 0 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 83
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_1" /* P */],
                { withoutMargin: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 84
                  }
                },
                "You can now ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["a" /* A */],
                  { onClick: _this._handleClickOnOpeningSaveModal, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 85
                    }
                  },
                  " save your ",
                  _this.props.options.nameplate.name,
                  " "
                ),
                " for future reference."
              )
            )
          )
        ),
        _this.state.saveFormOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["Z" /* Modal */],
          {
            width: "600px",
            handleClose: function handleClose() {
              _this.setState({ saveFormOpen: false });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 93
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["D" /* SaveForm */], {
            endPoint: _this.props.savedBuildEndPoint,
            imageSrc: [_this.props.options.color.imageSrc],
            description: "Save time and conveniently save your ideal Mazda now for future reference.",
            testDriveUrl: _this.props.testDriveUrl,
            buildUrl: __WEBPACK_IMPORTED_MODULE_3_constants_environment__["i" /* WINDOW */].location.href,
            location: _this.props.locationState,
            namePlate: _this.props.options.nameplate.name,
            bodyStyle: _this.props.options.bodyStyle.name,
            safetyModelExcess: includeSafetyModel && currentPrice.safetyModelPrice ? currentPrice.price === currentPrice.safetyModelPrice ? "Included as standard" : "+$" + safetyModelExcess : null,
            financeOptionText: financeOptionText,
            gtmEvents: { category: "Build Tool", action: "Build " + _this.props.options.nameplate.name + " " + _this.props.options.bodyStyle.name + " " + _this.props.options.drivetrain.name + " " + _this.props.options.grade.name + " " + _this.props.options.color.name + " " + _this.props.options.interiorDesign.name },
            fullWidth: true,
            handleClose: function handleClose() {
              _this.setState({ saveFormOpen: false });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 98
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            onClick: function onClick() {
              _this.setState({ shareFormOpen: true }, function () {
                _this.props.gtmEvent({
                  gtmID: _this.props.gtmBuildToolActionTypes.BUILDTOOL_CLICKED_SHARE,
                  gtmPayload: {
                    modelName: _this.props.options.nameplate.name,
                    stepNumber: _this.props.activeStep,
                    stepName: _this.props.stepData.name,
                    bodyName: _this.props.options.bodyStyle.name,
                    driveName: _this.props.options.drivetrain.name,
                    gradeName: _this.props.options.grade.name,
                    colorName: _this.props.options.color.name,
                    interiorName: _this.props.options.interiorDesign.name
                  }
                });
              });
            },
            key: "SharePart",
            style: styles.shareSectionColumn, __source: {
              fileName: _jsxFileName,
              lineNumber: 116
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 136
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_10" /* ShareIcon */], { style: styles.shareSectionIcon, __source: {
                fileName: _jsxFileName,
                lineNumber: 137
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.shareSectionText, key: "ShareText", __source: {
                fileName: _jsxFileName,
                lineNumber: 139
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 140
                }
              },
              "SHARE"
            )
          )
        ),
        _this.state.shareFormOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["Z" /* Modal */],
          {
            width: "600px",
            handleClose: function handleClose() {
              _this.setState({
                shareFormOpen: false,
                showShareForm: false,
                showMobileShare: true
              });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 145
            }
          },
          __WEBPACK_IMPORTED_MODULE_3_constants_environment__["g" /* IS_MOBILE */] && _this.state.showMobileShare && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["B" /* MobileShare */], {
            imageSrc: _this.props.options.color.imageSrc,
            mobileDescription: "How would you like to share your " + _this.props.options.nameplate.name + " " + _this.props.options.bodyStyle.name + " build?",
            description: "Check out the " + (_this.props.options.nameplate.name + " " + _this.props.options.bodyStyle.name) + " I built: ",
            EmailShareFunc: function EmailShareFunc() {
              _this.setState({
                showShareForm: true,
                showMobileShare: false
              });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 155
            }
          }),
          (!__WEBPACK_IMPORTED_MODULE_3_constants_environment__["g" /* IS_MOBILE */] || _this.state.showShareForm) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["F" /* ShareForm */], {
            endPoint: _this.props.sharedBuildEndPoint,
            imageSrc: [_this.props.options.color.imageSrc],
            namePlate: _this.props.options.nameplate.name,
            bodyStyle: _this.props.options.bodyStyle.name,
            description: "Send the URL of your Mazda build via email",
            compact: _this.props.compact,
            buildUrl: __WEBPACK_IMPORTED_MODULE_3_constants_environment__["i" /* WINDOW */].location.href,
            location: _this.props.locationState,
            safetyModelExcess: includeSafetyModel && currentPrice.safetyModelPrice ? currentPrice.price === currentPrice.safetyModelPrice ? "Included as standard" : "+$" + safetyModelExcess : null,
            gtmEvents: { category: "Build Tool", action: "Build " + _this.props.options.nameplate.name + " " + _this.props.options.bodyStyle.name + " " + _this.props.options.drivetrain.name + " " + _this.props.options.grade.name + " " + _this.props.options.color.name + " " + _this.props.options.interiorDesign.name },
            fullWidth: true,
            handleClose: function handleClose() {
              _this.setState({ shareFormOpen: false });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 167
            }
          })
        )
      );
    };

    _this._renderCompact = function () {
      var currentPrice = ((_this.props.price || {}).data || [])[0] || {};
      var _this$props2 = _this.props,
          mainHeading = _this$props2.mainHeading,
          options = _this$props2.options,
          includeSafetyModel = _this$props2.includeSafetyModel,
          safetyModel = _this$props2.safetyModel,
          hideLinks = _this$props2.hideLinks,
          finance = _this$props2.finance;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 194
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: stepStyles.stepHeader, __source: {
              fileName: _jsxFileName,
              lineNumber: 195
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_8" /* Section */],
            { horizontalPadding: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 196
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["s" /* HeadingBlock */], {
              tag: "h3",
              value: mainHeading,
              align: "center",
              customPreHeadingStyle: { fontSize: "94%" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 197
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { maxWidth: "70%", padding: "2em 0 0", margin: "auto" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 203
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["j" /* ConfiguredVehicle */], { src: options.color.imageSrc, __source: {
                fileName: _jsxFileName,
                lineNumber: 204
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { padding: "0 20px" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 206
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_10" /* SummaryWithPrice */], {
              heading: false,
              includeSafetyModel: includeSafetyModel,
              safetyModel: options.engine.safetyModelCode ? safetyModel : null,
              price: currentPrice,
              gtm: {
                category: "Build Tool \"" + options.nameplate.name.toUpperCase() + "\"",
                action: "Build \"" + options.nameplate.name.toUpperCase() + "\" - Step 4 Summary - Clicked \"PRICE DISCLAIMER\""
              },
              items: [{
                label: "Grade",
                value: options.grade.name,
                step: 3,
                onClick: function onClick() {
                  return _this.props.setStep(_this.getGradeStepNumber());
                }
              }, {
                label: "Drive & Transmission",
                value: options.drivetrain.name + " " + options.transmission.name
              }, { label: "Engine", value: options.engine.name }, {
                label: "Exterior",
                value: options.color.name,
                border: true,
                priceDifference: options.color.priceDifference,
                step: 4,
                onClick: function onClick() {
                  return _this.props.setStep(_this.getColorStepNumber());
                }
              }, { label: "Interior", value: options.interiorDesign.name }], __source: {
                fileName: _jsxFileName,
                lineNumber: 207
              }
            }),
            finance && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.financeOption, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 241
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
                style: styles.financeIcon,
                src: finance.icon, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 242
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["a" /* A */],
                {
                  href: finance.link,
                  external: true,
                  gtm: {
                    category: "Build Tool \"" + options.nameplate.name + "\"",
                    action: "Build \"" + options.nameplate.name + "\" - Step 4 SUMMARY - Clicked \"FINANCE\""
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 245
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["l" /* Caption */],
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 252
                    }
                  },
                  finance.description
                )
              )
            ),
            !hideLinks && _this._renderShareSection()
          )
        )
      );
    };

    _this._render = function () {
      var currentPrice = ((_this.props.price || {}).data || [])[0] || {};
      var _this$props3 = _this.props,
          mainHeading = _this$props3.mainHeading,
          stepData = _this$props3.stepData,
          options = _this$props3.options,
          gtmEventPriceDisclaimer = _this$props3.gtmEventPriceDisclaimer,
          includeSafetyModel = _this$props3.includeSafetyModel,
          safetyModel = _this$props3.safetyModel,
          hideLinks = _this$props3.hideLinks,
          finance = _this$props3.finance;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 280
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: stepStyles.stepHeader, __source: {
              fileName: _jsxFileName,
              lineNumber: 281
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["D" /* H6 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 282
              }
            },
            mainHeading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["z" /* H2 */],
            {
              withDetails: true,
              align: 'center',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 285
              }
            },
            stepData.heading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: {
                display: "flex", maxWidth: "85vw", margin: "auto", paddingTop: "4em"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 291
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { flex: "0 1 50%" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 294
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_10" /* SummaryWithPrice */], {
                heading: options.nameplate.name + " " + options.bodyStyle.name,
                safetyModel: options.engine.safetyModelCode ? safetyModel : null,
                includeSafetyModel: includeSafetyModel,
                price: currentPrice,
                gtm: {
                  category: "Build Tool \"" + options.nameplate.name.toUpperCase() + "\"",
                  action: "Build \"" + options.nameplate.name.toUpperCase() + "\" - Step 4 Summary - Clicked \"PRICE DISCLAIMER\""
                },
                items: [{
                  label: "Grade",
                  value: options.grade.name,
                  onClick: function onClick() {
                    return _this.props.setStep(_this.getGradeStepNumber());
                  }
                }, {
                  label: "Drive & Transmission",
                  value: options.drivetrain.name + " " + options.transmission.name
                }, { label: "Engine", value: options.engine.name }, {
                  label: "Exterior",
                  value: options.color.name,
                  border: true,
                  priceDifference: options.color.priceDifference,
                  onClick: function onClick() {
                    return _this.props.setStep(_this.getColorStepNumber());
                  }
                }, { label: "Interior", value: options.interiorDesign.name }], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 295
                }
              }),
              finance && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: styles.financeOption, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 331
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
                  style: styles.financeIcon,
                  src: finance.icon, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 332
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["a" /* A */],
                  {
                    href: finance.link,
                    external: true,
                    gtm: {
                      category: "Build Tool \"" + options.nameplate.name + "\"",
                      action: "Build \"" + options.nameplate.name + "\" - Step 4 SUMMARY - Clicked \"FINANCE\""
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 335
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["l" /* Caption */],
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 342
                      }
                    },
                    finance.description
                  )
                )
              ),
              !hideLinks && _this._renderShareSection()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { display: "flex" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 360
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["j" /* ConfiguredVehicle */], { src: options.color.imageSrc, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 361
                }
              })
            )
          )
        )
      );
    };

    _this.getGradeStepNumber = function () {
      var gradeStepNumber = 0;
      _this.props.allData.forEach(function (item, index) {
        if (item.name === "Grade") {
          gradeStepNumber = index;
        }
      });
      return gradeStepNumber;
    };

    _this.getColorStepNumber = function () {
      var colorStepNumber = 0;
      _this.props.allData.forEach(function (item, index) {
        if (item.name === "Color") {
          colorStepNumber = index;
        }
      });
      return colorStepNumber;
    };

    _this.state = {
      saveFormOpen: false,
      shareFormOpen: false,
      showMobileShare: true,
      showTooltipOfSaveInSummary: false
    };
    return _this;
  }

  BuildSummaryStep.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        _props$disableSavePro = _props.disableSavePrompt,
        disableSavePrompt = _props$disableSavePro === undefined ? false : _props$disableSavePro,
        _props$delayToShowSav = _props.delayToShowSavePrompt,
        delayToShowSavePrompt = _props$delayToShowSav === undefined ? 1000 : _props$delayToShowSav,
        _props$delayToCloseSa = _props.delayToCloseSavePrompt,
        delayToCloseSavePrompt = _props$delayToCloseSa === undefined ? 3000 : _props$delayToCloseSa;

    if (!disableSavePrompt) {
      setTimeout(function () {
        _this2.setState({
          showTooltipOfSaveInSummary: true
        }, function () {
          setTimeout(function () {
            _this2.setState({
              showTooltipOfSaveInSummary: false
            });
          }, delayToCloseSavePrompt);
        });
      }, delayToShowSavePrompt);
    }
  };

  BuildSummaryStep.prototype.render = function render() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 391
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 392
          }
        },
        this.props.compact ? this._renderCompact() : this._render()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 393
          }
        },
        this.props.specifications && this.props.specifications.data && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { maxWidth: "850px", margin: "0 auto", padding: "0 20px" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 396
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["_2" /* SpecificationList */], {
            alwaysOpen: !this.props.stepData.summary,
            key: this.props.stepData.summary ? "summary" : "other",
            gtmEventsDisclaimers: this.props.gtmEventsDisclaimers,
            specs: this.props.specifications.data.categories.map(function (item) {
              item.onClick = function (status) {
                Object(__WEBPACK_IMPORTED_MODULE_8__AtomicUtils_gtmHandler__["a" /* default */])({
                  pageAction: "Build \"" + getShortModel(_this3.props.options.nameplate.name) + "\" - Step " + _this3.props.activeStep + " SUMMARY- " + (status === 1 ? 'Opened' : 'Closed') + " Feature Specs",
                  pageCategory: "Build Tool \"" + getShortModel(_this3.props.options.nameplate.name) + "\""
                });
              };
              return item;
            }), __source: {
              fileName: _jsxFileName,
              lineNumber: 397
            }
          }),
          this.props.stepData.summary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { textAlign: "right", padding: "20px 0em 5em", width: "100%" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 411
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_components__["H" /* Hyperlink */],
              {
                gtmEvents: this.props.gtmEventsFullSpecLink,
                external: this.props.fullSpecCta.external,
                href: "" + this.props.fullSpecCta.href + this.props.search.queryString, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 412
                }
              },
              this.props.fullSpecCta.label,
              " \u203A"
            )
          )
        )
      )
    );
  };

  return BuildSummaryStep;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BuildSummaryStep.displayName = "BuildSummaryStep";

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["a" /* ConnectLocation */])())(BuildSummaryStep));

var stepStyles = {
  divider: {
    height: "2em",
    width: "1px",
    margin: "0px 1.8em 0 1.7em",
    background: "#cbcbcb",
    transform: "rotate(30deg)",
    display: "inline-block",
    verticalAlign: "middle"
  },
  stepHeader: {
    paddingTop: "30px",
    minHeight: "20vh"
  }
};
var styles = {
  link: {
    color: "#aaa",
    textDecoration: "none",
    fontSize: "90%",
    padding: "0em 0em 5em",
    ":hover": {
      color: "#101010"
    }
  },
  shareSection: {
    display: "inline-flex",
    width: "100%",
    maxWidth: "350px",
    justifyContent: "space-around",
    flex: "1 1 auto",
    margin: "auto",
    borderTop: "1px solid rgb(221, 221, 221)",
    padding: "2em 0em 4em 0em"
  },
  shareSectionColumn: {
    display: "flex",
    position: "relative",
    cursor: "pointer",
    color: __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__["a" /* default */].GRAY_DARKER,
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__["a" /* default */].RED
    }
  },
  shareSectionIcon: {
    height: "22px",
    width: "22px"
  },
  shareSectionText: {
    fontWeight: "bold",
    fontSize: "80%",
    letterSpacing: ".2em",
    color: __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__["a" /* default */].GRAY_DARKER,
    padding: "0 7px",
    whiteSpace: "nowrap"
  },
  financeOption: {
    display: 'flex',
    maxWidth: '350px',
    width: '100%',
    margin: '0 auto 18px auto',
    alignItems: 'center'
  },
  financeIcon: {
    marginRight: '10px',
    width: '15px'
  }
};

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(89);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomTreeShapes = getDomTreeShapes;
exports.findNativeHandler = findNativeHandler;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(1232));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(1233));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1235));

var _createClass2 = _interopRequireDefault(__webpack_require__(1236));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1237));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1240));

var _inherits2 = _interopRequireDefault(__webpack_require__(1241));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _warning = _interopRequireDefault(__webpack_require__(34));

var _properties = _interopRequireDefault(__webpack_require__(1243));

var _on = _interopRequireDefault(__webpack_require__(1244));

var _off = _interopRequireDefault(__webpack_require__(1245));

var _reactSwipeableViewsCore = __webpack_require__(1246);

function addEventListenerEnhanced(node, event, handler, options) {
  (0, _on.default)(node, event, handler, options);
  return {
    remove: function remove() {
      (0, _off.default)(node, event, handler, options);
    }
  };
}

var styleInjected = false; // Support old version of iOS and IE 10.
// To be deleted in 2019.

function injectStyle() {
  // Inject once for all the instances
  if (!styleInjected) {
    var style = document.createElement('style');
    style.innerHTML = "\n      .react-swipeable-view-container {\n        display: -webkit-box;\n        display: -ms-flexbox;\n      }\n      .react-swipeable-view-container > div {\n        -ms-flex-negative: 0;\n      }\n    ";

    if (document.body) {
      document.body.appendChild(style);
    }

    styleInjected = true;
  }
}

var styles = {
  container: {
    direction: 'ltr',
    display: 'flex',
    willChange: 'transform'
  },
  slide: {
    width: '100%',
    WebkitFlexShrink: 0,
    flexShrink: 0,
    overflow: 'auto'
  }
};
var axisProperties = {
  root: {
    x: {
      overflowX: 'hidden'
    },
    'x-reverse': {
      overflowX: 'hidden'
    },
    y: {
      overflowY: 'hidden'
    },
    'y-reverse': {
      overflowY: 'hidden'
    }
  },
  flexDirection: {
    x: 'row',
    'x-reverse': 'row-reverse',
    y: 'column',
    'y-reverse': 'column-reverse'
  },
  transform: {
    x: function x(translate) {
      return "translate(".concat(-translate, "%, 0)");
    },
    'x-reverse': function xReverse(translate) {
      return "translate(".concat(translate, "%, 0)");
    },
    y: function y(translate) {
      return "translate(0, ".concat(-translate, "%)");
    },
    'y-reverse': function yReverse(translate) {
      return "translate(0, ".concat(translate, "%)");
    }
  },
  length: {
    x: 'width',
    'x-reverse': 'width',
    y: 'height',
    'y-reverse': 'height'
  },
  rotationMatrix: {
    x: {
      x: [1, 0],
      y: [0, 1]
    },
    'x-reverse': {
      x: [-1, 0],
      y: [0, 1]
    },
    y: {
      x: [0, 1],
      y: [1, 0]
    },
    'y-reverse': {
      x: [0, -1],
      y: [1, 0]
    }
  },
  scrollPosition: {
    x: 'scrollLeft',
    'x-reverse': 'scrollLeft',
    y: 'scrollTop',
    'y-reverse': 'scrollTop'
  },
  scrollLength: {
    x: 'scrollWidth',
    'x-reverse': 'scrollWidth',
    y: 'scrollHeight',
    'y-reverse': 'scrollHeight'
  },
  clientLength: {
    x: 'clientWidth',
    'x-reverse': 'clientWidth',
    y: 'clientHeight',
    'y-reverse': 'clientHeight'
  }
};

function createTransition(property, options) {
  var duration = options.duration,
      easeFunction = options.easeFunction,
      delay = options.delay;
  return "".concat(property, " ").concat(duration, " ").concat(easeFunction, " ").concat(delay);
} // We are using a 2x2 rotation matrix.


function applyRotationMatrix(touch, axis) {
  var rotationMatrix = axisProperties.rotationMatrix[axis];
  return {
    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
  };
}

function adaptMouse(event) {
  event.touches = [{
    pageX: event.pageX,
    pageY: event.pageY
  }];
  return event;
}

function getDomTreeShapes(element, rootNode) {
  var domTreeShapes = [];

  while (element && element !== rootNode) {
    // We reach a Swipeable View, no need to look higher in the dom tree.
    if (element.hasAttribute('data-swipeable')) {
      break;
    }

    var style = window.getComputedStyle(element);

    if ( // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push({
        element: element,
        scrollWidth: element.scrollWidth,
        scrollHeight: element.scrollHeight,
        clientWidth: element.clientWidth,
        clientHeight: element.clientHeight,
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
      });
    }

    element = element.parentNode;
  }

  return domTreeShapes;
} // We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.


var nodeWhoClaimedTheScroll = null;

function findNativeHandler(params) {
  var domTreeShapes = params.domTreeShapes,
      pageX = params.pageX,
      startX = params.startX,
      axis = params.axis;
  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = pageX >= startX;

    if (axis === 'x' || axis === 'y') {
      goingForward = !goingForward;
    }

    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      nodeWhoClaimedTheScroll = shape.element;
      return true;
    }

    return false;
  });
}

var SwipeableViews =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwipeableViews, _React$Component);

  function SwipeableViews(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SwipeableViews);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwipeableViews).call(this, props));
    _this.rootNode = null;
    _this.containerNode = null;
    _this.ignoreNextScrollEvents = false;
    _this.viewLength = 0;
    _this.startX = 0;
    _this.lastX = 0;
    _this.vx = 0;
    _this.startY = 0;
    _this.isSwiping = undefined;
    _this.started = false;
    _this.startIndex = 0;
    _this.transitionListener = null;
    _this.touchMoveListener = null;
    _this.activeSlide = null;
    _this.indexCurrent = null;
    _this.firstRenderTimeout = null;

    _this.setRootNode = function (node) {
      _this.rootNode = node;
    };

    _this.setContainerNode = function (node) {
      _this.containerNode = node;
    };

    _this.setActiveSlide = function (node) {
      _this.activeSlide = node;

      _this.updateHeight();
    };

    _this.handleSwipeStart = function (event) {
      var axis = _this.props.axis;
      var touch = applyRotationMatrix(event.touches[0], axis);
      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
      _this.startX = touch.pageX;
      _this.lastX = touch.pageX;
      _this.vx = 0;
      _this.startY = touch.pageY;
      _this.isSwiping = undefined;
      _this.started = true;
      var computedStyle = window.getComputedStyle(_this.containerNode);
      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');

      if (transform && transform !== 'none') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        var rootStyle = window.getComputedStyle(_this.rootNode);
        var tranformNormalized = applyRotationMatrix({
          pageX: parseInt(transformValues[4], 10),
          pageY: parseInt(transformValues[5], 10)
        }, axis);
        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10)) || 0;
      }
    };

    _this.handleSwipeMove = function (event) {
      // The touch start event can be cancel.
      // Makes sure we set a starting point.
      if (!_this.started) {
        _this.handleTouchStart(event);

        return;
      } // We are not supposed to hanlde this touch move.


      if (nodeWhoClaimedTheScroll !== null && nodeWhoClaimedTheScroll !== _this.rootNode) {
        return;
      }

      var _this$props = _this.props,
          axis = _this$props.axis,
          children = _this$props.children,
          ignoreNativeScroll = _this$props.ignoreNativeScroll,
          onSwitching = _this$props.onSwitching,
          resistance = _this$props.resistance;
      var touch = applyRotationMatrix(event.touches[0], axis); // We don't know yet.

      if (_this.isSwiping === undefined) {
        var dx = Math.abs(touch.pageX - _this.startX);
        var dy = Math.abs(touch.pageY - _this.startY);
        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD; // We let the parent handle the scroll.

        if (!resistance && (axis === 'y' || axis === 'y-reverse') && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === _react.default.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
          _this.isSwiping = false;
          return;
        } // We are likely to be swiping, let's prevent the scroll event.


        if (dx > dy) {
          event.preventDefault();
        }

        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
          _this.isSwiping = isSwiping;
          _this.startX = touch.pageX; // Shift the starting point.

          return; // Let's wait the next touch event to move something.
        }
      }

      if (_this.isSwiping !== true) {
        return;
      } // We are swiping, let's prevent the scroll event.


      event.preventDefault(); // Low Pass filter.

      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
      _this.lastX = touch.pageX;

      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
        children: children,
        resistance: resistance,
        pageX: touch.pageX,
        startIndex: _this.startIndex,
        startX: _this.startX,
        viewLength: _this.viewLength
      }),
          index = _computeIndex.index,
          startX = _computeIndex.startX; // Add support for native scroll elements.


      if (nodeWhoClaimedTheScroll === null && !ignoreNativeScroll) {
        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
        var hasFoundNativeHandler = findNativeHandler({
          domTreeShapes: domTreeShapes,
          startX: _this.startX,
          pageX: touch.pageX,
          axis: axis
        }); // We abort the touch move handler.

        if (hasFoundNativeHandler) {
          return;
        }
      } // We are moving toward the edges.


      if (startX) {
        _this.startX = startX;
      } else if (nodeWhoClaimedTheScroll === null) {
        nodeWhoClaimedTheScroll = _this.rootNode;
      }

      _this.setIndexCurrent(index);

      var callback = function callback() {
        if (onSwitching) {
          onSwitching(index, 'move');
        }
      };

      if (_this.state.displaySameSlide || !_this.state.isDragging) {
        _this.setState({
          displaySameSlide: false,
          isDragging: true
        }, callback);
      }

      callback();
    };

    _this.handleSwipeEnd = function () {
      nodeWhoClaimedTheScroll = null; // The touch start event can be cancel.
      // Makes sure that a starting point is set.

      if (!_this.started) {
        return;
      }

      _this.started = false;

      if (_this.isSwiping !== true) {
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexCurrent = _this.indexCurrent;
      var delta = indexLatest - indexCurrent;
      var indexNew; // Quick movement

      if (Math.abs(_this.vx) > _this.props.threshold) {
        if (_this.vx > 0) {
          indexNew = Math.floor(indexCurrent);
        } else {
          indexNew = Math.ceil(indexCurrent);
        }
      } else if (Math.abs(delta) > _this.props.hysteresis) {
        // Some hysteresis with indexLatest.
        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
      } else {
        indexNew = indexLatest;
      }

      var indexMax = _react.default.Children.count(_this.props.children) - 1;

      if (indexNew < 0) {
        indexNew = 0;
      } else if (indexNew > indexMax) {
        indexNew = indexMax;
      }

      _this.setIndexCurrent(indexNew);

      _this.setState({
        indexLatest: indexNew,
        isDragging: false
      }, function () {
        if (_this.props.onSwitching) {
          _this.props.onSwitching(indexNew, 'end');
        }

        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
          _this.props.onChangeIndex(indexNew, indexLatest, {
            reason: 'swipe'
          });
        } // Manually calling handleTransitionEnd in that case as isn't otherwise.


        if (indexCurrent === indexLatest) {
          _this.handleTransitionEnd();
        }
      });
    };

    _this.handleTouchStart = function (event) {
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }

      _this.handleSwipeStart(event);
    };

    _this.handleTouchEnd = function (event) {
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }

      _this.handleSwipeEnd(event);
    };

    _this.handleMouseDown = function (event) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }

      event.persist();

      _this.handleSwipeStart(adaptMouse(event));
    };

    _this.handleMouseUp = function (event) {
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }

      _this.handleSwipeEnd(adaptMouse(event));
    };

    _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      } // Filter out events


      if (_this.started) {
        _this.handleSwipeEnd(adaptMouse(event));
      }
    };

    _this.handleMouseMove = function (event) {
      if (_this.props.onMouseMove) {
        _this.props.onMouseMove(event);
      } // Filter out events


      if (_this.started) {
        _this.handleSwipeMove(adaptMouse(event));
      }
    };

    _this.handleScroll = function (event) {
      if (_this.props.onScroll) {
        _this.props.onScroll(event);
      } // Ignore events bubbling up.


      if (event.target !== _this.rootNode) {
        return;
      }

      if (_this.ignoreNextScrollEvents) {
        _this.ignoreNextScrollEvents = false;
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
      _this.ignoreNextScrollEvents = true; // Reset the scroll position.

      event.target.scrollLeft = 0;

      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
        _this.props.onChangeIndex(indexNew, indexLatest, {
          reason: 'focus'
        });
      }
    };

    _this.updateHeight = function () {
      if (_this.activeSlide !== null) {
        var child = _this.activeSlide.children[0];

        if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) {
          _this.setState({
            heightLatest: child.offsetHeight
          });
        }
      }
    };

    if (false) {
      (0, _reactSwipeableViewsCore.checkIndexBounds)(props);
    }

    _this.state = {
      indexLatest: props.index,
      // Set to true as soon as the component is swiping.
      // It's the state counter part of this.isSwiping.
      isDragging: false,
      // Help with SSR logic and lazy loading logic.
      renderOnlyActive: !props.disableLazyLoading,
      heightLatest: 0,
      // Let the render method that we are going to display the same slide than previously.
      displaySameSlide: true
    };

    _this.setIndexCurrent(props.index);

    return _this;
  }

  (0, _createClass2.default)(SwipeableViews, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this2 = this;

      return {
        swipeableViews: {
          slideUpdateHeight: function slideUpdateHeight() {
            _this2.updateHeight();
          }
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      // Subscribe to transition end events.
      this.transitionListener = addEventListenerEnhanced(this.containerNode, _properties.default.end, function (event) {
        if (event.target !== _this3.containerNode) {
          return;
        }

        _this3.handleTransitionEnd();
      }); // Block the thread to handle that event.

      this.touchMoveListener = addEventListenerEnhanced(this.rootNode, 'touchmove', function (event) {
        // Handling touch events is disabled.
        if (_this3.props.disabled) {
          return;
        }

        _this3.handleSwipeMove(event);
      }, {
        passive: false
      });

      if (!this.props.disableLazyLoading) {
        this.firstRenderTimeout = setTimeout(function () {
          _this3.setState({
            renderOnlyActive: false
          });
        }, 0);
      }

      injectStyle(); // Send all functions in an object if action param is set.

      if (this.props.action) {
        this.props.action({
          updateHeight: this.updateHeight
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var index = nextProps.index;

      if (typeof index === 'number' && index !== this.props.index) {
        if (false) {
          (0, _reactSwipeableViewsCore.checkIndexBounds)(nextProps);
        }

        this.setIndexCurrent(index);
        this.setState({
          // If true, we are going to change the children. We shoudn't animate it.
          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
          indexLatest: index
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.transitionListener.remove();
      this.touchMoveListener.remove();
      clearTimeout(this.firstRenderTimeout);
    }
  }, {
    key: "setIndexCurrent",
    value: function setIndexCurrent(indexCurrent) {
      if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) {
        this.handleTransitionEnd();
      }

      this.indexCurrent = indexCurrent;

      if (this.containerNode) {
        var axis = this.props.axis;
        var transform = axisProperties.transform[axis](indexCurrent * 100);
        this.containerNode.style.WebkitTransform = transform;
        this.containerNode.style.transform = transform;
      }
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      if (!this.props.onTransitionEnd) {
        return;
      } // Filters out when changing the children


      if (this.state.displaySameSlide) {
        return;
      } // The rest callback is triggered when swiping. It's just noise.
      // We filter it out.


      if (!this.state.isDragging) {
        this.props.onTransitionEnd();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          action = _this$props2.action,
          animateHeight = _this$props2.animateHeight,
          animateTransitions = _this$props2.animateTransitions,
          axis = _this$props2.axis,
          children = _this$props2.children,
          containerStyleProp = _this$props2.containerStyle,
          disabled = _this$props2.disabled,
          disableLazyLoading = _this$props2.disableLazyLoading,
          enableMouseEvents = _this$props2.enableMouseEvents,
          hysteresis = _this$props2.hysteresis,
          ignoreNativeScroll = _this$props2.ignoreNativeScroll,
          index = _this$props2.index,
          onChangeIndex = _this$props2.onChangeIndex,
          onSwitching = _this$props2.onSwitching,
          onTransitionEnd = _this$props2.onTransitionEnd,
          resistance = _this$props2.resistance,
          slideStyleProp = _this$props2.slideStyle,
          slideClassName = _this$props2.slideClassName,
          springConfig = _this$props2.springConfig,
          style = _this$props2.style,
          threshold = _this$props2.threshold,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "animateHeight", "animateTransitions", "axis", "children", "containerStyle", "disabled", "disableLazyLoading", "enableMouseEvents", "hysteresis", "ignoreNativeScroll", "index", "onChangeIndex", "onSwitching", "onTransitionEnd", "resistance", "slideStyle", "slideClassName", "springConfig", "style", "threshold"]);
      var _this$state = this.state,
          displaySameSlide = _this$state.displaySameSlide,
          heightLatest = _this$state.heightLatest,
          indexLatest = _this$state.indexLatest,
          isDragging = _this$state.isDragging,
          renderOnlyActive = _this$state.renderOnlyActive;
      var touchEvents = !disabled ? {
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};
      var mouseEvents = !disabled && enableMouseEvents ? {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove
      } : {}; // There is no point to animate if we are already providing a height.

       false ? (0, _warning.default)(!animateHeight || !containerStyleProp || !containerStyleProp.height, "react-swipeable-view: You are setting animateHeight to true but you are\nalso providing a custom height.\nThe custom height has a higher priority than the animateHeight property.\nSo animateHeight is most likely having no effect at all.") : void 0;
      var slideStyle = (0, _extends2.default)({}, styles.slide, slideStyleProp);
      var transition;
      var WebkitTransition;

      if (isDragging || !animateTransitions || displaySameSlide) {
        transition = 'all 0s ease 0s';
        WebkitTransition = 'all 0s ease 0s';
      } else {
        transition = createTransition('transform', springConfig);
        WebkitTransition = createTransition('-webkit-transform', springConfig);

        if (heightLatest !== 0) {
          var additionalTranstion = ", ".concat(createTransition('height', springConfig));
          transition += additionalTranstion;
          WebkitTransition += additionalTranstion;
        }
      }

      var containerStyle = {
        height: null,
        WebkitFlexDirection: axisProperties.flexDirection[axis],
        flexDirection: axisProperties.flexDirection[axis],
        WebkitTransition: WebkitTransition,
        transition: transition
      }; // Apply the styles for SSR considerations

      if (!renderOnlyActive) {
        var transform = axisProperties.transform[axis](this.indexCurrent * 100);
        containerStyle.WebkitTransform = transform;
        containerStyle.transform = transform;
      }

      if (animateHeight) {
        containerStyle.height = heightLatest;
      }

      return _react.default.createElement("div", (0, _extends2.default)({
        ref: this.setRootNode,
        style: (0, _extends2.default)({}, axisProperties.root[axis], style)
      }, other, touchEvents, mouseEvents, {
        onScroll: this.handleScroll
      }), _react.default.createElement("div", {
        ref: this.setContainerNode,
        style: (0, _extends2.default)({}, containerStyle, styles.container, containerStyleProp),
        className: "react-swipeable-view-container"
      }, _react.default.Children.map(children, function (child, indexChild) {
        if (renderOnlyActive && indexChild !== indexLatest) {
          return null;
        }

         false ? (0, _warning.default)(_react.default.isValidElement(child), "react-swipeable-view: one of the children provided is invalid: ".concat(child, ".\nWe are expecting a valid React Element")) : void 0;
        var ref;
        var hidden = true;

        if (indexChild === indexLatest) {
          hidden = false;

          if (animateHeight) {
            ref = _this4.setActiveSlide;
            slideStyle.overflowY = 'hidden';
          }
        }

        return _react.default.createElement("div", {
          ref: ref,
          style: slideStyle,
          className: slideClassName,
          "aria-hidden": hidden,
          "data-swipeable": "true"
        }, child);
      })));
    }
  }]);
  return SwipeableViews;
}(_react.default.Component); // Added as an ads for people using the React dev tools in production.
// So they know, the tool used to build the awesome UI they
// are looking at/retro engineering.


SwipeableViews.displayName = 'ReactSwipableView';
SwipeableViews.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updateHeight() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * If `true`, the height of the container will be animated to match the current slide height.
   * Animating another style property has a negative impact regarding performance.
   */
  animateHeight: _propTypes.default.bool,

  /**
   * If `false`, changes to the index prop will not cause an animated transition.
   */
  animateTransitions: _propTypes.default.bool,

  /**
   * The axis on which the slides will slide.
   */
  axis: _propTypes.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),

  /**
   * Use this property to provide your slides.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * This is the inlined style that will be applied
   * to each slide container.
   */
  containerStyle: _propTypes.default.object,

  /**
   * If `true`, it will disable touch events.
   * This is useful when you want to prohibit the user from changing slides.
   */
  disabled: _propTypes.default.bool,

  /**
   * This is the config used to disable lazyloding,
   * if `true` will render all the views in first rendering.
   */
  disableLazyLoading: _propTypes.default.bool,

  /**
   * If `true`, it will enable mouse events.
   * This will allow the user to perform the relevant swipe actions with a mouse.
   */
  enableMouseEvents: _propTypes.default.bool,

  /**
   * Configure hysteresis between slides. This value determines how far
   * should user swipe to switch slide.
   */
  hysteresis: _propTypes.default.number,

  /**
   * If `true`, it will ignore native scroll container.
   * It can be used to filter out false positive that blocks the swipe.
   */
  ignoreNativeScroll: _propTypes.default.bool,

  /**
   * This is the index of the slide to show.
   * This is useful when you want to change the default slide shown.
   * Or when you have tabs linked to each slide.
   */
  index: _propTypes.default.number,

  /**
   * This is callback prop. It's call by the
   * component when the shown slide change after a swipe made by the user.
   * This is useful when you have tabs linked to each slide.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {integer} indexLatest This is the oldest index of the slide.
   * @param {object} meta Meta data containing more information about the event.
   */
  onChangeIndex: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onScroll: _propTypes.default.func,

  /**
   * This is callback prop. It's called by the
   * component when the slide switching.
   * This is useful when you want to implement something corresponding
   * to the current slide position.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {string} type Can be either `move` or `end`.
   */
  onSwitching: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchEnd: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchStart: _propTypes.default.func,

  /**
   * The callback that fires when the animation comes to a rest.
   * This is useful to defer CPU intensive task.
   */
  onTransitionEnd: _propTypes.default.func,

  /**
   * If `true`, it will add bounds effect on the edges.
   */
  resistance: _propTypes.default.bool,

  /**
   * This is the className that will be applied
   * on the slide component.
   */
  slideClassName: _propTypes.default.string,

  /**
   * This is the inlined style that will be applied
   * on the slide component.
   */
  slideStyle: _propTypes.default.object,

  /**
   * This is the config used to create CSS transitions.
   * This is useful to change the dynamic of the transition.
   */
  springConfig: _propTypes.default.shape({
    delay: _propTypes.default.string,
    duration: _propTypes.default.string,
    easeFunction: _propTypes.default.string
  }),

  /**
   * This is the inlined style that will be applied
   * on the root component.
   */
  style: _propTypes.default.object,

  /**
   * This is the threshold used for detecting a quick swipe.
   * If the computed speed is above this value, the index change.
   */
  threshold: _propTypes.default.number
} : {};
SwipeableViews.defaultProps = {
  animateHeight: false,
  animateTransitions: true,
  axis: 'x',
  disabled: false,
  disableLazyLoading: false,
  enableMouseEvents: false,
  hysteresis: 0.6,
  ignoreNativeScroll: false,
  index: 0,
  threshold: 5,
  springConfig: {
    duration: '0.35s',
    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
    delay: '0s'
  },
  resistance: false
};
SwipeableViews.childContextTypes = {
  swipeableViews: _propTypes.default.shape({
    slideUpdateHeight: _propTypes.default.func
  })
};
var _default = SwipeableViews;
exports.default = _default;

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(1234);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(1238);

var assertThisInitialized = __webpack_require__(1239);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1242);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(89);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(265));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(89);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(265));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(89);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(265));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(89);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "checkIndexBounds", {
  enumerable: true,
  get: function get() {
    return _checkIndexBounds.default;
  }
});
Object.defineProperty(exports, "computeIndex", {
  enumerable: true,
  get: function get() {
    return _computeIndex.default;
  }
});
Object.defineProperty(exports, "constant", {
  enumerable: true,
  get: function get() {
    return _constant.default;
  }
});
Object.defineProperty(exports, "getDisplaySameSlide", {
  enumerable: true,
  get: function get() {
    return _getDisplaySameSlide.default;
  }
});
Object.defineProperty(exports, "mod", {
  enumerable: true,
  get: function get() {
    return _mod.default;
  }
});

var _checkIndexBounds = _interopRequireDefault(__webpack_require__(1247));

var _computeIndex = _interopRequireDefault(__webpack_require__(1248));

var _constant = _interopRequireDefault(__webpack_require__(520));

var _getDisplaySameSlide = _interopRequireDefault(__webpack_require__(1249));

var _mod = _interopRequireDefault(__webpack_require__(1250));

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(89);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(34));

var checkIndexBounds = function checkIndexBounds(props) {
  var index = props.index,
      children = props.children;

  var childrenCount = _react.default.Children.count(children);

   false ? (0, _warning.default)(index >= 0 && index <= childrenCount, "react-swipeable-view: the new index: ".concat(index, " is out of bounds: [0-").concat(childrenCount, "].")) : void 0;
};

var _default = checkIndexBounds;
exports.default = _default;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(89);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computeIndex;

var _react = _interopRequireDefault(__webpack_require__(0));

var _constant = _interopRequireDefault(__webpack_require__(520));

function computeIndex(params) {
  var children = params.children,
      startIndex = params.startIndex,
      startX = params.startX,
      pageX = params.pageX,
      viewLength = params.viewLength,
      resistance = params.resistance;
  var indexMax = _react.default.Children.count(children) - 1;
  var index = startIndex + (startX - pageX) / viewLength;
  var newStartX;

  if (!resistance) {
    // Reset the starting point
    if (index < 0) {
      index = 0;
      newStartX = (index - startIndex) * viewLength + pageX;
    } else if (index > indexMax) {
      index = indexMax;
      newStartX = (index - startIndex) * viewLength + pageX;
    }
  } else if (index < 0) {
    index = Math.exp(index * _constant.default.RESISTANCE_COEF) - 1;
  } else if (index > indexMax) {
    index = indexMax + 1 - Math.exp((indexMax - index) * _constant.default.RESISTANCE_COEF);
  }

  return {
    index: index,
    startX: newStartX
  };
}

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
  var displaySameSlide = false;

  if (props.children.length && nextProps.children.length) {
    var oldChildren = props.children[props.index];
    var oldKey = oldChildren ? oldChildren.key : 'empty';

    if (oldKey !== null) {
      var newChildren = nextProps.children[nextProps.index];
      var newKey = newChildren ? newChildren.key : 'empty';

      if (oldKey === newKey) {
        displaySameSlide = true;
      }
    }
  }

  return displaySameSlide;
};

var _default = getDisplaySameSlide;
exports.default = _default;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Extended version of % with negative integer support.
function mod(n, m) {
  var q = n % m;
  return q < 0 ? q + m : q;
}

var _default = mod;
exports.default = _default;

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1252);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* canUseDOM */]) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUseDOM; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This file is a fallback for a consumer who is not yet on React 16
// as createPortal was introduced in React 16





var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(this.defaultNode || this.props.node);
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof this.props.children.type === 'function') {
        children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children);
      }

      this.portal = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Portal);


Portal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PortalCompat__ = __webpack_require__(522);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var KEYCODES = {
  ESCAPE: 27
};

var PortalWithState = function (_React$Component) {
  _inherits(PortalWithState, _React$Component);

  function PortalWithState(props) {
    _classCallCheck(this, PortalWithState);

    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));

    _this.portalNode = null;
    _this.state = { active: !!props.defaultOpen };
    _this.openPortal = _this.openPortal.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    return _this;
  }

  _createClass(PortalWithState, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.addEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'openPortal',
    value: function openPortal(e) {
      if (this.state.active) {
        return;
      }
      if (e && e.nativeEvent) {
        e.nativeEvent.stopImmediatePropagation();
      }
      this.setState({ active: true }, this.props.onOpen);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      if (!this.state.active) {
        return;
      }
      this.setState({ active: false }, this.props.onClose);
    }
  }, {
    key: 'wrapWithPortal',
    value: function wrapWithPortal(children) {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__PortalCompat__["a" /* default */],
        {
          node: this.props.node,
          key: 'react-portal',
          ref: function ref(portalNode) {
            return _this2.portalNode = portalNode;
          }
        },
        children
      );
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }
      var root = this.portalNode.props.node || this.portalNode.defaultNode;
      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        openPortal: this.openPortal,
        closePortal: this.closePortal,
        portal: this.wrapWithPortal,
        isOpen: this.state.active
      });
    }
  }]);

  return PortalWithState;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PortalWithState.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  defaultOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  closeOnEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  closeOnOutsideClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

PortalWithState.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};

/* harmony default export */ __webpack_exports__["a"] = (PortalWithState);

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return (/** @class */function () {
            function class_1() {
                this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
                /**
                 * @returns {boolean}
                 */
                get: function get() {
                    return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * @param {*} key
             * @returns {*}
             */
            class_1.prototype.get = function (key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
            };
            /**
             * @param {*} key
             * @param {*} value
             * @returns {void}
             */
            class_1.prototype.set = function (key, value) {
                var index = getIndex(this.__entries__, key);
                if (~index) {
                    this.__entries__[index][1] = value;
                } else {
                    this.__entries__.push([key, value]);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.delete = function (key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);
                if (~index) {
                    entries.splice(index, 1);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.has = function (key) {
                return !!~getIndex(this.__entries__, key);
            };
            /**
             * @returns {void}
             */
            class_1.prototype.clear = function () {
                this.__entries__.splice(0);
            };
            /**
             * @param {Function} callback
             * @param {*} [ctx=null]
             * @returns {void}
             */
            class_1.prototype.forEach = function (callback, ctx) {
                if (ctx === void 0) {
                    ctx = null;
                }
                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                }
            };
            return class_1;
        }()
    );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) {
        return setTimeout(function () {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName,
            propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth,
        clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();

var ResizeObserverEntry = /** @class */function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}();

var ResizeObserverSPI = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
}();

/* harmony default export */ __webpack_exports__["a"] = (index);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZoomZoom;
/* eslint-disable no-console */

var zoom = "zoom zoom 🚗 (◠‿◠✿)✌️";

var didZoomZoom = false;

function ZoomZoom() {
  if (didZoomZoom) return;
  didZoomZoom = true;
  console.log(zoom);
}

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2b173e96c2c81703a2f16911b69965e2.svg";

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ce829663b4e2d76327d89d87ce21b6a4.svg";

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_layout__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_componentParser__ = __webpack_require__(14);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\global-nav\\sub-nav-large.jsx",
    _primaryPanel,
    _secondaryPanel;









var getSections = function getSections(components, active) {
  return {
    primary: Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_componentParser__["a" /* default */])(components),
    secondary: Object(__WEBPACK_IMPORTED_MODULE_2_utils__["m" /* flatMap */])(function (comp) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_utils__["m" /* flatMap */])(function (_ref) {
        var name = _ref.name,
            props = _ref.props;

        // @todo Hacky map to derive subcomponents needs refactor
        if (name === "FlexContent") {
          return Object(__WEBPACK_IMPORTED_MODULE_2_utils__["q" /* get */])("components", props);
        }
        return null;
      }, Object(__WEBPACK_IMPORTED_MODULE_2_utils__["q" /* get */])("props.components", comp || {}));
    }, Object(__WEBPACK_IMPORTED_MODULE_2_utils__["q" /* get */])("props.components", components[active] || {}))
  };
};

var SubNavLarge = function SubNavLarge(_ref2) {
  var navItems = _ref2.navItems,
      activeItemIndex = _ref2.activeItemIndex,
      toggleActive = _ref2.toggleActive;

  var _getSections = getSections(navItems.filter(function (item) {
    return item !== null;
  }), activeItemIndex),
      primary = _getSections.primary,
      secondary = _getSections.secondary;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.wrapper, "data-test": "sub-nav-large", __source: {
        fileName: _jsxFileName,
        lineNumber: 27
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: [styles.panel, styles.primaryPanel], __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(primary, function (comp, index) {
        var childProps = {
          active: activeItemIndex === index,
          onClick: function onClick() {
            return toggleActive(index);
          },
          subNav: true
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: [styles.navLinkWrapper(index === 0)], key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 36
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["A" /* GlobalNavLink */], _extends({}, comp.props, childProps, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 37
            }
          }))
        );
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: [styles.panel, styles.secondaryPanel], __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      },
      secondary.map(function (_ref3, index) {
        var props = _ref3.props;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: [styles.navLinkWrapper(index === 0)], key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 44
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["C" /* GlobalNavLinkSecondary */], _extends({ key: index }, props, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 45
            }
          }))
        );
      })
    )
  );
};

SubNavLarge.displayName = "SubNavLarge";
SubNavLarge.displayName = "SubNavLarge";
SubNavLarge.propTypes = {
  navItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  activeItemIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  toggleActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["f" /* Radium */])(SubNavLarge));

/** @todo transform animations disrupt initial menu open on IE 11, disable for now */
var linkAnimateIn = Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["j" /* keyframes */])({
  from: {
    opacity: 0
    // transform: 'translateY(-50%)'
  },
  to: {
    opacity: 1
    // transform: 'translateY(0)'
  }
});

var breakpoint1 = "@media all and (min-width: " + (__WEBPACK_IMPORTED_MODULE_3_constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */] + "px") + ") and (max-width: " + (__WEBPACK_IMPORTED_MODULE_3_constants_layout__["c" /* DEFAULT_THRESHOLD_WIDE */] + "px") + ")";

var styles = {
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    height: "100%"
  },
  panel: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    boxSizing: "border-box",
    overflow: "hidden"
  },
  primaryPanel: (_primaryPanel = {
    width: "32%"
  }, _primaryPanel[breakpoint1] = {
    width: "40%"
  }, _primaryPanel),
  secondaryPanel: (_secondaryPanel = {
    textTransform: "none",
    width: "68%",
    backgroundColor: "#e6e6e6",
    padding: "0 2em 0 8vw"
  }, _secondaryPanel[breakpoint1] = {
    width: "60%"
  }, _secondaryPanel),
  navLinkWrapper: function navLinkWrapper(isFirst) {
    return {
      marginTop: isFirst ? "calc(12vw + .5em)" : 0
    };
  },
  animateIn: function animateIn(animDelay) {
    return {
      opacity: 0,
      animation: "x .75s " + animDelay + "s forwards",
      animationName: linkAnimateIn
    };
  }
};

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__ = __webpack_require__(14);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\global-nav\\sub-nav-compact.jsx";







/**
 * Sub-Navigation Component.
 * @param {Array|FlexContent} components - Nested Components
 * @returns {ReactElement} React Component
 */
var SubNavCompact = function SubNavCompact(_ref) {
  var navItems = _ref.navItems,
      activeItemIndex = _ref.activeItemIndex,
      _toggleActive = _ref.toggleActive,
      close = _ref.close,
      children = _ref.children,
      hideNavItems = _ref.hideNavItems;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.base, onKeyDown: close, "data-test": "sub-nav-compact", __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    },
    children,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: [styles.panel, hideNavItems && { opacity: 0 }], __source: {
          fileName: _jsxFileName,
          lineNumber: 23
        }
      },
      navItems.map(function (comp, index) {
        if (!comp) return;
        if (comp.props.components && comp.props.components.length) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["B" /* GlobalNavLinkAccordion */], _extends({}, comp.props, {
            key: index,
            active: activeItemIndex === index,
            toggleActive: function toggleActive() {
              return _toggleActive(index);
            },
            subNav: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 28
            }
          }));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.navLinkWrapper, key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 37
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])([comp], {
            active: activeItemIndex === index,
            toggleActive: function toggleActive() {
              return _toggleActive(index);
            },
            subNav: true
          })
        );
      })
    )
  );
};

SubNavCompact.displayName = "SubNavCompact";
SubNavCompact.displayName = "SubNavCompact";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__higher_order_components__["f" /* Radium */])(SubNavCompact));

SubNavCompact.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  navItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  activeItemIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  toggleActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hideNavItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

SubNavCompact.defaultProps = {
  activeItemIndex: 0,
  toggleActive: __WEBPACK_IMPORTED_MODULE_2_utils__["C" /* noop */],
  close: __WEBPACK_IMPORTED_MODULE_2_utils__["C" /* noop */]
};

var styles = {
  base: {
    position: "absolute",
    top: 0,
    left: "100vw",
    width: "calc(100vw - (3em + 40px))",
    height: "100vh",
    overflow: "scroll",
    background: "#dedede",
    boxSizing: "border-box",
    WebkitOverflowScrolling: "touch",
    transition: "opacity .5s"
  },
  navLinkWrapper: {
    display: "block",
    margin: "auto",
    flex: "1 1 100%"
  },
  panel: {
    transition: "opacity .25s",
    padding: "1em 0"
  }
};

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__search_field_slider__ = __webpack_require__(1262);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__search_field_slider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search_results_drawer__ = __webpack_require__(1263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__search_results_drawer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_field_compact__ = __webpack_require__(1264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__search_field_compact__["a"]; });







/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\global-nav-search\\search-field-slider.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var width = "4em";

var GlobalNavSearchFieldSlider = function GlobalNavSearchFieldSlider(_ref) {
  var _ref$open = _ref.open,
      open = _ref$open === undefined ? false : _ref$open,
      onOpen = _ref.onOpen,
      _ref$placeholderText = _ref.placeholderText,
      placeholderText = _ref$placeholderText === undefined ? "What are you looking for?" : _ref$placeholderText,
      innerInputRef = _ref.innerInputRef,
      onSlideEnd = _ref.onSlideEnd,
      props = _objectWithoutProperties(_ref, ["open", "onOpen", "placeholderText", "innerInputRef", "onSlideEnd"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        display: "inline-block",
        marginRight: width
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: styles.drawer(open),
        onTransitionEnd: function onTransitionEnd(e) {
          // Multiple transitionEnd event's fired. The drawer animation is a transform.
          if (e.propertyName === "transform") {
            onSlideEnd(e, open);
          }
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 22
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            display: "flex",
            height: "100%",
            boxSizing: "border-box",
            alignItems: "center",
            fontSize: "110%",
            padding: "0 2em .5em .5em"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 30
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_1" /* SearchInput */], _extends({
          innerRef: innerInputRef,
          onSearchIconClick: onOpen,
          lineColor: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARKER,
          focusStyle: false,
          behaviour: "close",
          styleName: "dark",
          icon: "cross",
          type: "text",
          fadeOutInput: !open,
          placeholder: placeholderText
        }, props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 39
          }
        }))
      )
    )
  );
};

GlobalNavSearchFieldSlider.displayName = "GlobalNavSearchFieldSlider";
GlobalNavSearchFieldSlider.displayName = "GlobalNavSearchFieldSlider";
GlobalNavSearchFieldSlider.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placeholderText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  searchPageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerInputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(GlobalNavSearchFieldSlider));

var styles = {
  drawer: function drawer(open) {
    return {
      position: "absolute",
      backgroundColor: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].BLACK,
      right: 0,
      top: 0,
      bottom: 0,
      left: "1em",
      transition: "transform 1s " + (open ? 0 : 0.5) + "s",
      transform: open ? "translateX(0)" : "translateX(100%) translateX(-" + width + ")"
    };
  },
  searchWrapper: {
    height: "1.25em",
    width: "1.25em",
    cursor: "pointer",
    verticalAlign: "middle",
    transition: ".25s",
    color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARK,
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].WHITE,
      outline: 0
    }
  },
  searchSvg: {
    width: "100%",
    height: "100%",
    fill: "currentColor",
    display: "inline-block"
  }
};

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\global-nav-search\\search-results-drawer.jsx";





var GlobalNavSearchResultsDrawer = function GlobalNavSearchResultsDrawer(_ref) {
  var open = _ref.open,
      query = _ref.query,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { position: "relative", zIndex: 5 }, __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          position: "absolute",
          width: "100%",
          overflow: "hidden",
          pointerEvents: "none"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY_LIGHT,
            padding: "1.5em",
            pointerEvents: "all",
            boxSizing: "border-box",
            transition: "transform .5s " + (open ? 0.5 : 0) + "s",
            transform: open ? "none" : "translateY(-100%)"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 15
          }
        },
        children
      )
    )
  );
};

GlobalNavSearchResultsDrawer.displayName = "GlobalNavSearchResultsDrawer";
GlobalNavSearchResultsDrawer.displayName = "GlobalNavSearchResultsDrawer";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__higher_order_components_configured_radium___["a" /* default */])(GlobalNavSearchResultsDrawer));

var styles = {};

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\global-nav-search\\search-field-compact.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var GlobalNavSearchFieldCompact = function GlobalNavSearchFieldCompact(_ref) {
  var height = _ref.height,
      placeholderText = _ref.placeholderText,
      innerInputRef = _ref.innerInputRef,
      searchFieldProps = _objectWithoutProperties(_ref, ["height", "placeholderText", "innerInputRef"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        boxSizing: "border-box",
        backgroundColor: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].BLACK,
        height: height
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      style: {
        height: "calc(100% - 2em)",
        borderLeft: "1px solid " + __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_DARKER
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          padding: "0.5em 1em",
          width: "100%"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_1" /* SearchInput */], _extends({
        innerRef: innerInputRef,
        lineColor: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_DARKER,
        focusStyle: false,
        styleName: "dark",
        placeholder: placeholderText
      }, searchFieldProps, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 31
        }
      }))
    )
  );
};

GlobalNavSearchFieldCompact.displayName = "GlobalNavSearchFieldCompact";
GlobalNavSearchFieldCompact.displayName = "GlobalNavSearchFieldCompact";
GlobalNavSearchFieldCompact.propTypes = {};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(GlobalNavSearchFieldCompact));

var styles = {};

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_nav_item_grid__ = __webpack_require__(183);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\global-nav-overlay\\index.jsx";





var GlobalNavOverlayBlock = function GlobalNavOverlayBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["D" /* GlobalNavOverlay */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};

GlobalNavOverlayBlock.displayName = "GlobalNavOverlayBlock";
GlobalNavOverlayBlock.displayName = "GlobalNavOverlayBlock";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["l" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__global_nav_item_grid__["a" /* default */]]
})(GlobalNavOverlayBlock));

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_heading_video_frame__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_countdown_timer__ = __webpack_require__(261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\heading-video-frame\\index.jsx";





var HeadingVideoFrameBlock = function HeadingVideoFrameBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_heading_video_frame__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};

HeadingVideoFrameBlock.displayName = "HeadingVideoFrameBlock";
HeadingVideoFrameBlock.displayName = "HeadingVideoFrameBlock";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["l" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3_blocks_countdown_timer__["a" /* default */]]
})(HeadingVideoFrameBlock));

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(13);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\heading-video-frame\\index.jsx";





var HeadingVideoFrame = function HeadingVideoFrame(_ref) {
  var preHeadingTagOverride = _ref.preHeadingTagOverride,
      tagOverride = _ref.tagOverride,
      mobilePreHeading = _ref.mobilePreHeading,
      mobileHeading = _ref.mobileHeading,
      preHeading = _ref.preHeading,
      heading = _ref.heading,
      compact = _ref.compact,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.wrapper, __source: {
        fileName: _jsxFileName,
        lineNumber: 16
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["s" /* HeadingBlock */], {
      preHeadingTagOverride: preHeadingTagOverride,
      tagOverride: tagOverride,
      preHeading: mobilePreHeading && compact ? mobilePreHeading : preHeading,
      value: compact ? mobileHeading : heading,
      tag: "h1",
      feature: true,
      margin: true, __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.componentArea, __source: {
          fileName: _jsxFileName,
          lineNumber: 25
        }
      },
      children
    )
  );
};

HeadingVideoFrame.displayName = "HeadingVideoFrame";
HeadingVideoFrame.displayName = "HeadingVideoFrame";
var styles = {
  wrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    textAlign: "center",
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].WHITE
  },
  componentArea: {
    marginBottom: "2em"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["b" /* DetectCompact */])())(HeadingVideoFrame));

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"IdWrapper":"IdWrapper__IdWrapper___3YxoH","IdWrapperSlug":"IdWrapper__IdWrapperSlug___2PAUa","IdWrapperSlugStandalone":"IdWrapper__IdWrapperSlugStandalone___1uJj_"};

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FlexContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__countdown_timer__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dynamic_text_video_frame__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__full_width_multi_video__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_nav_item_grid__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gyroscope__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__heading_section__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hero_video_with_timed_frames__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__map_search__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__map_select_state__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__single_dealer_map__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__time_clock_video_frame__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mymazda__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mymazda_manage_account__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mymazda_account_password__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mymazda_create_account__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mymazda_dealer_block__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mymazda_dynamic_resource__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mymazda_dynamic_resource_item__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mymazda_vehicle_specs__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mymazda_manage_vehicles__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mymazda_notifications__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mymazda_policies__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mymazda_policies_detail__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mymazda_policies_item__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mymazda_policies_summary__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__mymazda_recall_notification__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__mymazda_registration__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__mymazda_reset_password__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__mymazda_service_export__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__mymazda_service_form__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__mymazda_service_summary__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__mymazda_redirect__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__mymazda_vehicle_resource_list__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__mymazda_service_carousel__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__mymazda_service_history__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__mymazda_confirm_change_email__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__compare_vehicle_selector__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__full_width_image_section__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__global_nav__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__text_media_slider__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__global_nav_dropdown__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__offers__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__outlet_store_detail__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__service_details_full__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__site_search__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__tout_block__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__dealer_map_page__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__RecallsBlock__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__WysiwygContent__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Column__ = __webpack_require__(1276);
/* unused harmony reexport Accessories */
/* unused harmony reexport AccessoryDetails */
/* unused harmony reexport AccessoryList */
/* unused harmony reexport AccessoryPackDetails */
/* unused harmony reexport AccordionGroup */
/* unused harmony reexport CompareTool */
/* unused harmony reexport CompareVehicleSelector */
/* unused harmony reexport Configurator */
/* unused harmony reexport CountdownTimer */
/* unused harmony reexport DealerMapPage */
/* unused harmony reexport DynamicTextVideoFrameBlock */
/* unused harmony reexport FeatureYouTube */
/* unused harmony reexport FlexIconLink */
/* unused harmony reexport Footer */
/* unused harmony reexport FullWidthImageSection */
/* unused harmony reexport FullWidthMultiVideoBlock */
/* unused harmony reexport Gallery */
/* unused harmony reexport GalleryFullWidth */
/* unused harmony reexport GalleryItem */
/* unused harmony reexport GlobalNav */
/* unused harmony reexport GlobalNavItemGridBlock */
/* unused harmony reexport GyroscopeBlock */
/* unused harmony reexport Heading */
/* unused harmony reexport HeadingSectionBlock */
/* unused harmony reexport HeroVideoWithTimedFrames */
/* unused harmony reexport Hyperlink */
/* unused harmony reexport IconToutBlock */
/* unused harmony reexport ImageToutBlock */
/* unused harmony reexport InteractiveSlideshowBlock */
/* unused harmony reexport MapSearchBlock */
/* unused harmony reexport MapSelectStateBlock */
/* unused harmony reexport NavDropdown */
/* unused harmony reexport Offers */
/* unused harmony reexport OutletDetail */
/* unused harmony reexport OutletStoreSpecificationsBlock */
/* unused harmony reexport Overlay */
/* unused harmony reexport PostcodePopup */
/* unused harmony reexport ScrapedPage */
/* unused harmony reexport ServiceCalculatorOwner */
/* unused harmony reexport ServiceCalculatorProspect */
/* unused harmony reexport ServiceDetailsFull */
/* unused harmony reexport SingleDealerMapBlock */
/* unused harmony reexport SiteSearchBlock */
/* unused harmony reexport SocialIcons */
/* unused harmony reexport TimeClockVideoFrameBlock */
/* unused harmony reexport ToutBlock */
/* unused harmony reexport TriggeredOverlay */
/* unused harmony reexport VideoSlideshow */
/* unused harmony reexport MyMazda */
/* unused harmony reexport MyMazdaManageAccountBlock */
/* unused harmony reexport MyMazdaAccountPassword */
/* unused harmony reexport MyMazdaCreateAccount */
/* unused harmony reexport MyMazdaDealerBlock */
/* unused harmony reexport MyMazdaDynamicResource */
/* unused harmony reexport MyMazdaDynamicResourceItem */
/* unused harmony reexport MyMazdaFullSpecBlock */
/* unused harmony reexport MyMazdaLogin */
/* unused harmony reexport MyMazdaManageVehiclesBlock */
/* unused harmony reexport MyMazdaNotifications */
/* unused harmony reexport MyMazdaPolicies */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_24__mymazda_policies_detail__["a"]; });
/* unused harmony reexport MyMazdaPolicyItem */
/* unused harmony reexport MyMazdaPolicySummary */
/* unused harmony reexport MyMazdaRecallNotification */
/* unused harmony reexport MyMazdaRegistration */
/* unused harmony reexport MyMazdaResetPassword */
/* unused harmony reexport MyMazdaServiceHistoryExport */
/* unused harmony reexport MyMazdaServiceRequestFormBlock */
/* unused harmony reexport MyMazdaServiceSummaryBlock */
/* unused harmony reexport MyMazdaSpecificationBlock */
/* unused harmony reexport MyMazdaSummary */
/* unused harmony reexport MyMazdaUnauthRedirectBlock */
/* unused harmony reexport MyMazdaVehicleResourceList */
/* unused harmony reexport MyMazdaVehicleServiceCarouselBlock */
/* unused harmony reexport MyMazdaVehicleServiceHistoryBlock */
/* unused harmony reexport MyMazdaConfirmChangeEmailBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_AtomicContainers__ = __webpack_require__(8);
/* unused harmony reexport CardYoutubePlayerList */
/* unused harmony reexport ContentCardList */
/* unused harmony reexport RecallDocument */
/* unused harmony reexport PDFTemplate */
/* unused harmony reexport SixtyFourtyBlock */
/* unused harmony reexport FiftyFiftyBlock */
/* unused harmony reexport Button */
/* unused harmony reexport GradePicker */
/* unused harmony reexport SpecificationsBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_AtomicComponents__ = __webpack_require__(2);
/* unused harmony reexport ColumnGroup */
/* unused harmony reexport RecallsBlock */
/* unused harmony reexport WysiwygContent */
/* unused harmony reexport Column */
// What are Blocks
// Blocks are defined in Backend for using in CMS

 // eslint-disable-line import/no-duplicates

 // @CMS-CHANGE FlexIconLink => NameplateLink

// Import blocks without name-change












// MyMazda


























// Import blocks with name-change (@TODO: Change these names in CMS)
 // @CMS-CHANGE CompareVehicleSelector => CompareVehicleSelectorBlock
 // @CMS-CHANGE FullWidthImageSection => FullWidthImageSectionBlock
 // @CMS-CHANGE GlobalNav => GlobalNavBlock
 // @CMS-CHANGE InteractiveSlideshowBlock => TextMediaSliderBlock
 // @CMS-CHANGE NavDropdown => GlobalNavDropdownBlock
 // @CMS-CHANGE Offers => OffersBlock
 // @CMS-CHANGE OutletDetail => OutletStoreDetailBlock
 // @CMS-CHANGE ServiceDetailsFull => ServiceDetailsFullBlock

 // @CMS-CHANGE what is it really?
 // eslint-disable-line import/first, import/no-duplicates
 // @CMS-CHANGE FlexContent => GlobalNavItemGridBlock


// Atomic Design




var FlexContent = __WEBPACK_IMPORTED_MODULE_5__global_nav_item_grid__["a" /* default */];

// Export All


// MyMazda


// Atomic Design






/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_gtm_events__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\mymazda\\service\\history.jsx";






var MyMazdaVehicleServiceHistoryBlock = function MyMazdaVehicleServiceHistoryBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_containers__["g" /* ColumnGroup */],
    { verticalPadding: true, backgroundColor: props.backgroundColor || "#fff", __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_containers__["f" /* Column */],
      { textAlignMobile: "left", textAlign: "left", __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      props.heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["F" /* Heading */], {
        size: "medium",
        value: props.heading,
        customHeadingStyle: { marginBottom: "0.5em", textAlign: "center" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 11
        }
      }),
      props.blurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { style: { fontSize: "14px", fontWeight: "200", textAlign: "center", lineHeight: "20px" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 17
          }
        },
        props.blurb
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_19" /* VehicleServiceHistory */], _extends({
        gtmOnHistoryButtonClick: createGtmAction.historyButtonClick
      }, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 19
        }
      }))
    )
  );
};

MyMazdaVehicleServiceHistoryBlock.displayName = "MyMazdaVehicleServiceHistoryBlock";
MyMazdaVehicleServiceHistoryBlock.displayName = "MyMazdaVehicleServiceHistoryBlock";
MyMazdaVehicleServiceHistoryBlock.propTypes = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  blurb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var createGtmAction = {
  historyButtonClick: function historyButtonClick(_ref) {
    var buttonText = _ref.buttonText;
    return {
      gtmID: __WEBPACK_IMPORTED_MODULE_4_store_gtm_events__["i" /* gtmMyMazda2ActionTypes */].SERVICE_HISTORY_CLICK,
      gtmPayload: { buttonText: buttonText }
    };
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (MyMazdaVehicleServiceHistoryBlock);

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\compare-vehicle-selector\\index.jsx";





var mapCMScomponents = function mapCMScomponents(_ref) {
  var name = _ref.name,
      props = _ref.props;
  return {
    name: name === "FlexIconLink" ? "NameplateLink" : name,
    props: props
  };
};

var CompareVehicleSelectorBlock = function CompareVehicleSelectorBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["h" /* CompareVehicleSelectorContainer */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    }
  }));
};

CompareVehicleSelectorBlock.displayName = "CompareVehicleSelectorBlock";
CompareVehicleSelectorBlock.displayName = "CompareVehicleSelectorBlock";
CompareVehicleSelectorBlock.displayName = "CompareVehicleSelector"; // @CMS-CHANGE CompareVehicleSelector => CompareVehicleSelectorBlock

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["l" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3_components__["S" /* NameplateLink */]],
  mapInput: mapCMScomponents // @CMS-CHANGE in global nav FlexIconLink => NameplateLink
})(CompareVehicleSelectorBlock));

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_global_nav_link__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_nav_dropdown__ = __webpack_require__(186);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\global-nav\\index.jsx";






var mapCMScomponents = function mapCMScomponents(_ref) {
  var name = _ref.name,
      props = _ref.props;
  return {
    name: name === "NavLink" ? "GlobalNavLink" : name,
    props: props
  };
};

var GlobalNavBlock = function GlobalNavBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["q" /* GlobalNavContainer */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    }
  }));
};

GlobalNavBlock.displayName = "GlobalNavBlock";
GlobalNavBlock.displayName = "GlobalNavBlock";
GlobalNavBlock.displayName = "GlobalNav"; // @CMS-CHANGE Offers => GlobalNavBlock

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["l" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_4__global_nav_dropdown__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_components_global_nav_link__["a" /* default */]],
  mapInput: mapCMScomponents // @CMS-CHANGE in global nav NavLink => GlobalNavLink
})(GlobalNavBlock));

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_column_group__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_wysiwyg_content__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__full_width_image_section__ = __webpack_require__(556);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\offers\\index.jsx";







var OffersBlock = function OffersBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["J" /* OffersContainer */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    }
  }));
};

OffersBlock.displayName = "OffersBlock";
OffersBlock.displayName = "OffersBlock";
OffersBlock.displayName = "Offers"; // @CMS-CHANGE Offers => OffersBlock

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["l" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_5__full_width_image_section__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_containers_column_group__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_components_wysiwyg_content__["a" /* default */]]
})(OffersBlock));

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicContainers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\RecallsBlock\\index.js";



var RecallsBlock = function RecallsBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicContainers__["C" /* Recall */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

RecallsBlock.displayName = "RecallsBlock";
RecallsBlock.displayName = "RecallsBlock";
RecallsBlock.displayName = "RecallsBlock";

/* unused harmony default export */ var _unused_webpack_default_export = (RecallsBlock);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\WysiwygContent\\index.js";



var WysiwygContent = function WysiwygContent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["t" /* Content */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

WysiwygContent.displayName = "WysiwygContent";
WysiwygContent.displayName = "WysiwygContent";
WysiwygContent.displayName = "WysiwygContent";

/* unused harmony default export */ var _unused_webpack_default_export = (WysiwygContent);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\blocks\\Column\\index.js";



var Column = function Column(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_8" /* Section */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    }
  }));
};

Column.displayName = "Column";
Column.displayName = "Column";
Column.displayName = "Column";

/* unused harmony default export */ var _unused_webpack_default_export = (Column);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda-specifications-block\\mymazda-header.jsx";





var MyMazdaHeader = function MyMazdaHeader(props) {
  /**
   * @param {Object|BackHyperlink} backButton - props for back button
   * @param {String} logo - logo location
   */
  var backButton = props.backButton,
      logo = props.logo,
      _props$compact = props.compact,
      compact = _props$compact === undefined ? false : _props$compact;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        minHeight: "2em",
        position: "relative",
        padding: "1.2em 0",
        backgroundColor: "#FFF"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["i" /* BackButton */], {
      top: "50%",
      style: { position: "absolute", transform: "translateY(-50%)", zIndex: "2" },
      href: backButton.href,
      backText: backButton.name, __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    }),
    !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { textAlign: "center" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 27
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { maxWidth: "20em" }, src: logo, __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        }
      })
    )
  );
};

MyMazdaHeader.displayName = "MyMazdaHeader";
MyMazdaHeader.displayName = "MyMazdaHeader";
MyMazdaHeader.propTypes = {
  backButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    logo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  logo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(MyMazdaHeader));

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_layout__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\offers\\offer-tile.jsx',
    _innerContainer,
    _left,
    _right,
    _nameplateTitleDeskto,
    _nameplateTitleMobile;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Underline = function Underline() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { borderBottom: 'solid #910A2D 3px', width: '100%' }, __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    }
  });
};

Underline.displayName = 'Underline';
Underline.displayName = 'Underline';

var OfferTile = function (_PureComponent) {
  _inherits(OfferTile, _PureComponent);

  function OfferTile() {
    var _temp, _this, _ret;

    _classCallCheck(this, OfferTile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.renderButton = function () {
      var _this$props = _this.props,
          components = _this$props.components,
          nameplateTitle = _this$props.nameplateTitle,
          bodyGradeTitle = _this$props.bodyGradeTitle,
          heading = _this$props.heading;

      var buttons = components.map(function (button, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { margin: "0 1em 1em 0" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 16
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */], _extends({
            key: index
          }, button.props, {
            gtm: {
              category: "Offers",
              action: '"' + nameplateTitle + ' / ' + bodyGradeTitle + ' / ' + heading + '" - Clicked CTA - "' + button.props.label.toUpperCase() + '"'
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 17
            }
          }))
        );
      });

      return buttons;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  OfferTile.prototype.render = function render() {
    var _props = this.props,
        slug = _props.slug,
        compact = _props.compact,
        heading = _props.heading,
        preHeading = _props.preHeading,
        subHeading = _props.subHeading,
        offerPoints = _props.offerPoints,
        featuresAccordion = _props.featuresAccordion,
        imageSrc = _props.imageSrc,
        nameplateTitle = _props.nameplateTitle,
        bodyGradeTitle = _props.bodyGradeTitle;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { 'data-name': slug.slice(1), style: styles.base, 'data-test': 'offer-item', __source: {
          fileName: _jsxFileName,
          lineNumber: 44
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.innerContainer, __source: {
            fileName: _jsxFileName,
            lineNumber: 45
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { 'data-test': 'offer-left-block', style: styles.left, 'data-koala-offer-slug': slug, __source: {
              fileName: _jsxFileName,
              lineNumber: 46
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["D" /* H6 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 47
              }
            },
            preHeading
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["A" /* H3 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 48
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { display: 'inline-block', fontSize: "inherit", lineHeight: "inherit" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 49
                }
              },
              heading,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Underline, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 51
                }
              })
            )
          ),
          subHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 56
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 57
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 58
                }
              },
              subHeading
            )
          ),
          offerPoints && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.offerPoints, __source: {
                fileName: _jsxFileName,
                lineNumber: 62
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { textAlign: 'left', xmlString: offerPoints, __source: {
                fileName: _jsxFileName,
                lineNumber: 63
              }
            })
          ),
          featuresAccordion && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.features, __source: {
                fileName: _jsxFileName,
                lineNumber: 67
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["b" /* AccordionText */],
              {
                styleName: 'info',
                alwaysOpen: false,
                name: 'Features',
                gtm: {
                  category: "Offers",
                  action: '"' + nameplateTitle + ' / ' + bodyGradeTitle + ' / ' + heading + '" - Features'
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 68
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: '1em' }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 76
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { xmlString: featuresAccordion, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 77
                  }
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.buttons(compact), __source: {
                fileName: _jsxFileName,
                lineNumber: 82
              }
            },
            this.renderButton()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { 'data-test': 'offers-right-block', style: styles.right, __source: {
              fileName: _jsxFileName,
              lineNumber: 84
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.nameplateTitleDesktop, __source: {
                fileName: _jsxFileName,
                lineNumber: 85
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["A" /* H3 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 86
                }
              },
              nameplateTitle
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 87
                }
              },
              bodyGradeTitle
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: '100%' }, src: imageSrc, alt: heading, __source: {
              fileName: _jsxFileName,
              lineNumber: 89
            }
          })
        )
      )
    );
  };

  return OfferTile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

OfferTile.displayName = 'OfferTile';


OfferTile.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  slug: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  preHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  Interactive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nameplateTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  featuresAccordion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  offerPoints: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyGradeTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(OfferTile));

var breakPointMobile = '@media (min-width: ' + __WEBPACK_IMPORTED_MODULE_3_constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */] + 'px)';

var styles = {
  base: {
    backgroundColor: '#f5f5f5',
    border: 'solid #d5d5d5 1px'
  },
  innerContainer: (_innerContainer = {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '70em',
    margin: 'auto',
    paddingTop: '2.5em',
    paddingBottom: '2.5em',
    paddingLeft: '1em',
    paddingRight: '1em'
  }, _innerContainer[breakPointMobile] = {
    paddingTop: '4.5em',
    paddingBottom: '2em',
    paddingLeft: '1em',
    paddingRight: '1em',
    flexDirection: 'row'
  }, _innerContainer),
  features: {
    display: 'block'
  },
  offerPoints: {
    display: 'block',
    fontWeight: '300',
    lineHeight: '1.6',
    maxWidth: '70em',
    padding: '1em 0 .5em',
    textAlign: 'left'
  },
  left: (_left = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    textAlign: "center",
    order: 2
  }, _left[breakPointMobile] = {
    order: 1,
    textAlign: "left",
    paddingRight: '3em',
    width: '60%'
  }, _left),
  right: (_right = {
    width: '100%',
    textAlign: 'right',
    order: 1
  }, _right[breakPointMobile] = {
    order: 2
  }, _right),
  nameplateTitleDesktop: (_nameplateTitleDeskto = {}, _nameplateTitleDeskto[breakPointMobile] = {
    display: 'block'
  }, _nameplateTitleDeskto.textAlign = 'right', _nameplateTitleDeskto.display = 'none', _nameplateTitleDeskto),
  nameplateTitleMobile: (_nameplateTitleMobile = {}, _nameplateTitleMobile[breakPointMobile] = {
    display: 'none'
  }, _nameplateTitleMobile.textAlign = 'right', _nameplateTitleMobile.display = 'block', _nameplateTitleMobile),
  buttons: function buttons(compact) {
    return {
      display: 'flex',
      flexDirection: compact ? 'column' : 'row',
      padding: '2em 0',
      marginRight: '-1em',
      width: '100%'
    };
  }
};

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Typography_Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\outlet-store\\select-nameplate.jsx";










var SelectNameplate = function SelectNameplate(_ref) {
  var _ref$onNameplateChang = _ref.onNameplateChange,
      onNameplateChange = _ref$onNameplateChang === undefined ? __WEBPACK_IMPORTED_MODULE_4_utils__["C" /* noop */] : _ref$onNameplateChang,
      _ref$nameplateStock = _ref.nameplateStock,
      nameplateStock = _ref$nameplateStock === undefined ? [] : _ref$nameplateStock,
      _ref$preHeading = _ref.preHeading,
      preHeading = _ref$preHeading === undefined ? "" : _ref$preHeading,
      _ref$heading = _ref.heading,
      heading = _ref$heading === undefined ? "" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === undefined ? "" : _ref$description,
      _ref$components = _ref.components,
      components = _ref$components === undefined ? [] : _ref$components,
      noStockError = _ref.noStockError;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      }
    },
    Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_componentParser__["a" /* default */])(components),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["_8" /* Section */],
      { verticalPadding: true, backgroundColor: "#F5F5F5", __source: {
          fileName: _jsxFileName,
          lineNumber: 22
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_containers__["s" /* HeadingBlock */], { margin: false, textAlign: "center", preHeading: preHeading, value: heading, __source: {
          fileName: _jsxFileName,
          lineNumber: 23
        }
      }),
      description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["t" /* Content */], { xmlString: description, __source: {
          fileName: _jsxFileName,
          lineNumber: 25
        }
      }),
      noStockError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { style: { color: "red", lineHeight: "1.5em", marginTop: "2em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        },
        noStockError
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_components__["z" /* GlobalNavItemGrid */],
        { fadeItems: false, __source: {
            fileName: _jsxFileName,
            lineNumber: 30
          }
        },
        nameplateStock.map(function (_ref2, index) {
          var _classnames;

          var nameplate = _ref2.nameplate,
              imageSrcSide = _ref2.imageSrcSide,
              unavailableCta = _ref2.unavailableCta,
              gtmEvents = _ref2.gtmEvents,
              inStock = _ref2.inStock;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["S" /* NameplateLink */], {
            key: index,
            type: inStock ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 42
                }
              },
              "Available"
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 44
                }
              },
              "No Outlet stock available.",
              " ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_8_AtomicComponents_Typography_Typography_less___default.a.A] = true, _classnames)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 46
                  }
                },
                unavailableCta.label
              )
            ),
            appearDisabled: !inStock,
            image: imageSrcSide,
            name: nameplate,
            href: !inStock ? unavailableCta.href : null,
            gtmEvents: gtmEvents || [],
            onClick: function onClick() {
              return inStock && onNameplateChange({ nameplate: nameplate });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 38
            }
          });
        })
      )
    )
  );
};

SelectNameplate.displayName = "SelectNameplate";
SelectNameplate.displayName = "SelectNameplate";
SelectNameplate.propTypes = {
  preHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  nameplateStock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  onNameplateChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  noStockError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

/* harmony default export */ __webpack_exports__["a"] = (SelectNameplate);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\outlet-store\\select-dealer.jsx";







var SelectDealer = function SelectDealer(_ref) {
  var mapBlockProps = _ref.mapBlockProps,
      _ref$preHeading = _ref.preHeading,
      preHeading = _ref$preHeading === undefined ? "" : _ref$preHeading,
      _ref$heading = _ref.heading,
      heading = _ref$heading === undefined ? "" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === undefined ? "" : _ref$description,
      _ref$components = _ref.components,
      components = _ref$components === undefined ? [] : _ref$components;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        display: "flex",
        flex: "1 1 100%",
        flexDirection: "column"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    },
    Object(__WEBPACK_IMPORTED_MODULE_3_containers_utilities__["a" /* childParser */])({ components: components }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_containers__["g" /* ColumnGroup */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 22
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_containers__["f" /* Column */],
        { textAlign: "center", __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["s" /* HeadingBlock */], { margin: true, textAlign: "center", preHeading: preHeading, value: heading, __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        }),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["_25" /* WysiwygContent */], { style: { maxWidth: "45em", margin: "0 auto" }, xmlString: description, __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["A" /* MapLocationContainer */], _extends({
      searchType: "search"
    }, mapBlockProps, {
      flexSizing: true,
      scrollToMain: true,
      hideMapInCompact: true,
      hideWhenNoLocation: true,
      heading: null,
      displaySearchTop: true,
      initialSelectedFilters: {
        sales: true,
        service: false,
        parts: false
      },
      disableFilters: true,
      mapFixedHeight: true,
      mapFixHeightStyle: {
        height: "60vh",
        minHeight: "500px"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 30
      }
    }))
  );
};

SelectDealer.displayName = "SelectDealer";
SelectDealer.displayName = "SelectDealer";
SelectDealer.propTypes = {
  preHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mapBlockProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onDealerChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(SelectDealer));

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bowser__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stock_tile__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sort_mapping__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\outlet-store\\show-results.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var SortSymbol = function SortSymbol(_ref) {
  var down = _ref.down;

  var y1 = down ? 8 : 0;
  var y2 = down ? 0 : 8;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { width: "17", height: "10", viewBox: "0 0 17 10", __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "#999", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 18
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { y: y1, width: "17", height: "2", rx: "1", __source: {
          fileName: _jsxFileName,
          lineNumber: 19
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { x: "2", y: "4", width: "13", height: "2", rx: "1", __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { x: "5", y: y2, width: "7", height: "2", rx: "1", __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      })
    )
  );
};

SortSymbol.displayName = "SortSymbol";
SortSymbol.displayName = "SortSymbol";
SortSymbol.propTypes = {
  down: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var filterMapping = function filterMapping(_ref2, index) {
  var label = _ref2.label,
      count = _ref2.count,
      color = _ref2.color,
      _onClick = _ref2.onClick,
      checked = _ref2.checked,
      key = _ref2.key,
      extra = _objectWithoutProperties(_ref2, ["label", "count", "color", "onClick", "checked", "key"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["h" /* CheckBox */], _extends({
    "data-test": "filter",
    key: key,
    label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["_16" /* Tag */],
      { checked: checked, color: checked ? color : "grey", __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        }
      },
      label
    ),
    style: {
      marginRight: "0.2em"
    },
    showBox: false,
    checked: checked,
    onClick: function onClick() {
      return _onClick({ key: key, checked: !checked });
    }
  }, extra, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36
    }
  }));
};

filterMapping.displayName = "filterMapping";
filterMapping.displayName = "filterMapping";
filterMapping.propTypes = {
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.onClick,
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var filterSelect = function filterSelect(filters) {
  return function (_ref3) {
    var key = _ref3.key;
    return filters.some(function (filter) {
      return key === filter;
    });
  };
};

var ResponsiveStockTileLoop = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["b" /* DetectCompact */])({ threshold: [750, 1151] })(function (props) {
  var compact = props.compact,
      dealerState = props.dealerState;

  if (compact[0]) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          padding: "0 5vw",
          margin: "0 -0.5em"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_components__["_5" /* Slideshow */],
        { showBullets: true, bulletsBelow: true, isItemWrapperStyle: false, __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        },
        props.stockList.map(function (props, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                margin: "0.8em"
              },
              key: index, __source: {
                fileName: _jsxFileName,
                lineNumber: 72
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__stock_tile__["a" /* default */], _extends({ dealerState: dealerState }, props, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 77
              }
            }))
          );
        })
      )
    );
  } else if (compact[1]) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_containers__["_1" /* Slider */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85
        }
      },
      props.stockList.map(function (props, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              width: "calc(45vw - 1.6em)",
              margin: "0.8em"
            },
            key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__stock_tile__["a" /* default */], _extends({ dealerState: dealerState }, props, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 93
            }
          }))
        );
      })
    );
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 5vw"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 100
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StockTileLoop, _extends({ wrap: true }, props, { compact: false, __source: {
        fileName: _jsxFileName,
        lineNumber: 106
      }
    }))
  );
}));

var stockTileLoop = function (_PureComponent) {
  _inherits(stockTileLoop, _PureComponent);

  function stockTileLoop() {
    _classCallCheck(this, stockTileLoop);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.state = {
      hoverIndex: -1
    };
    _this.nextUpdate = false;
    _this.setActiveIndex = _this.setActiveIndex.bind(_this);
    return _this;
  }

  stockTileLoop.prototype.setActiveIndex = function setActiveIndex(index) {
    var _this2 = this;

    if (!this.props.focusActiveOnHover) return;
    if (__WEBPACK_IMPORTED_MODULE_3_constants_environment__["b" /* HAS_TOUCH */]) return;
    if (this.nextUpdate) clearTimeout(this.nextUpdate);
    this.nextUpdate = setTimeout(function () {
      _this2.setState({ hoverIndex: index });
    }, 50);
  };

  stockTileLoop.prototype.render = function render() {
    var _props = this.props,
        stockList = _props.stockList,
        wrap = _props.wrap,
        dealerState = _props.dealerState,
        compact = _props.compact;
    var hoverIndex = this.state.hoverIndex;

    var ghostLi = {
      minWidth: "20em",
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: "calc(33% - 1.6em)"
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "ol",
      {
        style: {
          display: "flex",
          flexWrap: wrap ? "wrap" : "nowrap",
          justifyContent: "space-between",
          listStyleType: "none",
          padding: 0,
          margin: compact ? 0 : "0 -0.5em"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 141
        }
      },
      stockList.map(function (props, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          {
            style: {
              flexGrow: 1,
              flexShrink: 1,
              flexBasis: "calc(33% - 1.6em)",
              minWidth: "20em",
              margin: 0,
              padding: "0.8em",
              boxSizing: "border-box",
              display: __WEBPACK_IMPORTED_MODULE_7_bowser___default.a.safari && "flex"
            },
            key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 151
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__stock_tile__["a" /* default */], _extends({
            key: index
          }, props, {
            dealerState: dealerState, __source: {
              fileName: _jsxFileName,
              lineNumber: 163
            }
          }))
        );
      }),
      !compact && wrap && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { style: ghostLi, __source: {
          fileName: _jsxFileName,
          lineNumber: 169
        }
      }),
      !compact && wrap && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { style: ghostLi, __source: {
          fileName: _jsxFileName,
          lineNumber: 170
        }
      }),
      !compact && wrap && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { style: ghostLi, __source: {
          fileName: _jsxFileName,
          lineNumber: 171
        }
      })
    );
  };

  return stockTileLoop;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

stockTileLoop.displayName = "stockTileLoop";


stockTileLoop.defaultProps = {
  focusActiveOnHover: true,
  wrap: true
};

stockTileLoop.propTypes = {
  focusActiveOnHover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  stockList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  wrap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var StockTileLoop = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(stockTileLoop);

var ShowResults = function ShowResults(_ref4) {
  var dealerState = _ref4.dealerState,
      _ref4$heading = _ref4.heading,
      heading = _ref4$heading === undefined ? "" : _ref4$heading,
      _ref4$pageDisclaimer = _ref4.pageDisclaimer,
      pageDisclaimer = _ref4$pageDisclaimer === undefined ? "" : _ref4$pageDisclaimer,
      _ref4$priceDisclaimer = _ref4.priceDisclaimer,
      priceDisclaimer = _ref4$priceDisclaimer === undefined ? "" : _ref4$priceDisclaimer,
      _ref4$preHeading = _ref4.preHeading,
      preHeading = _ref4$preHeading === undefined ? "" : _ref4$preHeading,
      _ref4$description = _ref4.description,
      description = _ref4$description === undefined ? "" : _ref4$description,
      _ref4$compact = _ref4.compact,
      compact = _ref4$compact === undefined ? true : _ref4$compact,
      _ref4$filters = _ref4.filters,
      filters = _ref4$filters === undefined ? [] : _ref4$filters,
      _ref4$showLoader = _ref4.showLoader,
      showLoader = _ref4$showLoader === undefined ? false : _ref4$showLoader,
      _ref4$components = _ref4.components,
      components = _ref4$components === undefined ? [] : _ref4$components,
      _ref4$stockList = _ref4.stockList,
      stockList = _ref4$stockList === undefined ? [] : _ref4$stockList,
      _ref4$featuredStockLi = _ref4.featuredStockList,
      featuredStockList = _ref4$featuredStockLi === undefined ? {} : _ref4$featuredStockLi,
      vehicleNotAvailableError = _ref4.vehicleNotAvailableError,
      nameplate = _ref4.nameplate,
      sortOptions = _ref4.sortOptions,
      handleSortChange = _ref4.handleSortChange,
      noResultsFoundMessage = _ref4.noResultsFoundMessage;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { position: "relative" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 209
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["_8" /* Section */],
      { padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 210
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["D" /* H6 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 211
          }
        },
        preHeading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["z" /* H2 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 212
          }
        },
        heading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 213
        }
      }),
      description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["_25" /* WysiwygContent */], { style: { maxWidth: "45em", margin: "0 auto" }, xmlString: description, __source: {
          fileName: _jsxFileName,
          lineNumber: 215
        }
      }),
      pageDisclaimer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["_25" /* WysiwygContent */], {
        style: { maxWidth: "30em", margin: "1em auto 0" },
        textStyle: { fontWeight: "600" },
        xmlString: pageDisclaimer, __source: {
          fileName: _jsxFileName,
          lineNumber: 218
        }
      }),
      priceDisclaimer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            maxWidth: "30em",
            margin: "0 auto",
            color: "#999999",
            fontSize: "90%",
            lineHeight: "1.25em",
            fontWeight: 600
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 224
          }
        },
        priceDisclaimer.replace(/#STATE#/gi, dealerState)
      ),
      vehicleNotAvailableError ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { style: { color: "red", lineHeight: "1.5em", marginTop: "2em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 237
          }
        },
        "Sorry, the vehicle you were looking for is no longer available.",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 239
          }
        }),
        "Take a look at other ",
        nameplate,
        " models available below."
      ) : null
    ),
    showLoader ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { display: "flex", justifyContent: "center", marginTop: "40vh" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 245
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["M" /* LoaderIcon */], { style: { margin: "initial" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 246
        }
      })
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 249
        }
      },
      featuredStockList && featuredStockList.stockList.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          "data-test": "featured-block",
          style: {
            backgroundColor: "#fff",
            textAlign: "center",
            padding: compact ? "2em 0 1em" : "3em 0 4em",
            marginTop: "3em"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 252
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { margin: "0 auto", maxWidth: "1200px", padding: "0 5vw" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 260
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveStockTileLoop, {
          stockList: featuredStockList.stockList,
          dealerState: dealerState, __source: {
            fileName: _jsxFileName,
            lineNumber: 261
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["_8" /* Section */],
        { horizontalPadding: !compact, __source: {
            fileName: _jsxFileName,
            lineNumber: 266
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { "data-test": "stock-filter", style: { margin: "0 0 4em 0", width: "100%" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 267
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
                flexDirection: compact ? "column" : "row"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 268
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: {
                  display: "flex",
                  flexDirection: compact ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "center"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 274
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "strong",
                { style: [styles.text, styles.greyText], __source: {
                    fileName: _jsxFileName,
                    lineNumber: 281
                  }
                },
                "SHOWING:"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 282
                  }
                },
                filters.filter(filterSelect(["RUNOUT", "DEMO"])).map(filterMapping)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { display: "flex", alignItems: "center", justifyContent: "center" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 284
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "strong",
                { style: [styles.text, styles.greyText], __source: {
                    fileName: _jsxFileName,
                    lineNumber: 285
                  }
                },
                "SORT RESULTS:"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__sort_mapping__["a" /* default */], { sortOptions: sortOptions, handleSortChange: handleSortChange, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 286
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { paddingTop: "0.5em" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 289
              }
            },
            stockList && stockList.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StockTileLoop, {
              compact: compact,
              stockList: stockList,
              dealerState: dealerState, __source: {
                fileName: _jsxFileName,
                lineNumber: 291
              }
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["B" /* H4 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 296
                }
              },
              noResultsFoundMessage || "No results to show"
            )
          )
        )
      )
    )
  );
};

ShowResults.displayName = "ShowResults";
ShowResults.displayName = "ShowResults";
ShowResults.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pageDisclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  preHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showLoader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  stockList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  featuredStockList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  vehicleNotAvailableError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  nameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sortOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  handleSortChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  noResultsFoundMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(ShowResults));

var styles = {
  crossStyle: {
    fill: "currentColor",
    width: "10px",
    height: "10px"
  },
  ghostLi: { flex: "1 1 33%" },
  text: {
    textTransform: "uppercase",
    color: "#000",
    letterSpacing: "0.15em",
    fontSize: "90%"
  },
  greyText: {
    color: "#999",
    marginRight: "1em",
    fontSize: "81%"
  }
};

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_function__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents_Typography_Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\outlet-store\\stock-tile.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Price = function Price(_ref) {
  var value = _ref.value,
      disclaimer = _ref.disclaimer,
      nameplate = _ref.nameplate,
      storeTypeCategory = _ref.storeTypeCategory,
      grade = _ref.grade;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { "data-test": "price", style: { whiteSpace: "noWrap" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["a" /* A */],
      {
        withoutStyle: true,
        style: { fontSize: "26px" },
        onClick: function onClick(event) {
          if (event && event.target && event.target.querySelector('button')) {
            event.target.querySelector('button').click();
          }
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      },
      "$",
      !!value && value.toLocaleString(),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_AtomicContainers__["i" /* Disclaimer */],
        {
          Icon: __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_14" /* StarIcon */],
          gtm: {
            category: "Outlet Store",
            action: "Search Result - \"" + nameplate.toUpperCase() + "\", \"" + storeTypeCategory.toUpperCase() + "\" \"" + grade.toUpperCase() + "\" - Clicked \"PRICE DISCLAIMER\""
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          }
        },
        disclaimer
      )
    )
  );
};

Price.displayName = "Price";
Price.displayName = "Price";
Price.propTypes = {
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var TileExtraInfoText = function TileExtraInfoText(_ref2) {
  var _ref2$textArray = _ref2.textArray,
      textArray = _ref2$textArray === undefined ? [] : _ref2$textArray;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        marginLeft: "1em",
        textAlign: "right"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 44
      }
    },
    textArray.map(function (text, key) {
      return !!text && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        {
          "data-test": "extra-info-text",
          key: key,
          style: {
            margin: 0,
            fontSize: "90%",
            color: "#7F7F7F",
            fontWeight: "200"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 51
          }
        },
        text
      );
    })
  );
};

TileExtraInfoText.displayName = "TileExtraInfoText";
TileExtraInfoText.displayName = "TileExtraInfoText";
TileExtraInfoText.propTypes = {
  textArray: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var FeaturedRibbon = function FeaturedRibbon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["P" /* Ribbon */], { text: "Featured", backgroundColor: "#910A2D", __source: {
      fileName: _jsxFileName,
      lineNumber: 70
    }
  });
};

FeaturedRibbon.displayName = "FeaturedRibbon";
FeaturedRibbon.displayName = "FeaturedRibbon";
// Each type of vehicle has different rule for title
var conditionalTitle = function conditionalTitle(nameplate, bodyStyle, grade) {
  if (nameplate && nameplate.toLowerCase().includes("cx") || bodyStyle && bodyStyle.toLowerCase().includes("rf")) {
    return "" + grade;
  }
  return bodyStyle + " " + grade;
};

var StockTile = function (_Component) {
  _inherits(StockTile, _Component);

  function StockTile() {
    var _temp, _this, _ret;

    _classCallCheck(this, StockTile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleOnClick = function (e) {
      var gtmEvents = _this.props.gtmEvents;

      gtmEvents.click && Object(__WEBPACK_IMPORTED_MODULE_7_utils_function__["e" /* invokeFuncs */])(gtmEvents.click);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StockTile.prototype.render = function render() {
    var _this2 = this,
        _classnames;

    var _props = this.props,
        nameplate = _props.nameplate,
        storeType = _props.storeType,
        storeTypeCategory = _props.storeTypeCategory,
        image = _props.image,
        grade = _props.grade,
        generation = _props.generation,
        engineSize = _props.engineSize,
        bodyStyle = _props.bodyStyle,
        backgroundImage = _props.backgroundImage,
        featured = _props.featured,
        fuelType = _props.fuelType,
        interiorSwatchImage = _props.interiorSwatchImage,
        interiorTitle = _props.interiorTitle,
        transmissionType = _props.transmissionType,
        gtmEvents = _props.gtmEvents,
        price = _props.price,
        href = _props.href,
        disclaimer = _props.disclaimer,
        odometer = _props.odometer,
        driveTrain = _props.driveTrain,
        extraInfo = _props.extraInfo,
        dealerState = _props.dealerState;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        "data-test": "stock-tile",
        style: {
          backgroundColor: "#fff",
          border: "1px solid #D5D5D5",
          transition: "box-shadow .2s",
          display: "flex",
          height: "100%",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          ":hover": {
            boxShadow: "0px 5px 10px #D5D5D5"
          }
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 114
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        {
          href: href,
          onTouchEnd: function onTouchEnd(e) {
            return __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["f" /* IS_IOS */] && _this2.handleOnClick(e);
          },
          onClick: function onClick(e) {
            return !__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["f" /* IS_IOS */] && _this2.handleOnClick(e);
          },
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_10_AtomicComponents_Typography_Typography_less___default.a.withoutStyle] = true, _classnames)),
          style: {
            color: "#101010",
            textDecoration: "none",
            fontWeight: "initial",
            width: "100%",
            height: (__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["d" /* IS_IE */] || __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_environment__["c" /* IS_EDGE */]) && "100%",
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 129
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: [backgroundImage && {
              backgroundImage: "url(" + backgroundImage + ")",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center bottom",
              flex: "0 0 auto"
            }], __source: {
              fileName: _jsxFileName,
              lineNumber: 146
            }
          },
          featured && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeaturedRibbon, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 156
            }
          }),
          image ? // If there's no image, add a place holder svg
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: "100%", paddingTop: "2.5em" }, src: image, __source: {
              fileName: _jsxFileName,
              lineNumber: 158
            }
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "svg",
            { style: { width: "100%", paddingTop: "2.5em", opacity: 0 }, viewBox: "0 0 980 520", __source: {
                fileName: _jsxFileName,
                lineNumber: 160
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { x: "10", y: "10", width: "980", height: "520", __source: {
                fileName: _jsxFileName,
                lineNumber: 161
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              padding: "1em 2em",
              flex: "1 1 auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 165
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 173
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_16" /* Tag */],
              { color: storeType === 0 ? 'orange' : 'blue', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 178
                }
              },
              storeTypeCategory || (storeType === 1 ? 'Clearance' : 'Demo')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 179
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["C" /* H5 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 180
                }
              },
              conditionalTitle(nameplate, bodyStyle, grade)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              {
                style: [stockTileStyles.modelDescription, { marginTop: "0.4em" }], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 183
                }
              },
              engineSize,
              " ",
              fuelType,
              " ",
              driveTrain,
              " ",
              transmissionType,
              " ",
              odometer > 0 && " |  " + odometer.toLocaleString('nz') + "km"
            ),
            generation === "Previous" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              { style: [stockTileStyles.modelDescription, { marginBottom: 0 }], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 192
                }
              },
              "Previous Model"
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { padding: "0em 2em 1em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 199
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              borderTop: "1px solid #E5E5E5",
              paddingTop: "1.2em",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              textAlign: "left",
              minHeight: "2em" // match the swatch height so there's no mismatch if swatch not available
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 200
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 210
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: {
                  textTransform: "uppercase",
                  whiteSpace: "noWrap",
                  fontWeight: 600,
                  letterSpacing: "0.15em",
                  fontSize: "80%",
                  marginBottom: ".5em"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 211
                }
              },
              "Price in ",
              dealerState
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: stockTileStyles.price, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 222
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Price, { value: price, disclaimer: disclaimer, nameplate: nameplate, storeTypeCategory: storeTypeCategory, grade: grade, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 223
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { flex: "1 1 100%" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 226
              }
            },
            extraInfo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TileExtraInfoText, { textArray: extraInfo, __source: {
                fileName: _jsxFileName,
                lineNumber: 227
              }
            })
          ),
          !!interiorSwatchImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["L" /* InteriorSwatch */], { label: interiorTitle, imageSrc: interiorSwatchImage, __source: {
              fileName: _jsxFileName,
              lineNumber: 230
            }
          })
        )
      )
    );
  };

  return StockTile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

StockTile.displayName = "StockTile";


StockTile.propTypes = {
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  faded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  lazyLoadImages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundImage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  featured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  interiorSwatchImage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  interiorTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  extraInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    click: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  nameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  storeType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  storeTypeCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  engineSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  grade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  generation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fuelType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  transmissionType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  odometer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  driveTrain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dealerState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var stockTileStyles = {
  price: {
    fontSize: "1.6em",
    fontWeight: "300"
  },
  modelDescription: {
    fontWeight: 200,
    lineHeight: "1.5em",
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 0
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium___["a" /* default */])(StockTile));

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\outlet-store\\sort-mapping.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SortMapping = function (_Component) {
  _inherits(SortMapping, _Component);

  function SortMapping(props) {
    _classCallCheck(this, SortMapping);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      selection: _this.props.sortOptions[0]
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  SortMapping.prototype.handleChange = function handleChange(option) {
    this.props.handleSortChange(option);
    this.setState({ selection: option });
  };

  SortMapping.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_3" /* SelectBase */], {
      simpleValue: true,
      clearable: false,
      searchable: false,
      value: this.state.selection,
      "data-test": "sort-filter",
      onChange: function onChange(option) {
        return _this2.handleChange(option);
      },
      options: this.props.sortOptions.map(function (option, index) {
        return {
          value: option,
          label: option.label
        };
      }),
      style: { width: "200px", display: "inline" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    });
  };

  return SortMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SortMapping.displayName = "SortMapping";


/* harmony default export */ __webpack_exports__["a"] = (SortMapping);

SortMapping.propTypes = {
  sortOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  handleSortChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PostCodePopup":"postcode-popup__PostCodePopup___epoyF","First":"postcode-popup__First___1ZccN","Form":"postcode-popup__Form___1llQp","Input":"postcode-popup__Input___3CiC1"};

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8a471c596670635b92ab693c38387c5c.svg";

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

var genobj = __webpack_require__(1287)
var genfun = __webpack_require__(1288)
var jsonpointer = __webpack_require__(1292)
var xtend = __webpack_require__(576)
var formats = __webpack_require__(1293)

var get = function(obj, additionalSchemas, ptr) {

  var visit = function(sub) {
    if (sub && sub.id === ptr) return sub
    if (typeof sub !== 'object' || !sub) return null
    return Object.keys(sub).reduce(function(res, k) {
      return res || visit(sub[k])
    }, null)
  }

  var res = visit(obj)
  if (res) return res

  ptr = ptr.replace(/^#/, '')
  ptr = ptr.replace(/\/$/, '')

  try {
    return jsonpointer.get(obj, decodeURI(ptr))
  } catch (err) {
    var end = ptr.indexOf('#')
    var other
    // external reference
    if (end !== 0) {
      // fragment doesn't exist.
      if (end === -1) {
        other = additionalSchemas[ptr]
      } else {
        var ext = ptr.slice(0, end)
        other = additionalSchemas[ext]
        var fragment = ptr.slice(end).replace(/^#/, '')
        try {
          return jsonpointer.get(other, fragment)
        } catch (err) {}
      }
    } else {
      other = additionalSchemas[ptr]
    }
    return other || null
  }
}

var formatName = function(field) {
  field = JSON.stringify(field)
  var pattern = /\[([^\[\]"]+)\]/
  while (pattern.test(field)) field = field.replace(pattern, '."+$1+"')
  return field
}

var types = {}

types.any = function() {
  return 'true'
}

types.null = function(name) {
  return name+' === null'
}

types.boolean = function(name) {
  return 'typeof '+name+' === "boolean"'
}

types.array = function(name) {
  return 'Array.isArray('+name+')'
}

types.object = function(name) {
  return 'typeof '+name+' === "object" && '+name+' && !Array.isArray('+name+')'
}

types.number = function(name) {
  return 'typeof '+name+' === "number" && isFinite('+name+')'
}

types.integer = function(name) {
  return 'typeof '+name+' === "number" && (Math.floor('+name+') === '+name+' || '+name+' > 9007199254740992 || '+name+' < -9007199254740992)'
}

types.string = function(name) {
  return 'typeof '+name+' === "string"'
}

var unique = function(array) {
  var list = []
  for (var i = 0; i < array.length; i++) {
    list.push(typeof array[i] === 'object' ? JSON.stringify(array[i]) : array[i])
  }
  for (var i = 1; i < list.length; i++) {
    if (list.indexOf(list[i]) !== i) return false
  }
  return true
}

var isMultipleOf = function(name, multipleOf) {
  var res;
  var factor = ((multipleOf | 0) !== multipleOf) ? Math.pow(10, multipleOf.toString().split('.').pop().length) : 1
  if (factor > 1) {
    var factorName = ((name | 0) !== name) ? Math.pow(10, name.toString().split('.').pop().length) : 1
    if (factorName > factor) res = true
    else res = Math.round(factor * name) % (factor * multipleOf)
  }
  else res = name % multipleOf;
  return !res;
}

var compile = function(schema, cache, root, reporter, opts) {
  var fmts = opts ? xtend(formats, opts.formats) : formats
  var scope = {unique:unique, formats:fmts, isMultipleOf:isMultipleOf}
  var verbose = opts ? !!opts.verbose : false;
  var greedy = opts && opts.greedy !== undefined ?
    opts.greedy : false;

  var syms = {}
  var gensym = function(name) {
    return name+(syms[name] = (syms[name] || 0)+1)
  }

  var reversePatterns = {}
  var patterns = function(p) {
    if (reversePatterns[p]) return reversePatterns[p]
    var n = gensym('pattern')
    scope[n] = new RegExp(p)
    reversePatterns[p] = n
    return n
  }

  var vars = ['i','j','k','l','m','n','o','p','q','r','s','t','u','v','x','y','z']
  var genloop = function() {
    var v = vars.shift()
    vars.push(v+v[0])
    return v
  }

  var visit = function(name, node, reporter, filter, schemaPath) {
    var properties = node.properties
    var type = node.type
    var tuple = false

    if (Array.isArray(node.items)) { // tuple type
      properties = {}
      node.items.forEach(function(item, i) {
        properties[i] = item
      })
      type = 'array'
      tuple = true
    }

    var indent = 0
    var error = function(msg, prop, value) {
      validate('errors++')
      if (reporter === true) {
        validate('if (validate.errors === null) validate.errors = []')
        if (verbose) {
          validate(
            'validate.errors.push({field:%s,message:%s,value:%s,type:%s,schemaPath:%s})',
            formatName(prop || name),
            JSON.stringify(msg),
            value || name,
            JSON.stringify(type),
            JSON.stringify(schemaPath)
          )
        } else {
          validate('validate.errors.push({field:%s,message:%s})', formatName(prop || name), JSON.stringify(msg))
        }
      }
    }

    if (node.required === true) {
      indent++
      validate('if (%s === undefined) {', name)
      error('is required')
      validate('} else {')
    } else {
      indent++
      validate('if (%s !== undefined) {', name)
    }

    var valid = [].concat(type)
      .map(function(t) {
        if (t && !types.hasOwnProperty(t)) {
          throw new Error('Unknown type: ' + t)
        }

        return types[t || 'any'](name)
      })
      .join(' || ') || 'true'

    if (valid !== 'true') {
      indent++
      validate('if (!(%s)) {', valid)
      error('is the wrong type')
      validate('} else {')
    }

    if (tuple) {
      if (node.additionalItems === false) {
        validate('if (%s.length > %d) {', name, node.items.length)
        error('has additional items')
        validate('}')
      } else if (node.additionalItems) {
        var i = genloop()
        validate('for (var %s = %d; %s < %s.length; %s++) {', i, node.items.length, i, name, i)
        visit(name+'['+i+']', node.additionalItems, reporter, filter, schemaPath.concat('additionalItems'))
        validate('}')
      }
    }

    if (node.format && fmts[node.format]) {
      if (type !== 'string' && formats[node.format]) validate('if (%s) {', types.string(name))
      var n = gensym('format')
      scope[n] = fmts[node.format]

      if (typeof scope[n] === 'function') validate('if (!%s(%s)) {', n, name)
      else validate('if (!%s.test(%s)) {', n, name)
      error('must be '+node.format+' format')
      validate('}')
      if (type !== 'string' && formats[node.format]) validate('}')
    }

    if (Array.isArray(node.required)) {
      var checkRequired = function (req) {
        var prop = genobj(name, req);
        validate('if (%s === undefined) {', prop)
        error('is required', prop)
        validate('missing++')
        validate('}')
      }
      validate('if ((%s)) {', type !== 'object' ? types.object(name) : 'true')
      validate('var missing = 0')
      node.required.map(checkRequired)
      validate('}');
      if (!greedy) {
        validate('if (missing === 0) {')
        indent++
      }
    }

    if (node.uniqueItems) {
      if (type !== 'array') validate('if (%s) {', types.array(name))
      validate('if (!(unique(%s))) {', name)
      error('must be unique')
      validate('}')
      if (type !== 'array') validate('}')
    }

    if (node.enum) {
      var complex = node.enum.some(function(e) {
        return typeof e === 'object'
      })

      var compare = complex ?
        function(e) {
          return 'JSON.stringify('+name+')'+' !== JSON.stringify('+JSON.stringify(e)+')'
        } :
        function(e) {
          return name+' !== '+JSON.stringify(e)
        }

      validate('if (%s) {', node.enum.map(compare).join(' && ') || 'false')
      error('must be an enum value')
      validate('}')
    }

    if (node.dependencies) {
      if (type !== 'object') validate('if (%s) {', types.object(name))

      Object.keys(node.dependencies).forEach(function(key) {
        var deps = node.dependencies[key]
        if (typeof deps === 'string') deps = [deps]

        var exists = function(k) {
          return genobj(name, k) + ' !== undefined'
        }

        if (Array.isArray(deps)) {
          validate('if (%s !== undefined && !(%s)) {', genobj(name, key), deps.map(exists).join(' && ') || 'true')
          error('dependencies not set')
          validate('}')
        }
        if (typeof deps === 'object') {
          validate('if (%s !== undefined) {', genobj(name, key))
          visit(name, deps, reporter, filter, schemaPath.concat(['dependencies', key]))
          validate('}')
        }
      })

      if (type !== 'object') validate('}')
    }

    if (node.additionalProperties || node.additionalProperties === false) {
      if (type !== 'object') validate('if (%s) {', types.object(name))

      var i = genloop()
      var keys = gensym('keys')

      var toCompare = function(p) {
        return keys+'['+i+'] !== '+JSON.stringify(p)
      }

      var toTest = function(p) {
        return '!'+patterns(p)+'.test('+keys+'['+i+'])'
      }

      var additionalProp = Object.keys(properties || {}).map(toCompare)
        .concat(Object.keys(node.patternProperties || {}).map(toTest))
        .join(' && ') || 'true'

      validate('var %s = Object.keys(%s)', keys, name)
        ('for (var %s = 0; %s < %s.length; %s++) {', i, i, keys, i)
          ('if (%s) {', additionalProp)

      if (node.additionalProperties === false) {
        if (filter) validate('delete %s', name+'['+keys+'['+i+']]')
        error('has additional properties', null, JSON.stringify(name+'.') + ' + ' + keys + '['+i+']')
      } else {
        visit(name+'['+keys+'['+i+']]', node.additionalProperties, reporter, filter, schemaPath.concat(['additionalProperties']))
      }

      validate
          ('}')
        ('}')

      if (type !== 'object') validate('}')
    }

    if (node.$ref) {
      var sub = get(root, opts && opts.schemas || {}, node.$ref)
      if (sub) {
        var fn = cache[node.$ref]
        if (!fn) {
          cache[node.$ref] = function proxy(data) {
            return fn(data)
          }
          fn = compile(sub, cache, root, false, opts)
        }
        var n = gensym('ref')
        scope[n] = fn
        validate('if (!(%s(%s))) {', n, name)
        error('referenced schema does not match')
        validate('}')
      }
    }

    if (node.not) {
      var prev = gensym('prev')
      validate('var %s = errors', prev)
      visit(name, node.not, false, filter, schemaPath.concat('not'))
      validate('if (%s === errors) {', prev)
      error('negative schema matches')
      validate('} else {')
        ('errors = %s', prev)
      ('}')
    }

    if (node.items && !tuple) {
      if (type !== 'array') validate('if (%s) {', types.array(name))

      var i = genloop()
      validate('for (var %s = 0; %s < %s.length; %s++) {', i, i, name, i)
      visit(name+'['+i+']', node.items, reporter, filter, schemaPath.concat('items'))
      validate('}')

      if (type !== 'array') validate('}')
    }

    if (node.patternProperties) {
      if (type !== 'object') validate('if (%s) {', types.object(name))
      var keys = gensym('keys')
      var i = genloop()
      validate
        ('var %s = Object.keys(%s)', keys, name)
        ('for (var %s = 0; %s < %s.length; %s++) {', i, i, keys, i)

      Object.keys(node.patternProperties).forEach(function(key) {
        var p = patterns(key)
        validate('if (%s.test(%s)) {', p, keys+'['+i+']')
        visit(name+'['+keys+'['+i+']]', node.patternProperties[key], reporter, filter, schemaPath.concat(['patternProperties', key]))
        validate('}')
      })

      validate('}')
      if (type !== 'object') validate('}')
    }

    if (node.pattern) {
      var p = patterns(node.pattern)
      if (type !== 'string') validate('if (%s) {', types.string(name))
      validate('if (!(%s.test(%s))) {', p, name)
      error('pattern mismatch')
      validate('}')
      if (type !== 'string') validate('}')
    }

    if (node.allOf) {
      node.allOf.forEach(function(sch, key) {
        visit(name, sch, reporter, filter, schemaPath.concat(['allOf', key]))
      })
    }

    if (node.anyOf && node.anyOf.length) {
      var prev = gensym('prev')

      node.anyOf.forEach(function(sch, i) {
        if (i === 0) {
          validate('var %s = errors', prev)
        } else {
          validate('if (errors !== %s) {', prev)
            ('errors = %s', prev)
        }
        visit(name, sch, false, false, schemaPath)
      })
      node.anyOf.forEach(function(sch, i) {
        if (i) validate('}')
      })
      validate('if (%s !== errors) {', prev)
      error('no schemas match')
      validate('}')
    }

    if (node.oneOf && node.oneOf.length) {
      var prev = gensym('prev')
      var passes = gensym('passes')

      validate
        ('var %s = errors', prev)
        ('var %s = 0', passes)

      node.oneOf.forEach(function(sch, i) {
        visit(name, sch, false, false, schemaPath)
        validate('if (%s === errors) {', prev)
          ('%s++', passes)
        ('} else {')
          ('errors = %s', prev)
        ('}')
      })

      validate('if (%s !== 1) {', passes)
      error('no (or more than one) schemas match')
      validate('}')
    }

    if (node.multipleOf !== undefined) {
      if (type !== 'number' && type !== 'integer') validate('if (%s) {', types.number(name))

      validate('if (!isMultipleOf(%s, %d)) {', name, node.multipleOf)

      error('has a remainder')
      validate('}')

      if (type !== 'number' && type !== 'integer') validate('}')
    }

    if (node.maxProperties !== undefined) {
      if (type !== 'object') validate('if (%s) {', types.object(name))

      validate('if (Object.keys(%s).length > %d) {', name, node.maxProperties)
      error('has more properties than allowed')
      validate('}')

      if (type !== 'object') validate('}')
    }

    if (node.minProperties !== undefined) {
      if (type !== 'object') validate('if (%s) {', types.object(name))

      validate('if (Object.keys(%s).length < %d) {', name, node.minProperties)
      error('has less properties than allowed')
      validate('}')

      if (type !== 'object') validate('}')
    }

    if (node.maxItems !== undefined) {
      if (type !== 'array') validate('if (%s) {', types.array(name))

      validate('if (%s.length > %d) {', name, node.maxItems)
      error('has more items than allowed')
      validate('}')

      if (type !== 'array') validate('}')
    }

    if (node.minItems !== undefined) {
      if (type !== 'array') validate('if (%s) {', types.array(name))

      validate('if (%s.length < %d) {', name, node.minItems)
      error('has less items than allowed')
      validate('}')

      if (type !== 'array') validate('}')
    }

    if (node.maxLength !== undefined) {
      if (type !== 'string') validate('if (%s) {', types.string(name))

      validate('if (%s.length > %d) {', name, node.maxLength)
      error('has longer length than allowed')
      validate('}')

      if (type !== 'string') validate('}')
    }

    if (node.minLength !== undefined) {
      if (type !== 'string') validate('if (%s) {', types.string(name))

      validate('if (%s.length < %d) {', name, node.minLength)
      error('has less length than allowed')
      validate('}')

      if (type !== 'string') validate('}')
    }

    if (node.minimum !== undefined) {
      if (type !== 'number' && type !== 'integer') validate('if (%s) {', types.number(name))

      validate('if (%s %s %d) {', name, node.exclusiveMinimum ? '<=' : '<', node.minimum)
      error('is less than minimum')
      validate('}')

      if (type !== 'number' && type !== 'integer') validate('}')
    }

    if (node.maximum !== undefined) {
      if (type !== 'number' && type !== 'integer') validate('if (%s) {', types.number(name))

      validate('if (%s %s %d) {', name, node.exclusiveMaximum ? '>=' : '>', node.maximum)
      error('is more than maximum')
      validate('}')

      if (type !== 'number' && type !== 'integer') validate('}')
    }

    if (properties) {
      Object.keys(properties).forEach(function(p) {
        if (Array.isArray(type) && type.indexOf('null') !== -1) validate('if (%s !== null) {', name)

        visit(
          genobj(name, p),
          properties[p],
          reporter,
          filter,
          schemaPath.concat(tuple ? p : ['properties', p])
        )

        if (Array.isArray(type) && type.indexOf('null') !== -1) validate('}')
      })
    }

    while (indent--) validate('}')
  }

  var validate = genfun
    ('function validate(data) {')
      // Since undefined is not a valid JSON value, we coerce to null and other checks will catch this
      ('if (data === undefined) data = null')
      ('validate.errors = null')
      ('var errors = 0')

  visit('data', schema, reporter, opts && opts.filter, [])

  validate
      ('return errors === 0')
    ('}')

  validate = validate.toFunction(scope)
  validate.errors = null

  if (Object.defineProperty) {
    Object.defineProperty(validate, 'error', {
      get: function() {
        if (!validate.errors) return ''
        return validate.errors.map(function(err) {
          return err.field + ' ' + err.message;
        }).join('\n')
      }
    })
  }

  validate.toJSON = function() {
    return schema
  }

  return validate
}

module.exports = function(schema, opts) {
  if (typeof schema === 'string') schema = JSON.parse(schema)
  return compile(schema, {}, schema, true, opts)
}

module.exports.filter = function(schema, opts) {
  var validate = module.exports(schema, xtend(opts, {filter: true}))
  return function(sch) {
    validate(sch)
    return sch
  }
}


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

var isProperty = __webpack_require__(575)

var gen = function(obj, prop) {
  return isProperty(prop) ? obj+'.'+prop : obj+'['+JSON.stringify(prop)+']'
}

gen.valid = isProperty
gen.property = function (prop) {
 return isProperty(prop) ? prop : JSON.stringify(prop)
}

module.exports = gen


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(1289)
var isProperty = __webpack_require__(575)

var INDENT_START = /[\{\[]/
var INDENT_END = /[\}\]]/

// from https://mathiasbynens.be/notes/reserved-keywords
var RESERVED = [
  'do',
  'if',
  'in',
  'for',
  'let',
  'new',
  'try',
  'var',
  'case',
  'else',
  'enum',
  'eval',
  'null',
  'this',
  'true',
  'void',
  'with',
  'await',
  'break',
  'catch',
  'class',
  'const',
  'false',
  'super',
  'throw',
  'while',
  'yield',
  'delete',
  'export',
  'import',
  'public',
  'return',
  'static',
  'switch',
  'typeof',
  'default',
  'extends',
  'finally',
  'package',
  'private',
  'continue',
  'debugger',
  'function',
  'arguments',
  'interface',
  'protected',
  'implements',
  'instanceof',
  'NaN',
  'undefined'
]

var RESERVED_MAP = {}

for (var i = 0; i < RESERVED.length; i++) {
  RESERVED_MAP[RESERVED[i]] = true
}

var isVariable = function (name) {
  return isProperty(name) && !RESERVED_MAP.hasOwnProperty(name)
}

var formats = {
  s: function(s) {
    return '' + s
  },
  d: function(d) {
    return '' + Number(d)
  },
  o: function(o) {
    return JSON.stringify(o)
  }
}

var genfun = function() {
  var lines = []
  var indent = 0
  var vars = {}

  var push = function(str) {
    var spaces = ''
    while (spaces.length < indent*2) spaces += '  '
    lines.push(spaces+str)
  }

  var pushLine = function(line) {
    if (INDENT_END.test(line.trim()[0]) && INDENT_START.test(line[line.length-1])) {
      indent--
      push(line)
      indent++
      return
    }
    if (INDENT_START.test(line[line.length-1])) {
      push(line)
      indent++
      return
    }
    if (INDENT_END.test(line.trim()[0])) {
      indent--
      push(line)
      return
    }

    push(line)
  }

  var line = function(fmt) {
    if (!fmt) return line

    if (arguments.length === 1 && fmt.indexOf('\n') > -1) {
      var lines = fmt.trim().split('\n')
      for (var i = 0; i < lines.length; i++) {
        pushLine(lines[i].trim())
      }
    } else {
      pushLine(util.format.apply(util, arguments))
    }

    return line
  }

  line.scope = {}
  line.formats = formats

  line.sym = function(name) {
    if (!name || !isVariable(name)) name = 'tmp'
    if (!vars[name]) vars[name] = 0
    return name + (vars[name]++ || '')
  }

  line.property = function(obj, name) {
    if (arguments.length === 1) {
      name = obj
      obj = ''
    }

    name = name + ''

    if (isProperty(name)) return (obj ? obj + '.' + name : name)
    return obj ? obj + '[' + JSON.stringify(name) + ']' : JSON.stringify(name)
  }

  line.toString = function() {
    return lines.join('\n')
  }

  line.toFunction = function(scope) {
    if (!scope) scope = {}

    var src = 'return ('+line.toString()+')'

    Object.keys(line.scope).forEach(function (key) {
      if (!scope[key]) scope[key] = line.scope[key]
    })

    var keys = Object.keys(scope).map(function(key) {
      return key
    })

    var vals = keys.map(function(key) {
      return scope[key]
    })

    return Function.apply(null, keys.concat(src)).apply(null, vals)
  }

  if (arguments.length) line.apply(null, arguments)

  return line
}

genfun.formats = formats
module.exports = genfun


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1290);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1291);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1292 */
/***/ (function(module, exports) {

var hasExcape = /~/
var escapeMatcher = /~[01]/g
function escapeReplacer (m) {
  switch (m) {
    case '~1': return '/'
    case '~0': return '~'
  }
  throw new Error('Invalid tilde escape: ' + m)
}

function untilde (str) {
  if (!hasExcape.test(str)) return str
  return str.replace(escapeMatcher, escapeReplacer)
}

function setter (obj, pointer, value) {
  var part
  var hasNextPart

  for (var p = 1, len = pointer.length; p < len;) {
    part = untilde(pointer[p++])
    hasNextPart = len > p

    if (typeof obj[part] === 'undefined') {
      // support setting of /-
      if (Array.isArray(obj) && part === '-') {
        part = obj.length
      }

      // support nested objects/array when setting values
      if (hasNextPart) {
        if ((pointer[p] !== '' && pointer[p] < Infinity) || pointer[p] === '-') obj[part] = []
        else obj[part] = {}
      }
    }

    if (!hasNextPart) break
    obj = obj[part]
  }

  var oldValue = obj[part]
  if (value === undefined) delete obj[part]
  else obj[part] = value
  return oldValue
}

function compilePointer (pointer) {
  if (typeof pointer === 'string') {
    pointer = pointer.split('/')
    if (pointer[0] === '') return pointer
    throw new Error('Invalid JSON pointer.')
  } else if (Array.isArray(pointer)) {
    return pointer
  }

  throw new Error('Invalid JSON pointer.')
}

function get (obj, pointer) {
  if (typeof obj !== 'object') throw new Error('Invalid input object.')
  pointer = compilePointer(pointer)
  var len = pointer.length
  if (len === 1) return obj

  for (var p = 1; p < len;) {
    obj = obj[untilde(pointer[p++])]
    if (len === p) return obj
    if (typeof obj !== 'object') return undefined
  }
}

function set (obj, pointer, value) {
  if (typeof obj !== 'object') throw new Error('Invalid input object.')
  pointer = compilePointer(pointer)
  if (pointer.length === 0) throw new Error('Invalid JSON pointer for set.')
  return setter(obj, pointer, value)
}

function compile (pointer) {
  var compiled = compilePointer(pointer)
  return {
    get: function (object) {
      return get(object, compiled)
    },
    set: function (object, value) {
      return set(object, compiled, value)
    }
  }
}

exports.get = get
exports.set = set
exports.compile = compile


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

var createIpValidator = __webpack_require__(1294)

var reEmailWhitespace = /\s/
var reHostnameFirstPass = /^[a-zA-Z0-9.-]+$/
var reHostnamePart = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/
var rePhoneFirstPass = /^\+[0-9][0-9 ]{5,27}[0-9]$/
var rePhoneDoubleSpace = / {2}/
var rePhoneGlobalSpace = / /g

exports['date-time'] = /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-[0-9]{2}[tT ]\d{2}:\d{2}:\d{2}(?:\.\d+|)([zZ]|[+-]\d{2}:\d{2})$/
exports['date'] = /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-[0-9]{2}$/
exports['time'] = /^\d{2}:\d{2}:\d{2}$/
exports['email'] = function (input) { return (input.indexOf('@') !== -1) && (!reEmailWhitespace.test(input)) }
exports['ip-address'] = exports['ipv4'] = createIpValidator({ version: 4 })
exports['ipv6'] = createIpValidator({ version: 6 })
exports['uri'] = /^[a-zA-Z][a-zA-Z0-9+-.]*:[^\s]*$/
exports['color'] = /(#?([0-9A-Fa-f]{3,6})\b)|(aqua)|(black)|(blue)|(fuchsia)|(gray)|(green)|(lime)|(maroon)|(navy)|(olive)|(orange)|(purple)|(red)|(silver)|(teal)|(white)|(yellow)|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\))/
exports['hostname'] = function (input) {
  if (!(reHostnameFirstPass.test(input))) return false

  var parts = input.split('.')

  for (var i = 0; i < parts.length; i++) {
    if (!(reHostnamePart.test(parts[i]))) return false
  }

  return true
}
exports['alpha'] = /^[a-zA-Z]+$/
exports['alphanumeric'] = /^[a-zA-Z0-9]+$/
exports['style'] = /\s*(.+?):\s*([^;]+);?/g
exports['phone'] = function (input) {
  if (!(rePhoneFirstPass.test(input))) return false
  if (rePhoneDoubleSpace.test(input)) return false

  var digits = input.substring(1).replace(rePhoneGlobalSpace, '').length

  return (digits >= 7 && digits <= 15)
}
exports['utc-millisec'] = /^[0-9]{1,15}\.?[0-9]{0,15}$/


/***/ }),
/* 1294 */
/***/ (function(module, exports) {

var reIpv4FirstPass = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/

var reSubnetString = /\/\d{1,3}(?=%|$)/
var reForwardSlash = /\//
var reZone = /%.*$/
var reBadCharacters = /([^0-9a-f:/%])/i
var reBadAddress = /([0-9a-f]{5,}|:{3,}|[^:]:$|^:[^:]|\/$)/i

function validate4 (input) {
  if (!(reIpv4FirstPass.test(input))) return false

  var parts = input.split('.')

  if (parts.length !== 4) return false

  if (parts[0][0] === '0' && parts[0].length > 1) return false
  if (parts[1][0] === '0' && parts[1].length > 1) return false
  if (parts[2][0] === '0' && parts[2].length > 1) return false
  if (parts[3][0] === '0' && parts[3].length > 1) return false

  var n0 = Number(parts[0])
  var n1 = Number(parts[1])
  var n2 = Number(parts[2])
  var n3 = Number(parts[3])

  return (n0 >= 0 && n0 < 256 && n1 >= 0 && n1 < 256 && n2 >= 0 && n2 < 256 && n3 >= 0 && n3 < 256)
}

function validate6 (input) {
  var withoutSubnet = input.replace(reSubnetString, '')
  var hasSubnet = (input.length !== withoutSubnet.length)

  // FIXME: this should probably be an option in the future
  if (hasSubnet) return false

  if (!hasSubnet) {
    if (reForwardSlash.test(input)) return false
  }

  var withoutZone = withoutSubnet.replace(reZone, '')
  var lastPartSeparator = withoutZone.lastIndexOf(':')

  if (lastPartSeparator === -1) return false

  var lastPart = withoutZone.substring(lastPartSeparator + 1)
  var hasV4Part = validate4(lastPart)
  var address = (hasV4Part ? withoutZone.substring(0, lastPartSeparator + 1) + '1234:5678' : withoutZone)

  if (reBadCharacters.test(address)) return false
  if (reBadAddress.test(address)) return false

  var halves = address.split('::')

  if (halves.length > 2) return false

  if (halves.length === 2) {
    var first = (halves[0] === '' ? [] : halves[0].split(':'))
    var last = (halves[1] === '' ? [] : halves[1].split(':'))
    var remainingLength = 8 - (first.length + last.length)

    if (remainingLength <= 0) return false
  } else {
    if (address.split(':').length !== 8) return false
  }

  return true
}

function validate (input) {
  return validate4(input) || validate6(input)
}

module.exports = function validator (options) {
  if (!options) options = {}

  if (options.version === 4) return validate4
  if (options.version === 6) return validate6
  if (options.version == null) return validate

  throw new Error('Unknown version: ' + options.version)
}

module.exports['__all_regexes__'] = [
  reIpv4FirstPass,
  reSubnetString,
  reForwardSlash,
  reZone,
  reBadCharacters,
  reBadAddress
]


/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  $schema: "http://json-schema.org/schema#",
  type: "object",
  properties: {
    errorCode: {
      anyOf: [{ type: "string" }, { type: null }]
    },
    errorMessage: {
      anyOf: [{ type: "string" }, { type: null }]
    },
    modelCode: { type: "string" },
    serviceSpecCode: { type: "string" },
    serviceItems: {
      type: "array",
      items: {
        type: "object"
      },
      minItems: 1
    }
  }
});

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "602d9a43c2b8cf5a2cca1484a1027016.svg";

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa6fcebb365f35b8af9f05acdf52586f.svg";

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa6fcebb365f35b8af9f05acdf52586f.svg";

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "602d9a43c2b8cf5a2cca1484a1027016.svg";

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SocialIcons":"SocialIcons__SocialIcons___zR8Yv"};

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Spotlight":"Spotlight__Spotlight___3Pkfm","SpotlightShadow":"Spotlight__SpotlightShadow___kF7Zq","SpotlightHeroContent":"Spotlight__SpotlightHeroContent___1B8BD"};

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"StickySectionParent":"StickySection__StickySectionParent___12ZHi","StickySection":"StickySection__StickySection___1-Rkn","StickySectionFixed":"StickySection__StickySectionFixed___1vQSv","slideIn":"StickySection__slideIn___2hxWc","StickySectionTop":"StickySection__StickySectionTop___23mHb"};

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Testimonial":"Testimonial__Testimonial___2ynPq","TestimonialColumns":"Testimonial__TestimonialColumns___1Rqzd","TestimonialColumn":"Testimonial__TestimonialColumn___1XqRv","TestimonialColumnWhite":"Testimonial__TestimonialColumnWhite___3--HC","TestimonialColumnValue":"Testimonial__TestimonialColumnValue___2fFOu"};

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(1305);

var _objectAssign = __webpack_require__(53);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _json2mq = __webpack_require__(1314);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(585);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _canUseDom = __webpack_require__(1316);

var _canUseDom2 = _interopRequireDefault(_canUseDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = _canUseDom2.default && __webpack_require__(1317);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
    return _this;
  }

  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
    this.innerSlider = ref;
  };

  Slider.prototype.media = function media(query, handler) {
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        var bQuery;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
        }
        _canUseDom2.default && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      _canUseDom2.default && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.slickPrev = function slickPrev() {
    this.innerSlider.slickPrev();
  };

  Slider.prototype.slickNext = function slickNext() {
    this.innerSlider.slickNext();
  };

  Slider.prototype.slickGoTo = function slickGoTo(slide) {
    this.innerSlider.slickGoTo(slide);
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
    } else {
      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
    }

    var children = this.props.children;
    if (!Array.isArray(children)) {
      children = [children];
    }

    // Children may contain false or null, so we should filter them
    children = children.filter(function (child) {
      return !!child;
    });

    if (settings === 'unslick') {
      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' unslicked' },
        children
      );
    } else {
      return _react2.default.createElement(
        _innerSlider.InnerSlider,
        _extends({ ref: this.innerSliderRefHandler }, settings),
        children
      );
    }
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _eventHandlers = __webpack_require__(1306);

var _eventHandlers2 = _interopRequireDefault(_eventHandlers);

var _helpers = __webpack_require__(272);

var _helpers2 = _interopRequireDefault(_helpers);

var _initialState = __webpack_require__(1307);

var _initialState2 = _interopRequireDefault(_initialState);

var _defaultProps = __webpack_require__(585);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _createReactClass = __webpack_require__(122);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _objectAssign = __webpack_require__(53);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _track = __webpack_require__(1311);

var _dots = __webpack_require__(1312);

var _arrows = __webpack_require__(1313);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
  displayName: 'InnerSlider',

  mixins: [_helpers2.default, _eventHandlers2.default],
  list: null,
  track: null,
  listRefHandler: function listRefHandler(ref) {
    this.list = ref;
  },
  trackRefHandler: function trackRefHandler(ref) {
    this.track = ref;
  },
  getInitialState: function getInitialState() {
    return _extends({}, _initialState2.default, {
      currentSlide: this.props.initialSlide
    });
  },
  getDefaultProps: function getDefaultProps() {
    return _defaultProps2.default;
  },
  componentWillMount: function componentWillMount() {
    if (this.props.init) {
      this.props.init();
    }
    this.setState({
      mounted: true
    });
    var lazyLoadedList = [];
    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
        lazyLoadedList.push(i);
      }
    }

    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
      this.setState({
        lazyLoadedList: lazyLoadedList
      });
    }
  },
  componentDidMount: function componentDidMount() {
    // Hack for autoplay -- Inspect Later
    this.initialize(this.props);
    this.adaptHeight();

    // To support server-side rendering
    if (!window) {
      return;
    }
    if (window.addEventListener) {
      window.addEventListener('resize', this.onWindowResized);
    } else {
      window.attachEvent('onresize', this.onWindowResized);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.animationEndCallback) {
      clearTimeout(this.animationEndCallback);
    }
    if (window.addEventListener) {
      window.removeEventListener('resize', this.onWindowResized);
    } else {
      window.detachEvent('onresize', this.onWindowResized);
    }
    if (this.state.autoPlayTimer) {
      clearInterval(this.state.autoPlayTimer);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.slickGoTo != nextProps.slickGoTo) {
      if (false) {
        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
      }
      this.changeSlide({
        message: 'index',
        index: nextProps.slickGoTo,
        currentSlide: this.state.currentSlide
      });
    } else if (this.state.currentSlide >= nextProps.children.length) {
      this.update(nextProps);
      this.changeSlide({
        message: 'index',
        index: nextProps.children.length - nextProps.slidesToShow,
        currentSlide: this.state.currentSlide
      });
    } else {
      this.update(nextProps);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.adaptHeight();
  },
  onWindowResized: function onWindowResized() {
    this.update(this.props);
    // animating state should be cleared while resizing, otherwise autoplay stops working
    this.setState({
      animating: false
    });
    clearTimeout(this.animationEndCallback);
    delete this.animationEndCallback;
  },
  slickPrev: function slickPrev() {
    this.changeSlide({ message: 'previous' });
  },
  slickNext: function slickNext() {
    this.changeSlide({ message: 'next' });
  },
  slickGoTo: function slickGoTo(slide) {
    slide = Number(slide);
    !isNaN(slide) && this.changeSlide({
      message: 'index',
      index: slide,
      currentSlide: this.state.currentSlide
    });
  },
  render: function render() {
    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
      'slick-vertical': this.props.vertical
    });

    var trackProps = {
      fade: this.props.fade,
      cssEase: this.props.cssEase,
      speed: this.props.speed,
      infinite: this.props.infinite,
      centerMode: this.props.centerMode,
      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
      currentSlide: this.state.currentSlide,
      lazyLoad: this.props.lazyLoad,
      lazyLoadedList: this.state.lazyLoadedList,
      rtl: this.props.rtl,
      slideWidth: this.state.slideWidth,
      slidesToShow: this.props.slidesToShow,
      slidesToScroll: this.props.slidesToScroll,
      slideCount: this.state.slideCount,
      trackStyle: this.state.trackStyle,
      variableWidth: this.props.variableWidth
    };

    var dots;

    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
      var dotProps = {
        dotsClass: this.props.dotsClass,
        slideCount: this.state.slideCount,
        slidesToShow: this.props.slidesToShow,
        currentSlide: this.state.currentSlide,
        slidesToScroll: this.props.slidesToScroll,
        clickHandler: this.changeSlide,
        children: this.props.children,
        customPaging: this.props.customPaging
      };

      dots = _react2.default.createElement(_dots.Dots, dotProps);
    }

    var prevArrow, nextArrow;

    var arrowProps = {
      infinite: this.props.infinite,
      centerMode: this.props.centerMode,
      currentSlide: this.state.currentSlide,
      slideCount: this.state.slideCount,
      slidesToShow: this.props.slidesToShow,
      prevArrow: this.props.prevArrow,
      nextArrow: this.props.nextArrow,
      clickHandler: this.changeSlide
    };

    if (this.props.arrows) {
      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
    }

    var verticalHeightStyle = null;

    if (this.props.vertical) {
      verticalHeightStyle = {
        height: this.state.listHeight
      };
    }

    var centerPaddingStyle = null;

    if (this.props.vertical === false) {
      if (this.props.centerMode === true) {
        centerPaddingStyle = {
          padding: '0px ' + this.props.centerPadding
        };
      }
    } else {
      if (this.props.centerMode === true) {
        centerPaddingStyle = {
          padding: this.props.centerPadding + ' 0px'
        };
      }
    }

    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);

    return _react2.default.createElement(
      'div',
      {
        className: className,
        onMouseEnter: this.onInnerSliderEnter,
        onMouseLeave: this.onInnerSliderLeave,
        onMouseOver: this.onInnerSliderOver
      },
      prevArrow,
      _react2.default.createElement(
        'div',
        {
          ref: this.listRefHandler,
          className: 'slick-list',
          style: listStyle,
          onMouseDown: this.swipeStart,
          onMouseMove: this.state.dragging ? this.swipeMove : null,
          onMouseUp: this.swipeEnd,
          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
          onTouchStart: this.swipeStart,
          onTouchMove: this.state.dragging ? this.swipeMove : null,
          onTouchEnd: this.swipeEnd,
          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
          onKeyDown: this.props.accessibility ? this.keyHandler : null },
        _react2.default.createElement(
          _track.Track,
          _extends({ ref: this.trackRefHandler }, trackProps),
          this.props.children
        )
      ),
      nextArrow,
      dots
    );
  }
});

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _trackHelper = __webpack_require__(584);

var _helpers = __webpack_require__(272);

var _helpers2 = _interopRequireDefault(_helpers);

var _objectAssign = __webpack_require__(53);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventHandlers = {
  // Event handler for previous and next
  changeSlide: function changeSlide(options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var _props = this.props,
        slidesToScroll = _props.slidesToScroll,
        slidesToShow = _props.slidesToShow;
    var _state = this.state,
        slideCount = _state.slideCount,
        currentSlide = _state.currentSlide;

    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

    if (options.message === 'previous') {
      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
      targetSlide = currentSlide - slideOffset;
      if (this.props.lazyLoad) {
        previousInt = currentSlide - slideOffset;
        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
      }
    } else if (options.message === 'next') {
      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
      targetSlide = currentSlide + slideOffset;
      if (this.props.lazyLoad) {
        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
      }
    } else if (options.message === 'dots' || options.message === 'children') {
      // Click on dots
      targetSlide = options.index * options.slidesToScroll;
      if (targetSlide === options.currentSlide) {
        return;
      }
    } else if (options.message === 'index') {
      targetSlide = Number(options.index);
      if (targetSlide === options.currentSlide) {
        return;
      }
    }

    this.slideHandler(targetSlide);
  },

  // Accessiblity handler for previous and next
  keyHandler: function keyHandler(e) {
    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (e.keyCode === 37 && this.props.accessibility === true) {
        this.changeSlide({
          message: this.props.rtl === true ? 'next' : 'previous'
        });
      } else if (e.keyCode === 39 && this.props.accessibility === true) {
        this.changeSlide({
          message: this.props.rtl === true ? 'previous' : 'next'
        });
      }
    }
  },
  // Focus on selecting a slide (click handler on track)
  selectHandler: function selectHandler(options) {
    this.changeSlide(options);
  },
  swipeStart: function swipeStart(e) {
    var touches, posX, posY;

    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
      return;
    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
      return;
    }
    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
    this.setState({
      dragging: true,
      touchObject: {
        startX: posX,
        startY: posY,
        curX: posX,
        curY: posY
      }
    });
  },
  swipeMove: function swipeMove(e) {
    if (!this.state.dragging) {
      e.preventDefault();
      return;
    }
    if (this.state.scrolling) {
      return;
    }
    if (this.state.animating) {
      e.preventDefault();
      return;
    }
    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
      e.preventDefault();
    }
    var swipeLeft;
    var curLeft, positionOffset;
    var touchObject = this.state.touchObject;

    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: this.state.currentSlide,
      trackRef: this.track
    }, this.props, this.state));
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
      this.setState({
        scrolling: true
      });
      return;
    }

    if (this.props.verticalSwiping) {
      touchObject.swipeLength = verticalSwipeLength;
    }

    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);

    if (this.props.verticalSwiping) {
      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    }

    var currentSlide = this.state.currentSlide;
    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
    var swipeDirection = this.swipeDirection(this.state.touchObject);
    var touchSwipeLength = touchObject.swipeLength;

    if (this.props.infinite === false) {
      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;

        if (this.state.edgeDragged === false && this.props.edgeEvent) {
          this.props.edgeEvent(swipeDirection);
          this.setState({ edgeDragged: true });
        }
      }
    }

    if (this.state.swiped === false && this.props.swipeEvent) {
      this.props.swipeEvent(swipeDirection);
      this.setState({ swiped: true });
    }

    if (!this.props.vertical) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
    }

    if (this.props.verticalSwiping) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    }

    this.setState({
      touchObject: touchObject,
      swipeLeft: swipeLeft,
      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
    });

    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
      return;
    }
    if (touchObject.swipeLength > 4) {
      this.setState({
        swiping: true
      });
      e.preventDefault();
    }
  },
  getNavigableIndexes: function getNavigableIndexes() {
    var max = void 0;
    var breakPoint = 0;
    var counter = 0;
    var indexes = [];

    if (!this.props.infinite) {
      max = this.state.slideCount;
    } else {
      breakPoint = this.props.slidesToShow * -1;
      counter = this.props.slidesToShow * -1;
      max = this.state.slideCount * 2;
    }

    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + this.props.slidesToScroll;

      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
    }

    return indexes;
  },
  checkNavigable: function checkNavigable(index) {
    var navigables = this.getNavigableIndexes();
    var prevNavigable = 0;

    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }

        prevNavigable = navigables[n];
      }
    }

    return index;
  },
  getSlideCount: function getSlideCount() {
    var _this = this;

    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;

    if (this.props.swipeToSlide) {
      var swipedSlide = void 0;

      var slickList = _reactDom2.default.findDOMNode(this.list);

      var slides = slickList.querySelectorAll('.slick-slide');

      Array.from(slides).every(function (slide) {
        if (!_this.props.vertical) {
          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
            swipedSlide = slide;
            return false;
          }
        } else {
          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
            swipedSlide = slide;
            return false;
          }
        }

        return true;
      });

      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;

      return slidesTraversed;
    } else {
      return this.props.slidesToScroll;
    }
  },

  swipeEnd: function swipeEnd(e) {
    if (!this.state.dragging) {
      if (this.props.swipe) {
        e.preventDefault();
      }
      return;
    }
    var touchObject = this.state.touchObject;
    var minSwipe = this.state.listWidth / this.props.touchThreshold;
    var swipeDirection = this.swipeDirection(touchObject);

    if (this.props.verticalSwiping) {
      minSwipe = this.state.listHeight / this.props.touchThreshold;
    }

    var wasScrolling = this.state.scrolling;
    // reset the state of touch related state variables.
    this.setState({
      dragging: false,
      edgeDragged: false,
      scrolling: false,
      swiping: false,
      swiped: false,
      swipeLeft: null,
      touchObject: {}
    });
    if (wasScrolling) {
      return;
    }

    // Fix for #13
    if (!touchObject.swipeLength) {
      return;
    }
    if (touchObject.swipeLength > minSwipe) {
      e.preventDefault();

      var slideCount = void 0,
          newSlide = void 0;

      switch (swipeDirection) {

        case 'left':
        case 'down':
          newSlide = this.state.currentSlide + this.getSlideCount();
          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
          this.state.currentDirection = 0;
          break;

        case 'right':
        case 'up':
          newSlide = this.state.currentSlide - this.getSlideCount();
          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
          this.state.currentDirection = 1;
          break;

        default:
          slideCount = this.state.currentSlide;

      }

      this.slideHandler(slideCount);
    } else {
      // Adjust the track back to it's original position.
      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, this.props, this.state));

      this.setState({
        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
      });
    }
  },
  onInnerSliderEnter: function onInnerSliderEnter(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.pause();
    }
  },
  onInnerSliderOver: function onInnerSliderOver(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.pause();
    }
  },
  onInnerSliderLeave: function onInnerSliderLeave(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.autoPlay();
    }
  }
};

exports.default = EventHandlers;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var initialState = {
    animating: false,
    dragging: false,
    autoPlayTimer: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    listWidth: null,
    listHeight: null,
    scrolling: false,
    // loadIndex: 0,
    slideCount: null,
    slideWidth: null,
    slideHeight: null,
    swiping: false,
    // sliding: false,
    // slideOffset: 0,
    swipeLeft: null,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },

    lazyLoadedList: [],

    // added for react
    initialized: false,
    edgeDragged: false,
    swiped: false, // used by swipeEvent. differentites between touch and swipe.
    trackStyle: {},
    trackWidth: 0

    // Removed
    // transformsEnabled: false,
    // $nextArrow: null,
    // $prevArrow: null,
    // $dots: null,
    // $list: null,
    // $slideTrack: null,
    // $slides: null,
};

module.exports = initialState;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(53);

var emptyObject = __webpack_require__(1309);
var _invariant = __webpack_require__(1310);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(53);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  return (0, _classnames2.default)({
    'slick-slide': true,
    'slick-active': slickActive,
    'slick-center': slickCenter,
    'slick-cloned': slickCloned
  });
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = 'relative';
    style.left = -spec.index * spec.slideWidth;
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  // key could be a zero
  return child.key === null || child.key === undefined ? fallbackKey : child.key;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var count = _react2.default.Children.count(spec.children);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: 'children',
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
      child = elem;
    } else {
      child = _react2.default.createElement('div', null);
    }
    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
    var slideClass = child.props.className || '';

    var onClick = function onClick(e) {
      child.props && child.props.onClick && child.props.onClick(e);
      if (spec.focusOnSelect) {
        spec.focusOnSelect(childOnClickOptions);
      }
    };

    slides.push(_react2.default.cloneElement(child, {
      key: 'original' + getKey(child, index),
      'data-index': index,
      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
      tabIndex: '-1',
      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
      onClick: onClick
    }));

    // variableWidth doesn't wrap properly.
    if (spec.infinite && spec.fade === false) {
      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;

      if (index >= count - infiniteCount) {
        key = -(count - index);
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: 'precloned' + getKey(child, key),
          'data-index': key,
          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
          onClick: onClick
        }));
      }

      if (index < infiniteCount) {
        key = count + index;
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: 'postcloned' + getKey(child, key),
          'data-index': key,
          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
          onClick: onClick
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$Component) {
  _inherits(Track, _React$Component);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides.call(this, this.props);
    return _react2.default.createElement(
      'div',
      { className: 'slick-track', style: this.props.trackStyle },
      slides
    );
  };

  return Track;
}(_react2.default.Component);

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;
  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  return dots;
};

var Dots = exports.Dots = function (_React$Component) {
  _inherits(Dots, _React$Component);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {

      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: 'dots',
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);

      return _react2.default.createElement(
        'li',
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.createElement(
      'ul',
      { className: this.props.dotsClass, style: { display: 'block' } },
      dots
    );
  };

  return Dots;
}(_react2.default.Component);

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(272);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$Component) {
  _inherits(PrevArrow, _React$Component);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses['slick-disabled'] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: '0',
      'data-role': 'none',
      className: (0, _classnames2.default)(prevClasses),
      style: { display: 'block' },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        'button',
        _extends({ key: '0', type: 'button' }, prevArrowProps),
        ' Previous'
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.Component);

var NextArrow = exports.NextArrow = function (_React$Component2) {
  _inherits(NextArrow, _React$Component2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
    var nextHandler = this.clickHandler.bind(this, { message: 'next' });

    if (!_helpers2.default.canGoNext(this.props)) {
      nextClasses['slick-disabled'] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: '1',
      'data-role': 'none',
      className: (0, _classnames2.default)(nextClasses),
      style: { display: 'block' },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        'button',
        _extends({ key: '1', type: 'button' }, nextArrowProps),
        ' Next'
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.Component);

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(1315);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(1318);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(1319);
var Util = __webpack_require__(586);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(1320);
var each = __webpack_require__(586).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 1320 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1322);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 169 /* <at>i */
	var CHARSET = 163 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							code = body.charCodeAt(caret)

							switch (code) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first + second) {
								case NULL: {
									break
								}
								case IMPORT:
								case CHARSET: {
									flat += chars + body.charAt(caret)
									break
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON)
										break

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				return out.charCodeAt(8) === DASH ? webkit + out + out : out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}

		switch (out) {
			case void 0:
			case false:
			case true:
			case null:
			case content: {
				break
			}
			default: {
				return out
			}
		}
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				switch (plugin.constructor) {
					case Array: {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
						break
					}
					case Function: {
						plugins[plugged++] = plugin
						break
					}
					case Boolean: {
						unkwn = !!plugin|0
					}
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, at, depth) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (at === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (at) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (depth === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 1325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Content":"Content__Content___3pA79","ContentLeft":"Content__ContentLeft___2WcsC","ContentRight":"Content__ContentRight___1Xnnp","ContentMobileCenter":"Content__ContentMobileCenter___4FYmY","ContentMobileLeft":"Content__ContentMobileLeft___IFC2b","ContentMobileRight":"Content__ContentMobileRight___30UDH","BlackA":"Content__BlackA___YJkX4","RedA":"Content__RedA___3xEbM","WhiteA":"Content__WhiteA___3F6Af","ContentDark":"Content__ContentDark___251b1"};

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ButtonGroup":"ButtonGroup__ButtonGroup___2VgWB","ButtonGroupStacked":"ButtonGroup__ButtonGroupStacked___2FU1R","ButtonGroupCenter":"ButtonGroup__ButtonGroupCenter___1Iyuy","ButtonGroupRight":"ButtonGroup__ButtonGroupRight___1hrW4","ButtonGroupLeft":"ButtonGroup__ButtonGroupLeft___3IwcC"};

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ButtonIcon":"ButtonIcon__ButtonIcon___22jFc","ButtonSquareWhite":"ButtonIcon__ButtonSquareWhite___1d3-4","ButtonWhiteColor":"ButtonIcon__ButtonWhiteColor___37-Xz"};

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\Caption.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Caption = function (_React$PureComponent) {
  _inherits(Caption, _React$PureComponent);

  function Caption() {
    _classCallCheck(this, Caption);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Caption.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        white = _props.white,
        black = _props.black,
        grey = _props.grey;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.Caption] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.white] = white, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.black] = black, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.grey] = grey, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    );
  };

  return Caption;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Caption.displayName = "Caption";


/* harmony default export */ __webpack_exports__["a"] = (Caption);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CheckBoxGroup_less__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CheckBoxGroup_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CheckBoxGroup_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputCheckBox_InputCheckBox_less__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputCheckBox_InputCheckBox_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InputCheckBox_InputCheckBox_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_CheckIcon__ = __webpack_require__(142);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\CheckBoxGroup\\CheckBoxGroup.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var CheckBoxGroup = function (_React$PureComponent) {
  _inherits(CheckBoxGroup, _React$PureComponent);

  function CheckBoxGroup(props) {
    _classCallCheck(this, CheckBoxGroup);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._onBlurHandler = function () {
      var _this$props$onBlur = _this.props.onBlur,
          onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur;

      onBlur();
    };

    _this._onChangeHandler = function (event) {
      var _this$props = _this.props,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange,
          items = _this$props.items;

      var name = event.target.name;
      var value = items.find(function (item) {
        return item.name === name;
      }).value;
      var isChecked = event.target.checked;

      _this.setState(function (prevState) {
        return {
          checkedItems: isChecked ? [].concat(prevState.checkedItems, [value]) : prevState.checkedItems.filter(function (item) {
            return item && item !== value;
          })
        };
      }, function () {
        onChange(_this.state.checkedItems.length ? _this.state.checkedItems : null);
      });
    };

    _this.state = {
      checkedItems: props.items.filter(function (item) {
        return item.checked;
      }).map(function (item) {
        return item && item.value;
      })

      // for testing purposes
    };if (process && process.env && "production" === 'test') {
      _this.random = 1;
    } else {
      _this.random = Math.random();
    }
    return _this;
  }

  CheckBoxGroup.prototype.componentDidMount = function componentDidMount() {
    var _props$onChange = this.props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;
    var checkedItems = this.state.checkedItems;


    if (checkedItems.length) {
      // Delay to allow for the update of all checkboxes
      setTimeout(function () {
        onChange(checkedItems);
      }, 200);
    }
  };

  CheckBoxGroup.prototype.render = function render() {
    var _classnames,
        _classnames2,
        _classnames3,
        _this2 = this,
        _classnames8;

    var _props = this.props,
        _props$items = _props.items,
        items = _props$items === undefined ? [] : _props$items,
        heading = _props.heading,
        _props$required = _props.required,
        required = _props$required === undefined ? false : _props$required,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? "normal" : _props$styleName,
        _props$message = _props.message,
        message = _props$message === undefined ? "" : _props$message,
        _props$isValid = _props.isValid,
        isValid = _props$isValid === undefined ? true : _props$isValid;
    var checkedItems = this.state.checkedItems;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__CheckBoxGroup_less___default.a.CheckBoxGroup] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_1" /* P */],
        { withoutMargin: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 69
          }
        },
        heading,
        required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__CheckBoxGroup_less___default.a.requiredStar] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          },
          "*"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_3__CheckBoxGroup_less___default.a.CheckBoxWrapper] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_3__CheckBoxGroup_less___default.a.CheckBoxWrapperCompact] = styleName === "compact", _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 77
          }
        },
        items && items.map(function (item) {
          var _classnames4, _classnames5, _classnames6, _classnames7;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              key: item.value,
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_4__InputCheckBox_InputCheckBox_less___default.a.InputCheckBox] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_4__InputCheckBox_InputCheckBox_less___default.a.InputCheckBoxLarge] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_3__CheckBoxGroup_less___default.a.InputCheckBox] = true, _classnames4)), __source: {
                fileName: _jsxFileName,
                lineNumber: 84
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              checked: checkedItems.indexOf(item.value) !== -1,
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_4__InputCheckBox_InputCheckBox_less___default.a.InputCheckBoxInput] = true, _classnames5)),
              name: "" + item.name,
              id: item.name + "-" + _this2.random,
              type: "checkbox",
              onChange: _this2._onChangeHandler,
              onBlur: _this2._onBlurHandler,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 91
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              {
                ref: function ref(c) {
                  return _this2.label = c;
                },
                htmlFor: item.name + "-" + _this2.random,
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_4__InputCheckBox_InputCheckBox_less___default.a.LabelCheckBox] = true, _classnames6)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 102
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons_CheckIcon__["a" /* default */], { style: {
                  width: "10px",
                  padding: "3px"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 108
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              {
                htmlFor: item.name + "-" + _this2.random,
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames7 = {}, _classnames7[__WEBPACK_IMPORTED_MODULE_4__InputCheckBox_InputCheckBox_less___default.a.Label] = true, _classnames7)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 113
                }
              },
              item.name
            )
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames8 = {}, _classnames8[__WEBPACK_IMPORTED_MODULE_3__CheckBoxGroup_less___default.a.message] = true, _classnames8[__WEBPACK_IMPORTED_MODULE_3__CheckBoxGroup_less___default.a.messageShow] = !isValid, _classnames8)), __source: {
            fileName: _jsxFileName,
            lineNumber: 124
          }
        },
        message
      )
    );
  };

  return CheckBoxGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

CheckBoxGroup.displayName = "CheckBoxGroup";


/* harmony default export */ __webpack_exports__["a"] = (CheckBoxGroup);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CheckBoxGroup":"CheckBoxGroup__CheckBoxGroup___18xgX","CheckBoxWrapper":"CheckBoxGroup__CheckBoxWrapper___2EhCi","InputCheckBox":"CheckBoxGroup__InputCheckBox___12zKT","CheckBoxWrapperCompact":"CheckBoxGroup__CheckBoxWrapperCompact___1BVcQ","requiredStar":"CheckBoxGroup__requiredStar___1B7BX","message":"CheckBoxGroup__message___2ZJZX","messageShow":"CheckBoxGroup__messageShow___15Fma"};

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorIcon_less__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorIcon_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ColorIcon_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CheckIcon__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_lightOrDark__ = __webpack_require__(1333);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ColorIcon\\ColorIcon.jsx";






var ColorIcon = function ColorIcon(_ref) {
  var _classnames, _classnames2;

  var _ref$color = _ref.color,
      color = _ref$color === undefined ? '#910A2D' : _ref$color,
      _ref$active = _ref.active,
      active = _ref$active === undefined ? false : _ref$active;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__ColorIcon_less___default.a.ColorIcon] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__ColorIcon_less___default.a.ColorIconActive] = active, _classnames)), __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__ColorIcon_less___default.a.ColorIconInside] = true, _classnames2)),
        style: {
          backgroundColor: color
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      },
      active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CheckIcon__["a" /* default */], {
        style: {
          width: '40%',
          color: Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_lightOrDark__["a" /* default */])(color) === 'dark' ? '#FFFFFF' : '#101010'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23
        }
      })
    )
  );
};

ColorIcon.displayName = "ColorIcon";
ColorIcon.displayName = "ColorIcon";
/* harmony default export */ __webpack_exports__["a"] = (ColorIcon);

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ColorIcon":"ColorIcon__ColorIcon___DkJbe","ColorIconInside":"ColorIcon__ColorIconInside___30jzI","ColorIconActive":"ColorIcon__ColorIconActive___3_9-t"};

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lightOrDark = function lightOrDark(color) {
  // Variables for red, green, blue values
  var r, g, b, hsp;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {

    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

    r = color[1];
    g = color[2];
    b = color[3];
  } else {

    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

    r = color >> 16;
    g = color >> 8 & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {

    return 'light';
  } else {

    return 'dark';
  }
};

/* harmony default export */ __webpack_exports__["a"] = (lightOrDark);

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ExternalLinkIcon.jsx";


var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 14 11", fill: "currentColor", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10.5,9.59H1.4V3.24H3.22A8.34,8.34,0,0,1,4.74,1.83h-4a0.7,0.7,0,0,0-.7.71v7.76A0.7,0.7,0,0,0,.7,11H11.2a0.7,0.7,0,0,0,.7-0.71V7.65L10.5,8.81V9.59ZM9.35,4.69v2.5L14,3.53,9.35,0V2.21c-5.64,0-5.64,5.62-5.64,5.62C5.31,5.18,6.29,4.69,9.35,4.69Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

ExternalLinkIcon.displayName = "ExternalLinkIcon";
ExternalLinkIcon.displayName = "ExternalLinkIcon";
/* harmony default export */ __webpack_exports__["a"] = (ExternalLinkIcon);

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\FacebookIcon.jsx";


var FacebookIcon = function FacebookIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 18 18", fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M15.8,0H2.2C1,0,0,1,0,2.2v13.5C0,17,1,18,2.2,18h6.8v-6.4H6.9V8.7h2.2V7.3C9,5.3,10.6,3.5,12.7,3.5c0,0,0,0,0.1,0h2v3.2h-1.8c-0.3,0-0.6,0.2-0.6,0.5c0,0.1,0,0.1,0,0.2v1.5h2.4v2.8h-2.4V18h3.4c1.2,0,2.2-1,2.2-2.2V2.2C18,1,17,0,15.8,0z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

FacebookIcon.displayName = "FacebookIcon";
FacebookIcon.displayName = "FacebookIcon";
/* harmony default export */ __webpack_exports__["a"] = (FacebookIcon);

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormGroup_less__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormGroup_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FormGroup_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\FormGroup\\FormGroup.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormGroup = function (_React$PureComponent) {
  _inherits(FormGroup, _React$PureComponent);

  function FormGroup() {
    _classCallCheck(this, FormGroup);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  FormGroup.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        _props$radio = _props.radio,
        radio = _props$radio === undefined ? false : _props$radio,
        _props$hide = _props.hide,
        hide = _props$hide === undefined ? false : _props$hide,
        _props$show = _props.show,
        show = _props$show === undefined ? false : _props$show,
        _props$checkbox = _props.checkbox,
        checkbox = _props$checkbox === undefined ? false : _props$checkbox,
        _props$center = _props.center,
        center = _props$center === undefined ? false : _props$center;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__FormGroup_less___default.a.FormGroup] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__FormGroup_less___default.a.FormGroupHide] = !show && hide, _classnames[__WEBPACK_IMPORTED_MODULE_2__FormGroup_less___default.a.FormGroupRadio] = show && radio, _classnames[__WEBPACK_IMPORTED_MODULE_2__FormGroup_less___default.a.FormGroupCheckbox] = show && checkbox, _classnames[__WEBPACK_IMPORTED_MODULE_2__FormGroup_less___default.a.FormGroupShow] = show, _classnames[__WEBPACK_IMPORTED_MODULE_2__FormGroup_less___default.a.FormGroupCenter] = center, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      children
    );
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

FormGroup.displayName = "FormGroup";


/* harmony default export */ __webpack_exports__["a"] = (FormGroup);

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FormGroup":"FormGroup__FormGroup___3jPnc","FormGroupShow":"FormGroup__FormGroupShow___2J4t-","FormGroupRadio":"FormGroup__FormGroupRadio___1ZM0M","FormGroupCenter":"FormGroup__FormGroupCenter___2_N2H","FormGroupCheckbox":"FormGroup__FormGroupCheckbox___25WIK","FormGroupHide":"FormGroup__FormGroupHide___1uU7j"};

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\H1.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var H1 = function (_React$PureComponent) {
  _inherits(H1, _React$PureComponent);

  function H1() {
    _classCallCheck(this, H1);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  H1.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        withDetails = _props.withDetails,
        white = _props.white,
        glow = _props.glow;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h1",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.SameHeadingStyle] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.H1] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.WithDetails] = withDetails, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.Glow] = glow, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.white] = white, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    );
  };

  return H1;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

H1.displayName = "H1";


/* harmony default export */ __webpack_exports__["a"] = (H1);

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\H2.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var H2 = function (_React$PureComponent) {
  _inherits(H2, _React$PureComponent);

  function H2() {
    _classCallCheck(this, H2);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  H2.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        withDetails = _props.withDetails,
        white = _props.white;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.SameHeadingStyle] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.H2] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.WithDetails] = withDetails, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.white] = white, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    );
  };

  return H2;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

H2.displayName = "H2";


/* harmony default export */ __webpack_exports__["a"] = (H2);

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\H3.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var H3 = function (_React$PureComponent) {
  _inherits(H3, _React$PureComponent);

  function H3() {
    _classCallCheck(this, H3);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  H3.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        withDetails = _props.withDetails,
        white = _props.white;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h3",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.SameHeadingStyle] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.H3] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.WithDetails] = withDetails, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.white] = white, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    );
  };

  return H3;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

H3.displayName = "H3";


/* harmony default export */ __webpack_exports__["a"] = (H3);

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\H4.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var H4 = function (_React$PureComponent) {
  _inherits(H4, _React$PureComponent);

  function H4() {
    _classCallCheck(this, H4);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  H4.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        withDetails = _props.withDetails,
        white = _props.white;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h4",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.SameHeadingStyle] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.H4] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.WithDetails] = withDetails, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.white] = white, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    );
  };

  return H4;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

H4.displayName = "H4";


/* harmony default export */ __webpack_exports__["a"] = (H4);

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\H5.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var H5 = function (_React$PureComponent) {
  _inherits(H5, _React$PureComponent);

  function H5() {
    _classCallCheck(this, H5);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  H5.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        withDetails = _props.withDetails,
        white = _props.white;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h5",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.SameHeadingStyle] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.H5] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.WithDetails] = withDetails, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.white] = white, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    );
  };

  return H5;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

H5.displayName = "H5";


/* harmony default export */ __webpack_exports__["a"] = (H5);

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\H6.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var H6 = function (_React$PureComponent) {
  _inherits(H6, _React$PureComponent);

  function H6() {
    _classCallCheck(this, H6);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  H6.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        withDetails = _props.withDetails,
        white = _props.white;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.SameHeadingStyle] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.H6] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.WithDetails] = withDetails, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.white] = white, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    );
  };

  return H6;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

H6.displayName = "H6";


/* harmony default export */ __webpack_exports__["a"] = (H6);

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\HideIcon.jsx";


var HideIcon = function HideIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 22 22", fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10.75,4 C11.5052121,4 12.2636681,4.11230356 13.0253906,4.33691406 C13.7871132,4.56152456 14.4820932,4.85611797 15.1103516,5.22070312 C15.7386099,5.58528828 16.3294243,6.00195078 16.8828125,6.47070312 C17.4362007,6.93945547 17.9016908,7.41633872 18.2792969,7.90136719 C18.6569029,8.38639565 18.9547515,8.86165132 19.1728516,9.32714844 C19.3909516,9.79264556 19.5,10.2044253 19.5,10.5625 C19.5,10.9205747 19.3909516,11.3323544 19.1728516,11.7978516 C18.9547515,12.2633487 18.6569029,12.7386043 18.2792969,13.2236328 C17.9016908,13.7086613 17.4362007,14.1855445 16.8828125,14.6542969 C16.3294243,15.1230492 15.7386099,15.5397117 15.1103516,15.9042969 C14.4820932,16.268882 13.7871132,16.5634754 13.0253906,16.7880859 C12.2636681,17.0126964 11.5052121,17.125 10.75,17.125 C9.99478789,17.125 9.23633193,17.0126964 8.47460938,16.7880859 C7.71288682,16.5634754 7.01790679,16.268882 6.38964844,15.9042969 C5.76139009,15.5397117 5.17057568,15.1230492 4.6171875,14.6542969 C4.06379932,14.1855445 3.59830918,13.7086613 3.22070312,13.2236328 C2.84309707,12.7386043 2.54524849,12.2633487 2.32714844,11.7978516 C2.10904839,11.3323544 2,10.9205747 2,10.5625 C2,10.2044253 2.10904839,9.79264556 2.32714844,9.32714844 C2.54524849,8.86165132 2.84309707,8.38639565 3.22070312,7.90136719 C3.59830918,7.41633872 4.06379932,6.93945547 4.6171875,6.47070312 C5.17057568,6.00195078 5.76139009,5.58528828 6.38964844,5.22070312 C7.01790679,4.85611797 7.71288682,4.56152456 8.47460938,4.33691406 C9.23633193,4.11230356 9.99478789,4 10.75,4 Z M10.75,15.5625 C11.3945345,15.5625 12.0390593,15.4632171 12.6835938,15.2646484 C13.3281282,15.0660797 13.9059219,14.8089208 14.4169922,14.4931641 C14.9280625,14.1774073 15.4082009,13.8274759 15.8574219,13.4433594 C16.3066429,13.0592429 16.6809881,12.6816425 16.9804688,12.3105469 C17.2799494,11.9394513 17.5143221,11.5992854 17.6835938,11.2900391 C17.8528654,10.9807927 17.9375,10.7382821 17.9375,10.5625 C17.9375,10.3867179 17.8528654,10.1442073 17.6835938,9.83496094 C17.5143221,9.5257146 17.2799494,9.18554873 16.9804688,8.81445312 C16.6809881,8.44335752 16.3066429,8.06575713 15.8574219,7.68164062 C15.4082009,7.29752412 14.9280625,6.94759272 14.4169922,6.63183594 C13.9059219,6.31607915 13.3281282,6.05892026 12.6835938,5.86035156 C12.0390593,5.66178286 11.3945345,5.5625 10.75,5.5625 C10.1054655,5.5625 9.46094072,5.66178286 8.81640625,5.86035156 C8.17187178,6.05892026 7.59407808,6.31607915 7.08300781,6.63183594 C6.57193755,6.94759272 6.09179912,7.29752412 5.64257812,7.68164062 C5.19335713,8.06575713 4.81901191,8.44335752 4.51953125,8.81445312 C4.22005059,9.18554873 3.98567793,9.5257146 3.81640625,9.83496094 C3.64713457,10.1442073 3.5625,10.3867179 3.5625,10.5625 C3.5625,10.7382821 3.64713457,10.9807927 3.81640625,11.2900391 C3.98567793,11.5992854 4.22005059,11.9394513 4.51953125,12.3105469 C4.81901191,12.6816425 5.19335713,13.0592429 5.64257812,13.4433594 C6.09179912,13.8274759 6.57193755,14.1774073 7.08300781,14.4931641 C7.59407808,14.8089208 8.17187178,15.0660797 8.81640625,15.2646484 C9.46094072,15.4632171 10.1054655,15.5625 10.75,15.5625 Z M12.703125,9.5859375 L14.0996094,8.8828125 C14.3665378,9.41666934 14.5,9.97655957 14.5,10.5625 C14.5,11.5976614 14.1337927,12.4814417 13.4013672,13.2138672 C12.6689417,13.9462927 11.7851614,14.3125 10.75,14.3125 C9.71483857,14.3125 8.83105835,13.9462927 8.09863281,13.2138672 C7.36620728,12.4814417 7,11.5976614 7,10.5625 C7,9.52733857 7.36620728,8.64355835 8.09863281,7.91113281 C8.83105835,7.17870728 9.71483857,6.8125 10.75,6.8125 L10.75,8.375 C10.1510387,8.375 9.6367209,8.5898416 9.20703125,9.01953125 C8.7773416,9.4492209 8.5625,9.96353867 8.5625,10.5625 C8.5625,11.1614613 8.7773416,11.6757791 9.20703125,12.1054688 C9.6367209,12.5351584 10.1510387,12.75 10.75,12.75 C11.3489613,12.75 11.8632791,12.5351584 12.2929688,12.1054688 C12.7226584,11.6757791 12.9375,11.1614613 12.9375,10.5625 C12.9375,10.2239566 12.8593758,9.89843906 12.703125,9.5859375 Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon", { transform: "translate(10.500000, 10.500000) rotate(-315.000000) translate(-10.500000, -10.500000) ", points: "-1.52081528 9.7026062 22.5208153 9.7026062 22.5208153 11.2973938 -1.52081528 11.2973938", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

HideIcon.displayName = "HideIcon";
HideIcon.displayName = "HideIcon";
/* harmony default export */ __webpack_exports__["a"] = (HideIcon);

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\HoursIcon.jsx";


var HoursIcon = function HoursIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 20 20", fill: "currentColor", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5c-4.6 0-8.4-3.8-8.4-8.4S5.4 1.6 10 1.6s8.4 3.8 8.4 8.4zm-1.6 0c0-3.7-3-6.8-6.8-6.8s-6.8 3-6.8 6.8 3 6.8 6.8 6.8c1.8 0 3.5-.7 4.8-2s2-3 2-4.8zm-5.9-.3l3.5 2.2-.9 1.5-4.4-2.7V5h1.7v4.7z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

HoursIcon.displayName = "HoursIcon";
HoursIcon.displayName = "HoursIcon";
/* harmony default export */ __webpack_exports__["a"] = (HoursIcon);

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\Icon180Icon.jsx";


var Icon180Icon = function Icon180Icon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, fill: "currentColor", viewBox: "0 0 22 11", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { transform: "translate(12.000000, 7.000000) rotate(45.000000) translate(-12.000000, -7.000000) translate(1.000000, -4.000000)", __source: {
          fileName: _jsxFileName,
          lineNumber: 5
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M9.47460938,10.4121094 L10.5878906,11.515625 L5.66601562,16.4375 L10.1875,16.4375 L10.1875,18 L3,18 L3,10.8125 L4.5625,10.8125 L4.5625,15.3339844 L9.47460938,10.4121094 Z M10.8125,3 L18,3 L18,10.1875 L16.4375,10.1875 L16.4375,5.66601562 L11.5253906,10.5878906 L10.4121094,9.47460938 L15.3339844,4.5625 L10.8125,4.5625 L10.8125,3 Z", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      })
    )
  );
};

Icon180Icon.displayName = "Icon180Icon";
Icon180Icon.displayName = "Icon180Icon";
/* harmony default export */ __webpack_exports__["a"] = (Icon180Icon);

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\Icon360Icon.jsx";


var Icon360Icon = function Icon360Icon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, fill: "currentColor", viewBox: "0 0 30 26", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M0.83,8C0.83,3.59,7.15,0,15,0h0.1c7.8,0,14.12,3.59,14.12,8a5,5,0,0,1-.86,2.75C25.82,8,20.79,6.19,15,6.19S4.18,8,1.68,10.75A5,5,0,0,1,.83,8ZM29,11.56h0c-1.75,2.52-5.59,4.44-10.3,5.11V13.83L8.14,19.91,18.66,26V22.86C25.17,21.94,30,18.61,30,14.65V8.87h0a5.51,5.51,0,0,1-1,2.68h0Zm-22.58,10C2.53,20,0,17.52,0,14.65V8.87H0a5.51,5.51,0,0,0,1,2.68H1a11.66,11.66,0,0,0,5.36,3.83v6.19H6.42Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

Icon360Icon.displayName = "Icon360Icon";
Icon360Icon.displayName = "Icon360Icon";
/* harmony default export */ __webpack_exports__["a"] = (Icon360Icon);

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\InfoIcon.jsx";


var InfoIcon = function InfoIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 16 16", style: style, fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M7.65625,0 C8.69141143,0 9.68098486,0.201820898 10.625,0.60546875 C11.5690151,1.0091166 12.3844367,1.55435854 13.0712891,2.24121094 C13.7581415,2.92806333 14.3033834,3.74348486 14.7070312,4.6875 C15.1106791,5.63151514 15.3125,6.62108857 15.3125,7.65625 C15.3125,8.67839053 15.118817,9.65494326 14.7314453,10.5859375 C14.3440736,11.5169317 13.7890661,12.3437464 13.0664062,13.0664062 C12.3437464,13.7890661 11.5169317,14.3440736 10.5859375,14.7314453 C9.65494326,15.118817 8.67839053,15.3125 7.65625,15.3125 C6.62108857,15.3125 5.63151514,15.1106791 4.6875,14.7070312 C3.74348486,14.3033834 2.92806333,13.7581415 2.24121094,13.0712891 C1.55435854,12.3844367 1.0091166,11.5690151 0.60546875,10.625 C0.201820898,9.68098486 0,8.69141143 0,7.65625 C0,6.63410947 0.193682959,5.65755674 0.581054688,4.7265625 C0.968426416,3.79556826 1.52343389,2.96875361 2.24609375,2.24609375 C2.96875361,1.52343389 3.79556826,0.968426416 4.7265625,0.581054688 C5.65755674,0.193682959 6.63410947,0 7.65625,0 Z M12.0117188,12.0117188 C12.5911487,11.4322888 13.0354802,10.7666053 13.3447266,10.0146484 C13.6539729,9.26269155 13.8085938,8.4765666 13.8085938,7.65625 C13.8085938,6.54296318 13.5335314,5.51432764 12.9833984,4.5703125 C12.4332655,3.62629736 11.6862026,2.87923452 10.7421875,2.32910156 C9.79817236,1.7789686 8.76953682,1.50390625 7.65625,1.50390625 C6.8359334,1.50390625 6.04980845,1.6585271 5.29785156,1.96777344 C4.54589468,2.27701978 3.88021123,2.72135127 3.30078125,3.30078125 C2.72135127,3.88021123 2.27701978,4.54589468 1.96777344,5.29785156 C1.6585271,6.04980845 1.50390625,6.8359334 1.50390625,7.65625 C1.50390625,8.76953682 1.7789686,9.79817236 2.32910156,10.7421875 C2.87923452,11.6862026 3.62629736,12.4332655 4.5703125,12.9833984 C5.51432764,13.5335314 6.54296318,13.8085938 7.65625,13.8085938 C8.48307705,13.8085938 9.27082959,13.6539729 10.0195312,13.3447266 C10.7682329,13.0354802 11.4322888,12.5911487 12.0117188,12.0117188 Z M6.875,5.3125 L6.875,3.75 L8.4375,3.75 L8.4375,5.3125 L6.875,5.3125 Z M6.875,11.5625 L6.875,6.25 L8.4375,6.25 L8.4375,11.5625 L6.875,11.5625 Z", fillRule: "evenodd", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

InfoIcon.displayName = "InfoIcon";
InfoIcon.displayName = "InfoIcon";
/* harmony default export */ __webpack_exports__["a"] = (InfoIcon);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input_less__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Input_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Input\\Input.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Input = function (_React$PureComponent) {
  _inherits(Input, _React$PureComponent);

  function Input(props) {
    _classCallCheck(this, Input);

    // for testing purposes
    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._onBlurHandler = function () {
      var _this$props = _this.props,
          _this$props$onBlur = _this$props.onBlur,
          onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange,
          _this$props$callOnCha = _this$props.callOnChangeAfterBlur,
          callOnChangeAfterBlur = _this$props$callOnCha === undefined ? true : _this$props$callOnCha;

      setTimeout(function () {
        onBlur();
      }, 200);
      if (callOnChangeAfterBlur) onChange(_this.input.value);
    };

    _this._onFocusHandler = function () {
      var _this$props2 = _this.props,
          _this$props2$onFocus = _this$props2.onFocus,
          onFocus = _this$props2$onFocus === undefined ? function () {} : _this$props2$onFocus,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === undefined ? function () {} : _this$props2$onChange;

      onFocus();
    };

    _this._onChangeHandler = function (event) {
      _this._onChange(event.target.value);
    };

    _this._onChange = function (value) {
      var forceChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props$onChange2 = _this.props.onChange,
          onChange = _this$props$onChange2 === undefined ? function () {} : _this$props$onChange2;

      _this._dirtyClass(value);
      onChange(value, forceChange);
      if (forceChange && _this.input) {
        _this.input.value = value;
      }
    };

    _this._onChangeOnlyValue = function (value) {
      _this._dirtyClass(value);
      _this.input.value = value;
    };

    _this._dirtyClass = function (value) {
      if (_this.label) {
        if (value && value != "") {
          _this.label.classList.add(__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.PlaceholderWithValue);
        } else {
          _this.label.classList.remove(__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.PlaceholderWithValue);
        }
      }
    };

    _this._getThisInput = function () {
      var _this$props$getThisIn = _this.props.getThisInput,
          getThisInput = _this$props$getThisIn === undefined ? function () {} : _this$props$getThisIn;

      getThisInput(_this);
    };

    _this._onKeyDownHandler = function (event) {
      var _this$props3 = _this.props,
          _this$props3$onClickD = _this$props3.onClickDownKey,
          onClickDownKey = _this$props3$onClickD === undefined ? function () {} : _this$props3$onClickD,
          _this$props3$onClickU = _this$props3.onClickUpKey,
          onClickUpKey = _this$props3$onClickU === undefined ? function () {} : _this$props3$onClickU,
          _this$props3$onClickE = _this$props3.onClickEnterKey,
          onClickEnterKey = _this$props3$onClickE === undefined ? function () {} : _this$props3$onClickE,
          _this$props3$disableE = _this$props3.disableEnter,
          disableEnter = _this$props3$disableE === undefined ? false : _this$props3$disableE;


      if (event.keyCode === 40) {
        event.preventDefault();
        onClickDownKey();
      }
      if (event.keyCode === 38) {
        event.preventDefault();
        onClickUpKey();
      }

      // We don't want default behaviour of Enter on InputSearchable
      if (event.keyCode === 13 && disableEnter) {
        event.preventDefault();
        onClickEnterKey();
      }
    };

    if (process && process.env && "production" === 'test') {
      _this.random = 1;
    } else {
      _this.random = Math.random();
    }
    return _this;
  }

  Input.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        defaultValue = _props.defaultValue,
        _props$onChange = _props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;

    if (defaultValue) {
      this._onChange(defaultValue, true);
    }
  };

  // Change the value without calling OnChange function


  Input.prototype.render = function render() {
    var _classnames,
        _this2 = this,
        _classnames2,
        _classnames3,
        _classnames4,
        _classnames5,
        _classnames6;

    var _props2 = this.props,
        defaultValue = _props2.defaultValue,
        _props2$name = _props2.name,
        name = _props2$name === undefined ? "" : _props2$name,
        _props2$type = _props2.type,
        type = _props2$type === undefined ? "text" : _props2$type,
        _props2$label = _props2.label,
        label = _props2$label === undefined ? "" : _props2$label,
        _props2$styleName = _props2.styleName,
        styleName = _props2$styleName === undefined ? "light" : _props2$styleName,
        _props2$required = _props2.required,
        required = _props2$required === undefined ? false : _props2$required,
        _props2$focused = _props2.focused,
        focused = _props2$focused === undefined ? false : _props2$focused,
        _props2$message = _props2.message,
        message = _props2$message === undefined ? "" : _props2$message,
        _props2$autoComplete = _props2.autoComplete,
        autoComplete = _props2$autoComplete === undefined ? "off" : _props2$autoComplete,
        _props2$isValid = _props2.isValid,
        isValid = _props2$isValid === undefined ? true : _props2$isValid;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        getthisinput: this._getThisInput(),
        "data-test": "input-text",
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.Input] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 108
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        ref: function ref(c) {
          return _this2.input = c;
        },
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.InputInput] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.Focused] = focused, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.InputInvalid] = !isValid, _classnames2[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.InputDark] = styleName === "dark", _classnames2[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.InputLight] = styleName === "light", _classnames2)),
        name: "" + name,
        id: name + "-" + this.random,
        type: type,
        autoComplete: autoComplete,
        defaultValue: defaultValue,
        "data-lpignore": true,
        onBlur: this._onBlurHandler,
        onFocus: this._onFocusHandler,
        onChange: this._onChangeHandler,
        onKeyDown: this._onKeyDownHandler,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        {
          ref: function ref(c) {
            return _this2.label = c;
          },
          htmlFor: name + "-" + this.random,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.Placeholder] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.PlaceholderWithValue] = false, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        },
        label,
        required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.requiredStar] = true, _classnames4)), __source: {
              fileName: _jsxFileName,
              lineNumber: 143
            }
          },
          "*"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.icon] = true, _classnames5[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.iconShow] = !isValid, _classnames5)), __source: {
            fileName: _jsxFileName,
            lineNumber: 148
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["d" /* AlertIcon */], { style: { height: "1em", width: "1em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 152
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.message] = true, _classnames6[__WEBPACK_IMPORTED_MODULE_2__Input_less___default.a.messageShow] = !isValid, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 154
          }
        },
        message
      )
    );
  };

  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Input.displayName = "Input";


/* harmony default export */ __webpack_exports__["a"] = (Input);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Input":"Input__Input___2bdS9","InputInput":"Input__InputInput___2YZct","InputDark":"Input__InputDark___1VY4Y","InputLight":"Input__InputLight___1XShG","Focused":"Input__Focused___2XJXD","InputInvalid":"Input__InputInvalid___39rMW","Placeholder":"Input__Placeholder___2ADb3","PlaceholderWithValue":"Input__PlaceholderWithValue___2i2CF","requiredStar":"Input__requiredStar___2BxM2","icon":"Input__icon___2fIY5","iconShow":"Input__iconShow___3HtJT","message":"Input__message___1QnPX","messageShow":"Input__messageShow___9yTGW"};

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputCaptcha_less__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputCaptcha_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InputCaptcha_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_google_recaptcha__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_google_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_google_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_config__ = __webpack_require__(199);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\InputCaptcha\\InputCaptcha.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var InputCaptcha = function (_React$PureComponent) {
  _inherits(InputCaptcha, _React$PureComponent);

  function InputCaptcha(props) {
    _classCallCheck(this, InputCaptcha);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._onChange = function (value) {
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;


      onChange(value);
    };

    _this._getThisInput = function () {
      var _this$props$getThisIn = _this.props.getThisInput,
          getThisInput = _this$props$getThisIn === undefined ? function () {} : _this$props$getThisIn;

      getThisInput(_this);
    };

    _this.resetRecaptcha = function () {
      var _this$props$formType = _this.props.formType,
          formType = _this$props$formType === undefined ? 'normal' : _this$props$formType;


      if (_this.inputCaptcha) {
        _this.inputCaptcha.reset();

        if (formType === "invisible") {
          _this.inputCaptcha.execute();
        }
      }
    };

    _this.state = {
      loading: true
    };
    return _this;
  }

  InputCaptcha.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props$formType = this.props.formType,
        formType = _props$formType === undefined ? 'normal' : _props$formType;


    this.setState({
      loading: false
    }, function () {
      if (_this2.inputCaptcha) {
        _this2.inputCaptcha.reset();

        if (formType === "invisible") {
          _this2.inputCaptcha.execute();
        }
      }
    });
  };

  InputCaptcha.prototype.render = function render() {
    var _classnames,
        _this3 = this,
        _classnames2;

    var _props = this.props,
        _props$name = _props.name,
        name = _props$name === undefined ? '' : _props$name,
        _props$sitekey = _props.sitekey,
        sitekey = _props$sitekey === undefined ? __WEBPACK_IMPORTED_MODULE_4__constants_config__["a" /* CAPTCHA_SITE_KEY */] : _props$sitekey,
        _props$label = _props.label,
        label = _props$label === undefined ? '' : _props$label,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? 'light' : _props$styleName,
        _props$formType2 = _props.formType,
        formType = _props$formType2 === undefined ? 'normal' : _props$formType2,
        _props$required = _props.required,
        required = _props$required === undefined ? false : _props$required,
        _props$message = _props.message,
        message = _props$message === undefined ? '' : _props$message,
        _props$isValid = _props.isValid,
        isValid = _props$isValid === undefined ? true : _props$isValid;
    var loading = this.state.loading;


    if (loading) return null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        getthisinput: this._getThisInput(),
        'data-test': 'input-captcha',
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__InputCaptcha_less___default.a.InputCaptcha] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 71
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_google_recaptcha___default.a, {
        onChange: this._onChange,
        onExpired: this.resetRecaptcha,
        ref: function ref(el) {
          _this3.inputCaptcha = el;
        },
        size: formType,
        theme: styleName,
        render: 'explicit',
        sitekey: sitekey, __source: {
          fileName: _jsxFileName,
          lineNumber: 77
        }
      }),
      formType !== "invisible" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__InputCaptcha_less___default.a.message] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_2__InputCaptcha_less___default.a.messageShow] = !isValid, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 87
          }
        },
        message
      )
    );
  };

  return InputCaptcha;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InputCaptcha.displayName = 'InputCaptcha';


/* harmony default export */ __webpack_exports__["a"] = (InputCaptcha);

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InputCaptcha":"InputCaptcha__InputCaptcha___18bbe","message":"InputCaptcha__message___1_WV7","messageShow":"InputCaptcha__messageShow___3U2Oy"};

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _recaptcha = __webpack_require__(1354);

var _recaptcha2 = _interopRequireDefault(_recaptcha);

var _reactAsyncScript = __webpack_require__(1384);

var _reactAsyncScript2 = _interopRequireDefault(_reactAsyncScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var callbackName = "onloadcallback";
var lang = typeof window !== "undefined" && window.recaptchaOptions && window.recaptchaOptions.lang ? "&hl=" + window.recaptchaOptions.lang : "";
var URL = "https://www.google.com/recaptcha/api.js?onload=" + callbackName + "&render=explicit" + lang;
var globalName = "grecaptcha";

exports.default = (0, _reactAsyncScript2.default)(_recaptcha2.default, URL, {
  callbackName: callbackName,
  globalName: globalName,
  exposeFuncs: ["getValue", "getWidgetId", "reset", "execute"]
});

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(592);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(597);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(598);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(599);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(607);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReCAPTCHA = function (_React$Component) {
  (0, _inherits3.default)(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    (0, _classCallCheck3.default)(this, ReCAPTCHA);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));

    _this.state = {};
    _this.handleExpired = _this.handleExpired.bind(_this);
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_this);
    return _this;
  }

  ReCAPTCHA.prototype.getValue = function getValue() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this.state.widgetId);
    }
    return null;
  };

  ReCAPTCHA.prototype.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      return this.state.widgetId;
    }
    return null;
  };

  ReCAPTCHA.prototype.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;
    var widgetId = this.state.widgetId;


    if (grecaptcha && widgetId !== undefined) {
      return grecaptcha.execute(widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  ReCAPTCHA.prototype.reset = function reset() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      this.props.grecaptcha.reset(this.state.widgetId);
    }
  };

  ReCAPTCHA.prototype.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else if (this.props.onChange) {
      this.props.onChange(null);
    }
  };

  ReCAPTCHA.prototype.explicitRender = function explicitRender(cb) {
    if (this.props.grecaptcha && this.state.widgetId === undefined) {
      var id = this.props.grecaptcha.render(this.captcha, {
        sitekey: this.props.sitekey,
        callback: this.props.onChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        size: this.props.size,
        stoken: this.props.stoken,
        badge: this.props.badge
      });
      this.setState({
        widgetId: id
      }, cb);
    }
    if (this._executeRequested && this.props.grecaptcha && this.state.widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  ReCAPTCHA.prototype.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  ReCAPTCHA.prototype.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  ReCAPTCHA.prototype.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  ReCAPTCHA.prototype.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
    /* eslint-disable no-unused-vars */
    var _props = this.props,
        sitekey = _props.sitekey,
        onChange = _props.onChange,
        theme = _props.theme,
        type = _props.type,
        tabindex = _props.tabindex,
        onExpired = _props.onExpired,
        size = _props.size,
        stoken = _props.stoken,
        grecaptcha = _props.grecaptcha,
        badge = _props.badge,
        childProps = (0, _objectWithoutProperties3.default)(_props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "size", "stoken", "grecaptcha", "badge"]);
    /* eslint-enable no-unused-vars */

    return _react2.default.createElement("div", (0, _extends3.default)({}, childProps, { ref: this.handleRecaptchaRef }));
  };

  return ReCAPTCHA;
}(_react2.default.Component);

exports.default = ReCAPTCHA;


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  grecaptcha: _propTypes2.default.object,
  theme: _propTypes2.default.oneOf(["dark", "light"]),
  type: _propTypes2.default.oneOf(["image", "audio"]),
  tabindex: _propTypes2.default.number,
  onExpired: _propTypes2.default.func,
  size: _propTypes2.default.oneOf(["compact", "normal", "invisible"]),
  stoken: _propTypes2.default.string,
  badge: _propTypes2.default.oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1356), __esModule: true };

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1357);
module.exports = __webpack_require__(61).Object.assign;


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(78);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1358) });


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(189);
var gOPS = __webpack_require__(282);
var pIE = __webpack_require__(192);
var toObject = __webpack_require__(283);
var IObject = __webpack_require__(274);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(124)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(125);
var toLength = __webpack_require__(277);
var toAbsoluteIndex = __webpack_require__(1360);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(278);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1362), __esModule: true };

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(284);
__webpack_require__(286);
module.exports = __webpack_require__(287).f('iterator');


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(278);
var defined = __webpack_require__(276);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(193);
var descriptor = __webpack_require__(188);
var setToStringTag = __webpack_require__(194);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(91)(IteratorPrototype, __webpack_require__(62)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(79);
var anObject = __webpack_require__(92);
var getKeys = __webpack_require__(189);

module.exports = __webpack_require__(81) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(72).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(106);
var toObject = __webpack_require__(283);
var IE_PROTO = __webpack_require__(279)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1369);
var step = __webpack_require__(602);
var Iterators = __webpack_require__(143);
var toIObject = __webpack_require__(125);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(285)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1369 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1371), __esModule: true };

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1372);
__webpack_require__(606);
__webpack_require__(1375);
__webpack_require__(1376);
module.exports = __webpack_require__(61).Symbol;


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(72);
var has = __webpack_require__(106);
var DESCRIPTORS = __webpack_require__(81);
var $export = __webpack_require__(78);
var redefine = __webpack_require__(601);
var META = __webpack_require__(288).KEY;
var $fails = __webpack_require__(124);
var shared = __webpack_require__(280);
var setToStringTag = __webpack_require__(194);
var uid = __webpack_require__(191);
var wks = __webpack_require__(62);
var wksExt = __webpack_require__(287);
var wksDefine = __webpack_require__(289);
var enumKeys = __webpack_require__(1373);
var isArray = __webpack_require__(603);
var anObject = __webpack_require__(92);
var isObject = __webpack_require__(80);
var toIObject = __webpack_require__(125);
var toPrimitive = __webpack_require__(273);
var createDesc = __webpack_require__(188);
var _create = __webpack_require__(193);
var gOPNExt = __webpack_require__(1374);
var $GOPD = __webpack_require__(605);
var $DP = __webpack_require__(79);
var $keys = __webpack_require__(189);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(604).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(192).f = $propertyIsEnumerable;
  __webpack_require__(282).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(190)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(91)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(189);
var gOPS = __webpack_require__(282);
var pIE = __webpack_require__(192);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(125);
var gOPN = __webpack_require__(604).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(289)('asyncIterator');


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(289)('observable');


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1378), __esModule: true };

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1379);
module.exports = __webpack_require__(61).Object.setPrototypeOf;


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(78);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1380).set });


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(80);
var anObject = __webpack_require__(92);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(123)(Function.call, __webpack_require__(605).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1383);
var $Object = __webpack_require__(61).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(78);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(193) });


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(592);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(597);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getIterator2 = __webpack_require__(1385);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(598);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(599);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(607);

var _inherits3 = _interopRequireDefault(_inherits2);

var _map = __webpack_require__(1388);

var _map2 = _interopRequireDefault(_map);

exports.default = makeAsyncScript;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SCRIPT_MAP = new _map2.default();

// A counter used to generate a unique id for each component that uses the function
var idCount = 0;

function makeAsyncScript(Component, scriptURL, options) {
  options = options || {};
  var wrappedComponentName = Component.displayName || Component.name || "Component";

  var AsyncScriptLoader = function (_React$Component) {
    (0, _inherits3.default)(AsyncScriptLoader, _React$Component);

    function AsyncScriptLoader() {
      (0, _classCallCheck3.default)(this, AsyncScriptLoader);

      var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));

      _this.state = {};
      return _this;
    }

    AsyncScriptLoader.prototype.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
      if (!this.__scriptLoaderID) {
        this.__scriptLoaderID = "async-script-loader-" + idCount++;
      }
      return this.__scriptLoaderID;
    };

    AsyncScriptLoader.prototype.getComponent = function getComponent() {
      return this.childComponent;
    };

    AsyncScriptLoader.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      var key = this.asyncScriptLoaderGetScriptLoaderID();
      var _options = options,
          globalName = _options.globalName,
          callbackName = _options.callbackName;

      if (globalName && typeof window[globalName] !== "undefined") {
        SCRIPT_MAP.set(scriptURL, { loaded: true, observers: new _map2.default() });
      }

      if (SCRIPT_MAP.has(scriptURL)) {
        var entry = SCRIPT_MAP.get(scriptURL);
        if (entry && (entry.loaded || entry.errored)) {
          this.asyncScriptLoaderHandleLoad(entry);
          return;
        }
        entry.observers.set(key, function (entry) {
          return _this2.asyncScriptLoaderHandleLoad(entry);
        });
        return;
      }

      var observers = new _map2.default();
      observers.set(key, function (entry) {
        return _this2.asyncScriptLoaderHandleLoad(entry);
      });
      SCRIPT_MAP.set(scriptURL, {
        loaded: false,
        observers: observers
      });

      var script = document.createElement("script");

      script.src = scriptURL;
      script.async = 1;

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
        if (SCRIPT_MAP.has(scriptURL)) {
          var mapEntry = SCRIPT_MAP.get(scriptURL);
          var observersMap = mapEntry.observers;

          for (var _iterator = observersMap, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var _ref2 = _ref,
                obsKey = _ref2[0],
                observer = _ref2[1];

            if (func(observer)) {
              observersMap.delete(obsKey);
            }
          }
        }
      };

      if (callbackName && typeof window !== "undefined") {
        window[callbackName] = AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded;
      }

      script.onload = function () {
        var mapEntry = SCRIPT_MAP.get(scriptURL);
        if (mapEntry) {
          mapEntry.loaded = true;
          callObserverFuncAndRemoveObserver(function (observer) {
            if (callbackName) {
              return false;
            }
            observer(mapEntry);
            return true;
          });
        }
      };
      script.onerror = function (event) {
        var mapEntry = SCRIPT_MAP.get(scriptURL);
        if (mapEntry) {
          mapEntry.errored = true;
          callObserverFuncAndRemoveObserver(function (observer) {
            observer(mapEntry);
            return true;
          });
        }
      };

      // (old) MSIE browsers may call "onreadystatechange" instead of "onload"
      script.onreadystatechange = function () {
        if (_this2.readyState === "loaded") {
          // wait for other events, then call onload if default onload hadn't been called
          window.setTimeout(function () {
            var mapEntry = SCRIPT_MAP.get(scriptURL);
            if (mapEntry && mapEntry.loaded !== true) {
              script.onload();
            }
          }, 0);
        }
      };

      document.body.appendChild(script);
    };

    AsyncScriptLoader.prototype.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
      this.setState(state, this.props.asyncScriptOnLoad);
    };

    AsyncScriptLoader.prototype.componentWillUnmount = function componentWillUnmount() {
      // Remove tag script
      if (options.removeOnUnmount === true) {
        var allScripts = document.getElementsByTagName("script");
        for (var i = 0; i < allScripts.length; i += 1) {
          if (allScripts[i].src.indexOf(scriptURL) > -1) {
            if (allScripts[i].parentNode) {
              allScripts[i].parentNode.removeChild(allScripts[i]);
            }
          }
        }
      }
      // Clean the observer entry
      var mapEntry = SCRIPT_MAP.get(scriptURL);
      if (mapEntry) {
        mapEntry.observers.delete(this.asyncScriptLoaderGetScriptLoaderID());
        if (options.removeOnUnmount === true) {
          SCRIPT_MAP.delete(scriptURL);
        }
      }
    };

    AsyncScriptLoader.prototype.render = function render() {
      var _this3 = this;

      var globalName = options.globalName;
      var _props = this.props,
          asyncScriptOnLoad = _props.asyncScriptOnLoad,
          childProps = (0, _objectWithoutProperties3.default)(_props, ["asyncScriptOnLoad"]);

      if (globalName && typeof window !== "undefined") {
        childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
      }
      return _react2.default.createElement(Component, (0, _extends3.default)({ ref: function ref(comp) {
          _this3.childComponent = comp;
        } }, childProps));
    };

    return AsyncScriptLoader;
  }(_react2.default.Component);

  AsyncScriptLoader.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
  AsyncScriptLoader.propTypes = {
    asyncScriptOnLoad: _propTypes2.default.func
  };
  AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded = function () {
    var mapEntry = SCRIPT_MAP.get(scriptURL);
    if (!mapEntry || !mapEntry.loaded) {
      throw new Error("Script is not loaded.");
    }
    for (var _iterator2 = mapEntry.observers.values(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var observer = _ref3;

      observer(mapEntry);
    }
    delete window[options.callbackName];
  };

  if (options.exposeFuncs) {
    var _loop = function _loop() {
      if (_isArray3) {
        if (_i3 >= _iterator3.length) return "break";
        _ref4 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) return "break";
        _ref4 = _i3.value;
      }

      var funcToExpose = _ref4;

      /* eslint-disable no-loop-func */
      AsyncScriptLoader.prototype[funcToExpose] = function () {
        var _getComponent;

        return (_getComponent = this.getComponent())[funcToExpose].apply(_getComponent, arguments);
      };
      /* eslint-enable no-loop-func */
    };

    for (var _iterator3 = options.exposeFuncs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
      var _ref4;

      var _ret = _loop();

      if (_ret === "break") break;
    }
  }
  return AsyncScriptLoader;
}

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1386), __esModule: true };

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(286);
__webpack_require__(284);
module.exports = __webpack_require__(1387);


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(92);
var get = __webpack_require__(608);
module.exports = __webpack_require__(61).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1389), __esModule: true };

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(606);
__webpack_require__(284);
__webpack_require__(286);
__webpack_require__(1390);
__webpack_require__(1399);
__webpack_require__(1402);
__webpack_require__(1404);
module.exports = __webpack_require__(61).Map;


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1391);
var validate = __webpack_require__(612);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(1395)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(79).f;
var create = __webpack_require__(193);
var redefineAll = __webpack_require__(610);
var ctx = __webpack_require__(123);
var anInstance = __webpack_require__(611);
var forOf = __webpack_require__(195);
var $iterDefine = __webpack_require__(285);
var step = __webpack_require__(602);
var setSpecies = __webpack_require__(1394);
var DESCRIPTORS = __webpack_require__(81);
var fastKey = __webpack_require__(288).fastKey;
var validate = __webpack_require__(612);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(92);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(143);
var ITERATOR = __webpack_require__(62)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(72);
var core = __webpack_require__(61);
var dP = __webpack_require__(79);
var DESCRIPTORS = __webpack_require__(81);
var SPECIES = __webpack_require__(62)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(72);
var $export = __webpack_require__(78);
var meta = __webpack_require__(288);
var fails = __webpack_require__(124);
var hide = __webpack_require__(91);
var redefineAll = __webpack_require__(610);
var forOf = __webpack_require__(195);
var anInstance = __webpack_require__(611);
var isObject = __webpack_require__(80);
var setToStringTag = __webpack_require__(194);
var dP = __webpack_require__(79).f;
var each = __webpack_require__(1396)(0);
var DESCRIPTORS = __webpack_require__(81);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(123);
var IObject = __webpack_require__(274);
var toObject = __webpack_require__(283);
var toLength = __webpack_require__(277);
var asc = __webpack_require__(1397);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1398);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
var isArray = __webpack_require__(603);
var SPECIES = __webpack_require__(62)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(78);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(1400)('Map') });


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(609);
var from = __webpack_require__(1401);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(195);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(1403)('Map');


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(78);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(1405)('Map');


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(78);
var aFunction = __webpack_require__(593);
var ctx = __webpack_require__(123);
var forOf = __webpack_require__(195);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_CheckIcon__ = __webpack_require__(142);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\InputCheckBox\\InputCheckBox.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var InputCheckBox = function (_React$PureComponent) {
  _inherits(InputCheckBox, _React$PureComponent);

  function InputCheckBox(props) {
    _classCallCheck(this, InputCheckBox);

    // for testing purposes
    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._onBlurHandler = function () {
      var _this$props = _this.props,
          _this$props$onBlur = _this$props.onBlur,
          onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

      onBlur();
      if (_this.input) {
        onChange(_this.input.checked);
      }
    };

    _this._onChangeHandler = function (event) {
      _this._onChange(event.target.checked);
    };

    _this._onChange = function (value) {
      var forceChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props$onChange2 = _this.props.onChange,
          onChange = _this$props$onChange2 === undefined ? function () {} : _this$props$onChange2;

      _this._dirtyClass(value);
      onChange(value);
      if (forceChange && _this.input) {
        _this.input.checked = value;
      }
    };

    _this._dirtyClass = function (value) {
      if (_this.label) {
        if (value && value != "") {
          _this.label.classList.add(__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.LabelCheckBoxWithValue);
        } else {
          _this.label.classList.remove(__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.LabelCheckBoxWithValue);
        }
      }
    };

    _this._getThisInput = function () {
      var _this$props$getThisIn = _this.props.getThisInput,
          getThisInput = _this$props$getThisIn === undefined ? function () {} : _this$props$getThisIn;

      getThisInput(_this);
    };

    if (process && process.env && "production" === 'test') {
      _this.random = 1;
    } else {
      _this.random = Math.random();
    }
    return _this;
  }

  InputCheckBox.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        checked = _props.checked,
        _props$onChange = _props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;

    if (checked) {
      this._onChange(checked, true);
    }
  };

  InputCheckBox.prototype.render = function render() {
    var _classnames,
        _this2 = this,
        _classnames2,
        _classnames3,
        _classnames4,
        _classnames5,
        _classnames6;

    var _props2 = this.props,
        _props2$name = _props2.name,
        name = _props2$name === undefined ? "" : _props2$name,
        _props2$type = _props2.type,
        type = _props2$type === undefined ? "text" : _props2$type,
        _props2$label = _props2.label,
        label = _props2$label === undefined ? "" : _props2$label,
        _props2$styleName = _props2.styleName,
        styleName = _props2$styleName === undefined ? "light" : _props2$styleName,
        _props2$large = _props2.large,
        large = _props2$large === undefined ? false : _props2$large,
        _props2$required = _props2.required,
        required = _props2$required === undefined ? false : _props2$required,
        _props2$disabled = _props2.disabled,
        disabled = _props2$disabled === undefined ? false : _props2$disabled,
        _props2$message = _props2.message,
        message = _props2$message === undefined ? "" : _props2$message,
        _props2$isValid = _props2.isValid,
        isValid = _props2$isValid === undefined ? true : _props2$isValid;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        getthisinput: this._getThisInput(),
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.InputCheckBox] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.InputCheckBoxLarge] = large, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 73
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        ref: function ref(c) {
          return _this2.input = c;
        },
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.InputCheckBoxInput] = true, _classnames2)),
        name: "" + name,
        id: name + "-" + this.random,
        type: "checkbox",
        disabled: disabled,
        onBlur: this._onBlurHandler,
        onChange: this._onChangeHandler,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        {
          ref: function ref(c) {
            return _this2.label = c;
          },
          htmlFor: name + "-" + this.random,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.LabelCheckBox] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.LabelCheckBoxWithValue] = false, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 91
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icons_CheckIcon__["a" /* default */], { style: {
            width: "10px",
            padding: "3px"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 98
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        {
          htmlFor: name + "-" + this.random,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.Label] = true, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 103
          }
        },
        label,
        required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.requiredStar] = true, _classnames5)), __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            }
          },
          "*"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.message] = true, _classnames6[__WEBPACK_IMPORTED_MODULE_2__InputCheckBox_less___default.a.messageShow] = !isValid, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 115
          }
        },
        message
      )
    );
  };

  return InputCheckBox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InputCheckBox.displayName = "InputCheckBox";


/* harmony default export */ __webpack_exports__["a"] = (InputCheckBox);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputEmail_less__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputEmail_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InputEmail_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\InputEmail\\InputEmail.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var InputEmail = function (_React$PureComponent) {
  _inherits(InputEmail, _React$PureComponent);

  function InputEmail() {
    var _temp, _this, _ret;

    _classCallCheck(this, InputEmail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._onBlurHandler = function () {
      var _this$props$onBlur = _this.props.onBlur,
          onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur;

      onBlur();
    }, _this._onChangeHandler = function (value) {
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

      onChange(value);
    }, _this._getThisInput = function (inputThis) {
      var _this$props$getThisIn = _this.props.getThisInput,
          getThisInput = _this$props$getThisIn === undefined ? function () {} : _this$props$getThisIn;

      getThisInput(inputThis);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  InputEmail.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        name = _props.name,
        required = _props.required,
        isValid = _props.isValid,
        message = _props.message,
        defaultValue = _props.defaultValue;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["K" /* Input */], {
      label: label,
      getThisInput: this._getThisInput,
      name: name,
      type: "email",
      required: required,
      defaultValue: defaultValue,
      isValid: isValid,
      message: message,
      onChange: this._onChangeHandler,
      onBlur: this._onBlurHandler,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34
      }
    });
  };

  return InputEmail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InputEmail.displayName = "InputEmail";


/* harmony default export */ __webpack_exports__["a"] = (InputEmail);

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InputEmail":"InputEmail__InputEmail___1-MMk"};

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputPassword_less__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputPassword_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InputPassword_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\InputPassword\\InputPassword.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var InputPassword = function (_React$PureComponent) {
  _inherits(InputPassword, _React$PureComponent);

  function InputPassword(props) {
    _classCallCheck(this, InputPassword);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._onBlurHandler = function () {
      var _this$props$onBlur = _this.props.onBlur,
          onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur;

      onBlur();
    };

    _this._onChangeHandler = function (value) {
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

      onChange(value);
    };

    _this._getThisInput = function (inputThis) {
      var _this$props$getThisIn = _this.props.getThisInput,
          getThisInput = _this$props$getThisIn === undefined ? function () {} : _this$props$getThisIn;

      _this.input = inputThis;
      getThisInput(inputThis);
    };

    _this._handleOnClick = function () {
      _this.setState(function (prevState) {
        return {
          isVisible: !prevState.isVisible
        };
      });
    };

    _this.state = {
      isVisible: false
    };
    return _this;
  }

  InputPassword.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        label = _props.label,
        name = _props.name,
        required = _props.required,
        isValid = _props.isValid,
        message = _props.message,
        defaultValue = _props.defaultValue;
    var isVisible = this.state.isVisible;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_3__InputPassword_less___default.a.InputPassword] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["K" /* Input */], {
        label: label,
        getThisInput: this._getThisInput,
        name: name,
        type: isVisible ? 'text' : 'password',
        required: required,
        defaultValue: defaultValue,
        isValid: isValid,
        message: message,
        onChange: this._onChangeHandler,
        onBlur: this._onBlurHandler,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_3__InputPassword_less___default.a.InputPasswordIcon] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_3__InputPassword_less___default.a.InputPasswordIconInnerInvalid] = !isValid && message, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 57
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
          { withoutStyle: true, styleName: "black", onClick: this._handleOnClick, __source: {
              fileName: _jsxFileName,
              lineNumber: 61
            }
          },
          isVisible ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["E" /* HideIcon */], { style: {
              width: "22px",
              height: "22px"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 64
            }
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["_11" /* ShowIcon */], { style: {
              width: "22px",
              height: "22px"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          })
        )
      )
    );
  };

  return InputPassword;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InputPassword.displayName = "InputPassword";


/* harmony default export */ __webpack_exports__["a"] = (InputPassword);

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InputPassword":"InputPassword__InputPassword___2GCtN","InputPasswordIcon":"InputPassword__InputPasswordIcon___3f_rR","InputPasswordIconInnerInvalid":"InputPassword__InputPasswordIconInnerInvalid___3jg2q","InputPasswordIconInner":"InputPassword__InputPasswordIconInner___k8mxX"};

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputRadio_less__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputRadio_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InputRadio_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\InputRadio\\InputRadio.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var InputRadio = function (_React$PureComponent) {
  _inherits(InputRadio, _React$PureComponent);

  function InputRadio(props) {
    _classCallCheck(this, InputRadio);

    // for testing purposes
    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._onBlurHandler = function () {
      var _this$props = _this.props,
          _this$props$onBlur = _this$props.onBlur,
          onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

      onBlur();
      onChange(_this.input.checked);
    };

    _this._onChangeHandler = function (event) {
      _this._onChange(event.target.checked);
    };

    _this._onChange = function (defaultValue) {
      var forceChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props2 = _this.props,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === undefined ? function () {} : _this$props2$onChange,
          _this$props2$value = _this$props2.value,
          value = _this$props2$value === undefined ? 0 : _this$props2$value;

      _this._dirtyClass(defaultValue);
      onChange(value);
      if (forceChange && _this.input) {
        _this.input.checked = value;
      }
    };

    _this._dirtyClass = function (value) {
      if (_this.label) {
        if (value && value != "") {
          _this.label.classList.add(__WEBPACK_IMPORTED_MODULE_2__InputRadio_less___default.a.PlaceholderWithValue);
        } else {
          _this.label.classList.remove(__WEBPACK_IMPORTED_MODULE_2__InputRadio_less___default.a.PlaceholderWithValue);
        }
      }
    };

    _this._getThisInput = function () {
      var _this$props$getThisIn = _this.props.getThisInput,
          getThisInput = _this$props$getThisIn === undefined ? function () {} : _this$props$getThisIn;

      getThisInput(_this);
    };

    if (process && process.env && "production" === 'test') {
      _this.random = 1;
    } else {
      _this.random = Math.random();
    }
    return _this;
  }

  InputRadio.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        checked = _props.checked,
        _props$onChange = _props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;

    if (checked) {
      this._onChange(checked, true);
    }
  };

  InputRadio.prototype.render = function render() {
    var _classnames,
        _this2 = this,
        _classnames2,
        _classnames3,
        _classnames4,
        _classnames5,
        _classnames6;

    var _props2 = this.props,
        _props2$name = _props2.name,
        name = _props2$name === undefined ? "" : _props2$name,
        _props2$label = _props2.label,
        label = _props2$label === undefined ? "" : _props2$label,
        _props2$message = _props2.message,
        message = _props2$message === undefined ? "" : _props2$message,
        _props2$isValid = _props2.isValid,
        isValid = _props2$isValid === undefined ? true : _props2$isValid;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        getthisinput: this._getThisInput(),
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__InputRadio_less___default.a.InputRadio] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 64
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        ref: function ref(c) {
          return _this2.input = c;
        },
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__InputRadio_less___default.a.InputRadioInput] = true, _classnames2)),
        name: "" + name,
        id: name + "-" + this.random,
        type: "radio",
        onBlur: this._onBlurHandler,
        onChange: this._onChangeHandler,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        {
          ref: function ref(c) {
            return _this2.label = c;
          },
          htmlFor: name + "-" + this.random,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__InputRadio_less___default.a.LabelCheckBox] = true, _classnames3)), __source: {
            fileName: _jsxFileName,
            lineNumber: 80
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__InputRadio_less___default.a.LabelCheckBoxCircle] = true, _classnames4)), __source: {
            fileName: _jsxFileName,
            lineNumber: 86
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        {
          htmlFor: name + "-" + this.random,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__InputRadio_less___default.a.Label] = true, _classnames5)), __source: {
            fileName: _jsxFileName,
            lineNumber: 91
          }
        },
        label
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__InputRadio_less___default.a.message] = true, _classnames6[__WEBPACK_IMPORTED_MODULE_2__InputRadio_less___default.a.messageShow] = !isValid, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 98
          }
        },
        message
      )
    );
  };

  return InputRadio;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InputRadio.displayName = "InputRadio";


/* harmony default export */ __webpack_exports__["a"] = (InputRadio);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InputRadio":"InputRadio__InputRadio___1W8xb","InputRadioInput":"InputRadio__InputRadioInput___soYQE","LabelCheckBox":"InputRadio__LabelCheckBox___2izSE","LabelCheckBoxCircle":"InputRadio__LabelCheckBoxCircle___1dGwf","Label":"InputRadio__Label___O_p1X","requiredStar":"InputRadio__requiredStar___2D8A6","message":"InputRadio__message___2Z0g-","messageShow":"InputRadio__messageShow___1imeu"};

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputRange_less__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InputRange_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_range__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_range__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\InputRange\\InputRange.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var InputRange1 = function (_React$PureComponent) {
  _inherits(InputRange1, _React$PureComponent);

  function InputRange1(props) {
    _classCallCheck(this, InputRange1);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._onChange = function (value) {
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;


      onChange({ min: value.min, max: value.max });
    };

    _this.state = {
      value: { min: props.min, max: props.max }

      // for testing purposes
    };if (process && process.env && "production" === 'test') {
      _this.random = 1;
    } else {
      _this.random = Math.random();
    }
    return _this;
  }

  InputRange1.prototype.componentDidMount = function componentDidMount() {
    var _props$onChange = this.props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;
    var _state$value = this.state.value,
        min = _state$value.min,
        max = _state$value.max;


    onChange({ min: min, max: max });
  };

  InputRange1.prototype.render = function render() {
    var _classnames,
        _this2 = this;

    var _props = this.props,
        min = _props.min,
        max = _props.max,
        step = _props.step;
    var value = this.state.value;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.InputRange] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 40
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_range___default.a, {
        maxValue: max,
        minValue: min,
        step: step,
        value: value,
        formatLabel: function formatLabel(value) {
          return value / 1000 + "k";
        },
        classNames: {
          activeTrack: __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.activeTrack,
          disabledInputRange: __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.disabledInputRange,
          inputRange: __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.inputRange,
          labelContainer: __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.labelContainer,
          maxLabel: __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.maxLabel,
          minLabel: __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.minLabel,
          slider: __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.slider,
          sliderContainer: __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.sliderContainer,
          track: __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.track,
          valueLabel: __WEBPACK_IMPORTED_MODULE_2__InputRange_less___default.a.valueLabel
        },
        onChange: function onChange(value) {
          return _this2.setState({ value: value });
        },
        onChangeComplete: function onChangeComplete(value) {
          return _this2._onChange(value);
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 45
        }
      })
    );
  };

  return InputRange1;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InputRange1.displayName = "InputRange1";


/* harmony default export */ __webpack_exports__["a"] = (InputRange1);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InputRange":"InputRange__InputRange___2hrB_","inputRange":"InputRange__inputRange___joZUM","slider":"InputRange__slider___1ChrH","minLabel":"InputRange__minLabel___2URBe","maxLabel":"InputRange__maxLabel___3dQes","valueLabel":"InputRange__valueLabel___2--7m","labelContainer":"InputRange__labelContainer___3YlcC","track":"InputRange__track___vd4dD","activeTrack":"InputRange__activeTrack___1V_3A"};

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inputRange = __webpack_require__(1416);

var _inputRange2 = _interopRequireDefault(_inputRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 * @typedef {Object} ClientRect
 * @property {number} height
 * @property {number} left
 * @property {number} top
 * @property {number} width
 */

/**
 * @typedef {Object} InputRangeClassNames
 * @property {string} activeTrack
 * @property {string} disabledInputRange
 * @property {string} inputRange
 * @property {string} labelContainer
 * @property {string} maxLabel
 * @property {string} minLabel
 * @property {string} slider
 * @property {string} sliderContainer
 * @property {string} track
 * @property {string} valueLabel
 */

/**
 * @typedef {Function} LabelFormatter
 * @param {number} value
 * @param {string} type
 * @return {string}
 */

/**
 * @ignore
 * @typedef {Object} Point
 * @property {number} x
 * @property {number} y
 */

/**
 * @typedef {Object} Range
 * @property {number} min - Min value
 * @property {number} max - Max value
 */

exports.default = _inputRange2.default;
module.exports = exports['default'];
//# sourceMappingURL=index.js.map

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = __webpack_require__(290);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _valueTransformer = __webpack_require__(1417);

var valueTransformer = _interopRequireWildcard(_valueTransformer);

var _defaultClassNames = __webpack_require__(1425);

var _defaultClassNames2 = _interopRequireDefault(_defaultClassNames);

var _label = __webpack_require__(613);

var _label2 = _interopRequireDefault(_label);

var _rangePropType = __webpack_require__(1426);

var _rangePropType2 = _interopRequireDefault(_rangePropType);

var _valuePropType = __webpack_require__(1427);

var _valuePropType2 = _interopRequireDefault(_valuePropType);

var _slider = __webpack_require__(1428);

var _slider2 = _interopRequireDefault(_slider);

var _track = __webpack_require__(1429);

var _track2 = _interopRequireDefault(_track);

var _utils = __webpack_require__(196);

var _keyCodes = __webpack_require__(1430);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * A React component that allows users to input numeric values within a range
 * by dragging its sliders.
 */
var InputRange = (_class = function (_React$Component) {
  _inherits(InputRange, _React$Component);

  _createClass(InputRange, null, [{
    key: 'propTypes',

    /**
     * @ignore
     * @override
     * @return {Object}
     */
    get: function get() {
      return {
        allowSameValues: _propTypes2.default.bool,
        ariaLabelledby: _propTypes2.default.string,
        ariaControls: _propTypes2.default.string,
        classNames: _propTypes2.default.objectOf(_propTypes2.default.string),
        disabled: _propTypes2.default.bool,
        draggableTrack: _propTypes2.default.bool,
        formatLabel: _propTypes2.default.func,
        maxValue: _rangePropType2.default,
        minValue: _rangePropType2.default,
        name: _propTypes2.default.string,
        onChangeStart: _propTypes2.default.func,
        onChange: _propTypes2.default.func.isRequired,
        onChangeComplete: _propTypes2.default.func,
        step: _propTypes2.default.number,
        value: _valuePropType2.default
      };
    }

    /**
     * @ignore
     * @override
     * @return {Object}
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        allowSameValues: false,
        classNames: _defaultClassNames2.default,
        disabled: false,
        maxValue: 10,
        minValue: 0,
        step: 1
      };
    }

    /**
     * @param {Object} props
     * @param {boolean} [props.allowSameValues]
     * @param {string} [props.ariaLabelledby]
     * @param {string} [props.ariaControls]
     * @param {InputRangeClassNames} [props.classNames]
     * @param {boolean} [props.disabled = false]
     * @param {Function} [props.formatLabel]
     * @param {number|Range} [props.maxValue = 10]
     * @param {number|Range} [props.minValue = 0]
     * @param {string} [props.name]
     * @param {string} props.onChange
     * @param {Function} [props.onChangeComplete]
     * @param {Function} [props.onChangeStart]
     * @param {number} [props.step = 1]
     * @param {number|Range} props.value
     */

  }]);

  function InputRange(props) {
    _classCallCheck(this, InputRange);

    /**
     * @private
     * @type {?number}
     */
    var _this = _possibleConstructorReturn(this, (InputRange.__proto__ || Object.getPrototypeOf(InputRange)).call(this, props));

    _this.startValue = null;

    /**
     * @private
     * @type {?Component}
     */
    _this.node = null;

    /**
     * @private
     * @type {?Component}
     */
    _this.trackNode = null;

    /**
     * @private
     * @type {bool}
     */
    _this.isSliderDragging = false;

    /**
     * @private
     * @type {?string}
     */
    _this.lastKeyMoved = null;
    return _this;
  }

  /**
   * @ignore
   * @override
   * @return {void}
   */


  _createClass(InputRange, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeDocumentMouseUpListener();
      this.removeDocumentTouchEndListener();
    }

    /**
     * Return the CSS class name of the component
     * @private
     * @return {string}
     */

  }, {
    key: 'getComponentClassName',
    value: function getComponentClassName() {
      if (!this.props.disabled) {
        return this.props.classNames.inputRange;
      }

      return this.props.classNames.disabledInputRange;
    }

    /**
     * Return the bounding rect of the track
     * @private
     * @return {ClientRect}
     */

  }, {
    key: 'getTrackClientRect',
    value: function getTrackClientRect() {
      return this.trackNode.getClientRect();
    }

    /**
     * Return the slider key closest to a point
     * @private
     * @param {Point} position
     * @return {string}
     */

  }, {
    key: 'getKeyByPosition',
    value: function getKeyByPosition(position) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var positions = valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());

      if (this.isMultiValue()) {
        var distanceToMin = (0, _utils.distanceTo)(position, positions.min);
        var distanceToMax = (0, _utils.distanceTo)(position, positions.max);

        if (distanceToMin < distanceToMax) {
          return 'min';
        }
      }

      return 'max';
    }

    /**
     * Return all the slider keys
     * @private
     * @return {string[]}
     */

  }, {
    key: 'getKeys',
    value: function getKeys() {
      if (this.isMultiValue()) {
        return ['min', 'max'];
      }

      return ['max'];
    }

    /**
     * Return true if the difference between the new and the current value is
     * greater or equal to the step amount of the component
     * @private
     * @param {Range} values
     * @return {boolean}
     */

  }, {
    key: 'hasStepDifference',
    value: function hasStepDifference(values) {
      var currentValues = valueTransformer.getValueFromProps(this.props, this.isMultiValue());

      return (0, _utils.length)(values.min, currentValues.min) >= this.props.step || (0, _utils.length)(values.max, currentValues.max) >= this.props.step;
    }

    /**
     * Return true if the component accepts a min and max value
     * @private
     * @return {boolean}
     */

  }, {
    key: 'isMultiValue',
    value: function isMultiValue() {
      return (0, _utils.isObject)(this.props.value);
    }

    /**
     * Return true if the range is within the max and min value of the component
     * @private
     * @param {Range} values
     * @return {boolean}
     */

  }, {
    key: 'isWithinRange',
    value: function isWithinRange(values) {
      if (this.isMultiValue()) {
        return values.min >= this.props.minValue && values.max <= this.props.maxValue && this.props.allowSameValues ? values.min <= values.max : values.min < values.max;
      }

      return values.max >= this.props.minValue && values.max <= this.props.maxValue;
    }

    /**
     * Return true if the new value should trigger a render
     * @private
     * @param {Range} values
     * @return {boolean}
     */

  }, {
    key: 'shouldUpdate',
    value: function shouldUpdate(values) {
      return this.isWithinRange(values) && this.hasStepDifference(values);
    }

    /**
     * Update the position of a slider
     * @private
     * @param {string} key
     * @param {Point} position
     * @return {void}
     */

  }, {
    key: 'updatePosition',
    value: function updatePosition(key, position) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var positions = valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());

      positions[key] = position;
      this.lastKeyMoved = key;

      this.updatePositions(positions);
    }

    /**
     * Update the positions of multiple sliders
     * @private
     * @param {Object} positions
     * @param {Point} positions.min
     * @param {Point} positions.max
     * @return {void}
     */

  }, {
    key: 'updatePositions',
    value: function updatePositions(positions) {
      var values = {
        min: valueTransformer.getValueFromPosition(positions.min, this.props.minValue, this.props.maxValue, this.getTrackClientRect()),
        max: valueTransformer.getValueFromPosition(positions.max, this.props.minValue, this.props.maxValue, this.getTrackClientRect())
      };

      var transformedValues = {
        min: valueTransformer.getStepValueFromValue(values.min, this.props.step),
        max: valueTransformer.getStepValueFromValue(values.max, this.props.step)
      };

      this.updateValues(transformedValues);
    }

    /**
     * Update the value of a slider
     * @private
     * @param {string} key
     * @param {number} value
     * @return {void}
     */

  }, {
    key: 'updateValue',
    value: function updateValue(key, value) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());

      values[key] = value;

      this.updateValues(values);
    }

    /**
     * Update the values of multiple sliders
     * @private
     * @param {Range|number} values
     * @return {void}
     */

  }, {
    key: 'updateValues',
    value: function updateValues(values) {
      if (!this.shouldUpdate(values)) {
        return;
      }

      this.props.onChange(this.isMultiValue() ? values : values.max);
    }

    /**
     * Increment the value of a slider by key name
     * @private
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'incrementValue',
    value: function incrementValue(key) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var value = values[key] + this.props.step;

      this.updateValue(key, value);
    }

    /**
     * Decrement the value of a slider by key name
     * @private
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'decrementValue',
    value: function decrementValue(key) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var value = values[key] - this.props.step;

      this.updateValue(key, value);
    }

    /**
     * Listen to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseUpListener',
    value: function addDocumentMouseUpListener() {
      this.removeDocumentMouseUpListener();
      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * Listen to touchend event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentTouchEndListener',
    value: function addDocumentTouchEndListener() {
      this.removeDocumentTouchEndListener();
      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * Stop listening to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseUpListener',
    value: function removeDocumentMouseUpListener() {
      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * Stop listening to touchend event
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentTouchEndListener',
    value: function removeDocumentTouchEndListener() {
      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * Handle any "mousemove" event received by the slider
     * @private
     * @param {SyntheticEvent} event
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'handleSliderDrag',
    value: function handleSliderDrag(event, key) {
      var _this2 = this;

      if (this.props.disabled) {
        return;
      }

      var position = valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
      this.isSliderDragging = true;
      requestAnimationFrame(function () {
        return _this2.updatePosition(key, position);
      });
    }

    /**
     * Handle any "mousemove" event received by the track
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleTrackDrag',
    value: function handleTrackDrag(event, prevEvent) {
      if (this.props.disabled || !this.props.draggableTrack || this.isSliderDragging) {
        return;
      }

      var _props = this.props,
          maxValue = _props.maxValue,
          minValue = _props.minValue,
          _props$value = _props.value,
          max = _props$value.max,
          min = _props$value.min;


      var position = valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
      var value = valueTransformer.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
      var stepValue = valueTransformer.getStepValueFromValue(value, this.props.step);

      var prevPosition = valueTransformer.getPositionFromEvent(prevEvent, this.getTrackClientRect());
      var prevValue = valueTransformer.getValueFromPosition(prevPosition, minValue, maxValue, this.getTrackClientRect());
      var prevStepValue = valueTransformer.getStepValueFromValue(prevValue, this.props.step);

      var offset = prevStepValue - stepValue;

      var transformedValues = {
        min: min - offset,
        max: max - offset
      };

      this.updateValues(transformedValues);
    }

    /**
     * Handle any "keydown" event received by the slider
     * @private
     * @param {SyntheticEvent} event
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'handleSliderKeyDown',
    value: function handleSliderKeyDown(event, key) {
      if (this.props.disabled) {
        return;
      }

      switch (event.keyCode) {
        case _keyCodes.LEFT_ARROW:
        case _keyCodes.DOWN_ARROW:
          event.preventDefault();
          this.decrementValue(key);
          break;

        case _keyCodes.RIGHT_ARROW:
        case _keyCodes.UP_ARROW:
          event.preventDefault();
          this.incrementValue(key);
          break;

        default:
          break;
      }
    }

    /**
     * Handle any "mousedown" event received by the track
     * @private
     * @param {SyntheticEvent} event
     * @param {Point} position
     * @return {void}
     */

  }, {
    key: 'handleTrackMouseDown',
    value: function handleTrackMouseDown(event, position) {
      if (this.props.disabled) {
        return;
      }

      var _props2 = this.props,
          maxValue = _props2.maxValue,
          minValue = _props2.minValue,
          _props2$value = _props2.value,
          max = _props2$value.max,
          min = _props2$value.min;


      event.preventDefault();

      var value = valueTransformer.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
      var stepValue = valueTransformer.getStepValueFromValue(value, this.props.step);

      if (!this.props.draggableTrack || stepValue > max || stepValue < min) {
        this.updatePosition(this.getKeyByPosition(position), position);
      }
    }

    /**
     * Handle the start of any mouse/touch event
     * @private
     * @return {void}
     */

  }, {
    key: 'handleInteractionStart',
    value: function handleInteractionStart() {
      if (this.props.onChangeStart) {
        this.props.onChangeStart(this.props.value);
      }

      if (this.props.onChangeComplete && !(0, _utils.isDefined)(this.startValue)) {
        this.startValue = this.props.value;
      }
    }

    /**
     * Handle the end of any mouse/touch event
     * @private
     * @return {void}
     */

  }, {
    key: 'handleInteractionEnd',
    value: function handleInteractionEnd() {
      if (this.isSliderDragging) {
        this.isSliderDragging = false;
      }

      if (!this.props.onChangeComplete || !(0, _utils.isDefined)(this.startValue)) {
        return;
      }

      if (this.startValue !== this.props.value) {
        this.props.onChangeComplete(this.props.value);
      }

      this.startValue = null;
    }

    /**
     * Handle any "keydown" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      this.handleInteractionStart(event);
    }

    /**
     * Handle any "keyup" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(event) {
      this.handleInteractionEnd(event);
    }

    /**
     * Handle any "mousedown" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      this.handleInteractionStart(event);
      this.addDocumentMouseUpListener();
    }

    /**
     * Handle any "mouseup" event received by the component
     * @private
     * @param {SyntheticEvent} event
     */

  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp(event) {
      this.handleInteractionEnd(event);
      this.removeDocumentMouseUpListener();
    }

    /**
     * Handle any "touchstart" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      this.handleInteractionStart(event);
      this.addDocumentTouchEndListener();
    }

    /**
     * Handle any "touchend" event received by the component
     * @private
     * @param {SyntheticEvent} event
     */

  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      this.handleInteractionEnd(event);
      this.removeDocumentTouchEndListener();
    }

    /**
     * Return JSX of sliders
     * @private
     * @return {JSX.Element}
     */

  }, {
    key: 'renderSliders',
    value: function renderSliders() {
      var _this3 = this;

      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var percentages = valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
      var keys = this.props.allowSameValues && this.lastKeyMoved === 'min' ? this.getKeys().reverse() : this.getKeys();

      return keys.map(function (key) {
        var value = values[key];
        var percentage = percentages[key];

        var _props3 = _this3.props,
            maxValue = _props3.maxValue,
            minValue = _props3.minValue;


        if (key === 'min') {
          maxValue = values.max;
        } else {
          minValue = values.min;
        }

        var slider = _react2.default.createElement(_slider2.default, {
          ariaLabelledby: _this3.props.ariaLabelledby,
          ariaControls: _this3.props.ariaControls,
          classNames: _this3.props.classNames,
          formatLabel: _this3.props.formatLabel,
          key: key,
          maxValue: maxValue,
          minValue: minValue,
          onSliderDrag: _this3.handleSliderDrag,
          onSliderKeyDown: _this3.handleSliderKeyDown,
          percentage: percentage,
          type: key,
          value: value });

        return slider;
      });
    }

    /**
     * Return JSX of hidden inputs
     * @private
     * @return {JSX.Element}
     */

  }, {
    key: 'renderHiddenInputs',
    value: function renderHiddenInputs() {
      var _this4 = this;

      if (!this.props.name) {
        return [];
      }

      var isMultiValue = this.isMultiValue();
      var values = valueTransformer.getValueFromProps(this.props, isMultiValue);

      return this.getKeys().map(function (key) {
        var value = values[key];
        var name = isMultiValue ? '' + _this4.props.name + (0, _utils.captialize)(key) : _this4.props.name;

        return _react2.default.createElement('input', { key: key, type: 'hidden', name: name, value: value });
      });
    }

    /**
     * @ignore
     * @override
     * @return {JSX.Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var componentClassName = this.getComponentClassName();
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var percentages = valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);

      return _react2.default.createElement(
        'div',
        {
          'aria-disabled': this.props.disabled,
          ref: function ref(node) {
            _this5.node = node;
          },
          className: componentClassName,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart },
        _react2.default.createElement(
          _label2.default,
          {
            classNames: this.props.classNames,
            formatLabel: this.props.formatLabel,
            type: 'min' },
          this.props.minValue
        ),
        _react2.default.createElement(
          _track2.default,
          {
            classNames: this.props.classNames,
            draggableTrack: this.props.draggableTrack,
            ref: function ref(trackNode) {
              _this5.trackNode = trackNode;
            },
            percentages: percentages,
            onTrackDrag: this.handleTrackDrag,
            onTrackMouseDown: this.handleTrackMouseDown },
          this.renderSliders()
        ),
        _react2.default.createElement(
          _label2.default,
          {
            classNames: this.props.classNames,
            formatLabel: this.props.formatLabel,
            type: 'max' },
          this.props.maxValue
        ),
        this.renderHiddenInputs()
      );
    }
  }]);

  return InputRange;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleSliderDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSliderKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype)), _class);
exports.default = InputRange;
module.exports = exports['default'];
//# sourceMappingURL=input-range.js.map

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getPercentageFromPosition = getPercentageFromPosition;
exports.getValueFromPosition = getValueFromPosition;
exports.getValueFromProps = getValueFromProps;
exports.getPercentageFromValue = getPercentageFromValue;
exports.getPercentagesFromValues = getPercentagesFromValues;
exports.getPositionFromValue = getPositionFromValue;
exports.getPositionsFromValues = getPositionsFromValues;
exports.getPositionFromEvent = getPositionFromEvent;
exports.getStepValueFromValue = getStepValueFromValue;

var _utils = __webpack_require__(196);

/**
 * Convert a point into a percentage value
 * @ignore
 * @param {Point} position
 * @param {ClientRect} clientRect
 * @return {number} Percentage value
 */
function getPercentageFromPosition(position, clientRect) {
  var length = clientRect.width;
  var sizePerc = position.x / length;

  return sizePerc || 0;
}

/**
 * Convert a point into a model value
 * @ignore
 * @param {Point} position
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {number}
 */
function getValueFromPosition(position, minValue, maxValue, clientRect) {
  var sizePerc = getPercentageFromPosition(position, clientRect);
  var valueDiff = maxValue - minValue;

  return minValue + valueDiff * sizePerc;
}

/**
 * Convert props into a range value
 * @ignore
 * @param {Object} props
 * @param {boolean} isMultiValue
 * @return {Range}
 */
function getValueFromProps(props, isMultiValue) {
  if (isMultiValue) {
    return _extends({}, props.value);
  }

  return {
    min: props.minValue,
    max: props.value
  };
}

/**
 * Convert a model value into a percentage value
 * @ignore
 * @param {number} value
 * @param {number} minValue
 * @param {number} maxValue
 * @return {number}
 */
function getPercentageFromValue(value, minValue, maxValue) {
  var validValue = (0, _utils.clamp)(value, minValue, maxValue);
  var valueDiff = maxValue - minValue;
  var valuePerc = (validValue - minValue) / valueDiff;

  return valuePerc || 0;
}

/**
 * Convert model values into percentage values
 * @ignore
 * @param {Range} values
 * @param {number} minValue
 * @param {number} maxValue
 * @return {Range}
 */
function getPercentagesFromValues(values, minValue, maxValue) {
  return {
    min: getPercentageFromValue(values.min, minValue, maxValue),
    max: getPercentageFromValue(values.max, minValue, maxValue)
  };
}

/**
 * Convert a value into a point
 * @ignore
 * @param {number} value
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {Point} Position
 */
function getPositionFromValue(value, minValue, maxValue, clientRect) {
  var length = clientRect.width;
  var valuePerc = getPercentageFromValue(value, minValue, maxValue);
  var positionValue = valuePerc * length;

  return {
    x: positionValue,
    y: 0
  };
}

/**
 * Convert a range of values into points
 * @ignore
 * @param {Range} values
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {Range}
 */
function getPositionsFromValues(values, minValue, maxValue, clientRect) {
  return {
    min: getPositionFromValue(values.min, minValue, maxValue, clientRect),
    max: getPositionFromValue(values.max, minValue, maxValue, clientRect)
  };
}

/**
 * Convert an event into a point
 * @ignore
 * @param {Event} event
 * @param {ClientRect} clientRect
 * @return {Point}
 */
function getPositionFromEvent(event, clientRect) {
  var length = clientRect.width;

  var _ref = event.touches ? event.touches[0] : event,
      clientX = _ref.clientX;

  return {
    x: (0, _utils.clamp)(clientX - clientRect.left, 0, length),
    y: 0
  };
}

/**
 * Convert a value into a step value
 * @ignore
 * @param {number} value
 * @param {number} valuePerStep
 * @return {number}
 */
function getStepValueFromValue(value, valuePerStep) {
  return Math.round(value / valuePerStep) * valuePerStep;
}
//# sourceMappingURL=value-transformer.js.map

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = captialize;
/**
 * Captialize a string
 * @ignore
 * @param {string} string
 * @return {string}
 */
function captialize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
module.exports = exports["default"];
//# sourceMappingURL=captialize.js.map

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clamp;
/**
 * Clamp a value between a min and max value
 * @ignore
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
module.exports = exports["default"];
//# sourceMappingURL=clamp.js.map

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = distanceTo;
/**
 * Calculate the distance between pointA and pointB
 * @ignore
 * @param {Point} pointA
 * @param {Point} pointB
 * @return {number} Distance
 */
function distanceTo(pointA, pointB) {
  var xDiff = Math.pow(pointB.x - pointA.x, 2);
  var yDiff = Math.pow(pointB.y - pointA.y, 2);

  return Math.sqrt(xDiff + yDiff);
}
module.exports = exports["default"];
//# sourceMappingURL=distance-to.js.map

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDefined;
/**
 * Check if a value is defined
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isDefined(value) {
  return value !== undefined && value !== null;
}
module.exports = exports["default"];
//# sourceMappingURL=is-defined.js.map

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumber;
/**
 * Check if a value is a number
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isNumber(value) {
  return typeof value === 'number';
}
module.exports = exports['default'];
//# sourceMappingURL=is-number.js.map

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isObject;
/**
 * Check if a value is an object
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isObject(value) {
  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}
module.exports = exports['default'];
//# sourceMappingURL=is-object.js.map

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = length;
/**
 * Calculate the absolute difference between two numbers
 * @ignore
 * @param {number} numA
 * @param {number} numB
 * @return {number}
 */
function length(numA, numB) {
  return Math.abs(numA - numB);
}
module.exports = exports["default"];
//# sourceMappingURL=length.js.map

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Default CSS class names
 * @ignore
 * @type {InputRangeClassNames}
 */
var DEFAULT_CLASS_NAMES = {
  activeTrack: 'input-range__track input-range__track--active',
  disabledInputRange: 'input-range input-range--disabled',
  inputRange: 'input-range',
  labelContainer: 'input-range__label-container',
  maxLabel: 'input-range__label input-range__label--max',
  minLabel: 'input-range__label input-range__label--min',
  slider: 'input-range__slider',
  sliderContainer: 'input-range__slider-container',
  track: 'input-range__track input-range__track--background',
  valueLabel: 'input-range__label input-range__label--value'
};

exports.default = DEFAULT_CLASS_NAMES;
module.exports = exports['default'];
//# sourceMappingURL=default-class-names.js.map

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rangePropType;

var _utils = __webpack_require__(196);

/**
 * @ignore
 * @param {Object} props - React component props
 * @return {?Error} Return Error if validation fails
 */
function rangePropType(props) {
  var maxValue = props.maxValue,
      minValue = props.minValue;


  if (!(0, _utils.isNumber)(minValue) || !(0, _utils.isNumber)(maxValue)) {
    return new Error('"minValue" and "maxValue" must be a number');
  }

  if (minValue >= maxValue) {
    return new Error('"minValue" must be smaller than "maxValue"');
  }
}
module.exports = exports['default'];
//# sourceMappingURL=range-prop-type.js.map

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = valuePropType;

var _utils = __webpack_require__(196);

/**
 * @ignore
 * @param {Object} props
 * @return {?Error} Return Error if validation fails
 */
function valuePropType(props, propName) {
  var maxValue = props.maxValue,
      minValue = props.minValue;

  var value = props[propName];

  if (!(0, _utils.isNumber)(value) && (!(0, _utils.isObject)(value) || !(0, _utils.isNumber)(value.min) || !(0, _utils.isNumber)(value.max))) {
    return new Error('"' + propName + '" must be a number or a range object');
  }

  if ((0, _utils.isNumber)(value) && (value < minValue || value > maxValue)) {
    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
  }

  if ((0, _utils.isObject)(value) && (value.min < minValue || value.min > maxValue || value.max < minValue || value.max > maxValue)) {
    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
  }
}
module.exports = exports['default'];
//# sourceMappingURL=value-prop-type.js.map

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = __webpack_require__(290);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _label = __webpack_require__(613);

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * @ignore
 */
var Slider = (_class = function (_React$Component) {
  _inherits(Slider, _React$Component);

  _createClass(Slider, null, [{
    key: 'propTypes',

    /**
     * Accepted propTypes of Slider
     * @override
     * @return {Object}
     * @property {Function} ariaLabelledby
     * @property {Function} ariaControls
     * @property {Function} className
     * @property {Function} formatLabel
     * @property {Function} maxValue
     * @property {Function} minValue
     * @property {Function} onSliderDrag
     * @property {Function} onSliderKeyDown
     * @property {Function} percentage
     * @property {Function} type
     * @property {Function} value
     */
    get: function get() {
      return {
        ariaLabelledby: _propTypes2.default.string,
        ariaControls: _propTypes2.default.string,
        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
        formatLabel: _propTypes2.default.func,
        maxValue: _propTypes2.default.number,
        minValue: _propTypes2.default.number,
        onSliderDrag: _propTypes2.default.func.isRequired,
        onSliderKeyDown: _propTypes2.default.func.isRequired,
        percentage: _propTypes2.default.number.isRequired,
        type: _propTypes2.default.string.isRequired,
        value: _propTypes2.default.number.isRequired
      };
    }

    /**
     * @param {Object} props
     * @param {string} [props.ariaLabelledby]
     * @param {string} [props.ariaControls]
     * @param {InputRangeClassNames} props.classNames
     * @param {Function} [props.formatLabel]
     * @param {number} [props.maxValue]
     * @param {number} [props.minValue]
     * @param {Function} props.onSliderKeyDown
     * @param {Function} props.onSliderDrag
     * @param {number} props.percentage
     * @param {number} props.type
     * @param {number} props.value
     */

  }]);

  function Slider(props) {
    _classCallCheck(this, Slider);

    /**
     * @private
     * @type {?Component}
     */
    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.node = null;
    return _this;
  }

  /**
   * @ignore
   * @override
   * @return {void}
   */


  _createClass(Slider, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeDocumentMouseMoveListener();
      this.removeDocumentMouseUpListener();
      this.removeDocumentTouchEndListener();
      this.removeDocumentTouchMoveListener();
    }

    /**
     * @private
     * @return {Object}
     */

  }, {
    key: 'getStyle',
    value: function getStyle() {
      var perc = (this.props.percentage || 0) * 100;
      var style = {
        position: 'absolute',
        left: perc + '%'
      };

      return style;
    }

    /**
     * Listen to mousemove event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseMoveListener',
    value: function addDocumentMouseMoveListener() {
      this.removeDocumentMouseMoveListener();
      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * Listen to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseUpListener',
    value: function addDocumentMouseUpListener() {
      this.removeDocumentMouseUpListener();
      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * Listen to touchmove event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentTouchMoveListener',
    value: function addDocumentTouchMoveListener() {
      this.removeDocumentTouchMoveListener();
      this.node.ownerDocument.addEventListener('touchmove', this.handleTouchMove);
    }

    /**
     * Listen to touchend event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentTouchEndListener',
    value: function addDocumentTouchEndListener() {
      this.removeDocumentTouchEndListener();
      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseMoveListener',
    value: function removeDocumentMouseMoveListener() {
      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseUpListener',
    value: function removeDocumentMouseUpListener() {
      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentTouchMoveListener',
    value: function removeDocumentTouchMoveListener() {
      this.node.ownerDocument.removeEventListener('touchmove', this.handleTouchMove);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentTouchEndListener',
    value: function removeDocumentTouchEndListener() {
      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown() {
      this.addDocumentMouseMoveListener();
      this.addDocumentMouseUpListener();
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp() {
      this.removeDocumentMouseMoveListener();
      this.removeDocumentMouseUpListener();
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      this.props.onSliderDrag(event, this.props.type);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart() {
      this.addDocumentTouchEndListener();
      this.addDocumentTouchMoveListener();
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      this.props.onSliderDrag(event, this.props.type);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd() {
      this.removeDocumentTouchMoveListener();
      this.removeDocumentTouchEndListener();
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      this.props.onSliderKeyDown(event, this.props.type);
    }

    /**
     * @override
     * @return {JSX.Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var style = this.getStyle();

      return _react2.default.createElement(
        'span',
        {
          className: this.props.classNames.sliderContainer,
          ref: function ref(node) {
            _this2.node = node;
          },
          style: style },
        _react2.default.createElement(
          _label2.default,
          {
            classNames: this.props.classNames,
            formatLabel: this.props.formatLabel,
            type: 'value' },
          this.props.value
        ),
        _react2.default.createElement('div', {
          'aria-labelledby': this.props.ariaLabelledby,
          'aria-controls': this.props.ariaControls,
          'aria-valuemax': this.props.maxValue,
          'aria-valuemin': this.props.minValue,
          'aria-valuenow': this.props.value,
          className: this.props.classNames.slider,
          draggable: 'false',
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart,
          role: 'slider',
          tabIndex: '0' })
      );
    }
  }]);

  return Slider;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype)), _class);
exports.default = Slider;
module.exports = exports['default'];
//# sourceMappingURL=slider.js.map

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = __webpack_require__(290);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * @ignore
 */
var Track = (_class = function (_React$Component) {
  _inherits(Track, _React$Component);

  _createClass(Track, null, [{
    key: 'propTypes',

    /**
     * @override
     * @return {Object}
     * @property {Function} children
     * @property {Function} classNames
     * @property {Boolean} draggableTrack
     * @property {Function} onTrackDrag
     * @property {Function} onTrackMouseDown
     * @property {Function} percentages
     */
    get: function get() {
      return {
        children: _propTypes2.default.node.isRequired,
        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
        draggableTrack: _propTypes2.default.bool,
        onTrackDrag: _propTypes2.default.func,
        onTrackMouseDown: _propTypes2.default.func.isRequired,
        percentages: _propTypes2.default.objectOf(_propTypes2.default.number).isRequired
      };
    }

    /**
     * @param {Object} props
     * @param {InputRangeClassNames} props.classNames
     * @param {Boolean} props.draggableTrack
     * @param {Function} props.onTrackDrag
     * @param {Function} props.onTrackMouseDown
     * @param {number} props.percentages
     */

  }]);

  function Track(props) {
    _classCallCheck(this, Track);

    /**
     * @private
     * @type {?Component}
     */
    var _this = _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).call(this, props));

    _this.node = null;
    _this.trackDragEvent = null;
    return _this;
  }

  /**
   * @private
   * @return {ClientRect}
   */


  _createClass(Track, [{
    key: 'getClientRect',
    value: function getClientRect() {
      return this.node.getBoundingClientRect();
    }

    /**
     * @private
     * @return {Object} CSS styles
     */

  }, {
    key: 'getActiveTrackStyle',
    value: function getActiveTrackStyle() {
      var width = (this.props.percentages.max - this.props.percentages.min) * 100 + '%';
      var left = this.props.percentages.min * 100 + '%';

      return { left: left, width: width };
    }

    /**
     * Listen to mousemove event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseMoveListener',
    value: function addDocumentMouseMoveListener() {
      this.removeDocumentMouseMoveListener();
      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * Listen to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseUpListener',
    value: function addDocumentMouseUpListener() {
      this.removeDocumentMouseUpListener();
      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseMoveListener',
    value: function removeDocumentMouseMoveListener() {
      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseUpListener',
    value: function removeDocumentMouseUpListener() {
      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      if (!this.props.draggableTrack) {
        return;
      }

      if (this.trackDragEvent !== null) {
        this.props.onTrackDrag(event, this.trackDragEvent);
      }

      this.trackDragEvent = event;
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp() {
      if (!this.props.draggableTrack) {
        return;
      }

      this.removeDocumentMouseMoveListener();
      this.removeDocumentMouseUpListener();
      this.trackDragEvent = null;
    }

    /**
     * @private
     * @param {SyntheticEvent} event - User event
     */

  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      var clientX = event.touches ? event.touches[0].clientX : event.clientX;
      var trackClientRect = this.getClientRect();
      var position = {
        x: clientX - trackClientRect.left,
        y: 0
      };

      this.props.onTrackMouseDown(event, position);

      if (this.props.draggableTrack) {
        this.addDocumentMouseMoveListener();
        this.addDocumentMouseUpListener();
      }
    }

    /**
     * @private
     * @param {SyntheticEvent} event - User event
     */

  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      event.preventDefault();

      this.handleMouseDown(event);
    }

    /**
     * @override
     * @return {JSX.Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var activeTrackStyle = this.getActiveTrackStyle();

      return _react2.default.createElement(
        'div',
        {
          className: this.props.classNames.track,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart,
          ref: function ref(node) {
            _this2.node = node;
          } },
        _react2.default.createElement('div', {
          style: activeTrackStyle,
          className: this.props.classNames.activeTrack }),
        this.props.children
      );
    }
  }]);

  return Track;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype)), _class);
exports.default = Track;
module.exports = exports['default'];
//# sourceMappingURL=track.js.map

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @ignore */
var DOWN_ARROW = exports.DOWN_ARROW = 40;

/** @ignore */
var LEFT_ARROW = exports.LEFT_ARROW = 37;

/** @ignore */
var RIGHT_ARROW = exports.RIGHT_ARROW = 39;

/** @ignore */
var UP_ARROW = exports.UP_ARROW = 38;
//# sourceMappingURL=key-codes.js.map

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputSelect_less__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InputSelect_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_ChevronIcon__ = __webpack_require__(138);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\InputSelect\\InputSelect.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var InputSelect = function (_React$PureComponent) {
  _inherits(InputSelect, _React$PureComponent);

  function InputSelect() {
    var _temp, _this, _ret;

    _classCallCheck(this, InputSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._onBlurHandler = function () {
      var _this$props$onBlur = _this.props.onBlur,
          onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur;

      onBlur();
    }, _this._onChangeHandler = function (event) {
      _this._onChange(event.target.value);
    }, _this._onChange = function (value) {
      var forceChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

      _this._dirtyClass(value);
      onChange(value);
      if (_this.input && forceChange) {
        _this.input.value = value;
      }
    }, _this._dirtyClass = function (value) {
      if (_this.label) {
        if (value && value != '') {
          _this.label.classList.add(__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.PlaceholderWithValue);
        } else {
          _this.label.classList.remove(__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.PlaceholderWithValue);
        }
      }
    }, _this._getThisInput = function () {
      var _this$props$getThisIn = _this.props.getThisInput,
          getThisInput = _this$props$getThisIn === undefined ? function () {} : _this$props$getThisIn;

      getThisInput(_this);
    }, _this._renderLabel = function () {
      var _classnames, _classnames2;

      var _this$props = _this.props,
          name = _this$props.name,
          label = _this$props.label,
          _this$props$required = _this$props.required,
          required = _this$props$required === undefined ? false : _this$props$required,
          _this$props$withoutSt = _this$props.withoutStar,
          withoutStar = _this$props$withoutSt === undefined ? false : _this$props$withoutSt,
          _this$props$active = _this$props.active,
          active = _this$props$active === undefined ? false : _this$props$active;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        {
          ref: function ref(c) {
            return _this.label = c;
          },
          htmlFor: name,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.Placeholder] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.PlaceholderWithValue] = active !== false && active !== -1, _classnames)), __source: {
            fileName: _jsxFileName,
            lineNumber: 52
          }
        },
        label,
        required && !withoutStar && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.requiredStar] = true, _classnames2)), __source: {
              fileName: _jsxFileName,
              lineNumber: 61
            }
          },
          '*'
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  InputSelect.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        _props$defaultValue = _props.defaultValue,
        defaultValue = _props$defaultValue === undefined ? { value: null } : _props$defaultValue,
        _props$onChange = _props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;

    if (defaultValue.value !== null) {
      this._onChange(defaultValue.value);
    }
  };

  InputSelect.prototype.render = function render() {
    var _classnames3,
        _this2 = this,
        _classnames4,
        _classnames5,
        _classnames6;

    var _props2 = this.props,
        _props2$defaultValue = _props2.defaultValue,
        defaultValue = _props2$defaultValue === undefined ? { value: null } : _props2$defaultValue,
        _props2$name = _props2.name,
        name = _props2$name === undefined ? '' : _props2$name,
        _props2$type = _props2.type,
        type = _props2$type === undefined ? 'text' : _props2$type,
        _props2$label = _props2.label,
        label = _props2$label === undefined ? '' : _props2$label,
        _props2$styleName = _props2.styleName,
        styleName = _props2$styleName === undefined ? 'light' : _props2$styleName,
        _props2$formType = _props2.formType,
        formType = _props2$formType === undefined ? 'normal' : _props2$formType,
        _props2$required = _props2.required,
        required = _props2$required === undefined ? false : _props2$required,
        _props2$withoutStar = _props2.withoutStar,
        withoutStar = _props2$withoutStar === undefined ? false : _props2$withoutStar,
        _props2$options = _props2.options,
        options = _props2$options === undefined ? [] : _props2$options,
        _props2$active = _props2.active,
        active = _props2$active === undefined ? false : _props2$active,
        _props2$message = _props2.message,
        message = _props2$message === undefined ? '' : _props2$message,
        _props2$isValid = _props2.isValid,
        isValid = _props2$isValid === undefined ? true : _props2$isValid;


    var option = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option', { disabled: true, selected: true, value: '', hidden: true, __source: {
        fileName: _jsxFileName,
        lineNumber: 85
      }
    });
    if (!required) option = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option', { value: '', selected: true, __source: {
        fileName: _jsxFileName,
        lineNumber: 86
      }
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        getthisinput: this._getThisInput(),
        'data-test': 'input-text',
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.InputSelect] = true, _classnames3[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.InputSelectCompact] = formType === "compact", _classnames3)), __source: {
          fileName: _jsxFileName,
          lineNumber: 89
        }
      },
      formType === "compact" && this._renderLabel(),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'select',
        {
          ref: function ref(c) {
            return _this2.input = c;
          },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.InputSelectInput] = true, _classnames4[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.InputSelectInvalid] = !isValid, _classnames4[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.InputSelectDark] = styleName === 'dark', _classnames4[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.InputSelectLight] = styleName === 'light', _classnames4)),
          name: name,
          id: name,
          onBlur: this._onBlurHandler,
          onChange: this._onChangeHandler,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 97
          }
        },
        option,
        options.map(function (option, index) {
          var selected = '';
          if (defaultValue && defaultValue.value === option.value) {
            selected = 'selected';
          }
          if (active !== false && active === index) {
            selected = 'selected';
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { key: 'Option-' + index, selected: selected, value: option.value, __source: {
                fileName: _jsxFileName,
                lineNumber: 120
              }
            },
            option.label
          );
        })
      ),
      formType === "normal" && this._renderLabel(),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames5 = {}, _classnames5[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.message] = true, _classnames5[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.messageShow] = !isValid, _classnames5)), __source: {
            fileName: _jsxFileName,
            lineNumber: 127
          }
        },
        message
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames6 = {}, _classnames6[__WEBPACK_IMPORTED_MODULE_2__InputSelect_less___default.a.chevron] = true, _classnames6)), __source: {
            fileName: _jsxFileName,
            lineNumber: 133
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icons_ChevronIcon__["a" /* default */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 136
          }
        })
      )
    );
  };

  return InputSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InputSelect.displayName = 'InputSelect';


/* harmony default export */ __webpack_exports__["a"] = (InputSelect);

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InputSelect":"InputSelect__InputSelect___2uC2l","InputSelectInput":"InputSelect__InputSelectInput___1XROB","InputSelectDark":"InputSelect__InputSelectDark___VmWLp","InputSelectLight":"InputSelect__InputSelectLight___1kkA9","InputSelectInvalid":"InputSelect__InputSelectInvalid___2UJPz","Placeholder":"InputSelect__Placeholder___eOIyc","PlaceholderWithValue":"InputSelect__PlaceholderWithValue___3QOq1","requiredStar":"InputSelect__requiredStar___2Fbnx","message":"InputSelect__message___11ASu","messageShow":"InputSelect__messageShow___32M_B","chevron":"InputSelect__chevron___14TKN","InputSelectCompact":"InputSelect__InputSelectCompact___1_sjw"};

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputText_less__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputText_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InputText_less__);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\InputText\\InputText.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var InputText = function (_React$PureComponent) {
  _inherits(InputText, _React$PureComponent);

  function InputText() {
    var _temp, _this, _ret;

    _classCallCheck(this, InputText);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._onBlurHandler = function () {
      var _this$props$onBlur = _this.props.onBlur,
          onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur;

      onBlur();
    }, _this._onChangeHandler = function (value) {
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

      onChange(value);
    }, _this._getThisInput = function (inputThis) {
      var _this$props$getThisIn = _this.props.getThisInput,
          getThisInput = _this$props$getThisIn === undefined ? function () {} : _this$props$getThisIn;

      getThisInput(inputThis);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  InputText.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        name = _props.name,
        required = _props.required,
        isValid = _props.isValid,
        message = _props.message,
        styleName = _props.styleName,
        defaultValue = _props.defaultValue;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["K" /* Input */], {
      label: label,
      getThisInput: this._getThisInput,
      name: name,
      type: 'text',
      required: required,
      styleName: styleName,
      defaultValue: defaultValue,
      isValid: isValid,
      message: message,
      onChange: this._onChangeHandler,
      onBlur: this._onBlurHandler,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34
      }
    });
  };

  return InputText;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InputText.displayName = 'InputText';


/* harmony default export */ __webpack_exports__["a"] = (InputText);

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InputText":"InputText__InputText___1YeM6"};

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\InstagramIcon.jsx";


var InstagramIcon = function InstagramIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 800 800", fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M400.003 72.068c106.804 0 119.451.408 161.633 2.332 38.997 1.781 60.178 8.298 74.274 13.774 18.673 7.257 31.996 15.926 45.993 29.923 13.999 13.997 22.669 27.317 29.923 45.99 5.477 14.097 11.993 35.277 13.771 74.275 1.924 42.181 2.332 54.829 2.332 161.636s-.408 119.457-2.332 161.636c-1.778 39-8.295 60.181-13.771 74.274-7.254 18.669-15.924 31.993-29.923 45.993-13.997 13.996-27.32 22.666-45.993 29.923-14.097 5.476-35.277 11.993-74.274 13.771-42.175 1.927-54.82 2.331-161.633 2.331-106.815 0-119.46-.404-161.636-2.331-38.997-1.778-60.178-8.296-74.275-13.771-18.669-7.257-31.996-15.927-45.993-29.923-13.996-14-22.663-27.324-29.92-45.993-5.476-14.094-11.996-35.274-13.774-74.274-1.924-42.179-2.332-54.829-2.332-161.636s.408-119.455 2.332-161.636c1.778-38.998 8.298-60.178 13.774-74.275 7.257-18.672 15.924-31.993 29.92-45.99 13.997-13.997 27.324-22.666 45.993-29.923 14.097-5.476 35.278-11.994 74.275-13.774 42.182-1.924 54.829-2.332 161.636-2.332m0-72.071c-108.636 0-122.258.459-164.92 2.408-42.577 1.942-71.654 8.706-97.096 18.593C111.683 31.22 89.376 44.896 67.14 67.133 44.903 89.37 31.223 111.68 21.004 137.98c-9.893 25.449-16.654 54.522-18.596 97.1C.46 277.746.003 291.365.003 399.997c0 108.636.457 122.255 2.405 164.917 1.942 42.58 8.703 71.654 18.596 97.1 10.219 26.303 23.899 48.61 46.136 70.85 22.236 22.237 44.543 35.914 70.847 46.136 25.442 9.887 54.519 16.647 97.096 18.593 42.663 1.945 56.285 2.408 164.92 2.408 108.633 0 122.255-.463 164.917-2.408 42.578-1.945 71.654-8.706 97.097-18.593 26.304-10.222 48.61-23.898 70.851-46.136 22.236-22.239 35.913-44.547 46.135-70.85 9.891-25.445 16.651-54.52 18.594-97.1 1.947-42.662 2.404-56.281 2.404-164.917 0-108.633-.457-122.252-2.404-164.917-1.942-42.577-8.703-71.651-18.594-97.099-10.222-26.3-23.898-48.61-46.135-70.847-22.24-22.237-44.547-35.914-70.851-46.135-25.442-9.887-54.519-16.651-97.097-18.593C522.258.457 508.636-.003 400.003-.003", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M400.003 194.594c-113.442 0-205.406 91.961-205.406 205.403S286.561 605.4 400.003 605.4c113.439 0 205.403-91.961 205.403-205.403s-91.964-205.403-205.403-205.403m0 338.735c-73.639 0-133.335-59.693-133.335-133.332s59.696-133.333 133.335-133.333 133.332 59.694 133.332 133.333-59.693 133.332-133.332 133.332M661.523 186.479c0 26.507-21.488 47.998-48.002 47.998-26.508 0-47.998-21.491-47.998-47.998 0-26.514 21.49-48.002 47.998-48.002 26.514 0 48.002 21.488 48.002 48.002", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

InstagramIcon.displayName = "InstagramIcon";
InstagramIcon.displayName = "InstagramIcon";
/* harmony default export */ __webpack_exports__["a"] = (InstagramIcon);

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\Interactive.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Interactive = function (_React$PureComponent) {
  _inherits(Interactive, _React$PureComponent);

  function Interactive() {
    _classCallCheck(this, Interactive);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Interactive.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        white = _props.white,
        withDetails = _props.withDetails;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.Interactive] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.WithDetails] = withDetails, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.white] = white, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    );
  };

  return Interactive;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Interactive.displayName = "Interactive";


/* harmony default export */ __webpack_exports__["a"] = (Interactive);

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\LinkIcon.jsx";


var LinkIcon = function LinkIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 17 17", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "M3.912 7c.21 0 .421.087.58.262a.818.818 0 0 1 .245.575c0 .21-.088.419-.246.576L3.456 9.442a2.868 2.868 0 0 0-.842 2.04c0 .785.298 1.5.842 2.041.544.541 1.263.837 2.053.837s1.509-.296 2.052-.837l1.035-1.029a.828.828 0 0 1 .58-.244c.21 0 .42.087.578.244a.818.818 0 0 1 .246.576c0 .21-.088.418-.246.575l-1.035 1.03c-.86.854-2 1.325-3.193 1.325a4.516 4.516 0 0 1-3.193-1.326A4.463 4.463 0 0 1 1 11.5a4.41 4.41 0 0 1 1.35-3.174l.983-1.082A.828.828 0 0 1 3.913 7zm8.58 1.604l1.053-1.001a2.898 2.898 0 0 0 .842-2.055c0-.79-.298-1.51-.842-2.054a2.86 2.86 0 0 0-2.052-.843 2.86 2.86 0 0 0-2.051.843L8.407 4.53a.825.825 0 0 1-.578.246.825.825 0 0 1-.58-.246c-.332-.316-.332-.826 0-1.16l1.035-1.035A4.497 4.497 0 0 1 11.476 1c1.21 0 2.332.474 3.191 1.335A4.51 4.51 0 0 1 16 5.53a4.51 4.51 0 0 1-1.333 3.196l-1.034 1.036a.804.804 0 0 1-1.14 0 .827.827 0 0 1-.246-.58c0-.21.088-.421.246-.58zM10.197 6c.017 0 .017 0 0 0 .222.017.41.103.564.24.154.153.24.358.24.563 0 .206-.086.41-.24.565l-3.404 3.401a.785.785 0 0 1-1.112 0c-.325-.307-.325-.803 0-1.128L9.63 6.239A.805.805 0 0 1 10.196 6z",
      stroke: "currentColor",
      fillRule: "nonzero",
      fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

LinkIcon.displayName = "LinkIcon";
LinkIcon.displayName = "LinkIcon";
/* unused harmony default export */ var _unused_webpack_default_export = (LinkIcon);

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoadingIcon_less__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoadingIcon_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LoadingIcon_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\LoadingIcon\\LoadingIcon.jsx";




var LoadingIcon = function LoadingIcon(_ref) {
  var _classnames;

  var style = _ref.style,
      _ref$styleName = _ref.styleName,
      styleName = _ref$styleName === undefined ? "light" : _ref$styleName;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__LoadingIcon_less___default.a.LoadingIcon] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__LoadingIcon_less___default.a.LoadingIconLight] = styleName === "light", _classnames[__WEBPACK_IMPORTED_MODULE_2__LoadingIcon_less___default.a.LoadingIconDark] = styleName === "dark", _classnames)),
    style: style, __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    }
  });
};

LoadingIcon.displayName = "LoadingIcon";
LoadingIcon.displayName = "LoadingIcon";
/* harmony default export */ __webpack_exports__["a"] = (LoadingIcon);

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"LoadingIcon":"LoadingIcon__LoadingIcon___1IrO1","spin":"LoadingIcon__spin___1k8pk","LoadingIconLight":"LoadingIcon__LoadingIconLight___1aDFs","LoadingIconDark":"LoadingIcon__LoadingIconDark___XF4Fx"};

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoadingSection_less__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoadingSection_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LoadingSection_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\LoadingSection\\LoadingSection.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var LoadingSection = function (_React$PureComponent) {
  _inherits(LoadingSection, _React$PureComponent);

  function LoadingSection() {
    _classCallCheck(this, LoadingSection);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  LoadingSection.prototype.render = function render() {
    var _this2 = this,
        _classnames;

    var _props = this.props,
        visible = _props.visible,
        height = _props.height,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? "light" : _props$styleName;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        ref: function ref(c) {
          return _this2.loading = c;
        },
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__LoadingSection_less___default.a.LoadingSection] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__LoadingSection_less___default.a.LoadingSectionHide] = !visible, _classnames)),
        style: {
          height: height && height < 35 && height > 10 ? height + "px" : "100%"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["V" /* LoadingIcon */], {
        styleName: styleName,
        style: {
          width: height && height < 35 && height > 10 ? height + "px" : "35px",
          height: height && height < 35 && height > 10 ? height + "px" : "35px",
          flexShrink: 0
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 19
        }
      })
    );
  };

  return LoadingSection;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

LoadingSection.displayName = "LoadingSection";


/* harmony default export */ __webpack_exports__["a"] = (LoadingSection);

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"LoadingSection":"LoadingSection__LoadingSection___3dupZ","LoadingSectionHide":"LoadingSection__LoadingSectionHide___1mSfA"};

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\MailIcon.jsx";


var MailIcon = function MailIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 37 29", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M31.603702,3.6251032 L6.37030835,3.6251032 L17.7288052,12.0311157 C18.3864068,12.5066473 19.5884297,12.5066473 20.2452051,12.0311157 L31.603702,3.6251032 Z M33.3724518,10.6036952 L37,7.54493694 L37,29 L0,29 L0,6.84237196 L3.62754817,9.92342073 L3.62754817,23.5404674 L10.5422779,14.8397244 L13.4667872,16.9920005 L6.80154956,25.3748968 L30.220756,25.3748968 L23.8950588,17.4452416 L26.8203943,15.2929655 L33.3724518,23.5173513 L33.3724518,10.6036952 Z M37,0 L37,3.7613232 L22.3989327,14.8851311 C21.447228,15.5876961 20.2228995,15.9270077 18.9754393,15.9270077 C17.7511108,15.9270077 16.5267823,15.5876961 15.5750776,14.8851311 L0,3.05875822 L0,0 L37,0 Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

MailIcon.displayName = "MailIcon";
MailIcon.displayName = "MailIcon";
/* harmony default export */ __webpack_exports__["a"] = (MailIcon);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\MaintenanceIcon.jsx";


var MaintenanceIcon = function MaintenanceIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 20 18", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 5
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(-551.000000, -2120.000000)", fill: "#979797", __source: {
            fileName: _jsxFileName,
            lineNumber: 6
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(0.000000, 1931.000000)", __source: {
              fileName: _jsxFileName,
              lineNumber: 7
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { transform: "translate(551.000000, 189.000000)", __source: {
                fileName: _jsxFileName,
                lineNumber: 8
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M2.69812,15.90958 C2.49012,16.11918 2.49012,16.45918 2.69792,16.66878 L3.64912,17.59798 C3.85732,17.80718 4.18732,17.71958 4.39532,17.50998 L9.30292,12.68478 L7.79872,10.97338 L2.69812,15.90958 Z M19.86112,2.24738 C19.78672,1.75338 19.53052,1.85798 19.39832,2.06718 C19.26612,2.27678 18.67732,3.16818 18.43552,3.57178 C18.19492,3.97338 17.60392,4.76298 16.50172,3.98318 C15.35352,3.17138 15.75272,2.60498 15.95332,2.22358 C16.15372,1.84098 16.77112,0.76838 16.86012,0.63378 C16.94892,0.49918 16.84532,0.10658 16.48912,0.27118 C16.13232,0.43578 13.96632,1.29678 13.66552,2.53038 C13.35912,3.78758 13.92272,4.90958 12.81552,6.02498 L11.47332,7.42538 L12.82152,8.99298 L14.47632,7.42238 C14.87092,7.02578 15.71192,6.64118 16.47412,6.81378 C18.10712,7.18358 18.99772,6.56998 19.53452,5.55658 C20.01472,4.64958 19.93532,2.74158 19.86112,2.24738 L19.86112,2.24738 Z M8.80152,6.26478 C8.68192,6.12658 8.53372,6.12318 8.40392,6.23678 L6.96972,7.48798 C6.85712,7.58718 6.84232,7.77178 6.94312,7.88798 L15.23712,17.32558 C15.43072,17.54918 15.76732,17.57278 15.98872,17.37838 L16.95952,16.56598 C17.18052,16.37158 17.20372,16.03218 17.01052,15.80858 L8.80152,6.26478 Z M3.09292,5.74818 C4.02632,5.02358 4.80012,5.52298 5.83372,6.71858 C5.94992,6.85258 6.10612,6.69598 6.19452,6.61818 C6.28292,6.54058 7.64612,5.31478 7.71252,5.25678 C7.77912,5.19838 7.85952,5.08878 7.75312,4.96598 C7.64732,4.84278 7.25912,4.34118 7.01052,4.01618 C5.20272,1.65078 11.95712,0.04738 10.91892,0.02138 C10.39152,0.00798 8.27312,-0.01662 7.95712,0.01678 C6.67312,0.15298 5.06292,1.35158 4.25172,1.90918 C3.19192,2.63758 2.79532,3.06218 2.72912,3.12018 C2.42952,3.38258 2.68092,3.98798 2.13752,4.46378 C1.56232,4.96898 1.20392,4.58818 0.87152,4.87938 C0.70572,5.02538 0.24452,5.37078 0.11192,5.48718 C-0.02108,5.60398 -0.04468,5.80118 0.09052,5.95778 C0.09052,5.95778 1.35412,7.35438 1.46072,7.47678 C1.56672,7.60038 1.85132,7.70438 2.02812,7.54878 C2.20552,7.39338 2.65952,6.99518 2.73672,6.92658 C2.81472,6.85918 2.68592,6.06398 3.09292,5.74818 L3.09292,5.74818 Z", __source: {
                fileName: _jsxFileName,
                lineNumber: 9
              }
            })
          )
        )
      )
    )
  );
};

MaintenanceIcon.displayName = "MaintenanceIcon";
MaintenanceIcon.displayName = "MaintenanceIcon";
/* harmony default export */ __webpack_exports__["a"] = (MaintenanceIcon);

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_aria_modal__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_aria_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_aria_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal_less__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Modal_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Modal\\Modal.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Modal = function (_React$PureComponent) {
  _inherits(Modal, _React$PureComponent);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Modal.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        children = _props.children,
        _props$handleClose = _props.handleClose,
        handleClose = _props$handleClose === undefined ? function () {} : _props$handleClose,
        width = _props.width,
        _props$fullWidth = _props.fullWidth,
        fullWidth = _props$fullWidth === undefined ? false : _props$fullWidth;


    if (!__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["b" /* IS_BROWSER */]) return null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_aria_modal___default.a,
      {
        titleText: "modal",
        onExit: handleClose,
        underlayClickExits: true,
        verticallyCenter: true,
        focusDialog: true,
        underlayStyle: { padding: '0' },
        dialogStyle: fullWidth ? { width: '100%', height: '100vh' } : {},
        __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5__Modal_less___default.a.Modal] = true, _classnames[__WEBPACK_IMPORTED_MODULE_5__Modal_less___default.a.ModalFullWidth] = fullWidth, _classnames)),
          style: {
            maxWidth: width
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_5__Modal_less___default.a.ModalClose] = true, _classnames2)),
            onClick: handleClose, __source: {
              fileName: _jsxFileName,
              lineNumber: 32
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["u" /* CrossIcon */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 37
            }
          })
        ),
        children
      )
    );
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Modal.displayName = "Modal";


/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);

var FocusTrap = __webpack_require__(1446);

var displace = __webpack_require__(1449);

var noScroll = __webpack_require__(614);

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getApplicationNode", function () {
      if (_this.props.getApplicationNode) return _this.props.getApplicationNode();
      return _this.props.applicationNode;
    });

    _defineProperty(_assertThisInitialized(_this), "checkUnderlayClick", function (event) {
      if (_this.dialogNode && _this.dialogNode.contains(event.target) || // If the click is on the scrollbar we don't want to close the modal.
      event.pageX > event.target.ownerDocument.documentElement.offsetWidth || event.pageY > event.target.ownerDocument.documentElement.offsetHeight) return;

      _this.exit(event);
    });

    _defineProperty(_assertThisInitialized(_this), "checkDocumentKeyDown", function (event) {
      if (_this.props.escapeExits && (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27)) {
        _this.exit(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "exit", function (event) {
      if (_this.props.onExit) {
        _this.props.onExit(event);
      }
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!this.props.titleText && !this.props.titleId) {
        throw new Error('react-aria-modal instances should have a `titleText` or `titleId`');
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onEnter) {
        this.props.onEnter();
      } // Timeout to ensure this happens *after* focus has moved


      var applicationNode = this.getApplicationNode();
      setTimeout(function () {
        if (applicationNode) {
          applicationNode.setAttribute('aria-hidden', 'true');
        }
      }, 0);

      if (this.props.escapeExits) {
        this.addKeyDownListener();
      }

      if (this.props.scrollDisabled) {
        noScroll.on();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.scrollDisabled && !this.props.scrollDisabled) {
        noScroll.off();
      } else if (!prevProps.scrollDisabled && this.props.scrollDisabled) {
        noScroll.on();
      }

      if (this.props.escapeExits && !prevProps.escapeExits) {
        this.addKeyDownListener();
      } else if (!this.props.escapeExits && prevProps.escapeExits) {
        this.removeKeyDownListener();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.scrollDisabled) {
        noScroll.off();
      }

      var applicationNode = this.getApplicationNode();

      if (applicationNode) {
        applicationNode.setAttribute('aria-hidden', 'false');
      }

      this.removeKeyDownListener();
    }
  }, {
    key: "addKeyDownListener",
    value: function addKeyDownListener() {
      var _this2 = this;

      setTimeout(function () {
        document.addEventListener('keydown', _this2.checkDocumentKeyDown);
      });
    }
  }, {
    key: "removeKeyDownListener",
    value: function removeKeyDownListener() {
      var _this3 = this;

      setTimeout(function () {
        document.removeEventListener('keydown', _this3.checkDocumentKeyDown);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var style = {};

      if (props.includeDefaultStyles) {
        style = {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1050,
          overflowX: 'hidden',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          textAlign: 'center'
        };

        if (props.underlayColor) {
          style.background = props.underlayColor;
        }

        if (props.underlayClickExits) {
          style.cursor = 'pointer';
        }
      }

      if (props.underlayStyle) {
        for (var key in props.underlayStyle) {
          if (!props.underlayStyle.hasOwnProperty(key)) continue;
          style[key] = props.underlayStyle[key];
        }
      }

      var underlayProps = {
        className: props.underlayClass,
        style: style
      };

      if (props.underlayClickExits) {
        underlayProps.onMouseDown = this.checkUnderlayClick;
      }

      for (var prop in this.props.underlayProps) {
        underlayProps[prop] = this.props.underlayProps[prop];
      }

      var verticalCenterStyle = {};

      if (props.includeDefaultStyles) {
        verticalCenterStyle = {
          display: 'inline-block',
          height: '100%',
          verticalAlign: 'middle'
        };
      }

      var verticalCenterHelperProps = {
        key: 'a',
        style: verticalCenterStyle
      };
      var dialogStyle = {};

      if (props.includeDefaultStyles) {
        dialogStyle = {
          display: 'inline-block',
          textAlign: 'left',
          top: 0,
          maxWidth: '100%',
          cursor: 'default',
          outline: props.focusDialog ? 0 : null
        };

        if (props.verticallyCenter) {
          dialogStyle.verticalAlign = 'middle';
          dialogStyle.top = 0;
        }
      }

      if (props.dialogStyle) {
        for (var _key2 in props.dialogStyle) {
          if (!props.dialogStyle.hasOwnProperty(_key2)) continue;
          dialogStyle[_key2] = props.dialogStyle[_key2];
        }
      }

      var dialogProps = {
        key: 'b',
        ref: function (el) {
          this.dialogNode = el;
        }.bind(this),
        role: props.alert ? 'alertdialog' : 'dialog',
        id: props.dialogId,
        className: props.dialogClass,
        style: dialogStyle
      };

      if (props.titleId) {
        dialogProps['aria-labelledby'] = props.titleId;
      } else if (props.titleText) {
        dialogProps['aria-label'] = props.titleText;
      }

      if (props.focusDialog) {
        dialogProps.tabIndex = '-1';
      } // Apply data- and aria- attributes passed as props


      for (var _key3 in props) {
        if (/^(data-|aria-)/.test(_key3)) {
          dialogProps[_key3] = props[_key3];
        }
      }

      var childrenArray = [React.createElement('div', dialogProps, props.children)];

      if (props.verticallyCenter) {
        childrenArray.unshift(React.createElement('div', verticalCenterHelperProps));
      }

      var focusTrapOptions = props.focusTrapOptions || {};

      if (props.focusDialog || props.initialFocus) {
        focusTrapOptions.initialFocus = props.focusDialog ? "#".concat(this.props.dialogId) : props.initialFocus;
      }

      focusTrapOptions.escapeDeactivates = props.escapeExits;
      return React.createElement(FocusTrap, {
        focusTrapOptions: focusTrapOptions,
        paused: props.focusTrapPaused
      }, React.createElement('div', underlayProps, childrenArray));
    }
  }]);

  return Modal;
}(React.Component);

_defineProperty(Modal, "defaultProps", {
  underlayProps: {},
  dialogId: 'react-aria-modal-dialog',
  underlayClickExits: true,
  escapeExits: true,
  underlayColor: 'rgba(0,0,0,0.5)',
  includeDefaultStyles: true,
  focusTrapPaused: false,
  scrollDisabled: true
});

var DisplacedModal = displace(Modal);

DisplacedModal.renderTo = function (input) {
  return displace(Modal, {
    renderTo: input
  });
};

module.exports = DisplacedModal;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(32);
var createFocusTrap = __webpack_require__(1447);

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap(props) {
    _classCallCheck(this, FocusTrap);

    var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));

    _this.setFocusTrapElement = function (element) {
      _this.focusTrapElement = element;
    };

    if (typeof document !== 'undefined') {
      _this.previouslyFocusedElement = document.activeElement;
    }
    return _this;
  }

  _createClass(FocusTrap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      var specifiedFocusTrapOptions = this.props.focusTrapOptions;
      var tailoredFocusTrapOptions = {
        returnFocusOnDeactivate: false
      };
      for (var optionName in specifiedFocusTrapOptions) {
        if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
        if (optionName === 'returnFocusOnDeactivate') continue;
        tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
      }

      var focusTrapElementDOMNode = ReactDOM.findDOMNode(this.focusTrapElement);

      this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNode, tailoredFocusTrapOptions);
      if (this.props.active) {
        this.focusTrap.activate();
      }
      if (this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.active && !this.props.active) {
        var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;

        var returnFocus = returnFocusOnDeactivate || false;
        var config = { returnFocus: returnFocus };
        this.focusTrap.deactivate(config);
      } else if (!prevProps.active && this.props.active) {
        this.focusTrap.activate();
      }

      if (prevProps.paused && !this.props.paused) {
        this.focusTrap.unpause();
      } else if (!prevProps.paused && this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.focusTrap.deactivate();
      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var child = React.Children.only(this.props.children);

      var composedRefCallback = function composedRefCallback(element) {
        _this2.setFocusTrapElement(element);
        if (typeof child.ref === 'function') {
          child.ref(element);
        }
      };

      var childWithRef = React.cloneElement(child, { ref: composedRefCallback });

      return childWithRef;
    }
  }]);

  return FocusTrap;
}(React.Component);

FocusTrap.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};

module.exports = FocusTrap;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

var tabbable = __webpack_require__(1448);
var xtend = __webpack_require__(576);

var activeFocusTraps = (function() {
  var trapQueue = [];
  return {
    activateTrap: function(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];
        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },

    deactivateTrap: function(trap) {
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
})();

function focusTrap(element, userOptions) {
  var doc = document;
  var container =
    typeof element === 'string' ? doc.querySelector(element) : element;

  var config = xtend(
    {
      returnFocusOnDeactivate: true,
      escapeDeactivates: true
    },
    userOptions
  );

  var state = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false
  };

  var trap = {
    activate: activate,
    deactivate: deactivate,
    pause: pause,
    unpause: unpause
  };

  return trap;

  function activate(activateOptions) {
    if (state.active) return;

    updateTabbableNodes();

    state.active = true;
    state.paused = false;
    state.nodeFocusedBeforeActivation = doc.activeElement;

    var onActivate =
      activateOptions && activateOptions.onActivate
        ? activateOptions.onActivate
        : config.onActivate;
    if (onActivate) {
      onActivate();
    }

    addListeners();
    return trap;
  }

  function deactivate(deactivateOptions) {
    if (!state.active) return;

    removeListeners();
    state.active = false;
    state.paused = false;

    activeFocusTraps.deactivateTrap(trap);

    var onDeactivate =
      deactivateOptions && deactivateOptions.onDeactivate !== undefined
        ? deactivateOptions.onDeactivate
        : config.onDeactivate;
    if (onDeactivate) {
      onDeactivate();
    }

    var returnFocus =
      deactivateOptions && deactivateOptions.returnFocus !== undefined
        ? deactivateOptions.returnFocus
        : config.returnFocusOnDeactivate;
    if (returnFocus) {
      delay(function() {
        tryFocus(state.nodeFocusedBeforeActivation);
      });
    }

    return trap;
  }

  function pause() {
    if (state.paused || !state.active) return;
    state.paused = true;
    removeListeners();
  }

  function unpause() {
    if (!state.paused || !state.active) return;
    state.paused = false;
    addListeners();
  }

  function addListeners() {
    if (!state.active) return;

    // There can be only one listening focus trap at a time
    activeFocusTraps.activateTrap(trap);

    updateTabbableNodes();

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    delay(function() {
      tryFocus(getInitialFocusNode());
    });
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, true);
    doc.addEventListener('touchstart', checkPointerDown, true);
    doc.addEventListener('click', checkClick, true);
    doc.addEventListener('keydown', checkKey, true);

    return trap;
  }

  function removeListeners() {
    if (!state.active) return;

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);

    return trap;
  }

  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error('`' + optionName + '` refers to no known node');
      }
    }
    if (typeof optionValue === 'function') {
      node = optionValue();
      if (!node) {
        throw new Error('`' + optionName + '` did not return a node');
      }
    }
    return node;
  }

  function getInitialFocusNode() {
    var node;
    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (container.contains(doc.activeElement)) {
      node = doc.activeElement;
    } else {
      node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error(
        "You can't have a focus-trap without at least one focusable element"
      );
    }

    return node;
  }

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  function checkPointerDown(e) {
    if (container.contains(e.target)) return;
    if (config.clickOutsideDeactivates) {
      deactivate({
        returnFocus: !tabbable.isFocusable(e.target)
      });
    } else {
      e.preventDefault();
    }
  }

  // In case focus escapes the trap for some strange reason, pull it back in.
  function checkFocusIn(e) {
    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (container.contains(e.target) || e.target instanceof Document) {
      return;
    }
    e.stopImmediatePropagation();
    tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
  }

  function checkKey(e) {
    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      e.preventDefault();
      deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  }

  // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  function checkTab(e) {
    updateTabbableNodes();
    if (e.shiftKey && e.target === state.firstTabbableNode) {
      e.preventDefault();
      tryFocus(state.lastTabbableNode);
      return;
    }
    if (!e.shiftKey && e.target === state.lastTabbableNode) {
      e.preventDefault();
      tryFocus(state.firstTabbableNode);
      return;
    }
  }

  function checkClick(e) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function updateTabbableNodes() {
    var tabbableNodes = tabbable(container);
    state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
    state.lastTabbableNode =
      tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
  }

  function tryFocus(node) {
    if (node === doc.activeElement) return;
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus();
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  }
}

function isSelectableInput(node) {
  return (
    node.tagName &&
    node.tagName.toLowerCase() === 'input' &&
    typeof node.select === 'function'
  );
}

function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}

function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
}

function delay(fn) {
  return setTimeout(fn, 0);
}

module.exports = focusTrap;


/***/ }),
/* 1448 */
/***/ (function(module, exports) {

var candidateSelectors = [
  'input',
  'select',
  'textarea',
  'a[href]',
  'button',
  '[tabindex]',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
];
var candidateSelector = candidateSelectors.join(',');

var matches = typeof Element === 'undefined'
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function tabbable(el, options) {
  options = options || {};

  var elementDocument = el.ownerDocument || el;
  var regularTabbables = [];
  var orderedTabbables = [];

  var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
  var candidates = el.querySelectorAll(candidateSelector);

  if (options.includeContainer) {
    if (matches.call(el, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var i, candidate, candidateTabindex;
  for (i = 0; i < candidates.length; i++) {
    candidate = candidates[i];

    if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;

    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(sortOrderedTabbables)
    .map(function(a) { return a.node })
    .concat(regularTabbables);

  return tabbableNodes;
}

tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;

function isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
  if (
    !isNodeMatchingSelectorFocusable(node, untouchabilityChecker)
    || isNonTabbableRadio(node)
    || getTabindex(node) < 0
  ) {
    return false;
  }
  return true;
}

function isTabbable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
}

function isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
  untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node.ownerDocument || node);
  if (
    node.disabled
    || isHiddenInput(node)
    || untouchabilityChecker.isUntouchable(node)
  ) {
    return false;
  }
  return true;
}

var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
}

function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) return 0;
  return node.tabIndex;
}

function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}

// Array.prototype.find not available in IE.
function find(list, predicate) {
  for (var i = 0, length = list.length; i < length; i++) {
    if (predicate(list[i])) return list[i];
  }
}

function isContentEditable(node) {
  return node.contentEditable === 'true';
}

function isInput(node) {
  return node.tagName === 'INPUT';
}

function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}

function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}

function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}

function getCheckedRadio(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}

function isTabbableRadio(node) {
  if (!node.name) return true;
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}

// An element is "untouchable" if *it or one of its ancestors* has
// `visibility: hidden` or `display: none`.
function UntouchabilityChecker(elementDocument) {
  this.doc = elementDocument;
  // Node cache must be refreshed on every check, in case
  // the content of the element has changed. The cache contains tuples
  // mapping nodes to their boolean result.
  this.cache = [];
}

// getComputedStyle accurately reflects `visibility: hidden` of ancestors
// but not `display: none`, so we need to recursively check parents.
UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
  if (node.nodeType !== Node.ELEMENT_NODE) return false;

    // Search for a cached result.
    var cached = find(this.cache, function(item) {
      return item === node;
    });
    if (cached) return cached[1];

    nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);

    var result = false;

    if (nodeComputedStyle.display === 'none') {
      result = true;
    } else if (node.parentNode) {
      result = this.hasDisplayNone(node.parentNode);
    }

    this.cache.push([node, result]);

    return result;
}

UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
  if (node === this.doc.documentElement) return false;
  var computedStyle = this.doc.defaultView.getComputedStyle(node);
  if (this.hasDisplayNone(node, computedStyle)) return true;
  return computedStyle.visibility === 'hidden';
}

module.exports = tabbable;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(32);

// React 16+ supports Portals.
var canUsePortals = !!ReactDOM.createPortal;

function displace(WrappedComponent, options) {
  if (!global.document) {
    return function (_React$Component) {
      _inherits(EmptyDisplace, _React$Component);

      function EmptyDisplace() {
        _classCallCheck(this, EmptyDisplace);

        return _possibleConstructorReturn(this, (EmptyDisplace.__proto__ || Object.getPrototypeOf(EmptyDisplace)).apply(this, arguments));
      }

      _createClass(EmptyDisplace, [{
        key: 'render',
        value: function render() {
          return false;
        }
      }]);

      return EmptyDisplace;
    }(React.Component);
  }

  options = options || {};

  var Displaced = function (_React$Component2) {
    _inherits(Displaced, _React$Component2);

    function Displaced() {
      var _ref;

      var _temp, _this2, _ret;

      _classCallCheck(this, Displaced);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Displaced.__proto__ || Object.getPrototypeOf(Displaced)).call.apply(_ref, [this].concat(args))), _this2), _this2.renderDisplaced = function () {
        ReactDOM.unstable_renderSubtreeIntoContainer(_this2, React.createElement(WrappedComponent, _this2.props, _this2.props.children), _this2.container);
      }, _this2.removeDisplaced = function () {
        ReactDOM.unmountComponentAtNode(_this2.container);
      }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(Displaced, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.container = function () {
          if (!options.renderTo) {
            var result = document.createElement('div');
            document.body.appendChild(result);
            return result;
          } else if (typeof options.renderTo === 'string') {
            return document.querySelector(options.renderTo);
          } else {
            return options.renderTo;
          }
        }();
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (canUsePortals) return;
        if (this.props.mounted) {
          this.renderDisplaced();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (canUsePortals) return;
        if (prevProps.mounted && !this.props.mounted) {
          ReactDOM.unmountComponentAtNode(this.container);
        } else if (this.props.mounted) {
          this.renderDisplaced();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!canUsePortals) {
          ReactDOM.unmountComponentAtNode(this.container);
        }
        if (!options.renderTo) {
          this.container.parentNode.removeChild(this.container);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        if (!canUsePortals || this.props.mounted === false) {
          return null;
        }
        return ReactDOM.createPortal(React.createElement(WrappedComponent, this.props, this.props.children), this.container);
      }
    }]);

    return Displaced;
  }(React.Component);

  Displaced.defaultProps = {
    mounted: true
  };
  Displaced.WrappedComponent = WrappedComponent;


  return Displaced;
}

module.exports = displace;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal___2x1UP","ModalFullWidth":"Modal__ModalFullWidth___3nkew","ModalClose":"Modal__ModalClose___1-eKq"};

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\MuteIcon.jsx";


var MuteIcon = function MuteIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 48.4 43", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "M9.2 32.6L0 31.2v-20l9.3-.9L21.6 0v43L9.2 32.6zm2-4.4l5.7 4.8V10l-5.7 4.8-6.5.6v11.8l6.5 1zM46.3 32.4l-8.1-8.1-8.2 8.1-2.1-2.1 8.1-8.1-8.1-8.2 2.1-2.1 8.1 8.1 8.1-8.1 2.1 2.1-8.1 8.1 8.1 8.1-2 2.2z",
      fill: "currentColor",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

MuteIcon.displayName = "MuteIcon";
MuteIcon.displayName = "MuteIcon";
/* harmony default export */ __webpack_exports__["a"] = (MuteIcon);

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\P.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var P = function (_React$PureComponent) {
  _inherits(P, _React$PureComponent);

  function P() {
    _classCallCheck(this, P);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  P.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        white = _props.white,
        _props$withoutMargin = _props.withoutMargin,
        withoutMargin = _props$withoutMargin === undefined ? false : _props$withoutMargin;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.P] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.white] = white, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.withoutMargin] = withoutMargin, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    );
  };

  return P;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

P.displayName = "P";


/* harmony default export */ __webpack_exports__["a"] = (P);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\PhoneIcon.jsx";


var PhoneIcon = function PhoneIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 20 20", fill: "currentColor", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M1.4 14.7c-.3-.9 0-1.5.9-1.9.6-.3 1.5-.7 2.2-1 .5-.2 1-.5 1.4-.6.2-.1.4-.2.7-.2.5 0 .9.4 1 .5l.9.9c.5-.3 1.4-.9 2.2-1.7s1.4-1.7 1.7-2.2l-.9-.9c-.7-.6-.6-1.2-.3-1.8.2-.4.4-.8.6-1.4.3-.7.7-1.6 1-2.2.1-.3.4-1 1.2-1 .2 0 .4.1.6.1 2 .6 4 2.1 4 4.2 0 2-1.6 5.7-4.6 8.6-3 3-6.6 4.6-8.6 4.6-1.9.1-3.5-2-4-4zm1.5-.4c.4 1.4 1.5 2.9 2.6 2.9 1.4 0 4.7-1.3 7.6-4.1 2.8-2.8 4.1-6.1 4.1-7.6 0-1.1-1.5-2.2-2.9-2.6-.3.6-.7 1.5-1 2.2-.2.5-.5 1-.6 1.3v.1l1.7 1.7-.2.5c0 .1-.8 1.6-2.3 3.1-1.5 1.5-3 2.2-3.1 2.3l-.5.2-1.7-1.7h-.1c-.3.2-.8.4-1.3.6-.9.4-1.7.8-2.3 1.1z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

PhoneIcon.displayName = "PhoneIcon";
PhoneIcon.displayName = "PhoneIcon";
/* harmony default export */ __webpack_exports__["a"] = (PhoneIcon);

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\PlusCircleIcon.jsx";


var PlusCircleIcon = function PlusCircleIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 20 20", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", strokeWidth: "1.75", __source: {
          fileName: _jsxFileName,
          lineNumber: 5
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "10", cy: "10", r: "9.125", stroke: "currentColor", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { stroke: "currentColor", __source: {
            fileName: _jsxFileName,
            lineNumber: 7
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m10 6v8", __source: {
            fileName: _jsxFileName,
            lineNumber: 8
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m6 10h8.0622577", __source: {
            fileName: _jsxFileName,
            lineNumber: 9
          }
        })
      )
    )
  );
};

PlusCircleIcon.displayName = "PlusCircleIcon";
PlusCircleIcon.displayName = "PlusCircleIcon";
/* harmony default export */ __webpack_exports__["a"] = (PlusCircleIcon);

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\PlusIcon.jsx";


var PlusIcon = function PlusIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 31 31", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "currentColor", strokeWidth: "1.8px", __source: {
          fileName: _jsxFileName,
          lineNumber: 5
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m 15.5 0 v 31", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m 0 15.5 h 31", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      })
    )
  );
};

PlusIcon.displayName = "PlusIcon";
PlusIcon.displayName = "PlusIcon";
/* unused harmony default export */ var _unused_webpack_default_export = (PlusIcon);

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\RemoveCircleIcon.jsx";


var RemoveCircleIcon = function RemoveCircleIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 20 20", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 5
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { fill: "currentColor", cx: "10", cy: "10", r: "10", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M13.536 6.464l-7.072 7.072M6.464 6.464l7.072 7.072",
        stroke: "#FFF",
        strokeWidth: "2",
        strokeLinecap: "round", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      })
    )
  );
};

RemoveCircleIcon.displayName = "RemoveCircleIcon";
RemoveCircleIcon.displayName = "RemoveCircleIcon";
/* harmony default export */ __webpack_exports__["a"] = (RemoveCircleIcon);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\RestartIcon.jsx";


var RestartIcon = function RestartIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 22 22", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "currentColor", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 5
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m11.219 2c1.0352 0 2.0247 0.20182 2.9688 0.60547s1.7594 0.94889 2.4463 1.6357c0.68685 0.68685 1.2321 1.5023 1.6357 2.4463 0.40365 0.94402 0.60547 1.9336 0.60547 2.9688 0 1.0352-0.20182 2.0247-0.60547 2.9688-0.40365 0.94402-0.94889 1.7594-1.6357 2.4463s-1.5023 1.2321-2.4463 1.6357c-0.94402 0.40365-1.9336 0.60547-2.9688 0.60547-1.2956 0-2.5032-0.30273-3.623-0.9082-1.1198-0.60547-2.0329-1.4339-2.7393-2.4854-0.70638-1.0514-1.1247-2.2119-1.2549-3.4814h1.582c0.19531 1.5039 0.86588 2.7653 2.0117 3.7842s2.487 1.5283 4.0234 1.5283c0.82683 0 1.6162-0.16113 2.3682-0.4834 0.75196-0.32227 1.3997-0.75521 1.9434-1.2988s0.97656-1.1914 1.2988-1.9434c0.32227-0.75196 0.4834-1.5413 0.4834-2.3682 0-0.82683-0.16113-1.6162-0.4834-2.3682-0.32227-0.75196-0.75521-1.3997-1.2988-1.9434s-1.1914-0.97656-1.9434-1.2988c-0.75196-0.32227-1.5413-0.4834-2.3682-0.4834-0.86589 0-1.6634 0.16276-2.3926 0.48828-0.72917 0.32552-1.4453 0.83659-2.1484 1.5332-0.65104 0.66407-1.3249 1.3444-2.0215 2.041h2.9688v1.5625h-5.625v-5.625h1.5625v2.9492c0.22136-0.22136 0.56803-0.57129 1.04-1.0498s0.7959-0.80566 0.97168-0.98145c0.85287-0.84636 1.7383-1.4714 2.6562-1.875s1.9141-0.60547 2.9883-0.60547z", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      })
    )
  );
};

RestartIcon.displayName = "RestartIcon";
RestartIcon.displayName = "RestartIcon";
/* harmony default export */ __webpack_exports__["a"] = (RestartIcon);

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\SaveIcon.jsx";


var SaveIcon = function SaveIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 22 22", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 5
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon", { points: "6 4 6 16.498 10.39 12.653 14.781 16.498 14.781 4", stroke: "#979797", strokeWidth: "1.5", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      })
    )
  );
};

SaveIcon.displayName = "SaveIcon";
SaveIcon.displayName = "SaveIcon";
/* harmony default export */ __webpack_exports__["a"] = (SaveIcon);

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\SearchIcon.jsx";


var SearchIcon = function SearchIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 20 20", fill: "#999999", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M19.9 18.9l-5.3-5.3c1.2-1.4 2-3.3 2-5.3 0-4.6-3.7-8.3-8.3-8.3S0 3.7 0 8.3s3.7 8.3 8.3 8.3c2 0 3.9-.7 5.3-2l5.3 5.3c.2.2.5.2.7 0l.3-.3c.1-.2.1-.5 0-.7zM1.4 8.3c0-3.8 3.1-6.9 6.9-6.9s6.9 3.1 6.9 6.9-3.1 6.9-6.9 6.9-6.9-3.1-6.9-6.9z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

SearchIcon.displayName = "SearchIcon";
SearchIcon.displayName = "SearchIcon";
/* harmony default export */ __webpack_exports__["a"] = (SearchIcon);

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ShareIcon.jsx";


var ShareIcon = function ShareIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 22 22", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 5
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(12.611 12.111) rotate(-30) translate(-9.5 -9.5)", strokeWidth: "1.2782", __source: {
            fileName: _jsxFileName,
            lineNumber: 6
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(8.6627 12.178) rotate(60) translate(-5.5 -3.5)", __source: {
              fileName: _jsxFileName,
              lineNumber: 7
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { cx: "7.2795", cy: "3.35", rx: "2.6404", ry: "2.7109", stroke: "#999", __source: {
              fileName: _jsxFileName,
              lineNumber: 8
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m0.47341 3.3851h3.7873", stroke: "#979797", strokeLinecap: "square", __source: {
              fileName: _jsxFileName,
              lineNumber: 9
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(9.6288 4.0025) translate(-9 -4)", __source: {
              fileName: _jsxFileName,
              lineNumber: 11
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "14.35", cy: "4.35", r: "2.7109", stroke: "#999", __source: {
              fileName: _jsxFileName,
              lineNumber: 12
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m7.4734 4.3851h3.7873", stroke: "#979797", strokeLinecap: "square", __source: {
              fileName: _jsxFileName,
              lineNumber: 13
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { transform: "translate(3.7212 4.3475) translate(-3.7212 -4.3475)", cx: "3.7212", cy: "4.3475", r: "2.7109", stroke: "#999", __source: {
              fileName: _jsxFileName,
              lineNumber: 14
            }
          })
        )
      )
    )
  );
};

ShareIcon.displayName = "ShareIcon";
ShareIcon.displayName = "ShareIcon";
/* harmony default export */ __webpack_exports__["a"] = (ShareIcon);

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ShowIcon.jsx";


var ShowIcon = function ShowIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 22 22", fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10.75,4 C11.5052121,4 12.2636681,4.11230356 13.0253906,4.33691406 C13.7871132,4.56152456 14.4820932,4.85611797 15.1103516,5.22070312 C15.7386099,5.58528828 16.3294243,6.00195078 16.8828125,6.47070312 C17.4362007,6.93945547 17.9016908,7.41633872 18.2792969,7.90136719 C18.6569029,8.38639565 18.9547515,8.86165132 19.1728516,9.32714844 C19.3909516,9.79264556 19.5,10.2044253 19.5,10.5625 C19.5,10.9205747 19.3909516,11.3323544 19.1728516,11.7978516 C18.9547515,12.2633487 18.6569029,12.7386043 18.2792969,13.2236328 C17.9016908,13.7086613 17.4362007,14.1855445 16.8828125,14.6542969 C16.3294243,15.1230492 15.7386099,15.5397117 15.1103516,15.9042969 C14.4820932,16.268882 13.7871132,16.5634754 13.0253906,16.7880859 C12.2636681,17.0126964 11.5052121,17.125 10.75,17.125 C9.99478789,17.125 9.23633193,17.0126964 8.47460938,16.7880859 C7.71288682,16.5634754 7.01790679,16.268882 6.38964844,15.9042969 C5.76139009,15.5397117 5.17057568,15.1230492 4.6171875,14.6542969 C4.06379932,14.1855445 3.59830918,13.7086613 3.22070312,13.2236328 C2.84309707,12.7386043 2.54524849,12.2633487 2.32714844,11.7978516 C2.10904839,11.3323544 2,10.9205747 2,10.5625 C2,10.2044253 2.10904839,9.79264556 2.32714844,9.32714844 C2.54524849,8.86165132 2.84309707,8.38639565 3.22070312,7.90136719 C3.59830918,7.41633872 4.06379932,6.93945547 4.6171875,6.47070312 C5.17057568,6.00195078 5.76139009,5.58528828 6.38964844,5.22070312 C7.01790679,4.85611797 7.71288682,4.56152456 8.47460938,4.33691406 C9.23633193,4.11230356 9.99478789,4 10.75,4 Z M10.75,15.5625 C11.3945345,15.5625 12.0390593,15.4632171 12.6835938,15.2646484 C13.3281282,15.0660797 13.9059219,14.8089208 14.4169922,14.4931641 C14.9280625,14.1774073 15.4082009,13.8274759 15.8574219,13.4433594 C16.3066429,13.0592429 16.6809881,12.6816425 16.9804688,12.3105469 C17.2799494,11.9394513 17.5143221,11.5992854 17.6835938,11.2900391 C17.8528654,10.9807927 17.9375,10.7382821 17.9375,10.5625 C17.9375,10.3867179 17.8528654,10.1442073 17.6835938,9.83496094 C17.5143221,9.5257146 17.2799494,9.18554873 16.9804688,8.81445312 C16.6809881,8.44335752 16.3066429,8.06575713 15.8574219,7.68164062 C15.4082009,7.29752412 14.9280625,6.94759272 14.4169922,6.63183594 C13.9059219,6.31607915 13.3281282,6.05892026 12.6835938,5.86035156 C12.0390593,5.66178286 11.3945345,5.5625 10.75,5.5625 C10.1054655,5.5625 9.46094072,5.66178286 8.81640625,5.86035156 C8.17187178,6.05892026 7.59407808,6.31607915 7.08300781,6.63183594 C6.57193755,6.94759272 6.09179912,7.29752412 5.64257812,7.68164062 C5.19335713,8.06575713 4.81901191,8.44335752 4.51953125,8.81445312 C4.22005059,9.18554873 3.98567793,9.5257146 3.81640625,9.83496094 C3.64713457,10.1442073 3.5625,10.3867179 3.5625,10.5625 C3.5625,10.7382821 3.64713457,10.9807927 3.81640625,11.2900391 C3.98567793,11.5992854 4.22005059,11.9394513 4.51953125,12.3105469 C4.81901191,12.6816425 5.19335713,13.0592429 5.64257812,13.4433594 C6.09179912,13.8274759 6.57193755,14.1774073 7.08300781,14.4931641 C7.59407808,14.8089208 8.17187178,15.0660797 8.81640625,15.2646484 C9.46094072,15.4632171 10.1054655,15.5625 10.75,15.5625 Z M12.703125,9.5859375 L14.0996094,8.8828125 C14.3665378,9.41666934 14.5,9.97655957 14.5,10.5625 C14.5,11.5976614 14.1337927,12.4814417 13.4013672,13.2138672 C12.6689417,13.9462927 11.7851614,14.3125 10.75,14.3125 C9.71483857,14.3125 8.83105835,13.9462927 8.09863281,13.2138672 C7.36620728,12.4814417 7,11.5976614 7,10.5625 C7,9.52733857 7.36620728,8.64355835 8.09863281,7.91113281 C8.83105835,7.17870728 9.71483857,6.8125 10.75,6.8125 L10.75,8.375 C10.1510387,8.375 9.6367209,8.5898416 9.20703125,9.01953125 C8.7773416,9.4492209 8.5625,9.96353867 8.5625,10.5625 C8.5625,11.1614613 8.7773416,11.6757791 9.20703125,12.1054688 C9.6367209,12.5351584 10.1510387,12.75 10.75,12.75 C11.3489613,12.75 11.8632791,12.5351584 12.2929688,12.1054688 C12.7226584,11.6757791 12.9375,11.1614613 12.9375,10.5625 C12.9375,10.2239566 12.8593758,9.89843906 12.703125,9.5859375 Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

ShowIcon.displayName = "ShowIcon";
ShowIcon.displayName = "ShowIcon";
/* harmony default export */ __webpack_exports__["a"] = (ShowIcon);

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ServiceIcon.jsx";


var ServiceIcon = function ServiceIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 29 25", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", transform: "translate(-20.000000, -81.000000)", __source: {
          fileName: _jsxFileName,
          lineNumber: 5
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M20.3062677,88.6560499 C20.4290654,88.2050252 20.756526,87.8770072 21.1658517,87.7540005 C21.61611,87.6309938 22.0663683,87.7540005 22.3938289,88.0820185 L26.0777602,91.7722206 C26.4052208,92.1002386 26.8964117,92.3052498 27.3876025,92.3052498 C27.3876025,92.3052498 27.3876025,92.3052498 27.3876025,92.3052498 C27.8787934,92.3052498 28.3699842,92.1002386 28.6974448,91.7722206 L30.3756802,90.0911285 C31.1124665,89.3530881 31.1124665,88.164023 30.3756802,87.4669848 L26.487086,83.5717714 C26.1596254,83.2437534 26.0368277,82.833731 26.1596254,82.3827063 C26.2824231,81.9726838 26.5689511,81.6036636 26.9782768,81.4806569 C30.5803431,80.332594 34.4689373,81.2756456 37.1295544,83.9407916 C39.2989807,86.1139107 40.3222949,89.1070746 39.9948344,92.1412408 C39.8311041,93.4533127 40.2813624,94.7243823 41.1818789,95.6264318 L49,103.457861 L47.6492252,104.810935 L39.8311041,96.9795059 C38.5212618,95.667434 37.8663407,93.8223329 38.1119361,91.9362296 C38.3984641,89.4760948 37.5388801,87.0569623 35.7787796,85.2938657 C33.8958813,83.4077624 31.2352642,82.5877175 28.6565122,83.0387422 L31.6855225,86.0729084 C33.159095,87.5489893 33.159095,89.9271196 31.6855225,91.4032004 L30.0072871,93.0842925 C29.3114334,93.7813307 28.3699842,94.1913531 27.3466699,94.1913531 C26.3233557,94.1913531 25.3819065,93.8223329 24.6860528,93.0842925 L21.902638,90.2961398 C21.6570426,92.7152723 22.5166266,95.0524003 24.2357946,96.8154969 C25.8730974,98.4555867 28.1653214,99.3166339 30.4984779,99.1526249 C32.299511,99.0296182 34.018679,99.6856541 35.2466561,100.915721 L38.9715201,104.646926 L37.6207453,106 L33.8958813,102.268796 C33.0772299,101.448751 31.8492528,100.997726 30.6212756,101.07973 C27.7150631,101.284742 24.8907157,100.218683 22.8440871,98.168571 C20.4290654,95.7084362 19.4466837,92.0592363 20.3062677,88.6560499 Z", fill: "#979797", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      })
    )
  );
};

ServiceIcon.displayName = "ServiceIcon";
ServiceIcon.displayName = "ServiceIcon";
/* harmony default export */ __webpack_exports__["a"] = (ServiceIcon);

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SlugIcon_less__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SlugIcon_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SlugIcon_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArrowDownIcon__ = __webpack_require__(412);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\SlugIcon\\SlugIcon.jsx";





var SlugIcon = function SlugIcon(_ref) {
  var _classnames;

  var style = _ref.style;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__SlugIcon_less___default.a.SlugIcon] = true, _classnames)),
      style: style,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ArrowDownIcon__["a" /* default */], {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    })
  );
};

SlugIcon.displayName = "SlugIcon";
SlugIcon.displayName = "SlugIcon";
/* harmony default export */ __webpack_exports__["a"] = (SlugIcon);

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SlugIcon":"SlugIcon__SlugIcon___NGe1x"};

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Typography_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Typography\\Space.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Space = function (_React$PureComponent) {
  _inherits(Space, _React$PureComponent);

  function Space() {
    _classCallCheck(this, Space);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Space.prototype.render = function render() {
    var _classnames;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Typography_less___default.a.Space] = true, _classnames)), __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    });
  };

  return Space;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Space.displayName = "Space";


/* harmony default export */ __webpack_exports__["a"] = (Space);

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\StarIcon.jsx";


var StarIcon = function StarIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 31 31", fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M0 14.355l2.246-6.933c5.176 1.823 8.936 3.402 11.28 4.736-.62-5.892-.945-9.944-.977-12.158h7.08c-.098 3.223-.472 7.26-1.123 12.11 3.353-1.693 7.194-3.256 11.523-4.688l2.246 6.933c-4.134 1.368-8.186 2.28-12.158 2.735 1.986 1.725 4.785 4.801 8.399 9.228l-5.86 4.15c-1.888-2.57-4.118-6.07-6.69-10.497-2.408 4.59-4.524 8.089-6.347 10.498l-5.762-4.15c3.776-4.656 6.478-7.732 8.106-9.23-4.2-.813-8.187-1.724-11.963-2.734", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

StarIcon.displayName = "StarIcon";
StarIcon.displayName = "StarIcon";
/* harmony default export */ __webpack_exports__["a"] = (StarIcon);

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tag_less__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tag_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tag_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_CheckIcon__ = __webpack_require__(142);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Tag\\Tag.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Tag = function (_React$PureComponent) {
  _inherits(Tag, _React$PureComponent);

  function Tag() {
    _classCallCheck(this, Tag);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Tag.prototype.render = function render() {
    var _classnames;

    var _props = this.props,
        children = _props.children,
        _props$color = _props.color,
        color = _props$color === undefined ? "green" : _props$color,
        _props$checked = _props.checked,
        checked = _props$checked === undefined ? false : _props$checked;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__Tag_less___default.a.Tag] = true, _classnames[__WEBPACK_IMPORTED_MODULE_2__Tag_less___default.a.TagGreen] = color === "green", _classnames[__WEBPACK_IMPORTED_MODULE_2__Tag_less___default.a.TagRed] = color === "red", _classnames[__WEBPACK_IMPORTED_MODULE_2__Tag_less___default.a.TagOrange] = color === "orange", _classnames[__WEBPACK_IMPORTED_MODULE_2__Tag_less___default.a.TagBlue] = color === "blue", _classnames[__WEBPACK_IMPORTED_MODULE_2__Tag_less___default.a.TagGrey] = color === "grey", _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      },
      checked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icons_CheckIcon__["a" /* default */], { style: {
          width: "10px",
          height: "9px",
          paddingRight: ".5em"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      }),
      children
    );
  };

  return Tag;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Tag.displayName = "Tag";


/* harmony default export */ __webpack_exports__["a"] = (Tag);

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Tag":"Tag__Tag___3Pdr2","TagGreen":"Tag__TagGreen___3QIJP","TagRed":"Tag__TagRed___3G6lm","TagOrange":"Tag__TagOrange___3IwI8","TagBlue":"Tag__TagBlue___U8pIe","TagGrey":"Tag__TagGrey___37SYf"};

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\TickModalIcon.jsx";


var TickModalIcon = function TickModalIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 35 35", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 5
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { fill: "#7DBE37", cx: "17.5", cy: "17.5", r: "17.5", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M15.034 22.85l-5.33-3.88L8 21.036 15.48 27 25 11.39 22.79 10z", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      })
    )
  );
};

TickModalIcon.displayName = "TickModalIcon";
TickModalIcon.displayName = "TickModalIcon";
/* harmony default export */ __webpack_exports__["a"] = (TickModalIcon);

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToastPopup_less__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToastPopup_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ToastPopup_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_CrossIcon__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonIcon_ButtonIcon__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Visible_Visible__ = __webpack_require__(615);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\ToastPopup\\ToastPopup.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ToastPopup = function (_React$PureComponent) {
  _inherits(ToastPopup, _React$PureComponent);

  function ToastPopup(props) {
    _classCallCheck(this, ToastPopup);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._handleClose = function () {
      var _this$props$onClose = _this.props.onClose,
          onClose = _this$props$onClose === undefined ? function () {} : _this$props$onClose;

      _this.toast && _this.toast.classList.remove(__WEBPACK_IMPORTED_MODULE_2__ToastPopup_less___default.a.ToastPopupVisible);

      setTimeout(function () {
        onClose();
      }, 1000);
    };

    return _this;
  }

  ToastPopup.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      // if there is any other ToastPopup, first close that one
      // We can only have on ToastPopup
      // Passing uniqueID is mandatory because we need to know is it a new one or not

      if (__WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].ToastPopupSingleton && __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].ToastPopupSingleton !== _this2 && __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].ToastPopupSingleton.props.uniqueID !== _this2.props.uniqueID) {
        __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].ToastPopupSingleton.toast && __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].ToastPopupSingleton.toast.classList.remove(__WEBPACK_IMPORTED_MODULE_2__ToastPopup_less___default.a.ToastPopupVisible);
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].ToastPopupSingleton.props.onClose && __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].ToastPopupSingleton.props.onClose();
          __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].ToastPopupSingleton = _this2;
        }, 100);
      } else {
        __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].ToastPopupSingleton = _this2;
      }

      _this2.toast && _this2.toast.classList.add(__WEBPACK_IMPORTED_MODULE_2__ToastPopup_less___default.a.ToastPopupVisible);
    }, 100);
  };

  ToastPopup.prototype.render = function render() {
    var _this3 = this,
        _classnames,
        _classnames2,
        _classnames3,
        _classnames4;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        ref: function ref(c) {
          return _this3.toast = c;
        },
        "data-test": "toast-popup",
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__ToastPopup_less___default.a.ToastPopup] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 44
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__ToastPopup_less___default.a.ToastPopupChildren] = true, _classnames2)), __source: {
            fileName: _jsxFileName,
            lineNumber: 50
          }
        },
        this.props.children
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 55
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ButtonIcon_ButtonIcon__["a" /* default */],
          { onClick: this._handleClose, styleName: "whiteColor", __source: {
              fileName: _jsxFileName,
              lineNumber: 56
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_2__ToastPopup_less___default.a.ToastPopupClose] = true, _classnames3)), __source: {
                fileName: _jsxFileName,
                lineNumber: 57
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icons_CrossIcon__["a" /* default */], { style: {
                width: "1.6em",
                height: "1.6em"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 60
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Visible_Visible__["a" /* default */],
              { visible: ["mobile"], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 64
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames4 = {}, _classnames4[__WEBPACK_IMPORTED_MODULE_2__ToastPopup_less___default.a.ToastPopupCloseText] = true, _classnames4)), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 65
                  }
                },
                "close"
              )
            )
          )
        )
      )
    );
  };

  return ToastPopup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

ToastPopup.displayName = "ToastPopup";


/* harmony default export */ __webpack_exports__["a"] = (ToastPopup);

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ToastPopup":"ToastPopup__ToastPopup___1sqVR","ToastPopupVisible":"ToastPopup__ToastPopupVisible___2X2pa","ToastPopupChildren":"ToastPopup__ToastPopupChildren___6vA7I","ToastPopupClose":"ToastPopup__ToastPopupClose___2LqEa","ToastPopupCloseText":"ToastPopup__ToastPopupCloseText___2tk8q"};

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Visible":"Visible__Visible___6lK8E","VisibleScreen":"Visible__VisibleScreen___6OCDR","VisibleTablet":"Visible__VisibleTablet___2X_kZ","VisibleMobile":"Visible__VisibleMobile___3SSPM"};

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\TorchIcon.jsx";




var TorchIcon = function TorchIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 452.96 454.1", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "currentColor", d: "M102.68 169.51a67.69 67.69 0 0 0 .53 8.35L180 101a69.88 69.88 0 0 0-8.36-.52 69.07 69.07 0 0 0-68.96 69.03z", transform: "translate(-58.14 -55.98)", __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M102.68 169.51a69.07 69.07 0 0 1 69-69 69.88 69.88 0 0 1 8.32.49l24.8-24.8A99 99 0 0 0 78.4 202.67l24.81-24.81a67.69 67.69 0 0 1-.53-8.35z", transform: "translate(-58.14 -55.98)", __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { className: "cls-1", transform: "rotate(-45 255.236 393.048)", d: "M300.06 237.3H403.7v227.11H300.06z", __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { className: "cls-1", d: "M201.27 85.91L85.68 201.5l66.86 31.7 79.63-79.63-30.9-67.66zM337.39 454.1l55.9-55.9-28.37 28.37-27.53 27.53z", __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { className: "cls-1", transform: "rotate(-45 75.03 211.702)", d: "M83.52 156.9h176.3v25.22H83.52z", __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M320.7 204.11l-44.16-96.68L225.09 56l-20.26 20.24L180 101l-76.82 76.82-24.78 24.85-20.26 20.26 51.37 51.37 95.54 45.3 13.6 13.6 21.14 21.14 155.74 155.74 27.53-27.53 28.37-28.37 30.29-30.28 29.38-29.39zm-220.28 18.82L225.09 98.26l17.83 17.83-124.66 124.67zm110.26 66.25l-66.86-31.7 115.59-115.59 30.9 67.66zM395.53 467.8L234.94 307.2l73.28-73.28 160.6 160.59z", transform: "translate(-58.14 -55.98)", __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    })
  );
};

TorchIcon.displayName = "TorchIcon";
TorchIcon.displayName = "TorchIcon";
/* unused harmony default export */ var _unused_webpack_default_export = (TorchIcon);

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\TwitterIcon.jsx";


var TwitterIcon = function TwitterIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 18 18", fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18,3.4c-0.7,0.3-1.4,0.5-2.1,0.6c0.8-0.5,1.3-1.2,1.6-2c-0.7,0.4-1.5,0.7-2.4,0.9c-1.4-1.5-3.8-1.5-5.2-0.1C9,3.7,8.6,5,8.9,6.2c-3-0.1-5.8-1.5-7.7-3.8c-1,1.7-0.5,3.8,1.2,4.9c-0.6,0-1.2-0.2-1.7-0.5l0,0c0,1.8,1.3,3.3,3,3.6c-0.5,0.2-1.1,0.3-1.7,0.2c0.5,1.5,1.9,2.5,3.4,2.6c-1.3,1-2.9,1.6-4.6,1.6c-0.2-0.1-0.5-0.1-0.8-0.1c1.7,1.1,3.7,1.7,5.7,1.7c5.8,0,10.5-4.6,10.5-10.4V5.9c0-0.2,0-0.3,0-0.5C16.9,4.8,17.5,4.2,18,3.4z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

TwitterIcon.displayName = "TwitterIcon";
TwitterIcon.displayName = "TwitterIcon";
/* harmony default export */ __webpack_exports__["a"] = (TwitterIcon);

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\UnMuteIcon.jsx";


var UnMuteIcon = function UnMuteIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 48.4 43", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "M9.3 10.3L21.6 0v43L9.2 32.7 0 31.3v-20l9.3-1zm1.9 4.6l-6.5.6v11.8l6.5 1 5.7 4.8v-23l-5.7 4.8zm22.4 6.9c0 5.2-1.4 10.1-3.9 14.3l-3.8-2.8c1.9-3.4 3-7.4 3-11.6 0-4.3-1.2-8.4-3.2-11.9l3.8-2.7c2.7 4.3 4.1 9.3 4.1 14.7zm8.5 0c0 7.1-2 13.6-5.4 19.3l-3.8-2.7c2.9-4.9 4.6-10.5 4.6-16.5 0-6.2-1.7-11.9-4.7-16.8l3.8-2.7c3.5 5.5 5.5 12.2 5.5 19.4z",
      fill: "currentColor",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    }),
    "/>"
  );
};

UnMuteIcon.displayName = "UnMuteIcon";
UnMuteIcon.displayName = "UnMuteIcon";
/* harmony default export */ __webpack_exports__["a"] = (UnMuteIcon);

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\WebsiteIcon.jsx";


var WebsiteIcon = function WebsiteIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 20 20", fill: "currentColor", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5-4.3-1-5.9-2.5-2.5-3.7-2.5-6 1-4.4 2.5-6 3.7-2.5 6-2.5c2.2 0 4.4.9 6 2.5s2.4 3.8 2.4 6zM3.3 9.1h2.8c0-1.8.4-3.5.9-4.8.1-.2.2-.3.2-.5-.8.3-1.4.8-2 1.4-1.1 1.1-1.7 2.5-1.9 3.9zm1.9 5.7c.6.6 1.3 1.1 2 1.4 0-.2-.1-.3-.2-.5-.5-1.3-.9-3-.9-4.8H3.3c.2 1.4.8 2.8 1.9 3.9zM10 3.2c-.3 0-.9.5-1.4 1.7-.4 1.2-.7 2.6-.8 4.2h4.4c-.1-1.6-.4-3.1-.8-4.2 0-.1-.1-.1-.1-.2.8.2 1.5.6 2.2 1.1.2 1 .4 2.1.5 3.3h2.8c-.2-1.5-.8-2.9-1.9-3.9-1.4-1.3-3.1-2-4.9-2zm1.4 11.9c.5-1.1.7-2.6.8-4.2H7.8c.1 1.6.4 3.1.8 4.2.5 1.3 1.1 1.7 1.4 1.7s.9-.5 1.4-1.7zm5.3-4.2h-2.8c-.1 1.8-.4 3.5-.9 4.8-.1.2-.2.4-.2.5.8-.3 1.4-.8 2-1.4 1.1-1.1 1.7-2.5 1.9-3.9z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

WebsiteIcon.displayName = "WebsiteIcon";
WebsiteIcon.displayName = "WebsiteIcon";
/* harmony default export */ __webpack_exports__["a"] = (WebsiteIcon);

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\YoutubeIcon.jsx";


var YoutubeIcon = function YoutubeIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 18 18", fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 4
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18,9c0,1.6,0,2.6-0.1,3.2c0,0.7-0.2,1.3-0.5,1.9c-0.3,0.5-0.8,0.9-1.4,1c-0.9,0.2-1.8,0.4-2.7,0.4c-0.8,0-2.2,0-4.4,0s-3.6,0-4.4-0.1c-0.9,0-1.8-0.1-2.7-0.4c-0.6-0.1-1.1-0.5-1.4-1c-0.1-0.5-0.3-1.2-0.3-1.8C0,11.6,0,10.6,0,9s0-2.6,0.1-3.2c0-0.7,0.2-1.3,0.5-1.9C0.9,3.4,1.4,3,2,2.9c0.8-0.2,1.7-0.4,2.6-0.4c0.8,0,2.2,0,4.4,0s3.6,0,4.4,0c0.9,0,1.8,0.1,2.7,0.4c0.6,0.1,1.1,0.5,1.4,1C17.8,4.5,18,5.2,18,5.8S18,7.4,18,9z M12.6,9L6.9,5.5v6.9L12.6,9z", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    })
  );
};

YoutubeIcon.displayName = "YoutubeIcon";
YoutubeIcon.displayName = "YoutubeIcon";
/* harmony default export */ __webpack_exports__["a"] = (YoutubeIcon);

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__YoutubePlayer_less__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__YoutubePlayer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__YoutubePlayer_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\YoutubePlayer\\YoutubePlayer.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var YoutubePlayer = function (_React$PureComponent) {
  _inherits(YoutubePlayer, _React$PureComponent);

  function YoutubePlayer() {
    _classCallCheck(this, YoutubePlayer);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  YoutubePlayer.prototype.render = function render() {
    var _classnames, _classnames2;

    var _props = this.props,
        youtubeId = _props.youtubeId,
        _props$autoPlay = _props.autoPlay,
        autoPlay = _props$autoPlay === undefined ? false : _props$autoPlay,
        youtubeLink = _props.youtubeLink;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_2__YoutubePlayer_less___default.a.YoutubePlayer] = true, _classnames)), __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      },
      (youtubeId || youtubeLink) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_2__YoutubePlayer_less___default.a.YoutubePlayerIframe] = true, _classnames2)),
        title: "YoutubePlayer",
        src: youtubeLink || "https://www.youtube.com/embed/" + youtubeId + "?autoplay=" + (autoPlay ? 1 : 0) + "&rel=0",
        allowFullScreen: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      }),
      !youtubeId && !youtubeLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        },
        "YoutubeId has not been provided"
      )
    );
  };

  return YoutubePlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

YoutubePlayer.displayName = "YoutubePlayer";


/* harmony default export */ __webpack_exports__["a"] = (YoutubePlayer);

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"YoutubePlayer":"YoutubePlayer__YoutubePlayer___11few","YoutubePlayerIframe":"YoutubePlayer__YoutubePlayerIframe___1_pDN"};

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\AtomicComponents\\Icons\\ZoomZoomIcon.jsx";




var ZoomZoomIcon = function ZoomZoomIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 100 9", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#fff", d: "M110.27,10.69V11l-5.6,7.55v.07c4.24,0,5.15,0,6.2-.19H111l-.54,1h-7.74V19l5.57-7.5v-.07h-5.09l.27-.77Z", transform: "translate(-102.67 -10.54)", __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#fff", d: "M122.53,15a4.45,4.45,0,0,1-4.69,4.5c-2.38,0-4.82-1.37-4.82-4.5a4.45,4.45,0,0,1,4.72-4.5C120.11,10.54,122.53,11.9,122.53,15Zm-1.48,0c0-2.15-1.36-3.74-3.32-3.74s-3.21,1.47-3.21,3.74,1.35,3.72,3.32,3.72S121.05,17.29,121.05,15Z", transform: "translate(-102.67 -10.54)", __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#fff", d: "M134.79,15a4.45,4.45,0,0,1-4.69,4.5c-2.39,0-4.82-1.37-4.82-4.5a4.45,4.45,0,0,1,4.71-4.5C132.36,10.54,134.79,11.9,134.79,15Zm-1.49,0c0-2.15-1.36-3.74-3.32-3.74s-3.2,1.47-3.2,3.74,1.34,3.72,3.32,3.72S133.3,17.29,133.3,15Z", transform: "translate(-102.67 -10.54)", __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#fff", d: "M143,17l3.23-6.3h1.25l1,8.69h-1.41l-.74-6.9h-.05l-3.36,6.38h-.46l-3.29-6.37h-.06l-.67,6.89h-.92l1-8.69h1.25L143,17Z", transform: "translate(-102.67 -10.54)", __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#fff", d: "M155,15.22h-3.8l.07-.82h3.79Z", transform: "translate(-102.67 -10.54)", __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#fff", d: "M164.45,10.69V11l-5.6,7.55v.07c4.24,0,5.15,0,6.2-.19h.08l-.54,1h-7.75V19l5.58-7.5v-.07h-5.09l.27-.77Z", transform: "translate(-102.67 -10.54)", __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#fff", d: "M176.71,15a4.45,4.45,0,0,1-4.69,4.5c-2.38,0-4.82-1.37-4.82-4.5a4.45,4.45,0,0,1,4.72-4.5C174.29,10.54,176.71,11.9,176.71,15Zm-1.49,0c0-2.15-1.35-3.74-3.32-3.74s-3.2,1.47-3.2,3.74,1.35,3.72,3.32,3.72S175.22,17.29,175.22,15Z", transform: "translate(-102.67 -10.54)", __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#fff", d: "M189,15a4.45,4.45,0,0,1-4.69,4.5c-2.38,0-4.82-1.37-4.82-4.5a4.45,4.45,0,0,1,4.72-4.5C186.54,10.54,189,11.9,189,15Zm-1.48,0c0-2.15-1.36-3.74-3.32-3.74S181,12.77,181,15s1.35,3.72,3.32,3.72S187.48,17.29,187.48,15Z", transform: "translate(-102.67 -10.54)", __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#fff", d: "M197.19,17l3.22-6.3h1.26l1,8.69h-1.41l-.74-6.9h-.05l-3.36,6.38h-.46l-3.3-6.37h0l-.67,6.89h-.92l1-8.69H194l3.19,6.3Z", transform: "translate(-102.67 -10.54)", __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    })
  );
};

ZoomZoomIcon.displayName = "ZoomZoomIcon";
ZoomZoomIcon.displayName = "ZoomZoomIcon";
/* harmony default export */ __webpack_exports__["a"] = (ZoomZoomIcon);

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\close-button\\index.jsx",
    _themeStyles;







var THEMES = { LIGHT: "light", DARK: "dark" };
var getBase = Object(__WEBPACK_IMPORTED_MODULE_4_utils__["q" /* get */])("base");
var getSvg = Object(__WEBPACK_IMPORTED_MODULE_4_utils__["q" /* get */])("svg");

var CloseButton = function CloseButton(_ref) {
  var onClick = _ref.onClick,
      style = _ref.style,
      dataTest = _ref.dataTest,
      styleName = _ref.styleName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    {
      style: [closeButtonStyles.base, getBase(themeStyles[styleName]), getBase(style) || style],
      onClick: onClick,
      "data-test": dataTest, __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["m" /* CrossIcon */], {
      style: _extends({}, closeButtonStyles.svg, getSvg(themeStyles[styleName]), getSvg(style)), __source: {
        fileName: _jsxFileName,
        lineNumber: 18
      }
    })
  );
};

CloseButton.displayName = "CloseButton";
CloseButton.displayName = "CloseButton";
CloseButton.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  styleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(THEMES).map(function (key) {
    return THEMES[key];
  })),
  dataTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool])
};

CloseButton.defaultProps = {
  onClick: __WEBPACK_IMPORTED_MODULE_4_utils__["C" /* noop */],
  style: {},
  styleName: THEMES.DARK,
  dataTest: false
};

CloseButton.THEMES = CloseButton.STYLE_NAMES = _extends({}, THEMES);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(CloseButton));

var themeStyles = (_themeStyles = {}, _themeStyles[THEMES.DARK] = {
  svg: {
    fill: "#101010"
  }
}, _themeStyles[THEMES.LIGHT] = {
  svg: {
    fill: "#fff"
  }
}, _themeStyles);

var closeButtonStyles = {
  base: {
    position: "absolute",
    width: "25px",
    height: "25px",
    right: "1.5em",
    top: "1.5em",
    cursor: "pointer",
    textDecoration: "none",
    border: 0,
    zIndex: 20
  },
  svg: {
    display: "block",
    width: "100%",
    height: "100%"
  }
};

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_radium__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_higher_order_components__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\color-selector\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ColorSelector = function (_Component) {
  _inherits(ColorSelector, _Component);

  function ColorSelector(props) {
    _classCallCheck(this, ColorSelector);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = function (index, option) {
      _this.setState({
        active: index
      }, function () {
        _this.props.onChange && _this.props.onChange(option, index);
      });
    };

    _this.handleMouseOver = function (index) {
      _this.setState({ hover: index });
    };

    _this.handleMouseOut = function () {
      _this.setState({ hover: -1 });
    };

    _this.state = {
      hover: -1,
      active: props.active || 0,
      uniqueID: Math.random()
    };
    return _this;
  }

  ColorSelector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      active: nextProps.active
    });
  };

  ColorSelector.prototype.render = function render() {
    var _this2 = this;

    var active = this.state.active;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { position: 'relative' }, 'data-test': this.props.dataTest, __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: [styles.base, this.props.compact && {
            overflowX: 'auto',
            overflowY: 'hidden'
          }, { padding: this.props.padding || '0px' }],
          'data-test': 'radio-group', __source: {
            fileName: _jsxFileName,
            lineNumber: 63
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            ref: function ref(c) {
              _this2.radioGroup = c;
            },
            style: [this.props.scrollEnable && styles.wrapper, styles.padding], __source: {
              fileName: _jsxFileName,
              lineNumber: 73
            }
          },
          this.props.options.map(function (option, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: styles.option, ref: index, key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 82
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                {
                  htmlFor: 'color-selector-input-' + index + '-' + _this2.state.uniqueID,
                  'data-test': 'radio-group-label',
                  'data-value': option.slug,
                  style: [styles.label, !_this2.props.only && styles.enabled, styles.inline, _extends({}, _this2.props.labelCustomStyle)],
                  ref: index,
                  onMouseOver: function onMouseOver() {
                    _this2.handleMouseOver(index);
                  },
                  onMouseOut: function onMouseOut() {
                    _this2.handleMouseOut();
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 83
                  }
                },
                option.hex && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["G" /* HexIcon */], {
                  color: option.hex,
                  active: index === active,
                  hover: index === _this2.state.hover, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 97
                  }
                }),
                !option.hex && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["_7" /* TextToggle */], {
                  focus: Object(__WEBPACK_IMPORTED_MODULE_2_radium__["getState"])(_this2.state, 'color-selector-input-' + index + '-' + _this2.state.uniqueID, ':focus'),
                  noPadding: _this2.props.divider,
                  divider: _this2.props.options.length - 1 > index,
                  primary: _this2.props.primary,
                  ignoreUppsercase: option.ignoreUppercase,
                  option: option.name,
                  active: index === active, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 103
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                  key: 'color-selector-input-' + index + '-' + _this2.state.uniqueID,
                  id: 'color-selector-input-' + index + '-' + _this2.state.uniqueID,
                  name: _this2.props.type,
                  style: styles.input,
                  type: _this2.props.type,
                  defaultValue: option.slug,
                  onChange: function onChange() {
                    return _this2.handleChange(index, option);
                  },
                  checked: index === active, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 112
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["d" /* Bubble */], {
                  content: option.label || option.name,
                  bottom: -2,
                  show: index === _this2.state.hover, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 121
                  }
                })
              ),
              index === active && option.extraLabel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: [styles.extraLabel, _this2.props.extraLabelCustomStyle], __source: {
                    fileName: _jsxFileName,
                    lineNumber: 128
                  }
                },
                option.extraLabel
              )
            );
          })
        )
      ),
      this.props.showActiveLabel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            color: '#999',
            fontWeight: 200,
            fontSize: '100%',
            textAlign: 'center'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 137
          }
        },
        this.props.options[this.state.active].name
      )
    );
  };

  return ColorSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ColorSelector.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  scrollEnable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  primary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  only: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showActiveLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  extraLabelCustomStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  labelCustomStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  dataTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
ColorSelector.defaultProps = {
  showActiveLabel: false,
  type: 'radio'
};
ColorSelector.displayName = 'ColorSelector';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["b" /* DetectCompact */])())(ColorSelector));

var styles = {
  base: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center'
  },
  divider: {
    display: 'inline-block',
    width: '2px',
    height: '.8em',
    margin: '0 1em',
    verticalAlign: 'middle',
    background: '#d5d5d5'
  },
  wrapper: {
    whiteSpace: 'nowrap',
    position: 'relative',
    WebkitOverflowScrolling: 'touch'
  },
  padding: {
    fontSize: 0,
    display: 'inline-flex'
  },
  option: {
    position: 'relative',
    display: 'inline-block'
  },
  input: {
    opacity: '0',
    position: 'absolute',
    ':focus': {}
  },
  label: {
    fontSize: '16px',
    position: 'relative',
    display: 'inline-block',
    padding: '1em .5em',
    userSelect: 'none'
  },
  extraLabel: {
    position: 'absolute',
    bottom: '-2em',
    height: '2em',
    left: '50%',
    textAlign: 'center',
    lineHeight: 2.1,
    padding: '1em 0',
    boxSizing: 'border-box',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap'
  },
  enabled: {
    cursor: 'pointer'
  },
  inline: {
    display: 'inline-block',
    whiteSpace: 'nowrap'
  },
  fadeRight: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '5em',
    height: '100%',
    background: 'linear-gradient(to left, #f5f5f5, rgba(245, 245, 245, 0))',
    pointerEvents: 'none',
    zIndex: 5
  }
};

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_countdown_now__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_countdown_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_countdown_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\countdown-timer\\index.jsx";






var CountdownTimer = function CountdownTimer(_ref) {
  var completeDate = _ref.completeDate,
      _ref$topContentCountd = _ref.topContentCountdownTimer,
      topContentCountdownTimer = _ref$topContentCountd === undefined ? "Entries Close In" : _ref$topContentCountd,
      _ref$completeContent = _ref.completeContent,
      completeContent = _ref$completeContent === undefined ? "" : _ref$completeContent,
      compact = _ref.compact;

  var countDate = new Date();
  if (completeDate) {
    countDate.setTime(completeDate);
  } else {
    countDate.setDate(countDate.getDate() + 1);
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { textAlign: "center" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 18
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: DigitStyles.heading, __source: {
          fileName: _jsxFileName,
          lineNumber: 19
        }
      },
      topContentCountdownTimer
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_countdown_now___default.a, {
      date: countDate,
      renderer: function renderer(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 23
            }
          },
          !props.completed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: DigitStyles.timer, __source: {
                fileName: _jsxFileName,
                lineNumber: 25
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 26
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: compact ? DigitStyles.compactSpan : DigitStyles.span, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 27
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_1_react_countdown_now__["zeroPad"])(props.days)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: DigitStyles.descriptor, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 30
                  }
                },
                "Days"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: compact ? DigitStyles.compactSeperator : DigitStyles.seperator, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 32
                }
              },
              ":"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 33
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: compact ? DigitStyles.compactSpan : DigitStyles.span, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 34
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_1_react_countdown_now__["zeroPad"])(props.hours)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: DigitStyles.descriptor, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 37
                  }
                },
                "Hours"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: compact ? DigitStyles.compactSeperator : DigitStyles.seperator, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 39
                }
              },
              ":"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 40
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: compact ? DigitStyles.compactSpan : DigitStyles.span, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 41
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_1_react_countdown_now__["zeroPad"])(props.minutes)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: DigitStyles.descriptor, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 44
                  }
                },
                "Minutes"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: compact ? DigitStyles.compactSeperator : DigitStyles.seperator, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 46
                }
              },
              ":"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 47
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: compact ? DigitStyles.compactSpan : DigitStyles.span, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 48
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_1_react_countdown_now__["zeroPad"])(props.seconds)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: DigitStyles.descriptor, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 51
                  }
                },
                "Seconds"
              )
            )
          ),
          props.completed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_25" /* WysiwygContent */], {
            xmlString: completeContent, __source: {
              fileName: _jsxFileName,
              lineNumber: 56
            }
          })
        );
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      }
    })
  );
};

CountdownTimer.displayName = "CountdownTimer";
CountdownTimer.displayName = "CountdownTimer";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["b" /* DetectCompact */])())(CountdownTimer));

var DigitStyles = {
  heading: _extends({}, __WEBPACK_IMPORTED_MODULE_2_constants_general_style__["b" /* BASE_HEADING */], {
    fontWeight: 200,
    color: "#FFF"
  }),
  descriptor: _extends({}, __WEBPACK_IMPORTED_MODULE_2_constants_general_style__["b" /* BASE_HEADING */], {
    fontSize: "0.8em",
    fontWeight: 200,
    color: "#FFF"
  }),
  timer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    flexWrap: "no-wrap",
    marginTop: "5px"
  },
  timerColumn: {
    display: "flex",
    flexDirection: "column"
  },
  span: {
    fontSize: "3.2em",
    padding: "0 10px",
    fontWeight: 700,
    letterSpacing: "6px"
  },
  compactSpan: {
    fontSize: "2em",
    padding: "0 5px",
    fontWeight: 700,
    letterSpacing: "4px"
  },
  compactSeperator: {
    fontSize: "2em",
    fontWeight: 700
  },
  seperator: {
    fontSize: "3.2em",
    fontWeight: 700
  }
};

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeDifference = exports.zeroPad = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Pads a given string or number with zeros.
 *
 * @param {any} value Value to zero-pad.
 * @param {number} [length=2] Amount of characters to pad.
 * @returns Left-padded number/string.
 */
var zeroPad = exports.zeroPad = function zeroPad(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (length === 0) return value;
  var strValue = String(value);
  return strValue.length >= length ? strValue : ('0'.repeat(length) + strValue).slice(length * -1);
};

/**
 * Calculates the time difference between a given end date and the current date.
 *
 * @param {Date|string|number} date Date or timestamp representation of the end date.
 * @param {Object} [{ now = Date.now, precision = 0, controlled = false }={}]
 *  {function} [date=Date.now] Alternative function for returning the current date.
 *  {number} [precision=0] The precision on a millisecond basis.
 *  {boolean} [controlled=false] Defines whether the calculated value is already provided as the time difference or not.
 * @param {number} [precision=0] The precision on a millisecond basis.
 * @param {boolean} [controlled=false] Defines whether the calculated value is already provided as the time difference or not.
 * @returns Object that includes details about the time difference.
 */
var getTimeDifference = exports.getTimeDifference = function getTimeDifference(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$now = _ref.now,
      now = _ref$now === undefined ? Date.now : _ref$now,
      _ref$precision = _ref.precision,
      precision = _ref$precision === undefined ? 0 : _ref$precision,
      _ref$controlled = _ref.controlled,
      controlled = _ref$controlled === undefined ? false : _ref$controlled;

  var startDate = typeof date === 'string' ? new Date(date) : date;
  var total = parseInt((Math.max(0, controlled ? startDate : startDate - now()) / 1000).toFixed(Math.max(0, Math.min(20, precision))) * 1000, 10);

  var seconds = total / 1000;

  return {
    total: total,
    days: Math.floor(seconds / (3600 * 24)),
    hours: Math.floor(seconds / 3600 % 24),
    minutes: Math.floor(seconds / 60 % 60),
    seconds: Math.floor(seconds % 60),
    milliseconds: Number((seconds % 1 * 1000).toFixed()),
    completed: total <= 0
  };
};

/**
 * A customizable countdown component for React.
 *
 * @export
 * @class Countdown
 * @extends {React.Component}
 */

var Countdown = function (_React$Component) {
  _inherits(Countdown, _React$Component);

  function Countdown(props) {
    _classCallCheck(this, Countdown);

    var _this = _possibleConstructorReturn(this, (Countdown.__proto__ || Object.getPrototypeOf(Countdown)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        date = _this$props.date,
        now = _this$props.now,
        precision = _this$props.precision,
        controlled = _this$props.controlled;

    _this.mounted = false;
    _this.state = _extends({}, getTimeDifference(date, {
      now: now,
      precision: precision,
      controlled: controlled
    }));
    return _this;
  }

  _createClass(Countdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;

      if (!this.props.controlled) {
        this.interval = setInterval(this.tick, this.props.intervalDelay);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var date = nextProps.date,
          now = nextProps.now,
          precision = nextProps.precision,
          controlled = nextProps.controlled;

      this.setDeltaState(getTimeDifference(date, {
        now: now,
        precision: precision,
        controlled: controlled
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      this.clearInterval();
    }
  }, {
    key: 'setDeltaState',
    value: function setDeltaState(delta) {
      if (!this.state.completed && delta.completed) {
        this.clearInterval();

        if (this.props.onComplete) {
          this.props.onComplete(delta);
        }
      }

      if (this.mounted) {
        this.setState(_extends({}, delta));
      }
    }
  }, {
    key: 'getFormattedDelta',
    value: function getFormattedDelta() {
      var _state = this.state,
          days = _state.days,
          hours = _state.hours;
      var _state2 = this.state,
          minutes = _state2.minutes,
          seconds = _state2.seconds;
      var _props = this.props,
          daysInHours = _props.daysInHours,
          zeroPadLength = _props.zeroPadLength;


      if (daysInHours) {
        hours = zeroPad(hours + days * 24, zeroPadLength);
        days = null;
      } else {
        hours = zeroPad(hours, Math.min(2, zeroPadLength));
      }

      return {
        days: days,
        hours: hours,
        minutes: zeroPad(minutes, Math.min(2, zeroPadLength)),
        seconds: zeroPad(seconds, Math.min(2, zeroPadLength))
      };
    }
  }, {
    key: 'clearInterval',
    value: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      clearInterval(this.interval);
      delete this.interval;
    })
  }, {
    key: 'render',
    value: function render() {
      var formattedDelta = this.getFormattedDelta();

      if (this.props.renderer) {
        return this.props.renderer(_extends({}, this.props, this.state, formattedDelta));
      }

      if (this.state.completed && this.props.children) {
        var computedProps = _extends({}, this.props, this.state, formattedDelta);
        delete computedProps.children;
        return _react2.default.cloneElement(this.props.children, {
          countdown: computedProps
        });
      } else {
        var days = formattedDelta.days,
            hours = formattedDelta.hours,
            minutes = formattedDelta.minutes,
            seconds = formattedDelta.seconds;

        return _react2.default.createElement(
          'span',
          null,
          days,
          days != null ? ':' : '',
          hours,
          ':',
          minutes,
          ':',
          seconds
        );
      }
    }
  }]);

  return Countdown;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.tick = function () {
    var _props2 = _this2.props,
        date = _props2.date,
        now = _props2.now,
        precision = _props2.precision,
        controlled = _props2.controlled,
        onTick = _props2.onTick;

    var delta = getTimeDifference(date, {
      now: now,
      precision: precision,
      controlled: controlled
    });

    _this2.setDeltaState(_extends({}, delta));

    if (onTick && delta.total > 0) {
      onTick(delta);
    }
  };
};

exports.default = Countdown;


Countdown.propTypes = {
  date: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.string, _propTypes2.default.number]).isRequired, // eslint-disable-line react/no-unused-prop-types
  daysInHours: _propTypes2.default.bool,
  zeroPadLength: _propTypes2.default.number,
  controlled: _propTypes2.default.bool,
  intervalDelay: _propTypes2.default.number,
  precision: _propTypes2.default.number,
  children: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
  renderer: _propTypes2.default.func,
  now: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  onTick: _propTypes2.default.func,
  onComplete: _propTypes2.default.func
};

Countdown.defaultProps = {
  daysInHours: false,
  zeroPadLength: 2,
  controlled: false,
  intervalDelay: 1000,
  precision: 0,
  children: null
};

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\error-message-section\\index.jsx";




var ErrorMessageSection = function ErrorMessageSection(_ref) {
  var error = _ref.error;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.wrapper, __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["r" /* ErrorIcon */], { style: styles.icon, __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      { style: styles.error, __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      },
      error
    )
  );
};

ErrorMessageSection.displayName = "ErrorMessageSection";
ErrorMessageSection.displayName = "ErrorMessageSection";
ErrorMessageSection.propTypes = {
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (ErrorMessageSection);

var styles = {
  wrapper: {
    background: "#fceeef",
    padding: "1em"
  },
  error: {
    fontSize: "90%",
    color: "#910A2D",
    textAlign: "left",
    lineHeight: "16px",
    fontWeight: 200,
    margin: "0 0 0 2em"
  },
  icon: {
    height: "1em",
    width: "1em",
    fill: "#910A2D",
    float: "left"
  }
};

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\expandable-area\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/* Accordion Component */

var ExpandableArea = function (_Component) {
  _inherits(ExpandableArea, _Component);

  function ExpandableArea(props) {
    _classCallCheck(this, ExpandableArea);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      isExpanded: props.initialStateExpanded,
      height: 0
    };

    _this.toggleExpanded = _this.toggleExpanded.bind(_this);
    _this.setClientHeight = _this.setClientHeight.bind(_this);
    _this.renderArea = _this.renderArea.bind(_this);
    _this.isExpanded = _this.isExpanded.bind(_this);
    return _this;
  }

  ExpandableArea.prototype.componentDidMount = function componentDidMount() {
    this.setClientHeight();
    window.addEventListener("resize", this.setClientHeight);
  };

  ExpandableArea.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("resize", this.setClientHeight);
  };

  ExpandableArea.prototype.setClientHeight = function setClientHeight() {
    if (!this.contentElement) return;
    this.setState({ height: this.contentElement.clientHeight });
  };

  ExpandableArea.prototype.toggleExpanded = function toggleExpanded() {
    this.setState({ isExpanded: !this.state.isExpanded }, this.setClientHeight);
    if (this.props.onToggle) {
      this.props.onToggle();
    }
  };

  ExpandableArea.prototype.isExpanded = function isExpanded() {
    var isExpanded = this.props.isExpanded;

    return typeof isExpanded !== "undefined" ? isExpanded : this.state.isExpanded;
  };

  ExpandableArea.prototype.renderArea = function renderArea(_ref) {
    var _this2 = this;

    var children = _ref.children;

    var isExpanded = this.isExpanded();
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: !(isExpanded && this.state.height === 0) ? styles.wrapper(this.state.height, isExpanded) : {}, __source: {
          fileName: _jsxFileName,
          lineNumber: 50
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          ref: function ref(element) {
            _this2.contentElement = element;
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 56
          }
        },
        children
      )
    );
  };

  ExpandableArea.prototype.render = function render() {
    return this.props.children({
      RenderArea: this.renderArea,
      isExpanded: this.isExpanded(),
      toggleExpanded: this.toggleExpanded
    });
  };

  return ExpandableArea;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ExpandableArea.displayName = "ExpandableArea";


ExpandableArea.propTypes = {
  initialStateExpanded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onToggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  isExpanded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

ExpandableArea.defaultProps = {
  initialStateExpanded: false
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(ExpandableArea));

var animationDuration = function animationDuration(height, speed) {
  var calculated = height / 100 / speed;
  if (calculated > 0.666 && calculated < 1.5) return calculated;
  return calculated > 1.5 ? 1.5 : 0.666;
};

var styles = {
  wrapper: function wrapper(height, open) {
    return {
      transition: "\n      opacity " + animationDuration(height, 10) + "s,\n      height " + animationDuration(height, 10) + "s\n    ",
      height: open ? height : "0px",
      opacity: open ? 1 : 0,
      overflow: "hidden"
    };
  }
};

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\flash-message\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var FlashMessage = function (_Component) {
  _inherits(FlashMessage, _Component);

  function FlashMessage() {
    _classCallCheck(this, FlashMessage);

    // State is used here to avoid using animation keyframes which is buggy for Safari IOS & IE
    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = { open: false };
    return _this;
  }

  FlashMessage.prototype.componentDidMount = function componentDidMount() {
    this.setState({ open: true });
  };

  FlashMessage.prototype.render = function render() {
    var _props = this.props,
        message = _props.message,
        _props$type = _props.type,
        type = _props$type === undefined ? "MESSAGE" : _props$type,
        onDismiss = _props.onDismiss,
        _props$index = _props.index,
        index = _props$index === undefined ? 0 : _props$index,
        _props$style = _props.style,
        style = _props$style === undefined ? {} : _props$style;

    var typeStyle = typeStyles[type] || typeStyles.MESSAGE;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { overflow: "hidden" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 27
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: [styles.slideIn(this.state.open, index), styles.base, { padding: onDismiss ? "1em 6em 1em 1em" : "1em" }, style], __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { style: styles.message, __source: {
              fileName: _jsxFileName,
              lineNumber: 34
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: {
                display: "flex"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 35
              }
            },
            typeStyle.icon && typeStyle.icon()
          ),
          message
        ),
        onDismiss && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.dismiss, __source: {
              fileName: _jsxFileName,
              lineNumber: 43
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["a" /* A */],
            { withoutStyle: true, onClick: onDismiss, __source: {
                fileName: _jsxFileName,
                lineNumber: 44
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["U" /* Interactive */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 45
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["u" /* CrossIcon */], { style: {
                  fill: "currentColor",
                  height: "13px",
                  width: "13px",
                  margin: "0 8px -2px 0"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 46
                }
              }),
              "Dismiss"
            )
          )
        )
      )
    );
  };

  return FlashMessage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FlashMessage.displayName = "FlashMessage";


var styles = {
  base: _extends({}, __WEBPACK_IMPORTED_MODULE_4_constants_general_style__["a" /* BASE_COPY */], {
    position: "relative",
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_LIGHTER,
    display: "block",
    textAlign: "center",
    "@media (min-width: 768px)": {
      padding: "1em 6em"
    }
  }),
  slideIn: function slideIn(open, index) {
    return {
      opacity: open ? 1 : 0,
      transform: open ? "translateY(0)" : "translateY(-100%)",
      transition: ".666s " + 0.2 * index + "s"
    };
  },
  dismiss: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    padding: "1em",
    display: "flex"
  },
  link: {
    cursor: "pointer",
    fontWeight: 400,
    color: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_DARK,
    fontSize: "90%",
    display: "flex",
    alignItems: "center",
    transition: "color 0.25s",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_DARKER
    }
  },
  message: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  statusIconSvg: {
    height: "1.2em",
    width: "1.2em",
    marginRight: "0.6em"
  }
};

var typeStyles = {
  MESSAGE: {},
  SUCCESS: {
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_17" /* TickModalIcon */], { style: styles.statusIconSvg, __source: {
          fileName: _jsxFileName,
          lineNumber: 116
        }
      });
    }
  },
  ERROR: {
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["d" /* AlertIcon */], { style: styles.statusIconSvg, __source: {
          fileName: _jsxFileName,
          lineNumber: 121
        }
      });
    }
  }
};

FlashMessage.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["SUCCESS", "ERROR", "MESSAGE"]),
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onDismiss: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(FlashMessage));

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FullWidthImageSectionContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__ = __webpack_require__(14);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\full-width-image-section\\index.jsx";






// /**
//  * Render a full width image section
//  * @param {'compact'|'medium'|'tall','extra tall', 'widescreen'} [height=compact] - Module height.
//  * @param {'full width'|'article'} [width=article] - Width mode of module.
//  * @param {String} backgroundImage - url for background image.
//  * @param {Url} [backgroundVideo] - Video Url. If not defined hero will show only background image.
//  * @param {'left'|'right'|'center'} [textAlign=center] - Text alignment of content.
//  * @param {'left'|'right'|'center'} [align=center] - Alignment of text block.
//  * @param {String} [heading] - text heading.
//  * @param {String} [preHeading] - text pre heading.
//  * @param {String} [blurb] - text blurb (accepts html).
//  * @param {'light'|'dark'} [wysiwygTheme='light'] - colour theme name for wysiwyg.
//  * @param {'top'|'bottom'|'center'} [textVerticalAlign=center] - Vertical text alignment.
//  * @returns {ReactElement} React Component
//  */

function FullWidthImageSectionContainer(_ref) {
  var height = _ref.height,
      width = _ref.width,
      backgroundImage = _ref.backgroundImage,
      mobileBackgroundImage = _ref.mobileBackgroundImage,
      _ref$compact = _ref.compact,
      compact = _ref$compact === undefined ? false : _ref$compact,
      backgroundImageArray = _ref.backgroundImageArray,
      backgroundVideo = _ref.backgroundVideo,
      textAlign = _ref.textAlign,
      interval = _ref.interval,
      loop = _ref.loop,
      align = _ref.align,
      fullWidth = _ref.fullWidth,
      _ref$floating = _ref.floating,
      floating = _ref$floating === undefined ? false : _ref$floating,
      heading = _ref.heading,
      headingSize = _ref.headingSize,
      _ref$mobileHeading = _ref.mobileHeading,
      mobileHeading = _ref$mobileHeading === undefined ? heading : _ref$mobileHeading,
      blurb = _ref.blurb,
      tagOverride = _ref.tagOverride,
      wysiwygTheme = _ref.wysiwygTheme,
      textVerticalAlign = _ref.textVerticalAlign,
      children = _ref.children,
      _ref$components = _ref.components,
      components = _ref$components === undefined ? [] : _ref$components;


  var length = 0;
  if (components && components.length && components.length > 0) {
    length = components.length;
  } else if (children && children.length && children.length > 0) {
    length = children.length;
  }

  var orientation = void 0;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "section",
    { style: [{ display: "flex", width: "100%" }, width === "article" && styles.articleColumn], __source: {
        fileName: _jsxFileName,
        lineNumber: 57
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          textAlign: "center",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          color: "white",
          display: "flex",
          position: "relative",
          width: "100%",
          overflow: "hidden",
          zIndex: 0,
          backgroundSize: "cover",
          backgroundImage: floating && length ? "" : "url(" + (mobileBackgroundImage || backgroundImage) + ")",
          "@media (min-width: 768px)": {
            backgroundImage: floating && length ? "" : "url(" + backgroundImage + ")"
          }
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 58
        }
      },
      floating && length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          backgroundImage: "url(" + (mobileBackgroundImage || backgroundImage) + ")",
          "@media (min-width: 768px)": {
            backgroundImage: "url(" + backgroundImage + ")"
          },
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "absolute",
          zIndex: -1,
          height: "65%",
          width: "100%"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 76
        }
      }) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_containers__["g" /* ColumnGroup */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 91
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_containers__["f" /* Column */],
          { textAlign: textAlign, __source: {
              fileName: _jsxFileName,
              lineNumber: 92
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: [styles.base(fullWidth && length), styles[align], !(floating && length) && styles.height(height)], __source: {
                fileName: _jsxFileName,
                lineNumber: 93
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 99
                }
              },
              compact
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: [{ display: fullWidth && length ? "block" : "table-cell" }, styles.verticalAlign(textVerticalAlign)], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 100
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 105
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 106
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["F" /* Heading */], {
                    white: true,
                    tag: tagOverride || "h2",
                    size: headingSize,
                    value: compact ? mobileHeading : heading, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 107
                    }
                  }),
                  blurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["t" /* Content */], { xmlString: blurb, theme: wysiwygTheme, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 112
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: {
                        display: "flex",
                        justifyContent: textAlign === "center" ? "center" : "none",
                        flexDirection: "column",
                        alignItems: "center",
                        position: "relative"
                      }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 113
                      }
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_5_AtomicUtils_componentParser__["a" /* default */])(components) || children
                  )
                )
              )
            )
          )
        )
      ),
      backgroundVideo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_22" /* VideoBackground */], { orientation: orientation, src: backgroundVideo, __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        }
      }),
      backgroundImageArray && backgroundImageArray.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["y" /* LayeredBackgroundImageAutoplay */], {
        interval: interval,
        loop: loop,
        imageSrcArray: backgroundImageArray,
        backgroundSize: "cover", __source: {
          fileName: _jsxFileName,
          lineNumber: 131
        }
      })
    )
  );
}

FullWidthImageSectionContainer.displayName = "FullWidthImageSectionContainer";
FullWidthImageSectionContainer.displayName = "FullWidthImageSectionContainer";
FullWidthImageSectionContainer.defaultProps = {
  align: "center",
  textAlign: "center",
  height: "compact",
  width: "full width",
  wysiwygTheme: "light"
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["b" /* DetectCompact */])())(FullWidthImageSectionContainer));

var styles = {
  base: function base(fullWidth) {
    return {
      maxWidth: fullWidth ? "none" : "calc(40em + 4vw)",
      boxSizing: "border-box",
      padding: "4vw 0",
      display: fullWidth ? "block" : "table",
      height: fullWidth ? "auto" : 0
    };
  },
  verticalAlign: function verticalAlign(alignment) {
    return {
      verticalAlign: alignment === "center" ? "middle" : alignment
    };
  },
  height: function height(_height) {
    switch (_height) {
      case "widescreen":
        return {
          minHeight: "180vw",
          "@media (min-width: 768px)": {
            minHeight: "56vw"
          }
        };
      case "extra tall":
        return {
          minHeight: "150vw",
          "@media (min-width: 768px)": {
            minHeight: "50vw"
          }
        };
      case "tall":
        return {
          minHeight: "100vw",
          "@media (min-width: 768px)": {
            minHeight: "40vw"
          }
        };
      case "medium":
        return {
          minHeight: "80vw",
          "@media (min-width: 768px)": {
            minHeight: "30vw"
          }
        };
      case "fit":
        return {};
      default:
        return {
          minHeight: "50vw",
          "@media (min-width: 768px)": {
            minHeight: "20vw"
          }
        };
    }
  },
  articleColumn: {
    maxWidth: "60em",
    margin: "auto",
    overflow: "auto"
  },
  left: {
    marginRight: "auto"
  },
  right: {
    marginLeft: "auto"
  },
  center: {
    margin: "0 auto"
  }
};

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\global-nav-dropdown\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







/** Navigation Dropdown Component. */
/**
 * @param {String} label - Navigation Label
 * @param {Array|Overlay} components - Nested Components.
 * @returns {ReactElement} React Component
 */
var GlobalNavDropdown = function GlobalNavDropdown(_ref) {
  var toggleActive = _ref.toggleActive,
      label = _ref.label,
      subNav = _ref.subNav,
      active = _ref.active,
      close = _ref.close,
      compact = _ref.compact,
      height = _ref.height,
      _ref$children = _ref.children,
      children = _ref$children === undefined ? [] : _ref$children,
      extra = _objectWithoutProperties(_ref, ["toggleActive", "label", "subNav", "active", "close", "compact", "height", "children"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: [styles.base, subNav ? subNav.base : topNav.base], __source: {
        fileName: _jsxFileName,
        lineNumber: 25
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components__["A" /* GlobalNavLink */],
      _extends({ type: "span", onClick: toggleActive, label: label, subNav: subNav, active: active, chevron: compact }, extra, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        }
      }),
      subNav && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: subNav.iconPos, __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["c" /* AnimatedPlusMinus */], { open: active, __source: {
            fileName: _jsxFileName,
            lineNumber: 29
          }
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (component, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(component, {
        key: index,
        active: active,
        subNav: subNav,
        close: close,
        height: height,
        nav: true
      });
    })
  );
};

GlobalNavDropdown.displayName = "GlobalNavDropdown";
GlobalNavDropdown.displayName = "GlobalNavDropdown";
GlobalNavDropdown.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  toggleActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  subNav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])({ threshold: 900 }))(GlobalNavDropdown));

var styles = {
  base: {
    textTransform: "uppercase",
    cursor: "pointer",
    transition: ".25s",
    position: "relative",
    "@media (min-width: 900px)": {
      position: "static"
    }
  }
};

var topNav = {
  base: {
    display: "inline-block"
  }
};

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(9);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\global-nav-item-grid\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/** Flexbox Content Component. */

var GlobalNavItemGrid = function (_Component) {
  _inherits(GlobalNavItemGrid, _Component);

  function GlobalNavItemGrid() {
    _classCallCheck(this, GlobalNavItemGrid);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.activate = function (index) {
      _this.setState({ active: index });
    };

    _this.reset = function () {
      _this.setState({ active: -1 });
    };

    _this.onClick = function (index) {
      _this.setState({ clickedIndex: index });
    };

    _this.isNav = function () {
      if (_this.props.nav) {
        if (_this.props.active && _this.props.subNav) return styles.subNavShow;
        if (_this.props.active) return styles.show;
        return styles.hide;
      }return styles.show;
    };

    _this.childProps = function (index) {
      var faded = _this.props.fadeItems ? _this.state.active === index || _this.state.active === index || _this.state.clickedIndex === index : false;
      var columns = _this.props.columns || 3;
      return {
        faded: faded,
        key: index,
        flexBasis: 100 / columns,
        animationDelay: index * 0.1,
        subNav: _this.props.subNav,
        centerContent: _this.props.centerContent === undefined && (_this.props.nav || _this.props.subNav) ? true : _this.props.centerContent,
        activate: _this.activate.bind(_this, index),
        reset: _this.reset.bind(_this, index),
        onClick: function onClick() {
          !_this.props.children[index].props.onClick && _this.onClick(index);
          _this.props.children[index].props.onClick && _this.props.children[index].props.onClick();
        },
        loading: _this.state.clickedIndex === index,
        active: _this.props.active
      };
    };

    _this.state = {
      active: -1,
      clickedIndex: -1
    };
    return _this;
  }

  GlobalNavItemGrid.prototype.componentDidMount = function componentDidMount() {
    if (this.props.nav) {
      setTimeout(function () {
        styles.hide.display = 'none';
      }, 100);
    }
  };

  GlobalNavItemGrid.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.props.nav) styles.hide.display = 'flex';
  };
  /**
   * @param {number} index - Index to set active
   */


  /**
   * @param {Boolean} [centerContent] - Center align content vertically
   * @param {Array|FlexIconLink} [components] - Nested Components
   * @param {Number} [columns=3] - Number of elements displayed horizontally.
   * @param {String} [backgroundColor='transparent'] - Background Color Hex Code.
   * @returns {ReactElement} React Component
   */
  GlobalNavItemGrid.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        nav = _props.nav,
        subNav = _props.subNav,
        children = _props.children,
        backgroundColor = _props.backgroundColor;

    var centerContent = this.props.centerContent === undefined && (nav || subNav) ? true : this.props.centerContent;

    // JIRA ticket MR-3165 had center-justified flex content clipped by container bounds.
    // Get around this by using margin auto on first and last children. Since we don't know which
    // components children will be comprised of (i.e. don't know if they allow style overrides,
    // how they size within a parent, etc), inject dummy divs to start and end of list
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        'data-test': 'flex-content',
        style: [styles.base, this.isNav(), backgroundColor && {
          backgroundColor: backgroundColor
        }, centerContent && {
          "@media (min-width: 900px)": {
            maxWidth: '1200px',
            margin: '0 auto'
          }
        }, subNav && styles.subNav], __source: {
          fileName: _jsxFileName,
          lineNumber: 83
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_3_utils__["m" /* flatMap */])(function (_ref) {
        var index = _ref[0],
            component = _ref[1];

        if (index === 0 && centerContent) {
          return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { style: styles.centerFirst, key: index - 1, __source: {
              fileName: _jsxFileName,
              lineNumber: 101
            }
          }), component];
        }

        if (index === children.length - 1 && centerContent) {
          return [component, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { style: styles.centerLast, key: index + 1, __source: {
              fileName: _jsxFileName,
              lineNumber: 105
            }
          })];
        }

        return component;
      }, Object(__WEBPACK_IMPORTED_MODULE_3_utils__["U" /* toPairs */])(children.map(function (comp, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(comp, _this2.childProps(index));
      })))
    );
  };

  return GlobalNavItemGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

GlobalNavItemGrid.displayName = 'GlobalNavItemGrid';


GlobalNavItemGrid.defaultProps = {
  fadeItems: true
};

GlobalNavItemGrid.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  fadeItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  subNav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  columns: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  centerContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(GlobalNavItemGrid));

var styles = {
  base: {
    width: '100%',
    boxSizing: 'border-box',
    flexWrap: 'wrap',
    padding: '1em 0 4em'
  },
  show: {
    display: 'flex'
  },
  hide: {
    display: 'flex'
  },
  subNav: {
    flexDirection: 'column'
  },
  subNavShow: {
    display: 'block'
  },
  centerFirst: {
    margin: 'auto 0 0 0',
    padding: 0,
    width: '100%'
  },
  centerLast: {
    margin: '0 0 auto 0',
    padding: 0,
    width: '100%'
  }
};

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_gtm_events__ = __webpack_require__(22);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\global-nav-link-accordion\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/* Navigation Dropdown Component. */

var GlobalNavLinkAccordion = function (_PureComponent) {
  _inherits(GlobalNavLinkAccordion, _PureComponent);

  function GlobalNavLinkAccordion() {
    _classCallCheck(this, GlobalNavLinkAccordion);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.state = {
      contentHeight: 0
    };
    _this.getHeight = _this.getHeight.bind(_this);
    return _this;
  }

  GlobalNavLinkAccordion.prototype.componentDidMount = function componentDidMount() {
    this.getHeight();
  };

  GlobalNavLinkAccordion.prototype.componentDidUpdate = function componentDidUpdate() {
    this.getHeight();
  };

  GlobalNavLinkAccordion.prototype.getHeight = function getHeight() {
    if (this.contentEl) this.setState({ contentHeight: this.contentEl.offsetHeight + 32 });
  };
  /**
   * @param {String} label - Navigation Label
   * @param {Array|Overlay} components - Nested Components.
   * @returns {ReactElement} React Component
   */


  GlobalNavLinkAccordion.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        "data-test": "nav-accordion",
        style: [styles.base, this.props.subNav ? subNav.base : topNav.base], __source: {
          fileName: _jsxFileName,
          lineNumber: 33
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_components__["A" /* GlobalNavLink */],
        {
          type: "span",
          onClick: this.props.toggleActive,
          label: this.props.label,
          subNav: this.props.subNav,
          active: this.props.active,
          gtm: this.props.gtm, __source: {
            fileName: _jsxFileName,
            lineNumber: 36
          }
        },
        this.props.subNav ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: subNav.iconPos, __source: {
              fileName: _jsxFileName,
              lineNumber: 44
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["c" /* AnimatedPlusMinus */], { open: this.props.active, __source: {
              fileName: _jsxFileName,
              lineNumber: 45
            }
          })
        ) : ""
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            height: this.props.active ? this.state.contentHeight + "px" : "0px",
            overflow: "hidden",
            transition: ".25s"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 51
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            ref: function ref(c) {
              _this2.contentEl = c;
            },
            style: { boxSizing: "border-box" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 57
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ol",
            { style: styles.ol, __source: {
                fileName: _jsxFileName,
                lineNumber: 62
              }
            },
            this.props.components[0].props.components[0].props.components.map(function (component, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { style: styles.li, key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 64
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_components__["H" /* Hyperlink */],
                  {
                    href: component.props.href,
                    style: styles.a,
                    key: index,
                    withoutStyle: true,
                    gtmEvents: [{
                      func: _this2.props.gtmEvent,
                      args: {
                        gtmID: __WEBPACK_IMPORTED_MODULE_5_store_gtm_events__["g" /* gtmGlobalNavActionTypes */].NAV_LINK_SECONDARY_CLICK,
                        gtmPayload: {
                          CMSGroupGTM: component.props.gtm
                        }
                      }
                    }], __source: {
                      fileName: _jsxFileName,
                      lineNumber: 65
                    }
                  },
                  component.props.name
                )
              );
            })
          )
        )
      )
    );
  };

  return GlobalNavLinkAccordion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

GlobalNavLinkAccordion.displayName = "GlobalNavLinkAccordion";


GlobalNavLinkAccordion.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  toggleActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  subNav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["i" /* gtmEvent */])())(GlobalNavLinkAccordion));

var styles = {
  base: {
    textTransform: "uppercase",
    cursor: "pointer",
    transition: ".25s",
    position: "relative",
    padding: "1px 0",
    "@media (min-width: 900px)": {
      position: "static"
    }
  },
  ol: {
    listStyle: "none",
    padding: "1.5em 2.15em",
    background: "#ffffff",
    textTransform: "capitalize",
    marginBottom: "1.5em",
    boxSizing: "border-box",
    "@media (min-width: 768px)": {
      padding: "1.5em 4em"
    }
  },
  li: {
    fontSize: "90%"
  },
  a: {
    textDecoration: "none",
    padding: ".75em 0",
    display: "block",
    color: "#999999",
    ":hover": {
      color: "#101010",
      transition: ".2s ease-in-out"
    }
  }
};

var topNav = {
  base: {
    display: "inline-block"
  }
};

var subNav = {
  base: {
    display: "block",
    color: "#808080",
    margin: "auto",
    flex: "1 1 100%"
  },
  iconPos: {
    position: "absolute",
    right: "1.25em",
    top: ".7em",
    width: "1em",
    height: "1em",
    "@media (min-width: 768px)": {
      top: ".375em"
    },
    "@media (min-width: 900px)": {
      display: "none"
    }
  }
};

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\global-nav-link-secondary\\index.jsx";





var GlobalNavLinkSecondary = function GlobalNavLinkSecondary(_ref) {
  var name = _ref.name,
      href = _ref.href,
      gtm = _ref.gtm;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["a" /* A */],
    {
      "data-test": "secondary-link",
      href: href,
      withoutStyle: true,
      gtm: gtm, __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: styles.base, __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      },
      name
    )
  );
};

GlobalNavLinkSecondary.displayName = "GlobalNavLinkSecondary";
GlobalNavLinkSecondary.displayName = "GlobalNavLinkSecondary";
var styles = {
  base: {
    textDecoration: "none",
    padding: ".75em 0",
    display: "block",
    color: "#808080",
    "@media (min-width: 1700px)": {
      fontSize: "125%"
    },
    ":hover": {
      color: "#101010",
      transition: ".2s ease-in-out"
    }
  }
};

GlobalNavLinkSecondary.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

GlobalNavLinkSecondary.defaultProps = {
  name: "",
  href: ""
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])()(GlobalNavLinkSecondary));

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_portal__ = __webpack_require__(90);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\global-nav-overlay\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/* Overlay Component. */

var GlobalNavOverlay = function (_PureComponent) {
  _inherits(GlobalNavOverlay, _PureComponent);

  function GlobalNavOverlay() {
    var _temp, _this, _ret;

    _classCallCheck(this, GlobalNavOverlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.getHeightStyles = function () {
      var _this$props = _this.props,
          compact = _this$props.compact,
          subNav = _this$props.subNav,
          active = _this$props.active;


      if (subNav && active && !compact) return { height: "100%", transition: "none" };
      if (subNav && !active) return { height: 0, transition: ".25s" };

      return {};
    }, _this.handleClose = function () {
      var gtm = _this.props.gtm;

      if (gtm && gtm.category) {
        Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
          pageCategory: gtm.category,
          pageAction: gtm.action
        });
      }
      _this.props.close();
    }, _this.handleKeyDown = function (event) {
      if (event.key === "Escape") _this.handleClose(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * @param {object} event - keyDown event
   */


  /**
   * @param {Array|FlexContent} components - Nested Components
   * @returns {ReactElement} React Component
   */
  GlobalNavOverlay.prototype.render = function render() {
    var _this2 = this;

    return this.props.active ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_portal__["a" /* Portal */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 40
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "ol",
        {
          "data-test": "global-nav-overlay",
          style: [styles.ol, this.props.subNav ? subNavStyles.ol(this.props.compact) : topNavStyles.ol(this.props.height, this.props.compact), this.getHeightStyles()],
          onKeyDown: this.handleKeyDown, __source: {
            fileName: _jsxFileName,
            lineNumber: 41
          }
        },
        !this.props.subNav ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["j" /* CloseButton */], { onClick: this.handleClose, __source: {
            fileName: _jsxFileName,
            lineNumber: 51
          }
        }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children, function (component, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(component, {
            key: index,
            active: _this2.props.active,
            subNav: _this2.props.subNav,
            nav: _this2.props.nav
          });
        })
      )
    ) : null;
  };

  return GlobalNavOverlay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

GlobalNavOverlay.displayName = "GlobalNavOverlay";


GlobalNavOverlay.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  subNav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(GlobalNavOverlay));

var styles = {
  ol: {
    display: "flex",
    flexWrap: "wrap",
    zIndex: 50,
    listStyle: "none",
    padding: 0,
    margin: 0,
    color: "#212121",
    width: "100%",
    maxHeight: "100%",
    overflowY: "scroll",
    overflowX: "none",
    WebkitOverflowScrolling: "touch"
  }
};

var subNavStyles = {
  ol: function ol(compact) {
    return _extends({
      position: compact ? "relative" : "absolute",
      background: "#e6e6e6"
    }, compact ? {} : {
      top: 0,
      left: "40vw"
    });
  }
};

var topNavStyles = {
  closed: {
    visibility: "hidden",
    display: "none",
    opacity: 0
  },
  open: {
    visibility: "visible",
    transition: "opacity .5s",
    display: "flex",
    opacity: 1
  },
  ol: function ol(height, compact) {
    return _extends({
      position: "fixed",
      background: "#dedede",
      width: "100vw"
    }, height ? { height: "calc(" + (compact ? '100%' : '100vh') + " - " + height + "px)", top: height } : {});
  }
};

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\gyroscope\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Gyroscope = function (_React$PureComponent) {
  _inherits(Gyroscope, _React$PureComponent);

  function Gyroscope() {
    _classCallCheck(this, Gyroscope);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Gyroscope.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      "Gyroscope"
    );
  };

  return Gyroscope;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Gyroscope.displayName = "Gyroscope";


/* harmony default export */ __webpack_exports__["a"] = (Gyroscope);

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\interior-selector\\index.js';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/** Radio Group Component. */
// @todo remove this component

var InteriorSelector = function (_Component) {
  _inherits(InteriorSelector, _Component);

  function InteriorSelector(props) {
    _classCallCheck(this, InteriorSelector);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = function (index, option) {
      _this.setState({
        active: index
      }, function () {
        _this.props.onChange && _this.props.onChange(option, index);
      });
    };

    _this.handleMouseOver = function (index) {
      _this.setState({ hover: index });
    };

    _this.handleMouseOut = function () {
      _this.setState({ hover: -1 });
    };

    _this.state = {
      hover: -1,
      active: props.active || 0,
      uniqueID: Math.random()
    };
    return _this;
  }

  InteriorSelector.prototype.render = function render() {
    var _this2 = this;

    var flow = true;
    var inline = false;
    var active = this.state.active;
    this.props.options.forEach(function (option) {
      if (option.hex || option.icon) flow = false;
      if (option.hex || option.icon) inline = true;
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { position: 'relative' }, 'data-test': this.props.dataTest, __source: {
          fileName: _jsxFileName,
          lineNumber: 61
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: [styles.base, this.props.compact && {
            overflowX: 'auto',
            overflowY: 'hidden'
          }, { padding: this.props.padding || '0px' }],
          'data-test': 'radio-group', __source: {
            fileName: _jsxFileName,
            lineNumber: 62
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            ref: function ref(c) {
              _this2.radioGroup = c;
            },
            style: [this.props.scrollEnable && styles.wrapper, styles.padding], __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          },
          this.props.options.map(function (option, index) {
            var divider = _this2.props.divider && index < _this2.props.options.length - 1;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: styles.option, ref: index, key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 83
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                {
                  htmlFor: 'interior-selector-input-' + index + '-' + _this2.state.uniqueID,
                  'data-test': 'radio-group-label',
                  'data-value': option.slug,
                  style: [styles.label, !_this2.props.only && styles.enabled, styles.inline, _extends({}, _this2.props.labelCustomStyle)],
                  ref: index,
                  onMouseOver: function onMouseOver() {
                    return _this2.handleMouseOver(index);
                  },
                  onMouseOut: _this2.handleMouseOut, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 84
                  }
                },
                option.icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Y" /* RadioIcon */], {
                  icon: option.icon,
                  active: index === active,
                  hover: index === _this2.state.hover, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 98
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                  key: 'interior-selector-input-' + index + '-' + _this2.state.uniqueID,
                  id: 'interior-selector-input-' + index + '-' + _this2.state.uniqueID,
                  style: styles.input,
                  type: 'radio',
                  name: _this2.props.type,
                  defaultValue: option.slug,
                  onChange: function onChange() {
                    return _this2.handleChange(index, option);
                  },
                  checked: index === active, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 103
                  }
                }),
                inline && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["d" /* Bubble */], {
                  content: option.label || option.name,
                  bottom: -1,
                  show: index === _this2.state.hover, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 113
                  }
                })
              ),
              divider && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.divider, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 119
                }
              }),
              index === active && option.extraLabel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: [styles.extraLabel, _this2.props.extraLabelCustomStyle], __source: {
                    fileName: _jsxFileName,
                    lineNumber: 122
                  }
                },
                option.extraLabel
              )
            );
          })
        )
      ),
      this.props.showActiveLabel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            color: '#999',
            fontWeight: 200,
            fontSize: '100%',
            textAlign: 'center',
            paddingBottom: '1.5em'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 132
          }
        },
        this.props.options[this.state.active].name
      )
    );
  };

  return InteriorSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

InteriorSelector.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  scrollEnable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  primary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  only: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showActiveLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  extraLabelCustomStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  labelCustomStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  dataTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
InteriorSelector.defaultProps = {
  showActiveLabel: false,
  type: 'radio'
};
InteriorSelector.displayName = 'InteriorSelector';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(InteriorSelector));

var styles = {
  base: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center'
  },
  divider: {
    display: 'inline-block',
    width: '2px',
    height: '.8em',
    margin: '0 1em',
    verticalAlign: 'middle',
    background: '#d5d5d5'
  },
  wrapper: {
    whiteSpace: 'nowrap',
    position: 'relative',
    WebkitOverflowScrolling: 'touch'
  },
  padding: {
    fontSize: 0,
    display: 'inline-flex'
  },
  option: {
    position: 'relative',
    display: 'inline-block'
  },
  input: {
    opacity: '0',
    position: 'absolute',
    ':focus': {}
  },
  label: {
    fontSize: '16px',
    position: 'relative',
    display: 'inline-block',
    padding: '1em .5em',
    userSelect: 'none'
  },
  extraLabel: {
    position: 'absolute',
    bottom: '-2em',
    height: '2em',
    left: '50%',
    textAlign: 'center',
    lineHeight: 2.1,
    padding: '1em 0',
    boxSizing: 'border-box',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap'
  },
  enabled: {
    cursor: 'pointer'
  },
  inline: {
    display: 'inline-block',
    whiteSpace: 'nowrap'
  },
  fadeRight: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '5em',
    height: '100%',
    background: 'linear-gradient(to left, #f5f5f5, rgba(245, 245, 245, 0))',
    pointerEvents: 'none',
    zIndex: 5
  }
};

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_radium__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\interior-swatch\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var InteriorSwatch = function (_Component) {
  _inherits(InteriorSwatch, _Component);

  function InteriorSwatch() {
    _classCallCheck(this, InteriorSwatch);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  // Radium requires stateful component to use getState()
  InteriorSwatch.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        imageSrc = _props.imageSrc;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        "data-test": "interior-swatch",
        style: {
          position: "relative",
          cursor: "pointer",
          ":hover": { cursor: "pointer" },
          paddingLeft: "1em"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: imageSrc, alt: label + " interior color swatch", style: { width: "3em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      }),
      label && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["d" /* Bubble */], { bottom: -3, content: label, show: Object(__WEBPACK_IMPORTED_MODULE_3_radium__["getState"])(this.state, "main", ":hover"), __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      })
    );
  };

  return InteriorSwatch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

InteriorSwatch.displayName = "InteriorSwatch";


InteriorSwatch.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(InteriorSwatch));

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\loading\\index.jsx";




var Loading = function Loading() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        display: "flex",
        flex: "1 1 auto",
        justifyContent: "center",
        textAlign: "center",
        margin: "2em 0"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["M" /* LoaderIcon */], {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    })
  );
};
Loading.displayName = "Loading";
Loading.displayName = "Loading";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["f" /* Radium */])()(Loading));

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MapMarker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\map-marker\\index.jsx";




var PinSvg = function PinSvg(_ref) {
  var onClick = _ref.onClick,
      style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 33 51", onClick: onClick, style: style || {}, __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M16.7 0h-.4C7.3.1 0 7.4 0 16.5c0 .3 0 1.3.2 2.6.1.8.2 1.5.7 2.6.4 1.1.6 1.7 1.2 2.9C6.6 33.5 14.6 47.8 15 48.5s1.6 2.5 1.6 2.5 1.2-1.8 1.6-2.5 8.4-15 12.9-23.9c.6-1.2.8-1.8 1.2-2.9.4-1.1.6-1.8.7-2.6.2-1.3.2-2.3.2-2.6C33 7.4 25.7.1 16.7 0zm-.2 22.5c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z", __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    })
  );
};

PinSvg.displayName = "PinSvg";
PinSvg.displayName = "PinSvg";
PinSvg.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

function MapMarker(_ref2) {
  var zIndex = _ref2.zIndex,
      active = _ref2.active,
      _ref2$hover = _ref2.hover,
      hover = _ref2$hover === undefined ? false : _ref2$hover,
      text = _ref2.text,
      onClick = _ref2.onClick;

  var dim = active ? "3.25em" : "2em";
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { fontSize: "16px" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: [{
          position: "absolute",
          top: 0,
          left: 0
        }, zIndex && { zIndex: zIndex }], __source: {
          fileName: _jsxFileName,
          lineNumber: 22
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: [{
            display: active ? "flex" : "block",
            flexDirection: "column",
            alignItems: "center",
            pointerEvents: "none",
            transform: "translate(-50%, -100%)"
          }, active && { zIndex: "10" }], __source: {
            fileName: _jsxFileName,
            lineNumber: 31
          }
        },
        active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          {
            onClick: onClick,
            style: [{
              fontWeight: "600",
              fontSize: "81%",
              textTransform: "uppercase",
              letterSpacing: ".2em",
              padding: "1em 1.5em",
              position: "relative",
              whiteSpace: "nowrap",
              background: "#fff",
              marginBottom: "1em",
              cursor: "pointer",
              pointerEvents: "initial",
              border: "1px #d5d5d5 solid"
            }], __source: {
              fileName: _jsxFileName,
              lineNumber: 43
            }
          },
          text
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PinSvg, {
          onClick: onClick,
          style: {
            height: dim,
            cursor: "pointer",
            pointerEvents: "initial",
            transition: "all .32s ease-in-out",
            fill: active || hover ? "#910A2D" : "#101010"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 64
          }
        })
      )
    )
  );
}

MapMarker.displayName = "MapMarker";
MapMarker.displayName = "MapMarker";
MapMarker.propTypes = {
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationDelay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(MapMarker));

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_google_map_react__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_google_map_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_google_map_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apis_google_maps__ = __webpack_require__(104);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\map-with-markers\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var defaultOptions = {
  gestureHandling: "auto",
  mapTypeControl: false,
  scrollwheel: false,
  disableDoubleClickZoom: __WEBPACK_IMPORTED_MODULE_4_constants_environment__["b" /* HAS_TOUCH */],
  fullscreenControl: false
};

var MapWithMarkers = function MapWithMarkers(_ref) {
  var defaultCenter = _ref.defaultCenter,
      defaultZoom = _ref.defaultZoom,
      map = _ref.map,
      locations = _ref.locations,
      activeIndex = _ref.activeIndex,
      handleClickOnLocation = _ref.handleClickOnLocation,
      options = _ref.options,
      rest = _objectWithoutProperties(_ref, ["defaultCenter", "defaultZoom", "map", "locations", "activeIndex", "handleClickOnLocation", "options"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.googleMapContainer, __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_google_map_react___default.a,
        _extends({}, rest, {
          resetBoundsOnResize: true,
          googleMapLoader: __WEBPACK_IMPORTED_MODULE_6_apis_google_maps__["c" /* getGoogleMapsApi */],
          defaultCenter: defaultCenter,
          defaultZoom: defaultZoom,
          zoom: map.zoom,
          center: map.center,
          options: _extends({}, defaultOptions, options),
          lockCenter: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 29
          }
        }),
        locations && locations.map(function (marker, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["O" /* MapMarker */], {
            key: index,
            lat: marker.lat,
            lng: marker.lng,
            animationDelay: (locations.slice().sort(function (a, b) {
              return b.lat - a.lat;
            }).indexOf(marker) + 1) * 0.25 + 0.666,
            zIndex: activeIndex === index ? 100000 : index,
            text: marker.name,
            active: activeIndex === index,
            hover: marker.hover,
            onClick: function onClick() {
              handleClickOnLocation(index);
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 41
            }
          });
        })
      )
    )
  );
};

MapWithMarkers.displayName = "MapWithMarkers";
MapWithMarkers.displayName = "MapWithMarkers";
MapWithMarkers.propTypes = {
  locations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    lat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
    lng: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
  })),
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  defaultZoom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  defaultCenter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  map: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    zoom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    center: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      lat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      lng: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
    })
  }),
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  handleClickOnLocation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

MapWithMarkers.defaultProps = {
  map: {
    center: {
      lat: -37.8390361,
      lng: 144.9997397
    },
    zoom: 17
  },
  options: {},
  handleClickOnLocation: function handleClickOnLocation() {}
};

var styles = {
  googleMapContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["m" /* withRadium */])()(MapWithMarkers));

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _google_map = __webpack_require__(1501);

var _google_map2 = _interopRequireDefault(_google_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _google_map2.default;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _google_map_map = __webpack_require__(1502);

var _google_map_map2 = _interopRequireDefault(_google_map_map);

var _marker_dispatcher = __webpack_require__(1503);

var _marker_dispatcher2 = _interopRequireDefault(_marker_dispatcher);

var _google_map_markers = __webpack_require__(617);

var _google_map_markers2 = _interopRequireDefault(_google_map_markers);

var _google_map_markers_prerender = __webpack_require__(1505);

var _google_map_markers_prerender2 = _interopRequireDefault(_google_map_markers_prerender);

var _google_heatmap = __webpack_require__(1506);

var _google_map_loader = __webpack_require__(409);

var _google_map_loader2 = _interopRequireDefault(_google_map_loader);

var _geo = __webpack_require__(1507);

var _geo2 = _interopRequireDefault(_geo);

var _raf = __webpack_require__(1509);

var _raf2 = _interopRequireDefault(_raf);

var _pick = __webpack_require__(1510);

var _pick2 = _interopRequireDefault(_pick);

var _omit = __webpack_require__(618);

var _omit2 = _interopRequireDefault(_omit);

var _log = __webpack_require__(623);

var _log2 = _interopRequireDefault(_log);

var _isEmpty = __webpack_require__(1511);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isNumber = __webpack_require__(1512);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _detect = __webpack_require__(1513);

var _detect2 = _interopRequireDefault(_detect);

var _shallowEqual = __webpack_require__(619);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _isPlainObject = __webpack_require__(1514);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isArraysEqualEps = __webpack_require__(1515);

var _isArraysEqualEps2 = _interopRequireDefault(_isArraysEqualEps);

var _detectElementResize = __webpack_require__(1516);

var _detectElementResize2 = _interopRequireDefault(_detectElementResize);

var _passiveEvents = __webpack_require__(624);

var _passiveEvents2 = _interopRequireDefault(_passiveEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies, react/forbid-prop-types, react/no-find-dom-node, no-console */


// helpers


// loaders


// utils


// consts
var kEPS = 0.00001;
var K_GOOGLE_TILE_SIZE = 256;
// real minZoom calculated here _getMinZoom
var K_IDLE_TIMEOUT = 100;
var K_IDLE_CLICK_TIMEOUT = 300;
var DEFAULT_MIN_ZOOM = 3;
// Starting with version 3.32, the maps API calls `draw()` each frame during
// a zoom animation.
var DRAW_CALLED_DURING_ANIMATION_VERSION = 32;
var IS_REACT_16 = _reactDom2.default.createPortal !== undefined;

var createPortal = IS_REACT_16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function defaultOptions_() /* maps */{
  return {
    overviewMapControl: false,
    streetViewControl: false,
    rotateControl: true,
    mapTypeControl: false,
    // disable poi
    styles: [{
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    }],
    minZoom: DEFAULT_MIN_ZOOM // dynamically recalculted if possible during init
  };
}

var latLng2Obj = function latLng2Obj(latLng) {
  return (0, _isPlainObject2.default)(latLng) ? latLng : { lat: latLng[0], lng: latLng[1] };
};

var _checkMinZoom = function _checkMinZoom(zoom, minZoom) {
  if (false) {
    if (zoom < minZoom) {
      console.warn('GoogleMap: ' + // eslint-disable-line
      'minZoom option is less than recommended ' + 'minZoom option for your map sizes.\n' + 'overrided to value ' + minZoom);
    }
  }

  if (minZoom < zoom) {
    return zoom;
  }
  return minZoom;
};

var isFullScreen = function isFullScreen() {
  return document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement;
};

var GoogleMap = function (_Component) {
  _inherits(GoogleMap, _Component);

  // eslint-disable-line

  function GoogleMap(props) {
    _classCallCheck(this, GoogleMap);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._getMinZoom = function () {
      if (_this.geoService_.getWidth() > 0 || _this.geoService_.getHeight() > 0) {
        var tilesPerWidth = Math.ceil(_this.geoService_.getWidth() / K_GOOGLE_TILE_SIZE) + 2;
        var tilesPerHeight = Math.ceil(_this.geoService_.getHeight() / K_GOOGLE_TILE_SIZE) + 2;
        var maxTilesPerDim = Math.max(tilesPerWidth, tilesPerHeight);
        return Math.ceil((0, _log2.default)(maxTilesPerDim));
      }
      return DEFAULT_MIN_ZOOM;
    };

    _this._computeMinZoom = function (minZoom) {
      if (!(0, _isEmpty2.default)(minZoom)) {
        return minZoom;
      }
      return _this._getMinZoom();
    };

    _this._mapDomResizeCallback = function () {
      _this.resetSizeOnIdle_ = true;
      if (_this.maps_) {
        var originalCenter = _this.props.center || _this.props.defaultCenter;
        var currentCenter = _this.map_.getCenter();
        _this.maps_.event.trigger(_this.map_, 'resize');
        _this.map_.setCenter(_this.props.resetBoundsOnResize ? originalCenter : currentCenter);
      }
    };

    _this._setLayers = function (layerTypes) {
      layerTypes.forEach(function (layerType) {
        _this.layers_[layerType] = new _this.maps_[layerType]();
        _this.layers_[layerType].setMap(_this.map_);
      });
    };

    _this._renderPortal = function () {
      return _react2.default.createElement(_google_map_markers2.default, {
        experimental: _this.props.experimental,
        onChildClick: _this._onChildClick,
        onChildMouseDown: _this._onChildMouseDown,
        onChildMouseEnter: _this._onChildMouseEnter,
        onChildMouseLeave: _this._onChildMouseLeave,
        geoService: _this.geoService_,
        insideMapPanes: true,
        distanceToMouse: _this.props.distanceToMouse,
        getHoverDistance: _this._getHoverDistance,
        dispatcher: _this.markersDispatcher_
      });
    };

    _this._initMap = function () {
      // only initialize the map once
      if (_this.initialized_) {
        return;
      }
      _this.initialized_ = true;

      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);

      _this._onBoundsChanged(); // now we can calculate map bounds center etc...

      var bootstrapURLKeys = _extends({}, _this.props.apiKey && { key: _this.props.apiKey }, _this.props.bootstrapURLKeys);

      _this.props.googleMapLoader(bootstrapURLKeys, _this.props.heatmapLibrary).then(function (maps) {
        if (!_this.mounted_) {
          return;
        }

        var centerLatLng = _this.geoService_.getCenter();

        var propsOptions = {
          zoom: _this.props.zoom || _this.props.defaultZoom,
          center: new maps.LatLng(centerLatLng.lat, centerLatLng.lng)
        };

        // Start Heatmap
        if (_this.props.heatmap.positions) {
          Object.assign(_this, {
            heatmap: (0, _google_heatmap.generateHeatmap)(maps, _this.props.heatmap)
          });
          (0, _google_heatmap.optionsHeatmap)(_this.heatmap, _this.props.heatmap);
        }
        // End Heatmap

        // prevent to exapose full api
        // next props must be exposed (console.log(Object.keys(pick(maps, isPlainObject))))
        // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
        // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition",
        // "SymbolPath", "ZoomControlStyle",
        // "event", "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem",
        // "DistanceMatrixStatus",
        // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType",
        // "GeocoderStatus", "KmlLayerStatus",
        // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference",
        // "TravelMode", "UnitSystem"
        var mapPlainObjects = (0, _pick2.default)(maps, _isPlainObject2.default);
        var options = typeof _this.props.options === 'function' ? _this.props.options(mapPlainObjects) : _this.props.options;
        var defaultOptions = defaultOptions_(mapPlainObjects);

        var draggableOptions = !(0, _isEmpty2.default)(_this.props.draggable) && {
          draggable: _this.props.draggable
        };

        var minZoom = _this._computeMinZoom(options.minZoom);
        _this.minZoom_ = minZoom;

        var preMapOptions = _extends({}, defaultOptions, {
          minZoom: minZoom
        }, options, propsOptions);

        _this.defaultDraggableOption_ = !(0, _isEmpty2.default)(preMapOptions.draggable) ? preMapOptions.draggable : _this.defaultDraggableOption_;

        var mapOptions = _extends({}, preMapOptions, draggableOptions);

        mapOptions.minZoom = _checkMinZoom(mapOptions.minZoom, minZoom);

        var map = new maps.Map(_reactDom2.default.findDOMNode(_this.googleMapDom_), mapOptions);

        _this.map_ = map;
        _this.maps_ = maps;

        _this._setLayers(_this.props.layerTypes);

        // Parse `google.maps.version` to capture the major version number.
        var versionMatch = maps.version.match(/^3\.(\d+)\./);
        // The major version is the first (and only) captured group.
        var mapsVersion = versionMatch && Number(versionMatch[1]);

        // render in overlay
        var this_ = _this;
        var overlay = Object.assign(new maps.OverlayView(), {
          onAdd: function onAdd() {
            var K_MAX_WIDTH = typeof screen !== 'undefined' ? screen.width + 'px' : '2000px';
            var K_MAX_HEIGHT = typeof screen !== 'undefined' ? screen.height + 'px' : '2000px';

            var div = document.createElement('div');
            div.style.backgroundColor = 'transparent';
            div.style.position = 'absolute';
            div.style.left = '0px';
            div.style.top = '0px';
            div.style.width = K_MAX_WIDTH; // prevents some chrome draw defects
            div.style.height = K_MAX_HEIGHT;

            if (this_.props.overlayViewDivStyle) {
              var overlayViewDivStyle = this_.props.overlayViewDivStyle;

              if ((typeof overlayViewDivStyle === 'undefined' ? 'undefined' : _typeof(overlayViewDivStyle)) === 'object') {
                Object.keys(overlayViewDivStyle).forEach(function (property) {
                  div.style[property] = overlayViewDivStyle[property];
                });
              }
            }

            var panes = this.getPanes();
            panes.overlayMouseTarget.appendChild(div);
            this_.geoService_.setMapCanvasProjection(maps, overlay.getProjection());

            if (!IS_REACT_16) {
              createPortal(this_, this_._renderPortal(), div,
              // remove prerendered markers
              function () {
                return this_.setState({ overlay: div });
              });
            } else {
              this_.setState({ overlay: div });
            }
          },
          onRemove: function onRemove() {
            var renderedOverlay = this_.state.overlay;
            if (renderedOverlay && !IS_REACT_16) {
              _reactDom2.default.unmountComponentAtNode(renderedOverlay);
            }
            this_.setState({ overlay: null });
          },
          draw: function draw() {
            this_.updateCounter_++;
            this_._onBoundsChanged(map, maps, !this_.props.debounced);

            if (!this_.googleApiLoadedCalled_) {
              this_._onGoogleApiLoaded({ map: map, maps: maps });
              this_.googleApiLoadedCalled_ = true;
            }

            if (this_.mouse_) {
              var latLng = this_.geoService_.fromContainerPixelToLatLng(this_.mouse_);
              this_.mouse_.lat = latLng.lat;
              this_.mouse_.lng = latLng.lng;
            }

            this_._onChildMouseMove();

            if (this_.markersDispatcher_) {
              this_.markersDispatcher_.emit('kON_CHANGE');
              if (this_.fireMouseEventOnIdle_) {
                this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
              }
            }
          }
        });

        _this.overlay_ = overlay;

        overlay.setMap(map);
        if (_this.props.heatmap.positions) {
          _this.heatmap.setMap(map);
        }

        if (_this.props.onTilesLoaded) {
          maps.event.addListener(map, 'tilesloaded', function () {
            this_._onTilesLoaded();
          });
        }

        maps.event.addListener(map, 'zoom_changed', function () {
          // recalc position at zoom start
          if (this_.geoService_.getZoom() !== map.getZoom()) {
            if (!this_.zoomAnimationInProgress_) {
              this_.zoomAnimationInProgress_ = true;
              this_._onZoomAnimationStart();
            }

            // If draw() is not called each frame during a zoom animation,
            // simulate it.
            if (mapsVersion < DRAW_CALLED_DURING_ANIMATION_VERSION) {
              var TIMEOUT_ZOOM = 300;

              if (new Date().getTime() - _this.zoomControlClickTime_ < TIMEOUT_ZOOM) {
                // there is strange Google Map Api behavior in chrome when zoom animation of map
                // is started only on second raf call, if was click on zoom control
                // or +- keys pressed, so i wait for two rafs before change state

                // this does not fully prevent animation jump
                // but reduce it's occurence probability
                (0, _raf2.default)(function () {
                  return (0, _raf2.default)(function () {
                    this_.updateCounter_++;
                    this_._onBoundsChanged(map, maps);
                  });
                });
              } else {
                this_.updateCounter_++;
                this_._onBoundsChanged(map, maps);
              }
            }
          }
        });

        maps.event.addListener(map, 'idle', function () {
          if (_this.resetSizeOnIdle_) {
            _this._setViewSize();
            var currMinZoom = _this._computeMinZoom(_this.props.options.minZoom);

            if (currMinZoom !== _this.minZoom_) {
              _this.minZoom_ = currMinZoom;
              map.setOptions({ minZoom: currMinZoom });
            }

            _this.resetSizeOnIdle_ = false;
          }

          if (this_.zoomAnimationInProgress_) {
            this_.zoomAnimationInProgress_ = false;
            this_._onZoomAnimationEnd();
          }

          this_.updateCounter_++;
          this_._onBoundsChanged(map, maps);

          this_.dragTime_ = 0;

          if (this_.markersDispatcher_) {
            this_.markersDispatcher_.emit('kON_CHANGE');
          }
        });

        maps.event.addListener(map, 'mouseover', function () {
          // has advantage over div MouseLeave
          this_.mouseInMap_ = true;
        });

        // an alternative way to know the mouse is back within the map
        // This would not fire when clicking/interacting with google maps
        // own on-map countrols+markers. This handles an edge case for touch devices
        // + 'draggable:false' custom option. See #332 for more details.
        maps.event.addListener(map, 'click', function () {
          this_.mouseInMap_ = true;
        });

        maps.event.addListener(map, 'mouseout', function () {
          // has advantage over div MouseLeave
          this_.mouseInMap_ = false;
          this_.mouse_ = null;
          this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
        });

        maps.event.addListener(map, 'drag', function () {
          this_.dragTime_ = new Date().getTime();
          this_._onDrag(map);
        });
        // user choosing satellite vs roads, etc
        maps.event.addListener(map, 'maptypeid_changed', function () {
          this_._onMapTypeIdChange(map.getMapTypeId());
        });
      }).catch(function (e) {
        // notify callback of load failure
        _this._onGoogleApiLoaded({ map: null, maps: null });
        console.error(e); // eslint-disable-line no-console
        throw e;
      });
    };

    _this._onGoogleApiLoaded = function () {
      if (_this.props.onGoogleApiLoaded) {
        var _this$props;

        if (false) {
          console.warn('GoogleMap: ' + // eslint-disable-line
          'Usage of internal api objects is dangerous ' + 'and can cause a lot of issues.\n' + 'To hide this warning add yesIWantToUseGoogleMapApiInternals={true} ' + 'to <GoogleMap instance');
        }

        (_this$props = _this.props).onGoogleApiLoaded.apply(_this$props, arguments);
      }
    };

    _this._getHoverDistance = function () {
      return _this.props.hoverDistance;
    };

    _this._onDrag = function () {
      var _this$props2;

      return _this.props.onDrag && (_this$props2 = _this.props).onDrag.apply(_this$props2, arguments);
    };

    _this._onMapTypeIdChange = function () {
      var _this$props3;

      return _this.props.onMapTypeIdChange && (_this$props3 = _this.props).onMapTypeIdChange.apply(_this$props3, arguments);
    };

    _this._onZoomAnimationStart = function () {
      var _this$props4;

      return _this.props.onZoomAnimationStart && (_this$props4 = _this.props).onZoomAnimationStart.apply(_this$props4, arguments);
    };

    _this._onZoomAnimationEnd = function () {
      var _this$props5;

      return _this.props.onZoomAnimationEnd && (_this$props5 = _this.props).onZoomAnimationEnd.apply(_this$props5, arguments);
    };

    _this._onTilesLoaded = function () {
      return _this.props.onTilesLoaded && _this.props.onTilesLoaded();
    };

    _this._onChildClick = function () {
      if (_this.props.onChildClick) {
        var _this$props6;

        return (_this$props6 = _this.props).onChildClick.apply(_this$props6, arguments);
      }
      return undefined;
    };

    _this._onChildMouseDown = function (hoverKey, childProps) {
      _this.childMouseDownArgs_ = [hoverKey, childProps];
      if (_this.props.onChildMouseDown) {
        _this.props.onChildMouseDown(hoverKey, childProps, _extends({}, _this.mouse_));
      }
    };

    _this._onChildMouseUp = function () {
      if (_this.childMouseDownArgs_) {
        if (_this.props.onChildMouseUp) {
          var _this$props7;

          (_this$props7 = _this.props).onChildMouseUp.apply(_this$props7, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
        }
        _this.childMouseDownArgs_ = null;
        _this.childMouseUpTime_ = new Date().getTime();
      }
    };

    _this._onChildMouseMove = function () {
      if (_this.childMouseDownArgs_) {
        if (_this.props.onChildMouseMove) {
          var _this$props8;

          (_this$props8 = _this.props).onChildMouseMove.apply(_this$props8, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
        }
      }
    };

    _this._onChildMouseEnter = function () {
      if (_this.props.onChildMouseEnter) {
        var _this$props9;

        return (_this$props9 = _this.props).onChildMouseEnter.apply(_this$props9, arguments);
      }
      return undefined;
    };

    _this._onChildMouseLeave = function () {
      if (_this.props.onChildMouseLeave) {
        var _this$props10;

        return (_this$props10 = _this.props).onChildMouseLeave.apply(_this$props10, arguments);
      }
      return undefined;
    };

    _this._setViewSize = function () {
      if (!_this.mounted_) return;
      if (isFullScreen()) {
        _this.geoService_.setViewSize(window.innerWidth, window.innerHeight);
      } else {
        var mapDom = _reactDom2.default.findDOMNode(_this.googleMapDom_);
        _this.geoService_.setViewSize(mapDom.clientWidth, mapDom.clientHeight);
      }
      _this._onBoundsChanged();
    };

    _this._onWindowResize = function () {
      _this.resetSizeOnIdle_ = true;
    };

    _this._onMapMouseMove = function (e) {
      if (!_this.mouseInMap_) return;

      var currTime = new Date().getTime();
      var K_RECALC_CLIENT_RECT_MS = 50;

      if (currTime - _this.mouseMoveTime_ > K_RECALC_CLIENT_RECT_MS) {
        _this.boundingRect_ = e.currentTarget.getBoundingClientRect();
      }
      _this.mouseMoveTime_ = currTime;

      var mousePosX = e.clientX - _this.boundingRect_.left;
      var mousePosY = e.clientY - _this.boundingRect_.top;

      if (!_this.mouse_) {
        _this.mouse_ = { x: 0, y: 0, lat: 0, lng: 0 };
      }

      _this.mouse_.x = mousePosX;
      _this.mouse_.y = mousePosY;

      var latLng = _this.geoService_.fromContainerPixelToLatLng(_this.mouse_);
      _this.mouse_.lat = latLng.lat;
      _this.mouse_.lng = latLng.lng;

      _this._onChildMouseMove();

      if (currTime - _this.dragTime_ < K_IDLE_TIMEOUT) {
        _this.fireMouseEventOnIdle_ = true;
      } else {
        _this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
        _this.fireMouseEventOnIdle_ = false;
      }
    };

    _this._onClick = function () {
      var _this$props11;

      return _this.props.onClick && !_this.childMouseDownArgs_ && new Date().getTime() - _this.childMouseUpTime_ > K_IDLE_CLICK_TIMEOUT && _this.dragTime_ === 0 && (_this$props11 = _this.props).onClick.apply(_this$props11, arguments);
    };

    _this._onMapClick = function (event) {
      if (_this.markersDispatcher_) {
        // support touch events and recalculate mouse position on click
        _this._onMapMouseMove(event);
        var currTime = new Date().getTime();
        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
          if (_this.mouse_) {
            _this._onClick(_extends({}, _this.mouse_, {
              event: event
            }));
          }

          _this.markersDispatcher_.emit('kON_CLICK', event);
        }
      }
    };

    _this._onMapMouseDownNative = function (event) {
      if (!_this.mouseInMap_) return;

      _this._onMapMouseDown(event);
    };

    _this._onMapMouseDown = function (event) {
      if (_this.markersDispatcher_) {
        var currTime = new Date().getTime();
        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
          // Hovered marker detected at mouse move could be deleted at mouse down time
          // so it will be good to force hovered marker recalculation
          _this._onMapMouseMove(event);
          _this.markersDispatcher_.emit('kON_MDOWN', event);
        }
      }
    };

    _this._onMapMouseDownCapture = function () {
      if ((0, _detect2.default)().isChrome) {
        // to fix strange zoom in chrome
        _this.zoomControlClickTime_ = new Date().getTime();
      }
    };

    _this._onKeyDownCapture = function () {
      if ((0, _detect2.default)().isChrome) {
        _this.zoomControlClickTime_ = new Date().getTime();
      }
    };

    _this._isCenterDefined = function (center) {
      return center && ((0, _isPlainObject2.default)(center) && (0, _isNumber2.default)(center.lat) && (0, _isNumber2.default)(center.lng) || center.length === 2 && (0, _isNumber2.default)(center[0]) && (0, _isNumber2.default)(center[1]));
    };

    _this._onBoundsChanged = function (map, maps, callExtBoundsChange) {
      if (map) {
        var gmC = map.getCenter();
        _this.geoService_.setView([gmC.lat(), gmC.lng()], map.getZoom(), 0);
      }

      if ((_this.props.onChange || _this.props.onBoundsChange) && _this.geoService_.canProject()) {
        var zoom = _this.geoService_.getZoom();
        var bounds = _this.geoService_.getBounds();
        var centerLatLng = _this.geoService_.getCenter();

        if (!(0, _isArraysEqualEps2.default)(bounds, _this.prevBounds_, kEPS)) {
          if (callExtBoundsChange !== false) {
            var marginBounds = _this.geoService_.getBounds(_this.props.margin);
            if (_this.props.onBoundsChange) {
              _this.props.onBoundsChange(_this.centerIsObject_ ? _extends({}, centerLatLng) : [centerLatLng.lat, centerLatLng.lng], zoom, bounds, marginBounds);
            }

            if (_this.props.onChange) {
              _this.props.onChange({
                center: _extends({}, centerLatLng),
                zoom: zoom,
                bounds: {
                  nw: {
                    lat: bounds[0],
                    lng: bounds[1]
                  },
                  se: {
                    lat: bounds[2],
                    lng: bounds[3]
                  },
                  sw: {
                    lat: bounds[4],
                    lng: bounds[5]
                  },
                  ne: {
                    lat: bounds[6],
                    lng: bounds[7]
                  }
                },
                marginBounds: {
                  nw: {
                    lat: marginBounds[0],
                    lng: marginBounds[1]
                  },
                  se: {
                    lat: marginBounds[2],
                    lng: marginBounds[3]
                  },
                  sw: {
                    lat: marginBounds[4],
                    lng: marginBounds[5]
                  },
                  ne: {
                    lat: marginBounds[6],
                    lng: marginBounds[7]
                  }
                },

                size: _this.geoService_.hasSize() ? {
                  width: _this.geoService_.getWidth(),
                  height: _this.geoService_.getHeight()
                } : {
                  width: 0,
                  height: 0
                }
              });
            }

            _this.prevBounds_ = bounds;
          }
        }
      }
    };

    _this._registerChild = function (ref) {
      _this.googleMapDom_ = ref;
    };

    _this.mounted_ = false;
    _this.initialized_ = false;
    _this.googleApiLoadedCalled_ = false;

    _this.map_ = null;
    _this.maps_ = null;
    _this.prevBounds_ = null;
    _this.heatmap = null;

    _this.layers_ = {};

    _this.mouse_ = null;
    _this.mouseMoveTime_ = 0;
    _this.boundingRect_ = null;
    _this.mouseInMap_ = true;

    _this.dragTime_ = 0;
    _this.fireMouseEventOnIdle_ = false;
    _this.updateCounter_ = 0;

    _this.markersDispatcher_ = new _marker_dispatcher2.default(_this);
    _this.geoService_ = new _geo2.default(K_GOOGLE_TILE_SIZE);
    _this.centerIsObject_ = (0, _isPlainObject2.default)(_this.props.center);

    _this.minZoom_ = DEFAULT_MIN_ZOOM;
    _this.defaultDraggableOption_ = true;

    _this.zoomControlClickTime_ = 0;

    _this.childMouseDownArgs_ = null;
    _this.childMouseUpTime_ = 0;

    _this.googleMapDom_ = null;

    if (false) {
      if (_this.props.apiKey) {
        console.warn('GoogleMap: ' + // eslint-disable-line no-console
        'apiKey is deprecated, use ' + 'bootstrapURLKeys={{key: YOUR_API_KEY}} instead.');
      }

      if (_this.props.onBoundsChange) {
        console.warn('GoogleMap: ' + // eslint-disable-line no-console
        'onBoundsChange is deprecated, use ' + 'onChange({center, zoom, bounds, ...other}) instead.');
      }

      if ((0, _isEmpty2.default)(_this.props.center) && (0, _isEmpty2.default)(_this.props.defaultCenter)) {
        console.warn('GoogleMap: center or defaultCenter property must be defined' // eslint-disable-line no-console
        );
      }

      if ((0, _isEmpty2.default)(_this.props.zoom) && (0, _isEmpty2.default)(_this.props.defaultZoom)) {
        console.warn('GoogleMap: zoom or defaultZoom property must be defined' // eslint-disable-line no-console
        );
      }
    }

    if (_this._isCenterDefined(_this.props.center || _this.props.defaultCenter)) {
      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
    }

    _this.zoomAnimationInProgress_ = false;

    _this.state = {
      overlay: null
    };
    return _this;
  }

  GoogleMap.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.mounted_ = true;
    (0, _passiveEvents2.default)(window, 'resize', this._onWindowResize, false);
    (0, _passiveEvents2.default)(window, 'keydown', this._onKeyDownCapture, true);
    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
    // gmap can't prevent map drag if mousedown event already occured
    // the only workaround I find is prevent mousedown native browser event

    if (mapDom) {
      (0, _passiveEvents2.default)(mapDom, 'mousedown', this._onMapMouseDownNative, true);
    }

    (0, _passiveEvents2.default)(window, 'mouseup', this._onChildMouseUp, false);
    var bootstrapURLKeys = _extends({}, this.props.apiKey && { key: this.props.apiKey }, this.props.bootstrapURLKeys);

    this.props.googleMapLoader(bootstrapURLKeys, this.props.heatmapLibrary); // we can start load immediatly

    setTimeout(function () {
      // to detect size
      _this2._setViewSize();
      if (_this2._isCenterDefined(_this2.props.center || _this2.props.defaultCenter)) {
        _this2._initMap();
      }
    }, 0, this);
    if (this.props.resetBoundsOnResize) {
      var that = this;
      _detectElementResize2.default.addResizeListener(mapDom, that._mapDomResizeCallback);
    }
  };

  GoogleMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    if (false) {
      if (!(0, _shallowEqual2.default)(this.props.defaultCenter, nextProps.defaultCenter)) {
        console.warn("GoogleMap: defaultCenter prop changed. You can't change default props.");
      }

      if (!(0, _shallowEqual2.default)(this.props.defaultZoom, nextProps.defaultZoom)) {
        console.warn("GoogleMap: defaultZoom prop changed. You can't change default props.");
      }
    }

    if (!this._isCenterDefined(this.props.center) && this._isCenterDefined(nextProps.center)) {
      setTimeout(function () {
        return _this3._initMap();
      }, 0);
    }

    if (this.map_) {
      var centerLatLng = this.geoService_.getCenter();
      if (this._isCenterDefined(nextProps.center)) {
        var nextPropsCenter = latLng2Obj(nextProps.center);
        var currCenter = this._isCenterDefined(this.props.center) ? latLng2Obj(this.props.center) : null;

        if (!currCenter || Math.abs(nextPropsCenter.lat - currCenter.lat) + Math.abs(nextPropsCenter.lng - currCenter.lng) > kEPS) {
          if (Math.abs(nextPropsCenter.lat - centerLatLng.lat) + Math.abs(nextPropsCenter.lng - centerLatLng.lng) > kEPS) {
            this.map_.panTo({
              lat: nextPropsCenter.lat,
              lng: nextPropsCenter.lng
            });
          }
        }
      }

      if (!(0, _isEmpty2.default)(nextProps.zoom)) {
        // if zoom chaged by user
        if (Math.abs(nextProps.zoom - this.props.zoom) > 0) {
          this.map_.setZoom(nextProps.zoom);
        }
      }

      if (!(0, _isEmpty2.default)(this.props.draggable) && (0, _isEmpty2.default)(nextProps.draggable)) {
        // reset to default
        this.map_.setOptions({ draggable: this.defaultDraggableOption_ });
      } else if (!(0, _shallowEqual2.default)(this.props.draggable, nextProps.draggable)) {
        // also prevent this on window 'mousedown' event to prevent map move
        this.map_.setOptions({ draggable: nextProps.draggable });
      }

      // use shallowEqual to try avoid calling map._setOptions if only the ref changes
      if (!(0, _isEmpty2.default)(nextProps.options) && !(0, _shallowEqual2.default)(this.props.options, nextProps.options)) {
        var mapPlainObjects = (0, _pick2.default)(this.maps_, _isPlainObject2.default);
        var options = typeof nextProps.options === 'function' ? nextProps.options(mapPlainObjects) : nextProps.options;
        // remove zoom, center and draggable options as these are managed by google-maps-react
        options = (0, _omit2.default)(options, ['zoom', 'center', 'draggable']);

        if ('minZoom' in options) {
          var minZoom = this._computeMinZoom(options.minZoom);
          options.minZoom = _checkMinZoom(options.minZoom, minZoom);
        }

        this.map_.setOptions(options);
      }

      if (!(0, _shallowEqual2.default)(nextProps.layerTypes, this.props.layerTypes)) {
        Object.keys(this.layers_).forEach(function (layerKey) {
          _this3.layers_[layerKey].setMap(null);
          delete _this3.layers_[layerKey];
        });
        this._setLayers(nextProps.layerTypes);
      }
    }
  };

  GoogleMap.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // draggable does not affect inner components
    return !(0, _shallowEqual2.default)((0, _omit2.default)(this.props, ['draggable']), (0, _omit2.default)(nextProps, ['draggable'])) || !(0, _shallowEqual2.default)(this.state, nextState);
  };

  GoogleMap.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    this.markersDispatcher_.emit('kON_CHANGE');

    if (!(0, _shallowEqual2.default)(this.props.hoverDistance, prevProps.hoverDistance)) {
      this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
    }
  };

  GoogleMap.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted_ = false;
    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
    if (mapDom) {
      mapDom.removeEventListener('mousedown', this._onMapMouseDownNative, true);
    }
    window.removeEventListener('resize', this._onWindowResize);
    window.removeEventListener('keydown', this._onKeyDownCapture);
    window.removeEventListener('mouseup', this._onChildMouseUp, false);
    if (this.props.resetBoundsOnResize) {
      _detectElementResize2.default.removeResizeListener(mapDom, this._mapDomResizeCallback);
    }

    if (this.overlay_) {
      // this triggers overlay_.onRemove(), which will unmount the <GoogleMapMarkers/>
      this.overlay_.setMap(null);
    }

    if (this.maps_ && this.map_) {
      // fix google, as otherwise listeners works even without map
      this.map_.setOptions({ scrollwheel: false });
      this.maps_.event.clearInstanceListeners(this.map_);
    }

    this.map_ = null;
    this.maps_ = null;
    this.markersDispatcher_.dispose();

    this.resetSizeOnIdle_ = false;

    delete this.map_;
    delete this.markersDispatcher_;
  };
  // calc minZoom if map size available
  // it's better to not set minZoom less than this calculation gives
  // otherwise there is no homeomorphism between screen coordinates and map
  // (one map coordinate can have different screen coordinates)


  // this method works only if this.props.onChildMouseDown was called


  // this method works only if this.props.onChildMouseDown was called


  // K_IDLE_CLICK_TIMEOUT - looks like 300 is enough


  // gmap can't prevent map drag if mousedown event already occured
  // the only workaround I find is prevent mousedown native browser event


  GoogleMap.prototype.render = function render() {
    var overlay = this.state.overlay;
    var mapMarkerPrerender = !overlay ? _react2.default.createElement(_google_map_markers_prerender2.default, {
      experimental: this.props.experimental,
      onChildClick: this._onChildClick,
      onChildMouseDown: this._onChildMouseDown,
      onChildMouseEnter: this._onChildMouseEnter,
      onChildMouseLeave: this._onChildMouseLeave,
      geoService: this.geoService_,
      insideMapPanes: false,
      distanceToMouse: this.props.distanceToMouse,
      getHoverDistance: this._getHoverDistance,
      dispatcher: this.markersDispatcher_
    }) : null;

    return _react2.default.createElement(
      'div',
      {
        style: this.props.style,
        onMouseMove: this._onMapMouseMove,
        onMouseDownCapture: this._onMapMouseDownCapture,
        onClick: this._onMapClick
      },
      _react2.default.createElement(_google_map_map2.default, { registerChild: this._registerChild }),
      IS_REACT_16 && overlay && createPortal(this._renderPortal(), overlay),
      mapMarkerPrerender
    );
  };

  return GoogleMap;
}(_react.Component);

GoogleMap.propTypes = {
  apiKey: _propTypes2.default.string,
  bootstrapURLKeys: _propTypes2.default.any,

  defaultCenter: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
    lat: _propTypes2.default.number,
    lng: _propTypes2.default.number
  })]),
  center: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
    lat: _propTypes2.default.number,
    lng: _propTypes2.default.number
  })]),
  defaultZoom: _propTypes2.default.number,
  zoom: _propTypes2.default.number,
  onBoundsChange: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onChildClick: _propTypes2.default.func,
  onChildMouseDown: _propTypes2.default.func,
  onChildMouseUp: _propTypes2.default.func,
  onChildMouseMove: _propTypes2.default.func,
  onChildMouseEnter: _propTypes2.default.func,
  onChildMouseLeave: _propTypes2.default.func,
  onZoomAnimationStart: _propTypes2.default.func,
  onZoomAnimationEnd: _propTypes2.default.func,
  onDrag: _propTypes2.default.func,
  onMapTypeIdChange: _propTypes2.default.func,
  onTilesLoaded: _propTypes2.default.func,
  options: _propTypes2.default.any,
  distanceToMouse: _propTypes2.default.func,
  hoverDistance: _propTypes2.default.number,
  debounced: _propTypes2.default.bool,
  margin: _propTypes2.default.array,
  googleMapLoader: _propTypes2.default.any,
  onGoogleApiLoaded: _propTypes2.default.func,
  yesIWantToUseGoogleMapApiInternals: _propTypes2.default.bool,
  draggable: _propTypes2.default.bool,
  style: _propTypes2.default.any,
  resetBoundsOnResize: _propTypes2.default.bool,
  layerTypes: _propTypes2.default.arrayOf(_propTypes2.default.string) // ['TransitLayer', 'TrafficLayer']
};
GoogleMap.defaultProps = {
  distanceToMouse: function distanceToMouse(pt, mousePos /* , markerProps */) {
    return Math.sqrt((pt.x - mousePos.x) * (pt.x - mousePos.x) + (pt.y - mousePos.y) * (pt.y - mousePos.y));
  },

  hoverDistance: 30,
  debounced: true,
  options: defaultOptions_,
  googleMapLoader: _google_map_loader2.default,
  yesIWantToUseGoogleMapApiInternals: false,
  style: {
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    position: 'relative'
  },
  layerTypes: [],
  heatmap: {},
  heatmapLibrary: false
};
GoogleMap.googleMapLoader = _google_map_loader2.default;
exports.default = GoogleMap;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var style = {
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  margin: 0,
  padding: 0,
  position: 'absolute'
};

var GoogleMapMap = function (_Component) {
  _inherits(GoogleMapMap, _Component);

  function GoogleMapMap() {
    _classCallCheck(this, GoogleMapMap);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  GoogleMapMap.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false; // disable react on this div
  };

  GoogleMapMap.prototype.render = function render() {
    var registerChild = this.props.registerChild;

    return _react2.default.createElement('div', { ref: registerChild, style: style });
  };

  return GoogleMapMap;
}(_react.Component);

exports.default = GoogleMapMap;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _eventemitter = __webpack_require__(1504);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarkerDispatcher = function (_EventEmitter) {
  _inherits(MarkerDispatcher, _EventEmitter);

  function MarkerDispatcher(gmapInstance) {
    _classCallCheck(this, MarkerDispatcher);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.gmapInstance = gmapInstance;
    return _this;
  }

  MarkerDispatcher.prototype.getChildren = function getChildren() {
    return this.gmapInstance.props.children;
  };

  MarkerDispatcher.prototype.getMousePosition = function getMousePosition() {
    return this.gmapInstance.mouse_;
  };

  MarkerDispatcher.prototype.getUpdateCounter = function getUpdateCounter() {
    return this.gmapInstance.updateCounter_;
  };

  MarkerDispatcher.prototype.dispose = function dispose() {
    this.gmapInstance = null;
    this.removeAllListeners();
  };

  return MarkerDispatcher;
}(_eventemitter2.default);

exports.default = MarkerDispatcher;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() { /* Nothing to set */ }

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events
    , names = []
    , name;

  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt]
    , events = [];

  if (fn) {
    if (listeners.fn) {
      if (
           listeners.fn !== fn
        || (once && !listeners.once)
        || (context && listeners.context !== context)
      ) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];
  else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    { style: style },
    _react2.default.createElement(_google_map_markers2.default, _extends({}, props, { prerender: true }))
  );
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _google_map_markers = __webpack_require__(617);

var _google_map_markers2 = _interopRequireDefault(_google_map_markers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  width: '50%',
  height: '50%',
  left: '50%',
  top: '50%',
  // backgroundColor: 'red',
  margin: 0,
  padding: 0,
  position: 'absolute'
  // opacity: 0.3
};

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var generateHeatmap = exports.generateHeatmap = function generateHeatmap(instance, _ref) {
  var positions = _ref.positions;
  return new instance.visualization.HeatmapLayer({
    data: positions.reduce(function (acc, _ref2) {
      var lat = _ref2.lat,
          lng = _ref2.lng,
          _ref2$weight = _ref2.weight,
          weight = _ref2$weight === undefined ? 1 : _ref2$weight;

      acc.push({
        location: new instance.LatLng(lat, lng),
        weight: weight
      });
      return acc;
    }, [])
  });
};

var optionsHeatmap = exports.optionsHeatmap = function optionsHeatmap(instance, _ref3) {
  var _ref3$options = _ref3.options,
      options = _ref3$options === undefined ? {} : _ref3$options;
  return Object.keys(options).map(function (option) {
    return instance.set(option, options[option]);
  });
};

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pointGeometry = __webpack_require__(620);

var _pointGeometry2 = _interopRequireDefault(_pointGeometry);

var _lat_lng = __webpack_require__(621);

var _lat_lng2 = _interopRequireDefault(_lat_lng);

var _transform = __webpack_require__(1508);

var _transform2 = _interopRequireDefault(_transform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Geo = function () {
  function Geo(tileSize) {
    _classCallCheck(this, Geo);

    // left_top view пользует гугл
    // super();
    this.hasSize_ = false;
    this.hasView_ = false;
    this.transform_ = new _transform2.default(tileSize || 512);
  }

  Geo.prototype.setView = function setView(center, zoom, bearing) {
    this.transform_.center = _lat_lng2.default.convert(center);
    this.transform_.zoom = +zoom;
    this.transform_.bearing = +bearing;
    this.hasView_ = true;
  };

  Geo.prototype.setViewSize = function setViewSize(width, height) {
    this.transform_.width = width;
    this.transform_.height = height;
    this.hasSize_ = true;
  };

  Geo.prototype.setMapCanvasProjection = function setMapCanvasProjection(maps, mapCanvasProjection) {
    this.maps_ = maps;
    this.mapCanvasProjection_ = mapCanvasProjection;
  };

  Geo.prototype.canProject = function canProject() {
    return this.hasSize_ && this.hasView_;
  };

  Geo.prototype.hasSize = function hasSize() {
    return this.hasSize_;
  };

  /** Returns the pixel position relative to the map center. */


  Geo.prototype.fromLatLngToCenterPixel = function fromLatLngToCenterPixel(ptLatLng) {
    return this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
  };

  /**
   * Returns the pixel position relative to the map panes,
   * or relative to the map center if there are no panes.
   */


  Geo.prototype.fromLatLngToDivPixel = function fromLatLngToDivPixel(ptLatLng) {
    if (this.mapCanvasProjection_) {
      var latLng = new this.maps_.LatLng(ptLatLng.lat, ptLatLng.lng);
      return this.mapCanvasProjection_.fromLatLngToDivPixel(latLng);
    }
    return this.fromLatLngToCenterPixel(ptLatLng);
  };

  /** Returns the pixel position relative to the map top-left. */


  Geo.prototype.fromLatLngToContainerPixel = function fromLatLngToContainerPixel(ptLatLng) {
    if (this.mapCanvasProjection_) {
      var latLng = new this.maps_.LatLng(ptLatLng.lat, ptLatLng.lng);
      return this.mapCanvasProjection_.fromLatLngToContainerPixel(latLng);
    }

    var pt = this.fromLatLngToCenterPixel(ptLatLng);
    pt.x -= this.transform_.worldSize * Math.round(pt.x / this.transform_.worldSize);

    pt.x += this.transform_.width / 2;
    pt.y += this.transform_.height / 2;

    return pt;
  };

  /** Returns the LatLng for the given offset from the map top-left. */


  Geo.prototype.fromContainerPixelToLatLng = function fromContainerPixelToLatLng(ptXY) {
    if (this.mapCanvasProjection_) {
      var latLng = this.mapCanvasProjection_.fromContainerPixelToLatLng(ptXY);
      return { lat: latLng.lat(), lng: latLng.lng() };
    }

    var ptxy = _extends({}, ptXY);
    ptxy.x -= this.transform_.width / 2;
    ptxy.y -= this.transform_.height / 2;
    var ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptxy));

    ptRes.lng -= 360 * Math.round(ptRes.lng / 360); // convert 2 google format
    return ptRes;
  };

  Geo.prototype.getWidth = function getWidth() {
    return this.transform_.width;
  };

  Geo.prototype.getHeight = function getHeight() {
    return this.transform_.height;
  };

  Geo.prototype.getZoom = function getZoom() {
    return this.transform_.zoom;
  };

  Geo.prototype.getCenter = function getCenter() {
    var ptRes = this.transform_.pointLocation({ x: 0, y: 0 });

    return ptRes;
  };

  Geo.prototype.getBounds = function getBounds(margins, roundFactor) {
    var bndT = margins && margins[0] || 0;
    var bndR = margins && margins[1] || 0;
    var bndB = margins && margins[2] || 0;
    var bndL = margins && margins[3] || 0;

    if (this.getWidth() - bndR - bndL > 0 && this.getHeight() - bndT - bndB > 0) {
      var topLeftCorner = this.transform_.pointLocation(_pointGeometry2.default.convert({
        x: bndL - this.getWidth() / 2,
        y: bndT - this.getHeight() / 2
      }));
      var bottomRightCorner = this.transform_.pointLocation(_pointGeometry2.default.convert({
        x: this.getWidth() / 2 - bndR,
        y: this.getHeight() / 2 - bndB
      }));

      var res = [topLeftCorner.lat, topLeftCorner.lng, // NW
      bottomRightCorner.lat, bottomRightCorner.lng, // SE
      bottomRightCorner.lat, topLeftCorner.lng, // SW
      topLeftCorner.lat, bottomRightCorner.lng];

      if (roundFactor) {
        res = res.map(function (r) {
          return Math.round(r * roundFactor) / roundFactor;
        });
      }
      return res;
    }

    return [0, 0, 0, 0];
  };

  return Geo;
}();

exports.default = Geo;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable class-methods-use-this */


var _pointGeometry = __webpack_require__(620);

var _pointGeometry2 = _interopRequireDefault(_pointGeometry);

var _lat_lng = __webpack_require__(621);

var _lat_lng2 = _interopRequireDefault(_lat_lng);

var _wrap = __webpack_require__(622);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// A single transform, generally used for a single tile to be scaled, rotated, and zoomed.
var Transform = function () {
  function Transform(tileSize, minZoom, maxZoom) {
    _classCallCheck(this, Transform);

    this.tileSize = tileSize || 512; // constant

    this._minZoom = minZoom || 0;
    this._maxZoom = maxZoom || 52;

    this.latRange = [-85.05113, 85.05113];

    this.width = 0;
    this.height = 0;
    this.zoom = 0;
    this.center = new _lat_lng2.default(0, 0);
    this.angle = 0;
  }

  Transform.prototype.zoomScale = function zoomScale(zoom) {
    return Math.pow(2, zoom);
  };

  Transform.prototype.scaleZoom = function scaleZoom(scale) {
    return Math.log(scale) / Math.LN2;
  };

  Transform.prototype.project = function project(latlng, worldSize) {
    return new _pointGeometry2.default(this.lngX(latlng.lng, worldSize), this.latY(latlng.lat, worldSize));
  };

  Transform.prototype.unproject = function unproject(point, worldSize) {
    return new _lat_lng2.default(this.yLat(point.y, worldSize), this.xLng(point.x, worldSize));
  };

  // lat/lon <-> absolute pixel coords convertion
  Transform.prototype.lngX = function lngX(lon, worldSize) {
    return (180 + lon) * (worldSize || this.worldSize) / 360;
  };

  // latitude to absolute y coord


  Transform.prototype.latY = function latY(lat, worldSize) {
    var y = 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360));
    return (180 - y) * (worldSize || this.worldSize) / 360;
  };

  Transform.prototype.xLng = function xLng(x, worldSize) {
    return x * 360 / (worldSize || this.worldSize) - 180;
  };

  Transform.prototype.yLat = function yLat(y, worldSize) {
    var y2 = 180 - y * 360 / (worldSize || this.worldSize);
    return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
  };

  Transform.prototype.locationPoint = function locationPoint(latlng) {
    var p = this.project(latlng);
    return this.centerPoint._sub(this.point._sub(p)._rotate(this.angle));
  };

  Transform.prototype.pointLocation = function pointLocation(p) {
    var p2 = this.centerPoint._sub(p)._rotate(-this.angle);
    return this.unproject(this.point.sub(p2));
  };

  _createClass(Transform, [{
    key: 'minZoom',
    get: function get() {
      return this._minZoom;
    },
    set: function set(zoom) {
      this._minZoom = zoom;
      this.zoom = Math.max(this.zoom, zoom);
    }
  }, {
    key: 'maxZoom',
    get: function get() {
      return this._maxZoom;
    },
    set: function set(zoom) {
      this._maxZoom = zoom;
      this.zoom = Math.min(this.zoom, zoom);
    }
  }, {
    key: 'worldSize',
    get: function get() {
      return this.tileSize * this.scale;
    }
  }, {
    key: 'centerPoint',
    get: function get() {
      return new _pointGeometry2.default(0, 0); // this.size._div(2);
    }
  }, {
    key: 'size',
    get: function get() {
      return new _pointGeometry2.default(this.width, this.height);
    }
  }, {
    key: 'bearing',
    get: function get() {
      return -this.angle / Math.PI * 180;
    },
    set: function set(bearing) {
      this.angle = -(0, _wrap.wrap)(bearing, -180, 180) * Math.PI / 180;
    }
  }, {
    key: 'zoom',
    get: function get() {
      return this._zoom;
    },
    set: function set(zoom) {
      var zoomV = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
      this._zoom = zoomV;
      this.scale = this.zoomScale(zoomV);
      this.tileZoom = Math.floor(zoomV);
      this.zoomFraction = zoomV - this.tileZoom;
    }
  }, {
    key: 'x',
    get: function get() {
      return this.lngX(this.center.lng);
    }
  }, {
    key: 'y',
    get: function get() {
      return this.latY(this.center.lat);
    }
  }, {
    key: 'point',
    get: function get() {
      return new _pointGeometry2.default(this.x, this.y);
    }
  }]);

  return Transform;
}();

exports.default = Transform;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = raf;
function raf(callback) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(callback);
  }

  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;

  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
}

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = pick;
// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js

function pick(obj, fn) {
  return Object.keys(obj).reduce(function (result, key) {
    if (fn(obj[key])) {
      result[key] = obj[key]; // eslint-disable-line
    }
    return result;
  }, {});
}

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isEmpty = function isEmpty(val) {
  // check for empty object {}, array []
  if (val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    if (Object.keys(val).length === 0) {
      return true;
    }
  } else if (val === null || val === undefined || val === '') {
    // check for undefined, null and ""
    return true;
  }
  return false;
};

exports.default = isEmpty;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isNumber;
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}

var objectToString = Object.prototype.toString;

function isNumber(value) {
  var numberTag = '[object Number]';
  return typeof value === 'number' || isObjectLike(value) && objectToString.call(value) === numberTag;
}

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = detectBrowser;
// http://stackoverflow.com/questions/5899783/detect-safari-chrome-ie-firefox-opera-with-user-agent
var detectBrowserResult_ = null;

function detectBrowser() {
  if (detectBrowserResult_) {
    return detectBrowserResult_;
  }

  if (typeof navigator !== 'undefined') {
    var isExplorer = navigator.userAgent.indexOf('MSIE') > -1;
    var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
    var isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;

    var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
    var isSafari = navigator.userAgent.indexOf('Safari') > -1;

    if (isChrome && isSafari) {
      isSafari = false;
    }

    if (isChrome && isOpera) {
      isChrome = false;
    }

    detectBrowserResult_ = {
      isExplorer: isExplorer,
      isFirefox: isFirefox,
      isOpera: isOpera,
      isChrome: isChrome,
      isSafari: isSafari
    };
    return detectBrowserResult_;
  }

  detectBrowserResult_ = {
    isChrome: true,
    isExplorer: false,
    isFirefox: false,
    isOpera: false,
    isSafari: false
  };

  return detectBrowserResult_;
}

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isPlainObject;
// source taken from https://github.com/rackt/redux/blob/master/src/utils/isPlainObject.js
var fnToString = function fnToString(fn) {
  return Function.prototype.toString.call(fn);
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return false;
  }

  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;

  if (proto === null) {
    return true;
  }

  var constructor = proto.constructor;

  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
}

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isArraysEqualEps;
function isArraysEqualEps(arrayA, arrayB, eps) {
  if (arrayA && arrayB) {
    for (var i = 0; i !== arrayA.length; ++i) {
      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
        return false;
      }
    }
    return true;
  }
  return false;
}

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _passiveEvents = __webpack_require__(624);

var _passiveEvents2 = _interopRequireDefault(_passiveEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Reliable `window` and `document` detection
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Check `document` and `window` in case of server-side rendering
/* eslint-disable */
/**
* Detect Element Resize.
* Forked in order to guard against unsafe 'window' and 'document' references.
*
* https://github.com/sdecima/javascript-detect-element-resize
* Sebastian Decima
*
* version: 0.5.3
**/

var _window;
if (canUseDOM) {
  _window = window;
} else if (typeof self !== 'undefined') {
  _window = self;
} else {
  _window = undefined;
}

var attachEvent = typeof document !== 'undefined' && document.attachEvent;
var stylesCreated = false;

if (canUseDOM && !attachEvent) {
  var requestFrame = function () {
    var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
      return _window.setTimeout(fn, 20);
    };
    return function (fn) {
      return raf(fn);
    };
  }();

  var cancelFrame = function () {
    var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
    return function (id) {
      return cancel(id);
    };
  }();

  var resetTriggers = function resetTriggers(element) {
    var triggers = element.__resizeTriggers__,
        expand = triggers.firstElementChild,
        contract = triggers.lastElementChild,
        expandChild = expand.firstElementChild;
    contract.scrollLeft = contract.scrollWidth;
    contract.scrollTop = contract.scrollHeight;
    expandChild.style.width = expand.offsetWidth + 1 + 'px';
    expandChild.style.height = expand.offsetHeight + 1 + 'px';
    expand.scrollLeft = expand.scrollWidth;
    expand.scrollTop = expand.scrollHeight;
  };

  var checkTriggers = function checkTriggers(element) {
    return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
  };

  var scrollListener = function scrollListener(e) {
    var element = this;
    resetTriggers(this);
    if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
    this.__resizeRAF__ = requestFrame(function () {
      if (checkTriggers(element)) {
        element.__resizeLast__.width = element.offsetWidth;
        element.__resizeLast__.height = element.offsetHeight;
        element.__resizeListeners__.forEach(function (fn) {
          fn.call(element, e);
        });
      }
    });
  };

  /* Detect CSS Animations support to detect element display/re-attach */
  var animation = false,
      animationstring = 'animation',
      keyframeprefix = '',
      animationstartevent = 'animationstart',
      domPrefixes = 'Webkit Moz O ms'.split(' '),
      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
      pfx = '';

  if (canUseDOM) {
    var elm = document.createElement('fakeelement');
    if (elm.style.animationName !== undefined) {
      animation = true;
    }

    if (animation === false) {
      for (var i = 0; i < domPrefixes.length; i++) {
        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
          pfx = domPrefixes[i];
          animationstring = pfx + 'Animation';
          keyframeprefix = '-' + pfx.toLowerCase() + '-';
          animationstartevent = startEvents[i];
          animation = true;
          break;
        }
      }
    }
  }

  var animationName = 'resizeanim';
  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
}

var createStyles = function createStyles() {
  if (!stylesCreated) {
    //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
    var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');

    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
    stylesCreated = true;
  }
};

var addResizeListener = function addResizeListener(element, fn) {
  if (element.parentNode === undefined) {
    var tempParentDiv = document.createElement('div');
    element.parentNode = tempParentDiv;
  }
  element = element.parentNode;
  if (attachEvent) element.attachEvent('onresize', fn);else {
    if (!element.__resizeTriggers__) {
      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
      createStyles();
      element.__resizeLast__ = {};
      element.__resizeListeners__ = [];
      (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
      element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
      element.appendChild(element.__resizeTriggers__);
      resetTriggers(element);

      (0, _passiveEvents2.default)(element, 'scroll', scrollListener, true);

      /* Listen for a css animation to detect element display/re-attach */
      animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
        if (e.animationName == animationName) resetTriggers(element);
      });
    }
    element.__resizeListeners__.push(fn);
  }
};

var removeResizeListener = function removeResizeListener(element, fn) {
  element = element.parentNode;
  if (attachEvent) element.detachEvent('onresize', fn);else {
    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
    if (!element.__resizeListeners__.length) {
      element.removeEventListener('scroll', scrollListener);
      element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
    }
  }
};

module.exports = {
  addResizeListener: addResizeListener,
  removeResizeListener: removeResizeListener
};

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\pagination-selector\\index.jsx";






var PaginationSelector = function PaginationSelector(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === undefined ? 0 : _ref$count,
      _ref$current = _ref.current,
      current = _ref$current === undefined ? 0 : _ref$current,
      _ref$maxDisplay = _ref.maxDisplay,
      maxDisplay = _ref$maxDisplay === undefined ? 3 : _ref$maxDisplay,
      _ref$onClickNumber = _ref.onClickNumber,
      onClickNumber = _ref$onClickNumber === undefined ? function () {} : _ref$onClickNumber,
      _ref$onClickNext = _ref.onClickNext,
      onClickNext = _ref$onClickNext === undefined ? function () {} : _ref$onClickNext,
      _ref$onClickBack = _ref.onClickBack,
      onClickBack = _ref$onClickBack === undefined ? function () {} : _ref$onClickBack;

  var workingDisplay = maxDisplay - 2;
  var min = Math.floor((current - 1) / workingDisplay) * workingDisplay;
  var max = min + workingDisplay;
  var leftSlice = min - 1;
  var rightSlice = max + 1;
  var pageNumbers = Array(count).fill().map(function (v, index) {
    return index + 1;
  }).slice(leftSlice < 0 ? 0 : leftSlice, rightSlice);
  var showPrev = current > 1;
  var showNext = current < count;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27
      }
    },
    showPrev && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        key: "back",
        onClick: onClickBack,
        style: [styles.link, styles.inactive, { padding: "0 0 0 1em" }],
        tabIndex: 0, __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        }
      },
      "< PREV"
    ),
    pageNumbers.map(function (pageNumber) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: pageNumber, style: styles.number, __source: {
            fileName: _jsxFileName,
            lineNumber: 38
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            key: "goto_" + pageNumber,
            onClick: function onClick() {
              return onClickNumber(pageNumber);
            },
            tabIndex: 0,
            style: [styles.link, pageNumber === current ? styles.active : styles.inactive], __source: {
              fileName: _jsxFileName,
              lineNumber: 39
            }
          },
          pageNumber
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.line, __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          }
        })
      );
    }),
    showNext && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        key: "next",
        onClick: onClickNext,
        style: [styles.link, styles.inactive],
        tabIndex: 0, __source: {
          fileName: _jsxFileName,
          lineNumber: 50
        }
      },
      "NEXT >"
    )
  );
};

PaginationSelector.displayName = "PaginationSelector";
PaginationSelector.displayName = "PaginationSelector";
PaginationSelector.propTypes = {
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  maxDisplay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClickNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickNext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickBack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var styles = {
  wrapper: {
    display: "inline-block",
    fontSize: "90%"
  },
  line: {
    borderRight: "1px " + __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARK + " solid",
    marginBottom: "0.14em"
  },
  inactive: {
    color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARK
  },
  active: {
    color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].BLACK
  },
  link: _extends({}, __WEBPACK_IMPORTED_MODULE_3_constants_general_style__["a" /* BASE_COPY */], {
    margin: "0",
    outline: "none",
    textAlign: "inherit",
    fontFamily: "inherit",
    overflow: "visible",
    background: "none",
    border: "none",
    padding: "0 1em",
    fontWeight: "400",
    lineHeight: "1.1",
    cursor: "pointer",
    transition: "color .25s",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].BLACK,
      textDecoration: "underline"
    },
    ":focus": {
      outline: 0
    }
  }),
  number: {
    display: "inline-flex"
  }
};

PaginationSelector.propTypes = {};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])()(PaginationSelector));

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_swipeable_views__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_swipeable_views___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_swipeable_views__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_function__ = __webpack_require__(35);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\slideshow\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/** Slideshow Component */

var Slideshow = function (_Component) {
  _inherits(Slideshow, _Component);

  function Slideshow(props) {
    _classCallCheck(this, Slideshow);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = function (index, type) {
      if (type === 'end') {
        _this.props.handleChange ? _this.props.handleChange(index) : _this.setState({ active: index });
      }
      var gtmEventsByIndex = _this.props.gtmEventsByIndex;

      if (gtmEventsByIndex) {
        gtmEventsByIndex[index] && Object(__WEBPACK_IMPORTED_MODULE_6_utils_function__["e" /* invokeFuncs */])(gtmEventsByIndex[index]);
      }
    };

    _this.state = {
      active: props.activate
    };
    return _this;
  }

  Slideshow.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    nextProps.activate !== null && this.setState({ active: nextProps.activate });
  };

  /**
   * @param {Number} [noAnimation] - Do not play swiping animation
   * @param {Boolean} [showBullets] - Display a list of navigation bullets below the slideshow.
   * @param {Boolean} [bulletsBelow] - Display a bullet list below slide.
   * @param {String} [disclaimer] - Dislaimer text as xmlString
   * @param {Array|SlideshowItem} components - Array of components.
   * @returns {ReactElement} React Component
   */
  Slideshow.prototype.render = function render() {
    var _this2 = this;

    var bulletButtons = this.props.showBullets && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["_7" /* StepCounter */], {
      steps: this.props.components || this.props.children,
      active: this.state.active + 1,
      setStep: function setStep(number) {
        _this2.handleChange(number - 1, 'end');
      },
      horizontal: true, __source: {
        fileName: _jsxFileName,
        lineNumber: 56
      }
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { 'data-test': 'slideshow', style: { overflow: 'hidden' }, __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        }
      },
      !this.props.bulletsBelow && bulletButtons,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_swipeable_views___default.a,
        {
          animateTransitions: !this.props.noAnimation,
          index: this.state.active,
          onSwitching: this.handleChange,
          style: styles.base,
          slideStyle: { overflow: 'hidden' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 67
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_3_containers_utilities__["a" /* childParser */])(this.props).map(function (component, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              'data-test': index === _this2.state.active ? 'active-slide' : 'slide',
              key: index,
              style: _this2.props.isItemWrapperStyle ? styles.slideshowItem : undefined, __source: {
                fileName: _jsxFileName,
                lineNumber: 74
              }
            },
            component
          );
        })
      ),
      this.props.bulletsBelow && bulletButtons
    );
  };

  return Slideshow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Slideshow.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  noAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showBullets: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bulletsBelow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  gtmEventsByIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  handleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  activate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  isItemWrapperStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Slideshow.defaultProps = {
  activate: 0,
  loop: true,
  isItemWrapperStyle: true
};
Slideshow.displayName = 'Slideshow';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(Slideshow));

var styles = {
  base: {
    position: 'relative',
    textAlign: 'center'
  },
  slideshowItem: {
    width: '100%',
    height: '100%'
    // pointerEvents: 'none' Video needs to be playable in slide
  }
};

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_map_location_locations_section__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\static-dealer-map-with-toggle\\index.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var StaticDealerMapWithToggle = function (_Component) {
  _inherits(StaticDealerMapWithToggle, _Component);

  function StaticDealerMapWithToggle(props) {
    _classCallCheck(this, StaticDealerMapWithToggle);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      activeDepartmentIndex: props.initialDepartmentIndex || 0
    };
    return _this;
  }

  StaticDealerMapWithToggle.prototype.render = function render() {
    var _this2 = this;

    var dealers = this.props.dealers.map(function (_ref) {
      var info = _ref.info;
      return info;
    });

    var options = this.props.dealers.map(function (_ref2) {
      var label = _ref2.label;
      return label;
    });

    var activeDealer = dealers[this.state.activeDepartmentIndex];

    activeDealer = _extends({}, activeDealer, {
      lat: Number(activeDealer.lat),
      lng: Number(activeDealer.lng)
    });

    var selector = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], {
      onChange: function onChange(props, index) {
        _this2.setState({ activeDepartmentIndex: index });
      },
      divider: true,
      active: this.state.activeDepartmentIndex,
      options: options.map(function (name) {
        return { name: name };
      }), __source: {
        fileName: _jsxFileName,
        lineNumber: 28
      }
    });

    var mapBlock = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { display: "flex", textAlign: "left" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 38
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { flex: "1 1 100%" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 39
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers_map_location_locations_section__["a" /* default */], {
          compact: this.props.compact,
          gtm: this.props.gtm,
          locations: [_extends({
            active: true,
            animateHeight: false
          }, activeDealer)],
          __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        })
      ),
      !this.props.compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { position: "relative", flex: "1 1 100%" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 51
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["P" /* MapWithMarkers */], {
          locations: [activeDealer],
          activeIndex: 0,
          options: { disableDefaultUI: true },
          map: {
            center: _extends({}, activeDealer),
            zoom: 17
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 52
          }
        })
      )
    );

    var children = this.props.children;


    return children ? children({
      selector: selector,
      mapBlock: mapBlock
    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { textAlign: "center" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 77
        }
      },
      selector,
      mapBlock
    );
  };

  return StaticDealerMapWithToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

StaticDealerMapWithToggle.displayName = "StaticDealerMapWithToggle";


StaticDealerMapWithToggle.propTypes = {
  initialDepartmentIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dealers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }))
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["b" /* DetectCompact */])())(StaticDealerMapWithToggle));

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_environment__ = __webpack_require__(12);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\step-counter\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Arrow = function Arrow() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      style: {
        position: 'absolute',
        left: '-10.1px',
        top: '7.4px',
        overflow: 'hidden',
        width: '10px',
        height: '55%'
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'svg',
      { viewBox: '0 0 10 21', __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { style: { fill: '#fff' }, points: '10 0.73 1.37 10.5 10 20.27 10 0.73', __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', {
        style: { fill: '#d5d5d5' },
        points: '9.28 21 0 10.5 9.28 0 9.28 0 10 0 10 0.73 10 0.73 1.37 10.5 10 20.27 10 20.27 10 21 9.28 21 9.28 21', __source: {
          fileName: _jsxFileName,
          lineNumber: 18
        }
      })
    )
  );
};

Arrow.displayName = 'Arrow';
Arrow.displayName = 'Arrow';

/** Step Counter Component. */
var StepCounter = function (_Component) {
  _inherits(StepCounter, _Component);

  function StepCounter() {
    _classCallCheck(this, StepCounter);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.hover = function (index) {
      _this.setState({ hover: index });
    };

    _this.reset = function () {
      _this.setState({ hover: -1 });
    };

    _this.state = {
      hover: -1
    };
    return _this;
  }

  StepCounter.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        horizontal = _props.horizontal,
        hidden = _props.hidden,
        steps = _props.steps,
        active = _props.active,
        setStep = _props.setStep,
        _props$theme = _props.theme,
        theme = _props$theme === undefined ? 'dark' : _props$theme;
    var hover = this.state.hover;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ol',
      {
        'data-test': 'StepCounter',
        style: [styles.base, { flexDirection: horizontal ? 'row' : 'column' }, hidden ? styles.hide : styles.show], __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        }
      },
      steps.map(function (step, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: index, style: [styles.step], __source: {
              fileName: _jsxFileName,
              lineNumber: 61
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            'data-test': 'step-counter-item-' + index,
            key: index,
            style: [styles.circle, active === index + 1 ? styles.active : styles.inactive, { borderColor: theme === 'light' ? '#FFF' : '#191919' }],
            onMouseOver: function onMouseOver() {
              return _this2.hover(index);
            },
            onMouseOut: _this2.reset,
            onClick: function onClick() {
              return setStep(index + 1);
            },
            onKeyDown: function onKeyDown() {
              return setStep(index + 1);
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 62
            }
          }),
          step.heading && !__WEBPACK_IMPORTED_MODULE_3_constants_environment__["b" /* HAS_TOUCH */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              style: [styles.bubble, horizontal ? styles.horizontalBubble : styles.verticalBubble], __source: {
                fileName: _jsxFileName,
                lineNumber: 74
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: [hover === index ? { opacity: 1 } : { opacity: 0, transform: 'translateX(-1em)' }], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 79
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: [styles.bubbleText], __source: {
                    fileName: _jsxFileName,
                    lineNumber: 85
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Arrow, {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 86
                  }
                }),
                step.heading
              )
            )
          )
        );
      })
    );
  };

  return StepCounter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

StepCounter.propTypes = {
  steps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
StepCounter.displayName = 'StepCounter';


var styles = {
  base: {
    listStyle: 'none',
    padding: 0,
    margin: '.5em 0',
    display: 'inline-flex',
    fontSize: '150%',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity .25s ease',
    zIndex: 10,
    width: '100%'
  },
  hide: {
    opacity: 0
  },
  show: {
    opacity: 1
  },
  step: {
    flex: '0 0 1.5em',
    width: '1em',
    height: '1em',
    position: 'relative',
    display: 'flex'
  },
  active: {
    width: '1em',
    height: '1em',
    background: 'transparent',
    borderWidth: '2px',
    borderStyle: 'solid',
    ':hover': {
      background: 'transparent'
    }
  },
  inactive: {
    background: '#999',
    borderWidth: '2px',
    borderColor: '#999',
    ':hover': {
      background: '#191919',
      borderColor: '#191919'
    }
  },
  circle: {
    margin: 'auto',
    boxSizing: 'border-box',
    width: '.5em',
    position: 'relative',
    transform: 'translate3d(0,0,0)',
    height: '.5em',
    borderRadius: '50%',
    borderWidth: '2px',
    transition: '.25s',
    cursor: 'pointer'
  },
  bubble: {
    position: 'absolute',
    display: 'inline-block',
    padding: '0.4em 0.4em 0.8em',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    fontSize: '57%',
    borderRadius: '0.2em',
    color: '#191919',
    letterSpacing: '.1em',
    textTransform: 'uppercase',
    fontWeight: 400,
    pointerEvents: 'none'
  },
  horizontalBubble: {
    left: '50%',
    bottom: '-2em',
    transform: 'translateX(-50%)'
  },
  verticalBubble: {
    bottom: '50%',
    left: '2em',
    transform: 'translateY(50%)'
  },
  bubbleText: {
    position: 'relative',
    top: '.2em',
    left: '10px',
    transition: '.25s',
    padding: '1em .5em .66em .5em',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#ddd',
    background: 'white',
    borderRadius: '0.2em'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(StepCounter));

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(9);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var toArray = function toArray(children) {
  if ((typeof children === "undefined" ? "undefined" : _typeof(children)) === "object") {
    return Object.values(children);
  }
  return children;
};

var SteppedFlow = function (_Component) {
  _inherits(SteppedFlow, _Component);

  function SteppedFlow(props) {
    _classCallCheck(this, SteppedFlow);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      steps: props.children.length,
      activeStepIndex: 0
    };
    Object(__WEBPACK_IMPORTED_MODULE_2_utils__["d" /* bindAll */])(["changeStep", "setStep"], _this);
    return _this;
  }

  SteppedFlow.prototype.changeStep = function changeStep(dir) {
    var stepIndex = this.state.activeStepIndex + dir;
    this.setStep(stepIndex);
  };

  SteppedFlow.prototype.setStep = function setStep(ref) {
    var index = ref;

    if (typeof ref === "string") {
      index = Object.keys(this.props.children).indexOf(ref);
    }

    if (index > this.state.steps - 1 || index < 0) return;

    this.setState({ activeStepIndex: index });
  };

  SteppedFlow.prototype.render = function render() {
    var _this2 = this;

    var activeStep = toArray(this.props.children)[this.state.activeStepIndex];

    if (!activeStep || typeof activeStep !== "function") {
      return null;
    }

    return activeStep({
      index: this.state.activeStepIndex,
      setStep: this.setStep,
      nextStep: function nextStep() {
        return _this2.changeStep(1);
      },
      prevStep: function prevStep() {
        return _this2.changeStep(-1);
      },
      isEnd: this.state.steps - 1 === this.state.activeStepIndex
    });
  };

  return SteppedFlow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SteppedFlow.displayName = "SteppedFlow";


SteppedFlow.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func)
};

/* harmony default export */ __webpack_exports__["a"] = (SteppedFlow);

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\summary\\item.jsx";






var Pencil = function Pencil(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ viewBox: "0 0 14 14" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10.39,6l0.9,0.9L6.22,11.91,0,14,2.1,7.79,7.15,2.73,8,3.62,3.2,8.47,2.32,11.08l0.6,0.59,2.61-.88ZM4,9.4A0.63,0.63,0,0,1,4.16,9L8.77,4.34l0.9,0.9L5.05,9.85A0.63,0.63,0,0,1,4.6,10,0.65,0.65,0,0,1,4,9.4Zm10-6a1.66,1.66,0,0,1-.48,1.16L12,6.13,7.88,2,9.4,0.48a1.65,1.65,0,0,1,2.33,0l1.8,1.79A1.66,1.66,0,0,1,14,3.45Zm-1.27,0a0.37,0.37,0,0,0-.1-0.27l-1.8-1.8a0.38,0.38,0,0,0-.54,0L9.67,2,12,4.34l0.63-.63A0.35,0.35,0,0,0,12.73,3.45Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    })
  );
};

Pencil.displayName = "Pencil";
Pencil.displayName = "Pencil";
var SummaryItem = function SummaryItem(_ref) {
  var border = _ref.border,
      label = _ref.label,
      value = _ref.value,
      editText = _ref.editText,
      onClick = _ref.onClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: [styles.base, border && { borderTop: "1px solid #ddd", paddingTop: "1.5em", marginTop: "1.5em" }],
      "data-test": "summary-item", __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 27
        }
      },
      label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { display: "flex", justifyContent: "space-between", fontWeight: 200 }, __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        }
      },
      value
    ),
    onClick && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { onClick: onClick, style: styles.editButton, __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pencil, {
        style: styles.svg,
        "data-test": "summary-item-step-" + label, __source: {
          fileName: _jsxFileName,
          lineNumber: 33
        }
      }),
      editText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: styles.editText, __source: {
            fileName: _jsxFileName,
            lineNumber: 36
          }
        },
        editText
      )
    )
  );
};

SummaryItem.displayName = "SummaryItem";
SummaryItem.displayName = "SummaryItem";
SummaryItem.propTypes = {
  border: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  editText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(SummaryItem));

var styles = {
  base: {
    textAlign: "left",
    position: "relative",
    paddingTop: "1em"
  },
  label: {
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_DARK,
    textTransform: "uppercase",
    fontSize: "80%",
    margin: "0 0 1em",
    display: "block",
    fontWeight: "600",
    letterSpacing: ".2em"
  },
  editText: {
    fontSize: "90%",
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_DARK,
    marginLeft: "0.5em",
    marginBottom: "-0.2em"
  },
  editButton: {
    position: "absolute",
    top: "1em",
    right: 0,
    cursor: "pointer",
    transition: ".25s",
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].RED,
    display: "flex",
    alignItems: "center",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].BLACK
    }
  },
  svg: {
    height: "1em",
    width: "1em",
    fill: "currentColor"
  }
};

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_summary__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\summary-with-price\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var RenderPrice = function RenderPrice(_ref) {
  var price = _ref.price,
      disclaimer = _ref.disclaimer,
      gtm = _ref.gtm;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { whiteSpace: "noWrap" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["a" /* A */],
      {
        withoutStyle: true,
        style: { fontSize: "32px" },
        onClick: function onClick(event) {
          if (event && event.target && event.target.querySelector('button')) {
            event.target.querySelector('button').click();
          }
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 11
        }
      },
      "$",
      !!price && price.toLocaleString(),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["i" /* Disclaimer */],
        {
          Icon: __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_14" /* StarIcon */],
          gtm: {
            category: gtm.category,
            action: gtm.action
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        },
        disclaimer
      )
    )
  );
};

RenderPrice.displayName = "RenderPrice";
RenderPrice.displayName = "RenderPrice";
var renderPriceStyles = {
  sup: {
    lineHeight: 0.5,
    fontSize: "50%"
  }
};

RenderPrice.propTypes = {
  disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var mapItems = function mapItems(_ref2, index) {
  var label = _ref2.label,
      value = _ref2.value,
      priceDifference = _ref2.priceDifference,
      rest = _objectWithoutProperties(_ref2, ["label", "value", "priceDifference"]);

  return _extends({
    label: label,
    value: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { key: index + "value", style: styles.value, __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        }
      },
      value
    ), !!priceDifference && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { key: index + "value", style: styles.value, __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        }
      },
      "$",
      Number(priceDifference).toLocaleString('nz')
    )]
  }, rest);
};

var SummaryWithPrice = function SummaryWithPrice(_ref3) {
  var previousGeneration = _ref3.previousGeneration,
      _ref3$items = _ref3.items,
      items = _ref3$items === undefined ? [] : _ref3$items,
      gtm = _ref3.gtm,
      price = _ref3.price,
      safetyModel = _ref3.safetyModel,
      _ref3$includeSafetyMo = _ref3.includeSafetyModel,
      includeSafetyModel = _ref3$includeSafetyMo === undefined ? false : _ref3$includeSafetyMo,
      rest = _objectWithoutProperties(_ref3, ["previousGeneration", "items", "gtm", "price", "safetyModel", "includeSafetyModel"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_components_summary__["a" /* default */],
    _extends({ items: items.map(mapItems) }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70
      }
    }),
    safetyModel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: {
          textAlign: "left",
          borderTop: "1px solid #dddddd",
          marginTop: "1.5em",
          paddingTop: "1.5em"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 73
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["U" /* Interactive */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 79
          }
        },
        "Options"
      ),
      safetyModel
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { "data-test": "price", style: styles.priceContainer, __source: {
          fileName: _jsxFileName,
          lineNumber: 83
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["U" /* Interactive */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 84
          }
        },
        price.message || "Recommended Retail Price"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: styles.price, __source: {
            fileName: _jsxFileName,
            lineNumber: 85
          }
        },
        !!price.price && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderPrice, { price: includeSafetyModel && price.safetyModelPrice ? price.safetyModelPrice : price.price, disclaimer: price.disclaimer, gtm: gtm, __source: {
            fileName: _jsxFileName,
            lineNumber: 87
          }
        }),
        !price.price && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { display: "flex", justifyContent: "flex-end" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 90
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["M" /* LoaderIcon */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 91
            }
          })
        )
      )
    )
  );
};

SummaryWithPrice.displayName = "SummaryWithPrice";
SummaryWithPrice.displayName = "SummaryWithPrice";
SummaryWithPrice.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  previousGeneration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
  })),
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  disableBase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
    price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(SummaryWithPrice));

var styles = {
  label: {
    color: "#aaa",
    textTransform: "uppercase",
    fontSize: "80%",
    margin: ".5em 0",
    display: "block",
    fontWeight: 600,
    letterSpacing: ".2em",
    textAlign: "left",
    flex: "1 1 40%"
  },
  priceContainer: {
    borderTop: "1px solid #ddd",
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    padding: '1.5em 0px',
    margin: '24px 0px 0px 0px'
  },
  price: {
    flex: "1 1 50%",
    fontSize: "200%",
    fontWeight: 200,
    textAlign: "right"
  }
};

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicContainers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\tabs\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Tabs = function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs() {
    var _temp, _this, _ret;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._onChange = function (activeIndex) {
      var _this$props = _this.props,
          options = _this$props.options,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

      onChange(options[activeIndex], activeIndex);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Tabs.prototype.render = function render() {
    var _props = this.props,
        _props$onChange = _props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange,
        rest = _objectWithoutProperties(_props, ["onChange"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicContainers__["I" /* Tabs */], _extends({
      onClick: this._onChange
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    }));
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tabs.displayName = "Tabs";


/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_animations_lib_flash__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_animations_lib_flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_animations_lib_flash__);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\time-component\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var flashKeyFrame = Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___["b" /* keyframes */])({
  from: {
    opacity: 1
  },
  '70%': {
    opacity: 0
  },
  to: {
    opacity: 0
  }
});

var TimeComponent = function (_Component) {
  _inherits(TimeComponent, _Component);

  function TimeComponent() {
    _classCallCheck(this, TimeComponent);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getHours12 = function (date) {
      return (date.getHours() + 24) % 12 || 12;
    };

    _this.state = {
      now: new Date()
    };
    return _this;
  }

  TimeComponent.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setInterval(function () {
      _this2.setState({
        now: new Date()
      });
    }, 1000);
  };

  TimeComponent.prototype.render = function render() {
    var TimeStyles = {
      time: {
        fontFamily: 'dseg7',
        textAlign: 'center',
        fontSize: '225%',
        transform: 'translate(-12%,-35%)',
        fontStyle: 'italic',
        letterSpacing: '0.18em',
        opacity: '0.5',
        color: '#ff2a3a',
        textShadow: '#ff2a3a 0px 0px 30px'
      },
      backTime: {
        position: 'absolute',
        opacity: 0.5,
        color: '#5f151f',
        zIndex: '-1',
        textShadow: '0px 0px 10px #4f010c'
      },
      dots: {
        animation: 'x 1s infinite',
        animationName: flashKeyFrame
      }
      // if we want the blinking effect, will need to rewrite.

    };var hours = String(this.getHours12(this.state.now));
    var mins = (Number(this.state.now.getMinutes()) < 10 ? '0' : '') + String(this.state.now.getMinutes());
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: TimeStyles.time, __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: TimeStyles.backTime, __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          },
          '88'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          },
          ':'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 73
            }
          },
          '88'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 77
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { style: { visibility: 'collapse' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 78
            }
          },
          Number(this.getHours12(this.state.now)) < 10 ? '0' : ''
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 81
            }
          },
          hours
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { style: TimeStyles.dots, __source: {
              fileName: _jsxFileName,
              lineNumber: 84
            }
          },
          ':'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 85
            }
          },
          mins
        )
      )
    );
  };

  return TimeComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TimeComponent.displayName = 'TimeComponent';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___["a" /* default */])(TimeComponent));

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var visible = {
  opacity: 1
};


var invisible = {
  opacity: 0
};

var flash = {
  from: visible,
  '25%': invisible,
  '50%': visible,
  '75%': invisible,
  to: visible
};

exports.default = flash;

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_measure__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_in_view__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_in_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_in_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicUtils_debounce__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_environment__ = __webpack_require__(17);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\video-background\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













/** Renders a video background component.
 * @param {Url} src - Href Value.
 * @param {Bool} relative - Position.
 * @param {String} poster - Label Value.
 * @returns {ReactElement} react component
 */

var VideoBackground = function (_PureComponent) {
  _inherits(VideoBackground, _PureComponent);

  function VideoBackground() {
    _classCallCheck(this, VideoBackground);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.handleFrame = function () {
      if (_this.props.updateCurrentFrame) {
        setInterval(function () {
          _this.props.updateCurrentFrame(_this.video);
        }, 100);
      }
    };

    _this.state = {
      videoRatio: 0,
      wrapperRatio: 0,
      inview: false,
      canPlay: false,
      componentMounted: false,
      muted: true
    };
    return _this;
  }

  VideoBackground.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.setState({
      componentMounted: true
    }, function () {
      _this2.domNode = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this2);
      _this2.scrollHandler = Object(__WEBPACK_IMPORTED_MODULE_7_utils__["M" /* rafThrottle */])(function () {
        return _this2.inViewHandler();
      });
      _this2.inViewHandler();
      _this2.handleFrame();
      __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_environment__["i" /* WINDOW */].addEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_debounce__["a" /* default */])(_this2.scrollHandler, 250), {
        passive: true
      });
    });
  };

  VideoBackground.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_environment__["i" /* WINDOW */].removeEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_9_AtomicUtils_debounce__["a" /* default */])(this.scrollHandler, 250), {
      passive: true
    });
    this.scrollHandler && this.scrollHandler.cancel();
  };

  VideoBackground.prototype.inViewHandler = function inViewHandler() {
    if (!this.domNode) return;
    if (this.props.isContainerInView) __WEBPACK_IMPORTED_MODULE_5_in_view___default.a.offset({ right: -99999, left: -99999 });
    if (__WEBPACK_IMPORTED_MODULE_5_in_view___default.a.is(this.domNode)) this.setState({ inview: true });else if (!this.state.fade) this.setState({ inview: false });
  };

  VideoBackground.prototype.render = function render() {
    var _this3 = this;

    if (!this.state.componentMounted) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67
      }
    });
    var _props = this.props,
        muted = _props.muted,
        src = _props.src,
        _onLoadedMetadata = _props.onLoadedMetadata,
        relative = _props.relative,
        _props$useInView = _props.useInView,
        useInView = _props$useInView === undefined ? true : _props$useInView,
        _props$soundColor = _props.soundColor,
        soundColor = _props$soundColor === undefined ? "white" : _props$soundColor,
        _props$soundDirection = _props.soundDirection,
        soundDirection = _props$soundDirection === undefined ? "left" : _props$soundDirection,
        _props$getVideoRef = _props.getVideoRef,
        getVideoRef = _props$getVideoRef === undefined ? function () {} : _props$getVideoRef;
    var wrapperRatio = this.state.wrapperRatio;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_measure__["a" /* default */],
      {
        onResize: function onResize(_ref) {
          var entry = _ref.entry;

          if (wrapperRatio !== entry.width / entry.height) {
            _this3.setState({
              wrapperRatio: entry.width / entry.height
            }, function () {
              _this3.props.getDimensionsChild && _this3.props.getDimensionsChild({
                width: _this3.video.offsetWidth,
                height: _this3.video.offsetHeight
              });
            });
          } else {
            _this3.props.getDimensionsChild && _this3.props.getDimensionsChild({
              width: _this3.video.offsetWidth,
              height: _this3.video.offsetHeight
            });
          }
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 80
        }
      },
      function (_ref2) {
        var measureRef = _ref2.measureRef;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            ref: measureRef,
            style: {
              position: relative ? "relative" : "absolute",
              width: "100%",
              height: "100%",
              boxSizing: "border-box",
              overflow: "hidden",
              top: 0,
              left: 0
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 99
            }
          },
          (!useInView || _this3.state.inview) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video", {
            muted: __WEBPACK_IMPORTED_MODULE_6_constants_environment__["b" /* HAS_TOUCH */] || muted || _this3.state.muted,
            autoPlay: true,
            playsInline: true,
            ref: function ref(element) {
              _this3.video = element;
              getVideoRef(element);
            },
            loop: _this3.props.loop,
            poster: _this3.props.poster,
            onLoadedMetadata: function onLoadedMetadata(element) {
              _onLoadedMetadata && _onLoadedMetadata(element);
              var target = element.target;

              _this3.setState({ videoRatio: target.videoWidth / target.videoHeight });
            },
            onLoadedData: function onLoadedData() {
              _this3.setState({ canPlay: true });
            },
            onTimeUpdate: function onTimeUpdate(element) {
              _this3.setState({ canPlay: true });
            },
            style: relative ? styles.relative : styles.absolute,
            src: src,
            type: "video/mp4", __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            }
          }),
          _this3.props.showSoundIcon && _this3.state.canPlay && !muted && !__WEBPACK_IMPORTED_MODULE_6_constants_environment__["b" /* HAS_TOUCH */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              onClick: function onClick() {
                _this3.setState({
                  muted: !_this3.state.muted
                });
              },
              style: styles.icon(soundColor, soundDirection), __source: {
                fileName: _jsxFileName,
                lineNumber: 133
              }
            },
            _this3.state.muted && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Q" /* MuteIcon */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 140
              }
            }),
            !_this3.state.muted && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["_15" /* UnMuteIcon */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 141
              }
            })
          )
        );
      }
    );
  };

  return VideoBackground;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

VideoBackground.displayName = "VideoBackground";

VideoBackground.propTypes = {
  onLoadedMetadata: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  poster: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  soundDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  soundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  relative: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSoundIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  muted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isContainerInView: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  loop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

VideoBackground.defaultProps = {
  loop: true,
  showSoundIcon: false
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(VideoBackground));

var styles = {
  absolute: {
    position: "absolute",
    left: "0",
    top: "0",
    minHeight: "100%",
    minWidth: "100%",
    zIndex: -1,
    objectFit: "cover",
    width: "100%",
    height: "100%"
  },
  relative: {
    maxWidth: "100%",
    maxHeight: "100%",
    position: "relative",
    height: "auto"
  },
  icon: function icon(soundColor, soundDirection) {
    return {
      position: "absolute",
      width: "40px",
      height: "40px",
      bottom: 0,
      right: soundDirection === "right" ? 0 : "auto",
      left: soundDirection === "left" ? 0 : "auto",
      padding: "30px",
      color: soundColor,
      cursor: "pointer"
    };
  }
};

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(9);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\video-with-timed-frames\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var VideoWithTimedFrames = function (_PureComponent) {
  _inherits(VideoWithTimedFrames, _PureComponent);

  function VideoWithTimedFrames() {
    _classCallCheck(this, VideoWithTimedFrames);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.updateCurrentFrame = function (videoElement) {
      var currentTime = videoElement.currentTime;
      if (currentTime) {
        // Find frame with time greater than current time but less than next frame time
        var currentFrameIndex = _this.props.frames.findIndex(function (_ref) {
          var startTime = _ref.startTime,
              endTime = _ref.endTime;
          return currentTime > startTime && currentTime < endTime;
        });
        // // Set frame as current (no special exceptions for -1)
        _this.setState({ currentFrameIndex: currentFrameIndex });
      }
    };

    _this.initialiseVideo = function (_ref2) {
      var target = _ref2.target;

      // Check all frames are valid (set for a time less than the duration of the video)
      if (_this.props.frames.some(function (_ref3) {
        var time = _ref3.time;
        return time >= target.duration;
      })) {
        console.warn('Some of the frames provided are set to display after the video ends');
      }
    };

    _this.getDimensionsChild = function (entry) {
      _this.setState({
        videoWidth: entry.width,
        videoHeight: entry.height
      });
    };

    _this.state = {
      currentFrameIndex: -1,
      videoWidth: 1,
      videoHeight: 1,
      widthParent: 1,
      heightParent: 1
    };
    return _this;
  }

  VideoWithTimedFrames.prototype.render = function render() {
    var currentFrameIndex = this.state.currentFrameIndex;

    // Set frame variable to currentFrames components (if no frame was found render null)

    var frame = currentFrameIndex > -1 ? this.props.frames[currentFrameIndex] : null;
    var components = frame && frame.components ? frame.components : null;
    var scale = Math.min(this.state.videoWidth / 1000, this.state.videoHeight / 1000);
    var frameStyle = frame && frame.resizable ? {
      transform: 'translate(-50%, -50%) scale(' + scale + ')',
      position: 'absolute',
      width: this.state.videoWidth / scale + 'px',
      height: '100%',
      left: '50%',
      top: '50%'
    } : {
      height: '100%'
    };

    var scrollToSlug = this.props.scrollToSlug;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: [this.props.styles, { position: 'relative' }], __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: frameStyle, __source: {
            fileName: _jsxFileName,
            lineNumber: 66
          }
        },
        components
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_22" /* VideoBackground */], {
        onLoadedMetadata: this.initialiseVideo,
        updateCurrentFrame: this.updateCurrentFrame,
        getDimensionsChild: this.getDimensionsChild,
        muted: this.props.muted,
        useInView: this.props.useInView,
        src: this.props.videoSrc,
        poster: this.props.poster,
        showSoundIcon: true,
        loop: this.props.loopVideo, __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        }
      }),
      scrollToSlug && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: {
            position: 'absolute',
            right: 0,
            bottom: 0,
            padding: '30px'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 81
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["Q" /* RoundIconButton */], {
          iconId: 'arrow-down',
          onClick: function onClick() {
            return Object(__WEBPACK_IMPORTED_MODULE_5_utils__["O" /* scrollToElementId */])(scrollToSlug);
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 87
          }
        })
      )
    );
  };

  return VideoWithTimedFrames;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

VideoWithTimedFrames.displayName = 'VideoWithTimedFrames';

VideoWithTimedFrames.defaultProps = {
  styles: {},
  frames: []
};

VideoWithTimedFrames.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  videoSrc: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  loopVideo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  scrollToSlug: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  muted: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  frames: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    time: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    components: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
  }))
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["f" /* Radium */])(VideoWithTimedFrames));

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\account-icon.jsx";



var AccountIcon = function AccountIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 13 14", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M4.21585541,3.53866667 C4.21585541,5.24933333 5.19305812,6.53866667 6.5,6.53866667 C7.8056069,6.53866667 8.78414459,5.24933333 8.78414459,3.53866667 C8.78414459,2.304 7.71215855,1.21066667 6.5,1.21066667 C5.28784145,1.21066667 4.21585541,2.304 4.21585541,3.53866667 Z M2.995687,3.53866667 C2.995687,1.624 4.59899363,0 6.5,0 C8.40100637,0 10.004313,1.624 10.004313,3.53866667 C10.004313,5.93733333 8.49445471,7.74933333 6.5,7.74933333 C4.50554529,7.74933333 2.995687,5.93733333 2.995687,3.53866667 Z M0,14 L0.109468063,12.7186667 C0.383138221,10.156 2.63524338,8.74933333 6.5,8.74933333 C10.3634216,8.74933333 12.6168618,10.156 12.8905319,12.7106667 L13,14 L11.7491271,14 L11.6396591,12.828 C11.3966934,10.492 8.7214007,9.976 6.5,9.976 C4.2785993,9.976 1.60330663,10.492 1.36034093,12.836 L1.25087287,14 L0,14 Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

AccountIcon.displayName = "AccountIcon";
AccountIcon.displayName = "AccountIcon";
AccountIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (AccountIcon);

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\add-circle-icon.jsx";



var AddCircleIcon = function AddCircleIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 20 20", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { fill: "currentColor", cx: "10", cy: "10", r: "10", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10 5v10M5 10h10", stroke: "#FFF", strokeWidth: "2", strokeLinecap: "round", __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      })
    )
  );
};

AddCircleIcon.displayName = "AddCircleIcon";
AddCircleIcon.displayName = "AddCircleIcon";
AddCircleIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (AddCircleIcon);

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_radium__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_radium__);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\animated-hamburger-icon.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/** Renders an animated hamburger icon. */

var AnimatedHamburgerIcon = function (_Component) {
  _inherits(AnimatedHamburgerIcon, _Component);

  function AnimatedHamburgerIcon() {
    var _temp, _this, _ret;

    _classCallCheck(this, AnimatedHamburgerIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleInteraction = function (event) {
      if (event.type === 'keydown' && event.key !== 'Enter') return;
      _this.props.onClick(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  AnimatedHamburgerIcon.prototype.setLineStyles = function setLineStyles(addStyles) {
    addStyles = addStyles || [];
    var base = [styles.line, styles.burger, this.getHoverFocus('base') ? styles.lineActive : styles.lineDefault, this.props.open ? styles.baseActive : styles.baseDefault];
    return base.concat(addStyles);
  };
  /**
   * @param {string} elementKey - ReactDOM key parameter of element.
   * @returns {boolean} if element is currently focussed or hovered.
   */


  AnimatedHamburgerIcon.prototype.getHoverFocus = function getHoverFocus(elementKey) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_radium__["getState"])(this.state, elementKey, ':hover') || Object(__WEBPACK_IMPORTED_MODULE_3_radium__["getState"])(this.state, elementKey, ':focus');
  };
  /**
   * @param {object} event - click / keyDown event
   */


  /**
   * @param {boolean} open - If true, the hamburger will render in it's open position.
   * @param {function} onClick - function to run on click
   * @returns {ReactElement} React Component
   */
  AnimatedHamburgerIcon.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        'data-test': 'hamburger',
        tabIndex: '0',
        key: 'base',
        style: [styles.base],
        onClick: this.handleInteraction,
        onKeyDown: this.handleInteraction, __source: {
          fileName: _jsxFileName,
          lineNumber: 44
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { key: '1', style: this.setLineStyles([this.props.open ? styles.firstLine : '']), __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { key: '3', style: this.setLineStyles([this.props.open ? styles.secondLine : '']), __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { key: '2', style: this.setLineStyles([this.props.open ? styles.thirdLine : '']), __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        }
      })
    );
  };

  return AnimatedHamburgerIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AnimatedHamburgerIcon.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
AnimatedHamburgerIcon.displayName = 'AnimatedHamburgerIcon';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(AnimatedHamburgerIcon));

var styles = {
  base: {
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    verticalAlign: 'middle',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
    outline: 0,
    ':hover': {},
    ':focus': {
      outline: 0
    }
  },
  firstLine: {
    transform: 'rotate(135deg)'
  },
  secondLine: {
    opacity: 0
  },
  thirdLine: {
    transform: 'rotate(45deg)'
  },
  baseActive: {
    transition: 'margin .25s .5s, transform .25s .75s, opacity .5s .5s, background .25s',
    margin: '-1px 0 -1px 0'
  },
  baseDefault: {
    transition: 'margin .25s .75s, transform .25s .5s, opacity .5s .5s, background .25s',
    margin: '3px 0 3px 0'
  },
  line: {
    display: 'block',
    height: '2px',
    width: '100%'
  },
  lineActive: {
    background: '#fff'
  },
  lineDefault: {
    background: '#999'
  }
};

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\calculator-icon.jsx";



var CalculatorIcon = function CalculatorIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 17 20", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "m13.8872597.03125c1.2353516 0 2.234375.99902344 2.234375 2.234375v14.78125c0 1.2353516-.9990234 2.234375-2.234375 2.234375h-11.34374998c-1.23535156 0-2.234375-.9990234-2.234375-2.234375v-14.78125c0-1.23535156.99902344-2.234375 2.234375-2.234375zm.515625 17.015625v-14.78125c0-.27929688-.2363281-.515625-.515625-.515625h-11.34374998c-.27929687 0-.515625.23632812-.515625.515625v14.78125c0 .2792969.23632813.515625.515625.515625h11.34374998c.2792969 0 .515625-.2363281.515625-.515625zm-10.31249998-11.515625v-1.71875h8.24999998v1.71875zm1.03125 7.90625c.56933594 0 1.03125.4619141 1.03125 1.03125s-.46191406 1.03125-1.03125 1.03125-1.03125-.4619141-1.03125-1.03125.46191406-1.03125 1.03125-1.03125zm3.09375 0c.56933594 0 1.03125.4619141 1.03125 1.03125s-.46191406 1.03125-1.03125 1.03125-1.03125-.4619141-1.03125-1.03125.46191406-1.03125 1.03125-1.03125zm3.09374998 0c.569336 0 1.03125.4619141 1.03125 1.03125s-.461914 1.03125-1.03125 1.03125c-.5693359 0-1.03125-.4619141-1.03125-1.03125s.4619141-1.03125 1.03125-1.03125zm-6.18749998-3.09375c.56933594 0 1.03125.4619141 1.03125 1.03125s-.46191406 1.03125-1.03125 1.03125-1.03125-.4619141-1.03125-1.03125.46191406-1.03125 1.03125-1.03125zm3.09375 0c.56933594 0 1.03125.4619141 1.03125 1.03125s-.46191406 1.03125-1.03125 1.03125-1.03125-.4619141-1.03125-1.03125.46191406-1.03125 1.03125-1.03125zm3.09374998 0c.569336 0 1.03125.4619141 1.03125 1.03125s-.461914 1.03125-1.03125 1.03125c-.5693359 0-1.03125-.4619141-1.03125-1.03125s.4619141-1.03125 1.03125-1.03125zm-6.18749998-3.09375c.56933594 0 1.03125.46191406 1.03125 1.03125s-.46191406 1.03125-1.03125 1.03125-1.03125-.46191406-1.03125-1.03125.46191406-1.03125 1.03125-1.03125zm3.09375 0c.56933594 0 1.03125.46191406 1.03125 1.03125s-.46191406 1.03125-1.03125 1.03125-1.03125-.46191406-1.03125-1.03125.46191406-1.03125 1.03125-1.03125zm3.09374998 0c.569336 0 1.03125.46191406 1.03125 1.03125s-.461914 1.03125-1.03125 1.03125c-.5693359 0-1.03125-.46191406-1.03125-1.03125s.4619141-1.03125 1.03125-1.03125z",
      fill: "#9b9b9b",
      fillRule: "evenodd", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

CalculatorIcon.displayName = "CalculatorIcon";
CalculatorIcon.displayName = "CalculatorIcon";
CalculatorIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (CalculatorIcon);

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\calendar-icon.jsx";



var CalendarIcon = function CalendarIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 20 20", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M6,1 L6,5", id: "top2", stroke: "#999999", strokeWidth: "2", strokeLinecap: "round", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M14,1 L14,5", id: "top", stroke: "#999999", strokeWidth: "2", strokeLinecap: "round", __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M9,3 L11,3", id: "dividertop", stroke: "#999999", strokeWidth: "2", strokeLinecap: "square", __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M2,8 L18,8", id: "divider", stroke: "#999999", strokeWidth: "2", strokeLinecap: "square", __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M4,3 L4,3 C2.8954305,3 2,3.8954305 2,5 L2,17 C2,18.1045695 2.8954305,19 4,19 L16,19 C17.1045695,19 18,18.1045695 18,17 L18,5 C18,3.8954305 17.1045695,3 16,3", stroke: "#999999", strokeWidth: "2", __source: {
          fileName: _jsxFileName,
          lineNumber: 11
        }
      })
    )
  );
};

CalendarIcon.displayName = "CalendarIcon";
CalendarIcon.displayName = "CalendarIcon";
CalendarIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (CalendarIcon);

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\cancel-icon.jsx";



var CancelIcon = function CancelIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 20 20", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M16.8850098,7.84033203 L15.2358398,9.48095703 L10.7924805,5.02905273 L12.4331055,3.38842773 C12.7663574,3.05517578 13.2192383,2.8671875 13.689209,2.8671875 C14.1677246,2.8671875 14.6120605,3.05517578 14.9453125,3.38842773 L16.8850098,5.31958008 C17.2182617,5.66137695 17.3977051,6.10571289 17.3977051,6.58422852 C17.3977051,7.05419922 17.2182617,7.49853516 16.8850098,7.84033203 Z M13.3986816,4.35400391 L12.7236328,5.02905273 L15.2358398,7.54980469 L15.9194336,6.86621094 C15.9963379,6.79785156 16.0305176,6.68676758 16.0305176,6.58422852 C16.0305176,6.47314453 15.9963379,6.37060547 15.9194336,6.29370117 L13.9797363,4.35400391 C13.902832,4.27709961 13.800293,4.234375 13.689209,4.234375 C13.578125,4.234375 13.4755859,4.27709961 13.3986816,4.35400391 Z M8.27172852,14.513916 L10.296875,12.4887695 L11.2624512,13.4543457 L9.0065918,15.7102051 L2.29882812,17.9660645 L4.56323242,11.2668457 L6.8190918,9.00244141 L7.78466797,9.9765625 L5.75097656,12.001709 L4.80249023,14.8215332 L5.4519043,15.4624023 L8.27172852,14.513916 Z M6.78491211,13.4885254 C6.64819336,13.3603516 6.57983398,13.1809082 6.57983398,13.0100098 C6.57983398,12.8305664 6.64819336,12.659668 6.78491211,12.5229492 L8.56225586,10.7456055 L9.52783203,11.7111816 L7.75048828,13.4885254 C7.61376953,13.6252441 7.44287109,13.6936035 7.26342773,13.6936035 C7.0925293,13.6936035 6.91308594,13.6252441 6.78491211,13.4885254 Z M13.0483398,11.668457 L18.3291016,16.9406738 L17.3549805,17.90625 L2.31591797,2.8671875 L3.28149414,1.90161133 L8.60498047,7.21655273 L10.0148926,5.80664062 L10.9804688,6.7722168 L9.57055664,8.19067383 L10.3481445,8.9597168 L11.7580566,7.54980469 L12.7236328,8.51538086 L11.3137207,9.92529297 L12.0827637,10.7028809 L13.5012207,9.28442383 L14.4667969,10.25 L13.0483398,11.668457 Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

CancelIcon.displayName = "CancelIcon";
CancelIcon.displayName = "CancelIcon";
CancelIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (CancelIcon);

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\check-icon.jsx";



var CheckIcon = function CheckIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 10 10", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M4.138 7.559L1.002 5.277 0 6.491 4.4 10 10 .818 8.7 0z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

CheckIcon.displayName = "CheckIcon";
CheckIcon.displayName = "CheckIcon";
CheckIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (CheckIcon);

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\confirm-copy-link-icon.jsx";



var ConfirmCopyLinkIcon = function ConfirmCopyLinkIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 24 24", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { fill: "#7DBE37", cx: "12", cy: "12", r: "12", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        stroke: "#FFF",
        fill: "#FFF",
        d: "M10.136 14.83l-3.102-3.103L6 12.761l4.136 4.137L19 8.034 17.966 7z", __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      })
    )
  );
};

ConfirmCopyLinkIcon.displayName = "ConfirmCopyLinkIcon";
ConfirmCopyLinkIcon.displayName = "ConfirmCopyLinkIcon";
ConfirmCopyLinkIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (ConfirmCopyLinkIcon);

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\contact-icon.jsx";



var ContactIcon = function ContactIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 22 25", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { transform: "translate(-25.000000, -234.000000)", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M43.2360743,243.166667 C43.2360743,239.024531 39.8960233,235.666667 35.7758621,235.666667 C31.6557008,235.666667 28.3156499,239.024531 28.3156499,243.166667 L29.5579936,243.166667 C29.7874573,243.166667 29.9734748,243.349774 29.9734748,243.584359 L29.9734748,251.915641 C29.9734748,252.146326 29.7845818,252.333333 29.5579936,252.333333 L28.3156499,252.333333 C28.3156499,254.493895 29.9513748,256.270375 32.045756,256.479427 L32.045756,256.082096 C32.045756,255.852661 32.2312206,255.666667 32.4595913,255.666667 L37.0198516,255.666667 C37.2484064,255.666667 37.433687,255.855432 37.433687,256.082096 L37.433687,258.584571 C37.433687,258.814006 37.2482224,259 37.0198516,259 L32.4595913,259 C32.2310366,259 32.045756,258.811235 32.045756,258.584571 L32.045756,258.152015 C29.034617,257.93837 26.6578249,255.414897 26.6578249,252.333333 L25.4154812,252.333333 C25.1860175,252.333333 25,252.150226 25,251.915641 L25,243.584359 C25,243.353674 25.188893,243.166667 25.4154812,243.166667 L26.6578249,243.166667 C26.6578249,238.104057 30.7401094,234 35.7758621,234 C40.8116147,234 44.8938992,238.104057 44.8938992,243.166667 L46.136243,243.166667 C46.3657066,243.166667 46.5517241,243.349774 46.5517241,243.584359 L46.5517241,251.915641 C46.5517241,252.146326 46.3628312,252.333333 46.136243,252.333333 L41.9937305,252.333333 C41.7642668,252.333333 41.5782493,252.150226 41.5782493,251.915641 L41.5782493,243.584359 C41.5782493,243.353674 41.7671423,243.166667 41.9937305,243.166667 L43.2360743,243.166667 Z", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      })
    )
  );
};

ContactIcon.displayName = "ContactIcon";
ContactIcon.displayName = "ContactIcon";
ContactIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (ContactIcon);

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\cross-icon.jsx";



var CrossIcon = function CrossIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 31 31", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M31 1.4L29.6 0 15.5 14.1 1.4 0 0 1.4l14.1 14.1L0 29.6 1.4 31l14.1-14.1L29.6 31l1.4-1.4-14.1-14.1z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

CrossIcon.displayName = "CrossIcon";
CrossIcon.displayName = "CrossIcon";
CrossIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (CrossIcon);

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\document-icon.jsx";



var DocumentIcon = function DocumentIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 21 26", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { transform: "translate(-26.000000, -177.000000)", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M26,177 L26,203 L39.3595639,203 L47,195.070321 L47,177 L26,177 Z M28.3344394,179.408691 L44.6655606,179.408691 L44.6655606,194.076543 L38.3789998,200.591309 L28.3344394,200.591309 L28.3344394,179.408691 Z M31.5996682,184.703704 L41.4003318,184.703704 L41.4003318,182.29758 L31.5996682,182.29758 L31.5996682,184.703704 Z M31.5996682,189.035753 L41.4003318,189.035753 L41.4003318,186.62963 L31.5996682,186.62963 L31.5996682,189.035753 Z M35.8006637,191.444444 L35.8006637,198.667951 L38.1326144,198.667951 L38.1326144,193.853136 L42.7990045,193.853136 L42.7990045,191.444444 L35.8006637,191.444444 Z", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      })
    )
  );
};

DocumentIcon.displayName = "DocumentIcon";
DocumentIcon.displayName = "DocumentIcon";
DocumentIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (DocumentIcon);

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\down-arrow-icon.jsx";



var DownArrowIcon = function DownArrowIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 12 12", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon", {
      transform: "translate(6.000000, 5.500000) scale(1, -1) rotate(-180.000000) translate(-6.000000, -5.500000) ",
      points: "10.6 2 6 6.35135135 1.4 2 0 3.32432432 6 9 12 3.32432432", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

DownArrowIcon.displayName = "DownArrowIcon";
DownArrowIcon.displayName = "DownArrowIcon";
DownArrowIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (DownArrowIcon);

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\download-icon.jsx";



var DownloadIcon = function DownloadIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 14 12", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M14,7v5H0V7H2v3H12V7h2ZM7,8.41L2.81,4.27l1-1L6.29,5.71V0H7.71V5.71l2.46-2.43,1,1Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

DownloadIcon.displayName = "DownloadIcon";
DownloadIcon.displayName = "DownloadIcon";
DownloadIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (DownloadIcon);

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\edit-icon.jsx";



var EditIcon = function EditIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 20 20", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M16.8850098,5.31958008 C17.2182617,5.66137695 17.3977051,6.10571289 17.3977051,6.58422852 C17.3977051,7.05419922 17.2182617,7.49853516 16.8850098,7.84033203 L15.2358398,9.48095703 L10.7924805,5.02905273 L12.4331055,3.38842773 C12.7663574,3.05517578 13.2192383,2.8671875 13.689209,2.8671875 C14.1677246,2.8671875 14.6120605,3.05517578 14.9453125,3.38842773 L16.8850098,5.31958008 Z M15.9194336,6.86621094 C15.9963379,6.79785156 16.0305176,6.68676758 16.0305176,6.58422852 C16.0305176,6.47314453 15.9963379,6.37060547 15.9194336,6.29370117 L13.9797363,4.35400391 C13.902832,4.27709961 13.800293,4.234375 13.689209,4.234375 C13.578125,4.234375 13.4755859,4.27709961 13.3986816,4.35400391 L12.7236328,5.02905273 L15.2358398,7.54980469 L15.9194336,6.86621094 Z M8.27172852,14.513916 L13.5012207,9.28442383 L14.4667969,10.25 L9.0065918,15.7102051 L2.29882812,17.9660645 L4.56323242,11.2668457 L10.0148926,5.80664062 L10.9804688,6.7722168 L5.75097656,12.001709 L4.80249023,14.8215332 L5.4519043,15.4624023 L8.27172852,14.513916 Z M6.78491211,13.4885254 C6.64819336,13.3603516 6.57983398,13.1809082 6.57983398,13.0100098 C6.57983398,12.8305664 6.64819336,12.659668 6.78491211,12.5229492 L11.7580566,7.54980469 L12.7236328,8.51538086 L7.75048828,13.4885254 C7.61376953,13.6252441 7.44287109,13.6936035 7.26342773,13.6936035 C7.0925293,13.6936035 6.91308594,13.6252441 6.78491211,13.4885254 Z", fill: "#D50001", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

EditIcon.displayName = "EditIcon";
EditIcon.displayName = "EditIcon";
EditIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (EditIcon);

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\error-icon.jsx";



var ErrorIcon = function ErrorIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 20 20", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 16.4c-.7 0-1.2-.5-1.2-1.2S9.3 14 10 14s1.2.5 1.2 1.2c0 .6-.5 1.2-1.2 1.2zm0-3.6c-.9 0-1.6-6.7-1.6-7.6s.7-1.6 1.6-1.6 1.6.7 1.6 1.6-.7 7.6-1.6 7.6z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

ErrorIcon.displayName = "ErrorIcon";
ErrorIcon.displayName = "ErrorIcon";
ErrorIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (ErrorIcon);

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\external-link.jsx";



var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 14 11", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10.5,9.59H1.4V3.24H3.22A8.34,8.34,0,0,1,4.74,1.83h-4a0.7,0.7,0,0,0-.7.71v7.76A0.7,0.7,0,0,0,.7,11H11.2a0.7,0.7,0,0,0,.7-0.71V7.65L10.5,8.81V9.59ZM9.35,4.69v2.5L14,3.53,9.35,0V2.21c-5.64,0-5.64,5.62-5.64,5.62C5.31,5.18,6.29,4.69,9.35,4.69Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

ExternalLinkIcon.displayName = "ExternalLinkIcon";
ExternalLinkIcon.displayName = "ExternalLinkIcon";
ExternalLinkIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (ExternalLinkIcon);

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\eye-icon.jsx";



var EyeIcon = function EyeIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 17 12", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "mask",
      { id: "mask-2", fill: "white", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon", { id: "path-1", points: "17 12 17 0 0 1.46968299e-15 0 12 17 12", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M11.7539655,4.46421677 C12.000543,4.92857143 12.1429513,5.44649752 12.1429513,6 C12.1429513,7.8927882 10.5111887,9.42857143 8.49989012,9.42857143 C6.48881132,9.42857143 4.85704867,7.8927882 4.85704867,6 C4.85704867,4.10700496 6.48881132,2.57142857 8.49989012,2.57142857 L8.49989012,3.99986211 C7.33315235,3.99986211 6.37475276,4.90168229 6.37475276,6 C6.37475276,7.09811087 7.33315235,7.99993105 8.49989012,7.99993105 C9.66684765,7.99993105 10.6250275,7.09811087 10.6250275,6 C10.6250275,5.67857143 10.5397583,5.37493105 10.3973499,5.10707391 L11.7539655,4.46421677 Z M15.4822959,6 C15.4822959,5.07149752 12.4273286,1.42843354 8.49989012,1.42843354 C4.57245168,1.42843354 1.51770409,5.07149752 1.51770409,6 C1.51770409,6.92850248 4.57245168,10.5713596 8.49989012,10.5713596 C12.4273286,10.5713596 15.4822959,6.92850248 15.4822959,6 Z M17,6 C17,7.97324876 13.0631116,12 8.49989012,12 C3.93688837,12 0,7.97324876 0,6 C0,4.02675124 3.93688837,0 8.49989012,0 C13.0631116,0 17,4.02675124 17,6 Z", id: "Fill-1", fill: "#101010", mask: "url(#mask-2)", __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    })
  );
};

EyeIcon.displayName = "EyeIcon";
EyeIcon.displayName = "EyeIcon";
EyeIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (EyeIcon);

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\hex-icon\\index.jsx";





/**
 * Renders a set of background images
 * @param {object} props - Component props
 * @param {String} props.color - hex String
 * @param {Boolean} props.active - render in active state
 * @param {Boolean} props.hover - render in hover state
 * @returns {ReactElement} React Component
 */
var HexIcon = function HexIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.base, "data-test": "hex-icon", __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: [styles.innerCircle, props.hover ? styles.hover : styles.inactive, props.active ? styles.active : "", { backgroundColor: props.color }], __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      props.active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.shade, __source: {
          fileName: _jsxFileName,
          lineNumber: 23
        }
      }),
      props.active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["b" /* AnimatedCheckIcon */], { color: props.color, __source: {
          fileName: _jsxFileName,
          lineNumber: 24
        }
      })
    )
  );
};

HexIcon.displayName = "HexIcon";
HexIcon.displayName = "HexIcon";
HexIcon.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(HexIcon));

var styles = {
  base: {
    pointerEvents: "none",
    width: "2.1em",
    height: "2.1em",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundSize: "50%",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    position: "relative",
    backgroundColor: "#e7e7e7",
    boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .2)"
  },
  innerCircle: {
    borderRadius: "50%",
    overflow: "hidden",
    transition: "height .125s, width .125s",
    border: "1px solid rgba(0, 0, 0, .1)",
    boxSizing: "content-box"
  },
  hover: {
    width: "2em",
    height: "2em"
  },
  active: {
    width: "2em",
    height: "2em",
    zIndex: 1
  },
  inactive: {
    width: "1em",
    height: "1em"
  },
  shade: {
    position: "relative",
    top: "50%",
    left: 0,
    width: "100%",
    height: "50%",
    background: "rgba(0, 0, 0, .1)",
    pointerEvents: "none"
  }
};

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\link-icon.jsx";



var LinkIcon = function LinkIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 17 17", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "M3.912 7c.21 0 .421.087.58.262a.818.818 0 0 1 .245.575c0 .21-.088.419-.246.576L3.456 9.442a2.868 2.868 0 0 0-.842 2.04c0 .785.298 1.5.842 2.041.544.541 1.263.837 2.053.837s1.509-.296 2.052-.837l1.035-1.029a.828.828 0 0 1 .58-.244c.21 0 .42.087.578.244a.818.818 0 0 1 .246.576c0 .21-.088.418-.246.575l-1.035 1.03c-.86.854-2 1.325-3.193 1.325a4.516 4.516 0 0 1-3.193-1.326A4.463 4.463 0 0 1 1 11.5a4.41 4.41 0 0 1 1.35-3.174l.983-1.082A.828.828 0 0 1 3.913 7zm8.58 1.604l1.053-1.001a2.898 2.898 0 0 0 .842-2.055c0-.79-.298-1.51-.842-2.054a2.86 2.86 0 0 0-2.052-.843 2.86 2.86 0 0 0-2.051.843L8.407 4.53a.825.825 0 0 1-.578.246.825.825 0 0 1-.58-.246c-.332-.316-.332-.826 0-1.16l1.035-1.035A4.497 4.497 0 0 1 11.476 1c1.21 0 2.332.474 3.191 1.335A4.51 4.51 0 0 1 16 5.53a4.51 4.51 0 0 1-1.333 3.196l-1.034 1.036a.804.804 0 0 1-1.14 0 .827.827 0 0 1-.246-.58c0-.21.088-.421.246-.58zM10.197 6c.017 0 .017 0 0 0 .222.017.41.103.564.24.154.153.24.358.24.563 0 .206-.086.41-.24.565l-3.404 3.401a.785.785 0 0 1-1.112 0c-.325-.307-.325-.803 0-1.128L9.63 6.239A.805.805 0 0 1 10.196 6z",
      stroke: "currentColor",
      fillRule: "nonzero",
      fill: "currentColor", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

LinkIcon.displayName = "LinkIcon";
LinkIcon.displayName = "LinkIcon";
LinkIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (LinkIcon);

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\loader-icon.jsx";




var LoaderIcon = function LoaderIcon(_ref) {
  var _ref$styleName = _ref.styleName,
      styleName = _ref$styleName === undefined ? "dark" : _ref$styleName,
      _ref$scale = _ref.scale,
      scale = _ref$scale === undefined ? 1 : _ref$scale,
      style = _ref.style;

  var color = styleName === "dark" ? "#fff" : "#101010";
  var dim = 38;
  var viewBox = "0 0 " + dim + " " + dim;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: _extends({
        position: "relative",
        transform: "scale(" + scale + ")",
        height: dim + "px",
        margin: "0 auto",
        width: dim + "px"
      }, style), __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "svg",
      {
        style: { position: "absolute", top: 0, right: 0 },
        width: dim,
        height: dim,
        viewBox: viewBox,
        stroke: color, __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { fill: "none", fillRule: "evenodd", __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(1 1)", strokeWidth: "2", __source: {
              fileName: _jsxFileName,
              lineNumber: 27
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { strokeOpacity: ".5", cx: "18", cy: "18", r: "18", __source: {
              fileName: _jsxFileName,
              lineNumber: 28
            }
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "svg",
      {
        style: [{ position: "absolute", top: 0, right: 0 }, styles.rotate],
        width: dim,
        height: dim,
        viewBox: viewBox,
        fill: "none",
        stroke: color, __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(1 1)", strokeWidth: "2", __source: {
            fileName: _jsxFileName,
            lineNumber: 39
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M36 18c0-9.94-8.06-18-18-18", __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        })
      )
    )
  );
};

LoaderIcon.displayName = "LoaderIcon";
LoaderIcon.displayName = "LoaderIcon";
LoaderIcon.propTypes = {
  styleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dark", "light"]),
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var rotate = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["b" /* keyframes */])({
  to: {
    transform: "rotate(360deg)"
  }
});

var styles = {
  rotate: {
    animation: "x ease 1s infinite",
    animationName: rotate
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(LoaderIcon));

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\mail-icon.jsx";



var MailIcon = function MailIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 37 29", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M31.603702,3.6251032 L6.37030835,3.6251032 L17.7288052,12.0311157 C18.3864068,12.5066473 19.5884297,12.5066473 20.2452051,12.0311157 L31.603702,3.6251032 Z M33.3724518,10.6036952 L37,7.54493694 L37,29 L0,29 L0,6.84237196 L3.62754817,9.92342073 L3.62754817,23.5404674 L10.5422779,14.8397244 L13.4667872,16.9920005 L6.80154956,25.3748968 L30.220756,25.3748968 L23.8950588,17.4452416 L26.8203943,15.2929655 L33.3724518,23.5173513 L33.3724518,10.6036952 Z M37,0 L37,3.7613232 L22.3989327,14.8851311 C21.447228,15.5876961 20.2228995,15.9270077 18.9754393,15.9270077 C17.7511108,15.9270077 16.5267823,15.5876961 15.5750776,14.8851311 L0,3.05875822 L0,0 L37,0 Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

MailIcon.displayName = "MailIcon";
MailIcon.displayName = "MailIcon";
MailIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (MailIcon);

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\notifications-icon.jsx";



var NotificationsIcon = function NotificationsIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 19 20", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M11.1279012,17.1428571 L12.9537778,17.1428571 C12.6347654,18.7828571 11.2160988,20 9.50093827,20 C7.78577778,20 6.36711111,18.7828571 6.04809877,17.1428571 L7.87397531,17.1428571 C8.13669136,17.7904762 8.76345679,18.247619 9.50093827,18.247619 C10.2365432,18.247619 10.8633086,17.7904762 11.1279012,17.1428571 Z M16.7143704,13.9295238 C15.4814815,12.5104762 13.2934321,9.43047619 12.9969383,5.32380952 L12.788642,2.36571429 C12.2275556,2.13142857 11.0941235,1.75238095 9.5891358,1.75238095 L9.45590123,1.75238095 C7.96217284,1.75238095 6.82874074,2.13142857 6.26765432,2.36571429 L6.05935802,5.32380952 C5.7628642,9.43047619 3.5522963,12.4990476 2.29876543,13.9295238 L16.7143704,13.9295238 Z M19,15.7142857 L0,15.7142857 L0,13.727619 L0.29837037,13.4590476 C0.330271605,13.4380952 3.95950617,10.0780952 4.29916049,5.2 L4.5862716,1.28380952 L4.98222222,1.04952381 C5.04790123,1.00380952 6.77432099,0 9.45590123,0 L9.5891358,0 C12.270716,0 13.9971358,1.00380952 14.0740741,1.04952381 L14.4700247,1.28380952 L14.7571358,5.2 C15.1080494,10.0895238 18.6809877,13.4380952 18.7147654,13.4704762 L19,13.7390476 L19,15.7142857 Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

NotificationsIcon.displayName = "NotificationsIcon";
NotificationsIcon.displayName = "NotificationsIcon";
NotificationsIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (NotificationsIcon);

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\plus-icon.jsx";



var PlusIcon = function PlusIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 20 20", style: style, __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", strokeWidth: "1.75", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "10", cy: "10", r: "9.125", stroke: "#9b9b9b", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { stroke: "#979797", __source: {
            fileName: _jsxFileName,
            lineNumber: 8
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m10 6v8", __source: {
            fileName: _jsxFileName,
            lineNumber: 9
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m6 10h8.0622577", __source: {
            fileName: _jsxFileName,
            lineNumber: 10
          }
        })
      )
    )
  );
};

PlusIcon.displayName = "PlusIcon";
PlusIcon.displayName = "PlusIcon";
PlusIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (PlusIcon);

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\print-icon.jsx";



var PrintIcon = function PrintIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 18 16", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m13.9370323 13.4193548h1.4508387v-1.4508387h-1.4508387zm-8.71122585 6.0975484h7.54838705v-3.4838709h-7.54838705zm0-10.16206449h7.54838705v-2.90322581h-7.54838705zm-1.45083871 11.61290319h10.45161286v-6.3870967h-10.45161286zm14.22503226-9.7254193v5.8064516c0 1.0436129-.843871 1.8874839-1.8874839 1.8874839h-.7246451v-1.4523871h.7246451c.2369033 0 .4366452-.199742.4366452-.4350968v-5.8064516c0-.2369032-.1997419-.4350968-.4366452-.4350968h-14.22503223c-.23690322 0-.43664516.1981936-.43664516.4350968v5.8064516c0 .2353548.19974194.4350968.43664516.4350968h.72464516v1.4523871h-.72464516c-1.0436129 0-1.88748387-.843871-1.88748387-1.8874839v-5.8064516c0-1.0436129.84387097-1.88748389 1.88748387-1.88748389h1.88748387v-4.3556129h10.45161286v4.3556129h1.8859355c1.0436129 0 1.8874839.84387099 1.8874839 1.88748389z", fillRule: "evenodd", transform: "translate(0 -5)", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

PrintIcon.displayName = "PrintIcon";
PrintIcon.displayName = "PrintIcon";
PrintIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (PrintIcon);

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swatch_svg__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swatch_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swatch_svg__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\radio-icon\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var RadioIcon = function (_Component) {
  _inherits(RadioIcon, _Component);

  function RadioIcon() {
    _classCallCheck(this, RadioIcon);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * @param {String} icon - URL for icon asset.
   * @returns {ReactElement} React Component
   */
  RadioIcon.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: [styles.base, { backgroundImage: "url(" + this.props.icon + ")" }, this.props.hover || this.props.active ? styles.active : ""],
        "data-test": "swatch-icon", __source: {
          fileName: _jsxFileName,
          lineNumber: 13
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.swatch, __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      }),
      this.props.active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["b" /* AnimatedCheckIcon */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      })
    );
  };

  return RadioIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RadioIcon.displayName = "RadioIcon";

var styles = {
  base: {
    margin: ".25em",
    width: "4.25em",
    height: "4.25em",
    display: "inline-block",
    backgroundSize: "60%",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    transition: ".25s",
    position: "relative",
    transform: "translate3d(0, 0, 0)"
  },
  swatch: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    backgroundImage: "url(" + __WEBPACK_IMPORTED_MODULE_3__swatch_svg___default.a + ")"
  },
  active: {
    backgroundSize: "94%"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___["a" /* default */])(RadioIcon));

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0abcf81f670fd0163fb2b1e46f8167bb.svg";

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\remove-circle-icon.jsx";



var RemoveCircleIcon = function RemoveCircleIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 20 20", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { fill: "currentColor", cx: "10", cy: "10", r: "10", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M13.536 6.464l-7.072 7.072M6.464 6.464l7.072 7.072",
        stroke: "#FFF",
        strokeWidth: "2",
        strokeLinecap: "round", __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      })
    )
  );
};

RemoveCircleIcon.displayName = "RemoveCircleIcon";
RemoveCircleIcon.displayName = "RemoveCircleIcon";
RemoveCircleIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (RemoveCircleIcon);

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\save-icon.jsx";



var SaveIcon = function SaveIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 14 20", xmlns: "http://www.w3.org/2000/svg", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "M1 2v16a1 1 0 0 0 1.596.803l4.029-2.992a1 1 0 0 1 1.223.024l3.524 2.841A1 1 0 0 0 13 17.898V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1z",
      stroke: "currentColor",
      strokeWidth: "2",
      fill: "none",
      fillRule: "evenodd", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

SaveIcon.displayName = "SaveIcon";
SaveIcon.displayName = "SaveIcon";
SaveIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (SaveIcon);

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\chevron-icon.jsx";



var ChevronIcon = function ChevronIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 284.929 284.929", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "currentColor", d: "M282.082 195.285L149.028 62.24c-1.901-1.903-4.088-2.856-6.562-2.856s-4.665.953-6.567 2.856L2.856 195.285C.95 197.191 0 199.378 0 201.853c0 2.474.953 4.664 2.856 6.566l14.272 14.271c1.903 1.903 4.093 2.854 6.567 2.854s4.664-.951 6.567-2.854l112.204-112.202 112.208 112.209c1.902 1.903 4.093 2.848 6.563 2.848 2.478 0 4.668-.951 6.57-2.848l14.274-14.277c1.902-1.902 2.847-4.093 2.847-6.566.001-2.476-.944-4.666-2.846-6.569z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

ChevronIcon.displayName = "ChevronIcon";
ChevronIcon.displayName = "ChevronIcon";
ChevronIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (ChevronIcon);

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\search-icon.jsx";



var SearchIcon = function SearchIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 20 20", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M19.9 18.9l-5.3-5.3c1.2-1.4 2-3.3 2-5.3 0-4.6-3.7-8.3-8.3-8.3S0 3.7 0 8.3s3.7 8.3 8.3 8.3c2 0 3.9-.7 5.3-2l5.3 5.3c.2.2.5.2.7 0l.3-.3c.1-.2.1-.5 0-.7zM1.4 8.3c0-3.8 3.1-6.9 6.9-6.9s6.9 3.1 6.9 6.9-3.1 6.9-6.9 6.9-6.9-3.1-6.9-6.9z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

SearchIcon.displayName = "SearchIcon";
SearchIcon.displayName = "SearchIcon";
SearchIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (SearchIcon);

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\servicing-icon.jsx";



var ServicingIcon = function ServicingIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 29 25", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", transform: "translate(-20.000000, -81.000000)", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M20.3062677,88.6560499 C20.4290654,88.2050252 20.756526,87.8770072 21.1658517,87.7540005 C21.61611,87.6309938 22.0663683,87.7540005 22.3938289,88.0820185 L26.0777602,91.7722206 C26.4052208,92.1002386 26.8964117,92.3052498 27.3876025,92.3052498 C27.3876025,92.3052498 27.3876025,92.3052498 27.3876025,92.3052498 C27.8787934,92.3052498 28.3699842,92.1002386 28.6974448,91.7722206 L30.3756802,90.0911285 C31.1124665,89.3530881 31.1124665,88.164023 30.3756802,87.4669848 L26.487086,83.5717714 C26.1596254,83.2437534 26.0368277,82.833731 26.1596254,82.3827063 C26.2824231,81.9726838 26.5689511,81.6036636 26.9782768,81.4806569 C30.5803431,80.332594 34.4689373,81.2756456 37.1295544,83.9407916 C39.2989807,86.1139107 40.3222949,89.1070746 39.9948344,92.1412408 C39.8311041,93.4533127 40.2813624,94.7243823 41.1818789,95.6264318 L49,103.457861 L47.6492252,104.810935 L39.8311041,96.9795059 C38.5212618,95.667434 37.8663407,93.8223329 38.1119361,91.9362296 C38.3984641,89.4760948 37.5388801,87.0569623 35.7787796,85.2938657 C33.8958813,83.4077624 31.2352642,82.5877175 28.6565122,83.0387422 L31.6855225,86.0729084 C33.159095,87.5489893 33.159095,89.9271196 31.6855225,91.4032004 L30.0072871,93.0842925 C29.3114334,93.7813307 28.3699842,94.1913531 27.3466699,94.1913531 C26.3233557,94.1913531 25.3819065,93.8223329 24.6860528,93.0842925 L21.902638,90.2961398 C21.6570426,92.7152723 22.5166266,95.0524003 24.2357946,96.8154969 C25.8730974,98.4555867 28.1653214,99.3166339 30.4984779,99.1526249 C32.299511,99.0296182 34.018679,99.6856541 35.2466561,100.915721 L38.9715201,104.646926 L37.6207453,106 L33.8958813,102.268796 C33.0772299,101.448751 31.8492528,100.997726 30.6212756,101.07973 C27.7150631,101.284742 24.8907157,100.218683 22.8440871,98.168571 C20.4290654,95.7084362 19.4466837,92.0592363 20.3062677,88.6560499 Z", fill: "#979797", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      })
    )
  );
};

ServicingIcon.displayName = "ServicingIcon";
ServicingIcon.displayName = "ServicingIcon";
ServicingIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (ServicingIcon);

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\share-icon.jsx";



var ShareIcon = function ShareIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 12 15", xmlns: "http://www.w3.org/2000/svg", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "M7.092 11.826L3.538 9.775A2.5 2.5 0 0 1 .011 7.739L0 7.732l.01-.016a2.5 2.5 0 0 1 3.355-2.563l3.69-2.13A2.5 2.5 0 1 1 8.23 4.653L4.837 6.611a2.494 2.494 0 0 1 .05 1.632l3.495 2.019a2.5 2.5 0 1 1-1.291 1.564z",
      fill: "currentColor",
      fillRule: "evenodd", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

ShareIcon.displayName = "ShareIcon";
ShareIcon.displayName = "ShareIcon";
ShareIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (ShareIcon);

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\tabs-responsive\\index.jsx";




var compareFn = function compareFn(props) {
  // the Measure component just calculates the height of element with padding
  // height of element will be 50 px-ish so 90 would be good for detecting two lines
  return props.secondChildDimensions.height > 90;
};

var TabsResponsive = function TabsResponsive(props) {
  return props.dropdown ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_containers__["i" /* ConditionalLayout */],
    { compareFn: compareFn, __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_2" /* Select */], _extends({}, props, { margin: false, __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16
      }
    }))
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({ scrolling: true }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    }
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (TabsResponsive);

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\tick-modal-icon.jsx";



var TickModalIcon = function TickModalIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 35 35", xmlns: "http://www.w3.org/2000/svg", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { fill: "#7DBE37", cx: "17.5", cy: "17.5", r: "17.5", __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M15.034 22.85l-5.33-3.88L8 21.036 15.48 27 25 11.39 22.79 10z", __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      })
    )
  );
};

TickModalIcon.displayName = "TickModalIcon";
TickModalIcon.displayName = "TickModalIcon";
TickModalIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (TickModalIcon);

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\mute-icon.jsx";



var MuteIcon = function MuteIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48.4 43", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "M9.2 32.6L0 31.2v-20l9.3-.9L21.6 0v43L9.2 32.6zm2-4.4l5.7 4.8V10l-5.7 4.8-6.5.6v11.8l6.5 1zM46.3 32.4l-8.1-8.1-8.2 8.1-2.1-2.1 8.1-8.1-8.1-8.2 2.1-2.1 8.1 8.1 8.1-8.1 2.1 2.1-8.1 8.1 8.1 8.1-2 2.2z",
      fill: "currentColor",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

MuteIcon.displayName = "MuteIcon";
MuteIcon.displayName = "MuteIcon";
MuteIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (MuteIcon);

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\unmute-icon.jsx";



var UnMuteIcon = function UnMuteIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48.4 43", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "M9.3 10.3L21.6 0v43L9.2 32.7 0 31.3v-20l9.3-1zm1.9 4.6l-6.5.6v11.8l6.5 1 5.7 4.8v-23l-5.7 4.8zm22.4 6.9c0 5.2-1.4 10.1-3.9 14.3l-3.8-2.8c1.9-3.4 3-7.4 3-11.6 0-4.3-1.2-8.4-3.2-11.9l3.8-2.7c2.7 4.3 4.1 9.3 4.1 14.7zm8.5 0c0 7.1-2 13.6-5.4 19.3l-3.8-2.7c2.9-4.9 4.6-10.5 4.6-16.5 0-6.2-1.7-11.9-4.7-16.8l3.8-2.7c3.5 5.5 5.5 12.2 5.5 19.4z",
      fill: "currentColor",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    }),
    "/>"
  );
};

UnMuteIcon.displayName = "UnMuteIcon";
UnMuteIcon.displayName = "UnMuteIcon";
UnMuteIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (UnMuteIcon);

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\vehicle-icon.jsx";



var VehicleIcon = function VehicleIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 31 14", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", transform: "translate(-21.000000, -136.000000)", __source: {
          fileName: _jsxFileName,
          lineNumber: 6
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(22.000000, 137.000000)", stroke: "#979797", strokeWidth: "1.98", __source: {
            fileName: _jsxFileName,
            lineNumber: 7
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M3.95454545,9.5395752 C1.555335,9.36755053 0.32620522,9.0575625 0.267156103,8.60961109 C0.178582427,7.93768399 -0.657820099,5.39872865 1.17243118,4.81786858 C2.34456701,4.47175229 4.68851304,3.09482473 8.1283955,3.1358972 C11.568278,3.17696967 10.468271,-0.366645911 18.4867938,0.0311570884 C26.5053166,0.428960088 27.8151976,3.10041346 28.4978987,4.55 C29.1805999,5.99958654 29.0550662,8.02475146 28.7764825,8.31718128 C28.59076,8.51213449 27.498662,8.75067271 25.5001887,9.03279595", __source: {
            fileName: _jsxFileName,
            lineNumber: 8
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { id: "Oval-3", cx: "5.93181818", cy: "9.75", rx: "2.30545455", ry: "2.26", __source: {
            fileName: _jsxFileName,
            lineNumber: 9
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { id: "Oval-3-Copy", cx: "23.0681818", cy: "9.75", rx: "2.30545455", ry: "2.26", __source: {
            fileName: _jsxFileName,
            lineNumber: 10
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M7.90909091,9.1 L20.794994,9.1", __source: {
            fileName: _jsxFileName,
            lineNumber: 11
          }
        })
      )
    )
  );
};

VehicleIcon.displayName = "VehicleIcon";
VehicleIcon.displayName = "VehicleIcon";
VehicleIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (VehicleIcon);

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\icons\\info-circle-icon.jsx";



var InfoCircleIcon = function InfoCircleIcon(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 20 20", __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm.348-11.59a1.02 1.02 0 0 0-1.03 1.008c0 .574.466 1.037 1.03 1.037a1.03 1.03 0 0 0 1.016-1.023 1.02 1.02 0 0 0-1.016-1.023zm1.688 7.296c.05-.162-.1-.265-.3-.206-.116.03-.216.103-.333.147-.15.06-.3.104-.45.118-.183.015-.316-.073-.366-.236-.033-.117-.05-.25-.033-.368.033-.25.1-.501.15-.752.15-.766.316-1.518.466-2.285.05-.206.083-.413.083-.62 0-.25-.166-.368-.45-.368H6.007c-.1 0-.2 0-.283.015-.166.03-.25.103-.266.221-.017.103.066.221.216.266.133.03.266.044.4.059.316.029.416.132.416.412 0 .045-.017.089-.017.133-.133.663-.266 1.342-.4 2.005l-.2 1.15c-.082.56.534 1.09 1.017 1.15.3.044.582.044.882.044.633 0 1.165-.236 1.598-.634a.693.693 0 0 0 .167-.25z", __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    })
  );
};

InfoCircleIcon.displayName = "InfoCircleIcon";
InfoCircleIcon.displayName = "InfoCircleIcon";
InfoCircleIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (InfoCircleIcon);

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_google_maps__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apis_geo__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_function__ = __webpack_require__(35);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\address-suggest\\index.jsx';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AddressSuggest = function (_Component) {
  _inherits(AddressSuggest, _Component);

  function AddressSuggest(props) {
    _classCallCheck(this, AddressSuggest);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = { autocompleteItems: [] };
    _this.autocompleteCallback = _this.autocompleteCallback.bind(_this);
    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.places = {};
    return _this;
  }

  AddressSuggest.prototype.getAutocompleteService = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _ref2, autocompleteService, statusCodes;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.autocompleteService && this.autocompleteOK !== undefined)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', this.autocompleteService);

            case 2:
              _context.prev = 2;
              _context.next = 5;
              return Object(__WEBPACK_IMPORTED_MODULE_5_apis_google_maps__["a" /* getAutocompleteService */])();

            case 5:
              _ref2 = _context.sent;
              autocompleteService = _ref2.autocompleteService;
              statusCodes = _ref2.statusCodes;


              this.autocompleteService = autocompleteService;
              this.autocompleteOK = statusCodes.OK;
              this.autocompleteZERO_RESULTS = statusCodes.ZERO_RESULTS;

              return _context.abrupt('return', this.autocompleteService);

            case 14:
              _context.prev = 14;
              _context.t0 = _context['catch'](2);
              throw _context.t0;

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[2, 14]]);
    }));

    function getAutocompleteService() {
      return _ref.apply(this, arguments);
    }

    return getAutocompleteService;
  }();

  AddressSuggest.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.getSuggestionsDebounced = __WEBPACK_IMPORTED_MODULE_3_debounce___default()(function (value) {
      _this2.getAutocompleteService().then(function (service) {
        service.getPlacePredictions({
          input: value,
          componentRestrictions: _this2.props.componentRestrictions,
          types: ['address']
        }, _this2.autocompleteCallback);
      });
    }, 100, false);
  };

  AddressSuggest.prototype.autocompleteCallback = function autocompleteCallback(predictions, status) {
    if (status === this.autocompleteZERO_RESULTS) {
      this.setState({ autocompleteItems: [] });
      return;
    }
    if (status !== this.autocompleteOK) return;

    var predictionResults = predictions
    // Ensure that places without a postcode won't be returned
    .filter(function (_ref3) {
      var types = _ref3.types;
      return ['street_address', 'route'].some(function (type) {
        return types.indexOf(type) !== -1;
      });
    })
    // Format, ready to put in state
    .map(function (place, index) {
      return {
        suggestion: place.description,
        placeId: place.place_id,
        active: false,
        index: index
      };
    });

    this.setState({
      autocompleteItems: predictionResults
    });
  };

  AddressSuggest.prototype.clearAutocomplete = function clearAutocomplete() {
    this.setState({ autocompleteItems: [] });
  };

  AddressSuggest.prototype.selectAddress = function selectAddress(address, id) {
    this.clearAutocomplete();
    this._handleSelect(address, id);
  };

  AddressSuggest.prototype._selectPlace = function _selectPlace(activeName, placeId) {
    var _this3 = this;

    var _props = this.props,
        onChange = _props.onChange,
        onLocation = _props.onLocation;

    var handleGeoCode = function handleGeoCode(params, pid) {
      var postcode = params.postcode,
          state = params.state,
          suburb = params.suburb,
          lat = params.lat,
          lng = params.lng,
          number = params.number,
          street = params.street,
          subpremise = params.subpremise;

      _this3.places[pid] = {
        postcode: postcode,
        state: state,
        suburb: suburb,
        lat: lat,
        lng: lng,
        number: number,
        street: street,
        subpremise: subpremise
      };

      var address = '' + (subpremise ? subpremise.concat('/') : '') + (number || '') + ' ' + street;

      var name = address + ', ' + suburb + ' ' + state + ' ' + postcode;

      onChange({
        name: name,
        postcode: postcode,
        state: state,
        suburb: suburb,
        address: address,
        number: number,
        street: street,
        subpremise: subpremise
      });
      onLocation && onLocation({
        name: name,
        postcode: postcode,
        state: state,
        suburb: suburb,
        number: number,
        street: street,
        address: address,
        subpremise: subpremise
      });

      window.dispatchEvent(new CustomEvent('postcodeSelect', {
        detail: { label: _this3.props.placeholder, message: name }
      }));
      // Dispatch gtm events from here so all information fetched is captured
      _this3.props.gtmEvents && Object(__WEBPACK_IMPORTED_MODULE_7_utils_function__["e" /* invokeFuncs */])(_this3.props.gtmEvents);
    };

    if (this.places[placeId]) {
      handleGeoCode(this.places[placeId], placeId);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_6_apis_geo__["a" /* fetchGeoDataFromAddress */])({
        placeId: placeId
      }).then(function (_ref4) {
        var addressDetails = _ref4.addressDetails,
            pid = _ref4.placeId;
        return handleGeoCode(addressDetails, pid);
      });
    }
  };

  AddressSuggest.prototype._handleSelect = function _handleSelect(address, id) {
    this._selectPlace(address, id);
  };

  AddressSuggest.prototype._getActiveItem = function _getActiveItem() {
    return this.state.autocompleteItems.find(function (item) {
      return item.active;
    });
  };

  AddressSuggest.prototype._selectActiveItemAtIndex = function _selectActiveItemAtIndex(index) {
    var activeItem = this.state.autocompleteItems.find(function (item) {
      return item.index === index;
    });
    var activeName = activeItem.suggestion;
    this._setActiveItemAtIndex(index);
    this._selectPlace(activeName, activeItem.placeId);
  };

  AddressSuggest.prototype._handleEnterKey = function _handleEnterKey() {
    var activeItem = this._getActiveItem();
    if (activeItem === undefined) {
      activeItem = this.state.autocompleteItems[0];
    }
    this.clearAutocomplete();
    if (activeItem !== undefined) {
      this._handleSelect(activeItem.suggestion, activeItem.placeId);
    }
  };

  AddressSuggest.prototype._handleDownKey = function _handleDownKey() {
    var activeItem = this._getActiveItem();
    if (activeItem === undefined) {
      this._selectActiveItemAtIndex(0);
    } else {
      var nextIndex = (activeItem.index + 1) % this.state.autocompleteItems.length;
      this._selectActiveItemAtIndex(nextIndex);
    }
  };

  AddressSuggest.prototype._handleUpKey = function _handleUpKey() {
    var activeItem = this._getActiveItem();
    if (activeItem === undefined) {
      this._selectActiveItemAtIndex(this.state.autocompleteItems.length - 1);
    } else {
      var prevIndex = void 0;
      if (activeItem.index === 0) {
        prevIndex = this.state.autocompleteItems.length - 1;
      } else {
        prevIndex = (activeItem.index - 1) % this.state.autocompleteItems.length;
      }
      this._selectActiveItemAtIndex(prevIndex);
    }
  };

  AddressSuggest.prototype.handleInputKeyDown = function handleInputKeyDown(event) {
    var ARROW_UP = 38;
    var ARROW_DOWN = 40;
    var ENTER_KEY = 13;
    var ESC = 27;
    switch (event.keyCode) {
      case ENTER_KEY:
        event.preventDefault();
        this._handleEnterKey();
        break;
      case ARROW_DOWN:
        this._handleDownKey();
        break;
      case ARROW_UP:
        this._handleUpKey();
        break;
      case ESC:
        this.clearAutocomplete();
        break;
      default:
        this.clearAutocomplete();
        break;
    }
  };

  AddressSuggest.prototype._setActiveItemAtIndex = function _setActiveItemAtIndex(index) {
    this.setState({
      autocompleteItems: this.state.autocompleteItems.map(function (item, idx) {
        if (idx === index) {
          return _extends({}, item, { active: true });
        }
        return _extends({}, item, { active: false });
      })
    });
  };

  AddressSuggest.prototype.handleInputChange = function handleInputChange(event) {
    var value = event.target.value && { name: event.target.value };
    this.props.onChange(value);
    if (!event.target.value) {
      this.clearAutocomplete();
      return;
    }
    if (event.target.value && event.target.value.length > 2) {
      this.getSuggestionsDebounced(event.target.value);
    }
  };

  AddressSuggest.prototype.renderOverlay = function renderOverlay() {
    var _this4 = this;

    if (this.state.autocompleteItems.length === 0) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.autocompleteOverlay, onClick: function onClick() {
        return _this4.clearAutocomplete();
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 253
      }
    });
  };

  AddressSuggest.prototype.renderAutocomplete = function renderAutocomplete() {
    var _this5 = this;

    var autocompleteItems = this.state.autocompleteItems;

    if (autocompleteItems.length === 0) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { 'data-test': 'suggestions', style: styles.autocompleteWrapper, __source: {
          fileName: _jsxFileName,
          lineNumber: 262
        }
      },
      autocompleteItems.map(function (place) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            key: place.placeId,
            onClick: function onClick() {
              return _this5.selectAddress(place.suggestion, place.placeId);
            },
            style: [styles.autocompleteItem, place.active ? { background: '#dddddd' } : null], __source: {
              fileName: _jsxFileName,
              lineNumber: 264
            }
          },
          place.suggestion
        );
      })
    );
  };

  AddressSuggest.prototype.render = function render() {
    var _this6 = this;

    var _props2 = this.props,
        placeholder = _props2.placeholder,
        value = _props2.value,
        _onFocus = _props2.onFocus,
        onBlur = _props2.onBlur,
        isValid = _props2.isValid,
        message = _props2.message,
        styleName = _props2.styleName,
        disabled = _props2.disabled;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { 'data-test': 'address-suggest', style: styles.base, __source: {
          fileName: _jsxFileName,
          lineNumber: 287
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { position: 'relative' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 288
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["J" /* InputText */], {
          onFocus: function onFocus() {
            if (value && (value.postcode || value.name)) {
              _this6.getSuggestionsDebounced(value.postcode || value.name);
            }
            _onFocus && _onFocus();
          },
          disabled: disabled,
          onBlur: onBlur,
          styleName: styleName || 'light',
          isValid: isValid,
          message: message,
          autoComplete: 'nope',
          required: this.props.required,
          label: placeholder,
          icon: 'search',
          value: value && value.name,
          onChange: this.handleInputChange,
          onKeyDown: this.handleInputKeyDown, __source: {
            fileName: _jsxFileName,
            lineNumber: 289
          }
        }),
        this.renderOverlay(),
        this.renderAutocomplete()
      )
    );
  };

  return AddressSuggest;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AddressSuggest.displayName = 'AddressSuggest';


AddressSuggest.propTypes = {
  componentRestrictions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLocation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  styleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

AddressSuggest.defaultProps = {
  componentRestrictions: { country: 'nz' }
};

var styles = {
  base: {
    position: 'relative',
    padding: '0',
    margin: 'auto',
    '@media (min-width: 768px)': {
      padding: '0'
    }
  },
  autocompleteOverlay: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 9998
  },
  autocompleteWrapper: {
    position: 'absolute',
    top: 'calc(100% - (0em + 2px))',
    left: '-1em',
    backgroundColor: 'white',
    textAlign: 'left',
    border: '1px solid #ddd',
    boxShadow: '2px 2px 10px rgba(0, 0, 0, .125)',
    width: 'calc(100% + 1em)',
    zIndex: 9999
  },
  autocompleteItem: {
    padding: '1em',
    color: '#191919',
    cursor: 'pointer',
    borderBottom: '1px solid #ddd',
    background: 'white',
    ':hover': {
      background: '#dddddd'
    }
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(AddressSuggest));

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_function__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers__ = __webpack_require__(7);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\checkbox\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var themeLight = {
  message: function message(valid) {
    return {
      color: valid ? "#101010" : "#910A2D"
    };
  }
};

var themeDark = {
  message: function message(valid) {
    return {
      color: valid ? "#fff" : "#910A2D"
    };
  }
};

var themes = {
  dark: themeDark,
  light: themeLight
};

var CheckBox = function (_Component) {
  _inherits(CheckBox, _Component);

  function CheckBox(props) {
    _classCallCheck(this, CheckBox);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      focused: false
    };
    _this.onBlur = function (e) {
      return _this.setState({ focused: false });
    };
    _this.onFocus = function (e) {
      return _this.setState({ focused: true });
    };
    _this.handleClick = function (e) {
      var _this$props = _this.props,
          value = _this$props.value,
          checked = _this$props.checked,
          onClick = _this$props.onClick,
          onChange = _this$props.onChange,
          _this$props$gtmEvents = _this$props.gtmEvents,
          gtmEvents = _this$props$gtmEvents === undefined ? false : _this$props$gtmEvents;

      var initValue = !!(checked || value);
      onClick && onClick(e) || onChange && onChange({
        target: {
          value: !initValue
        }
      });
      __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].dispatchEvent(new CustomEvent("check"));
      if (gtmEvents) {
        initValue ? Object(__WEBPACK_IMPORTED_MODULE_4_utils_function__["e" /* invokeFuncs */])(gtmEvents.unchecked) : Object(__WEBPACK_IMPORTED_MODULE_4_utils_function__["e" /* invokeFuncs */])(gtmEvents.checked);
      }
    };
    return _this;
  }

  CheckBox.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        value = _props.value,
        checked = _props.checked,
        required = _props.required,
        _props$style = _props.style,
        style = _props$style === undefined ? {} : _props$style,
        _props$showBox = _props.showBox,
        showBox = _props$showBox === undefined ? true : _props$showBox,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? "light" : _props$styleName,
        message = _props.message,
        isValid = _props.isValid;

    var renderValue = !!(checked || value);
    var themeStyles = themes[styleName];
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      "div",
      { style: [styles.checkbox, _extends({}, style)], "data-test": "check-box", __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        }
      },
      showBox && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        {
          style: styles.checkboxInner(renderValue, this.state),
          "data-test": "check-box-" + (this.props.id || (typeof label === "undefined" ? "undefined" : _typeof(label)) !== "object" && label || "checkbox"),
          onClick: this.handleClick, __source: {
            fileName: _jsxFileName,
            lineNumber: 69
          }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input", {
          type: "checkbox",
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          value: renderValue,
          style: styles.input, __source: {
            fileName: _jsxFileName,
            lineNumber: 73
          }
        }),
        renderValue && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers__["b" /* AnimatedCheckIcon */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 79
          }
        })
      ),
      label && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "label",
        {
          style: styles.label(styleName),
          onClick: this.handleClick, __source: {
            fileName: _jsxFileName,
            lineNumber: 82
          }
        },
        label,
        required && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "sup",
          { style: styles.sup, __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          },
          "*"
        )
      ),
      message && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "p",
        { style: [styles.message, themeStyles.message(isValid), styles.fadeIn], __source: {
            fileName: _jsxFileName,
            lineNumber: 90
          }
        },
        message
      )
    );
  };

  return CheckBox;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

CheckBox.displayName = "CheckBox";


CheckBox.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  required: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  showBox: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  isValid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  checked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  styleName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    checked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
    unchecked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
    clicked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(CheckBox));

var fadeInKeyframes = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["b" /* keyframes */])({
  from: {
    opacity: 0
  }
});

var styles = {
  message: {
    position: "absolute",
    left: "3em",
    fontSize: "75%",
    fontWeight: 200,
    top: "calc(100% + .1em)",
    margin: 0
  },
  checkbox: {
    position: "relative",
    display: "inline-block",
    whiteSpace: "noWrap",
    userSelect: "none",
    margin: ".5em 1em .5em 0"
  },
  label: function label(styleName) {
    return {
      marginLeft: "1em",
      display: "inline-block",
      verticalAlign: "top",
      whiteSpace: "normal",
      color: styleName === "dark" ? "#ffffff" : "#999999",
      fontSize: "90%",
      fontWeight: "200",
      lineHeight: 1.4,
      ":hover": {}
    };
  },
  input: {
    position: "absolute",
    cursor: "pointer",
    left: "10em",
    top: "10em",
    width: 0,
    height: 0
  },
  sup: {
    color: "#bf0000",
    fontWeight: "300",
    lineHeight: 1
  },
  fadeIn: {
    animation: "x .666s",
    animationName: fadeInKeyframes
  },
  checkboxInner: function checkboxInner(renderValue, state) {
    return {
      borderRadius: "2px",
      position: "relative",
      display: "inline-block",
      cursor: "pointer",
      backgroundColor: renderValue ? "#910A2D" : "white",
      borderWidth: "2px",
      borderStyle: "solid",
      borderColor: state.focused ? "#82befb" : renderValue ? "#910A2D" : __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_DARK,
      width: "0.75em",
      height: "0.75em",
      transition: "all 0.2s ease-in",
      padding: "0.1em",
      userSelect: "none",
      overflow: "hidden",
      verticalAlign: "top"
    };
  }
};

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fetch_please__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fetch_please___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fetch_please__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_google_maps__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apis_geo__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_highlight_words__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_highlight_words___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_highlight_words__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_googleAutoComplete__ = __webpack_require__(424);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\dealer-search-box\\index.jsx';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var DealerSearchBox = function (_PureComponent) {
  _inherits(DealerSearchBox, _PureComponent);

  function DealerSearchBox(props) {
    _classCallCheck(this, DealerSearchBox);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _initialiseProps.call(_this);

    _this.google = new __WEBPACK_IMPORTED_MODULE_10_AtomicUtils_googleAutoComplete__["a" /* default */]();
    _this.state = {
      autocompleteItems: [],
      dealerSearch: [],
      searchOptions: [],
      currentSearchValue: props.value && props.value.toString() || '',
      didEdit: false,
      inputValue: ''
    };

    _this.dealerSearch = new __WEBPACK_IMPORTED_MODULE_2_fetch_please___default.a(props.dealerSearchEndPoint, {
      timeout: 3000,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    _this.debouncedLocationSearchToState = __WEBPACK_IMPORTED_MODULE_3_debounce___default()(function (search) {
      return _this.doLocationSearchToState(search);
    }, 500);
    return _this;
  }

  // Api fns - consider reafactoring and moving these out of component.

  //

  DealerSearchBox.prototype.componentWillMount = function componentWillMount() {
    var searchOverride = this.props.searchOverride;

    if (searchOverride) {
      this.searchOverride(searchOverride);
    }
    this.doAutoSearchFromState();
  };

  DealerSearchBox.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var _this2 = this;

    var value = _ref.value,
        searchOverride = _ref.searchOverride;

    if (!this.state.didEdit && value) {
      var _value = _value.toString();
      this.setState({ currentSearchValue: _value }, function () {
        _this2.doAutoSearchFromState();
      });
    }
    if (searchOverride !== this.props.searchOverride) {
      this.searchOverride(searchOverride);
    }
  };

  DealerSearchBox.prototype.render = function render() {
    var _this3 = this;

    var placeholder = this.props.placeholder;
    var _state = this.state,
        searchOptions = _state.searchOptions,
        currentSearchValue = _state.currentSearchValue;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { key: 'DealerSearchBox', __source: {
          fileName: _jsxFileName,
          lineNumber: 283
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["R" /* SearchSelectBox */], {
        placeholder: placeholder,
        onChange: function onChange(value) {
          return _this3.handleSelectChange(value, false);
        },
        onInputChange: this.handleInputChange,
        onBlur: function onBlur() {
          _this3.setState({ inputValue: '' });
        },
        optionRenderer: function optionRenderer(_ref2) {
          var label = _ref2.label;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_highlight_words___default.a, {
            highlightStyle: { fontWeight: 400, backgroundColor: 'transparent' },
            searchWords: _this3.state.inputValue.split(' '),
            textToHighlight: label, __source: {
              fileName: _jsxFileName,
              lineNumber: 292
            }
          });
        },
        value: currentSearchValue,
        options: searchOptions, __source: {
          fileName: _jsxFileName,
          lineNumber: 284
        }
      })
    );
  };

  return DealerSearchBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getAutocompleteService = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref4, autocompleteService, statusCodes;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(_this4.autocompleteService && _this4.autocompleteOK !== undefined)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', _this4.autocompleteService);

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return Object(__WEBPACK_IMPORTED_MODULE_5_apis_google_maps__["a" /* getAutocompleteService */])();

          case 5:
            _ref4 = _context.sent;
            autocompleteService = _ref4.autocompleteService;
            statusCodes = _ref4.statusCodes;


            _this4.autocompleteService = autocompleteService;
            _this4.autocompleteOK = statusCodes.OK;

            return _context.abrupt('return', _this4.autocompleteService);

          case 13:
            _context.prev = 13;
            _context.t0 = _context['catch'](2);

            console.warn(_context.t0);
            throw _context.t0;

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this4, [[2, 13]]);
  }));

  this.searchOverride = function (search) {
    _this4.doLocationSearchToState(search).then(function () {
      var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var item = results.find(function (result) {
        return result.label === search;
      }) || results[0];
      _this4.setState({ currentSearchValue: item ? String(item.value) : '' }, function () {
        _this4.handleSelectChange(item, true);
      });
    });
  };

  this.doDealerSearch = function (search) {
    _this4.dealerSearch && _this4.dealerSearch.abort();
    return _this4.dealerSearch.post('', { searchText: search }).then(function (_ref5) {
      var data = _ref5.data;
      return data;
    });
  };

  this.doPredictionSearch = function (search) {
    return _this4.getAutocompleteService().then(function (service) {
      return new Promise(function (resolve, reject) {
        service.getPlacePredictions({
          input: search,
          componentRestrictions: _this4.props.componentRestrictions || null,
          types: ['(regions)']
        }, function (predictions, status) {
          if (status !== _this4.autocompleteOK) reject(status);else {
            resolve(predictions.filter(function (_ref6) {
              var types = _ref6.types;
              return ['colloquial_area'].some(function (type) {
                return types.indexOf(type) === -1;
              }) && ['postal_code', 'locality'].some(function (type) {
                return types.indexOf(type) !== -1;
              });
            }));
          }
        });
      });
    }).catch(function (error) {
      return console.warn('Google response:', error);
    });
  };

  this.doLocationSearchToState = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(search) {
      var _state2, _state2$dealerSearch, dealerSearch, _state2$autocompleteI, autocompleteItems, _ref8, dealerResults, autocompleteResults, searchOptions;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _state2 = _this4.state, _state2$dealerSearch = _state2.dealerSearch, dealerSearch = _state2$dealerSearch === undefined ? [] : _state2$dealerSearch, _state2$autocompleteI = _state2.autocompleteItems, autocompleteItems = _state2$autocompleteI === undefined ? [] : _state2$autocompleteI;
              _context2.prev = 1;

              console.log('do search');
              console.log(search);
              _context2.next = 6;
              return Promise.all([_this4.doDealerSearch(search), _this4.doPredictionSearch(search)]);

            case 6:
              _ref8 = _context2.sent;
              dealerResults = _ref8[0];
              autocompleteResults = _ref8[1];


              dealerSearch = dealerResults;
              autocompleteItems = autocompleteResults;
              _context2.next = 16;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2['catch'](1);

              console.warn(_context2.t0);

            case 16:
              searchOptions = _this4.createSearchOptions({
                dealerSearch: dealerSearch,
                autocompleteItems: autocompleteItems
              });


              _this4.setState({
                dealerSearch: dealerSearch,
                autocompleteItems: autocompleteItems,
                searchOptions: searchOptions
              });

              return _context2.abrupt('return', searchOptions);

            case 19:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this4, [[1, 13]]);
    }));

    return function (_x2) {
      return _ref7.apply(this, arguments);
    };
  }();

  this.doAutoSearchFromState = function () {
    if (!_this4.state.currentSearchValue) return;

    _this4.doLocationSearchToState(_this4.state.currentSearchValue).then(function () {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
          _ref9$ = _ref9[0],
          firstResult = _ref9$ === undefined ? {} : _ref9$;

      return _this4.setState({
        currentSearchValue: firstResult.value || ''
      });
    });
  };

  this.clearAutocomplete = function () {
    _this4.setState({
      autocompleteItems: [],
      dealerSearch: [],
      searchOptions: [],
      currentSearchValue: ''
    });
  };

  this.handleInputChange = function (value) {
    _this4.setState({ didEdit: true, inputValue: value });

    if (!value) {
      return;
    }

    _this4.debouncedLocationSearchToState(value);
  };

  this.handleSelectChange = function (props, isOnLoad) {
    _this4.setState({ didEdit: true });

    var _ref10 = props || {},
        value = _ref10.value;

    if (!props || !value) {
      _this4.clearAutocomplete();
      return;
    }

    var currentItem = _this4.getCurrentItem(value);
    console.log('dealer search box');
    console.log(JSON.stringify(currentItem));
    //var place = new{}
    if (currentItem && currentItem.place_id) {
      console.log(currentItem.description);
      console.log(_this4.google);

      // this.google.searchAddress(currentItem.description, (response) => {
      //   console.log('searchAddress')
      //   console.log(JSON.stringify(response))
      //   console.log(JSON.stringify(response[0].structured_formatting.secondary_text))

      //   this.google.getPostcode(response[0].structured_formatting.secondary_text, (response2) => {
      //     console.log('getPostcodeUsingLatLong')
      //     console.log(JSON.stringify(response2))
      //   });

      //   this.google.searchAddress(response[0].structured_formatting.secondary_text, (response3) => {
      //     console.log('searchAddress again')
      //     console.log(JSON.stringify(response3))
      //   })

      // this.google.getPostcode(response.structured_formatting.secondary_text, (response1) => {
      //   console.log('getPostcode')
      //   console.log(JSON.stringify(response1))
      //   //getPlaceUsingPlaceId
      //   if(response1 && response1.length > 0)
      //   {
      //     console.log('geometry')
      //     console.log(JSON.stringify(response1[0].geometry))
      //     var geometry = response1[0].geometry.location
      //     this.google.getPostcodeUsingLatLong(geometry.lat, geometry.lng, (response2) => {
      //       console.log('getPostcodeUsingLatLong')
      //       console.log(JSON.stringify(response2))
      //     });
      //   }

      // });

      // });


      Object(__WEBPACK_IMPORTED_MODULE_6_apis_geo__["a" /* fetchGeoDataFromAddress */])({
        placeId: currentItem.place_id
      }).then(function (_ref11) {
        var addressDetails = _ref11.addressDetails;

        console.log(addressDetails);
        currentItem = addressDetails;
        _this4.props.onChange(currentItem, isOnLoad);
      });

      _this4.props.onSelect(currentItem.description, currentItem.place_id);
    } else if (currentItem && currentItem.value) {
      currentItem = _extends({}, currentItem, { dealerCode: currentItem.value });
      _this4.props.onChange(currentItem, isOnLoad);
    } else {
      _this4.props.onChange(currentItem, isOnLoad);
    }
    // We don't want a GTM event to fire on first load, hence the checking.
    if (!isOnLoad && _this4.state.searchOptions[value]) {
      _this4.props.gtmEvent({
        gtmID: _this4.props.gtmMapping.ENTER_LOCATION,
        gtmPayload: {
          location: _this4.state.searchOptions[value].label
        }
      });
    }

    _this4.setState({ currentSearchValue: value });
  };

  this.createSearchOptions = function (_ref12) {
    var _ref12$dealerSearch = _ref12.dealerSearch,
        dealerSearch = _ref12$dealerSearch === undefined ? [] : _ref12$dealerSearch,
        _ref12$autocompleteIt = _ref12.autocompleteItems,
        autocompleteItems = _ref12$autocompleteIt === undefined ? [] : _ref12$autocompleteIt;

    if (dealerSearch) {
      var dealersCount = dealerSearch.length;
      return dealerSearch.map(function (_ref13, index) {
        var display = _ref13.display;
        return {
          value: index.toString(),
          label: display
        };
      }).concat(autocompleteItems.map(function (_ref14, index) {
        var description = _ref14.description;
        return {
          value: (index + dealersCount).toString(),
          label: description
        };
      }));
    }
    return [];
  };

  this.getCurrentItem = function (searchValue) {
    var _state3 = _this4.state,
        _state3$dealerSearch = _state3.dealerSearch,
        dealerSearch = _state3$dealerSearch === undefined ? [] : _state3$dealerSearch,
        _state3$autocompleteI = _state3.autocompleteItems,
        autocompleteItems = _state3$autocompleteI === undefined ? [] : _state3$autocompleteI;

    return dealerSearch.concat(autocompleteItems)[parseInt(searchValue, 10)];
  };
};

DealerSearchBox.displayName = 'DealerSearchBox';


DealerSearchBox.propTypes = {
  dealerSearchEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  componentRestrictions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  searchOverride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmMapping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

DealerSearchBox.defaultProps = {
  dealerSearchEndPoint: '',
  placeholder: 'Enter your postcode, suburb or Dealer name',
  value: '',
  onSelect: __WEBPACK_IMPORTED_MODULE_7_utils__["C" /* noop */],
  onChange: __WEBPACK_IMPORTED_MODULE_7_utils__["C" /* noop */],
  componentRestrictions: {},
  gtmMapping: {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8_higher_order_components__["i" /* gtmEvent */])()(DealerSearchBox));

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apis_koala__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dealer_details__ = __webpack_require__(1571);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\dealers-field\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var DealersField = function (_Component) {
  _inherits(DealersField, _Component);

  function DealersField(props) {
    _classCallCheck(this, DealersField);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onChange = function (location) {
      var onChange = _this.props.onChange;

      onChange({
        id: location.id,
        code: location.dealerCode
      });
    };

    _this.fetchDealers = function (postcode) {
      var _this$props = _this.props,
          endpoint = _this$props.endpoint,
          initialLocations = _this$props.initialLocations,
          type = _this$props.type;

      if (initialLocations.length || !postcode) return;
      var options = {
        DealerType: type || null,
        PostCode: postcode
      };
      _this.setState({
        dealersSpinner: true,
        dealers: null
      });
      Object(__WEBPACK_IMPORTED_MODULE_4_apis_koala__["a" /* fetchKoalaData */])(endpoint, options).then(function (dealers) {
        if (!dealers) return;

        _this.setState({
          dealers: dealers,
          dealersSpinner: false
        }, function () {
          _this.onChange(dealers[0]);
        });
      }).catch(function (error) {
        /**
        * @todo  handle errors here
        */
        console.warn(error);
      });
    };

    _this.state = {
      dealers: props.initialLocations || []
    };
    return _this;
  }

  DealersField.prototype.componentDidMount = function componentDidMount() {
    var initialLocations = this.props.initialLocations;

    initialLocations.length && this.onChange(initialLocations[0]);
  };

  DealersField.prototype.componentWillReceiveProps = function componentWillReceiveProps(newprops) {
    var getPostecode = Object(__WEBPACK_IMPORTED_MODULE_6_utils__["q" /* get */])('location.value.postcode');
    if (getPostecode(newprops) !== getPostecode(this.props) && newprops.location && newprops.location.value) {
      this.fetchDealers(newprops.location.value.postcode);
    }
  };

  DealersField.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        _props$value = _props.value,
        value = _props$value === undefined ? {} : _props$value,
        type = _props.type,
        subTitle = _props.subTitle,
        gtmEvents = _props.gtmEvents;
    var dealers = this.state.dealers;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { margin: '1em 0' }, __source: {
          fileName: _jsxFileName,
          lineNumber: 79
        }
      },
      dealers && dealers.length > 0 ? dealers.map(function (location) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            key: location.id,
            style: {
              display: 'flex',
              flexDirection: 'row',
              color: value.id === location.id ? 'black' : undefined
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 82
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { padding: '.25em' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 89
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["h" /* CheckBox */], {
              checked: value.id === location.id,
              onClick: function onClick() {
                return _this2.onChange(location);
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 90
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: {
                flexGrow: 1,
                paddingLeft: '2em',
                lineHeight: 1.2,
                fontWeight: 300,
                cursor: 'pointer'
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 94
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__dealer_details__["a" /* default */], { compact: _this2.props.compact, gtmEvents: gtmEvents, location: location, type: type, __source: {
                fileName: _jsxFileName,
                lineNumber: 102
              }
            })
          )
        );
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { style: { textAlign: 'center', fontWeight: 200, lineHeight: 1.6 }, __source: {
            fileName: _jsxFileName,
            lineNumber: 107
          }
        },
        __WEBPACK_IMPORTED_MODULE_3_constants_errors__["c" /* FORM_ERRORS */].DEALERS_NO_POSTCODE
      )
    );
  };

  return DealersField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DealersField.displayName = 'DealersField';


DealersField.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['service', 'sales', 'parts']),
  endpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  initialLocations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

DealersField.defaultProps = {
  initialLocations: []
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(DealersField));

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\dealers-field\\dealer-details.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var fullAddress = function fullAddress(location) {
  var address = location.address,
      suburb = location.suburb,
      state = location.state,
      postCode = location.postCode;

  var region = Object(__WEBPACK_IMPORTED_MODULE_2_utils__["f" /* compact */])([state, postCode]).join(" ");
  return Object(__WEBPACK_IMPORTED_MODULE_2_utils__["g" /* compactMap */])(__WEBPACK_IMPORTED_MODULE_2_utils__["T" /* titleCase */], [address, suburb]).concat(region || []).join(", ");
};

var HoursIcon = function HoursIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5c-4.6 0-8.4-3.8-8.4-8.4S5.4 1.6 10 1.6s8.4 3.8 8.4 8.4zm-1.6 0c0-3.7-3-6.8-6.8-6.8s-6.8 3-6.8 6.8 3 6.8 6.8 6.8c1.8 0 3.5-.7 4.8-2s2-3 2-4.8zm-5.9-.3l3.5 2.2-.9 1.5-4.4-2.7V5h1.7v4.7z", __source: {
        fileName: _jsxFileName,
        lineNumber: 18
      }
    })
  );
};

HoursIcon.displayName = "HoursIcon";
HoursIcon.displayName = "HoursIcon";
var AddressIcon = function AddressIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M17 7.3c0 3.1-1.6 5.5-3.3 7.6-.9 1.1-3.1 4-3.1 4l-.6.9-.7-.9s-2.2-2.9-3.1-4C4.6 12.8 3 10.4 3 7.3 3 3.4 6.2.2 10 .2s7 3.2 7 7.1zm-1.6-.1c0-3-2.4-5.4-5.4-5.4S4.6 4.3 4.6 7.2c0 2.4 1.1 4.2 2.9 6.6.6.8 1.7 2.2 2.4 3.2.7-1 1.9-2.4 2.4-3.2 2-2.3 3.1-4.2 3.1-6.6zm-3.2-.6c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2.9 2.2 2.2z", __source: {
        fileName: _jsxFileName,
        lineNumber: 24
      }
    })
  );
};

AddressIcon.displayName = "AddressIcon";
AddressIcon.displayName = "AddressIcon";
var WebsiteIcon = function WebsiteIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5-4.3-1-5.9-2.5-2.5-3.7-2.5-6 1-4.4 2.5-6 3.7-2.5 6-2.5c2.2 0 4.4.9 6 2.5s2.4 3.8 2.4 6zM3.3 9.1h2.8c0-1.8.4-3.5.9-4.8.1-.2.2-.3.2-.5-.8.3-1.4.8-2 1.4-1.1 1.1-1.7 2.5-1.9 3.9zm1.9 5.7c.6.6 1.3 1.1 2 1.4 0-.2-.1-.3-.2-.5-.5-1.3-.9-3-.9-4.8H3.3c.2 1.4.8 2.8 1.9 3.9zM10 3.2c-.3 0-.9.5-1.4 1.7-.4 1.2-.7 2.6-.8 4.2h4.4c-.1-1.6-.4-3.1-.8-4.2 0-.1-.1-.1-.1-.2.8.2 1.5.6 2.2 1.1.2 1 .4 2.1.5 3.3h2.8c-.2-1.5-.8-2.9-1.9-3.9-1.4-1.3-3.1-2-4.9-2zm1.4 11.9c.5-1.1.7-2.6.8-4.2H7.8c.1 1.6.4 3.1.8 4.2.5 1.3 1.1 1.7 1.4 1.7s.9-.5 1.4-1.7zm5.3-4.2h-2.8c-.1 1.8-.4 3.5-.9 4.8-.1.2-.2.4-.2.5.8-.3 1.4-.8 2-1.4 1.1-1.1 1.7-2.5 1.9-3.9z", __source: {
        fileName: _jsxFileName,
        lineNumber: 30
      }
    })
  );
};

WebsiteIcon.displayName = "WebsiteIcon";
WebsiteIcon.displayName = "WebsiteIcon";
var PhoneIcon = function PhoneIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M1.4 14.7c-.3-.9 0-1.5.9-1.9.6-.3 1.5-.7 2.2-1 .5-.2 1-.5 1.4-.6.2-.1.4-.2.7-.2.5 0 .9.4 1 .5l.9.9c.5-.3 1.4-.9 2.2-1.7s1.4-1.7 1.7-2.2l-.9-.9c-.7-.6-.6-1.2-.3-1.8.2-.4.4-.8.6-1.4.3-.7.7-1.6 1-2.2.1-.3.4-1 1.2-1 .2 0 .4.1.6.1 2 .6 4 2.1 4 4.2 0 2-1.6 5.7-4.6 8.6-3 3-6.6 4.6-8.6 4.6-1.9.1-3.5-2-4-4zm1.5-.4c.4 1.4 1.5 2.9 2.6 2.9 1.4 0 4.7-1.3 7.6-4.1 2.8-2.8 4.1-6.1 4.1-7.6 0-1.1-1.5-2.2-2.9-2.6-.3.6-.7 1.5-1 2.2-.2.5-.5 1-.6 1.3v.1l1.7 1.7-.2.5c0 .1-.8 1.6-2.3 3.1-1.5 1.5-3 2.2-3.1 2.3l-.5.2-1.7-1.7h-.1c-.3.2-.8.4-1.3.6-.9.4-1.7.8-2.3 1.1z", __source: {
        fileName: _jsxFileName,
        lineNumber: 36
      }
    })
  );
};

PhoneIcon.displayName = "PhoneIcon";
PhoneIcon.displayName = "PhoneIcon";
var InfoIcon = function InfoIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5c-4.6 0-8.4-3.8-8.4-8.4 0-2.2.9-4.4 2.5-6s3.7-2.5 6-2.5c4.6 0 8.4 3.8 8.4 8.4zm-1.6 0c0-3.7-3-6.8-6.8-6.8-1.8 0-3.5.7-4.8 2s-2 3-2 4.8c0 3.7 3 6.8 6.8 6.8 1.8 0 3.5-.7 4.8-2s2-3 2-4.8zM9.1 5.7h1.7v1.7H9.1V5.7zm0 2.8h1.7v5.8H9.1V8.5z", __source: {
        fileName: _jsxFileName,
        lineNumber: 42
      }
    })
  );
};

InfoIcon.displayName = "InfoIcon";
InfoIcon.displayName = "InfoIcon";
var Icon = function Icon(_ref) {
  var name = _ref.name;

  var style = {
    height: "1.3em",
    width: "1.3em",
    marginRight: "1em",
    fill: "#999999",
    flexShrink: 0
  };
  switch (name) {
    case "hours":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HoursIcon, { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 56
        }
      });
    case "address":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddressIcon, { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 58
        }
      });
    case "website":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WebsiteIcon, { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 60
        }
      });
    case "phone":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PhoneIcon, { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        }
      });
    case "info":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoIcon, { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 64
        }
      });
  }
};

var DealerDetails = function (_React$PureComponent) {
  _inherits(DealerDetails, _React$PureComponent);

  function DealerDetails() {
    _classCallCheck(this, DealerDetails);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  DealerDetails.prototype.render = function render() {
    var _props = this.props,
        location = _props.location,
        type = _props.type,
        gtmEvents = _props.gtmEvents;

    var department = location.departments.find(function (department) {
      return department.name.toLowerCase() === type;
    });
    var asAbsolute = function asAbsolute(url) {
      if (url.slice(0, "http://".length) === "http://" || url.slice(0, "https://".length) === "https://") {
        return url;
      }
      return "http://" + url;
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { marginBottom: "2em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 84
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], { value: location.name, tag: "h5", __source: {
          fileName: _jsxFileName,
          lineNumber: 85
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "ul",
        { style: { padding: 0, margin: "1em 0", listStyleType: "none" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 86
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { style: [dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn], __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "address", __source: {
              fileName: _jsxFileName,
              lineNumber: 88
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 89
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["H" /* Hyperlink */], {
              text: fullAddress(this.props.location),
              href: "https://google.com.au/maps?q=" + fullAddress(this.props.location).replace(/ /g, "+") + "/",
              external: true,
              gtmEvents: [{
                func: gtmEvents[0].func,
                args: [{
                  gtmID: gtmEvents[0].args[0].gtmID,
                  gtmPayload: {
                    dealerName: location.name,
                    address: fullAddress(this.props.location)
                  }
                }]
              }], __source: {
                fileName: _jsxFileName,
                lineNumber: 90
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { style: [dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn], __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "hours", __source: {
              fileName: _jsxFileName,
              lineNumber: 111
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 112
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 113
                }
              },
              "Opening hours:"
            ),
            department.hours.map(function (label, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 114
                  }
                },
                label
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { style: [dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn], __source: {
              fileName: _jsxFileName,
              lineNumber: 117
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "website", __source: {
              fileName: _jsxFileName,
              lineNumber: 118
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 119
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["H" /* Hyperlink */], {
              text: location.websiteLabel,
              href: asAbsolute(location.website),
              external: true,
              gtmEvents: [{
                func: gtmEvents[1].func,
                args: [{
                  gtmID: gtmEvents[1].args[0].gtmID,
                  gtmPayload: {
                    dealerName: location.name,
                    address: fullAddress(this.props.location),
                    website: location.websiteLabel
                  }
                }]
              }], __source: {
                fileName: _jsxFileName,
                lineNumber: 120
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { style: [dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn], __source: {
              fileName: _jsxFileName,
              lineNumber: 141
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "phone", __source: {
              fileName: _jsxFileName,
              lineNumber: 142
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 143
              }
            },
            this.props.compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["H" /* Hyperlink */], {
              text: department.phoneLabel,
              href: "tel:" + department.phone,
              gtmEvents: [{
                func: gtmEvents[2].func,
                args: [{
                  gtmID: gtmEvents[2].args[0].gtmID,
                  gtmPayload: {
                    dealerName: location.name,
                    address: fullAddress(this.props.location),
                    phone: department.phone
                  }
                }]
              }], __source: {
                fileName: _jsxFileName,
                lineNumber: 145
              }
            }),
            !this.props.compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 164
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_2_utils__["p" /* formatPhoneNumber */])(department.phoneLabel)
            )
          )
        )
      )
    );
  };

  return DealerDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

DealerDetails.displayName = "DealerDetails";

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["f" /* Radium */])(DealerDetails));

var dealerDetailStyles = {
  detailItem: {
    display: "flex",
    fontWeight: 200,
    margin: ".5em 0",
    lineHeight: "1.4"
  }
};

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(13);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\input-label\\index.jsx";





var InputLabel = function InputLabel(_ref) {
  var textArea = _ref.textArea,
      dirty = _ref.dirty,
      text = _ref.text,
      required = _ref.required,
      disabled = _ref.disabled,
      styleName = _ref.styleName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      "data-test": "input-label",
      style: [labelStyles.base({ textArea: textArea, styleName: styleName }), dirty ? labelStyles.dirty : labelStyles.clean, disabled ? labelStyles.disabled : {}], __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    text,
    required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "sup",
      { style: { color: "#bf0000", fontWeight: "300" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      },
      "*"
    )
  );
};

InputLabel.displayName = "InputLabel";
InputLabel.displayName = "InputLabel";
InputLabel.propTypes = {
  textArea: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // To detect if the label is for textArea, then we move the label to top-left
  dirty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  styleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

InputLabel.defaultProps = {
  textArea: false,
  dirty: false,
  required: false,
  text: "",
  styleName: "light",
  disabled: false
};

var labelStyles = {
  base: function base(_ref2) {
    var textArea = _ref2.textArea,
        styleName = _ref2.styleName;
    return {
      position: "absolute",
      bottom: textArea ? undefined : 0,
      top: textArea ? 0 : undefined,
      left: 0,
      padding: "0.25em 0 0.75em",
      fontWeight: 200,
      color: styleName === "light" ? __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_DARK : __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].WHITE,
      transition: "transform .25s"
    };
  },
  clean: {
    pointerEvents: "none"
  },
  dirty: {
    fontSize: "80%",
    transform: "translateY(-100%)"
  },
  disabled: {
    opacity: 0.32,
    cursor: "not-allowed"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(InputLabel));

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\input-radio\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var InputRadio = function (_React$Component) {
  _inherits(InputRadio, _React$Component);

  function InputRadio(props) {
    _classCallCheck(this, InputRadio);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleClick = function () {
      _this.setState({
        checked: !_this.state.checked
      }, function () {
        _this.props.handleOnClick && _this.props.handleOnClick();
      });
    };

    _this.state = {
      checked: props.checked || false
    };
    return _this;
  }

  InputRadio.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    this.setState({
      checked: newProps.checked
    });
  };

  InputRadio.prototype.render = function render() {
    var _props = this.props,
        handleOnClick = _props.handleOnClick,
        name = _props.name,
        checked = _props.checked,
        label = _props.label;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.main, onClick: this.handleClick, __source: {
          fileName: _jsxFileName,
          lineNumber: 31
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        name: this.props.name,
        type: 'radio',
        style: styles.input,
        checked: this.state.checked ? 'checked' : '',
        value: this.state.checked, __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { htmlFor: this.props.name, key: 'label', style: styles.label, __source: {
            fileName: _jsxFileName,
            lineNumber: 38
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 39
            }
          },
          ' ',
          this.props.label,
          ' '
        )
      ),
      !this.state.checked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.unchecked, __source: {
            fileName: _jsxFileName,
            lineNumber: 42
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.insideUnChecked, __source: {
            fileName: _jsxFileName,
            lineNumber: 43
          }
        })
      ),
      this.state.checked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.checked, __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.insideChecked, __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        })
      )
    );
  };

  return InputRadio;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InputRadio.displayName = 'InputRadio';


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])()(InputRadio));

var styles = {
  main: {
    position: 'relative',
    flexGrow: 1,
    flexDirection: 'row',
    display: 'flex',
    margin: '0.5em 1em 0.5em 0px'
  },
  label: {
    display: 'block',
    lineHeight: '1.25em',
    position: 'relative',
    padding: '0 0 0 2em',
    margin: '0px auto',
    zIndex: 10,
    cursor: 'pointer',
    width: '100%'
  },
  unchecked: {
    display: 'block',
    position: 'absolute',
    border: '2px solid ' + __WEBPACK_IMPORTED_MODULE_1_constants_color_palette__["a" /* default */].GRAY,
    borderRadius: '100%',
    height: '1em',
    width: '1em',
    top: '0',
    left: '0',
    zIndex: '5',
    transition: 'border .25s linear',
    ':hover': {
      border: '5px solid #FFFFFF'
    }
  },
  insideUnChecked: {},
  checked: {
    display: 'block',
    position: 'absolute',
    border: '2px solid ' + __WEBPACK_IMPORTED_MODULE_1_constants_color_palette__["a" /* default */].GRAY,
    borderRadius: '100%',
    height: '1em',
    width: '1em',
    top: '0',
    left: '0',
    zIndex: '5',
    transition: 'border .25s linear',
    ':hover': {
      border: '5px solid #FFFFFF'
    }
  },
  insideChecked: {
    backgroundColor: '' + __WEBPACK_IMPORTED_MODULE_1_constants_color_palette__["a" /* default */].RED,
    width: '0.5em',
    height: '0.5em',
    position: 'absolute',
    top: '25%',
    left: '25%',
    borderRadius: '100%'
  },
  input: {
    position: 'absolute',
    visibility: 'hidden',
    width: '0px',
    height: '0px'
  }
};

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_function__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bowser__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\input-text\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var renderIcon = function renderIcon(name, style) {
  switch (name) {
    case "error":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["r" /* ErrorIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      });
    case "search":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["_0" /* SearchIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      });
    case "cross":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["m" /* CrossIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      });
    case "eye":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["v" /* EyeIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 18
        }
      });
  }
};

var themeLight = {
  label: function label(valid) {
    return {
      color: "#d5d5d5"
    };
  },
  input: function input(valid) {
    return {
      color: valid ? "#101010" : "#910A2D",
      borderColor: valid ? "#d5d5d5" : "#910A2D"
    };
  },
  message: function message(valid) {
    return {
      color: valid ? "#999999" : "#910A2D"
    };
  },
  iconSvg: function iconSvg(valid) {
    return {
      fill: valid ? "#999" : "#910A2D"
    };
  }
};

var themeDark = {
  label: function label(valid) {
    return {
      color: "#fff"
    };
  },
  input: function input(valid) {
    return {
      color: valid ? "#fff" : "#910A2D",
      borderColor: valid ? "#d5d5d5" : "#910A2D"
    };
  },
  message: function message(valid) {
    return {
      color: valid ? "#fff" : "#910A2D"
    };
  },
  iconSvg: function iconSvg(valid) {
    return {
      fill: valid ? "#fff" : "#910A2D"
    };
  }
};

var themes = {
  dark: themeDark,
  light: themeLight

  /**
   * @param {Object} props - Component props
   * @param {String} props.label - Field label text
   * @param {String} props.value - Input value
   * @param {Number} props.maxLength - input maxLength property
   * @param {String} props.placeholder - Field placeholder text
   * @param {Boolean} props.disabled - disable input
   * @param {String} props.icon - Name of icon
   * @param {Boolean} props.isValid - validation status of input
   * @param {String} props.message - message displayed after input
   * @param {Boolean} props.required - input required
   * @param {Function} props.onChange - onChange callback of input
   * @param {Function} props.onIconClick - Callback for when icon is clicked.
   * @param {Function} props.styleName - change the theme of the component
   * @returns {ReactElement} React Component
   */
};
var InputText = function (_Component) {
  _inherits(InputText, _Component);

  function InputText() {
    var _temp, _this, _ret;

    _classCallCheck(this, InputText);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onBlurHandler = function () {
      var _this$props = _this.props,
          onBlur = _this$props.onBlur,
          gtmEvents = _this$props.gtmEvents;

      onBlur && onBlur();
      gtmEvents && Object(__WEBPACK_IMPORTED_MODULE_3_utils_function__["e" /* invokeFuncs */])(gtmEvents);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  InputText.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        innerRef = _props.innerRef,
        label = _props.label,
        focus = _props.focus,
        gtmEvents = _props.gtmEvents,
        initialValue = _props.initialValue,
        value = _props.value,
        type = _props.type,
        _props$showBorderBott = _props.showBorderBottom,
        showBorderBottom = _props$showBorderBott === undefined ? true : _props$showBorderBott,
        required = _props.required,
        placeholder = _props.placeholder,
        onIconClick = _props.onIconClick,
        icon = _props.icon,
        iconText = _props.iconText,
        message = _props.message,
        isValid = _props.isValid,
        margin = _props.margin,
        styleName = _props.styleName,
        style = _props.style,
        id = _props.id,
        inputProps = _objectWithoutProperties(_props, ["innerRef", "label", "focus", "gtmEvents", "initialValue", "value", "type", "showBorderBottom", "required", "placeholder", "onIconClick", "icon", "iconText", "message", "isValid", "margin", "styleName", "style", "id"]);

    var themeStyles = themes[styleName];
    var visiblePlaceholder = !label && placeholder ? placeholder : "";

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: _extends({
          margin: margin || "1em auto 1.9em",
          position: "relative"
        }, style),
        "data-test": id || "input-text", __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { position: "relative" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 117
          }
        },
        label && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["I" /* InputLabel */], {
          text: label,
          dirty: !!(value && value.length > 0),
          required: !inputProps.disabled && required,
          styleName: styleName,
          disabled: inputProps.disabled,
          style: styles.label,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 119
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({}, inputProps, {
          ref: function ref(c) {
            innerRef && innerRef(c);
            _this2.inputEl = c;
          },
          style: [styles.input, showBorderBottom && styles.inputBorder, themeStyles.input(isValid), { opacity: inputProps.disabled ? 0.6 : 1 }, styles.iconPadding],
          type: type || "text",
          placeholder: !__WEBPACK_IMPORTED_MODULE_4_bowser___default.a.msie ? visiblePlaceholder : "" // Special IE placeholder implementation below
          , value: value || "",
          onBlur: this.onBlurHandler,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 128
          }
        })),
        __WEBPACK_IMPORTED_MODULE_4_bowser___default.a.msie && (!value || value && !value.length) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: [{
              pointerEvents: "none",
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              textAlign: "left",
              fontWeight: 200
            }, styles.iconPadding], __source: {
              fileName: _jsxFileName,
              lineNumber: 148
            }
          },
          visiblePlaceholder
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.iconWrapper, __source: {
              fileName: _jsxFileName,
              lineNumber: 165
            }
          },
          icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              onClick: function onClick() {
                return onIconClick({ icon: icon });
              },
              style: [styles.iconContainer, !!onIconClick && { cursor: "pointer" }], __source: {
                fileName: _jsxFileName,
                lineNumber: 167
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: [styles.icon, { display: icon === "eye" ? "inline-block" : "block" }], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 170
                }
              },
              renderIcon(icon, _extends({}, themeStyles.iconSvg(true), styles.baseSvg))
            ),
            icon === "eye" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: styles.iconText, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 176
                }
              },
              iconText
            )
          ),
          !isValid && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: [styles.iconContainer, styles.fadeIn], __source: {
                fileName: _jsxFileName,
                lineNumber: 180
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.icon, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 181
                }
              },
              renderIcon("error", _extends({}, themeStyles.iconSvg(isValid), styles.baseSvg))
            )
          )
        )
      ),
      message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { style: [styles.message, themeStyles.message(isValid), styles.fadeIn], __source: {
            fileName: _jsxFileName,
            lineNumber: 192
          }
        },
        message
      )
    );
  };

  return InputText;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

InputText.displayName = "InputText";


InputText.propTypes = {
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  attributes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onIconClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showBorderBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  maxLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  focus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  margin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  styleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["light", "dark"]),
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

InputText.defaultProps = {
  focus: false,
  isValid: true,
  margin: "",
  styleName: "light"
};

var fadeInKeyframes = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["b" /* keyframes */])({
  from: {
    opacity: 0
  }
});

var styles = {
  baseSvg: {
    height: "100%",
    width: "100%"
  },
  fadeIn: {
    animation: "x .666s",
    animationName: fadeInKeyframes
  },
  message: {
    position: "absolute",
    fontSize: "75%",
    fontWeight: 200,
    top: "calc(100% + .6em)",
    margin: 0
  },
  iconWrapper: {
    position: "absolute",
    right: ".5em",
    top: "65%"
  },
  iconContainer: {
    float: "right",
    padding: "0px 0px 0px 3px"
  },
  icon: {
    width: "1em",
    height: "1em",
    transform: "translateY(-50%)"
  },
  input: {
    fontWeight: 200,
    WebkitAppearance: "none",
    caretColor: "currentColor",
    /* disable box shadow for firefox red shadow on page load bug */
    boxShadow: "none",
    background: "none",
    boxSizing: "border-box",
    width: "100%",
    outline: "none",
    borderRadius: 0,
    borderWidth: "0px"
  },
  inputBorder: {
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    borderBottomStyle: "solid",
    borderBottomWidth: "1px"
  },
  iconPadding: {
    padding: "1.5em 1.4em .75em 0"
  },
  iconText: {
    display: "inline-block",
    fontSize: "14px",
    lineHeight: "22px",
    marginLeft: "0.25em",
    transform: "translateY(-50%)"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(InputText));

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_function__ = __webpack_require__(35);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\input-textarea\\index.jsx";






/**
 * @param {String} label - Field label text
 * @param {String} value - Input value
 * @param {Number} maxLength - input maxLength property
 * @param {String} placeholder - Field placeholder text
 * @param {Boolean} disabled - disable input
 * @param {String} icon - Name of icon
 * @param {Boolean} isValid - validation status of input
 * @param {String} message - message displayed after input
 * @param {Boolean} required - input required
 * @param {Function} onChange - onChange callback of input
 * @returns {ReactElement} React Component
 */
var InputTextArea = function InputTextArea(_ref) {
  var label = _ref.label,
      value = _ref.value,
      maxLength = _ref.maxLength,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      icon = _ref.icon,
      isValid = _ref.isValid,
      message = _ref.message,
      required = _ref.required,
      _onChange = _ref.onChange,
      type = _ref.type,
      name = _ref.name,
      _onBlur = _ref.onBlur,
      onKeyDown = _ref.onKeyDown,
      onFocus = _ref.onFocus,
      autoComplete = _ref.autoComplete,
      gtmEvents = _ref.gtmEvents;

  var valid = typeof isValid === "undefined" || isValid;
  var color = valid ? "#d5d5d5" : "#bf0000";
  var textColor = valid ? "#101010" : "#bf0000";
  var autoResize = function autoResize(e) {
    e.target.style.height = e.target.scrollHeight + "px";
  };
  /**
   * onMouseUp and onClick was added to fix IE bugs
   * However, it slows down the typing experience as the browser now has to check for 4 events
   * we can drop those 2 event hooks when IE removed from support list
   */
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { margin: "1em auto 1.5em", position: "relative" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 51
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { position: "relative", color: textColor }, __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        }
      },
      label && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["I" /* InputLabel */], { textArea: true, text: label, dirty: value && value.length > 0, required: required, __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", {
        rows: "1",
        ref: "input",
        style: [styles.input, styles.border(color), { color: textColor }, styles.iconPadding(icon)],
        type: type || "text",
        name: name,
        disabled: disabled,
        required: required,
        placeholder: !label && placeholder ? placeholder : "",
        value: value || "",
        onKeyDown: onKeyDown,
        autoComplete: autoComplete,
        onFocus: onFocus,
        onBlur: function onBlur() {
          gtmEvents && Object(__WEBPACK_IMPORTED_MODULE_4_utils_function__["e" /* invokeFuncs */])(gtmEvents);
          _onBlur && _onBlur();
        },
        maxLength: maxLength,
        onChange: function onChange(e) {
          _onChange(e);
          autoResize(e);
        },
        onKeyUp: function onKeyUp(e) {
          _onChange(e);
          autoResize(e);
        },
        onMouseUp: function onMouseUp(e) {
          _onChange(e);
          autoResize(e);
        },
        onClick: function onClick(e) {
          _onChange(e);
          autoResize(e);
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 56
        }
      }),
      !valid && icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: [styles.iconWrapper, styles.fadeIn], __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.icon, __source: {
              fileName: _jsxFileName,
              lineNumber: 97
            }
          },
          icon("error", color)
        )
      ),
      icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.iconWrapper, __source: {
            fileName: _jsxFileName,
            lineNumber: 101
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.icon, __source: {
              fileName: _jsxFileName,
              lineNumber: 102
            }
          },
          icon(icon, "#999999")
        )
      )
    ),
    message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      { style: [styles.message(textColor), styles.fadeIn], __source: {
          fileName: _jsxFileName,
          lineNumber: 106
        }
      },
      message
    )
  );
};

InputTextArea.displayName = "InputTextArea";
InputTextArea.displayName = "InputTextArea";
InputTextArea.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  maxLength: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  placeholder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  icon: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  isValid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  autoComplete: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array
};

var fadeInKeyframes = Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___["b" /* keyframes */])({
  from: {
    opacity: 0
  }
});

var styles = {
  fadeIn: {
    animation: "x .666s",
    animationName: fadeInKeyframes
  },
  iconPadding: function iconPadding(icon) {
    return {
      padding: icon ? "1.5em calc(1.4em + 1em) .75em 0" : "0 0 .5em"
    };
  },
  message: function message(color) {
    return {
      position: "absolute",
      color: color,
      fontSize: "75%",
      fontWeight: 200,
      top: "calc(100% + .5em)",
      margin: 0
    };
  },
  iconWrapper: {
    position: "absolute",
    right: ".5em",
    top: "50%"
  },
  icon: {
    width: "1.4em",
    height: "1.4em",
    transform: "translateY(-50%)"
  },
  input: {
    fontFamily: "inherit",
    fontWeight: 200,
    fontSize: "100%",
    background: "none",
    boxSizing: "border-box",
    width: "100%",
    outline: "none",
    overflow: "hidden",
    resize: "none",
    transition: ".2s",
    height: "26px"
  },
  border: function border(color) {
    return {
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      borderBottom: "1px solid " + color
    };
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___["a" /* default */])(InputTextArea));

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\input-time\\index.jsx";






var renderIcon = function renderIcon(name, style) {
  switch (name) {
    case "error":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["r" /* ErrorIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      });
    case "search":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_0" /* SearchIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      });
    case "cross":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["m" /* CrossIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      });
    default:
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["m" /* CrossIcon */], { style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      });
  }
};

var HOURS = "01,02,03,04,05,06,07,08,09,10,11,12".split(",").map(function (name) {
  return { name: name, value: name.toLowerCase() };
});
var MINUTES = "00,15,30,45".split(",").map(function (name) {
  return { name: name, value: name };
});
var AMPM = "am,pm".split(",").map(function (name) {
  return { name: name.toUpperCase(), value: name };
});

var themeDark = {
  label: function label(valid) {
    return {
      color: "ddd"
    };
  },
  input: function input(valid) {
    return {
      color: valid ? "#101010" : "#bf0000",
      borderColor: valid ? "#ddd" : "#bf0000"
    };
  },
  message: function message(valid) {
    return {
      color: valid ? "#101010" : "#bf0000"
    };
  },
  iconSvg: function iconSvg(valid) {
    return {
      fill: valid ? "#999" : "#bf0000"
    };
  }
};

var themeLight = {
  label: function label(valid) {
    return {
      color: "#fff"
    };
  },
  input: function input(valid) {
    return {
      color: valid ? "#fff" : "#bf0000",
      borderColor: valid ? "#ddd" : "#bf0000"
    };
  },
  message: function message(valid) {
    return {
      color: valid ? "#fff" : "#bf0000"
    };
  },
  iconSvg: function iconSvg(valid) {
    return {
      fill: valid ? "#fff" : "#bf0000"
    };
  }
};

var themes = {
  dark: themeDark,
  light: themeLight

  /**
   * @param {Object} props - Component props
   * @param {String} props.label - Field label text
   * @param {String} props.value - Input value
   * @param {String} props.defaultValue - Default field value
   * @param {Number} props.maxLength - input maxLength property
   * @param {String} props.placeholder - Field placeholder text
   * @param {Boolean} props.disabled - disable input
   * @param {String} props.icon - Name of icon
   * @param {Boolean} props.isValid - validation status of input
   * @param {String} props.message - message displayed after input
   * @param {Boolean} props.required - input required
   * @param {Function} props.onChange - onChange callback of input
   * @param {Function} props.onIconClick - Callback for when icon is clicked.
   * @param {Function} props.styleName - change the theme of the component
   * @param {Array} props.gtmEvents - Array of gtm events
   * @returns {ReactElement} React Component
   */
};var InputTime = function InputTime(_ref) {
  var label = _ref.label,
      value = _ref.value,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === undefined ? "09:00 am" : _ref$defaultValue,
      required = _ref.required,
      _onChange = _ref.onChange,
      onIconClick = _ref.onIconClick,
      icon = _ref.icon,
      message = _ref.message,
      isValid = _ref.isValid,
      styleName = _ref.styleName;

  var themeStyles = themes[styleName];

  var time = value || defaultValue;

  var hhmmam = "";

  var lessThan9Add0 = function lessThan9Add0(number) {
    var newString = String(number);
    if (newString.length < 2) {
      return "0" + newString;
    }
    return newString;
  };
  if (time.includes("/")) {
    hhmmam = [lessThan9Add0(String(time.split("/")[0])), lessThan9Add0(String(time.split("/")[1])), time.split("/")[2]];
  } else {
    hhmmam = [lessThan9Add0(String(time.split(":")[0])), lessThan9Add0(String(time.split(":")[1].split(" ")[0])), time.split(" ")[1]];
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { marginTop: "-1em", position: "relative" }, "data-test": "input-time", __source: {
        fileName: _jsxFileName,
        lineNumber: 120
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { position: "relative" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 121
        }
      },
      label && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { position: "absolute", top: "70%", width: "100%" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 123
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["I" /* InputLabel */], { text: label, dirty: true, required: required, __source: {
            fileName: _jsxFileName,
            lineNumber: 124
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { display: "flex", flexDirection: "row" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 127
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_2" /* Select */], {
          label: "",
          options: HOURS,
          value: { name: hhmmam[0], value: hhmmam[0] },
          onChange: function onChange(v) {
            _onChange(v.value + ":" + hhmmam[1] + " " + hhmmam[2]);
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 128
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { minWidth: "1em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 135
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_2" /* Select */], {
          label: "",
          options: MINUTES,
          value: { name: hhmmam[1], value: hhmmam[1] },
          onChange: function onChange(v) {
            _onChange(hhmmam[0] + ":" + v.value + " " + hhmmam[2]);
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 136
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { minWidth: "1em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 143
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_2" /* Select */], {
          label: "",
          options: AMPM,
          value: { name: hhmmam[2], value: hhmmam[2] && hhmmam[2].toLowerCase() },
          onChange: function onChange(v) {
            _onChange(hhmmam[0] + ":" + hhmmam[1] + " " + v.value);
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 144
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 151
          }
        })
      ),
      icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          onClick: function onClick() {
            return onIconClick({ icon: icon });
          },
          style: [styles.iconWrapper, !!onIconClick && { cursor: "pointer" }], __source: {
            fileName: _jsxFileName,
            lineNumber: 154
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.icon, __source: {
              fileName: _jsxFileName,
              lineNumber: 157
            }
          },
          renderIcon(icon, _extends({}, themeStyles.iconSvg(true), styles.baseSvg))
        )
      ),
      !isValid && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: [styles.iconWrapper, styles.fadeIn], __source: {
            fileName: _jsxFileName,
            lineNumber: 166
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.icon, __source: {
              fileName: _jsxFileName,
              lineNumber: 167
            }
          },
          renderIcon("error", _extends({}, themeStyles.iconSvg(isValid), styles.baseSvg))
        )
      )
    ),
    message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      { style: [styles.message, themeStyles.message(isValid), styles.fadeIn], __source: {
          fileName: _jsxFileName,
          lineNumber: 177
        }
      },
      message
    )
  );
};

InputTime.displayName = "InputTime";
InputTime.displayName = "InputTime";
InputTime.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onIconClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  styleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["light", "dark"])
};

InputTime.defaultProps = {
  value: "09:00",
  isValid: true,
  styleName: "dark"
};

var fadeInKeyframes = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["b" /* keyframes */])({
  from: {
    opacity: 0
  }
});

var styles = {
  baseSvg: {
    height: "100%",
    width: "100%"
  },
  fadeIn: {
    animation: "x .666s",
    animationName: fadeInKeyframes
  },
  message: {
    position: "absolute",
    fontSize: "75%",
    fontWeight: 200,
    top: "calc(100% + .5em)",
    margin: 0
  },
  iconWrapper: {
    position: "absolute",
    right: ".5em",
    top: "50%"
  },
  icon: {
    width: "1.4em",
    height: "1.4em",
    transform: "translateY(-50%)"
  },
  input: {
    /* disable box shadow for firefox red shadow on page load bug */
    boxShadow: "none",
    background: "none",
    boxSizing: "border-box",
    width: "100%",
    outline: "none",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    borderBottomStyle: "solid",
    borderBottomWidth: "2px"
  },
  iconPadding: {
    padding: "1.5em 2.4em .75em 0"
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(InputTime));

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_google_maps__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apis_geo__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_function__ = __webpack_require__(35);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\postcode-suggest\\index.jsx';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PostcodeSuggest = function (_Component) {
  _inherits(PostcodeSuggest, _Component);

  function PostcodeSuggest(props) {
    _classCallCheck(this, PostcodeSuggest);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = { autocompleteItems: [] };
    _this.autocompleteCallback = _this.autocompleteCallback.bind(_this);
    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.places = {};
    return _this;
  }

  PostcodeSuggest.prototype.getAutocompleteService = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _ref2, autocompleteService, statusCodes;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.autocompleteService && this.autocompleteOK !== undefined)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', this.autocompleteService);

            case 2:
              _context.prev = 2;
              _context.next = 5;
              return Object(__WEBPACK_IMPORTED_MODULE_5_apis_google_maps__["a" /* getAutocompleteService */])();

            case 5:
              _ref2 = _context.sent;
              autocompleteService = _ref2.autocompleteService;
              statusCodes = _ref2.statusCodes;


              this.autocompleteService = autocompleteService;
              this.autocompleteOK = statusCodes.OK;
              this.autocompleteZERO_RESULTS = statusCodes.ZERO_RESULTS;

              return _context.abrupt('return', this.autocompleteService);

            case 14:
              _context.prev = 14;
              _context.t0 = _context['catch'](2);
              throw _context.t0;

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[2, 14]]);
    }));

    function getAutocompleteService() {
      return _ref.apply(this, arguments);
    }

    return getAutocompleteService;
  }();

  PostcodeSuggest.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.getSuggestionsDebounced = __WEBPACK_IMPORTED_MODULE_3_debounce___default()(function (value) {
      if (!value) return;

      _this2.getAutocompleteService().then(function (service) {
        service.getPlacePredictions({
          input: value,
          componentRestrictions: _this2.props.componentRestrictions,
          types: ['(regions)']
        }, _this2.autocompleteCallback);
      });
    }, 100, false);
  };

  PostcodeSuggest.prototype.autocompleteCallback = function autocompleteCallback(predictions, status) {
    if (status === this.autocompleteZERO_RESULTS) {
      this.setState({ autocompleteItems: [] });
      return;
    }
    if (status !== this.autocompleteOK) return;
    var predictionResults = predictions
    // Ensure that places without a postcode won't be returned
    .filter(function (_ref3) {
      var types = _ref3.types;
      return ['colloquial_area'].some(function (type) {
        return types.indexOf(type) === -1;
      }) && ['postal_code', 'locality'].some(function (type) {
        return types.indexOf(type) !== -1;
      });
    })
    // Format, ready to put in state
    .map(function (place, index) {
      return {
        suggestion: place.description,
        placeId: place.place_id,
        active: false,
        index: index
      };
    });
    this.setState({
      autocompleteItems: predictionResults
    });
  };

  PostcodeSuggest.prototype.clearAutocomplete = function clearAutocomplete() {
    this.setState({ autocompleteItems: [] });
  };

  PostcodeSuggest.prototype.selectAddress = function selectAddress(address, id) {
    this.clearAutocomplete();
    this._handleSelect(address, id);
  };

  PostcodeSuggest.prototype._selectPlace = function _selectPlace(activeName, placeId) {
    var _this3 = this;

    var _props = this.props,
        onChange = _props.onChange,
        onLocation = _props.onLocation;

    var handleGeoCode = function handleGeoCode(params, pid) {
      var postcode = params.postcode,
          state = params.state,
          suburb = params.suburb,
          lat = params.lat,
          lng = params.lng,
          number = params.number,
          street = params.street;

      _this3.places[pid] = {
        postcode: postcode, state: state, suburb: suburb, lat: lat, lng: lng, number: number, street: street
      };

      var address = number + ' ' + street;

      var name = activeName.indexOf(postcode) === -1 ? postcode + ', ' + activeName : activeName;
      onChange({
        name: name, postcode: postcode, state: state, suburb: suburb, address: address
      });
      onLocation && onLocation({
        name: name, postcode: postcode, state: state, suburb: suburb, address: address
      });
      window.dispatchEvent(new CustomEvent('postcodeSelect', {
        detail: { label: _this3.props.placeholder, message: name }
      }));
      // Dispatch gtm events from here so all information fetched is captured
      _this3.props.gtmEvents && Object(__WEBPACK_IMPORTED_MODULE_7_utils_function__["e" /* invokeFuncs */])(_this3.props.gtmEvents);
    };

    if (this.places[placeId]) {
      handleGeoCode(this.places[placeId], placeId);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_6_apis_geo__["a" /* fetchGeoDataFromAddress */])({
        placeId: placeId
      }).then(function (_ref4) {
        var addressDetails = _ref4.addressDetails,
            pid = _ref4.placeId;
        return handleGeoCode(addressDetails, pid);
      });
    }
  };

  PostcodeSuggest.prototype._handleSelect = function _handleSelect(address, id) {
    this._selectPlace(address, id);
  };

  PostcodeSuggest.prototype._getActiveItem = function _getActiveItem() {
    return this.state.autocompleteItems.find(function (item) {
      return item.active;
    });
  };

  PostcodeSuggest.prototype._selectActiveItemAtIndex = function _selectActiveItemAtIndex(index) {
    var activeItem = this.state.autocompleteItems.find(function (item) {
      return item.index === index;
    });
    var activeName = activeItem.suggestion;
    this._setActiveItemAtIndex(index);
    this._selectPlace(activeName, activeItem.placeId);
  };

  PostcodeSuggest.prototype._handleEnterKey = function _handleEnterKey() {
    var activeItem = this._getActiveItem();
    if (activeItem === undefined) {
      activeItem = this.state.autocompleteItems[0];
    }
    this.clearAutocomplete();
    if (activeItem !== undefined) {
      this._handleSelect(activeItem.suggestion, activeItem.placeId);
    }
  };

  PostcodeSuggest.prototype._handleDownKey = function _handleDownKey() {
    var activeItem = this._getActiveItem();
    if (activeItem === undefined) {
      this._selectActiveItemAtIndex(0);
    } else {
      var nextIndex = (activeItem.index + 1) % this.state.autocompleteItems.length;
      this._selectActiveItemAtIndex(nextIndex);
    }
  };

  PostcodeSuggest.prototype._handleUpKey = function _handleUpKey() {
    var activeItem = this._getActiveItem();
    if (activeItem === undefined) {
      this._selectActiveItemAtIndex(this.state.autocompleteItems.length - 1);
    } else {
      var prevIndex = void 0;
      if (activeItem.index === 0) {
        prevIndex = this.state.autocompleteItems.length - 1;
      } else {
        prevIndex = (activeItem.index - 1) % this.state.autocompleteItems.length;
      }
      this._selectActiveItemAtIndex(prevIndex);
    }
  };

  PostcodeSuggest.prototype.handleInputKeyDown = function handleInputKeyDown(event) {
    var ARROW_UP = 38;
    var ARROW_DOWN = 40;
    var ENTER_KEY = 13;
    var ESC = 27;
    switch (event.keyCode) {
      case ENTER_KEY:
        event.preventDefault();
        this._handleEnterKey();
        break;
      case ARROW_DOWN:
        this._handleDownKey();
        break;
      case ARROW_UP:
        this._handleUpKey();
        break;
      case ESC:
        this.clearAutocomplete();
        break;
    }
  };

  PostcodeSuggest.prototype._setActiveItemAtIndex = function _setActiveItemAtIndex(index) {
    this.setState({
      autocompleteItems: this.state.autocompleteItems.map(function (item, idx) {
        if (idx === index) {
          return _extends({}, item, { active: true });
        }
        return _extends({}, item, { active: false });
      })
    });
  };

  PostcodeSuggest.prototype.handleInputChange = function handleInputChange(event) {
    var value = event.target.value && { name: event.target.value };
    this.props.onChange(value);
    if (!event.target.value) {
      this.clearAutocomplete();
      return;
    }
    if (event.target.value && event.target.value.length > 2) {
      this.getSuggestionsDebounced(event.target.value);
    }
  };

  PostcodeSuggest.prototype.renderOverlay = function renderOverlay() {
    var _this4 = this;

    if (this.state.autocompleteItems.length === 0) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.autocompleteOverlay, onClick: function onClick() {
        return _this4.clearAutocomplete();
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 213
      }
    });
  };

  PostcodeSuggest.prototype.renderAutocomplete = function renderAutocomplete() {
    var _this5 = this;

    var autocompleteItems = this.state.autocompleteItems;

    if (autocompleteItems.length === 0) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { 'data-test': 'suggestions', style: styles.autocompleteWrapper, __source: {
          fileName: _jsxFileName,
          lineNumber: 221
        }
      },
      autocompleteItems.map(function (place, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            key: place.placeId,
            onClick: function onClick() {
              return _this5.selectAddress(place.suggestion, place.placeId);
            },
            style: [styles.autocompleteItem, place.active ? { background: '#dddddd' } : null], __source: {
              fileName: _jsxFileName,
              lineNumber: 223
            }
          },
          place.suggestion
        );
      })
    );
  };

  PostcodeSuggest.prototype.render = function render() {
    var _this6 = this;

    var _props2 = this.props,
        placeholder = _props2.placeholder,
        value = _props2.value,
        _onFocus = _props2.onFocus,
        onBlur = _props2.onBlur,
        isValid = _props2.isValid,
        message = _props2.message,
        styleName = _props2.styleName;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { 'data-test': 'postcode-suggest', style: styles.base, __source: {
          fileName: _jsxFileName,
          lineNumber: 238
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { position: 'relative' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 239
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["J" /* InputText */], {
          onFocus: function onFocus() {
            if (value && (value.postcode || value.name)) {
              _this6.getSuggestionsDebounced(value.postcode || value.name);
            }
            _onFocus && _onFocus();
          },
          onBlur: onBlur,
          styleName: styleName || 'light',
          isValid: isValid,
          message: message,
          autoComplete: 'nope',
          required: this.props.required,
          label: placeholder,
          icon: 'search',
          value: value && value.name,
          onChange: this.handleInputChange,
          onKeyDown: this.handleInputKeyDown, __source: {
            fileName: _jsxFileName,
            lineNumber: 240
          }
        }),
        this.renderOverlay(),
        this.renderAutocomplete()
      )
    );
  };

  return PostcodeSuggest;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PostcodeSuggest.defaultProps = {
  componentRestrictions: { country: 'nz' }
};
PostcodeSuggest.displayName = 'PostcodeSuggest';


PostcodeSuggest.propTypes = {
  componentRestrictions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLocation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var styles = {
  base: {
    position: 'relative',
    padding: '0',
    margin: 'auto',
    '@media (min-width: 768px)': {
      padding: '0'
    }
  },
  autocompleteOverlay: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 9998
  },
  autocompleteWrapper: {
    position: 'absolute',
    top: 'calc(100% - (0em + 2px))',
    left: '-1em',
    backgroundColor: 'white',
    textAlign: 'left',
    border: '1px solid #ddd',
    boxShadow: '2px 2px 10px rgba(0, 0, 0, .125)',
    width: 'calc(100% + 1em)',
    zIndex: 9999
  },
  autocompleteItem: {
    padding: '1em',
    color: '#191919',
    cursor: 'pointer',
    borderBottom: '1px solid #ddd',
    background: 'white',
    ':hover': {
      background: '#dddddd'
    }
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(PostcodeSuggest));

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__ = __webpack_require__(13);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\search-input\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SearchInput = function (_Component) {
  _inherits(SearchInput, _Component);

  function SearchInput(props) {
    _classCallCheck(this, SearchInput);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = function (_ref) {
      var value = _ref.target.value;
      return _this.setState({ value: value });
    };

    _this.handleTouchSearch = function () {
      // This method is for touch devices only
      if (!__WEBPACK_IMPORTED_MODULE_4_constants_environment__["b" /* HAS_TOUCH */]) return;
      var _this$props = _this.props,
          onClear = _this$props.onClear,
          onSearch = _this$props.onSearch;

      var search = _this.input.value;
      if (search === '') {
        onClear && onClear();
      } else {
        onSearch && onSearch(search);
      }
    };

    _this.handleClear = function () {
      var onClear = _this.props.onClear;

      _this.setState({ value: '' }, function () {
        onClear && onClear();
      });
    };

    _this.handleKeyUp = function (e) {
      if (e.key === 'Escape') {
        _this.handleClear();
      }
    };

    _this.handleKeyDown = function (e) {
      var onSearch = _this.props.onSearch;

      var search = _this.input.value;
      if (e.key === 'Enter') {
        onSearch && onSearch(search);
      }
    };

    _this.handleOnFocus = function (e) {
      _this.setState({ focus: true });
      _this.props.onFocus && _this.props.onFocus(e);
    };

    _this.handleOnBlur = function (e) {
      _this.setState({ focus: false });
      _this.props.onBlur && _this.props.onBlur();
    };

    _this.handleInnerRef = function (e) {
      _this.input = e;
      _this.props.innerRef && _this.props.innerRef(e);
    };

    _this.handleOnChange = function (e) {
      // if input is not controlled update to state
      if (!_this.controlled) {
        _this.handleChange(e);
      }
      _this.props.onChange && _this.props.onChange(e);
    };

    _this.state = {
      value: props.initialValue || ''
    };
    _this.controlled = typeof props.value === 'string';
    return _this;
  }

  SearchInput.prototype.componentDidMount = function componentDidMount() {
    // onSearch is not a valid html attribute in react
    this.input.addEventListener('search', this.handleTouchSearch);
  };

  SearchInput.prototype.componentWillUnmount = function componentWillUnmount() {
    this.input.removeEventListener('search', this.handleTouchSearch);
  };

  SearchInput.prototype.render = function render() {
    var _props = this.props,
        hideIcon = _props.hideIcon,
        onSearchIconClick = _props.onSearchIconClick,
        fadeOutInput = _props.fadeOutInput,
        _props$focusStyle = _props.focusStyle,
        focusStyle = _props$focusStyle === undefined ? true : _props$focusStyle,
        _props$styleName = _props.styleName,
        styleName = _props$styleName === undefined ? 'light' : _props$styleName,
        _props$lineColor = _props.lineColor,
        lineColor = _props$lineColor === undefined ? __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY : _props$lineColor,
        placeholder = _props.placeholder;

    // use value from props if component is controlled

    var value = this.controlled ? this.props.value : this.state.value;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: [styles.container, fadeOutInput ? { borderColor: 'transparent' } : focusStyle && this.state.focus ? styles.focus : { borderColor: lineColor }], __source: {
          fileName: _jsxFileName,
          lineNumber: 89
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            height: '100%',
            display: 'flex'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            onClick: onSearchIconClick,
            style: [styles.svgContainer, onSearchIconClick && styles.searchIconInteractive, hideIcon && { visibility: 'hidden' }, {
              height: '1.2em',
              width: '1.2em',
              marginRight: '1em',
              paddingTop: '.5em'
            }], __source: {
              fileName: _jsxFileName,
              lineNumber: 101
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_0" /* SearchIcon */], { style: styles.svgBase, __source: {
              fileName: _jsxFileName,
              lineNumber: 114
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: [{ width: '100%', transition: 'opacity .25s' }, fadeOutInput && { opacity: 0 }], __source: {
            fileName: _jsxFileName,
            lineNumber: 117
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["J" /* InputText */], {
          placeholder: placeholder,
          value: value,
          margin: '0px',
          autoComplete: 'none',
          showBorderBottom: false,
          icon: this.props.icon || '',
          onIconClick: this.props.behaviour === 'close' ? onSearchIconClick : this.handleClear,
          type: this.props.type || 'search',
          styleName: styleName,
          name: 'search',
          onKeyUp: this.handleKeyUp,
          onKeyDown: this.handleKeyDown,
          onBlur: this.handleOnBlur,
          onChange: this.handleOnChange,
          onFocus: this.handleOnFocus,
          innerRef: this.handleInnerRef, __source: {
            fileName: _jsxFileName,
            lineNumber: 122
          }
        })
      )
    );
  };

  return SearchInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SearchInput.displayName = 'SearchInput';


SearchInput.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSearchIconClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  initialValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  styleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  focusStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onSearch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fadeOutInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  lineColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(SearchInput));

var styles = {
  searchIconInteractive: {
    transition: 'color .25s',
    cursor: 'pointer',
    ':hover': {
      color: 'white'
    }
  },
  svgContainer: {
    position: 'relative',
    color: '#979797'
  },
  svgBase: {
    fill: 'currentColor',
    height: '100%',
    width: '100%'
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    transition: 'border-color .25s',
    borderBottom: '1px solid',
    padding: '0 .5em',
    boxSizing: 'border-box',
    width: '100%'
  },
  focus: {
    boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)'
  }
};

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\select\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Select = function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select() {
    var _temp, _this, _ret;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._handleChange = function (value) {
      var options = _this.props.options;

      var index = options.findIndex(function (item) {
        return item.name === value;
      });
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

      onChange(options[index], index);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Select.prototype.render = function render() {
    var options = this.props.options;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["R" /* InputSelect */], _extends({}, this.props, {
      required: true,
      withoutStar: true,
      onChange: this._handleChange,
      options: options.map(function (item) {
        item.value = item.label || item.name;
        item.label = item.label || item.name;
        return item;
      }),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    }));
  };

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Select.displayName = 'Select';


/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SelectBase = null;

if (undefined && undefined === "dingo") {
  SelectBase = __webpack_require__(1581).default;
} else {
  SelectBase = __webpack_require__(1583).default;
}

/* harmony default export */ __webpack_exports__["a"] = (SelectBase);

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select_dist_react_select_css__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_select_dist_react_select_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\select-base\\dingo.jsx";

var _templateObject = _taggedTemplateLiteralLoose(["\n    ", "\n  "], ["\n    ", "\n  "]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n    box-sizing: border-box;\n    text-align: left;\n    max-width: 100%;\n\n    & * {\n      box-sizing: border-box;\n    }\n\n    & *:focus,\n    & *:focus *,\n    & .is-focused,\n    & .is-focused * {\n      outline: none !important;\n      box-shadow: none !important;\n    }\n\n    & .Select {\n      position: relative;\n      font-weight: 200;\n    }\n\n    .Select-control {\n      display: flex;\n      align-items: center;\n      background-color: transparent;\n      border: none;\n      border-bottom: 1px solid #d5d5d5;\n      border-radius: 0;\n      text-align: left;\n    }\n\n    & .Select-multi-value-wrapper {\n      margin-bottom: -.3em;\n    }\n\n    & .Select-multi-value-wrapper {\n      flex: 1 1 100%;\n      position: relative;\n    }\n\n    & .Select-clear-zone {\n      flex: 0 0 auto;\n      width: initial;\n    }\n\n    & .Select-arrow-zone {\n      width: initial;\n    }\n\n    & .Select.is-disabled .Select-control {\n      background-color: transparent;\n    }\n\n    & .Select-input {\n      width: 100%;\n      display: flex !important;\n      align-items: center;\n    }\n    & .Select-input > input {\n      min-width: 100%;\n      padding: 0;\n      vertical-align: 'baseline';\n    }\n\n    & .Select-input,\n    & .Select--single > .Select-control .Select-value,\n    & .Select-placeholder {\n      padding: 0;\n      color: inherit;\n    }\n\n    & .is-open > .Select-control {\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 0;\n      background: transparent;\n      border-color: transparent transparent #ddd;\n    }\n\n    & .is-focused:not(.is-open) > .Select-control {\n      border-color: #ddd;\n      background-color: inherit;\n    }\n\n    & .Select-menu-outer {\n      text-align: left;\n      border-radius: 0;\n      background-color: #fff;\n      border: 1px solid #ddd;\n      box-shadow: 2px 2px 10px rgba(0, 0, 0, .125) !important;\n      width: calc(100% + 2em);\n      margin: -2px 0 0 -1em;\n    }\n\n    & .Select-option,\n    & .Select-noresults {\n      background-color: #fff;\n      color: #666666;\n      cursor: default;\n      display: block;\n      padding: 1em;\n    }\n\n    & .Select-option:last-child {\n      border-radius: 0;\n    }\n\n    & .Select-option.is-selected {\n      background-color: #e3e3e3;\n      color: #333;\n    }\n\n    & .Select-option.is-focused {\n      background-color: #c1d3e2;\n      color: #333;\n    }\n\n    & .Select-option.is-disabled {\n      color: #cccccc;\n      cursor: default;\n    }\n"], ["\n    box-sizing: border-box;\n    text-align: left;\n    max-width: 100%;\n\n    & * {\n      box-sizing: border-box;\n    }\n\n    & *:focus,\n    & *:focus *,\n    & .is-focused,\n    & .is-focused * {\n      outline: none !important;\n      box-shadow: none !important;\n    }\n\n    & .Select {\n      position: relative;\n      font-weight: 200;\n    }\n\n    .Select-control {\n      display: flex;\n      align-items: center;\n      background-color: transparent;\n      border: none;\n      border-bottom: 1px solid #d5d5d5;\n      border-radius: 0;\n      text-align: left;\n    }\n\n    & .Select-multi-value-wrapper {\n      margin-bottom: -.3em;\n    }\n\n    & .Select-multi-value-wrapper {\n      flex: 1 1 100%;\n      position: relative;\n    }\n\n    & .Select-clear-zone {\n      flex: 0 0 auto;\n      width: initial;\n    }\n\n    & .Select-arrow-zone {\n      width: initial;\n    }\n\n    & .Select.is-disabled .Select-control {\n      background-color: transparent;\n    }\n\n    & .Select-input {\n      width: 100%;\n      display: flex !important;\n      align-items: center;\n    }\n    & .Select-input > input {\n      min-width: 100%;\n      padding: 0;\n      vertical-align: 'baseline';\n    }\n\n    & .Select-input,\n    & .Select--single > .Select-control .Select-value,\n    & .Select-placeholder {\n      padding: 0;\n      color: inherit;\n    }\n\n    & .is-open > .Select-control {\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 0;\n      background: transparent;\n      border-color: transparent transparent #ddd;\n    }\n\n    & .is-focused:not(.is-open) > .Select-control {\n      border-color: #ddd;\n      background-color: inherit;\n    }\n\n    & .Select-menu-outer {\n      text-align: left;\n      border-radius: 0;\n      background-color: #fff;\n      border: 1px solid #ddd;\n      box-shadow: 2px 2px 10px rgba(0, 0, 0, .125) !important;\n      width: calc(100% + 2em);\n      margin: -2px 0 0 -1em;\n    }\n\n    & .Select-option,\n    & .Select-noresults {\n      background-color: #fff;\n      color: #666666;\n      cursor: default;\n      display: block;\n      padding: 1em;\n    }\n\n    & .Select-option:last-child {\n      border-radius: 0;\n    }\n\n    & .Select-option.is-selected {\n      background-color: #e3e3e3;\n      color: #333;\n    }\n\n    & .Select-option.is-focused {\n      background-color: #c1d3e2;\n      color: #333;\n    }\n\n    & .Select-option.is-disabled {\n      color: #cccccc;\n      cursor: default;\n    }\n"]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }










if (undefined && undefined === "dingo") {
  Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["b" /* injectGlobal */])(_templateObject, __WEBPACK_IMPORTED_MODULE_7_react_select_dist_react_select_css___default.a);
} else {
  __webpack_require__(292);
}

var SelectStyle = __WEBPACK_IMPORTED_MODULE_5_styled_components__["a" /* default */].div(_templateObject2);

var themeLight = {
  text: function text() {
    return {
      color: __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__["a" /* default */].BLACK
    };
  }
};

var themeDark = {
  text: function text() {
    return {
      color: __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__["a" /* default */].WHITE
    };
  }
};

var themes = {
  dark: themeDark,
  light: themeLight
};

var Chevron = function Chevron(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 20 20", __source: {
        fileName: _jsxFileName,
        lineNumber: 161
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M0 5.8l1.6-1.6 8.4 8.4 8.4-8.4L20 5.8l-10 10-10-10z", __source: {
        fileName: _jsxFileName,
        lineNumber: 162
      }
    })
  );
};

Chevron.displayName = "Chevron";
Chevron.displayName = "Chevron";
var renderControl = function renderControl(Svg) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { width: "0.85em", height: "0.85em", marginLeft: "auto" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 167
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg, { style: { fill: "#aaa", width: "100%", height: "100%" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 168
        }
      })
    );
  };
};

var SelectBase = function SelectBase(props) {
  var selectProps = _extends({
    arrowRenderer: renderControl(Chevron),
    clearRenderer: renderControl(__WEBPACK_IMPORTED_MODULE_4_components__["m" /* CrossIcon */])
  }, Object(__WEBPACK_IMPORTED_MODULE_3_utils__["E" /* omit */])(["style", "className"], props), {
    autoFocus: false,
    style: {
      color: props.styleName ? themes[props.styleName].text().color : "#aaa"
    }
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    SelectStyle,
    {
      style: _extends({}, props.style),
      ref: props.getRef, __source: {
        fileName: _jsxFileName,
        lineNumber: 183
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], _extends({}, selectProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 186
      }
    }))
  );
};

SelectBase.displayName = "SelectBase";
SelectBase.displayName = "SelectBase";
SelectBase.propTypes = {
  arrowRenderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  clearRenderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

SelectBase.defaultProps = {
  style: {}
};

/* harmony default export */ __webpack_exports__["default"] = (SelectBase);

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_select_dist_react_select_css__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__select_base_css__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__select_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__select_base_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\select-base\\koala.jsx";








var Chevron = function Chevron(_ref) {
  var style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    "svg",
    { style: style, viewBox: "0 0 20 20", __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { d: "M0 5.8l1.6-1.6 8.4 8.4 8.4-8.4L20 5.8l-10 10-10-10z", __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    })
  );
};

Chevron.displayName = "Chevron";
Chevron.displayName = "Chevron";
var renderControl = function renderControl(Svg) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      "div",
      { style: { width: "0.85em", height: "0.85em", marginLeft: "auto" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Svg, { style: { fill: "#aaa", width: "100%", height: "100%" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      })
    );
  };
};

var SelectBase = function SelectBase(props) {
  var selectProps = _extends({
    arrowRenderer: renderControl(Chevron),
    clearRenderer: renderControl(__WEBPACK_IMPORTED_MODULE_5_components__["m" /* CrossIcon */])
  }, Object(__WEBPACK_IMPORTED_MODULE_4_utils__["E" /* omit */])(["style", "className"], props));

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    "div",
    {
      className: [__WEBPACK_IMPORTED_MODULE_6__select_base_css___default.a.__SelectBase].concat(props.className || []).join(" "),
      style: _extends({}, props.style),
      ref: props.getRef, __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      }
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], _extends({}, selectProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33
      }
    }))
  );
};

SelectBase.displayName = "SelectBase";
SelectBase.displayName = "SelectBase";
SelectBase.propTypes = {
  arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};

SelectBase.defaultProps = {
  style: {}
};

/* harmony default export */ __webpack_exports__["default"] = (SelectBase);

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"__SelectBase":"__SelectBase"};

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fetch_please__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fetch_please___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fetch_please__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_google_maps__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apis_geo__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dealer_search_box_nz_less__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dealer_search_box_nz_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__dealer_search_box_nz_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_highlight_words__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_highlight_words___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_highlight_words__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\form-elements\\dealer-search-box-nz\\index.jsx';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Typeahead = __webpack_require__(1587).Typeahead;




// import googleAutoComplete from 'AtomicUtils/googleAutoComplete'

var DealerSearchBoxNZ = function (_PureComponent) {
  _inherits(DealerSearchBoxNZ, _PureComponent);

  function DealerSearchBoxNZ(props) {
    _classCallCheck(this, DealerSearchBoxNZ);

    // this.google = new googleAutoComplete()
    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      autocompleteItems: [],
      dealerSearch: [],
      searchOptions: [],
      currentSearchValue: props.value && props.value.toString() || '',
      didEdit: false,
      inputValue: '',
      selectedRegion: null,
      dealers: [],
      success: false,
      errorMessage: null
    };

    _this.dealerSearch = new __WEBPACK_IMPORTED_MODULE_2_fetch_please___default.a(props.dealerSearchEndPoint, {
      timeout: 3000,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    _this.debouncedLocationSearchToState = __WEBPACK_IMPORTED_MODULE_3_debounce___default()(function (search) {
      return _this.doLocationSearchToState(search);
    }, 500);
    return _this;
  }

  // Api fns - consider reafactoring and moving these out of component.

  //

  DealerSearchBoxNZ.prototype.componentDidMount = function componentDidMount() {
    if (window.location.href.indexOf('dealerCode') != -1) {
      this.setState({
        selectedRegion: localStorage.getItem('selectedRegion') || null
      });
    } else {
      this.setState({
        selectedRegion: null
      });
    }
  };

  DealerSearchBoxNZ.prototype.componentWillMount = function componentWillMount() {
    var searchOverride = this.props.searchOverride;

    if (searchOverride) {
      this.searchOverride(searchOverride);
    }
    this.doAutoSearchFromState();
  };

  DealerSearchBoxNZ.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var _this2 = this;

    var value = _ref.value,
        searchOverride = _ref.searchOverride;

    if (!this.state.didEdit && value) {
      var _value = _value.toString();
      this.setState({ currentSearchValue: _value }, function () {
        _this2.doAutoSearchFromState();
      });
    }
    if (searchOverride !== this.props.searchOverride) {
      this.searchOverride(searchOverride);
    }
  };

  DealerSearchBoxNZ.prototype.render = function render() {
    var _this3 = this,
        _classnames,
        _classnames2,
        _classnames3;

    var placeholder = this.props.placeholder;
    var _state = this.state,
        searchOptions = _state.searchOptions,
        currentSearchValue = _state.currentSearchValue;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { key: 'DealerSearchBoxNZ', __source: {
          fileName: _jsxFileName,
          lineNumber: 262
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.dropDown, __source: {
            fileName: _jsxFileName,
            lineNumber: 263
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["_2" /* Select */], {
          defaultValue: { value: this.state.selectedRegion },
          label: selectOptions.label,
          options: selectOptions.regions,
          onChange: function onChange(value) {
            _this3.handleRegionChange(value);
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 264
          }
        })
      ),
      this.state.dealers.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.typeahead, __source: {
            fileName: _jsxFileName,
            lineNumber: 272
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Typeahead, {
          placeholder: 'Type to filter then select a dealer',
          showOptionsWhenEmpty: true,
          options: this.state.dealers.map(function (dealer) {
            return dealer.name;
          }),
          maxVisible: 10,
          onOptionSelected: function onOptionSelected(dealer) {
            return _this3.handleTypeaheadSelect(dealer);
          },
          ref: 'typeahead',
          customClasses: {
            input: __WEBPACK_IMPORTED_MODULE_10_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_9__dealer_search_box_nz_less___default.a.TypeaheadInput] = true, _classnames)),
            results: __WEBPACK_IMPORTED_MODULE_10_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_9__dealer_search_box_nz_less___default.a.TypeaheadResults] = true, _classnames2)),
            listItem: __WEBPACK_IMPORTED_MODULE_10_classnames___default()((_classnames3 = {}, _classnames3[__WEBPACK_IMPORTED_MODULE_9__dealer_search_box_nz_less___default.a.TypeaheadListItem] = true, _classnames3))
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 273
          }
        })
      )
    );
  };

  return DealerSearchBoxNZ;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getAutocompleteService = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref3, autocompleteService, statusCodes;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(_this4.autocompleteService && _this4.autocompleteOK !== undefined)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', _this4.autocompleteService);

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return Object(__WEBPACK_IMPORTED_MODULE_5_apis_google_maps__["a" /* getAutocompleteService */])();

          case 5:
            _ref3 = _context.sent;
            autocompleteService = _ref3.autocompleteService;
            statusCodes = _ref3.statusCodes;


            _this4.autocompleteService = autocompleteService;
            _this4.autocompleteOK = statusCodes.OK;

            return _context.abrupt('return', _this4.autocompleteService);

          case 13:
            _context.prev = 13;
            _context.t0 = _context['catch'](2);

            console.warn(_context.t0);
            throw _context.t0;

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this4, [[2, 13]]);
  }));

  this.searchOverride = function (search) {
    _this4.doLocationSearchToState(search).then(function () {
      var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var item = results.find(function (result) {
        return result.label === search;
      }) || results[0];
      _this4.setState({ currentSearchValue: item ? String(item.value) : '' }, function () {
        _this4.handleSelectChange(item, true);
      });
    });
  };

  this.doDealerSearch = function (search) {
    _this4.dealerSearch && _this4.dealerSearch.abort();
    return _this4.dealerSearch.post('', { searchText: search }).then(function (_ref4) {
      var data = _ref4.data;
      return data;
    });
  };

  this.doPredictionSearch = function (search) {
    return _this4.getAutocompleteService().then(function (service) {
      return new Promise(function (resolve, reject) {
        service.getPlacePredictions({
          input: search,
          componentRestrictions: _this4.props.componentRestrictions || null,
          types: ['(regions)']
        }, function (predictions, status) {
          if (status !== _this4.autocompleteOK) reject(status);else {
            resolve(predictions.filter(function (_ref5) {
              var types = _ref5.types;
              return ['colloquial_area'].some(function (type) {
                return types.indexOf(type) === -1;
              }) && ['postal_code', 'locality'].some(function (type) {
                return types.indexOf(type) !== -1;
              });
            }));
          }
        });
      });
    }).catch(function (error) {
      return console.warn('Google response:', error);
    });
  };

  this.doLocationSearchToState = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(search) {
      var _state2, _state2$dealerSearch, dealerSearch, _state2$autocompleteI, autocompleteItems, _ref7, dealerResults, autocompleteResults, searchOptions;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _state2 = _this4.state, _state2$dealerSearch = _state2.dealerSearch, dealerSearch = _state2$dealerSearch === undefined ? [] : _state2$dealerSearch, _state2$autocompleteI = _state2.autocompleteItems, autocompleteItems = _state2$autocompleteI === undefined ? [] : _state2$autocompleteI;
              _context2.prev = 1;
              _context2.next = 4;
              return Promise.all([_this4.doDealerSearch(search), _this4.doPredictionSearch(search)]);

            case 4:
              _ref7 = _context2.sent;
              dealerResults = _ref7[0];
              autocompleteResults = _ref7[1];


              dealerSearch = dealerResults;
              autocompleteItems = autocompleteResults;
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2['catch'](1);

              console.warn(_context2.t0);

            case 14:
              searchOptions = _this4.createSearchOptions({
                dealerSearch: dealerSearch,
                autocompleteItems: autocompleteItems
              });


              _this4.setState({
                dealerSearch: dealerSearch,
                autocompleteItems: autocompleteItems,
                searchOptions: searchOptions
              });

              return _context2.abrupt('return', searchOptions);

            case 17:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this4, [[1, 11]]);
    }));

    return function (_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.doAutoSearchFromState = function () {
    if (!_this4.state.currentSearchValue) return;

    _this4.doLocationSearchToState(_this4.state.currentSearchValue).then(function () {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
          _ref8$ = _ref8[0],
          firstResult = _ref8$ === undefined ? {} : _ref8$;

      return _this4.setState({
        currentSearchValue: firstResult.value || ''
      });
    });
  };

  this.clearAutocomplete = function () {
    _this4.setState({
      autocompleteItems: [],
      dealerSearch: [],
      searchOptions: [],
      currentSearchValue: ''
    });
  };

  this.handleInputChange = function (value) {
    _this4.setState({ didEdit: true, inputValue: value });

    if (!value) {
      return;
    }

    _this4.debouncedLocationSearchToState(value);
  };

  this.handleSelectChange = function (props, isOnLoad) {
    _this4.setState({ didEdit: true });

    var _ref9 = props || {},
        value = _ref9.value;

    if (!props || !value) {
      _this4.clearAutocomplete();
      return;
    }

    var currentItem = _this4.getCurrentItem(value);
    //var place = new{}
    if (currentItem && currentItem.place_id) {
      Object(__WEBPACK_IMPORTED_MODULE_6_apis_geo__["a" /* fetchGeoDataFromAddress */])({
        placeId: currentItem.place_id
      }).then(function (_ref10) {
        var addressDetails = _ref10.addressDetails;

        currentItem = addressDetails;
        _this4.props.onChange(currentItem, isOnLoad);
      });

      _this4.props.onSelect(currentItem.description, currentItem.place_id);
    } else if (currentItem && currentItem.value) {
      currentItem = _extends({}, currentItem, { dealerCode: currentItem.value });
      _this4.props.onChange(currentItem, isOnLoad);
    } else {
      _this4.props.onChange(currentItem, isOnLoad);
    }
    // We don't want a GTM event to fire on first load, hence the checking.
    if (!isOnLoad && _this4.state.searchOptions[value]) {
      _this4.props.gtmEvent({
        gtmID: _this4.props.gtmMapping.ENTER_LOCATION,
        gtmPayload: {
          location: _this4.state.searchOptions[value].label
        }
      });
    }

    _this4.setState({ currentSearchValue: value });
  };

  this.createSearchOptions = function (_ref11) {
    var _ref11$dealerSearch = _ref11.dealerSearch,
        dealerSearch = _ref11$dealerSearch === undefined ? [] : _ref11$dealerSearch,
        _ref11$autocompleteIt = _ref11.autocompleteItems,
        autocompleteItems = _ref11$autocompleteIt === undefined ? [] : _ref11$autocompleteIt;

    if (dealerSearch) {
      var dealersCount = dealerSearch.length;
      return dealerSearch.map(function (_ref12, index) {
        var display = _ref12.display;
        return {
          value: index.toString(),
          label: display
        };
      }).concat(autocompleteItems.map(function (_ref13, index) {
        var description = _ref13.description;
        return {
          value: (index + dealersCount).toString(),
          label: description
        };
      }));
    }
    return [];
  };

  this.getCurrentItem = function (searchValue) {
    var _state3 = _this4.state,
        _state3$dealerSearch = _state3.dealerSearch,
        dealerSearch = _state3$dealerSearch === undefined ? [] : _state3$dealerSearch,
        _state3$autocompleteI = _state3.autocompleteItems,
        autocompleteItems = _state3$autocompleteI === undefined ? [] : _state3$autocompleteI;

    return dealerSearch.concat(autocompleteItems)[parseInt(searchValue, 10)];
  };

  this.handleTypeaheadSelect = function (dealer) {
    var selectedDealer = _this4.state.dealers.find(function (item) {
      return item.name === dealer;
    });

    if (selectedDealer && !_this4.props.noMap) {
      _this4.props.handleNZLocations([selectedDealer]);
    }

    if (_this4.props.selectDealerVariant) {
      _this4.props.selectDealer(selectedDealer);
    }

    document.activeElement.blur();
  };

  this.getUrlParameter = function (name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  this.handleRegionChange = function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(region) {
      var url, port;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this4.setState({
                selectedRegion: region
              });

              localStorage.setItem('selectedRegion', region.value);

              // if local
              url = '';
              port = window.location.port;


              if (port == 4000) {
                url = 'http://www.mocky.io/v2/5dedc1ca33000052002b91d9';
              } else {
                url = '/api/dealer-search-by-region';
              }

              _context4.next = 7;
              return Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_fetchAPI__["a" /* default */])({
                method: "POST",
                url: url,
                body: {
                  region: region.value
                }
              }).then(function () {
                var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(response) {
                  var json, success, errorMsg, department, searchType, filteredData, qs, indexVal;
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return response.json();

                        case 2:
                          json = _context3.sent;
                          success = json.success, errorMsg = json.errorMsg;

                          if (!success) {
                            _this4.setState({
                              errorMessage: errorMsg,
                              loading: false
                            });
                          } else {
                            // successful
                            department = '';
                            searchType = _this4.props.searchType || '';
                            filteredData = [];
                            qs = _this4.getUrlParameter("department") || '';


                            if (searchType && searchType != '') {
                              department = searchType.toUpperCase();
                            } else if (qs && qs != '') {
                              department = qs.toUpperCase();
                            } else {
                              department = 'SALES';
                            }

                            indexVal = '';

                            if (department == 'SALES') indexVal = 0;
                            if (department == 'SERVICE') indexVal = 1;
                            if (department == 'PARTS') indexVal = 2;
                            localStorage.setItem('activeTabIndex', indexVal);

                            filteredData = json.data.filter(function (item) {
                              var departmentMatch = item.departments.find(function (dep) {
                                return dep.name.toUpperCase() === department;
                              });

                              if (departmentMatch) return item;
                            });

                            _this4.setState({
                              loading: false,
                              success: true,
                              dealers: filteredData
                            });

                            _this4.refs.typeahead.setState({
                              entryValue: '',
                              selection: null,
                              selectionIndex: null,
                              visible: []
                            });

                            if (!_this4.props.noMap) _this4.props.handleNZLocations(filteredData, json.data);
                            _this4.refs.typeahead.focus();
                          }

                        case 5:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this4);
                }));

                return function (_x5) {
                  return _ref15.apply(this, arguments);
                };
              }()).catch(function (response) {
                _this4.setState({
                  errorMessage: response.message || 'Failed with status ' + response.status,
                  loading: false
                });
              });

            case 7:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }));

    return function (_x4) {
      return _ref14.apply(this, arguments);
    };
  }();
};

DealerSearchBoxNZ.displayName = 'DealerSearchBoxNZ';


DealerSearchBoxNZ.propTypes = {
  dealerSearchEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  componentRestrictions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  searchOverride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmMapping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  handleNZLocations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  noMap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectDealerVariant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectDealer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  searchType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

DealerSearchBoxNZ.defaultProps = {
  dealerSearchEndPoint: '',
  placeholder: 'Enter your postcode, suburb or Dealer name',
  value: '',
  onSelect: __WEBPACK_IMPORTED_MODULE_11_utils__["C" /* noop */],
  onChange: __WEBPACK_IMPORTED_MODULE_11_utils__["C" /* noop */],
  componentRestrictions: {},
  gtmMapping: {}
};

var styles = {
  dropDown: {
    maxWidth: "400px",
    width: "100%",
    margin: "0 auto 1.8em"
  },
  typeahead: {
    maxWidth: "400px",
    width: "100%",
    margin: "1.8em auto"
  }
};

var selectOptions = {
  label: "Region",
  regions: [{ name: "Auckland" }, { name: "Bay of Plenty" }, { name: "Canterbury" }, { name: "North Island Central" }, { name: "North Island Lower" }, { name: "Northland" }, { name: "Otago" }, { name: "South Island Upper" }, { name: "Southland" }, { name: "Waikato" }]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_higher_order_components__["i" /* gtmEvent */])()(DealerSearchBoxNZ));

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Typeahead":"dealer-search-box-nz__Typeahead___1mA4H","TypeaheadInput":"dealer-search-box-nz__TypeaheadInput___mM0hL","TypeaheadResults":"dealer-search-box-nz__TypeaheadResults___NljHD","TypeaheadListItem":"dealer-search-box-nz__TypeaheadListItem___2O55K"};

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

var Typeahead = __webpack_require__(630);
var Tokenizer = __webpack_require__(1591);

module.exports = {
  Typeahead: Typeahead,
  Tokenizer: Tokenizer
};

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var TypeaheadOption = __webpack_require__(1589);
var classNames = __webpack_require__(5);
var createReactClass = __webpack_require__(122);
var PropTypes = __webpack_require__(1);

/**
 * Container for the options rendered as part of the autocompletion process
 * of the typeahead
 */
var TypeaheadSelector = createReactClass({
  displayName: 'TypeaheadSelector',

  propTypes: {
    options: PropTypes.array,
    allowCustomValues: PropTypes.number,
    customClasses: PropTypes.object,
    customValue: PropTypes.string,
    selectionIndex: PropTypes.number,
    onOptionSelected: PropTypes.func,
    displayOption: PropTypes.func.isRequired,
    defaultClassNames: PropTypes.bool,
    areResultsTruncated: PropTypes.bool,
    resultsTruncatedMessage: PropTypes.string
  },

  getDefaultProps: function () {
    return {
      selectionIndex: null,
      customClasses: {},
      allowCustomValues: 0,
      customValue: null,
      onOptionSelected: function (option) {},
      defaultClassNames: true
    };
  },

  render: function () {
    // Don't render if there are no options to display
    if (!this.props.options.length && this.props.allowCustomValues <= 0) {
      return false;
    }

    var classes = {
      "typeahead-selector": this.props.defaultClassNames
    };
    classes[this.props.customClasses.results] = this.props.customClasses.results;
    var classList = classNames(classes);

    // CustomValue should be added to top of results list with different class name
    var customValue = null;
    var customValueOffset = 0;
    if (this.props.customValue !== null) {
      customValueOffset++;
      customValue = React.createElement(
        TypeaheadOption,
        { ref: this.props.customValue, key: this.props.customValue,
          hover: this.props.selectionIndex === 0,
          customClasses: this.props.customClasses,
          customValue: this.props.customValue,
          onClick: this._onClick.bind(this, this.props.customValue) },
        this.props.customValue
      );
    }

    var results = this.props.options.map(function (result, i) {
      var displayString = this.props.displayOption(result, i);
      var uniqueKey = displayString + '_' + i;
      return React.createElement(
        TypeaheadOption,
        { ref: uniqueKey, key: uniqueKey,
          hover: this.props.selectionIndex === i + customValueOffset,
          customClasses: this.props.customClasses,
          onClick: this._onClick.bind(this, result) },
        displayString
      );
    }, this);

    if (this.props.areResultsTruncated && this.props.resultsTruncatedMessage !== null) {
      var resultsTruncatedClasses = {
        "results-truncated": this.props.defaultClassNames
      };
      resultsTruncatedClasses[this.props.customClasses.resultsTruncated] = this.props.customClasses.resultsTruncated;
      var resultsTruncatedClassList = classNames(resultsTruncatedClasses);

      results.push(React.createElement(
        'li',
        { key: 'results-truncated', className: resultsTruncatedClassList },
        this.props.resultsTruncatedMessage
      ));
    }

    return React.createElement(
      'ul',
      { className: classList },
      customValue,
      results
    );
  },

  _onClick: function (result, event) {
    return this.props.onOptionSelected(result, event);
  }

});

module.exports = TypeaheadSelector;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var classNames = __webpack_require__(5);
var createReactClass = __webpack_require__(122);
var PropTypes = __webpack_require__(1);

/**
 * A single option within the TypeaheadSelector
 */
var TypeaheadOption = createReactClass({
  displayName: 'TypeaheadOption',

  propTypes: {
    customClasses: PropTypes.object,
    customValue: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.string,
    hover: PropTypes.bool
  },

  getDefaultProps: function () {
    return {
      customClasses: {},
      onClick: function (event) {
        event.preventDefault();
      }
    };
  },

  render: function () {
    var classes = {};
    classes[this.props.customClasses.hover || "hover"] = !!this.props.hover;
    classes[this.props.customClasses.listItem] = !!this.props.customClasses.listItem;

    if (this.props.customValue) {
      classes[this.props.customClasses.customAdd] = !!this.props.customClasses.customAdd;
    }

    var classList = classNames(classes);

    // For some reason onClick is not fired when clicked on an option
    // onMouseDown is used here as a workaround of #205 and other
    // related tickets
    return React.createElement(
      'li',
      { className: classList, onClick: this._onClick, onMouseDown: this._onClick },
      React.createElement(
        'a',
        { href: 'javascript: void 0;', className: this._getClasses(), ref: 'anchor' },
        this.props.children
      )
    );
  },

  _getClasses: function () {
    var classes = {
      "typeahead-option": true
    };
    classes[this.props.customClasses.listAnchor] = !!this.props.customClasses.listAnchor;

    return classNames(classes);
  },

  _onClick: function (event) {
    event.preventDefault();
    return this.props.onClick(event);
  }
});

module.exports = TypeaheadOption;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Fuzzy
 * https://github.com/myork/fuzzy
 *
 * Copyright (c) 2012 Matt York
 * Licensed under the MIT license.
 */

(function() {

var root = this;

var fuzzy = {};

// Use in node or in browser
if (true) {
  module.exports = fuzzy;
} else {
  root.fuzzy = fuzzy;
}

// Return all elements of `array` that have a fuzzy
// match against `pattern`.
fuzzy.simpleFilter = function(pattern, array) {
  return array.filter(function(str) {
    return fuzzy.test(pattern, str);
  });
};

// Does `pattern` fuzzy match `str`?
fuzzy.test = function(pattern, str) {
  return fuzzy.match(pattern, str) !== null;
};

// If `pattern` matches `str`, wrap each matching character
// in `opts.pre` and `opts.post`. If no match, return null
fuzzy.match = function(pattern, str, opts) {
  opts = opts || {};
  var patternIdx = 0
    , result = []
    , len = str.length
    , totalScore = 0
    , currScore = 0
    // prefix
    , pre = opts.pre || ''
    // suffix
    , post = opts.post || ''
    // String to compare against. This might be a lowercase version of the
    // raw string
    , compareString =  opts.caseSensitive && str || str.toLowerCase()
    , ch;

  pattern = opts.caseSensitive && pattern || pattern.toLowerCase();

  // For each character in the string, either add it to the result
  // or wrap in template if it's the next string in the pattern
  for(var idx = 0; idx < len; idx++) {
    ch = str[idx];
    if(compareString[idx] === pattern[patternIdx]) {
      ch = pre + ch + post;
      patternIdx += 1;

      // consecutive characters should increase the score more than linearly
      currScore += 1 + currScore;
    } else {
      currScore = 0;
    }
    totalScore += currScore;
    result[result.length] = ch;
  }

  // return rendered string if we have a match for every char
  if(patternIdx === pattern.length) {
    // if the string is an exact match with pattern, totalScore should be maxed
    totalScore = (compareString === pattern) ? Infinity : totalScore;
    return {rendered: result.join(''), score: totalScore};
  }

  return null;
};

// The normal entry point. Filters `arr` for matches against `pattern`.
// It returns an array with matching values of the type:
//
//     [{
//         string:   '<b>lah' // The rendered string
//       , index:    2        // The index of the element in `arr`
//       , original: 'blah'   // The original element in `arr`
//     }]
//
// `opts` is an optional argument bag. Details:
//
//    opts = {
//        // string to put before a matching character
//        pre:     '<b>'
//
//        // string to put after matching character
//      , post:    '</b>'
//
//        // Optional function. Input is an entry in the given arr`,
//        // output should be the string to test `pattern` against.
//        // In this example, if `arr = [{crying: 'koala'}]` we would return
//        // 'koala'.
//      , extract: function(arg) { return arg.crying; }
//    }
fuzzy.filter = function(pattern, arr, opts) {
  if(!arr || arr.length === 0) {
    return [];
  }
  if (typeof pattern !== 'string') {
    return arr;
  }
  opts = opts || {};
  return arr
    .reduce(function(prev, element, idx, arr) {
      var str = element;
      if(opts.extract) {
        str = opts.extract(element);
      }
      var rendered = fuzzy.match(pattern, str, opts);
      if(rendered != null) {
        prev[prev.length] = {
            string: rendered.rendered
          , score: rendered.score
          , index: idx
          , original: element
        };
      }
      return prev;
    }, [])

    // Sort by score. Browsers are inconsistent wrt stable/unstable
    // sorting, so force stable by using the index in the case of tie.
    // See http://ofb.net/~sethml/is-sort-stable.html
    .sort(function(a,b) {
      var compare = b.score - a.score;
      if(compare) return compare;
      return a.index - b.index;
    });
};


}());



/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var Accessor = __webpack_require__(631);
var React = __webpack_require__(0);
var Token = __webpack_require__(1592);
var KeyEvent = __webpack_require__(632);
var Typeahead = __webpack_require__(630);
var classNames = __webpack_require__(5);
var createReactClass = __webpack_require__(122);
var PropTypes = __webpack_require__(1);

function _arraysAreDifferent(array1, array2) {
  if (array1.length != array2.length) {
    return true;
  }
  for (var i = array2.length - 1; i >= 0; i--) {
    if (array2[i] !== array1[i]) {
      return true;
    }
  }
}

/**
 * A typeahead that, when an option is selected, instead of simply filling
 * the text entry widget, prepends a renderable "token", that may be deleted
 * by pressing backspace on the beginning of the line with the keyboard.
 */
var TypeaheadTokenizer = createReactClass({
  displayName: 'TypeaheadTokenizer',

  propTypes: {
    name: PropTypes.string,
    options: PropTypes.array,
    customClasses: PropTypes.object,
    allowCustomValues: PropTypes.number,
    defaultSelected: PropTypes.array,
    initialValue: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    inputProps: PropTypes.object,
    onTokenRemove: PropTypes.func,
    onKeyDown: PropTypes.func,
    onKeyPress: PropTypes.func,
    onKeyUp: PropTypes.func,
    onTokenAdd: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    filterOption: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    searchOptions: PropTypes.func,
    displayOption: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    formInputOption: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    maxVisible: PropTypes.number,
    resultsTruncatedMessage: PropTypes.string,
    defaultClassNames: PropTypes.bool,
    showOptionsWhenEmpty: PropTypes.bool
  },

  getInitialState: function () {
    return {
      // We need to copy this to avoid incorrect sharing
      // of state across instances (e.g., via getDefaultProps())
      selected: this.props.defaultSelected.slice(0)
    };
  },

  getDefaultProps: function () {
    return {
      options: [],
      defaultSelected: [],
      customClasses: {},
      allowCustomValues: 0,
      initialValue: "",
      placeholder: "",
      disabled: false,
      inputProps: {},
      defaultClassNames: true,
      filterOption: null,
      searchOptions: null,
      displayOption: function (token) {
        return token;
      },
      formInputOption: null,
      onKeyDown: function (event) {},
      onKeyPress: function (event) {},
      onKeyUp: function (event) {},
      onFocus: function (event) {},
      onBlur: function (event) {},
      onTokenAdd: function () {},
      onTokenRemove: function () {},
      showOptionsWhenEmpty: false
    };
  },

  componentWillReceiveProps: function (nextProps) {
    // if we get new defaultProps, update selected
    if (_arraysAreDifferent(this.props.defaultSelected, nextProps.defaultSelected)) {
      this.setState({ selected: nextProps.defaultSelected.slice(0) });
    }
  },

  focus: function () {
    this.refs.typeahead.focus();
  },

  getSelectedTokens: function () {
    return this.state.selected;
  },

  // TODO: Support initialized tokens
  //
  _renderTokens: function () {
    var tokenClasses = {};
    tokenClasses[this.props.customClasses.token] = !!this.props.customClasses.token;
    var classList = classNames(tokenClasses);
    var result = this.state.selected.map(function (selected) {
      var displayString = Accessor.valueForOption(this.props.displayOption, selected);
      var value = Accessor.valueForOption(this.props.formInputOption || this.props.displayOption, selected);
      return React.createElement(
        Token,
        { key: displayString, className: classList,
          onRemove: this._removeTokenForValue,
          object: selected,
          value: value,
          name: this.props.name },
        displayString
      );
    }, this);
    return result;
  },

  _getOptionsForTypeahead: function () {
    // return this.props.options without this.selected
    return this.props.options;
  },

  _onKeyDown: function (event) {
    // We only care about intercepting backspaces
    if (event.keyCode === KeyEvent.DOM_VK_BACK_SPACE) {
      return this._handleBackspace(event);
    }
    this.props.onKeyDown(event);
  },

  _handleBackspace: function (event) {
    // No tokens
    if (!this.state.selected.length) {
      return;
    }

    // Remove token ONLY when bksp pressed at beginning of line
    // without a selection
    var entry = this.refs.typeahead.refs.entry;
    if (entry.selectionStart == entry.selectionEnd && entry.selectionStart == 0) {
      this._removeTokenForValue(this.state.selected[this.state.selected.length - 1]);
      event.preventDefault();
    }
  },

  _removeTokenForValue: function (value) {
    var index = this.state.selected.indexOf(value);
    if (index == -1) {
      return;
    }

    this.state.selected.splice(index, 1);
    this.setState({ selected: this.state.selected });
    this.props.onTokenRemove(value);
    return;
  },

  _addTokenForValue: function (value) {
    if (this.state.selected.indexOf(value) != -1) {
      return;
    }
    this.state.selected.push(value);
    this.setState({ selected: this.state.selected });
    this.refs.typeahead.setEntryText("");
    this.props.onTokenAdd(value);
  },

  render: function () {
    var classes = {};
    classes[this.props.customClasses.typeahead] = !!this.props.customClasses.typeahead;
    var classList = classNames(classes);
    var tokenizerClasses = [this.props.defaultClassNames && "typeahead-tokenizer"];
    tokenizerClasses[this.props.className] = !!this.props.className;
    var tokenizerClassList = classNames(tokenizerClasses);

    return React.createElement(
      'div',
      { className: tokenizerClassList },
      this._renderTokens(),
      React.createElement(Typeahead, { ref: 'typeahead',
        className: classList,
        placeholder: this.props.placeholder,
        disabled: this.props.disabled,
        inputProps: this.props.inputProps,
        allowCustomValues: this.props.allowCustomValues,
        customClasses: this.props.customClasses,
        options: this._getOptionsForTypeahead(),
        initialValue: this.props.initialValue,
        maxVisible: this.props.maxVisible,
        resultsTruncatedMessage: this.props.resultsTruncatedMessage,
        onOptionSelected: this._addTokenForValue,
        onKeyDown: this._onKeyDown,
        onKeyPress: this.props.onKeyPress,
        onKeyUp: this.props.onKeyUp,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        displayOption: this.props.displayOption,
        defaultClassNames: this.props.defaultClassNames,
        filterOption: this.props.filterOption,
        searchOptions: this.props.searchOptions,
        showOptionsWhenEmpty: this.props.showOptionsWhenEmpty })
    );
  }
});

module.exports = TypeaheadTokenizer;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var classNames = __webpack_require__(5);
var createReactClass = __webpack_require__(122);
var PropTypes = __webpack_require__(1);

/**
 * Encapsulates the rendering of an option that has been "selected" in a
 * TypeaheadTokenizer
 */
var Token = createReactClass({
  displayName: 'Token',

  propTypes: {
    className: PropTypes.string,
    name: PropTypes.string,
    children: PropTypes.string,
    object: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onRemove: PropTypes.func,
    value: PropTypes.string
  },

  render: function () {
    var className = classNames(["typeahead-token", this.props.className]);

    return React.createElement(
      'div',
      { className: className },
      this._renderHiddenInput(),
      this.props.children,
      this._renderCloseButton()
    );
  },

  _renderHiddenInput: function () {
    // If no name was set, don't create a hidden input
    if (!this.props.name) {
      return null;
    }

    return React.createElement('input', {
      type: 'hidden',
      name: this.props.name + '[]',
      value: this.props.value || this.props.object
    });
  },

  _renderCloseButton: function () {
    if (!this.props.onRemove) {
      return "";
    }
    return React.createElement(
      'a',
      { className: this.props.className || "typeahead-token-close", href: '#', onClick: function (event) {
          this.props.onRemove(this.props.object);
          event.preventDefault();
        }.bind(this) },
      '\xD7'
    );
  }
});

module.exports = Token;

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_dealer_search__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__details__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__ = __webpack_require__(22);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\dealer\\summary.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var DealerSummary = function (_Component) {
  _inherits(DealerSummary, _Component);

  function DealerSummary(props) {
    _classCallCheck(this, DealerSummary);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateLocations = function () {
      _this.setState({
        loading: true
      }, function () {
        var value = _this.props.value;

        Object(__WEBPACK_IMPORTED_MODULE_5_apis_dealer_search__["a" /* dealerInfo */])(_extends({}, _this.state.searchInput, { dealerTypes: ["service"] })).then(function (_ref) {
          var response = _ref.response;

          var selectedDealerList = value ? __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(_this.state.dealers, {
            dealerCode: value.code,
            id: value.id,
            name: value.name
          }) : {};
          _this.setState({
            tempDealer: value ? {
              dealerCode: value.code,
              id: value.id,
              name: value.name
            } : {},
            dealers: __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()([].concat(selectedDealerList, response), "id") || [],
            loading: false
          });
        }).catch(console.warn.bind(console));
      });
    };

    _this.updateLocationInSearchInput = function (search) {
      if (!search) return;
      _this.setState({
        searchInput: {
          dealerCode: search.dealerCode,
          postcode: search.postcode
        }
      }, function () {
        _this.updateLocations();
      });
    };

    _this.state = {
      dealers: props.initialLocations || [],
      editMode: !(props.initialLocations && props.initialLocations[0]),
      loading: false,
      searchInput: {
        postcode: props.initialLocations && props.initialLocations[0] ? String(props.initialLocations[0].postcode) : ""
      },
      tempDealer: props.initialLocations && props.initialLocations[0] ? {
        dealerCode: props.initialLocations[0].dealerCode,
        id: props.initialLocations[0].id,
        name: props.initialLocations[0].name
      } : {},
      fields: {
        postcode: {}
      }
    };

    _this.onEdit = function () {
      var _this$state = _this.state,
          editMode = _this$state.editMode,
          dealers = _this$state.dealers;
      var value = _this.props.value;


      if (!value) return;

      _this.setState({
        editMode: !editMode || !dealers.length,
        tempDealer: {
          dealerCode: value.code,
          id: value.id,
          name: value.name
        },
        dealers: __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(dealers, {
          dealerCode: value.code,
          id: value.id,
          name: value.name
        }), "id")
      });
    };

    _this.onDealerSelect = function () {
      var tempDealer = _this.state.tempDealer;

      _this.setState({
        editMode: false,
        dealers: __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(_this.state.dealers, {
          dealerCode: tempDealer.dealerCode,
          id: tempDealer.id,
          name: tempDealer.name
        })
      });

      _this.onChange(tempDealer);
    };
    return _this;
  }

  DealerSummary.prototype.componentDidMount = function componentDidMount() {
    var initialLocations = this.props.initialLocations;

    initialLocations && initialLocations.length && this.onChange(initialLocations[0]);
  };

  DealerSummary.prototype.onChange = function onChange(location) {
    var onChange = this.props.onChange;

    onChange({
      id: location.id,
      code: location.dealerCode,
      name: location.name
    });
  };

  DealerSummary.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        _props$value = _props.value,
        value = _props$value === undefined ? {} : _props$value,
        type = _props.type;
    var _state = this.state,
        dealers = _state.dealers,
        editMode = _state.editMode,
        loading = _state.loading;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { margin: "2em 0 1em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 154
        }
      },
      editMode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { marginBottom: "2em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 156
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          {
            style: {
              fontWeight: 200,
              lineHeight: 1.6,
              overflow: "hidden",
              textAlign: "left",
              color: __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__["a" /* default */].BLACK
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 157
            }
          },
          !__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(value) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            {
              style: {
                padding: "0 0 2em 3em",
                float: "right",
                cursor: "pointer",
                color: __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__["a" /* default */].GRAY_DARK,
                ":hover": { color: __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__["a" /* default */].BLACK }
              },
              onClick: function onClick() {
                return _this2.onEdit();
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 166
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["g" /* CancelIcon */], {
              style: {
                fill: "currentColor",
                width: "20px",
                height: "20px",
                margin: "0 0.5em -3px 0"
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 175
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { fontSize: "14px", fontWeight: "400" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 183
                }
              },
              "Cancel"
            )
          ),
          "Enter a dealer name, postcode or suburb to find your nearest Mazda dealerships."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["n" /* DealerSearchBoxNZ */], {
          searchOverride: "",
          dealerSearchEndPoint: this.props.dealerSearchEndPoint || "/api/dealer-search",
          onChange: this.updateLocationInSearchInput,
          componentRestrictions: { country: 'nz' // handleAutocomplete
          },
          updateLocations: this.updateLocationInSearchInput,
          gtmMapping: __WEBPACK_IMPORTED_MODULE_10_store_gtm_events__["f" /* gtmFindADealerActionTypes */],
          __source: {
            fileName: _jsxFileName,
            lineNumber: 191
          }
        })
      ),
      loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["M" /* LoaderIcon */], { styleName: "light", __source: {
          fileName: _jsxFileName,
          lineNumber: 203
        }
      }),
      dealers.length > 0 && dealers.map(function (location) {
        return location.id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: location.id,
            style: {
              display: !editMode && value.id !== location.id || editMode && value.id === location.id ? "none" : "flex",
              flexDirection: "row",
              color: __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__["a" /* default */].BLACK
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 207
            }
          },
          editMode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { padding: ".25em" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 218
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["h" /* CheckBox */], {
              checked: _this2.state.tempDealer.id === location.id,
              onClick: function onClick() {
                _this2.setState({
                  tempDealer: {
                    dealerCode: location.dealerCode,
                    id: location.id,
                    name: location.name
                  }
                });
              },
              style: { margin: "0 1em .5em 0" },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 219
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                flexGrow: 1,
                lineHeight: 1.2,
                fontWeight: 300,
                cursor: "pointer"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 234
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__details__["a" /* default */], { compact: _this2.props.compact, location: location, type: type, __source: {
                fileName: _jsxFileName,
                lineNumber: 241
              }
            })
          ),
          !editMode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: { cursor: "pointer", width: "4em", lineHeight: "25px", textAlign: "center" },
              onClick: function onClick() {
                return _this2.onEdit();
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 244
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["q" /* EditIcon */], { style: { width: "20px", height: "20px", marginBottom: "-3px" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 247
              }
            }),
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { fontSize: "14px", fontWeight: "400", color: __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__["a" /* default */].GRAY_DARK, ":hover": { color: __WEBPACK_IMPORTED_MODULE_7_constants_color_palette__["a" /* default */].BLACK } }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 248
                }
              },
              "Edit"
            )
          )
        );
      }),
      editMode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_components__["e" /* Button */],
        {
          onClick: this.onDealerSelect,
          label: "Select dealer",
          disabled: this.state.tempDealer.id === value.id,
          display: "block",
          styleName: "black", __source: {
            fileName: _jsxFileName,
            lineNumber: 255
          }
        },
        "Select dealer"
      ) : null
    );
  };

  return DealerSummary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DealerSummary.displayName = "DealerSummary";


DealerSummary.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["service", "sales", "parts"]),
  dealerApiEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  dealerSearchEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  initialLocations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["b" /* DetectCompact */])())(DealerSummary));

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(397),
    baseFilter = __webpack_require__(1595),
    baseIteratee = __webpack_require__(168),
    isArray = __webpack_require__(70);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1596);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1597),
    createBaseEach = __webpack_require__(1600);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1598),
    keys = __webpack_require__(175);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1599);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1599 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(176);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\dealer\\details.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var fullAddress = function fullAddress(location) {
  var address = location.address,
      suburb = location.suburb,
      state = location.state,
      postCode = location.postCode;

  var region = Object(__WEBPACK_IMPORTED_MODULE_3_utils__["f" /* compact */])([state, postCode]).join(" ");
  return Object(__WEBPACK_IMPORTED_MODULE_3_utils__["g" /* compactMap */])(__WEBPACK_IMPORTED_MODULE_3_utils__["T" /* titleCase */], [address, suburb]).concat(region || []).join(", ");
};

var DealerDetails = function (_React$PureComponent) {
  _inherits(DealerDetails, _React$PureComponent);

  function DealerDetails() {
    _classCallCheck(this, DealerDetails);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  DealerDetails.prototype.render = function render() {
    var _props = this.props,
        location = _props.location,
        type = _props.type,
        gtmEvents = _props.gtmEvents;

    var department = location.departments.find(function (department) {
      return department.name.toLowerCase() === type;
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { marginBottom: "2em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 25
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        },
        location.name
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "ul",
        { style: { padding: 0, margin: "0", listStyleType: "none" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { style: [dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn], __source: {
              fileName: _jsxFileName,
              lineNumber: 28
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 29
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["H" /* Hyperlink */], {
              text: fullAddress(this.props.location),
              href: "https://google.com.au/maps?q=" + fullAddress(this.props.location).replace(/ /g, "+") + "/",
              external: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 30
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { style: [dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn], __source: {
              fileName: _jsxFileName,
              lineNumber: 39
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 40
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 41
                }
              },
              "Opening hours:"
            ),
            department.hours.map(function (label, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 42
                  }
                },
                label
              );
            })
          )
        )
      )
    );
  };

  return DealerDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

DealerDetails.displayName = "DealerDetails";


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["f" /* Radium */])(DealerDetails));

DealerDetails.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
};

var dealerDetailStyles = {
  detailItem: {
    fontWeight: 200,
    margin: "0 0 0.5em",
    lineHeight: "1.4"
  }
};

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_heading__ = __webpack_require__(616);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\editable-details-section\\index.jsx";





var EditableDetailsSection = function EditableDetailsSection(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === undefined ? "" : _ref$heading,
      _ref$details = _ref.details,
      details = _ref$details === undefined ? [] : _ref$details;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_components_heading__["a" /* default */],
      { tag: "h2", size: "medium", __source: {
          fileName: _jsxFileName,
          lineNumber: 11
        }
      },
      heading
    ),
    details.map(function (_ref2) {
      var label = _ref2.label,
          value = _ref2.value;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: label, __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 14
            }
          },
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 15
            }
          },
          value
        )
      );
    })
  );
};

EditableDetailsSection.displayName = "EditableDetailsSection";
EditableDetailsSection.displayName = "EditableDetailsSection";
EditableDetailsSection.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  details: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }))
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(EditableDetailsSection));

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_mymazda_navigation_notifications__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Button_Button_less__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Button_Button_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Button_Button_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\notifications-list\\index.jsx";












var NotificationsList = function NotificationsList(_ref) {
  var items = _ref.items,
      compact = _ref.compact;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { borderTop: "1px solid " + __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY, marginTop: "4em", width: "100%", textAlign: "left" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    },
    items && items.length ? items.map(function (item) {
      var _classnames;

      if (!item.notificationID) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: item.notificationID, style: styles.item(compact), __source: {
            fileName: _jsxFileName,
            lineNumber: 19
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.left(compact), __source: {
              fileName: _jsxFileName,
              lineNumber: 20
            }
          },
          item.notificationType === "RECALL" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["d" /* AlertIcon */], { style: styles.icon(__WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].RED), __source: {
              fileName: _jsxFileName,
              lineNumber: 22
            }
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["T" /* NotificationsIcon */], { style: styles.icon(__WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].BLACK), __source: {
              fileName: _jsxFileName,
              lineNumber: 24
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            { style: styles.paragraph, __source: {
                fileName: _jsxFileName,
                lineNumber: 26
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_containers_mymazda_navigation_notifications__["a" /* NotificationType */], { item: item, __source: {
                fileName: _jsxFileName,
                lineNumber: 27
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 29
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_AtomicComponents__["l" /* Caption */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 30
              }
            },
            item.notificationDate
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { flex: "1 1 25%", margin: compact && item.buttonUrl ? "2em 0 0 3em" : "0" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 32
            }
          },
          item.buttonUrl && item.buttonLinkText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],
            { to: item.buttonUrl, style: { textDecoration: "none" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 34
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                className: "Button " + __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Button_Button_less___default.a.Button] = true, _classnames[__WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Button_Button_less___default.a.ButtonFullWidth] = !compact, _classnames[__WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Button_Button_less___default.a.ButtonWhiteOutlined] = item.notificationType !== "RECALL", _classnames[__WEBPACK_IMPORTED_MODULE_9_AtomicComponents_Button_Button_less___default.a.ButtonRed] = item.notificationType === "RECALL", _classnames)),
                onClick: function onClick() {
                  Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "MyMazda - Notifications",
                    pageAction: "\"" + item.notificationType + "\" - clicked \"" + item.buttonLinkText.toUpperCase() + "\""
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 35
                }
              },
              item.buttonLinkText
            )
          )
        )
      );
    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      { style: [styles.item(compact), { justifyContent: "center", margin: "0" }], __source: {
          fileName: _jsxFileName,
          lineNumber: 56
        }
      },
      "No notifications."
    )
  );
};

NotificationsList.displayName = "NotificationsList";
NotificationsList.displayName = "NotificationsList";
var styles = {
  item: function item(compact) {
    return {
      borderBottom: "1px solid " + __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY,
      padding: "2em 0",
      display: "flex",
      fontWeight: "200",
      flexDirection: compact ? "column" : "row"
    };
  },
  left: function left(compact) {
    return {
      flex: "1 1 75%",
      paddingLeft: "3em",
      paddingRight: compact ? "0" : "2em",
      boxSizing: "border-box",
      position: "relative"
    };
  },
  icon: function icon(color) {
    return {
      position: "absolute",
      left: "0",
      top: "4px",
      width: "20px",
      height: "20px",
      fill: color
    };
  },
  paragraph: {
    lineHeight: "27px",
    margin: "0"
  },
  date: {
    color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARK,
    margin: "1em 0 0",
    fontSize: "14px"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["b" /* DetectCompact */])())(NotificationsList));

NotificationsList.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\vehicle-resource-list\\index.jsx";





var VehicleResourceList = function VehicleResourceList(_ref) {
  var title = _ref.title,
      imageUrl = _ref.imageUrl,
      size = _ref.size,
      vehicleResources = _ref.vehicleResources;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_containers__["g" /* ColumnGroup */],
    { horizontalPadding: false, __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_containers__["f" /* Column */],
      { padding: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 13
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_containers__["_0" /* SixtyFourtyBlock */],
        {
          heading: title,
          textAlign: "left",
          imagePosition: "right",
          size: size,
          backgroundSize: "contain",
          headingUppercase: true,
          textVerticalAlign: "center",
          imageUrl: imageUrl, __source: {
            fileName: _jsxFileName,
            lineNumber: 14
          }
        },
        vehicleResources && vehicleResources.items.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            { style: { marginBottom: "1em" }, key: item.href, __source: {
                fileName: _jsxFileName,
                lineNumber: 25
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "a",
              {
                href: item.href,
                style: {
                  color: "#101010", fontWeight: "200", borderBottom: "none", textDecoration: "none"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 26
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { display: "inline", marginRight: "1em" }, src: "/globalassets/mymazda/" + (item.isExternal ? "icon_external-link" : "icon_download") + ".svg", height: "16", width: "19", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 31
                }
              }),
              item.label
            )
          );
        })
      )
    )
  );
};
VehicleResourceList.displayName = "VehicleResourceList";
VehicleResourceList.displayName = "VehicleResourceList";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(VehicleResourceList));

VehicleResourceList.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vehicleResources: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

VehicleResourceList.defaultProps = {
  size: "small"
};

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nuka_carousel__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__carousel_item__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\service\\carousel.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var RadiumCarousel = Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["f" /* Radium */])(__WEBPACK_IMPORTED_MODULE_2_nuka_carousel__["a" /* default */]);

var VehicleServiceCarousel = function (_Component) {
  _inherits(VehicleServiceCarousel, _Component);

  function VehicleServiceCarousel(props) {
    _classCallCheck(this, VehicleServiceCarousel);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    var serviceTiles = props.serviceTiles,
        nextServiceFactoryCode = props.nextServiceFactoryCode;


    _this.state = {
      currentSlideIndex: nextServiceFactoryCode ? serviceTiles.findIndex(function (service) {
        return service.factoryCode === nextServiceFactoryCode;
      }) : 0
    };
    return _this;
  }

  VehicleServiceCarousel.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        compact = _props.compact,
        heading = _props.heading,
        blurb = _props.blurb,
        serviceTiles = _props.serviceTiles,
        requestUnscheduledServicePageUrl = _props.requestUnscheduledServicePageUrl,
        gtmOnCarouselButtonClick = _props.gtmOnCarouselButtonClick,
        recallsPageUrl = _props.recallsPageUrl,
        gtmEvent = _props.gtmEvent;
    var currentSlideIndex = this.state.currentSlideIndex;


    var hyperlinkText = "Request an interim service >";

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_containers__["g" /* ColumnGroup */],
      { verticalPadding: true, horizontalPadding: false, fullWidth: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 45
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_containers__["f" /* Column */],
        { textAlignMobile: "center", textAlign: "center", __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          }
        },
        heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["z" /* H2 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 48
            }
          },
          heading
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 50
          }
        }),
        blurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */], { xmlString: blurb, textAlign: "center", __source: {
            fileName: _jsxFileName,
            lineNumber: 51
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { padding: "3em 0" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 52
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            RadiumCarousel,
            {
              cellAlign: "center",
              cellSpacing: 20,
              easing: "easeCubicInOut",
              slideIndex: currentSlideIndex,
              afterSlide: function afterSlide(slideIndex) {
                return _this2.setState({ currentSlideIndex: slideIndex });
              },
              slideWidth: "280px",
              slidesToShow: 1,
              renderCenterLeftControls: function renderCenterLeftControls(_ref) {
                var previousSlide = _ref.previousSlide,
                    currentSlide = _ref.currentSlide;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    key: "left",
                    style: {
                      padding: compact ? "0.75em" : "1em",
                      marginLeft: compact ? "1em" : "2.25em",
                      cursor: currentSlide === 0 ? "default" : "pointer",
                      borderRadius: "100%",
                      opacity: currentSlide === 0 ? "0.3" : "1",
                      transition: "background 0.25s ease-in-out",
                      ":hover": { background: currentSlide === 0 ? "transparent" : __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].WHITE }
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 62
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "svg",
                    {
                      viewBox: "0 0 27 52",
                      width: compact ? "14px" : "18px",
                      height: compact ? "26px" : "34px",
                      onClick: previousSlide,
                      style: {
                        transform: "rotate(180deg)",
                        transformOrigin: "center center",
                        padding: compact ? "0 5px 0 9px" : "0 7px 0 11px"
                      }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 73
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                      style: { fill: __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].BLACK },
                      d: "M1.43,52L0,50.57,24.56,26,0,1.43,1.43,0,26.7,25.28a1,1,0,0,1,0,1.43Z", __source: {
                        fileName: _jsxFileName,
                        lineNumber: 83
                      }
                    })
                  )
                );
              },
              renderCenterRightControls: function renderCenterRightControls(_ref2) {
                var nextSlide = _ref2.nextSlide,
                    currentSlide = _ref2.currentSlide,
                    slideCount = _ref2.slideCount;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    key: "right",
                    style: {
                      padding: compact ? "0.75em" : "1em",
                      marginRight: compact ? "1em" : "2.25em",
                      cursor: currentSlide === slideCount - 1 ? "default" : "pointer",
                      borderRadius: "100%",
                      opacity: currentSlide === slideCount - 1 ? "0.3" : "1",
                      transition: "background 0.25s ease-in-out",
                      ":hover": {
                        background: currentSlide === slideCount - 1 ? "transparent" : __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].WHITE
                      }
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 90
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "svg",
                    {
                      viewBox: "0 0 27 52",
                      width: compact ? "14px" : "18px",
                      height: compact ? "26px" : "34px",
                      onClick: nextSlide,
                      style: { cursor: "pointer", padding: compact ? "0 5px 0 9px" : "0 7px 0 11px" }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 103
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                      style: { fill: __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].BLACK },
                      d: "M1.43,52L0,50.57,24.56,26,0,1.43,1.43,0,26.7,25.28a1,1,0,0,1,0,1.43Z", __source: {
                        fileName: _jsxFileName,
                        lineNumber: 109
                      }
                    })
                  )
                );
              },
              renderBottomCenterControls: function renderBottomCenterControls() {}, __source: {
                fileName: _jsxFileName,
                lineNumber: 53
              }
            },
            serviceTiles && serviceTiles.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__carousel_item__["a" /* default */], _extends({
                key: index,
                item: item,
                index: index,
                currentIndex: currentSlideIndex
              }, _this2.props, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 119
                }
              }));
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],
          {
            gtmevents: [{ func: gtmEvent, args: [gtmOnCarouselButtonClick({ buttonText: hyperlinkText })] }],
            text: hyperlinkText,
            to: requestUnscheduledServicePageUrl,
            style: { color: __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].BLACK }, __source: {
              fileName: _jsxFileName,
              lineNumber: 129
            }
          },
          hyperlinkText
        ),
        recallsPageUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              margin: "3em auto 0",
              maxWidth: "calc(1200px + 10vw)"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 139
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            {
              style: {
                fontWeight: "200",
                padding: "1.5em 0",
                borderTop: "1px solid " + __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].GRAY,
                borderBottom: "1px solid " + __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].GRAY,
                lineHeight: compact ? "30px" : "38px",
                margin: "0 5vw"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 144
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                style: {
                  fontSize: "18px",
                  letterSpacing: "0.2em",
                  fontWeight: "600",
                  display: compact ? "block" : "inline-block",
                  paddingRight: !compact && "1em",
                  marginRight: !compact && "1em",
                  borderRight: !compact && "1px solid " + __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].GRAY }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 153
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["d" /* AlertIcon */], {
                style: {
                  width: "1.25em",
                  height: "1.25em",
                  marginRight: "0.5em",
                  fill: __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].RED,
                  display: "inline-block",
                  verticalAlign: "sub" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 162
                }
              }),
              " MAZDA RECALLS"
            ),
            "For information about recalls for your vehicle.",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],
              { to: recallsPageUrl, style: { color: __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].BLACK, fontWeight: "600", marginLeft: "0.5em", whiteSpace: "nowrap" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 171
                }
              },
              "View Recalls >"
            )
          )
        )
      )
    );
  };

  return VehicleServiceCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

VehicleServiceCarousel.displayName = "VehicleServiceCarousel";


VehicleServiceCarousel.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  blurb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  serviceTiles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  requestUnscheduledServicePageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  requestServicePageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  registerRoutes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  services: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  gtmOnCarouselButtonClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  recallsPageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["i" /* gtmEvent */])())(VehicleServiceCarousel));

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Carousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_exenv__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_move_Animate__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_move_Animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_move_Animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_ease__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__default_controls__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__all_transitions__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__announce_slide__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_utilities__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_style_utilities__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_bootstrapping_utilities__ = __webpack_require__(1657);
/* unused harmony reexport NextButton */
/* unused harmony reexport PreviousButton */
/* unused harmony reexport PagingDots */
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }













var Carousel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel() {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).apply(this, arguments));
    _this.displayName = 'Carousel';
    _this.clickDisabled = false;
    _this.isTransitioning = false;
    _this.touchObject = {};
    _this.controlsMap = [{
      funcName: 'renderTopLeftControls',
      key: 'TopLeft'
    }, {
      funcName: 'renderTopCenterControls',
      key: 'TopCenter'
    }, {
      funcName: 'renderTopRightControls',
      key: 'TopRight'
    }, {
      funcName: 'renderCenterLeftControls',
      key: 'CenterLeft'
    }, {
      funcName: 'renderCenterCenterControls',
      key: 'CenterCenter'
    }, {
      funcName: 'renderCenterRightControls',
      key: 'CenterRight'
    }, {
      funcName: 'renderBottomLeftControls',
      key: 'BottomLeft'
    }, {
      funcName: 'renderBottomCenterControls',
      key: 'BottomCenter'
    }, {
      funcName: 'renderBottomRightControls',
      key: 'BottomRight'
    }];
    _this.state = _objectSpread({
      currentSlide: _this.props.slideIndex,
      dragging: false,
      easing: __WEBPACK_IMPORTED_MODULE_4_d3_ease__["easeCircleOut"],
      isWrappingAround: false,
      left: 0,
      resetWrapAroundPosition: false,
      slideCount: Object(__WEBPACK_IMPORTED_MODULE_10__utilities_bootstrapping_utilities__["c" /* getValidChildren */])(_this.props.children).length,
      top: 0,
      wrapToIndex: null
    }, Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["b" /* calcSomeInitialState */])(_this.props));
    _this.autoplayIterator = _this.autoplayIterator.bind(_assertThisInitialized(_this));
    _this.calcSlideHeightAndWidth = _this.calcSlideHeightAndWidth.bind(_assertThisInitialized(_this));
    _this.getChildNodes = _this.getChildNodes.bind(_assertThisInitialized(_this));
    _this.getMouseEvents = _this.getMouseEvents.bind(_assertThisInitialized(_this));
    _this.getOffsetDeltas = _this.getOffsetDeltas.bind(_assertThisInitialized(_this));
    _this.getTargetLeft = _this.getTargetLeft.bind(_assertThisInitialized(_this));
    _this.getTouchEvents = _this.getTouchEvents.bind(_assertThisInitialized(_this));
    _this.goToSlide = _this.goToSlide.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_this));
    _this.handleSwipe = _this.handleSwipe.bind(_assertThisInitialized(_this));
    _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized(_this));
    _this.onReadyStateChange = _this.onReadyStateChange.bind(_assertThisInitialized(_this));
    _this.onResize = _this.onResize.bind(_assertThisInitialized(_this));
    _this.onVisibilityChange = _this.onVisibilityChange.bind(_assertThisInitialized(_this));
    _this.previousSlide = _this.previousSlide.bind(_assertThisInitialized(_this));
    _this.renderControls = _this.renderControls.bind(_assertThisInitialized(_this));
    _this.resetAutoplay = _this.resetAutoplay.bind(_assertThisInitialized(_this));
    _this.setDimensions = _this.setDimensions.bind(_assertThisInitialized(_this));
    _this.setLeft = _this.setLeft.bind(_assertThisInitialized(_this));
    _this.setSlideHeightAndWidth = _this.setSlideHeightAndWidth.bind(_assertThisInitialized(_this));
    _this.startAutoplay = _this.startAutoplay.bind(_assertThisInitialized(_this));
    _this.stopAutoplay = _this.stopAutoplay.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
      this.mounted = true;
      this.setLeft();
      this.setDimensions();
      this.bindEvents();

      if (this.props.autoplay) {
        this.startAutoplay();
      }
    } // @TODO Remove deprecated componentWillReceiveProps with getDerivedStateFromProps
    // eslint-disable-next-line react/no-deprecated

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var slideCount = Object(__WEBPACK_IMPORTED_MODULE_10__utilities_bootstrapping_utilities__["c" /* getValidChildren */])(nextProps.children).length;
      var slideCountChanged = slideCount !== this.state.slideCount;
      this.setState(function (prevState) {
        return {
          slideCount: slideCount,
          currentSlide: slideCountChanged ? nextProps.slideIndex : prevState.currentSlide
        };
      });

      if (slideCount <= this.state.currentSlide) {
        this.goToSlide(Math.max(slideCount - 1, 0), nextProps);
      }

      var updateDimensions = slideCountChanged || Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["e" /* shouldUpdate */])(this.props, nextProps, ['cellSpacing', 'vertical', 'slideWidth', 'slideHeight', 'heightMode', 'slidesToScroll', 'slidesToShow', 'transitionMode', 'cellAlign']);

      if (updateDimensions) {
        this.setDimensions(nextProps);
      }

      if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide && !this.state.isWrappingAround) {
        this.goToSlide(nextProps.slideIndex, this.props);
      }

      if (this.props.autoplay !== nextProps.autoplay) {
        if (nextProps.autoplay) {
          this.startAutoplay();
        } else {
          this.stopAutoplay();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var slideChanged = prevState.currentSlide !== this.state.currentSlide;
      var heightModeChanged = prevProps.heightMode !== this.props.heightMode;

      if (slideChanged || heightModeChanged) {
        this.setSlideHeightAndWidth();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEvents();
      this.stopAutoplay(); // see https://github.com/facebook/react/issues/3417#issuecomment-121649937

      this.mounted = false;
    }
  }, {
    key: "getTouchEvents",
    value: function getTouchEvents() {
      var _this2 = this;

      if (this.props.swiping === false) {
        return {
          onTouchStart: function onTouchStart() {
            _this2.handleMouseOver();
          },
          onTouchEnd: function onTouchEnd() {
            _this2.handleMouseOut();
          }
        };
      }

      return {
        onTouchStart: function onTouchStart(e) {
          _this2.touchObject = {
            startX: e.touches[0].pageX,
            startY: e.touches[0].pageY
          };

          _this2.handleMouseOver();

          _this2.setState({
            dragging: true
          });
        },
        onTouchMove: function onTouchMove(e) {
          var direction = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["f" /* swipeDirection */])(_this2.touchObject.startX, e.touches[0].pageX, _this2.touchObject.startY, e.touches[0].pageY, _this2.props.vertical);

          if (direction !== 0) {
            e.preventDefault();
          }

          var length = _this2.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - _this2.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - _this2.touchObject.startX, 2)));
          _this2.touchObject = {
            startX: _this2.touchObject.startX,
            startY: _this2.touchObject.startY,
            endX: e.touches[0].pageX,
            endY: e.touches[0].pageY,
            length: length,
            direction: direction
          };

          _this2.setState({
            left: _this2.props.vertical ? 0 : _this2.getTargetLeft(_this2.touchObject.length * _this2.touchObject.direction),
            top: _this2.props.vertical ? _this2.getTargetLeft(_this2.touchObject.length * _this2.touchObject.direction) : 0
          });
        },
        onTouchEnd: function onTouchEnd(e) {
          _this2.handleSwipe(e);

          _this2.handleMouseOut();
        },
        onTouchCancel: function onTouchCancel(e) {
          _this2.handleSwipe(e);
        }
      };
    }
  }, {
    key: "getMouseEvents",
    value: function getMouseEvents() {
      var _this3 = this;

      if (this.props.dragging === false) {
        return {
          onMouseOver: function onMouseOver() {
            return _this3.handleMouseOver();
          },
          onMouseOut: function onMouseOut() {
            return _this3.handleMouseOut();
          }
        };
      }

      return {
        onMouseOver: function onMouseOver() {
          return _this3.handleMouseOver();
        },
        onMouseOut: function onMouseOut() {
          return _this3.handleMouseOut();
        },
        onMouseDown: function onMouseDown(e) {
          _this3.touchObject = {
            startX: e.clientX,
            startY: e.clientY
          };

          _this3.setState({
            dragging: true
          });
        },
        onMouseMove: function onMouseMove(e) {
          if (!_this3.state.dragging) {
            return;
          }

          var direction = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["f" /* swipeDirection */])(_this3.touchObject.startX, e.clientX, _this3.touchObject.startY, e.clientY, _this3.props.vertical);

          if (direction !== 0) {
            e.preventDefault();
          }

          var length = _this3.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - _this3.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - _this3.touchObject.startX, 2))); // prevents disabling click just because mouse moves a fraction of a pixel

          if (length >= 10) _this3.clickDisabled = true;
          _this3.touchObject = {
            startX: _this3.touchObject.startX,
            startY: _this3.touchObject.startY,
            endX: e.clientX,
            endY: e.clientY,
            length: length,
            direction: direction
          };

          _this3.setState({
            left: _this3.props.vertical ? 0 : _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction),
            top: _this3.props.vertical ? _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction) : 0
          });
        },
        onMouseUp: function onMouseUp(e) {
          if (_this3.touchObject.length === 0 || _this3.touchObject.length === undefined) {
            _this3.setState({
              dragging: false
            });

            return;
          }

          _this3.handleSwipe(e);
        },
        onMouseLeave: function onMouseLeave(e) {
          if (!_this3.state.dragging) {
            return;
          }

          _this3.handleSwipe(e);
        }
      };
    }
  }, {
    key: "pauseAutoplay",
    value: function pauseAutoplay() {
      if (this.props.autoplay) {
        this.autoplayPaused = true;
        this.stopAutoplay();
      }
    }
  }, {
    key: "unpauseAutoplay",
    value: function unpauseAutoplay() {
      if (this.props.autoplay && this.autoplayPaused) {
        this.startAutoplay();
        this.autoplayPaused = null;
      }
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver() {
      if (this.props.pauseOnHover) {
        this.pauseAutoplay();
      }
    }
  }, {
    key: "handleMouseOut",
    value: function handleMouseOut() {
      if (this.autoplayPaused) {
        this.unpauseAutoplay();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (this.clickDisabled === true) {
        if (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (event.nativeEvent) {
          event.nativeEvent.stopPropagation();
        }
      }
    }
  }, {
    key: "handleSwipe",
    value: function handleSwipe() {
      var _this4 = this;

      var slidesToShow = this.state.slidesToShow;

      if (this.props.slidesToScroll === 'auto') {
        slidesToShow = this.state.slidesToScroll;
      }

      if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
        if (this.touchObject.direction === 1) {
          if (this.state.currentSlide >= this.state.slideCount - slidesToShow && !this.props.wrapAround) {
            this.setState({
              easing: __WEBPACK_IMPORTED_MODULE_4_d3_ease__[this.props.edgeEasing]
            });
          } else {
            this.nextSlide();
          }
        } else if (this.touchObject.direction === -1) {
          if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
            this.setState({
              easing: __WEBPACK_IMPORTED_MODULE_4_d3_ease__[this.props.edgeEasing]
            });
          } else {
            this.previousSlide();
          }
        }
      } else {
        this.goToSlide(this.state.currentSlide);
      } // wait for `handleClick` event before resetting clickDisabled


      setTimeout(function () {
        _this4.clickDisabled = false;
      }, 0);
      this.touchObject = {};
      this.setState({
        dragging: false
      });
    } // eslint-disable-next-line complexity

  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      if (this.props.enableKeyboardControls) {
        switch (e.keyCode) {
          case 39:
          case 68:
          case 38:
          case 87:
            this.nextSlide();
            break;

          case 37:
          case 65:
          case 40:
          case 83:
            this.previousSlide();
            break;

          case 81:
            this.goToSlide(0, this.props);
            break;

          case 69:
            this.goToSlide(this.state.slideCount - 1, this.props);
            break;

          case 32:
            if (this.state.pauseOnHover && this.props.autoplay) {
              this.setState({
                pauseOnHover: false
              });
              this.pauseAutoplay();
              break;
            } else {
              this.setState({
                pauseOnHover: true
              });
              this.unpauseAutoplay();
              break;
            }

        }
      }
    }
  }, {
    key: "autoplayIterator",
    value: function autoplayIterator() {
      if (this.props.wrapAround) {
        this.nextSlide();
        return;
      }

      if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
        this.nextSlide();
      } else {
        this.stopAutoplay();
      }
    }
  }, {
    key: "startAutoplay",
    value: function startAutoplay() {
      this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
    }
  }, {
    key: "resetAutoplay",
    value: function resetAutoplay() {
      if (this.props.autoplay && !this.autoplayPaused) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }
  }, {
    key: "stopAutoplay",
    value: function stopAutoplay() {
      if (this.autoplayID) {
        clearInterval(this.autoplayID);
      }
    } // Animation Method

  }, {
    key: "getTargetLeft",
    value: function getTargetLeft(touchOffset, slide) {
      var offset;
      var target = slide || this.state.currentSlide;

      switch (this.state.cellAlign) {
        case 'left':
          {
            offset = 0;
            offset -= this.props.cellSpacing * target;
            break;
          }

        case 'center':
          {
            offset = (this.state.frameWidth - this.state.slideWidth) / 2;
            offset -= this.props.cellSpacing * target;
            break;
          }

        case 'right':
          {
            offset = this.state.frameWidth - this.state.slideWidth;
            offset -= this.props.cellSpacing * target;
            break;
          }
      }

      var left = this.state.slideWidth * target;
      var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;

      if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
        left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
        offset = 0;
        offset -= this.props.cellSpacing * (this.state.slideCount - 1);
      }

      offset -= touchOffset || 0;
      return (left - offset) * -1;
    }
  }, {
    key: "getOffsetDeltas",
    value: function getOffsetDeltas() {
      var offset = 0;

      if (this.state.isWrappingAround) {
        offset = this.getTargetLeft(null, this.state.wrapToIndex);
      } else {
        offset = this.getTargetLeft(this.touchObject.length * this.touchObject.direction);
      }

      return {
        tx: [this.props.vertical ? 0 : offset],
        ty: [this.props.vertical ? offset : 0]
      };
    } // Action Methods

  }, {
    key: "goToSlide",
    value: function goToSlide(index, props) {
      var _this5 = this;

      if (props === undefined) {
        props = this.props;
      }

      if (this.isTransitioning) {
        return;
      }

      this.setState({
        easing: __WEBPACK_IMPORTED_MODULE_4_d3_ease__[props.easing]
      });
      this.isTransitioning = true;
      var previousSlide = this.state.currentSlide;

      if (index >= this.state.slideCount || index < 0) {
        if (!props.wrapAround) {
          this.isTransitioning = false;
          return;
        }

        if (index >= this.state.slideCount) {
          props.beforeSlide(this.state.currentSlide, 0);
          this.setState(function (prevState) {
            return {
              left: props.vertical ? 0 : _this5.getTargetLeft(_this5.state.slideWidth, prevState.currentSlide),
              top: props.vertical ? _this5.getTargetLeft(_this5.state.slideWidth, prevState.currentSlide) : 0,
              currentSlide: 0,
              isWrappingAround: true,
              wrapToIndex: index
            };
          }, function () {
            setTimeout(function () {
              _this5.resetAutoplay();

              _this5.isTransitioning = false;

              if (index !== previousSlide) {
                _this5.props.afterSlide(0);
              }
            }, props.speed);
          });
          return;
        } else {
          var endSlide = this.state.slideCount - this.state.slidesToScroll;
          props.beforeSlide(this.state.currentSlide, endSlide);
          this.setState(function (prevState) {
            return {
              left: props.vertical ? 0 : _this5.getTargetLeft(0, prevState.currentSlide),
              top: props.vertical ? _this5.getTargetLeft(0, prevState.currentSlide) : 0,
              currentSlide: endSlide,
              isWrappingAround: true,
              wrapToIndex: index
            };
          }, function () {
            setTimeout(function () {
              _this5.resetAutoplay();

              _this5.isTransitioning = false;

              if (index !== previousSlide) {
                _this5.props.afterSlide(_this5.state.slideCount - 1);
              }
            }, props.speed);
          });
          return;
        }
      }

      this.props.beforeSlide(this.state.currentSlide, index);
      this.setState({
        currentSlide: index
      }, function () {
        return setTimeout(function () {
          _this5.resetAutoplay();

          _this5.isTransitioning = false;

          if (index !== previousSlide) {
            _this5.props.afterSlide(index);
          }
        }, props.speed);
      });
    }
  }, {
    key: "nextSlide",
    value: function nextSlide() {
      var childrenCount = this.state.slideCount;
      var slidesToShow = this.state.slidesToShow;

      if (this.props.slidesToScroll === 'auto') {
        slidesToShow = this.state.slidesToScroll;
      }

      if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround && this.props.cellAlign === 'left') {
        return;
      }

      if (this.props.wrapAround) {
        this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
      } else {
        if (this.props.slideWidth !== 1) {
          this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
          return;
        }

        var offset = this.state.currentSlide + this.state.slidesToScroll;
        var nextSlideIndex = this.props.cellAlign !== 'left' ? offset : Math.min(offset, childrenCount - slidesToShow);
        this.goToSlide(nextSlideIndex);
      }
    }
  }, {
    key: "previousSlide",
    value: function previousSlide() {
      if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
        return;
      }

      if (this.props.wrapAround) {
        this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
      } else {
        this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
      }
    } // Bootstrapping

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      if (__WEBPACK_IMPORTED_MODULE_2_exenv___default.a.canUseDOM) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["a" /* addEvent */])(window, 'resize', this.onResize);
        Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["a" /* addEvent */])(document, 'readystatechange', this.onReadyStateChange);
        Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["a" /* addEvent */])(document, 'visibilitychange', this.onVisibilityChange);
        Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["a" /* addEvent */])(document, 'keydown', this.handleKeyPress);
      }
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.setDimensions(null, this.props.onResize);
    }
  }, {
    key: "onReadyStateChange",
    value: function onReadyStateChange() {
      this.setDimensions();
    }
  }, {
    key: "onVisibilityChange",
    value: function onVisibilityChange() {
      if (document.hidden) {
        this.pauseAutoplay();
      } else {
        this.unpauseAutoplay();
      }
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      if (__WEBPACK_IMPORTED_MODULE_2_exenv___default.a.canUseDOM) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["d" /* removeEvent */])(window, 'resize', this.onResize);
        Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["d" /* removeEvent */])(document, 'readystatechange', this.onReadyStateChange);
        Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["d" /* removeEvent */])(document, 'visibilitychange', this.onVisibilityChange);
        Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["d" /* removeEvent */])(document, 'keydown', this.handleKeyPress);
      }
    }
  }, {
    key: "calcSlideHeightAndWidth",
    value: function calcSlideHeightAndWidth(props) {
      // slide height
      props = props || this.props;
      var childNodes = this.getChildNodes();
      var slideHeight = Object(__WEBPACK_IMPORTED_MODULE_10__utilities_bootstrapping_utilities__["b" /* getSlideHeight */])(props, this.state, childNodes); //slide width

      var _getPropsByTransition = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["c" /* getPropsByTransitionMode */])(props, ['slidesToShow']),
          slidesToShow = _getPropsByTransition.slidesToShow;

      var frame = this.frame;
      var slideWidth;

      if (this.props.animation === 'zoom') {
        slideWidth = frame.offsetWidth - frame.offsetWidth * 15 / 100;
      } else if (typeof props.slideWidth !== 'number') {
        slideWidth = parseInt(props.slideWidth);
      } else if (props.vertical) {
        slideWidth = slideHeight / slidesToShow * props.slideWidth;
      } else {
        slideWidth = frame.offsetWidth / slidesToShow * props.slideWidth;
      }

      if (!props.vertical) {
        slideWidth -= props.cellSpacing * ((100 - 100 / slidesToShow) / 100);
      }

      return {
        slideHeight: slideHeight,
        slideWidth: slideWidth
      };
    }
  }, {
    key: "setSlideHeightAndWidth",
    value: function setSlideHeightAndWidth() {
      this.setState(this.calcSlideHeightAndWidth());
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(props) {
      var _this6 = this;

      var stateCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      props = props || this.props;

      var _getPropsByTransition2 = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["c" /* getPropsByTransitionMode */])(props, ['slidesToShow', 'cellAlign']),
          slidesToShow = _getPropsByTransition2.slidesToShow,
          cellAlign = _getPropsByTransition2.cellAlign;

      var frame = this.frame;

      var _calcSlideHeightAndWi = this.calcSlideHeightAndWidth(props),
          slideHeight = _calcSlideHeightAndWi.slideHeight,
          slideWidth = _calcSlideHeightAndWi.slideWidth;

      var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
      var frameWidth = props.vertical ? frameHeight : frame.offsetWidth;

      var _getPropsByTransition3 = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_utilities__["c" /* getPropsByTransitionMode */])(props, ['slidesToScroll']),
          slidesToScroll = _getPropsByTransition3.slidesToScroll;

      if (slidesToScroll === 'auto') {
        slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
      }

      this.setState({
        frameWidth: frameWidth,
        slideHeight: slideHeight,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        slideWidth: slideWidth,
        cellAlign: cellAlign,
        left: props.vertical ? 0 : this.getTargetLeft(),
        top: props.vertical ? this.getTargetLeft() : 0
      }, function () {
        stateCb();

        _this6.setLeft();
      });
    }
  }, {
    key: "getChildNodes",
    value: function getChildNodes() {
      return this.frame.childNodes[0].childNodes;
    }
  }, {
    key: "setLeft",
    value: function setLeft() {
      var newLeft = this.props.vertical ? 0 : this.getTargetLeft();
      var newTop = this.props.vertical ? this.getTargetLeft() : 0;

      if (newLeft !== this.state.left || newTop !== this.state.top) {
        this.setState({
          left: newLeft,
          top: newTop
        });
      }
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this7 = this;

      if (this.props.withoutControls) {
        return this.controlsMap.map(function () {
          return null;
        });
      } else {
        return this.controlsMap.map(function (_ref) {
          var funcName = _ref.funcName,
              key = _ref.key;
          var func = _this7.props[funcName];
          return func && typeof func === 'function' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "slider-control-".concat(key.toLowerCase()),
            style: Object(__WEBPACK_IMPORTED_MODULE_9__utilities_style_utilities__["a" /* getDecoratorStyles */])(key),
            key: key
          }, func({
            cellSpacing: _this7.props.cellSpacing,
            currentSlide: _this7.state.currentSlide,
            frameWidth: _this7.state.frameWidth,
            goToSlide: function goToSlide(index) {
              return _this7.goToSlide(index);
            },
            nextSlide: function nextSlide() {
              return _this7.nextSlide();
            },
            previousSlide: function previousSlide() {
              return _this7.previousSlide();
            },
            slideCount: _this7.state.slideCount,
            slidesToScroll: _this7.state.slidesToScroll,
            slidesToShow: _this7.state.slidesToShow,
            slideWidth: _this7.state.slideWidth,
            wrapAround: _this7.props.wrapAround
          }));
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _state = this.state,
          currentSlide = _state.currentSlide,
          slideCount = _state.slideCount,
          frameWidth = _state.frameWidth;
      var _props = this.props,
          frameOverflow = _props.frameOverflow,
          vertical = _props.vertical,
          framePadding = _props.framePadding,
          slidesToShow = _props.slidesToShow,
          renderAnnounceSlideMessage = _props.renderAnnounceSlideMessage;
      var duration = this.state.dragging || this.state.resetWrapAroundPosition ? 0 : this.props.speed;
      var frameStyles = Object(__WEBPACK_IMPORTED_MODULE_9__utilities_style_utilities__["b" /* getFrameStyles */])(frameOverflow, vertical, framePadding, frameWidth);
      var touchEvents = this.getTouchEvents();
      var mouseEvents = this.getMouseEvents();
      var TransitionControl = __WEBPACK_IMPORTED_MODULE_6__all_transitions__["a" /* default */][this.props.transitionMode];
      var validChildren = Object(__WEBPACK_IMPORTED_MODULE_10__utilities_bootstrapping_utilities__["c" /* getValidChildren */])(this.props.children);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: ['slider', this.props.className || ''].join(' '),
        style: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__utilities_style_utilities__["d" /* getSliderStyles */])(this.props.width, this.state.slideWidth), this.props.style)
      }, !this.props.autoplay && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__announce_slide__["a" /* default */], {
        message: renderAnnounceSlideMessage({
          currentSlide: currentSlide,
          slideCount: slideCount
        })
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_move_Animate___default.a, {
        show: true,
        start: {
          tx: 0,
          ty: 0
        },
        update: _extends({}, this.getOffsetDeltas(this.touchObject, this.props, this.state), {
          timing: {
            duration: duration,
            ease: this.state.easing
          },
          events: {
            end: function end() {
              var newLeft = _this8.props.vertical ? 0 : _this8.getTargetLeft();
              var newTop = _this8.props.vertical ? _this8.getTargetLeft() : 0;

              if (newLeft !== _this8.state.left || newTop !== _this8.state.top) {
                _this8.setState({
                  left: newLeft,
                  top: newTop,
                  isWrappingAround: false,
                  resetWrapAroundPosition: true
                }, function () {
                  _this8.setState({
                    resetWrapAroundPosition: false
                  });
                });
              }
            }
          }
        }),
        children: function children(_ref2) {
          var tx = _ref2.tx,
              ty = _ref2.ty;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
            className: "slider-frame",
            ref: function ref(frame) {
              return _this8.frame = frame;
            },
            style: frameStyles
          }, touchEvents, mouseEvents, {
            onClickCapture: _this8.handleClick
          }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransitionControl, _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__utilities_style_utilities__["e" /* getTransitionProps */])(_this8.props, _this8.state), {
            deltaX: tx,
            deltaY: ty
          }), Object(__WEBPACK_IMPORTED_MODULE_10__utilities_bootstrapping_utilities__["a" /* addAccessibility */])(validChildren, slidesToShow, currentSlide)));
        }
      }), this.renderControls(), this.props.autoGenerateStyleTag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style", {
        type: "text/css",
        dangerouslySetInnerHTML: {
          __html: Object(__WEBPACK_IMPORTED_MODULE_9__utilities_style_utilities__["c" /* getImgTagStyles */])()
        }
      }));
    }
  }]);

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);


Carousel.propTypes = {
  afterSlide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['zoom']),
  autoGenerateStyleTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoplay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoplayInterval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  beforeSlide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  cellAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'center', 'right']),
  cellSpacing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  enableKeyboardControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dragging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  easing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  edgeEasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  frameOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  framePadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heightMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['first', 'current', 'max']),
  initialSlideHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  initialSlideWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onResize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  renderAnnounceSlideMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderBottomCenterControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderBottomLeftControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderBottomRightControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderCenterCenterControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderCenterLeftControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderCenterRightControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderTopCenterControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderTopLeftControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderTopRightControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  slideIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slidesToScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto'])]),
  slidesToShow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  speed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  swiping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  transitionMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['scroll', 'fade']),
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  withoutControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  wrapAround: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Carousel.defaultProps = {
  afterSlide: function afterSlide() {},
  autoGenerateStyleTag: true,
  autoplay: false,
  autoplayInterval: 3000,
  beforeSlide: function beforeSlide() {},
  cellAlign: 'left',
  cellSpacing: 0,
  enableKeyboardControls: false,
  dragging: true,
  easing: 'easeCircleOut',
  edgeEasing: 'easeElasticOut',
  frameOverflow: 'hidden',
  framePadding: '0px',
  heightMode: 'max',
  onResize: function onResize() {},
  pauseOnHover: true,
  renderAnnounceSlideMessage: __WEBPACK_IMPORTED_MODULE_7__announce_slide__["b" /* defaultRenderAnnounceSlideMessage */],
  renderBottomCenterControls: function renderBottomCenterControls(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__default_controls__["b" /* PagingDots */], props);
  },
  renderCenterLeftControls: function renderCenterLeftControls(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__default_controls__["c" /* PreviousButton */], props);
  },
  renderCenterRightControls: function renderCenterRightControls(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__default_controls__["a" /* NextButton */], props);
  },
  slideIndex: 0,
  slideOffset: 25,
  slidesToScroll: 1,
  slidesToShow: 1,
  slideWidth: 1,
  speed: 500,
  style: {},
  swiping: true,
  transitionMode: 'scroll',
  vertical: false,
  width: '100%',
  withoutControls: false,
  wrapAround: false
};


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Animate.default;
  }
});

var _Animate = _interopRequireDefault(__webpack_require__(1608));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _NodeGroup = _interopRequireDefault(__webpack_require__(1609));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyAccessor = function keyAccessor() {
  return '$$key$$';
};

function Animate(props) {
  var show = props.show,
      start = props.start,
      enter = props.enter,
      update = props.update,
      leave = props.leave,
      children = props.children;
  var data = typeof start === 'function' ? start() : start;
  return _react.default.createElement(_NodeGroup.default, {
    data: show ? [data] : [],
    start: function start() {
      return data;
    },
    keyAccessor: keyAccessor,
    enter: typeof enter === 'function' ? enter : function () {
      return enter;
    },
    update: typeof update === 'function' ? update : function () {
      return update;
    },
    leave: typeof leave === 'function' ? leave : function () {
      return leave;
    }
  }, function (nodes) {
    if (!nodes[0]) {
      return null;
    }

    var renderedChildren = children(nodes[0].state);
    return renderedChildren && _react.default.Children.only(renderedChildren);
  });
}

Animate.propTypes =  false ? {
  /**
   * Boolean value that determines if the child should be rendered or not.
   */
  show: _propTypes.default.bool.isRequired,

  /**
   * An object or function that returns an obejct to be used as the starting state.
   */
  start: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * An object, array of objects, or function that returns an object or array of objects describing how the state should transform on enter.
   */
  enter: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),

  /**
   * An object, array of objects, or function that returns an object or array of objects describing how the state should transform on update. ***Note:*** although not required, in most cases it make sense to specify an update prop to handle interrupted enter and leave transitions.
   */
  update: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),

  /**
   * An object, array of objects, or function that returns an object or array of objects describing how the state should transform on leave.
   */
  leave: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),

  /**
   * A function that renders the node.  The function is passed the data and state.
   */
  children: _propTypes.default.func.isRequired
} : {};
Animate.defaultProps = {
  show: true
};
var _default = Animate;
exports.default = _default;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NodeGroup.default;
  }
});

var _NodeGroup = _interopRequireDefault(__webpack_require__(1610));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(1611);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _d3Timer = __webpack_require__(296);

var _Node = _interopRequireDefault(__webpack_require__(1614));

var _mergeKeys = _interopRequireDefault(__webpack_require__(1616));

var _types = __webpack_require__(1617);

var _transition = __webpack_require__(1618);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NodeGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(NodeGroup, _Component);

  function NodeGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NodeGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NodeGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      nodeKeys: [],
      nodeHash: {},
      nodes: [],
      data: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "animate", function () {
      var _this$state = _this.state,
          nodeKeys = _this$state.nodeKeys,
          nodeHash = _this$state.nodeHash;

      if (_this.unmounting) {
        return;
      }

      var pending = false;
      var nextNodeKeys = [];
      var length = nodeKeys.length;

      for (var i = 0; i < length; i++) {
        var k = nodeKeys[i];
        var n = nodeHash[k];

        if (n.TRANSITION_SCHEDULES) {
          pending = true;
        }

        if (n.type === _types.LEAVE && !n.TRANSITION_SCHEDULES) {
          delete nodeHash[k];
        } else {
          nextNodeKeys.push(k);
        }
      }

      if (!pending) {
        _this.interval.stop();
      }

      _this.setState(function () {
        return {
          nodeKeys: nextNodeKeys,
          nodes: nextNodeKeys.map(function (key) {
            return nodeHash[key];
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "interval", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "unmounting", false);

    return _this;
  }

  _createClass(NodeGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startInterval();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.data !== this.props.data && !this.unmounting) {
        this.startInterval();
      }
    }
  }, {
    key: "startInterval",
    value: function startInterval() {
      if (!this.interval) {
        this.interval = (0, _d3Timer.interval)(this.animate);
      } else {
        this.interval.restart(this.animate);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$state2 = this.state,
          nodeKeys = _this$state2.nodeKeys,
          nodeHash = _this$state2.nodeHash;
      this.unmounting = true;

      if (this.interval) {
        this.interval.stop();
      }

      nodeKeys.forEach(function (key) {
        _transition.stop.call(nodeHash[key]);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var renderedChildren = this.props.children(this.state.nodes);
      return renderedChildren && _react.default.Children.only(renderedChildren);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.data !== prevState.data) {
        var data = nextProps.data,
            keyAccessor = nextProps.keyAccessor,
            start = nextProps.start,
            enter = nextProps.enter,
            update = nextProps.update,
            leave = nextProps.leave;
        var nodeKeys = prevState.nodeKeys,
            nodeHash = prevState.nodeHash;
        var keyIndex = {};

        for (var i = 0; i < nodeKeys.length; i++) {
          keyIndex[nodeKeys[i]] = i;
        }

        var nextKeyIndex = {};
        var nextNodeKeys = [];

        for (var _i = 0; _i < data.length; _i++) {
          var d = data[_i];
          var k = keyAccessor(d, _i);
          nextKeyIndex[k] = _i;
          nextNodeKeys.push(k);

          if (keyIndex[k] === undefined) {
            nodeHash[k] = new _Node.default(k, d, _types.ENTER);
          }
        }

        for (var _i2 = 0; _i2 < nodeKeys.length; _i2++) {
          var _k = nodeKeys[_i2];
          var n = nodeHash[_k];

          if (nextKeyIndex[_k] !== undefined) {
            n.updateData(data[nextKeyIndex[_k]]);
            n.updateType(_types.UPDATE);
          } else {
            n.updateType(_types.LEAVE);
          }
        }

        var mergedNodeKeys = (0, _mergeKeys.default)(nodeKeys, keyIndex, nextNodeKeys, nextKeyIndex);

        for (var _i3 = 0; _i3 < mergedNodeKeys.length; _i3++) {
          var _k2 = mergedNodeKeys[_i3];
          var _n = nodeHash[_k2];
          var _d = _n.data;

          if (_n.type === _types.ENTER) {
            _n.setState(start(_d, nextKeyIndex[_k2]));

            _transition.transition.call(_n, enter(_d, nextKeyIndex[_k2]));
          } else if (_n.type === _types.LEAVE) {
            _transition.transition.call(_n, leave(_d, keyIndex[_k2]));
          } else {
            _transition.transition.call(_n, update(_d, nextKeyIndex[_k2]));
          }
        }

        return {
          data: data,
          nodes: mergedNodeKeys.map(function (key) {
            return nodeHash[key];
          }),
          nodeHash: nodeHash,
          nodeKeys: mergedNodeKeys
        };
      }

      return null;
    }
  }]);

  return NodeGroup;
}(_react.Component);

NodeGroup.propTypes =  false ? {
  /**
   * An array.  The data prop is treated as immutable so the nodes will only update if prev.data !== next.data.
   */
  data: _propTypes.default.array.isRequired,

  /**
   * Function that returns a string key given the data and its index.  Used to track which nodes are entering, updating and leaving.
   */
  keyAccessor: _propTypes.default.func.isRequired,

  /**
   * A function that returns the starting state.  The function is passed the data and index and must return an object.
   */
  start: _propTypes.default.func.isRequired,

  /**
   * A function that **returns an object or array of objects** describing how the state should transform on enter.  The function is passed the data and index.
   */
  enter: _propTypes.default.func,

  /**
   * A function that **returns an object or array of objects** describing how the state should transform on update.  The function is passed the data and index.
   */
  update: _propTypes.default.func,

  /**
   * A function that **returns an object or array of objects** describing how the state should transform on leave.  The function is passed the data and index.
   */
  leave: _propTypes.default.func,

  /**
   * A function that renders the nodes. It should accept an array of nodes as its only argument.  Each node is an object with the key, data, state and a type of 'ENTER', 'UPDATE' or 'LEAVE'.
   */
  children: _propTypes.default.func.isRequired
} : {};
NodeGroup.defaultProps = {
  enter: function enter() {},
  update: function update() {},
  leave: function leave() {}
};
(0, _reactLifecyclesCompat.polyfill)(NodeGroup);
var _default = NodeGroup;
exports.default = _default;

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(297);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(297);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Node.default;
  }
});

var _Node = _interopRequireDefault(__webpack_require__(1615));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i]; // eslint-disable-line no-param-reassign
  }

  return obj;
}

function Node(key, data, type) {
  this.key = key;
  this.data = data;
  this.type = type;
  this.state = {};
}

extend(Node.prototype, {
  setState: function setState(state) {
    var s = this.state;
    extend(s, typeof state === 'function' ? state(s) : state);
  },
  updateData: function updateData(data) {
    this.data = data;
    return this;
  },
  updateType: function updateType(type) {
    this.type = type;
    return this;
  }
});
var _default = Node;
exports.default = _default;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* based on react-motion's mergeDiff (https://github.com/chenglou/react-motion) */
function mergeKeys(currNodeKeys, currKeyIndex, nextNodeKeys, nextKeyIndex) {
  var allKeys = [];

  for (var i = 0; i < nextNodeKeys.length; i++) {
    allKeys[i] = nextNodeKeys[i];
  }

  for (var _i = 0; _i < currNodeKeys.length; _i++) {
    if (nextKeyIndex[currNodeKeys[_i]] === undefined) {
      allKeys.push(currNodeKeys[_i]);
    }
  }

  return allKeys.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a];
    var nextOrderB = nextKeyIndex[b];
    var currOrderA = currKeyIndex[a];
    var currOrderB = currKeyIndex[b];

    if (nextOrderA != null && nextOrderB != null) {
      return nextKeyIndex[a] - nextKeyIndex[b];
    } else if (currOrderA != null && currOrderB != null) {
      return currKeyIndex[a] - currKeyIndex[b];
    } else if (nextOrderA != null) {
      for (var _i2 = 0; _i2 < nextNodeKeys.length; _i2++) {
        var pivot = nextNodeKeys[_i2];

        if (!currKeyIndex[pivot]) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && currOrderB > currKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && currOrderB < currKeyIndex[pivot]) {
          return 1;
        }
      }

      return 1;
    }

    for (var _i3 = 0; _i3 < nextNodeKeys.length; _i3++) {
      var _pivot = nextNodeKeys[_i3];

      if (!currKeyIndex[_pivot]) {
        continue;
      }

      if (nextOrderB < nextKeyIndex[_pivot] && currOrderA > currKeyIndex[_pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[_pivot] && currOrderA < currKeyIndex[_pivot]) {
        return -1;
      }
    }

    return -1;
  });
}

var _default = mergeKeys;
exports.default = _default;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEAVE = exports.UPDATE = exports.ENTER = void 0;
var ENTER = 'ENTER';
exports.ENTER = ENTER;
var UPDATE = 'UPDATE';
exports.UPDATE = UPDATE;
var LEAVE = 'LEAVE';
exports.LEAVE = LEAVE;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "transition", {
  enumerable: true,
  get: function get() {
    return _transition.default;
  }
});
Object.defineProperty(exports, "stop", {
  enumerable: true,
  get: function get() {
    return _stop.default;
  }
});

var _transition = _interopRequireDefault(__webpack_require__(1619));

var _stop = _interopRequireDefault(__webpack_require__(1638));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newId = newId;
exports.default = transition;
exports.preset = void 0;

var _d3Timer = __webpack_require__(296);

var _tween = _interopRequireDefault(__webpack_require__(1620));

var _schedule = _interopRequireDefault(__webpack_require__(1637));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function once(func) {
  var called = false;
  return function transitionEvent() {
    if (!called) {
      called = true;
      func.call(this);
    }
  };
}

var id = 0;

function newId() {
  return ++id;
} // from https://github.com/d3/d3-ease/blob/master/src/linear.js


function linear(t) {
  return +t;
}

var preset = {
  time: null,
  delay: 0,
  duration: 250,
  ease: linear
};
exports.preset = preset;

function scheduleTransitions() {
  var _this = this;

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var transitions = _objectSpread({}, config);

  var events = transitions.events || {};
  delete transitions.events; // each event handler should be called only once

  Object.keys(events).forEach(function (d) {
    if (typeof events[d] !== 'function') {
      throw new Error('Event handlers must be a function');
    } else {
      events[d] = once(events[d]);
    }
  });
  var timing = transitions.timing || {};
  delete transitions.timing;
  Object.keys(transitions).forEach(function (stateKey) {
    var tweens = [];

    if (_typeof(transitions[stateKey]) === 'object' && Array.isArray(transitions[stateKey]) === false) {
      Object.keys(transitions[stateKey]).forEach(function (attr) {
        var val = transitions[stateKey][attr];

        if (Array.isArray(val)) {
          if (val.length === 1) {
            tweens.push(_tween.default.call(_this, stateKey, attr, val[0]));
          } else {
            _this.setState(function (state) {
              return _defineProperty({}, stateKey, _objectSpread({}, state[stateKey], _defineProperty({}, attr, val[0])));
            });

            tweens.push(_tween.default.call(_this, stateKey, attr, val[1]));
          }
        } else if (typeof val === 'function') {
          var getResonanceCustomTween = function getResonanceCustomTween() {
            var resonanceCustomTween = function resonanceCustomTween(t) {
              _this.setState(function (state) {
                return _defineProperty({}, stateKey, _objectSpread({}, state[stateKey], _defineProperty({}, attr, val(t))));
              });
            };

            return resonanceCustomTween;
          };

          tweens.push(getResonanceCustomTween);
        } else {
          _this.setState(function (state) {
            return _defineProperty({}, stateKey, _objectSpread({}, state[stateKey], _defineProperty({}, attr, val)));
          }); // This assures any existing transitions are stopped


          tweens.push(_tween.default.call(_this, stateKey, attr, val));
        }
      });
    } else {
      var val = transitions[stateKey];

      if (Array.isArray(val)) {
        if (val.length === 1) {
          tweens.push(_tween.default.call(_this, null, stateKey, val[0]));
        } else {
          _this.setState(function () {
            return _defineProperty({}, stateKey, val[0]);
          });

          tweens.push(_tween.default.call(_this, null, stateKey, val[1]));
        }
      } else if (typeof val === 'function') {
        var getResonanceCustomTween = function getResonanceCustomTween() {
          var resonanceCustomTween = function resonanceCustomTween(t) {
            _this.setState(function () {
              return _defineProperty({}, stateKey, val(t));
            });
          };

          return resonanceCustomTween;
        };

        tweens.push(getResonanceCustomTween);
      } else {
        _this.setState(function () {
          return _defineProperty({}, stateKey, val);
        }); // This assures any existing transitions are stopped


        tweens.push(_tween.default.call(_this, null, stateKey, val));
      }
    }

    var timingConfig = _objectSpread({}, preset, timing, {
      time: (0, _d3Timer.now)()
    });

    (0, _schedule.default)(_this, stateKey, newId(), timingConfig, tweens, events);
  });
}

function transition(config) {
  var _this2 = this;

  if (Array.isArray(config)) {
    config.forEach(function (c) {
      scheduleTransitions.call(_this2, c);
    });
  } else {
    scheduleTransitions.call(this, config);
  }
}

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInterpolator = getInterpolator;
exports.default = _default;

var _d3Interpolate = __webpack_require__(1621);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getInterpolator(attr) {
  if (attr === 'transform') {
    return _d3Interpolate.interpolateTransformSvg;
  }

  return _d3Interpolate.interpolate;
}

function getTween(nameSpace, attr, value1) {
  return function tween() {
    var _this = this;

    var value0 = nameSpace ? this.state[nameSpace][attr] : this.state[attr];

    if (value0 === value1) {
      return null;
    }

    var i = getInterpolator(attr)(value0, value1);
    var stateTween;

    if (nameSpace === null) {
      stateTween = function stateTween(t) {
        _this.setState(function () {
          return _defineProperty({}, attr, i(t));
        });
      };
    } else {
      stateTween = function stateTween(t) {
        _this.setState(function (state) {
          return _defineProperty({}, nameSpace, _objectSpread({}, state[nameSpace], _defineProperty({}, attr, i(t))));
        });
      };
    }

    return stateTween;
  };
}

function _default(nameSpace, attr, value) {
  return getTween.call(this, nameSpace, attr, value);
}

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_0__value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(640);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_1__array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis__ = __webpack_require__(301);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_2__basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed__ = __webpack_require__(638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_3__basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date__ = __webpack_require__(641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_4__date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete__ = __webpack_require__(1624);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDiscrete", function() { return __WEBPACK_IMPORTED_MODULE_5__discrete__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue__ = __webpack_require__(1625);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHue", function() { return __WEBPACK_IMPORTED_MODULE_6__hue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_7__number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_8__object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__round__ = __webpack_require__(1626);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_9__round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__string__ = __webpack_require__(643);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_10__string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transform_index__ = __webpack_require__(1627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_11__transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_11__transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zoom__ = __webpack_require__(1630);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_12__zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rgb__ = __webpack_require__(637);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hsl__ = __webpack_require__(1631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_14__hsl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_14__hsl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lab__ = __webpack_require__(1632);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_15__lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hcl__ = __webpack_require__(1633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_16__hcl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_16__hcl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cubehelix__ = __webpack_require__(1634);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_17__cubehelix__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_17__cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__piecewise__ = __webpack_require__(1635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "piecewise", function() { return __WEBPACK_IMPORTED_MODULE_18__piecewise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__quantize__ = __webpack_require__(1636);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_19__quantize__["a"]; });






















/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gray */
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* unused harmony export lch */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(636);




// https://beta.observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(636);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_0__color__["c" /* hue */])(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(1628);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(1629);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(128);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(128);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(128);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(128);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ __webpack_exports__["b"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = piecewise;
function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _d3Timer = __webpack_require__(296);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

function _default(node, stateKey, id, timing, tweens) {
  var events = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var schedules = node.TRANSITION_SCHEDULES;

  if (!schedules) {
    node.TRANSITION_SCHEDULES = {}; // eslint-disable-line no-param-reassign
  } else if (id in schedules) {
    return;
  }

  var config = _objectSpread({
    stateKey: stateKey,
    events: events,
    tweens: tweens
  }, timing, {
    timer: null,
    state: CREATED
  });

  create(node, id, config);
}

function create(node, id, config) {
  var schedules = node.TRANSITION_SCHEDULES; // Initialize the transition timer when the transition is created.
  // Note the actual delay is not known until the first callback!

  var transition = _objectSpread({}, config);

  var n = transition.tweens.length;
  var tweens = new Array(n);
  schedules[id] = transition;
  transition.timer = (0, _d3Timer.timer)(schedule, 0, transition.time);

  function schedule(elapsed) {
    transition.state = SCHEDULED;
    transition.timer.restart(start, transition.delay, transition.time); // If the elapsed delay is less than our first sleep, start immediately.

    if (transition.delay <= elapsed) {
      start(elapsed - transition.delay);
    }
  }

  function start(elapsed) {
    // eslint-disable-line consistent-return
    // If the state is not SCHEDULED, then we previously errored on start.
    if (transition.state !== SCHEDULED) return stop();

    for (var sid in schedules) {
      // eslint-disable-line
      var s = schedules[sid];

      if (s.stateKey !== transition.stateKey) {
        continue; // eslint-disable-line no-continue
      } // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!


      if (s.state === STARTED) return (0, _d3Timer.timeout)(start); // 1. Interrupt the active transition, if any. dispatch the interrupt event.
      // 2. Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!

      if (s.state === RUNNING) {
        s.state = ENDED;
        s.timer.stop();

        if (s.events.interrupt && typeof s.events.interrupt === 'function') {
          s.events.interrupt.call(this);
        }

        delete schedules[sid];
      } else if (+sid < id) {
        s.state = ENDED;
        s.timer.stop();
        delete schedules[sid];
      }
    } // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.


    (0, _d3Timer.timeout)(function () {
      if (transition.state === STARTED) {
        transition.state = RUNNING;
        transition.timer.restart(tick, transition.delay, transition.time);
        tick(elapsed);
      }
    });
    transition.state = STARTING;

    if (transition.events.start && typeof transition.events.start === 'function') {
      transition.events.start.call(node);
    }

    if (transition.state !== STARTING) {
      // interrupted
      return; // eslint-disable-line consistent-return
    }

    transition.state = STARTED; // Initialize the tween, deleting null tween.

    var j = -1;

    for (var i = 0; i < n; ++i) {
      var res = transition.tweens[i].call(node);

      if (res) {
        tweens[++j] = res;
      }
    }

    tweens.length = j + 1;
  }

  function tick(elapsed) {
    var t = 1;

    if (elapsed < transition.duration) {
      t = transition.ease.call(null, elapsed / transition.duration);
    } else {
      transition.timer.restart(stop);
      transition.state = ENDING;
    }

    var i = -1;

    while (++i < tweens.length) {
      tweens[i].call(null, t);
    }

    if (transition.state === ENDING) {
      if (transition.events.end && typeof transition.events.end === 'function') {
        transition.events.end.call(node);
      }

      stop();
    }
  }

  function stop() {
    transition.state = ENDED;
    transition.timer.stop();
    delete schedules[id];

    for (var i in schedules) {
      return;
    } // eslint-disable-line guard-for-in, no-restricted-syntax


    delete node.TRANSITION_SCHEDULES; // eslint-disable-line no-param-reassign
  }
}

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stop;

function stop() {
  var ts = this.TRANSITION_SCHEDULES;

  if (ts) {
    Object.keys(ts).forEach(function (s) {
      ts[s].timer.stop();
    });
  }
}

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(1640);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeLinear", function() { return __WEBPACK_IMPORTED_MODULE_0__linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quad__ = __webpack_require__(1641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeQuad", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeQuadIn", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeQuadOut", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeQuadInOut", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubic__ = __webpack_require__(1642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCubic", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCubicIn", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCubicOut", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCubicInOut", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__poly__ = __webpack_require__(1643);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easePoly", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easePolyIn", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easePolyOut", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easePolyInOut", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sin__ = __webpack_require__(1644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeSin", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeSinIn", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeSinOut", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeSinInOut", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exp__ = __webpack_require__(1645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeExp", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeExpIn", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeExpOut", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeExpInOut", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__circle__ = __webpack_require__(1646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCircle", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCircleIn", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCircleOut", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCircleInOut", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bounce__ = __webpack_require__(1647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBounce", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBounceIn", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBounceOut", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBounceInOut", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__back__ = __webpack_require__(1648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBack", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBackIn", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBackOut", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBackInOut", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elastic__ = __webpack_require__(1649);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeElastic", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeElasticIn", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeElasticOut", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeElasticInOut", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["b"]; });





















/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
function linear(t) {
  return +t;
}


/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = quadOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = quadInOut;
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = cubicOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return polyOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return polyInOut; });
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sinIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = sinOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = sinInOut;
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = expIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = expOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = expInOut;
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = circleOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = circleInOut;
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bounceIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = bounceOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = bounceInOut;
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return backOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return backInOut; });
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return elasticIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return elasticOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return elasticInOut; });
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PreviousButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NextButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PagingDots; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }



var defaultButtonStyles = function defaultButtonStyles(disabled) {
  return {
    border: 0,
    background: 'rgba(0,0,0,0.4)',
    color: 'white',
    padding: 10,
    opacity: disabled ? 0.3 : 1,
    cursor: disabled ? 'not-allowed' : 'pointer'
  };
};

var PreviousButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PreviousButton, _React$Component);

  function PreviousButton() {
    var _this;

    _classCallCheck(this, PreviousButton);

    _this = _possibleConstructorReturn(this, (PreviousButton.__proto__ || Object.getPrototypeOf(PreviousButton)).apply(this, arguments));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PreviousButton, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();
      this.props.previousSlide();
    }
  }, {
    key: "render",
    value: function render() {
      var disabled = this.props.currentSlide === 0 && !this.props.wrapAround || this.props.slideCount === 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        style: defaultButtonStyles(disabled),
        disabled: disabled,
        onClick: this.handleClick,
        "aria-label": "previous"
      }, "PREV");
    }
  }]);

  return PreviousButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
var NextButton =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(NextButton, _React$Component2);

  function NextButton() {
    var _this2;

    _classCallCheck(this, NextButton);

    _this2 = _possibleConstructorReturn(this, (NextButton.__proto__ || Object.getPrototypeOf(NextButton)).apply(this, arguments));
    _this2.handleClick = _this2.handleClick.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(NextButton, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();
      this.props.nextSlide();
    }
  }, {
    key: "render",
    value: function render() {
      var disabled = this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        style: defaultButtonStyles(disabled),
        disabled: disabled,
        onClick: this.handleClick,
        "aria-label": "next"
      }, "NEXT");
    }
  }]);

  return NextButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
var PagingDots =
/*#__PURE__*/
function (_React$Component3) {
  _inherits(PagingDots, _React$Component3);

  function PagingDots() {
    _classCallCheck(this, PagingDots);

    return _possibleConstructorReturn(this, (PagingDots.__proto__ || Object.getPrototypeOf(PagingDots)).apply(this, arguments));
  }

  _createClass(PagingDots, [{
    key: "getIndexes",
    value: function getIndexes(count, inc) {
      var arr = [];

      for (var i = 0; i < count; i += inc) {
        arr.push(i);
      }

      return arr;
    }
  }, {
    key: "getListStyles",
    value: function getListStyles() {
      return {
        position: 'relative',
        margin: 0,
        top: -10,
        padding: 0
      };
    }
  }, {
    key: "getListItemStyles",
    value: function getListItemStyles() {
      return {
        listStyleType: 'none',
        display: 'inline-block'
      };
    }
  }, {
    key: "getButtonStyles",
    value: function getButtonStyles(active) {
      return {
        border: 0,
        background: 'transparent',
        color: 'black',
        cursor: 'pointer',
        padding: 10,
        fontSize: 24,
        opacity: active ? 1 : 0.5
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var indexes = this.getIndexes(this.props.slideCount, this.props.slidesToScroll);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        style: this.getListStyles()
      }, indexes.map(function (index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          style: _this3.getListItemStyles(),
          key: index
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          style: _this3.getButtonStyles(_this3.props.currentSlide === index),
          onClick: _this3.props.goToSlide.bind(null, index),
          "aria-label": "slide ".concat(index + 1, " bullet")
        }, "\u2022"));
      }));
    }
  }]);

  return PagingDots;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitions_scroll_transition__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions_fade_transition__ = __webpack_require__(1653);


/* harmony default export */ __webpack_exports__["a"] = ({
  fade: __WEBPACK_IMPORTED_MODULE_1__transitions_fade_transition__["a" /* default */],
  scroll: __WEBPACK_IMPORTED_MODULE_0__transitions_scroll_transition__["a" /* default */]
});

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }




var ScrollTransition =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScrollTransition, _React$Component);

  function ScrollTransition(props) {
    var _this;

    _classCallCheck(this, ScrollTransition);

    _this = _possibleConstructorReturn(this, (ScrollTransition.__proto__ || Object.getPrototypeOf(ScrollTransition)).call(this, props));
    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ScrollTransition, [{
    key: "getSlideDirection",
    value: function getSlideDirection(start, end, isWrapping) {
      var direction = 0;
      if (start === end) return direction;

      if (isWrapping) {
        direction = start < end ? -1 : 1;
      } else {
        direction = start < end ? 1 : -1;
      }

      return direction;
    }
    /* eslint-disable complexity */

  }, {
    key: "getSlideTargetPosition",
    value: function getSlideTargetPosition(index, positionValue) {
      var targetPosition = (this.props.slideWidth + this.props.cellSpacing) * index;
      var startSlide = Math.min(Math.abs(Math.floor(positionValue / this.props.slideWidth)), this.props.slideCount - 1);
      var offset = 0;

      if (this.props.animation === 'zoom' && (this.props.currentSlide === index + 1 || this.props.currentSlide === 0 && index === this.props.children.length - 1)) {
        offset = this.props.slideOffset;
      } else if (this.props.animation === 'zoom' && (this.props.currentSlide === index - 1 || this.props.currentSlide === this.props.children.length - 1 && index === 0)) {
        offset = -this.props.slideOffset;
      }

      if (this.props.wrapAround && index !== startSlide) {
        var direction = this.getSlideDirection(startSlide, this.props.currentSlide, this.props.isWrappingAround);
        var slidesBefore = Math.floor((this.props.slideCount - 1) / 2);
        var slidesAfter = this.props.slideCount - slidesBefore - 1;

        if (direction < 0) {
          var temp = slidesBefore;
          slidesBefore = slidesAfter;
          slidesAfter = temp;
        }

        var distanceFromStart = Math.abs(startSlide - index);

        if (index < startSlide) {
          if (distanceFromStart > slidesBefore) {
            targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount + index);
          }
        } else if (distanceFromStart > slidesAfter) {
          targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount - index) * -1;
        }
      }

      return targetPosition + offset;
    }
    /* eslint-enable complexity */

  }, {
    key: "formatChildren",
    value: function formatChildren(children) {
      var _this2 = this;

      var _props = this.props,
          top = _props.top,
          left = _props.left,
          currentSlide = _props.currentSlide,
          slidesToShow = _props.slidesToShow;
      var positionValue = this.props.vertical ? top : left;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
        var visible = index >= currentSlide && index < currentSlide + slidesToShow;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          className: "slider-slide".concat(visible ? ' slide-visible' : ''),
          style: _this2.getSlideStyles(index, positionValue),
          key: index
        }, child);
      });
    }
  }, {
    key: "getSlideStyles",
    value: function getSlideStyles(index, positionValue) {
      var targetPosition = this.getSlideTargetPosition(index, positionValue);
      return {
        boxSizing: 'border-box',
        display: this.props.vertical ? 'block' : 'inline-block',
        height: 'auto',
        left: this.props.vertical ? 0 : targetPosition,
        listStyleType: 'none',
        marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
        marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
        marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
        marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
        MozBoxSizing: 'border-box',
        position: 'absolute',
        top: this.props.vertical ? targetPosition : 0,
        transform: this.props.animation === 'zoom' && this.props.currentSlide !== index ? 'scale(0.85)' //TODO make this configurable via prop
        : 'scale(1.0)',
        transition: 'transform .4s linear',
        verticalAlign: 'top',
        width: this.props.vertical ? '100%' : this.props.slideWidth
      };
    }
  }, {
    key: "getListStyles",
    value: function getListStyles(styles) {
      var deltaX = styles.deltaX,
          deltaY = styles.deltaY;
      var listWidth = this.props.slideWidth * __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children);
      var spacingOffset = this.props.cellSpacing * __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children);
      var transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0)");
      return {
        transform: transform,
        WebkitTransform: transform,
        msTransform: "translate(".concat(deltaX, "px, ").concat(deltaY, "px)"),
        position: 'relative',
        display: 'block',
        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
        padding: 0,
        height: this.props.vertical ? listWidth + spacingOffset : this.props.slideHeight,
        width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
        boxSizing: 'border-box',
        MozBoxSizing: 'border-box',
        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y')
      };
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.formatChildren(this.props.children);
      var deltaX = this.props.deltaX;
      var deltaY = this.props.deltaY;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "slider-list",
        style: this.getListStyles({
          deltaX: deltaX,
          deltaY: deltaY
        })
      }, children);
    }
  }]);

  return ScrollTransition;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);


ScrollTransition.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['zoom']),
  cellSpacing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  currentSlide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  deltaX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  deltaY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  dragging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isWrappingAround: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  wrapAround: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ScrollTransition.defaultProps = {
  cellSpacing: 0,
  currentSlide: 0,
  deltaX: 0,
  deltaY: 0,
  dragging: false,
  isWrappingAround: false,
  left: 0,
  slideCount: 0,
  slideHeight: 0,
  slideWidth: 0,
  top: 0,
  vertical: false,
  wrapAround: false
};

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FadeTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FadeTransition =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FadeTransition, _React$Component);

  function FadeTransition(props) {
    var _this;

    _classCallCheck(this, FadeTransition);

    _this = _possibleConstructorReturn(this, (FadeTransition.__proto__ || Object.getPrototypeOf(FadeTransition)).call(this, props));
    _this.fadeFromSlide = props.currentSlide;
    return _this;
  }

  _createClass(FadeTransition, [{
    key: "formatChildren",
    value: function formatChildren(children, opacity) {
      var _this2 = this;

      var _props = this.props,
          currentSlide = _props.currentSlide,
          slidesToShow = _props.slidesToShow;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
        var visible = index >= currentSlide && index < currentSlide + slidesToShow;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          className: "slider-slide".concat(visible ? ' slide-visible' : ''),
          style: _this2.getSlideStyles(index, opacity),
          key: index
        }, child);
      });
    }
  }, {
    key: "getSlideOpacityAndLeftMap",
    value: function getSlideOpacityAndLeftMap(fadeFrom, fadeTo, fade) {
      // Figure out which position to fade to
      var fadeToPosition = fadeTo;

      if (fadeFrom > fade && fadeFrom === 0) {
        fadeToPosition = fadeFrom - this.props.slidesToShow;
      } else if (fadeFrom < fade && fadeFrom + this.props.slidesToShow > this.props.slideCount - 1) {
        fadeToPosition = fadeFrom + this.props.slidesToShow;
      } // Calculate opacity for active slides


      var opacity = {};

      if (fadeFrom === fadeTo) {
        opacity[fadeFrom] = 1;
      } else {
        var distance = fadeFrom - fadeToPosition;
        opacity[fadeFrom] = (fade - fadeToPosition) / distance;
        opacity[fadeTo] = (fadeFrom - fade) / distance;
      } // Calculate left for slides and merge in opacity


      var map = {};

      for (var i = 0; i < this.props.slidesToShow; i++) {
        map[fadeFrom + i] = {
          opacity: opacity[fadeFrom],
          left: this.props.slideWidth * i
        };
        map[fadeTo + i] = {
          opacity: opacity[fadeTo],
          left: this.props.slideWidth * i
        };
      }

      return map;
    }
  }, {
    key: "getSlideStyles",
    value: function getSlideStyles(index, data) {
      return {
        boxSizing: 'border-box',
        display: 'block',
        height: 'auto',
        left: data[index] ? data[index].left : 0,
        listStyleType: 'none',
        marginBottom: 'auto',
        marginLeft: this.props.cellSpacing / 2,
        marginRight: this.props.cellSpacing / 2,
        marginTop: 'auto',
        MozBoxSizing: 'border-box',
        opacity: data[index] ? data[index].opacity : 0,
        position: 'absolute',
        top: 0,
        verticalAlign: 'top',
        visibility: data[index] ? 'inherit' : 'hidden',
        width: this.props.slideWidth
      };
    }
  }, {
    key: "getContainerStyles",
    value: function getContainerStyles() {
      var width = this.props.slideWidth * this.props.slidesToShow;
      return {
        boxSizing: 'border-box',
        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
        display: 'block',
        height: this.props.slideHeight,
        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
        MozBoxSizing: 'border-box',
        padding: 0,
        touchAction: 'none',
        width: width
      };
    }
  }, {
    key: "render",
    value: function render() {
      var fade = -(this.props.deltaX || this.props.deltaY) / this.props.slideWidth;

      if (parseInt(fade) === fade) {
        this.fadeFromSlide = fade;
      }

      var opacityAndLeftMap = this.getSlideOpacityAndLeftMap(this.fadeFromSlide, this.props.currentSlide, fade);
      var children = this.formatChildren(this.props.children, opacityAndLeftMap);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "slider-list",
        style: this.getContainerStyles()
      }, children);
    }
  }]);

  return FadeTransition;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);


FadeTransition.propTypes = {
  cellSpacing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  currentSlide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  deltaX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  deltaY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  dragging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isWrappingAround: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slidesToShow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  wrapAround: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
FadeTransition.defaultProps = {
  cellSpacing: 0,
  currentSlide: 0,
  deltaX: 0,
  deltaY: 0,
  dragging: false,
  isWrappingAround: false,
  left: 0,
  slideCount: 0,
  slideHeight: 0,
  slidesToShow: 1,
  slideWidth: 0,
  top: 0,
  vertical: false,
  wrapAround: false
};

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultRenderAnnounceSlideMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var AnnounceSlide = function AnnounceSlide(_ref) {
  var message = _ref.message;
  var styles = {
    position: 'absolute',
    left: '-10000px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden'
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "aria-live": "polite",
    "aria-atomic": "true",
    style: styles,
    tabIndex: -1
  }, message);
};

var defaultRenderAnnounceSlideMessage = function defaultRenderAnnounceSlideMessage(_ref2) {
  var currentSlide = _ref2.currentSlide,
      slideCount = _ref2.slideCount;
  return "Slide ".concat(currentSlide + 1, " of ").concat(slideCount);
};
/* harmony default export */ __webpack_exports__["a"] = (AnnounceSlide);

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeEvent; });
/* unused harmony export addAccessibility */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPropsByTransitionMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return swipeDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calcSomeInitialState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var addEvent = function addEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }

  if (elem.addEventListener) {
    elem.addEventListener(type, eventHandle, false);
  } else if (elem.attachEvent) {
    elem.attachEvent("on".concat(type), eventHandle);
  } else {
    elem["on".concat(type)] = eventHandle;
  }
};
var removeEvent = function removeEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }

  if (elem.removeEventListener) {
    elem.removeEventListener(type, eventHandle, false);
  } else if (elem.detachEvent) {
    elem.detachEvent("on".concat(type), eventHandle);
  } else {
    elem["on".concat(type)] = null;
  }
};
var addAccessibility = function addAccessibility(children, slidesToShow, currentSlide) {
  var needsTabIndex;

  if (slidesToShow > 1) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
      var firstVisibleSlide = index >= currentSlide;
      var lastVisibleSlide = index < slidesToShow + currentSlide;
      needsTabIndex = firstVisibleSlide && lastVisibleSlide;
      var ariaProps = needsTabIndex ? {
        'aria-hidden': 'false',
        tabIndex: 0
      } : {
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _objectSpread({}, child.props, ariaProps));
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
      needsTabIndex = index !== currentSlide;
      var ariaProps = needsTabIndex ? {
        'aria-hidden': 'true'
      } : {
        'aria-hidden': 'false',
        tabIndex: 0
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _objectSpread({}, child.props, ariaProps));
    });
  }
};
var getPropsByTransitionMode = function getPropsByTransitionMode(props, keys) {
  var slidesToShow = props.slidesToShow,
      transitionMode = props.transitionMode;
  var updatedDefaults = {};

  if (transitionMode === 'fade') {
    keys.forEach(function (key) {
      switch (key) {
        case 'slidesToShow':
          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
          break;

        case 'slidesToScroll':
          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
          break;

        case 'cellAlign':
          updatedDefaults[key] = 'left';
          break;

        default:
          updatedDefaults[key] = props[key];
          break;
      }
    });
  } else {
    keys.forEach(function (key) {
      updatedDefaults[key] = props[key];
    });
  }

  return updatedDefaults;
};
var swipeDirection = function swipeDirection(x1, x2, y1, y2, vertical) {
  var xDist = x1 - x2;
  var yDist = y1 - y2;
  var r = Math.atan2(yDist, xDist);
  var swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0) {
    return 1;
  }

  if (swipeAngle <= 360 && swipeAngle >= 315) {
    return 1;
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return -1;
  }

  if (vertical === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return 1;
    } else {
      return -1;
    }
  }

  return 0;
};
var shouldUpdate = function shouldUpdate(curr, next, keys) {
  var update = false;

  for (var i = 0; i < keys.length; i++) {
    if (curr[keys[i]] !== next[keys[i]]) {
      update = true;
      break;
    }
  }

  return update;
};
var calcSomeInitialState = function calcSomeInitialState(props) {
  var _getPropsByTransition = getPropsByTransitionMode(props, ['slidesToScroll', 'slidesToShow', 'cellAlign']),
      slidesToScroll = _getPropsByTransition.slidesToScroll,
      slidesToShow = _getPropsByTransition.slidesToShow,
      cellAlign = _getPropsByTransition.cellAlign;

  var slideWidth = props.vertical ? props.initialSlideHeight || 0 : props.initialSlideWidth || 0;
  var slideHeight = props.vertical ? (props.initialSlideHeight || 0) * props.slidesToShow : props.initialSlideHeight || 0;
  var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
  var frameWidth = props.vertical ? frameHeight : '100%';
  return {
    slideWidth: slideWidth,
    slideHeight: slideHeight,
    frameWidth: frameWidth,
    slidesToScroll: slidesToScroll,
    slidesToShow: slidesToShow,
    cellAlign: cellAlign
  };
};

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getImgTagStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDecoratorStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSliderStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFrameStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTransitionProps; });
var getImgTagStyles = function getImgTagStyles() {
  return ".slider-slide > img { width: 100%; display: block; }\n          .slider-slide > img:focus { margin: auto; }";
};
var getDecoratorStyles = function getDecoratorStyles(position) {
  switch (position) {
    case 'TopLeft':
      {
        return {
          position: 'absolute',
          top: 0,
          left: 0
        };
      }

    case 'TopCenter':
      {
        return {
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          WebkitTransform: 'translateX(-50%)',
          msTransform: 'translateX(-50%)'
        };
      }

    case 'TopRight':
      {
        return {
          position: 'absolute',
          top: 0,
          right: 0
        };
      }

    case 'CenterLeft':
      {
        return {
          position: 'absolute',
          top: '50%',
          left: 0,
          transform: 'translateY(-50%)',
          WebkitTransform: 'translateY(-50%)',
          msTransform: 'translateY(-50%)'
        };
      }

    case 'CenterCenter':
      {
        return {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          WebkitTransform: 'translate(-50%, -50%)',
          msTransform: 'translate(-50%, -50%)'
        };
      }

    case 'CenterRight':
      {
        return {
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translateY(-50%)',
          WebkitTransform: 'translateY(-50%)',
          msTransform: 'translateY(-50%)'
        };
      }

    case 'BottomLeft':
      {
        return {
          position: 'absolute',
          bottom: 0,
          left: 0
        };
      }

    case 'BottomCenter':
      {
        return {
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          WebkitTransform: 'translateX(-50%)',
          msTransform: 'translateX(-50%)'
        };
      }

    case 'BottomRight':
      {
        return {
          position: 'absolute',
          bottom: 0,
          right: 0
        };
      }

    default:
      {
        return {
          position: 'absolute',
          top: 0,
          left: 0
        };
      }
  }
};
var getSliderStyles = function getSliderStyles(propWidth, stateSlideWidth) {
  return {
    boxSizing: 'border-box',
    display: 'block',
    height: 'auto',
    MozBoxSizing: 'border-box',
    position: 'relative',
    visibility: stateSlideWidth ? 'inherit' : 'hidden',
    width: propWidth
  };
};
var getFrameStyles = function getFrameStyles(propFrameOverFlow, propVertical, propFramePadding, stateFrameWidth) {
  return {
    boxSizing: 'border-box',
    display: 'block',
    height: propVertical ? stateFrameWidth || 'initial' : '100%',
    margin: propFramePadding,
    MozBoxSizing: 'border-box',
    msTransform: 'translate(0, 0)',
    overflow: propFrameOverFlow,
    padding: 0,
    position: 'relative',
    touchAction: "pinch-zoom ".concat(propVertical ? 'pan-x' : 'pan-y'),
    transform: 'translate3d(0, 0, 0)',
    WebkitTransform: 'translate3d(0, 0, 0)'
  };
};
var getTransitionProps = function getTransitionProps(props, state) {
  return {
    animation: props.animation,
    cellSpacing: props.cellSpacing,
    currentSlide: state.currentSlide,
    dragging: props.dragging,
    isWrappingAround: state.isWrappingAround,
    left: state.left,
    slideCount: state.slideCount,
    slideHeight: state.slideHeight,
    slideOffset: props.slideOffset,
    slidesToShow: state.slidesToShow,
    slideWidth: state.slideWidth,
    top: state.top,
    vertical: props.vertical,
    wrapAround: props.wrapAround
  };
};

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAccessibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getValidChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSlideHeight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var addAccessibility = function addAccessibility(children, slidesToShow, currentSlide) {
  var needsTabIndex;

  if (slidesToShow > 1) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
      // create a range from first visible slide to last visible slide
      var firstVisibleSlide = index >= currentSlide;
      var lastVisibleSlide = index < slidesToShow + currentSlide;
      needsTabIndex = firstVisibleSlide && lastVisibleSlide; // if the index of the slide is in range add ariaProps to the slide

      var ariaProps = needsTabIndex ? {
        'aria-hidden': 'false',
        tabIndex: 0
      } : {
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _objectSpread({}, child.props, ariaProps));
    });
  } else {
    // when slidesToshow is 1
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
      needsTabIndex = index !== currentSlide;
      var ariaProps = needsTabIndex ? {
        'aria-hidden': 'true'
      } : {
        'aria-hidden': 'false',
        tabIndex: 0
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _objectSpread({}, child.props, ariaProps));
    });
  }
};
var getValidChildren = function getValidChildren(children) {
  // .toArray automatically removes invalid React children
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children);
};

var findMaxHeightSlide = function findMaxHeightSlide(slides) {
  var maxHeight = 0;

  for (var i = 0; i < slides.length; i++) {
    if (slides[i].offsetHeight > maxHeight) {
      maxHeight = slides[i].offsetHeight;
    }
  }

  return maxHeight;
};

var getSlideHeight = function getSlideHeight(props, state) {
  var childNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var heightMode = props.heightMode,
      vertical = props.vertical,
      initialSlideHeight = props.initialSlideHeight;
  var slidesToShow = state.slidesToShow,
      currentSlide = state.currentSlide;
  var firstSlide = childNodes[0];

  if (firstSlide && heightMode === 'first') {
    return vertical ? firstSlide.offsetHeight * slidesToShow : firstSlide.offsetHeight;
  }

  if (heightMode === 'max') {
    return findMaxHeightSlide(childNodes);
  }

  if (heightMode === 'current') {
    return childNodes[currentSlide].offsetHeight;
  }

  return initialSlideHeight || 100;
};

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_AtomicComponents_Typography_Typography_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\service\\carousel-item.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var VehicleServiceCarouselItem = function (_Component) {
  _inherits(VehicleServiceCarouselItem, _Component);

  function VehicleServiceCarouselItem(props) {
    _classCallCheck(this, VehicleServiceCarouselItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.setService = function (code) {
      _this.props.updateServiceDetails({
        activeServiceCodeIndex: _this.activeServiceCodeIndex(code),
        selectedAdditionalServices: {}
      }, _this.props.vin);
    };

    _this.activeServiceCodeIndex = function (factoryCode) {
      if (_this.props.serviceOptions) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default()(_this.props.serviceOptions.serviceItems, { factoryCode: factoryCode });
      }
      return 0;
    };

    _this.state = {
      mounted: false
    };
    return _this;
  }

  VehicleServiceCarouselItem.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      mounted: true
    });
  };

  VehicleServiceCarouselItem.prototype.render = function render() {
    var _this2 = this,
        _classnames,
        _classnames2;

    var _props = this.props,
        item = _props.item,
        index = _props.index,
        currentIndex = _props.currentIndex,
        serviceDetailpageUrl = _props.serviceDetailpageUrl,
        requestServicePageUrl = _props.requestServicePageUrl,
        requestComplementaryServicePageUrl = _props.requestComplementaryServicePageUrl,
        complementaryServiceImage = _props.complementaryServiceImage,
        scheduledServiceImage = _props.scheduledServiceImage,
        gtmEvent = _props.gtmEvent,
        _props$primaryButtonT = _props.primaryButtonText,
        primaryButtonText = _props$primaryButtonT === undefined ? "Request service" : _props$primaryButtonT,
        _props$secondaryButto = _props.secondaryButtonText,
        secondaryButtonText = _props$secondaryButto === undefined ? "WHAT'S INCLUDED?" : _props$secondaryButto,
        gtmOnCarouselButtonClick = _props.gtmOnCarouselButtonClick;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        key: item.factoryCode,
        style: [styles.tile, this.state.mounted ? styles.in(index * 0.1) : styles.out], __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.base(currentIndex === index), __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.coverImg, __source: {
              fileName: _jsxFileName,
              lineNumber: 71
            }
          },
          item.isComplementaryService ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.complementaryServiceImage, __source: {
                fileName: _jsxFileName,
                lineNumber: 73
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "figure",
              { style: styles.figure(complementaryServiceImage), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 74
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
                src: complementaryServiceImage,
                alt: item.serviceDescription,
                style: { width: "100%", height: "100%", opacity: 0 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 75
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: styles.heading(item.isComplementaryService), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 80
                }
              },
              item.serviceDescription
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.scheduledServiceImage, __source: {
                fileName: _jsxFileName,
                lineNumber: 83
              }
            },
            scheduledServiceImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: scheduledServiceImage, alt: item.serviceDescription, __source: {
                fileName: _jsxFileName,
                lineNumber: 85
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: styles.heading(item.isComplementaryService), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 87
                }
              },
              item.serviceDescription
            )
          ),
          item.isCompleted && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["_13" /* TickModalIcon */], {
            style: {
              width: "2.25em",
              height: "2.25em",
              position: "relative",
              transform: "translateY(-50%)"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 91
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.details, __source: {
              fileName: _jsxFileName,
              lineNumber: 100
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_AtomicComponents__["_1" /* P */],
            { withoutMargin: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 101
              }
            },
            "ESTIMATED PRICE"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 102
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_AtomicComponents__["_1" /* P */],
            {
              withoutMargin: true,
              "data-test": "price",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 103
              }
            },
            item.customerTotal || item.price
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 109
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              onClick: function onClick() {
                _this2.setService(item.factoryCode);
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 110
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],
              {
                to: item.isComplementaryService ? requestComplementaryServicePageUrl : requestServicePageUrl,
                className: "Button " + __WEBPACK_IMPORTED_MODULE_13_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less___default.a.Button] = true, _classnames[__WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less___default.a.ButtonFullWidth] = true, _classnames[__WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less___default.a.ButtonRed] = true, _classnames)), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 114
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                {
                  onClick: function onClick() {
                    Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_gtmHandler__["a" /* default */])({
                      pageCategory: "MyMazda - Servicing",
                      pageAction: "Carousel - clicked \"" + (item.isComplementaryService ? "REQUEST INSPECTION" : primaryButtonText.toUpperCase()) + "\""
                    });
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 125
                  }
                },
                item.isComplementaryService ? "Request inspection" : primaryButtonText
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.hr, __source: {
                fileName: _jsxFileName,
                lineNumber: 135
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],
              {
                to: item.isComplementaryService ? requestComplementaryServicePageUrl : serviceDetailpageUrl,
                className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_15_AtomicComponents_Typography_Typography_less___default.a.withoutStyle] = true, _classnames2)),
                key: "survey", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 136
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_AtomicComponents__["U" /* Interactive */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 146
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  {
                    onClick: function onClick() {
                      return Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_gtmHandler__["a" /* default */])({
                        pageCategory: "MyMazda - Servicing",
                        pageAction: "Carousel - clicked \"" + secondaryButtonText.toUpperCase() + "\""
                      });
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 147
                    }
                  },
                  secondaryButtonText
                )
              )
            )
          )
        )
      )
    );
  };

  return VehicleServiceCarouselItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

VehicleServiceCarouselItem.displayName = "VehicleServiceCarouselItem";


VehicleServiceCarouselItem.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  currentIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  serviceDetailpageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  requestServicePageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  requestComplementaryServicePageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  complementaryServiceImage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  scheduledServiceImage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  serviceOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  updateServiceDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  primaryButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  secondaryButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmOnCarouselButtonClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var styles = {
  base: function base(opacity) {
    return {
      position: "relative",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      backgroundColor: "white",
      boxSizing: "border-box",
      border: "1px solid " + __WEBPACK_IMPORTED_MODULE_8_constants_color_palette__["a" /* default */].GRAY,
      minHeight: "200px",
      width: "100%",
      flexDirection: "column",
      height: "100%",
      textDecoration: "none",
      color: "#101010",
      transition: "opacity 0.5s",
      opacity: opacity ? "1" : "0.3"
    };
  },
  coverImg: {
    left: "0px",
    top: "0px",
    bottom: "0px",
    boxSizing: "border-box",
    position: "relative",
    width: "100%",
    height: "200px",
    backgroundColor: __WEBPACK_IMPORTED_MODULE_8_constants_color_palette__["a" /* default */].GRAY_LIGHT
  },
  figure: function figure(bg) {
    return {
      backgroundImage: "url(" + bg + ")",
      backgroundPosition: "center center",
      backgroundSize: "cover",
      width: "100%",
      height: "100%",
      margin: 0,
      padding: 0
    };
  },
  heading: function heading(isComplementaryService) {
    return _extends({}, __WEBPACK_IMPORTED_MODULE_9_constants_general_style__["b" /* BASE_HEADING */], {
      color: isComplementaryService ? "#fff" : "#101010",
      fontSize: "16px",
      left: isComplementaryService ? "50%" : "auto",
      padding: isComplementaryService ? "" : "20px 5% 0",
      position: isComplementaryService ? "absolute" : "relative",
      textAlign: "center",
      top: isComplementaryService ? "50%" : "auto",
      transform: isComplementaryService ? "translateX(-50%) translateY(-50%)" : "none",
      width: "90%"
    });
  },
  details: {
    padding: "1.5em 1.5em 1.25em",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    marginLeft: "0px",
    width: "100%"
  },
  readMore: {
    fontSize: "81%",
    color: "#aaaaaa",
    transition: ".5s",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    fontWeight: "600",
    letterSpacing: ".2em",
    textTransform: "uppercase",
    width: "100%",
    ":hover": { color: "black" }
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid rgb(229, 229, 229)",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1.25em",
    paddingBottom: "1.5em"
  },
  scheduledServiceImage: {
    padding: "1em",
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  complementaryServiceImage: {
    height: "100%",
    position: "relative",
    width: "100%"
  },
  tile: {
    display: "flex",
    maxWidth: "280px",
    width: "280px",
    flex: "1 0 auto"
  },
  in: function _in(delay) {
    return {
      transitionDuration: "1s",
      transitionDelay: delay + "s",
      willChange: "transform"
    };
  },
  out: {
    opacity: 0,
    transform: "translateY(-3em)",
    willChange: "transform"
  }
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    service: __WEBPACK_IMPORTED_MODULE_6_store_actions_mymazda__["f" /* selectors */].getService(props.vin)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_6_store_actions_mymazda__["a" /* actionCreators */], dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps))(VehicleServiceCarouselItem));

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1660);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(1661);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(172),
    isSymbol = __webpack_require__(177);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\service\\export.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var VehicleServiceExport = function (_Component) {
  _inherits(VehicleServiceExport, _Component);

  function VehicleServiceExport() {
    _classCallCheck(this, VehicleServiceExport);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  VehicleServiceExport.columns = function columns(date, distance, price, dealer, details) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { display: "flex", justifyContent: "space-between" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 11
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: [styles.cell, { fontWeight: "600", letterSpacing: ".2em" }], __source: {
            fileName: _jsxFileName,
            lineNumber: 12
          }
        },
        date
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.cell, __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        },
        distance
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.cell, __source: {
            fileName: _jsxFileName,
            lineNumber: 14
          }
        },
        price
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.cell, __source: {
            fileName: _jsxFileName,
            lineNumber: 15
          }
        },
        dealer
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.cell, __source: {
            fileName: _jsxFileName,
            lineNumber: 16
          }
        },
        details
      )
    );
  };

  VehicleServiceExport.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        headerImage = _props.headerImage,
        vin = _props.vin,
        rego = _props.rego,
        namePlate = _props.namePlate,
        grade = _props.grade,
        bodyStyle = _props.bodyStyle,
        serviceHistoryData = _props.serviceHistoryData;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { padding: "5em 5vw", minWidth: "842px" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 27
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            padding: "1em 0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid " + __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { marginRight: "1em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 36
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: headerImage, alt: "Mazda", style: { height: "44px", width: "auto" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 37
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { display: "flex", flexFlow: "wrap", justifyContent: "flex-end" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 39
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: [styles.menuText, { borderLeft: "0" }], __source: {
                fileName: _jsxFileName,
                lineNumber: 40
              }
            },
            namePlate,
            " ",
            grade,
            " ",
            bodyStyle
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: styles.menuText, __source: {
                fileName: _jsxFileName,
                lineNumber: 43
              }
            },
            "VIN: ",
            vin
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: styles.menuText, __source: {
                fileName: _jsxFileName,
                lineNumber: 44
              }
            },
            "Registration: ",
            rego
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: styles.menuText, __source: {
                fileName: _jsxFileName,
                lineNumber: 45
              }
            },
            serviceHistoryData.length,
            " service reports generated"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: styles.menuText, __source: {
                fileName: _jsxFileName,
                lineNumber: 48
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                onClick: function onClick() {
                  return window.print();
                },
                style: {
                  color: __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY_DARK,
                  cursor: "pointer",
                  fontWeight: "600",
                  textDecoration: "none"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 49
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["X" /* PrintIcon */], {
                style: {
                  marginRight: "0.5em",
                  width: "18px",
                  height: "16px",
                  verticalAlign: "text-bottom"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 57
                }
              }),
              "Print"
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { padding: "2em 0" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 69
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.label, __source: {
              fileName: _jsxFileName,
              lineNumber: 70
            }
          },
          this.constructor.columns("DATE", "ODOMETER (KM)", "PRICE", "SERVICE LOCATION", "SERVICE DESCRIPTION")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 80
            }
          },
          serviceHistoryData.map(function (service, i) {
            var details = service.completedServiceItems.map(function (item, j) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                { key: j, style: { marginTop: "0" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 84
                  }
                },
                item.serviceDescription
              );
            });

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                key: i,
                style: {
                  borderTop: "1px solid " + __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY,
                  fontWeight: "200",
                  padding: "1em 0"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 91
                }
              },
              _this2.constructor.columns(service.serviceDates, service.distance, service.formattedPrice, service.dealerName, details)
            );
          })
        )
      )
    );
  };

  return VehicleServiceExport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

VehicleServiceExport.displayName = "VehicleServiceExport";


var styles = {
  label: {
    color: __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY_DARK,
    textTransform: "uppercase",
    fontSize: "81%",
    margin: "0 0 1em",
    display: "block",
    fontWeight: "600",
    letterSpacing: ".2em"
  },
  menuText: {
    fontSize: "14px",
    fontWeight: "200",
    margin: "0.25em 0 0.25em 1em",
    paddingLeft: "1em",
    borderLeft: "1px solid " + __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY
  },
  cell: {
    flex: "1 0",
    paddingRight: "0.5em"
  }
};

VehicleServiceExport.propTypes = {
  headerImage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rego: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  namePlate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  grade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  serviceHistoryData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_5_higher_order_components__["i" /* gtmEvent */])())(VehicleServiceExport));

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\service\\history.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var VehicleServiceHistory = function (_Component) {
  _inherits(VehicleServiceHistory, _Component);

  function VehicleServiceHistory() {
    _classCallCheck(this, VehicleServiceHistory);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  VehicleServiceHistory.prototype.columns = function columns(date, distance, price, dealer, slug) {
    var _props = this.props,
        compact = _props.compact,
        printAllLink = _props.printAllLink,
        gtmOnHistoryButtonClick = _props.gtmOnHistoryButtonClick,
        gtmEvent = _props.gtmEvent;

    var viewButtonText = "View";
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { display: "flex", justifyContent: "space-between" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            fontWeight: "600",
            flex: "1 0",
            letterSpacing: ".2em",
            fontSize: "14px"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 15
          }
        },
        date
      ),
      !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { flex: "1 0" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        },
        distance
      ),
      !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { flex: "1 0" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          }
        },
        price
      ),
      !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { flex: "1 0" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        },
        dealer
      ),
      !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { flex: "0 0 1" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components__["H" /* Hyperlink */],
          {
            gtmEvents: [{ func: gtmEvent, args: [gtmOnHistoryButtonClick({ buttonText: viewButtonText })] }],
            href: printAllLink + "&slug=" + slug,
            external: true,
            style: [styles.link, { color: slug ? __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY_DARK : "transparent" }], __source: {
              fileName: _jsxFileName,
              lineNumber: 29
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["u" /* ExternalLinkIcon */], {
            style: {
              height: "11px",
              width: "14px",
              fill: slug ? __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].BLACK : "transparent",
              marginRight: "0.5em"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 34
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 41
              }
            },
            viewButtonText
          )
        )
      )
    );
  };

  VehicleServiceHistory.prototype.accordionTitle = function accordionTitle(service) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["I" /* IdWrapper */],
      { key: service.slug, slug: service.slug, __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            color: __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].BLACK,
            borderRight: service.completedServiceItems.length ? "1px solid " + __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY : "0",
            fontWeight: "200",
            padding: "1.2em 2em 1.2em 0",
            marginRight: "1em"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 52
          }
        },
        this.columns(service.serviceDates, service.distance, service.formattedPrice, service.dealerName, service.slug)
      )
    );
  };

  VehicleServiceHistory.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        compact = _props2.compact,
        emptyHistoryText = _props2.emptyHistoryText,
        serviceHistoryData = _props2.serviceHistoryData,
        printAllLink = _props2.printAllLink,
        gtmOnHistoryButtonClick = _props2.gtmOnHistoryButtonClick,
        gtmEvent = _props2.gtmEvent;


    var printButtonText = "Print view";

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { padding: "5em 0 0" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 82
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { padding: "0 4em 1em 0", marginRight: "1em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 83
          }
        },
        !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.label, __source: {
              fileName: _jsxFileName,
              lineNumber: 85
            }
          },
          this.columns("DATE", "ODOMETER (KM)", "PRICE", "SERVICE LOCATION", null)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { borderBottom: "1px solid " + __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY }, __source: {
            fileName: _jsxFileName,
            lineNumber: 90
          }
        },
        serviceHistoryData ? serviceHistoryData.map(function (service, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["b" /* AccordionText */],
            {
              key: index,
              title: _this2.accordionTitle(service),
              styles: { padding: "1.5em 2em 1.5em 0" },
              name: service.slug,
              barBorder: "top",
              disabled: !service.completedServiceItems.length,
              ignorePropsComponents: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 93
              }
            },
            service.completedServiceItems && service.completedServiceItems.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { padding: "2em 0" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 102
                }
              },
              compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 104
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { style: { fontWeight: "200", marginBottom: "1em" }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 105
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: styles.label, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 106
                      }
                    },
                    "ODOMETER (KM)"
                  ),
                  service.distance
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { style: { fontWeight: "200", marginBottom: "1em" }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 109
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: styles.label, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 110
                      }
                    },
                    "PRICE"
                  ),
                  service.formattedPrice
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { style: { fontWeight: "200", marginBottom: "1em" }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 113
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: styles.label, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 114
                      }
                    },
                    "SERVICE LOCATION"
                  ),
                  service.dealerName
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                { style: styles.label, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 119
                  }
                },
                "SERVICE DESCRIPTION"
              ),
              service.completedServiceItems.map(function (item, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "p",
                  { key: i, style: { fontWeight: "200" }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 122
                    }
                  },
                  item.serviceDescription
                );
              })
            ) : null
          );
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          {
            style: {
              borderTop: "1px solid " + __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY,
              padding: "2em 0",
              margin: "0",
              textAlign: "center"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 132
            }
          },
          emptyHistoryText || "We'll automatically keep your service records here when you complete a Mazda Genuine Service."
        )
      ),
      serviceHistoryData && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { padding: "3em 0 0", textAlign: "center" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 145
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components__["e" /* Button */],
          {
            styleName: "blackOutlined",
            type: "a",
            gtmEvents: [{ func: gtmEvent, args: [gtmOnHistoryButtonClick({ buttonText: printButtonText })] }],
            href: printAllLink,
            display: "inline",
            alignment: "center",
            external: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 146
            }
          },
          printButtonText
        )
      )
    );
  };

  return VehicleServiceHistory;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

VehicleServiceHistory.displayName = "VehicleServiceHistory";


var styles = {
  label: {
    color: __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY_DARK,
    textTransform: "uppercase",
    fontSize: "81%",
    margin: "0 0 1em",
    display: "block",
    fontWeight: "600",
    letterSpacing: ".2em"
  },
  link: {
    fontSize: "13px",
    fontWeight: "200",
    textDecoration: "none",
    letterSpacing: "initial",
    textTransform: "none"
  }
};

VehicleServiceHistory.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  emptyHistoryText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  serviceHistoryData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  printAllLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmOnHistoryButtonClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["i" /* gtmEvent */])())(VehicleServiceHistory));

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_layout__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__details__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\service\\summary.jsx",
    _mainCTAButtons,
    _regoInput,
    _changeVinRegoDesktop,
    _changeVinRegoMobile;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var scheduledOnly = function scheduledOnly(s) {
  return s.factoryCodeEntity.type === "Scheduled Maintenance" && s.factoryCodeEntity.distance > 0;
};

var VehicleServiceSummary = function (_Component) {
  _inherits(VehicleServiceSummary, _Component);

  function VehicleServiceSummary(props) {
    _classCallCheck(this, VehicleServiceSummary);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    if (__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(props.service)) {
      _this.props.updateServiceDetails({
        activeServiceCodeIndex: 0,
        selectedAdditionalServices: {}
      }, _this.props.vin);
    }

    _this.activeFactoryCode = function () {
      var _this$props = _this.props,
          service = _this$props.service,
          serviceItems = _this$props.serviceItems,
          factoryCode = _this$props.factoryCode;

      var activeServiceCodeIndex = service && service.activeServiceCodeIndex !== -1 ? service.activeServiceCodeIndex : 0;

      return service ? serviceItems.serviceItems[activeServiceCodeIndex].factoryCode : factoryCode || null;
    };

    _this.activeServiceCodeIndex = function (factoryCode) {
      return _this.props.serviceItems.serviceItems.filter(scheduledOnly).findIndex(function (item) {
        return item.factoryCode === factoryCode;
      });
    };

    _this.setService = function (s) {
      var service = _this.props.service;


      if (service && service.activeServiceCodeIndex === _this.activeServiceCodeIndex(s)) {
        return;
      }

      _this.props.updateServiceDetails({
        activeServiceCodeIndex: _this.activeServiceCodeIndex(s),
        selectedAdditionalServices: {}
      }, _this.props.vin);
    };
    return _this;
  }

  VehicleServiceSummary.prototype.renderServiceSelect = function renderServiceSelect() {
    var _this2 = this;

    var _props = this.props,
        serviceItems = _props.serviceItems,
        service = _props.service;

    var options = serviceItems.serviceItems.filter(scheduledOnly).map(function (s, index) {
      return {
        name: s.factoryCodeEntity.description,
        code: s.factoryCodeEntity.code,
        label: s.factoryCodeEntity.description,
        value: s.factoryCodeEntity.code,
        index: index
      };
    });
    var activeServiceIndex = options.findIndex(function (s) {
      return s.code === _this2.activeFactoryCode();
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_AtomicComponents__["R" /* InputSelect */], {
      label: "Please Select",
      defaultValue: options[activeServiceIndex],
      options: options,
      onChange: this.setService, __source: {
        fileName: _jsxFileName,
        lineNumber: 73
      }
    });
  };

  VehicleServiceSummary.prototype.isSPG = function isSPG() {
    var serviceItems = this.props.serviceItems;

    try {
      // trying to guess MSS vs SPG service type
      // MSS factoryCode starts with 'S' and SPG starts with 'M' (yes, it's counterintuitive)
      return serviceItems && serviceItems.serviceItems.some(function (si) {
        return si.factoryCode[0] === "M";
      });
    } catch (e) {
      return false;
    }
  };

  VehicleServiceSummary.prototype.render = function render() {
    var _classnames;

    var _props2 = this.props,
        title = _props2.title,
        termsAndConditions = _props2.termsAndConditions,
        serviceItems = _props2.serviceItems,
        expandDetails = _props2.expandDetails,
        nameplate = _props2.nameplate,
        grade = _props2.grade,
        rego = _props2.rego,
        vin = _props2.vin,
        gtmEvent = _props2.gtmEvent,
        gtmOnClickContinue = _props2.gtmOnClickContinue,
        serviceBookingUrl = _props2.serviceBookingUrl;


    var continueButtonText = "Continue";

    var errorMessage = this.state.errorMessage;

    var renderSelect = serviceItems && serviceItems.serviceItems && serviceItems.serviceItems.length > 0 && !errorMessage;
    var showDetails = serviceItems && !errorMessage && this.activeFactoryCode();
    var mssDisclaimer = serviceItems && !this.isSPG() ? "The total service price is the Base Scheduled Maintenance, plus any Additional Scheduled Maintenance items that are due." : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { position: "relative", width: "100%" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 122
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_AtomicComponents__["z" /* H2 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 123
          }
        },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124
        }
      }),
      serviceItems && serviceItems.vehicle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_AtomicComponents__["U" /* Interactive */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 128
          }
        },
        serviceItems.vehicle.modelGroup || nameplate,
        " ",
        serviceItems.vehicle.grade || grade,
        " ",
        "| ",
        serviceItems.vehicle.rego || rego
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 134
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_AtomicComponents__["x" /* FormGroup */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 135
          }
        },
        renderSelect && this.renderServiceSelect()
      ),
      errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { "data-test": "error-message", style: styles.error, __source: {
            fileName: _jsxFileName,
            lineNumber: 139
          }
        },
        errorMessage
      ),
      showDetails && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 144
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { padding: "1em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 145
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__details__["a" /* default */], {
            data: serviceItems,
            factoryCode: this.activeFactoryCode(),
            selectAdditionalItems: true,
            expandDetails: expandDetails,
            vin: vin, __source: {
              fileName: _jsxFileName,
              lineNumber: 146
            }
          }),
          mssDisclaimer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            { style: [styles.textLeft], __source: {
                fileName: _jsxFileName,
                lineNumber: 152
              }
            },
            mssDisclaimer
          ),
          termsAndConditions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { textAlign: "left" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 154
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_AtomicComponents__["l" /* Caption */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 155
                }
              },
              "*Additional maintenance may be required based on how you use your vehicle and may incur additional cost.",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 157
                }
              }),
              "This can be discussed with your service dealer."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 159
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_containers__["k" /* ExpandableInfo */], {
              color: "rgb(170, 170, 170)",
              mainText: "Read full terms and conditions",
              description: termsAndConditions,
              textAlign: "left",
              styleName: "black", __source: {
                fileName: _jsxFileName,
                lineNumber: 160
              }
            })
          )
        ),
        expandDetails && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            onClick: function onClick() {
              Object(__WEBPACK_IMPORTED_MODULE_11_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: "MyMazda Servicing",
                pageAction: "Calculator - Clicked  \"" + continueButtonText.toUpperCase() + "\""
              });
            },
            style: styles.mainCTAButtons, __source: {
              fileName: _jsxFileName,
              lineNumber: 170
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],
            {
              to: serviceBookingUrl,
              className: "Button " + __WEBPACK_IMPORTED_MODULE_12_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less___default.a.Button] = true, _classnames[__WEBPACK_IMPORTED_MODULE_14_AtomicComponents_Button_Button_less___default.a.ButtonRed] = true, _classnames)), __source: {
                fileName: _jsxFileName,
                lineNumber: 178
              }
            },
            continueButtonText
          )
        )
      )
    );
  };

  return VehicleServiceSummary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

VehicleServiceSummary.displayName = "VehicleServiceSummary";


var breakpoint1 = "@media (min-width: " + __WEBPACK_IMPORTED_MODULE_5_constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */] + "px)";

var styles = {
  textLeft: {
    textAlign: "left",
    fontWeight: 200,
    padding: ".6em 1em 1em 0",
    lineHeight: "23px"
  },
  error: {
    textAlign: "center",
    fontWeight: 200,
    color: "#910A2D",
    padding: "1em",
    margin: "1em auto",
    lineHeight: 1.8
  },
  mainCTAButtons: (_mainCTAButtons = {
    boxSizing: "border-box",
    display: "flex",
    backgroundColor: "white",
    justifyContent: "left",
    padding: "0.5em",
    flexDirection: "column"
  }, _mainCTAButtons[breakpoint1] = {
    flexDirection: "row"
  }, _mainCTAButtons),
  regoInput: (_regoInput = {
    width: "100%",
    margin: "auto",
    display: "flex",
    flexDirection: "column"
  }, _regoInput[breakpoint1] = {
    flexDirection: "row",
    maxWidth: "30em",
    alignItems: "center"
  }, _regoInput),
  popup: {
    position: "fixed",
    left: "0px",
    right: "0px",
    bottom: "0px",
    top: "0px",
    padding: "2em",
    backgroundColor: "#e5e6e9",
    zIndex: "100"
  },
  changeVinRego: {
    fontWeight: 600,
    letterSpacing: 1.8,
    color: "#aaaaaa",
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: "81%",
    textTransform: "uppercase",
    padding: "1em 1em 3em"
  },
  changeVinRegoDesktop: (_changeVinRegoDesktop = {}, _changeVinRegoDesktop[breakpoint1] = {
    display: "block"
  }, _changeVinRegoDesktop.display = "none", _changeVinRegoDesktop),
  changeVinRegoMobile: (_changeVinRegoMobile = {}, _changeVinRegoMobile[breakpoint1] = {
    display: "none"
  }, _changeVinRegoMobile.display = "block", _changeVinRegoMobile)
};

VehicleServiceSummary.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  serviceItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  termsAndConditions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  serviceBookingUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  expandDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  factoryCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  service: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  nameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  grade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rego: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  updateServiceDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmOnClickContinue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    service: __WEBPACK_IMPORTED_MODULE_9_store_actions_mymazda__["f" /* selectors */].getService(props.vin)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_9_store_actions_mymazda__["a" /* actionCreators */], dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["i" /* gtmEvent */])())(VehicleServiceSummary));

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__panel__ = __webpack_require__(1668);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\service\\details.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var VehicleServiceDetails = function (_Component) {
  _inherits(VehicleServiceDetails, _Component);

  function VehicleServiceDetails(props) {
    _classCallCheck(this, VehicleServiceDetails);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.services = props.data.serviceItems.sort(function (s1, s2) {
      return s1.factoryCodeEntity.distance - s2.factoryCodeEntity.distance;
    }).slice(0, props.scheduledServiceItemsLimit > 0 ? props.scheduledServiceItemsLimit : 1e10).map(function (s) {
      var m = /([^\s]+) Service or (.+)/.exec(s.factoryCodeEntity.description);
      return {
        name: m ? m[1] + " Service | $" + s.basePrice : s.factoryCodeEntity.description,
        extraLabel: m ? "or " + m[2] : "",
        price: "$" + s.basePrice,
        basePrice: s.basePrice,
        shortName: m ? m[1] + " Service" : s.factoryCodeEntity.description,
        code: s.factoryCodeEntity.code,
        item: s
      };
    });

    _this.additionalServices = _this.props.data.serviceItems.filter(function (s) {
      return s.factoryCodeEntity.type.match(/^Additional/);
    }).map(function (s) {
      return {
        name: s.factoryCodeEntity.description,
        description: s.operationActions.length > 0 ? s.operationActions[0].operations[0].description : "",
        price: "$" + s.basePrice,
        basePrice: s.basePrice,
        code: s.factoryCodeEntity.code
      };
    });

    _this.toggleService = function (code) {
      var newSelectedAdditionalServices = _extends({}, _this.props.service.selectedAdditionalServices);
      newSelectedAdditionalServices[code] = !newSelectedAdditionalServices[code];
      _this.syncAdditionalServicesState(newSelectedAdditionalServices);
    };

    _this.syncAdditionalServicesState = function (newSelectedAdditionalItems) {
      var _this$props = _this.props,
          service = _this$props.service,
          updateServiceDetails = _this$props.updateServiceDetails;


      if (__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(newSelectedAdditionalItems)) {
        newSelectedAdditionalItems = service.selectedAdditionalServices;
      } else {
        updateServiceDetails({
          activeServiceCodeIndex: service.activeServiceCodeIndex,
          selectedAdditionalServices: newSelectedAdditionalItems
        }, _this.props.vin);
      }
    };

    _this.findNonZeroDistance = function () {
      var distance = 0;

      _this.props.data && _this.props.data.serviceItems.forEach(function (item) {
        if (item.factoryCodeEntity.distance > 0 && distance === 0) {
          distance = item.factoryCodeEntity.distance;
        }
      });

      return distance;
    };
    return _this;
  }

  VehicleServiceDetails.prototype.calculateTotal = function calculateTotal() {
    var service = this.props.service;


    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(service) || __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(service)) return "0";

    var activeService = this.services[service.activeServiceCodeIndex];
    var totalPrice = this.additionalServices.filter(function (s) {
      return service.selectedAdditionalServices[s.code];
    }).reduce(function (price, s) {
      return price + s.basePrice;
    }, activeService.basePrice);

    return "" + totalPrice.toFixed(0);
  };

  VehicleServiceDetails.prototype.getActiveService = function getActiveService() {
    return this.services[this.props.service.activeServiceCodeIndex];
  };

  VehicleServiceDetails.prototype.isSPG = function isSPG() {
    try {
      // trying to guess MSS vs SPG service type
      // MSS factoryCode starts with 'S' and SPG starts with 'M' (yes, it's counterintuitive)
      return this.props.data && this.props.data.serviceItems.some(function (si) {
        return si.factoryCode[0] === "M";
      });
    } catch (e) {
      return false;
    }
  };

  VehicleServiceDetails.prototype.renderAdditionalDetails = function renderAdditionalDetails() {
    var _this2 = this;

    var _props = this.props,
        selectable = _props.selectAdditionalItems,
        compact = _props.compact,
        service = _props.service,
        expandDetails = _props.expandDetails;

    var additionalItemsHeading = this.isSPG() ? "Optional Service Maintenance items" : "ADDITIONAL SCHEDULED MAINTENANCE";

    var totalPrice = service && service && this.additionalServices.filter(function (s) {
      return service.selectedAdditionalServices[s.code];
    }).reduce(function (price, s) {
      return price + s.basePrice;
    }, 0);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.additionalServicesContainer, __source: {
          fileName: _jsxFileName,
          lineNumber: 126
        }
      },
      this.additionalServices && !!this.additionalServices.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 129
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              borderBottom: compact && "1px solid #aaa",
              marginBottom: compact && "1em"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 130
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_AtomicContainers__["b" /* AccordionText */],
            {
              title: this.accordionTitle(additionalItemsHeading, "plus", totalPrice),
              styles: { padding: compact ? "1.5em 3em 1.5em 0" : "1.5em 4em 1.5em 0" },
              name: "base",
              styleName: "simple",
              barBorder: "top",
              iconStyles: { right: compact ? "0.5em" : "1em" },
              ignorePropsComponents: true,
              open: expandDetails, __source: {
                fileName: _jsxFileName,
                lineNumber: 135
              }
            },
            selectable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { paddingLeft: !compact && "3em" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 145
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { paddingTop: "1em" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 146
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "p",
                  { style: { fontWeight: 200, textAlign: "left" }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 147
                    }
                  },
                  "Explore the items to better understand our service pricing. Items must be attended to when they are due but selections are not mandatory for booking a service."
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_containers__["W" /* ServiceListSelect */], {
                services: this.additionalServices,
                selectedServices: service && service.selectedAdditionalServices,
                onServiceClick: function onServiceClick(code) {
                  return _this2.toggleService(code);
                },
                compact: compact, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 151
                }
              })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_containers__["V" /* ServiceListInspect */], { services: this.additionalServices, compact: compact, __source: {
                fileName: _jsxFileName,
                lineNumber: 158
              }
            })
          )
        )
      ),
      selectable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { width: "100%" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 165
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.totalServicePrice(compact), __source: {
              fileName: _jsxFileName,
              lineNumber: 166
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 167
              }
            },
            !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["f" /* CalculatorIcon */], { style: styles.icon, __source: {
                fileName: _jsxFileName,
                lineNumber: 168
              }
            }),
            "Total service price"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { marginLeft: "2em" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 171
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: styles.symbols(compact), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 172
                }
              },
              "$"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: styles.totalServicePriceValue(compact), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 173
                }
              },
              this.calculateTotal()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: styles.symbols(compact), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 174
                }
              },
              "*"
            )
          )
        )
      )
    );
  };

  VehicleServiceDetails.prototype.accordionTitle = function accordionTitle(title, icon, price) {
    var compact = this.props.compact;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.accordionTitle, __source: {
          fileName: _jsxFileName,
          lineNumber: 187
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: { lineHeight: "20px", color: __WEBPACK_IMPORTED_MODULE_10_constants_color_palette__["a" /* default */].BLACK }, __source: {
            fileName: _jsxFileName,
            lineNumber: 188
          }
        },
        !compact ? icon === "servicing" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["_4" /* ServicingIcon */], { style: styles.icon, __source: {
            fileName: _jsxFileName,
            lineNumber: 191
          }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["W" /* PlusIcon */], { style: styles.icon, __source: {
            fileName: _jsxFileName,
            lineNumber: 193
          }
        }) : null,
        title
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: { textAlign: "center", minWidth: "60px", color: __WEBPACK_IMPORTED_MODULE_10_constants_color_palette__["a" /* default */].BLACK }, __source: {
            fileName: _jsxFileName,
            lineNumber: 198
          }
        },
        price ? "$" + price : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { style: styles.none, __source: {
              fileName: _jsxFileName,
              lineNumber: 199
            }
          },
          "None selected"
        )
      )
    );
  };

  VehicleServiceDetails.prototype.render = function render() {
    var _this3 = this;

    var activeService = this.getActiveService();
    if (!activeService) return null;

    var _props2 = this.props,
        data = _props2.data,
        factoryCode = _props2.factoryCode,
        expandDetails = _props2.expandDetails,
        compact = _props2.compact;

    var spg = this.isSPG();
    var baseScheduleHeading = spg ? "Scheduled Maintenance" : "Base Scheduled Maintenance";
    var km = this.findNonZeroDistance().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var baseScheduleDescription = spg ? "Regular servicing is the key to maintaining your investment, which is why it\u2019s important you return every " + km + " kms. To ensure your car receives the best and most appropriate service schedule, you should consult your Mazda Dealer." : "Base scheduled maintenance is due every " + km + " km, but no longer than 12 months, whichever comes first.";

    var baseItem = __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(data.serviceItems, { factoryCode: factoryCode });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.base, __source: {
          fileName: _jsxFileName,
          lineNumber: 224
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_AtomicContainers__["b" /* AccordionText */],
        {
          styleName: "simple",
          title: this.accordionTitle(baseScheduleHeading, "servicing", baseItem && baseItem.basePrice),
          styles: { padding: compact ? "1.5em 3em 1.5em 0" : "1.5em 4em 1.5em 0" },
          name: "base",
          barBorder: "top",
          iconStyles: { right: compact ? "0.5em" : "1em" },
          ignorePropsComponents: true,
          open: expandDetails, __source: {
            fileName: _jsxFileName,
            lineNumber: 225
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { paddingLeft: !compact && "3em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 238
            }
          },
          factoryCode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                paddingTop: "1em",
                borderBottom: "1px solid rgb(203, 203, 203)",
                width: "100%"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 240
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              { style: { letterSpacing: ".2em", fontWeight: "600" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 246
                }
              },
              activeService.shortName,
              " ",
              activeService.extraLabel
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              { style: { fontWeight: 200 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 249
                }
              },
              baseScheduleDescription
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__panel__["a" /* default */], {
            services: this.services,
            activeService: activeService,
            factoryCode: this.props.factoryCode,
            activeServiceCodeIndex: this.state.activeServiceCodeIndex,
            compact: this.props.compact,
            onServiceSelect: function onServiceSelect(index) {
              _this3.setState({ activeServiceCodeIndex: index });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 252
            }
          })
        )
      ),
      this.renderAdditionalDetails()
    );
  };

  return VehicleServiceDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

VehicleServiceDetails.displayName = "VehicleServiceDetails";


VehicleServiceDetails.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  factoryCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectAdditionalItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scheduledServiceItemsLimit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  expandDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  service: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  updateServiceDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

VehicleServiceDetails.defaultProps = {
  data: {},
  factoryCode: "",
  serviceDetailsURL: "",
  selectAdditionalItems: false,
  compact: true
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    service: __WEBPACK_IMPORTED_MODULE_11_store_actions_mymazda__["f" /* selectors */].getService(props.vin)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_11_store_actions_mymazda__["a" /* actionCreators */], dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps))(VehicleServiceDetails));

var styles = {
  base: {
    width: "100%"
  },

  mainServiceHeader: {
    textAlign: "left",
    lineHeight: 1.2,
    width: "100%"
  },

  icon: {
    verticalAlign: "bottom",
    marginRight: "1.75em",
    width: "1.25em",
    height: "1.25em",
    fill: __WEBPACK_IMPORTED_MODULE_10_constants_color_palette__["a" /* default */].GRAY_DARK
  },

  introOwner: function introOwner(compact) {
    return {
      display: "flex",
      flexDirection: compact ? "column" : "row",
      alignItems: "baseline",
      padding: "0.4em 0 1em",
      justifyContent: "space-between"
    };
  },

  accordionTitle: {
    letterSpacing: ".2em",
    fontWeight: "600",
    padding: "1em 0",
    borderTop: "1px solid " + __WEBPACK_IMPORTED_MODULE_10_constants_color_palette__["a" /* default */].GRAY_LIGHT,
    textAlign: "left",
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },

  none: {
    fontSize: "12px",
    fontWeight: "200",
    letterSpacing: "initial",
    textTransform: "none",
    display: "block",
    marginTop: "-3px",
    width: "5em",
    textAlign: "center",
    lineHeight: "11px",
    color: __WEBPACK_IMPORTED_MODULE_10_constants_color_palette__["a" /* default */].GRAY_DARK
  },

  additionalServicesContainer: {
    boxSizing: "border-box",
    width: "100%",
    display: "block",
    padding: 0
  },

  totalServicePrice: function totalServicePrice(compact) {
    return {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      textTransform: "uppercase",
      fontWeight: 600,
      borderTop: !compact && "1px solid #d5d5d5",
      letterSpacing: "0.2em",
      padding: "1.5em 0 1.5em 0",
      alignItems: "center"
    };
  },

  totalServicePriceValue: function totalServicePriceValue(compact) {
    return {
      paddingBottom: "0.2em",
      fontSize: compact ? "140%" : "160%",
      fontWeight: compact && "600",
      letterSpacing: "2px"
    };
  },

  symbols: function symbols(compact) {
    return {
      verticalAlign: "top",
      paddingTop: ".1em",
      letterSpacing: compact && "0",
      fontWeight: compact && "600",
      fontSize: compact && "140%"
    };
  }
};

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1667),
    findIndex = __webpack_require__(644);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(168),
    isArrayLike = __webpack_require__(176),
    keys = __webpack_require__(175);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\service\\panel.jsx";




var ServiceMainPanel = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var activeService = props.activeService,
      services = props.services,
      compact = props.compact;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.wrapper, __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          width: "100%",
          maxWidth: "70em",
          margin: "auto",
          boxSizing: "border-box",
          padding: "1em 0"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { position: "relative", transition: "height 1s ease-in-out" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 18
          }
        },
        services.map(function (s) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              key: s.code,
              style: {
                columnCount: compact ? 1 : 3,
                MozColumnCount: compact ? 1 : 3,
                margin: "auto",
                paddingTop: compact ? "2em" : "3em",
                paddingBottom: compact ? "2em" : "3em",
                display: s.item.factoryCodeEntity.code === activeService.code ? "block" : "none"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 21
              }
            },
            s.item.operationActions.map(function (category) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { display: "block", paddingBottom: "1.5em" }, key: category.name, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 32
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  { style: styles.scheduledMaintenanceItem, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 33
                    }
                  },
                  category.name
                ),
                category.operations.map(function (o) {
                  return o.name === "M-MDS M-MDS" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { key: o.subOpCode, style: styles.scheduledMaintenanceItem, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 37
                      }
                    },
                    o.name
                  );
                })
              );
            })
          );
        })
      )
    )
  );
});

var styles = {
  wrapper: {
    width: "100%"
  },

  basicsLastLine: {
    width: "100%",
    textTransform: "uppercase",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },

  scheduledMaintenanceItem: {
    display: "block",
    padding: "0.3em",
    fontSize: "16px",
    marginTop: "0",
    marginBottom: "5px"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ServiceMainPanel);

ServiceMainPanel.propTypes = {
  services: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  activeService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  fullDetailsURL: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  factoryCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeServiceCodeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onServiceSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\vehicle-specs\\index.jsx";







var Desc = function Desc(_ref) {
  var name = _ref.name,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        padding: "1em",
        textAlign: "left",
        boxSizing: "border-box"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["U" /* Interactive */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      },
      name
    ),
    value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_1" /* P */],
      { withoutMargin: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      value
    )
  );
};

Desc.displayName = "Desc";
Desc.displayName = "Desc";
Desc.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var VehicleSpecifications = function VehicleSpecifications(_ref2) {
  var specifications = _ref2.specifications,
      exterior = _ref2.exterior,
      grade = _ref2.grade,
      interior = _ref2.interior,
      bodyStyle = _ref2.bodyStyle,
      driveTransmission = _ref2.driveTransmission,
      engine = _ref2.engine,
      compact = _ref2.compact;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.details(compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 36
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            flexBasis: "33%",
            flexGrow: 1,
            flexShrink: 1
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 37
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Grade", value: grade, __source: {
            fileName: _jsxFileName,
            lineNumber: 43
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Engine", value: engine, __source: {
            fileName: _jsxFileName,
            lineNumber: 44
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            flexBasis: "33%",
            flexGrow: 1,
            flexShrink: 1
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Body", value: bodyStyle, __source: {
            fileName: _jsxFileName,
            lineNumber: 52
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Exterior", value: exterior, __source: {
            fileName: _jsxFileName,
            lineNumber: 53
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            flexBasis: "33%",
            flexGrow: 1,
            flexShrink: 1
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 55
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Drive & transmission", value: driveTransmission, __source: {
            fileName: _jsxFileName,
            lineNumber: 61
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc, { name: "Interior", value: interior, __source: {
            fileName: _jsxFileName,
            lineNumber: 62
          }
        })
      )
    ),
    specifications && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["_2" /* SpecificationList */], { specs: specifications.data.categories, __source: {
        fileName: _jsxFileName,
        lineNumber: 65
      }
    })
  );
};

VehicleSpecifications.displayName = "VehicleSpecifications";
VehicleSpecifications.displayName = "VehicleSpecifications";
var styles = {
  details: function details(compact) {
    return {
      display: compact ? "block" : "flex",
      justifyContent: "space-around",
      fontSize: "95%",
      padding: "2em 0"
    };
  }
};

VehicleSpecifications.propTypes = {
  exterior: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  grade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  interior: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  bodyStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  driveTransmission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  specifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      categories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      disclaimers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
    })
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(VehicleSpecifications));

/**
 * @typedef {Object} BackHyperlink
 * @property {String} name - Displayed Name.
 * @property {String} href - Hyperlink href.
 */

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vehicle_tile__ = __webpack_require__(1671);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\vehicle-list\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var MyMazdaVehicleList = function MyMazdaVehicleList(_ref) {
  var vehicles = _ref.vehicles,
      dashboardButtonText = _ref.dashboardButtonText,
      nextServiceDisclaimer = _ref.nextServiceDisclaimer,
      _removeOnClick = _ref.removeOnClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.list, __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    },
    vehicles.map(function (_ref2, index) {
      var dashboardUrl = _ref2.dashboardUrl,
          disabled = _ref2.disabled,
          vehicle = _objectWithoutProperties(_ref2, ["dashboardUrl", "disabled"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: vehicle.vin, style: { margin: ".5em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 15
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__vehicle_tile__["a" /* default */], _extends({
          cta: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_AtomicComponents__["j" /* Button */],
            {
              disabled: disabled,
              styleName: "black",
              href: dashboardUrl,
              fullWidth: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 18
              }
            },
            dashboardButtonText
          ),
          nextServiceDisclaimer: nextServiceDisclaimer,
          removeOnClick: function removeOnClick() {
            return _removeOnClick(index);
          },
          index: index,
          disabled: disabled
        }, vehicle, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 16
          }
        }))
      );
    })
  );
};

MyMazdaVehicleList.displayName = "MyMazdaVehicleList";
MyMazdaVehicleList.displayName = "MyMazdaVehicleList";
MyMazdaVehicleList.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  vehicles: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_4__vehicle_tile__["a" /* default */].propTypes)).isRequired,
  dashboardButtonText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  nextServiceDisclaimer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  removeOnClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var styles = {
  list: {
    display: "flex",
    margin: "3em 0",
    justifyContent: "center",
    flexWrap: "wrap"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["f" /* Radium */])(MyMazdaVehicleList));

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__ = __webpack_require__(13);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\mymazda\\vehicle-list\\vehicle-tile.jsx";








var RemoveVehicleButton = function RemoveVehicleButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      disabled = _ref.disabled;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      onClick: !disabled ? onClick : function () {},
      style: [removeButtonStyles.wrapper, disabled ? { opacity: 0.5 } : removeButtonStyles.interactive], __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: removeButtonStyles.icon, __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Z" /* RemoveCircleIcon */], { style: { display: "block", height: "20px", width: "20px" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 19
        }
      },
      children
    )
  );
};

RemoveVehicleButton.displayName = "RemoveVehicleButton";
RemoveVehicleButton.displayName = "RemoveVehicleButton";
RemoveVehicleButton.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

RemoveVehicleButton = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(RemoveVehicleButton);

// Taken from src/containers/outlet-store/stock-tile.jsx:68
var conditionalTitle = function conditionalTitle(nameplate, bodyStyle, grade, driveTransmission) {
  if (nameplate && nameplate.toLowerCase().includes("cx")) {
    return [grade, driveTransmission].filter(Boolean).join(" ");
  }
  if (bodyStyle && bodyStyle.toLowerCase().includes("rf")) {
    return grade;
  }
  return [bodyStyle, grade].filter(Boolean).join(" ");
};

var removeButtonStyles = {
  interactive: {
    transition: "color 0.25s",
    cursor: "pointer",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__["a" /* default */].GRAY_DARK
    }
  },
  wrapper: {
    color: __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__["a" /* default */].GRAY,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "87%"
  },
  icon: {
    paddingRight: "0.5em"
  }
};

var MyMazdaVehicleTile = function MyMazdaVehicleTile(_ref2) {
  var nameplate = _ref2.nameplate,
      grade = _ref2.grade,
      bodyStyle = _ref2.bodyStyle,
      imageUrl = _ref2.imageUrl,
      status = _ref2.status,
      driveTransmission = _ref2.driveTransmission,
      registrationNumber = _ref2.registrationNumber,
      nextServiceDateStr = _ref2.nextServiceDateStr,
      nextServiceDisclaimer = _ref2.nextServiceDisclaimer,
      removeOnClick = _ref2.removeOnClick,
      disabled = _ref2.disabled,
      cta = _ref2.cta;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.tile, __source: {
        fileName: _jsxFileName,
        lineNumber: 79
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.base, __source: {
          fileName: _jsxFileName,
          lineNumber: 80
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.coverImg, __source: {
            fileName: _jsxFileName,
            lineNumber: 81
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              padding: "1.5em 1.5em 0.5em",
              textAlign: "center",
              display: "flex",
              height: "100%",
              flexDirection: "column",
              justifyContent: "space-between",
              boxSizing: "border-box"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 82
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { width: "100%", position: "relative" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 92
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["C" /* H5 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 93
                }
              },
              nameplate
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
              { withoutMargin: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 94
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["U" /* Interactive */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 95
                  }
                },
                [conditionalTitle(nameplate, bodyStyle, grade, driveTransmission), registrationNumber].filter(Boolean).join(" | ")
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["o" /* Image */], { src: imageUrl + "?width=440", __source: {
              fileName: _jsxFileName,
              lineNumber: 103
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.details, __source: {
            fileName: _jsxFileName,
            lineNumber: 106
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { textAlign: "center" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 107
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["D" /* H6 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 108
              }
            },
            status ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 111
                }
              },
              "Vehicle status"
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 113
                }
              },
              "Next Service",
              nextServiceDisclaimer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicContainers__["i" /* Disclaimer */],
                { Icon: __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["J" /* InfoIcon */], __source: {
                    fileName: _jsxFileName,
                    lineNumber: 117
                  }
                },
                nextServiceDisclaimer
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_1" /* P */],
            { withoutMargin: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 125
              }
            },
            status || nextServiceDateStr
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 126
            }
          }),
          cta,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 128
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.hr, __source: {
              fileName: _jsxFileName,
              lineNumber: 129
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            RemoveVehicleButton,
            { disabled: disabled, onClick: removeOnClick, __source: {
                fileName: _jsxFileName,
                lineNumber: 130
              }
            },
            "Remove Vehicle"
          )
        )
      )
    )
  );
};

MyMazdaVehicleTile.displayName = "MyMazdaVehicleTile";
MyMazdaVehicleTile.displayName = "MyMazdaVehicleTile";
MyMazdaVehicleTile.propTypes = {
  nameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  grade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  registrationNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextServiceDateStr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextServiceDisclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  removeOnClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  cta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var styles = {
  base: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    boxSizing: "border-box",
    border: "1px solid " + __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__["a" /* default */].GRAY,
    minHeight: "230px",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    textDecoration: "none",
    color: "#101010",
    transition: "opacity 0.5s"
  },
  nameplateDetails: {
    margin: 0,
    fontWeight: 400,
    fontSize: "87%",
    lineHeight: "18px",
    color: __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__["a" /* default */].GRAY_DARK
  },
  coverImg: {
    left: "0px",
    top: "0px",
    bottom: "0px",
    overflow: "hidden",
    boxSizing: "border-box",
    position: "relative",
    width: "100%",
    height: "230px",
    backgroundColor: "#f5f5f5"
  },
  details: {
    padding: "1.5em 1.5em 1em",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    marginLeft: "0px",
    width: "100%"
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid rgb(229, 229, 229)",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1em",
    paddingBottom: "0.5em"
  },
  tile: {
    display: "flex",
    maxWidth: "270px",
    width: "270px",
    flex: "1 0 auto"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(MyMazdaVehicleTile));

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\animated-arrow\\index.jsx";




/**
 * Animated Arrow component.
 * @param {Number} [scale = 1] - Scale of the arrow
 * @param {String} [bgColor = '#f5f5f5'] - Arrow background colour
 * @param {String} [borderColor = '#e7e7e7'] - Arrow border colour
 * @param {Boolean} [down = false] - Direction in which the arrow points. Points up by default.
 * @param {Number} [leftPx] - Position from left in px
 * @param {Number} [leftPercent] - Position from left in percent
 * @returns {ReactElement} React Component
 */
var AnimatedArrow = function AnimatedArrow(_ref) {
  var _ref$scale = _ref.scale,
      scale = _ref$scale === undefined ? 1 : _ref$scale,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === undefined ? "#f5f5f5" : _ref$bgColor,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === undefined ? "#e7e7e7" : _ref$borderColor,
      _ref$down = _ref.down,
      down = _ref$down === undefined ? false : _ref$down,
      leftPx = _ref.leftPx,
      leftPercent = _ref.leftPercent;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: [{
        position: "relative",
        overflow: "hidden",
        boxSizing: "border-box",
        height: scale * Math.sqrt(2) / 2 + "em"
      }, down ? { top: "-1px" } : { bottom: "-1px" }], __source: {
        fileName: _jsxFileName,
        lineNumber: 23
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: [{
          position: "absolute",
          zIndex: 1,
          transition: ".5s",
          left: leftPx ? leftPx + "px" : leftPercent + "%"
        }, down ? { transform: "translate(-50%, -50%)", top: "-1px" } : { transform: "translate(-50%, 50%)", bottom: "-1px" }], __source: {
          fileName: _jsxFileName,
          lineNumber: 33
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          height: scale + "em",
          width: scale + "em",
          border: "1px solid " + borderColor,
          transform: "rotate(45deg)",
          background: bgColor
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 45
        }
      })
    )
  );
};

AnimatedArrow.displayName = "AnimatedArrow";
AnimatedArrow.displayName = "AnimatedArrow";
AnimatedArrow.propTypes = {
  leftPx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  leftPercent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  borderColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bgColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  down: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(AnimatedArrow));

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\animated-check-icon\\index.jsx";




/**
 * Calculate contrasting colour based on background colour
 * @param {String} backgroundColor - Hex colour value
 * @returns {String} Contrasting hex colour value
 */
var checkIconColor = function checkIconColor(backgroundColor) {
  var c = "#000";
  if (backgroundColor !== undefined) {
    c = backgroundColor.substring(1); // strip #
  }
  if (c.length < 6) {
    // convert 3-digit hex to 6-digit
    c = c.substr(0, 1) + c.substr(0, 1) + c.substr(1, 1) + c.substr(1, 1) + c.substr(2, 1) + c.substr(2, 1);
  }
  var rgb = parseInt(c, 16); // convert rrggbb to decimal
  var r = rgb >> 16 & 0xff; // extract red
  var g = rgb >> 8 & 0xff; // extract green
  var b = rgb >> 0 & 0xff; // extract blue
  var brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

  var iconColor = "#fff";
  if (brightness > 120) {
    iconColor = "#101010";
  }
  return iconColor;
};

/**
 * Animated Check Icon component
 * @param {object} props - Component props
 * @param {String} props.color - hex background color to calculate contrasting check colour.
 * @returns {ReactElement} React Component
 */
var AnimatedCheckIcon = function AnimatedCheckIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.base, "data-test": "check-icon", __source: {
        fileName: _jsxFileName,
        lineNumber: 45
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "svg",
      { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 11 11", style: { display: "block" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "title",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        "check"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon", {
        style: { fill: checkIconColor(props.color) },
        points: "9.57 0 4.67 8.01 1.32 4.08 0 5.14 4.84 11 11 0.9 9.57 0", __source: {
          fileName: _jsxFileName,
          lineNumber: 48
        }
      })
    )
  );
};

AnimatedCheckIcon.displayName = "AnimatedCheckIcon";
AnimatedCheckIcon.displayName = "AnimatedCheckIcon";
AnimatedCheckIcon.propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(AnimatedCheckIcon));

var fadeInKeyframes = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["b" /* keyframes */])({
  from: {
    opacity: 0,
    transform: "rotate(-45deg)"
  }
});

var styles = {
  base: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: ".7em",
    width: ".7em",
    pointerEvents: "none",
    animation: "x .25s",
    transformOrigin: "50% 50%",
    animationName: fadeInKeyframes
  }
};

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\animated-plus-minus\\index.jsx";




/** Renders an animated plus minus icon. */
var AnimatedPlusMinus = function AnimatedPlusMinus(_ref) {
  var open = _ref.open,
      _ref$styleOverride = _ref.styleOverride,
      styleOverride = _ref$styleOverride === undefined ? {} : _ref$styleOverride;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { key: "base", style: [styles.base], "data-test": open ? "open" : "closed", __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { key: "1", style: [styles.line, styles.firstLine(open), styleOverride], __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { key: "2", style: [styles.line, styles.secondLine(open), styleOverride], __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    })
  );
};

AnimatedPlusMinus.displayName = "AnimatedPlusMinus";
AnimatedPlusMinus.displayName = "AnimatedPlusMinus";
AnimatedPlusMinus.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  styleOverride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(AnimatedPlusMinus));

var styles = {
  base: {
    display: "inline-block",
    position: "relative",
    verticalAlign: "middle",
    flexShrink: 0,
    top: "-3px",
    width: "1em"
  },
  firstLine: function firstLine(active) {
    return {
      transform: active ? "rotate(180deg)" : "rotate(90deg)",
      background: active ? "#910A2D" : "currentColor"
    };
  },
  secondLine: function secondLine(active) {
    return {
      transform: active && "rotate(180deg)",
      background: active ? "#910A2D" : "currentColor"
    };
  },
  line: {
    transition: "transform .15s linear .15s, background .15s ease .25s",
    position: "absolute",
    top: "50%",
    transformOrigin: "center center",
    display: "inline",
    verticalAlign: "middle",
    height: "2px",
    width: "100%"
  }
};

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\arrow-icon\\index.jsx";



/**
 * @param {String} 'left'|'right' - Direction of arrow
 * @param {function} onClick - Click event handler
 */

var SvgArrowLeftIcon = function SvgArrowLeftIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    {
      style: styles.arrows,
      viewBox: "0 0 50 80", __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "title",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 13
        }
      },
      "Arrow left"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
      fill: "none",
      stroke: "#FFF",
      strokeWidth: "5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      points: "45.63,75.8 0.375,38.087 45.63,0.375 ", __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    })
  );
};

SvgArrowLeftIcon.displayName = "SvgArrowLeftIcon";
SvgArrowLeftIcon.displayName = "SvgArrowLeftIcon";
var SvgArrowRightIcon = function SvgArrowRightIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    {
      style: styles.arrows,
      viewBox: "0 0 50 80", __source: {
        fileName: _jsxFileName,
        lineNumber: 25
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "title",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        }
      },
      "Arrow left"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
      fill: "none",
      stroke: "#FFF",
      strokeWidth: "5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      points: "0.375,0.375 45.63,38.087 0.375,75.8", __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      }
    })
  );
};

SvgArrowRightIcon.displayName = "SvgArrowRightIcon";
SvgArrowRightIcon.displayName = "SvgArrowRightIcon";
var ArrowIcon = function ArrowIcon(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === undefined ? "left" : _ref$direction,
      _onClick = _ref.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: styles.arrowWrapper,
      onClick: function onClick() {
        _onClick();
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 41
      }
    },
    direction === "left" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SvgArrowLeftIcon, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46
      }
    }),
    direction === "right" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SvgArrowRightIcon, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47
      }
    })
  );
};

ArrowIcon.displayName = "ArrowIcon";
ArrowIcon.displayName = "ArrowIcon";
/* unused harmony default export */ var _unused_webpack_default_export = (ArrowIcon);

var styles = {
  arrowWrapper: {
    width: "1.4em",
    height: "1.4em",
    padding: "8px",
    position: "relative",
    cursor: "pointer"
  }
};

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__article_styles_global_css__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__article_styles_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__article_styles_global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicUtils_componentParser__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\article-page\\index.jsx";

var _templateObject = _taggedTemplateLiteralLoose(["\n    ", "\n  "], ["\n    ", "\n  "]);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }












if (undefined && undefined === "dingo") {
  Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["b" /* injectGlobal */])(_templateObject, __WEBPACK_IMPORTED_MODULE_7__article_styles_global_css___default.a);
} else {
  __webpack_require__(645);
}

var ZoomZoom = function ZoomZoom() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { height: "0.8em", viewBox: "0 0 170 13", style: { width: "100px" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 22
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "title",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23
        }
      },
      "Mazda Zoom-Zoom logo"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      fill: "currentColor",
      d: "M142.7 5.7c.7-.9 1.1-2.1 1.2-3.2 0-.7-.3-1.4-.9-1.8-.9-.5-1.8-.7-2.8-.6h-5.5c-.9 0-1.7.1-2.6.2-.7.1-1.3.3-1.9.7-.6.3-1.1.8-1.6 1.3-.6.7-1.1 1.4-1.6 2.1l-1.9 3.1c-.7.9-1 2.1-1.1 3.2 0 .7.3 1.4.9 1.8.9.5 1.8.7 2.8.6h5.5c.9 0 1.7-.1 2.5-.2.7-.1 1.3-.3 1.9-.7.6-.3 1.1-.8 1.6-1.3.6-.7 1.1-1.4 1.6-2.1l1.9-3.1zm-4.4 2.7c-.3.5-.6 1-1 1.5-.3.3-.6.6-1 .8-.4.2-.8.3-1.2.4-.5.1-1.1.1-1.6.1h-4.6c-.6 0-1.1-.1-1.6-.3-.4-.2-.6-.5-.6-.9.1-.8.4-1.6.9-2.3l2-3.1c.3-.5.6-1 1-1.4.6-.7 1.4-1.1 2.3-1.3.5-.1 1.1-.1 1.6-.1h4.5c.6 0 1.1.1 1.6.3.4.2.6.5.6.9-.1.8-.4 1.6-.9 2.3l-2 3.1zm-13.1-6c0-.7-.3-1.4-.9-1.8-.9-.5-1.8-.7-2.8-.6H116c-.9 0-1.7.1-2.6.2-.7.1-1.3.3-1.9.7-.6.4-1.1.8-1.5 1.4-.6.7-1.1 1.4-1.6 2.1l-1.9 3.1c-.7.9-1.1 2.1-1.2 3.2 0 .7.3 1.4.9 1.8.9.5 1.8.7 2.8.6h5.5c.9 0 1.7-.1 2.5-.2.7-.1 1.3-.3 1.9-.7.6-.3 1.1-.8 1.6-1.3.6-.7 1.1-1.4 1.6-2.1l1.9-3c.7-1 1.1-2.2 1.2-3.4zm-3.6 2.8l-2 3.1c-.3.5-.6 1-1 1.5-.3.3-.6.6-1 .8-.4.2-.8.3-1.2.4-.5.1-1.1.1-1.6.1h-4.6c-.6 0-1.1-.1-1.6-.3-.3-.2-.6-.5-.6-.9.1-.8.4-1.6.9-2.3l2-3.1c.3-.5.6-1 1-1.4.6-.7 1.4-1.1 2.3-1.3.5-.1 1.1-.1 1.6-.1h4.6c.6 0 1.1.1 1.6.3.4.2.6.5.6.9-.1 1-.4 1.7-1 2.3zM37.8 2.5c0-.7-.3-1.4-1-1.8C36 .2 35-.1 34.1 0h-5.5c-.9 0-1.7.1-2.6.2-.7.1-1.3.3-1.9.7-.6.3-1.1.8-1.5 1.3-.6.6-1.1 1.3-1.6 2.1l-1.9 3.1c-.7.9-1.1 2-1.1 3.2 0 .7.3 1.4.9 1.8.9.5 1.8.7 2.8.6h5.5c.9 0 1.7-.1 2.5-.2.7-.1 1.3-.3 1.9-.7.6-.3 1.1-.8 1.6-1.3.6-.7 1.1-1.4 1.5-2.1l1.9-3c.8-1 1.1-2.1 1.2-3.2zm-3.5 2.8l-2 3.1c-.3.5-.6 1-1 1.5-.3.3-.6.6-1 .8-.4.2-.8.3-1.2.4-.5.1-1.1.1-1.6.1h-4.7c-.6 0-1.1-.1-1.6-.3-.3-.2-.6-.5-.6-.9.1-.8.4-1.6.9-2.3l2-3.1c.3-.5.6-1 1-1.4.6-.7 1.4-1.1 2.3-1.3.5-.1 1.1-.1 1.6-.1H33c.6 0 1.1.1 1.6.3.4.1.6.5.6.9-.1.8-.4 1.6-.9 2.3zM21.1 1l.5-1H7.3l-1 1.8h10.1L.6 12 0 13h15l1-1.8H5.3L21.1 1zm148-.1c-.8-.5-1.8-.7-2.7-.7h-4c-.4 0-.9.1-1.3.2s-.8.2-1.1.4c-.4.2-.7.4-1 .7-.2-.4-.6-.8-1-1-.7-.3-1.5-.4-2.2-.3h-2.4c-.7 0-1.3 0-1.8.1-.5 0-.9.1-1.4.2l.2-.5h-2.2l-7.6 13h2.5l4-6.6c.6-.9 1.1-1.7 1.5-2.3.4-.5.8-1 1.3-1.4.4-.3.9-.5 1.4-.6.6-.1 1.2-.1 1.7-.1h1.7c.5 0 1 .1 1.5.3.3.2.5.6.5 1 0 .6-.3 1.2-.6 1.7l-4.8 8.1h2.5l3.9-6.6c.6-.9 1.1-1.7 1.5-2.3.4-.5.8-1 1.3-1.3.4-.3.9-.5 1.4-.6.6-.1 1.2-.1 1.8-.1h1.6c1.4 0 2.1.4 2.1 1.2 0 .6-.3 1.2-.6 1.6l-4.8 8h2.5l4.8-8c.4-.7.7-1.5.8-2.3-.1-.8-.4-1.5-1-1.8zm-60.6.1l.5-1H94.7l-1.1 1.8h10.1L87.9 12l-.6 1h15l1.1-1.8H92.7L108.5 1zM55.3 5.7c.7-.9 1.1-2.1 1.2-3.2 0-.7-.3-1.4-.9-1.8-.9-.5-1.8-.7-2.8-.6h-5.5c-.9 0-1.7.1-2.5.2-.7.1-1.3.3-1.9.7-.6.3-1.1.8-1.5 1.3-.6.7-1.1 1.4-1.6 2.1l-1.9 3.1c-.7.9-1.1 2.1-1.2 3.2 0 .7.3 1.4.9 1.8.9.5 1.8.7 2.8.6h5.5c.9 0 1.7-.1 2.5-.2.7-.1 1.3-.3 1.9-.7.6-.3 1.1-.8 1.5-1.3.6-.7 1.1-1.4 1.5-2.1l2-3.1zm-4.4 2.7c-.3.5-.6 1-1 1.5-.3.3-.6.6-1 .8-.4.2-.8.3-1.2.4-.5.1-1.1.1-1.6.1h-4.7c-.6 0-1.1-.1-1.6-.3-.3-.2-.6-.5-.6-.9.1-.8.4-1.6.9-2.3l2-3.1c.3-.5.6-1 1-1.4.6-.7 1.4-1.1 2.3-1.3.5-.1 1.1-.1 1.6-.1h4.6c.6 0 1.1.1 1.6.3.4.2.6.5.5.9-.1.8-.4 1.6-.9 2.3l-1.9 3.1zm40.7-2.9H84l-1.2 1.9h7.6l1.2-1.9zM81.7.8C80.9.3 80 .1 79 .2h-3.9c-.4 0-.9.1-1.3.2s-.8.2-1.1.4c-.4.2-.7.4-1 .7-.2-.4-.6-.8-1-1-.7-.3-1.5-.4-2.3-.3h-2.3c-.7 0-1.3 0-1.8.1-.5 0-.9.1-1.4.2l.3-.5H61l-7.6 13h2.5l4-6.6c.5-.9 1-1.7 1.5-2.3.4-.5.8-1 1.3-1.3.4-.3.9-.5 1.3-.6.5-.2 1.1-.2 1.7-.2h1.7c.5 0 1 .1 1.5.3.3.2.5.6.5 1 0 .6-.3 1.2-.6 1.7L64 13h2.5l3.9-6.6c.6-.9 1-1.7 1.5-2.3.4-.5.8-1 1.3-1.3.4-.3.9-.5 1.3-.6.6-.2 1.2-.2 1.8-.2h1.6c1.4 0 2.1.4 2.1 1.2 0 .6-.3 1.2-.6 1.7L74.6 13h2.5l4.8-8c.5-.7.7-1.5.8-2.4-.1-.7-.4-1.4-1-1.8z", __source: {
        fileName: _jsxFileName,
        lineNumber: 24
      }
    })
  );
};

ZoomZoom.displayName = "ZoomZoom";
ZoomZoom.displayName = "ZoomZoom";
var ArticleHeader = function ArticleHeader(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        fontSize: "12px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        color: "#9e9e9e",
        padding: "1em 2em",
        backgroundColor: "white",
        borderBottom: "solid 1px #eaeaea",
        fontWeight: 600
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 31
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flexGrow: 1,
          justifyContent: "flex-start"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 44
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ZoomZoom, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          display: "inline-block",
          borderLeft: "solid 1px #cccccc",
          width: "2px",
          height: "1.2em",
          margin: "0.3em 1em"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_AtomicComponents__["a" /* A */],
        {
          withoutStyle: true,
          style: {
            color: "#9e9e9e",
            textDecoration: "none",
            textTransform: "uppercase"
          },
          href: props.backUrl, __source: {
            fileName: _jsxFileName,
            lineNumber: 61
          }
        },
        "< Back to beyond the drive"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { color: "black", textTransform: "uppercase" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        }
      },
      "posted on ",
      props.publishDate
    )
  );
};

ArticleHeader.displayName = "ArticleHeader";
ArticleHeader.displayName = "ArticleHeader";
ArticleHeader.propTypes = {
  publishDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var ArticlePageContainer = function (_Component) {
  _inherits(ArticlePageContainer, _Component);

  function ArticlePageContainer() {
    _classCallCheck(this, ArticlePageContainer);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ArticlePageContainer.prototype.render = function render() {
    var _props = this.props,
        preHeading = _props.preHeading,
        heading = _props.heading,
        description = _props.description,
        content = _props.content,
        featureImage = _props.featureImage,
        featureImageCaption = _props.featureImageCaption,
        styleName = _props.styleName,
        publishDate = _props.publishDate,
        backUrl = _props.backUrl,
        backgroundColor = _props.backgroundColor,
        children = _props.children,
        components = _props.components,
        hero = _props.hero,
        disableDropCap = _props.disableDropCap;


    var date = new Date(publishDate);
    var dateString = date.getDate() + "/" + (1 + date.getMonth()) + "/" + (1900 + date.getYear());

    if (styleName === "news") {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { backgroundColor: backgroundColor }, __source: {
            fileName: _jsxFileName,
            lineNumber: 126
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleHeader, { publishDate: dateString, backUrl: backUrl, __source: {
            fileName: _jsxFileName,
            lineNumber: 128
          }
        }),
        Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_componentParser__["a" /* default */])(hero),
        featureImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { maxWidth: "80em", margin: "auto" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 132
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
            src: featureImage,
            alt: heading,
            style: {
              width: "100%",
              padding: "3em 3em 0",
              boxSizing: "border-box"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 133
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            { style: styles.caption, __source: {
                fileName: _jsxFileName,
                lineNumber: 141
              }
            },
            featureImageCaption
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.articleColumn, __source: {
              fileName: _jsxFileName,
              lineNumber: 144
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["s" /* HeadingBlock */], { value: heading, __source: {
              fileName: _jsxFileName,
              lineNumber: 145
            }
          }),
          description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_25" /* WysiwygContent */], {
            className: "beyond-drive__article-description",
            style: {
              color: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY_DARKER,
              paddingBottom: "1em",
              margin: "1em 0px",
              borderBottom: "1px solid #ccc"
            },
            xmlString: description, __source: {
              fileName: _jsxFileName,
              lineNumber: 147
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_25" /* WysiwygContent */], {
            className: disableDropCap ? "" : "beyond-drive__article-body",
            style: { padding: "1em 0" },
            xmlString: content, __source: {
              fileName: _jsxFileName,
              lineNumber: 157
            }
          })
        ),
        components && Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_componentParser__["a" /* default */])(components),
        !components && children
      );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { backgroundColor: backgroundColor }, __source: {
          fileName: _jsxFileName,
          lineNumber: 168
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleHeader, { publishDate: dateString, __source: {
          fileName: _jsxFileName,
          lineNumber: 169
        }
      }),
      Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_componentParser__["a" /* default */])(hero),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["x" /* FullWidthImageSection */], {
        backgroundImage: featureImage,
        preHeading: preHeading,
        heading: heading,
        align: "center",
        textAlign: "center",
        blurb: description, __source: {
          fileName: _jsxFileName,
          lineNumber: 171
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.articleColumn, __source: {
            fileName: _jsxFileName,
            lineNumber: 178
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_25" /* WysiwygContent */], {
          className: "beyond-drive__article-body",
          style: { padding: "1em 0" },
          xmlString: content, __source: {
            fileName: _jsxFileName,
            lineNumber: 179
          }
        })
      ),
      components && Object(__WEBPACK_IMPORTED_MODULE_8_AtomicUtils_componentParser__["a" /* default */])(components),
      !components && children
    );
  };

  return ArticlePageContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ArticlePageContainer.propTypes = {
  publishDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  preHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  featureImage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  featureImageCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  styleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["news", "editorial"]),
  disableDropCap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hero: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
ArticlePageContainer.defaultProps = {
  disableDropCap: false
};
ArticlePageContainer.displayName = "ArticlePageContainer";


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(ArticlePageContainer));

var styles = {
  caption: {
    textAlign: "center",
    fontWeight: "300",
    color: "#9e9e9e",
    fontSize: "90%",
    fontStyle: "italic"
  },
  articleColumn: {
    maxWidth: "60em",
    margin: "auto",
    padding: "2em",
    overflow: "auto"
  }
};

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\background-image\\index.jsx";






/**
 * Render an image component
 * @param {Number} zIndex - set CSS zIndex attribute.
 * @param {'absolute'|'relative'} position - sets CSS position attribute.
 * @param {'left'|'right'|'center'} backgroundPosition - sets CSS backgroundPosition attribute.
 * @param {'contain'|'cover'} backgroundSize - sets CSS backgroundSize attribute.
 * @param {'top'|'bottom'|'center'} [textVerticalAlign=center] - Vertical text alignment.
 * @param {Boolean} flex - Applys flex:1 to fill display:flex parents.
 * @param {String} src - URL for image asset.
 * @returns {ReactElement} React Component
 */
var BackgroundImage = function BackgroundImage(_ref) {
  var zIndex = _ref.zIndex,
      position = _ref.position,
      backgroundPosition = _ref.backgroundPosition,
      backgroundSize = _ref.backgroundSize,
      textVerticalAlign = _ref.textVerticalAlign,
      flex = _ref.flex,
      src = _ref.src,
      transition = _ref.transition,
      components = _ref.components,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      "data-test": "background-image",
      style: [styles.base, styles.verticalAlign(textVerticalAlign), { backgroundImage: "url(" + src + ")" }, backgroundSize ? { backgroundSize: backgroundSize } : { backgroundSize: "cover" }, zIndex ? { zIndex: zIndex } : "", position ? { position: position } : "", backgroundPosition ? { backgroundPosition: backgroundPosition } : "", Object(__WEBPACK_IMPORTED_MODULE_3_utils__["b" /* animate */])(transition), flex ? styles.flex : styles.fill], __source: {
        fileName: _jsxFileName,
        lineNumber: 30
      }
    },
    Object(__WEBPACK_IMPORTED_MODULE_2_containers_utilities__["a" /* childParser */])({ components: components, children: children })
  );
};

BackgroundImage.displayName = "BackgroundImage";
BackgroundImage.displayName = "BackgroundImage";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components_configured_radium___["a" /* default */])(BackgroundImage));

BackgroundImage.propTypes = {
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  position: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["absolute", "relative"]),
  backgroundPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["left", "right", "center", "top"]),
  backgroundSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["contain", "cover"]),
  textVerticalAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["top", "bottom", "center"]),
  flex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
BackgroundImage.defaultProps = {
  textVerticalAlign: "center",
  backgroundSize: "cover"
};

var styles = {
  base: {
    textAlign: "center",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    color: "white",
    display: "flex",
    position: "relative",
    overflow: "hidden",
    zIndex: 0
  },
  verticalAlign: function verticalAlign(alignment) {
    return {
      alignItems: alignment === "bottom" ? "flex-end" : alignment === "top" ? "top" : "center"
    };
  },
  fill: {
    width: "100%",
    height: "100%"
  },
  flex: {
    flex: "1 1 auto"
  }
};

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_gtm_events__ = __webpack_require__(22);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\background-image-selector\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/** Background Image Selector Component */

var BackgroundImageSelector = function (_Component) {
  _inherits(BackgroundImageSelector, _Component);

  function BackgroundImageSelector(props) {
    _classCallCheck(this, BackgroundImageSelector);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = function (option) {
      var _this$props = _this.props,
          gtm = _this$props.gtm,
          gtmEvent = _this$props.gtmEvent;

      gtmEvent({
        gtmID: __WEBPACK_IMPORTED_MODULE_5_store_gtm_events__["c" /* gtmBackgroundImageSelectorActionTypes */].CLICK_IMAGE,
        gtmPayload: {
          CMSGroupGTM: gtm,
          imageName: option.name
        }
      });
      _this.setState({ active: _this.props.options.indexOf(option) });
    };

    _this.state = {
      active: 0
    };
    return _this;
  }

  BackgroundImageSelector.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      active: this.props.initialActiveIndex || 0
    });
  };

  /**
   * @param {String} [heading] - Heading text.
   * @param {String} [mobileHeading] - Mobile Heading text.
   * @param {Array|BackgroundImageSelectorOption} options - Array of options.
   * @param {String} type - Radio Group Type ('interior, exterior, technology').
   * @returns {ReactElement} React Component
   */
  BackgroundImageSelector.prototype.render = function render() {
    var _props = this.props,
        description = _props.description,
        heading = _props.heading,
        _props$mobileHeading = _props.mobileHeading,
        mobileHeading = _props$mobileHeading === undefined ? heading : _props$mobileHeading,
        options = _props.options,
        type = _props.type,
        compact = _props.compact;
    var active = this.state.active;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.wrapper, __source: {
          fileName: _jsxFileName,
          lineNumber: 57
        }
      },
      heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], { tag: "h3", textAlign: "center", value: compact ? mobileHeading : heading, __source: {
          fileName: _jsxFileName,
          lineNumber: 59
        }
      }),
      description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.description, dangerouslySetInnerHTML: { __html: description }, __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        }
      }),
      options.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 65
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.selector, __source: {
              fileName: _jsxFileName,
              lineNumber: 66
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["K" /* InteriorSelector */], {
            showActiveLabel: this.props.compact,
            options: options,
            padding: compact ? "0.5em 1em 0.2em" : "10px 0 20px",
            active: active,
            onChange: this.handleChange,
            type: type,
            labelCustomStyle: { padding: "1em .3em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 67
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.base, __source: {
              fileName: _jsxFileName,
              lineNumber: 76
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["x" /* LayeredBackgroundImage */], { imageSrc: options[active].src, __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          }),
          options[active].disclaimer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["t" /* ImageDisclaimer */], { content: options[active].disclaimer, __source: {
              fileName: _jsxFileName,
              lineNumber: 79
            }
          })
        )
      )
    );
  };

  return BackgroundImageSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BackgroundImageSelector.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mobileHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  gtm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
BackgroundImageSelector.displayName = "BackgroundImageSelector";


BackgroundImageSelector.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  initialActiveIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  gtm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["i" /* gtmEvent */])())(BackgroundImageSelector));

var styles = {
  wrapper: {
    textAlign: "center",
    margin: 0
  },
  base: {
    position: "relative",
    color: "white",
    maxWidth: "1200px",
    width: "90vw",
    margin: "0 auto",
    userSelect: "none"
  },
  selector: {
    padding: "0",
    textAlign: "center"
    // margin: '2em 0 0' Padding is removed for SM-1357
  },
  description: {
    fontWeight: "200",
    fontSize: "100%",
    lineHeight: "1.6",
    margin: "1.5em 0",
    letterSpacing: "0.01em"
  }

  /**
   * @typedef {Object} BackgroundImageSelectorOption
   * @property {String} slug - Option Slug
   * @property {String} name - Option Name/Value
   * @property {URL} src - Image URL
   * @property {URL} icon - Icon URL
   * @property {String} [disclaimer] - Disclaimer Text
   */

};

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_no_scroll__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_no_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_no_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var Body = function () {
  function Body() {
    var _this = this;

    _classCallCheck(this, Body);

    this.locked = false;
    __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].__body = false;
    if (!__WEBPACK_IMPORTED_MODULE_0_constants_environment__["a" /* DOCUMENT */]) {
      ["lock", "unlock", "padBottom", "slide"].forEach(function (fn) {
        _this[fn] = __WEBPACK_IMPORTED_MODULE_2__utils__["C" /* noop */];
      });
    } else this.body = __WEBPACK_IMPORTED_MODULE_0_constants_environment__["a" /* DOCUMENT */].body;
  }

  Body.prototype.lock = function lock(top) {
    if (top) {
      __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].scrollTo(0, 0);
    }
    __WEBPACK_IMPORTED_MODULE_1_no_scroll___default.a.on();
    __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].__body = true;
    this.locked = true;
  };

  Body.prototype.unlock = function unlock() {
    var scrollY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    // IE 11 strikes again, ignores null, clear with ''
    __WEBPACK_IMPORTED_MODULE_1_no_scroll___default.a.off();
    this.locked = false;
    __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].__body = false;
    scrollY && __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */].scrollTo(0, scrollY);
  };

  Body.prototype.padBottom = function padBottom(height) {
    this.body.style.paddingBottom = height;
  };

  Body.prototype.slide = function slide(translations) {
    // ie 11 does not like calc in transform values, so we use a combination of transforms
    // see http://stackoverflow.com/a/21469557
    if (!translations || !translations.length) {
      this.body.style.overflowX = "inherit";
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* clearTransform */])(this.body);
    }

    this.body.style.overflowX = "initial";

    if (typeof translations === "string") {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* applyTransform */])("translateX(calc(-100vw " + translations + "))", this.body);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* applyTransform */])(["-100vw"].concat(translations).map(function (t) {
      return "translateX(" + t + ")";
    }).join(" "), this.body);
  };

  return Body;
}();

var body = __WEBPACK_IMPORTED_MODULE_0_constants_environment__["i" /* WINDOW */] && new Body();

/* harmony default export */ __webpack_exports__["a"] = (body);

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_radium__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_radium__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\colored-label\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ColoredLabel = function (_Component) {
  _inherits(ColoredLabel, _Component);

  function ColoredLabel() {
    _classCallCheck(this, ColoredLabel);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ColoredLabel.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        _props$color = _props.color,
        color = _props$color === undefined ? __WEBPACK_IMPORTED_MODULE_2_constants_color_palette__["a" /* default */].GRAY_LIGHT : _props$color,
        style = _props.style,
        _props$hoverLabel = _props.hoverLabel,
        hoverLabel = _props$hoverLabel === undefined ? undefined : _props$hoverLabel;

    var hoverStatus = Object(__WEBPACK_IMPORTED_MODULE_4_radium__["getState"])(this.state, "ColoredLabel", ":hover");
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      {
        ref: "ColoredLabel",
        "data-test": "stock-type",
        style: [_extends({
          backgroundColor: color,
          color: "#fff",
          display: "inline-block",
          letterSpacing: ".15em",
          textTransform: "uppercase",
          fontWeight: 900,
          fontSize: "70%",
          padding: ".5em .9em .35em 1em",
          borderRadius: "1em",
          transition: "background-color 250ms linear",
          ":hover": {}
        }), _extends({}, style)], __source: {
          fileName: _jsxFileName,
          lineNumber: 14
        }
      },
      hoverLabel && hoverStatus && hoverLabel,
      (!hoverLabel || !hoverStatus) && label
    );
  };

  return ColoredLabel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ColoredLabel.displayName = "ColoredLabel";


ColoredLabel.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  hoverLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium___["a" /* default */])(ColoredLabel));

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bowser__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bowser__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\column\\index.jsx";






/**
 * @param {Boolean} [alignMiddle=false] - Vertically and horizontally align contents of column.
 * @param {Boolean} [padding=false] - Apply padding to column.
 * @param {Number} [order] - Manually set order of column using [flex css order](https://developer.mozilla.org/en-US/docs/Web/CSS/order).
 * @param {'left'|'right'|'center'} [textAlign=left] - Text alignment.
 * @param {'left'|'right'|'center'} [textAlignMobile=left] - Text alignment on mobile.
 * @param {Boolean} [mobileAlwaysFirst=false] - Set column to first (in ColumnGroup) on mobile.
 * @param {Boolean} [flex=false] - Display columns as flex (used vertically fill column).
 * @param {boolean} gutter - Adds gutter spacing to column.
 * @param {boolean} [divider] - Adds dividing line to the right of column.
 * @param {boolean} minHeight - Give column a (effectively) minHeight. (used to fill children with no height)
 * @param {Array} components - Array of Components.
 * @returns {ReactElement} React Component
 */
var Column = function Column() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      minHeight = _ref.minHeight,
      alignMiddle = _ref.alignMiddle,
      flex = _ref.flex,
      count = _ref.count,
      mobileAlwaysFirst = _ref.mobileAlwaysFirst,
      divider = _ref.divider,
      gutter = _ref.gutter,
      padding = _ref.padding,
      order = _ref.order,
      compact = _ref.compact,
      components = _ref.components,
      children = _ref.children,
      styleName = _ref.styleName,
      textAlign = _ref.textAlign,
      textAlignMobile = _ref.textAlignMobile;

  var vertical = void 0,
      flexBasis = void 0,
      renderTextAlign = void 0,
      renderMobileAlwaysFirst = void 0;
  if (compact) {
    renderTextAlign = textAlignMobile;
    flexBasis = minHeight ? "300px" : "0";
    renderMobileAlwaysFirst = mobileAlwaysFirst;
    vertical = true;
  } else {
    renderTextAlign = textAlign;
    // the .toFixed() - 2 part is for IE11, more info: https://github.com/philipwalton/flexbugs/issues/3
    flexBasis = __WEBPACK_IMPORTED_MODULE_4_bowser___default.a.ios && __WEBPACK_IMPORTED_MODULE_4_bowser___default.a.version < 10 ? "auto" : ((100 / count).toFixed() - 2 || 100) + "%";
    renderMobileAlwaysFirst = false;
    vertical = false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      "data-test": "column",
      style: [
      // flex-basis: 100% doesn't work on Safari 9, replaced with 'auto instead. This can be revert when support for Safari 9 dropped.
      (!vertical || minHeight) && {
        flex: "1 " + (minHeight ? 0 : 1) + " auto"
      }, vertical && { flex: "1 1 auto" }, styles.column(styleName), alignMiddle && { margin: "auto" }, (minHeight || flex) && { display: "flex" }, divider && styles.divider, { textAlign: renderTextAlign }, order && { order: order }, renderMobileAlwaysFirst && { order: -1 }, { width: "100%" }], __source: {
        fileName: _jsxFileName,
        lineNumber: 57
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: [{ padding: gutter ? "0 1em" : "0" }, padding && styles.padding], __source: {
          fileName: _jsxFileName,
          lineNumber: 75
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_3_containers_utilities__["a" /* childParser */])({ components: components, children: children })
    )
  );
};

Column.displayName = "Column";
Column.displayName = "Column";
Column.propTypes = {
  alignMiddle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  order: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  textAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["left", "right", "center"]),
  textAlignMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["left", "right", "center"]),
  mobileAlwaysFirst: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  gutter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  minHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  styleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dark", "light"])
};

Column.defaultProps = {
  textAlign: "left",
  textAlignMobile: "center",
  styleName: "light"
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(Column));

var styles = {
  column: function column(styleName) {
    return {
      textAlign: "center",
      boxSizing: "border-box",
      backgroundColor: styleName === "dark" && "#101010"
    };
  },
  padding: {
    padding: "2.5em",
    "@media (min-width: 820px)": {
      padding: "4em"
    }
  },
  divider: {
    "@media (min-width: 820px)": {
      borderRight: "1px solid #e7e7e7"
    }
  }
};

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_measure__ = __webpack_require__(185);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\conditional-layout\\index.jsx';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var styles = {
  measuringArea: {
    position: 'absolute',
    left: '0px',
    right: '0px',
    visibility: 'hidden'
  }
};

var ConditionalSizeRender = function (_Component) {
  _inherits(ConditionalSizeRender, _Component);

  function ConditionalSizeRender() {
    _classCallCheck(this, ConditionalSizeRender);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.renderSelectedChild = function () {
      var compareFn = _this.props.compareFn || _this.selectLowestHeightChild;
      if (!_this.state.firstChildDimensions || !_this.state.secondChildDimensions) {
        return null;
      }
      return compareFn(_extends({}, _this.state)) ? _this.props.children[0] : _this.props.children[1];
    };

    _this.selectLowestHeightChild = function () {
      return _this.state.firstChildDimensions.height < _this.state.secondChildDimensions.height;
    };

    _this.state = {
      firstChildDimensions: {},
      secondChildDimensions: {}
    };
    return _this;
  }

  ConditionalSizeRender.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        'data-test': 'conditional-layout',
        style: {
          position: 'relative',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 40
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.measuringArea, __source: {
            fileName: _jsxFileName,
            lineNumber: 50
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_measure__["a" /* default */],
          {
            onResize: function onResize(_ref) {
              var entry = _ref.entry;
              var height = entry.height,
                  width = entry.width;

              _this2.setState({ firstChildDimensions: { height: height, width: width } });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 51
            }
          },
          function (_ref2) {
            var measureRef = _ref2.measureRef;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { ref: measureRef, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 56
                }
              },
              _this2.props.children[0]
            );
          }
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_measure__["a" /* default */],
          {
            onResize: function onResize(_ref3) {
              var entry = _ref3.entry;
              var height = entry.height,
                  width = entry.width;

              _this2.setState({ secondChildDimensions: { height: height, width: width } });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 58
            }
          },
          function (_ref4) {
            var measureRef = _ref4.measureRef;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { ref: measureRef, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 63
                }
              },
              _this2.props.children[1]
            );
          }
        )
      ),
      this.renderSelectedChild()
    );
  };

  return ConditionalSizeRender;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConditionalSizeRender.propTypes = {
  compareFn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  measuringAreaStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
ConditionalSizeRender.displayName = 'ConditionalSizeRender';
/* harmony default export */ __webpack_exports__["a"] = (ConditionalSizeRender);

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__background_image_png__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__background_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__background_image_png__);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\configured-vehicle\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/** Configured Vehicle Component. */

var ConfiguredVehicle = function (_Component) {
  _inherits(ConfiguredVehicle, _Component);

  function ConfiguredVehicle(props) {
    _classCallCheck(this, ConfiguredVehicle);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      top: props.src,
      bottom: props.src
    };
    return _this;
  }

  ConfiguredVehicle.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    var _this2 = this;

    var top = this.state.top;
    var src = this.props.src;

    if (newProps.src !== src) {
      this.setState({ bottom: false, top: false }, function () {
        _this2.setState({ bottom: top, top: newProps.src ? newProps.src : top });
      });
    }
  };

  ConfiguredVehicle.prototype.render = function render() {
    var _props$noShadow = this.props.noShadow,
        noShadow = _props$noShadow === undefined ? false : _props$noShadow;
    var _state = this.state,
        top = _state.top,
        bottom = _state.bottom;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.base(true), 'data-test': 'configured-vehicle', __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        }
      },
      top && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
        style: [styles.top, styles.proportionalSizing],
        src: top,
        'data-test': 'active-vehicle',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        }
      }),
      bottom && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
        style: [styles.proportionalSizing, styles.fadeOut(this.props.isFadeAnimation)],
        src: bottom,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        }
      })
    );
  };

  return ConfiguredVehicle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConfiguredVehicle.propTypes = {
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isFadeAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ConfiguredVehicle.displayName = 'ConfiguredVehicle';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(ConfiguredVehicle));

var fadeOutKeyframes = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["j" /* keyframes */])({
  from: {
    opacity: 1
  }
});

var crossfadeDuration = '.5s';

var styles = {
  base: function base(noShadow) {
    return {
      alignItems: 'center',
      margin: 'auto',
      width: '100%',
      // height: '100%', // Commented because it was a reason for a bug
      position: 'relative',
      pointerEvents: 'none',
      display: 'block',
      backgroundImage: noShadow ? 'none' : 'url(' + __WEBPACK_IMPORTED_MODULE_3__background_image_png___default.a + ')',
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center bottom'
    };
  },
  top: {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    margin: 'auto'
  },
  fadeOut: function fadeOut(isFadeAnimation) {
    return {
      opacity: 0,
      animation: isFadeAnimation && 'x ' + crossfadeDuration + ' ease-in',
      animationName: isFadeAnimation && fadeOutKeyframes
    };
  },
  proportionalSizing: {
    maxWidth: '100%',
    maxHeight: '100%',
    left: '0px',
    right: '0px',
    margin: 'auto'
  }
};

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5ff494baa4faa6cc140cdc1d344c4e41.png";

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\expandable-info\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ExpandableInfo = function (_Component) {
  _inherits(ExpandableInfo, _Component);

  function ExpandableInfo(props) {
    _classCallCheck(this, ExpandableInfo);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      open: props.isOpen
    };
    return _this;
  }

  ExpandableInfo.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        mainText = _props.mainText,
        description = _props.description,
        styleName = _props.styleName,
        descriptionStyle = _props.descriptionStyle,
        textAlign = _props.textAlign;
    var open = this.state.open;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          margin: "auto",
          textAlign: textAlign,
          cursor: "pointer",
          paddingBottom: "1em"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 19
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["H" /* Hyperlink */], {
        onClick: function onClick() {
          return _this2.setState({ open: !open });
        },
        text: mainText,
        styleName: styleName, __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        "data-test": "expandable-description",
        style: [{
          textAlign: "left",
          margin: open ? "1em auto 0" : "0",
          fontWeight: 300,
          lineHeight: 1.4,
          overflow: "hidden",
          fontSize: "90%",
          color: "#939393",
          maxHeight: open ? "50em" : "0em",
          transition: "max-height 0.2s ease-in"
        }, descriptionStyle],
        dangerouslySetInnerHTML: { __html: description }, __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        }
      })
    );
  };

  return ExpandableInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ExpandableInfo.displayName = "ExpandableInfo";


ExpandableInfo.propTypes = {
  mainText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  styleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  descriptionStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  textAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

ExpandableInfo.defaultProps = {
  isOpen: false,
  textAlign: "center"
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])()(ExpandableInfo));

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FeatureYoutube */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_portal__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_get_video_id__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_get_video_id___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_get_video_id__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_gtm_events__ = __webpack_require__(22);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\feature-youtube\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PlayIcon = function PlayIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { style: props.style, viewBox: "0 0 40 40", __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { r: "15", cy: "20", cx: "20", __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "m17.44771,15.71548l7.80763,4.28452l-7.80763,4.28452l0,-8.56904l0,-0.00001z",
      fill: "white",
      strokeWidth: "0", __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    })
  );
};

PlayIcon.displayName = "PlayIcon";
PlayIcon.displayName = "PlayIcon";
PlayIcon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var FeatureYoutube = function (_React$PureComponent) {
  _inherits(FeatureYoutube, _React$PureComponent);

  function FeatureYoutube() {
    _classCallCheck(this, FeatureYoutube);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this));

    _this.state = {
      overlayActive: false
    };
    return _this;
  }

  FeatureYoutube.prototype.activateOverlay = function activateOverlay(active) {
    this.setState({ overlayActive: active });
  };

  FeatureYoutube.prototype.youtubeId = function youtubeId(url) {
    var videoId = __WEBPACK_IMPORTED_MODULE_6_get_video_id___default()(url);
    if (videoId) {
      return videoId.id;
    }
    return null;
  };

  FeatureYoutube.prototype.render = function render() {
    var _this2 = this;

    // false was this.props.compact -> removed because of SM-617
    var styles = AccessoryItemStyles(false);
    var _props = this.props,
        imageSrc = _props.imageSrc,
        videoSrc = _props.videoSrc,
        heading = _props.heading,
        gtmEvent = _props.gtmEvent,
        CMSGroupGTM = _props.CMSGroupGTM,
        outline = _props.outline;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: [styles.base, outline && styles.border], "data-test": "accessory-item", __source: {
          fileName: _jsxFileName,
          lineNumber: 49
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.coverImg, __source: {
            fileName: _jsxFileName,
            lineNumber: 50
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: [{ width: "100%", height: "100%", position: "relative" }, styles.accsessoryCoverImg],
            onClick: function onClick() {
              gtmEvent({
                gtmID: __WEBPACK_IMPORTED_MODULE_7_store_gtm_events__["e" /* gtmFeatureYoutubeActionTypes */].CLICK_PLAY_WATCH_VIDEO,
                gtmPayload: {
                  CMSGroupGTM: CMSGroupGTM,
                  isPlay: true,
                  videoName: heading
                }
              });
              _this2.activateOverlay(true);
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 51
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "figure",
            {
              style: {
                backgroundImage: "url(" + imageSrc + ")",
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "100%",
                height: "100%",
                margin: 0,
                padding: 0
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 67
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
              src: imageSrc,
              alt: heading,
              style: { width: "100%", height: "100%", opacity: 0 }, __source: {
                fileName: _jsxFileName,
                lineNumber: 77
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              position: "absolute",
              left: 0,
              top: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 83
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlayIcon, {
            style: {
              width: "25%",
              height: "25%",
              fill: "transparent",
              stroke: "white"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 95
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.accessoryDetails, __source: {
            fileName: _jsxFileName,
            lineNumber: 104
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["F" /* Heading */], {
          tag: "h5",
          value: heading,
          customHeadingStyle: {
            fontSize: "90%"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 105
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 111
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles.hr, __source: {
              fileName: _jsxFileName,
              lineNumber: 112
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              key: Math.random(),
              style: styles.readMore,
              onClick: function onClick() {
                gtmEvent({
                  gtmID: __WEBPACK_IMPORTED_MODULE_7_store_gtm_events__["e" /* gtmFeatureYoutubeActionTypes */].CLICK_PLAY_WATCH_VIDEO,
                  gtmPayload: {
                    CMSGroupGTM: CMSGroupGTM,
                    isPlay: false,
                    videoName: heading
                  }
                });
                _this2.activateOverlay(true);
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 113
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["F" /* Heading */], { tag: "h5", value: "WATCH VIDEO", __source: {
                fileName: _jsxFileName,
                lineNumber: 127
              }
            })
          )
        )
      ),
      this.state.overlayActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_portal__["a" /* Portal */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 132
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_containers__["L" /* Overlay */],
          { close: function close() {
              return _this2.activateOverlay(false);
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 133
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "video-control",
              style: {
                position: "relative",
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 134
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["_10" /* YoutubePlayer */], { videoId: this.youtubeId(videoSrc), autoPlay: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 144
              }
            })
          )
        )
      )
    );
  };

  return FeatureYoutube;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

FeatureYoutube.displayName = "FeatureYoutube";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["i" /* gtmEvent */])())(FeatureYoutube));

FeatureYoutube.propTypes = {
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  videoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  CMSGroupGTM: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

FeatureYoutube.defaultProps = {
  compact: true,
  outline: true
};

var AccessoryItemStyles = function AccessoryItemStyles(compact) {
  return {
    base: {
      position: "relative",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box",
      borderBottomSize: "2px",
      minHeight: "200px",
      flexDirection: compact ? "row" : "column",
      height: !compact && "auto"
    },

    border: {
      border: "1px solid #d5d5d5",
      background: "#fff"
    },

    coverImg: {
      left: "0px",
      top: "0px",
      bottom: "0px",
      overflow: "hidden",
      boxSizing: "border-box",
      position: compact ? "absolute" : "relative",
      width: compact ? "50%" : "100%",
      height: !compact && "200px",
      cursor: "pointer"
    },

    accessoryDetails: {
      padding: "1.5em 1.5em 0.5em",
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxSizing: "border-box",
      marginLeft: compact ? "50%" : "0px",
      textAlign: "center",
      width: compact ? "50%" : "100%"
    },

    readMore: {
      fontSize: "90%",
      color: "#aaaaaa",
      transition: ".5s",
      cursor: "pointer",
      display: compact ? "none" : "block",
      ":hover": { color: "black" }
    },

    hr: {
      width: "100%",
      borderBottom: "1px solid rgb(229, 229, 229)",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "1em",
      paddingBottom: "1.3em",
      display: compact ? "none" : "block"
    },

    accsessoryCoverImg: {
      width: "100%",
      transition: "transform 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      ":hover": { transform: "scale(1.05)" },
      ":focus": { transform: "scale(1.05)" }
    }
  };
};

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getSrc = __webpack_require__(1688);

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('get-video-id expects a string');
	}

	if (/<iframe/ig.test(str)) {
		str = getSrc(str);
	}

	// remove surrounding whitespaces or linefeeds
	str = str.trim();

	// remove the '-nocookie' flag from youtube urls
	str = str.replace('-nocookie', '');

	// remove any leading `www.`
	str = str.replace('/www.', '/');

	var metadata;

	// Try to handle google redirection uri
	if (/\/\/google/.test(str)) {
		// Find the redirection uri
		var matches = str.match(/url=([^&]+)&/);

		// Decode the found uri and replace current url string - continue with final link
		if (matches) {
			// Javascript can get encoded URI
			str = decodeURIComponent(matches[1]);
		}
	}

	if (/youtube|youtu\.be|i.ytimg\./.test(str)) {
		metadata = {
			id: youtube(str),
			service: 'youtube'
		};
	} else if (/vimeo/.test(str)) {
		metadata = {
			id: vimeo(str),
			service: 'vimeo'
		};
	} else if (/vine/.test(str)) {
		metadata = {
			id: vine(str),
			service: 'vine'
		};
	} else if (/videopress/.test(str)) {
		metadata = {
			id: videopress(str),
			service: 'videopress'
		};
	}
	return metadata;
};

/**
 * Get the vimeo id.
 * @param {string} str - the url from which you want to extract the id
 * @returns {string|undefined}
 */
function vimeo(str) {
	if (str.indexOf('#') > -1) {
		str = str.split('#')[0];
	}
	if (str.indexOf('?') > -1) {
		str = str.split('?')[0];
	}

	var id;
	if (/https?:\/\/vimeo\.com\/[0-9]+$|https?:\/\/player\.vimeo\.com\/video\/[0-9]+$|https?:\/\/vimeo\.com\/channels|groups|album/igm.test(str)) {
		var arr = str.split('/');
		if (arr && arr.length) {
			id = arr.pop();
		}
	}
	return id;
}

/**
 * Get the vine id.
 * @param {string} str - the url from which you want to extract the id
 * @returns {string|undefined}
 */
function vine(str) {
	var regex = /https:\/\/vine\.co\/v\/([a-zA-Z0-9]*)\/?/;
	var matches = regex.exec(str);
	return matches && matches[1];
}

/**
 * Get the Youtube Video id.
 * @param {string} str - the url from which you want to extract the id
 * @returns {string|undefined}
 */
function youtube(str) {
	// shortcode
	var shortcode = /youtube:\/\/|https?:\/\/youtu\.be\//g;

	if (shortcode.test(str)) {
		var shortcodeid = str.split(shortcode)[1];
		return stripParameters(shortcodeid);
	}

	// /v/ or /vi/
	var inlinev = /\/v\/|\/vi\//g;

	if (inlinev.test(str)) {
		var inlineid = str.split(inlinev)[1];
		return stripParameters(inlineid);
	}

	// v= or vi=
	var parameterv = /v=|vi=/g;

	if (parameterv.test(str)) {
		var arr = str.split(parameterv);
		return arr[1].split('&')[0];
	}

	// v= or vi=
	var parameterwebp = /\/an_webp\//g;

	if (parameterwebp.test(str)) {
		var webp = str.split(parameterwebp)[1];
		return stripParameters(webp);
	}

	// embed
	var embedreg = /\/embed\//g;

	if (embedreg.test(str)) {
		var embedid = str.split(embedreg)[1];
		return stripParameters(embedid);
	}

	// user
	var userreg = /\/user\//g;

	if (userreg.test(str)) {
		var elements = str.split('/');
		return stripParameters(elements.pop());
	}

	// attribution_link
	var attrreg = /\/attribution_link\?.*v%3D([^%&]*)(%26|&|$)/;

	if (attrreg.test(str)) {
		return str.match(attrreg)[1];
	}
}

/**
 * Get the VideoPress id.
 * @param {string} str - the url from which you want to extract the id
 * @returns {string|undefined}
 */
function videopress(str) {
	var idRegex;
	if (str.indexOf('embed') > -1) {
		idRegex = /embed\/(\w{8})/;
		return str.match(idRegex)[1];
	}

	idRegex = /\/v\/(\w{8})/;
	return str.match(idRegex)[1];
}

/**
 * Strip away any parameters following `?` or `/`
 * @param str
 * @returns {*}
 */
function stripParameters(str) {
	// Split parameters or split folder separator
	if (str.indexOf('?') > -1) {
		return str.split('?')[0];
	} else if (str.indexOf('/') > -1) {
		return str.split('/')[0];
	}
	return str;
}


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (input) {
	if (typeof input !== 'string') {
		throw new TypeError('get-src expected a string');
	}
	var re = /src="(.*?)"/gm;
	var url = re.exec(input);

	if (url && url.length >= 2) {
		return url[1];
	}
};


/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\fifty-fifty-block\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/** Render a fifty fifty block */

var FiftyFiftyBlock = function (_Component) {
  _inherits(FiftyFiftyBlock, _Component);

  function FiftyFiftyBlock() {
    _classCallCheck(this, FiftyFiftyBlock);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * @param {String} [preHeading] - Pre-Heading text.
   * @param {String} [heading] - Heading text.
   * @param {String} [blurb] - blurb text as xhtml string.
   * @param {'left'|'right'|'center'} [textAlign=left] - Text alignment.
   * @param {'small'|'medium'|'large'} [size] - Size of component.
   * @param {'top'|'bottom'|'center'} [textVerticalAlign=top] - Vertical text alignment.
   * @param {String} imageUrl - Image url.
   * @param {String} [backgroundColor='#f5f5f5'] - Background color as HTML hex code.
   * @param {'left'|'right'} [imagePosition=left] - Image position.
   * @param {'true'|'false'} [imagePositionMobile=false] - true means image should be on top always
   * @param {Array|Button} [components] - Array of nested components.
   * @returns {ReactElement} React Component
   */
  FiftyFiftyBlock.prototype.render = function render() {
    var _props = this.props,
        imagePosition = _props.imagePosition,
        imagePositionMobile = _props.imagePositionMobile,
        size = _props.size,
        ratio = _props.ratio,
        backgroundColor = _props.backgroundColor,
        heading = _props.heading,
        preHeading = _props.preHeading,
        textAlign = _props.textAlign,
        headingUppercase = _props.headingUppercase,
        videoUrl = _props.videoUrl,
        imageUrl = _props.imageUrl,
        backgroundImageArray = _props.backgroundImageArray,
        interval = _props.interval,
        loop = _props.loop,
        _props$overlay = _props.overlay,
        overlay = _props$overlay === undefined ? false : _props$overlay,
        imageAlign = _props.imageAlign,
        backgroundSize = _props.backgroundSize,
        blurb = _props.blurb,
        textVerticalAlign = _props.textVerticalAlign;

    var leftRatio = imagePosition === "right" ? 100 - ratio : ratio;
    var rightRatio = imagePosition !== "right" ? 100 - ratio : ratio;
    var minHeight = "40vw";
    switch (size) {
      case "small":
        minHeight = "20vw";
        break;
      case "medium":
        minHeight = "30vw";
        break;
      case "disable":
        minHeight = "initial";
        break;
    }
    var Tag = "div";

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "section",
      { style: [styles.base, { backgroundColor: backgroundColor }], "data-test": "fifty-fifty-block", __source: {
          fileName: _jsxFileName,
          lineNumber: 63
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: [styles.columns, { minHeight: minHeight }], __source: {
            fileName: _jsxFileName,
            lineNumber: 64
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: [styles.row(leftRatio + "%", !imagePosition === "right", !imagePositionMobile), { flexShrink: 0 }], __source: {
              fileName: _jsxFileName,
              lineNumber: 65
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.fitHeight, __source: {
                fileName: _jsxFileName,
                lineNumber: 70
              }
            },
            videoUrl ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["_22" /* VideoBackground */], { src: videoUrl, poster: imageUrl, __source: {
                fileName: _jsxFileName,
                lineNumber: 72
              }
            }) : backgroundImageArray && backgroundImageArray.length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["y" /* LayeredBackgroundImageAutoplay */], {
              interval: interval,
              loop: loop,
              imageSrcArray: backgroundImageArray,
              backgroundSize: "cover", __source: {
                fileName: _jsxFileName,
                lineNumber: 75
              }
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_containers__["d" /* BackgroundImage */],
              {
                fill: true,
                src: imageUrl,
                backgroundPosition: imageAlign,
                backgroundSize: backgroundSize, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 80
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: imageUrl, alt: heading, style: [styles.image, { minHeight: minHeight }], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 85
                }
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: [styles.row(rightRatio + "%", imagePosition === "right", imagePositionMobile), styles.textAlign(textAlign)], __source: {
              fileName: _jsxFileName,
              lineNumber: 90
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.verticalAlign(textVerticalAlign), __source: {
                fileName: _jsxFileName,
                lineNumber: 95
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Tag,
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 96
                }
              },
              heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["s" /* HeadingBlock */], {
                tag: "h3",
                uppercase: headingUppercase,
                value: heading,
                preHeading: preHeading, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 98
                }
              }),
              blurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["_25" /* WysiwygContent */], { xmlString: blurb, textAlign: textAlign, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 104
                }
              }),
              Object(__WEBPACK_IMPORTED_MODULE_3_containers_utilities__["a" /* childParser */])(this.props)
            )
          )
        )
      )
    );
  };

  return FiftyFiftyBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FiftyFiftyBlock.displayName = "FiftyFiftyBlock";


FiftyFiftyBlock.propTypes = {
  preHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  blurb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  textAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["left", "right", "center"]),
  textVerticalAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["top", "bottom", "center"]),
  imageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  videoUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imagePosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["left", "right"]),
  imagePositionMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  imageAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  headingUppercase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["small", "medium", "large", "disable"]),
  ratio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  backgroundSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["cover", "contain"]),
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

FiftyFiftyBlock.defaultProps = {
  backgroundColor: "#f5f5f5",
  ratio: 50
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(FiftyFiftyBlock));

var styles = {
  base: {
    display: "block",
    width: "100%",
    flex: "1 1 auto",
    color: "#101010",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    "@media (min-width: 820px)": {
      display: "flex"
    }
  },
  columns: {
    flex: "1 1 auto",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    "@media (min-width: 820px)": {
      flexDirection: "row",
      alignItems: "stretch"
    }
  },
  row: function row(width, displayOnLeft, imagePositionMobile) {
    return {
      order: imagePositionMobile ? 2 : 1,
      display: "flex",
      width: "100%",
      "@media (min-width: 820px)": {
        width: width,
        position: "relative",
        order: displayOnLeft ? 1 : 2
      }
    };
  },
  // Fix for older Safari / Chrome where internal elements did not fill height of parent
  // elements that stretched to flex container
  fitHeight: {
    width: "100%",
    zIndex: 0,
    "@media (min-width: 820px)": {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0
    }
  },
  textAlign: function textAlign(alignment) {
    return {
      "@media (min-width: 820px)": {
        textAlign: alignment
      },
      textAlign: "center"
    };
  },
  verticalAlign: function verticalAlign(alignment) {
    return {
      padding: "2em 1em 1em",
      display: "flex",
      justifyContent: alignment === "bottom" ? "flex-end" : alignment === "top" ? "top" : "center",
      flexDirection: "column",
      flex: "1 1 100%",
      boxSizing: "border-box"
    };
  },
  image: {
    width: "100%",
    visibility: "hidden",
    "@media (min-width: 820px)": {
      height: "100%"
    }
  }
};

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\fine-print\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FinePrint = function (_Component) {
  _inherits(FinePrint, _Component);

  function FinePrint() {
    _classCallCheck(this, FinePrint);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  FinePrint.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.base, __source: {
          fileName: _jsxFileName,
          lineNumber: 7
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h3",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 8
          }
        },
        this.props.heading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 9
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 10
            }
          },
          "Lorem Ipsum"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h5",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 11
            }
          },
          "Performance"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ol",
          { style: styles.ol, __source: {
              fileName: _jsxFileName,
              lineNumber: 12
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 13
              }
            },
            "test"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 14
              }
            },
            "test"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 15
              }
            },
            "test"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h5",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 17
            }
          },
          "Interior"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ol",
          { style: styles.ol, __source: {
              fileName: _jsxFileName,
              lineNumber: 18
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 19
              }
            },
            "test"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 20
              }
            },
            "test"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 21
              }
            },
            "test"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h5",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 23
            }
          },
          "Exterior"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ol",
          { style: styles.ol, __source: {
              fileName: _jsxFileName,
              lineNumber: 24
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 25
              }
            },
            "test"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 26
              }
            },
            "test"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 27
              }
            },
            "test"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h5",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 29
            }
          },
          "Technology and Safety"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ol",
          { style: styles.ol, __source: {
              fileName: _jsxFileName,
              lineNumber: 30
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 31
              }
            },
            "test"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 32
              }
            },
            "test"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 33
              }
            },
            "test"
          )
        )
      )
    );
  };

  return FinePrint;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FinePrint.displayName = "FinePrint";


var styles = {
  base: {
    textAlign: "left",
    maxWidth: "1200px",
    margin: "auto"
  },
  ol: {
    listStyle: "none"
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium___["a" /* default */])(FinePrint));

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components___ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_utilities__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bowser__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bowser__);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\fixed-bar\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/** Fixed Bar Component. */

var FixedBar = function (_Component) {
  _inherits(FixedBar, _Component);

  function FixedBar() {
    _classCallCheck(this, FixedBar);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.detectVirtualKeyboard = function () {
      if (_this.props.compact && __WEBPACK_IMPORTED_MODULE_6_constants_environment__["b" /* HAS_TOUCH */] && __WEBPACK_IMPORTED_MODULE_7_bowser___default.a.android) {
        if (__WEBPACK_IMPORTED_MODULE_6_constants_environment__["i" /* WINDOW */].innerWidth === _this.state.currentWidth) {
          if (_this.state.currentHeight > __WEBPACK_IMPORTED_MODULE_6_constants_environment__["i" /* WINDOW */].innerHeight + 200) {
            _this.setState({ isVirtualKeyboard: true });
          } else if (_this.state.isVirtualKeyboard) {
            _this.setState({ isVirtualKeyboard: false });
          }
        } else {
          _this.setState({
            currentWidth: __WEBPACK_IMPORTED_MODULE_6_constants_environment__["i" /* WINDOW */].innerWidth,
            currentHeight: __WEBPACK_IMPORTED_MODULE_6_constants_environment__["i" /* WINDOW */].innerHeight
          });
        }
      }
    };

    _this.state = {
      isVirtualKeyboard: false,
      currentWidth: __WEBPACK_IMPORTED_MODULE_6_constants_environment__["i" /* WINDOW */].innerWidth,
      currentHeight: __WEBPACK_IMPORTED_MODULE_6_constants_environment__["i" /* WINDOW */].innerHeight
    };
    return _this;
  }

  FixedBar.prototype.componentDidMount = function componentDidMount() {
    __WEBPACK_IMPORTED_MODULE_5_containers__["e" /* Body */].padBottom(Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this).clientHeight + 'px');
    this.handleResize = Object(__WEBPACK_IMPORTED_MODULE_2_utils__["M" /* rafThrottle */])(this.resize);
    // This is for hiding the fixed bar when there is virtual keyboard on Android chrome SM-1146
    // There is no API for detecting a virtual keyboard, so the logic is based on viewport height
    // change when the keyboard appears.
    __WEBPACK_IMPORTED_MODULE_6_constants_environment__["i" /* WINDOW */].addEventListener('resize', this.detectVirtualKeyboard);
  };

  FixedBar.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_6_constants_environment__["i" /* WINDOW */].removeEventListener('resize', this.detectVirtualKeyboard);
  };

  FixedBar.prototype.componentDidUpdate = function componentDidUpdate() {
    if (__WEBPACK_IMPORTED_MODULE_5_containers__["e" /* Body */].body.style.paddingBottom !== Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this).clientHeight + 'px') {
      __WEBPACK_IMPORTED_MODULE_5_containers__["e" /* Body */].padBottom(Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this).clientHeight + 'px');
    }
  };

  FixedBar.prototype.render = function render() {
    var innerRef = this.props.innerRef;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        ref: innerRef,
        style: [styles.base, this.state.isVirtualKeyboard && { display: 'none' }],
        'data-test': 'fixed-bar', __source: {
          fileName: _jsxFileName,
          lineNumber: 59
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_3_containers_utilities__["a" /* childParser */])(this.props)
    );
  };

  return FixedBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FixedBar.displayName = 'FixedBar';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components___["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components___["b" /* DetectCompact */])())(FixedBar));

var styles = {
  base: {
    position: 'fixed',
    width: '100%',
    bottom: 0,
    borderTop: '1px solid #e5e5e5',
    backgroundColor: '#fff',
    padding: '.5em 0',
    zIndex: '20',
    textAlign: 'left',
    lineHeight: '1.2em',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
};

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\gallery-grid\\index.jsx";




/**
 * Renders full width grid cell
 * @param {Object} props - Component of props.
 * @param {Array} props.items - Array of components to render inside grid cell.
 * @returns {ReactElement} React Component
 */
var fullWidth = function fullWidth(_ref) {
  var items = _ref.items;

  if (items.length < 1) return;
  return items.splice(0, 1).map(wrapItems({
    additionalStyles: {
      paddingBottom: "50%"
    }
  }));
};

fullWidth.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array

  /**
   * Renders one large cell with two supporting cells
   * @param {Object} props - Component of props.
   * @param {Array} props.items - Array of components to render inside grid cell.
   * @param {boolean} left - Render the feature image on the left.
   * @returns {ReactElement} React Component
   */
};var featureTwoSupport = function featureTwoSupport(_ref2) {
  var items = _ref2.items,
      left = _ref2.left;

  if (items.length < 3) return;
  var dimension = 100 / items.length;
  var largeItemProps = {
    additionalStyles: {
      flex: "1 1 " + 2 * dimension + "%"
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { display: "flex" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 40
      }
    },
    left && items.splice(0, 1).map(firefix).map(wrapItems(largeItemProps)),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          display: "flex",
          flex: "1 1 " + dimension + "%",
          flexDirection: "column"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 43
        }
      },
      items.splice(0, 1).map(wrapItems()),
      items.splice(0, 1).map(wrapItems())
    ),
    !left && items.splice(0, 1).map(firefix).map(wrapItems(largeItemProps))
  );
};

featureTwoSupport.displayName = "featureTwoSupport";
featureTwoSupport.displayName = "featureTwoSupport";
featureTwoSupport.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool

  /**
   * Renders a row of equi dimensioned cells.
   * @param {Object} props - Component of props.
   * @param {Array} props.items - Array of components to render inside grid cell.
   * @returns {ReactElement} React Component
   */
};var imageRow = function imageRow(_ref3) {
  var items = _ref3.items;

  if (items.length < 2) return fullWidth({ items: items });
  var dimension = 100 / items.length;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { display: "flex" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 73
      }
    },
    items.map(firefix).map(wrapItems({
      additionalStyles: {
        flex: "1 1 " + dimension + "%"
      }
    }))
  );
};

imageRow.displayName = "imageRow";
imageRow.displayName = "imageRow";
// Fix for SM-2915 - Firefox not calculating height of flex if all GalleryItems are position: absolute
var firefix = function firefix(item) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item, { additionalStyles: { position: "relative" } });
};

imageRow.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array

  /**
   * Assign components to grid function based on position in array & responsive state.
   * @param {Object} props - Component of props.
   * @param {Array} props.items - Array of components to render inside grid cell.
   * @param {Object} props.additionalStyles - Styles to add to div wrapping component.
   * @returns {ReactElement} React Component
   */
};var wrapItems = function wrapItems() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$additionalStyle = _ref4.additionalStyles,
      additionalStyles = _ref4$additionalStyle === undefined ? {} : _ref4$additionalStyle;

  return function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        key: index,
        style: [{
          position: "relative",
          flex: "1 1 auto",
          overflow: "hidden",
          userSelect: "none",
          border: "3px solid transparent"
        },
        // If the item is a normal GalleryItem, put in additional styles
        // otherwise (e.g. ImagesRotator) we don't need those styles
        item.type.displayName === "GalleryItem" && additionalStyles], __source: {
          fileName: _jsxFileName,
          lineNumber: 98
        }
      },
      item
    );
  };
};

/** Render a gallery grid.
 * @param {Object} props - Component of props.
 * @param {Array|GridItem} props.components - Array of GridItem components.
 * @param {Boolean} props.compact - Render component as compact.
 * @param {Array|Layout String} layouts - Array of Layouts.
 * @returns {ReactElement} React Component
 */
var GalleryGrid = function GalleryGrid(_ref5) {
  var children = _ref5.children,
      compact = _ref5.compact,
      layouts = _ref5.layouts;

  var newLayouts = layouts;
  var items = children.slice(0);
  if (!newLayouts || !newLayouts.length) {
    newLayouts = ["Large", "MediumLeftSmall", "Small", "SmallMediumRight", "Small"];
  }

  if (!compact) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { margin: "2.5em 0 1em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 133
        }
      },
      items.length && newLayouts.map(function (layout, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 135
            }
          },
          layout === "Small" ? imageRow({ items: items.splice(0, 3) }) : layout === "MediumLeftSmall" ? featureTwoSupport({ items: items.splice(0, 3), left: true }) : layout === "SmallMediumRight" ? featureTwoSupport({ items: items.splice(0, 3), left: false }) : fullWidth({ items: items.splice(0, 1) })
        );
      })
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { margin: "2.5em 0 1em" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 149
      }
    },
    items && items.length && newLayouts.map(function (layout, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: index, __source: {
            fileName: _jsxFileName,
            lineNumber: 151
          }
        },
        layout === "Large" ? fullWidth({ items: items.splice(0, 1) }) : imageRow({ items: items.splice(0, 2) })
      );
    })
  );
};

GalleryGrid.displayName = "GalleryGrid";
GalleryGrid.displayName = "GalleryGrid";
GalleryGrid.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  layouts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(GalleryGrid));

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils__ = __webpack_require__(9);


var getImageSrcBasedOnOptions = function getImageSrcBasedOnOptions(display360, options, activeOption, step, isSelectColorInterior) {
  var finalImageSrc = "";
  var getTransmissionName = Object(__WEBPACK_IMPORTED_MODULE_0_utils__["q" /* get */])("transmission.name", options);
  var getFuelType = Object(__WEBPACK_IMPORTED_MODULE_0_utils__["q" /* get */])("engine.fuelType", options);
  if (isSelectColorInterior) {
    // If it is select INTERIOR color screen, use the fallback options
    if (getTransmissionName === "Manual") {
      if (getFuelType === "Diesel" && activeOption.dieselManualSrc) {
        finalImageSrc = activeOption.dieselManualSrc;
      } else {
        finalImageSrc = activeOption.manualImageSrc;
      }
    } else if (getTransmissionName === "Auto") {
      if (getFuelType === "Diesel" && activeOption.dieselAutoSrc) {
        finalImageSrc = activeOption.dieselAutoSrc;
      } else {
        finalImageSrc = activeOption.autoImageSrc;
      }
    }
  } else {
    // If it is EXTERIOR color image, check to see if it is "SELECT A GRADE" step
    if (step.radioGroup[0].groupName === "grades" && options.color) {
      // Check if there's any pre-selected color that persists, use that otherwise fall back to default.
      if (options.color) {
        finalImageSrc = options.color.imageSrc;
      } else {
        for (var _iterator = options.colors, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var color = _ref;

          if (color.default) {
            finalImageSrc = color.imageSrc;
          }
        }
      }
    } else {
      // If it is not "SELECT A GRADE" step, use the active option image, otherwise fall back to default
      finalImageSrc = display360 && Array.isArray(activeOption.imageSrc360) && activeOption.imageSrc360.length > 0 ? activeOption.imageSrc360 : activeOption.imageSrc || options.color.imageSrc;
    }
  }
  return finalImageSrc;
};

/* harmony default export */ __webpack_exports__["a"] = (getImageSrcBasedOnOptions);

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\heading-block\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var HeadingBlock = function (_React$Component) {
  _inherits(HeadingBlock, _React$Component);

  function HeadingBlock() {
    _classCallCheck(this, HeadingBlock);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  HeadingBlock.prototype.render = function render() {
    var _props = this.props,
        _props$tag = _props.tag,
        tag = _props$tag === undefined ? 'h2' : _props$tag,
        value = _props.value,
        preHeading = _props.preHeading,
        white = _props.white,
        margin = _props.margin;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["_8" /* Section */],
      { padding: margin, __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      },
      preHeading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["D" /* H6 */],
        { white: white, withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 17
          }
        },
        preHeading
      ),
      tag === 'h1' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["y" /* H1 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        }),
        value
      ),
      tag === 'h2' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["z" /* H2 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        }),
        value
      ),
      tag === 'h3' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["A" /* H3 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        }),
        value
      ),
      tag === 'h4' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["B" /* H4 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        }),
        value
      ),
      tag === 'h5' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["C" /* H5 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          }
        }),
        value
      ),
      tag === 'h6' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_AtomicComponents__["D" /* H6 */],
        _extends({ withDetails: true, white: white }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        }),
        value
      )
    );
  };

  return HeadingBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

HeadingBlock.displayName = 'HeadingBlock';

/* harmony default export */ __webpack_exports__["a"] = (HeadingBlock);

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\icon-link\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var IconLink = function (_Component) {
  _inherits(IconLink, _Component);

  function IconLink() {
    _classCallCheck(this, IconLink);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * @param {String} label - Label Value.
   * @param {Url} href - Url Value.
   * @param {Url} icon - Icon Url.
   * @returns {ReactElement} React Component
   */
  IconLink.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { style: styles.base, __source: {
          fileName: _jsxFileName,
          lineNumber: 19
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { style: styles.a, href: this.props.href, __source: {
            fileName: _jsxFileName,
            lineNumber: 20
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: styles.icon, alt: this.props.label, src: this.props.icon, __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        }),
        this.props.label
      )
    );
  };

  return IconLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

IconLink.propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string };
IconLink.displayName = 'IconLink';


var styles = {
  base: {
    display: 'inline-block',
    lineHeight: '1.5em',
    textTransform: 'uppercase',
    opacity: 0.75,
    ':hover': {
      opacity: 1
    }
  },
  a: {
    display: 'inline-block',
    textDecoration: 'none',
    color: 'currentColor',
    fontWeight: 'bold',
    letterSpacing: '2px'
  },
  icon: {
    width: '1.5em',
    height: '1.5em',
    display: 'inline-block',
    position: 'relative',
    top: '.35em',
    left: '0em',
    paddingRight: '.5em'
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(IconLink));

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\image-block\\index.jsx";




/**
 * Render an image component
 * @param { imageSrc } Src of Image
 * @param { imageAlt } Alt of Img element
 * @returns {ReactElement} React Component
 */
var ImageBlock = function ImageBlock(_ref) {
  var imageSrc = _ref.imageSrc,
      imageAlt = _ref.imageAlt;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { "data-test": "image-block", src: imageSrc, alt: imageAlt, style: { width: "100%" }, __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    }
  });
};

ImageBlock.displayName = "ImageBlock";
ImageBlock.displayName = "ImageBlock";
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(ImageBlock));

ImageBlock.propTypes = {
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageAlt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__ = __webpack_require__(17);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\image-disclaimer\\index.jsx";





/**
 * Renders an image disclaimer
 * @param {'left'|'right'|'center'} [textAlign='center'] - Text alignment of disclaimer
 * @param {'small'|'normal'} [size='small'] - Text size of disclaimer
 * @param {String} content - Content of disclaimer
 * @param {Boolean} [gradient=true] - Display gradient behind disclaimer
 * @param {Boolean} [uppercase=false] - Display content in uppercase
 * @returns {ReactElement} React Component
 */
var ImageDisclaimer = function ImageDisclaimer(_ref) {
  var _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === undefined ? "center" : _ref$textAlign,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? "small" : _ref$size,
      uppercase = _ref.uppercase,
      _ref$gradient = _ref.gradient,
      gradient = _ref$gradient === undefined ? true : _ref$gradient,
      content = _ref.content,
      _ref$active = _ref.active,
      active = _ref$active === undefined ? false : _ref$active;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { "data-test": "image-disclaimer", style: [styles.base(active), gradient && styles.gradient], __source: {
        fileName: _jsxFileName,
        lineNumber: 23
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: [styles.label, styles[size], { textAlign: textAlign }, uppercase && { textTransform: "uppercase", letterSpacing: "0.15em" }], __source: {
          fileName: _jsxFileName,
          lineNumber: 24
        }
      },
      content
    )
  );
};

ImageDisclaimer.displayName = "ImageDisclaimer";
ImageDisclaimer.displayName = "ImageDisclaimer";
ImageDisclaimer.propTypes = {
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["small", "normal"]),
  uppercase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  textAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["left", "right", "center"]),
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  gradient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(ImageDisclaimer));

var styles = {
  base: function base(active) {
    return {
      position: "absolute",
      zIndex: "20",
      padding: "2em 1em 1em",
      transition: "padding 0.5s",
      bottom: "0",
      left: "0",
      right: "0",
      fontWeight: 600,
      textAlign: "center",
      "@media (min-width: 768px)": {
        padding: !__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_environment__["a" /* HAS_TOUCH */] && active ? "1em 1.8em 2.4em" : "2em 1.8em 1.4em"
      }
    };
  },
  gradient: {
    background: "linear-gradient(to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, 0))"
  },
  label: {
    zIndex: "3",
    lineHeight: "1.5em",
    pointerEvents: "none"
  },
  small: {
    fontSize: "81%"
  },
  normal: {
    letterSpacing: ".2em",
    fontSize: "90%"
  }
};

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\image-selector\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ImageSelector = function (_Component) {
  _inherits(ImageSelector, _Component);

  function ImageSelector() {
    var _temp, _this, _ret;

    _classCallCheck(this, ImageSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleChange = function (option, index) {
      if (_this.props.onChange) _this.props.onChange(option);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ImageSelector.prototype.render = function render() {
    var _this2 = this;

    var width = ['55%', '45%'];
    if (this.props.options.length === 3) width = ['30%', '40%', '30%'];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.base, 'data-test': 'image-selector', __source: {
          fileName: _jsxFileName,
          lineNumber: 13
        }
      },
      this.props.options.map(function (option, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: [styles.wrapper, { width: width[index] || 'auto' }, _this2.props.active === index ? { opacity: 1 } : { opacity: 0.5 }],
            key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 15
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
            src: option.imageSrc,
            onClick: _this2.handleChange.bind(_this2, option, index),
            style: styles.img, __source: {
              fileName: _jsxFileName,
              lineNumber: 22
            }
          })
        );
      })
    );
  };

  return ImageSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ImageSelector.displayName = 'ImageSelector';


var styles = {
  base: {
    display: 'flex',
    height: '100%',
    alignItems: 'flex-start',
    padding: '0px 30px'
  },
  wrapper: {
    backgroundSize: 'contain',
    backgroundPosition: 'center top',
    transition: '.5s',
    maxHeight: '100%',
    cursor: 'pointer'
  },
  img: {
    width: '100%',
    height: 'auto'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(ImageSelector));

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_function__ = __webpack_require__(35);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\inline-disclaimer-block\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * As legal requirements, the whole block of text with inline disclaimer need to be clickable,
 * not just the disclaimer itself. Thus this component needs to wrap around the text to provide
 * the onClick event to the whole block of text + disclaimer.
 */








var InlineDisclaimerBlock = function (_PureComponent) {
  _inherits(InlineDisclaimerBlock, _PureComponent);

  function InlineDisclaimerBlock(props) {
    _classCallCheck(this, InlineDisclaimerBlock);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.handleClick = function (e) {
      if (!_this.props.message || _this.state.open) return;
      var gtmEvents = _this.props.gtmEvents;

      e.stopPropagation();
      gtmEvents && Object(__WEBPACK_IMPORTED_MODULE_5_utils_function__["e" /* invokeFuncs */])(gtmEvents);
      _this.setState({ open: true, fresh: _this.state.fresh + 1 });
    };

    _this.state = {
      open: false,
      fresh: 0
    };
    return _this;
  }

  InlineDisclaimerBlock.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({ open: false, fresh: this.state.fresh + 1 });
  };

  /**
   * @param {string} message - Disclaimer message to display on click.
   * @param {string} identifier - Character or number to insert. Defaults to *.
   * @param {number} yOffset - Vertical position offset (used to avoid conflict with sticky elements).
   * @param {array} gtmEvents - Actions array fired on click.
   * @param {object} blockStyling - Styling of the whole block (text + disclaimer)
   * @param {object} disclaimerStyling - Any customised styling for the disclaimer
   * @returns {ReactElement} React Component
   */
  InlineDisclaimerBlock.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        yOffset = _props.yOffset,
        blockStyling = _props.blockStyling,
        disclaimerStyling = _props.disclaimerStyling,
        identifier = _props.identifier,
        children = _props.children,
        message = _props.message,
        showingUnderline = _props.showingUnderline,
        isIdentifierHidden = _props.isIdentifierHidden;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: [blockStyling, {
          cursor: message && 'pointer',
          ':hover': showingUnderline && !__WEBPACK_IMPORTED_MODULE_4_constants_environment__["b" /* HAS_TOUCH */] && message && {
            textDecoration: 'underline'
          }
        }],
        'data-test': 'inline-version-rendered-' + this.state.fresh,
        onClick: this.handleClick, __source: {
          fileName: _jsxFileName,
          lineNumber: 69
        }
      },
      children,
      message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { 'data-test': 'inline-disclaimer', style: { display: !isIdentifierHidden && 'inline' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 85
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'sup',
          {
            key: 'sup',
            style: [styles.priceDisclaimer, _extends({}, disclaimerStyling), isIdentifierHidden && { display: 'none' }], __source: {
              fileName: _jsxFileName,
              lineNumber: 86
            }
          },
          identifier
        ),
        this.state.open && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_containers__["_8" /* ToastPopup */],
          {
            show: this.state.open,
            yOffset: yOffset,
            onCloseClick: function onCloseClick() {
              _this2.setState({ open: false });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 96
            }
          },
          this.props.identifier && !this.props.isIdentifierHiddenInPopUp && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.identifier, __source: {
                fileName: _jsxFileName,
                lineNumber: 104
              }
            },
            identifier
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: styles.message, __source: {
                fileName: _jsxFileName,
                lineNumber: 106
              }
            },
            message
          )
        )
      )
    );
  };

  return InlineDisclaimerBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

InlineDisclaimerBlock.defaultProps = {
  identifier: '*',
  isIdentifierHidden: false,
  showingUnderline: false
};
InlineDisclaimerBlock.propTypes = {
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  identifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  yOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  blockStyling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disclaimerStyling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isIdentifierHidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showingUnderline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isIdentifierHiddenInPopUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
InlineDisclaimerBlock.displayName = 'InlineDisclaimerBlock';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])())(InlineDisclaimerBlock));

var styles = {
  identifier: {
    fontSize: '300%',
    paddingRight: '.5em'
  },
  message: {
    lineHeight: 1.4
  },
  priceDisclaimer: {
    fontWeight: 400,
    position: 'relative',
    top: '0.1em',
    fontSize: '85%',
    lineHeight: 0,
    marginLeft: '.2em',
    textDecoration: __WEBPACK_IMPORTED_MODULE_4_constants_environment__["b" /* HAS_TOUCH */] ? 'underline' : 'none',
    color: '#910A2D',
    ':hover': !__WEBPACK_IMPORTED_MODULE_4_constants_environment__["b" /* HAS_TOUCH */] && {
      textDecoration: 'underline'
    }
  }
};

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\layered-background-image\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/** Renders a set of background images */

var LayeredBackgroundImage = function (_Component) {
  _inherits(LayeredBackgroundImage, _Component);

  function LayeredBackgroundImage(props) {
    _classCallCheck(this, LayeredBackgroundImage);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      bottom: props.imageSrc
    };
    return _this;
  }

  LayeredBackgroundImage.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    var _this2 = this;

    var imageSrc = this.props.imageSrc;

    if (newProps.imageSrc !== imageSrc) {
      this.setState({ bottom: imageSrc, top: false }, function () {
        _this2.setState({ top: newProps.imageSrc });
      });
    }
  };
  /**
   * @param {String} src - URL for image asset.
   * @returns {ReactElement} React Component
   */


  LayeredBackgroundImage.prototype.render = function render() {
    var _state = this.state,
        top = _state.top,
        bottom = _state.bottom;
    var _props = this.props,
        backgroundSize = _props.backgroundSize,
        fill = _props.fill,
        transition = _props.transition;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: [{ position: "relative", zIndex: 0 }, fill && {
          height: "100%",
          width: "100%"
        }],
        "data-test": "layered-background-image", __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: [styles.base], __source: {
            fileName: _jsxFileName,
            lineNumber: 39
          }
        },
        top && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["d" /* BackgroundImage */], {
          backgroundSize: backgroundSize,
          src: top,
          position: "absolute",
          transition: transition,
          zIndex: 2, __source: {
            fileName: _jsxFileName,
            lineNumber: 41
          }
        }),
        bottom && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["d" /* BackgroundImage */], { backgroundSize: backgroundSize, src: bottom, position: "absolute", transition: transition, __source: {
            fileName: _jsxFileName,
            lineNumber: 49
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { opacity: 0, height: "auto", maxWidth: "100%" }, src: bottom, __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        }
      })
    );
  };

  return LayeredBackgroundImage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LayeredBackgroundImage.displayName = "LayeredBackgroundImage";

var styles = {
  base: {
    height: "100%",
    width: "100%",
    position: "absolute",
    pointerEvents: "none"
  }
};

LayeredBackgroundImage.propTypes = {
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  backgroundSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["contain", "cover"]),
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium___["a" /* default */])(LayeredBackgroundImage));

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_in_view__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_in_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_in_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\layered-background-image-autoplay\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/** AutoPlay Layered Background Image Component */

var LayeredBackgroundImageAutoplay = function (_Component) {
  _inherits(LayeredBackgroundImageAutoplay, _Component);

  function LayeredBackgroundImageAutoplay(props) {
    _classCallCheck(this, LayeredBackgroundImageAutoplay);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.inViewHandler = function () {
      if (__WEBPACK_IMPORTED_MODULE_3_in_view___default.a.is(_this.slideshow)) {
        if (!_this.state.playing) {
          _this.setState({ active: 0, playing: true }, function () {
            _this.timerEvent(_this.props.interval);
          });
        }
      } else {
        _this.clearTimerInterval();
      }
    };

    _this.timerEvent = function (interval) {
      _this.interval = setInterval(function () {
        var active = _this.state.active;

        if (!_this.props.loop && active >= _this.itemLength - 1) {
          _this.clearTimerInterval();
        } else {
          _this.handleChange(active + 1);
        }
      }, interval);
    };

    _this.clearTimerInterval = function () {
      _this.setState({ playing: false });
      clearInterval(_this.interval);
    };

    _this.handleChange = function (index) {
      if (_this.props.loop) {
        index = index < 0 ? _this.itemLength - 1 : index;
        index = index > _this.itemLength - 1 ? 0 : index;
      } else {
        index = index < 0 ? 0 : index;
        index = index > _this.itemLength - 1 ? _this.itemLength - 1 : index;
      }
      _this.setState({ active: index });
    };

    _this.state = {
      active: 0
    };
    _this.itemLength = _this.props.imageSrcArray.length;
    _this.inViewHandler = Object(__WEBPACK_IMPORTED_MODULE_4_utils__["M" /* rafThrottle */])(_this.inViewHandler);
    return _this;
  }

  LayeredBackgroundImageAutoplay.prototype.componentDidMount = function componentDidMount() {
    var interval = this.props.interval;

    this.slideshow = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this);
    interval && window.addEventListener('scroll', this.inViewHandler);
    interval && this.inViewHandler();
  };

  LayeredBackgroundImageAutoplay.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.inViewHandler);
    this.inViewHandler.cancel();
  };

  /**
   * @param {Number} [interval] - If set, slides will change automatically with the specified interval.
   * @param {Boolean} [loop=true] - If the slide updates past the final slide, it will loop back to the first (and vise versa).
   * @param {String} [disclaimer] - Dislaimer text as xmlString
   * @param {Array|SlideshowItem} imageSrcArray - Array of imageurls.
   * @returns {ReactElement} React Component
   */
  LayeredBackgroundImageAutoplay.prototype.render = function render() {
    var active = this.state.active;

    var activeImage = this.props.imageSrcArray[active];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: {
          position: this.props.compact ? 'relative' : 'absolute',
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          boxSizing: 'border-box',
          overflow: 'hidden',
          zIndex: '-1',
          top: 0,
          left: 0
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 76
        }
      },
      activeImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_containers__["x" /* LayeredBackgroundImage */], {
        fill: true,
        backgroundSize: this.props.backgroundSize,
        transition: activeImage.transition,
        imageSrc: activeImage.imageSrc, __source: {
          fileName: _jsxFileName,
          lineNumber: 89
        }
      })
    );
  };

  return LayeredBackgroundImageAutoplay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LayeredBackgroundImageAutoplay.displayName = 'LayeredBackgroundImageAutoplay';


LayeredBackgroundImageAutoplay.propTypes = {
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  backgroundSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['contain', 'cover']),
  loop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  imageSrcArray: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

LayeredBackgroundImageAutoplay.defaultProps = {
  loop: true,
  interval: 500
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["b" /* DetectCompact */])({ threshold: 820 })(LayeredBackgroundImageAutoplay));

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents_Button_Button_less__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents_Button_Button_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_AtomicComponents_Button_Button_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents_Typography_Typography_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(40);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\location-tile\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var HoursIcon = function HoursIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5c-4.6 0-8.4-3.8-8.4-8.4S5.4 1.6 10 1.6s8.4 3.8 8.4 8.4zm-1.6 0c0-3.7-3-6.8-6.8-6.8s-6.8 3-6.8 6.8 3 6.8 6.8 6.8c1.8 0 3.5-.7 4.8-2s2-3 2-4.8zm-5.9-.3l3.5 2.2-.9 1.5-4.4-2.7V5h1.7v4.7z", __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    })
  );
};

HoursIcon.displayName = "HoursIcon";
HoursIcon.displayName = "HoursIcon";
var AddressIcon = function AddressIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M17 7.3c0 3.1-1.6 5.5-3.3 7.6-.9 1.1-3.1 4-3.1 4l-.6.9-.7-.9s-2.2-2.9-3.1-4C4.6 12.8 3 10.4 3 7.3 3 3.4 6.2.2 10 .2s7 3.2 7 7.1zm-1.6-.1c0-3-2.4-5.4-5.4-5.4S4.6 4.3 4.6 7.2c0 2.4 1.1 4.2 2.9 6.6.6.8 1.7 2.2 2.4 3.2.7-1 1.9-2.4 2.4-3.2 2-2.3 3.1-4.2 3.1-6.6zm-3.2-.6c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2.9 2.2 2.2z", __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    })
  );
};

AddressIcon.displayName = "AddressIcon";
AddressIcon.displayName = "AddressIcon";
var WebsiteIcon = function WebsiteIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5-4.3-1-5.9-2.5-2.5-3.7-2.5-6 1-4.4 2.5-6 3.7-2.5 6-2.5c2.2 0 4.4.9 6 2.5s2.4 3.8 2.4 6zM3.3 9.1h2.8c0-1.8.4-3.5.9-4.8.1-.2.2-.3.2-.5-.8.3-1.4.8-2 1.4-1.1 1.1-1.7 2.5-1.9 3.9zm1.9 5.7c.6.6 1.3 1.1 2 1.4 0-.2-.1-.3-.2-.5-.5-1.3-.9-3-.9-4.8H3.3c.2 1.4.8 2.8 1.9 3.9zM10 3.2c-.3 0-.9.5-1.4 1.7-.4 1.2-.7 2.6-.8 4.2h4.4c-.1-1.6-.4-3.1-.8-4.2 0-.1-.1-.1-.1-.2.8.2 1.5.6 2.2 1.1.2 1 .4 2.1.5 3.3h2.8c-.2-1.5-.8-2.9-1.9-3.9-1.4-1.3-3.1-2-4.9-2zm1.4 11.9c.5-1.1.7-2.6.8-4.2H7.8c.1 1.6.4 3.1.8 4.2.5 1.3 1.1 1.7 1.4 1.7s.9-.5 1.4-1.7zm5.3-4.2h-2.8c-.1 1.8-.4 3.5-.9 4.8-.1.2-.2.4-.2.5.8-.3 1.4-.8 2-1.4 1.1-1.1 1.7-2.5 1.9-3.9z", __source: {
        fileName: _jsxFileName,
        lineNumber: 27
      }
    })
  );
};

WebsiteIcon.displayName = "WebsiteIcon";
WebsiteIcon.displayName = "WebsiteIcon";
var PhoneIcon = function PhoneIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M1.4 14.7c-.3-.9 0-1.5.9-1.9.6-.3 1.5-.7 2.2-1 .5-.2 1-.5 1.4-.6.2-.1.4-.2.7-.2.5 0 .9.4 1 .5l.9.9c.5-.3 1.4-.9 2.2-1.7s1.4-1.7 1.7-2.2l-.9-.9c-.7-.6-.6-1.2-.3-1.8.2-.4.4-.8.6-1.4.3-.7.7-1.6 1-2.2.1-.3.4-1 1.2-1 .2 0 .4.1.6.1 2 .6 4 2.1 4 4.2 0 2-1.6 5.7-4.6 8.6-3 3-6.6 4.6-8.6 4.6-1.9.1-3.5-2-4-4zm1.5-.4c.4 1.4 1.5 2.9 2.6 2.9 1.4 0 4.7-1.3 7.6-4.1 2.8-2.8 4.1-6.1 4.1-7.6 0-1.1-1.5-2.2-2.9-2.6-.3.6-.7 1.5-1 2.2-.2.5-.5 1-.6 1.3v.1l1.7 1.7-.2.5c0 .1-.8 1.6-2.3 3.1-1.5 1.5-3 2.2-3.1 2.3l-.5.2-1.7-1.7h-.1c-.3.2-.8.4-1.3.6-.9.4-1.7.8-2.3 1.1z", __source: {
        fileName: _jsxFileName,
        lineNumber: 33
      }
    })
  );
};

PhoneIcon.displayName = "PhoneIcon";
PhoneIcon.displayName = "PhoneIcon";
var InfoIcon = function InfoIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5c-4.6 0-8.4-3.8-8.4-8.4 0-2.2.9-4.4 2.5-6s3.7-2.5 6-2.5c4.6 0 8.4 3.8 8.4 8.4zm-1.6 0c0-3.7-3-6.8-6.8-6.8-1.8 0-3.5.7-4.8 2s-2 3-2 4.8c0 3.7 3 6.8 6.8 6.8 1.8 0 3.5-.7 4.8-2s2-3 2-4.8zM9.1 5.7h1.7v1.7H9.1V5.7zm0 2.8h1.7v5.8H9.1V8.5z", __source: {
        fileName: _jsxFileName,
        lineNumber: 39
      }
    })
  );
};

InfoIcon.displayName = "InfoIcon";
InfoIcon.displayName = "InfoIcon";
var PlusIcon = function PlusIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ width: "14", height: "14", viewBox: "0 0 14 14" }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M6 0v6H0v2h6v6h2V8h6V6H8V0z", fillRule: "evenodd", __source: {
        fileName: _jsxFileName,
        lineNumber: 45
      }
    })
  );
};

PlusIcon.displayName = "PlusIcon";
PlusIcon.displayName = "PlusIcon";

var LocationTile = function (_PureComponent) {
  _inherits(LocationTile, _PureComponent);

  function LocationTile() {
    _classCallCheck(this, LocationTile);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.icon = function (name, moreStyles) {
      var style = _extends({
        height: "1.3em",
        width: "1.3em",
        fill: "#999999",
        flexShrink: 0
      }, moreStyles);
      switch (name) {
        case "hours":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HoursIcon, { style: style, __source: {
              fileName: _jsxFileName,
              lineNumber: 71
            }
          });
        case "address":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddressIcon, { style: style, __source: {
              fileName: _jsxFileName,
              lineNumber: 73
            }
          });
        case "website":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WebsiteIcon, { style: style, __source: {
              fileName: _jsxFileName,
              lineNumber: 75
            }
          });
        case "phone":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PhoneIcon, { style: style, __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          });
        case "info":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoIcon, { style: style, __source: {
              fileName: _jsxFileName,
              lineNumber: 79
            }
          });
        case "plus":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlusIcon, { style: style, __source: {
              fileName: _jsxFileName,
              lineNumber: 81
            }
          });
      }
    };

    _this.handleInteraction = function (event) {
      var onClick = _this.props.onClick;

      if (event.type === "keydown" && event.key !== "Enter") return;
      onClick(event, function () {
        _this.forceUpdate();
      });
    };

    _this.handleMouseEnter = function () {
      _this.props.mouseEnter(_this.props.index);
      _this.setState({ isHovered: true });
    };

    _this.handleMouseLeave = function () {
      _this.props.mouseLeave(_this.props.index);
      _this.setState({ isHovered: false });
    };

    _this.renderDetail = function (detail, index) {
      var _this$props = _this.props,
          compact = _this$props.compact,
          active = _this$props.active;

      var labels = Array.isArray(detail.label) ? detail.label : [detail.label];
      if (compact && !active && detail.name === "hours") return;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { key: index, style: [styles.detailItem, styles.fadeIn], __source: {
            fileName: _jsxFileName,
            lineNumber: 104
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.iconWrapper, __source: {
              fileName: _jsxFileName,
              lineNumber: 105
            }
          },
          _this.icon(detail.name)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 106
            }
          },
          detail.name === "hours" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 107
              }
            },
            "Opening hours:"
          ),
          detail.href ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["H" /* Hyperlink */], {
            key: index,
            text: detail.label,
            href: detail.href,
            external: detail.external, __source: {
              fileName: _jsxFileName,
              lineNumber: 109
            }
          }) : labels.map(function (label, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 115
                }
              },
              label
            );
          })
        )
      );
    };

    _this.state = {
      activeIndex: 0,
      isHovered: false
    };
    return _this;
  }

  LocationTile.prototype.componentDidMount = function componentDidMount() {
    this.props.getFirstLocationTileHeight && this.props.getFirstLocationTileHeight(this.element.offsetHeight);
  };

  LocationTile.prototype.fullAddress = function fullAddress() {
    var _props = this.props,
        address = _props.address,
        suburb = _props.suburb,
        state = _props.state,
        postCode = _props.postCode;

    var region = Object(__WEBPACK_IMPORTED_MODULE_9_utils__["f" /* compact */])([state, postCode]).join(" ");
    return Object(__WEBPACK_IMPORTED_MODULE_9_utils__["g" /* compactMap */])(__WEBPACK_IMPORTED_MODULE_9_utils__["T" /* titleCase */], [address, suburb]).concat(region || []).join(", ");
  };

  LocationTile.prototype.addressHref = function addressHref() {
    return "https://google.com.au/maps?q=" + this.fullAddress().replace(/ /g, "+") + "/";
  };

  LocationTile.prototype.render = function render() {
    var _this2 = this,
        _classnames,
        _classnames2;

    var _props2 = this.props,
        displayHours = _props2.displayHours,
        message = _props2.message,
        name = _props2.name,
        compact = _props2.compact,
        salesCTA = _props2.salesCTA,
        serviceCTA = _props2.serviceCTA,
        emailCTA = _props2.emailCTA,
        selectCTA = _props2.selectCTA,
        websiteLabel = _props2.websiteLabel,
        website = _props2.website,
        active = _props2.active,
        primaryCTA = _props2.primaryCTA,
        departments = _props2.departments,
        disableCategories = _props2.disableCategories,
        customDealerDescription = _props2.customDealerDescription,
        _props2$animateHeight = _props2.animateHeight,
        animateHeight = _props2$animateHeight === undefined ? true : _props2$animateHeight,
        gtmEvent = _props2.gtmEvent,
        gtm = _props2.gtm;

    var department = void 0;
    department = departments[localStorage.getItem('activeTabIndex') || this.state.activeIndex];
    var primaryButton = void 0;
    if (department) {
      primaryButton = primaryCTA || department.name !== "Parts" && (department.name === "Sales" ? salesCTA : serviceCTA);
    } else {
      department = departments[0];
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        "data-test": "location-tile",
        "data-status": active ? "selected" : "deselected",
        style: animateHeight ? [styles.wrapper(this.element && this.element.offsetHeight || 0)] : [],
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave, __source: {
          fileName: _jsxFileName,
          lineNumber: 165
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: [{
            padding: compact ? "2em" : "3em 4vw",
            display: "block",
            transition: "background .1s",
            cursor: "pointer",
            outline: 0
          }, active && { background: "#fff" }],
          ref: function ref(c) {
            _this2.element = c;
          },
          onClick: this.handleInteraction, __source: {
            fileName: _jsxFileName,
            lineNumber: 171
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { display: "flex", justifyContent: "space-between" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 186
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["a" /* A */],
            {
              withoutStyle: true,
              tabIndex: 0,
              onKeyDown: this.handleInteraction,
              style: styles.headingLink(active, this.state.isHovered), __source: {
                fileName: _jsxFileName,
                lineNumber: 187
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["C" /* H5 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 192
                }
              },
              name
            )
          )
        ),
        compact && active && selectCTA,
        compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          {
            style: {
              color: "#910A2D",
              fontWeight: "200",
              margin: "1em 0",
              lineHeight: "1.4"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 199
            }
          },
          message
        ),
        customDealerDescription ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { margin: "1em 0 2em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 210
            }
          },
          customDealerDescription
        ) : !disableCategories && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { marginLeft: "-0.5em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 213
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["_11" /* Tabs */], {
            compact: true,
            divider: true,
            options: departments,
            active: this.state.activeIndex,
            onChange: function onChange(option, index) {
              Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                pageCategory: gtm && gtm.category ? gtm.category : null,
                pageAction: gtm && gtm.action ? gtm.action : gtm && gtm.category ? gtm.category + " - " + name + " - Clicked \"DEPARTMENT MENU " + departments[index].name.toUpperCase() + "\" - " + _this2.fullAddress() : null
              });
              _this2.setState({ activeIndex: index });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 214
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          { style: { padding: 0, listStyleType: "none", margin: "1.5em 0" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 229
            }
          },
          this.fullAddress() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { style: [styles.detailItem, styles.fadeIn], __source: {
                fileName: _jsxFileName,
                lineNumber: 231
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.iconWrapper, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 232
                }
              },
              this.icon("address")
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 233
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["H" /* Hyperlink */], {
                text: this.fullAddress(),
                href: this.addressHref(),
                external: true,
                gtm: {
                  category: gtm && gtm.category ? gtm.category : null,
                  action: gtm && gtm.action ? gtm.action : gtm && gtm.category ? gtm.category + " - " + name + " - Clicked \"ADDRESS " + this.fullAddress().toUpperCase() + "\" - " + departments.map(function (d) {
                    return d.name;
                  }).toString() + " - " + this.fullAddress() : null
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 234
                }
              })
            )
          ),
          displayHours && department.hours.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { style: [styles.detailItem, styles.fadeIn], __source: {
                fileName: _jsxFileName,
                lineNumber: 247
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.iconWrapper, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 248
                }
              },
              this.icon("hours")
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 249
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "strong",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 250
                  }
                },
                "Opening hours:"
              ),
              department.hours.map(function (label, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { style: { margin: ".3em 0" }, key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 252
                    }
                  },
                  label
                );
              })
            )
          ),
          active && websiteLabel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { style: [styles.detailItem, styles.fadeIn], __source: {
                fileName: _jsxFileName,
                lineNumber: 261
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.iconWrapper, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 262
                }
              },
              this.icon("website")
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 263
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["H" /* Hyperlink */], {
                text: websiteLabel,
                href: website,
                external: true,
                gtm: {
                  category: gtm && gtm.category ? gtm.category : null,
                  action: gtm && gtm.action ? gtm.action : gtm && gtm.category ? gtm.category + " - " + name + " - Clicked \"WEBSITE " + websiteLabel.toUpperCase() + "\" - " + departments.map(function (d) {
                    return d.name;
                  }).toString() + " - " + this.fullAddress() : null
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 264
                }
              })
            )
          ),
          active && department.phone && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { style: [styles.detailItem, styles.fadeIn], __source: {
                fileName: _jsxFileName,
                lineNumber: 277
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.iconWrapper, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 278
                }
              },
              this.icon("phone")
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 279
                }
              },
              compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["H" /* Hyperlink */], {
                text: Object(__WEBPACK_IMPORTED_MODULE_9_utils__["p" /* formatPhoneNumber */])(department.phoneLabel),
                href: "tel:" + department.phone,
                gtm: {
                  category: gtm && gtm.category ? gtm.category : null,
                  action: gtm && gtm.action ? gtm.action : gtm && gtm.category ? gtm.category + " - " + name + " - Clicked \"PHONE " + department.phoneLabel + "\" - " + departments.map(function (d) {
                    return d.name;
                  }).toString() + " - " + this.fullAddress() : null
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 281
                }
              }),
              !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 289
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_9_utils__["p" /* formatPhoneNumber */])(department.phoneLabel)
              )
            )
          ),
          !active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { style: [styles.detailItem, styles.fadeIn], __source: {
                fileName: _jsxFileName,
                lineNumber: 294
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.iconWrapper, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 295
                }
              },
              this.icon("plus", {
                height: "14px",
                width: "14px",
                fill: "#101010"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 302
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["H" /* Hyperlink */], {
                text: "More Info",
                style: {
                  color: "#101010",
                  fontWeight: "400",
                  ":hover": { color: "#484848" }
                },
                onClick: this.handleInteraction, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 303
                }
              })
            )
          )
        ),
        active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: [styles.fadeIn,, styles.buttons(compact)], __source: {
              fileName: _jsxFileName,
              lineNumber: 316
            }
          },
          primaryButton && primaryButton.label && (primaryButton.isMyMazdaLink ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */],
            {
              to: primaryButton.href,
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_5_AtomicComponents_Typography_Typography_less___default.a.withoutStyle] = true, _classnames)),
              style: { textDecoration: "none" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 321
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              {
                className: "Button " + __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames2 = {}, _classnames2[__WEBPACK_IMPORTED_MODULE_4_AtomicComponents_Button_Button_less___default.a.Button] = true, _classnames2[__WEBPACK_IMPORTED_MODULE_4_AtomicComponents_Button_Button_less___default.a.ButtonBlackOutlined] = primaryButton.styleName === "blackOutlined", _classnames2[__WEBPACK_IMPORTED_MODULE_4_AtomicComponents_Button_Button_less___default.a.ButtonBlack] = primaryButton.styleName === "black", _classnames2)),
                onClick: function onClick() {
                  Object(__WEBPACK_IMPORTED_MODULE_3_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: gtm && gtm.category ? gtm.category : "MyMazda - Dealer",
                    pageAction: "DEALER BLOCK - clicked \"" + primaryButton.label.toUpperCase() + "\""
                  });
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 327
                }
              },
              primaryButton.label
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["e" /* Button */], _extends({}, primaryButton, {
            display: compact ? "block" : "inline",
            gtm: {
              category: gtm && gtm.category ? gtm.category : null,
              action: gtm && gtm.action ? gtm.action : gtm && gtm.category ? gtm.category + " - " + name + " - Clicked \"CTA BUTTON " + primaryButton.label.toUpperCase() + "\" - " + departments.map(function (d) {
                return d.name;
              }).toString() + " - " + this.fullAddress() : null
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 345
            }
          }))),
          emailCTA && department.email && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { padding: compact ? '16px 0 0 0' : '0 0 0 16px' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 356
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["e" /* Button */], _extends({}, emailCTA, {
              href: "mailto:" + department.email,
              display: compact ? "block" : "inline",
              gtm: {
                category: gtm && gtm.category ? gtm.category : null,
                action: gtm && gtm.action ? gtm.action : gtm && gtm.category ? gtm.category + " - " + name + " - Clicked \"CTA BUTTON " + emailCTA.label.toUpperCase() + "\" - " + departments.map(function (d) {
                  return d.name;
                }).toString() + " - " + this.fullAddress() : null
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 357
              }
            }))
          ),
          !compact && active && selectCTA
        ),
        !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          {
            style: {
              color: "#910A2D",
              fontWeight: "200",
              margin: "1em 0",
              lineHeight: "1.4"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 371
            }
          },
          message
        )
      )
    );
  };

  return LocationTile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

LocationTile.displayName = "LocationTile";


LocationTile.defaultProps = {
  displayHours: true,
  displayExpand: true,
  mouseEnter: function mouseEnter() {},
  mouseLeave: function mouseLeave() {}
};

LocationTile.propTypes = {
  displayHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  departments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  mouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  suburb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  postCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  website: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  websiteLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disableCategories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  serviceCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  primaryCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  salesCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  emailCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  customDealerDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getFirstLocationTileHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["i" /* gtmEvent */])())(LocationTile));

var animationDuration = function animationDuration(height, speed) {
  var calculated = height / 100 / speed;
  if (calculated > 0.666 && calculated < 1.5) return calculated;
  return calculated > 1.5 ? 1.5 : 0.666;
};

var fadeInKeyframes = Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["j" /* keyframes */])({
  from: {
    opacity: 0
  }
});

var styles = {
  iconWrapper: {
    marginRight: "1em",
    display: "flex",
    width: "1.3em",
    justifyContent: "center"
  },
  detailItem: {
    display: "flex",
    fontWeight: 200,
    margin: "1em 0",
    lineHeight: "1.4"
  },
  compactMain: {
    flexDirection: "column"
  },
  main: {
    maxHeight: "calc(100vh - 101px)"
  },
  fadeIn: {
    display: 'flex',
    animation: "x .666s",
    animationName: fadeInKeyframes
  },
  buttons: function buttons(compact) {
    return {
      flexDirection: compact ? 'column' : 'row'
    };
  },
  detailsPanel: { flex: "0 0 50%", overflowY: "scroll" },
  compactMapPanel: { height: "100vw", order: "-1" },
  mapPanel: { flex: "0 0 50%" },
  headingLink: function headingLink(active, isHovered) {
    return {
      color: active || isHovered ? "#101010" : "#999999",
      transition: "color .66s",
      ":focus": {
        textDecoration: "underline",
        outline: 0
      }
    };
  },
  wrapper: function wrapper(height) {
    return {
      transition: "opacity " + animationDuration(height, 10) + "s",
      height: height,
      overflow: "hidden"
    };
  }
};

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_google_map_react_utils__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_google_map_react_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_google_map_react_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_google_maps__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apis_dealer_search__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_actions_environment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apis_expose_global__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__header_section__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__locations_section__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_AtomicUtils_fetchAPI__ = __webpack_require__(21);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\map-location\\index.jsx",
    _mapPanel;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var MapLocationContainer = function (_PureComponent) {
  _inherits(MapLocationContainer, _PureComponent);

  function MapLocationContainer(props) {
    var _this2 = this;

    _classCallCheck(this, MapLocationContainer);

    // locationState comes from backend
    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.handleToggleFilter = function (option) {
      var eventID = "FED-FAD-";
      switch (option.slug) {
        case "sales":
          eventID += "002";
          break;
        case "service":
          eventID += "004";
          break;
        case "parts":
          eventID += "006";
          break;
        default:
          return null;
      }
      _this.props.gtmEvent({
        gtmID: _this.props.gtmMapping.CHECK_DEALERTYPE,
        gtmPayload: { dealerType: option.name, eventID: eventID }
      });
      var selectedFilters = _extends({}, _this.state.selectedFilters);
      Object.keys(selectedFilters).map(function (key) {
        selectedFilters[key] = false;
      });
      selectedFilters[option.slug] = !selectedFilters[option.slug];
      _this.setState({ selectedFilters: selectedFilters }, function () {
        _this.props.search.pushParam({ department: option.slug });
        // this.updateLocations()
        var optionName = option.slug.toUpperCase();
        var indexVal = '';
        if (optionName == 'SALES') indexVal = 0;
        if (optionName == 'SERVICE') indexVal = 1;
        if (optionName == 'PARTS') indexVal = 2;
        localStorage.setItem('activeTabIndex', indexVal);

        _this.updateLocationsOnFiltersToggle();
      });
    };

    _this.getSelectedDealer = function () {
      return {
        selected: _this.state.locations[_this.state.activeIndex],
        totalCount: _this.state.locations.length
      };
    };

    _this.handleClickOnLocation = function (index) {
      var scrollToActiveTileOrNot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      // reset all hovers -> it was a bug in devices
      if (!_this.props.compact) {
        _this.handleMouseLeaveOnLocation();
      }
      _this.setState(_extends({
        activeIndex: index
      }, !_this.state.didEdit ? { didEdit: true } : {}), function () {
        // Scroll to the right location tile
        if (scrollToActiveTileOrNot) _this.handleScrollToActiveLocation();
        // Blur function closes mobile keyboard
        scrollToActiveTileOrNot && __WEBPACK_IMPORTED_MODULE_4_constants_environment__["a" /* DOCUMENT */] && __WEBPACK_IMPORTED_MODULE_4_constants_environment__["a" /* DOCUMENT */].activeElement && __WEBPACK_IMPORTED_MODULE_4_constants_environment__["a" /* DOCUMENT */].activeElement.blur && __WEBPACK_IMPORTED_MODULE_4_constants_environment__["a" /* DOCUMENT */].activeElement.blur();
        // Scroll to this section for concentration
        !_this.props.compact && scrollToActiveTileOrNot && Object(__WEBPACK_IMPORTED_MODULE_9_utils__["P" /* scrollToNode */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_dom__["findDOMNode"])(_this));
        _this.props.onDealerChange(_this.getSelectedDealer());

        callback();
      });
    };

    _this.handleMouseEnterOnLocation = function (index) {
      var newLocations = _this.state.locations.slice(0);
      newLocations.map(function (item, locationIndex) {
        item.hover = locationIndex === index;
      });
      newLocations[index] = _extends({}, newLocations[index], { hover: true });
      _this.setState({ locations: newLocations, fresh: !_this.state.fresh });
    };

    _this.handleMouseLeaveOnLocation = function () {
      var newLocations = _this.state.locations.slice(0);
      newLocations.map(function (item, locationIndex) {
        item.hover = false;
      });
      _this.setState({ locations: newLocations, fresh: !_this.state.fresh });
    };

    _this.handleScrollToActiveLocation = function () {
      if (!__WEBPACK_IMPORTED_MODULE_4_constants_environment__["c" /* IS_BROWSER */] || !_this.activeTileRef) return;
      Object(__WEBPACK_IMPORTED_MODULE_9_utils__["P" /* scrollToNode */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_dom__["findDOMNode"])(_this.activeTileRef), {
        container: _this.props.compact ? "body, html" : Object(__WEBPACK_IMPORTED_MODULE_11_react_dom__["findDOMNode"])(_this.detailsPanelRef)
      });
    };

    _this.calculateBoundsAndZommLevelBasedOnLocations = function () {
      if (!_this.props.compact) {
        var bounds = {};
        var map = _extends({}, _this.state.map);
        if (_this.state.locations.length < 1) {
          bounds.zoom = map.zoom;
          bounds.center = map.center;
        } else {
          var dimensions = {
            height: _this.mapRef ? _this.mapRef.clientHeight : 1,
            width: _this.mapRef ? _this.mapRef.clientWidth : 1
          };
          var allLatitudes = [];
          var allLongitudes = [];
          for (var _iterator = _this.state.locations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var marker = _ref;

            allLatitudes.push(marker.lat);
            allLongitudes.push(marker.lng);
          }
          var northWest = {
            lat: Math.max.apply(Math, allLatitudes),
            lng: Math.min.apply(Math, allLongitudes)
          };
          var southEast = {
            lat: Math.min.apply(Math, allLatitudes),
            lng: Math.max.apply(Math, allLongitudes)
          };
          if (Object.keys(northWest).every(function (key, index) {
            return northWest[key] === southEast[key];
          })) {
            bounds = { center: northWest };
            bounds.zoom = _this.props.defaultZoom;
          } else {
            bounds = Object(__WEBPACK_IMPORTED_MODULE_2_google_map_react_utils__["fitBounds"])({ nw: northWest, se: southEast }, dimensions);
            bounds.zoom -= 1;
          }
          bounds.zoom = bounds.zoom > _this.props.defaultZoom ? _this.props.defaultZoom : bounds.zoom;
          if (!_this.mapRef) delete bounds.zoom;
        }
        map.zoom = bounds.zoom;
        map.center = bounds.center;
        // This should resolve immediately and not refetch once the api is loaded the first time
        Object(__WEBPACK_IMPORTED_MODULE_5_apis_google_maps__["c" /* getGoogleMapsApi */])().then(function () {
          return _this && _this.setState({ map: map });
        });
      }
    };

    _this.updateLocations = function () {
      console.log('update locations state');
      console.log(_this.state);
      var dealerTypes = Object.keys(_this.state.selectedFilters).map(function (key) {
        if (_this.state.selectedFilters[key] === true) {
          return key;
        }
      }).filter(function (result) {
        return !!result;
      });
      _this.setState({
        loadingLocations: true
      }, function () {
        var _console;

        console.log('update locations search Input');
        (_console = console).log.apply(_console, _this.state.searchInput);
        console.log('update locations dealer types');
        console.log(dealerTypes);
        Object(__WEBPACK_IMPORTED_MODULE_6_apis_dealer_search__["a" /* dealerInfo */])(_extends({}, _this.state.searchInput, { dealerTypes: dealerTypes })).then(function (_ref2) {
          var response = _ref2.response;
          return _this.setState({
            locations: response || [],
            loadingLocations: false
          }, function () {

            if (!_this.props.compact) {
              _this.calculateBoundsAndZommLevelBasedOnLocations();
            }
            if (_this.props.autoSelectDealer) {
              // Click on the first one with scrolling to the first one
              _this.handleClickOnLocation(0, false);
            } else {
              _this.setState({ activeIndex: -1 });
            }
          });
        }).catch(console.warn.bind(console));
      });
    };

    _this.searchDealers = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(search) {
        var service;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                service = '/api/dealer-search';
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_16_AtomicUtils_fetchAPI__["a" /* default */])({
                  method: "POST",
                  url: service,
                  body: {
                    searchText: search.suburb
                  }
                }).then(function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                    var json, success, data, _success, _data;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return response.json();

                          case 2:
                            json = _context.sent;
                            success = json.success, data = json.data;

                            if (success) {
                              _success = json.success, _data = json.data;

                              console.log('dealer-search response map-location');
                              console.log(json);
                              if (_success && json.data && json.data.length > 0) {
                                console.log('setting dealer code');
                                _this.setState({
                                  searchInput: {
                                    dealerCode: json.data[0].value,
                                    postcode: search.postcode
                                  }
                                }, function () {
                                  _this.updateLocations();
                                });
                              }
                            }

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x4) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.updateLocationInSearchInput = function (search) {
      if (!search) return;

      console.log('updateLocationInSearchInput - map location');
      console.log('updateLocationInSearchInput - map location' + JSON.stringify(search));
      if (!search.postcode && !search.dealerCode) {
        _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this.searchDealers(search);

                case 2:
                  return _context3.abrupt("return", _context3.sent);

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, _this2);
        }))();
        search.dealerCode = _this.state.dealerCode;
      } else {
        _this.setState({
          searchInput: {
            dealerCode: search.dealerCode,
            postcode: search.postcode
          }
        }, function () {
          _this.updateLocations();
        });
      }
    };

    _this.handleSelectDropDown = function (value, isOnLoad) {
      var activeIndexOfStates = 0;
      for (var i = 0; i < _this.state.uniqStates.length; i += 1) {
        if (_this.state.uniqStates[i].name === value.name) {
          activeIndexOfStates = i;
        }
      }
      _this.setState({
        activeIndexOfStates: activeIndexOfStates
      }, function () {
        _this.handleFilterLocations(value, function () {
          if (!_this.props.compact) {
            _this.calculateBoundsAndZommLevelBasedOnLocations();
            // we don't want anything to be highlighted after changing state
            _this.handleMouseLeaveOnLocation();
          }
        });
      });
      // We don't want a GTM event to fire on first load, hence the checking.
      if (!isOnLoad) {
        _this.props.gtmEvent({
          gtmID: __WEBPACK_IMPORTED_MODULE_13_store_gtm_events__["h" /* gtmMapCampaignBlockActionTypes */].SELECT_FILTER_OPTION,
          gtmPayload: { option: value.name }
        });
      }
    };

    _this.createUniqueStates = function (next) {
      var uniqStates = ["All States"];
      for (var _iterator2 = _this.state.locations, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref6;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref6 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref6 = _i2.value;
        }

        var single = _ref6;

        if (uniqStates.indexOf(single.state) <= -1) {
          uniqStates.push(single.state);
        }
      }
      _this.setState({
        uniqStates: uniqStates.map(function (item) {
          return { name: item };
        })
      }, next);
    };

    _this.handleFilterLocations = function (value, next) {
      if (value.name !== "All States" && _this.state.uniqStates.map(function (item) {
        return item.name;
      }).includes(value.name)) {
        _this.setState({
          locations: _this.state.backupLocations.filter(function (item) {
            return item.state === value.name;
          })
        }, function () {
          if (typeof next === "function") next();
        });
      } else {
        _this.setState({
          locations: _this.state.backupLocations
        }, function () {
          next();
        });
      }
    };

    _this.updateLocationsOnFiltersToggle = function () {
      setTimeout(function () {
        var department = '';
        var qs = _this.getUrlParameter("department");
        department = qs.toUpperCase();
        var filteredData = [];

        if (!qs || qs === '') department = 'SALES';

        filteredData = _this.state.originalLocations.filter(function (item) {
          var departmentMatch = item.departments.find(function (dep) {
            return dep.name.toUpperCase() === department;
          });

          if (departmentMatch) return item;
        });

        _this.setState({
          locations: filteredData,
          activeIndex: -1
        });

        setTimeout(function () {
          _this.calculateBoundsAndZommLevelBasedOnLocations();
        }, 250);
      }, 100);
    };

    _this.handleNZLocations = function (data) {
      var originalSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // first item is active by default
      _this.setState({
        locations: data,
        activeIndex: data.length > 1 ? -1 : 0
      });

      if (originalSet.length > 0) {
        _this.setState({
          originalLocations: originalSet
        });
      }

      // better in case google map isn't loaded yet
      _this.mapInterval = setInterval(_this.mapFunction, 100);
    };

    _this.mapFunction = function () {
      if ((typeof google === "undefined" ? "undefined" : _typeof(google)) === 'object' && _typeof(google.maps) === 'object') {
        _this.calculateBoundsAndZommLevelBasedOnLocations();
        clearInterval(_this.mapInterval);
      }
    };

    _this.getUrlParameter = function (name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    _this.state = {
      fresh: true,
      activeIndex: -1,
      activeIndexOfStates: 0,
      locations: props.locations || [],
      originalLocations: [],
      hovers: [],
      searchInput: {
        postcode: props.locationState.postcode ? String(props.locationState.postcode) : ""
      },
      map: {
        center: {
          lat: props.locationState.latitude || -37.8390361,
          lng: props.locationState.longitude || 144.9997397
        },
        zoom: props.defaultZoom
      },
      defaultCenter: { lat: -37.8390361, lng: 144.9997397 },
      selectedFilters: props.initialSelectedFilters || {
        sales: true,
        service: false,
        parts: false
      },
      didEdit: false,
      filters: [{ name: "Sales", slug: "sales" }, { name: "Service", slug: "service" }, { name: "Parts", slug: "parts" }],
      dealerCode: null // For an unknown reason, component didn't update by chaning inside the json, so this helps the component to be updated // This is for showing the first impression before entering anything
    };return _this;
  }

  // Handling filters of Sales/Service/Parts


  MapLocationContainer.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    // TODO: WE NEED TO GET RID OF THIS API!
    Object(__WEBPACK_IMPORTED_MODULE_10_apis_expose_global__["a" /* default */])("getSelectedLocation", function () {
      return {
        locations: _this3.state.locations,
        selectedLocation: _this3.state.locations[_this3.state.activeIndex]
      };
    });

    // Initial Load when we have a select states
    if (this.props.searchType === "select") {
      if (this.props.dealerLocations.length > 0) {
        var newDealers = this.props.dealerLocations.map(function (item) {
          return _extends({}, item, {
            lat: Number(item.lat),
            lng: Number(item.lng)
          });
        });
        this.setState({
          locations: newDealers,
          backupLocations: newDealers
        }, function () {
          _this3.createUniqueStates(function () {
            if (__WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].localStorage.getItem("state")) {
              _this3.handleSelectDropDown({
                name: __WEBPACK_IMPORTED_MODULE_4_constants_environment__["i" /* WINDOW */].localStorage.getItem("state")
              }, true);
            } else {
              if (!_this3.props.compact) {
                _this3.calculateBoundsAndZommLevelBasedOnLocations();
              }
            }
          });
        });
      }
    }

    // Initial Load when we have a search dealer input
    if (this.props.searchType === "search") {
      var initialDepartment = this.props.search.query.department;
      var departments = { sales: false, service: false, parts: false };
      if (initialDepartment) {
        departments[initialDepartment] = true;
        this.setState({ selectedFilters: departments });
      }
      setTimeout(function () {
        if (_this3.state.searchInput.postcode != "") {
          console.log('map location initial load');
          console.log(_this3.state.searchInput);

          _this3.updateLocationInSearchInput(_this3.state.searchInput);
        }
        if (_this3.props.scrollToMain) {
          Object(__WEBPACK_IMPORTED_MODULE_9_utils__["P" /* scrollToNode */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_dom__["findDOMNode"])(_this3.node));
        }
      }, 100);
    }

    // locations are sent by parent
    if (this.props.searchType === "nothing") {
      setTimeout(function () {
        // Click on the first one with scrolling to the first one
        _this3.handleClickOnLocation(0, false);
        if (!_this3.props.compact) {
          _this3.calculateBoundsAndZommLevelBasedOnLocations();
        }
      }, 100);
    }
  };

  // Get Dealer


  // Handle Click on Each Location Tile for Showing on the Map
  // no scrolling for nz maps (all loaded on one map)


  // for handling mouse entering on locations to change marker to become red


  // for handling mouse leaving on locations to change marker to become red
  // Removed index because it was better to reset all hovers to become false


  // Scroll to the location which is selected


  // Calculating the center of the map with zoomLevel


  MapLocationContainer.prototype.render = function render() {
    var _this4 = this;

    var activeFilterIndex = 0;
    for (var i = 0; i < this.state.filters.length; i += 1) {
      if (this.state.selectedFilters[this.state.filters[i].slug]) {
        activeFilterIndex = i;
      }
    }
    var SearchSection = function SearchSection() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__header_section__["a" /* default */], {
        heading: _this4.props.heading,
        description: _this4.props.description,
        searchInput: _this4.state.searchInput || {},
        dealerSearchEndPoint: _this4.props.dealerSearchEndPoint,
        updateLocationInSearchInput: _this4.updateLocationInSearchInput,
        gtmMapping: _this4.props.gtmMapping,
        disableFilters: _this4.props.disableFilters,
        searchOverride: _this4.props.searchOverride,
        filters: _this4.state.filters,
        handleToggleFilter: _this4.handleToggleFilter,
        activeIndex: activeFilterIndex,
        searchType: _this4.props.searchType,
        dropDownDisabled: _this4.props.dropDownDisabled,
        handleSelectDropDown: _this4.handleSelectDropDown,
        activeIndexOfStates: _this4.state.activeIndexOfStates,
        uniqStates: _this4.state.uniqStates,
        dropDownLabel: _this4.props.dropDownLabel,
        handleNZLocations: _this4.handleNZLocations, __source: {
          fileName: _jsxFileName,
          lineNumber: 519
        }
      });
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        key: "MapLocationContainer",
        ref: function ref(node) {
          _this4.node = node;
        },
        style: [!this.props.mapFixHeight && this.props.compact ? styles.mapBlockContainerCompact : styles.mapBlockContainerNotCompact, this.props.mapFixHeight && { display: "block", minHeight: "1px" }, // 1px required for the map to show on Safari
        !this.props.mapFixHeight && styles.main(this.props.globalHeaderHeight)], __source: {
          fileName: _jsxFileName,
          lineNumber: 540
        }
      },
      this.props.searchType != "nothing" && this.props.displaySearchTop && SearchSection(),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: [{ flex: "1 1 100%" }, styles.locationsAndMapContainer, this.props.compact && styles.locationsAndMapContainerCompactMode, styles.map(this.props.isMapFirstInCompact, this.props.mapFixHeightStyle), {
            visibility: this.props.hideWhenNoLocation && this.state.locations.length === 0 ? "hidden" : "visible"
          }], __source: {
            fileName: _jsxFileName,
            lineNumber: 555
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: styles.detailsPanel(this.props.showScrollbars),
            ref: function ref(c) {
              _this4.detailsPanelRef = c;
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 570
            }
          },
          !this.props.displaySearchTop && SearchSection(),
          this.state.loadingLocations ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.loaderContainer, __source: {
                fileName: _jsxFileName,
                lineNumber: 577
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components__["M" /* LoaderIcon */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 578
              }
            })
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__locations_section__["a" /* default */], {
            entryMessage: this.props.entryMessage,
            locations: this.state.locations.map(function (location) {
              return _this4.props.mapLocationData(location);
            }),
            activeIndex: this.state.activeIndex,
            salesCTA: this.props.salesCTA,
            serviceCTA: this.props.serviceCTA,
            emailCTA: this.props.emailCTA,
            getActiveTileRef: function getActiveTileRef(c) {
              _this4.activeTileRef = c;
            },
            compact: this.props.compact,
            handleMouseEnterOnLocation: this.handleMouseEnterOnLocation,
            handleMouseLeaveOnLocation: this.handleMouseLeaveOnLocation,
            handleClickOnLocation: this.handleClickOnLocation,
            gtm: this.props.gtm, __source: {
              fileName: _jsxFileName,
              lineNumber: 581
            }
          })
        ),
        !(this.props.hideMapInCompact && this.props.compact) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            ref: function ref(c) {
              _this4.mapRef = c;
            },
            style: styles.mapPanel, __source: {
              fileName: _jsxFileName,
              lineNumber: 601
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components__["P" /* MapWithMarkers */], {
            defaultCenter: this.state.defaultCenter,
            locations: this.state.locations,
            defaultZoom: this.props.defaultZoom,
            map: this.state.map,
            activeIndex: this.state.activeIndex,
            handleClickOnLocation: this.handleClickOnLocation, __source: {
              fileName: _jsxFileName,
              lineNumber: 606
            }
          })
        )
      )
    );
  };

  return MapLocationContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

MapLocationContainer.displayName = "MapLocationContainer";


MapLocationContainer.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dealerSearchEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoSelectDealer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  globalHeaderHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  dealerLocations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  entryMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disableFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  defaultZoom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDealerChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  searchOverride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mapLocationData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hideMapInCompact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  searchType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  displaySearchTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollToMain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  initialSelectedFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    sales: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    service: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    parts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  locationState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    latitude: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    longitude: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    postcode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.postcode
  }),
  salesCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  serviceCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  emailCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  locations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  hideWhenNoLocation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isMapFirstInCompact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropDownDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropDownLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showScrollbars: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  mapFixHeightStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  gtmMapping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  mapFixHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

MapLocationContainer.defaultProps = {
  defaultZoom: 17,
  disableFilters: false,
  displaySearchTop: true,
  onDealerChange: __WEBPACK_IMPORTED_MODULE_9_utils__["C" /* noop */],
  mapLocationData: function mapLocationData(location) {
    return location;
  }, // because we need to change locations in outlet
  isMapFirstInCompact: true,
  scrollToMain: true,
  entryMessage: "",
  showScrollbars: true,
  autoSelectDealer: true,
  heading: "Find a Dealer",
  hideWhenNoLocation: true
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["i" /* gtmEvent */])(), Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["b" /* DetectCompact */])({ threshold: 768 }), Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["a" /* ConnectLocation */])(), Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["g" /* SearchParams */])({
  exposeParams: ["department", "dealerCode", "locationId", "step"]
}), Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) {
  return {
    globalHeaderHeight: __WEBPACK_IMPORTED_MODULE_8_store_actions_environment__["c" /* selectors */].getGlobalHeaderHeight(state)
  };
}))(MapLocationContainer));

var breakpointWide = "@media (min-width: 768px)";

var styles = {
  main: function main(headerHeight) {
    var _ref7;

    return _ref7 = {}, _ref7[breakpointWide] = {
      // height: `calc(100vh - ${headerHeight}px + 270px)`,
      minHeight: "650px"
    }, _ref7;
  },
  detailItem: {
    fontWeight: 200,
    margin: ".5em 0",
    lineHeight: "1.4"
  },
  map: function map(isMapFirstInCompact) {
    var _ref8;

    var mapFixHeightStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { height: "100%" };
    return _ref8 = {
      flexDirection: isMapFirstInCompact ? "column" : "column-reverse"
    }, _ref8[breakpointWide] = _extends({}, mapFixHeightStyle, {
      flexDirection: "row"
    }), _ref8;
  },
  detailsPanel: function detailsPanel(showScrollbars) {
    var _ref9;

    return _ref9 = {
      display: "flex",
      flexDirection: "column",
      borderBottom: "1px solid rgb(213, 213, 213)",
      borderTop: "1px solid rgb(213, 213, 213)"
    }, _ref9[breakpointWide] = {
      flex: "0 0 50%",
      overflowY: showScrollbars ? "auto" : "hidden"
    }, _ref9;
  },
  mapPanel: (_mapPanel = {
    alignSelf: "stretch",
    position: "relative",
    order: "-1"
  }, _mapPanel[breakpointWide] = {
    flex: "0 0 50%",
    order: "1"
  }, _mapPanel),
  loaderContainer: {
    display: "flex",
    flex: "1 1 auto",
    justifyContent: "center",
    margin: "2em 0"
  },
  locationsAndMapContainer: { display: "flex", textAlign: "left" },
  locationsAndMapContainerCompactMode: { minHeight: "66vh" },
  mapBlockContainerCompact: { display: "block", minHeight: "50vh" },

  mapBlockContainerNotCompact: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    overflow: 'hidden'
  }
};

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(1705); // eslint-disable-line
module.exports = utils;


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(1706);

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.convertNeSwToNwSe = convertNeSwToNwSe;
exports.convertNwSeToNeSw = convertNwSeToNeSw;
exports.fitBounds = fitBounds;
exports.meters2ScreenPixels = meters2ScreenPixels;
exports.tile2LatLng = tile2LatLng;
exports.latLng2Tile = latLng2Tile;
exports.getTilesIds = getTilesIds;

var _log = __webpack_require__(623);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GOOGLE_TILE_SIZE = 256;

function latLng2World(_ref) {
  var lat = _ref.lat,
      lng = _ref.lng;

  var sin = Math.sin(lat * Math.PI / 180);
  var x = lng / 360 + 0.5;
  var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;

  y = y < 0 // eslint-disable-line
  ? 0 : y > 1 ? 1 : y;
  return { x: x, y: y };
}

function world2LatLng(_ref2) {
  var x = _ref2.x,
      y = _ref2.y;

  var n = Math.PI - 2 * Math.PI * y;

  // TODO test that this is faster
  // 360 * Math.atan(Math.exp((180 - y * 360) * Math.PI / 180)) / Math.PI - 90;
  return {
    lat: 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))),
    lng: x * 360 - 180
  };
}

// Thank you wiki https://en.wikipedia.org/wiki/Geographic_coordinate_system
function latLng2MetersPerDegree(_ref3) {
  var lat = _ref3.lat;

  var phi = lat * Math.PI / 180;
  var metersPerLatDegree = 111132.92 - 559.82 * Math.cos(2 * phi) + 1.175 * Math.cos(4 * phi) - 0.0023 * Math.cos(6 * phi);
  var metersPerLngDegree = 111412.84 * Math.cos(phi) - 93.5 * Math.cos(3 * phi) + 0.118 * Math.cos(5 * phi);
  return { metersPerLatDegree: metersPerLatDegree, metersPerLngDegree: metersPerLngDegree };
}

function meters2LatLngBounds(meters, _ref4) {
  var lat = _ref4.lat,
      lng = _ref4.lng;

  var _latLng2MetersPerDegr = latLng2MetersPerDegree({
    lat: lat
  }),
      metersPerLatDegree = _latLng2MetersPerDegr.metersPerLatDegree,
      metersPerLngDegree = _latLng2MetersPerDegr.metersPerLngDegree;

  var latDelta = 0.5 * meters / metersPerLatDegree;
  var lngDelta = 0.5 * meters / metersPerLngDegree;

  return {
    nw: {
      lat: lat - latDelta,
      lng: lng - lngDelta
    },
    se: {
      lat: lat + latDelta,
      lng: lng + lngDelta
    }
  };
}

function meters2WorldSize(meters, _ref5) {
  var lat = _ref5.lat,
      lng = _ref5.lng;

  var _meters2LatLngBounds = meters2LatLngBounds(meters, { lat: lat, lng: lng }),
      nw = _meters2LatLngBounds.nw,
      se = _meters2LatLngBounds.se;

  var nwWorld = latLng2World(nw);
  var seWorld = latLng2World(se);
  var w = Math.abs(seWorld.x - nwWorld.x);
  var h = Math.abs(seWorld.y - nwWorld.y);

  return { w: w, h: h };
}

function fitNwSe(nw, se, width, height) {
  var EPS = 0.000000001;
  var nwWorld = latLng2World(nw);
  var seWorld = latLng2World(se);
  var dx = nwWorld.x < seWorld.x ? seWorld.x - nwWorld.x : 1 - nwWorld.x + seWorld.x;
  var dy = seWorld.y - nwWorld.y;

  if (dx <= 0 && dy <= 0) {
    return null;
  }

  var zoomX = (0, _log2.default)(width / GOOGLE_TILE_SIZE / Math.abs(dx));
  var zoomY = (0, _log2.default)(height / GOOGLE_TILE_SIZE / Math.abs(dy));
  var zoom = Math.floor(EPS + Math.min(zoomX, zoomY));

  // TODO find center just unproject middle world point
  var middle = {
    x: nwWorld.x < seWorld.x // eslint-disable-line
    ? 0.5 * (nwWorld.x + seWorld.x) : nwWorld.x + seWorld.x - 1 > 0 ? 0.5 * (nwWorld.x + seWorld.x - 1) : 0.5 * (1 + nwWorld.x + seWorld.x),
    y: 0.5 * (nwWorld.y + seWorld.y)
  };

  var scale = Math.pow(2, zoom);
  var halfW = width / scale / GOOGLE_TILE_SIZE / 2;
  var halfH = height / scale / GOOGLE_TILE_SIZE / 2;

  var newNW = world2LatLng({
    x: middle.x - halfW,
    y: middle.y - halfH
  });

  var newSE = world2LatLng({
    x: middle.x + halfW,
    y: middle.y + halfH
  });

  return {
    center: world2LatLng(middle),
    zoom: zoom,
    newBounds: {
      nw: newNW,
      se: newSE
    }
  };
}

function convertNeSwToNwSe(_ref6) {
  var ne = _ref6.ne,
      sw = _ref6.sw;

  return {
    nw: {
      lat: ne.lat,
      lng: sw.lng
    },
    se: {
      lat: sw.lat,
      lng: ne.lng
    }
  };
}

function convertNwSeToNeSw(_ref7) {
  var nw = _ref7.nw,
      se = _ref7.se;

  return {
    ne: {
      lat: nw.lat,
      lng: se.lng
    },
    sw: {
      lat: se.lat,
      lng: nw.lng
    }
  };
}

function fitBounds(_ref8, _ref9) {
  var nw = _ref8.nw,
      se = _ref8.se,
      ne = _ref8.ne,
      sw = _ref8.sw;
  var width = _ref9.width,
      height = _ref9.height;

  var fittedData = void 0;

  if (nw && se) {
    fittedData = fitNwSe(nw, se, width, height);
  } else {
    var calculatedNwSe = convertNeSwToNwSe({ ne: ne, sw: sw });
    fittedData = fitNwSe(calculatedNwSe.nw, calculatedNwSe.se, width, height);
  }

  return _extends({}, fittedData, {
    newBounds: _extends({}, fittedData.newBounds, convertNwSeToNeSw(fittedData.newBounds))
  });
}

// -------------------------------------------------------------------
// Helpers to calc some markers size

function meters2ScreenPixels(meters, _ref10, zoom) {
  var lat = _ref10.lat,
      lng = _ref10.lng;

  var _meters2WorldSize = meters2WorldSize(meters, { lat: lat, lng: lng }),
      w = _meters2WorldSize.w,
      h = _meters2WorldSize.h;

  var scale = Math.pow(2, zoom);
  var wScreen = w * scale * GOOGLE_TILE_SIZE;
  var hScreen = h * scale * GOOGLE_TILE_SIZE;
  return {
    w: wScreen,
    h: hScreen
  };
}

// --------------------------------------------------
// Helper functions for working with svg tiles, (examples coming soon)

function tile2LatLng(_ref11, zoom) {
  var x = _ref11.x,
      y = _ref11.y;

  var n = Math.PI - 2 * Math.PI * y / Math.pow(2, zoom);

  return {
    lat: 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))),
    lng: x / Math.pow(2, zoom) * 360 - 180
  };
}

function latLng2Tile(_ref12, zoom) {
  var lat = _ref12.lat,
      lng = _ref12.lng;

  var worldCoords = latLng2World({ lat: lat, lng: lng });
  var scale = Math.pow(2, zoom);

  return {
    x: Math.floor(worldCoords.x * scale),
    y: Math.floor(worldCoords.y * scale)
  };
}

function getTilesIds(_ref13, zoom) {
  var from = _ref13.from,
      to = _ref13.to;

  var scale = Math.pow(2, zoom);

  var ids = [];
  for (var x = from.x; x !== (to.x + 1) % scale; x = (x + 1) % scale) {
    for (var y = from.y; y !== (to.y + 1) % scale; y = (y + 1) % scale) {
      ids.push([zoom, x, y]);
    }
  }

  return ids;
}

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select_section__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_section__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\map-location\\header-section.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var HeaderSectionMapLocationContainer = function (_PureComponent) {
  _inherits(HeaderSectionMapLocationContainer, _PureComponent);

  function HeaderSectionMapLocationContainer() {
    _classCallCheck(this, HeaderSectionMapLocationContainer);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  HeaderSectionMapLocationContainer.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { key: "HeaderSectionMapLocationContainer", style: styles.searchSection, __source: {
          fileName: _jsxFileName,
          lineNumber: 11
        }
      },
      this.props.heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["s" /* HeadingBlock */], {
        value: this.props.heading,
        description: this.props.description,
        textAlign: "center",
        tag: "h3", __source: {
          fileName: _jsxFileName,
          lineNumber: 13
        }
      }),
      this.props.searchType === "search" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__search_section__["a" /* default */], {
        searchOverride: this.props.searchOverride || this.props.searchInput.postcode,
        dealerSearchEndPoint: this.props.dealerSearchEndPoint,
        updateLocationInSearchInput: this.props.updateLocationInSearchInput,
        gtmMapping: this.props.gtmMapping,
        disableFilters: this.props.disableFilters,
        filters: this.props.filters,
        handleToggleFilter: this.props.handleToggleFilter,
        activeIndex: this.props.activeIndex,
        handleNZLocations: this.props.handleNZLocations, __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      }),
      this.props.searchType === "select" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__select_section__["a" /* default */], {
        dropDownDisabled: this.props.dropDownDisabled,
        handleSelectDropDown: this.props.handleSelectDropDown,
        activeIndexOfStates: this.props.activeIndexOfStates,
        uniqStates: this.props.uniqStates,
        dropDownLabel: this.props.dropDownLabel, __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        }
      })
    );
  };

  return HeaderSectionMapLocationContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

HeaderSectionMapLocationContainer.displayName = "HeaderSectionMapLocationContainer";


HeaderSectionMapLocationContainer.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  searchType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dealerSearchEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmMapping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  searchOverride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  searchInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disableFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  dropDownDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  handleSelectDropDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  updateLocationInSearchInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  handleToggleFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  activeIndexOfStates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  uniqStates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  dropDownLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var styles = {
  searchSection: { padding: "2em 0", textAlign: "center" }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__higher_order_components__["m" /* withRadium */])()(HeaderSectionMapLocationContainer));

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\map-location\\select-section.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SelectSectionMapLocationContainer = function (_PureComponent) {
  _inherits(SelectSectionMapLocationContainer, _PureComponent);

  function SelectSectionMapLocationContainer() {
    _classCallCheck(this, SelectSectionMapLocationContainer);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  SelectSectionMapLocationContainer.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      !this.props.dropDownDisabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.dropDown, __source: {
            fileName: _jsxFileName,
            lineNumber: 11
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_2" /* Select */], {
          onChange: function onChange(value) {
            return _this2.props.handleSelectDropDown(value, false);
          },
          label: this.props.dropDownLabel,
          active: this.props.activeIndexOfStates,
          options: this.props.uniqStates || [], __source: {
            fileName: _jsxFileName,
            lineNumber: 12
          }
        })
      )
    );
  };

  return SelectSectionMapLocationContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SelectSectionMapLocationContainer.displayName = "SelectSectionMapLocationContainer";


SelectSectionMapLocationContainer.propTypes = {
  dropDownDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  handleSelectDropDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  activeIndexOfStates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  uniqStates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  dropDownLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var styles = {
  dropDown: {
    width: "80%",
    margin: "1.8em auto",
    boxSizing: "border-box",
    maxWidth: "15em"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])()(SelectSectionMapLocationContainer));

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\map-location\\search-section.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SearchSectionMapLocationContainer = function (_PureComponent) {
  _inherits(SearchSectionMapLocationContainer, _PureComponent);

  function SearchSectionMapLocationContainer() {
    _classCallCheck(this, SearchSectionMapLocationContainer);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  SearchSectionMapLocationContainer.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      !this.props.disableFilters && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.checkboxes, __source: {
            fileName: _jsxFileName,
            lineNumber: 11
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], {
          compact: true,
          divider: true,
          options: this.props.filters.map(function (filter) {
            return _extends({}, filter, {
              label: filter.name
            });
          }),
          onChange: this.props.handleToggleFilter,
          active: this.props.activeIndex,
          style: styles.radioGroup, __source: {
            fileName: _jsxFileName,
            lineNumber: 12
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.dealerBoxContainer, __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* DealerSearchBoxNZ */], {
          searchOverride: this.props.searchOverride || "",
          dealerSearchEndPoint: this.props.dealerSearchEndPoint,
          onChange: this.props.updateLocationInSearchInput,
          componentRestrictions: { country: 'nz' // handleAutocomplete
          },
          updateLocations: this.props.updateLocationInSearchInput,
          gtmMapping: this.props.gtmMapping,
          handleNZLocations: this.props.handleNZLocations, __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          }
        })
      )
    );
  };

  return SearchSectionMapLocationContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SearchSectionMapLocationContainer.displayName = "SearchSectionMapLocationContainer";


SearchSectionMapLocationContainer.propTypes = {
  dealerSearchEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  searchOverride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disableFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  updateLocationInSearchInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  handleToggleFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  gtmMapping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var styles = {
  checkboxes: {
    fontSize: "70%",
    margin: "1.8em auto"
  },
  dealerBoxContainer: {
    width: "80%",
    margin: "1.8em auto",
    boxSizing: "border-box",
    maxWidth: "30em"
  },
  radioGroup: {
    letterSpacing: "0.2em",
    textTransform: "uppercase",
    fontSize: "80%"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])()(SearchSectionMapLocationContainer));

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_short_url__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_environment__ = __webpack_require__(12);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mobile-share\\index.js';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MobileShare = function (_PureComponent) {
  _inherits(MobileShare, _PureComponent);

  function MobileShare(props) {
    _classCallCheck(this, MobileShare);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.state = {
      smsHref: false
    };
    var myUrl = _this.props.url || window.location.href;
    Object(__WEBPACK_IMPORTED_MODULE_5_apis_short_url__["a" /* default */])(myUrl).then(function (response) {
      var link = response.success ? response.data : window.location.href; // use regular url if short url fails
      var smsMessage = 'Check out the ' + _this.props.model + ' I built: ' + link;
      var smsHref = 'sms:' + (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["f" /* IS_IOS */] ? '&' : '?') + 'body=' + smsMessage; // may need to change based on ios or android
      _this.setState({ smsHref: smsHref });
    });
    return _this;
  }

  MobileShare.prototype.render = function render() {
    var _props = this.props,
        model = _props.model,
        imageSrc = _props.imageSrc;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 27
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["Heading"], { value: 'SHARE', textAlign: 'center', __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { textAlign: 'center' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 29
          }
        },
        model
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: '100%' }, src: imageSrc, __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_components__["e" /* Button */],
        {
          onClick: this.props.EmailShareFunc,
          styleName: 'blackOutlined',
          label: 'via email',
          display: 'block', __source: {
            fileName: _jsxFileName,
            lineNumber: 31
          }
        },
        'Via Email'
      ),
      this.state.smsHref ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_components__["e" /* Button */],
        { type: 'a', href: this.state.smsHref, styleName: 'blackOutlined', label: 'via sms', display: 'block', __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        },
        'Via SMS'
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["N" /* Loading */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44
        }
      })
    );
  };

  return MobileShare;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

MobileShare.displayName = 'MobileShare';


MobileShare.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])()(MobileShare));

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
var fetchFromApi = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url, {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify({})
            });

          case 2:
            response = _context2.sent;

            if (!(response.status !== 200)) {
              _context2.next = 5;
              break;
            }

            throw new Error('Failed with status ' + response.status);

          case 5:
            _context2.next = 7;
            return response.json();

          case 7:
            return _context2.abrupt('return', _context2.sent);

          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchFromApi(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var shortenUrlEndPoint = '/api/shortlink-creator';

/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
    var fetchUrl, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            fetchUrl = shortenUrlEndPoint + '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({ longLink: url });
            _context.next = 4;
            return fetchFromApi(fetchUrl);

          case 4:
            response = _context.sent;
            return _context.abrupt('return', response);

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](0);
            return _context.abrupt('return', { error: _context.t0 });

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 8]]);
  }));

  function shortenUrl(_x) {
    return _ref.apply(this, arguments);
  }

  return shortenUrl;
})());

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spinner_svg__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spinner_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__spinner_svg__);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda-login\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var MyMazdaLogin = function (_Component) {
  _inherits(MyMazdaLogin, _Component);

  function MyMazdaLogin(props) {
    _classCallCheck(this, MyMazdaLogin);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      vinOrRegoInput: props.vinRego ? props.vinRego : "",
      displaySpinner: false,
      errorMessage: props.errorMessage
    };

    _this.setVinOrRego = function (e) {
      _this.setState({ vinOrRegoInput: e.target.value.trim(), errorMessage: "" });
    };

    _this.navigate = function (data) {
      var paramNames = ["vin", "rego", "modelCode", "exterior", "grade", "engine", "drive", "colourCode", "transmission", "nameplate", "series"];
      var url = new window.URL(window.location);
      paramNames.forEach(function (n) {
        return url.searchParams.set(n, data[n]);
      });
      window.location = _this.props.redirectUrl + "?" + url.searchParams.toString();
    };

    _this.fetchLogin = function () {
      _this.setState({
        errorMessage: "",
        displaySpinner: true
      });
      var options = {
        method: "POST",
        credentials: "include",
        headers: {
          "content-type": "application/json"
        },
        body: "{}"
      };
      var url = _this.props.endpoint + "?vinrego=" + encodeURIComponent(_this.state.vinOrRegoInput);
      fetch(url, options).then(function (response) {
        if (response.status === 200) return response.json();

        throw new Error("Unfortunately the service is unavailable. Please try again later (Status " + response.status + ").");
      }).then(function (json) {
        if (json.errorMessage || json.errorCode) {
          // Fire GTM event when submission failed
          _this.props.gtmEvent({
            gtmID: __WEBPACK_IMPORTED_MODULE_4_store_gtm_events__["j" /* gtmMyMazdaLoginActionTypes */].FAIL_LOGIN,
            gtmPayload: { isVin: _this.state.vinOrRegoInput.length > 6 }
          });
          var messages = {
            NOTFOUND: _this.props.errorMessageNOTFOUND,
            MULTIPLERESULTS: _this.props.errorMessageMULTIPLERESULTS,
            NOTSUPPORTED: _this.props.errorMessageNOTSUPPORTED
          };
          var errorMessage = json.errorMessage || messages[json.errorCode];
          _this.setState({
            displaySpinner: false,
            errorMessage: errorMessage
          });
        } else {
          // Only fire gtm event if the submission is successful
          _this.props.gtmEvent({
            gtmID: __WEBPACK_IMPORTED_MODULE_4_store_gtm_events__["j" /* gtmMyMazdaLoginActionTypes */].SUBMIT_LOGIN,
            gtmPayload: { isVin: _this.state.vinOrRegoInput.length > 6 }
          });
          _this.setState({
            errorMessage: null
          }, function () {
            return _this.navigate(json);
          });
        }
      }).catch(function (error) {
        _this.setState({
          displaySpinner: false,
          errorMessage: error.message
        });
      });
    };
    return _this;
  }

  MyMazdaLogin.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        heading = _props.heading,
        description = _props.description;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { backgroundColor: "white", padding: "3em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 126
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { maxWidth: "70em", textAlign: "center", margin: "auto" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 127
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { padding: "2em 0" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 128
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], { value: heading, size: "large", textAlign: "center", __source: {
              fileName: _jsxFileName,
              lineNumber: 129
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          style: { fontWeight: 300, lineHeight: 1.8 },
          dangerouslySetInnerHTML: { __html: description }, __source: {
            fileName: _jsxFileName,
            lineNumber: 131
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.regoInputContainer, __source: {
              fileName: _jsxFileName,
              lineNumber: 134
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.regoInput, __source: {
                fileName: _jsxFileName,
                lineNumber: 135
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["J" /* InputText */], {
              onKeyDown: function onKeyDown(e) {
                e.key === "Enter" && _this2.fetchLogin();
              },
              label: "ENTER VIN OR REGO",
              value: this.state.vinOrRegoInput,
              onChange: this.setVinOrRego, __source: {
                fileName: _jsxFileName,
                lineNumber: 136
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["e" /* Button */], {
            styleName: "black",
            display: "block",
            label: "View details",
            onClick: this.fetchLogin,
            disabled: !this.state.vinOrRegoInput || this.state.displaySpinner,
            fullWidth: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 144
            }
          })
        ),
        this.state.displaySpinner && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "2em"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 153
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_5__spinner_svg___default.a, style: { width: "5em", height: "5em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 160
            }
          })
        ),
        this.state.errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.error, __source: {
              fileName: _jsxFileName,
              lineNumber: 163
            }
          },
          this.state.errorMessage
        )
      )
    );
  };

  return MyMazdaLogin;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMazdaLogin.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  endpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  redirectUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vinRego: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  errorMessageNOTFOUND: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  errorMessageMULTIPLERESULTS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  errorMessageNOTSUPPORTED: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
MyMazdaLogin.defaultProps = {
  endpoint: "/api/mymazdalogin?vinRego=",
  errorMessageNOTFOUND: "Unfortunately we were unable to identify your vehicle from the details entered, or no service data exists. Please verify the vehicle details entered and try again, or contact your local Mazda dealer.",
  errorMessageMULTIPLERESULTS: "Sorry, no result can be displayed because more than one result exists in Mazda’s database. Please enter your VIN and try again or contact your local Mazda dealer.",
  errorMessageNOTSUPPORTED: "Unfortunately the VIN/Rego number you entered is not supported. Please verify the vehicle details entered and try again, or contact your local Mazda dealer."
};
MyMazdaLogin.displayName = "MyMazdaLogin";


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["i" /* gtmEvent */])())(MyMazdaLogin));

var styles = {
  error: {
    textAlign: "center",
    margin: "auto",
    backgroundColor: "#fffff0",
    border: "solid 1px #cccccc",
    borderRadius: "3px",
    marginTop: "1em",
    marginBottom: "1em",
    padding: "2em",
    lineHeight: 1.8
  },
  regoInputContainer: {
    width: "100%",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    "@media (min-width: 768px)": {
      flexDirection: "row",
      maxWidth: "30em",
      alignItems: "center"
    }
  },
  regoInput: {
    flex: "1 1 100%",
    marginRight: "0em",
    "@media (min-width: 768px)": {
      marginRight: "2em"
    }
  }
};

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "602d9a43c2b8cf5a2cca1484a1027016.svg";

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_outlet_store_navigation_bar__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apis_koala__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__accessories_category__ = __webpack_require__(1715);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\outlet-store-detail\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var OutletDetail = function (_Component) {
  _inherits(OutletDetail, _Component);

  function OutletDetail() {
    _classCallCheck(this, OutletDetail);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.renderRego = function (registrationNumber, registrationExpiryDate) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 43
          }
        },
        registrationNumber,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { style: { margin: '0 .5em', color: '#aaa' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 45
            }
          },
          '|'
        ),
        'Expires ',
        !!registrationExpiryDate && 'JanFebMarAprMayJunJulAugSepOctNovDec'.match(/.{1,3}/g)[registrationExpiryDate.slice(-2) - 1] + ' ' + registrationExpiryDate.slice(0, 4)
      );
    };

    _this.state = {
      mapBlockHeight: '500px',
      specs: {
        categories: []
      }
    };
    return _this;
  }

  OutletDetail.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        specsApiEndpoint = _props.specsApiEndpoint,
        modelCode = _props.data.modelCode;

    var options = {
      modelCode: modelCode,
      featured: true // this is for getting featured specs, not related to the featured car prop
    };
    Object(__WEBPACK_IMPORTED_MODULE_8_apis_koala__["a" /* fetchKoalaData */])(specsApiEndpoint, options).then(function (specs) {
      _this2.setState({ specs: specs || false });
    }).catch(function (error) {
      return console.warn(error);
    });
  };

  OutletDetail.prototype.render = function render() {
    var _this3 = this;

    var _props2 = this.props,
        compact = _props2.compact,
        note = _props2.note,
        preHeading = _props2.preHeading,
        heading = _props2.heading,
        dealer = _props2.dealer,
        nameplateImage = _props2.nameplateImage,
        stockTileBackgroundUrl = _props2.stockTileBackgroundUrl,
        primaryCta = _props2.primaryCta,
        outletUrl = _props2.outletUrl,
        fullSpecificationsUrl = _props2.fullSpecificationsUrl,
        imageDisclaimer = _props2.imageDisclaimer,
        _props2$dealerInfoDes = _props2.dealerInfoDescription,
        dealerInfoDescription = _props2$dealerInfoDes === undefined ? 'To reserve this car, please call this dealer or enquire now.' : _props2$dealerInfoDes,
        _props2$data = _props2.data,
        image = _props2$data.image,
        interiorImage = _props2$data.interiorImage,
        interiorTitle = _props2$data.interiorTitle,
        colourDescription = _props2$data.colourDescription,
        nameplate = _props2$data.nameplate,
        bodyStyle = _props2$data.bodyStyle,
        vin = _props2$data.vin,
        odometer = _props2$data.odometer,
        storeType = _props2$data.storeType,
        storeTypeCategory = _props2$data.storeTypeCategory,
        registrationExpiryDate = _props2$data.registrationExpiryDate,
        registrationNumber = _props2$data.registrationNumber,
        grade = _props2$data.grade,
        driveTrain = _props2$data.driveTrain,
        engineSize = _props2$data.engineSize,
        fuelType = _props2$data.fuelType,
        transmissionType = _props2$data.transmissionType,
        price = _props2$data.price,
        _props2$data$accessor = _props2$data.accessories,
        accessories = _props2$data$accessor === undefined ? [] : _props2$data$accessor,
        disclaimer = _props2$data.disclaimer,
        stockNumber = _props2$data.stockNumber,
        featured = _props2$data.featured,
        generation = _props2$data.generation;

    var toOutletHref = function toOutletHref(params) {
      return outletUrl + '?' + __WEBPACK_IMPORTED_MODULE_7_query_string___default.a.stringify(params);
    };
    var toFormHref = function toFormHref(params) {
      return primaryCta.href + '?' + __WEBPACK_IMPORTED_MODULE_7_query_string___default.a.stringify(params);
    };

    var slideshowItems = [{
      src: image,
      type: 'Exterior',
      label: colourDescription,
      disclaimer: imageDisclaimer || 'For illustration purposes only',
      backgroundImage: stockTileBackgroundUrl,
      gtmEvents: [{
        func: this.props.gtmEvent,
        args: [{
          gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].SLIDESHOW_INTERACTION_DETAIL,
          gtmPayload: {
            nameplate: nameplate,
            bodyStyle: bodyStyle,
            storeTypeCategory: storeTypeCategory,
            grade: grade,
            imageLabel: 'Exterior Image 1'
          }
        }]
      }]
    }, {
      src: image,
      type: 'Interior',
      backgroundImage: interiorImage,
      label: interiorTitle,
      disclaimer: imageDisclaimer || 'For illustration purposes only',
      gtmEvents: [{
        func: this.props.gtmEvent,
        args: [{
          gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].SLIDESHOW_INTERACTION_DETAIL,
          gtmPayload: {
            nameplate: nameplate,
            bodyStyle: bodyStyle,
            storeTypeCategory: storeTypeCategory,
            grade: grade,
            imageLabel: 'Interior Image 1'
          }
        }]
      }]
    }];

    var gtmTags = function gtmTags(category) {
      return _extends({}, category, {
        gtmEvents: {
          expand: [{
            func: _this3.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].EXPAND_ACCORDION_DETAIL,
              gtmPayload: {
                nameplate: nameplate,
                bodyStyle: bodyStyle,
                storeTypeCategory: storeTypeCategory,
                grade: grade,
                sectionTitle: category.name
              }
            }]
          }],
          collapse: [{
            func: _this3.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].COLLAPSE_ACCORDION_DETAIL,
              gtmPayload: {
                nameplate: nameplate,
                bodyStyle: bodyStyle,
                storeTypeCategory: storeTypeCategory,
                grade: grade,
                sectionTitle: category.name
              }
            }]
          }]
        }
      });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { height: '100%', display: 'flex', flexDirection: 'column' }, __source: {
          fileName: _jsxFileName,
          lineNumber: 191
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_8" /* Section */],
        { padding: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 192
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["s" /* HeadingBlock */], { margin: false, textAlign: 'center', preHeading: preHeading, value: heading, __source: {
            fileName: _jsxFileName,
            lineNumber: 193
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: {
              display: compact[0] ? 'block' : 'flex',
              margin: '4em 0',
              justifyContent: 'space-between',
              width: "100%"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 194
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { flex: '0 1 62%', textAlign: 'center' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 201
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_components__["_5" /* Slideshow */],
              {
                gtmEventsByIndex: slideshowItems.map(function (_ref) {
                  var gtmEvents = _ref.gtmEvents;
                  return gtmEvents;
                }),
                showBullets: true,
                bulletsBelow: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 202
                }
              },
              slideshowItems.map(function (_ref2, index) {
                var src = _ref2.src,
                    backgroundImage = _ref2.backgroundImage,
                    label = _ref2.label,
                    disclaimer = _ref2.disclaimer,
                    type = _ref2.type;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  {
                    key: index,
                    style: [{ position: 'relative', marginBottom: '1em' }, backgroundImage ? {
                      backgroundImage: 'url(' + backgroundImage + ')',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center bottom'
                    } : null], __source: {
                      fileName: _jsxFileName,
                      lineNumber: 207
                    }
                  },
                  featured && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["P" /* Ribbon */], { text: 'Featured', backgroundColor: '#910A2D', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 220
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["t" /* ImageDisclaimer */], {
                    content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      {
                        'data-test': type.toLowerCase(),
                        style: {
                          display: 'flex',
                          justifyContent: 'space-between',
                          color: '#fff ',
                          flexDirection: compact[0] ? 'column' : 'row'
                        }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 223
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["U" /* Interactive */],
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 231
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          { style: { color: '#fff' }, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 232
                            }
                          },
                          label
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["l" /* Caption */],
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 234
                          }
                        },
                        disclaimer
                      )
                    ), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 221
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                    src: src,
                    style: {
                      width: '100%',
                      display: 'block',
                      padding: compact[0] ? '2.5em 0 3.5em' : '4em 0 2em', // push the image up in compact to have space for disclaimer
                      opacity: type === 'Interior' && 0
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 237
                    }
                  })
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: {
                flex: '0 1 30%',
                order: '-1',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: '0 auto'
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 249
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_16" /* Tag */],
              { color: storeType === 0 ? 'orange' : 'blue', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 259
                }
              },
              storeTypeCategory || (storeType === 1 ? 'Clearance' : 'Demo')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 260
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_10" /* SummaryWithPrice */], {
              disableBase: true,
              heading: nameplate + ' ' + bodyStyle,
              previousGeneration: generation === 'Previous',
              price: {
                message: 'Delivered price in ' + this.props.dealer.state,
                price: price,
                disclaimer: disclaimer
              },
              gtm: {
                category: "Outlet Store",
                action: 'Vehicle Details Page - "' + nameplate.toUpperCase() + ' ' + bodyStyle.toUpperCase() + '", "' + storeTypeCategory.toUpperCase() + '", "' + grade.toUpperCase() + '" - Clicked "PRICE DISCLAIMER"'
              },
              items: [{ label: 'Grade', value: grade, border: true }, {
                label: 'Drive & Transmission',
                value: driveTrain + ' ' + transmissionType
              }, { label: 'Engine', value: engineSize + ' ' + fuelType }, !storeType && { label: 'VIN', value: vin, border: true }, !!odometer && {
                label: 'Odometer',
                value: odometer.toLocaleString('nz') + 'km'
              }, !storeType && {
                label: 'Registration',
                value: this.renderRego(registrationNumber.toUpperCase(), registrationExpiryDate)
              }].filter(Boolean), __source: {
                fileName: _jsxFileName,
                lineNumber: 261
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: {
              width: '90%',
              margin: '0 auto',
              textAlign: 'center'
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 296
            }
          },
          !!accessories.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__accessories_category__["a" /* default */], {
            accessories: accessories,
            gtmEvents: {
              expand: [{
                func: this.props.gtmEvent,
                args: [{
                  gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].EXPAND_ACCORDION_DETAIL,
                  gtmPayload: {
                    nameplate: nameplate,
                    bodyStyle: bodyStyle,
                    storeTypeCategory: storeTypeCategory,
                    grade: grade,
                    sectionTitle: 'Fitted Accessories (' + accessories.length + ')'
                  }
                }]
              }],
              collapse: [{
                func: this.props.gtmEvent,
                args: [{
                  gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].COLLAPSE_ACCORDION_DETAIL,
                  gtmPayload: {
                    nameplate: nameplate,
                    bodyStyle: bodyStyle,
                    storeTypeCategory: storeTypeCategory,
                    grade: grade,
                    sectionTitle: 'Fitted Accessories (' + accessories.length + ')'
                  }
                }]
              }]
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 303
            }
          }),
          !!this.state.specs && !!this.state.specs.categories.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["_2" /* SpecificationList */], { specs: this.state.specs.categories.map(gtmTags), __source: {
              fileName: _jsxFileName,
              lineNumber: 344
            }
          })
        ),
        fullSpecificationsUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { textAlign: 'right', width: "80%", margin: "0px auto", padding: '1em 0' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 348
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_components__["H" /* Hyperlink */],
            {
              href: fullSpecificationsUrl,
              gtmEvents: [{
                func: this.props.gtmEvent,
                args: [{
                  gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLICK_FULL_SPECS_DETAIL,
                  gtmPayload: {
                    nameplate: nameplate,
                    bodyStyle: bodyStyle,
                    storeTypeCategory: storeTypeCategory,
                    grade: grade,
                    buttonText: 'Explore full ' + nameplate + ' specifications'
                  }
                }]
              }], __source: {
                fileName: _jsxFileName,
                lineNumber: 349
              }
            },
            'Explore full ',
            nameplate,
            ' specifications \u203A'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          {
            style: {
              fontSize: '90%',
              color: '#999999',
              fontWeight: 200,
              textAlign: 'center'
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 372
            }
          },
          note
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 382
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["A" /* MapLocationContainer */], {
          mapFixHeight: true,
          searchType: 'nothing',
          scrollToMain: false,
          showScrollbars: false,
          locations: [dealer].map(function (item) {
            return _extends({}, item, {
              customDealerDescription: dealerInfoDescription
            });
          }), __source: {
            fileName: _jsxFileName,
            lineNumber: 383
          }
        })
      ),
      compact[1] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_containers__["n" /* FixedBar */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 394
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: compact[0] ? '0 0 0 1em' : '0 1em' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 395
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */], {
            label: 'BACK',
            href: 'javascript:history.back()',
            styleName: 'blackOutlined',
            display: 'inline', __source: {
              fileName: _jsxFileName,
              lineNumber: 396
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: '0 1em' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 402
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["j" /* Button */], _extends({}, primaryCta, {
            // Append params to the link to lead form
            href: toFormHref({
              dealerCode: dealer.dealerCode,
              locationId: dealer.id,
              stockNumber: stockNumber,
              nameplate: nameplate
            }), __source: {
              fileName: _jsxFileName,
              lineNumber: 403
            }
          }))
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers_outlet_store_navigation_bar__["a" /* default */], {
        compact: compact[0],
        dealerButton: {
          selectionLabel: 'Step 1',
          selectedText: dealer.name,
          href: toOutletHref({
            nameplate: nameplate,
            dealerCode: 'reset',
            previousDealer: dealer.name
          })
        },
        nameplateButton: {
          selectionLabel: 'Step 2',
          selectedText: nameplate,
          image: nameplateImage,
          href: toOutletHref({
            dealerCode: dealer.dealerCode,
            locationId: dealer.id
          })
        },
        backButton: {
          label: 'BACK',
          href: toOutletHref({
            nameplate: nameplate,
            step: 2
          })
        },
        gtmEvents: {
          editDealer: [{
            func: this.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].EDIT_DEALER,
              gtmPayload: {
                buttonText: 'Edit',
                dealerName: dealer.name
              }
            }]
          }],
          editNameplate: [{
            func: this.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].EDIT_MODEL,
              gtmPayload: { buttonText: 'Edit', nameplate: nameplate }
            }]
          }],
          selectBack: [{
            func: this.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLICK_BACK_DETAIL,
              gtmPayload: {
                buttonText: 'BACK'
              }
            }]
          }],
          selectNext: [{
            func: this.props.gtmEvent,
            args: [{
              gtmID: __WEBPACK_IMPORTED_MODULE_9_store_gtm_events__["m" /* gtmOutletStoreActionTypes */].CLICK_NEXT_DETAIL,
              gtmPayload: {
                nameplate: nameplate,
                bodyStyle: bodyStyle,
                storeTypeCategory: storeTypeCategory,
                grade: grade,
                dealerName: dealer.name,
                hasAccessories: accessories.length ? 'Yes' : 'No',
                fittedAccessories: accessories.length ? accessories.map(function (_ref3) {
                  var description = _ref3.description;
                  return description;
                }).join(',') : '',
                buttonText: primaryCta.label
              }
            }]
          }]
        },
        nextButton: _extends({}, primaryCta, {
          // Append params to the link to lead form
          href: toFormHref({
            dealerCode: dealer.dealerCode,
            locationId: dealer.id,
            stockNumber: stockNumber,
            nameplate: nameplate
          })
        }), __source: {
          fileName: _jsxFileName,
          lineNumber: 415
        }
      })
    );
  };

  return OutletDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

OutletDetail.displayName = 'OutletDetail';


OutletDetail.propTypes = {
  preHeading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  nameplateImage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  stockTileBackgroundUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  note: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool),
  dealer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  primaryCta: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  outletUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  fullSpecificationsUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  specsApiEndpoint: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  imageDisclaimer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  dealerInfoDescription: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    image: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    nameplate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bodyStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    storeType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    storeTypeCategory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    registrationExpiryDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    registrationNumber: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    grade: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    modelCode: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    driveTrain: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    engine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    price: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    accessories: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    disclaimer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    stockNumber: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    generation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

OutletDetail.defaultProps = {
  specsApiEndpoint: '/api/configurator-outlet-spec'
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["i" /* gtmEvent */])(), Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["b" /* DetectCompact */])({ threshold: [768, 900] }))(OutletDetail));

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\outlet-store-detail\\accessories-category.jsx";





var AccessoriesCategory = function AccessoriesCategory(_ref) {
  var accessories = _ref.accessories,
      gtmEvents = _ref.gtmEvents;

  // Group accessories by category
  var groupedCategories = accessories.reduce(function (cats, accessory) {
    cats[accessory.category] = cats[accessory.category] || [];
    cats[accessory.category].push({ key: accessory.description });
    return cats;
  }, {});
  // Convert it to array of category strings, sort it alphabetically
  var sortedCategories = Object.keys(groupedCategories).sort();
  if (sortedCategories.indexOf("Other") > -1) {
    // If there's 'Other' category out and put it at the end of array
    sortedCategories.push(sortedCategories.splice(sortedCategories.indexOf("Other"), 1)[0]);
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["b" /* AccordionText */],
    {
      styleName: "box",
      textAlign: "left",
      title: "Fitted Accessories (" + accessories.length + ")",
      gtmEvents: gtmEvents, __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      }
    },
    sortedCategories.map(function (category, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers__["_3" /* SpecificationListItem */], { key: index, name: category, items: groupedCategories[category], __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        }
      });
    })
  );
};

AccessoriesCategory.displayName = "AccessoriesCategory";
AccessoriesCategory.displayName = "AccessoriesCategory";
AccessoriesCategory.propTypes = {
  accessories: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    collapse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    expand: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
  })
};

/* harmony default export */ __webpack_exports__["a"] = (AccessoriesCategory);

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_function__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\postcode-selector\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SvgPostCodeIcon = function SvgPostCodeIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: "0 0 18 18", style: _extends({}, styles.icon, props.active ? styles.activeIcon : ""), __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "title",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      "postcode"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M15.5 6.5c0 2.9-1.5 5-3 7-.8 1.1-2.9 3.7-2.9 3.7L9 18l-.6-.8s-2.1-2.6-2.9-3.7c-1.5-2-3-4.1-3-7C2.5 2.9 5.4 0 9 0s6.5 2.9 6.5 6.5zm-1.5 0c0-2.8-2.2-5-5-5s-5 2.2-5 5c0 2.2 1 3.9 2.7 6.1.5.7 1.6 2 2.3 2.9.7-.9 1.7-2.2 2.3-2.9 1.7-2.3 2.7-4 2.7-6.1zm-2.9-.7c0 1.1-.9 2.1-2.1 2.1-1.1 0-2-.9-2-2s.9-2 2-2.1c1.1 0 2.1.9 2.1 2z", __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    })
  );
};

SvgPostCodeIcon.displayName = "SvgPostCodeIcon";
SvgPostCodeIcon.displayName = "SvgPostCodeIcon";
var SvgLocationIcon = function SvgLocationIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    {
      style: {
        display: "inline-block",
        margin: "0 0 0 1em",
        width: "1em",
        height: "1em",
        fill: "currentColor"
      },
      viewBox: "0 0 14 14", __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10.39,6l0.9,0.9L6.22,11.91,0,14,2.1,7.79,7.15,2.73,8,3.62,3.2,8.47,2.32,11.08l0.6,0.59,2.61-.88ZM4,9.4A0.63,0.63,0,0,1,4.16,9L8.77,4.34l0.9,0.9L5.05,9.85A0.63,0.63,0,0,1,4.6,10,0.65,0.65,0,0,1,4,9.4Zm10-6a1.66,1.66,0,0,1-.48,1.16L12,6.13,7.88,2,9.4,0.48a1.65,1.65,0,0,1,2.33,0l1.8,1.79A1.66,1.66,0,0,1,14,3.45Zm-1.27,0a0.37,0.37,0,0,0-.1-0.27l-1.8-1.8a0.38,0.38,0,0,0-.54,0L9.67,2,12,4.34l0.63-.63A0.35,0.35,0,0,0,12.73,3.45Z", __source: {
        fileName: _jsxFileName,
        lineNumber: 24
      }
    })
  );
};

SvgLocationIcon.displayName = "SvgLocationIcon";
SvgLocationIcon.displayName = "SvgLocationIcon";

/** Postcode Selector Component. */
var PostcodeSelector = function (_Component) {
  _inherits(PostcodeSelector, _Component);

  function PostcodeSelector(props) {
    _classCallCheck(this, PostcodeSelector);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      active: false
    };

    Object(__WEBPACK_IMPORTED_MODULE_4_utils__["d" /* bindAll */])(["activate", "reset", "handleClick"], _this);
    return _this;
  }

  PostcodeSelector.prototype.activate = function activate() {
    this.setState({ active: true });
  };

  PostcodeSelector.prototype.reset = function reset() {
    this.setState({ active: false });
  };

  PostcodeSelector.prototype.handleClick = function handleClick() {
    var requestPostcodeInput = this.props.locationActions.requestPostcodeInput;
    var gtmEvents = this.props.gtmEvents;

    gtmEvents && Object(__WEBPACK_IMPORTED_MODULE_3_utils_function__["e" /* invokeFuncs */])(gtmEvents);
    requestPostcodeInput();
  };

  PostcodeSelector.prototype.render = function render() {
    var postcode = this.props.locationState.postcode;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: styles.base, "data-test": "postcode-selector", __source: {
          fileName: _jsxFileName,
          lineNumber: 59
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          "data-test": "PostcodeSelector",
          style: [styles.button, this.state.active ? styles.active : ""],
          onClick: this.handleClick,
          onMouseOver: this.activate,
          onFocus: this.activate,
          onMouseOut: this.reset,
          onBlur: this.reset, __source: {
            fileName: _jsxFileName,
            lineNumber: 60
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SvgPostCodeIcon, { active: this.state.active, __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        }),
        postcode,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { style: styles.change, __source: {
              fileName: _jsxFileName,
              lineNumber: 70
            }
          },
          "Change my location",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SvgLocationIcon, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          })
        )
      ),
      this.props.children
    );
  };

  return PostcodeSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PostcodeSelector.displayName = "PostcodeSelector";


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["a" /* ConnectLocation */])())(PostcodeSelector));

PostcodeSelector.propTypes = {
  locationState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  locationActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

PostcodeSelector.defaultProps = {
  locationState: {},
  locationActions: {
    requestPostcodeInput: __WEBPACK_IMPORTED_MODULE_4_utils__["C" /* noop */]
  }
};

var styles = {
  base: {
    display: "inline-block",
    lineHeight: "1.5em",
    position: "relative",
    whiteSpace: "nowrap"
  },
  button: {
    cursor: "pointer",
    fontWeight: 800,
    textTransform: "uppercase",
    transition: ".25s"
  },
  active: {
    color: "white"
  },
  activeIcon: {
    fill: "#910A2D"
  },
  change: {
    display: "inline-block",
    margin: "0 .5em",
    fontWeight: 200,
    fontStyle: "italic",
    textTransform: "none",
    borderBottom: "1px solid currentColor",
    "@media (min-width: 768px)": {
      display: "none"
    }
  },
  icon: {
    width: "1.5em",
    height: "1.5em",
    display: "inline-block",
    position: "relative",
    top: ".35em",
    left: "0em",
    paddingRight: "0.125em",
    fill: "rgb(153, 153, 153)",
    transition: ".25s"
  }
};

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\read-more-text\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ReadMoreText = function (_Component) {
  _inherits(ReadMoreText, _Component);

  function ReadMoreText() {
    _classCallCheck(this, ReadMoreText);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.toggleHidden = function () {
      _this.setState({ isTextHidden: !_this.state.isTextHidden });
    };

    _this.symbolStyle = {
      fontSize: '150%',
      fontWeight: 200,
      position: 'relative',
      top: '3px'
    };

    _this.state = {
      isTextHidden: true
    };
    return _this;
  }

  ReadMoreText.prototype.render = function render() {
    var isTextHidden = this.state.isTextHidden;
    var _props = this.props,
        children = _props.children,
        isCompactOnly = _props.isCompactOnly,
        compact = _props.compact;

    if (isCompactOnly) {
      if (!compact) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 34
            }
          },
          children
        );
      }
    }
    if (isTextHidden) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { onClick: this.toggleHidden, __source: {
            fileName: _jsxFileName,
            lineNumber: 39
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { color: '#0082C7', marginTop: '2em' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 40
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { textDecoration: 'underline ' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 41
              }
            },
            'Read More'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: this.symbolStyle, __source: {
                fileName: _jsxFileName,
                lineNumber: 42
              }
            },
            '+'
          )
        )
      );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 48
        }
      },
      children,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { onClick: this.toggleHidden, __source: {
            fileName: _jsxFileName,
            lineNumber: 50
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { color: '#0082C7', marginTop: '2em' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 51
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { textDecoration: 'underline ' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 52
              }
            },
            'Show Less'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: this.symbolStyle, __source: {
                fileName: _jsxFileName,
                lineNumber: 53
              }
            },
            '\u2013'
          )
        )
      )
    );
  };

  return ReadMoreText;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ReadMoreText.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.component,
  isCompactOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ReadMoreText.displayName = 'ReadMoreText';


/* harmony default export */ __webpack_exports__["a"] = (ReadMoreText);

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_layout__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_history__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_gtm_events__ = __webpack_require__(22);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\recalls-block\\index.jsx',
    _buttonGroup,
    _regoInput;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// Move this to a separate component along with one in calculator
var VinLocator = function VinLocator() {
  var descriptionText = '\n      The Vehicle Identification Number [VIN] is a unique\n      number that identifies your vehicle. Please refer\n      to the Specifications section of your owner\'s manual\n      for the exact location of this number.\n    ';
  var mainText = 'Where is my VIN located?';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["k" /* ExpandableInfo */], {
    mainText: mainText,
    description: descriptionText,
    isOpen: true,
    descriptionStyle: { textAlign: 'center' },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    }
  });
};

VinLocator.displayName = 'VinLocator';
VinLocator.displayName = 'VinLocator';

var RecallsBlock = function (_Component) {
  _inherits(RecallsBlock, _Component);

  function RecallsBlock(props) {
    _classCallCheck(this, RecallsBlock);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleNext = function () {
      _this.setState({ isUpdatingVINRego: false });
      _this.fetchRecallsForVinOrRego();
    };

    _this.setVinOrRego = function (e) {
      _this.setState({ vinOrRegoInput: e.target.value.trim(), errorMessage: '' });
    };

    _this.handleChangeVinOrRego = function () {
      _this.setState({
        displaySpinner: false,
        recallData: null,
        vinOrRegoInput: '',
        isUpdatingVINRego: true,
        mode: 'input'
      }, function () {
        __WEBPACK_IMPORTED_MODULE_7_utils_history__["b" /* history */].push({
          pathname: __WEBPACK_IMPORTED_MODULE_5_constants_environment__["i" /* WINDOW */].location.href.split('?')[0]
        });
      });
    };

    _this.fetchRecallsForVinOrRego = function () {
      if (_this.state.vinOrRegoInput && _this.state.vinOrRegoInput !== '') {
        var url = _this.props.endpoint;
        _this.setState({
          errorMessage: '',
          displaySpinner: true,
          isPopupOpen: false
        });
        var options = {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            vin: _this.state.vinOrRegoInput
          })

          /** @todo convert this to use apis/koala/fetchKoalaData * */
        };fetch(url, options).then(function (response) {
          if (response.status) return response.json();

          throw new Error('Unfortunately the service is unavailable. Please try again later or contact your Mazda Dealer (Status ' + response.statusCode + ').');
        }).then(function (json) {
          var message = json.message;
          /** @todo Add schema validation for API call */

          var isValid = true;
          /** @todo Handle this in validaterecallData if possible */
          if (!isValid) {
            _this.setState({
              displaySpinner: false,
              errorMessage: 'Unfortunately data received from the server is invalid. Please try again later or contact your Mazda Dealer'
            });
            return;
          }

          if (isValid && message) {
            _this.setState({
              displaySpinner: false,
              errorMessage: message
            });
            return;
          }

          _this.setState({
            displaySpinner: false,
            errorMessage: message,
            recallData: message ? null : json,
            mode: json.recallResponse.recallActivities && json.recallResponse.recallActivities.length > 0 ? 'recall' : 'norecall'
          }, function () {
            !_this.props.isMyMazdaBlock && _this.syncUrl();
            // If VIN submitted successfully, fire GTM event
            _this.props.gtmEvent({
              gtmID: __WEBPACK_IMPORTED_MODULE_8_store_gtm_events__["n" /* gtmRecallsActionTypes */].CHECK_VIN,
              gtmPayload: {
                result: json.recallResponse.recallActivities.length > 0 ? _this.renderRecallMessage() : _this.props.noRecallMessage || 'NO OUTSTANDING RECALLS'
              }
            });
          });
        }).catch(function (error) {
          _this.setState({
            displaySpinner: false,
            errorMessage: error.message
          });
          console.warn('URL: ' + url, error);
        });
      }
    };

    _this.syncUrl = function () {
      if (!_this.state.recallData || !__WEBPACK_IMPORTED_MODULE_5_constants_environment__["c" /* IS_BROWSER */]) return;

      if (_this.state.recallData.recallResponse) {
        var vin = _this.state.recallData.recallResponse.vin;

        var url = new window.URL(window.location);

        url.searchParams.set('VIN', vin);

        if (window.location.pathname !== url.pathname || window.location.search !== url.search) {
          __WEBPACK_IMPORTED_MODULE_7_utils_history__["b" /* history */].push({
            pathname: url.pathname,
            search: url.search
          });
        }
      }
    };

    _this.renderCheckAnotherVehicleButton = function () {
      var buttonLabel = 'CHECK ANOTHER VEHICLE';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["e" /* Button */], {
        label: buttonLabel,
        styleName: 'blackOutlined',
        onClick: _this.handleChangeVinOrRego,
        customWrapperStyle: { margin: '.3em' },
        fullWidthMobile: true,
        gtmEvents: [{
          func: _this.props.gtmEvent,
          args: [{
            gtmID: __WEBPACK_IMPORTED_MODULE_8_store_gtm_events__["n" /* gtmRecallsActionTypes */].CLICK_CTA,
            gtmPayload: {
              ctaName: buttonLabel,
              result: _this.state.recallData.recallResponse.recallActivities.length > 0 ? _this.renderRecallMessage() : _this.props.noRecallMessage || 'NO OUTSTANDING RECALLS'
            }
          }]
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 205
        }
      });
    };

    _this.renderRecallDetails = function () {
      var recallResponse = _this.state.recallData.recallResponse;

      return recallResponse.recallActivities.map(function (recall, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: [styles.border, { textAlign: 'left' }], __source: {
              fileName: _jsxFileName,
              lineNumber: 235
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], {
            customHeadingStyle: { margin: '3.5em 0 1em' },
            tag: 'h5',
            value: recallResponse.recallActivities.length > 1 ? index + 1 + '. ' + recall.description : recall.description,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 236
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 245
              }
            },
            'Recall Code: ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontWeight: 200 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 246
                }
              },
              recall.serviceActivityCode
            )
          ),
          recall.summaryText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 249
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], { customHeadingStyle: styles.heading, tag: 'h5', value: 'SUMMARY', __source: {
                fileName: _jsxFileName,
                lineNumber: 250
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: styles.text, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 251
                }
              },
              recall.summaryText
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_containers__["M" /* ReadMoreText */],
            { isCompactOnly: true, compact: _this.props.compact, __source: {
                fileName: _jsxFileName,
                lineNumber: 254
              }
            },
            recall.riskText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 256
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], { customHeadingStyle: styles.heading, tag: 'h5', value: 'RISK', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 257
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: styles.text, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 258
                  }
                },
                recall.riskText
              )
            ),
            recall.remedyText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 262
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], { customHeadingStyle: styles.heading, tag: 'h5', value: 'REMEDY', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 263
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: styles.text, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 264
                  }
                },
                recall.remedyText
              )
            )
          )
        );
      });
    };

    _this.renderRecallMessage = function () {
      var recallData = _this.state.recallData;
      var recallMessage = _this.props.recallMessage;

      if (recallMessage && recallMessage.includes('{number}')) {
        return recallMessage.replace('{number}', recallData.recallResponse.recallActivities.length);
      }
      return 'YOUR VEHICLE IS AFFECTED BY ' + recallData.recallResponse.recallActivities.length + ' RECALL' + (recallData.recallResponse.recallActivities.length > 1 ? 'S' : '');
    };

    _this.renderModelDetails = function (recallData) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["Y" /* ServiceModelDetails */], {
        model: recallData.recallResponse.modelDescription,
        vin: recallData.recallResponse.vin,
        compact: _this.props.compact,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 284
        }
      });
    };

    _this.state = {
      displaySpinner: false,
      vinOrRegoInput: '',
      isUpdatingVINRego: false,
      recallData: null,
      mode: 'input' // input, recall or norecall
    };
    return _this;
  }

  RecallsBlock.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!__WEBPACK_IMPORTED_MODULE_5_constants_environment__["c" /* IS_BROWSER */]) return;
    var search = new window.URL(window.location).searchParams;
    var vin = this.props.vin || search.get('VIN');

    if (vin) {
      this.setState({
        vinOrRegoInput: vin
      }, function () {
        _this2.fetchRecallsForVinOrRego();
      });
    }

    this.unlistenHistory = __WEBPACK_IMPORTED_MODULE_7_utils_history__["b" /* history */].listen(function (location, action) {
      var searchParams = new window.URL(window.location).searchParams;
      var vin = _this2.props.vin || searchParams.get('VIN');
      var oldVin = _this2.state.recallData ? _this2.state.recallData.recallResponse.vin : null;

      _this2.setState({ vinOrRegoInput: vin }, function () {
        if (oldVin !== vin) _this2.fetchRecallsForVinOrRego();else _this2.syncUrl();
      });
    });
  };

  RecallsBlock.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        displaySpinner = _state.displaySpinner,
        vinOrRegoInput = _state.vinOrRegoInput,
        recallData = _state.recallData,
        errorMessage = _state.errorMessage,
        mode = _state.mode;
    var _props = this.props,
        heading = _props.heading,
        noRecallMessage = _props.noRecallMessage,
        recallMessageDescription = _props.recallMessageDescription,
        noRecallMessageDescription = _props.noRecallMessageDescription,
        findADealerCta = _props.findADealerCta,
        _props$isMyMazdaBlock = _props.isMyMazdaBlock,
        isMyMazdaBlock = _props$isMyMazdaBlock === undefined ? false : _props$isMyMazdaBlock,
        buttonText = _props.buttonText,
        buttonUrl = _props.buttonUrl;

    var renderInput = true;
    var findADealerCtaName = findADealerCta && findADealerCta.props.label || 'Find A Dealer';
    if (mode === 'recall') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.background, __source: {
            fileName: _jsxFileName,
            lineNumber: 307
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.container, __source: {
              fileName: _jsxFileName,
              lineNumber: 308
            }
          },
          !isMyMazdaBlock && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], {
            customHeadingStyle: { marginBottom: '2em' },
            tag: 'h3',
            value: heading || 'HAS MY MAZDA BEEN RECALLED?',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 310
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["r" /* ErrorIcon */], {
            style: { width: '2em', height: '2em', marginBottom: '1em', fill: '#910A2D' },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 316
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], {
            tag: 'h3',
            customHeadingStyle: { color: '#910A2D' },
            value: this.renderRecallMessage(),
            __source: {
              fileName: _jsxFileName,
              lineNumber: 319
            }
          }),
          this.renderModelDetails(recallData),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: [styles.border, styles.descriptionText], __source: {
                fileName: _jsxFileName,
                lineNumber: 325
              }
            },
            recallMessageDescription || 'Your vehicle is affected by the following outstanding recalls. Please continue through to the next step so that Mazda can facilitate the booking of your vehicle for repair.'
          ),
          this.renderRecallDetails(),
          !isMyMazdaBlock && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.buttonGroup, __source: {
                fileName: _jsxFileName,
                lineNumber: 331
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["e" /* Button */], {
              label: findADealerCtaName,
              href: findADealerCta.props.href || '/find-a-dealer',
              customWrapperStyle: { margin: '.3em' },
              styleName: findADealerCta.props.styleName || 'red',
              external: findADealerCta.props.external,
              gtmEvents: [{
                func: this.props.gtmEvent,
                args: [{
                  gtmID: __WEBPACK_IMPORTED_MODULE_8_store_gtm_events__["n" /* gtmRecallsActionTypes */].CLICK_CTA,
                  gtmPayload: {
                    ctaName: findADealerCtaName,
                    result: this.renderRecallMessage()
                  }
                }]
              }],
              __source: {
                fileName: _jsxFileName,
                lineNumber: 332
              }
            }),
            this.renderCheckAnotherVehicleButton()
          ),
          isMyMazdaBlock && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.buttonGroup, __source: {
                fileName: _jsxFileName,
                lineNumber: 357
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["e" /* Button */], {
              label: buttonText,
              href: buttonUrl,
              customWrapperStyle: { margin: '.3em' },
              styleName: 'red',
              gtmEvents: [{
                func: this.props.gtmEvent,
                args: [{
                  gtmID: __WEBPACK_IMPORTED_MODULE_8_store_gtm_events__["n" /* gtmRecallsActionTypes */].CLICK_CTA,
                  gtmPayload: {
                    ctaName: buttonText,
                    result: this.renderRecallMessage()
                  }
                }]
              }],
              __source: {
                fileName: _jsxFileName,
                lineNumber: 358
              }
            })
          )
        )
      );
    } else if (mode === 'norecall') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.background, __source: {
            fileName: _jsxFileName,
            lineNumber: 385
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.container, __source: {
              fileName: _jsxFileName,
              lineNumber: 386
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], {
            customHeadingStyle: { marginBottom: '2em' },
            tag: 'h3',
            value: heading || 'HAS MY MAZDA BEEN RECALLED?',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 387
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_13" /* TickModalIcon */], { style: { width: '2em', height: '2em', marginBottom: '1em' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 392
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], {
            tag: 'h3',
            customHeadingStyle: { color: '#7DBE37' },
            value: noRecallMessage || 'NO OUTSTANDING RECALLS',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 393
            }
          }),
          this.renderModelDetails(recallData),
          !isMyMazdaBlock && this.renderCheckAnotherVehicleButton()
        )
      );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: {
          backgroundColor: '#fff',
          padding: '2em 0'
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 405
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.container, __source: {
            fileName: _jsxFileName,
            lineNumber: 410
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], {
          customHeadingStyle: styles.heading,
          tag: 'h3',
          value: heading || 'HAS MY MAZDA BEEN RECALLED?',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 411
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.regoInput, __source: {
              fileName: _jsxFileName,
              lineNumber: 416
            }
          },
          renderInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { flex: '0 1 100%', marginRight: '2em' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 418
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["J" /* InputText */], {
              onKeyDown: function onKeyDown(e) {
                e.key === 'Enter' && _this3.handleNext();
              },
              placeholder: 'Enter your VIN here',
              value: vinOrRegoInput,
              onChange: this.setVinOrRego,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 419
              }
            })
          ),
          renderInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { flex: '0 3 100%' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 430
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["e" /* Button */], {
              styleName: 'black',
              label: 'check',
              onClick: this.handleNext,
              display: 'block',
              disabled: !vinOrRegoInput || displaySpinner,
              fullWidth: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 431
              }
            })
          )
        ),
        renderInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VinLocator, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 442
          }
        }),
        displaySpinner && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '1em'
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 444
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["M" /* LoaderIcon */], { style: { margin: '5em' }, styleName: 'light', __source: {
              fileName: _jsxFileName,
              lineNumber: 451
            }
          })
        ),
        errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.error, __source: {
              fileName: _jsxFileName,
              lineNumber: 454
            }
          },
          errorMessage
        )
      )
    );
  };

  return RecallsBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RecallsBlock.displayName = 'RecallsBlock';


RecallsBlock.propTypes = {
  endpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  recallMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  noRecallMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  recallMessageDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  noRecallMessageDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  findADealerCta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["i" /* gtmEvent */])())(RecallsBlock));

var breakpoint1 = '@media (min-width: ' + __WEBPACK_IMPORTED_MODULE_4_constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */] + 'px)';

var styles = {
  background: {
    backgroundColor: '#fff',
    padding: '5em 0'
  },
  container: {
    margin: '0 auto',
    maxWidth: '50em',
    textAlign: 'center',
    padding: '0 1.25em'
  },
  text: {
    fontWeight: 200,
    lineHeight: '27px'
  },
  heading: {
    margin: '2.5em 0 1em'
  },
  border: {
    paddingBottom: '3em',
    borderBottom: '1px solid #eee'
  },
  buttonGroup: (_buttonGroup = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: '2.5em'
  }, _buttonGroup[breakpoint1] = {
    marginTop: '3.5em',
    flexDirection: 'row'
  }, _buttonGroup),
  error: {
    textAlign: 'center',
    fontWeight: 200,
    color: '#910A2D',
    padding: '1em',
    margin: '1em auto',
    lineHeight: 1.8
  },
  regoInput: (_regoInput = {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column'
  }, _regoInput[breakpoint1] = {
    flexDirection: 'row',
    maxWidth: '30em',
    alignItems: 'center'
  }, _regoInput),
  descriptionText: {
    fontWeight: 200,
    marginTop: '1em',
    paddingBottom: '3em'
  }
};

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__background_image_png__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__background_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__background_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\configured-vehicle-selector\\render-config-vehicle.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var descriptionText = function descriptionText(description) {
  return description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    { style: styles.description, 'data-test': 'description', __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    },
    description
  );
};

var Icon360 = function Icon360(_ref) {
  var isTextOutside = _ref.isTextOutside;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    { style: { height: '1.3em', paddingLeft: '10px' }, viewBox: '0 0 30 26', __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      fill: isTextOutside ? '#191919' : '#fff',
      d: 'M0.83,8C0.83,3.59,7.15,0,15,0h0.1c7.8,0,14.12,3.59,14.12,8a5,5,0,0,1-.86,2.75C25.82,8,20.79,6.19,15,6.19S4.18,8,1.68,10.75A5,5,0,0,1,.83,8ZM29,11.56h0c-1.75,2.52-5.59,4.44-10.3,5.11V13.83L8.14,19.91,18.66,26V22.86C25.17,21.94,30,18.61,30,14.65V8.87h0a5.51,5.51,0,0,1-1,2.68h0Zm-22.58,10C2.53,20,0,17.52,0,14.65V8.87H0a5.51,5.51,0,0,0,1,2.68H1a11.66,11.66,0,0,0,5.36,3.83v6.19H6.42Z', __source: {
        fileName: _jsxFileName,
        lineNumber: 22
      }
    })
  );
};

Icon360.displayName = 'Icon360';
Icon360.displayName = 'Icon360';
var downArrow = function downArrow() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    { style: { width: '1em' }, viewBox: '0 0 9 5', __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'inherit', d: 'M0 .7L.7 0l3.8 3.6L8.3 0l.7.7L4.5 5 0 .7z', __source: {
        fileName: _jsxFileName,
        lineNumber: 30
      }
    })
  );
};
downArrow.displayName = 'downArrow';
downArrow.displayName = 'downArrow';
var renderImageSelector = function renderImageSelector(step, options, onChange, selectIndex) {
  return step.radioGroup.map(function (radio, index) {
    var props = {
      onChange: onChange,
      options: options[radio.groupName],
      active: options[radio.groupName].indexOf(options[radio.itemName]),
      only: options[radio.groupName].length <= 1
    };
    if (index === 0) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["u" /* ImageSelector */], _extends({ key: index }, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      }));
    }
  });
};

var RenderConfiguredVehicle = function (_React$PureComponent) {
  _inherits(RenderConfiguredVehicle, _React$PureComponent);

  function RenderConfiguredVehicle() {
    _classCallCheck(this, RenderConfiguredVehicle);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  RenderConfiguredVehicle.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        display360 = _props.display360,
        step = _props.step,
        isSelectColorInterior = _props.isSelectColorInterior,
        options = _props.options,
        onChange = _props.onChange,
        selectIndex = _props.selectIndex,
        showDescription = _props.showDescription,
        display360Status = _props.display360Status,
        price = _props.price,
        _props$includeSafetyM = _props.includeSafetyModel,
        includeSafetyModel = _props$includeSafetyM === undefined ? false : _props$includeSafetyM,
        finance = _props.finance,
        background = _props.background;

    if (!step.radioGroup) return null;
    var newSelectIndex = selectIndex === undefined ? 0 : selectIndex;
    if (!step.radioGroup[newSelectIndex]) return null;
    var activeOption = options[step.radioGroup[newSelectIndex].itemName];
    var imageSrc = Object(__WEBPACK_IMPORTED_MODULE_2_containers__["_11" /* getImageSrcBasedOnOptions */])(display360Status && display360, options, activeOption, step, isSelectColorInterior);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: [background && styles.vehicleBackground(true), styles.statBase], __source: {
            fileName: _jsxFileName,
            lineNumber: 76
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.vehicleWrapper, __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          },
          step.imageSelector && renderImageSelector(step, options, onChange),
          !step.imageSelector && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { position: 'relative' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 80
              }
            },
            !this.props.compact && this.props.display360 && !display360Status && !isSelectColorInterior && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  position: 'absolute',
                  justifyContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  height: '100%',
                  zIndex: 10
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 84
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["j" /* Button */],
                {
                  onClick: function onClick() {
                    _this2.props.changeDisplay360Status(true);
                  },
                  styleName: 'whiteOutlinedWithOpacity',
                  display: 'inline', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 94
                  }
                },
                'VIEW 360\xB0',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon360, {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 101
                  }
                })
              )
            ),
            (!display360Status || isSelectColorInterior) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["j" /* ConfiguredVehicle */], { isFadeAnimation: true, key: newSelectIndex, src: imageSrc, __source: {
                fileName: _jsxFileName,
                lineNumber: 106
              }
            }),
            display360Status && !isSelectColorInterior && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["q" /* ImagesRotator */], {
              imagesSrc: imageSrc,
              customTextStyle: {
                position: 'fixed',
                bottom: '5em',
                left: 0,
                right: 0,
                background: 'linear-gradient(to top, rgba(245,245,245,1), rgba(245,245,245,0))',
                padding: '5em 0 1em'
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 109
              }
            }),
            this.props.compact && this.props.display360 && !display360Status && !isSelectColorInterior && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  justifyContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  height: '100%',
                  zIndex: 10
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 125
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["j" /* Button */],
                {
                  onClick: function onClick() {
                    _this2.props.changeDisplay360Status(true);
                  },
                  styleName: 'blackOutlined',
                  display: 'inline', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 134
                  }
                },
                'VIEW 360\xB0',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon360, { isTextOutside: true, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 141
                  }
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: [{ boxSizing: "border-box", overflow: "hidden", textAlign: "left" }, step.features && options.grade.features ? { minWidth: "365px", padding: "16px 0 16px 32px" } : { height: "0", width: "0" }], __source: {
              fileName: _jsxFileName,
              lineNumber: 148
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.feature, __source: {
                fileName: _jsxFileName,
                lineNumber: 152
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["C" /* H5 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 153
                }
              },
              options.grade.name
            ),
            price && price.price && price.disclaimer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["a" /* A */],
              {
                withoutStyle: true,
                onClick: function onClick(event) {
                  if (event && event.target && event.target.querySelector('button')) {
                    event.target.querySelector('button').click();
                  }
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 156
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["l" /* Caption */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 163
                  }
                },
                'From'
              ),
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { fontSize: "20px" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 163
                  }
                },
                '$',
                includeSafetyModel ? price.safetyModelPrice.toLocaleString() : price.price.toLocaleString()
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["i" /* Disclaimer */],
                { Icon: __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_14" /* StarIcon */], __source: {
                    fileName: _jsxFileName,
                    lineNumber: 164
                  }
                },
                price.disclaimer
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["V" /* LoadingIcon */], {
              style: {
                width: "16px",
                height: "16px"
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 168
              }
            })
          ),
          options.engine.safetyModelCode && this.props.safetyModel,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["_13" /* Space */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 180
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["t" /* Content */],
            { textAlign: 'left', __source: {
                fileName: _jsxFileName,
                lineNumber: 181
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 182
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'b',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 182
                  }
                },
                options.grade.featuresHeading ? options.grade.featuresHeading : options.grades.length === 1 || options.grades.indexOf(options.grade) === 0 || options.grades.length === options.grades.indexOf(options.grade) - 1 ? "Base features:" : 'In addition to ' + options.grades[options.grades.indexOf(options.grade) - 1].name + ':'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 193
                }
              },
              options.grade.features && options.grade.features.length && options.grade.features.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  {
                    key: 'Featuer-' + index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 198
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["l" /* Caption */],
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 200
                      }
                    },
                    item.description
                  )
                );
              })
            ),
            finance && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: styles.financeOption, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 206
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                style: styles.financeIcon,
                src: finance.icon, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 207
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_AtomicComponents__["l" /* Caption */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 210
                  }
                },
                finance.description
              )
            )
          )
        )
      ),
      activeOption.description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { margin: '1.5em 0', fill: '#999999' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 220
          }
        },
        showDescription && descriptionText(activeOption.description),
        step.specifications && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 222
            }
          },
          downArrow()
        )
      )
    );
  };

  return RenderConfiguredVehicle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

RenderConfiguredVehicle.displayName = 'RenderConfiguredVehicle';


RenderConfiguredVehicle.propTypes = {
  display360: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  step: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isSelectColorInterior: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  selectIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  showDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  background: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

RenderConfiguredVehicle.defaultProps = {
  display360: false,
  showDescription: false,
  background: false
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["f" /* Radium */])(RenderConfiguredVehicle));

var styles = {
  vehicleWrapper: {
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    minHeight: '300px',
    width: '100%'
  },
  statBase: {
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative'
  },
  vehicleBackground: function vehicleBackground(compact) {
    return {
      padding: compact ? '0' : '0 3em',
      margin: '0 auto',
      backgroundImage: compact ? '' : 'url(' + __WEBPACK_IMPORTED_MODULE_5__background_image_png___default.a + ')',
      backgroundPosition: 'center bottom',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '50vw'
    };
  },
  description: {
    textAlign: 'center',
    margin: '0 0 1em 0',
    color: '#191919',
    fontWeight: '300',
    lineHeight: '1.5'
  },
  statList: {
    opacity: 1,
    overflow: 'hidden',
    transition: '.6s',
    display: 'inline-block',
    verticalAlign: 'middle',
    alignItems: 'center',
    pointerEvents: 'none',
    width: '100%'
  },
  feature: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e7e7e7",
    minHeight: "44px"
  },
  financeOption: {
    display: 'flex',
    marginTop: '18px',
    alignItems: 'center'
  },
  financeIcon: {
    marginRight: '10px',
    width: '15px'
  }
};

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5ff494baa4faa6cc140cdc1d344c4e41.png";

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_higher_order_components__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\configured-vehicle-selector\\render-config-vehicle-compact.jsx";








var descriptionText = function descriptionText(description) {
  return description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "p",
    { style: styles.description, "data-test": "description", __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    },
    description
  );
};

var RenderConfiguredVehicleCompact = function RenderConfiguredVehicleCompact(_ref) {
  var display360 = _ref.display360,
      step = _ref.step,
      isSelectColorInterior = _ref.isSelectColorInterior,
      options = _ref.options,
      onChange = _ref.onChange,
      price = _ref.price,
      safetyModel = _ref.safetyModel,
      includeSafetyModel = _ref.includeSafetyModel,
      finance = _ref.finance,
      showDescription = _ref.showDescription;

  if (!step.radioGroup) return null;
  var activeOption = options[step.radioGroup[0].itemName];
  var activeGroup = options[step.radioGroup[0].groupName];
  var activeIndex = activeGroup.indexOf(activeOption);
  var imageSrc = Object(__WEBPACK_IMPORTED_MODULE_3_containers__["_11" /* getImageSrcBasedOnOptions */])(display360, options, activeOption, step, isSelectColorInterior);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { padding: "15px" }, "data-test": "compact-vehicle", __source: {
        fileName: _jsxFileName,
        lineNumber: 43
      }
    },
    activeOption.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["B" /* H4 */],
      { withDetails: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 44
        }
      },
      activeOption.name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45
      }
    }),
    step.radioGroup.map(function (radio, index) {
      var props = {
        onChange: onChange,
        options: options[radio.groupName],
        active: options[radio.groupName].indexOf(options[radio.itemName]),
        only: options[radio.groupName].length <= 1
      };
      if (index !== 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_11" /* Tabs */], _extends({ key: index, divider: true }, props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 54
          }
        }));
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components__["_5" /* Slideshow */],
      {
        showBullets: true,
        activate: activeIndex,
        bulletsBelow: true,
        handleChange: function handleChange(index) {
          onChange(activeGroup[index]);
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 57
        }
      },
      activeGroup.map(function (option, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: index, style: styles.slideshowItem, __source: {
              fileName: _jsxFileName,
              lineNumber: 65
            }
          },
          Array.isArray(imageSrc) && display360 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["q" /* ImagesRotator */], { imagesSrc: imageSrc, __source: {
              fileName: _jsxFileName,
              lineNumber: 67
            }
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["j" /* ConfiguredVehicle */], {
            isFadeAnimation: true,
            key: index,
            src: option.imageMobileSrc || imageSrc, __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          })
        );
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 77
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: [{ boxSizing: "border-box", overflow: "hidden", textAlign: "left" }, step.features && options.grade.features ? { width: "100%" } : { height: 0, width: "0" }], __source: {
          fileName: _jsxFileName,
          lineNumber: 78
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.feature, __source: {
            fileName: _jsxFileName,
            lineNumber: 82
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["C" /* H5 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 83
            }
          },
          options.grade.name
        ),
        price && price.price && price.disclaimer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["a" /* A */],
          {
            withoutStyle: true,
            onClick: function onClick(event) {
              if (event && event.target && event.target.querySelector('button')) {
                event.target.querySelector('button').click();
              }
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 86
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["l" /* Caption */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 93
              }
            },
            "From"
          ),
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: { fontSize: "20px" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 93
              }
            },
            "$",
            includeSafetyModel ? price.safetyModelPrice.toLocaleString() : price.price.toLocaleString()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["i" /* Disclaimer */],
            { Icon: __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_14" /* StarIcon */], __source: {
                fileName: _jsxFileName,
                lineNumber: 94
              }
            },
            price.disclaimer
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["V" /* LoadingIcon */], {
          style: {
            width: "16px",
            height: "16px"
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 98
          }
        })
      ),
      options.engine.safetyModelCode && safetyModel,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["t" /* Content */],
        { textAlign: "left", __source: {
            fileName: _jsxFileName,
            lineNumber: 111
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 112
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "b",
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 112
              }
            },
            options.grade.featuresHeading ? options.grade.featuresHeading : options.grades.length === 1 || options.grades.indexOf(options.grade) === 0 || options.grades.length === options.grades.indexOf(options.grade) - 1 ? "Base features:" : "In addition to " + options.grades[options.grades.indexOf(options.grade) - 1].name + ":"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 123
            }
          },
          options.grade.features.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              {
                key: "Featuer-" + index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 125
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["l" /* Caption */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 127
                  }
                },
                item.description
              )
            );
          })
        ),
        finance && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.financeOption, __source: {
              fileName: _jsxFileName,
              lineNumber: 133
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
            style: styles.financeIcon,
            src: finance.icon, __source: {
              fileName: _jsxFileName,
              lineNumber: 134
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["l" /* Caption */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 137
              }
            },
            finance.description
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 145
      }
    }),
    showDescription ? descriptionText(activeOption.description) : ""
  );
};

RenderConfiguredVehicleCompact.displayName = "RenderConfiguredVehicleCompact";
RenderConfiguredVehicleCompact.displayName = "RenderConfiguredVehicleCompact";
RenderConfiguredVehicleCompact.propTypes = {
  display360: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  step: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isSelectColorInterior: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  currentPriceArray: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  showDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["f" /* Radium */])(RenderConfiguredVehicleCompact));

var styles = {
  slideshowItem: {
    maxWidth: "90%",
    margin: "0 auto"
  },
  description: {
    textAlign: "center",
    margin: "0 0 1em 0",
    color: "#101010",
    fontWeight: "300",
    lineHeight: "1.5"
  },
  feature: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e7e7e7",
    minHeight: "44px"
  },
  financeOption: {
    display: 'flex',
    marginTop: '18px',
    alignItems: 'center'
  },
  financeIcon: {
    marginRight: '10px',
    width: '15px'
  }
};

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\ribbon\\index.jsx";




var Ribbon = function Ribbon(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === undefined ? "" : _ref$text,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? "#910A2D" : _ref$backgroundColor,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? "#fff" : _ref$color;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      "data-test": "ribbon",
      style: {
        position: "absolute",
        overflow: "hidden",
        fontSize: "70%",
        paddingTop: "2.3em",
        paddingLeft: "2.3em",
        height: "6em",
        width: "6em"
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          backgroundColor: backgroundColor,
          color: color,
          fontWeight: "900",
          textTransform: "uppercase",
          letterSpacing: "0.15em",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transformOrigin: "top left",
          width: "12em",
          height: "2.2em",
          transform: "rotate(-45deg) translateX(-50%)"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { style: { margin: "0 0 -0.18em 0" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        },
        text
      )
    )
  );
};

Ribbon.displayName = "Ribbon";
Ribbon.displayName = "Ribbon";
Ribbon.propTypes = {
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(Ribbon));

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\round-icon-button\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SvgArrowUpIcon = function SvgArrowUpIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    {
      style: _extends({}, styles.iconSvg, styles.animateDown),
      viewBox: '0 0 9 5', __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      'Arrow Up'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'inherit', d: 'M4.5 1.4L.7 5 0 4.3 4.5 0 9 4.3l-.7.7-3.8-3.6z', __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    })
  );
};

SvgArrowUpIcon.displayName = 'SvgArrowUpIcon';
SvgArrowUpIcon.displayName = 'SvgArrowUpIcon';
var SvgArrowDownIcon = function SvgArrowDownIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    {
      style: _extends({}, styles.iconSvg, styles.animateDown),
      viewBox: '0 0 9 5', __source: {
        fileName: _jsxFileName,
        lineNumber: 18
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 24
        }
      },
      'Arrow down'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'inherit', d: 'M0 .7L.7 0l3.8 3.6L8.3 0l.7.7L4.5 5 0 .7z', __source: {
        fileName: _jsxFileName,
        lineNumber: 25
      }
    })
  );
};

SvgArrowDownIcon.displayName = 'SvgArrowDownIcon';
SvgArrowDownIcon.displayName = 'SvgArrowDownIcon';

/**
 * Renders a Round Icon Button.
 * @todo  Change to stateless component
 */
var RoundIconButton = function (_Component) {
  _inherits(RoundIconButton, _Component);

  function RoundIconButton() {
    _classCallCheck(this, RoundIconButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.activate = function () {
      _this.setState({ active: true });
    };

    _this.reset = function () {
      _this.setState({ active: false });
    };

    _this.state = {
      active: false
    };
    return _this;
  }

  /**
   * @param {('arrow-up'|'arrow-down')} iconId - ID of svg icon.
   * @returns {ReactElement} react component
   */
  RoundIconButton.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: [styles.base, this.state.active ? styles.baseActive : styles.baseDefault],
        onMouseOver: this.activate,
        onMouseOut: this.reset,
        onClick: this.props.onClick, __source: {
          fileName: _jsxFileName,
          lineNumber: 60
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: [styles.iconBase, this.state.active ? styles.iconBaseActive : styles.iconBaseDefault], __source: {
            fileName: _jsxFileName,
            lineNumber: 65
          }
        },
        this.props.iconId === 'arrow-up' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SvgArrowUpIcon, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        }),
        this.props.iconId === 'arrow-down' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SvgArrowDownIcon, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 71
          }
        })
      )
    );
  };

  return RoundIconButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RoundIconButton.propTypes = {
  iconId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
RoundIconButton.defaultProps = {
  iconId: '',
  onClick: function onClick() {}
};
RoundIconButton.displayName = 'RoundIconButton';

var slideDownKeyframes = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["b" /* keyframes */])({
  '0%': {
    opacity: 0,
    transform: 'translateY(-35%)'
  },
  '35%': {
    opacity: 1,
    transform: 'translateY(0)'
  },
  '65%': {
    opacity: 1,
    transform: 'translateY(0)'
  },
  '100%': {
    opacity: 0,
    transform: 'translateY(35%)'
  }
});

var styles = {
  base: {
    width: '3em',
    height: '3em',
    position: 'relative',
    borderRadius: '50%',
    border: 'solid #fff 2px',
    cursor: 'pointer',
    transition: 'background-color .25s'
  },
  baseDefault: {
    backgroundColor: 'transparent'
  },
  baseActive: {
    backgroundColor: '#fff'
  },
  iconBase: {
    fill: '#fff',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    transition: 'fill .25s',
    display: 'flex'
  },
  iconBaseDefault: {
    fill: '#fff'
  },
  iconBaseActive: {
    fill: '#000'
  },
  iconSvg: {
    width: '30%',
    height: '30%',
    margin: 'auto'
  },
  animateDown: {
    animation: 'x 1.4s infinite',
    animationName: slideDownKeyframes
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(RoundIconButton));

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export goToTop */
/* unused harmony export configureAnchors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__manager__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scrollable_anchor__ = __webpack_require__(1725);
/* unused harmony reexport default */


var goToTop = __WEBPACK_IMPORTED_MODULE_0__manager__["a" /* default */].goToTop;
var configureAnchors = __WEBPACK_IMPORTED_MODULE_0__manager__["a" /* default */].configure;



/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__manager__ = __webpack_require__(646);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ScrollableAnchor = function (_Component) {
  _inherits(ScrollableAnchor, _Component);

  function ScrollableAnchor(props) {
    _classCallCheck(this, ScrollableAnchor);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.id = props.id || props.children.ref;
    return _this;
  }

  ScrollableAnchor.prototype.componentDidMount = function componentDidMount() {
    var element = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs[Object.keys(this.refs)[0]]);
    __WEBPACK_IMPORTED_MODULE_3__manager__["a" /* default */].addAnchor(this.id, element);
  };

  ScrollableAnchor.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_3__manager__["a" /* default */].removeAnchor(this.id);
  };

  ScrollableAnchor.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        id = _props.id;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, {
      ref: children.ref || id
    });
  };

  return ScrollableAnchor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ScrollableAnchor.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
ScrollableAnchor.displayName = 'ScrollableAnchor';
/* unused harmony default export */ var _unused_webpack_default_export = (ScrollableAnchor);

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchSelectBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\search-select-box\\index.jsx';

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Clear = function Clear() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      style: [styles.svgContainer, {
        width: '1em',
        height: '1em',
        transition: 'color .25s',
        marginLeft: '1em',
        ':hover': {
          color: '#191919'
        }
      }, { zIndex: 3 }], __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["m" /* CrossIcon */], { style: styles.svgBase, __source: {
        fileName: _jsxFileName,
        lineNumber: 23
      }
    })
  );
};

Clear.displayName = 'Clear';
Clear.displayName = 'Clear';
var EnhancedClear = Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(Clear);

var SearchSelectBox = function (_PureComponent) {
  _inherits(SearchSelectBox, _PureComponent);

  function SearchSelectBox(props) {
    _classCallCheck(this, SearchSelectBox);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.field = {
      focus: false,
      value: ''
    };
    Object(__WEBPACK_IMPORTED_MODULE_4_utils__["d" /* bindAll */])(['renderSearch', 'renderClear'], _this);
    return _this;
  }

  SearchSelectBox.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        _onBlur = _props.onBlur,
        _onFocus = _props.onFocus,
        props = _objectWithoutProperties(_props, ['onBlur', 'onFocus']);

    var selectProps = _extends({
      clearRenderer: function clearRenderer() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EnhancedClear, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          }
        });
      },
      arrowRenderer: function arrowRenderer() {},
      onFocus: function onFocus() {
        _this2.setState({ focus: true });
        _onFocus && _onFocus();
      },
      onBlur: function onBlur() {
        _this2.setState({ focus: false });
        _onBlur && _onBlur();
      }
    }, props);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: [styles.container, this.state.focus ? styles.focus : { borderColor: '#D5D5D5' }], __source: {
          fileName: _jsxFileName,
          lineNumber: 59
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: [styles.svgContainer, { height: '1.2em', width: '1.2em', marginRight: '1em' }], __source: {
            fileName: _jsxFileName,
            lineNumber: 60
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_0" /* SearchIcon */], { style: styles.svgBase, __source: {
            fileName: _jsxFileName,
            lineNumber: 61
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { flex: '1 1 100%', marginBottom: "-1px" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 63
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_3" /* SelectBase */], _extends({ className: __WEBPACK_IMPORTED_MODULE_5__style_css___default.a.__SearchSelectBox }, selectProps, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 64
          }
        }))
      )
    );
  };

  return SearchSelectBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SearchSelectBox.propTypes = {
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
SearchSelectBox.displayName = 'SearchSelectBox';
SearchSelectBox.defaultProps = {
  placeholder: 'Search',
  value: ''
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(SearchSelectBox));

var styles = {
  svgContainer: {
    position: 'relative',
    color: '#979797'
  },
  svgBase: {
    fill: 'currentColor',
    height: '100%',
    width: '100%'
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    transition: 'border-color .25s',
    borderBottom: '1px solid',
    padding: '0 .5em'
  },
  focus: {
    boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)'
  }
};

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"__SearchSelectBox":"__SearchSelectBox","Select-arrow-zone":"Select-arrow-zone","Select-control":"Select-control"};

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ServiceCalculatorFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_layout__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(9);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\service-calculator-filter\\index.jsx",
    _base,
    _filtersGroup,
    _selectFilter,
    _selectFilterFirst,
    _selectFilterLast;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var FILTER_PROPS = ["nameplate", "body", "grade", "engine"];

var ServiceCalculatorFilter = function (_Component) {
  _inherits(ServiceCalculatorFilter, _Component);

  function ServiceCalculatorFilter(props) {
    _classCallCheck(this, ServiceCalculatorFilter);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = _extends({ activeService: 0 }, _this.getFilterStateFromProps(props));

    _this.handleSubmit = function () {
      var selection = _this.getSelection();
      _this.props.onSubmit(selection.modelCode, selection.selection);
    };

    _this.handleChange = function () {
      if (!_this.props.onChange) return;

      var _this$getSelection = _this.getSelection(),
          modelCode = _this$getSelection.modelCode,
          selection = _this$getSelection.selection;

      _this.props.onChange(modelCode, selection);
    };

    _this.getSelection = function () {
      var data = _this.props.vehiclesData;
      var selection = [];
      var modelCode = void 0;
      if (_this.state.nameplate < 0) {
        return { modelCode: modelCode, selection: selection };
      }
      selection.push(data.namePlates[_this.state.nameplate].name);
      if (_this.state.body < 0) {
        return { modelCode: modelCode, selection: selection };
      }
      selection.push(data.namePlates[_this.state.nameplate].bodyStyles[_this.state.body].name);
      if (_this.state.grade < 0) {
        return { modelCode: modelCode, selection: selection };
      }
      selection.push(data.namePlates[_this.state.nameplate].bodyStyles[_this.state.body].grades[_this.state.grade].name);
      if (_this.state.engine < 0) {
        return { modelCode: modelCode, selection: selection };
      }
      selection.push(data.namePlates[_this.state.nameplate].bodyStyles[_this.state.body].grades[_this.state.grade].modelCodes[_this.state.engine].description);
      modelCode = data.namePlates[_this.state.nameplate].bodyStyles[_this.state.body].grades[_this.state.grade].modelCodes[_this.state.engine].code;

      return { modelCode: modelCode, selection: selection };
    };

    _this.setNameplate = function (v) {
      if (!v) {
        _this.setState({
          nameplate: -1,
          body: -1,
          grade: -1,
          engine: -1
        }, _this.handleChange);
        return;
      }
      var data = _this.props.vehiclesData;
      var newValue = data.namePlates.findIndex(function (d) {
        return d.name === v.name;
      });
      var numBodies = data.namePlates[newValue].bodyStyles.length;
      _this.setState({
        nameplate: newValue,
        body: numBodies > 1 ? -1 : 0,
        grade: -1,
        engine: -1
      }, _this.handleChange);
    };

    _this.setBody = function (v) {
      if (!v) {
        _this.setState({
          body: -1,
          grade: -1,
          engine: -1
        }, _this.handleChange);
        return;
      }
      var data = _this.props.vehiclesData;
      var newValue = data.namePlates[_this.state.nameplate].bodyStyles.findIndex(function (d) {
        return d.name === v.name;
      });
      var numGrades = data.namePlates[_this.state.nameplate].bodyStyles[newValue].grades.length;
      _this.setState({
        body: newValue,
        grade: numGrades > 1 ? -1 : 0,
        engine: -1
      }, _this.handleChange);
    };

    _this.setGrade = function (v) {
      if (!v) {
        _this.setState({
          grade: -1,
          engine: -1
        }, _this.handleChange);
        return;
      }
      var data = _this.props.vehiclesData;
      var newValue = data.namePlates[_this.state.nameplate].bodyStyles[_this.state.body].grades.findIndex(function (d) {
        return d.name === v.name;
      });
      var numEngines = data.namePlates[_this.state.nameplate].bodyStyles[_this.state.body].grades[newValue].modelCodes.length;
      _this.setState({
        grade: newValue,
        engine: numEngines > 1 ? -1 : 0
      }, _this.handleChange);
    };

    _this.setEngine = function (v) {
      if (!v) {
        _this.setState({ engine: -1 }, _this.handleChange);
        return;
      }
      var data = _this.props.vehiclesData;
      var newValue = data.namePlates[_this.state.nameplate].bodyStyles[_this.state.body].grades[_this.state.grade].modelCodes.findIndex(function (d) {
        return d.description === v.name;
      });
      _this.setState({
        engine: newValue
      }, _this.handleChange);
    };
    return _this;
  }

  ServiceCalculatorFilter.prototype.getFilterStateFromProps = function getFilterStateFromProps(_ref, currentState) {
    var _ref$vehiclesData = _ref.vehiclesData,
        data = _ref$vehiclesData === undefined ? {} : _ref$vehiclesData,
        _ref$selection = _ref.selection,
        selection = _ref$selection === undefined ? [] : _ref$selection;

    var _ref2 = selection || [],
        nameplate = _ref2[0],
        body = _ref2[1],
        grade = _ref2[2],
        engine = _ref2[3];

    var newState = currentState ? Object(__WEBPACK_IMPORTED_MODULE_5_utils__["I" /* pick */])(FILTER_PROPS, currentState) : FILTER_PROPS.reduce(function (obj, key) {
      var _extends2;

      return _extends({}, obj, (_extends2 = {}, _extends2[key] = -1, _extends2));
    }, {});

    newState.nameplate = data.namePlates.findIndex(function (d) {
      return d.name === nameplate;
    });

    if (newState.nameplate !== -1) {
      newState.body = data.namePlates[newState.nameplate].bodyStyles.findIndex(function (d) {
        return d.name === body;
      });
    }

    if (newState.body !== -1) {
      newState.grade = data.namePlates[newState.nameplate].bodyStyles[newState.body].grades.findIndex(function (d) {
        return d.name === grade;
      });
    }

    if (newState.grade !== -1) {
      newState.engine = data.namePlates[newState.nameplate].bodyStyles[newState.body].grades[newState.grade].modelCodes.findIndex(function (d) {
        return d.description === engine;
      });
    }

    return newState;
  };

  ServiceCalculatorFilter.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    this.setState(_extends({}, this.state, this.getFilterStateFromProps(newProps, this.state)));
  };

  ServiceCalculatorFilter.prototype.renderFilters = function renderFilters() {
    var _this2 = this;

    var data = this.props.vehiclesData;
    var _state = this.state,
        nameplate = _state.nameplate,
        body = _state.body,
        grade = _state.grade,
        engine = _state.engine;

    var pickName = Object(__WEBPACK_IMPORTED_MODULE_5_utils__["I" /* pick */])(["name"]);

    var nameplateOptions = data.namePlates.map(pickName);

    var bodyOptions = nameplate !== -1 ? data.namePlates[nameplate].bodyStyles.map(pickName) : [];

    var gradeOptions = nameplate !== -1 && body !== -1 ? data.namePlates[nameplate].bodyStyles[body].grades.map(pickName) : [];

    var engineOptions = nameplate !== -1 && body !== -1 && grade !== -1 ? data.namePlates[nameplate].bodyStyles[body].grades[grade].modelCodes.map(function (_ref3) {
      var description = _ref3.description;
      return { name: description };
    }) : [];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.filtersGroup, __source: {
          fileName: _jsxFileName,
          lineNumber: 211
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.selectFilterFirst, __source: {
            fileName: _jsxFileName,
            lineNumber: 212
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_2" /* Select */], {
          ref: function ref(e) {
            _this2.nameplateSelect = e;
          },
          label: "Model",
          active: nameplate,
          options: nameplateOptions,
          onChange: this.setNameplate, __source: {
            fileName: _jsxFileName,
            lineNumber: 213
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.selectFilter, __source: {
            fileName: _jsxFileName,
            lineNumber: 222
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_2" /* Select */], {
          ref: function ref(e) {
            _this2.bodySelect = e;
          },
          label: "Body",
          active: body,
          disabled: nameplate === -1 || bodyOptions.length < 2,
          options: bodyOptions,
          onChange: this.setBody, __source: {
            fileName: _jsxFileName,
            lineNumber: 223
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.selectFilter, __source: {
            fileName: _jsxFileName,
            lineNumber: 233
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_2" /* Select */], {
          ref: function ref(e) {
            _this2.gradeSelect = e;
          },
          label: "Grade",
          active: grade,
          disabled: body === -1,
          options: gradeOptions,
          onChange: this.setGrade, __source: {
            fileName: _jsxFileName,
            lineNumber: 234
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.selectFilterLast, __source: {
            fileName: _jsxFileName,
            lineNumber: 244
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_2" /* Select */], {
          ref: function ref(e) {
            _this2.engineSelect = e;
          },
          label: "Engine",
          active: engine,
          disabled: grade === -1,
          options: engineOptions,
          onChange: this.setEngine, __source: {
            fileName: _jsxFileName,
            lineNumber: 245
          }
        })
      )
    );
  };

  ServiceCalculatorFilter.prototype.render = function render() {
    var _getSelection = this.getSelection(),
        selection = _getSelection.selection;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.base, __source: {
          fileName: _jsxFileName,
          lineNumber: 263
        }
      },
      this.renderFilters(),
      !this.props.hideCTA && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.buttonContainer, "data-name": "test-test", __source: {
            fileName: _jsxFileName,
            lineNumber: 266
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["e" /* Button */], {
          styleName: "black",
          label: this.props.ctaLabel,
          onClick: this.handleSubmit,
          disabled: selection.length < FILTER_PROPS.length,
          fullWidth: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 267
          }
        })
      )
    );
  };

  return ServiceCalculatorFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ServiceCalculatorFilter.displayName = "ServiceCalculatorFilter";
ServiceCalculatorFilter.propTypes = {
  vehiclesData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  hideCTA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  ctaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

ServiceCalculatorFilter.defaultProps = {
  hideCTA: false,
  ctaLabel: "Calculate",
  onSubmit: __WEBPACK_IMPORTED_MODULE_5_utils__["C" /* noop */],
  onChange: __WEBPACK_IMPORTED_MODULE_5_utils__["C" /* noop */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["f" /* Radium */])(ServiceCalculatorFilter));

var breakpoint1 = "@media (min-width: " + __WEBPACK_IMPORTED_MODULE_3_constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */] + "px)";

var styles = {
  base: (_base = {
    maxWidth: "70em",
    margin: "auto",
    display: "flex",
    flexDirection: "column"
  }, _base[breakpoint1] = {
    flexDirection: "row"
  }, _base),
  filtersGroup: (_filtersGroup = {
    display: "flex",
    width: "100%",
    flexDirection: "column"
  }, _filtersGroup[breakpoint1] = {
    flexDirection: "row",
    marginRight: "1em"
  }, _filtersGroup),
  selectFilter: (_selectFilter = {}, _selectFilter[breakpoint1] = {
    flexGrow: 1,
    padding: "0.5em",
    width: "100%"
  }, _selectFilter.flexGrow = 1, _selectFilter.paddingTop = "0.5em", _selectFilter),
  buttonContainer: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex"
  },
  selectFilterFirst: (_selectFilterFirst = {}, _selectFilterFirst[breakpoint1] = {
    flexGrow: 1,
    paddingRight: "0.5em",
    width: "120%"
  }, _selectFilterFirst.width = "100%", _selectFilterFirst.flexGrow = 1, _selectFilterFirst.paddingTop = "0.5em", _selectFilterFirst),
  selectFilterLast: (_selectFilterLast = {}, _selectFilterLast[breakpoint1] = {
    flexGrow: 1,
    width: "180%",
    paddingLeft: "0.5em"
  }, _selectFilterLast.width = "100%", _selectFilterLast.flexGrow = 1, _selectFilterLast.paddingTop = "0.5em", _selectFilterLast)
};

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ServiceDetails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_object__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\service-details\\index.jsx';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ServiceDetails = function (_Component) {
  _inherits(ServiceDetails, _Component);

  function ServiceDetails(props) {
    _classCallCheck(this, ServiceDetails);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.syncAdditionalServicesState = function (newSelectedAdditionalItems) {
      var updateSelectedAddtionalServices = _this.props.updateSelectedAddtionalServices;
      // When we updae the selected additional services here, we also need to notify the wrapper (calculator) to update it's state

      _this.setState({ selectedAdditionalServices: newSelectedAdditionalItems });
      updateSelectedAddtionalServices && updateSelectedAddtionalServices(newSelectedAdditionalItems);
    };

    _this._findNonZeroDistance = function () {
      var distance = 0;
      _this.props.data && _this.props.data.serviceItems.forEach(function (item) {
        if (item.factoryCodeEntity.distance > 0 && distance === 0) {
          distance = item.factoryCodeEntity.distance;
        }
      });
      return distance;
    };

    _this.state = {
      activeServiceCodeIndex: 0,
      selectedAdditionalServices: {}
    };

    _this.services = props.data.serviceItems.filter(function (s) {
      return s.factoryCodeEntity.type === 'Scheduled Maintenance' && s.factoryCodeEntity.distance > 0;
    }).sort(function (s1, s2) {
      return s1.factoryCodeEntity.distance - s2.factoryCodeEntity.distance;
    }).slice(0, props.scheduledServiceItemsLimit > 0 ? props.scheduledServiceItemsLimit : 1e10).map(function (s) {
      var m = /([^\s]+) Service or (.+)/.exec(s.factoryCodeEntity.description);
      return {
        name: m ? m[1] + ' Service | $' + s.basePrice : s.factoryCodeEntity.description,
        extraLabel: m ? 'or ' + m[2] : '',
        price: '$' + s.basePrice,
        basePrice: s.basePrice,
        shortName: m ? m[1] + ' Service' : s.factoryCodeEntity.description,
        code: s.factoryCodeEntity.code,
        item: s
      };
    });

    _this.additionalServices = _this.props.data.serviceItems.filter(function (s) {
      return s.factoryCodeEntity.type.match(/^Additional/);
    }).map(function (s) {
      return {
        name: s.factoryCodeEntity.description,
        description: s.operationActions.length > 0 ? s.operationActions[0].operations[0].description : '',
        price: '$' + s.basePrice,
        basePrice: s.basePrice,
        code: s.factoryCodeEntity.code
      };
    });

    if (props.factoryCode) {
      _this.state.activeServiceCodeIndex = _this.services.findIndex(function (s) {
        return s.code === props.factoryCode;
      });
    }

    _this.toggleService = function (code) {
      var newSelectedAdditionalServices = _extends({}, _this.state.selectedAdditionalServices);
      newSelectedAdditionalServices[code] = !newSelectedAdditionalServices[code];
      _this.syncAdditionalServicesState(newSelectedAdditionalServices);
    };
    return _this;
  }

  ServiceDetails.prototype.calculateTotal = function calculateTotal() {
    var _this2 = this;

    var activeService = this.services[this.state.activeServiceCodeIndex];
    var totalPrice = this.additionalServices.filter(function (s) {
      return _this2.state.selectedAdditionalServices[s.code];
    }).reduce(function (price, s) {
      return price + s.basePrice;
    }, activeService.basePrice);
    return '' + totalPrice.toFixed(0);
  };

  ServiceDetails.prototype.componentDidMount = function componentDidMount() {
    var _get = Object(__WEBPACK_IMPORTED_MODULE_6_utils_object__["b" /* get */])('search.query')(this.props),
        asmc = _get.asmc;

    var asmcArray = asmc && (Array.isArray(asmc) ? asmc : [asmc]);
    var preSelectedAdditionalItems = {};
    asmcArray && asmcArray.forEach(function (item) {
      preSelectedAdditionalItems[item] = true;
    });
    this.syncAdditionalServicesState(preSelectedAdditionalItems);
  };

  ServiceDetails.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (newProps.factoryCode !== this.props.factoryCode) {
      this.setState({
        activeServiceCodeIndex: this.services.findIndex(function (s) {
          return s.code === newProps.factoryCode;
        }),
        selectedAdditionalServices: {}
      });
    }
  };

  ServiceDetails.prototype.getActiveService = function getActiveService() {
    return this.services[this.state.activeServiceCodeIndex];
  };

  ServiceDetails.prototype.getFullDetailsURL = function getFullDetailsURL() {
    var _this3 = this;

    var activeService = this.getActiveService();
    if (!activeService) return '';

    var vin = this.props.data.vehicle ? this.props.data.vehicle.vin : '';
    var selectedCodes = Object.keys(this.state.selectedAdditionalServices).filter(function (k) {
      return _this3.state.selectedAdditionalServices[k];
    }).join(',');
    var vehicleParams = vin && vin.length > 0 ? '&VIN=' + vin + '&modelGroup=' + encodeURIComponent(this.props.data.vehicle.modelGroup) + '&rego=' + this.props.data.vehicle.rego : '';
    var additionalCodesParam = selectedCodes.length > 0 ? '&additionalCodes=' + selectedCodes : '';
    var responseUrl = (this.props.serviceDetailsURL || '/service-details') + '?serviceSpecCode=' + this.props.data.serviceSpecCode + '&factoryCode=' + activeService.code + vehicleParams + additionalCodesParam;
    return responseUrl;
  };

  ServiceDetails.prototype.isSPG = function isSPG() {
    try {
      // trying to guess MSS vs SPG service type
      // MSS factoryCode starts with 'S' and SPG starts with 'M' (yes, it's counterintuitive)
      return this.props.data && this.props.data.serviceItems.some(function (si) {
        return si.factoryCode[0] === 'M';
      });
    } catch (e) {
      if (false) console.log(e);
      return false;
    }
  };

  ServiceDetails.prototype.renderAdditionalDetails = function renderAdditionalDetails() {
    var _this4 = this;

    var _props = this.props,
        selectable = _props.selectAdditionalItems,
        compact = _props.compact;

    var additionalItemsHeading = this.isSPG() ? 'Optional Service Maintenance items' : 'ADDITIONAL SCHEDULED MAINTENANCE';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.additionalServicesContainer(compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 163
        }
      },
      this.additionalServices && !!this.additionalServices.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { textAlign: 'center' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 166
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: {
              borderBottom: compact && '1px solid #aaa',
              marginBottom: '1em'
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 167
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { padding: '4em 0px 0.2em' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 172
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["B" /* H4 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 173
                }
              },
              additionalItemsHeading
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["_1" /* P */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 174
                }
              },
              'Items below must be attended to when they are due.'
            )
          ),
          selectable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: {
                color: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].BLACK,
                fontStyle: 'italic',
                marginBottom: '1.3em',
                fontSize: '90%',
                fontWeight: 200
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 179
              }
            },
            'Select to add to your Total Service Price'
          ),
          selectable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["W" /* ServiceListSelect */], {
            services: this.additionalServices,
            selectedServices: this.state.selectedAdditionalServices,
            onServiceClick: function onServiceClick(code) {
              return _this4.toggleService(code);
            },
            compact: compact, __source: {
              fileName: _jsxFileName,
              lineNumber: 191
            }
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["V" /* ServiceListInspect */], { services: this.additionalServices, compact: compact, __source: {
              fileName: _jsxFileName,
              lineNumber: 197
            }
          })
        ),
        compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["e" /* Button */], {
          styleName: 'blackOutlined',
          label: 'View item details',
          href: this.getFullDetailsURL().concat('#item-details'),
          fullWidth: true,
          inline: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 201
          }
        })
      ),
      selectable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { width: '100%' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 211
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.totalServicePrice(compact), __source: {
              fileName: _jsxFileName,
              lineNumber: 212
            }
          },
          'Total service price',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: '.5em' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 214
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: styles.symbols(compact), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 215
                }
              },
              '$'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: styles.totalServicePriceValue(compact), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 216
                }
              },
              this.calculateTotal()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: styles.symbols(compact), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 217
                }
              },
              '*'
            )
          )
        )
      )
    );
  };

  ServiceDetails.prototype.render = function render() {
    var _this5 = this;

    var activeService = this.getActiveService();
    if (!activeService) return null;
    // /owners/servicing/owners-service-calculator/?VIN=MM0UP0YF100105709&factoryCode=S020
    // /owners/servicing/mazda-genuine-service/?body=Wagon&engine=2.2l%20Diesel%20Auto%20FWD&grade=Touring&model=Mazda6
    var compact = this.props.compact;

    var spg = this.isSPG();
    var baseScheduleHeading = spg ? 'Scheduled Maintenance' : 'Base Scheduled Maintenance';
    var km = this._findNonZeroDistance().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var baseScheduleDescription = spg ? 'Regular servicing is the key to maintaining your investment, which is why it\u2019s important you return every ' + km + ' kms. To ensure your car receives the best and most appropriate service schedule, you should consult your Mazda Dealer.' : 'Base scheduled maintenance is due every ' + km + ' km, but no longer than 12 months, whichever comes first.';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.base, __source: {
          fileName: _jsxFileName,
          lineNumber: 250
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            width: '100%'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 251
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["B" /* H4 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 255
            }
          },
          baseScheduleHeading
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["_1" /* P */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 256
            }
          },
          baseScheduleDescription
        )
      ),
      this.props.factoryCode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            paddingTop: '2em',
            borderBottom: '1px solid rgb(203, 203, 203)',
            textAlign: "left",
            width: '100%'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 259
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["B" /* H4 */],
          { withDetails: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 266
            }
          },
          activeService.shortName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.introOwner(compact), __source: {
              fileName: _jsxFileName,
              lineNumber: 267
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_AtomicComponents__["U" /* Interactive */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 268
              }
            },
            activeService.extraLabel
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["X" /* ServiceMainPanel */], {
        services: this.services,
        activeService: activeService,
        fullDetailsURL: this.getFullDetailsURL(),
        factoryCode: this.props.factoryCode,
        activeServiceCodeIndex: this.state.activeServiceCodeIndex,
        compact: this.props.compact,
        onServiceSelect: function onServiceSelect(index) {
          _this5.setState({ activeServiceCodeIndex: index });
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 272
        }
      }),
      this.renderAdditionalDetails()
    );
  };

  return ServiceDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ServiceDetails.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  factoryCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  serviceDetailsURL: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectAdditionalItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scheduledServiceItemsLimit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  updateSelectedAddtionalServices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
ServiceDetails.defaultProps = {
  data: {},
  factoryCode: '',
  serviceDetailsURL: '',
  selectAdditionalItems: false,
  compact: true
};
ServiceDetails.displayName = 'ServiceDetails';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["g" /* SearchParams */])({ exposeParams: ['factoryCode', 'VIN', 'asmc'] }))(ServiceDetails));

var styles = {
  base: {
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: 'white'
  },

  mainServiceHeader: {
    textAlign: 'left',
    width: '100%'
  },

  introOwner: function introOwner(compact) {
    return {
      display: 'flex',
      flexDirection: compact ? 'column' : 'row',
      alignItems: 'baseline',
      padding: '0.4em 0 1em',
      justifyContent: 'space-between'
    };
  },

  additionalServicesContainer: function additionalServicesContainer(compact) {
    return {
      boxSizing: 'border-box',
      width: '100%',
      display: 'block',
      padding: 0
    };
  },

  totalServicePrice: function totalServicePrice(compact) {
    return {
      display: 'flex',
      flexDirection: compact ? 'column' : 'row',
      justifyContent: 'space-between',
      textTransform: 'uppercase',
      borderBottom: !compact && '1px solid #aaaaaa',
      fontSize: '112.5%',
      letterSpacing: '0.2em',
      fontFamily: 'MazdaTypeTT, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
      paddingTop: '2em',
      paddingBottom: '0.5em',
      alignItems: 'center',
      textAlign: compact && 'center'
    };
  },

  totalServicePriceValue: function totalServicePriceValue(compact) {
    return {
      paddingBottom: '0.2em',
      fontSize: compact ? '250%' : '125%',
      fontWeight: compact && '200',
      letterSpacing: '0'
    };
  },

  symbols: function symbols(compact) {
    return {
      display: compact && 'inline-block',
      verticalAlign: 'top',
      paddingTop: '.1em',
      letterSpacing: compact && '0',
      fontWeight: compact && '200',
      fontSize: compact && '140%'
    };
  }
};

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_base_price__ = __webpack_require__(1731);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\service-details-full\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ServiceDetailsFullContainer = function (_Component) {
  _inherits(ServiceDetailsFullContainer, _Component);

  function ServiceDetailsFullContainer(props) {
    _classCallCheck(this, ServiceDetailsFullContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._findNonZeroDistance = function () {
      var distance = 0;
      _this.props.data && _this.props.data.serviceItems.forEach(function (item) {
        if (item.factoryCodeEntity.distance > 0 && distance === 0) {
          distance = item.factoryCodeEntity.distance;
        }
      });
      return distance;
    };

    _this.state = {};
    _this.selectedAdditionalServices = {};
    props.additionalCodes && props.additionalCodes.forEach(function (c) {
      _this.selectedAdditionalServices[c] = true;
    });
    return _this;
  }

  ServiceDetailsFullContainer.prototype.getMainService = function getMainService() {
    var _this2 = this;

    return (Object(__WEBPACK_IMPORTED_MODULE_5_utils__["q" /* get */])('data.serviceItems', this.props) || []).filter(function (s) {
      return s.factoryCodeEntity.type.match(/Scheduled/);
    }).filter(function (s, index) {
      if (_this2.props.factoryCode) {
        return s.factoryCodeEntity.code === _this2.props.factoryCode;
      }
      return index === 0;
    }).map(function (s) {
      var m = /([^\s]+) Service or (.+)/.exec(s.factoryCodeEntity.description);
      return {
        name: m ? m[1] + ' Service | $' + s.basePrice : s.factoryCodeEntity.description,
        extraLabel: m ? m[2] + ' or ' + s.factoryCodeEntity.time + 'm' : '',
        price: '$' + s.basePrice,
        shortName: m ? m[1] + ' Service' : s.factoryCodeEntity.description,
        code: s.factoryCodeEntity.code,
        item: s
      };
    })[0];
  };

  ServiceDetailsFullContainer.prototype.getAdditionalServices = function getAdditionalServices() {
    return (Object(__WEBPACK_IMPORTED_MODULE_5_utils__["q" /* get */])('data.serviceItems', this.props) || []).filter(function (s) {
      return s.factoryCodeEntity.type === 'Additional Scheduled Maintenance' && s.factoryCodeEntity.distance > 0;
    }).map(function (s) {
      return {
        name: s.factoryCodeEntity.description,
        description: s.operationActions[0].operations[0].description,
        price: '$' + s.basePrice,
        code: s.factoryCodeEntity.code
      };
    });
  };

  ServiceDetailsFullContainer.prototype.renderLinkBack = function renderLinkBack() {
    var url = this.props.backLink;
    if (this.props.data.vehicle.vin) {
      url = '/owners/servicing/owners-service-calculator/?VIN=' + this.props.data.vehicle.vin + '&factoryCode=' + this.props.factoryCode;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["i" /* BackButton */], {
      href: url,
      backText: 'BACK TO SERVICING', __source: {
        fileName: _jsxFileName,
        lineNumber: 84
      }
    });
  };

  ServiceDetailsFullContainer.prototype.isSPG = function isSPG() {
    try {
      // trying to guess MSS vs SPG service type
      // MSS factoryCode starts with 'S' and SPG starts with 'M' (yes, it's counterintuitive)
      return this.props.data && this.props.data.serviceItems.some(function (si) {
        return si.factoryCodeEntity.code[0] === 'M';
      });
    } catch (e) {
      if (false) console.log(e);
      return false;
    }
  };

  ServiceDetailsFullContainer.prototype.render = function render() {
    var _props = this.props,
        data = _props.data,
        compact = _props.compact;

    var mainService = this.getMainService();
    var additionalServices = this.getAdditionalServices();
    var vehicle = data.vehicle;
    // /service-details?serviceSpecCode=GL20SH0DA10&factoryCode=S030
    // we had some rule for some reason earlier to hide price for all Owner results (e.i with vin number)
    var hidePrice = false;
    var spg = this.isSPG();
    // only display price in top header for SPG results
    var serviceTitle = spg ? mainService.item.factoryCodeEntity.description + ' - $' + mainService.item.basePrice : mainService.item.factoryCodeEntity.description;
    var km = this._findNonZeroDistance().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var baseScheduleHeading = spg ? 'Scheduled Maintenance' : 'Base Scheduled Maintenance';
    var baseScheduleDescription = spg ? 'Regular servicing is the key to maintaining your investment, which is why it\u2019s important you return every ' + km + ' kms. To ensure your car receives the best and most appropriate service schedule, you should consult your Mazda Dealer.' : 'Base scheduled maintenance is due every ' + km + ' km, but no longer than 12 months, whichever comes first.';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_8" /* Section */],
      { horizontalPadding: true, center: false, backgroundColor: '#f5f5f5', __source: {
          fileName: _jsxFileName,
          lineNumber: 133
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.base(compact), __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { alignSelf: "flex-start" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 135
            }
          },
          this.renderLinkBack()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.mainServiceHeader(compact), __source: {
              fileName: _jsxFileName,
              lineNumber: 138
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["A" /* H3 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 139
              }
            },
            'SERVICE DETAILS'
          ),
          vehicle.modelGroup && vehicle.vin && vehicle.grade && vehicle.rego && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["Y" /* ServiceModelDetails */], {
            model: vehicle.modelGroup + ' ' + vehicle.grade,
            vin: vehicle.vin,
            registration: vehicle.rego && vehicle.rego != 'null' ? vehicle.rego : '',
            compact: compact, __source: {
              fileName: _jsxFileName,
              lineNumber: 145
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.serviceSummary, __source: {
              fileName: _jsxFileName,
              lineNumber: 153
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: {
                background: "#fff",
                padding: "2em"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 154
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["C" /* H5 */],
              { withDetails: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 159
                }
              },
              serviceTitle
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_1" /* P */],
              { withoutMargin: true, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 160
                }
              },
              baseScheduleDescription
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.serviceListContainer(compact), __source: {
              fileName: _jsxFileName,
              lineNumber: 164
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["A" /* H3 */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 165
              }
            },
            baseScheduleHeading
          ),
          mainService.item.operationActions.length && mainService.item.operationActions.map(function (category, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: category.name, style: styles.listSection(i === 0), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 168
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["C" /* H5 */],
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 169
                  }
                },
                category.name
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["V" /* ServiceListInspect */], { services: category.operations, compact: compact, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 170
                }
              })
            );
          }),
          !hidePrice && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: {
                textAlign: 'right',
                padding: '2em 0',
                borderTop: '1px solid #aaa'
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 174
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__service_base_price__["a" /* default */], { service: mainService.item, compact: compact, __source: {
                fileName: _jsxFileName,
                lineNumber: 180
              }
            })
          ),
          additionalServices.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { id: 'item-details', __source: {
                fileName: _jsxFileName,
                lineNumber: 184
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["B" /* H4 */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 185
                }
              },
              'ADDITIONAL SCHEDULED MAINTENANCE'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["V" /* ServiceListInspect */], { services: additionalServices, compact: compact, __source: {
                fileName: _jsxFileName,
                lineNumber: 186
              }
            })
          ) : ''
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: '2em' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 192
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { maxWidth: '70em', margin: 'auto' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 193
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers__["k" /* ExpandableInfo */], {
              color: '#cccccc',
              mainText: 'Read full terms and conditions',
              description: this.props.termsAndConditions, __source: {
                fileName: _jsxFileName,
                lineNumber: 194
              }
            })
          )
        )
      )
    );
  };

  return ServiceDetailsFullContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ServiceDetailsFullContainer.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  factoryCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  additionalCodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  termsAndConditions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ServiceDetailsFullContainer.defaultProps = {
  data: {},
  factoryCode: '',
  additionalCodes: []
};
ServiceDetailsFullContainer.displayName = 'ServiceDetailsFullContainer';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["b" /* DetectCompact */])())(ServiceDetailsFullContainer));

var styles = {
  base: function base(compact) {
    return {
      flexDirection: 'column',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      boxSizing: 'border-box'
    };
  },

  serviceSummary: {
    backgroundColor: 'white',
    borderRadius: '4px',
    border: 'solid #999 1px',
    marginTop: '1em',
    width: '100%'
  },

  serviceListContainer: function serviceListContainer(compact) {
    return {
      width: '100%',
      boxSizing: 'border-box',
      margin: 'auto',
      padding: compact ? 0 : '0 2em'
    };
  },

  mainServiceHeader: function mainServiceHeader(compact) {
    return {
      marginTop: '1em',
      textAlign: "center"
    };
  },

  listSection: function listSection(isFirst) {
    return {
      margin: isFirst ? '1em 0 0' : '5em 0 0',
      borderBottom: '1px solid #aaa'
    };
  },

  listSectionTitle: {
    display: 'block',
    fontSize: '1.2em',
    margin: '0 0 0.9em 0',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    fontFamily: 'inherit'
  }
};

/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\service-details-full\\service-base-price.jsx";






var ServiceBasePrice = function ServiceBasePrice(_ref) {
  var basePrice = _ref.service.basePrice,
      compact = _ref.compact;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.basePrice(compact), __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: styles.basePriceLabel(compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      "BASE SCHEDULED MAINTENANCE:"
    ),
    " ",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: styles.basePriceValue, __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      },
      "$" + basePrice.toFixed(0)
    )
  );
};

ServiceBasePrice.displayName = "ServiceBasePrice";
ServiceBasePrice.displayName = "ServiceBasePrice";
ServiceBasePrice.propTypes = {
  service: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    basePrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var styles = {
  basePrice: function basePrice(compact) {
    return _extends({
      letterSpacing: __WEBPACK_IMPORTED_MODULE_3_constants_general_style__["c" /* GENERAL_STYLE_HEADING */].LETTER_SPACING,
      color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].BLACK,
      textTransform: "uppercase",
      display: "flex",
      alignItems: "center",
      fontWeight: 600
    }, compact ? {
      width: "100%",
      justifyContent: "space-between"
    } : {
      justifyContent: "flex-end"
    });
  },

  basePriceLabel: function basePriceLabel(compact) {
    return {
      display: "block",
      lineHeight: 1.4,
      textAlign: "left",
      margin: "0 1em 0 0",
      fontSize: compact ? "1em" : "0.9em"
    };
  },

  basePriceValue: {
    display: "block"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(ServiceBasePrice));

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\service-list-inspect\\index.jsx";





var commonStyles = {
  list: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  },
  description: {
    fontWeight: 200,
    padding: "0 1em 0 0",
    lineHeight: 1.5,
    display: "block"
  },
  price: {
    fontWeight: 600
  }
};

function Compact(_ref) {
  var _ref$services = _ref.services,
      services = _ref$services === undefined ? [] : _ref$services;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25
      }
    },
    services.map(function (service, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["b" /* AccordionText */],
        {
          styleName: "simple",
          key: service.subOpCode || i,
          name: service.name,
          labelCase: "inherit",
          barBorder: "top",
          ignorePropsComponents: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: compactStyles.service, __source: {
              fileName: _jsxFileName,
              lineNumber: 34
            }
          },
          service.price && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: _extends({}, commonStyles.price, compactStyles.price), __source: {
                fileName: _jsxFileName,
                lineNumber: 36
              }
            },
            service.price
          ),
          service.description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: commonStyles.description, __source: {
                fileName: _jsxFileName,
                lineNumber: 39
              }
            },
            service.description
          )
        )
      );
    })
  );
}

Compact.displayName = "Compact";
Compact.displayName = "Compact";
var compactStyles = {
  service: {
    display: "flex",
    flexDirection: "column",
    padding: "1em 0"
  },
  price: {
    margin: ".5em 0 1em"
  }
};

function Large(_ref2) {
  var services = _ref2.services;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "ul",
    { style: commonStyles.list, __source: {
        fileName: _jsxFileName,
        lineNumber: 61
      }
    },
    services.map(function (service, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { style: largeStyles.service, key: service.subOpCode || i, __source: {
            fileName: _jsxFileName,
            lineNumber: 63
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: largeStyles.content, __source: {
              fileName: _jsxFileName,
              lineNumber: 64
            }
          },
          service.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: largeStyles.name, __source: {
                fileName: _jsxFileName,
                lineNumber: 65
              }
            },
            service.name
          ),
          service.description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: commonStyles.description, __source: {
                fileName: _jsxFileName,
                lineNumber: 67
              }
            },
            service.description
          )
        ),
        service.price && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: _extends({}, commonStyles.price, largeStyles.price), __source: {
              fileName: _jsxFileName,
              lineNumber: 71
            }
          },
          service.price
        )
      );
    })
  );
}

Large.displayName = "Large";
Large.displayName = "Large";
var largeStyles = {
  service: {
    boxSizing: "border-box",
    padding: "1.8em 1em 1.2em",
    display: "flex",
    borderTop: "1px solid #aaaaaa",
    margin: 0,
    listStyleType: "none"
  },
  content: {
    flexGrow: 1,
    textAlign: "left"
  },
  name: {
    fontWeight: 600,
    margin: "0 0 1em 0"
  },
  price: {
    flexGrow: 0,
    flexShrink: 0
  }
};

function ServiceListInspect() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return props.compact ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Compact, _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103
    }
  })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Large, _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103
    }
  }));
}

ServiceListInspect.propTypes = Compact.propTypes = Large.propTypes = {
  services: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(ServiceListInspect));

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\service-list-select\\index.jsx";





function ServiceListSelect(_ref) {
  var _ref$services = _ref.services,
      services = _ref$services === undefined ? [] : _ref$services,
      _ref$selectedServices = _ref.selectedServices,
      selectedServices = _ref$selectedServices === undefined ? {} : _ref$selectedServices,
      _ref$compact = _ref.compact,
      compact = _ref$compact === undefined ? true : _ref$compact,
      _ref$onServiceClick = _ref.onServiceClick,
      onServiceClick = _ref$onServiceClick === undefined ? function () {} : _ref$onServiceClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "ul",
    { style: styles.list, __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    },
    services.map(function (service) {
      var isSelected = !!selectedServices[service.code];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        {
          key: service.code,
          onClick: function onClick() {
            return onServiceClick(service.code);
          },
          style: _extends({}, styles.service(compact), isSelected ? styles.selected : {}), __source: {
            fileName: _jsxFileName,
            lineNumber: 18
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.checkboxContainer(compact), __source: {
              fileName: _jsxFileName,
              lineNumber: 25
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["h" /* CheckBox */], {
            checked: isSelected,
            onClick: function onClick(e) {
              e && e.stopPropagation();
              onServiceClick(service.code);
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 26
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.details(compact), __source: {
              fileName: _jsxFileName,
              lineNumber: 34
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.content, __source: {
                fileName: _jsxFileName,
                lineNumber: 35
              }
            },
            service.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.name, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 36
                }
              },
              service.name
            ),
            !compact && service.description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: styles.description, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 39
                }
              },
              service.description
            )
          ),
          service.price && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.price, __source: {
                fileName: _jsxFileName,
                lineNumber: 42
              }
            },
            service.price
          )
        )
      );
    })
  );
}

ServiceListSelect.displayName = "ServiceListSelect";
ServiceListSelect.displayName = "ServiceListSelect";
ServiceListSelect.propTypes = {
  services: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  selectedServices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onServiceClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var styles = {
  list: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
    display: "block",
    width: "100%"
  },
  service: function service(compact) {
    return _extends({
      boxSizing: "border-box",
      padding: compact ? "2em 0 1.8em" : "2em 1em 1.8em 0",
      display: "flex",
      borderTop: "1px solid rgb(203, 203, 203)",
      margin: 0,
      width: "100%",
      listStyleType: "none",
      cursor: "pointer"
    }, compact ? { alignItems: "center" } : {}, {
      ":hover": {
        backgroundColor: "#f5f5f5"
      }
    });
  },
  selected: {
    backgroundColor: "#f5f5f5"
  },
  checkboxContainer: function checkboxContainer(compact) {
    return {
      flexGrow: 0,
      flexShrink: 0,
      margin: compact ? "0" : "0 1em 0 0",
      transform: "scale(0.9)"
    };
  },
  details: function details(compact) {
    return _extends({
      textAlign: "left",
      flexGrow: 1,
      display: "flex"
    }, compact ? { alignItems: "center" } : {});
  },
  content: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    flexBasis: "100%" // This is added for IE 11 only.
  },
  name: {
    fontWeight: 400,
    lineHeight: 1.2
  },
  description: {
    fontWeight: 200,
    lineHeight: 1.5,
    margin: "1em 0 0"
  },
  price: {
    fontWeight: 600,
    flexGrow: 0,
    flexShrink: 0,
    marginLeft: "2em"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(ServiceListSelect));

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ServiceMainPanel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\service-main-panel\\index.jsx";






var Large = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var activeService = props.activeService,
      fullDetailsURL = props.fullDetailsURL,
      factoryCode = props.factoryCode,
      activeServiceCodeIndex = props.activeServiceCodeIndex,
      services = props.services,
      onServiceSelect = props.onServiceSelect;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: largeStyles.wrapper, __source: {
        fileName: _jsxFileName,
        lineNumber: 18
      }
    },
    !factoryCode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { width: "100%", margin: "auto", paddingBottom: "3em", overflow: "hidden" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["_12" /* TabsResponsive */], {
        active: activeServiceCodeIndex,
        animatedLine: true,
        options: services,
        onChange: function onChange(e) {
          onServiceSelect(services.findIndex(function (s) {
            return s.code === e.code;
          }));
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          width: "100%",
          margin: "auto",
          boxSizing: "border-box",
          padding: "0 1em 1em"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { position: "relative", transition: "height 1s ease-in-out" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 37
          }
        },
        services.map(function (s) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              key: s.code,
              style: {
                textAlign: "left",
                columnCount: 3,
                MozColumnCount: 3,
                margin: "auto",
                paddingTop: "4em",
                paddingBottom: "3em",
                display: s.item.factoryCodeEntity.code === activeService.code ? "block" : "none"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 39
              }
            },
            s.item.operationActions.map(function (category) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { display: "block", paddingBottom: "1.5em" }, key: category.name, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 51
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  { style: largeStyles.scheduledMaintenanceItem, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 52
                    }
                  },
                  category.name
                ),
                category.operations.map(function (o) {
                  return o.name === "M-MDS M-MDS" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { key: o.subOpCode, style: largeStyles.scheduledMaintenanceItem, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 55
                      }
                    },
                    o.name
                  );
                })
              );
            })
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: [largeStyles.basicsLastLine, {
            fontWeight: 600,
            letterSpacing: 1.8,
            fontSize: "81%",
            marginLeft: "0.4em"
          }], __source: {
            fileName: _jsxFileName,
            lineNumber: 64
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["a" /* A */],
          { href: fullDetailsURL, __source: {
              fileName: _jsxFileName,
              lineNumber: 74
            }
          },
          "view service details \u203A",
          " "
        )
      )
    )
  );
});

var largeStyles = {
  wrapper: {
    width: "100%"
  },

  basicsLastLine: {
    width: "100%",
    textTransform: "uppercase",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },

  scheduledMaintenanceItem: {
    display: "block",
    padding: "0.3em",
    fontSize: "16px",
    marginTop: "0",
    marginBottom: "5px"
  }
};

var Compact = Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fullDetailsURL = props.fullDetailsURL,
      factoryCode = props.factoryCode,
      activeServiceCodeIndex = props.activeServiceCodeIndex,
      services = props.services,
      onServiceSelect = props.onServiceSelect;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: compactStyles.wrapper, __source: {
        fileName: _jsxFileName,
        lineNumber: 111
      }
    },
    !factoryCode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            color: "#b8b6b8",
            fontStyle: "italic",
            textAlign: "center",
            padding: "1em"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 114
          }
        },
        "Swipe to see your first five services"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_components__["_5" /* Slideshow */],
        {
          showBullets: true,
          activate: activeServiceCodeIndex,
          bulletsBelow: true,
          handleChange: function handleChange(index) {
            if (Math.floor(index) !== parseFloat(activeServiceCodeIndex)) {
              onServiceSelect(Math.floor(index));
            }
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 123
          }
        },
        services.map(function (s, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { key: index, style: { paddingBottom: "1em" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 133
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                style: {
                  border: "solid 1px #b8b6b8",
                  marginLeft: "1em",
                  marginRight: "1em",
                  display: "flex",
                  flexDirection: "column",
                  paddingTop: "2em",
                  paddingBottom: "2em",
                  alignItems: "center"
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 134
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["F" /* Heading */], { value: s.shortName, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 145
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: compactStyles.basePriceMobile, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 146
                  }
                },
                s.price
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { fontStyle: "italic" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 147
                  }
                },
                s.extraLabel
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { pointerEvents: "auto" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 148
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["e" /* Button */], {
                  type: "a",
                  styleName: "black",
                  label: "Service details",
                  href: fullDetailsURL, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 149
                  }
                })
              )
            )
          );
        })
      )
    ),
    factoryCode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          boxSizing: "border-box",
          paddingTop: "2em",
          paddingBottom: "2em"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 162
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["e" /* Button */], {
        styleName: "blackOutlined",
        label: "View service details",
        href: fullDetailsURL,
        fullWidth: true,
        inline: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 168
        }
      })
    )
  );
});

var compactStyles = {
  wrapper: {
    display: "block",
    textAlign: "center",
    width: "100%",
    boxSizing: "border-box"
  },
  basePriceMobile: {
    fontWeight: 600,
    fontSize: "2em",
    margin: "1em"
  }
};

function ServiceMainPanel() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return props.compact ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Compact, _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 195
    }
  })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Large, _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 195
    }
  }));
}

ServiceMainPanel.propTypes = Large.propTypes = Compact.propTypes = {
  services: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  activeService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  fullDetailsURL: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  factoryCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeServiceCodeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onServiceSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\service-model-details\\index.jsx";




function ServiceModelDetails(_ref) {
  var _ref$model = _ref.model,
      model = _ref$model === undefined ? "" : _ref$model,
      _ref$vin = _ref.vin,
      vin = _ref$vin === undefined ? "" : _ref$vin,
      _ref$registration = _ref.registration,
      registration = _ref$registration === undefined ? "" : _ref$registration,
      _ref$compact = _ref.compact,
      compact = _ref$compact === undefined ? true : _ref$compact;

  var item = styles.item(compact);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.list(compact), __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      }
    },
    model && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: item, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "b",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        },
        "Model:"
      ),
      " ",
      model
    ),
    vin && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: item, __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "b",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 18
          }
        },
        "VIN:"
      ),
      " ",
      vin
    ),
    registration && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: item, __source: {
          fileName: _jsxFileName,
          lineNumber: 22
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "b",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        },
        "Registration:"
      ),
      " ",
      registration
    )
  );
}

ServiceModelDetails.displayName = "ServiceModelDetails";
ServiceModelDetails.displayName = "ServiceModelDetails";
var styles = {
  list: function list(compact) {
    return {
      textAlign: "center",
      display: "flex",
      padding: "0.5em",
      justifyContent: "center",
      flexWrap: "wrap",
      alignItems: "center",
      margin: compact ? 0 : "1em 0 0",
      width: "100%",
      fontWeight: 200
    };
  },

  item: function item(compact) {
    return {
      display: "block",
      margin: ".3em .5em",
      lineHeight: 1.3,
      wordWrap: compact ? "break-word" : "normal"
    };
  }
};

ServiceModelDetails.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  registration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(ServiceModelDetails));

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__search_result_item__ = __webpack_require__(1737);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\site-search\\index.jsx";










var getResultRange = function getResultRange(currentPage, resultsPerPage, totalHits) {
  var from = (currentPage - 1) * resultsPerPage;
  var to = currentPage * resultsPerPage;
  return from + 1 + " - " + (to > totalHits ? totalHits : to);
};

var SiteSearchContainer = function SiteSearchContainer(_ref) {
  var heading = _ref.heading,
      backgroundImageUrl = _ref.backgroundImageUrl,
      searchFieldPlaceholderText = _ref.searchFieldPlaceholderText,
      updateSearchQuery = _ref.updateSearchQuery,
      requestPage = _ref.requestPage,
      gtmEvent = _ref.gtmEvent,
      compact = _ref.compact,
      _ref$searchResultsDat = _ref.searchResultsData,
      resultsPerPage = _ref$searchResultsDat.resultsPerPage,
      error = _ref$searchResultsDat.error,
      currentPage = _ref$searchResultsDat.currentPage,
      results = _ref$searchResultsDat.results,
      totalHits = _ref$searchResultsDat.totalHits,
      totalPage = _ref$searchResultsDat.totalPage,
      isFetching = _ref$searchResultsDat.isFetching,
      query = _ref.query;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { position: "relative", overflow: "hidden", minHeight: "calc(100vh - 100px)" }, __source: {
        fileName: _jsxFileName,
        lineNumber: 42
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components__["x" /* FullWidthImageSection */],
      {
        height: "fit",
        fullWidth: true,
        backgroundImage: backgroundImageUrl, __source: {
          fileName: _jsxFileName,
          lineNumber: 43
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { maxWidth: "800px", margin: "0 auto" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["F" /* Heading */], { tag: "h3", value: heading, __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { onSubmit: function onSubmit(e) {
              e.preventDefault();
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 49
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_1" /* SearchInput */], {
            styleName: "dark",
            onSearch: function onSearch(q) {
              if (q.length) {
                gtmEvent({
                  gtmID: __WEBPACK_IMPORTED_MODULE_6_store_gtm_events__["o" /* gtmSearchActionTypes */].SITE_SEARCH_RESULTS,
                  gtmPayload: { query: q }
                });
                updateSearchQuery(q);
              }
            },
            initialValue: query,
            placeholder: searchFieldPlaceholderText, __source: {
              fileName: _jsxFileName,
              lineNumber: 50
            }
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { maxWidth: "800px", margin: "0 auto", padding: "2em 1em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        }
      },
      error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { style: styles.error, __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        },
        error
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        },
        isFetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["M" /* LoaderIcon */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 73
            }
          })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 76
            }
          },
          !!query.length && (totalHits ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            { style: styles.message, __source: {
                fileName: _jsxFileName,
                lineNumber: 79
              }
            },
            "Showing",
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              { style: { fontWeight: 400 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 81
                }
              },
              getResultRange(currentPage, resultsPerPage, totalHits)
            ),
            " ",
            "of ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              { style: { fontWeight: 400 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 84
                }
              },
              totalHits
            ),
            " results for \"",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              { style: { fontWeight: 400 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 84
                }
              },
              query
            ),
            "\""
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            { style: styles.message, __source: {
                fileName: _jsxFileName,
                lineNumber: 87
              }
            },
            "No results for \"",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              { style: { fontWeight: 400 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 88
                }
              },
              query
            ),
            "\""
          )),
          results && results.map(function (_ref2, index) {
            var title = _ref2.title,
                excerpt = _ref2.excerpt,
                url = _ref2.url;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__search_result_item__["a" /* default */], {
              highlight: query.split(" "),
              key: currentPage + "-" + (title || "").replace(/(\s|\_|\|)/g, "-").toLowerCase() + "-" + index // eslint-disable-line react/no-array-index-key
              , href: url,
              title: title,
              description: excerpt,
              animationDelay: index * 0.1,
              gtmEvents: [{
                func: gtmEvent,
                args: [{
                  gtmID: __WEBPACK_IMPORTED_MODULE_6_store_gtm_events__["o" /* gtmSearchActionTypes */].SITE_SEARCH_RESULTS_CLICKED,
                  gtmPayload: { query: query, clicked: title }
                }]
              }], __source: {
                fileName: _jsxFileName,
                lineNumber: 93
              }
            });
          })
        ),
        !isFetching && results && totalPage > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.pagesSection, __source: {
              fileName: _jsxFileName,
              lineNumber: 119
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["V" /* PaginationSelector */], {
            onClickNumber: function onClickNumber(page) {
              return requestPage(page);
            },
            onClickNext: function onClickNext() {
              return requestPage(currentPage + 1);
            },
            onClickBack: function onClickBack() {
              return requestPage(currentPage - 1);
            },
            maxDisplay: compact ? 3 : 5,
            current: currentPage,
            count: totalPage, __source: {
              fileName: _jsxFileName,
              lineNumber: 120
            }
          })
        )
      )
    )
  );
};

SiteSearchContainer.displayName = "SiteSearchContainer";
SiteSearchContainer.displayName = "SiteSearchContainer";
SiteSearchContainer.propTypes = {
  updateSearchQuery: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  requestPage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  searchResultsData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    hits: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    totalHits: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    totalPage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    isFetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  searchFieldPlaceholderText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundImageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["i" /* gtmEvent */])(), Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["n" /* withSearch */])())(SiteSearchContainer));

var styles = {
  error: _extends({}, __WEBPACK_IMPORTED_MODULE_4_constants_general_style__["a" /* BASE_COPY */], {
    textAlign: "center",
    color: __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].RED
  }),
  pagesSection: {
    textAlign: "center",
    padding: "3em 0 1em",
    borderTop: "1px solid " + __WEBPACK_IMPORTED_MODULE_5_constants_color_palette__["a" /* default */].GRAY
  },
  message: _extends({}, __WEBPACK_IMPORTED_MODULE_4_constants_general_style__["a" /* BASE_COPY */])
};

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_highlight_words__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_highlight_words___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_highlight_words__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\site-search\\search-result-item.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SearchResultItem = function (_PureComponent) {
  _inherits(SearchResultItem, _PureComponent);

  function SearchResultItem() {
    _classCallCheck(this, SearchResultItem);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  SearchResultItem.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        description = _props.description,
        animationDelay = _props.animationDelay,
        href = _props.href,
        highlight = _props.highlight,
        gtmEvents = _props.gtmEvents;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_components__["H" /* Hyperlink */],
      {
        gtmEvents: gtmEvents,
        href: href,
        withoutStyle: true,
        style: _extends({}, styles.container), __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        {
          style: [styles.title, Object(__WEBPACK_IMPORTED_MODULE_1_radium__["getState"])(this.state, "main", ":hover") && { textDecoration: "underline" }], __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        },
        title
      ),
      description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { style: styles.description, __source: {
            fileName: _jsxFileName,
            lineNumber: 31
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_highlight_words___default.a, {
          highlightStyle: { fontWeight: 400, backgroundColor: "transparent" },
          searchWords: highlight || [],
          textToHighlight: description, __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        })
      )
    );
  };

  return SearchResultItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SearchResultItem.displayName = "SearchResultItem";


SearchResultItem.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  animationDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  href: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium__["a" /* default */])(SearchResultItem));

var fadeInKeyframes = Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium__["b" /* keyframes */])({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});

var styles = {
  title: _extends({}, __WEBPACK_IMPORTED_MODULE_5_constants_general_style__["b" /* BASE_HEADING */]),
  description: _extends({}, __WEBPACK_IMPORTED_MODULE_5_constants_general_style__["a" /* BASE_COPY */], {
    textDecoration: "none"
  }),
  container: {
    color: __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__["a" /* default */].BLACK,
    display: "block",
    textDecoration: "none",
    margin: "2em 0",
    paddingTop: "2em",
    borderTop: "1px solid " + __WEBPACK_IMPORTED_MODULE_6_constants_color_palette__["a" /* default */].GRAY,
    ":hover": {}
  },
  animation: function animation(delay) {
    return {
      opacity: 0,
      animation: "x .666s " + delay + "s forwards",
      animationName: fadeInKeyframes
    };
  }
};

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\sixty-fourty-block\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SixtyFourtyBlock = function (_Component) {
  _inherits(SixtyFourtyBlock, _Component);

  function SixtyFourtyBlock() {
    _classCallCheck(this, SixtyFourtyBlock);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * @param {String} [preHeading] - Pre-Heading text.
   * @param {String} [heading] - Heading text.
   * @param {String} [blurb] - blurb text as xhtml string.
   * @param {'left'|'right'|'center'} [textAlign=left] - Text alignment.
   * @param {'top'|'bottom'|'center'} [textVerticalAlign=top] - Vertical text alignment.
   * @param {String} imageUrl - Image url.
   * @param {String} [backgroundColor='#f5f5f5'] - Background color as HTML hex code.
   * @param {'true'|'false'} [imagePositionMobile=false] - true means image should be on top always
   * @param {'left'|'right'} [imagePosition=left] - Image position.
   * @param {Array|Button} [components] - Array of nested components.
   * @returns {ReactElement} React Component
   */
  SixtyFourtyBlock.prototype.render = function render() {
    var props = this.props;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["m" /* FiftyFiftyBlock */], _extends({}, props, {
      imageAlign: props.imagePosition === 'left' ? 'left' : 'right',
      ratio: props.imagePosition === 'left' ? 60 : 40, __source: {
        fileName: _jsxFileName,
        lineNumber: 38
      }
    }));
  };

  return SixtyFourtyBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SixtyFourtyBlock.propTypes = {
  preHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['small', 'medium', 'large', 'disable']),
  blurb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  textAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right', 'center']),
  textVerticalAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom', 'center']),
  imageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  imagePosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),
  ImagePositionMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  imageSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  ratio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string };
SixtyFourtyBlock.displayName = 'SixtyFourtyBlock';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(SixtyFourtyBlock));

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__slick_css__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__slick_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\slider\\index.jsx";

var _templateObject = _taggedTemplateLiteralLoose(["\n    ", "\n  "], ["\n    ", "\n  "]);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }








if (undefined && undefined === "dingo") {
  Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["b" /* injectGlobal */])(_templateObject, __WEBPACK_IMPORTED_MODULE_5__slick_css___default.a);
} else {
  __webpack_require__(647);
}

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider() {
    _classCallCheck(this, Slider);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Slider.prototype.render = function render() {
    var settings = {};
    if (!this.props.settings) {
      settings = {
        arrows: !this.props.compact,
        centerMode: false,
        mobileFirst: true,
        infinite: false,
        variableWidth: true,
        slidesToShow: 9,
        slidesToScroll: 5,
        initialSlide: 0,
        responsive: [{
          breakpoint: 604,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 906,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 1208,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 1510,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 1812,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 2114,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 2416,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 4
          }
        }, {
          breakpoint: 2718,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 5
          }
        }]
      };
    } else {
      settings = this.props.settings;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_slick___default.a,
      _extends({}, settings, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 90
        }
      }),
      this.props.children
    );
  };

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Slider.displayName = "Slider";


Slider.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  settings: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["b" /* DetectCompact */])())(Slider));

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SpecificationList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\specification-list\\index.jsx";







/**
 * Specification List
 * @returns {ReactElement} React Component
 */
var SpecificationList = function SpecificationList(props) {
  var accordionProps = Object(__WEBPACK_IMPORTED_MODULE_5_utils__["E" /* omit */])(["specs"], props);
  var specs = props.specs;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicContainers__["c" /* AccordionTextList */], {
    alwaysOpen: props.alwaysOpen,
    data: specs.map(function (category, index) {
      return {
        title: category.name,
        onClick: category.onClick,
        description: category.items.map(function (item, index) {
          return item.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers__["_3" /* SpecificationListItem */], _extends({
            gtmEventsDisclaimers: props.gtmEventsDisclaimers,
            key: index
          }, item, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 25
            }
          }));
        })
      };
    }), __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    }
  });
};

SpecificationList.displayName = "SpecificationList";
SpecificationList.displayName = "SpecificationList";
SpecificationList.propTypes = {
  specs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  alwaysOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(SpecificationList));

/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\specification-list-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/** Specification List Component */

var SpecificationListItem = function (_Component) {
  _inherits(SpecificationListItem, _Component);

  function SpecificationListItem() {
    _classCallCheck(this, SpecificationListItem);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * @returns {ReactElement} React Component
   */
  SpecificationListItem.prototype.render = function render() {
    var _props = this.props,
        name = _props.name,
        items = _props.items,
        gtmEventsDisclaimers = _props.gtmEventsDisclaimers,
        imageUrl = _props.imageUrl,
        description = _props.description,
        partNumber = _props.partNumber;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.content, __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      },
      imageUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imageUrl, style: styles.img, alt: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.contentCell, __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        },
        name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["D" /* H6 */],
          { withDetails: true, style: styles.subLabel, __source: {
              fileName: _jsxFileName,
              lineNumber: 24
            }
          },
          name
        ),
        name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_13" /* Space */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          }
        }),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_25" /* WysiwygContent */], { xmlString: description, __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        }),
        partNumber && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_25" /* WysiwygContent */], { xmlString: '<p>PART NUMBER: ' + partNumber + '</p>', style: styles.contentText, __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        })
      ),
      items && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.contentCell, __source: {
            fileName: _jsxFileName,
            lineNumber: 30
          }
        },
        items.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index, __source: {
                fileName: _jsxFileName,
                lineNumber: 32
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: styles.item, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 33
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_containers__["w" /* InlineDisclaimerBlock */],
                {
                  yOffset: -6,
                  showingUnderline: true,
                  gtmEvents: gtmEventsDisclaimers,
                  identifier: item.disclaimer && item.disclaimer.disclaimerCode,
                  message: item.disclaimer && item.disclaimer.disclaimerText, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 34
                  }
                },
                item.key,
                item.content && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: styles.contentText, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 41
                    }
                  },
                  ' ',
                  item.content
                )
              )
            )
          );
        })
      )
    );
  };

  return SpecificationListItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SpecificationListItem.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array };
SpecificationListItem.displayName = 'SpecificationListItem';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(SpecificationListItem));

var styles = {
  subLabel: {
    fontSize: '81%',
    textTransform: 'uppercase',
    letterSpacing: '.2em',
    marginBottom: '1em',
    fontWeight: 600
  },
  item: {
    display: 'inline-block',
    fontWeight: 200,
    fontSize: '100%',
    margin: '0 0 1em',
    lineHeight: '1.2'
  },
  content: {
    display: 'flex',
    padding: '1em 0px',
    flexWrap: 'wrap',
    '@media (min-width: 768px)': {
      padding: '2em 0px'
    }
  },
  contentCell: {
    flex: '1 1 100%',
    '@media (min-width: 768px)': {
      flex: '1 1 50%'
    }
  },
  img: {
    marginRight: '2em',
    width: '230px'
  },
  contentText: {
    color: '#888'
  }
};

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils__ = __webpack_require__(9);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\specifications-block\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var apiMapping = function apiMapping(stateOptions) {
  return {
    nameplate: stateOptions.nameplate.name,
    bodystyle: stateOptions.bodyStyle.name,
    grade: stateOptions.grade.name,
    drivetrain: stateOptions.drivetrain.name
  };
};

var getNameIfDefault = function getNameIfDefault(option) {
  return option && Object(__WEBPACK_IMPORTED_MODULE_6_utils__["q" /* get */])("name", option);
};
var stateToParamsMapping = function stateToParamsMapping(options) {
  return {
    bodyStyle: getNameIfDefault(options.bodyStyle),
    drivetrain: getNameIfDefault(options.drivetrain),
    grade: getNameIfDefault(options.grade),
    transmission: getNameIfDefault(options.transmission),
    engine: getNameIfDefault(options.engine),
    color: getNameIfDefault(options.color),
    interiorDesign: getNameIfDefault(options.interiorDesign)
  };
};

// Specification block component

var SpecificationsBlock = function (_Component) {
  _inherits(SpecificationsBlock, _Component);

  function SpecificationsBlock(props) {
    _classCallCheck(this, SpecificationsBlock);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.getSpecs = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var update = _this.props.specifications.update;

      var updateOptions = options;
      if (_this.earlyUpdate) {
        updateOptions = _this.earlyUpdate;
        _this.earlyUpdate = false;
      }
      var updatePromise = update(updateOptions);
      if (!updatePromise) _this.earlyUpdate = options;else _this.props.search.pushParam(stateToParamsMapping(updateOptions));
    };

    _this.state = {
      specifications: false,
      isLoading: true
    };
    return _this;
  }

  SpecificationsBlock.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        specifications = _props.specifications,
        initialResults = _props.initialResults,
        specsApiEndpoint = _props.specsApiEndpoint;

    specifications.setOptions({
      mapping: apiMapping,
      initial: initialResults && { categories: initialResults },
      fetchURL: specsApiEndpoint,
      featured: false
    });
  };

  SpecificationsBlock.prototype.componentDidMount = function componentDidMount() {
    this.setState({ isLoading: false });
  };

  /**
   * @param {String} heading - Heading text.
   * @param {String} specsApiEndpoint - Api enpoint url for full specifications.
   * @param {Object} gradePickerData - Object containing grade picker selection tree.
   * @returns {ReactElement} React Component
   */
  SpecificationsBlock.prototype.render = function render() {
    var _props2 = this.props,
        specifications = _props2.specifications,
        heading = _props2.heading,
        gradePickerData = _props2.gradePickerData;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_containers__["g" /* ColumnGroup */],
      { style: { minHeight: "70vh" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 81
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_containers__["f" /* Column */],
        { textAlignMobile: "left", __source: {
            fileName: _jsxFileName,
            lineNumber: 82
          }
        },
        this.state.isLoading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "center",
              marginBottom: "3em"
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 84
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["M" /* LoaderIcon */], {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 90
            }
          })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 93
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_AtomicContainers__["l" /* GradePicker */], {
            heading: heading,
            onChange: this.getSpecs,
            initialParams: this.props.search.query,
            data: gradePickerData, __source: {
              fileName: _jsxFileName,
              lineNumber: 94
            }
          }),
          specifications.loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "center",
                marginBottom: "3em"
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 100
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["M" /* LoaderIcon */], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 106
              }
            })
          ),
          !specifications.loading && specifications.data && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["_2" /* SpecificationList */], { specs: specifications.data.categories, __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            }
          })
        )
      )
    );
  };

  return SpecificationsBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SpecificationsBlock.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradePickerData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  specsApiEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  specifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  initialResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    pushParam: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })
};
SpecificationsBlock.displayName = "SpecificationsBlock";


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])(), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["g" /* SearchParams */])({
  exposeParams: ["bodyStyle", "drivetrain", "grade", "transmission", "engine", "color", "interiorDesign"]
}), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["h" /* Specs */])({ expose: "specifications" }))(SpecificationsBlock));

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\stat-list\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/** Renders a stat list. */
var StatList = function (_PureComponent) {
  _inherits(StatList, _PureComponent);

  function StatList() {
    _classCallCheck(this, StatList);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.state = {
      active: false
    };
    _this.items = [];
    return _this;
  }

  StatList.prototype.componentDidMount = function componentDidMount() {
    this.container = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this);
    this.scrollEvent = Object(__WEBPACK_IMPORTED_MODULE_4_utils__["M" /* rafThrottle */])(this.calculateLines);
    window.addEventListener("resize", this.scrollEvent);
  };

  StatList.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("resize", this.scrollEvent);
  };

  StatList.prototype.render = function render() {
    var _this2 = this;

    var stats = this.props.stats;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "ul",
      { style: [styles.statlist], "data-test": "stat-list", __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        }
      },
      !!stats && stats.map(function (stat, index) {
        var uppercase = stat.uppercase,
            value = stat.value,
            description = stat.description;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { ref: function ref(item) {
              return _this2.items[index] = item;
            }, key: index, style: styles.statDefault, __source: {
              fileName: _jsxFileName,
              lineNumber: 34
            }
          },
          value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: [styles.value, { marginTop: "auto" }], __source: {
                fileName: _jsxFileName,
                lineNumber: 35
              }
            },
            value
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["D" /* H6 */],
            {
              withDetails: true,
              style: [styles.description, (typeof uppercase === "undefined" ? true : uppercase) && {
                textTransform: "uppercase"
              }, !value && { marginTop: "auto" }], __source: {
                fileName: _jsxFileName,
                lineNumber: 36
              }
            },
            description
          )
        );
      })
    );
  };

  return StatList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

StatList.displayName = "StatList";
StatList.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    uppercase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components_configured_radium___["a" /* default */])(StatList));

var styles = {
  statlist: {
    margin: "0 auto",
    padding: 0,
    flex: "1 1 auto",
    flexWrap: "wrap",
    listStyleType: "none",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
    fontWeight: 200,
    top: "-2px",
    left: "-2px",
    whiteSpace: "normal"
  },
  statDefault: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    padding: "1em",
    margin: "0",
    flex: "1 1 auto",
    minWidth: "13em",
    boxSizing: "border-box",
    borderStyle: "solid",
    borderColor: "#999",
    borderWidth: "0 1px 1px 0",
    top: "2px",
    left: "2px"
  },
  value: {
    display: "block",
    fontSize: "270%",
    letterSpacing: "-0.03em",
    lineHeight: 1
  },
  description: {
    display: "block",
    fontSize: "90%",
    fontWeight: "600",
    letterSpacing: ".2em",
    lineHeight: 1.4
  },
  divider: {
    position: "absolute",
    height: "100%",
    top: "0",
    right: "0",
    transform: "rotate(25deg)",
    width: "1px",
    display: "inline-block",
    backgroundColor: "#999"
  }
};

/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Sticky */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_measure__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_debounce__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_environment__ = __webpack_require__(12);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\sticky\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/* Sticky Nav Component */
var Sticky = function (_PureComponent) {
  _inherits(Sticky, _PureComponent);

  function Sticky() {
    _classCallCheck(this, Sticky);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.calculateFixed = function () {
      var _this$element$getBoun = _this.element.getBoundingClientRect(),
          top = _this$element$getBoun.top;

      var fixed = Object(__WEBPACK_IMPORTED_MODULE_5_utils__["x" /* isFinite */])(top) ? top <= 0 : false;
      _this.setState({ fixed: fixed });
    };

    _this.state = {
      fixed: false
    };
    return _this;
  }

  Sticky.prototype.componentDidMount = function componentDidMount() {
    this.element = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this);
    this.calculateFixed();
    __WEBPACK_IMPORTED_MODULE_7_constants_environment__["i" /* WINDOW */].addEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_debounce__["a" /* default */])(this.calculateFixed, 250), {
      passive: true
    });
  };

  Sticky.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_7_constants_environment__["i" /* WINDOW */].removeEventListener("scroll", Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_debounce__["a" /* default */])(this.calculateFixed, 250), {
      passive: true
    });
  };

  /**
   * @param {Array} components - Array of Components.
   * @returns {ReactElement} React Component
   */
  Sticky.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        compact = _props.compact,
        children = _props.children;
    var _state = this.state,
        fixed = _state.fixed,
        height = _state.height;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_measure__["a" /* default */],
      {
        bounds: true,
        onResize: function onResize(_ref) {
          var height = _ref.bounds.height;

          _this2.setState({ height: height });
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 43
        }
      },
      function (_ref2) {
        var measureRef = _ref2.measureRef;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { ref: measureRef, "data-test": "sticky", __source: {
              fileName: _jsxFileName,
              lineNumber: 49
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: [!fixed ? styles.base : {}, fixed ? { paddingTop: height + "px" } : ""], __source: {
                fileName: _jsxFileName,
                lineNumber: 50
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: [fixed ? styles.sticky : ""], __source: {
                  fileName: _jsxFileName,
                  lineNumber: 51
                }
              },
              children
            )
          )
        );
      }
    );
  };

  return Sticky;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Sticky.displayName = "Sticky";
Sticky.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["b" /* DetectCompact */])())(Sticky));

var styles = {
  base: {
    position: "relative",
    zIndex: 2,
    width: "100%",
    transform: "translate3d(0, 0, 0)"
  },
  sticky: {
    position: "fixed",
    top: "0",
    zIndex: 21,
    width: "100%",
    background: "white",
    transform: "translate3d(0, 0, 0)"
  }
};

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_utilities__ = __webpack_require__(43);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\interactive-slideshow-block\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/** Interactive Slideshow Block Component */

var TextMediaSliderContainer = function (_Component) {
  _inherits(TextMediaSliderContainer, _Component);

  function TextMediaSliderContainer(props) {
    _classCallCheck(this, TextMediaSliderContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = function (index) {
      _this.setState({ active: index });
    };

    _this.state = {
      active: props.active ? props.active : 0
    };
    return _this;
  }

  /**
   * @param {String} [disclaimer] - Dislaimer text as xmlString
   * @param {Array|SlideshowItem} components - Array of components.
   * @param {Boolean} [bulletsBelow] - Display a bullet list below slide.
   * @param {Boolean} [displayOnTop] - display images on top or bottom of content area
   * @returns {ReactElement} React Component
   */
  TextMediaSliderContainer.prototype.render = function render() {
    var _props = this.props,
        description = _props.description,
        disclaimer = _props.disclaimer,
        heading = _props.heading,
        bulletsBelow = _props.bulletsBelow,
        displayOnTop = _props.displayOnTop,
        items = _props.items,
        padding = _props.padding,
        backgroundColor = _props.backgroundColor;

    var activeItem = items.length > 0 && items[this.state.active].props;
    var contentSection = activeItem && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: [styles.copy, this.state.hidden ? styles.hide : styles.show], __source: {
          fileName: _jsxFileName,
          lineNumber: 57
        }
      },
      activeItem.heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["F" /* Heading */], { value: activeItem.heading, tag: "h4", __source: {
          fileName: _jsxFileName,
          lineNumber: 58
        }
      }),
      activeItem.blurb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["_25" /* WysiwygContent */], { xmlString: activeItem.blurb, __source: {
          fileName: _jsxFileName,
          lineNumber: 59
        }
      })
    );
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_AtomicComponents__["_8" /* Section */],
      {
        fullWidth: true,
        backgroundColor: backgroundColor || "#f5f5f5",
        textAlign: "center",
        padding: padding,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: {
            textAlign: "center",
            width: '100%',
            overflow: 'hidden'
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        },
        heading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["F" /* Heading */], { tag: "h3", value: heading, __source: {
            fileName: _jsxFileName,
            lineNumber: 75
          }
        }),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          style: styles.description,
          dangerouslySetInnerHTML: {
            __html: description
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 77
          }
        }),
        !displayOnTop && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { textAlign: "center" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 84
            }
          },
          contentSection
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { marginBottom: "1em" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 88
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_components__["_5" /* Slideshow */],
            {
              noAnimation: true,
              showBullets: true,
              activate: this.state.active,
              handleChange: this.handleChange,
              disclaimer: disclaimer,
              bulletsBelow: bulletsBelow, __source: {
                fileName: _jsxFileName,
                lineNumber: 89
              }
            },
            items && items.map(function (component, index) {
              var _component$props = component.props,
                  video = _component$props.video,
                  imageSrc = _component$props.imageSrc;

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { key: index, style: styles.slideshowItem, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 100
                  }
                },
                video && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["_22" /* VideoBackground */], { src: video, poster: imageSrc, relative: true, isContainerInView: true, useInView: false, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 101
                  }
                }),
                imageSrc && !video && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["x" /* LayeredBackgroundImage */], { backgroundSize: "contain", imageSrc: imageSrc, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 104
                  }
                })
              );
            })
          )
        ),
        displayOnTop && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { textAlign: "center" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 112
            }
          },
          contentSection,
          Object(__WEBPACK_IMPORTED_MODULE_6_containers_utilities__["a" /* childParser */])(this.props)
        )
      )
    );
  };

  return TextMediaSliderContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TextMediaSliderContainer.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bulletsBelow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  displayOnTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};
TextMediaSliderContainer.defaultProps = {
  bulletsBelow: false,
  padding: true
};
TextMediaSliderContainer.displayName = "TextMediaSliderContainer";


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(TextMediaSliderContainer));

var styles = {
  copy: {
    marginTop: "1.5em"
  },
  slideshowItem: {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    overflow: "hidden" // Fix overflow problem in IE11
  },
  description: {
    fontWeight: "200",
    fontSize: "100%",
    lineHeight: "1.6",
    margin: "1.5em 0",
    letterSpacing: "0.01em"
  }
};

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\text-toggle\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/** Renders a text based toggle button */

var TextToggle = function (_PureComponent) {
  _inherits(TextToggle, _PureComponent);

  function TextToggle() {
    _classCallCheck(this, TextToggle);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  /**
   * @param {String} icon - URL for icon asset.
   * @returns {ReactElement} React Component
   */
  TextToggle.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        ref: this.props.innerRef,
        'data-test': 'text-toggle',
        style: [styles.base(this.props.ignoreUppsercase), this.props.focus && styles.focus, !this.props.noPadding && { margin: '0 1em' }, this.props.active && styles.active], __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      },
      this.props.option
    );
  };

  return TextToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

TextToggle.propTypes = {
  noPadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  focus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  option: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ignoreUppsercase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func };
TextToggle.displayName = 'TextToggle';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(TextToggle));

var styles = {
  base: function base(ignoreUppsercase) {
    return {
      display: 'inline-block',
      textTransform: ignoreUppsercase ? 'none' : 'uppercase',
      letterSpacing: '.2em',
      fontWeight: '600',
      fontSize: '81%',
      color: '#aaa'
    };
  },
  active: {
    color: '#191919'
  },
  focus: {
    textDecoration: 'underline'
  }
};

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ToastPopup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_portal__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bowser__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bowser__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\toast-popup\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ToastPopup = function (_PureComponent) {
  _inherits(ToastPopup, _PureComponent);

  function ToastPopup() {
    _classCallCheck(this, ToastPopup);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.state = {
      open: false
    };
    Object(__WEBPACK_IMPORTED_MODULE_4_utils__["d" /* bindAll */])(["close", "open", "handleCloseClick"], _this);
    return _this;
  }

  ToastPopup.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      _this2.open();
    }, 100);
  };

  ToastPopup.prototype.componentWillUnmount = function componentWillUnmount() {
    this.close();
  };

  ToastPopup.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    if (!nextState.open) {
      if (ToastPopup.activeInstanse === this) {
        ToastPopup.activeInstanse = null;
      }
    } else {
      if (ToastPopup.activeInstanse && ToastPopup.activeInstanse !== this) {
        ToastPopup.activeInstanse.close();
      }
      ToastPopup.activeInstanse = this;
    }
  };

  ToastPopup.prototype.componentDidUpdate = function componentDidUpdate() {
    // ** DIRTY HACK ** DIRTY HACK **
    // Avoid opacity flicker on iOS by hiding / showing root node
    // if (this.rootNode) {
    //   setTimeout(() => {
    //     if (this.rootNode) this.rootNode.style.opacity = this.state.open ? 1 : 0
    //   }, 80)
    // }
  };

  ToastPopup.prototype.handleCloseClick = function handleCloseClick() {
    this.close();
  };

  ToastPopup.prototype.open = function open() {
    this.setState({ open: true });
  };

  ToastPopup.prototype.close = function close() {
    this.props.onClose && this.props.onClose();
    this.props.onCloseClick && this.props.onCloseClick();
    if (ToastPopup.activeInstanse === this) {
      ToastPopup.activeInstanse = null;
    }
    this.setState({ open: false });
  };

  ToastPopup.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        thresholds = _props.thresholds,
        yOffset = _props.yOffset,
        children = _props.children;
    var open = this.state.open;

    var styles = ToastPopupStyles(thresholds);
    var compact = thresholds.compact;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_portal__["a" /* Portal */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          ref: function ref(c) {
            _this3.rootNode = c;
          },
          style: _extends({}, styles.base(Number(yOffset) || 0), {
            display: this.props.show ? "block" : "none"
          }),
          "data-test": "toast-popup", __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: styles.container, __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: styles.content, __source: {
                fileName: _jsxFileName,
                lineNumber: 78
              }
            },
            children
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              "data-test": "toast-close",
              style: styles.closeContainer,
              onClick: this.handleCloseClick,
              key: "close", __source: {
                fileName: _jsxFileName,
                lineNumber: 79
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["j" /* CloseButton */], {
              styleName: __WEBPACK_IMPORTED_MODULE_5_components__["j" /* CloseButton */].STYLE_NAMES.LIGHT,
              style: styles.closeButton,
              onClick: this.handleCloseClick, __source: {
                fileName: _jsxFileName,
                lineNumber: 84
              }
            }),
            compact ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 88
                }
              },
              "Close"
            ) : ""
          )
        )
      )
    );
  };

  return ToastPopup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ToastPopup.displayName = "ToastPopup";
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["c" /* DetectThresholds */])())(ToastPopup));

ToastPopup.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onCloseClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  yOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  thresholds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    wide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
};

ToastPopup.defaultProps = {
  onClose: __WEBPACK_IMPORTED_MODULE_4_utils__["C" /* noop */],
  children: [],
  yOffset: 0,
  thresholds: {
    compact: true,
    wide: false
  }
};

var appearKeyframes = Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["j" /* keyframes */])({
  from: {
    transform: "translateY(10vh)",
    opacity: 0
  },
  to: {
    transform: "translateY(0)",
    opacity: 1
  }
});

var ToastPopupStyles = function ToastPopupStyles(_ref) {
  var compact = _ref.compact,
      wide = _ref.wide;
  return {
    base: function base(yOffset) {
      return {
        position: "fixed",
        width: "90vw",
        maxWidth: "1200px",
        left: "50%",
        bottom: 0,
        zIndex: "50",
        transform: "translate(-50%, " + (-3 + yOffset) + "em)"
      };
    },
    container: {
      background: "#2d2d2d",
      alignItems: "center",
      justifyContent: "center",
      flexAlign: "middle",
      textAlign: "left",
      color: "white",
      textTransform: "none",
      padding: compact ? "1.6em" : "1.2em 2em",
      display: "flex",
      opacity: 0,
      flexDirection: "row",
      flexWrap: compact ? "wrap" : "nowrap",
      animation: __WEBPACK_IMPORTED_MODULE_6_bowser___default.a.ios && __WEBPACK_IMPORTED_MODULE_6_bowser___default.a.version < 10 ? undefined : "x .666s 0.001s forwards", // remove ios check when ios 9 support dropped
      animationName: appearKeyframes
    },
    content: _extends({
      display: "flex",
      textAlign: "center",
      flexGrow: 1,
      alignItems: "center",
      flexDirection: "column"
    }, compact ? {} : {
      paddingRight: "2em",
      textAlign: "left",
      flexDirection: "row"
    }),
    closeContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textTransform: "lowercase",
      cursor: "pointer"
    },
    closeButton: {
      display: compact ? "inline-block" : "block",
      position: "static",
      top: "auto",
      left: "auto",
      right: "auto",
      margin: compact ? "0 0.4em 0 0" : "auto",
      width: compact ? "0.8em" : "2em",
      height: compact ? "0.8em" : "2em"
    }
  };
};

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers__ = __webpack_require__(7);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\video-overlay\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var VideoOverlay = function (_Component) {
  _inherits(VideoOverlay, _Component);

  function VideoOverlay() {
    _classCallCheck(this, VideoOverlay);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * @returns {ReactElement} React Component
   */
  VideoOverlay.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_containers__["L" /* Overlay */],
      { close: this.props.close, __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_containers__["g" /* ColumnGroup */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 18
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_containers__["f" /* Column */],
          { alignMiddle: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 19
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers__["_10" /* YoutubePlayer */], { autoPlay: true, videoId: this.props.videoId, __source: {
              fileName: _jsxFileName,
              lineNumber: 20
            }
          })
        )
      )
    );
  };

  return VideoOverlay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

VideoOverlay.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  videoId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string };
VideoOverlay.displayName = 'VideoOverlay';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components_configured_radium___["a" /* default */])(VideoOverlay));

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export YoutubePlayer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\youtube-player\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/* Render an embeded youtube player */
var YoutubePlayer = function (_Component) {
  _inherits(YoutubePlayer, _Component);

  function YoutubePlayer() {
    var _temp, _this, _ret;

    _classCallCheck(this, YoutubePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.togglePlay = function (toggle) {
      _this.videoWindow && _this.videoWindow.postMessage('{"event": "command", "func": "' + (toggle ? 'playVideo' : 'pauseVideo') + '", "args": ""}', '*');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  YoutubePlayer.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.base, __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', {
        style: styles.video,
        ref: function ref(c) {
          _this2.videoWindow = c && c.contentWindow;
        },
        src: 'https://www.youtube.com/embed/' + this.props.videoId + '?autoplay=' + (this.props.autoPlay ? 1 : 0) + '&rel=0',
        allowFullScreen: true, __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        }
      })
    );
  };

  return YoutubePlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

YoutubePlayer.displayName = 'YoutubePlayer';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(YoutubePlayer));

YoutubePlayer.propTypes = {
  videoId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var styles = {
  base: {
    position: 'relative',
    width: '100%',
    paddingBottom: '56.25%',
    overflow: 'hidden'
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
    border: 0,
    width: '100%',
    height: '100%'
  }
};

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apis_koala__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_AtomicUtils_fetchAPI__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEqual__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_cookieHandler__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_AtomicUtils_gtmHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__page__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__navigation_navigation_layout__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__navigation_breadcrumb__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_top_navigation__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__navigation_navigation_item__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__navigation_notifications__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__navigation_account__ = __webpack_require__(1756);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\index.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var MyMazdaContainer = function (_Component) {
  _inherits(MyMazdaContainer, _Component);

  function MyMazdaContainer() {
    var _this2 = this;

    _classCallCheck(this, MyMazdaContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.fetchNotifications = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _this$props, notifications, saveNotifications, loading;

                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _this$props = _this.props, notifications = _this$props.notifications, saveNotifications = _this$props.saveNotifications;
                        loading = _this.state.loading;

                        if (loading) {
                          _context3.next = 5;
                          break;
                        }

                        _context3.next = 5;
                        return _this.setState({
                          loading: true
                        }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                          return regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  _context2.next = 2;
                                  return Object(__WEBPACK_IMPORTED_MODULE_4_AtomicUtils_fetchAPI__["a" /* default */])({
                                    method: "GET",
                                    url: notifications.notificationsEndpoint
                                  }).then(function () {
                                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                                      var json, _json, data, success;

                                      return regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1) {
                                          switch (_context.prev = _context.next) {
                                            case 0:
                                              json = {};

                                              if (!(response.status === 200)) {
                                                _context.next = 5;
                                                break;
                                              }

                                              _context.next = 4;
                                              return response.json();

                                            case 4:
                                              json = _context.sent;

                                            case 5:
                                              _json = json, data = _json.data, success = _json.success;

                                              if (!success) {
                                                _this.setState({
                                                  loading: false
                                                });
                                              } else {
                                                _this.setState({
                                                  loading: false
                                                }, function () {
                                                  saveNotifications(data);
                                                });
                                              }

                                            case 7:
                                            case "end":
                                              return _context.stop();
                                          }
                                        }
                                      }, _callee, _this2);
                                    }));

                                    return function (_x) {
                                      return _ref4.apply(this, arguments);
                                    };
                                  }()).catch(function () {
                                    _this.setState({
                                      loading: false
                                    });
                                  });

                                case 2:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2, _this2);
                        })));

                      case 5:
                        _this.fetchNotifications();

                      case 6:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this2);
              })), 10 * 60 * 1000);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));

    _this.isActiveRoute = _this.isActiveRoute.bind(_this);
    _this.hasActiveRoutes = _this.hasActiveRoutes.bind(_this);

    _this.state = {
      loading: false
    };
    return _this;
  }

  MyMazdaContainer.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        registerRoutes = _props.registerRoutes,
        initialComponents = _props.initialComponents,
        initialComponentsRoute = _props.initialComponentsRoute,
        hydrateRouteComponents = _props.hydrateRouteComponents,
        routerDefinition = _props.routerDefinition,
        toggleNavItem = _props.toggleNavItem,
        mainNavItems = _props.mainNavItems;


    var routes = routerDefinition.reduce(function (allRoutes, _ref5) {
      var _extends2;

      var route = _ref5.route,
          properties = _objectWithoutProperties(_ref5, ["route"]);

      return _extends({}, allRoutes, (_extends2 = {}, _extends2[route] = properties, _extends2));
    }, {});

    registerRoutes(routes);
    hydrateRouteComponents(initialComponentsRoute, initialComponents);

    // update ui to expand the correct navigation item
    var initialActiveItem = mainNavItems.findIndex(this.hasActiveRoutes) || 0;
    toggleNavItem(initialActiveItem);
  };

  MyMazdaContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props2 = this.props,
        location = _props2.location,
        closeAllNav = _props2.closeAllNav,
        updateRouteComponents = _props2.updateRouteComponents,
        notifications = _props2.notifications,
        saveNotifications = _props2.saveNotifications,
        allNotifications = _props2.allNotifications,
        notificationMenuOpen = _props2.ui.notificationMenuOpen;

    var unreadNotifications = allNotifications && allNotifications.length ? allNotifications.filter(function (item) {
      return item.notificationStatus === "NEW";
    }) : [];

    if (location.key !== prevProps.location.key) {
      closeAllNav();
      updateRouteComponents(location.pathname, location.search);
    }

    if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isEqual___default()(notifications.notificationItems, prevProps.notifications.notificationItems)) {
      saveNotifications(notifications.notificationItems);
    }

    if (prevProps.ui.notificationMenuOpen && !notificationMenuOpen && unreadNotifications.length) {
      Object(__WEBPACK_IMPORTED_MODULE_3_apis_koala__["a" /* fetchKoalaData */])(notifications.notificationsEndpoint, unreadNotifications.map(function (_ref6) {
        var notificationID = _ref6.notificationID;
        return { notificationID: notificationID, notificationStatus: "VIEWED" };
      })).then(function (data) {
        if (!data) return;
        saveNotifications(data);
      }).catch(function (error) {
        throw error;
      });
    }
  };

  MyMazdaContainer.prototype.componentDidMount = function componentDidMount() {
    var _props3 = this.props,
        notificationItems = _props3.notifications.notificationItems,
        saveNotifications = _props3.saveNotifications,
        account = _props3.account;

    if (notificationItems) saveNotifications(notificationItems);
    this.fetchNotifications();

    if (account && account.userId) {
      new __WEBPACK_IMPORTED_MODULE_12_AtomicUtils_cookieHandler__["a" /* default */]().setCookie("userId", account.userId);
    }
  };

  MyMazdaContainer.prototype.isActiveRoute = function isActiveRoute(href) {
    /*
      this should be true for any route under the navigation href
      eg for /mymazda/1/servicing the following pathnames will be true.
      - /mymazda/1/servicing/summary
      - /mymazda/1/servicing/request
      - /mymazda/1/servicing/deeply/nested/route
    */
    return this.props.location.pathname.indexOf(href) > -1;
  };

  MyMazdaContainer.prototype.hasActiveRoutes = function hasActiveRoutes(_ref7) {
    var _this3 = this;

    var href = _ref7.href,
        _ref7$items = _ref7.items,
        items = _ref7$items === undefined ? [] : _ref7$items;

    return this.isActiveRoute(href) || items.some(function (item) {
      return _this3.isActiveRoute(item.href);
    });
  };

  MyMazdaContainer.prototype.render = function render() {
    var _this4 = this;

    var _props4 = this.props,
        routes = _props4.routes,
        mainNavItems = _props4.mainNavItems,
        notifications = _props4.notifications,
        allNotifications = _props4.allNotifications,
        account = _props4.account,
        breadcrumb = _props4.breadcrumb,
        toggleNav = _props4.toggleNav,
        toggleUser = _props4.toggleUser,
        toggleNotifications = _props4.toggleNotifications,
        expandNavItem = _props4.expandNavItem,
        closeAllNav = _props4.closeAllNav,
        toggleNavItem = _props4.toggleNavItem,
        _props4$ui = _props4.ui,
        navigationOpen = _props4$ui.navigationOpen,
        expandedNavItemIndex = _props4$ui.expandedNavItemIndex,
        notificationMenuOpen = _props4$ui.notificationMenuOpen,
        userMenuOpen = _props4$ui.userMenuOpen;


    var manyNestedItems = mainNavItems.filter(function (_ref8) {
      var items = _ref8.items;
      return typeof items !== "undefined";
    }).length > 1; // more than 1 mainNavItems with nested items

    var unreadNotifications = allNotifications && allNotifications.length ? allNotifications.filter(function (item) {
      return item && item.notificationStatus === "NEW";
    }) : [];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.container, __source: {
          fileName: _jsxFileName,
          lineNumber: 192
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16__navigation_navigation_layout__["a" /* default */],
        {
          topNav: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_18__navigation_top_navigation__["a" /* default */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 195
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 196
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__navigation_breadcrumb__["a" /* default */], { hideOnMobile: true, items: breadcrumb, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 196
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { display: "flex", alignItems: "center" }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 197
                }
              },
              notifications && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__navigation_notifications__["b" /* NotificationsButton */], {
                open: notificationMenuOpen,
                onClick: function onClick() {
                  Object(__WEBPACK_IMPORTED_MODULE_13_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "MyMazda - Notifications",
                    pageAction: "Drop down - \"" + (notificationMenuOpen ? 'Collapsed' : 'Expanded') + "\""
                  });
                  toggleNotifications();
                },
                notifications: unreadNotifications, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 199
                }
              }),
              account && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__navigation_account__["a" /* AccountButton */], {
                open: userMenuOpen,
                name: account.name,
                onClick: toggleUser, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 211
                }
              })
            )
          ),
          darkenBg: navigationOpen || userMenuOpen || notificationMenuOpen,
          topNavPanels: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__navigation_notifications__["c" /* default */], _extends({
            open: notificationMenuOpen
          }, notifications, {
            notifications: allNotifications, __source: {
              fileName: _jsxFileName,
              lineNumber: 221
            }
          })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__navigation_account__["b" /* default */], {
            key: "account-dropdown",
            open: userMenuOpen,
            items: account.items, __source: {
              fileName: _jsxFileName,
              lineNumber: 225
            }
          })],
          onBackgroundClick: closeAllNav,
          onNavButtonClick: toggleNav,
          sideNavOpen: navigationOpen,
          sideNav: mainNavItems.map(function (_ref9, index) {
            var _ref9$items = _ref9.items,
                items = _ref9$items === undefined ? [] : _ref9$items,
                label = _ref9.label,
                href = _ref9.href,
                description = _ref9.description,
                imageUrl = _ref9.imageUrl;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { key: href.split("/").join("-"), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 240
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_components__["t" /* ExpandableArea */],
                {
                  isExpanded: !manyNestedItems || expandedNavItemIndex === index,
                  onToggle: function onToggle() {
                    return toggleNavItem(index);
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 241
                  }
                },
                function (_ref10) {
                  var RenderArea = _ref10.RenderArea,
                      isExpanded = _ref10.isExpanded,
                      toggleExpanded = _ref10.toggleExpanded;
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: { borderBottom: "1px solid " + __WEBPACK_IMPORTED_MODULE_10_constants_color_palette__["a" /* default */].GRAY2 }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 249
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__navigation_navigation_item__["a" /* PrimaryNavigationItem */],
                      _extends({
                        active: _this4.isActiveRoute(href),
                        onClick: function onClick() {
                          return expandNavItem(index);
                        }
                      }, {
                        label: label, href: href, description: description, imageUrl: imageUrl
                      }, {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 250
                        }
                      }),
                      manyNestedItems && !!items.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        {
                          style: styles.expandButton,
                          onClick: function onClick(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleExpanded();
                          }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 258
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers__["c" /* AnimatedPlusMinus */], { styleOverride: { background: "#979797" }, open: isExpanded, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 266
                          }
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      RenderArea,
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 270
                        }
                      },
                      items && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { style: {
                            background: __WEBPACK_IMPORTED_MODULE_10_constants_color_palette__["a" /* default */].GRAY3
                          }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 272
                          }
                        },
                        items.map(function (subItemProps) {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__navigation_navigation_item__["b" /* SecondaryNavigationItem */], {
                            onClick: function onClick() {
                              return expandNavItem(index);
                            },
                            active: _this4.isActiveRoute(subItemProps.href),
                            key: subItemProps.href.split("/").join("-"),
                            label: subItemProps.label,
                            href: subItemProps.href, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 276
                            }
                          });
                        })
                      )
                    )
                  );
                }
              )
            );
          }), __source: {
            fileName: _jsxFileName,
            lineNumber: 193
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_router_dom__["e" /* Switch */],
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 290
            }
          },
          Object.entries(routes).map(function (_ref11) {
            var route = _ref11[0];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["c" /* Route */], {
              key: route,
              path: route,
              component: __WEBPACK_IMPORTED_MODULE_15__page__["a" /* default */], __source: {
                fileName: _jsxFileName,
                lineNumber: 292
              }
            });
          })
        )
      )
    );
  };

  return MyMazdaContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMazdaContainer.displayName = "MyMazdaContainer";


var routeValidation = function routeValidation(props, propName, componentName) {
  if (!/^(\/.*)/.test(props[propName])) {
    return new Error("invalid prop \"" + propName + "\" supplied to \"" + componentName + "\". (should begin with \"/\")");
  }
};

MyMazdaContainer.propTypes = {
  registerRoutes: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  initialComponents: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  initialComponentsRoute: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  hydrateRouteComponents: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  updateRouteComponents: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  closeAllNav: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  routerDefinition: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    route: routeValidation,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
      label: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
      href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
    })).isRequired,
    fetchUrl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
  })),
  location: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  routes: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mainNavItems: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  notifications: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  allNotifications: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  saveNotifications: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  account: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  toggleNav: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  toggleUser: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  toggleNotifications: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  expandNavItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  toggleNavItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  breadcrumb: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
  })),
  ui: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    navigationOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    expandedNavItemIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    notificationMenuOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  })
};

var styles = {
  container: {
    position: "relative"
  },
  expandButton: {
    display: "flex",
    height: "100%",
    paddingLeft: "1.5em",
    borderLeft: "1px solid " + __WEBPACK_IMPORTED_MODULE_10_constants_color_palette__["a" /* default */].GRAY2,
    marginLeft: "1em"
  },
  body: function body(compact) {
    return {
      textAlign: "left",
      position: "relative",
      marginLeft: compact ? "0px" : "320px",
      width: compact ? "100%" : "calc(100% - 320px)"
    };
  }
};

var mapStateToProps = function mapStateToProps(state, _ref12) {
  var location = _ref12.location;
  return {
    routes: __WEBPACK_IMPORTED_MODULE_14_store_actions_mymazda__["f" /* selectors */].getRoutes(state),
    ui: __WEBPACK_IMPORTED_MODULE_14_store_actions_mymazda__["f" /* selectors */].getUiState(state),
    breadcrumb: __WEBPACK_IMPORTED_MODULE_14_store_actions_mymazda__["f" /* selectors */].getBreadcrumb(location.pathname)(state),
    allNotifications: __WEBPACK_IMPORTED_MODULE_14_store_actions_mymazda__["f" /* selectors */].getNotifications(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_14_store_actions_mymazda__["a" /* actionCreators */], dispatch);
};

/** Top Level MyMazda Container. */
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_11_react_router_dom__["f" /* withRouter */])(MyMazdaContainer));

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(245);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicUtils_componentParser__ = __webpack_require__(14);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\page.jsx";








var PageWithData = function PageWithData(_ref) {
  var isFetching = _ref.isFetching,
      fetchError = _ref.fetchError,
      components = _ref.components;

  if (fetchError) {
    return null;
  }
  if (!components.length) {
    if (isFetching) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            height: "100%",
            padding: "3em 0"
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 16
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["M" /* LoaderIcon */], { styleName: "light", __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        })
      );
    }
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      }
    },
    Object(__WEBPACK_IMPORTED_MODULE_6_AtomicUtils_componentParser__["a" /* default */])(components)
  );
};

PageWithData.displayName = "PageWithData";
PageWithData.displayName = "PageWithData";
var mapStateToProps = function mapStateToProps(state, _ref2) {
  var location = _ref2.location;
  return _extends({}, __WEBPACK_IMPORTED_MODULE_4_store_actions_mymazda__["f" /* selectors */].getRoute(location.pathname)(state), {
    components: __WEBPACK_IMPORTED_MODULE_4_store_actions_mymazda__["f" /* selectors */].getRouteComponents(location.pathname, location.search)(state) || []
  });
};

PageWithData.propTypes = {
  isFetching: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  fetchError: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  components: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, null))(PageWithData));

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_radium__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_higher_order_components_configured_radium___ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__animated_arrow_icon__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__animated_dropdown__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings__ = __webpack_require__(126);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\navigation\\navigation-layout.jsx",
    _hideIfDesktop,
    _wrapper,
    _extends2,
    _topNavBar,
    _topNav,
    _sidebar,
    _main;













var NavigationLayout = function NavigationLayout(_ref) {
  var _ref$compact = _ref.compact,
      isMobile = _ref$compact[0],
      isTablet = _ref$compact[1],
      topNav = _ref.topNav,
      sideNav = _ref.sideNav,
      children = _ref.children,
      sideNavOpen = _ref.sideNavOpen,
      topNavPanels = _ref.topNavPanels,
      darkenBg = _ref.darkenBg,
      onNavButtonClick = _ref.onNavButtonClick,
      onBackgroundClick = _ref.onBackgroundClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { position: "relative", background: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY1 }, __source: {
        fileName: _jsxFileName,
        lineNumber: 30
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_radium__["Style"], {
      scopeSelector: ".no-scroll-bar",
      rules: {
        "div:-webkit-scrollbar": {
          display: "none"
        },
        "div::-webkit-scrollbar": {
          display: "none"
        }
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 31
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_containers__["_5" /* Sticky */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "no-scroll-bar", style: style.wrapper, __source: {
            fileName: _jsxFileName,
            lineNumber: 42
          }
        },
        !isTablet && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: [style.sidebar, { pointerEvents: "all" }], __source: {
              fileName: _jsxFileName,
              lineNumber: 43
            }
          },
          sideNav
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: style.topNav, __source: {
              fileName: _jsxFileName,
              lineNumber: 44
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              onClick: onNavButtonClick,
              style: [style.navButton, sideNavOpen && { color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].WHITE, background: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY1 }], __source: {
                fileName: _jsxFileName,
                lineNumber: 45
              }
            },
            "MyMazda\xA0",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__animated_arrow_icon__["a" /* default */], { flip: sideNavOpen, __source: {
                fileName: _jsxFileName,
                lineNumber: 51
              }
            })
          ),
          topNav,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: style.topPanel, __source: {
                fileName: _jsxFileName,
                lineNumber: 54
              }
            },
            topNavPanels,
            isTablet && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: style.hideIfDesktop, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 57
                }
              },
              darkenBg && isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: onBackgroundClick, style: style.fadedBg, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 58
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__animated_dropdown__["a" /* default */],
                { open: sideNavOpen, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 59
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { style: style.sidebar, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 60
                    }
                  },
                  sideNav
                )
              )
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: style.main, __source: {
          fileName: _jsxFileName,
          lineNumber: 68
        }
      },
      children
    )
  );
};

NavigationLayout.displayName = "NavigationLayout";
NavigationLayout.displayName = "NavigationLayout";
NavigationLayout.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool),
  topNav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  sideNav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  sideNavOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  topNavPanels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  onNavButtonClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBackgroundClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  darkenBg: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var fadeIn = Object(__WEBPACK_IMPORTED_MODULE_7_higher_order_components_configured_radium___["b" /* keyframes */])({
  from: {
    opacity: 0
  }
});

var style = {
  topPanel: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0
  },
  fadedBg: {
    background: "black",
    position: "absolute",
    left: 0,
    right: 0,
    zIndex: 0,
    height: "100vh",
    opacity: "0.5",
    pointerEvents: "all",
    animation: "x .5s",
    animationName: fadeIn
  },
  hideIfDesktop: (_hideIfDesktop = {
    display: "block",
    width: "100%"
  }, _hideIfDesktop[__WEBPACK_IMPORTED_MODULE_10__settings__["a" /* breakpointDesktop */]] = {
    display: "none"
  }, _hideIfDesktop),
  wrapper: (_wrapper = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    pointerEvents: "none"
  }, _wrapper[__WEBPACK_IMPORTED_MODULE_10__settings__["a" /* breakpointDesktop */]] = {
    flexDirection: "row",
    position: "absolute",
    left: 0,
    right: 0
  }, _wrapper),
  navButton: _extends({}, __WEBPACK_IMPORTED_MODULE_5_constants_general_style__["b" /* BASE_HEADING */], (_extends2 = {
    background: "#383838",
    color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARK,
    display: "flex",
    padding: "1em 2em",
    alignItems: "center",
    whiteSpace: "nowrap",
    cursor: "pointer",
    flex: "1 1 100%",
    transition: "color 0.666s"
  }, _extends2[__WEBPACK_IMPORTED_MODULE_10__settings__["b" /* breakpointTablet */]] = {
    flex: "0 0 auto",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].WHITE
    }
  }, _extends2[__WEBPACK_IMPORTED_MODULE_10__settings__["a" /* breakpointDesktop */]] = {
    display: "none"
  }, _extends2)),
  topNavBar: (_topNavBar = {
    height: "4.5rem"
  }, _topNavBar[__WEBPACK_IMPORTED_MODULE_10__settings__["b" /* breakpointTablet */]] = {
    width: "100%"
  }, _topNavBar),
  topNav: (_topNav = {
    pointerEvents: "auto",
    fontSize: "13px",
    width: "100%",
    display: "flex",
    position: "relative",
    order: -1
  }, _topNav[__WEBPACK_IMPORTED_MODULE_10__settings__["a" /* breakpointDesktop */]] = {
    order: 1
  }, _topNav),
  sidebar: (_sidebar = {
    background: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY1,
    maxHeight: "calc(100vh - 9rem)",
    overflowX: "auto",
    width: "100%",
    flex: "0 0 auto"
  }, _sidebar[__WEBPACK_IMPORTED_MODULE_10__settings__["b" /* breakpointTablet */]] = {
    width: __WEBPACK_IMPORTED_MODULE_10__settings__["e" /* sidebarWidth */]
  }, _sidebar[__WEBPACK_IMPORTED_MODULE_10__settings__["a" /* breakpointDesktop */]] = {
    height: "100vh"
  }, _sidebar),
  main: (_main = {
    background: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_LIGHTER,
    minHeight: "100vh"
  }, _main[__WEBPACK_IMPORTED_MODULE_10__settings__["a" /* breakpointDesktop */]] = {
    paddingTop: "4.5rem",
    marginLeft: __WEBPACK_IMPORTED_MODULE_10__settings__["e" /* sidebarWidth */] + "px"
  }, _main)
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["b" /* DetectCompact */])({
  threshold: [__WEBPACK_IMPORTED_MODULE_10__settings__["f" /* tabletWidth */], __WEBPACK_IMPORTED_MODULE_10__settings__["c" /* desktopWidth */]]
}))(NavigationLayout));

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents_Typography_Typography_less__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicComponents_Typography_Typography_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_AtomicComponents_Typography_Typography_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\navigation\\breadcrumb.jsx";








var Splitter = function Splitter() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { style: _extends({}, styles.text, { color: "#6D6D6D", margin: "0 0.75em" }), __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    },
    ">"
  );
};

Splitter.displayName = "Splitter";
Splitter.displayName = "Splitter";
var RadiumLink = Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */]);

var Breadcumb = function Breadcumb(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items,
      hideOnMobile = _ref.hideOnMobile;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: [styles.base, hideOnMobile ? styles.hideOnMobile : {}], __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "ul",
      { style: styles.list, __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        }
      },
      items.map(function (crumb, index) {
        var _classnames;

        var label = crumb || "[undefined]";
        var href = "/mymazda";
        if (typeof crumb !== "string") {
          label = crumb.label || "[undefined]";
          href = crumb.href; /* eslint-disable-line */
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { key: index, style: styles.listItem, __source: {
              fileName: _jsxFileName,
              lineNumber: 25
            }
          },
          index === items.length - 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: [styles.text, { color: "#6D6D6D" }], __source: {
                fileName: _jsxFileName,
                lineNumber: 27
              }
            },
            label
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            RadiumLink,
            {
              style: _extends({}, styles.text, { ":hover": { color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].WHITE } }),
              className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()((_classnames = {}, _classnames[__WEBPACK_IMPORTED_MODULE_6_AtomicComponents_Typography_Typography_less___default.a.withoutStyle] = true, _classnames)),
              to: href, __source: {
                fileName: _jsxFileName,
                lineNumber: 29
              }
            },
            label
          )
        );
      }).reduce(function (all, item, index) {
        return all.concat(item, index < items.length - 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Splitter, { key: "splitter-" + index, __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        }) : null);
      }, // Add splitter after all except last items
      [])
    )
  );
};

Breadcumb.displayName = "Breadcumb";
Breadcumb.displayName = "Breadcumb";
var styles = {
  base: {
    marginLeft: "1.5em",
    height: "100%",
    alignItems: "center",
    display: "flex"
  },
  hideOnMobile: {
    display: "none",
    "@media (min-width: 800px)": {
      display: "flex"
    }
  },
  list: {
    listStyleType: "none",
    margin: "0",
    padding: "0"
  },
  listItem: {
    display: "inline-block"
  },
  text: {
    color: "#A3A3A3",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textDecoration: "none",
    transition: "color 0.25s"
  }
};

Breadcumb.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })])),
  hideOnMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["f" /* Radium */])(Breadcumb));

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flash_message_banner__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings__ = __webpack_require__(126);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\navigation\\top-navigation.jsx",
    _wrapper;







var TopNavigation = function TopNavigation(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.wrapper, __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: [styles.base, { background: "#383838" }], __source: {
          fileName: _jsxFileName,
          lineNumber: 9
        }
      },
      children
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.flashWrapper, __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__flash_message_banner__["a" /* default */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 11
        }
      })
    )
  );
};

TopNavigation.displayName = "TopNavigation";
TopNavigation.displayName = "TopNavigation";
var styles = {
  wrapper: (_wrapper = {
    height: "4.5rem"
  }, _wrapper[__WEBPACK_IMPORTED_MODULE_4__settings__["b" /* breakpointTablet */]] = {
    width: "100%"
  }, _wrapper),
  base: {
    display: "flex",
    height: "100%",
    justifyContent: "space-between"
  },
  flashWrapper: {
    position: "absolute",
    left: 0,
    right: 0,
    zIndex: "-1"
  }
};

TopNavigation.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(TopNavigation));

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__top_navigation_item__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__animated_dropdown__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_item__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__settings__ = __webpack_require__(126);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\navigation\\account.jsx",
    _menu;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











var AccountButton = function AccountButton(_ref) {
  var name = _ref.name,
      props = _objectWithoutProperties(_ref, ["name"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__top_navigation_item__["a" /* default */], _extends({ label: name, Icon: __WEBPACK_IMPORTED_MODULE_3_components__["a" /* AccountIcon */] }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    }
  }));
};

AccountButton.displayName = "AccountButton";
AccountButton.displayName = "AccountButton";

AccountButton.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var AccountDropdown = function AccountDropdown(_ref2) {
  var open = _ref2.open,
      items = _ref2.items;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__animated_dropdown__["a" /* default */],
    { open: open, __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: style.menu, __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      },
      items.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: index, style: { borderBottom: "1px solid #545454" }, __source: {
              fileName: _jsxFileName,
              lineNumber: 23
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__navigation_item__["a" /* PrimaryNavigationItem */], _extends({}, item, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 24
            }
          }))
        );
      })
    )
  );
};

AccountDropdown.displayName = "AccountDropdown";
AccountDropdown.displayName = "AccountDropdown";
var style = {
  menu: (_menu = {
    background: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY3,
    marginLeft: "auto",
    width: "100%"
  }, _menu[__WEBPACK_IMPORTED_MODULE_8__settings__["b" /* breakpointTablet */]] = {
    width: __WEBPACK_IMPORTED_MODULE_8__settings__["d" /* dropdownWidth */]
  }, _menu)
};

AccountDropdown.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["f" /* Radium */])(AccountDropdown));

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_color_palette__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\login\\index.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











var MyMazdaLoginContainer = function MyMazdaLoginContainer(_ref) {
  var compact = _ref.compact,
      img = _ref.img,
      registerPageUrl = _ref.registerPageUrl,
      gtmEvent = _ref.gtmEvent,
      createAccountButtonText = _ref.createAccountButtonText,
      props = _objectWithoutProperties(_ref, ["compact", "img", "registerPageUrl", "gtmEvent", "createAccountButtonText"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: styles.wrapper, __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      }
    },
    !compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.container(true, compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["z" /* H2 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 17
          }
        },
        "Create an account"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 20
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
          style: styles.img,
          src: img || "/globalassets/mymazda/mazda-ownership2x.png",
          alt: "key", __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { style: [styles.text, { marginTop: "1em" }], __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        },
        "Own a Mazda? Create your account now."
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { marginTop: "-1em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_components__["e" /* Button */],
          {
            styleName: "blackOutlined",
            type: "a",
            href: registerPageUrl,
            display: "block",
            gtmEvents: [createGtmAction.createAccount({ gtmEvent: gtmEvent, createAccountButtonText: createAccountButtonText })], __source: {
              fileName: _jsxFileName,
              lineNumber: 28
            }
          },
          createAccountButtonText
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.container2(false, compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_AtomicContainers__["v" /* MyMazdaLogin */], _extends({}, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 40
        }
      })),
      compact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.register, __source: {
            fileName: _jsxFileName,
            lineNumber: 42
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          { style: [styles.text, { marginTop: "2em" }], __source: {
              fileName: _jsxFileName,
              lineNumber: 43
            }
          },
          "Own a Mazda? Create your account now."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_components__["e" /* Button */],
          {
            styleName: "blackOutlined",
            type: "a",
            href: registerPageUrl,
            display: "block",
            gtmEvents: [createGtmAction.createAccount({ gtmEvent: gtmEvent, createAccountButtonText: createAccountButtonText })], __source: {
              fileName: _jsxFileName,
              lineNumber: 44
            }
          },
          createAccountButtonText
        )
      )
    )
  );
};

MyMazdaLoginContainer.displayName = "MyMazdaLoginContainer";
MyMazdaLoginContainer.displayName = "MyMazdaLoginContainer";
MyMazdaLoginContainer.propTypes = {
  createAccountButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  img: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  registerPageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

MyMazdaLoginContainer.defaultProps = {
  createAccountButtonText: "Create my account"
};

var createGtmAction = {
  createAccount: function createAccount(_ref2) {
    var gtmEvent = _ref2.gtmEvent,
        createAccountButtonText = _ref2.createAccountButtonText;
    return {
      func: gtmEvent,
      args: [{
        gtmID: __WEBPACK_IMPORTED_MODULE_3_store_gtm_events__["i" /* gtmMyMazda2ActionTypes */].CREATE_ACCOUNT,
        gtmPayload: { buttonText: createAccountButtonText }
      }]
    };
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* DetectCompact */])({ threshold: 920 }), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["i" /* gtmEvent */])())(MyMazdaLoginContainer));

var styles = {
  wrapper: {
    color: __WEBPACK_IMPORTED_MODULE_8_constants_color_palette__["a" /* default */].BLACK,
    marginTop: "8em",
    background: "#fff",
    display: "flex",
    padding: "2em 2em 0em 2em"
  },
  container: function container(border, compact) {
    return {
      background: "#fff",
      borderRight: border ? "1px solid #eee" : "0",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      margin: compact ? "0" : "3.2em 0",
      padding: compact ? "0" : "2.4em 6em",
      width: compact ? "100%" : "50%"
    };
  },
  container2: function container2(border, compact) {
    return {
      background: "#fff",
      borderRight: border ? "1px solid #eee" : "0",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      padding: compact ? "0" : "4.1em 3em",
      width: compact ? "100%" : "50%"
    };
  },
  text: _extends({}, __WEBPACK_IMPORTED_MODULE_7_constants_general_style__["a" /* BASE_COPY */], {
    marginBottom: "1em",
    textAlign: "center"
  }),
  img: {
    display: "block",
    margin: "1em auto 0px",
    width: "70px"
  },
  register: {
    borderTop: "1px solid #eee",
    margin: "2em auto 0 auto",
    width: "100%",
    maxWidth: "24em"
  }
};

/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_flash_message_banner__ = __webpack_require__(648);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\wrapper.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MyMazdaWrapper = function (_Component) {
  _inherits(MyMazdaWrapper, _Component);

  function MyMazdaWrapper() {
    _classCallCheck(this, MyMazdaWrapper);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  MyMazdaWrapper.prototype.componentDidMount = function componentDidMount() {
    var onLoadMessage = this.props.onLoadMessage;

    if (onLoadMessage && onLoadMessage.message) {
      this.props.addFlashMessage(onLoadMessage.message, onLoadMessage.type || "SUCCESS", 0);
    }
  };

  MyMazdaWrapper.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$backButton = _props.backButton,
        backButton = _props$backButton === undefined ? false : _props$backButton;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: styles.flashWrapper, __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__navigation_flash_message_banner__["a" /* default */], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        })
      ),
      backButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["i" /* BackButton */], {
        href: "javascript:history.back()",
        backText: "Go back",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_AtomicComponents__["_8" /* Section */],
        { padding: true, backgroundColor: "#ffffff", __source: {
            fileName: _jsxFileName,
            lineNumber: 31
          }
        },
        children
      )
    );
  };

  return MyMazdaWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMazdaWrapper.displayName = "MyMazdaWrapper";


var styles = {
  flashWrapper: {
    position: "absolute",
    left: 0,
    right: 0,
    width: "100%",
    zIndex: "1"
  },
  backLink: {
    position: "absolute",
    textAlign: "left",
    top: "-6em",
    left: "0",
    padding: "2em",
    fontSize: "13px",
    letterSpacing: "0.2em",
    textTransform: "uppercase",
    fontWeight: 600,
    lineHeight: "1.2",
    textDecoration: "none",
    cursor: "pointer",
    color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARK,
    transition: "color .25s",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_4_constants_color_palette__["a" /* default */].GRAY_DARKER
    }
  }
};

MyMazdaWrapper.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  backButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onLoadMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  addFlashMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addFlashMessage: function addFlashMessage() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6_store_actions_mymazda__["a" /* actionCreators */].addFlashMessage.apply(__WEBPACK_IMPORTED_MODULE_6_store_actions_mymazda__["a" /* actionCreators */], arguments));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null, mapDispatchToProps))(MyMazdaWrapper));

/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_mymazda__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apis_persist__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\manage-vehicle-flows\\remove-vehicle.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MyMazdaRemoveVehicleFlow = function (_Component) {
  _inherits(MyMazdaRemoveVehicleFlow, _Component);

  function MyMazdaRemoveVehicleFlow() {
    _classCallCheck(this, MyMazdaRemoveVehicleFlow);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      reason: undefined,
      validation: false,
      isFetching: false
    };
    Object(__WEBPACK_IMPORTED_MODULE_4_utils__["d" /* bindAll */])(["handleClose", "handleRemoveVehicle", "renderSelectReason", "renderAreYouSure", "renderRemoveSuccess"], _this);
    return _this;
  }

  MyMazdaRemoveVehicleFlow.prototype.componentDidMount = function componentDidMount() {
    // clear localStorage
    Object(__WEBPACK_IMPORTED_MODULE_10_apis_persist__["e" /* removeLocal */])("addRemoveVehicleLastStep");
  };

  MyMazdaRemoveVehicleFlow.prototype.handleClose = function handleClose() {
    if (this.state.isFetching) return;
    this.props.onClose();
  };

  MyMazdaRemoveVehicleFlow.prototype.handleRemoveVehicle = function handleRemoveVehicle(setStep) {
    var _this2 = this;

    var _props$vehicle = this.props.vehicle,
        nameplate = _props$vehicle.nameplate,
        registrationNumber = _props$vehicle.registrationNumber;

    this.setState({ isFetching: true });
    Object(__WEBPACK_IMPORTED_MODULE_5_apis_mymazda__["e" /* removeMyMazdaVehicle */])(this.props.removeVehicleEndpoint, {
      notes: this.state.reason ? this.state.reason.value : "none",
      vin: this.props.vehicle.vin
    }).then(function () {
      _this2.props.flashMessage(__WEBPACK_IMPORTED_MODULE_9_constants_errors__["e" /* MYMAZDA_ERRORS */].VEHICLE_REMOVE_SUCCESS({ nameplate: nameplate, registrationNumber: registrationNumber }), "SUCCESS");
      Object(__WEBPACK_IMPORTED_MODULE_10_apis_persist__["b" /* isLocalStorageSupported */])() && Object(__WEBPACK_IMPORTED_MODULE_10_apis_persist__["f" /* setLocal */])("addRemoveVehicleLastStep", JSON.stringify(true));
      setStep(2);
      // this.props.onClose()
      // this.props.refreshCurrentRoute() // this will cause the modal to remount, closing it.
    }).catch(function (error) {
      _this2.props.flashMessage(__WEBPACK_IMPORTED_MODULE_9_constants_errors__["e" /* MYMAZDA_ERRORS */].VEHICLE_REMOVE_FAILED({
        nameplate: nameplate,
        registrationNumber: registrationNumber,
        error: error.message
      }), "ERROR", 0);
      _this2.props.onClose();
    });
  };

  MyMazdaRemoveVehicleFlow.prototype.renderSelectReason = function renderSelectReason(_ref) {
    var _this3 = this;

    var nextStep = _ref.nextStep;
    var _props = this.props,
        removeDescription = _props.removeDescription,
        _props$vehicle2 = _props.vehicle,
        nameplate = _props$vehicle2.nameplate,
        bodyStyle = _props$vehicle2.bodyStyle,
        registrationNumber = _props$vehicle2.registrationNumber;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.slide(this.props.compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["A" /* H3 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 73
          }
        },
        "Remove a Vehicle"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 74
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["_25" /* WysiwygContent */], {
        replaceVariables: {
          nameplate: nameplate,
          bodyStyle: bodyStyle,
          registrationNumber: registrationNumber || "Registration number not available"
        },
        xmlString: removeDescription, __source: {
          fileName: _jsxFileName,
          lineNumber: 75
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["_2" /* Select */], {
        label: "Reason for removal",
        value: this.state.reason,
        required: true,
        onChange: function onChange(reason) {
          _this3.setState({ reason: reason, validation: false });
        },
        message: this.state.validation ? __WEBPACK_IMPORTED_MODULE_9_constants_errors__["c" /* FORM_ERRORS */].SELECT_REQUIRED : "",
        options: ["Private Sale", "Trade in", "Write off/recall", "Other"].map(function (value) {
          return {
            name: value,
            value: value
          };
        }), __source: {
          fileName: _jsxFileName,
          lineNumber: 82
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 94
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["j" /* Button */],
        {
          fullWidth: true,
          styleName: "black",
          onClick: function onClick() {
            _this3.setState({
              validation: true
            }, _this3.state.reason && nextStep);
          },
          disabled: !this.state.reason, __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          }
        },
        "Remove vehicle"
      )
    );
  };

  MyMazdaRemoveVehicleFlow.prototype.renderAreYouSure = function renderAreYouSure(_ref2) {
    var _this4 = this;

    var setStep = _ref2.setStep;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.slide(this.props.compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 116
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["A" /* H3 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 117
          }
        },
        "Remove Vehicle"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["_25" /* WysiwygContent */], { xmlString: this.props.removeConfirmationDescription, __source: {
          fileName: _jsxFileName,
          lineNumber: 120
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["j" /* Button */],
        {
          fullWidth: true,
          styleName: "black",
          loading: this.state.isFetching,
          onClick: function onClick() {
            _this4.handleRemoveVehicle(setStep);
          },
          gtm: {
            category: "MyMazda - Manage Vehicles",
            action: "Remove vehicle - clicked \"REMOVE VEHICLE\""
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 121
          }
        },
        "Yes, remove Vehicle"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 132
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["j" /* Button */],
        { fullWidth: true, styleName: "blackOutlined", onClick: this.handleClose, __source: {
            fileName: _jsxFileName,
            lineNumber: 133
          }
        },
        "Cancel"
      )
    );
  };

  MyMazdaRemoveVehicleFlow.prototype.renderRemoveSuccess = function renderRemoveSuccess() {
    var _props2 = this.props,
        compact = _props2.compact,
        _props2$vehicle = _props2.vehicle,
        nameplate = _props2$vehicle.nameplate,
        registrationNumber = _props2$vehicle.registrationNumber;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.slide(compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 144
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["_13" /* TickModalIcon */], { style: { width: "2.25em", height: "2.25em", margin: "0 auto 1em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 145
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["A" /* H3 */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 146
          }
        },
        "Vehicle removed"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["_25" /* WysiwygContent */], { xmlString: "" + __WEBPACK_IMPORTED_MODULE_9_constants_errors__["e" /* MYMAZDA_ERRORS */].VEHICLE_REMOVE_SUCCESS({ nameplate: nameplate, registrationNumber: registrationNumber }), theme: "light", style: { margin: "1em 0" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 147
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["j" /* Button */],
        {
          onClick: function onClick() {
            window.location.reload();
          },
          fullWidth: true,
          styleName: "black",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 148
          }
        },
        "Continue"
      )
    );
  };

  MyMazdaRemoveVehicleFlow.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_components__["_8" /* SteppedFlow */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 159
        }
      },
      [this.renderSelectReason, this.renderAreYouSure, this.renderRemoveSuccess]
    );
  };

  return MyMazdaRemoveVehicleFlow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMazdaRemoveVehicleFlow.displayName = "MyMazdaRemoveVehicleFlow";


var styles = {
  slide: function slide(compact) {
    return {
      padding: compact ? "0" : "3em",
      textAlign: "center"
    };
  }
};

MyMazdaRemoveVehicleFlow.propTypes = {
  vehicle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    nameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bodyStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    registrationNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    vin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  removeVehicleEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  removeDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  removeConfirmationDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  refreshCurrentRoute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  flashMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    flashMessage: function flashMessage() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3_store_actions_mymazda__["a" /* actionCreators */].addFlashMessage.apply(__WEBPACK_IMPORTED_MODULE_3_store_actions_mymazda__["a" /* actionCreators */], arguments));
    },
    refreshCurrentRoute: function refreshCurrentRoute() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3_store_actions_mymazda__["a" /* actionCreators */].refreshCurrentRoute());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_6_higher_order_components__["b" /* DetectCompact */])())(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8_AtomicComponents__["Z" /* Modal */],
    { open: true, width: "650px", handleClose: props.onClose, __source: {
        fileName: _jsxFileName,
        lineNumber: 198
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyMazdaRemoveVehicleFlow, _extends({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 199
      }
    }))
  );
}));

/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apis_mymazda__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_apis_persist__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\manage-vehicle-flows\\add-vehicle.jsx";

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var onEnter = Object(__WEBPACK_IMPORTED_MODULE_7_utils__["F" /* onKeyPress */])(["Enter"]);

var titleCase = function titleCase(str) {
  return str.toLowerCase().split(" ").map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(" ");
};

var MyMazdaAddVehiclFlow = function (_Component) {
  _inherits(MyMazdaAddVehiclFlow, _Component);

  function MyMazdaAddVehiclFlow() {
    _classCallCheck(this, MyMazdaAddVehiclFlow);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      inputValue: "",
      isFetching: false,
      searchError: null,
      foundVehicle: {}
    };
    Object(__WEBPACK_IMPORTED_MODULE_7_utils__["d" /* bindAll */])(["linkVehicle", "renderSearchError", "renderLinkSuccess", "handleInputChange", "handleSearch", "renderVinSearch", "renderConfirmVehicle"], _this);
    return _this;
  }

  MyMazdaAddVehiclFlow.prototype.componentDidMount = function componentDidMount() {
    // clear localStorage
    Object(__WEBPACK_IMPORTED_MODULE_13_apis_persist__["e" /* removeLocal */])("addRemoveVehicleLastStep");
  };

  MyMazdaAddVehiclFlow.prototype.handleSearch = function handleSearch(callback, errorCallback) {
    var _this2 = this;

    if (!this.state.inputValue.length) return;
    this.setState({ isFetching: true });
    Object(__WEBPACK_IMPORTED_MODULE_2_apis_mymazda__["d" /* queryMyMazdaVinRego */])(this.props.vehicleSearchEndPoint, this.state.inputValue).then(function (_ref) {
      var errorCode = _ref.errorCode,
          errorMessage = _ref.errorMessage,
          foundVehicle = _objectWithoutProperties(_ref, ["errorCode", "errorMessage"]);

      _this2.setState({ isFetching: false, foundVehicle: foundVehicle }, callback);
    }).catch(function (error) {
      _this2.setState({ isFetching: false, searchError: _this2.props.errorMessage }, errorCallback);
    });
  };

  MyMazdaAddVehiclFlow.prototype.linkVehicle = function linkVehicle(setStep) {
    var _this3 = this;

    var _state$foundVehicle = this.state.foundVehicle,
        vin = _state$foundVehicle.vin,
        nameplate = _state$foundVehicle.nameplate,
        rego = _state$foundVehicle.rego;


    this.setState({ isFetching: true });
    Object(__WEBPACK_IMPORTED_MODULE_2_apis_mymazda__["c" /* linkMyMazdaVinRego */])(this.props.linkVehicleEndPoint, vin).then(function (_ref2) {
      var statusCode = _ref2.statusCode;

      var messages = {
        // statusCode 202 means vehicle transfer has been requested
        202: __WEBPACK_IMPORTED_MODULE_9_constants_errors__["e" /* MYMAZDA_ERRORS */].VEHICLE_ADD_TRANSFER_REQUESTED({ nameplate: nameplate, rego: rego }),
        // statusCode 200 indicates a successful link
        200: __WEBPACK_IMPORTED_MODULE_9_constants_errors__["e" /* MYMAZDA_ERRORS */].VEHICLE_ADD_SUCCESS({ nameplate: nameplate, rego: rego })
      };

      _this3.props.flashMessage(messages[statusCode || 200], "SUCCESS");
      if (statusCode === 200) {
        // force page reload to show updated navigation
        Object(__WEBPACK_IMPORTED_MODULE_13_apis_persist__["b" /* isLocalStorageSupported */])() && Object(__WEBPACK_IMPORTED_MODULE_13_apis_persist__["f" /* setLocal */])("addRemoveVehicleLastStep", JSON.stringify(true));
        setStep("renderLinkSuccess");
      } else {
        // refresh route will only update page content not navigation
        // transfer requested vehicles don't show in nav
        _this3.props.refreshCurrentRoute();
        _this3.props.onClose();
      }
    }).catch(function (error) {
      _this3.props.flashMessage(__WEBPACK_IMPORTED_MODULE_9_constants_errors__["e" /* MYMAZDA_ERRORS */].VEHICLE_ADD_FAILED({ nameplate: nameplate, rego: rego, error: error.message }), "ERROR");
      _this3.props.onClose();
    });
  };

  MyMazdaAddVehiclFlow.prototype.renderVinSearch = function renderVinSearch(_ref3) {
    var _this4 = this;

    var setStep = _ref3.setStep,
        nextStep = _ref3.nextStep;
    var _props = this.props,
        compact = _props.compact,
        addVehicleHeading = _props.addVehicleHeading,
        addVehicleDescriptionExtended = _props.addVehicleDescriptionExtended,
        addSearchButtonText = _props.addSearchButtonText;


    var handelSearch = function handelSearch() {
      if (!_this4.state.inputValue) return;
      return _this4.handleSearch(function () {
        return setStep("renderConfirmVehicle");
      }, function () {
        return setStep("renderSearchError");
      });
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.slide(compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 126
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["A" /* H3 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 127
          }
        },
        addVehicleHeading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components__["_25" /* WysiwygContent */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 129
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 130
            }
          },
          addVehicleDescriptionExtended
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["J" /* InputText */], {
        label: "Enter your registration or VIN",
        disabled: this.state.isFetching,
        onKeyPress: onEnter(handelSearch),
        value: this.state.inputValue,
        onChange: function onChange(_ref4) {
          var value = _ref4.target.value;
          return _this4.setState({ inputValue: value });
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 132
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["j" /* Button */],
        {
          fullWidth: true,
          loading: this.state.isFetching,
          disabled: !this.state.inputValue,
          styleName: "black",
          onClick: handelSearch, __source: {
            fileName: _jsxFileName,
            lineNumber: 138
          }
        },
        addSearchButtonText
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components__["t" /* ExpandableArea */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 146
          }
        },
        function (_ref5) {
          var RenderArea = _ref5.RenderArea,
              toggleExpanded = _ref5.toggleExpanded;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { margin: "2em 0 0" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 148
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_components__["H" /* Hyperlink */],
              { onClick: toggleExpanded, styleName: "black", __source: {
                  fileName: _jsxFileName,
                  lineNumber: 149
                }
              },
              _this4.props.vinHitLabel
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              RenderArea,
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 152
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                { style: { fontSize: "90%", color: "#aaaaaa", padding: "1em 0" }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 153
                  }
                },
                _this4.props.vinHintDescription
              )
            )
          );
        }
      )
    );
  };

  MyMazdaAddVehiclFlow.prototype.renderConfirmVehicle = function renderConfirmVehicle(_ref6) {
    var _this5 = this;

    var setStep = _ref6.setStep;
    var _props2 = this.props,
        compact = _props2.compact,
        addConfirmHeading = _props2.addConfirmHeading,
        addConfirmButtonText = _props2.addConfirmButtonText,
        addVehicleConfirmationDescription = _props2.addVehicleConfirmationDescription;
    var _state$foundVehicle2 = this.state.foundVehicle,
        nameplate = _state$foundVehicle2.nameplate,
        modelDescription = _state$foundVehicle2.modelDescription,
        vin = _state$foundVehicle2.vin,
        rego = _state$foundVehicle2.rego,
        colour = _state$foundVehicle2.colour;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.slide(compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 173
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: styles.backLink, onClick: function onClick() {
            return setStep("renderVinSearch");
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 174
          }
        },
        "<",
        " Go Back"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["A" /* H3 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 177
          }
        },
        addConfirmHeading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 178
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { marginBottom: "2em" }, __source: {
            fileName: _jsxFileName,
            lineNumber: 179
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["_9" /* Summary */], {
          disableBase: true,
          items: [{
            label: "Model",
            value: "" + (titleCase(modelDescription || "") || nameplate)
          }, {
            label: "Registration",
            value: rego || "Contact Dealer"
          }, {
            label: "VIN",
            value: vin
          }, colour && {
            label: "Exterior",
            value: colour
          }].filter(Boolean), __source: {
            fileName: _jsxFileName,
            lineNumber: 180
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { borderTop: "1px solid " + __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_LIGHT, margin: "2em 0 2.5em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 201
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["_25" /* WysiwygContent */], { xmlString: addVehicleConfirmationDescription, __source: {
          fileName: _jsxFileName,
          lineNumber: 202
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["j" /* Button */],
        {
          fullWidth: true,
          loading: this.state.isFetching,
          styleName: "black",
          onClick: function onClick() {
            _this5.linkVehicle(setStep);
          },
          gtm: {
            category: "MyMazda - Manage Vehicles",
            action: "Add vehicle - clicked \"" + addConfirmButtonText.toUpperCase() + "\""
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 203
          }
        },
        addConfirmButtonText
      )
    );
  };

  MyMazdaAddVehiclFlow.prototype.renderSearchError = function renderSearchError(_ref7) {
    var _this6 = this;

    var setStep = _ref7.setStep;
    var _props3 = this.props,
        compact = _props3.compact,
        retrySearchButtonText = _props3.retrySearchButtonText;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.slide(compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 220
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["A" /* H3 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 221
          }
        },
        "Vehicle not found"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 222
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 223
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_AtomicContainers__["d" /* AlertList */], { data: this.state.searchError, __source: {
          fileName: _jsxFileName,
          lineNumber: 224
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["j" /* Button */],
        {
          fullWidth: true,
          styleName: "black",
          onClick: function onClick() {
            _this6.setState({ inputValue: "", searchError: null });
            setStep(0);
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 225
          }
        },
        "<",
        " ",
        retrySearchButtonText
      )
    );
  };

  MyMazdaAddVehiclFlow.prototype.renderLinkSuccess = function renderLinkSuccess() {
    var compact = this.props.compact;
    var _state$foundVehicle3 = this.state.foundVehicle,
        nameplate = _state$foundVehicle3.nameplate,
        rego = _state$foundVehicle3.rego;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.slide(compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 244
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["_13" /* TickModalIcon */], { style: { width: "2.25em", height: "2.25em", margin: "0 auto 1em" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 245
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["A" /* H3 */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 246
          }
        },
        "Vehicle added"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["_25" /* WysiwygContent */], { xmlString: "" + __WEBPACK_IMPORTED_MODULE_9_constants_errors__["e" /* MYMAZDA_ERRORS */].VEHICLE_ADD_SUCCESS({ nameplate: nameplate, rego: rego }), theme: "light", style: { margin: "1em 0" }, __source: {
          fileName: _jsxFileName,
          lineNumber: 247
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["j" /* Button */],
        {
          onClick: function onClick() {
            window.location.reload();
          },
          fullWidth: true,
          styleName: "black",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 248
          }
        },
        "Continue"
      )
    );
  };

  MyMazdaAddVehiclFlow.prototype.render = function render() {
    var renderVinSearch = this.renderVinSearch,
        renderConfirmVehicle = this.renderConfirmVehicle,
        renderLinkSuccess = this.renderLinkSuccess,
        renderSearchError = this.renderSearchError;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_components__["_8" /* SteppedFlow */],
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 266
        }
      },
      {
        renderVinSearch: renderVinSearch,
        renderConfirmVehicle: renderConfirmVehicle,
        renderLinkSuccess: renderLinkSuccess,
        renderSearchError: renderSearchError
      }
    );
  };

  return MyMazdaAddVehiclFlow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMazdaAddVehiclFlow.displayName = "MyMazdaAddVehiclFlow";


var styles = {
  slide: function slide(compact) {
    return {
      padding: compact ? "0" : "3em",
      textAlign: "center"
    };
  },
  backLink: _extends({}, __WEBPACK_IMPORTED_MODULE_4_constants_general_style__["b" /* BASE_HEADING */], {
    display: "block",
    textAlign: "left",
    marginTop: "-2em",
    marginLeft: "-2em",
    marginBottom: "2em",
    fontSize: "80%",
    cursor: "pointer",
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_DARK,
    transition: "color .25s",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_DARKER
    }
  })
};

MyMazdaAddVehiclFlow.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  errorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  addVehicleConfirmationDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  addVehicleDescriptionExtended: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  addVehicleHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  addSearchButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  retrySearchButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  addConfirmHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  addConfirmButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vehicleSearchEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vinHitLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vinHintDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkVehicleEndPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  refreshCurrentRoute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  flashMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    flashMessage: function flashMessage() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6_store_actions_mymazda__["a" /* actionCreators */].addFlashMessage.apply(__WEBPACK_IMPORTED_MODULE_6_store_actions_mymazda__["a" /* actionCreators */], arguments));
    },
    refreshCurrentRoute: function refreshCurrentRoute() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6_store_actions_mymazda__["a" /* actionCreators */].refreshCurrentRoute());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_8_higher_order_components__["b" /* DetectCompact */])())(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["Z" /* Modal */],
    { open: true, width: "650px", handleClose: props.onClose, __source: {
        fileName: _jsxFileName,
        lineNumber: 325
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyMazdaAddVehiclFlow, _extends({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 326
      }
    }))
  );
}));

/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apis_mymazda__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_general_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_environment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\manage-account\\deactivate-account-flow.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var onEnter = Object(__WEBPACK_IMPORTED_MODULE_6_utils__["F" /* onKeyPress */])(["Enter"]);

var MyMazdaDeactivateAccountFlow = function (_Component) {
  _inherits(MyMazdaDeactivateAccountFlow, _Component);

  function MyMazdaDeactivateAccountFlow() {
    _classCallCheck(this, MyMazdaDeactivateAccountFlow);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      isFetching: false,
      errorMsg: null,
      password: ""
    };
    Object(__WEBPACK_IMPORTED_MODULE_6_utils__["d" /* bindAll */])(["handleDeactivateAccount"], _this);
    return _this;
  }

  MyMazdaDeactivateAccountFlow.prototype.handleDeactivateAccount = function handleDeactivateAccount(event) {
    var _this2 = this;

    if (!this.state.password) return;
    this.setState({ isFetching: true, errorMsg: null });
    Object(__WEBPACK_IMPORTED_MODULE_2_apis_mymazda__["a" /* deactivateAccount */])(this.props.deactivateAccountEndpoint, this.state.password).then(function () {
      _this2.setState({ isFetching: false });
      _this2.props.onClose();
      _this2.props.flashMessage(__WEBPACK_IMPORTED_MODULE_10_constants_errors__["e" /* MYMAZDA_ERRORS */].VEHICLE_DEACTIVATE_SUCCESS, "SUCCESS");
      setTimeout(function () {
        // redirect back to mymazda index page
        __WEBPACK_IMPORTED_MODULE_5_constants_environment__["i" /* WINDOW */].location.assign("/mymazda");
      }, 3000);
    }).catch(function (error) {
      _this2.setState({ isFetching: false, errorMsg: error.message });
      if (!error.message) {
        _this2.props.onClose();
        _this2.props.flashMessage(__WEBPACK_IMPORTED_MODULE_10_constants_errors__["e" /* MYMAZDA_ERRORS */].VEHICLE_DEACTIVATE_FAILED, "ERROR");
      }
    });
  };

  MyMazdaDeactivateAccountFlow.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        compact = _props.compact,
        deactivateAccountHeading = _props.deactivateAccountHeading,
        deactivateAccountDescription = _props.deactivateAccountDescription,
        deactivateAccountButton = _props.deactivateAccountButton,
        cancelDeactivateAccountButton = _props.cancelDeactivateAccountButton,
        onClose = _props.onClose;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: styles.slide(compact), __source: {
          fileName: _jsxFileName,
          lineNumber: 69
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["A" /* H3 */],
        { withDetails: true, __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        },
        deactivateAccountHeading
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_components__["_25" /* WysiwygContent */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 73
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 74
            }
          },
          deactivateAccountDescription
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "form",
        { autoComplete: "nope", __source: {
            fileName: _jsxFileName,
            lineNumber: 76
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components__["J" /* InputText */], {
          label: "Enter your password",
          type: "password",
          autocomplete: "new-password",
          name: "password",
          onKeyPress: onEnter(this.handleDeactivateAccount),
          disabled: this.state.isFetching,
          value: this.state.password,
          onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return _this3.setState({ password: value });
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 77
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_AtomicContainers__["d" /* AlertList */], { data: this.state.errorMsg, __source: {
          fileName: _jsxFileName,
          lineNumber: 87
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["j" /* Button */],
        {
          gtm: {
            category: "MyMazda - Manage Account",
            action: "DEACTIVATE ACCOUNT - Clicked \"" + deactivateAccountButton.toUpperCase() + "\""
          },
          disabled: !this.state.password,
          loading: this.state.isFetching,
          fullWidth: true,
          styleName: "black",
          onClick: this.handleDeactivateAccount, __source: {
            fileName: _jsxFileName,
            lineNumber: 88
          }
        },
        deactivateAccountButton
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 100
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["j" /* Button */],
        {
          gtm: {
            category: "MyMazda - Manage Account",
            action: "DEACTIVATE ACCOUNT - Clicked \"" + cancelDeactivateAccountButton.toUpperCase() + "\""
          },
          disabled: this.state.isFetching,
          fullWidth: true,
          styleName: "blackOutlined",
          onClick: onClose, __source: {
            fileName: _jsxFileName,
            lineNumber: 101
          }
        },
        cancelDeactivateAccountButton
      )
    );
  };

  return MyMazdaDeactivateAccountFlow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMazdaDeactivateAccountFlow.displayName = "MyMazdaDeactivateAccountFlow";


var styles = {
  slide: function slide(compact) {
    return {
      padding: compact ? "0" : "3em",
      textAlign: "center"
    };
  },
  backLink: _extends({}, __WEBPACK_IMPORTED_MODULE_4_constants_general_style__["b" /* BASE_HEADING */], {
    display: "block",
    textAlign: "left",
    marginTop: "-2em",
    marginLeft: "-2em",
    marginBottom: "2em",
    fontSize: "80%",
    cursor: "pointer",
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_DARK,
    transition: "color .25s",
    ":hover": {
      color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].GRAY_DARKER
    }
  })
};

MyMazdaDeactivateAccountFlow.propTypes = {
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  flashMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  deactivateAccountEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  deactivateAccountHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  deactivateAccountDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  deactivateAccountButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cancelDeactivateAccountButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    flashMessage: function flashMessage() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8_store_actions_mymazda__["a" /* actionCreators */].addFlashMessage.apply(__WEBPACK_IMPORTED_MODULE_8_store_actions_mymazda__["a" /* actionCreators */], arguments));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(null, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_9_higher_order_components__["b" /* DetectCompact */])())(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_11_AtomicComponents__["Z" /* Modal */],
    { open: true, width: "650px", handleClose: props.onClose, __source: {
        fileName: _jsxFileName,
        lineNumber: 159
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyMazdaDeactivateAccountFlow, _extends({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 160
      }
    }))
  );
}));

/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apis_mymazda__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_actions_mymazda__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__edit_password__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__edit_email_address__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_AtomicContainers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_AtomicUtils_gtmHandler__ = __webpack_require__(11);
var _jsxFileName = "C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\manage-account\\account-details.jsx";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var createDetail = function createDetail(label, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _extends({ label: label, value: value }, options);
};

var createStateAutofill = function createStateAutofill(_ref) {
  var state = _ref.state;
  return state && { name: state, value: state.toLowerCase() };
};
var createTitleAutofill = function createTitleAutofill(title) {
  return title && { name: title, value: title.toLowerCase() };
};

var fadeInKeyframes = Object(__WEBPACK_IMPORTED_MODULE_8_higher_order_components__["j" /* keyframes */])({
  from: {
    opacity: 0
  }
});

var BlackoutOverlay = Object(__WEBPACK_IMPORTED_MODULE_8_higher_order_components__["f" /* Radium */])(function (_ref2) {
  var children = _ref2.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        position: "relative",
        zIndex: 1
      }, __source: {
        fileName: _jsxFileName,
        lineNumber: 30
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      style: {
        position: "fixed",
        backgroundColor: "white",
        opacity: 0.9,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: -1,
        animation: "x .666s",
        animationName: fadeInKeyframes
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          backgroundColor: "white"
        }, __source: {
          fileName: _jsxFileName,
          lineNumber: 49
        }
      },
      children
    )
  );
});

var pickPersonalDetails = Object(__WEBPACK_IMPORTED_MODULE_4_utils__["I" /* pick */])(["title", "firstName", "surname", "mobilePhone", "afterHoursPhone", "businessHoursPhone", "businessHoursPhoneExtension", "address1", "address2", "address3", "townName", "postcode", "state", "driversLicenceNumber", "driversLicenceState"]);

var editableSections = ["editPersonalDetails", "editEmailAddress", "editPassword"];

var MyMazdaAccountDetails = function (_Component) {
  _inherits(MyMazdaAccountDetails, _Component);

  function MyMazdaAccountDetails(props) {
    _classCallCheck(this, MyMazdaAccountDetails);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleEmailAddressUpdate = function (_ref3) {
      var success = _ref3.success;

      if (success) {
        _this.props.flashMessage(__WEBPACK_IMPORTED_MODULE_10_constants_errors__["e" /* MYMAZDA_ERRORS */].ACCOUNT_CHANGE_EMAIL_REQUESTED, "SUCCESS");
        _this.props.refreshCurrentRoute();
      }
      _this.setState({ activeSection: -1 });
    };

    _this.handlePersonalDetailsUpdate = function (_ref4) {
      var success = _ref4.success;

      if (success) {
        _this.props.flashMessage(__WEBPACK_IMPORTED_MODULE_10_constants_errors__["e" /* MYMAZDA_ERRORS */].ACCOUNT_PERSONAL_DETAILS_UPDATED, "SUCCESS");
        _this.props.refreshCurrentRoute();
      }
      _this.setState({ activeSection: -1 });
    };

    _this.handlePasswordUpdate = function (_ref5) {
      var success = _ref5.success;

      if (success) {
        _this.props.flashMessage(__WEBPACK_IMPORTED_MODULE_10_constants_errors__["e" /* MYMAZDA_ERRORS */].ACCOUNT_PASSWORD_UPDATED, "SUCCESS");
        _this.props.refreshCurrentRoute();
      }
      _this.setState({ activeSection: -1 });
    };

    _this.handleResendEmail = function () {
      if (_this.state.verificationEmailResent) return;
      Object(__WEBPACK_IMPORTED_MODULE_5_apis_mymazda__["f" /* resendMyMazdaVerificationEmail */])(_this.props.resendEmailEndpoint).then(function () {
        _this.props.flashMessage(__WEBPACK_IMPORTED_MODULE_10_constants_errors__["e" /* MYMAZDA_ERRORS */].ACCOUNT_RESEND_CHANGE_EMAIL, "SUCCESS");
        _this.setState({ verificationEmailResent: true });
      }).catch(function (error) {
        _this.props.flashMessage(__WEBPACK_IMPORTED_MODULE_10_constants_errors__["e" /* MYMAZDA_ERRORS */].ACCOUNT_RESEND_CHANGE_EMAIL_FAILED, "ERROR");
      });
    };

    _this.state = {
      activeSection: -1,
      verificationEmailResent: false
    };
    return _this;
  }

  MyMazdaAccountDetails.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        heading = _props.heading,
        customer = _props.customer,
        changePasswordEndpoint = _props.changePasswordEndpoint,
        accountSettingsEndpoint = _props.accountSettingsEndpoint,
        accountEmailAddressEndpoint = _props.accountEmailAddressEndpoint,
        changeEmailDescription = _props.changeEmailDescription,
        changeEmailEndpoint = _props.changeEmailEndpoint,
        emailPendingApproval = _props.emailPendingApproval;
    var title = customer.title,
        firstName = customer.firstName,
        surname = customer.surname,
        mobilePhone = customer.mobilePhone,
        afterHoursPhone = customer.afterHoursPhone,
        businessHoursPhone = customer.businessHoursPhone,
        address = customer.address,
        email = customer.email;
    var _state = this.state,
        activeSection = _state.activeSection,
        verificationEmailResent = _state.verificationEmailResent;

    var isActive = function isActive(section) {
      return editableSections.indexOf(section) === activeSection;
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 154
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 155
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["x" /* FormGroup */],
          { center: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 156
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["C" /* H5 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 157
              }
            },
            "Personal Details"
          )
        ),
        isActive("editPersonalDetails") ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          BlackoutOverlay,
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 160
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_AtomicContainers__["x" /* MyMazdaPersonalDetails */], {
            onUpdate: this.handlePersonalDetailsUpdate,
            updatePersonalDetailsEndpoint: accountSettingsEndpoint,
            customer: customer,
            prefillFields: pickPersonalDetails(_extends({}, customer, customer.address, {
              title: createTitleAutofill(customer.title),
              state: createStateAutofill(customer.address)
            })), __source: {
              fileName: _jsxFileName,
              lineNumber: 161
            }
          })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_9" /* Summary */], {
          disableBase: true,
          items: [_extends({}, createDetail("Name", title + " " + firstName + " " + surname), {
            editText: "Edit",
            onClick: function onClick() {
              _this2.setState({
                activeSection: editableSections.indexOf("editPersonalDetails")
              }, function () {
                Object(__WEBPACK_IMPORTED_MODULE_14_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda - Manage Account",
                  pageAction: "PERSONAL DETAILS - \"NAME\" - clicked \"EDIT\""
                });
              });
            }
          }), createDetail("Mobile Phone", mobilePhone), // May need to run formatting func here
          afterHoursPhone && createDetail("After hours Phone", afterHoursPhone), businessHoursPhone && createDetail("Business hours Phone", businessHoursPhone), createDetail("Address", Object(__WEBPACK_IMPORTED_MODULE_4_utils__["o" /* formatAddress */])(address))],
          __source: {
            fileName: _jsxFileName,
            lineNumber: 173
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["_13" /* Space */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 198
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 199
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["x" /* FormGroup */],
          { center: true, __source: {
              fileName: _jsxFileName,
              lineNumber: 200
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["C" /* H5 */],
            { withDetails: true, __source: {
                fileName: _jsxFileName,
                lineNumber: 201
              }
            },
            "Account Details"
          )
        ),
        isActive("editEmailAddress") ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          BlackoutOverlay,
          { onClick: function onClick() {
              return _this2.setState({ activeSection: -1 });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 204
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__edit_email_address__["a" /* default */], {
            onUpdate: this.handleEmailAddressUpdate,
            updateEmailAddressEndpoint: accountEmailAddressEndpoint,
            description: changeEmailDescription,
            changeEmailEndpoint: changeEmailEndpoint,
            prefillFields: Object(__WEBPACK_IMPORTED_MODULE_4_utils__["I" /* pick */])(["email"], customer), __source: {
              fileName: _jsxFileName,
              lineNumber: 205
            }
          })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 213
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_9" /* Summary */], { disableBase: true, items: [_extends({}, createDetail("Email", email), {
              editText: "Edit",
              onClick: function onClick() {
                _this2.setState({
                  activeSection: editableSections.indexOf("editEmailAddress")
                }, function () {
                  Object(__WEBPACK_IMPORTED_MODULE_14_AtomicUtils_gtmHandler__["a" /* default */])({
                    pageCategory: "MyMazda - Manage Account",
                    pageAction: "PERSONAL DETAILS - \"EMAIL\" - clicked \"EDIT\""
                  });
                });
              }
            })], __source: {
              fileName: _jsxFileName,
              lineNumber: 214
            }
          }),
          emailPendingApproval && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: "flex", alignItems: "center" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 228
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_AtomicComponents__["d" /* AlertIcon */], { style: { marginTop: "-0.15em", height: "1em", width: "1em", paddingRight: "0.5em" }, __source: {
                fileName: _jsxFileName,
                lineNumber: 229
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              { style: { fontSize: "90%", color: __WEBPACK_IMPORTED_MODULE_9_constants_color_palette__["a" /* default */].GRAY_DARK, fontWeight: 400 }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 230
                }
              },
              "Verification email sent. Pending approval.",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: [verificationEmailResent ? { opacity: 0.5, pointerEvents: "none" } : {}, { transition: "opacity 0.25s", marginLeft: "0.5em" }], __source: {
                    fileName: _jsxFileName,
                    lineNumber: 232
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_components__["H" /* Hyperlink */],
                  { styleName: "black", onClick: this.handleResendEmail, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 236
                    }
                  },
                  verificationEmailResent ? "Sent" : "Resend"
                )
              )
            )
          )
        ),
        isActive("editPassword") ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          BlackoutOverlay,
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 245
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__edit_password__["a" /* default */], {
            gtmEvent: "GTM",
            changePasswordEndpoint: changePasswordEndpoint,
            onUpdate: this.handlePasswordUpdate,
            email: email,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 246
            }
          })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["_9" /* Summary */], {
          disableBase: true,
          items: [_extends({}, createDetail("Password", Array(11).join("*")), {
            editText: "Edit",
            onClick: function onClick() {
              _this2.setState({
                activeSection: editableSections.indexOf("editPassword")
              }, function () {
                Object(__WEBPACK_IMPORTED_MODULE_14_AtomicUtils_gtmHandler__["a" /* default */])({
                  pageCategory: "MyMazda - Manage Account",
                  pageAction: "PERSONAL DETAILS - \"PASSWORD\" - clicked \"EDIT\""
                });
              });
            }
          })],
          __source: {
            fileName: _jsxFileName,
            lineNumber: 254
          }
        })
      )
    );
  };

  return MyMazdaAccountDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMazdaAccountDetails.displayName = "MyMazdaAccountDetails";


MyMazdaAccountDetails.propTypes = {
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  changePasswordEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accountSettingsEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  changeEmailDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  emailPendingApproval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  resendEmailEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    firstName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    surname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mobilePhone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    flashMessage: function flashMessage() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7_store_actions_mymazda__["a" /* actionCreators */].addFlashMessage.apply(__WEBPACK_IMPORTED_MODULE_7_store_actions_mymazda__["a" /* actionCreators */], arguments));
    },
    refreshCurrentRoute: function refreshCurrentRoute() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7_store_actions_mymazda__["a" /* actionCreators */].refreshCurrentRoute());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(null, mapDispatchToProps))(MyMazdaAccountDetails));

/***/ }),
/* 1763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EditPassword */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_validation__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_forms__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_forms_form_section__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_forms_submit_section__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_forms_mymazda_password__ = __webpack_require__(1764);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\manage-account\\edit-password.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Redux







var EditPassword = function (_Form) {
  _inherits(EditPassword, _Form);

  function EditPassword(props) {
    _classCallCheck(this, EditPassword);

    var _this = _possibleConstructorReturn(this, _Form.call(this, props));

    _this.submitMapping = function () {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var getVal = Object(__WEBPACK_IMPORTED_MODULE_5_utils__["q" /* get */])(__WEBPACK_IMPORTED_MODULE_5_utils__["a" /* PLACEHOLDER */], fields);

      return {
        email: _this.props.email,
        oldPassword: getVal('oldPassword.value'),
        newPassword: getVal('password.value')
      };
    };

    _this.state = {
      displayThankYou: false,
      showPassword: false,
      fields: {
        oldPassword: '',
        password: '',
        confirmPassword: ''
      }
    };
    return _this;
  }

  EditPassword.prototype.togglePassword = function togglePassword(key) {
    var _setState;

    this.setState((_setState = {}, _setState[key] = !this.state[key], _setState));
  };

  EditPassword.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        displayThankYou = _state.displayThankYou,
        fields = _state.fields,
        showPassword = _state.showPassword;
    var _props = this.props,
        changePasswordEndpoint = _props.changePasswordEndpoint,
        onUpdate = _props.onUpdate;


    if (displayThankYou) {
      onUpdate({ success: true });
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { 'data-test': 'mymazda-password-form', __source: {
          fileName: _jsxFileName,
          lineNumber: 57
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.container, __source: {
            fileName: _jsxFileName,
            lineNumber: 58
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.content, __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 60
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: styles.label, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 61
                }
              },
              'CHANGE PASSWORD'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { onClick: onUpdate, style: styles.cancel, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 62
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["g" /* CancelIcon */], { style: styles.cancelIcon, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 63
                }
              }),
              'Cancel'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components_forms_form_section__["a" /* default */],
            { marginTop: '0', __source: {
                fileName: _jsxFileName,
                lineNumber: 67
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["J" /* InputText */], _extends({
              label: 'Enter current password',
              type: showPassword ? 'text' : 'password',
              icon: 'eye',
              iconText: showPassword ? 'Hide' : 'Show',
              onIconClick: this.togglePassword.bind(this, 'showPassword')
            }, this.linkState('oldPassword', Object(__WEBPACK_IMPORTED_MODULE_6_utils_validation__["e" /* required */])(undefined, __WEBPACK_IMPORTED_MODULE_3_constants_errors__["c" /* FORM_ERRORS */].PASSWORD_REQUIRED)), {
              gtmEvents: [{
                func: this.props.gtmEvent,
                args: [{
                  gtmID: __WEBPACK_IMPORTED_MODULE_7_store_gtm_events__["k" /* gtmMyMazdaRegisterActionTypes */].ENTER_PASSWORD,
                  gtmPayload: { model: Object(__WEBPACK_IMPORTED_MODULE_5_utils__["q" /* get */])('oldPassword.value', fields) }
                }]
              }],
              __source: {
                fileName: _jsxFileName,
                lineNumber: 68
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_forms_mymazda_password__["a" /* PasswordSection */], {
            fields: fields,
            passwordInputLabel: 'Enter new password',
            linkState: this.linkState,
            gtmEvent: this.props.gtmEvent,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 91
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_forms_submit_section__["a" /* default */], {
            buttonText: this.props.buttonText,
            onSubmit: function onSubmit() {
              _this2.submit(changePasswordEndpoint, _this2.state.fields, _this2.submitMapping, {
                credentials: 'same-origin'
              });
            },
            canSubmit: this.canSubmit(),
            errorMessages: [this.state.errorMessages, this.state.error],
            submitting: this.state.submitting,
            gtmEvents: [{
              func: this.props.gtmEvent,
              args: [{
                gtmID: __WEBPACK_IMPORTED_MODULE_7_store_gtm_events__["k" /* gtmMyMazdaRegisterActionTypes */].REGISTER,
                gtmPayload: {
                  model: this.props.buttonText
                }
              }]
            }],
            __source: {
              fileName: _jsxFileName,
              lineNumber: 98
            }
          })
        )
      )
    );
  };

  return EditPassword;
}(__WEBPACK_IMPORTED_MODULE_8_components_forms__["a" /* default */]);

EditPassword.displayName = 'EditPassword';
EditPassword.propTypes = {
  fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  passwordInputLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

EditPassword.defaultProps = {
  buttonText: 'Change password'
};

var styles = {
  container: {
    boxSizing: 'content-box',
    maxWidth: '24em',
    margin: '1.5em auto 0',
    textAlign: 'left'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  heading: {
    color: '#191919',
    marginBottom: '1em',
    textAlign: 'center'
  },
  label: {
    color: '#aaa',
    fontSize: '80%',
    margin: '0',
    display: 'inline-block',
    fontWeight: '600',
    letterSpacing: '.2em'
  },
  cancel: {
    color: '#aaa',
    fontSize: '90%',
    margin: '0',
    display: 'inline-block',
    cursor: 'pointer',
    fontWeight: '400',
    letterSpacing: 'inherit',
    ':hover': { color: '#191919' }
  },
  cancelIcon: {
    fill: 'currentColor',
    width: '1em',
    height: '1em',
    marginRight: '0.5em'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["i" /* gtmEvent */])())(EditPassword));

/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyMazdaPassword */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasswordSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_validation__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_forms__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_section__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__submit_section__ = __webpack_require__(304);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\components\\forms\\mymazda\\password\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Redux






var MyMazdaPassword = function (_Form) {
  _inherits(MyMazdaPassword, _Form);

  function MyMazdaPassword(props) {
    _classCallCheck(this, MyMazdaPassword);

    var _this = _possibleConstructorReturn(this, _Form.call(this, props));

    _this.submitMapping = function () {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var getVal = Object(__WEBPACK_IMPORTED_MODULE_5_utils__["q" /* get */])(__WEBPACK_IMPORTED_MODULE_5_utils__["a" /* PLACEHOLDER */], fields);
      var queryParams = Object(__WEBPACK_IMPORTED_MODULE_5_utils__["G" /* paramsFromLocation */])(location);

      return {
        email: queryParams.email,
        guid: queryParams.token,
        password: getVal('password.value')
      };
    };

    _this.state = {
      displayThankYou: false,
      fields: {
        password: '',
        confirmPassword: ''
      }
    };
    return _this;
  }

  MyMazdaPassword.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        displayThankYou = _state.displayThankYou,
        fields = _state.fields;
    var _props = this.props,
        accountActivationApiEndpoint = _props.accountActivationApiEndpoint,
        heading = _props.heading,
        successfulPageUrl = _props.successfulPageUrl,
        passswordUpdateSuccessfulText = _props.passswordUpdateSuccessfulText,
        passwordInputLabel = _props.passwordInputLabel;


    var toMyMazdaButtonText = "Login to MyMazda";

    if (displayThankYou) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.container, __source: {
            fileName: _jsxFileName,
            lineNumber: 60
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: [].concat(styles.content, [{ justifyContent: 'center', textAlign: 'center' }]), __source: {
              fileName: _jsxFileName,
              lineNumber: 61
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_13" /* TickModalIcon */], { style: { width: '2.25em', height: '2.25em', margin: '0 auto 1em' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 62
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["F" /* Heading */], {
            value: 'New password created',
            customHeadingStyle: styles.heading,
            textAlign: 'center',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 63
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_25" /* WysiwygContent */], { xmlString: passswordUpdateSuccessfulText, theme: 'light', __source: {
              fileName: _jsxFileName,
              lineNumber: 68
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["e" /* Button */], {
            gtmEvents: [createGtmAction.continueToMyMazda(_extends({}, this.props, { buttonText: toMyMazdaButtonText }))],
            type: 'a',
            href: successfulPageUrl,
            label: toMyMazdaButtonText,
            styleName: 'black',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          })
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { 'data-test': 'mymazda-password-form', __source: {
          fileName: _jsxFileName,
          lineNumber: 82
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.container, __source: {
            fileName: _jsxFileName,
            lineNumber: 83
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.content, __source: {
              fileName: _jsxFileName,
              lineNumber: 84
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["F" /* Heading */], { tag: 'h2', size: 'large', value: heading, customHeadingStyle: styles.heading, __source: {
              fileName: _jsxFileName,
              lineNumber: 85
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PasswordSection, {
            fields: fields,
            passwordInputLabel: passwordInputLabel,
            linkState: this.linkState,
            gtmEvent: this.props.gtmEvent,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 86
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__submit_section__["a" /* default */], {
            buttonText: this.props.buttonText,
            onSubmit: function onSubmit() {
              _this2.submit(accountActivationApiEndpoint, _this2.state.fields, _this2.submitMapping, {
                credentials: 'same-origin'
              });
            },
            canSubmit: this.canSubmit(),
            errorMessages: [this.state.errorMessages, this.state.error],
            submitting: this.state.submitting,
            gtmEvents: [createGtmAction.createPassword(this.props)],
            __source: {
              fileName: _jsxFileName,
              lineNumber: 93
            }
          })
        )
      )
    );
  };

  return MyMazdaPassword;
}(__WEBPACK_IMPORTED_MODULE_8_components_forms__["a" /* default */]);

MyMazdaPassword.displayName = 'MyMazdaPassword';
var createGtmAction = {
  createPassword: function createPassword(_ref) {
    var gtmEvent = _ref.gtmEvent,
        buttonText = _ref.buttonText;
    return {
      func: gtmEvent,
      args: [{
        gtmID: __WEBPACK_IMPORTED_MODULE_7_store_gtm_events__["i" /* gtmMyMazda2ActionTypes */].CREATE_PASSWORD,
        gtmPayload: {
          buttonText: buttonText
        }
      }]
    };
  },
  continueToMyMazda: function continueToMyMazda(_ref2) {
    var gtmEvent = _ref2.gtmEvent,
        buttonText = _ref2.buttonText;
    return {
      func: gtmEvent,
      args: [{
        gtmID: __WEBPACK_IMPORTED_MODULE_7_store_gtm_events__["i" /* gtmMyMazda2ActionTypes */].CONTINUE_TO_MYMAZDA,
        gtmPayload: {
          buttonText: buttonText
        }
      }]
    };
  }
};

MyMazdaPassword.propTypes = {
  accountActivationApiEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  thankYouComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  buttonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // GTM actions
  gtmClickGoBack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmClickSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmEnterEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

MyMazdaPassword.defaultProps = {
  buttonText: 'Register account'
};

var PasswordSection = function (_Component) {
  _inherits(PasswordSection, _Component);

  function PasswordSection(props) {
    _classCallCheck(this, PasswordSection);

    var _this3 = _possibleConstructorReturn(this, _Component.call(this, props));

    _this3.state = {
      showPassword: false,
      showConfirmPassword: false
    };
    return _this3;
  }

  PasswordSection.prototype.togglePassword = function togglePassword(key) {
    var _setState;

    this.setState((_setState = {}, _setState[key] = !this.state[key], _setState));
  };

  PasswordSection.prototype.passwordStrengthIndicator = function passwordStrengthIndicator() {
    var fields = this.props.fields;

    var icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_13" /* TickModalIcon */], { style: { width: '18px', height: '18px', float: 'left', margin: '1px 0.5em 0 0' }, __source: {
        fileName: _jsxFileName,
        lineNumber: 171
      }
    });
    var invalid = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
      style: {
        width: '1em',
        height: '1em',
        margin: '1px 0.5em 0 0',
        border: '2px solid #D8D8D8',
        borderRadius: '50%',
        float: 'left'
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174
      }
    });
    var style = { lineHeight: '20px', color: '#191919' };
    var val = Object(__WEBPACK_IMPORTED_MODULE_5_utils__["q" /* get */])('password.value', fields);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { fontSize: '0.875em' }, __source: {
          fileName: _jsxFileName,
          lineNumber: 189
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["_25" /* WysiwygContent */], {
        xmlString: '<p style="margin-bottom: 0;">Please select a password that has</p>',
        theme: 'light',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 190
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { style: style, __source: {
            fileName: _jsxFileName,
            lineNumber: 194
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_6_utils_validation__["d" /* lengthCheck */])(val, 8, 20) ? icon : invalid,
        ' 8-20 characters.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { style: style, __source: {
            fileName: _jsxFileName,
            lineNumber: 195
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_6_utils_validation__["a" /* hasLowerUpperCase */])(val) ? icon : invalid,
        ' Upper and lowercase letters.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { style: style, __source: {
            fileName: _jsxFileName,
            lineNumber: 196
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_6_utils_validation__["b" /* hasNumber */])(val) || Object(__WEBPACK_IMPORTED_MODULE_6_utils_validation__["c" /* hasSymbol */])(val) ? icon : invalid,
        ' One number or one symbol.'
      )
    );
  };

  PasswordSection.prototype.passwordMatch = function passwordMatch(value) {
    var fields = this.props.fields;

    var isValid = true;
    var message = void 0;

    if (value !== Object(__WEBPACK_IMPORTED_MODULE_5_utils__["q" /* get */])('password.value', fields)) {
      isValid = false;
      message = 'Password does not match';
    }

    return {
      status: {
        modifiedValue: value,
        isValid: isValid,
        message: message
      }
    };
  };

  PasswordSection.prototype.render = function render() {
    var _state2 = this.state,
        showPassword = _state2.showPassword,
        showConfirmPassword = _state2.showConfirmPassword;
    var _props2 = this.props,
        fields = _props2.fields,
        passwordInputLabel = _props2.passwordInputLabel;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 227
        }
      },
      this.passwordStrengthIndicator(),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__form_section__["a" /* default */],
        { marginTop: '0', __source: {
            fileName: _jsxFileName,
            lineNumber: 230
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["J" /* InputText */], _extends({
          label: passwordInputLabel,
          type: showPassword ? 'text' : 'password',
          icon: 'eye',
          iconText: showPassword ? 'Hide' : 'Show',
          onIconClick: this.togglePassword.bind(this, 'showPassword')
        }, this.props.linkState('password', Object(__WEBPACK_IMPORTED_MODULE_6_utils_validation__["e" /* required */])(__WEBPACK_IMPORTED_MODULE_6_utils_validation__["g" /* validatePassword */], __WEBPACK_IMPORTED_MODULE_3_constants_errors__["c" /* FORM_ERRORS */].PASSWORD_REQUIRED)), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 231
          }
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["J" /* InputText */], _extends({
          label: 'Confirm password',
          type: showConfirmPassword ? 'text' : 'password',
          icon: 'eye',
          iconText: showConfirmPassword ? 'Hide' : 'Show',
          onIconClick: this.togglePassword.bind(this, 'showConfirmPassword')
        }, this.props.linkState('confirmPassword', Object(__WEBPACK_IMPORTED_MODULE_6_utils_validation__["e" /* required */])(this.passwordMatch.bind(this), __WEBPACK_IMPORTED_MODULE_3_constants_errors__["c" /* FORM_ERRORS */].PASSWORD_REQUIRED)), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 243
          }
        }))
      )
    );
  };

  return PasswordSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PasswordSection.displayName = 'PasswordSection';
PasswordSection.propTypes = {
  fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  passwordInputLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var styles = {
  container: {
    background: '#fff',
    boxSizing: 'content-box',
    maxWidth: '24em',
    margin: '0 auto',
    textAlign: 'left'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  heading: {
    color: '#191919',
    marginBottom: '1em',
    textAlign: 'center'
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["g" /* SearchParams */])({
  exposeParams: ['mymazda', 'register']
}), Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["i" /* gtmEvent */])())(MyMazdaPassword));

/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EditEmailAddress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apis_mymazda__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_higher_order_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_errors__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_validation__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_forms__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_forms_form_section__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_forms_submit_section__ = __webpack_require__(304);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\MazdaNZ\\koala\\koala-frontend\\src\\containers\\mymazda\\manage-account\\edit-email-address.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Redux






var onEnter = Object(__WEBPACK_IMPORTED_MODULE_6_utils__["F" /* onKeyPress */])(['Enter']);

var EditEmailAddress = function (_Form) {
  _inherits(EditEmailAddress, _Form);

  function EditEmailAddress(props) {
    _classCallCheck(this, EditEmailAddress);

    var _this = _possibleConstructorReturn(this, _Form.call(this, props));

    _this.submitMapping = function () {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var getVal = Object(__WEBPACK_IMPORTED_MODULE_6_utils__["q" /* get */])(__WEBPACK_IMPORTED_MODULE_6_utils__["a" /* PLACEHOLDER */], fields);
      return {
        NewEmail: getVal('email.value')
      };
    };

    _this.handleSubmit = function (event) {
      _this.submit(_this.props.changeEmailEndpoint, _this.state.fields, _this.submitMapping, {}, __WEBPACK_IMPORTED_MODULE_2_apis_mymazda__["g" /* verifyMymazdaEmail */]);
    };

    _this.state = {
      displayThankYou: false,
      showPassword: false,
      fields: {}
    };
    return _this;
  }

  EditEmailAddress.prototype.render = function render() {
    var _state = this.state,
        displayThankYou = _state.displayThankYou,
        fields = _state.fields,
        showPassword = _state.showPassword;
    var _props = this.props,
        onUpdate = _props.onUpdate,
        description = _props.description;


    if (displayThankYou) {
      onUpdate({ success: true });
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { 'data-test': 'mymazda-change-email-form', __source: {
          fileName: _jsxFileName,
          lineNumber: 57
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.container, __source: {
            fileName: _jsxFileName,
            lineNumber: 58
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.content, __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 60
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: styles.label, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 61
                }
              },
              'CHANGE EMAIL'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { onClick: onUpdate, style: styles.cancel, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 62
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["g" /* CancelIcon */], { style: styles.cancelIcon, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 63
                }
              }),
              'Cancel'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_components_forms_form_section__["a" /* default */],
            { marginTop: '0', __source: {
                fileName: _jsxFileName,
                lineNumber: 67
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["J" /* InputText */], _extends({
              label: 'Email',
              type: 'text',
              onKeyPress: onEnter(this.handleSubmit)
            }, this.linkState('email', Object(__WEBPACK_IMPORTED_MODULE_7_utils_validation__["e" /* required */])(__WEBPACK_IMPORTED_MODULE_7_utils_validation__["f" /* validateEmail */], __WEBPACK_IMPORTED_MODULE_4_constants_errors__["c" /* FORM_ERRORS */].EMAIL_REQUIRED)), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 68
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_components__["_25" /* WysiwygContent */],
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 77
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 78
                  }
                },
                description
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_forms_submit_section__["a" /* default */], {
            buttonText: this.props.buttonText,
            onSubmit: this.handleSubmit,
            canSubmit: this.canSubmit(),
            errorMessages: [this.state.errorMessages, this.state.error],
            submitting: this.state.submitting,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 84
            }
          })
        )
      )
    );
  };

  return EditEmailAddress;
}(__WEBPACK_IMPORTED_MODULE_9_components_forms__["a" /* default */]);

EditEmailAddress.displayName = 'EditEmailAddress';
EditEmailAddress.propTypes = {
  buttonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  passwordInputLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

EditEmailAddress.defaultProps = {
  buttonText: 'Send Verification Email'
};

var styles = {
  container: {
    boxSizing: 'content-box',
    maxWidth: '24em',
    margin: '1.5em auto 0',
    textAlign: 'left'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  heading: {
    color: '#191919',
    marginBottom: '1em',
    textAlign: 'center'
  },
  label: {
    color: '#aaa',
    fontSize: '80%',
    margin: '0',
    display: 'inline-block',
    fontWeight: '600',
    letterSpacing: '.2em'
  },
  cancel: {
    color: '#aaa',
    fontSize: '90%',
    margin: '0',
    display: 'inline-block',
    cursor: 'pointer',
    fontWeight: '400',
    letterSpacing: 'inherit',
    ':hover': { color: '#191919' }
  },
  cancelIcon: {
    fill: 'currentColor',
    width: '1em',
    height: '1em',
    marginRight: '0.5em'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["m" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3_higher_order_components__["i" /* gtmEvent */])())(EditEmailAddress));

/***/ }),
/* 1766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchStock */
/* unused harmony export fetchDealerInfo */
/* unused harmony export dealerChangeRequest */
/* unused harmony export refreshStock */
/* unused harmony export initOutletStore */
/* unused harmony export nameplateChange */
/* unused harmony export showResults */
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__outlet__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_persist__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_dealer_search__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis_outlet__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gtm_events__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gtm__ = __webpack_require__(377);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchStock),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchDealerInfo),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(dealerChangeRequest),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(refreshStock),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(initOutletStore),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(nameplateChange),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(dealerConfirm),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(showResults),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(_callee5);










var INIT_OUTLET_STORE = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].INIT_OUTLET_STORE,
    LOAD_OUTLET_STORE = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].LOAD_OUTLET_STORE,
    STEP_CHANGE = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].STEP_CHANGE,
    DEALER_CHANGE_REQUEST = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].DEALER_CHANGE_REQUEST,
    DEALER_CHANGE_SUCCESS = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].DEALER_CHANGE_SUCCESS,
    DEALER_CHANGE_NO_RESULTS = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].DEALER_CHANGE_NO_RESULTS,
    DEALER_CONFIRM = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].DEALER_CONFIRM,
    DEALER_FETCH_START = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].DEALER_FETCH_START,
    DEALER_FETCH_CANNOT_RESOLVE = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].DEALER_FETCH_CANNOT_RESOLVE,
    DEALER_FETCH_SUCCESS = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].DEALER_FETCH_SUCCESS,
    DEALER_FETCH_ERROR = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].DEALER_FETCH_ERROR,
    NAMEPLATE_CHANGE = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].NAMEPLATE_CHANGE,
    OUTLET_STOCKS_FETCH_START = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].OUTLET_STOCKS_FETCH_START,
    OUTLET_STOCKS_FETCH_SUCCESS = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].OUTLET_STOCKS_FETCH_SUCCESS,
    OUTLET_STOCKS_FETCH_ERROR = __WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* actionTypes */].OUTLET_STOCKS_FETCH_ERROR;


function fetchStock() {
  var dealerCode, id, _ref, dealer, nameplate, outletStockEndpoint, _ref2, response, error, availability, _ref4, _ref4$stock, stock;

  return regeneratorRuntime.wrap(function fetchStock$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          dealerCode = void 0, id = void 0;
          _context.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({ type: OUTLET_STOCKS_FETCH_START });

        case 3:
          _context.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2__outlet__["c" /* selectors */].getOutlet);

        case 5:
          _ref = _context.sent;
          dealer = _ref.dealer;
          nameplate = _ref.nameplate;
          outletStockEndpoint = _ref.outletStockEndpoint;

          if (dealer) {
            dealerCode = dealer.dealerCode;
            id = dealer.id;
          }
          _context.next = 12;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__apis_outlet__["b" /* fetchStockData */], {
            dealerCode: dealerCode,
            locationId: id,
            nameplate: nameplate,
            outletStockEndpoint: outletStockEndpoint
          });

        case 12:
          _ref2 = _context.sent;
          response = _ref2.response;
          error = _ref2.error;

          if (!error) {
            _context.next = 18;
            break;
          }

          _context.next = 18;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({ type: OUTLET_STOCKS_FETCH_ERROR, payload: { error: error } });

        case 18:
          if (!response) {
            _context.next = 23;
            break;
          }

          availability = response.map(function (_ref3) {
            var nameplate = _ref3.nameplate,
                inStock = _ref3.inStock;
            return {
              nameplate: nameplate,
              inStock: inStock
            };
          });
          _ref4 = response.find(function (stock) {
            return stock.nameplate === nameplate;
          }) || {}, _ref4$stock = _ref4.stock, stock = _ref4$stock === undefined ? [] : _ref4$stock;
          _context.next = 23;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: OUTLET_STOCKS_FETCH_SUCCESS,
            payload: {
              availability: availability,
              results: Array.isArray(stock) ? stock : []
            }
          });

        case 23:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}

function fetchDealerInfo(_ref5) {
  var _ref5$payload = _ref5.payload,
      dealer = _ref5$payload.dealer,
      postcode = _ref5$payload.postcode;

  var search, _ref6, response, error, singleDealerInfo, _dealer, dealerCode, id;

  return regeneratorRuntime.wrap(function fetchDealerInfo$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(dealer && postcode)) {
            _context2.next = 2;
            break;
          }

          throw new Error("Can only update local dealer from postcode or dealercode");

        case 2:
          if (!(dealer && dealer.fetched)) {
            _context2.next = 4;
            break;
          }

          return _context2.abrupt("return");

        case 4:
          _context2.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({ type: DEALER_FETCH_START });

        case 6:
          search = dealer ? { dealerCode: dealer.dealerCode } : { postcode: postcode };
          _context2.next = 9;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4__apis_dealer_search__["a" /* dealerInfo */], _extends({
            dealerTypes: ["sales"]
          }, search));

        case 9:
          _ref6 = _context2.sent;
          response = _ref6.response;
          error = _ref6.error;

          if (!response) {
            _context2.next = 27;
            break;
          }

          singleDealerInfo = void 0;

          if (response.length !== 1) {
            if (dealer && dealer.id) {
              singleDealerInfo = response.find(function (_ref7) {
                var id = _ref7.id;
                return id === dealer.id;
              });
            }
          } else {
            singleDealerInfo = response[0];
          }

          if (!singleDealerInfo) {
            _context2.next = 23;
            break;
          }

          _dealer = _extends({}, singleDealerInfo, { fetched: true });
          dealerCode = _dealer.dealerCode, id = _dealer.id;

          Object(__WEBPACK_IMPORTED_MODULE_3__apis_persist__["d" /* persist */])({ localDealer: { dealerCode: dealerCode, id: id } });
          _context2.next = 21;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({ type: DEALER_FETCH_SUCCESS, payload: { dealer: _dealer } });

        case 21:
          _context2.next = 25;
          break;

        case 23:
          _context2.next = 25;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({ type: DEALER_FETCH_CANNOT_RESOLVE });

        case 25:
          _context2.next = 29;
          break;

        case 27:
          _context2.next = 29;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({ type: DEALER_FETCH_ERROR, payload: { error: error } });

        case 29:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function dealerChangeRequest(_ref8) {
  var payload = _ref8.payload;
  return regeneratorRuntime.wrap(function dealerChangeRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(fetchDealerInfo, { payload: payload });

        case 2:
          _context3.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(refreshStock);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function refreshStock() {
  var autoConfirm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _ref9, results, dealer, nameplate, _ref10, noResultMessage;

  return regeneratorRuntime.wrap(function refreshStock$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(fetchStock);

        case 2:
          _context4.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2__outlet__["c" /* selectors */].getOutlet);

        case 4:
          _ref9 = _context4.sent;
          results = _ref9.results;
          dealer = _ref9.dealer;
          nameplate = _ref9.nameplate;

          if (!(results && results.length > 0 || !nameplate)) {
            _context4.next = 13;
            break;
          }

          _context4.next = 11;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: DEALER_CHANGE_SUCCESS,
            payload: { dealer: dealer, dealerConfirm: autoConfirm }
          });

        case 11:
          _context4.next = 16;
          break;

        case 13:
          noResultMessage = dealer && dealer.fetched ? (_ref10 = {}, _ref10[Object(__WEBPACK_IMPORTED_MODULE_5__apis_outlet__["a" /* cacheKeyGen */])(dealer, nameplate)] = true, _ref10) : {};
          _context4.next = 16;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: DEALER_CHANGE_NO_RESULTS,
            payload: { noResultMessage: noResultMessage, dealerConfirm: autoConfirm }
          });

        case 16:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function initOutletStore() {
  var _ref11, _ref11$dealer, dealer, _ref12, postcode, _dealer2, dealerCode, _ref13;

  return regeneratorRuntime.wrap(function initOutletStore$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2__outlet__["c" /* selectors */].getOutlet);

        case 2:
          _ref11 = _context5.sent;
          _ref11$dealer = _ref11.dealer;
          dealer = _ref11$dealer === undefined ? {} : _ref11$dealer;
          _context5.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__location__["c" /* selectors */].getLocation);

        case 7:
          _ref12 = _context5.sent;
          postcode = _ref12.postcode;
          _dealer2 = dealer, dealerCode = _dealer2.dealerCode;

          if (!(!dealerCode && postcode || dealerCode && !dealer.fetched)) {
            _context5.next = 17;
            break;
          }

          _context5.next = 13;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(fetchDealerInfo, {
            payload: dealerCode ? { dealer: dealer } : { postcode: postcode }
          });

        case 13:
          _context5.next = 15;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2__outlet__["c" /* selectors */].getOutlet);

        case 15:
          _ref13 = _context5.sent;
          dealer = _ref13.dealer;

        case 17:
          _context5.next = 19;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(refreshStock, true);

        case 19:
          _context5.next = 21;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: STEP_CHANGE,
            payload: { step: "SHOW_RESULTS", copyMode: "WELCOME" }
          });

        case 21:
          _context5.next = 23;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({ type: LOAD_OUTLET_STORE });

        case 23:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function nameplateChange() {
  return regeneratorRuntime.wrap(function nameplateChange$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(refreshStock, true);

        case 2:
          _context6.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(showResults);

        case 4:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function dealerConfirm() {
  var _ref14, name;

  return regeneratorRuntime.wrap(function dealerConfirm$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2__outlet__["c" /* selectors */].getOutlet);

        case 2:
          _ref14 = _context7.sent;
          name = _ref14.dealer.name;
          _context7.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__gtm__["a" /* gtmEvent */])({
            gtmID: __WEBPACK_IMPORTED_MODULE_6__gtm_events__["m" /* gtmOutletStoreActionTypes */].SELECT_DEALER_NAME,
            gtmPayload: { dealerName: name }
          }));

        case 6:
          _context7.next = 8;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(showResults);

        case 8:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function showResults() {
  return regeneratorRuntime.wrap(function showResults$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])({
            type: STEP_CHANGE,
            payload: { step: "SHOW_RESULTS" }
          });

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function _callee5() {
  return regeneratorRuntime.wrap(function _callee5$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(INIT_OUTLET_STORE, initOutletStore);

                  case 2:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(DEALER_CHANGE_REQUEST, dealerChangeRequest);

                  case 2:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee2, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _context11.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(NAMEPLATE_CHANGE, nameplateChange);

                  case 2:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee3, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            return regeneratorRuntime.wrap(function _callee4$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(DEALER_CONFIRM, dealerConfirm);

                  case 2:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee4, this);
          }))]);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked9, this);
}

/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadInitialData */
/* unused harmony export updateCurrentSearchResults */
/* unused harmony export updatePageData */
/* unused harmony export updateCurrentPage */
/* unused harmony export fetchPageData */
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee4;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_site_search__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_errors__ = __webpack_require__(41);
var _marked = /*#__PURE__*/regeneratorRuntime.mark(loadInitialData),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(updateCurrentSearchResults),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(updatePageData),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(updateCurrentPage),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchPageData),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(_callee4);








var LOAD_INITIAL_DATA = __WEBPACK_IMPORTED_MODULE_1__search__["b" /* actionTypes */].LOAD_INITIAL_DATA,
    FETCH_SEARCH = __WEBPACK_IMPORTED_MODULE_1__search__["b" /* actionTypes */].FETCH_SEARCH,
    UPDATE_SEARCH_QUERY = __WEBPACK_IMPORTED_MODULE_1__search__["b" /* actionTypes */].UPDATE_SEARCH_QUERY,
    REQUEST_PAGE = __WEBPACK_IMPORTED_MODULE_1__search__["b" /* actionTypes */].REQUEST_PAGE;


function loadInitialData() {
  var currentPage;
  return regeneratorRuntime.wrap(function loadInitialData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getCurrentPage);

        case 2:
          currentPage = _context.sent;
          _context.next = 5;
          return updateCurrentPage({ payload: currentPage });

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}

function updateCurrentSearchResults(_ref) {
  var payload = _ref.payload;
  var currentPage;
  return regeneratorRuntime.wrap(function updateCurrentSearchResults$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getCurrentPage);

        case 2:
          currentPage = _context2.sent;
          _context2.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3__utils__["K" /* pushParam */], { q: payload });

        case 5:
          _context2.next = 7;
          return updatePageData(currentPage);

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

// handle request for new data on specific page.
function updatePageData(page) {
  var currentQuery;
  return regeneratorRuntime.wrap(function updatePageData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getQuery);

        case 2:
          currentQuery = _context3.sent;
          _context3.next = 5;
          return fetchPageData(page, currentQuery);

        case 5:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

// handle navigation between result pages
function updateCurrentPage(_ref2) {
  var page = _ref2.payload;

  var pageData, _ref3, failure, pageCount, nextPageData;

  return regeneratorRuntime.wrap(function updateCurrentPage$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getPage(page));

        case 2:
          pageData = _context4.sent;

          if (!(!pageData || !pageData.results.length)) {
            _context4.next = 12;
            break;
          }

          _context4.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])(updatePageData, page);

        case 6:
          _context4.next = 8;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* race */])({
            success: Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* take */])(FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* requestTypes */].SUCCESS]),
            failure: Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* take */])(FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* requestTypes */].FAILURE])
          });

        case 8:
          _ref3 = _context4.sent;
          failure = _ref3.failure;

          if (!failure) {
            _context4.next = 12;
            break;
          }

          return _context4.abrupt("return");

        case 12:
          _context4.next = 14;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getPageCount);

        case 14:
          pageCount = _context4.sent;

          if (!(page !== 1 && page > pageCount)) {
            _context4.next = 19;
            break;
          }

          _context4.next = 18;
          return updateCurrentPage({ payload: 1 });

        case 18:
          return _context4.abrupt("return");

        case 19:
          _context4.next = 21;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3__utils__["K" /* pushParam */], { page: page });

        case 21:
          _context4.next = 23;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(window.scrollTo, 0, 0);

        case 23:
          _context4.next = 25;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_1__search__["a" /* actionCreators */].changePage(page));

        case 25:
          _context4.next = 27;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getPage(page + 1));

        case 27:
          nextPageData = _context4.sent;

          if (nextPageData) {
            _context4.next = 30;
            break;
          }

          return _context4.delegateYield(updatePageData(page + 1), "t0", 30);

        case 30:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function fetchPageData(page, query) {
  var pageSize, _ref4, response, error;

  return regeneratorRuntime.wrap(function fetchPageData$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getResultsPerPage);

        case 2:
          pageSize = _context5.sent;
          _context5.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_1__search__["a" /* actionCreators */].fetchSearch.request(page, query));

        case 5:
          _context5.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__apis_site_search__["a" /* default */], {
            q: query,
            page: page,
            pageSize: pageSize
          });

        case 7:
          _ref4 = _context5.sent;
          response = _ref4.response;
          error = _ref4.error;

          if (!error) {
            _context5.next = 15;
            break;
          }

          _context5.next = 13;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_1__search__["a" /* actionCreators */].fetchSearch.failure(page, __WEBPACK_IMPORTED_MODULE_5__constants_errors__["g" /* SEARCH_ERRORS */].API_ERROR));

        case 13:
          _context5.next = 17;
          break;

        case 15:
          _context5.next = 17;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_1__search__["a" /* actionCreators */].fetchSearch.success(page, response));

        case 17:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function _callee4() {
  return regeneratorRuntime.wrap(function _callee4$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(LOAD_INITIAL_DATA, loadInitialData);

                  case 2:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(UPDATE_SEARCH_QUERY, updateCurrentSearchResults);

                  case 2:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee2, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(REQUEST_PAGE, updateCurrentPage);

                  case 2:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee3, this);
          }))]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked6, this);
}

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
var fetchFromApi = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url, { method: 'GET' });

          case 2:
            response = _context2.sent;

            if (!(response.status !== 200)) {
              _context2.next = 5;
              break;
            }

            throw new Error('Failed with status ' + response.status);

          case 5:
            _context2.next = 7;
            return response.json();

          case 7:
            return _context2.abrupt('return', _context2.sent);

          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchFromApi(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var siteSearchEndpoint = '/api/search';

var getRequestURL = function getRequestURL(endpoint, params) {
  return endpoint + '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
};

/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
    var q = _ref2.q,
        page = _ref2.page,
        pageSize = _ref2.pageSize;

    var url, _ref3, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            url = getRequestURL(siteSearchEndpoint, {
              q: q,
              page: page,
              pageSize: pageSize
            });
            _context.next = 4;
            return fetchFromApi(url);

          case 4:
            _ref3 = _context.sent;
            data = _ref3.data;
            return _context.abrupt('return', { response: data });

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](0);
            return _context.abrupt('return', { error: _context.t0 });

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 9]]);
  }));

  function fetchSiteSearch(_x) {
    return _ref.apply(this, arguments);
  }

  return fetchSiteSearch;
})());

/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__book_testdrive_duck__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compare_tool_duck__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compare_vehicle_selector_duck__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__competition_form_duck__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contact_us_duck__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accessory_list_duck__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__accordion_duck__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__background_image_selector_duck__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_duck__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__button_duck__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__feature_youtube_duck__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__map_search_duck__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_footer_duck__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_nav_duck__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__icon_tout_block_duck__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__in_page_navigation_duck__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__map_select_state_duck__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mini_configurator_duck__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mymazda2_duck__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mymazda_login_duck__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mymazda_summary_duck__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__offers_duck__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__outlet_store_duck__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__outlet_store_enquiry_form_duck__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__recalls_block_duck__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__register_interest_duck__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__search_duck__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__image_tout_block_duck__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__postcode_popup_duck__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__book_service_duck__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__wysiwyg_content_duck__ = __webpack_require__(509);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

































/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_0__book_testdrive_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_1__compare_tool_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_2__compare_vehicle_selector_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_3__competition_form_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_4__contact_us_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_5__accessory_list_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_6__accordion_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_7__background_image_selector_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_8__build_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_9__button_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_10__feature_youtube_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_11__map_search_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_12__global_footer_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_13__global_nav_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_14__icon_tout_block_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_15__in_page_navigation_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_16__map_select_state_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_17__mini_configurator_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_18__mymazda2_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_19__mymazda_login_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_20__mymazda_summary_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_21__offers_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_22__outlet_store_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_23__outlet_store_enquiry_form_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_24__recalls_block_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_25__register_interest_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_26__search_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_27__image_tout_block_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_28__postcode_popup_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_29__book_service_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_30__wysiwyg_content_duck__["a" /* gtmEvents */]));

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEvents = exports.createMetaReducer = exports.createMiddleware = undefined;

var _createMiddleware = __webpack_require__(1771);

var _createMiddleware2 = _interopRequireDefault(_createMiddleware);

var _createMetaReducer = __webpack_require__(1772);

var _createMetaReducer2 = _interopRequireDefault(_createMetaReducer);

var _createEvents = __webpack_require__(305);

var _createEvents2 = _interopRequireDefault(_createEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createMiddleware = _createMiddleware2.default;
exports.createMetaReducer = _createMetaReducer2.default;
exports.createEvents = _createEvents2.default;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createEvents = __webpack_require__(305);

var _createEvents2 = _interopRequireDefault(_createEvents);

var _registerEvents = __webpack_require__(649);

var _registerEvents2 = _interopRequireDefault(_registerEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMiddleware(eventDefinitionsMap, target) {
  var extensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return function (store) {
    return function (next) {
      return function (action) {
        if (!eventDefinitionsMap[action.type]) {
          return next(action);
        }

        var prevState = store.getState();
        var result = next(action);
        var nextState = store.getState();

        var events = (0, _createEvents2.default)(eventDefinitionsMap[action.type], prevState, action, nextState);

        (0, _registerEvents2.default)(events, target, extensions, prevState, action);

        return result;
      };
    };
  };
}

exports.default = createMiddleware;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createEvents = __webpack_require__(305);

var _createEvents2 = _interopRequireDefault(_createEvents);

var _registerEvents = __webpack_require__(649);

var _registerEvents2 = _interopRequireDefault(_registerEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMetaReducer(eventDefinitionsMap, target) {
  var extensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  /* Why not arrow functions? AOT... */
  /* eslint-disable func-names */
  return function (reducer) {
    return function (prevState, action) {
      if (!eventDefinitionsMap[action.type]) {
        return reducer(prevState, action);
      }

      var nextState = reducer(prevState, action);
      var events = (0, _createEvents2.default)(eventDefinitionsMap[action.type], prevState, action, nextState);

      (0, _registerEvents2.default)(events, target, extensions, prevState, action);

      return nextState;
    };
  };
}

exports.default = createMetaReducer;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimestamp = exports.logger = undefined;

var _logger = __webpack_require__(1774);

exports.logger = _logger.logger;
exports.getTimestamp = _logger.getTimestamp;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getTimestamp(sinceEpoch) {
  var date = new Date(sinceEpoch);
  return date.toTimeString().match(/^\d\d:\d\d:\d\d/g).concat(date.getTime().toString().slice(-3)).join('.');
}

var styles = {
  title: {
    primary: 'color: #1da1f2; font-weight: bold;',
    danger: 'color: #D63230; font-weight: bold;',
    warning: 'color: #F39237; font-weight: bold;'
  },
  label: 'color: #93748A; font-weight: bold;'
};

/* eslint-disable no-console */
var groups = [];
var hr = '-'.repeat(80); // 80 dashes row line

if (!console.group) {
  console.group = function logGroupStart(label) {
    groups.push(label);
    console.log('%c \nBEGIN GROUP: %c', hr, label);
  };
}
if (!console.groupEnd) {
  console.groupEnd = function logGroupEnd() {
    console.log('END GROUP: %c\n%c', groups.pop(), hr);
  };
}

function logEvents(events) {
  if (events.length > 1) {
    console.group('%c Events:', styles.label);
    events.forEach(function (event, index) {
      console.log('%c (' + (index + 1) + ')', styles.label, event);
    });
    console.groupEnd('Events');
  } else if (events.length === 1) {
    console.log('%c Event:', styles.label, events[0]);
  }
}

function logAction(action) {
  console.log('%c Action:', styles.label, action);
}

function logger(events, action, state, isSavedOffline, wasSavedOffline) {
  var timestamp = getTimestamp(Date.now());
  var title = 'Analytics events @ ' + timestamp + ' ' + (action ? action.type : '');

  if (events.length > 0) {
    if (isSavedOffline) {
      console.group('%c ' + title + ' (saved offline)', styles.title.danger);
      logAction(action);
      logEvents(events);
      console.groupEnd();
    } else if (wasSavedOffline) {
      console.group('%c ' + title + ' (was offline)', styles.title.warning);
      logEvents(events);
      console.groupEnd();
    } else {
      console.group('%c ' + title, styles.title.primary);
      logAction(action);
      logEvents(events);
      console.groupEnd();
    }
  }
}

exports.logger = logger;
exports.getTimestamp = getTimestamp;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1776);

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GoogleTagManager = function GoogleTagManager() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$dataLayerName = _ref.dataLayerName,
      dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName;

  return function (events) {
    if (typeof window === 'undefined') {
      return;
    }
    if (!window[dataLayerName] || typeof window[dataLayerName].push !== 'function') {
      throw new Error('redux-beacon error: window.' + dataLayerName + ' is not defined. Have you forgotten to include Google Tag Manager and dataLayer?');
    }
    events.forEach(function (event) {
      var eventToPush = function () {
        if (event.event === undefined && event.hitType !== undefined) {
          return Object.assign({}, event, { event: event.hitType });
        }
        return event;
      }();
      window[dataLayerName].push(eventToPush);
    });
  };
};

module.exports = { GoogleTagManager: GoogleTagManager };

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1778);

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(1779),
    addTimestamp = _require.addTimestamp;

var DB_NAME = 'AnalyticsEvents';
var DB_VERSION = 1;

function openDB(dbName, version) {
  return new Promise(function (resolve, reject) {
    var request = window.indexedDB.open(dbName, version);

    request.onsuccess = function (event) {
      var db = event.target.result;
      resolve(db);
    };
    request.onupgradeneeded = function (event) {
      /* Runs if the db hasn't been created yet, or if the requested db
       * version is greater than the existing db version.  This will run
       * before onsuccess */
      var db = event.target.result;
      db.createObjectStore('EventsStore', { autoIncrement: true });
    };
    request.onerror = reject;
  });
}

function save(events, db) {
  return new Promise(function (resolve, reject) {
    var transaction = db.transaction(['EventsStore'], 'readwrite');
    var objectStore = transaction.objectStore('EventsStore');

    var addEvents = objectStore.add(addTimestamp(events));
    addEvents.onsuccess = function () {
      return resolve(events);
    };
    addEvents.onerror = reject;
  });
}

function purge(db) {
  return new Promise(function (resolve, reject) {
    var transaction = db.transaction(['EventsStore'], 'readwrite');
    var objectStore = transaction.objectStore('EventsStore');
    var openCursor = objectStore.openCursor();

    var oldEvents = [];
    openCursor.onsuccess = function (event) {
      var cursor = event.target.result;
      if (cursor) {
        oldEvents = oldEvents.concat(cursor.value);
        objectStore.delete(cursor.key);
        cursor.continue();
      } else {
        resolve(oldEvents);
      }
    };
    openCursor.onerror = reject;
  });
}

function offlineWeb(isConnected) {
  return {
    saveEvents: function saveEvents(events) {
      return openDB(DB_NAME, DB_VERSION).then(function (db) {
        return save(events, db);
      });
    },
    purgeEvents: function purgeEvents(handlePurgedEvents) {
      return openDB(DB_NAME, DB_VERSION).then(purge).then(handlePurgedEvents);
    },

    isConnected: isConnected
  };
}

module.exports = { offlineWeb: offlineWeb, addTimestamp: addTimestamp };

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function addTimestamp(events) {
  return events.map(function (event) {
    return Object.assign({}, event, { timeSaved: Date.now() });
  });
}

module.exports = {
  addTimestamp: addTimestamp
};

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fixIt = __webpack_require__(1782);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fixIt).default;
  }
});

var _options = __webpack_require__(650);

Object.defineProperty(exports, 'options', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_options).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactComponentErrors = __webpack_require__(1783);

var _reactComponentErrors2 = _interopRequireDefault(_reactComponentErrors);

var _options = __webpack_require__(650);

var _options2 = _interopRequireDefault(_options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_reactComponentErrors.config.errorHandler = function (errorReport) {
  var message = errorReport.error.message.replace(/'/g, '\\\'');

  var test = 'test(\'' + errorReport.component + ' should not throw "' + message + '" on ' + errorReport.method + '\', () => {\n  const props = ' + JSON.stringify(errorReport.props) + '\n  const wrapper = shallow(<' + errorReport.component + ' {...props} />)\n  const instance = wrapper.instance()\n  const args = ' + JSON.stringify(errorReport.arguments ? [].concat(_toConsumableArray(errorReport.arguments)) : []) + '\n\n  expect(() => instance.' + errorReport.method + '(...args)).not.toThrowError(\'' + message + '\')\n})';

  _options2.default.log(test);

  throw errorReport.error;
};

var fixIt = function fixIt(Component) {
  (0, _reactComponentErrors2.default)(Component);

  return Component;
};

exports.default = fixIt;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

/**
 * Configuration that allows overriding default behavior.
 * @type {Object}
 */
var config = {
  /**
   * If enabled=false then this essentially disables the try/catch monkey-patch
   * @type {Boolean}
   */
  enabled: true,

  /**
   * Currently thif is configured to console.error a useful message if one of you
   * Component lifecycle methos throws an error. You can override the implementation
   * to integrate with you'r eown error logging.
   * @param  {[Object]} errorReport The report metadata including component, method, error thrown.
   * @return {[void]}
   */
  errorHandler: function errorHandler(errorReport) {
    console.error('Error in ' + errorReport.component + '.' + errorReport.method + '(' + (errorReport.arguments ? '...' : '') + '): ' + errorReport.error, errorReport);
  }
};

exports.config = config;
/**
 * Implementation of the try/catch wrapper
 * @param  {[React.Component]} component The ES6 React.Component.prototype that contains the React lifecycle method.
 * @param  {[string]} method             The name of the method to wrap ex: "render"
 * @return {[React.Component]}           Returns the same React.Component.prototype method monkey-patched with the specified method wrapped with a try/catch
 */
var wrapWithTryCatch = function wrapWithTryCatch(component, method) {
  var unsafe = component[method];

  component[method] = function () {
    if (!config.enabled) {
      return;
    }
    try {
      return unsafe.apply(this, arguments);
    } catch (err) {
      var errorReport = {
        component: component.constructor.name,
        method: method,
        props: this.props,
        error: err
      };
      if (arguments.length > 0) {
        errorReport.arguments = arguments;
      }
      config.errorHandler(errorReport);
    }
  };

  if (method === "constructor") {
    console.log(component[method]);
  }
};

/**
 * Wraps each React.Component lifecycle method with a try/catch that enables easier development diagnostics of errors throwin within each method
 * Methods wrapped include: `render, componentWillMount, componentDidMount, componentWillReceiveProps, shouldComponentUpdate, componentWillUpdate, componentDidUpdate, componentWillUnmount`
 * @param  {[React.Component]} ComponentConstructor The React.Component you want to wrap lifecycle methods with a try/catch and error handler.
 * @return {[void]}                      [description]
 */
var wrapReactLifecycleMethodsWithTryCatch = function wrapReactLifecycleMethodsWithTryCatch(ComponentConstructor) {
  [
    'render',
    'componentWillMount',
    'componentDidMount',
    'componentWillReceiveProps',
    'shouldComponentUpdate',
    'componentWillUpdate',
    'componentDidUpdate',
    'componentWillUnmount'
  ].forEach(function (method) {
    if (ComponentConstructor.prototype[method]) {
      wrapWithTryCatch(ComponentConstructor.prototype, method);
    }
  });
};

exports.wrapReactLifecycleMethodsWithTryCatch = wrapReactLifecycleMethodsWithTryCatch;
exports['default'] = wrapReactLifecycleMethodsWithTryCatch;


/***/ }),
/* 1784 */
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_event_polyfill__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_event_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_custom_event_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_utilities_console_shim__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_utilities_console_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__containers_utilities_console_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_utilities_url_polyfill_js__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_utilities_url_polyfill_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__containers_utilities_url_polyfill_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_config__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);
/* global Event */










__webpack_require__(930);
// use patched version for quiet failure
// require('expose-loader?ReactDOM!./patched-react-dom')
__webpack_require__(931);
__webpack_require__(935) // semicolon is important

// Polyfill for requestAnimationFrame
;

(function () {
  var lastTime = 0;
  var vendors = ["ms", "moz", "webkit", "o"];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
    window.cancelAnimationFrame = window[vendors[x] + "CancelAnimationFrame"] || window[vendors[x] + "CancelRequestAnimationFrame"];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
})();

if (!Object(__WEBPACK_IMPORTED_MODULE_7__utils__["z" /* isOldBrowser */])()) {
  __WEBPACK_IMPORTED_MODULE_5_raven_js___default.a.config(__WEBPACK_IMPORTED_MODULE_6__constants_config__["d" /* SENTRY_URL */], {
    release: __WEBPACK_IMPORTED_MODULE_6__constants_config__["c" /* RELEASE */]
  }).install();
}

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

try {
    var ce = new window.CustomEvent('test');
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
        // IE has problems with .preventDefault() on custom events
        // http://stackoverflow.com/questions/23349191
        throw new Error('Could not prevent default');
    }
} catch(e) {
  var CustomEvent = function(event, params) {
    var evt, origPrevent;
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };

    evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    origPrevent = evt.preventDefault;
    evt.preventDefault = function () {
      origPrevent.call(this);
      try {
        Object.defineProperty(this, 'defaultPrevented', {
          get: function () {
            return true;
          }
        });
      } catch(e) {
        this.defaultPrevented = true;
      }
    };
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent; // expose definition to window
}


/***/ }),
/* 1787 */
/***/ (function(module, exports) {

/**
 * console-shim 1.0.3
 * https://github.com/kayahr/console-shim
 * Copyright (C) 2011 Klaus Reimer <k@ailis.de>
 * Licensed under the MIT license
 * (See http://www.opensource.org/licenses/mit-license)
 */

(function () {
  /**
  * Returns a function which calls the specified function in the specified
  * scope.
  *
  * @param {Function} func
  *            The function to call.
  * @param {Object} scope
  *            The scope to call the function in.
  * @param {...*} args
  *            Additional arguments to pass to the bound function.
  * @returns {function(...[*]): undefined}
  *            The bound function.
  */
  var bind = function bind(func, scope, args) {
    var fixedArgs = Array.prototype.slice.call(arguments, 2);
    return function () {
      var args = fixedArgs.concat(Array.prototype.slice.call(arguments, 0));
      /** @type {Function} */func.apply(scope, args);
    };
  };

  // Create console if not present
  if (!window.console) window.console /** @type {Console} */ = {};
  var console = /** @type {Object} */window.console;

  // Implement console log if needed
  if (!console.log) {
    // Use log4javascript if present
    if (window.log4javascript) {
      var log = log4javascript.getDefaultLogger();
      console.log = bind(log.info, log);
      console.debug = bind(log.debug, log);
      console.info = bind(log.info, log);
      console.warn = bind(log.warn, log);
      console.error = bind(log.error, log);
    } else {
      // Use empty dummy implementation to ignore logging
      console.log = /** @param {...*} args */function (args) {};
    }
  }

  // Implement other log levels to console.log if missing
  if (!console.debug) console.debug = console.log;
  if (!console.info) console.info = console.log;
  if (!console.warn) console.warn = console.log;
  if (!console.error) console.error = console.log;

  // Wrap the log methods in IE (<=9) because their argument handling is wrong
  // This wrapping is also done if the __consoleShimTest__ symbol is set. This
  // is needed for unit testing.
  if (window.__consoleShimTest__ != null || eval("/*@cc_on @_jscript_version <= 9@*/")) {
    /**
     * Wraps the call to a real IE logging method. Modifies the arguments so
     * parameters which are not represented by a placeholder are properly
     * printed with a space character as separator.
     *
     * @param {...*} args
     *            The function arguments. First argument is the log function
     *            to call, the other arguments are the log arguments.
     */
    var wrap = function wrap(args) {
      var i = void 0,
          max = void 0,
          match = void 0,
          log = void 0;

      // Convert argument list to real array
      args = Array.prototype.slice.call(arguments, 0);

      // First argument is the log method to call
      log = args.shift();

      max = args.length;
      if (max > 1 && window.__consoleShimTest__ !== false) {
        // When first parameter is not a string then add a format string to
        // the argument list so we are able to modify it in the next stop
        if (typeof args[0] !== "string") {
          args.unshift("%o");
          max += 1;
        }

        // For each additional parameter which has no placeholder in the
        // format string we add another placeholder separated with a
        // space character.
        match = args[0].match(/%[a-z]/g);
        for (i = match ? match.length + 1 : 1; i < max; i += 1) {
          args[0] += " %o";
        }
      }
      Function.apply.call(log, console, args);
    };

    // Wrap the native log methods of IE to fix argument output problems
    console.log = bind(wrap, window, console.log);
    console.debug = bind(wrap, window, console.debug);
    console.info = bind(wrap, window, console.info);
    console.warn = bind(wrap, window, console.warn);
    console.error = bind(wrap, window, console.error);
  }

  // Implement console.assert if missing
  if (!console.assert) {
    console.assert = function () {
      var args = Array.prototype.slice.call(arguments, 0);
      var expr = args.shift();
      if (!expr) {
        args[0] = "Assertion failed: " + args[0];
        console.error.apply(console, args);
      }
    };
  }

  // Linking console.dir and console.dirxml to the console.log method if
  // missing. Hopefully the browser already logs objects and DOM nodes as a
  // tree.
  if (!console.dir) console.dir = console.log;
  if (!console.dirxml) console.dirxml = console.log;

  // Linking console.exception to console.error. This is not the same but
  // at least some error message is displayed.
  if (!console.exception) console.exception = console.error;

  // Implement console.time and console.timeEnd if one of them is missing
  if (!console.time || !console.timeEnd) {
    var timers = {};
    console.time = function (id) {
      timers[id] = new Date().getTime();
    };
    console.timeEnd = function (id) {
      var start = timers[id];
      if (start) {
        console.log(id + ": " + (new Date().getTime() - start) + "ms");
        delete timers[id];
      }
    };
  }

  // Implement console.table if missing
  if (!console.table) {
    console.table = function (data, columns) {
      var i = void 0,
          iMax = void 0,
          row = void 0,
          j = void 0,
          jMax = void 0,
          k = void 0;

      // Do nothing if data has wrong type or no data was specified
      if (!data || !(data instanceof Array) || !data.length) return;

      // Auto-calculate columns array if not set
      if (!columns || !(columns instanceof Array)) {
        columns = [];
        for (k in data[0]) {
          if (!data[0].hasOwnProperty(k)) continue;
          columns.push(k);
        }
      }

      for (i = 0, iMax = data.length; i < iMax; i += 1) {
        row = [];
        for (j = 0, jMax = columns.length; j < jMax; j += 1) {
          row.push(data[i][columns[j]]);
        }

        Function.apply.call(console.log, console, row);
      }
    };
  }

  // Dummy implementations of other console features to prevent error messages
  // in browsers not supporting it.
  if (!console.clear) console.clear = function () {};
  if (!console.trace) console.trace = function () {};
  if (!console.group) console.group = function () {};
  if (!console.groupCollapsed) console.groupCollapsed = function () {};
  if (!console.groupEnd) console.groupEnd = function () {};
  if (!console.timeStamp) console.timeStamp = function () {};
  if (!console.profile) console.profile = function () {};
  if (!console.profileEnd) console.profileEnd = function () {};
  if (!console.count) console.count = function () {};
})();

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

// URL Polyfill
// Draft specification: https://url.spec.whatwg.org

// Notes:
// - Primarily useful for parsing URLs and modifying query parameters
// - Should work in IE8+ and everything more modern

(function (global) {
  // Browsers may have:
  // * No global URL object
  // * URL with static methods only - may have a dummy constructor
  // * URL with members except searchParams
  // * Full URL API support
  var origURL = global.URL;
  var nativeURL = void 0;
  try {
    if (origURL) {
      nativeURL = new global.URL("http://example.com");
      if ("searchParams" in nativeURL) return;
      if (!("href" in nativeURL)) nativeURL = undefined;
    }
  } catch (_) {}

  // NOTE: Doesn't do the encoding/decoding dance
  function urlencoded_serialize(pairs) {
    var output = "",
        first = true;
    pairs.forEach(function (pair) {
      var name = encodeURIComponent(pair.name);
      var value = encodeURIComponent(pair.value);
      if (!first) output += "&";
      output += name + "=" + value;
      first = false;
    });
    return output.replace(/%20/g, "+");
  }

  // NOTE: Doesn't do the encoding/decoding dance
  function urlencoded_parse(input, isindex) {
    var sequences = input.split("&");
    if (isindex && sequences[0].indexOf("=") === -1) sequences[0] = "=" + sequences[0];
    var pairs = [];
    sequences.forEach(function (bytes) {
      if (bytes.length === 0) return;
      var index = bytes.indexOf("=");
      if (index !== -1) {
        var name = bytes.substring(0, index);
        var value = bytes.substring(index + 1);
      } else {
        name = bytes;
        value = "";
      }
      name = name.replace(/\+/g, " ");
      value = value.replace(/\+/g, " ");
      pairs.push({ name: name, value: value });
    });
    var output = [];
    pairs.forEach(function (pair) {
      output.push({
        name: decodeURIComponent(pair.name),
        value: decodeURIComponent(pair.value)
      });
    });
    return output;
  }

  function URLUtils(url) {
    if (nativeURL) return new origURL(url);
    var anchor = document.createElement("a");
    anchor.href = url;
    return anchor;
  }

  function URLSearchParams(init) {
    var $this = this;
    this._list = [];

    if (init === undefined || init === null) init = "";

    if (Object(init) !== init || init instanceof URLSearchParams) init = String(init);

    if (typeof init === "string") {
      if (init.substring(0, 1) === "?") {
        init = init.substring(1);
      }
      this._list = urlencoded_parse(init);
    }

    this._url_object = null;
    this._setList = function (list) {
      if (!updating) $this._list = list;
    };

    var updating = false;
    this._update_steps = function () {
      if (updating) return;
      updating = true;

      if (!$this._url_object) return;

      // Partial workaround for IE issue with 'about:'
      if ($this._url_object.protocol === "about:" && $this._url_object.pathname.indexOf("?") !== -1) {
        $this._url_object.pathname = $this._url_object.pathname.split("?")[0];
      }

      $this._url_object.search = urlencoded_serialize($this._list);

      updating = false;
    };
  }

  Object.defineProperties(URLSearchParams.prototype, {
    append: {
      value: function value(name, _value) {
        this._list.push({ name: name, value: _value });
        this._update_steps();
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    delete: {
      value: function value(name) {
        for (var i = 0; i < this._list.length;) {
          if (this._list[i].name === name) this._list.splice(i, 1);else ++i;
        }
        this._update_steps();
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    get: {
      value: function value(name) {
        for (var i = 0; i < this._list.length; ++i) {
          if (this._list[i].name === name) return this._list[i].value;
        }
        return null;
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    getAll: {
      value: function value(name) {
        var result = [];
        for (var i = 0; i < this._list.length; ++i) {
          if (this._list[i].name === name) result.push(this._list[i].value);
        }
        return result;
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    has: {
      value: function value(name) {
        for (var i = 0; i < this._list.length; ++i) {
          if (this._list[i].name === name) return true;
        }
        return false;
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    set: {
      value: function value(name, _value2) {
        var found = false;
        for (var i = 0; i < this._list.length;) {
          if (this._list[i].name === name) {
            if (!found) {
              this._list[i].value = _value2;
              found = true;
              ++i;
            } else {
              this._list.splice(i, 1);
            }
          } else {
            ++i;
          }
        }

        if (!found) this._list.push({ name: name, value: _value2 });

        this._update_steps();
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    entries: {
      value: function value() {
        var $this = this,
            index = 0;
        return {
          next: function next() {
            if (index >= $this._list.length) return { done: true, value: undefined };
            var pair = $this._list[index++];
            return { done: false, value: [pair.name, pair.value] };
          }
        };
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    keys: {
      value: function value() {
        var $this = this,
            index = 0;
        return {
          next: function next() {
            if (index >= $this._list.length) return { done: true, value: undefined };
            var pair = $this._list[index++];
            return { done: false, value: pair.name };
          }
        };
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    values: {
      value: function value() {
        var $this = this,
            index = 0;
        return {
          next: function next() {
            if (index >= $this._list.length) return { done: true, value: undefined };
            var pair = $this._list[index++];
            return { done: false, value: pair.value };
          }
        };
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    forEach: {
      value: function value(callback) {
        var thisArg = arguments.length > 1 ? arguments[1] : undefined;
        this._list.forEach(function (pair, index) {
          callback.call(thisArg, pair.value, pair.name);
        });
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    toString: {
      value: function value() {
        return urlencoded_serialize(this._list);
      },

      writable: true,
      enumerable: false,
      configurable: true
    }
  });

  if ("Symbol" in global && "iterator" in global.Symbol) {
    Object.defineProperty(URLSearchParams.prototype, global.Symbol.iterator, {
      value: URLSearchParams.prototype.entries,
      writable: true,
      enumerable: true,
      configurable: true
    });
  }

  function URL(url, base) {
    if (!(this instanceof global.URL)) {
      throw new TypeError("Failed to construct 'URL': Please use the 'new' operator.");
    }

    if (base) {
      url = function () {
        if (nativeURL) return new origURL(url, base).href;

        var doc = void 0;
        // Use another document/base tag/anchor for relative URL resolution, if possible
        if (document.implementation && document.implementation.createHTMLDocument) {
          doc = document.implementation.createHTMLDocument("");
        } else if (document.implementation && document.implementation.createDocument) {
          doc = document.implementation.createDocument("http://www.w3.org/1999/xhtml", "html", null);
          doc.documentElement.appendChild(doc.createElement("head"));
          doc.documentElement.appendChild(doc.createElement("body"));
        } else if (window.ActiveXObject) {
          doc = new window.ActiveXObject("htmlfile");
          doc.write("<head></head><body></body>");
          doc.close();
        }

        if (!doc) throw Error("base not supported");

        var baseTag = doc.createElement("base");
        baseTag.href = base;
        doc.getElementsByTagName("head")[0].appendChild(baseTag);
        var anchor = doc.createElement("a");
        anchor.href = url;
        return anchor.href;
      }();
    }

    // An inner object implementing URLUtils (either a native URL
    // object or an HTMLAnchorElement instance) is used to perform the
    // URL algorithms. With full ES5 getter/setter support, return a
    // regular object For IE8's limited getter/setter support, a
    // different HTMLAnchorElement is returned with properties
    // overridden

    var instance = URLUtils(url || "");

    // Detect for ES5 getter/setter support
    // (an Object.defineProperties polyfill that doesn't support getters/setters may throw)
    var ES5_GET_SET = function () {
      if (!("defineProperties" in Object)) return false;
      try {
        var obj = {};
        Object.defineProperties(obj, {
          prop: {
            get: function get() {
              return true;
            }
          }
        });
        return obj.prop;
      } catch (_) {
        return false;
      }
    }();

    var self = ES5_GET_SET ? this : document.createElement("a");

    var query_object = new URLSearchParams(instance.search ? instance.search.substring(1) : null);
    query_object._url_object = self;

    Object.defineProperties(self, {
      href: {
        get: function get() {
          return instance.href;
        },
        set: function set(v) {
          instance.href = v;
          tidy_instance();
          update_steps();
        },

        enumerable: true,
        configurable: true
      },
      origin: {
        get: function get() {
          if ("origin" in instance) return instance.origin;
          return this.protocol + "//" + this.host;
        },

        enumerable: true,
        configurable: true
      },
      protocol: {
        get: function get() {
          return instance.protocol;
        },
        set: function set(v) {
          instance.protocol = v;
        },

        enumerable: true,
        configurable: true
      },
      username: {
        get: function get() {
          return instance.username;
        },
        set: function set(v) {
          instance.username = v;
        },

        enumerable: true,
        configurable: true
      },
      password: {
        get: function get() {
          return instance.password;
        },
        set: function set(v) {
          instance.password = v;
        },

        enumerable: true,
        configurable: true
      },
      host: {
        get: function get() {
          // IE returns default port in |host|
          var re = { "http:": /:80$/, "https:": /:443$/, "ftp:": /:21$/ }[instance.protocol];
          return re ? instance.host.replace(re, "") : instance.host;
        },
        set: function set(v) {
          instance.host = v;
        },

        enumerable: true,
        configurable: true
      },
      hostname: {
        get: function get() {
          return instance.hostname;
        },
        set: function set(v) {
          instance.hostname = v;
        },

        enumerable: true,
        configurable: true
      },
      port: {
        get: function get() {
          return instance.port;
        },
        set: function set(v) {
          instance.port = v;
        },

        enumerable: true,
        configurable: true
      },
      pathname: {
        get: function get() {
          // IE does not include leading '/' in |pathname|
          if (instance.pathname.charAt(0) !== "/") return "/" + instance.pathname;
          return instance.pathname;
        },
        set: function set(v) {
          instance.pathname = v;
        },

        enumerable: true,
        configurable: true
      },
      search: {
        get: function get() {
          return instance.search;
        },
        set: function set(v) {
          if (instance.search === v) return;
          instance.search = v;
          tidy_instance();
          update_steps();
        },

        enumerable: true,
        configurable: true
      },
      searchParams: {
        get: function get() {
          return query_object;
        },

        enumerable: true,
        configurable: true
      },
      hash: {
        get: function get() {
          return instance.hash;
        },
        set: function set(v) {
          instance.hash = v;
          tidy_instance();
        },

        enumerable: true,
        configurable: true
      },
      toString: {
        value: function value() {
          return instance.toString();
        },

        enumerable: false,
        configurable: true
      },
      valueOf: {
        value: function value() {
          return instance.valueOf();
        },

        enumerable: false,
        configurable: true
      }
    });

    function tidy_instance() {
      var href = instance.href.replace(/#$|\?$|\?(?=#)/g, "");
      if (instance.href !== href) instance.href = href;
    }

    function update_steps() {
      query_object._setList(instance.search ? urlencoded_parse(instance.search.substring(1)) : []);
      query_object._update_steps();
    }

    return self;
  }

  if (origURL) {
    for (var i in origURL) {
      if (origURL.hasOwnProperty(i) && typeof origURL[i] === "function") URL[i] = origURL[i];
    }
  }

  global.URL = URL;
  global.URLSearchParams = URLSearchParams;
})(self);

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__(1790);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/**
 * DISCLAIMER:
 *
 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
 *
 * It's called `Client' to be in-line with Raven Node implementation.
 *
 * HOWTO:
 *
 * import Raven from 'raven-js';
 *
 * const someAppReporter = new Raven.Client();
 * const someOtherAppReporter = new Raven.Client();
 *
 * someAppReporter.config('__DSN__', {
 *   ...config goes here
 * });
 *
 * someOtherAppReporter.config('__OTHER_DSN__', {
 *   ...config goes here
 * });
 *
 * someAppReporter.captureMessage(...);
 * someAppReporter.captureException(...);
 * someAppReporter.captureBreadcrumb(...);
 *
 * someOtherAppReporter.captureMessage(...);
 * someOtherAppReporter.captureException(...);
 * someOtherAppReporter.captureBreadcrumb(...);
 *
 * It should "just work".
 */
module.exports.Client = RavenConstructor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__(1791);
var stringify = __webpack_require__(1784);
var md5 = __webpack_require__(1792);
var RavenConfigError = __webpack_require__(1793);

var utils = __webpack_require__(852);
var isErrorEvent = utils.isErrorEvent;
var isDOMError = utils.isDOMError;
var isDOMException = utils.isDOMException;
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__(1794).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.27.0',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = {};
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      mechanism: {
        type: 'onunhandledrejection',
        handled: false
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener &&
      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function() {
    _window.removeEventListener &&
      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isDOMError(ex) || isDOMException(ex)) {
      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
      // then we just extract the name and message, as they don't provide anything else
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
      var message = ex.message ? name + ': ' + ex.message : name;

      return this.captureMessage(
        message,
        objectMerge(options, {
          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
          // but it's barely any overhead so we may at least try
          stacktrace: true,
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a DOMError/DOMException
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message:
        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge(
      {
        message: msg
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    // Always attempt to get stacktrace if message is empty.
    // It's the only way to provide any helpful information to the user.
    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge(
        {
          trimHeadFrames: 0
        },
        options
      );
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint)
        ? data.fingerprint
        : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = objectMerge(
      {
        eventId: this.lastEventId(),
        dsn: this._dsn,
        user: this._globalContext.user || {}
      },
      options
    );

    if (!options.eventId) {
      throw new RavenConfigError('Missing eventId');
    }

    if (!options.dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var encodedOptions = [];

    for (var key in options) {
      if (key === 'user') {
        var user = options.user;
        if (user.name) encodedOptions.push('name=' + encode(user.name));
        if (user.email) encodedOptions.push('email=' + encode(user.email));
      } else {
        encodedOptions.push(encode(key) + '=' + encode(options[key]));
      }
    }
    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: orig.name || '<anonymous>'}
              }
            },
            originalCallback
          );
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          target: global,
                          function: 'handleEvent',
                          handler: (fn && fn.name) || '<anonymous>'
                        }
                      }
                    },
                    fn.handleEvent
                  );
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(
                  {
                    mechanism: {
                      type: 'instrument',
                      data: {
                        target: global,
                        function: 'addEventListener',
                        handler: (fn && fn.name) || '<anonymous>'
                      }
                    }
                  },
                  fn,
                  before
                ),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(
              self.wrap(
                {
                  mechanism: {
                    type: 'instrument',
                    data: {
                      function: 'requestAnimationFrame',
                      handler: (orig && orig.name) || '<anonymous>'
                    }
                  }
                },
                cb
              )
            );
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: prop, handler: (orig && orig.name) || '<anonymous>'}
              }
            },
            orig
          );
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          function: 'onreadystatechange',
                          handler: (orig && orig.name) || '<anonymous>'
                        }
                      }
                    },
                    orig,
                    onreadystatechangeHandler
                  );
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch
              .apply(this, args)
              .then(function(response) {
                fetchData.status_code = response.status;

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData
                });

                return response;
              })
              ['catch'](function(err) {
                // if there is an error performing the request
                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData,
                  level: 'error'
                });

                throw err;
              });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      _window.history.pushState &&
      _window.history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function(stackInfo, options) {
    options = options || {};
    options.mechanism = options.mechanism || {
      type: 'onerror',
      handled: false
    };

    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo(stackInfo, options);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        transaction: fileurl
      },
      options
    );

    var ex = data.exception.values[0];
    if (ex.type == null && ex.value === '') {
      ex.value = 'Unrecoverable error caught';
    }

    // Move mechanism from options to exception interface
    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
    // too much
    if (!data.exception.mechanism && data.mechanism) {
      data.exception.mechanism = data.mechanism;
      delete data.mechanism;
    }

    data.exception.mechanism = objectMerge(
      {
        type: 'generic',
        handled: true
      },
      data.exception.mechanism || {}
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': _navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.transaction !== last.transaction // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (
      this._originalConsoleMethods[level] &&
      (this.debug || this._globalOptions.debug)
    ) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(852);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';
  return document.location.href;
}

function getLocationOrigin() {
  if (typeof document === 'undefined' || document.location == null) return '';

  // Oh dear IE10...
  if (!document.location.origin) {
    return (
      document.location.protocol +
      '//' +
      document.location.hostname +
      (document.location.port ? ':' + document.location.port : '')
    );
  }

  return document.location.origin;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function() {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      if (element.url && element.url.substr(0, 5) === 'blob:') {
        // Special case for handling JavaScript loaded into a blob.
        // We use a synchronous AJAX request here as a blob is already in
        // memory - it's not making a network request.  This will generate a warning
        // in the browser console, but there has already been an error so that's not
        // that much of an issue.
        var xhr = new XMLHttpRequest();
        xhr.open('GET', element.url, false);
        xhr.send(null);

        // If we failed to download the source, skip this patch
        if (xhr.status === 200) {
          var source = xhr.responseText || '';

          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
          source = source.slice(-300);

          // Now we dig out the source map URL
          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);

          // If we don't find a source map comment or we find more than one, continue on to the next element.
          if (sourceMaps) {
            var sourceMapAddress = sourceMaps[1];

            // Now we check to see if it's a relative URL.
            // If it is, convert it to an absolute one.
            if (sourceMapAddress.charAt(0) === '~') {
              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
            }

            // Now we strip the '.map' off of the end of the URL and update the
            // element so that Sentry can match the map to the blob.
            element.url = sourceMapAddress.slice(0, -4);
          }
        }
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << (len % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;


/***/ }),
/* 1793 */
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(852);

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// client.bundle.f4e9e58.js